webpackJsonp([180],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return Utils; });
/* unused harmony export Log */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return Storage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Filter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Stripe; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_numeral__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(841);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__constants__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__constants__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__constants__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_2__constants__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_2__constants__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_2__constants__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_2__constants__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_2__constants__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_2__constants__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_2__constants__["j"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_2__constants__["k"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_2__constants__["l"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_2__constants__["m"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_2__constants__["n"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_2__constants__["o"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_2__constants__["p"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_2__constants__["q"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_2__constants__["r"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_2__constants__["s"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_2__constants__["t"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_2__constants__["u"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_2__constants__["v"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_2__constants__["w"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_2__constants__["x"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_2__constants__["y"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_2__constants__["z"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_2__constants__["A"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_2__constants__["B"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_2__constants__["C"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_2__constants__["D"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_2__constants__["E"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_2__constants__["F"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_2__constants__["G"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "L", function() { return __WEBPACK_IMPORTED_MODULE_2__constants__["H"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "M", function() { return __WEBPACK_IMPORTED_MODULE_2__constants__["I"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "N", function() { return __WEBPACK_IMPORTED_MODULE_2__constants__["J"]; });





var Utils = {
  isEmpty: function isEmpty(val) {
    if (val === null || val === void 0 || val === '') {
      return true;
    } else {
      return false;
    }
  },
  toLocalTimeString: function toLocalTimeString(str) {
    return __WEBPACK_IMPORTED_MODULE_0_moment___default()(str).calendar(null, {
      lastDay: '[Yesterday,] LT',
      sameDay: '[Today,] LT',
      nextDay: '[Tomorrow,] LT',
      // lastWeek: '[Last] dddd[,] LT',
      // nextWeek: 'dddd[,] LT',
      lastWeek: 'LLLL',
      nextWeek: 'LLLL',
      sameElse: 'LLLL'
    });
  },
  toLocalDateString: function toLocalDateString(str) {
    return __WEBPACK_IMPORTED_MODULE_0_moment___default()(str).calendar(null, {
      lastDay: '[Yesterday,] LL',
      sameDay: '[Today,] LL',
      nextDay: '[Tomorrow,] LL',
      // lastWeek: '[Last] dddd[,] LT',
      // nextWeek: 'dddd[,] LT',
      lastWeek: 'LL',
      nextWeek: 'LL',
      sameElse: 'LL'
    });
  },
  parseJSON: function parseJSON(str) {
    var val = void 0;
    try {
      val = JSON.parse(str);
    } catch (e) {
      val = {};
    }
    return val;
  },
  getFilenameWithExtension: function getFilenameWithExtension(filename) {
    var allowedExtensions = /(\.mp3|\.mpa|\.wav)$/i;
    if (allowedExtensions.exec(filename)) {
      return filename;
    } else {
      return filename + '.mp3';
    }
  },
  downloadFile: function downloadFile(url) {
    var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    var a = document.createElement('A');
    a.href = url;
    a.download = name;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
};

var Log = {
  put: function put() {
    if (false) {
      console.log.apply(console, arguments);
    }
  }
};

var Storage = {
  set: function set(key, value) {
    localStorage.setItem(key, value);
  },
  get: function get(key) {
    return localStorage.getItem(key) || null;
  },
  remove: function remove(key) {
    localStorage.removeItem(key);
  },
  removeAll: function removeAll() {
    localStorage.clear();
  }
};

var Filter = {
  toLocalTimeString: function toLocalTimeString(str) {
    return __WEBPACK_IMPORTED_MODULE_0_moment___default()(str).calendar(null, {
      lastDay: '[Yesterday,] LT',
      sameDay: '[Today,] LT',
      nextDay: '[Tomorrow,] LT',
      // lastWeek: '[Last] dddd[,] LT',
      // nextWeek: 'dddd[,] LT',
      lastWeek: 'LLLL',
      nextWeek: 'LLLL',
      sameElse: 'LLLL'
    });
  },
  formatSlashedDate: function formatSlashedDate(value) {
    if (value) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(value).format('DD/MM/YYYY');
    }
  },
  formatDate: function formatDate(value) {
    if (value) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(String(value)).format('MMM DD, YYYY');
    }
  },
  formatDateFromNow: function formatDateFromNow(value) {
    if (value) {
      __WEBPACK_IMPORTED_MODULE_0_moment___default.a.locale('en');
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(String(value)).fromNow();
    }
  },
  formatDateFromNowShort: function formatDateFromNowShort(value) {
    if (value) {
      __WEBPACK_IMPORTED_MODULE_0_moment___default.a.locale('en');
      var ago = __WEBPACK_IMPORTED_MODULE_0_moment___default()(String(value)).fromNow(true);
      var splitAgo = ago.split(' ');

      return '' + splitAgo[0] + splitAgo[1][0];
    }
  },


  // #TODO rename it formatDecimal
  formatNumber: function formatNumber(value) {
    return __WEBPACK_IMPORTED_MODULE_1_numeral___default()(value / 100).format('0,0.00'); // displaying other groupings/separators is possible, look at the docs
  },
  formatNumberWithComma: function formatNumberWithComma(value) {
    return __WEBPACK_IMPORTED_MODULE_1_numeral___default()(value).format('0,0');
  },


  // #REF https://stackoverflow.com/questions/10599933/convert-long-number-into-abbreviated-string-in-javascript-with-a-special-shortn
  formatLargeNumber: function formatLargeNumber(num) {
    if (num === null || num === undefined || num === 0) {
      return '0';
    } // terminate early
    var fixed = 0; // number of decimal places to show
    var b = num.toPrecision(2).split('e'); // get power
    var k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 3); // floor at decimals, ceiling at trillions
    var c = k < 1 ? num.toFixed(0 + fixed) : (num / Math.pow(10, k * 3)).toFixed(1 + fixed); // divide by power
    var d = c < 0 ? c : Math.abs(c); // enforce -0 is 0
    var e = d + ['', 'K', 'M', 'B', 'T'][k]; // append power
    return e;
  },

  formatFullUrl: function formatFullUrl(value) {
    if (/http(s?):\/\//gi.test(value)) {
      return value;
    } else {
      return 'http://' + value;
    }
  },
  getTime: function getTime(value) {
    return __WEBPACK_IMPORTED_MODULE_0_moment___default()(String(value)).format('hh:mm A');
  },
  timeInHours: function timeInHours(value) {
    var hours = parseInt(Math.floor(value / 3600));
    var minutes = parseInt(Math.floor((value - hours * 3600) / 60));
    var seconds = parseInt((value - (hours * 3600 + minutes * 60)) % 60);

    var dHours = hours > 9 ? hours : '0' + hours;
    var dMins = minutes > 9 ? minutes : '0' + minutes;
    var dSecs = seconds > 9 ? seconds : '0' + seconds;

    return hours === 0 ? dMins + ':' + dSecs : dHours + ':' + dMins + ':' + dSecs;
  },
  timeInMinutes: function timeInMinutes(value) {
    var minutes = Math.floor(value / 60) || 0;
    var seconds = value - minutes * 60 || 0;

    var dMins = minutes.toString();
    var dSecs = seconds > 9 ? seconds : '0' + seconds;

    return dMins + ':' + dSecs;
  },
  timeInWords: function timeInWords(value) {
    var hours = parseInt(Math.floor(value / 3600));
    var minutes = parseInt(Math.floor((value - hours * 3600) / 60));
    var seconds = parseInt((value - (hours * 3600 + minutes * 60)) % 60);

    var dHours = hours > 9 ? hours : '0' + hours;
    var dMins = minutes > 9 ? minutes : '0' + minutes;
    var dSecs = seconds > 9 ? seconds : '0' + seconds;

    return hours === 0 ? dMins + ' minutes ' + dSecs + ' & seconds' : dHours + ' hours ' + dMins + ' minutes & ' + dSecs + ' seconds';
  },
  capitalize: function capitalize(value) {
    if (!value) return '';
    value = value.toString().toLowerCase();
    return value.charAt(0).toUpperCase() + value.slice(1);
  },
  truncateInMiddle: function truncateInMiddle(str, len) {
    console.log('truncateInMiddle', str, len);
    if (str.length > len) {
      return str.substr(0, len - 5) + '...' + str.substr(str.length - 5, str.length);
    } else {
      return str;
    }
  },
  titleize: function titleize(value) {
    var stringArr = value.split(' ');
    stringArr = stringArr.map(function (str) {
      return Filter.capitalize(str);
    });
    return stringArr.join(' ');
  },
  pluralize: function pluralize(value) {
    var len = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    if (!len) return value;
    var str = len > 1 ? value + 's' : value;
    return str || '';
  }
};

var Stripe = {
  calculateFee: function calculateFee(amount) {
    return amount > 50 ? Math.round(((amount + 30) / 0.971 - amount) * 100) / 100 : 0;
  },
  calculateSubFee: function calculateSubFee(amount) {
    var fee = parseFloat(amount) * (2.9 / 100);
    return fee;
  }
};

/***/ }),
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(10);




var API_BASE_URL = "https://api.yousound.com" + '/v1/auth';
var ACCESS_TOKEN_KEY = 'access_token';
var USER_INFO = 'user_info';
var USER_CREDENTIAL = 'user_credential';
var USER_HMAC = 'user_hmac';

/* harmony default export */ __webpack_exports__["a"] = ({
  login: function login(params) {
    return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.post(API_BASE_URL + '/sign_in?web=true', params);
  },
  registerAsListener: function registerAsListener(params) {
    localStorage.setItem("user_email", params.get("user[email]"));
    localStorage.setItem("user_pass", params.get("user[password]"));
    return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.post(API_BASE_URL + '/sign_up_as_listener', params);
  },
  registerAsArtist: function registerAsArtist(params) {
    return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.post(API_BASE_URL + '/sign_up_as_artist', params);
  },
  sendConfirmEmail: function sendConfirmEmail(params) {
    return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.post(API_BASE_URL + '/send_confirm_email', params);
  },
  activeAccount: function activeAccount(params) {
    return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.post(API_BASE_URL + '/confirm', params);
  },
  signinUrlForTwitter: function signinUrlForTwitter(params) {
    return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.post(API_BASE_URL + '/signin_url_for_twitter', params);
  },
  signinWithSocial: function signinWithSocial(params) {
    return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.post(API_BASE_URL + '/signin_with_social', params);
  },
  isUsernameAvailable: function isUsernameAvailable(params) {
    return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.post(API_BASE_URL + '/is_username_available', params);
  },
  isEmailAvailable: function isEmailAvailable(params) {
    return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.post(API_BASE_URL + '/is_email_available', params);
  },
  checkTokenValidation: function checkTokenValidation() {
    var params = {
      auth_token: localStorage.getItem(ACCESS_TOKEN_KEY)
    };
    return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.post(API_BASE_URL + '/token_validity', params);
  },
  requestResetPassword: function requestResetPassword(params) {
    return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.post(API_BASE_URL + '/reset_password', params);
  },
  resetPassword: function resetPassword(params) {
    return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.post(API_BASE_URL + '/set_password', params);
  },
  signout: function signout() {
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.post(API_BASE_URL + '/sign_out', null, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.auth.token }
    });
    this.clearTokenAndUserInfo();
  },
  clearTokenAndUserInfo: function clearTokenAndUserInfo() {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
    localStorage.removeItem(USER_HMAC);
    localStorage.removeItem(USER_INFO);
    __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('auth/setToken', null);
    __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('auth/setHMAC', null);
    __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('auth/setUser', null);
    __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('auth/setFirstVisit', false);
  },
  isAuthenticated: function isAuthenticated() {
    var token = this.getToken() || null;

    if (token) {
      return true;
    } else {
      return false;
    }
  },
  setTokenAndUserInfo: function setTokenAndUserInfo(user) {
    localStorage.setItem(ACCESS_TOKEN_KEY, user.token);
    __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('auth/setToken', user.token);
    // localStorage.setItem(USER_HMAC, user.hmac)
    // $store.dispatch('auth/setHMAC', user.hmac)
    this.setUser(user);
  },
  setUser: function setUser(user) {
    localStorage.setItem(USER_INFO, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(user));
    __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('auth/setUser', user);

    if (user.hmac) {
      localStorage.setItem(USER_HMAC, user.hmac);
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('auth/setHMAC', user.hmac);
    }
  },
  getToken: function getToken() {
    var token = localStorage.getItem(ACCESS_TOKEN_KEY);
    var user = JSON.parse(localStorage.getItem(USER_INFO));
    __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('auth/setToken', token);
    __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('auth/setUser', user);
    return token || null;
  },
  saveCredential: function saveCredential(credential) {
    localStorage.setItem(USER_CREDENTIAL, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(credential));
  },
  loadCredential: function loadCredential() {
    var val = localStorage.getItem(USER_CREDENTIAL);
    if (val !== null) val = JSON.parse(val);
    return val;
  }
});

/***/ }),
/* 6 */,
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_cache__ = __webpack_require__(76);




var API_BASE_URL = "https://api.yousound.com" + '/v1/users';

var cache = new __WEBPACK_IMPORTED_MODULE_2__services_cache__["a" /* default */]('users', { expiration: 150 });

/* harmony default export */ __webpack_exports__["a"] = ({
  initCache: function initCache() {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.interceptors.push(function (req) {
      if (req.fresh) cache.del(req.url);
      if (req.url.startsWith(API_BASE_URL) && req.method === 'GET') {
        var valid = cache.get(req.url);
        if (valid) {
          return req.respondWith(valid, {
            status: 200,
            statusText: 'OK'
          });
        } // if nothing is returned, continue
      }

      return function (res) {
        if (res && res.status === 200 && res.url.startsWith(API_BASE_URL)) {
          cache.set(res.url, res.body);
        }
        return res;
      };
    });
  },
  getUsers: function getUsers(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token },
      params: params
    });
  },
  searchUsers: function searchUsers(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/search', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token },
      params: params
    });
  },
  getUserInfo: function getUserInfo(userId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + userId + '/info', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  creatorReRequest: function creatorReRequest(userId, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + userId + '/creator_re_request', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token },
      params: params
    });
  },
  uploadStreamLimit: function uploadStreamLimit(userId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + userId + '/stream_uploaded_limit_available', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  updateUserInfo: function updateUserInfo(userId, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.patch(API_BASE_URL + '/' + userId, params, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  changeCreatorRoleIntoListener: function changeCreatorRoleIntoListener(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/change_creator_role_into_listener', {
      params: params
    });
  },
  deleteUser: function deleteUser(userId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.delete(API_BASE_URL + '/' + userId, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  getSubscriptionDetail: function getSubscriptionDetail(userId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + userId + '/fetch_subscription_details', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  getRepostPriceProration: function getRepostPriceProration(userId, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + userId + '/repost_price_proration', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token },
      params: params
    });
  },
  setRepostPrice: function setRepostPrice(userId, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL + '/' + userId + '/set_repost_price', params, { headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token } });
  },
  changePassword: function changePassword(userId, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL + '/' + userId + '/change_password', params, { headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token } });
  },
  checkStripeConnection: function checkStripeConnection(userId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + userId + '/check_stripe_connection', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  donateMoney: function donateMoney(userId, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL + '/' + userId + '/donate', params, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  addVideoCredit: function addVideoCredit(userId, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL + '/' + userId + '/video_credit', params, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  inviteUser: function inviteUser(userId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + userId + '/invite', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  repostedFeeds: function repostedFeeds(userId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + userId + '/reposted_feeds', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  cartItems: function cartItems(userId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + userId + '/cart_items', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  followUser: function followUser(userId, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + userId + '/follow', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token },
      params: params
    });
  },
  unfollowUser: function unfollowUser(userId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + userId + '/unfollow', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  blockUser: function blockUser(userId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + userId + '/block', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  unblockUser: function unblockUser(userId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + userId + '/unblock', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  favoriteUser: function favoriteUser(userId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + userId + '/favorite', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  unfavoriteUser: function unfavoriteUser(userId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + userId + '/unfavorite', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  hiddenUserGenres: function hiddenUserGenres(userId, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL + '/' + userId + '/hidden_genres', params, { headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token } });
  },
  sendLabelRequest: function sendLabelRequest(userId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + userId + '/send_label_request', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  removeLabel: function removeLabel(userId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + userId + '/remove_label', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  acceptLabelRequest: function acceptLabelRequest(userId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + userId + '/accept_label_request', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  denyLabelRequest: function denyLabelRequest(userId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + userId + '/deny_label_request', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  updateUserStatus: function updateUserStatus(userId, params) {
    // status : inactive, active, pending, suspended, verified
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL + '/' + userId + '/update_status', params, { headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token } });
  },
  updateUserRole: function updateUserRole(userId, params) {
    // role: admin, moderator, artist, listener
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL + '/' + userId + '/update_role', params, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  getAccessLevels: function getAccessLevels(userId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + userId + '/access_levels', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  getMembershipTiers: function getMembershipTiers(userId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + userId + '/membership_tiers', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  guestSearch: function guestSearch(q) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/search_guests', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token },
      params: { q: q }
    });
  },
  saveInviteMsg: function saveInviteMsg(userId, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL + '/' + userId + '/save_invite_msg', params, { headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token } });
  },
  getMemberships: function getMemberships(userId, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + userId + '/memberships', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token },
      params: params
    });
  },
  storeCard: function storeCard(userId, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL + '/' + userId + '/store_card', params, { headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token } });
  }
});

/***/ }),
/* 8 */,
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1336)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(885),
  /* template */
  __webpack_require__(1798),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7e53a8e8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_activity__ = __webpack_require__(845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_album__ = __webpack_require__(846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_app__ = __webpack_require__(847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_auth__ = __webpack_require__(849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_discover__ = __webpack_require__(850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_trending__ = __webpack_require__(861);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_error__ = __webpack_require__(851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_genre__ = __webpack_require__(852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_genre_selector__ = __webpack_require__(853);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_navigator__ = __webpack_require__(854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_order__ = __webpack_require__(855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modules_player__ = __webpack_require__(856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modules_playlist__ = __webpack_require__(857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__modules_product__ = __webpack_require__(858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__modules_track__ = __webpack_require__(860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__modules_user__ = __webpack_require__(862);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__modules_stream_player__ = __webpack_require__(859);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__modules_app_mobile__ = __webpack_require__(848);





















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* default */].Store({
  strict: "production" !== 'production',
  actions: {},
  getters: {},
  modules: {
    activity: __WEBPACK_IMPORTED_MODULE_2__modules_activity__["a" /* default */],
    album: __WEBPACK_IMPORTED_MODULE_3__modules_album__["a" /* default */],
    app: __WEBPACK_IMPORTED_MODULE_4__modules_app__["a" /* default */],
    auth: __WEBPACK_IMPORTED_MODULE_5__modules_auth__["a" /* default */],
    discover: __WEBPACK_IMPORTED_MODULE_6__modules_discover__["a" /* default */],
    trending: __WEBPACK_IMPORTED_MODULE_7__modules_trending__["a" /* default */],
    genre: __WEBPACK_IMPORTED_MODULE_9__modules_genre__["a" /* default */],
    genreSelector: __WEBPACK_IMPORTED_MODULE_10__modules_genre_selector__["a" /* default */],
    error: __WEBPACK_IMPORTED_MODULE_8__modules_error__["a" /* default */],
    navigator: __WEBPACK_IMPORTED_MODULE_11__modules_navigator__["a" /* default */],
    order: __WEBPACK_IMPORTED_MODULE_12__modules_order__["a" /* default */],
    player: __WEBPACK_IMPORTED_MODULE_13__modules_player__["a" /* default */],
    playlist: __WEBPACK_IMPORTED_MODULE_14__modules_playlist__["a" /* default */],
    product: __WEBPACK_IMPORTED_MODULE_15__modules_product__["a" /* default */],
    track: __WEBPACK_IMPORTED_MODULE_16__modules_track__["a" /* default */],
    user: __WEBPACK_IMPORTED_MODULE_17__modules_user__["a" /* default */],
    streamPlayer: __WEBPACK_IMPORTED_MODULE_18__modules_stream_player__["a" /* default */],
    appMobile: __WEBPACK_IMPORTED_MODULE_19__modules_app_mobile__["a" /* default */]
  },
  plugins: []
}));

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_cache__ = __webpack_require__(76);




var API_BASE_URL = "https://api.yousound.com" + '/v1/albums';

var cache = new __WEBPACK_IMPORTED_MODULE_2__services_cache__["a" /* default */]('albums', { expiration: 100 });

/* harmony default export */ __webpack_exports__["a"] = ({
  initCache: function initCache() {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.interceptors.push(function (req) {
      if (req.fresh) cache.del(req.url);
      if (req.url.startsWith(API_BASE_URL) && req.method === 'GET') {
        var valid = cache.get(req.url);
        if (valid) {
          return req.respondWith(valid, {
            status: 200,
            statusText: 'OK'
          });
        } // if nothing is returned, continue
      }

      return function (res) {
        if (res && res.status === 200 && res.url.startsWith(API_BASE_URL)) {
          cache.set(res.url, res.body);
        }
        return res;
      };
    });
  },
  getAlbums: function getAlbums(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token },
      params: params
    });
  },
  getAlbum: function getAlbum(albumId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + albumId, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  getAlbumPublicUser: function getAlbumPublicUser(albumId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + albumId + '/public');
  },
  createAlbum: function createAlbum(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL, params, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  releaseAlbum: function releaseAlbum(albumId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + albumId + '/release', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  myRole: function myRole(albumId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + albumId + '/my_role', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  repostAlbum: function repostAlbum(albumId, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + albumId + '/repost', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token },
      params: params
    });
  },
  acceptCollaboration: function acceptCollaboration(albumId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + albumId + '/accept_collaboration', { headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token } });
  },
  denyCollaboration: function denyCollaboration(albumId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + albumId + '/deny_collaboration', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  sendLabelRequest: function sendLabelRequest(albumId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + albumId + '/send_label_request', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  removeLabel: function removeLabel(albumId, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + albumId + '/remove_label', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token },
      params: params
    });
  },
  acceptLabelRequest: function acceptLabelRequest(albumId, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + albumId + '/accept_label_request', { headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }, params: params });
  },
  denyLabelRequest: function denyLabelRequest(albumId, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + albumId + '/deny_label_request', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token },
      params: params
    });
  },
  makePublicAlbum: function makePublicAlbum(albumId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + albumId + '/make_public', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  makePrivateAlbum: function makePrivateAlbum(albumId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + albumId + '/make_private', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  makeLiveVideoOnlyAlbum: function makeLiveVideoOnlyAlbum(albumId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + albumId + '/make_live_video_only', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  recommendAlbum: function recommendAlbum(albumId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + albumId + '/recommend', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  unrecommendAlbum: function unrecommendAlbum(albumId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + albumId + '/unrecommend', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  reportAlbum: function reportAlbum(albumId, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL + '/' + albumId + '/report', params, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  hideAlbum: function hideAlbum(albumId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + albumId + '/hide', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  downloadAlbum: function downloadAlbum(albumId, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + albumId + '/download', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token },
      params: params
    });
  },
  playAlbum: function playAlbum(albumId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + albumId + '/play', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  rearrangeTracks: function rearrangeTracks(albumId, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL + '/' + albumId + '/rearrange', params, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  addTracks: function addTracks(albumId, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL + '/' + albumId + '/add_tracks', params, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  removeTracks: function removeTracks(albumId, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL + '/' + albumId + '/remove_tracks', params, { headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token } });
  },
  deleteAlbum: function deleteAlbum(albumId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.delete(API_BASE_URL + '/' + albumId, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  updateAlbum: function updateAlbum(albumId, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.patch(API_BASE_URL + '/' + albumId, params, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  updateAccessLevel: function updateAccessLevel(albumId, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.patch(API_BASE_URL + '/' + albumId + '/update_access_level', params, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  getMembersAlbums: function getMembersAlbums(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/members_albums', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token },
      params: params
    });
  }
});

/***/ }),
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_cache__ = __webpack_require__(76);




var API_BASE_URL = "https://api.yousound.com" + '/v1/shopping/products';

var cache = new __WEBPACK_IMPORTED_MODULE_2__services_cache__["a" /* default */]('products', { expiration: 150 });

/* harmony default export */ __webpack_exports__["a"] = ({
  initCache: function initCache() {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.interceptors.push(function (req) {
      if (req.fresh) cache.del(req.url);
      if (req.url.startsWith(API_BASE_URL) && req.method === 'GET') {
        var valid = cache.get(req.url);
        if (valid) {
          return req.respondWith(valid, {
            status: 200,
            statusText: 'OK'
          });
        } // if nothing is returned, continue
      }

      return function (res) {
        if (res && res.status === 200 && res.url.startsWith(API_BASE_URL)) {
          cache.set(res.url, res.body);
        }
        return res;
      };
    });
  },
  getProducts: function getProducts(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token },
      params: params
    });
  },
  addIntoCollection: function addIntoCollection(productId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + productId + '/add_to_collection', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  getProduct: function getProduct(productId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + productId, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  addProduct: function addProduct(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL, params, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token },
      progress: function progress(e) {
        if (e.lengthComputable) {
          __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('error/setProgressBarValue', parseInt(e.loaded / e.total * 100));
        }
      }
    });
  },
  deleteProduct: function deleteProduct(productId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.delete(API_BASE_URL + '/' + productId, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  updateProduct: function updateProduct(productId, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.put(API_BASE_URL + '/' + productId, params, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token },
      progress: function progress(e) {
        if (e.lengthComputable) {
          __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('error/setProgressBarValue', parseInt(e.loaded / e.total * 100));
        }
      }
    });
  },
  releaseProduct: function releaseProduct(productId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + productId + '/release', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  repostProduct: function repostProduct(productId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + productId + '/repost', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  hideProduct: function hideProduct(productId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + productId + '/hide', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  searchProduct: function searchProduct(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL + '/search', params, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  acceptCollaboration: function acceptCollaboration(productId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + productId + '/accept_collaboration', { headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token } });
  },
  denyCollaboration: function denyCollaboration(productId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + productId + '/deny_collaboration', { headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token } });
  },
  orderedItems: function orderedItems(productId, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + productId + '/ordered_items', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token },
      params: params
    });
  },
  tickets: function tickets(productId, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + productId + '/tickets', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token },
      params: params
    });
  },
  getMembersProducts: function getMembersProducts(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/members_products', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token },
      params: params
    });
  },
  updateAccessLevel: function updateAccessLevel(productId, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.put(API_BASE_URL + '/' + productId + '/update_access_level', params, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  }
});

/***/ }),
/* 16 */,
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1199)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(939),
  /* template */
  __webpack_require__(1609),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0d1546c5",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(10);



var API_BASE_URL = "https://api.yousound.com" + '/v1/streams';

/* harmony default export */ __webpack_exports__["a"] = ({
  getStreams: function getStreams(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get('' + API_BASE_URL, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token },
      params: params
    });
  },
  getStreamsPublicUsers: function getStreamsPublicUsers(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/public_user_streams', {
      params: params
    });
  },
  getStream: function getStream(streamId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + streamId, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token },
      params: {}
    });
  },
  getSpotlightStream: function getSpotlightStream(userId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/spotlight_video', {
      params: { user_id: userId }
    });
  },
  getSimilarStreams: function getSimilarStreams(streamId, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + streamId + '/similars', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token },
      params: params
    });
  },
  createStream: function createStream(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL, params, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  updateStream: function updateStream(streamId, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.patch(API_BASE_URL + '/' + streamId, params, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  deleteStream: function deleteStream(streamId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.delete(API_BASE_URL + '/' + streamId, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  archiveStream: function archiveStream(streamId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL + '/' + streamId + '/archive', {}, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  notifyStream: function notifyStream(streamId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + streamId + '/notify', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  startStream: function startStream(streamId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + streamId + '/start', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  stopStream: function stopStream(streamId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + streamId + '/stop', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  repostStream: function repostStream(streamId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + streamId + '/repost', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  canViewStream: function canViewStream(streamId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + streamId + '/can_view', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  payViewStream: function payViewStream(streamId, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL + '/' + streamId + '/pay_view', params, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  payAttachment: function payAttachment(streamId, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL + '/' + streamId + '/pay_attachment', params, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  viewStream: function viewStream(streamId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + streamId + '/view', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  watchingStream: function watchingStream(streamId) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + streamId + '/watching', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  getMembersStreams: function getMembersStreams(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/members_streams', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token },
      params: params
    });
  }
});

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/nav_logo_white.f790ddf.png";

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(920),
  /* template */
  __webpack_require__(1789),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1200)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(937),
  /* template */
  __webpack_require__(1611),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0edd835e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 22 */,
/* 23 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTUuNzUgMTEuNUMyLjU3OTM0IDExLjUgMCA4LjkyMDUzIDAgNS43NUMwIDIuNTc5NDcgMi41NzkzNCAwIDUuNzUgMEM4LjkyMDY2IDAgMTEuNSAyLjU3OTQ3IDExLjUgNS43NUMxMS41IDguOTIwNTMgOC45MjA2NiAxMS41IDUuNzUgMTEuNVoiIGZpbGw9IiMyNUEzMjUiLz4KPHBhdGggZD0iTTQuNzUgOC40NTcyN0wyLjA0Mjk3IDUuNzUwMTJMMi43NSA1LjA0Mjk3TDQuNzUgNy4wNDI5N0w4Ljc1IDMuMDQyOTdMOS40NTcwMyAzLjc1MDEyTDQuNzUgOC40NTcyN1oiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo="

/***/ }),
/* 24 */,
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(928),
  /* template */
  __webpack_require__(1607),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1325)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(916),
  /* template */
  __webpack_require__(1783),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-75888206",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 27 */,
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(10);



var API_BASE_URL = "https://api.yousound.com" + '/v1/me';

var MeService = {
  stripeEmail: function stripeEmail() {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/stripe_email', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },

  mutualUsers: function mutualUsers(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL + '/mutual_users', params, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },

  videoAttachAlbums: function videoAttachAlbums() {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/video_attach_albums', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },

  videoAttachProducts: function videoAttachProducts() {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/video_attach_products', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },

  connectStripe: function connectStripe(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL + '/connect_stripe', params, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },

  disconnectStripe: function disconnectStripe() {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/disconnect_stripe', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (MeService);

/***/ }),
/* 29 */,
/* 30 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1223)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1044),
  /* template */
  __webpack_require__(1640),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1e5d42cc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1252)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(917),
  /* template */
  __webpack_require__(1683),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3790e830",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1258)
  __webpack_require__(1257)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(941),
  /* template */
  __webpack_require__(1692),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3fd409f8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(10);



var API_BASE_URL = "https://api.yousound.com" + '/v1/shopping/items';

/* harmony default export */ __webpack_exports__["a"] = ({
  orderItems: function orderItems(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL + '/buy', params, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  getShoppingCartItems: function getShoppingCartItems() {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  addToCart: function addToCart(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL, params, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  getCartItem: function getCartItem(itemId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + itemId, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  deleteCartItem: function deleteCartItem(itemId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.delete(API_BASE_URL + '/' + itemId, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  updateCartItem: function updateCartItem(itemId, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.patch(API_BASE_URL + '/' + itemId, params, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  markShipped: function markShipped(itemId, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL + '/' + itemId + '/mark_as_shipped', params, { headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token } });
  },
  markUnshipped: function markUnshipped(itemId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + itemId + '/mark_as_unshipped', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  markAllShipped: function markAllShipped() {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/mark_all_as_shipped', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  tickets: function tickets(itemId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + itemId + '/tickets', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  calculateCost: function calculateCost(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/calculate_cost', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token },
      params: params
    });
  }
});

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(870),
  /* template */
  __webpack_require__(1695),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 36 */,
/* 37 */,
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(891),
  /* template */
  __webpack_require__(1803),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 43 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ys_logo_primary-black.dc79528.svg";

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(10);



var API_BASE_URL_V1 = "https://api.yousound.com" + '/v1/search';
var API_BASE_URL_V2 = "https://api.yousound.com" + '/v2/search';

/* harmony default export */ __webpack_exports__["a"] = ({
  searchStream: function searchStream(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL_V1 + '/search_stream', params, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },


  // searchStreamV2 (params) {
  //   return Vue.http.post(API_BASE_URL_V1 + '/search_stream_v2', params, { headers: { 'Authorization': $store.state.auth.token } })
  // },

  searchStreamV2: function searchStreamV2(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL_V2 + '/search_stream', params, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  searchDiscover: function searchDiscover(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL_V1 + '/search_discover', params, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  searchDiscoverPublicUser: function searchDiscoverPublicUser(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL_V1 + '/search_discover_public_user', params, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  searchGlobal: function searchGlobal(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL_V1 + '/search_global', params, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  searchLanding: function searchLanding(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL_V1 + '/search_landing', params, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  }
});

/***/ }),
/* 46 */,
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(10);



var API_BASE_URL = "https://api.yousound.com" + '/v2/subscription';
var API_BASE_URL2 = "https://api.yousound.com" + '/v1/users';

/* harmony default export */ __webpack_exports__["a"] = ({
  createSubscription: function createSubscription(params) {
    var auth_token = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token;
    if (auth_token != null) {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL, params, {
        headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
      });
    } else {
      var id = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.app.onboarding.username;
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL2 + '/' + id + '/creator_subscription', {
        params: params
      });
    }
  },
  freeAccountCredit: function freeAccountCredit(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/free_account_credit', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token },
      params: params
    });
  },
  deactivateSubscription: function deactivateSubscription() {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/deactivate_subscription', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  subscriptionChange: function subscriptionChange(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/subscription_change', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token },
      params: params
    });
  }
});

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1385)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(983),
  /* template */
  __webpack_require__(1859),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e8781320",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/nav_logo_primary.7541579.png";

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(10);



var API_BASE_URL = "https://api.yousound.com" + '/v1/comments';

/* harmony default export */ __webpack_exports__["a"] = ({
  // getComments (commentableType, commentableId) {
  //   return Vue.http.get(API_BASE_URL + '?commentable_type=' + commentableType + '&commentable_id=' + commentableId, { headers: { 'Authorization': $store.state.auth.token } })
  // },

  getComments: function getComments(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token },
      params: params
    });
  },
  sendComment: function sendComment(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL, params, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  makePublicComment: function makePublicComment(commentId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + commentId + '/make_public', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  makePrivateComment: function makePrivateComment(commentId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + commentId + '/make_private', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  deleteComment: function deleteComment(commentId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.delete(API_BASE_URL + '/' + commentId, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  editMessage: function editMessage(commentId, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.patch(API_BASE_URL + '/' + commentId, params, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  }
});

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1377)
  __webpack_require__(1376)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(909),
  /* template */
  __webpack_require__(1849),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c7da33a6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 52 */,
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(10);



var API_BASE_URL = "https://api.yousound.com" + '/v1/admin';

/* harmony default export */ __webpack_exports__["a"] = ({
  getUsers: function getUsers(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/users', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token },
      params: params
    });
  },
  getFreeAccountCreditUsers: function getFreeAccountCreditUsers(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/free_account_credit_users', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token },
      params: params
    });
  },
  getSignupUsers: function getSignupUsers(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/signed_up_artists', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token },
      params: params
    });
  },
  approveUser: function approveUser(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL + '/approve_user', params, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  denyUser: function denyUser(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL + '/deny_user', params, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  disconnectStripe: function disconnectStripe(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL + '/disconnect_stripe', params, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  toggleViewDirectMessages: function toggleViewDirectMessages(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL + '/toggle_view_direct_messages', params, { headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token } });
  },
  toggleLiveVideo: function toggleLiveVideo(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL + '/toggle_live_video', params, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  toggleLiveVideoFree: function toggleLiveVideoFree(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL + '/toggle_live_video_free', params, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  toggleSignInAuthorized: function toggleSignInAuthorized(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL + '/toggle_sign_in_authorized', params, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  getAlbums: function getAlbums(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/albums', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token },
      params: params
    });
  },
  getProducts: function getProducts(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/products', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token },
      params: params
    });
  },
  getStreams: function getStreams(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/streams', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token },
      params: params
    });
  },
  sendGlobalMessage: function sendGlobalMessage(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL + '/send_global_message', params, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  getGlobalStats: function getGlobalStats(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/global_stats', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token },
      params: params
    });
  },
  getAttendees: function getAttendees() {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/attendees', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  inviteAttendee: function inviteAttendee(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/invite_attendee', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token },
      params: params
    });
  }
});

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1371)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(945),
  /* template */
  __webpack_require__(1845),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(10);



var API_BASE_URL = "https://api.yousound.com" + '/v1/tracks';

/* harmony default export */ __webpack_exports__["a"] = ({
  uploadTrack: function uploadTrack(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL, params, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  deleteTrack: function deleteTrack(trackId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.delete(API_BASE_URL + '/' + trackId, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  patchTrack: function patchTrack(trackId, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.patch(API_BASE_URL + '/' + trackId, params, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  downloadTrack: function downloadTrack(trackId, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + trackId + '/download', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token },
      params: params
    });
  },
  playTrack: function playTrack(trackId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + trackId + '/play', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  playTrackPublicUser: function playTrackPublicUser(trackId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + trackId + '/play_public_user');
  }
});

/***/ }),
/* 56 */,
/* 57 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjgzMzMgNy44MzMzM0gxMS4xNjY3VjMuMTY2NjdDMTEuMTY2NyAyLjg1NzI1IDExLjA0MzcgMi41NjA1IDEwLjgyNSAyLjM0MTcxQzEwLjYwNjIgMi4xMjI5MiAxMC4zMDk0IDIgMTAgMkM5LjY5MDU4IDIgOS4zOTM4MyAyLjEyMjkyIDkuMTc1MDQgMi4zNDE3MUM4Ljk1NjI1IDIuNTYwNSA4LjgzMzMzIDIuODU3MjUgOC44MzMzMyAzLjE2NjY3VjcuODMzMzNINC4xNjY2N0MzLjg1NzI1IDcuODMzMzMgMy41NjA1IDcuOTU2MjUgMy4zNDE3MSA4LjE3NTA0QzMuMTIyOTIgOC4zOTM4MyAzIDguNjkwNTggMyA5QzMgOS4zMDk0MiAzLjEyMjkyIDkuNjA2MTYgMy4zNDE3MSA5LjgyNDk2QzMuNTYwNSAxMC4wNDM3IDMuODU3MjUgMTAuMTY2NyA0LjE2NjY3IDEwLjE2NjdIOC44MzMzM1YxNC44MzMzQzguODMzMzMgMTUuMTQyOCA4Ljk1NjI1IDE1LjQzOTUgOS4xNzUwNCAxNS42NTgzQzkuMzkzODMgMTUuODc3MSA5LjY5MDU4IDE2IDEwIDE2QzEwLjMwOTQgMTYgMTAuNjA2MiAxNS44NzcxIDEwLjgyNSAxNS42NTgzQzExLjA0MzcgMTUuNDM5NSAxMS4xNjY3IDE1LjE0MjggMTEuMTY2NyAxNC44MzMzVjEwLjE2NjdIMTUuODMzM0MxNi4xNDI4IDEwLjE2NjcgMTYuNDM5NSAxMC4wNDM3IDE2LjY1ODMgOS44MjQ5NkMxNi44NzcxIDkuNjA2MTYgMTcgOS4zMDk0MiAxNyA5QzE3IDguNjkwNTggMTYuODc3MSA4LjM5MzgzIDE2LjY1ODMgOC4xNzUwNEMxNi40Mzk1IDcuOTU2MjUgMTYuMTQyOCA3LjgzMzMzIDE1LjgzMzMgNy44MzMzM1oiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo="

/***/ }),
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1220)
  __webpack_require__(1221)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1089),
  /* template */
  __webpack_require__(1638),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1e544f3a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1265)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1004),
  /* template */
  __webpack_require__(1703),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-442020bf",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1256)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(992),
  /* template */
  __webpack_require__(1690),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3dc52124",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1219)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1027),
  /* template */
  __webpack_require__(1637),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1dd9ae6f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(868),
  /* template */
  __webpack_require__(1701),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(927),
  /* template */
  __webpack_require__(1614),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 68 */,
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1211)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(993),
  /* template */
  __webpack_require__(1626),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-17bf23cd",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(10);



var API_BASE_URL = "https://api.yousound.com" + '/v1/collections';

/* harmony default export */ __webpack_exports__["a"] = ({
  getCollections: function getCollections() {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/', { headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token } });
  },
  createCollection: function createCollection(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL + '/', params, { headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token } });
  },
  destroy: function destroy(contentType, contentId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.delete(API_BASE_URL + '/' + contentId, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token },
      params: { content_type: contentType }
    });
  }
});

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(921),
  /* template */
  __webpack_require__(1618),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 72 */,
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1235)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(989),
  /* template */
  __webpack_require__(1655),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-27eccaf9",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1255)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(979),
  /* template */
  __webpack_require__(1688),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3c878984",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1347)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(984),
  /* template */
  __webpack_require__(1814),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-93f75c9a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);




var VueCache = function () {
  function VueCache(id, options) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, VueCache);

    this._cache = JSON.parse(localStorage.getItem(id) || '{}');
    this.id = id;
    this.expiration = 300; // seconds
    if (options.expiration) {
      this.expiration = options.expiration;
    }
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(VueCache, [{
    key: 'get',
    value: function get(key) {
      if (this._cache[key] && this._cache[key].val) {
        var currTime = new Date().getTime() / 1000;
        if (currTime - this._cache[key].time < 0) {
          self.del(key);
          return null;
        }
        return this._cache[key].val;
      } else {
        return null;
      }
    }
  }, {
    key: 'set',
    value: function set(key, val) {
      this._cache[key] = {
        time: new Date().getTime() / 1000,
        val: val
      };
      this.save();
    }
  }, {
    key: 'del',
    value: function del(key) {
      this._cache[key].val = null;
      this._cache[key].time = null;
    }
  }, {
    key: 'save',
    value: function save() {
      // save into localstorage
      localStorage.setItem(this.id, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this._cache));
    }
  }]);

  return VueCache;
}();

/* harmony default export */ __webpack_exports__["a"] = (VueCache);

/***/ }),
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyLjQ5MTUgMS41MDg1OEMxMi4yNzI3IDEuMjg5ODYgMTEuOTc2IDEuMTY2OTkgMTEuNjY2NyAxLjE2Njk5QzExLjM1NzMgMS4xNjY5OSAxMS4wNjA2IDEuMjg5ODYgMTAuODQxOCAxLjUwODU4TDcuMDAwMDEgNS4zNTA0MUwzLjE1ODE4IDEuNTA4NThDMi45MzgxNCAxLjI5NjA2IDIuNjQzNDQgMS4xNzg0NyAyLjMzNzU1IDEuMTgxMTJDMi4wMzE2NSAxLjE4Mzc4IDEuNzM5MDMgMS4zMDY0OCAxLjUyMjcyIDEuNTIyNzlDMS4zMDY0MiAxLjczOTEgMS4xODM3MiAyLjAzMTcxIDEuMTgxMDYgMi4zMzc2MUMxLjE3ODQgMi42NDM1IDEuMjk2IDIuOTM4MjEgMS41MDg1MSAzLjE1ODI0TDUuMzUwMzUgNy4wMDAwOEwxLjUwODUxIDEwLjg0MTlDMS4zOTcwOCAxMC45NDk1IDEuMzA4MjEgMTEuMDc4MyAxLjI0NzA2IDExLjIyMDZDMS4xODU5MiAxMS4zNjI5IDEuMTUzNzMgMTEuNTE2IDEuMTUyMzkgMTEuNjcwOUMxLjE1MTA0IDExLjgyNTkgMS4xODA1NiAxMS45Nzk1IDEuMjM5MjIgMTIuMTIyOUMxLjI5Nzg4IDEyLjI2NjIgMS4zODQ1MSAxMi4zOTY1IDEuNDk0MDUgMTIuNTA2QzEuNjAzNTkgMTIuNjE1NiAxLjczMzg1IDEyLjcwMjIgMS44NzcyMyAxMi43NjA5QzIuMDIwNjEgMTIuODE5NSAyLjE3NDI0IDEyLjg0OSAyLjMyOTE1IDEyLjg0NzdDMi40ODQwNiAxMi44NDY0IDIuNjM3MTUgMTIuODE0MiAyLjc3OTQ5IDEyLjc1M0MyLjkyMTgyIDEyLjY5MTkgMy4wNTA1NiAxMi42MDMgMy4xNTgxOCAxMi40OTE2TDcuMDAwMDEgOC42NDk3NEwxMC44NDE4IDEyLjQ5MTZDMTEuMDYxOSAxMi43MDQxIDExLjM1NjYgMTIuODIxNyAxMS42NjI1IDEyLjgxOUMxMS45Njg0IDEyLjgxNjQgMTIuMjYxIDEyLjY5MzcgMTIuNDc3MyAxMi40Nzc0QzEyLjY5MzYgMTIuMjYxMSAxMi44MTYzIDExLjk2ODQgMTIuODE5IDExLjY2MjVDMTIuODIxNiAxMS4zNTY2IDEyLjcwNCAxMS4wNjE5IDEyLjQ5MTUgMTAuODQxOUw4LjY0OTY4IDcuMDAwMDhMMTIuNDkxNSAzLjE1ODI0QzEyLjcxMDIgMi45Mzk0NiAxMi44MzMxIDIuNjQyNzcgMTIuODMzMSAyLjMzMzQxQzEyLjgzMzEgMi4wMjQwNSAxMi43MTAyIDEuNzI3MzYgMTIuNDkxNSAxLjUwODU4WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg=="

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1342)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(935),
  /* template */
  __webpack_require__(1807),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-870d5704",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1328)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(889),
  /* template */
  __webpack_require__(1786),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-77fd02aa",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1222)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1036),
  /* template */
  __webpack_require__(1639),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1e5ca3b1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 84 */,
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(10);



var API_BASE_URL = "https://api.yousound.com" + '/v1/payments';

/* harmony default export */ __webpack_exports__["a"] = ({
  refundMoney: function refundMoney(paymentId, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post("https://api.yousound.com" + '/v1/payments/' + paymentId + '/refund', params, { headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token } });
  },
  refundOrder: function refundOrder(paymentId, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post("https://api.yousound.com" + '/v1/payments/' + paymentId + '/refund_order', params, { headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token } });
  },
  makeDeposit: function makeDeposit(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL + '/deposit', params, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  withdrawMoney: function withdrawMoney(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL + '/withdraw', params, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  getAllPayments: function getAllPayments(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL, {
      params: params,
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  getSentPayments: function getSentPayments(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/sent', {
      params: params,
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  getReceivedPayments: function getReceivedPayments(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/received', {
      params: params,
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  hasTransactionInPeriod: function hasTransactionInPeriod() {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/has_transaction_in_period', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  }
});

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1217)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(991),
  /* template */
  __webpack_require__(1634),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1c92bd32",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 87 */,
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(10);



var API_BASE_URL = "https://api.yousound.com" + '/v1/activities';

/* harmony default export */ __webpack_exports__["a"] = ({
  getActivities: function getActivities(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token },
      params: params
    });
  },
  getMetrics: function getMetrics(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/metrics', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token },
      params: params
    });
  },
  getUnread: function getUnread() {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/unread', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  makeRead: function makeRead(type) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/read?module_type=' + type, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },


  /* album / {id} / activities */
  getAlbumActivities: function getAlbumActivities(albumId, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get("https://api.yousound.com" + '/v1/albums/' + albumId + '/activities', { headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }, params: params });
  },
  getAlbumStats: function getAlbumStats(albumId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get("https://api.yousound.com" + '/v1/albums/' + albumId + '/activities/stats', { headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token } });
  },
  repostedBy: function repostedBy(albumId, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get("https://api.yousound.com" + '/v1/albums/' + albumId + '/activities/reposted_by', { headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }, params: params });
  },
  downloadedBy: function downloadedBy(albumId, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get("https://api.yousound.com" + '/v1/albums/' + albumId + '/activities/downloaded_by', { headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }, params: params });
  },
  playedBy: function playedBy(albumId, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get("https://api.yousound.com" + '/v1/albums/' + albumId + '/activities/played_by', { headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }, params: params });
  }
});

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1370)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(934),
  /* template */
  __webpack_require__(1844),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-bd1c5bf0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1330)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(990),
  /* template */
  __webpack_require__(1790),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7a0d0470",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 91 */,
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1287)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1101),
  /* template */
  __webpack_require__(1735),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5afe97e2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(10);



var API_BASE_URL_V1 = "https://api.yousound.com" + '/v1/genres';
var API_BASE_URL_V2 = "https://api.yousound.com" + '/v2/genres';

/* harmony default export */ __webpack_exports__["a"] = ({
  getGenres2: function getGenres2() {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL_V2);
  },
  addGenre2: function addGenre2(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL_V2, params, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  deleteGenres2: function deleteGenres2(genreId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.delete(API_BASE_URL_V2 + '/' + genreId, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  updateGenre2: function updateGenre2(genreId, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.patch(API_BASE_URL_V2 + '/' + genreId, params, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  getGenres: function getGenres() {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL_V1);
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(10);



var API_BASE_URL = "https://api.yousound.com" + '/v1/playlists';

/* harmony default export */ __webpack_exports__["a"] = ({
  getPlaylists: function getPlaylists() {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  createPlaylist: function createPlaylist(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL, params, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  getPlaylist: function getPlaylist(playlistId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + playlistId, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  deletePlaylist: function deletePlaylist(playlistId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.delete(API_BASE_URL + '/' + playlistId, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  updatePlaylist: function updatePlaylist(playlistId, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.patch(API_BASE_URL + '/' + playlistId, params, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  removeTrack: function removeTrack(playlistId, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL + '/' + playlistId + '/remove_track', params, { headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token } });
  }
});

/***/ }),
/* 95 */,
/* 96 */,
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/music-drop.a393fa0.gif";

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1242)
}
var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(1668),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2d1d024b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1390)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(956),
  /* template */
  __webpack_require__(1866),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ee94af60",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1250)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(957),
  /* template */
  __webpack_require__(1681),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-36e8a24d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1357)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(980),
  /* template */
  __webpack_require__(1825),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a01bce68",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1332)
  __webpack_require__(1333)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(981),
  /* template */
  __webpack_require__(1795),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7d071d58",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1398)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(982),
  /* template */
  __webpack_require__(1876),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f9a364b6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1352)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(985),
  /* template */
  __webpack_require__(1820),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-9d814eb2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1214)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(986),
  /* template */
  __webpack_require__(1631),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1a80f13b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1399)
  __webpack_require__(1400)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(987),
  /* template */
  __webpack_require__(1877),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-fa6d51e2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1361)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(988),
  /* template */
  __webpack_require__(1833),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a8122a9e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1305)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(995),
  /* template */
  __webpack_require__(1756),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-67a96152",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1212)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(996),
  /* template */
  __webpack_require__(1627),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-17c182c7",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1291)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(997),
  /* template */
  __webpack_require__(1739),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5f3dc97b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIxMSIgdmlld0JveD0iMCAwIDIwIDExIiBmaWxsPSJub25lIj4KICA8cGF0aCBkPSJNMSAxLjU1OTkyTDEwIDkuNzQzOUwxOSAxLjU1OTkyIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPg=="

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/you.a48b21a.png";

/***/ }),
/* 119 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjEiIGhlaWdodD0iNjEiIHZpZXdCb3g9IjAgMCA2MSA2MSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTUxLjIxMTUgOC43ODg1M0M0NS41NTM5IDMuMTEyNiAzOC4wMTA0IDAgMzAuMDA5MiAwQzIxLjk4OTYgMCAxNC40NDYxIDMuMTEyNiA4Ljc4ODUzIDguNzg4NTNDMy4xMTI2IDE0LjQ0NjEgMCAyMS45ODk2IDAgMzAuMDA5MkMwIDM4LjAyODcgMy4xMTI2IDQ1LjU1MzkgOC43ODg1MyA1MS4yMjk4QzE0LjQ0NjEgNTYuODg3NCAyMS45ODk2IDYwLjAxODMgMzAuMDA5MiA2MC4wMTgzQzM4LjAyODcgNjAuMDE4MyA0NS41NTM5IDU2LjkwNTcgNTEuMjI5OCA1MS4yMjk4QzU2Ljg4NzQgNDUuNTcyMiA2MC4wMTgzIDM4LjAyODcgNjAuMDE4MyAzMC4wMDkyQzYwIDIxLjk4OTYgNTYuODg3NCAxNC40NDYxIDUxLjIxMTUgOC43ODg1M1oiIGZpbGw9IiMzQ0FGNDciLz4KPHBhdGggZD0iTTI2LjA3MjUgMzUuNDQ3MkwyMC4xNzY4IDI5LjU1MTVDMTkuMDQxNiAyOC40MTY0IDE3LjE3NDEgMjguNDE2NCAxNi4wMzg5IDI5LjU1MTVDMTQuOTAzNyAzMC42ODY3IDE0LjkwMzcgMzIuNTU0MyAxNi4wMzg5IDMzLjY4OTVMMjQuMDAzNSA0MS42NTQxQzI1LjEzODcgNDIuNzg5MyAyNy4wMDYyIDQyLjc4OTMgMjguMTQxNCA0MS42NTQxTDQ0LjcxMTUgMjUuMDg0QzQ1Ljg0NjYgMjMuOTQ4OSA0NS44NDY2IDIyLjA4MTMgNDQuNzExNSAyMC45NDYxQzQzLjU3NjMgMTkuODEwOSA0MS43MDg3IDE5LjgxMDkgNDAuNTczNSAyMC45NDYxTDI2LjA3MjUgMzUuNDQ3MloiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo="

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1264)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(947),
  /* template */
  __webpack_require__(1702),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1269)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(977),
  /* template */
  __webpack_require__(1711),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1225)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1088),
  /* template */
  __webpack_require__(1643),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1380)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(978),
  /* template */
  __webpack_require__(1853),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d10e088c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1374)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(994),
  /* template */
  __webpack_require__(1847),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c4e4c282",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1279)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(998),
  /* template */
  __webpack_require__(1720),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-51152611",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(10);



var API_BASE_URL = "https://api.yousound.com" + '/v1/messages';

/* harmony default export */ __webpack_exports__["a"] = ({
  getConversations: function getConversations(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/conversations', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token },
      params: params
    });
  },
  deleteConversation: function deleteConversation(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL + '/delete_conversation', params, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  hasPendingRepost: function hasPendingRepost(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL + '/has_pending_repost', params, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  removeRepost: function removeRepost(id) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + id + '/remove_repost_request', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  acceptRepost: function acceptRepost(id) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + id + '/accept_repost', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  denyRepost: function denyRepost(id) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + id + '/deny_repost', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  acceptRepostOnFree: function acceptRepostOnFree(id) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + id + '/accept_repost_on_free', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  getMessages: function getMessages(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token },
      params: params
    });
  },
  addMessage: function addMessage(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL, params, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  deleteMessage: function deleteMessage(messageId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.delete(API_BASE_URL + '/' + messageId, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  getMessage: function getMessage(messageId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + messageId, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  editMessage: function editMessage(messageId, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.patch(API_BASE_URL + '/' + messageId, params, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  }
});

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(926),
  /* template */
  __webpack_require__(1718),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 128 */,
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1261)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(869),
  /* template */
  __webpack_require__(1698),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-41da1ec1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(10);



var API_BASE_URL = "https://api.yousound.com" + '/v1/shopping/orders';

/* harmony default export */ __webpack_exports__["a"] = ({
  getOrders: function getOrders(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL, {
      params: params,
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  getSentOrders: function getSentOrders(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/sent', {
      params: params,
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  getReceivedOrders: function getReceivedOrders(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/received', {
      params: params,
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  receivedExport: function receivedExport(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/received_export', {
      params: params,
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  getOrder: function getOrder(orderId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + orderId, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  hideMyAddress: function hideMyAddress(orderId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get("https://api.yousound.com" + '/v1/shopping/orders/' + orderId + '/hide_customer_address', { headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token } });
  }
});

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1247)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1029),
  /* template */
  __webpack_require__(1677),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-35306e0e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1023),
  /* template */
  __webpack_require__(1632),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(954),
  /* template */
  __webpack_require__(1741),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 134 */,
/* 135 */,
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(892),
  /* template */
  __webpack_require__(1753),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1055),
  /* template */
  __webpack_require__(1792),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(951),
  /* template */
  __webpack_require__(1874),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1063),
  /* template */
  __webpack_require__(1726),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1353)
  __webpack_require__(1354)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1084),
  /* template */
  __webpack_require__(1821),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-9e5a8ba0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1379)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(976),
  /* template */
  __webpack_require__(1851),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d00e0554",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1322)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1104),
  /* template */
  __webpack_require__(1777),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-74438020",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1111),
  /* template */
  __webpack_require__(1773),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1201)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1030),
  /* template */
  __webpack_require__(1613),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-10cfd65f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1118),
  /* template */
  __webpack_require__(1813),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(10);



var API_BASE_URL = "https://api.yousound.com" + '/v1/collection_playlists';

/* harmony default export */ __webpack_exports__["a"] = ({
  getCollectionPlaylists: function getCollectionPlaylists() {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/', { headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token } });
  },
  createCollectionPlaylist: function createCollectionPlaylist(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL + '/', params, { headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token } });
  },
  getPlaylistDetails: function getPlaylistDetails(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/fetch_playlist_details', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token },
      params: params
    });
  },
  removeFromPlaylist: function removeFromPlaylist(playlistId, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL + '/' + playlistId + '/remove_from_playlist', params, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  destroy: function destroy(playlistId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.delete(API_BASE_URL + '/' + playlistId, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  }
});

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/loading.d4cf7f2.gif";

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tile-1.f162568.jpeg";

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1237)
  __webpack_require__(1236)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(913),
  /* template */
  __webpack_require__(1662),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-299cf0ac",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1288)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1045),
  /* template */
  __webpack_require__(1736),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5d5cf286",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1093),
  /* template */
  __webpack_require__(1827),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1318)
  __webpack_require__(1317)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1108),
  /* template */
  __webpack_require__(1769),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-703f06d1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1210)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1122),
  /* template */
  __webpack_require__(1625),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-16f87427",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 154 */,
/* 155 */,
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(10);



var API_BASE_URL = "https://api.yousound.com" + '/v1/settings';

/* harmony default export */ __webpack_exports__["a"] = ({
  getSettings: function getSettings() {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL);
  },
  updateSetting: function updateSetting(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL, params, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  }
});

/***/ }),
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1IDFMMSAxNSIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTUgMTVMMSAxIiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo="

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/community.75f2783.png";

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/loader.0a55a0f.gif";

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1362)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(967),
  /* template */
  __webpack_require__(1834),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a89604fc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1253)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(970),
  /* template */
  __webpack_require__(1685),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3829967c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1195)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1003),
  /* template */
  __webpack_require__(1602),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-08139298",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1218)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(964),
  /* template */
  __webpack_require__(1636),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1dc3b0a3",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1037),
  /* template */
  __webpack_require__(1839),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 175 */,
/* 176 */,
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1341)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(895),
  /* template */
  __webpack_require__(1805),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-846f8b9a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 178 */,
/* 179 */,
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_cache__ = __webpack_require__(76);




var API_BASE_URL = "https://api.yousound.com" + '/v1/profile';

var cache = new __WEBPACK_IMPORTED_MODULE_2__services_cache__["a" /* default */]('profile', { expiration: 60 });

/* harmony default export */ __webpack_exports__["a"] = ({
  initCache: function initCache() {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.interceptors.push(function (req) {
      if (req.fresh) cache.del(req.url);
      if (req.url.startsWith(API_BASE_URL)) {
        var valid = cache.get(req.url);
        if (valid) {
          return req.respondWith(valid, {
            status: 200,
            statusText: 'OK'
          });
        } // if nothing is returned, continue
      }

      return function (res) {
        if (res && res.status === 200 && res.url.startsWith(API_BASE_URL)) {
          cache.set(res.url, res.body);
        }
        return res;
      };
    });
  },
  getAlbums: function getAlbums(userId, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL + '/' + userId + '/songs', params);
  },
  getMerch: function getMerch(userId, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL + '/' + userId + '/merch', params);
  },
  getDownloaded: function getDownloaded(userId, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL + '/' + userId + '/downloaded', params);
  },
  getReposted: function getReposted(userId, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL + '/' + userId + '/reposted', params);
  },
  getPlaylists: function getPlaylists(userId, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL + '/' + userId + '/playlists', params);
  },
  getSampleFollowings: function getSampleFollowings(userId, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL + '/' + userId + '/sample_followings', params);
  },
  getFollowings: function getFollowings(userId, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL + '/' + userId + '/followings', params);
  },
  getFollowers: function getFollowers(userId, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL + '/' + userId + '/followers', params);
  },
  getItems: function getItems(userId, type, params) {
    if (__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.user) {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL + '/' + userId + '/' + type, params, {
        headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
      });
    } else {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL + '/' + userId + '/' + type, params);
    }
  }
});

/***/ }),
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1022),
  /* template */
  __webpack_require__(1830),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 186 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 187 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 188 */,
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1232)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1064),
  /* template */
  __webpack_require__(1652),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1397)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1094),
  /* template */
  __webpack_require__(1875),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f98928d2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1310)
  __webpack_require__(1309)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1123),
  /* template */
  __webpack_require__(1761),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6b6de363",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);


var API_BASE_URL = "https://api.yousound.com" + '/v1/shopping/categories';

/* harmony default export */ __webpack_exports__["a"] = ({
  getCategories: function getCategories() {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL);
  }
});

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(10);



var API_BASE_URL = "https://api.yousound.com" + '/v1/invitations';

var InvitationService = {
  createInvitation: function createInvitation() {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL, null, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  findByToken: function findByToken(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/find_by_token', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token },
      params: params
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (InvitationService);

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(10);



var API_BASE_URL = "https://api.yousound.com" + '/v1/videos';

/* harmony default export */ __webpack_exports__["a"] = ({
  createVideo: function createVideo(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL, params, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  similarVideos: function similarVideos(videoId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + videoId + '/similars', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  spotlightVideoAvailable: function spotlightVideoAvailable() {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/spotlight_video_available', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  }
});

/***/ }),
/* 199 */,
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(894),
  /* template */
  __webpack_require__(1766),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(1629),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(1715),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(1603),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(1723),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(1675),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(1747),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(1617),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(1799),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(1762),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 210 */,
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(10);



var API_BASE_URL = "https://api.yousound.com" + '/v2/sms';

var smsService = {
  sendSMS: function sendSMS(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL + '/sms_send', params, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },

  listSMS: function listSMS() {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  getSMS: function getSMS(smsId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + smsId, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },

  deleteSMS: function deleteSMS(smsId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.delete(API_BASE_URL + '/' + smsId, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },

  updateSMS: function updateSMS(smsId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.patch(API_BASE_URL + '/' + smsId, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (smsService);

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(10);



var API_BASE_URL = "https://api.yousound.com" + '/v1/trackings';

/* harmony default export */ __webpack_exports__["a"] = ({
  createPlayRecord: function createPlayRecord(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL, params, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  getDashboardStats: function getDashboardStats() {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/dashboard_stats', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  }
});

/***/ }),
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/banner.58a6eaa.gif";

/***/ }),
/* 222 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTYuODM0IDEuMTI4MDFDNi43NjIxMiAxLjA2MzQ5IDYuNjczMDkgMS4wMjExNyA2LjU3NzY3IDEuMDA2MTZDNi40ODIyNiAwLjk5MTE1NyA2LjM4NDUzIDEuMDA0MTEgNi4yOTYzMiAxLjA0MzQ2QzYuMjA4MTEgMS4wODI4IDYuMTMzMTggMS4xNDY4NiA2LjA4MDU5IDEuMjI3ODhDNi4wMjgwMSAxLjMwODkgNi4wMDAwMiAxLjQwMzQyIDYgMS41MDAwMVY0LjAxNDAxQzMuODY2IDQuMTMwMDEgMCA1LjA5MDAxIDAgMTAuNUMwLjAwMDE3OTY1OSAxMC42MDc3IDAuMDM1MTMyIDEwLjcxMjUgMC4wOTk2NTUgMTAuNzk4N0MwLjE2NDE3OCAxMC44ODUgMC4yNTQ4MjIgMTAuOTQ4MSAwLjM1ODA5NyAxMC45Nzg2QzAuNDYxMzcyIDExLjAwOTIgMC41NzE3NTYgMTEuMDA1NiAwLjY3MjgyMiAxMC45Njg0QzAuNzczODg3IDEwLjkzMTEgMC44NjAyMyAxMC44NjIzIDAuOTE5IDEwLjc3MkMxLjQ3MDI0IDkuOTI0MzMgMi4yMjI2OCA5LjIyNjIyIDMuMTA5MjMgOC43Mzk5M0MzLjk5NTc4IDguMjUzNjUgNC45ODg4OCA3Ljk5NDMgNiA3Ljk4NTAxVjEwLjVDNi4wMDAwMiAxMC41OTY2IDYuMDI4MDEgMTAuNjkxMSA2LjA4MDU5IDEwLjc3MjFDNi4xMzMxOCAxMC44NTMyIDYuMjA4MTEgMTAuOTE3MiA2LjI5NjMyIDEwLjk1NjZDNi4zODQ1MyAxMC45OTU5IDYuNDgyMjYgMTEuMDA4OSA2LjU3NzY3IDEwLjk5MzlDNi42NzMwOSAxMC45Nzg5IDYuNzYyMTIgMTAuOTM2NSA2LjgzNCAxMC44NzJMMTEuODM0IDYuMzcyMDFDMTEuODg2MiA2LjMyNTEyIDExLjkyOCA2LjI2Nzc2IDExLjk1NjYgNi4yMDM2N0MxMS45ODUxIDYuMTM5NTggMTEuOTk5OSA2LjA3MDE5IDExLjk5OTkgNi4wMDAwMUMxMS45OTk5IDUuOTI5ODMgMTEuOTg1MSA1Ljg2MDQ0IDExLjk1NjYgNS43OTYzNUMxMS45MjggNS43MzIyNiAxMS44ODYyIDUuNjc0OSAxMS44MzQgNS42MjgwMUw2LjgzNCAxLjEyODAxWiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg=="

/***/ }),
/* 223 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1IDFMMSAxNSIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTUgMTVMMSAxIiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo="

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1244)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(880),
  /* template */
  __webpack_require__(1672),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-318beaa8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1283)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(881),
  /* template */
  __webpack_require__(1727),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-551a8f77",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1208)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(906),
  /* template */
  __webpack_require__(1622),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-160f9dc0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1375)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(950),
  /* template */
  __webpack_require__(1848),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1047),
  /* template */
  __webpack_require__(1624),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1228)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1048),
  /* template */
  __webpack_require__(1645),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1fa8ff3c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1049),
  /* template */
  __webpack_require__(1600),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1299)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1050),
  /* template */
  __webpack_require__(1750),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-638c7c64",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1327)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1051),
  /* template */
  __webpack_require__(1785),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-77332981",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1231)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1052),
  /* template */
  __webpack_require__(1649),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-20f811ab",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1053),
  /* template */
  __webpack_require__(1863),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1289)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1054),
  /* template */
  __webpack_require__(1737),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5d6553a1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1302)
  __webpack_require__(1301)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1056),
  /* template */
  __webpack_require__(1752),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6469ac4d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1057),
  /* template */
  __webpack_require__(1779),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1323)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1058),
  /* template */
  __webpack_require__(1778),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-74611830",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1307)
  __webpack_require__(1308)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1059),
  /* template */
  __webpack_require__(1758),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-68e157fa",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(952),
  /* template */
  __webpack_require__(1840),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1298)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(953),
  /* template */
  __webpack_require__(1749),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-63736202",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1062),
  /* template */
  __webpack_require__(1867),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1272)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(955),
  /* template */
  __webpack_require__(1713),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1072),
  /* template */
  __webpack_require__(1697),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1073),
  /* template */
  __webpack_require__(1770),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(959),
  /* template */
  __webpack_require__(1794),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1282)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(960),
  /* template */
  __webpack_require__(1725),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-53e47d0c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1387)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(961),
  /* template */
  __webpack_require__(1861),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-eb7dd666",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1196)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(962),
  /* template */
  __webpack_require__(1605),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0b33b5fe",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(965),
  /* template */
  __webpack_require__(1691),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(966),
  /* template */
  __webpack_require__(1806),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1206)
  __webpack_require__(1205)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1087),
  /* template */
  __webpack_require__(1620),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1500a68c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(1642),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(1684),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(1658),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(1760),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(1730),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(1772),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1381)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1019),
  /* template */
  __webpack_require__(1854),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-dd3f6ae8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1351)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1020),
  /* template */
  __webpack_require__(1819),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1096),
  /* template */
  __webpack_require__(1724),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1024),
  /* template */
  __webpack_require__(1670),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1100),
  /* template */
  __webpack_require__(1818),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1102),
  /* template */
  __webpack_require__(1673),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1103),
  /* template */
  __webpack_require__(1862),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1105),
  /* template */
  __webpack_require__(1780),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1106),
  /* template */
  __webpack_require__(1671),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1107),
  /* template */
  __webpack_require__(1788),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1243)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1031),
  /* template */
  __webpack_require__(1669),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2d5ee601",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1275)
  __webpack_require__(1274)
  __webpack_require__(1276)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1032),
  /* template */
  __webpack_require__(1716),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 308 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAyNSAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGxpbmUgeDE9IjEuNSIgeTE9IjIuNSIgeDI9IjEuNSIgeTI9IjI4LjUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+CjxsaW5lIHgxPSI5LjUiIHkxPSIyLjUiIHgyPSI5LjUiIHkyPSIyOC41IiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8bGluZSB4MT0iMTYuMjA0MyIgeTE9IjIuMzI1OTgiIHgyPSIyMy4wNjA2IiB5Mj0iMjcuOTE0MiIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIzIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPC9zdmc+Cg=="

/***/ }),
/* 309 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTkiIHZpZXdCb3g9IjAgMCAxOCAxOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9Ikljb24iPgo8cGF0aCBpZD0iVmVjdG9yIiBkPSJNMy43MjY2NSA5LjM0ODcyTDcuMzc0OTMgMTIuOTk3TDE0LjY3MTUgNS43MDA0NCIgc3Ryb2tlPSIjMTQxNDE0IiBzdHJva2Utd2lkdGg9IjEuNDU5MzEiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L2c+Cjwvc3ZnPgo="

/***/ }),
/* 310 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTQiIGhlaWdodD0iNTQiIHZpZXdCb3g9IjAgMCA1NCA1NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI3IDEuNjg3NUMyMS45OTM3IDEuNjg3NSAxNy4wOTk4IDMuMTcyMDUgMTIuOTM3MSA1Ljk1MzQyQzguNzc0NTIgOC43MzQ4IDUuNTMwMTUgMTIuNjg4MSAzLjYxNDMxIDE3LjMxMzNDMS42OTg0NyAyMS45Mzg2IDEuMTk3MiAyNy4wMjgxIDIuMTczODggMzEuOTM4MkMzLjE1MDU3IDM2Ljg0ODQgNS41NjEzNSA0MS4zNTg2IDkuMTAxMzcgNDQuODk4NkMxMi42NDE0IDQ4LjQzODcgMTcuMTUxNiA1MC44NDk0IDIyLjA2MTggNTEuODI2MUMyNi45NzE5IDUyLjgwMjggMzIuMDYxNCA1Mi4zMDE1IDM2LjY4NjcgNTAuMzg1N0M0MS4zMTE5IDQ4LjQ2OTkgNDUuMjY1MiA0NS4yMjU1IDQ4LjA0NjYgNDEuMDYyOUM1MC44MjggMzYuOTAwMiA1Mi4zMTI1IDMyLjAwNjMgNTIuMzEyNSAyN0M1Mi4zMDY3IDIwLjI4ODUgNDkuNjM4IDEzLjg1MzUgNDQuODkyMiA5LjEwNzc3QzQwLjE0NjUgNC4zNjIwMiAzMy43MTE1IDEuNjkzMzEgMjcgMS42ODc1Wk0zOS40MDMxIDE5LjE1MzFMMjIuNTI4MSAzNi4wMjgxQzIyLjQ1MTkgMzYuMTA4MSAyMi4zNjAzIDM2LjE3MTcgMjIuMjU4OCAzNi4yMTUyQzIyLjE1NzMgMzYuMjU4NyAyMi4wNDggMzYuMjgxMSAyMS45Mzc1IDM2LjI4MTFDMjEuODI3MSAzNi4yODExIDIxLjcxNzggMzYuMjU4NyAyMS42MTYyIDM2LjIxNTJDMjEuNTE0NyAzNi4xNzE3IDIxLjQyMzEgMzYuMTA4MSAyMS4zNDY5IDM2LjAyODFMMTQuNTk2OSAyOS4yNzgxQzE0LjQ0MjggMjkuMTIwOSAxNC4zNTcxIDI4LjkwOTMgMTQuMzU4MiAyOC42ODkyQzE0LjM1OTMgMjguNDY5MiAxNC40NDcyIDI4LjI1ODQgMTQuNjAyOCAyOC4xMDI4QzE0Ljc1ODQgMjcuOTQ3MiAxNC45NjkyIDI3Ljg1OTMgMTUuMTg5MyAyNy44NTgyQzE1LjQwOTMgMjcuODU3IDE1LjYyMSAyNy45NDI4IDE1Ljc3ODEgMjguMDk2OUwyMS45Mzc1IDM0LjI1NjJMMzguMjIxOSAxNy45NzE5QzM4LjI5OTIgMTcuODkzIDM4LjM5MTMgMTcuODMwMyAzOC40OTMgMTcuNzg3MkMzOC41OTQ3IDE3Ljc0NDIgMzguNzAzOSAxNy43MjE4IDM4LjgxNDMgMTcuNzIxMkMzOC45MjQ3IDE3LjcyMDcgMzkuMDM0MSAxNy43NDIgMzkuMTM2MiAxNy43ODRDMzkuMjM4MyAxNy44MjYgMzkuMzMxMSAxNy44ODc4IDM5LjQwOTEgMTcuOTY1OUMzOS40ODcyIDE4LjA0MzkgMzkuNTQ5IDE4LjEzNjcgMzkuNTkxIDE4LjIzODhDMzkuNjMzIDE4LjM0MDkgMzkuNjU0MyAxOC40NTAzIDM5LjY1MzggMTguNTYwOEMzOS42NTMyIDE4LjY3MTIgMzkuNjMwOCAxOC43ODA0IDM5LjU4NzggMTguODgyQzM5LjU0NDcgMTguOTgzNyAzOS40ODIgMTkuMDc1OCAzOS40MDMxIDE5LjE1MzFaIiBmaWxsPSIjMUFBRTVFIi8+Cjwvc3ZnPgo="

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/img_download_app_store.bac32ff.svg";

/***/ }),
/* 312 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/jacki.7bc9035.png";

/***/ }),
/* 314 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 315 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDEyIDEyIiBmaWxsPSJub25lIj4KICA8cGF0aCBkPSJNNS43NSAxMS41QzIuNTc5MzQgMTEuNSAwIDguOTIwNTMgMCA1Ljc1QzAgMi41Nzk0NyAyLjU3OTM0IDAgNS43NSAwQzguOTIwNjYgMCAxMS41IDIuNTc5NDcgMTEuNSA1Ljc1QzExLjUgOC45MjA1MyA4LjkyMDY2IDExLjUgNS43NSAxMS41WiIgZmlsbD0id2hpdGUiLz4KICA8cGF0aCBkPSJNNC43NSA4LjQ1NzE2TDIuMDQyOTcgNS43NUwyLjc1IDUuMDQyODVMNC43NSA3LjA0Mjg1TDguNzUgMy4wNDI4NUw5LjQ1NzAzIDMuNzVMNC43NSA4LjQ1NzE2WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+"

/***/ }),
/* 316 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 317 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9ImRvdHMgMSI+CjxnIGlkPSJHcm91cCI+CjxwYXRoIGlkPSJWZWN0b3IiIGQ9Ik0xMiAxNUMxMy4xMDQ2IDE1IDE0IDE0LjEwNDYgMTQgMTNDMTQgMTEuODk1NCAxMy4xMDQ2IDExIDEyIDExQzEwLjg5NTQgMTEgMTAgMTEuODk1NCAxMCAxM0MxMCAxNC4xMDQ2IDEwLjg5NTQgMTUgMTIgMTVaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBpZD0iVmVjdG9yXzIiIGQ9Ik0zIDE1QzQuMTA0NTcgMTUgNSAxNC4xMDQ2IDUgMTNDNSAxMS44OTU0IDQuMTA0NTcgMTEgMyAxMUMxLjg5NTQzIDExIDEgMTEuODk1NCAxIDEzQzEgMTQuMTA0NiAxLjg5NTQzIDE1IDMgMTVaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBpZD0iVmVjdG9yXzMiIGQ9Ik0yMSAxNUMyMi4xMDQ2IDE1IDIzIDE0LjEwNDYgMjMgMTNDMjMgMTEuODk1NCAyMi4xMDQ2IDExIDIxIDExQzE5Ljg5NTQgMTEgMTkgMTEuODk1NCAxOSAxM0MxOSAxNC4xMDQ2IDE5Ljg5NTQgMTUgMjEgMTVaIiBmaWxsPSJ3aGl0ZSIvPgo8L2c+CjwvZz4KPC9zdmc+Cg=="

/***/ }),
/* 318 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAyNSAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9Ikdyb3VwIj4KPHBhdGggaWQ9IlZlY3RvciIgZD0iTTIyLjE3NiAwSDIuMjM1MjlDMS4xMzM5OSAwIDAuMjQxMjExIDAuODk1NDMgMC4yNDEyMTEgMlYxNEMwLjI0MTIxMSAxNS4xMDQ2IDEuMTMzOTkgMTYgMi4yMzUyOSAxNkgyMi4xNzZDMjMuMjc3MyAxNiAyNC4xNzAxIDE1LjEwNDYgMjQuMTcwMSAxNFYyQzI0LjE3MDEgMC44OTU0MyAyMy4yNzczIDAgMjIuMTc2IDBaIiBmaWxsPSIjMjUyNTI1Ii8+CjxwYXRoIGlkPSJWZWN0b3JfMiIgZD0iTTkuMjE0NjggMTNDMTEuOTY3OSAxMyAxNC4xOTk5IDEwLjc2MTQgMTQuMTk5OSA4QzE0LjE5OTkgNS4yMzg1OCAxMS45Njc5IDMgOS4yMTQ2OCAzQzYuNDYxNDQgMyA0LjIyOTQ5IDUuMjM4NTggNC4yMjk0OSA4QzQuMjI5NDkgMTAuNzYxNCA2LjQ2MTQ0IDEzIDkuMjE0NjggMTNaIiBmaWxsPSIjRUIwMDFCIi8+CjxwYXRoIGlkPSJWZWN0b3JfMyIgZD0iTTE1LjE5NzEgMTNDMTcuOTUwMyAxMyAyMC4xODIzIDEwLjc2MTQgMjAuMTgyMyA4QzIwLjE4MjMgNS4yMzg1OCAxNy45NTAzIDMgMTUuMTk3MSAzQzEyLjQ0MzkgMyAxMC4yMTE5IDUuMjM4NTggMTAuMjExOSA4QzEwLjIxMTkgMTAuNzYxNCAxMi40NDM5IDEzIDE1LjE5NzEgMTNaIiBmaWxsPSIjRjc5RTFCIi8+CjxwYXRoIGlkPSJWZWN0b3JfNCIgZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMi4yMDYgMy45OTk2M0MxMy40MTY4IDQuOTExODQgMTQuMjAwMSA2LjM2NDE4IDE0LjIwMDEgOEMxNC4yMDAxIDkuNjM1ODIgMTMuNDE2OCAxMS4wODgyIDEyLjIwNiAxMi4wMDA0QzEwLjk5NTEgMTEuMDg4MiAxMC4yMTE5IDkuNjM1ODIgMTAuMjExOSA4QzEwLjIxMTkgNi4zNjQxOCAxMC45OTUxIDQuOTExODQgMTIuMjA2IDMuOTk5NjNaIiBmaWxsPSIjRkY1RjAwIi8+CjwvZz4KPC9zdmc+Cg=="

/***/ }),
/* 319 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 320 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 321 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzEzMTFfMjA0NikiPgo8cGF0aCBkPSJNOC40ODU1IDBIMy41MTQ1TDAgMy41MTQ1VjguNDg1NUwzLjUxNDUgMTJIOC40ODU1TDEyIDguNDg1NVYzLjUxNDVMOC40ODU1IDBaTTYgOUM1Ljg5OTk0IDkuMDA2MDEgNS43OTk3NCA4Ljk5MDc0IDUuNzA2MDIgOC45NTUxN0M1LjYxMjMgOC45MTk2MSA1LjUyNzE5IDguODY0NTcgNS40NTYzMSA4Ljc5MzY5QzUuMzg1NDMgOC43MjI4MSA1LjMzMDM5IDguNjM3NyA1LjI5NDgzIDguNTQzOThDNS4yNTkyNiA4LjQ1MDI2IDUuMjQzOTkgOC4zNTAwNiA1LjI1IDguMjVDNS4yNDM5OSA4LjE0OTk0IDUuMjU5MjYgOC4wNDk3NCA1LjI5NDgzIDcuOTU2MDJDNS4zMzAzOSA3Ljg2MjMgNS4zODU0MyA3Ljc3NzE5IDUuNDU2MzEgNy43MDYzMUM1LjUyNzE5IDcuNjM1NDMgNS42MTIzIDcuNTgwMzkgNS43MDYwMiA3LjU0NDgzQzUuNzk5NzQgNy41MDkyNiA1Ljg5OTk0IDcuNDkzOTkgNiA3LjVDNi4xMDAwNiA3LjQ5Mzk5IDYuMjAwMjYgNy41MDkyNiA2LjI5Mzk4IDcuNTQ0ODNDNi4zODc3IDcuNTgwMzkgNi40NzI4MSA3LjYzNTQzIDYuNTQzNjkgNy43MDYzMUM2LjYxNDU3IDcuNzc3MTkgNi42Njk2MSA3Ljg2MjMgNi43MDUxNyA3Ljk1NjAyQzYuNzQwNzQgOC4wNDk3NCA2Ljc1NjAxIDguMTQ5OTQgNi43NSA4LjI1QzYuNzU2MDEgOC4zNTAwNiA2Ljc0MDc0IDguNDUwMjYgNi43MDUxNyA4LjU0Mzk4QzYuNjY5NjEgOC42Mzc3IDYuNjE0NTcgOC43MjI4MSA2LjU0MzY5IDguNzkzNjlDNi40NzI4MSA4Ljg2NDU3IDYuMzg3NyA4LjkxOTYxIDYuMjkzOTggOC45NTUxN0M2LjIwMDI2IDguOTkwNzQgNi4xMDAwNiA5LjAwNjAxIDYgOVY5Wk02Ljc1IDYuNzVINS4yNVYzSDYuNzVWNi43NVoiIGZpbGw9IndoaXRlIi8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfMTMxMV8yMDQ2Ij4KPHJlY3Qgd2lkdGg9IjEyIiBoZWlnaHQ9IjEyIiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo="

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/qrcode_android.6180649.png";

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/qrcode_ios.6180649.png";

/***/ }),
/* 324 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0LjU4NDYgNS44Njk2MkMxNC41MzI0IDUuNzQ2NTggMTQuNDExNiA1LjY2NjY2IDE0LjI3NzggNS42NjY2NkgxMC4yMTIxTDguMzAxOTIgMS41ODEwNEM4LjI0NzA3IDEuNDYzNjkgOC4xMjkzOSAxLjM4ODgyIDggMS4zODg4MkM3Ljg3MDYxIDEuMzg4ODIgNy43NTI5MyAxLjQ2MzY5IDcuNjk4MDggMS41ODEwNEw1Ljc4NzkyIDUuNjY2NjZIMS43MjIxN0MxLjU4ODM4IDUuNjY2NjYgMS40Njc2MSA1Ljc0NjU4IDEuNDE1MzYgNS44Njk2MkMxLjM2MzEyIDUuOTkyNjcgMS4zODkzMiA2LjEzNTA5IDEuNDgyMjYgNi4yMzE0NEw0LjQ5MyA5LjM1Mzg0TDMuMjgyMjMgMTQuMTk2OUMzLjI0OTg0IDE0LjMyNjUgMy4yOTc4NSAxNC40NjI5IDMuNDA0MyAxNC41NDM1QzMuNTEwNzQgMTQuNjI0IDMuNjU1MTEgMTQuNjMzMyAzLjc3MSAxNC41NjcyTDggMTIuMTUwNUwxMi4yMjkgMTQuNTY3MkMxMi4yODA0IDE0LjU5NjcgMTIuMzM3NCAxNC42MTEyIDEyLjM5NDQgMTQuNjExMkMxMi40NjU1IDE0LjYxMTIgMTIuNTM2NSAxNC41ODg0IDEyLjU5NTcgMTQuNTQzNUMxMi43MDIxIDE0LjQ2MjkgMTIuNzUwMiAxNC4zMjY1IDEyLjcxNzggMTQuMTk2OUwxMS41MDcgOS4zNTM4M0wxNC41MTc3IDYuMjMxNDRDMTQuNjEwNyA2LjEzNTA4IDE0LjYzNjkgNS45OTI2NyAxNC41ODQ2IDUuODY5NjJaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K"

/***/ }),
/* 325 */,
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1209)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(905),
  /* template */
  __webpack_require__(1623),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-16458c64",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1378)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(944),
  /* template */
  __webpack_require__(1850),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c8e5fb46",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1300)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(946),
  /* template */
  __webpack_require__(1751),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-640ff1a0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1233)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(948),
  /* template */
  __webpack_require__(1653),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2757306a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1314)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(949),
  /* template */
  __webpack_require__(1765),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6dba0e16",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1334)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1046),
  /* template */
  __webpack_require__(1796),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7df4a598",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1349)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1060),
  /* template */
  __webpack_require__(1816),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-948b24b6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1061),
  /* template */
  __webpack_require__(1612),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1065),
  /* template */
  __webpack_require__(1610),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1368)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1066),
  /* template */
  __webpack_require__(1842),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b90c6346",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1402)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1067),
  /* template */
  __webpack_require__(1879),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-fe4a8388",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1319)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1068),
  /* template */
  __webpack_require__(1771),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-71640cd4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1069),
  /* template */
  __webpack_require__(1745),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1070),
  /* template */
  __webpack_require__(1837),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1071),
  /* template */
  __webpack_require__(1604),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(958),
  /* template */
  __webpack_require__(1657),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1266)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1074),
  /* template */
  __webpack_require__(1706),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-44b5ce12",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1075),
  /* template */
  __webpack_require__(1864),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1076),
  /* template */
  __webpack_require__(1759),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1077),
  /* template */
  __webpack_require__(1822),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1364)
  __webpack_require__(1365)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1078),
  /* template */
  __webpack_require__(1836),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-adf1e6d8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1372)
  __webpack_require__(1373)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1079),
  /* template */
  __webpack_require__(1846),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-bff0e48c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1367)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1080),
  /* template */
  __webpack_require__(1841),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b8a8bd16",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1278)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1081),
  /* template */
  __webpack_require__(1719),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-50fbef94",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1396)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1082),
  /* template */
  __webpack_require__(1873),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f6c45a68",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1348)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1083),
  /* template */
  __webpack_require__(1815),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-9479c088",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1213)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(963),
  /* template */
  __webpack_require__(1630),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-19891cf6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1085),
  /* template */
  __webpack_require__(1767),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1086),
  /* template */
  __webpack_require__(1628),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1320)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(968),
  /* template */
  __webpack_require__(1774),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-72fc2972",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1245)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(969),
  /* template */
  __webpack_require__(1674),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3312f395",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1234)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(971),
  /* template */
  __webpack_require__(1654),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2790b15c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1339)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(972),
  /* template */
  __webpack_require__(1802),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-81f3b27e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1338)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(973),
  /* template */
  __webpack_require__(1801),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-81d7837c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1337)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(974),
  /* template */
  __webpack_require__(1800),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-81bb547a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1194)
  __webpack_require__(1193)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(975),
  /* template */
  __webpack_require__(1601),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-08127653",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1246)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(999),
  /* template */
  __webpack_require__(1676),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3426e565",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1285)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1000),
  /* template */
  __webpack_require__(1733),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5888a926",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1321)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1001),
  /* template */
  __webpack_require__(1775),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-72fc960b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1260)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1002),
  /* template */
  __webpack_require__(1694),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-40764274",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1248)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1005),
  /* template */
  __webpack_require__(1678),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-35977910",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1392)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1006),
  /* template */
  __webpack_require__(1869),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f35013ce",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1207)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1007),
  /* template */
  __webpack_require__(1621),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1527ea16",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1331)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1008),
  /* template */
  __webpack_require__(1791),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7a53320c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1296)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1009),
  /* template */
  __webpack_require__(1746),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-61fdb72e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1268)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1010),
  /* template */
  __webpack_require__(1709),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-47d8ff06",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1292)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1011),
  /* template */
  __webpack_require__(1740),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5f9e51de",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1359)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1012),
  /* template */
  __webpack_require__(1831),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a64dcea0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1369)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1013),
  /* template */
  __webpack_require__(1843),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b9b86e24",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1391)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1014),
  /* template */
  __webpack_require__(1868),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f248661c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1198)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1015),
  /* template */
  __webpack_require__(1608),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0cbc0566",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1326)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1016),
  /* template */
  __webpack_require__(1784),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-76c73cf4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1277)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1017),
  /* template */
  __webpack_require__(1717),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4bc8f25f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1384)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1018),
  /* template */
  __webpack_require__(1858),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e6be242c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1383)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1090),
  /* template */
  __webpack_require__(1857),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e218cfce",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1091),
  /* template */
  __webpack_require__(1687),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1329)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1092),
  /* template */
  __webpack_require__(1787),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7819fd59",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1401)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1021),
  /* template */
  __webpack_require__(1878),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-fb8165ec",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1316)
  __webpack_require__(1315)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1095),
  /* template */
  __webpack_require__(1768),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6f8a6f3f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1271)
  __webpack_require__(1270)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1097),
  /* template */
  __webpack_require__(1712),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4a4aa63c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1273)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1098),
  /* template */
  __webpack_require__(1714),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4ad08a0d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1280)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1099),
  /* template */
  __webpack_require__(1721),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-51578858",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1304)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1025),
  /* template */
  __webpack_require__(1755),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6746527c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1191)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1026),
  /* template */
  __webpack_require__(1598),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0178a6f2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1394)
}
var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(1871),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1303)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1109),
  /* template */
  __webpack_require__(1754),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1356)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1110),
  /* template */
  __webpack_require__(1824),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-9ee88bb8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1267)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1112),
  /* template */
  __webpack_require__(1708),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-46465822",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1113),
  /* template */
  __webpack_require__(1793),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1114),
  /* template */
  __webpack_require__(1776),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1388)
  __webpack_require__(1389)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1115),
  /* template */
  __webpack_require__(1865),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ede03a00",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1259)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1116),
  /* template */
  __webpack_require__(1693),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-401cdb90",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1117),
  /* template */
  __webpack_require__(1646),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1230)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1028),
  /* template */
  __webpack_require__(1648),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-20cbace0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1238)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1119),
  /* template */
  __webpack_require__(1663),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2a02d3bb",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1120),
  /* template */
  __webpack_require__(1696),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1121),
  /* template */
  __webpack_require__(1664),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1227)
  __webpack_require__(1226)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1124),
  /* template */
  __webpack_require__(1644),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1fa5c96b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1313)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1125),
  /* template */
  __webpack_require__(1764),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6d1173a4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1346)
  __webpack_require__(1345)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1126),
  /* template */
  __webpack_require__(1812),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-9218fa08",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1312)
  __webpack_require__(1311)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1127),
  /* template */
  __webpack_require__(1763),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6c2d9380",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1293)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1033),
  /* template */
  __webpack_require__(1742),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 408 */,
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1395)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(873),
  /* template */
  __webpack_require__(1872),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f545df6c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(923),
  /* template */
  __webpack_require__(1728),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(10);



var API_BASE_URL = "https://api.yousound.com" + '/v1/attendees';

/* harmony default export */ __webpack_exports__["a"] = ({
  getAttendees: function getAttendees(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token },
      params: params
    });
  },
  createAttendee: function createAttendee(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL, params);
  },
  deleteAttendee: function deleteAttendee(attendeeId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.delete(API_BASE_URL + '/' + attendeeId, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  findByToken: function findByToken(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/find_by_token', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token },
      params: params
    });
  },
  inviteAttendee: function inviteAttendee(attendeeId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + attendeeId + '/invite', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  }
});

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1360)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(867),
  /* template */
  __webpack_require__(1832),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a6538a8e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(876),
  /* template */
  __webpack_require__(1650),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_cache__ = __webpack_require__(76);




var API_BASE_URL = "https://api.yousound.com" + '/v1/memberships';

var cache = new __WEBPACK_IMPORTED_MODULE_2__services_cache__["a" /* default */]('tiers', { expiration: 150 });

/* harmony default export */ __webpack_exports__["a"] = ({
  initCache: function initCache() {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.interceptors.push(function (req) {
      if (req.fresh) cache.del(req.url);
      if (req.url.startsWith(API_BASE_URL) && req.method === 'GET') {
        var valid = cache.get(req.url);
        if (valid) {
          return req.respondWith(valid, {
            status: 200,
            statusText: 'OK'
          });
        } // if nothing is returned, continue
      }

      return function (res) {
        if (res && res.status === 200 && res.url.startsWith(API_BASE_URL)) {
          cache.set(res.url, res.body);
        }
        return res;
      };
    });
  },
  purchaseMembership: function purchaseMembership(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL, params, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  updateMembership: function updateMembership(membershipId, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.put(API_BASE_URL + '/' + membershipId, params, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  getMembers: function getMembers(tierFilter, daysFilter, q) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/members', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token },
      params: { 'tier_filter': tierFilter, 'days_filter': daysFilter, 'search': q }
    });
  },
  deleteMembership: function deleteMembership(membershipId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.delete(API_BASE_URL + '/' + membershipId, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  addToGuestlist: function addToGuestlist(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL + '/add_to_guestlist', params, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  removeFromGuestlist: function removeFromGuestlist(membershipId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.delete(API_BASE_URL + '/' + membershipId + '/remove_from_guestlist', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  }
});

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1284)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(865),
  /* template */
  __webpack_require__(1729),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-57215bed",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);


var API_BASE_URL = "https://api.yousound.com" + '/v1/twitter';

/* harmony default export */ __webpack_exports__["a"] = ({
  getRequestToken: function getRequestToken(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL + '/request_token', params);
  },
  getAccessToken: function getAccessToken(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL + '/access_token', params);
  },
  getUserInfo: function getUserInfo(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL + '/user_info', params);
  }
});

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(924),
  /* template */
  __webpack_require__(1660),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(10);



var API_BASE_URL = "https://api.yousound.com" + '/v1/shopping/addresses';

/* harmony default export */ __webpack_exports__["a"] = ({
  getAddresses: function getAddresses() {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  addAddress: function addAddress(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL, params, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  getAddress: function getAddress(addressId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + addressId, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  deleteAddress: function deleteAddress(addressId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.delete(API_BASE_URL + '/' + addressId, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  updateAddress: function updateAddress(addressId, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.patch(API_BASE_URL + '/' + addressId, params, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  }
});

/***/ }),
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1038),
  /* template */
  __webpack_require__(1659),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(936),
  /* template */
  __webpack_require__(1635),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_socket_io_client__ = __webpack_require__(1425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_socket_io_client___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_socket_io_client__);
/**
 * [SocketManager description]
 * @param {String} socketHost url of socket connection
 * @param {String} room       room to join
 */


var SocketManager = function SocketManager(socketHost, roomName, token, callback) {
  var sm = this;
  var socket = __WEBPACK_IMPORTED_MODULE_0_socket_io_client___default.a.connect(socketHost);

  sm.room = roomName || getParameterByName('room') || 'general'; // TODO: change 'general'

  socket.on('connect', function () {
    console.log('SocketManager connected to ' + roomName + ' @ ' + socketHost);
    socket.emit('authentication', { token: token });
    socket.on('authenticated', function () {
      callback();
      socket.emit('loadMessages', sm.room); // ask for old messages and to join artist soundroom
    });
    socket.on('unauthorized', function (err) {
      sm.onError('There was an error with the authentication: ' + err.message); // TODO: don't use alert
      sm.close();
    });
    socket.on('newMessage', function (a) {
      sm.onMessage(a);
    });
    socket.on('loadMessages', function (a) {
      sm.onLoadMessages(a);
    });
    socket.on('roomInfo', function (a) {
      sm.onRoomInfo(a);
    });
    socket.on('userInfo', sm.onUserInfo);
    socket.on('disconnect', function () {
      sm.onDisconnect();
    });
    socket.on('reconnect', sm.onReconnect);
    socket.on('messageError', function (a) {
      return sm.onError(a);
    });
  });

  /**
   * [messageConstructor description]
   * @param  {String} text [description]
   * @param  {User} from [description]
   * @return {Message}      [description]
   */
  var messageConstructor = function messageConstructor(text, from) {
    return { from: from, text: text, time: Date.now(), localId: Date.now() * Math.random() // fix id generation
    };
  };

  /**
   * [sendMessage description]
   * @param  {String} text [description]
   * @param  {User} from [description]
   */
  sm.sendMessage = function (text, from) {
    if (text.trim() === '') {
      return;
    }
    var message = messageConstructor(text, from);
    sm.onMessageSending(message);
    socket.emit('newMessage', message); // From field doesn't matter because server knows who this is
  };

  sm.idle = function () {
    socket.emit('idleUser');
  };

  sm.online = function () {
    socket.emit('onlineUser');
  };

  sm.updateSettings = function (settings) {
    socket.emit('settingsUpdate', settings);
  };

  sm.onDisconnect = function () {
    console.log('disconnected :('); // switch to toast eventually instead
  };

  sm.onReconnect = function () {
    console.log('reconnected :)'); // switch to toast eventually instead
    socket.emit('loadMessages', sm.room); // reload messages
  };

  // sm.loadMessages = () => {
  //   // socket.emit('loadMessages', sm.room)
  // }

  sm.close = function () {
    socket.close();
  };

  sm.onUserInfo = function (user) {
    // Override
  };

  sm.onRoomInfo = function (room) {
    // Override
  };

  sm.onMessageSending = function (message) {
    // Override
  };

  sm.onMessage = function (message) {
    // Override
  };

  sm.onLoadMessages = function (message) {
    // Override
  };

  sm.onError = function () {
    // Override
  };

  sm.moreMessages = function (chunk) {
    socket.emit('moreMessages', chunk);
  };

  return sm;
};

// Helper functions
var getParameterByName = function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[[]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
  var results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

/* harmony default export */ __webpack_exports__["a"] = (SocketManager);

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(10);



var API_BASE_URL = "https://api.yousound.com" + '/v1/tickets';

/* harmony default export */ __webpack_exports__["a"] = ({
  createTicket: function createTicket(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL, params, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  updateTicket: function updateTicket(ticketId, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.patch(API_BASE_URL + '/' + ticketId, params, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  }
});

/***/ }),
/* 426 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 427 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 428 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2NCA2NCIgd2lkdGg9IjY0IiBoZWlnaHQ9IjY0Ij48dGl0bGU+ZmlsZSBjb3BpZXM8L3RpdGxlPjxnIGNsYXNzPSJuYy1pY29uLXdyYXBwZXIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIzIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjUgMC41KSIgZmlsbD0iIzAwMDAwMCIgc3Ryb2tlPSIjMDAwMDAwIj48cmVjdCB4PSI2IiB5PSIxNiIgd2lkdGg9IjQwIiBoZWlnaHQ9IjQ0IiBmaWxsPSJub25lIiBzdHJva2U9IiMwMDAwMDAiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIvPjxwb2x5bGluZSBkYXRhLWNvbG9yPSJjb2xvci0yIiBwb2ludHM9IjE4IDQgNTggNCA1OCA0OCIgZmlsbD0ibm9uZSIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIi8+PHBvbHlsaW5lIGRhdGEtY29sb3I9ImNvbG9yLTIiIHBvaW50cz0iMTIgMTAgNTIgMTAgNTIgNTQiIGZpbGw9Im5vbmUiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIvPjwvZz48L3N2Zz4="

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/nav_logo_primary.7541579.png";

/***/ }),
/* 430 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2NCA2NCIgd2lkdGg9IjY0IiBoZWlnaHQ9IjY0Ij48dGl0bGU+c2V0dGluZ3MgZ2VhcjwvdGl0bGU+PGcgY2xhc3M9Im5jLWljb24td3JhcHBlciIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuNSAwLjUpIiBmaWxsPSIjMDAwMDAwIiBzdHJva2U9IiMwMDAwMDAiPjxjaXJjbGUgZGF0YS1jb2xvcj0iY29sb3ItMiIgY3g9IjMyIiBjeT0iMzIiIHI9IjkiIGZpbGw9Im5vbmUiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIvPjxwYXRoIGQ9Ik01My4wOTEsMzJhMjEuMTY2LDIxLjE2NiwwLDAsMC0uNS00LjUxNmw3LjE1NS01LjQxOC01LjI3Mi05LjEzMi04LjI4NiwzLjVBMjEuMDM0LDIxLjAzNCwwLDAsMCwzOC4zODUsMTEuOUwzNy4yNzMsM0gyNi43MjdsLTEuMTEyLDguOWEyMS4wMzQsMjEuMDM0LDAsMCwwLTcuODA3LDQuNTMybC04LjI4Ni0zLjVMNC4yNSwyMi4wNjZsNy4xNTUsNS40MThhMjAuODE3LDIwLjgxNywwLDAsMCwwLDkuMDMyTDQuMjUsNDEuOTM0bDUuMjcyLDkuMTMyLDguMjg2LTMuNUEyMS4wMzQsMjEuMDM0LDAsMCwwLDI1LjYxNSw1Mi4xTDI2LjcyNyw2MUgzNy4yNzNsMS4xMTItOC45YTIxLjAzNCwyMS4wMzQsMCwwLDAsNy44MDctNC41MzJsOC4yODYsMy41LDUuMjcyLTkuMTMyTDUyLjYsMzYuNTE2QTIxLjE2NiwyMS4xNjYsMCwwLDAsNTMuMDkxLDMyWiIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAwMDAwIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiLz48L2c+PC9zdmc+"

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(871),
  /* template */
  __webpack_require__(1710),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1355)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(884),
  /* template */
  __webpack_require__(1823),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-9ed37f6c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(933),
  /* template */
  __webpack_require__(1810),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzEzMTFfMjA0MikiPgo8cGF0aCBkPSJNMTAuOTMwNSA0LjI1MTc3TDkuODYyNDkgNS4zMTk3N0MxMC4wNzEgNS41ODAwMiAxMC4yNDIgNS44MTc3NyAxMC4zNjQyIDYuMDAwMDJDOS43OTQyNSA2Ljg0NzUyIDguMjI2NzUgOC44NjUwMiA2LjE5MzUgOC45ODg3N0w0LjgzMjI0IDEwLjM1QzUuMjA0MjQgMTAuNDQzIDUuNTkyNzUgMTAuNSA1Ljk5OTk5IDEwLjVDOS41MzAyNCAxMC41IDExLjgwOCA2LjUzNzAyIDExLjkwMzIgNi4zNjkwMkMxMi4wMzE1IDYuMTQxMDIgMTIuMDMyMiA1Ljg2MjAyIDExLjkwNCA1LjYzNDAyQzExLjg2ODcgNS41NzAyNyAxMS41MjkgNC45NzMyNyAxMC45MzA1IDQuMjUxNzdaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNMC4yMTk2NSAxMS43ODAyQzAuMzY1OSAxMS45MjY0IDAuNTU3OSAxMS45OTk5IDAuNzQ5OSAxMS45OTk5QzAuOTQxOSAxMS45OTk5IDEuMTMzOSAxMS45MjY0IDEuMjgwMTUgMTEuNzgwMkwxMS43ODAxIDEuMjgwMTlDMTIuMDczNCAwLjk4Njk0MyAxMi4wNzM0IDAuNTEyOTQzIDExLjc4MDEgMC4yMTk2OTNDMTEuNDg2OSAtMC4wNzM1NTY3IDExLjAxMjkgLTAuMDczNTU2NyAxMC43MTk2IDAuMjE5NjkzTDguNjYwOSAyLjI3ODQ0QzcuODg2MTUgMS44MjMxOSA2Ljk5ODE1IDEuNDk5OTQgNS45OTk5IDEuNDk5OTRDMi40MzM2NSAxLjQ5OTk0IDAuMTg4MTUgNS40NjY2OSAwLjA5NDM5OTkgNS42MzU0NEMtMC4wMzIzNTAxIDUuODYyNjkgLTAuMDMxNjAwMSA2LjEzOTQ0IDAuMDk1ODk5OSA2LjM2NjY5QzAuMTQ4NCA2LjQ2MDQ0IDAuODc4OSA3LjcxODE5IDIuMTE1NjUgOC44MjM2OUwwLjIxODkgMTAuNzIwNEMtMC4wNzM2MDAxIDExLjAxMjkgLTAuMDczNjAwMSAxMS40ODY5IDAuMjE5NjUgMTEuNzgwMlpNMS42MzU2NSA1Ljk5OTE5QzIuMjE4NCA1LjEyNjE5IDMuODU5NCAyLjk5OTk0IDUuOTk5OSAyLjk5OTk0QzYuNTU2NCAyLjk5OTk0IDcuMDc3NjUgMy4xNTA2OSA3LjU1ODQgMy4zODA5NEw2LjM4MzkgNC41NTU0NEM2LjI2MDkgNC41MjE2OSA2LjEzMzQgNC40OTk5NCA1Ljk5OTkgNC40OTk5NEM1LjE3MTE1IDQuNDk5OTQgNC40OTk5IDUuMTcxMTkgNC40OTk5IDUuOTk5OTRDNC40OTk5IDYuMTMzNDQgNC41MjE2NSA2LjI2MDk0IDQuNTU1NCA2LjM4Mzk0TDMuMTc5OSA3Ljc1OTQ0QzIuNDYzNjUgNy4xMzI0NCAxLjkxOTE1IDYuNDIxNDQgMS42MzU2NSA1Ljk5OTE5WiIgZmlsbD0id2hpdGUiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF8xMzExXzIwNDIiPgo8cmVjdCB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIGZpbGw9IndoaXRlIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg=="

/***/ }),
/* 593 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ios-app-link-qr.facba03.svg";

/***/ }),
/* 595 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxOCAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEgNC43MzMzNEw5IDlMMTcgNC43MzMzNCIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLW9wYWNpdHk9IjAuNyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xNS40IDE0Ljg2NjdIMi42QzIuMTc1NjUgMTQuODY2NyAxLjc2ODY5IDE0LjY5ODEgMS40Njg2MyAxNC4zOThDMS4xNjg1NyAxNC4wOTggMSAxMy42OTEgMSAxMy4yNjY3VjIuNkMxIDIuMTc1NjUgMS4xNjg1NyAxLjc2ODY5IDEuNDY4NjMgMS40Njg2M0MxLjc2ODY5IDEuMTY4NTcgMi4xNzU2NSAxIDIuNiAxSDE1LjRDMTUuODI0MyAxIDE2LjIzMTMgMS4xNjg1NyAxNi41MzE0IDEuNDY4NjNDMTYuODMxNCAxLjc2ODY5IDE3IDIuMTc1NjUgMTcgMi42VjEzLjI2NjdDMTcgMTMuNjkxIDE2LjgzMTQgMTQuMDk4IDE2LjUzMTQgMTQuMzk4QzE2LjIzMTMgMTQuNjk4MSAxNS44MjQzIDE0Ljg2NjcgMTUuNCAxNC44NjY3VjE0Ljg2NjdaIiBzdHJva2U9ImJsYWNrIiBzdHJva2Utb3BhY2l0eT0iMC43IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg=="

/***/ }),
/* 596 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCAxMiAxMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTYuNzE4IDYuODE2OTdDNi40OTc2MSA2LjkzNzIzIDYuMjUwNTYgNy4wMDAyNSA1Ljk5OTUgNy4wMDAyNUM1Ljc0ODQ0IDcuMDAwMjUgNS41MDEzOSA2LjkzNzIzIDUuMjgxIDYuODE2OTdMMCAzLjkzNTk3VjguNDk5OTdDMCA4Ljg5NzggMC4xNTgwMzUgOS4yNzkzMyAwLjQzOTM0IDkuNTYwNjRDMC43MjA2NDQgOS44NDE5NCAxLjEwMjE4IDkuOTk5OTcgMS41IDkuOTk5OTdIMTAuNUMxMC44OTc4IDkuOTk5OTcgMTEuMjc5NCA5Ljg0MTk0IDExLjU2MDcgOS41NjA2NEMxMS44NDIgOS4yNzkzMyAxMiA4Ljg5NzggMTIgOC40OTk5N1YzLjkzNTk3TDYuNzE4IDYuODE2OTdaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNNiA2QzUuOTE2NDkgNS45OTk5NCA1LjgzNDMyIDUuOTc4OTcgNS43NjEgNS45MzlMMC4yNjEgMi45MzlDMC4xODIwNTYgMi44OTYwNCAwLjExNjE1MSAyLjgzMjU5IDAuMDcwMjIwNCAyLjc1NTM0QzAuMDI0MjkgMi42NzgwOCAzLjIzNDQxZS0wNSAyLjU4OTg4IDAgMi41TDAgMS41QzAgMS4xMDIxOCAwLjE1ODAzNSAwLjcyMDY0NCAwLjQzOTM0IDAuNDM5MzRDMC43MjA2NDQgMC4xNTgwMzUgMS4xMDIxOCAwIDEuNSAwSDEwLjVDMTAuODk3OCAwIDExLjI3OTQgMC4xNTgwMzUgMTEuNTYwNyAwLjQzOTM0QzExLjg0MiAwLjcyMDY0NCAxMiAxLjEwMjE4IDEyIDEuNVYyLjVDMTIgMi41ODk4OCAxMS45NzU3IDIuNjc4MDggMTEuOTI5OCAyLjc1NTM0QzExLjg4MzggMi44MzI1OSAxMS44MTc5IDIuODk2MDQgMTEuNzM5IDIuOTM5TDYuMjM5IDUuOTM5QzYuMTY1NjggNS45Nzg5NyA2LjA4MzUxIDUuOTk5OTQgNiA2WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg=="

/***/ }),
/* 597 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 598 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMSIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDExIDIwIiBmaWxsPSJub25lIj4KICA8cGF0aCBkPSJNMTAgMUwxIDEwTDEwIDE5IiBzdHJva2U9ImJsYWNrIiBzdHJva2Utb3BhY2l0eT0iMC42IiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPg=="

/***/ }),
/* 599 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/library_3.3776512.jpg";

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/user.383d3a4.svg";

/***/ }),
/* 602 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzEzMTFfMjAzMikiPgo8cGF0aCBkPSJNOC43NzUgMC4yMjVDOC40NzUgLTAuMDc1IDguMDI1IC0wLjA3NSA3LjcyNSAwLjIyNUwwLjIyNSA3LjcyNUMwLjA3NSA3Ljg3NSAwIDguMDI1IDAgOC4yNVYxMS4yNUMwIDExLjcgMC4zIDEyIDAuNzUgMTJIMy43NUMzLjk3NSAxMiA0LjEyNSAxMS45MjUgNC4yNzUgMTEuNzc1TDExLjc3NSA0LjI3NUMxMi4wNzUgMy45NzUgMTIuMDc1IDMuNTI1IDExLjc3NSAzLjIyNUw4Ljc3NSAwLjIyNVpNMy40NSAxMC41SDEuNVY4LjU1TDYgNC4wNUw3Ljk1IDZMMy40NSAxMC41Wk05IDQuOTVMNy4wNSAzTDguMjUgMS44TDEwLjIgMy43NUw5IDQuOTVaIiBmaWxsPSJibGFjayIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzEzMTFfMjAzMiI+CjxyZWN0IHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K"

/***/ }),
/* 603 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzNC44IDI1Ljk4Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I2FmYWVhZTt9PC9zdHlsZT48L2RlZnM+PGcgaWQ9Ik9XVWQxMy50aWYiPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTE5Mi4yMiwxNDQuMzJjLS4xLTIuMSwxLjEyLTMuNTguNTUtNS4zN2EzLjgsMy44LDAsMCwwLTQuNDQtMi44OGMtMi4xNi4yNS0xLjE2LDIuMTUtMS4yMSwzLjMtLjE1LDMsMCw1LjkyLS4wNiw4Ljg4LDAsMy42Ni0xLjYzLDUuODItNS4wNSw2Ljc3LTIuMjUuNjItNC41Mi41Mi01LjY0LTEuODRzMC00LjIzLDEuOTMtNS42M2E0LjkyLDQuOTIsMCwwLDEsMi43Ni0xLjIzYzQsLjE2LDQtMi4yOCwzLjgxLTUuMTctLjE3LTMuMTgtLjA2LTYuMzgsMC05LjU2LDAtLjc1LS4yNi0xLjcyLjY4LTIuMTFzMS4zMy40NSwxLjc3LDEuMTJjMS4wNiwxLjYxLDIuODMsMi4yMyw0LjQsMy4xNEMxOTYuMzYsMTM2LjQzLDE5Ni42NSwxNDAuNDEsMTkyLjIyLDE0NC4zMloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xNjAuNTcgLTEyOS4zNikiLz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0xNzAuNCwxMzMuNGMtMi42MiwwLTUuMjUsMC03Ljg4LDAtMSwwLTEuOTItLjMtMS45My0xLjQ1czEtMS40MiwxLjk0LTEuNDJxOC4wNiwwLDE2LjExLDBjMSwwLDEuOTQuMjUsMS45MywxLjQzcy0uOTQsMS40NS0xLjk0LDEuNDVDMTc1Ljg5LDEzMy40MSwxNzMuMTUsMTMzLjQsMTcwLjQsMTMzLjRaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTYwLjU3IC0xMjkuMzYpIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMTcwLjE5LDE0MS42MmgtNy41NGMtMSwwLTItLjE5LTIuMDctMS4zMnMuODQtMS41MywxLjgxLTEuNTNjNS40OSwwLDExLDAsMTYuNDYsMCwuODcsMCwxLjY4LjMzLDEuNzMsMS4yOC4wNiwxLjE0LS43OSwxLjU1LTEuODEsMS41NUMxNzUuOTEsMTQxLjYzLDE3My4wNSwxNDEuNjIsMTcwLjE5LDE0MS42MloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xNjAuNTcgLTEyOS4zNikiLz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0xNjUuOTQsMTQ5LjE5aC0zLjM4Yy0xLDAtMS45Mi0uMjItMi0xLjM2cy44NS0xLjUsMS44Mi0xLjUxYzIuNDgsMCw1LDAsNy40NSwwLDEsMCwxLjg3LjQsMS44LDEuNTRzLTEsMS4zNC0yLDEuMzRaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTYwLjU3IC0xMjkuMzYpIi8+PC9nPjwvc3ZnPg=="

/***/ }),
/* 604 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxOSAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTUuNjkgMTIuMzhWMS4wMDAwMyIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNOC43ODQ5MyAxMi4zOFYxLjAwMDAzIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xNSAxMkwxMS4xODYzIDEuMTE4NzkiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg=="

/***/ }),
/* 605 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNDg1NSAwSDMuNTE0NUwwIDMuNTE0NVY4LjQ4NTVMMy41MTQ1IDEySDguNDg1NUwxMiA4LjQ4NTVWMy41MTQ1TDguNDg1NSAwWk02IDlDNS44OTk5NCA5LjAwNjAxIDUuNzk5NzQgOC45OTA3NCA1LjcwNjAyIDguOTU1MTdDNS42MTIzIDguOTE5NjEgNS41MjcxOSA4Ljg2NDU3IDUuNDU2MzEgOC43OTM2OUM1LjM4NTQzIDguNzIyODEgNS4zMzAzOSA4LjYzNzcgNS4yOTQ4MyA4LjU0Mzk4QzUuMjU5MjYgOC40NTAyNiA1LjI0Mzk5IDguMzUwMDYgNS4yNSA4LjI1QzUuMjQzOTkgOC4xNDk5NCA1LjI1OTI2IDguMDQ5NzQgNS4yOTQ4MyA3Ljk1NjAyQzUuMzMwMzkgNy44NjIzIDUuMzg1NDMgNy43NzcxOSA1LjQ1NjMxIDcuNzA2MzFDNS41MjcxOSA3LjYzNTQzIDUuNjEyMyA3LjU4MDM5IDUuNzA2MDIgNy41NDQ4M0M1Ljc5OTc0IDcuNTA5MjYgNS44OTk5NCA3LjQ5Mzk5IDYgNy41QzYuMTAwMDYgNy40OTM5OSA2LjIwMDI2IDcuNTA5MjYgNi4yOTM5OCA3LjU0NDgzQzYuMzg3NyA3LjU4MDM5IDYuNDcyODEgNy42MzU0MyA2LjU0MzY5IDcuNzA2MzFDNi42MTQ1NyA3Ljc3NzE5IDYuNjY5NjEgNy44NjIzIDYuNzA1MTcgNy45NTYwMkM2Ljc0MDc0IDguMDQ5NzQgNi43NTYwMSA4LjE0OTk0IDYuNzUgOC4yNUM2Ljc1NjAxIDguMzUwMDYgNi43NDA3NCA4LjQ1MDI2IDYuNzA1MTcgOC41NDM5OEM2LjY2OTYxIDguNjM3NyA2LjYxNDU3IDguNzIyODEgNi41NDM2OSA4Ljc5MzY5QzYuNDcyODEgOC44NjQ1NyA2LjM4NzcgOC45MTk2MSA2LjI5Mzk4IDguOTU1MTdDNi4yMDAyNiA4Ljk5MDc0IDYuMTAwMDYgOS4wMDYwMSA2IDlWOVpNNi43NSA2Ljc1SDUuMjVWM0g2Ljc1VjYuNzVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K"

/***/ }),
/* 606 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzAiIGhlaWdodD0iNzAiIHZpZXdCb3g9IjAgMCA3MCA3MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE5LjcwNSA0MS41NzU2TDU0LjY4NzUgNjcuODEyNUw2Ny44MTI1IDIuMTg3NUwyLjE4NzUgMjguNDM3NUwxMC45NDYzIDM1LjAwNDQiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMyIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTMzLjM4MTMgNTEuODM1TDE5LjY4NzUgNjcuODEyNUwxOS43MDUgNDEuNTc1NkwzOS4zNzUgMjguNDM3NSIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIzIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K"

/***/ }),
/* 607 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 608 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 609 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwLjExNjcgMS42MzI3NEwxMC4xMDU3IDEuNjI0NzRDOC45Njk0MiAwLjU1ODQxMyA3LjQ2MjggLTAuMDIzOTkzMyA1LjkwNDcgMC4wMDA3NTc3OUM0LjM0NjYgMC4wMjU1MDg5IDIuODU5MjQgMC42NTU0NzYgMS43NTczNiAxLjc1NzM2QzAuNjU1NDc2IDIuODU5MjQgMC4wMjU1MDg5IDQuMzQ2NiAwLjAwMDc1Nzc5IDUuOTA0N0MtMC4wMjM5OTMzIDcuNDYyOCAwLjU1ODQxMyA4Ljk2OTQyIDEuNjI0NzQgMTAuMTA1N0wxLjYzMjc0IDEwLjExNjdMMS42NDM3NCAxMC4xMjQ3QzIuNzgwMDcgMTEuMTkxMSA0LjI4NjY4IDExLjc3MzUgNS44NDQ3OSAxMS43NDg3QzcuNDAyODkgMTEuNzI0IDguODkwMjQgMTEuMDk0IDkuOTkyMTMgOS45OTIxM0MxMS4wOTQgOC44OTAyNCAxMS43MjQgNy40MDI4OSAxMS43NDg3IDUuODQ0NzlDMTEuNzczNSA0LjI4NjY4IDExLjE5MTEgMi43ODAwNyAxMC4xMjQ3IDEuNjQzNzRMMTAuMTE2NyAxLjYzMjc0Wk01Ljg3NDc0IDEuODc0NzRDNi41ODY1NiAxLjg3ODIzIDcuMjg0MTggMi4wNzQxNCA3Ljg5Mzc0IDIuNDQxNzRMMi40NDE3NCA3Ljg5Mzc0QzIuMDc0MTQgNy4yODQxOCAxLjg3ODIzIDYuNTg2NTYgMS44NzQ3NCA1Ljg3NDc0QzEuODc0NzQgNC44MTM4OCAyLjI5NjE3IDMuNzk2NDYgMy4wNDYzMiAzLjA0NjMyQzMuNzk2NDYgMi4yOTYxNyA0LjgxMzg4IDEuODc0NzQgNS44NzQ3NCAxLjg3NDc0VjEuODc0NzRaTTUuODc0NzQgOS44NzQ3NEM1LjE2MjkzIDkuODcxMjYgNC40NjUzIDkuNjc1MzQgMy44NTU3NCA5LjMwNzc0TDkuMzA3NzQgMy44NTU3NEM5LjY3NTM0IDQuNDY1MyA5Ljg3MTI2IDUuMTYyOTMgOS44NzQ3NCA1Ljg3NDc0QzkuODc0NzQgNi45MzU2MSA5LjQ1MzMyIDcuOTUzMDIgOC43MDMxNyA4LjcwMzE3QzcuOTUzMDIgOS40NTMzMiA2LjkzNTYxIDkuODc0NzQgNS44NzQ3NCA5Ljg3NDc0VjkuODc0NzRaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K"

/***/ }),
/* 610 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iOThweCIgaGVpZ2h0PSI5OHB4IiB2aWV3Qm94PSIwIDAgOTggOTgiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+Y3VycmVuY3ktZXhjaGFuZ2UtMi0yLTI8L3RpdGxlPgogICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9ImN1cnJlbmN5LWV4Y2hhbmdlLTItMi0yIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzLjAwMDAwMCwgMy4wMDAwMDApIj4KICAgICAgICAgICAgPHBhdGggZD0iTTYwLjUwNSw1Mi45MjUgQzYwLjU4NTI0MDksNTUuOTkwNjM0NSA1OS4yODU5NDYxLDU4LjkzMDU2NDIgNTYuOTY1LDYwLjkzNSBDNTQuMDMwNTkzNyw2My4yNjI1NzQ4IDUwLjQ0NTExMjEsNjQuNjIwMjM1MiA0Ni43MDUsNjQuODIgTDQ2LjcwNSw3Mi4wOTUgTDQyLjI1LDcyLjA5NSBMNDIuMjUsNjUuMDE1IEMzNy41ODA0MDEyLDY1LjA5OTk4NDIgMzIuOTQyMDIzOCw2NC4yMzc2MjM2IDI4LjYxNSw2Mi40OCBMMjguNjE1LDU1LjQgQzMwLjc3MTU3OTMsNTYuNDIxODA2MSAzMy4wMjg3NjkzLDU3LjIxNjA5NTcgMzUuMzUsNTcuNzcgQzM3LjYwNDYyNTQsNTguMzYyNTIxMSAzOS45MTk3MzE0LDU4LjY5NDY4ODUgNDIuMjUsNTguNzYgTDQyLjI1LDQ2LjIyIEwzOS40NDUsNDUuMTg1IEMzNi40MDIyNDY5LDQ0LjE3NzcwNjIgMzMuNjQ4NzQ2Nyw0Mi40NDg0MDUxIDMxLjQyLDQwLjE0NSBDMjkuNjk5OTgzNywzOC4xMjQ0NTI4IDI4Ljc5MTI4NDYsMzUuNTM3MzMzMiAyOC44NywzMi44ODUgQzI4LjgxNDIzNTksMjkuOTIzMDQ3NiAzMC4xNTI4ODUsMjcuMTA2ODg1NiAzMi40ODUsMjUuMjggQzM1LjMwNzk0MzcsMjMuMTMwNDg1IDM4LjcwNzg3NTQsMjEuODcxODMxMyA0Mi4yNSwyMS42NjUgTDQyLjI1LDE2LjAyNSBMNDYuNzA1LDE2LjAyNSBMNDYuNzA1LDIxLjU2IEM1MS4xMzQ4MzcsMjEuNjkzODYyNyA1NS41MDQ0NDg1LDIyLjYyMzY3NTQgNTkuNjA1LDI0LjMwNSBMNTcuMTYsMzAuNDQgQzUzLjgxODIxNDQsMjkuMDk3MzI3OSA1MC4yOTQwNzQ5LDI4LjI2MzA2MjUgNDYuNzA1LDI3Ljk2NSBMNDYuNzA1LDQwLjE2IEw0OS4yNTUsNDEuMTM1IEM1Mi41MzYxMzgyLDQyLjE4MTIwNTYgNTUuNTQzNjc3OCw0My45NDM3MTYgNTguMDYsNDYuMjk1IEM1OS42OTIyOTE0LDQ4LjExMTM1NzUgNjAuNTY3MTgxMSw1MC40ODM3NTc4IDYwLjUwNSw1Mi45MjUgTDYwLjUwNSw1Mi45MjUgWiBNMzYuNzQ1LDMyLjgyNSBDMzYuNzEyMzAxNSwzNC4wMDEzODQzIDM3LjE0MzI4NDQsMzUuMTQzNDg4OSAzNy45NDUsMzYuMDA1IEMzOS4xOTUyNDMxLDM3LjEzMTE3ODEgNDAuNjY2NTQ2LDM3Ljk4NDMyOTQgNDIuMjY1LDM4LjUxIEw0Mi4yNjUsMjguMSBDNDAuNzcxNTYwNywyOC4yNDE0NzMzIDM5LjM1MDE5NDgsMjguODA4OTc4NCAzOC4xNywyOS43MzUgQzM3LjI1MjM3MDMsMzAuNDk2NjcwMSAzNi43Mjg1Mzc4LDMxLjYzMjU1OTQgMzYuNzQ1LDMyLjgyNSBMMzYuNzQ1LDMyLjgyNSBaIE01Mi42LDUzLjQzNSBDNTIuNjM5NjkwOCw1Mi4yMTkzMjAxIDUyLjE0NjYxODksNTEuMDQ2OTA0NyA1MS4yNSw1MC4yMjUgQzQ5LjkwMDA1MDcsNDkuMTM4MjY3OCA0OC4zNTg0NjE1LDQ4LjMxNDA1MTggNDYuNzA1LDQ3Ljc5NSBMNDYuNzA1LDU4LjQ3NSBDNTAuNjM1LDU3Ljg3NSA1Mi42LDU2LjE5NSA1Mi42LDUzLjQzNSBaIiBpZD0iU2hhcGUiIGZpbGw9IiMwMDAwMDAiIGZpbGwtcnVsZT0ibm9uemVybyI+PC9wYXRoPgogICAgICAgICAgICA8Y2lyY2xlIGlkPSJPdmFsIiBzdHJva2U9IiMwMDAwMDAiIHN0cm9rZS13aWR0aD0iNiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjeD0iNDMuNSIgY3k9IjQzLjUiIHI9IjQzLjUiPjwvY2lyY2xlPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1263)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(879),
  /* template */
  __webpack_require__(1700),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-428e6a46",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1382)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(896),
  /* template */
  __webpack_require__(1856),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e17cad06",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1297)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(903),
  /* template */
  __webpack_require__(1748),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-62b2d2df",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1295)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(907),
  /* template */
  __webpack_require__(1744),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-60e50c9d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 615 */,
/* 616 */,
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createRouter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(1882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_methods_promise__ = __webpack_require__(1881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_methods_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_methods_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_auth_protect_page__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_auth_protect_page___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_auth_protect_page__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_auth_login__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_auth_login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_auth_login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_mobile_auth_onboarding__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_mobile_auth_onboarding___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__views_mobile_auth_onboarding__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_mobile_auth_activation__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_mobile_auth_activation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__views_mobile_auth_activation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_auth_authTab__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_auth_authTab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__views_auth_authTab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_auth_forgot_password__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_auth_forgot_password___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__views_auth_forgot_password__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_auth_reset_password__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_auth_reset_password___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__views_auth_reset_password__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_auth_confirmation__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_auth_confirmation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__views_auth_confirmation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_auth_social_verify__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_auth_social_verify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__views_auth_social_verify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_chartPage__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_chartPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__views_chartPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_auth_twitter_confirm__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_auth_twitter_confirm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__views_auth_twitter_confirm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_auth_twitter_callback__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_auth_twitter_callback___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__views_auth_twitter_callback__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_terms_index__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_terms_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__views_terms_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_overview_index__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_overview_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__views_overview_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_admin_admin__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_admin_admin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__views_admin_admin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_landingPages_landing1__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_landingPages_landing1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__views_landingPages_landing1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__views_welcomePage_index_vue__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__views_welcomePage_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__views_welcomePage_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__views_supportPage_index_vue__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__views_supportPage_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__views_supportPage_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__views_landingPages_landing2__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__views_landingPages_landing2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__views_landingPages_landing2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__views_landingPages_landing3__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__views_landingPages_landing3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__views_landingPages_landing3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__views_LoginPage__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__views_LoginPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__views_LoginPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__views_SignUpPage__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__views_SignUpPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__views_SignUpPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__views_home_add_attendee__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__views_home_add_attendee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__views_home_add_attendee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__views_Playlists_playlist__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__views_Playlists_playlist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__views_Playlists_playlist__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__views_activity_index__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__views_activity_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__views_activity_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__views_notification_index__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__views_notification_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__views_notification_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__views_collection_index__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__views_collection_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__views_collection_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__views_chat_chat__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__views_chat_chat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__views_chat_chat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__views_user_direct_messages__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__views_user_direct_messages___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__views_user_direct_messages__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__views_user_members__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__views_user_members___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__views_user_members__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__views_cart_cart__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__views_cart_cart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__views_cart_cart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__views_cart_checkout__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__views_cart_checkout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__views_cart_checkout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__views_sell_sell__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__views_sell_sell___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__views_sell_sell__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__views_sell_orderdetail__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__views_sell_orderdetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__views_sell_orderdetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__views_sell_add_product__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__views_sell_add_product___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__views_sell_add_product__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__views_sell_edit_product__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__views_sell_edit_product___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__views_sell_edit_product__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__views_product_index__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__views_product_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__views_product_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__views_album_index__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__views_album_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__views_album_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__views_album_playlist__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__views_album_playlist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__views_album_playlist__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__views_manage__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__views_manage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__views_manage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__views_album_album_stats__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__views_album_album_stats___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__views_album_album_stats__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__views_album_manage__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__views_album_manage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__views_album_manage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__views_label_manage__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__views_label_manage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__views_label_manage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__views_video_live__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__views_video_live___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46__views_video_live__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__views_spotlight__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__views_spotlight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47__views_spotlight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__views_upload__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__views_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48__views_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__views_album_upload_album__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__views_album_upload_album___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49__views_album_upload_album__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__views_album_album_edit__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__views_album_album_edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50__views_album_album_edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__views_payments_index__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__views_payments_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51__views_payments_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__views_user_stripe_connect__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__views_user_stripe_connect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52__views_user_stripe_connect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__views_user_profile__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__views_user_profile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53__views_user_profile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__views_404__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__views_404___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54__views_404__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__views_user_get_verified__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__views_user_get_verified___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_55__views_user_get_verified__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__views_settings_index__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__views_settings_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_56__views_settings_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__views_topCreators__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__views_topCreators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_57__views_topCreators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__views_video_index__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__views_video_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_58__views_video_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__views_video_manage__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__views_video_manage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_59__views_video_manage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__views_video_edit__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__views_video_edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_60__views_video_edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__views_video_show__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__views_video_show___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_61__views_video_show__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__views_video_delete__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__views_video_delete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_62__views_video_delete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__views_partners___ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__views_partners____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_63__views_partners___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__views_dashboard___ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__views_dashboard____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_64__views_dashboard___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__views_subscribe___ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__views_subscribe____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_65__views_subscribe___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__views_landing_new___ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__views_landing_new____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_66__views_landing_new___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__views_landing_new_components_ForCreators_vue__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__views_landing_new_components_ForCreators_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_67__views_landing_new_components_ForCreators_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__views_mobile_auth_confirmation__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__views_mobile_auth_confirmation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_68__views_mobile_auth_confirmation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__views_mobile_QR__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__views_mobile_QR___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_69__views_mobile_QR__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__views_new_mobile_community__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__views_new_mobile_community___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_70__views_new_mobile_community__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__views_new_mobile_cart__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__views_new_mobile_cart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_71__views_new_mobile_cart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__views_new_mobile_checkout__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__views_new_mobile_checkout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_72__views_new_mobile_checkout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__views_new_mobile_confirmation__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__views_new_mobile_confirmation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_73__views_new_mobile_confirmation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__views_new_mobile_you__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__views_new_mobile_you___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_74__views_new_mobile_you__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__views_new_mobile_library__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__views_new_mobile_library___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_75__views_new_mobile_library__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__views_new_mobile_notification__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__views_new_mobile_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_76__views_new_mobile_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__views_new_mobile_messages__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__views_new_mobile_messages___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_77__views_new_mobile_messages__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__views_new_mobile_spotlight__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__views_new_mobile_spotlight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_78__views_new_mobile_spotlight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__views_new_mobile_discover__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__views_new_mobile_discover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_79__views_new_mobile_discover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__views_new_mobile_player__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__views_new_mobile_player___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_80__views_new_mobile_player__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__views_new_mobile_profile__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__views_new_mobile_profile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_81__views_new_mobile_profile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__views_new_mobile_plan__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__views_new_mobile_plan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_82__views_new_mobile_plan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__views_new_mobile_plan_detail__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__views_new_mobile_plan_detail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_83__views_new_mobile_plan_detail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__views_new_mobile_chat_room__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__views_new_mobile_chat_room___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_84__views_new_mobile_chat_room__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__views_video_estimate__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__views_video_estimate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_85__views_video_estimate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__views_video_create__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__views_video_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_86__views_video_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__views_video_upload__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__views_video_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_87__views_video_upload__);






















































































 // Ensure this path is correct
 // Ensure this path is correct
 // Ensure this path is correct

var isMobile = function isMobile() {
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    return true;
  } else {
    return false;
  }
};

var onMobile = isMobile();

var setComponent = function setComponent(path, hasNoIndexFile) {
  var ext = hasNoIndexFile ? '.vue' : 'index.vue';
  var addEndSlash = hasNoIndexFile ? '' : '/';

  if (onMobile) {
    return function () {
      return __webpack_require__(1886)("./" + path + addEndSlash + ext);
    };
  } else {
    return function () {
      return __webpack_require__(1885)("./" + path + addEndSlash + ext);
    };
  }
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_methods_promise___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

function createRouter(settings) {
  var routes = [{ path: '/', name: 'Home', component: __WEBPACK_IMPORTED_MODULE_66__views_landing_new____default.a, meta: { allowOnMobile: true, noSideSpace: true, bgDark: true } }, { path: '/landing-x', name: 'LandingX', component: __WEBPACK_IMPORTED_MODULE_18__views_landingPages_landing1___default.a, meta: { allowOnMobile: true, noSideSpace: false } }, { path: '/creators', name: 'Creators', component: __WEBPACK_IMPORTED_MODULE_21__views_landingPages_landing2___default.a, meta: { allowOnMobile: true } }, { path: '/adfree', name: 'AdFree', component: __WEBPACK_IMPORTED_MODULE_22__views_landingPages_landing3___default.a, meta: { allowOnMobile: true } }, { path: "/chatroomm", name: "ChatRoomMobile", component: __WEBPACK_IMPORTED_MODULE_84__views_new_mobile_chat_room___default.a, meta: { allowOnMobile: true, onlyOnMobile: true, noPadding: true, noMargin: true } }, { path: "/communitym", name: "CommunityMobile", component: __WEBPACK_IMPORTED_MODULE_70__views_new_mobile_community___default.a, meta: { allowOnMobile: true, onlyOnMobile: true } }, { path: "/username/m", name: "ProfileMobile", component: __WEBPACK_IMPORTED_MODULE_81__views_new_mobile_profile___default.a, meta: { allowOnMobile: true, onlyOnMobile: true, noPadding: true, noMargin: true, bgBlack: true } }, { path: "/username/plansm", name: "PlanMobile", component: __WEBPACK_IMPORTED_MODULE_82__views_new_mobile_plan___default.a, meta: { allowOnMobile: true, onlyOnMobile: true, noPadding: true, noMargin: true, bgBlack: true } }, { path: "/username/plan-detailsm", name: "PlanDetailMobile", component: __WEBPACK_IMPORTED_MODULE_83__views_new_mobile_plan_detail___default.a, meta: { allowOnMobile: true, onlyOnMobile: true, noPadding: true, noMargin: true, bgBlack: true } }, { path: "/playerm", name: "PlayerMobile", component: __WEBPACK_IMPORTED_MODULE_80__views_new_mobile_player___default.a, meta: { allowOnMobile: true, onlyOnMobile: true, noPadding: true, noMargin: true } }, { path: "/discoverm", name: "DiscoverMobile", component: __WEBPACK_IMPORTED_MODULE_79__views_new_mobile_discover___default.a, meta: { allowOnMobile: true, onlyOnMobile: true } }, { path: "/spotlightm", name: "SpotlightMobile", component: __WEBPACK_IMPORTED_MODULE_78__views_new_mobile_spotlight___default.a, meta: { allowOnMobile: true, onlyOnMobile: true } }, { path: "/notificationsm", name: "NotificationMobile", component: __WEBPACK_IMPORTED_MODULE_76__views_new_mobile_notification___default.a, meta: { allowOnMobile: true, onlyOnMobile: true } }, { path: "/messagesm", name: "MessagesMobile", component: __WEBPACK_IMPORTED_MODULE_77__views_new_mobile_messages___default.a, meta: { allowOnMobile: true, onlyOnMobile: true } }, { path: "/youm", name: "YouMobile", component: __WEBPACK_IMPORTED_MODULE_74__views_new_mobile_you___default.a, meta: { allowOnMobile: true, bgBlack: true, onlyOnMobile: true } }, { path: "/username/librarym", name: "LibraryMobile", component: __WEBPACK_IMPORTED_MODULE_75__views_new_mobile_library___default.a, meta: { allowOnMobile: true, bgBlack: true, onlyOnMobile: true } }, { path: "/cartm", name: "CartMobile", component: __WEBPACK_IMPORTED_MODULE_71__views_new_mobile_cart___default.a, meta: { allowOnMobile: true, onlyOnMobile: true } }, { path: "/checkoutm", name: "CheckoutMobile", component: __WEBPACK_IMPORTED_MODULE_72__views_new_mobile_checkout___default.a, meta: { allowOnMobile: true, onlyOnMobile: true } }, { path: "/confirmationm", name: "ConfirmationMobile", component: __WEBPACK_IMPORTED_MODULE_73__views_new_mobile_confirmation___default.a, meta: { allowOnMobile: true, onlyOnMobile: true } }, { path: '/protect', name: 'ProtectPage', component: __WEBPACK_IMPORTED_MODULE_3__views_auth_protect_page___default.a }, { path: '/login-page', name: 'Login', component: __WEBPACK_IMPORTED_MODULE_4__views_auth_login___default.a, meta: { showGoBack: true } }, { path: '/login', name: 'Login', component: __WEBPACK_IMPORTED_MODULE_23__views_LoginPage___default.a, meta: { allowOnMobile: true, noSideSpace: true, authPage: true, showGoBack: true, bgNaturalGrey: true } }, { path: '/signup', name: 'SignUpPage', component: onMobile ? __WEBPACK_IMPORTED_MODULE_69__views_mobile_QR___default.a : __WEBPACK_IMPORTED_MODULE_24__views_SignUpPage___default.a, meta: { showGoBack: true, allowOnMobile: true, noSideSpace: true, bgNaturalGrey: true, QRPage: true } }, { path: '/forgot', name: 'ForgotPassword', component: __WEBPACK_IMPORTED_MODULE_8__views_auth_forgot_password___default.a, meta: { showGoBack: true } }, { path: '/reset_password/:token', name: 'ResetPassword', component: __WEBPACK_IMPORTED_MODULE_9__views_auth_reset_password___default.a, meta: { noSidebar: true, allowOnMobile: true } }, { path: '/members/:slug', name: 'MembersPage', component: __WEBPACK_IMPORTED_MODULE_32__views_user_members___default.a, meta: { allowOnMobile: true } }, { path: '/terms', name: 'TermsPage', component: __WEBPACK_IMPORTED_MODULE_15__views_terms_index___default.a, meta: { allowOnMobile: true } }, { path: '/squad', name: 'OverviewPage', component: __WEBPACK_IMPORTED_MODULE_16__views_overview_index___default.a }, { path: '/chart', name: 'ChartPageIndex', component: __WEBPACK_IMPORTED_MODULE_12__views_chartPage___default.a }, { path: '/_oauth/verification', name: 'SocialVerification', component: __WEBPACK_IMPORTED_MODULE_11__views_auth_social_verify___default.a }, { path: '/_oauth/stripe_connect_callback', name: 'StripeConnectPage', component: __WEBPACK_IMPORTED_MODULE_52__views_user_stripe_connect___default.a }, { path: '/_oauth/twitter_confirm', name: 'TwitterConfirmPage', component: __WEBPACK_IMPORTED_MODULE_13__views_auth_twitter_confirm___default.a }, { path: '/_oauth/twitter_callback', name: 'TwitterCallbackPage', component: __WEBPACK_IMPORTED_MODULE_14__views_auth_twitter_callback___default.a }, { path: '/confirm/:token', name: 'Confirmation', component: onMobile ? __WEBPACK_IMPORTED_MODULE_68__views_mobile_auth_confirmation___default.a : __WEBPACK_IMPORTED_MODULE_10__views_auth_confirmation___default.a, meta: { allowOnMobile: true } }, { path: '/welcome', name: 'welcomePage', component: __WEBPACK_IMPORTED_MODULE_19__views_welcomePage_index_vue___default.a, meta: { allowOnMobile: true, welcomePage: true } }, { path: '/support', name: 'support', component: __WEBPACK_IMPORTED_MODULE_20__views_supportPage_index_vue___default.a, meta: { allowOnMobile: true, noSidebar: true } }];

  if (!settings.disable_sign_up) {
    routes = routes.concat([{ path: '/onboarding', name: 'Onboarding', component: __WEBPACK_IMPORTED_MODULE_5__views_mobile_auth_onboarding___default.a }, { path: '/activation', name: 'Activation', component: __WEBPACK_IMPORTED_MODULE_6__views_mobile_auth_activation___default.a, meta: { hideMobileHeader: true, noSideSpace: true } }, { path: '/register', name: 'Register', component: __WEBPACK_IMPORTED_MODULE_7__views_auth_authTab___default.a }, { path: '/register/invited/:token', name: 'InvitedRegister', component: __WEBPACK_IMPORTED_MODULE_7__views_auth_authTab___default.a }]);
  } else {
    routes = routes.concat([{ path: '/register', name: 'RegisterAs', redirect: '/login' }, { path: '/register/listener', name: 'ListenerRegister', redirect: '/login' }, { path: '/register/artist', name: 'ArtistRegister', redirect: '/login' }, { path: '/register/label', name: 'LabelRegister', redirect: '/login' }, { path: '/register/brand', name: 'BrandRegister', redirect: '/login' }]);
  }

  routes = routes.concat([{ path: '/admin', name: 'AdminPage', component: __WEBPACK_IMPORTED_MODULE_17__views_admin_admin___default.a, meta: { bgNaturalGrey: true, noPadding: true, noMargin: true } }, { path: '/video', name: 'VideoIndex', component: __WEBPACK_IMPORTED_MODULE_58__views_video_index___default.a, meta: { noSideSpace: onMobile, senderRoute: 'video', bgGrey: true } }, { path: '/music/discover', name: 'AlbumIndex', component: __WEBPACK_IMPORTED_MODULE_40__views_album_index___default.a, meta: { showRightAltIcon: true, noSideSpace: true, senderRoute: 'video', bgGrey: true } }, { path: '/product', name: 'ProductIndex', component: __WEBPACK_IMPORTED_MODULE_39__views_product_index___default.a, meta: { senderRoute: 'merch', bgGrey: false, bgLight: true } }, { path: '/search', name: 'Search', component: setComponent('search/search', true), props: function props(route) {
      return { query: route.query.q };
    }, meta: { isModalComp: !!onMobile } }, { path: '/feed', name: 'Feed', component: setComponent('feed'), meta: { noSideSpace: onMobile, showRightAltIcon: onMobile } }, { path: '/activity', name: 'ActivityIndex', component: __WEBPACK_IMPORTED_MODULE_27__views_activity_index___default.a }, { path: '/notifications', name: 'NotificationIndex', component: __WEBPACK_IMPORTED_MODULE_28__views_notification_index___default.a, meta: { bgGrey: true, bgLight: false } }, { path: '/collection', name: 'CollectionIndex', component: __WEBPACK_IMPORTED_MODULE_29__views_collection_index___default.a, meta: { bgGrey: true } }, { path: '/messages', name: 'Messages', component: setComponent('messages'), meta: { noSideSpace: onMobile, bgGrey: true, bgLight: false } }, { path: '/cart', name: 'Cart', component: __WEBPACK_IMPORTED_MODULE_33__views_cart_cart___default.a, meta: { noPadding: true } }, { path: '/cart/checkout', name: 'Checkout', component: __WEBPACK_IMPORTED_MODULE_34__views_cart_checkout___default.a }, { path: '/sell', name: 'Sell', component: __WEBPACK_IMPORTED_MODULE_35__views_sell_sell___default.a, meta: { bgNaturalGrey: true } }, { path: '/sell/order/:slug', name: 'OrderDetail', component: __WEBPACK_IMPORTED_MODULE_36__views_sell_orderdetail___default.a, meta: { noPadding: true } }, { path: '/upload/product/add', name: 'AddProduct', component: __WEBPACK_IMPORTED_MODULE_37__views_sell_add_product___default.a, meta: { bgNaturalGrey: true } }, { path: '/product/edit/:id', name: 'EditProduct', component: __WEBPACK_IMPORTED_MODULE_38__views_sell_edit_product___default.a }, { path: '/product/:id', name: 'SingleProduct', component: setComponent('sell/single_product', true), meta: { isModalComp: !!onMobile, noSideSpace: onMobile } }, { path: '/album/:slug', name: 'AlbumDetail', component: setComponent('album/album', true), meta: { isModalComp: !!onMobile, showModalCompLeftIcon: true, noSideSpace: onMobile, bgLight: true } }, { path: '/x', name: 'AddAttendee', component: __WEBPACK_IMPORTED_MODULE_25__views_home_add_attendee___default.a }, { path: '/playlist/:id', name: 'Playlist', component: __WEBPACK_IMPORTED_MODULE_26__views_Playlists_playlist___default.a }, { path: '/playlist/:slug', name: 'PlaylistDetail', component: __WEBPACK_IMPORTED_MODULE_41__views_album_playlist___default.a }, { path: '/manage', name: 'ManageIndex', component: __WEBPACK_IMPORTED_MODULE_42__views_manage___default.a, meta: { bgNaturalGrey: true } }, { path: '/album/:slug/stats', name: 'AlbumStats', component: __WEBPACK_IMPORTED_MODULE_43__views_album_album_stats___default.a }, { path: '/albums', name: 'AlbumsManage', component: __WEBPACK_IMPORTED_MODULE_44__views_album_manage___default.a }, { path: '/labels', name: 'LabelsManage', component: __WEBPACK_IMPORTED_MODULE_45__views_label_manage___default.a }, { path: '/live/', name: 'CreateLive', component: __WEBPACK_IMPORTED_MODULE_46__views_video_live___default.a }, { path: '/spotlight', name: 'SpotLight', component: __WEBPACK_IMPORTED_MODULE_47__views_spotlight___default.a }, { path: '/upload/', name: 'UploadIndex', component: __WEBPACK_IMPORTED_MODULE_48__views_upload___default.a, meta: { wrapFullHeight: !!onMobile, bgNaturalGrey: true } }, { path: '/upload/album', name: 'UploadAlbum', component: __WEBPACK_IMPORTED_MODULE_49__views_album_upload_album___default.a, meta: { bgNaturalGrey: true } }, { path: '/album/:slug/edit', name: 'AlbumEdit', component: __WEBPACK_IMPORTED_MODULE_50__views_album_album_edit___default.a, meta: { bgNaturalGrey: true } }, { path: '/verified', name: 'UserGetVerified', component: __WEBPACK_IMPORTED_MODULE_55__views_user_get_verified___default.a }, { path: '/payments', name: 'PaymentIndex', component: __WEBPACK_IMPORTED_MODULE_51__views_payments_index___default.a, meta: { bgNaturalGrey: true } }, { path: '/settings', name: 'UserSettings', component: __WEBPACK_IMPORTED_MODULE_56__views_settings_index___default.a, meta: { bgNaturalGrey: true } }, { path: '/top-creators', name: 'TopCreators', component: __WEBPACK_IMPORTED_MODULE_57__views_topCreators___default.a }, { path: '/partners', name: 'Partners', component: __WEBPACK_IMPORTED_MODULE_63__views_partners____default.a }, { path: '/dashboard', name: 'Dashboard', component: __WEBPACK_IMPORTED_MODULE_64__views_dashboard____default.a, meta: { bgNaturalGrey: true } }, { path: '/subscribe', name: 'SubscribeIndex', component: __WEBPACK_IMPORTED_MODULE_65__views_subscribe____default.a }, { path: '/user/:user/chat', name: 'Chat', component: __WEBPACK_IMPORTED_MODULE_30__views_chat_chat___default.a }, { path: '/user/:user/messages', name: 'DirectMessages', component: __WEBPACK_IMPORTED_MODULE_31__views_user_direct_messages___default.a }, { path: '/for-creators', name: 'ForCreators', component: __WEBPACK_IMPORTED_MODULE_67__views_landing_new_components_ForCreators_vue___default.a, meta: { allowOnMobile: true, noSideSpace: true, bgDark: true } }]);

  if (!settings.disable_live_video) {
    routes = routes.concat([{ path: '/user/:user/video', name: 'VideoManage', component: __WEBPACK_IMPORTED_MODULE_59__views_video_manage___default.a }, { path: '/user/:user/video/info', name: 'VideoInfo', component: __WEBPACK_IMPORTED_MODULE_85__views_video_estimate___default.a }, { path: '/upload/create', name: 'VideoCreate', component: __WEBPACK_IMPORTED_MODULE_86__views_video_create___default.a, meta: { bgNaturalGrey: true } }, { path: '/upload/video', name: 'VideoUpload', component: __WEBPACK_IMPORTED_MODULE_87__views_video_upload___default.a, meta: { bgNaturalGrey: true } }, { path: '/user/:user/video/edit', name: 'VideoEdit', component: __WEBPACK_IMPORTED_MODULE_60__views_video_edit___default.a }, { path: '/user/:user/video/delete', name: 'VideoDelete', component: __WEBPACK_IMPORTED_MODULE_62__views_video_delete___default.a }, { path: '/video/:videoId/edit', name: 'VideoUpload', component: __WEBPACK_IMPORTED_MODULE_87__views_video_upload___default.a, meta: { bgNaturalGrey: true } }, { path: '/video/:videoId/show', name: 'VideoShow', component: __WEBPACK_IMPORTED_MODULE_61__views_video_show___default.a, meta: { bgGrey: true, isModalComp: !!onMobile, showModalCompLeftIcon: true, noSideSpace: onMobile } }]);
  } else {
    routes = routes.concat([{ path: '/user/:user/video', name: 'VideoManage', redirect: '/' }, { path: '/user/:user/video/create', name: 'VideoCreate', redirect: '/' }, { path: '/user/:user/video/delete', name: 'VideoDelete', redirect: '/' }]);
  }

  routes = routes.concat([{ path: '/:slug', name: 'UserProfile', component: __WEBPACK_IMPORTED_MODULE_53__views_user_profile___default.a, meta: { bgLight: true } }, { path: '*', name: 'NotFound', component: __WEBPACK_IMPORTED_MODULE_54__views_404___default.a }]);

  return new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    mode: 'history',
    scrollBehavior: function scrollBehavior(to, from, savedPosition) {
      if (savedPosition) {
        return savedPosition;
      } else {
        if (to.hash) {
          return { selector: to.hash, behavior: 'smooth' };
        } else {
          return { x: 0, y: 0 };
        }
      }
    },

    routes: routes
  });
}

/***/ }),
/* 618 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 619 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 620 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1262)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(863),
  /* template */
  __webpack_require__(1699),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1290)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1035),
  /* template */
  __webpack_require__(1738),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5de59cd6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(943),
  /* template */
  __webpack_require__(1829),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 637 */,
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1358)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(877),
  /* template */
  __webpack_require__(1826),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a08b18c6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1240)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1034),
  /* template */
  __webpack_require__(1666),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2cba492e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1335)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(918),
  /* template */
  __webpack_require__(1797),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7e3e2eb3",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_cache__ = __webpack_require__(76);




var API_BASE_URL = "https://api.yousound.com" + '/v1/membership_tiers';

var cache = new __WEBPACK_IMPORTED_MODULE_2__services_cache__["a" /* default */]('tiers', { expiration: 150 });

/* harmony default export */ __webpack_exports__["a"] = ({
  initCache: function initCache() {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.interceptors.push(function (req) {
      if (req.fresh) cache.del(req.url);
      if (req.url.startsWith(API_BASE_URL) && req.method === 'GET') {
        var valid = cache.get(req.url);
        if (valid) {
          return req.respondWith(valid, {
            status: 200,
            statusText: 'OK'
          });
        } // if nothing is returned, continue
      }

      return function (res) {
        if (res && res.status === 200 && res.url.startsWith(API_BASE_URL)) {
          cache.set(res.url, res.body);
        }
        return res;
      };
    });
  },
  getTiers: function getTiers(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token },
      params: params
    });
  },
  getTier: function getTier(tierId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + tierId, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  addTier: function addTier(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL, params, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token },
      progress: function progress(e) {
        if (e.lengthComputable) {
          __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('error/setProgressBarValue', parseInt(e.loaded / e.total * 100));
        }
      }
    });
  },
  deleteTier: function deleteTier(tierId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.delete(API_BASE_URL + '/' + tierId, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  updateTier: function updateTier(tierId, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.put(API_BASE_URL + '/' + tierId, params, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token },
      progress: function progress(e) {
        if (e.lengthComputable) {
          __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('error/setProgressBarValue', parseInt(e.loaded / e.total * 100));
        }
      }
    });
  },
  searchTier: function searchTier(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL + '/search', params, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  getTiersList: function getTiersList() {
    var userId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var monthly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/list', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token },
      params: { user_id: userId, monthly: monthly }
    });
  }
});

/***/ }),
/* 645 */,
/* 646 */,
/* 647 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2NCA2NCIgd2lkdGg9IjY0IiBoZWlnaHQ9IjY0Ij48dGl0bGU+Z3JpZCBpbnRlcmZhY2U8L3RpdGxlPjxnIGNsYXNzPSJuYy1pY29uLXdyYXBwZXIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIzIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjUgMC41KSIgZmlsbD0iIzAwMDAwMCIgc3Ryb2tlPSIjMDAwMDAwIj48cmVjdCB4PSI1IiB5PSI1IiB3aWR0aD0iMjIiIGhlaWdodD0iMjIiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzAwMDAwMCIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIi8+PHJlY3QgZGF0YS1jb2xvcj0iY29sb3ItMiIgeD0iMzciIHk9IjUiIHdpZHRoPSIyMiIgaGVpZ2h0PSIyMiIgZmlsbD0ibm9uZSIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIi8+PHJlY3QgZGF0YS1jb2xvcj0iY29sb3ItMiIgeD0iNSIgeT0iMzciIHdpZHRoPSIyMiIgaGVpZ2h0PSIyMiIgZmlsbD0ibm9uZSIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIi8+PHJlY3QgeD0iMzciIHk9IjM3IiB3aWR0aD0iMjIiIGhlaWdodD0iMjIiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzAwMDAwMCIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIi8+PC9nPjwvc3ZnPg=="

/***/ }),
/* 648 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2NCA2NCIgd2lkdGg9IjY0IiBoZWlnaHQ9IjY0Ij48dGl0bGU+bXVzaWM8L3RpdGxlPjxnIGNsYXNzPSJuYy1pY29uLXdyYXBwZXIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIzIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjUgMC41KSIgZmlsbD0iIzAwMDAwMCIgc3Ryb2tlPSIjMDAwMDAwIj48bGluZSBkYXRhLWNhcD0iYnV0dCIgeDE9IjIwIiB5MT0iMTgiIHgyPSI1OCIgeTI9IjE4IiBmaWxsPSJub25lIiBzdHJva2U9IiMwMDAwMDAiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIvPjxwb2x5bGluZSBkYXRhLWNhcD0iYnV0dCIgcG9pbnRzPSI1OCA0NyA1OCA1IDIwIDUgMjAgNTMiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzAwMDAwMCIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIi8+PGNpcmNsZSBkYXRhLWNvbG9yPSJjb2xvci0yIiBjeD0iMTIiIGN5PSI1MyIgcj0iOCIgZmlsbD0ibm9uZSIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIi8+PGNpcmNsZSBkYXRhLWNvbG9yPSJjb2xvci0yIiBjeD0iNTAiIGN5PSI0NyIgcj0iOCIgZmlsbD0ibm9uZSIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIi8+PC9nPjwvc3ZnPg=="

/***/ }),
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(10);



var API_BASE_URL = "https://api.yousound.com" + '/v1/label';

/* harmony default export */ __webpack_exports__["a"] = ({
  getLabelUsers: function getLabelUsers(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/label_users', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token },
      params: params
    });
  },
  getLabelAlbums: function getLabelAlbums(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/label_albums', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token },
      params: params
    });
  }
});

/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(10);



var API_BASE_URL = "https://api.yousound.com" + '/v1/presets';

/* harmony default export */ __webpack_exports__["a"] = ({
  getPresets: function getPresets() {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  createPreset: function createPreset(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL, params, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  loadPreset: function loadPreset(presetId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(API_BASE_URL + '/' + presetId + '/load', {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  deletePreset: function deletePreset(presetId) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.delete(API_BASE_URL + '/' + presetId, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  }
});

/***/ }),
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 758 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/album-drop.f1cf4d2.gif";

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/broadcast-icon.822a408.png";

/***/ }),
/* 761 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzEzNTZfMjA4MSkiPgo8cGF0aCBkPSJNMC45OTk3ODcgMTIuMDAwMUMwLjgwMjAzNyAxMiAwLjYwODczOCAxMS45NDE0IDAuNDQ0MzI4IDExLjgzMTVDMC4yNzk5MTkgMTEuNzIxNiAwLjE1MTc3OSAxMS41NjU0IDAuMDc2MTA4OSAxMS4zODI3QzAuMDAwNDM4OTA2IDExLjIgLTAuMDE5MzY0MSAxMC45OTkgMC4wMTkyMDM1IDEwLjgwNUMwLjA1Nzc3MTEgMTAuNjExMSAwLjE1Mjk3NyAxMC40MzI5IDAuMjkyNzg3IDEwLjI5MzFMNC43OTI3OSA1Ljc5MzA4QzQuOTgwMzEgNS42MDU2MSA1LjIzNDYyIDUuNTAwMjkgNS40OTk3OSA1LjUwMDI5QzUuNzY0OTUgNS41MDAyOSA2LjAxOTI2IDUuNjA1NjEgNi4yMDY3OSA1Ljc5MzA4TDkuNDk5NzkgOS4wODYwOEwxNC4yOTI4IDQuMjkzMDhDMTQuMzg1IDQuMTk3NTcgMTQuNDk1NCA0LjEyMTM5IDE0LjYxNzQgNC4wNjg5OEMxNC43Mzk0IDQuMDE2NTcgMTQuODcwNiAzLjk4ODk4IDE1LjAwMzQgMy45ODc4M0MxNS4xMzYyIDMuOTg2NjggMTUuMjY3OCA0LjAxMTk4IDE1LjM5MDcgNC4wNjIyNkMxNS41MTM2IDQuMTEyNTQgMTUuNjI1MyA0LjE4Njc5IDE1LjcxOTIgNC4yODA2OUMxNS44MTMxIDQuMzc0NTggMTUuODg3MyA0LjQ4NjIzIDE1LjkzNzYgNC42MDkxM0MxNS45ODc5IDQuNzMyMDIgMTYuMDEzMiA0Ljg2MzcgMTYuMDEyIDQuOTk2NDhDMTYuMDEwOSA1LjEyOTI2IDE1Ljk4MzMgNS4yNjA0OCAxNS45MzA5IDUuMzgyNDlDMTUuODc4NSA1LjUwNDQ5IDE1LjgwMjMgNS42MTQ4MyAxNS43MDY4IDUuNzA3MDhMMTAuMjA2OCAxMS4yMDcxQzEwLjAxOTMgMTEuMzk0NiA5Ljc2NDk1IDExLjQ5OTkgOS40OTk3OSAxMS40OTk5QzkuMjM0NjIgMTEuNDk5OSA4Ljk4MDMyIDExLjM5NDYgOC43OTI3OSAxMS4yMDcxTDUuNDk5NzkgNy45MTQwOEwxLjcwNjc5IDExLjcwNzFDMS41MTkyOSAxMS44OTQ2IDEuMjY0OTggMTIgMC45OTk3ODcgMTIuMDAwMVoiIGZpbGw9IndoaXRlIi8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfMTM1Nl8yMDgxIj4KPHJlY3Qgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo="

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/live-drop.d24b290.gif";

/***/ }),
/* 763 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI5LjUgMS41SDEwLjVDMTAuMjI0IDEuNSAxMCAxLjcyNCAxMCAyVjIzLjE3OEM5LjE3NDUgMjIuMTU2IDcuOTEzIDIxLjUgNi41IDIxLjVDNC4wMTkgMjEuNSAyIDIzLjUxOSAyIDI2QzIgMjguNDgxIDQuMDE5IDMwLjUgNi41IDMwLjVDOC45ODEgMzAuNSAxMSAyOC40ODEgMTEgMjZWOUgyOVYyMC4xNzhDMjguMTc0NSAxOS4xNTYgMjYuOTEzIDE4LjUgMjUuNSAxOC41QzIzLjAxOSAxOC41IDIxIDIwLjUxOSAyMSAyM0MyMSAyNS40ODEgMjMuMDE5IDI3LjUgMjUuNSAyNy41QzI3Ljk4MSAyNy41IDMwIDI1LjQ4MSAzMCAyM1YyQzMwIDEuNzI0IDI5Ljc3NiAxLjUgMjkuNSAxLjVaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K"

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/product-drop.0f7dc8f.gif";

/***/ }),
/* 765 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI3LjAyMzUgMTguMDgwNUwxMy44MDQ4IDQuODYxODRDMTMuNjc5OCA0LjczNjggMTMuNTEwMyA0LjY2NjU0IDEzLjMzMzUgNC42NjY1SDIuMDAwMTZDMS44MjMzNSA0LjY2NjUgMS42NTM3OCA0LjczNjc0IDEuNTI4NzYgNC44NjE3N0MxLjQwMzczIDQuOTg2NzkgMS4zMzM1IDUuMTU2MzYgMS4zMzM1IDUuMzMzMTdWMTYuNjY2NUMxLjMzMzUzIDE2Ljg0MzMgMS40MDM4IDE3LjAxMjggMS41Mjg4MyAxNy4xMzc4TDE0Ljc0NzUgMzAuMzU2NUMxNS4zNzMxIDMwLjk4MDYgMTYuMjIwOCAzMS4zMzExIDE3LjEwNDUgMzEuMzMxMUMxNy45ODgyIDMxLjMzMTEgMTguODM1OSAzMC45ODA2IDE5LjQ2MTUgMzAuMzU2NUwyNy4wMjM1IDIyLjc5NDVDMjcuNjQ3NiAyMi4xNjg5IDI3Ljk5ODEgMjEuMzIxMiAyNy45OTgxIDIwLjQzNzVDMjcuOTk4MSAxOS41NTM4IDI3LjY0NzYgMTguNzA2MSAyNy4wMjM1IDE4LjA4MDVaTTguNjY2ODMgMTQuNjY2NUM4LjEzOTQxIDE0LjY2NjUgNy42MjM4NCAxNC41MTAxIDcuMTg1MzEgMTQuMjE3MUM2Ljc0Njc4IDEzLjkyNDEgNi40MDQ5OCAxMy41MDc2IDYuMjAzMTUgMTMuMDIwM0M2LjAwMTMyIDEyLjUzMzEgNS45NDg1MSAxMS45OTY5IDYuMDUxNCAxMS40Nzk2QzYuMTU0MjkgMTAuOTYyMyA2LjQwODI3IDEwLjQ4NzIgNi43ODEyMSAxMC4xMTQyQzcuMTU0MTUgOS43NDEyOCA3LjYyOTMgOS40ODczIDguMTQ2NTkgOS4zODQ0MUM4LjY2Mzg3IDkuMjgxNTIgOS4yMDAwNSA5LjMzNDMyIDkuNjg3MzIgOS41MzYxNkMxMC4xNzQ2IDkuNzM3OTkgMTAuNTkxMSAxMC4wNzk4IDEwLjg4NDEgMTAuNTE4M0MxMS4xNzcxIDEwLjk1NjggMTEuMzMzNSAxMS40NzI0IDExLjMzMzUgMTEuOTk5OEMxMS4zMzM1IDEyLjcwNzEgMTEuMDUyNSAxMy4zODU0IDEwLjU1MjQgMTMuODg1NUMxMC4wNTIzIDE0LjM4NTYgOS4zNzQwNyAxNC42NjY1IDguNjY2ODMgMTQuNjY2NVoiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik0xMy4zMzMzIDMuMzMzMTdDMTMuNTk2MSAzLjMzMjQyIDEzLjg1NjQgMy4zODM4MyAxNC4wOTkxIDMuNDg0NDNDMTQuMzQxOCAzLjU4NTAyIDE0LjU2MjEgMy43MzI3OSAxNC43NDczIDMuOTE5MTdMMjcuNDk0NyAxNi42NjY1TDI5LjQ5NDcgMTQuNjY2NUwxNi4wODA3IDEuMjUxODRDMTUuNzA1NiAwLjg3Njk4MyAxNS4xOTcgMC42NjY0NCAxNC42NjY3IDAuNjY2NTA0SDQuNjY2NjdDNC40ODk4NiAwLjY2NjUwNCA0LjMyMDI5IDAuNzM2NzQyIDQuMTk1MjYgMC44NjE3NjZDNC4wNzAyNCAwLjk4Njc5IDQgMS4xNTYzNiA0IDEuMzMzMTdWMy4zMzMxN0gxMy4zMzMzWiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg=="

/***/ }),
/* 766 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2NCA2NCIgd2lkdGg9IjY0IiBoZWlnaHQ9IjY0Ij48dGl0bGU+em9vbTwvdGl0bGU+PGcgY2xhc3M9Im5jLWljb24td3JhcHBlciIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuNSAwLjUpIiBmaWxsPSIjMDAwMDAwIiBzdHJva2U9IiMwMDAwMDAiPjxsaW5lIGRhdGEtY29sb3I9ImNvbG9yLTIiIHgxPSI1OSIgeTE9IjU5IiB4Mj0iNDIuNTU2IiB5Mj0iNDIuNTU2IiBmaWxsPSJub25lIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiLz48Y2lyY2xlIGN4PSIyNyIgY3k9IjI3IiByPSIyMiIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAwMDAwIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiLz48L2c+PC9zdmc+"

/***/ }),
/* 767 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 768 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjYiIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCAyNiAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcuMjM4MDUgMjRDNy44MTY2MyAyNCA4LjI4NTY3IDIzLjUzMSA4LjI4NTY3IDIyLjk1MjRDOC4yODU2NyAyMi4zNzM4IDcuODE2NjMgMjEuOTA0OCA3LjIzODA1IDIxLjkwNDhDNi42NTk0NiAyMS45MDQ4IDYuMTkwNDMgMjIuMzczOCA2LjE5MDQzIDIyLjk1MjRDNi4xOTA0MyAyMy41MzEgNi42NTk0NiAyNCA3LjIzODA1IDI0WiIgZmlsbD0iIzlFOUU5RSIvPgo8cGF0aCBkPSJNMjEuOTA1IDI0QzIyLjQ4MzYgMjQgMjIuOTUyNyAyMy41MzEgMjIuOTUyNyAyMi45NTI0QzIyLjk1MjcgMjIuMzczOCAyMi40ODM2IDIxLjkwNDggMjEuOTA1IDIxLjkwNDhDMjEuMzI2NSAyMS45MDQ4IDIwLjg1NzQgMjIuMzczOCAyMC44NTc0IDIyLjk1MjRDMjAuODU3NCAyMy41MzEgMjEuMzI2NSAyNCAyMS45MDUgMjRaIiBmaWxsPSIjOUU5RTlFIi8+CjxwYXRoIGQ9Ik03LjIzODA1IDI0QzcuODE2NjMgMjQgOC4yODU2NyAyMy41MzEgOC4yODU2NyAyMi45NTI0QzguMjg1NjcgMjIuMzczOCA3LjgxNjYzIDIxLjkwNDggNy4yMzgwNSAyMS45MDQ4QzYuNjU5NDYgMjEuOTA0OCA2LjE5MDQzIDIyLjM3MzggNi4xOTA0MyAyMi45NTI0QzYuMTkwNDMgMjMuNTMxIDYuNjU5NDYgMjQgNy4yMzgwNSAyNFoiIHN0cm9rZT0iIzlFOUU5RSIgc3Ryb2tlLXdpZHRoPSIyLjQiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0yMS45MDUgMjRDMjIuNDgzNiAyNCAyMi45NTI3IDIzLjUzMSAyMi45NTI3IDIyLjk1MjRDMjIuOTUyNyAyMi4zNzM4IDIyLjQ4MzYgMjEuOTA0OCAyMS45MDUgMjEuOTA0OEMyMS4zMjY1IDIxLjkwNDggMjAuODU3NCAyMi4zNzM4IDIwLjg1NzQgMjIuOTUyNEMyMC44NTc0IDIzLjUzMSAyMS4zMjY1IDI0IDIxLjkwNSAyNFoiIHN0cm9rZT0iIzlFOUU5RSIgc3Ryb2tlLXdpZHRoPSIyLjQiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik01Ljk4MDk1IDcuMjM4MUgyNEwyMS45MDQ4IDE3LjcxNDNINy4yMzgxTDUuMTQyODYgMkgyIiBzdHJva2U9IiM5RTlFOUUiIHN0cm9rZS13aWR0aD0iMi40IiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K"

/***/ }),
/* 769 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2NCA2NCIgd2lkdGg9IjY0IiBoZWlnaHQ9IjY0Ij48dGl0bGU+Y3JlZGl0IGNhcmQ8L3RpdGxlPjxnIGNsYXNzPSJuYy1pY29uLXdyYXBwZXIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIzIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjUgMC41KSIgZmlsbD0iIzAwMDAwMCIgc3Ryb2tlPSIjMDAwMDAwIj48bGluZSBkYXRhLWNvbG9yPSJjb2xvci0yIiBmaWxsPSJub25lIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHgxPSIyIiB5MT0iMjIiIHgyPSI2MiIgeTI9IjIyIi8+IDxsaW5lIGRhdGEtY29sb3I9ImNvbG9yLTIiIGZpbGw9Im5vbmUiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgeDE9IjIiIHkxPSIzMiIgeDI9IjYyIiB5Mj0iMzIiLz4gPGxpbmUgZGF0YS1jb2xvcj0iY29sb3ItMiIgZmlsbD0ibm9uZSIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiB4MT0iMTAiIHkxPSI0NCIgeDI9IjI0IiB5Mj0iNDQiLz4gPGxpbmUgZGF0YS1jb2xvcj0iY29sb3ItMiIgZmlsbD0ibm9uZSIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiB4MT0iNDgiIHkxPSI0NCIgeDI9IjU0IiB5Mj0iNDQiLz4gPHBhdGggZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAwMDAwIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIGQ9Ik0yLDUwVjE0IGMwLTIuMjA5LDEuNzkxLTQsNC00aDUyYzIuMjA5LDAsNCwxLjc5MSw0LDR2MzZjMCwyLjIwOS0xLjc5MSw0LTQsNEg2QzMuNzkxLDU0LDIsNTIuMjA5LDIsNTB6Ii8+PC9nPjwvc3ZnPg=="

/***/ }),
/* 770 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2NCA2NCIgd2lkdGg9IjY0IiBoZWlnaHQ9IjY0Ij48dGl0bGU+ZGF0YSBkb3dubG9hZDwvdGl0bGU+PGcgY2xhc3M9Im5jLWljb24td3JhcHBlciIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuNSAwLjUpIiBmaWxsPSIjMDAwMDAwIiBzdHJva2U9IiMwMDAwMDAiPjxsaW5lIGRhdGEtY2FwPSJidXR0IiBkYXRhLWNvbG9yPSJjb2xvci0yIiB4MT0iMzIiIHkxPSI2IiB4Mj0iMzIiIHkyPSI0NyIgZmlsbD0ibm9uZSIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIi8+PHBvbHlsaW5lIGRhdGEtY29sb3I9ImNvbG9yLTIiIHBvaW50cz0iMTggMzMgMzIgNDcgNDYgMzMiIGZpbGw9Im5vbmUiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIvPjxwYXRoIGQ9Ik00LDQyVjUzYTUsNSwwLDAsMCw1LDVINTVhNSw1LDAsMCwwLDUtNVY0MiIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAwMDAwIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiLz48L2c+PC9zdmc+"

/***/ }),
/* 771 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/nav_logo_white_mini.ca49cb4.png";

/***/ }),
/* 773 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2NCA2NCIgd2lkdGg9IjY0IiBoZWlnaHQ9IjY0Ij48dGl0bGU+dGltZSBjbG9jazwvdGl0bGU+PGcgY2xhc3M9Im5jLWljb24td3JhcHBlciIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuNSAwLjUpIiBmaWxsPSIjMDAwMDAwIiBzdHJva2U9IiMwMDAwMDAiPjxsaW5lIGRhdGEtY29sb3I9ImNvbG9yLTIiIHgxPSIzMiIgeTE9IjMiIHgyPSIzMiIgeTI9IjEyIiBmaWxsPSJub25lIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiLz48bGluZSBkYXRhLWNvbG9yPSJjb2xvci0yIiB4MT0iNjEiIHkxPSIzMiIgeDI9IjUyIiB5Mj0iMzIiIGZpbGw9Im5vbmUiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIvPjxsaW5lIGRhdGEtY29sb3I9ImNvbG9yLTIiIHgxPSIzMiIgeTE9IjYxIiB4Mj0iMzIiIHkyPSI1MiIgZmlsbD0ibm9uZSIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIi8+PGxpbmUgZGF0YS1jb2xvcj0iY29sb3ItMiIgeDE9IjMiIHkxPSIzMiIgeDI9IjEyIiB5Mj0iMzIiIGZpbGw9Im5vbmUiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIvPjxwb2x5bGluZSBkYXRhLWNvbG9yPSJjb2xvci0yIiBwb2ludHM9IjIwIDE2IDMyIDMyIDQ0IDMyIiBmaWxsPSJub25lIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiLz48Y2lyY2xlIGN4PSIzMiIgY3k9IjMyIiByPSIyOSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAwMDAwIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiLz48L2c+PC9zdmc+"

/***/ }),
/* 774 */,
/* 775 */,
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1229)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(866),
  /* template */
  __webpack_require__(1647),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-20bdedf2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(874),
  /* template */
  __webpack_require__(1661),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1204)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(882),
  /* template */
  __webpack_require__(1619),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1350)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(886),
  /* template */
  __webpack_require__(1817),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-94b261c6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(887),
  /* template */
  __webpack_require__(1656),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(888),
  /* template */
  __webpack_require__(1731),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1216)
  __webpack_require__(1215)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(890),
  /* template */
  __webpack_require__(1633),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1b632f2a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1241)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(904),
  /* template */
  __webpack_require__(1667),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2ce2ef73",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(919),
  /* template */
  __webpack_require__(1732),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1203)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(922),
  /* template */
  __webpack_require__(1616),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-14418c9b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(925),
  /* template */
  __webpack_require__(1689),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(931),
  /* template */
  __webpack_require__(1679),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(938),
  /* template */
  __webpack_require__(1782),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(940),
  /* template */
  __webpack_require__(1651),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return loadStripe; });
var V3_URL = 'https://js.stripe.com/v3';
var V3_URL_REGEX = /^https:\/\/js\.stripe\.com\/v3\/?(\?.*)?$/;
var EXISTING_SCRIPT_MESSAGE = 'loadStripe.setLoadParameters was called but an existing Stripe.js script already exists in the document; existing script parameters will be used';
var findScript = function findScript() {
  var scripts = document.querySelectorAll("script[src^=\"".concat(V3_URL, "\"]"));

  for (var i = 0; i < scripts.length; i++) {
    var script = scripts[i];

    if (!V3_URL_REGEX.test(script.src)) {
      continue;
    }

    return script;
  }

  return null;
};

var injectScript = function injectScript(params) {
  var queryString = params && !params.advancedFraudSignals ? '?advancedFraudSignals=false' : '';
  var script = document.createElement('script');
  script.src = "".concat(V3_URL).concat(queryString);
  var headOrBody = document.head || document.body;

  if (!headOrBody) {
    throw new Error('Expected document.body not to be null. Stripe.js requires a <body> element.');
  }

  headOrBody.appendChild(script);
  return script;
};

var registerWrapper = function registerWrapper(stripe, startTime) {
  if (!stripe || !stripe._registerWrapper) {
    return;
  }

  stripe._registerWrapper({
    name: 'stripe-js',
    version: "3.4.0",
    startTime: startTime
  });
};

var stripePromise = null;
var onErrorListener = null;
var onLoadListener = null;

var onError = function onError(reject) {
  return function () {
    reject(new Error('Failed to load Stripe.js'));
  };
};

var onLoad = function onLoad(resolve, reject) {
  return function () {
    if (window.Stripe) {
      resolve(window.Stripe);
    } else {
      reject(new Error('Stripe.js not available'));
    }
  };
};

var loadScript = function loadScript(params) {
  // Ensure that we only attempt to load Stripe.js at most once
  if (stripePromise !== null) {
    return stripePromise;
  }

  stripePromise = new Promise(function (resolve, reject) {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      // Resolve to null when imported server side. This makes the module
      // safe to import in an isomorphic code base.
      resolve(null);
      return;
    }

    if (window.Stripe && params) {
      console.warn(EXISTING_SCRIPT_MESSAGE);
    }

    if (window.Stripe) {
      resolve(window.Stripe);
      return;
    }

    try {
      var script = findScript();

      if (script && params) {
        console.warn(EXISTING_SCRIPT_MESSAGE);
      } else if (!script) {
        script = injectScript(params);
      } else if (script && onLoadListener !== null && onErrorListener !== null) {
        var _script$parentNode;

        // remove event listeners
        script.removeEventListener('load', onLoadListener);
        script.removeEventListener('error', onErrorListener); // if script exists, but we are reloading due to an error,
        // reload script to trigger 'load' event

        (_script$parentNode = script.parentNode) === null || _script$parentNode === void 0 ? void 0 : _script$parentNode.removeChild(script);
        script = injectScript(params);
      }

      onLoadListener = onLoad(resolve, reject);
      onErrorListener = onError(reject);
      script.addEventListener('load', onLoadListener);
      script.addEventListener('error', onErrorListener);
    } catch (error) {
      reject(error);
      return;
    }
  }); // Resets stripePromise on error

  return stripePromise["catch"](function (error) {
    stripePromise = null;
    return Promise.reject(error);
  });
};
var initStripe = function initStripe(maybeStripe, args, startTime) {
  if (maybeStripe === null) {
    return null;
  }

  var stripe = maybeStripe.apply(undefined, args);
  registerWrapper(stripe, startTime);
  return stripe;
}; // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types

var stripePromise$1;
var loadCalled = false;

var getStripePromise = function getStripePromise() {
  if (stripePromise$1) {
    return stripePromise$1;
  }

  stripePromise$1 = loadScript(null)["catch"](function (error) {
    // clear cache on error
    stripePromise$1 = null;
    return Promise.reject(error);
  });
  return stripePromise$1;
}; // Execute our own script injection after a tick to give users time to do their
// own script injection.


Promise.resolve().then(function () {
  return getStripePromise();
})["catch"](function (error) {
  if (!loadCalled) {
    console.warn(error);
  }
});
var loadStripe = function loadStripe() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  loadCalled = true;
  var startTime = Date.now(); // if previous attempts are unsuccessful, will re-load script

  return getStripePromise().then(function (maybeStripe) {
    return initStripe(maybeStripe, args, startTime);
  });
};




/***/ }),
/* 819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dist_index_mjs__ = __webpack_require__(818);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__dist_index_mjs__["a"]; });



/***/ }),
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var autoplay = {
  props: {
    /**
     * Flag to enable autoplay
     */
    autoplay: {
      type: Boolean,
      default: false
    },
    /**
     * Time elapsed before next slide
     */
    autoplayTimeout: {
      type: Number,
      default: 2000
    },
    /**
     * Flag to pause autoplay on hover
     */
    autoplayHoverPause: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      autoplayInterval: null
    };
  },
  destroyed: function destroyed() {
    this.pauseAutoplay();

    if (!this.$isServer) {
      this.$el.removeEventListener('mouseenter', this.pauseAutoplay);
      this.$el.removeEventListener('mouseleave', this.startAutoplay);
    }
  },

  methods: {
    pauseAutoplay: function pauseAutoplay() {
      if (this.autoplayInterval) {
        this.autoplayInterval = clearInterval(this.autoplayInterval);
      }
    },
    startAutoplay: function startAutoplay() {
      var _this = this;

      if (this.autoplay) {
        this.autoplayInterval = setInterval(function () {
          _this.dir === 'ltr' ? _this.goPrev() : _this.goNext();
        }, this.autoplayTimeout);
      }
    }
  },
  mounted: function mounted() {
    if (!this.$isServer && this.autoplayHoverPause) {
      this.$el.addEventListener('mouseenter', this.pauseAutoplay);
      this.$el.addEventListener('mouseleave', this.startAutoplay);
    }

    this.startAutoplay();
  }
};

/* harmony default export */ __webpack_exports__["a"] = (autoplay);

/***/ }),
/* 841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ViolationsEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PublicRelationsUsername; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return Countries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return States; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return VideoGenres; });
/* unused harmony export UserTypes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return UserTypeOptions; });
/* unused harmony export StreamHourlyPrice */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return PaymentTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return MediaLiveInputTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return MediaLiveInputCodecs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return MediaLiveInputResolutions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return MediaLiveInputMaximumBitrates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return StreamViewPrices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return StreamViewersLimits; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return StreamCosts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return StreamStatuses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return VideoTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return UserBooleanOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return UserGenderOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return UserArtistTypeOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return UserReleasedAlbumsCountOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return UserYearsSinceFirstReleasedOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return UserAnnualIncomeOnMerchSalesOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return UserAnnualPerformancesCountOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return UserSignedStatusOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return UserPerformanceRightsOrganizationOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return UserArtistsCountOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return UserStandardBrandTypeOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return UserEmployeesCountOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return UserYearsInBusinessOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return UserProductsCountOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return UserAnnualIncomeOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return CollaboratorRoleTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return CollaboratorProfitShareTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MyEvents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return MyCookies; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return QrCodeTypeList; });
/* eslint-disable */
var ViolationsEmail = 'violations@yousound.com';
var PublicRelationsUsername = 'yousound';

var Countries = ['Afghanistan', 'Albania', 'Algeria', 'Andorra', 'Angola', 'Anguilla', 'Antigua & Barbuda', 'Argentina', 'Armenia', 'Aruba', 'Australia', 'Austria', 'Azerbaijan', 'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bermuda', 'Bhutan', 'Bolivia', 'Bosnia & Herzegovina', 'Botswana', 'Brazil', 'British Virgin Islands', 'Brunei', 'Bulgaria', 'Burkina Faso', 'Burundi', 'Cambodia', 'Cameroon', 'Canada', 'Cape Verde', 'Cayman Islands', 'Chad', 'Chile', 'China', 'Colombia', 'Congo', 'Cook Islands', 'Costa Rica', 'Cote D Ivoire', 'Croatia', 'Cuba', 'Cyprus', 'Czech Republic', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea', 'Estonia', 'Ethiopia', 'Falkland Islands', 'Faroe Islands', 'Fiji', 'Finland', 'France', 'French Polynesia', 'French West Indies', 'Gabon', 'Gambia', 'Georgia', 'Germany', 'Ghana', 'Gibraltar', 'Greece', 'Greenland', 'Grenada', 'Guam', 'Guatemala', 'Guernsey', 'Guinea', 'Guinea Bissau', 'Guyana', 'Haiti', 'Honduras', 'Hong Kong', 'Hungary', 'Iceland', 'India', 'Indonesia', 'Iran', 'Iraq', 'Ireland', 'Isle of Man', 'Israel', 'Italy', 'Jamaica', 'Japan', 'Jersey', 'Jordan', 'Kazakhstan', 'Kenya', 'Kuwait', 'Kyrgyz Republic', 'Laos', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Macau', 'Macedonia', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 'Mauritania', 'Mauritius', 'Mexico', 'Moldova', 'Monaco', 'Mongolia', 'Montenegro', 'Montserrat', 'Morocco', 'Mozambique', 'Namibia', 'Nepal', 'Netherlands', 'Netherlands Antilles', 'New Caledonia', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'Norway', 'Oman', 'Pakistan', 'Palestine', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Poland', 'Portugal', 'Puerto Rico', 'Qatar', 'Reunion', 'Romania', 'Russia', 'Rwanda', 'Saint Pierre & Miquelon', 'Samoa', 'San Marino', 'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles', 'Sierra Leone', 'Singapore', 'Slovakia', 'Slovenia', 'South Africa', 'South Korea', 'Spain', 'Sri Lanka', 'St Kitts & Nevis', 'St Lucia', 'St Vincent', 'St. Lucia', 'Sudan', 'Suriname', 'Swaziland', 'Sweden', 'Switzerland', 'Syria', 'Taiwan', 'Tajikistan', 'Tanzania', 'Thailand', 'Timor Leste', 'Togo', 'Tonga', 'Trinidad & Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Turks & Caicos', 'Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom', 'United States', 'United States Minor Outlying Islands', 'Uruguay', 'Uzbekistan', 'Venezuela', 'Vietnam', 'Virgin Islands (US)', 'Yemen', 'Zambia', 'Zimbabwe'];

var States = [{ value: 'AK', name: 'Alaska' }, { value: 'AL', name: 'Alabama' }, { value: 'AR', name: 'Arkansas' }, { value: 'AZ', name: 'Arizona' }, { value: 'CA', name: 'California' }, { value: 'CO', name: 'Colorado' }, { value: 'CT', name: 'Connecticut' }, { value: 'DC', name: 'DistrictofColumbia' }, { value: 'DE', name: 'Delaware' }, { value: 'FL', name: 'Florida' }, { value: 'GA', name: 'Georgia' }, { value: 'HI', name: 'Hawaii' }, { value: 'IA', name: 'Iowa' }, { value: 'ID', name: 'Idaho' }, { value: 'IL', name: 'Illinois' }, { value: 'IN', name: 'Indiana' }, { value: 'KS', name: 'Kansas' }, { value: 'KY', name: 'Kentucky' }, { value: 'LA', name: 'Louisiana' }, { value: 'MA', name: 'Massachusetts' }, { value: 'MD', name: 'Maryland' }, { value: 'ME', name: 'Maine' }, { value: 'MI', name: 'Michigan' }, { value: 'MN', name: 'Minnesota' }, { value: 'MO', name: 'Missouri' }, { value: 'MS', name: 'Mississippi' }, { value: 'MT', name: 'Montana' }, { value: 'NC', name: 'NorthCarolina' }, { value: 'ND', name: 'NorthDakota' }, { value: 'NE', name: 'Nebraska' }, { value: 'NH', name: 'NewHampshire' }, { value: 'NJ', name: 'NewJersey' }, { value: 'NM', name: 'NewMexico' }, { value: 'NV', name: 'Nevada' }, { value: 'NY', name: 'NewYork' }, { value: 'OH', name: 'Ohio' }, { value: 'OK', name: 'Oklahoma' }, { value: 'OR', name: 'Oregon' }, { value: 'PA', name: 'Pennsylvania' }, { value: 'RI', name: 'RhodeIsland' }, { value: 'SC', name: 'SouthCarolina' }, { value: 'SD', name: 'SouthDakota' }, { value: 'TN', name: 'Tennessee' }, { value: 'TX', name: 'Texas' }, { value: 'UT', name: 'Utah' }, { value: 'VA', name: 'Virginia' }, { value: 'VT', name: 'Vermont' }, { value: 'WA', name: 'Washington' }, { value: 'WI', name: 'Wisconsin' }, { value: 'WV', name: 'WestVirginia' }, { value: 'WY', name: 'Wyoming' }];

// Commented out the original VideoGenres export and replaced it with an empty array
/*
export const VideoGenres = [
  'Music',
  'Film',
  'Documentary',
  'Animation',
  'Podcast',
  'Sports',
  'Events',
  'Gaming',
  'Interview',
  'Comedy',
  'How to',
  'Lifestyle',
  'Education',
  'Technology',
]
*/
var VideoGenres = [];

var UserTypes = {
  ADMIN: 'admin',
  LISTENER: 'listener',
  ARTIST: 'artist',
  BRAND: 'brand',
  LABEL: 'label'
};

var UserTypeOptions = [{ value: 'artist', text: 'Artist' }, { value: 'brand', text: 'Brand' }];

var StreamHourlyPrice = 1000;

var PaymentTypes = {
  repost_price_upgrade_cost: 'Repost Price Upgrade Cost',
  pay_view_stream: 'Pay Per View'

  // export const RepostPrices = [5, 10, 15]

  // export const MediaLiveInputTypes = {
  //   UDP_PUSH: 'UDP_PUSH',
  //   RTP_PUSH: 'RTP_PUSH',
  //   RTMP_PUSH: 'RTMP_PUSH',
  //   RTMP_PULL: 'RTMP_PULL',
  //   URL_PULL: 'URL_PULL'
  // }

};var MediaLiveInputTypes = ['UDP_PUSH', 'RTP_PUSH', 'RTMP_PUSH', 'RTMP_PULL', 'URL_PULL'];
var MediaLiveInputCodecs = ['MPEG2', 'AVC', 'HEVC'];
var MediaLiveInputResolutions = ['SD', 'HD', 'UHD'];
var MediaLiveInputMaximumBitrates = ['MAX_10_MBPS', 'MAX_20_MBPS', 'MAX_50_MBPS'];

var StreamViewPrices = [{ id: 0, name: 'No' }, { id: 100, name: '$1' }, { id: 500, name: '$5' }, { id: 1000, name: '$10' }, { id: 2000, name: '$20' }, { id: 5000, name: '$50' }, { id: 10000, name: '$100' }, { id: 25000, name: '$250' }, { id: 50000, name: '$500' }, { id: 100000, name: '$1,000' }, { id: 250000, name: '$2,500' }, { id: 500000, name: '$5,000' }, { id: 1000000, name: '$10,000' }];
var StreamViewersLimits = [{ id: 0, name: 'Unlimited' }, { id: 1, name: '1' }, { id: 5, name: '5' }, { id: 10, name: '10' }, { id: 20, name: '20' }, { id: 50, name: '50' }, { id: 100, name: '100' }, { id: 250, name: '250' }, { id: 500, name: '500' }, { id: 1000, name: '1,000' }, { id: 2500, name: '2,500' }, { id: 5000, name: '5,000' }, { id: 10000, name: '10,000' }];
var StreamCosts = [{ value: 1000, name: '$10' }, { value: 5000, name: '$50' }, { value: 10000, name: '$100' }, { value: 100000, name: '$1000' }];
var StreamStatuses = {
  RUNNING: 'running',
  INACTIVE: 'inactive',
  UPLOADING: 'uploading',
  ARCHIVED: 'archived',
  DELETED: 'deleted'
};

var VideoTypes = {
  LIVE: 'live',
  UPLOADED: 'uploaded'

  // Additional options being used for user registration.
};var UserBooleanOptions = [{ id: true, name: 'Yes' }, { id: false, name: 'No' }];
// export const UserGenderOptions = ['Male', 'Female']
var UserGenderOptions = [{ value: '', text: "I'd rather not say" }, { value: 'Male', text: 'Male' }, { value: 'Female', text: 'Female' }];
var UserArtistTypeOptions = ['Solo artist', 'Brand/Group', 'Producer', 'DJ'];
var UserReleasedAlbumsCountOptions = [{ id: 0, name: '0' }, { id: 1, name: '1-5' }, { id: 6, name: '6-10' }, { id: 11, name: '10+' }];
var UserYearsSinceFirstReleasedOptions = [{ id: 0, name: '0' }, { id: 1, name: '1-5' }, { id: 6, name: '6-10' }, { id: 11, name: '10+' }];
var UserAnnualIncomeOnMerchSalesOptions = [{ id: 0, name: 'None' }, { id: 1, name: '$1-$4k' }, { id: 5001, name: '$5k-$10k' }, { id: 10001, name: '$11k-$50k' }, { id: 50001, name: '$50k+' }];
var UserAnnualPerformancesCountOptions = [{ id: 0, name: 'None' }, { id: 1, name: '1-10' }, { id: 11, name: '11-50' }, { id: 51, name: '50+' }];
var UserSignedStatusOptions = ['No', 'Yes, Indie label', 'Yes, major label'];
var UserPerformanceRightsOrganizationOptions = [{ id: 'Argentina-SADAIC', name: 'Argentina - SADAIC' }, {
  id: 'Australia-APRA',
  name: 'Australia - Australasian Performing Right Association (APRA)'
}, {
  id: 'Australia-PPCA',
  name: 'Australia - Phonographic Performance Company of Australia (PPCA)'
}, {
  id: 'Austria-AKM',
  name: 'Austria - Autoren, Komponisten und Musikverleger (AKM)'
}, { id: 'Belgium-SABAM', name: 'Belgium - SABAM' }, {
  id: 'Bolivia-SENAPI',
  name: 'Bolivia - Servicio Nacional de Propiedad Intelectual (SENAPI)'
}, {
  id: 'Brazil-ECAD',
  name: 'Brazil - ECAD (Escritório Central de Arrecadação e Distribuição)'
}, { id: 'Bulgaria-MUSICAUTHOR', name: 'Bulgaria - MUSICAUTHOR' }, {
  id: 'Canada-SOCAN',
  name: 'Canada - Society of Composers, Authors and Music Publishers of Canada (SOCAN)'
}, {
  id: 'Chile-SCD',
  name: 'Chile - Sociedad Chilena del Derecho de Autor (SCD)'
}, { id: 'Colombia-SAYCO/ACINPRO', name: 'Colombia - SAYCO/ACINPRO' }, { id: 'Croatia-HDS', name: 'Croatia - HDS' }, { id: 'Czech Republic-OSA', name: 'Czech Republic - OSA' }, { id: 'Denmark-KODA', name: ' Denmark - KODA' }, { id: 'Estonia-EAU', name: 'Estonia - EAU' }, { id: 'Finland-Teosto', name: 'Finland - Teosto' }, {
  id: 'France-SACEM',
  name: 'France - Société des auteurs, compositeurs et éditeurs de musique (SACEM)'
}, { id: 'Georgia-SAS', name: 'Georgia - SAS' }, {
  id: 'Germany-GEMA',
  name: 'Germany - Gesellschaft für musikalische Aufführungs- und mechanische Vervielfältigungsrechte (GEMA)'
}, { id: 'Greece-AEPI', name: 'Greece - AEPI' }, { id: 'Greece-GEA-GRAMMO', name: 'Greece - GEA-GRAMMO, ERATO-APOLLON' }, { id: 'Hong Kong-CASH', name: 'Hong Kong - CASH' }, { id: 'Hungary-ARTISJUS', name: 'Hungary - ARTISJUS' }, {
  id: 'India-The Indian Performing Right Society Ltd',
  name: 'India - The Indian Performing Right Society Ltd'
}, {
  id: 'Ireland-PPI',
  name: 'Ireland - Irish Music Rights Organisation, Phonographic Performance Ireland (PPI)'
}, { id: 'Israel-ACUM', name: 'Israel - ACUM' }, { id: 'Italy-SIAE', name: 'Italy - SIAE' }, { id: 'Japan-JASRAC', name: 'Japan - JASRAC' }, { id: 'Lithuania-LATGA-A', name: 'Lithuania - LATGA-A' }, { id: 'Malaysia-MACP', name: 'Malaysia - MACP' }, { id: 'Mexico-SACM', name: 'Mexico - SACM' }, {
  id: 'Nepal-MRCSN',
  name: 'Nepal - Music Royalty Collection Society Nepal (MRCSN)'
}, { id: 'Netherlands-BUMA', name: 'Netherlands - BUMA' }, { id: 'New Zealand-APRA', name: 'New Zealand - APRA' }, { id: 'Norway-TONO', name: 'Norway - TONO' }, { id: 'Panama-SPAC', name: 'Panama - SPAC' }, { id: 'Peru-APDAYC', name: 'Peru - APDAYC' }, { id: 'Philippines-FILSCAP', name: 'Philippines - FILSCAP' }, { id: 'Poland-ZAIKS', name: 'Poland - ZAIKS' }, { id: 'Puerto Rico-ACEMLA', name: 'Puerto Rico - ACEMLA' }, { id: 'Romania-UCMR', name: 'Romania - UCMR' }, { id: 'Russia-RAO', name: 'Russia - RAO' }, { id: 'Serbia-SOKOJ', name: 'Serbia - SOKOJ' }, { id: 'Singapore-COMPASS', name: 'Singapore - COMPASS' }, { id: 'Slovakia-SOZA', name: 'Slovakia - SOZA' }, {
  id: 'South Africa-SAMRO',
  name: 'South Africa - Southern African Music Rights Organisation (SAMRO)'
}, { id: 'South Korea-KOMCA', name: 'South Korea - KOMCA, KOSCAP' }, { id: 'Spain-SGAE', name: 'Spain - SGAE' }, { id: 'Sweden-STIM', name: 'Sweden - STIM' }, { id: 'Switzerland-SUISA', name: 'Switzerland - SUISA' }, { id: 'Taiwan-MUST', name: 'Taiwan - MUST' }, { id: 'Thailand-MCT', name: 'Thailand - MCT' }, { id: 'Trinidad-COTT', name: 'Trinidad - COTT' }, { id: 'Ukraine-UACRR', name: 'Ukraine - UACRR' }, { id: 'United Kingdom-PRS', name: 'United Kingdom - PRS, PPL' }, {
  id: 'United States of America-SPACEM',
  name: 'United States of America - ASCAP, BMI, SESAC, ACEMLA (SPACEM)'
}, { id: 'Uruguay-AGADU', name: 'Uruguay - AGADU' }, { id: 'Venezuela-SACVEN', name: 'Venezuela - SACVEN' }];
var UserArtistsCountOptions = [{ id: 0, name: 'None' }, { id: 1, name: '1-2' }, { id: 3, name: '3-5' }, { id: 6, name: '6-10+' }];
var UserStandardBrandTypeOptions = ['Clothing Brand (Streetwear, Luxury)', 'Service Brand (Mixing/Mastering Engineers, Graphic Designers, Manufacturing)', 'Lifestyle Brand (Culture, Sports, Promoters, Food & Beverage)', 'Broadcasting Brand (Podcasts, TV/Movie, Personality)', 'Technology Brand (Software, Video Game)', 'Retail Brand (Record Stores, Coffee Shop)'];
var UserEmployeesCountOptions = [{ id: 1, name: '1-5' }, { id: 6, name: '6-10' }, { id: 11, name: '10+' }];
var UserYearsInBusinessOptions = [{ id: 0, name: '0' }, { id: 1, name: '1-5' }, { id: 6, name: '6-10+' }];
var UserProductsCountOptions = [{ id: 0, name: 'None' }, { id: 1, name: '1-10' }, { id: 11, name: '11-50' }, { id: 51, name: '50+' }];
var UserAnnualIncomeOptions = [{ id: 0, name: 'None' }, { id: 5000, name: '$5k-$24k' }, { id: 25000, name: '$25k-$80k' }, { id: 80000, name: '$81k-$100k' }, { id: 100000, name: '$100k-$249k' }, { id: 250000, name: '$250k-$1m' }, { id: 1000000, name: '$1m-$10m' }, { id: 10000000, name: '$10m+' }];

// collaborator of product, stream

var CollaboratorRoleTypes = ['Additional Production', 'Album Artwork', 'Arranger', 'Choreography', 'Composer', 'Creative Direction', 'Engineer', 'Executive Producer', 'Mastering', 'Musician - Bass', 'Musician - Brass', 'Musician - Drums', 'Musician - Electronics', 'Musician - Guitar', 'Musician - Keys', 'Musician - Orchestral', 'Musician - Percussion', 'Musician - Strings', 'Musician - Vocals', 'Producer', 'Remixer', 'Stylist', 'Video DP', 'Video Director', 'Video Producer', 'Vocalist', 'Writer'];

var CollaboratorProfitShareTypes = [1, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95];

// #TODO - combile audio_player_play and replay
var MyEvents = {
  AUTH_SIGNIN: 'auth_signin',
  AUTH_SIGNOUT: 'auth_signout',
  USER_FOLLOW: 'follow',
  AUDIO_PLAYER_PAUSE: 'pause',
  AUDIO_PLAYER_PLAY: 'play',
  AUDIO_PLAYER_REPLAY: 'replay',
  AUDIO_PLAYER_SKIPTO: 'skipTo',
  STREM_PLAYER_INIT: 'stream_player_init',
  STREM_PLAYER_FULLSCREEN_ENTER: 'stream_player_fullscreen_enter',
  STREM_PLAYER_SHUTDOWN: 'stream_player_shutdown',
  STREM_PLAYER_EXIT: 'stream_player_exit'
};

var MyCookies = {
  TRACKING_SITE: 'tracking_site'
};

var QrCodeTypeList = {
  ANDROID: 'android',
  IOS: 'ios'
};

/***/ }),
/* 842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_intercom__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_intercom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_intercom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_home_browser__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_home_browser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__views_home_browser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuetify__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_numeric__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_numeric___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_numeric__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_clipboard2__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_clipboard2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_clipboard2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_head__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_head___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_head__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vee_validate__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_social_sharing__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_social_sharing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_social_sharing__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_lazyload__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue_lazyload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_fullpage_js_vendors_scrolloverflow__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_fullpage_js_vendors_scrolloverflow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_fullpage_js_vendors_scrolloverflow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_fullpage_js_dist_fullpage_css__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_fullpage_js_dist_fullpage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_fullpage_js_dist_fullpage_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_fullpage_js__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_fullpage_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vue_fullpage_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_ctk_date_time_picker__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_ctk_date_time_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vue_ctk_date_time_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_ctk_date_time_picker_dist_vue_ctk_date_time_picker_css__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_ctk_date_time_picker_dist_vue_ctk_date_time_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_vue_ctk_date_time_picker_dist_vue_ctk_date_time_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_apexcharts__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_apexcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_vue_apexcharts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue_on_click_outside__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue_on_click_outside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_vue_on_click_outside__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__helper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__services_setting__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__static_styles_app_scss__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__static_styles_app_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__static_styles_app_scss__);























__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_21_vue_apexcharts___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("ApexChart", __WEBPACK_IMPORTED_MODULE_21_vue_apexcharts___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('VueCtkDateTimePicker', __WEBPACK_IMPORTED_MODULE_19_vue_ctk_date_time_picker___default.a);






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype, '_', { value: __WEBPACK_IMPORTED_MODULE_4_lodash___default.a });
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_intercom___default.a, { appId: "c87vjth9" });
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vue_numeric___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_vue_clipboard2___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_vue_head___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_14_vue_social_sharing___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_15_vue_lazyload___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_18_vue_fullpage_js___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_19_vue_ctk_date_time_picker___default.a);

var dictionary = {
  en: {
    custom: {
      username: {
        regex: 'Username cannot have special char.'
      }
    }
  }
};
__WEBPACK_IMPORTED_MODULE_13_vee_validate__["a" /* default */].Validator.localize('en', dictionary.en);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13_vee_validate__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].directive('on-click-outside', __WEBPACK_IMPORTED_MODULE_22_vue_on_click_outside__["directive"]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('formatSlashedDate', __WEBPACK_IMPORTED_MODULE_23__helper__["a" /* Filter */].formatSlashedDate);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('formatDate', __WEBPACK_IMPORTED_MODULE_23__helper__["a" /* Filter */].formatDate);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('formatDateFromNow', __WEBPACK_IMPORTED_MODULE_23__helper__["a" /* Filter */].formatDateFromNow);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('formatDateFromNowShort', __WEBPACK_IMPORTED_MODULE_23__helper__["a" /* Filter */].formatDateFromNowShort);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('formatNumber', __WEBPACK_IMPORTED_MODULE_23__helper__["a" /* Filter */].formatNumber);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('formatNumberWithComma', __WEBPACK_IMPORTED_MODULE_23__helper__["a" /* Filter */].formatNumberWithComma);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('formatLargeNumber', __WEBPACK_IMPORTED_MODULE_23__helper__["a" /* Filter */].formatLargeNumber);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('formatFullUrl', __WEBPACK_IMPORTED_MODULE_23__helper__["a" /* Filter */].formatFullUrl);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('getTime', __WEBPACK_IMPORTED_MODULE_23__helper__["a" /* Filter */].getTime);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('timeInHours', __WEBPACK_IMPORTED_MODULE_23__helper__["a" /* Filter */].timeInHours);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('timeInMinutes', __WEBPACK_IMPORTED_MODULE_23__helper__["a" /* Filter */].timeInMinutes);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('timeInWords', __WEBPACK_IMPORTED_MODULE_23__helper__["a" /* Filter */].timeInWords);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('capitalize', __WEBPACK_IMPORTED_MODULE_23__helper__["a" /* Filter */].capitalize);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('truncateInMiddle', __WEBPACK_IMPORTED_MODULE_23__helper__["a" /* Filter */].truncateInMiddle);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('pluralize', __WEBPACK_IMPORTED_MODULE_23__helper__["a" /* Filter */].pluralize);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('toLocalTimeString', __WEBPACK_IMPORTED_MODULE_23__helper__["a" /* Filter */].toLocalTimeString);

navigator.sayswho = function () {
  var ua = navigator.userAgent;
  var tem = void 0;
  var M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
  if (/trident/i.test(M[1])) {
    tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
    return 'IE ' + (tem[1] || '');
  }
  if (M[1] === 'Chrome') {
    tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
    if (tem != null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
  }
  M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
  if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
  return M.join(' ');
}();

var isOldBrowser = false;
var browserInfo = navigator.sayswho.split(' ');
var browserName = browserInfo[0].toLowerCase();
var browserVersion = parseInt(browserInfo[1]) || 0;
switch (browserName) {
  case 'chrome':
    if (browserVersion < 64) isOldBrowser = true;
    break;
  case 'firefox':
    if (browserVersion < 60) isOldBrowser = true;
    break;
  case 'safari':
    if (browserVersion < 10) isOldBrowser = true;
    break;
  case 'ie':
    if (browserVersion < 11) isOldBrowser = true;
    break;
  case 'opera':
    if (browserVersion < 50) isOldBrowser = true;
    break;
  case 'qq':
    if (browserVersion < 6) isOldBrowser = true;
    break;
}

var isMobile = function isMobile() {
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    return true;
  } else {
    return false;
  }
};
var onMobile = isMobile();

if (isOldBrowser) {
  var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
    template: '<BrowserPage/>',
    components: { BrowserPage: __WEBPACK_IMPORTED_MODULE_7__views_home_browser___default.a }
  });
  app.$mount('#app');
} else {
  __WEBPACK_IMPORTED_MODULE_24__services_setting__["a" /* default */].getSettings().then(function (response) {
    var settings = response.body;
    var router = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__router__["a" /* createRouter */])(settings);
    router.beforeEach(function (to, from, next) {
      var isAllowedOnMobile = to.meta.allowOnMobile;
      if (onMobile && !isAllowedOnMobile) {
        return next({
          name: "Home",
          replace: true
        });
      }

      if (/^\/(x)$/.test(to.path) && __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].state.auth.secret_code !== "e82a084c96d055241d1883bb219377cfd1804594d019a331db83cd054ccd9404") {
        next('/protect');
      } else {
        next();
      }
    });
    var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
      router: router,
      store: __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */],
      template: '<App/>',
      components: { App: __WEBPACK_IMPORTED_MODULE_5__App___default.a }
    });
    app.$mount('#app');
  });
}

/***/ }),
/* 843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);

// import $store from '@/store'

var API_BASE_URL = "https://api.yousound.com" + '/v1/newsletter_recipients';

/* harmony default export */ __webpack_exports__["a"] = ({
  storeRecipient: function storeRecipient(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL, params);
  }
});

/***/ }),
/* 844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(10);



var API_BASE_URL = "https://api.yousound.com" + '/v1/promote';

/* harmony default export */ __webpack_exports__["a"] = ({
  searchUsers: function searchUsers(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL + '/search_users', params, {
      headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token }
    });
  },
  calculateSuggestedReposters: function calculateSuggestedReposters(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL + '/calculate_on_suggested_reposters', params, { headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token } });
  },
  calculateCurrentReposters: function calculateCurrentReposters(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_BASE_URL + '/calculate_on_current_reposters', params, { headers: { Authorization: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.token } });
  }
});

/***/ }),
/* 845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

// import { Utils } from '@/helper'
// import * as types from '@/store/mutation-types'

function initialState() {
  return {
    badge: {
      activity: 0,
      stream: 0,
      message: 0,
      cart: 0,
      sell: 0
    }
  };
}

var state = initialState;

var getters = {};

var actions = {
  setBadge: function setBadge(_ref, badge) {
    var commit = _ref.commit;

    commit('setBadge', badge);
  },
  addBadge: function addBadge(_ref2, badge) {
    var commit = _ref2.commit;

    commit('addBadge', badge);
  }
};

var mutations = {
  setBadge: function setBadge(state, badge) {
    state.badge = badge;
  },
  addBadge: function addBadge(state, badge) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(badge).forEach(function (key) {
      state.badge[key] += badge[key];
    });
  },
  reset: function reset(state) {
    var s = initialState();
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(s).forEach(function (key) {
      state[key] = s[key];
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  strict: "production" !== 'production',
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// import { Utils } from '@/helper'
// import * as types from '@/store/mutation-types'

var state = {
  // user: Utils.parseJSON(Storage.get('user')),
  albums: []
};

var getters = {};

var actions = {
  setAlbums: function setAlbums(_ref, albums) {
    var commit = _ref.commit;

    commit('setAlbums', albums);
  }
};

var mutations = {
  setAlbums: function setAlbums(state, albums) {
    state.albums = albums;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  strict: "production" !== 'production',
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(8);




var state = {
  toggleActivity: false,
  settings: {},
  genres: [],
  product_categories: [],
  public_relations_user: {},
  sideBarMini: false,
  sideBarWidth: 250,
  countries: [],
  cities: [],
  activation: {
    current: 1,
    accountCategory: 'creator'
  },
  onboarding: {
    current: 1,
    accountCategory: '',
    user_type: '',
    accountType: '',
    username: '',
    profileImage: '',
    avatar: '',
    first_name: '',
    last_name: '',
    fullName: '',
    email: '',
    password: '',
    age_group: '',
    country: '',
    city: '',
    social_provider: '',
    social_user_name: ''
  },
  globalSMSactive: false,
  windowsWidth: null,
  plansData: [{
    title: "Basic",
    list: ["Ad-free", "Access to all content", "Unlimited playlists", 'Creators share 50% of your sub', "See creators you support", "Get paid to share", "Join SMS communities"],
    active: false,
    price: "10",
    id: "basic",
    stripePriceId: __webpack_require__.i({"NODE_ENV":"production","CHAT_SERVER_URL":"https://chat.yousound.com","API_BASE_URL":"https://api.yousound.com","SOCKET_BASE_URL":"wss://api.yousound.com/cable","SECRET_CODE":"e82a084c96d055241d1883bb219377cfd1804594d019a331db83cd054ccd9404","INTERCOM_APP_ID":"c87vjth9","STRIPE_PUBLISHABLE_KEY":"pk_live_fXEdJ0v6E2ROxT8rufDCby12","STRIPE_SECRET_KEY":"sk_live_pntvln2j8e8tB8Euf3xAy2dG","STRIPE_CONNECT_CLIENT_ID":"ca_CC74CVRdkHTZqAIPQVJS04XoPwiVB1Kx"}).BASIC_PRICE_ID
  }, {
    title: "Creators",
    list: ['All features for everyone +', "User-centric subscription share", "Keep 100% of sales", "SMS text your followers*", "Unlimited uploads", "Batch audio uploads", "Collaborative payment splits", "Live video pay-per-view", "Live video exclusive content"],
    active: true,
    price: "40",
    id: "plus",
    stripePriceId: __webpack_require__.i({"NODE_ENV":"production","CHAT_SERVER_URL":"https://chat.yousound.com","API_BASE_URL":"https://api.yousound.com","SOCKET_BASE_URL":"wss://api.yousound.com/cable","SECRET_CODE":"e82a084c96d055241d1883bb219377cfd1804594d019a331db83cd054ccd9404","INTERCOM_APP_ID":"c87vjth9","STRIPE_PUBLISHABLE_KEY":"pk_live_fXEdJ0v6E2ROxT8rufDCby12","STRIPE_SECRET_KEY":"sk_live_pntvln2j8e8tB8Euf3xAy2dG","STRIPE_CONNECT_CLIENT_ID":"ca_CC74CVRdkHTZqAIPQVJS04XoPwiVB1Kx"}).PLUS_PRICE_ID
  }, {
    title: "Advanced",
    list: ['<b>All features for creators +</b>', "<b>Advanced analytics</b>", ["Listeners/buyers by country", "External traffic location", "Average listening/watch time", "Page views", "Watching/listening now", "Product conversion %", "+more"]],
    active: false,
    price: "100",
    id: "pro",
    stripePriceId: __webpack_require__.i({"NODE_ENV":"production","CHAT_SERVER_URL":"https://chat.yousound.com","API_BASE_URL":"https://api.yousound.com","SOCKET_BASE_URL":"wss://api.yousound.com/cable","SECRET_CODE":"e82a084c96d055241d1883bb219377cfd1804594d019a331db83cd054ccd9404","INTERCOM_APP_ID":"c87vjth9","STRIPE_PUBLISHABLE_KEY":"pk_live_fXEdJ0v6E2ROxT8rufDCby12","STRIPE_SECRET_KEY":"sk_live_pntvln2j8e8tB8Euf3xAy2dG","STRIPE_CONNECT_CLIENT_ID":"ca_CC74CVRdkHTZqAIPQVJS04XoPwiVB1Kx"}).PRO_PRICE_ID
  }],
  plansDataSub: [{
    title: "Basic",
    list: ["Ad-free", "Access to all content", "Unlimited playlists", 'Creators share 50% of your sub', "See creators you support", "Get paid to share", "Join SMS communities"],
    active: false,
    price: "10",
    id: "basic",
    stripePriceId: __webpack_require__.i({"NODE_ENV":"production","CHAT_SERVER_URL":"https://chat.yousound.com","API_BASE_URL":"https://api.yousound.com","SOCKET_BASE_URL":"wss://api.yousound.com/cable","SECRET_CODE":"e82a084c96d055241d1883bb219377cfd1804594d019a331db83cd054ccd9404","INTERCOM_APP_ID":"c87vjth9","STRIPE_PUBLISHABLE_KEY":"pk_live_fXEdJ0v6E2ROxT8rufDCby12","STRIPE_SECRET_KEY":"sk_live_pntvln2j8e8tB8Euf3xAy2dG","STRIPE_CONNECT_CLIENT_ID":"ca_CC74CVRdkHTZqAIPQVJS04XoPwiVB1Kx"}).BASIC_PRICE_ID
  }, {
    title: "Creators",
    list: ['All features for everyone +', "User-centric subscription share", "Keep 100% of sales", "SMS text your followers*", "Unlimited uploads", "Batch audio uploads", "Collaborative payment splits", "Live video pay-per-view", "Live video exclusive content"],
    active: true,
    price: "40",
    id: "plus",
    stripePriceId: __webpack_require__.i({"NODE_ENV":"production","CHAT_SERVER_URL":"https://chat.yousound.com","API_BASE_URL":"https://api.yousound.com","SOCKET_BASE_URL":"wss://api.yousound.com/cable","SECRET_CODE":"e82a084c96d055241d1883bb219377cfd1804594d019a331db83cd054ccd9404","INTERCOM_APP_ID":"c87vjth9","STRIPE_PUBLISHABLE_KEY":"pk_live_fXEdJ0v6E2ROxT8rufDCby12","STRIPE_SECRET_KEY":"sk_live_pntvln2j8e8tB8Euf3xAy2dG","STRIPE_CONNECT_CLIENT_ID":"ca_CC74CVRdkHTZqAIPQVJS04XoPwiVB1Kx"}).PLUS_PRICE_ID
  }, {
    title: "Advanced",
    list: ['<b>All features for creators +</b>', "<b>Advanced analytics</b>", ["Content performance", "Listeners/buyers by country", "External traffic location", "Average listening/watch time", "Page views", "Watching/listening now", "Product conversion %", "Repost request data"]],
    active: false,
    price: "100",
    id: "pro",
    stripePriceId: __webpack_require__.i({"NODE_ENV":"production","CHAT_SERVER_URL":"https://chat.yousound.com","API_BASE_URL":"https://api.yousound.com","SOCKET_BASE_URL":"wss://api.yousound.com/cable","SECRET_CODE":"e82a084c96d055241d1883bb219377cfd1804594d019a331db83cd054ccd9404","INTERCOM_APP_ID":"c87vjth9","STRIPE_PUBLISHABLE_KEY":"pk_live_fXEdJ0v6E2ROxT8rufDCby12","STRIPE_SECRET_KEY":"sk_live_pntvln2j8e8tB8Euf3xAy2dG","STRIPE_CONNECT_CLIENT_ID":"ca_CC74CVRdkHTZqAIPQVJS04XoPwiVB1Kx"}).PRO_PRICE_ID
  }]
};

var getters = {
  isiOS: function isiOS() {
    if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
      return true;
    }
  },
  isAndroid: function isAndroid() {
    var useragent = navigator.userAgent.toLowerCase();
    var isAndroid = useragent.indexOf("android") > -1;
    if (isAndroid) {
      return true;
    }
  },
  getWindowsWidth: function getWindowsWidth(state) {
    return state.windowsWidth;
  },
  onMobileStrict: function onMobileStrict(state) {
    var windowsWidth = state.windowsWidth;

    if (windowsWidth < 768) {
      return true;
    }
    return false;
  },
  onTabletStrict: function onTabletStrict(state) {
    var windowsWidth = state.windowsWidth;

    if (windowsWidth > 767 && windowsWidth < 1024) {
      return true;
    }
    return false;
  },
  onTabletAndAbove: function onTabletAndAbove(state) {
    var windowsWidth = state.windowsWidth;

    if (windowsWidth > 767) {
      return true;
    }
    return false;
  },
  onTabletAndBelow: function onTabletAndBelow(state) {
    var windowsWidth = state.windowsWidth;

    if (windowsWidth <= 1024) {
      return true;
    }
    return false;
  },
  globalSMSactive: function globalSMSactive(state) {
    return state.globalSMSactive;
  },
  tabs: function tabs() {
    var tabs = [{
      name: '',
      items: [{
        title: 'Upload',
        id: 'upload',
        icon: __webpack_require__(1477),
        path: 'upload/album',
        directPath: true,
        allowedUser: ['artist', 'brand']
      },
      // {
      //   title: 'Memberships',
      //   id: 'membership',
      //   icon: require('@/assets/menu/member-icon.svg'),
      //   path: 'Membership',
      //   allowedUser: ['artist', 'brand'],
      // },
      {
        title: 'Analytics',
        id: 'analytics',
        icon: __webpack_require__(1476),
        path: 'Dashboard',
        allowedUser: ['artist', 'brand']
      },
      // {
      //   title: 'Sales',
      //   id: 'sales',
      //   icon: require('@/assets/menu/analytics-icon.svg'),
      //   path: 'Sell',
      //   allowedUser: ['artist'],
      // },
      {
        title: 'Payments',
        id: 'payment',
        icon: __webpack_require__(1475),
        path: 'PaymentIndex'
      }, {
        title: 'Account',
        id: 'account',
        icon: __webpack_require__(1478),
        path: 'UserSettings'
      }]
    }];
    return tabs;
  },
  accordions: function accordions() {
    var accordions = [{
      title: 'How much does it cost?',
      content: 'Lorem ipsum dolor sit amet consectetur adipisicing elit'
    }, {
      title: 'How often do I pay for my repost price?',
      content: 'Lorem ipsum dolor sit amet consectetur adipisicing elit'
    }, {
      title: 'Can I change my price any time?',
      content: 'Lorem ipsum dolor sit amet consectetur adipisicing elit'
    }, {
      title: 'How many followers should I have?',
      content: 'Lorem ipsum dolor sit amet consectetur adipisicing elit'
    }, {
      title: 'How long do my accepted reposts last for?',
      content: 'Lorem ipsum dolor sit amet consectetur adipisicing elit'
    }, {
      title: 'How much should I charge?',
      content: 'Lorem ipsum dolor sit amet consectetur adipisicing elit'
    }];

    return accordions;
  },
  disabledLiveVideo: function disabledLiveVideo(state) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(state.settings, 'disable_live_video', false);
  },
  disabledVerification: function disabledVerification(state) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(state.settings, 'disable_verification', false);
  },
  digitalCategoryIds: function digitalCategoryIds(state) {
    // return _.chain(state.product_categories).find((c) => (c.name === 'Digital Product')).get('id', null).value()
    return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.chain(state.product_categories).filter(function (c) {
      return c.is_digital;
    }).map('id').value();
  },
  reminderTracksCount: function reminderTracksCount(state) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(state.settings, 'reminder_tracks_count', 5);
  },
  onboardingStages: function onboardingStages(state, getters) {
    if (state.onboarding.accountCategory === 'listener') {
      return getters.onboardingListenerStages;
    } else if (state.onboarding.accountCategory === 'creator') {
      return getters.onboardingCreatorStages;
    } else {
      return [{
        title: 'What are you?',
        stage: 1
      }];
    }
  },
  onboardingListenerStages: function onboardingListenerStages() {
    var stages = [{
      title: 'What are you?',
      stage: 1
    }, {
      title: 'Listener',
      stage: 2
    }, {
      title: 'Profile image',
      stage: 3
    }, {
      title: 'Account info',
      stage: 4
    }, {
      title: 'Age & location',
      stage: 5
    }, {
      // title: 'Let\'s get verified',
      title: 'Social media',
      stage: 6
    }, {
      title: 'Check your email',
      stage: 7,
      hideStagerBar: true
    }];
    return stages;
  },
  onboardingCreatorStages: function onboardingCreatorStages() {
    var stages = [{
      title: 'What are you?',
      stage: 1
    }, {
      title: 'Artist or brand?',
      stage: 2
    }, {
      title: 'Profile image',
      stage: 3
    }, {
      title: 'Account info',
      stage: 4
    }, {
      title: 'Age & location',
      stage: 5
    }, {
      // title: 'Let\'s get verified',
      title: 'Social media',
      stage: 6
    }, {
      title: 'Check your email',
      stage: 7,
      hideStagerBar: true
    }, {
      title: 'Plans',
      stage: 8,
      hideStagerBar: true
    }];
    return stages;
  },
  onboardingCurrentStage: function onboardingCurrentStage(state, getters) {
    var current = getters.onboardingStages.find(function (stage) {
      return stage.stage === state.onboarding.current;
    }) || {};

    return current;
  },

  activationStages: function activationStages(state, getters) {
    if (state.activation.accountCategory === 'listener') {
      return getters.activationListenerStages;
    } else if (state.activation.accountCategory === 'creator') {
      return getters.activationCreatorStages;
    } else {
      return [{
        title: 'Your account is activated!',
        stage: 1
      }];
    }
  },
  activationListenerStages: function activationListenerStages() {
    var stages = [{
      title: 'Profile Image',
      stage: 2
    }, {
      title: 'Account Info',
      stage: 3
    }, {
      title: 'Age & Location',
      stage: 4
    }, {
      title: 'Check Email',
      stage: 5
    }];
    return stages;
  },
  activationCreatorStages: function activationCreatorStages() {
    var stages = [{
      stage: 1,
      title: 'Your account is activated!',
      subtitle: 'Lets get you familiar <br /> with YouSound',
      color: '#F3452E',
      cta1: {
        title: 'Let\'s go!',
        action: 'next',
        color: '#000000'
      },
      cta2: {
        title: 'Skip',
        action: 'Dashboard',
        color: 'transparent'
      },
      image: __webpack_require__(1433)
    }, {
      stage: 2,
      title: 'What is <br> YouSound?',
      subtitle: 'YouSound is a platform for artists & brands to easily share their content, build community & make a livable income',
      color: '#3971DE',
      image: __webpack_require__(1434)
    }, {
      stage: 3,
      title: 'Upload all of your content',
      subtitle: 'YouSound is powered by verified creators that can upload all of their music, videos, products & broadcast live.',
      color: '#BF9D45',
      image: __webpack_require__(1435)
    }, {
      stage: 4,
      title: 'User-centric streaming',
      subtitle: '<b>10k</b> combined streams from <b>5,000</b> users on other platforms earns <b class="highlight">$25</b>. On YouSound 10 creators can earn <b class="highlight">$2,500</b> per month.',
      color: '#323343',
      image: __webpack_require__(1436)
    }, {
      stage: 5,
      title: 'Connect direct <br /> with SMS text',
      subtitle: 'When people follow you they can opt-in to get SMS texts. Bypass the algorithms & contact your valued supporters directly.',
      color: '#474CB5',
      image: __webpack_require__(1437)
    }, {
      stage: 6,
      title: 'Get paid <br /> to share',
      subtitle: 'You can send & receive direct messages requesting to share content.  Subscribers can set their price to earn money.',
      color: '#439846',
      image: __webpack_require__(1438)
    }, {
      stage: 7,
      title: 'Join the <br /> creative revival',
      subtitle: 'Tell your fans to subscribe & make sure you choose a plan to unlock all of the PRO features',
      color: '#D8EDF0',
      cta1: {
        title: 'Choose subscription',
        action: '',
        color: '#FF472E'
      },
      cta2: {
        title: 'Not yet, take me to the app',
        action: '',
        color: '#FF472E'
      },
      image: __webpack_require__(1439),
      isDark: true
    }];
    return stages;
  },
  activationCurrentStage: function activationCurrentStage(state, getters) {
    var current = getters.activationStages.find(function (stage) {
      return stage.stage === state.activation.current;
    }) || {};

    return current;
  }
};

var actions = {
  toggleGlobalSMS: function toggleGlobalSMS(_ref, status) {
    var commit = _ref.commit;

    commit('toggleGlobalSMS', status);
  },
  toggleActivityPopup: function toggleActivityPopup(_ref2, status) {
    var commit = _ref2.commit;

    commit('toggleActivityPopup', status);
  },
  setSettings: function setSettings(_ref3, settings) {
    var commit = _ref3.commit;

    commit('setSettings', settings);
  },
  setGenres: function setGenres(_ref4, genres) {
    var commit = _ref4.commit;

    commit('setGenres', genres);
  },
  setProductCategories: function setProductCategories(_ref5, categories) {
    var commit = _ref5.commit;

    commit('setProductCategories', categories);
  },
  setPublicRelationsUser: function setPublicRelationsUser(_ref6, user) {
    var commit = _ref6.commit;

    commit('setPublicRelationsUser', user);
  },
  toggleSideBarMini: function toggleSideBarMini(_ref7, status) {
    var commit = _ref7.commit;

    commit('toggleSideBarMini', status);
  },
  getCountries: function getCountries(_ref8, data) {
    var commit = _ref8.commit;

    return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get("https://countriesnow.space/api/v0.1/countries").then(function (response) {
      return commit('setCountries', response.data.data);
    }).catch(function (err) {
      return err;
    });
  },
  getCities: function getCities(context, country) {
    var getCountry = context.state.countries.find(function (c) {
      return c.country === country;
    });
    context.commit('setCities', getCountry.cities);
  },
  nextOnboardingStage: function nextOnboardingStage(_ref9, stage) {
    var commit = _ref9.commit;

    commit('gotoNextOnboarding', stage);
  },
  prevOnboardingStage: function prevOnboardingStage(_ref10, stage) {
    var commit = _ref10.commit;

    commit('gotoPrevOnboarding', stage);
  },
  nextActivationStage: function nextActivationStage(_ref11, stage) {
    var commit = _ref11.commit;

    commit('gotoNextActivation', stage);
  },
  prevActivationStage: function prevActivationStage(_ref12, stage) {
    var commit = _ref12.commit;

    commit('gotoPrevActivation', stage);
  },
  setWindowsWidth: function setWindowsWidth(_ref13, width) {
    var commit = _ref13.commit;

    commit('setWindowsWidth', width);
  }
};

var mutations = {
  setSettings: function setSettings(state, settings) {
    state.settings = settings;
  },
  setGenres: function setGenres(state, genres) {
    state.genres = genres;
  },
  setProductCategories: function setProductCategories(state, categories) {
    state.product_categories = categories;
  },
  setPublicRelationsUser: function setPublicRelationsUser(state, user) {
    state.public_relations_user = user;
  },
  toggleSideBarMini: function toggleSideBarMini(state, status) {
    state.sideBarMini = status;
  },
  setCountries: function setCountries(state, data) {
    state.countries = data;
  },
  setCities: function setCities(state, data) {
    state.cities = data;
  },
  gotoNextOnboarding: function gotoNextOnboarding(state, stage) {
    state.onboarding.current = stage;
  },
  gotoPrevOnboarding: function gotoPrevOnboarding(state, stage) {
    state.onboarding.current = stage;
  },
  updateOnboarding: function updateOnboarding(state, options) {
    var optionKeys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(options);

    // find in onboarding, keys that are being updated
    for (var i = 0; i < optionKeys.length; i++) {
      var element = optionKeys[i];

      if (Object.hasOwnProperty.call(state.onboarding, element)) {
        state.onboarding[element] = options[element];
      }
    }
  },
  gotoNextActivation: function gotoNextActivation(state, stage) {
    state.activation.current = stage;
  },
  gotoPrevActivation: function gotoPrevActivation(state, stage) {
    state.activation.current = stage;
  },
  updateActivation: function updateActivation(state, options) {
    var optionKeys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(options);

    // find in activation, keys that are being updated
    for (var i = 0; i < optionKeys.length; i++) {
      var element = optionKeys[i];

      if (Object.hasOwnProperty.call(state.activation, element)) {
        state.activation[element] = options[element];
      }
    }
    console.log(state.activation);
  },
  toggleGlobalSMS: function toggleGlobalSMS(state, status) {
    state.globalSMSactive = status;
  },
  toggleActivityPopup: function toggleActivityPopup(state, status) {
    state.toggleActivity = status;
  },
  setWindowsWidth: function setWindowsWidth(state, width) {
    state.windowsWidth = width;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  strict: "production" !== 'production',
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

var state = {
  mobileHeaderOptions: {
    hideUser: false,
    showMenu: '',
    leftAltIcon: '',
    rightAltIcon: '/static/images/graph-bar.svg',
    centerImg: '/static/images/nav_logo_primary.png',
    menuImg: '',
    closeCallBack: {}
  },
  mobileFooterOptions: {
    showFooter: true
  },
  albumPrevRoute: '' || 'AlbumIndex' // fallback,
};

var getters = {
  hideGoBackCTA: function hideGoBackCTA(state) {
    // pass route name
    return ['AlbumIndex'];
  }
};

var actions = {
  setMobileHeaderOptions: function setMobileHeaderOptions(_ref, options) {
    var commit = _ref.commit;

    commit('toggleMobileHeaderOptions', options);
  },
  setMobileFooterOptions: function setMobileFooterOptions(_ref2, options) {
    var commit = _ref2.commit;

    commit('toggleMobileFooterOptions', options);
  }
};

var mutations = {
  setAlbumPrevRoute: function setAlbumPrevRoute(state, route) {
    state.albumPrevRoute = route;
  },
  toggleMobileHeaderOptions: function toggleMobileHeaderOptions(state, options) {
    var optionKeys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(options);

    // find in mobileHeaderOptions, keys that are being updated
    for (var i = 0; i < optionKeys.length; i++) {
      var element = optionKeys[i];
      if (Object.hasOwnProperty.call(state.mobileHeaderOptions, element)) {
        state.mobileHeaderOptions[element] = options[element];
      }
    }
  },
  toggleMobileFooterOptions: function toggleMobileFooterOptions(state, options) {
    var optionKeys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(options);

    // find in mobileFooterHeaderOptions, keys that are being updated
    for (var i = 0; i < optionKeys.length; i++) {
      var element = optionKeys[i];
      if (Object.hasOwnProperty.call(state.mobileFooterOptions, element)) {
        state.mobileFooterOptions[element] = options[element];
      }
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  strict: "production" !== 'production',
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// import { Utils } from '@/helper'
// import * as types from '@/store/mutation-types'
// import AuthService from '@/services/auth'

var state = {
  // user: Utils.parseJSON(Storage.get('user')),
  secret_code: '',
  register_role: null,
  token: null,
  hmac: null,
  pendingUser: null,
  user: null,
  genreIds: '',
  firstVisit: false,
  redirectPath: ''
};

var getters = {
  isAuthenticated: function isAuthenticated(state) {
    return state.token != null;
  },
  userType: function userType(state) {
    return state.user && state.user.user_type;
  },
  currentUser: function currentUser(state) {
    return state.user;
  },
  redirectPath: function redirectPath(state) {
    return state.redirectPath;
  }
};

var actions = {
  setToken: function setToken(_ref, token) {
    var commit = _ref.commit;

    commit('setToken', token);
  },
  setHMAC: function setHMAC(_ref2, hmac) {
    var commit = _ref2.commit;

    commit('setHMAC', hmac);
  },
  setUser: function setUser(_ref3, user) {
    var commit = _ref3.commit;

    commit('setUser', user);
  },
  setStripeStatus: function setStripeStatus(_ref4, status) {
    var commit = _ref4.commit;

    commit('setStripeStatus', status);
  },
  setPendingUser: function setPendingUser(_ref5, user) {
    var commit = _ref5.commit;

    commit('setPendingUser', user);
  },
  setStream: function setStream(_ref6, stream) {
    var commit = _ref6.commit;

    commit('setStream', stream);
  },
  addFavoriteUser: function addFavoriteUser(_ref7, user) {
    var commit = _ref7.commit;

    commit('addFavoriteUser', user);
  },
  removeFavoriteUser: function removeFavoriteUser(_ref8, user) {
    var commit = _ref8.commit;

    commit('removeFavoriteUser', user);
  },
  setRegisterRole: function setRegisterRole(_ref9, role) {
    var commit = _ref9.commit;

    commit('setRegisterRole', role);
  },
  setSecretCode: function setSecretCode(_ref10, code) {
    var commit = _ref10.commit;

    commit('setSecretCode', code);
  },
  setGenreIds: function setGenreIds(_ref11, genreIds) {
    var commit = _ref11.commit;

    commit('setGenreIds', genreIds);
  },
  setFirstVisit: function setFirstVisit(_ref12, firstVisit) {
    var commit = _ref12.commit;

    commit('setFirstVisit', firstVisit);
  },
  setRedirectPath: function setRedirectPath(_ref13, path) {
    var commit = _ref13.commit;

    commit('setRedirectPath', path);
  }
};

var mutations = {
  setToken: function setToken(state, token) {
    state.token = token;
  },
  setHMAC: function setHMAC(state, hmac) {
    state.hmac = hmac;
  },
  setUser: function setUser(state, user) {
    // console.log('setUser', user)
    state.user = user;
  },
  setPendingUser: function setPendingUser(state, user) {
    state.pendingUser = user;
  },
  setStream: function setStream(state, stream) {
    state.user.stream = stream;
  },
  setStripeStatus: function setStripeStatus(state, status) {
    state.user.stripe_connected = status;
  },
  addFavoriteUser: function addFavoriteUser(state, user) {
    state.user.favorite_users.push(user);
  },
  removeFavoriteUser: function removeFavoriteUser(state, user) {
    for (var index in state.user.favorite_users) {
      if (user.id === state.user.favorite_users[index].id) {
        state.user.favorite_users.splice(index, 1);
        break;
      }
    }
  },
  setRegisterRole: function setRegisterRole(state, role) {
    state.register_role = role;
  },
  setSecretCode: function setSecretCode(state, code) {
    state.secret_code = code;
  },
  setGenreIds: function setGenreIds(state, genreIds) {
    state.genreIds = genreIds;
  },
  setFirstVisit: function setFirstVisit(state, firstVisit) {
    state.firstVisit = firstVisit;
  },
  setRedirectPath: function setRedirectPath(state, path) {
    state.redirectPath = path;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  strict: "production" !== 'production',
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_search__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_stream__ = __webpack_require__(18);


// import { Utils } from '@/helper'
// import * as types from '@/store/mutation-types'




var state = {
  // user: Utils.parseJSON(Storage.get('user')),
  feeds: [],
  products: [],
  mobileMusicFeed: {
    recommended: [],
    new: [],
    popular: []
  },
  mobileVideoFeed: {
    recommended: [],
    new: [],
    popular: []
  },
  mobileProductFeed: {
    allProducts: [], // temp
    recommended: [],
    new: [],
    popular: []
  }
};

var getters = {};

var actions = {
  getMobileMusicFeed: function getMobileMusicFeed(_ref, params) {
    var _this = this;

    var commit = _ref.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_3__services_search__["a" /* default */].searchDiscover(params).then(function (response) {
                return commit('setMobileMusicFeed', { albums: response.body.albums, filter: params.filter });
              });

            case 2:
              return _context.abrupt('return', _context.sent);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getMobileVideoFeed: function getMobileVideoFeed(_ref2, params) {
    var _this2 = this;

    var commit = _ref2.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_4__services_stream__["a" /* default */].getStreams(params).then(function (response) {
                return commit('setMobileVideoFeed', { videos: response.body.streams, filter: params.filter });
              });

            case 2:
              return _context2.abrupt('return', _context2.sent);

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  getMobileProductFeed: function getMobileProductFeed(_ref3, params) {
    var _this3 = this;

    var commit = _ref3.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_3__services_search__["a" /* default */].searchDiscover(params).then(function (response) {
                commit('setMobileProductFeed', { products: response.body.products, filter: params.category, categories: response.body.categories });
              });

            case 2:
              return _context3.abrupt('return', _context3.sent);

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  setFeeds: function setFeeds(_ref4, feeds) {
    var commit = _ref4.commit;

    commit('setFeeds', feeds);
  },
  setProducts: function setProducts(_ref5, products) {
    var commit = _ref5.commit;

    commit('setProducts', products);
  }
};

var mutations = {
  setMobileMusicFeed: function setMobileMusicFeed(state, feed) {
    var filter = feed.filter;
    var albums = feed.albums;


    state.mobileMusicFeed[filter] = albums;
  },
  setMobileVideoFeed: function setMobileVideoFeed(state, feed) {
    var filter = feed.filter;
    var videos = feed.videos;


    state.mobileVideoFeed[filter] = videos;
  },
  setMobileProductFeed: function setMobileProductFeed(state, feed) {
    // const { filter } = feed
    var products = feed.products;
    var categories = feed.categories;


    var arrCategories = categories.map(function (c) {
      return { id: c, name: c };
    });
    state.mobileProductFeed.categories = [{ id: 'any', name: 'All' }].concat(arrCategories);
    state.mobileProductFeed.allProducts = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqBy(products, 'id'); // temp
    // state.mobileProductFeed[filter] = _.uniqBy(products, 'id')

    // console.log({feed});
    // console.log({stateProduct: state.mobileProductFeed});
  },
  setFeeds: function setFeeds(state, feeds) {
    state.feeds = feeds;
  },
  setProducts: function setProducts(state, products) {
    state.products = products;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  strict: "production" !== 'production',
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  progressBar: {
    hasValue: false,
    visibility: false,
    value: -1
  },
  isLoading: false,
  progressValue: 0,
  showError: false,
  color: 'error',
  timeout: 3000,
  errors: ['']
};

var getters = {
  isLoading: function isLoading(state) {
    return state.progressBar.visibility;
  }
};

var actions = {
  showLoadingActivity: function showLoadingActivity(_ref, show) {
    var commit = _ref.commit;

    commit('setProgressBarVisibility', show);
  },
  setProgressBarValue: function setProgressBarValue(_ref2, value) {
    var commit = _ref2.commit;

    commit('setProgressBarValue', value);
  },
  showErrorToast: function showErrorToast(_ref3, errors) {
    var commit = _ref3.commit;

    commit('showErrorToast', errors);
  },
  showSuccessToast: function showSuccessToast(_ref4, errors) {
    var commit = _ref4.commit;

    commit('showSuccessToast', errors);
  },
  hideToast: function hideToast(_ref5) {
    var commit = _ref5.commit;

    commit('hideToast');
  },
  setTimeOut: function setTimeOut(_ref6, timeout) {
    var commit = _ref6.commit;

    commit('setTimeOut', timeout);
  },
  removeAll: function removeAll(_ref7) {
    var commit = _ref7.commit;

    commit('removeAll');
  }
};

var mutations = {
  setProgressBarVisibility: function setProgressBarVisibility(state, show) {
    state.progressBar.value = -1;
    state.progressBar.visibility = show;
  },
  setProgressBarValue: function setProgressBarValue(state, value) {
    state.progressBar.value = value;
  },
  showErrorToast: function showErrorToast(state, errors) {
    state.errors = errors;
    state.showError = true;
    state.color = 'error-dark';
  },
  showSuccessToast: function showSuccessToast(state, errors) {
    state.errors = errors;
    state.showError = true;
    state.color = 'success-dark';
  },
  hideToast: function hideToast(state) {
    state.showError = false;
  },
  setTimeOut: function setTimeOut(state, timeout) {
    state.timeout = timeout;
  },
  removeAll: function removeAll(state) {
    state.errors = [''];
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// import { Utils } from '@/helper'
// import * as types from '@/store/mutation-types'
// import GenreService from '@/services/genre'

var state = {
  genres: []
};

var getters = {};

var actions = {
  // getGenres: (state) => {
  //   if (state.genres && state.genres.length > 0) {
  //     return state.genres
  //   } else {
  //     GenreService.getGenres().then(response => {
  //       state.genres = response.body
  //       return state.genres
  //     })
  //     .catch(e => {
  //       console.log(e)
  //       return state.genres
  //     })
  //   }
  // },

  setGenres: function setGenres(_ref, genres) {
    var commit = _ref.commit;

    commit('setGenres', genres);
  }
};

var mutations = {
  setGenres: function setGenres(state, genres) {
    state.genres = genres;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  strict: "production" !== 'production',
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);


function initialState() {
  return {
    genres: []
  };
}

var state = initialState;

var getters = {
  genre: function genre(state) {
    return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(state.genres, '[0]', { id: '', name: '' });
  }
};

var actions = {
  setGenres: function setGenres(_ref, genres) {
    var commit = _ref.commit;

    commit('setGenres', genres);
  }
};

var mutations = {
  setGenres: function setGenres(state, genres) {
    state.genres = genres;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  strict: "production" !== 'production',
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);


var state = {
  // user: Utils.parseJSON(Storage.get('user')),
  current: {
    page: '',
    tab: '',
    action: '',
    params: {}
  },
  history: []
};

var getters = {
  last: function last(state) {
    var lastState = state.history[state.history.length - 1];
    if (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isEmpty(lastState)) {
      return { page: '', tab: '', action: '' };
    }
    return lastState;
  },

  hasHeader: function hasHeader(state) {
    return ['login', 'register', 'register_by_listener', 'landing', 'terms', ''].indexOf(state.current.page) === -1;
  },

  hasNoSidebar: function hasNoSidebar(state) {
    // pass route name
    return ['Home', 'Creators', 'AdFree', 'Login', 'Register', 'ForgotPassword', 'Confirmation', 'TermsPage', 'NotFound'];
  },
  hasNoMobileHeader: function hasNoMobileHeader(state) {
    // pass route name
    return ['Home', 'Creators', 'AdFree', 'TermsPage'];
  },
  hasFooter: function hasFooter(state) {
    return ['landing'].indexOf(state.current.page) === -1;
  },
  // New implementation
  hasNoFooter: function hasNoFooter(state) {
    // pass route name
    return ['NotificationIndex', 'Register', 'Login', 'Confirmation', 'ForgotPassword'];
  },

  hasAudioPlayer: function hasAudioPlayer(state) {
    return ['settings', ''].indexOf(state.current.page) === -1;
  },

  isHeaderFixed: function isHeaderFixed(state) {
    // return ['main_landing'].indexOf(state.current.page) > -1
    return true;
  },

  isPrimaryTheme: function isPrimaryTheme(state) {
    return ['music', 'profile-slider'].indexOf(state.current.page) > -1;
  },

  isGrayTheme: function isGrayTheme(state) {
    return ['upload', 'product', 'profile'].indexOf(state.current.page) > -1;
  },

  isNormalTheme: function isNormalTheme(state) {
    return ['album/show', 'playlist'].indexOf(state.current.page) > -1;
  }
};

var actions = {
  setCurrentState: function setCurrentState(_ref, current) {
    var commit = _ref.commit;

    commit('setCurrentState', current);
  },
  setParams: function setParams(_ref2, params) {
    var commit = _ref2.commit;

    commit('setParams', params);
  },
  goNextState: function goNextState(_ref3, next) {
    var commit = _ref3.commit;

    if (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isEqual(state.current, next) === false) {
      commit('pushToHistory');
      commit('setCurrentState', next);
    }
  }
};

var mutations = {
  setCurrentState: function setCurrentState(state, current) {
    state.current = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.assignIn({ page: '', tab: '', action: '' }, current);
  },
  setParams: function setParams(state, params) {
    state.current.params = params;
  },
  pushToHistory: function pushToHistory(state) {
    if (state.current.page !== '') {
      state.history.push(state.current);
      if (state.history.length > 100) {
        state.history = state.history.slice(1);
      }
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  strict: "production" !== 'production',
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// import { Utils } from '@/helper'
// import * as types from '@/store/mutation-types'

var state = {
  // user: Utils.parseJSON(Storage.get('user')),
  orders: [],
  tab: null
};

var getters = {};

var actions = {
  setOrders: function setOrders(_ref, orders) {
    var commit = _ref.commit;

    commit('setOrders', orders);
  },
  removeOrder: function removeOrder(_ref2, index) {
    var commit = _ref2.commit;

    commit('removeOrder', index);
  },
  removeAllOrders: function removeAllOrders(_ref3) {
    var commit = _ref3.commit;

    commit('removeAllOrders');
  },
  setTab: function setTab(_ref4, tab) {
    var commit = _ref4.commit;

    commit('setTab', tab);
  }
};

var mutations = {
  setOrders: function setOrders(state, orders) {
    state.orders = orders;
  },
  removeOrder: function removeOrder(state, index) {
    state.orders.splice(index, 1);
  },
  removeAllOrders: function removeAllOrders(state) {
    state.orders = [];
  },
  setTab: function setTab(state, tab) {
    state.tab = tab;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  strict: "production" !== 'production',
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// import { Utils } from '@/helper'
// import * as types from '@/store/mutation-types'
// import AuthService from '@/services/auth'

var state = {
  // user: Utils.parseJSON(Storage.get('user')),
  /* whether sound track loaded */
  isPlaying: false,
  isPaused: false,
  isShuffle: false,
  list: [],
  tracks: [],
  listIndex: -1,
  trackIndex: -1,
  currentTrackPlaying: {},
  progressiveTrack: {},
  gridShow: false,
  user: null,
  isMobilePlayerActive: false
};

var getters = {
  isPlaying: function isPlaying(state) {
    return state.isPlaying;
  },

  currentAlbum: function currentAlbum(state) {
    if (!state.list || state.listIndex < 0 || !state.list[state.listIndex]) {
      return null;
    }

    if (state.list[state.listIndex].assoc_type) {
      return state.list[state.listIndex].assoc_type;
    } else {
      return state.list[state.listIndex];
    }
  }
};

var actions = {
  setPlayingStatus: function setPlayingStatus(_ref, isPlaying) {
    var commit = _ref.commit;

    commit('setPlayingStatus', isPlaying);
  },
  setPauseStatus: function setPauseStatus(_ref2, isPaused) {
    var commit = _ref2.commit;

    commit('setPauseStatus', isPaused);
  },
  setShuffleStatus: function setShuffleStatus(_ref3, isShuffle) {
    var commit = _ref3.commit;

    commit('setShuffleStatus', isShuffle);
  },
  setPlaylist: function setPlaylist(_ref4, list) {
    var commit = _ref4.commit;

    commit('setPlaylist', list);
  },
  setTracks: function setTracks(_ref5, tracks) {
    var commit = _ref5.commit;

    commit('setTracks', tracks);
  },
  setListIndex: function setListIndex(_ref6, listIndex) {
    var commit = _ref6.commit;

    commit('setListIndex', listIndex);
  },
  updateFollowingStatus: function updateFollowingStatus(_ref7, status) {
    var commit = _ref7.commit;

    commit('updateFollowingStatus', status);
  },
  setTrackIndex: function setTrackIndex(_ref8, trackIndex) {
    var commit = _ref8.commit;

    // console.log('player action setTrackIndex', trackIndex)
    commit('setTrackIndex', trackIndex);
  },
  setCurrentPlayingTrack: function setCurrentPlayingTrack(_ref9, currentTrackPlaying) {
    var commit = _ref9.commit;

    console.log('current track', currentTrackPlaying);
    commit('setCurrentPlayingTrack', currentTrackPlaying);
  },
  setProgressiveTrack: function setProgressiveTrack(_ref10, progressiveTrack) {
    var commit = _ref10.commit;

    commit('setProgressiveTrack', progressiveTrack);
  },
  setGridShow: function setGridShow(_ref11, gridShow) {
    var commit = _ref11.commit;

    commit('setGridShow', gridShow);
  },
  setUpdatedUser: function setUpdatedUser(_ref12, user) {
    var commit = _ref12.commit;

    commit('setUpdatedUser', user);
  },
  toggleMobilePlayer: function toggleMobilePlayer(_ref13, status) {
    var commit = _ref13.commit;

    commit('toggleMobilePlayer', status);
  }
};

var mutations = {
  setPlayingStatus: function setPlayingStatus(state, isPlaying) {
    state.isPlaying = isPlaying;
  },
  setPauseStatus: function setPauseStatus(state, isPaused) {
    state.isPaused = isPaused;
  },
  setShuffleStatus: function setShuffleStatus(state, isShuffle) {
    state.isShuffle = isShuffle;
  },
  setPlaylist: function setPlaylist(state, list) {
    state.list = list;
  },
  setTracks: function setTracks(state, tracks) {
    state.tracks = tracks;
  },
  setListIndex: function setListIndex(state, listIndex) {
    state.listIndex = listIndex;
    // if (listIndex >= state.list.length) {
    //   state.listIndex = 0
    // } else {
    //   state.listIndex = listIndex
    // }
  },
  updateFollowingStatus: function updateFollowingStatus(state, status) {
    if (state.list[state.listIndex]) {
      if (state.list[state.listIndex].assoc_type) {
        state.list[state.listIndex].assoc.publisher.is_following = status;
      } else {
        state.list[state.listIndex].user.is_following = status;
      }
    }
  },
  setTrackIndex: function setTrackIndex(state, trackIndex) {
    state.trackIndex = trackIndex;
    // if (trackIndex >= state.tracks.length) {
    //   state.trackIndex = 0
    // } else {
    //   state.trackIndex = trackIndex
    // }
  },
  setCurrentPlayingTrack: function setCurrentPlayingTrack(state, currentTrackPlaying) {
    state.currentTrackPlaying = currentTrackPlaying;
  },
  setProgressiveTrack: function setProgressiveTrack(state, progressiveTrack) {
    state.progressiveTrack = progressiveTrack;
  },
  setGridShow: function setGridShow(state, gridShow) {
    state.gridShow = gridShow;
  },
  setUpdatedUser: function setUpdatedUser(state, user) {
    state.user = user;
  },
  toggleMobilePlayer: function toggleMobilePlayer(state, status) {
    console.log('toggleMobilePlayer status', status);
    state.isMobilePlayerActive = status;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  strict: "production" !== 'production',
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// import { Utils } from '@/helper'
// import * as types from '@/store/mutation-types'

var state = {
  playlists: []
};

var getters = {};

var actions = {
  setPlaylists: function setPlaylists(_ref, playlists) {
    var commit = _ref.commit;

    commit('setPlaylists', playlists);
  }
};

var mutations = {
  setPlaylists: function setPlaylists(state, playlists) {
    state.playlists = playlists;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  strict: "production" !== 'production',
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// import { Utils } from '@/helper'
// import * as types from '@/store/mutation-types'

var state = {
  // user: Utils.parseJSON(Storage.get('user')),
  products: []
};

var getters = {};

var actions = {
  setProducts: function setProducts(_ref, products) {
    var commit = _ref.commit;

    commit('setProducts', products);
  },
  removeProduct: function removeProduct(_ref2, index) {
    var commit = _ref2.commit;

    commit('removeProduct', index);
  },
  removeAllProducts: function removeAllProducts(_ref3) {
    var commit = _ref3.commit;

    commit('removeAllProducts');
  }
};

var mutations = {
  setProducts: function setProducts(state, products) {
    state.products = products;
  },
  removeProduct: function removeProduct(state, index) {
    state.products.splice(index, 1);
  },
  removeAllProducts: function removeAllProducts(state) {
    state.products = [];
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  strict: "production" !== 'production',
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);



function initialState() {
  return {
    stream: null,
    play_mode: 'stopped', // 'stopped', 'playing', 'paused'
    frame_mode: 'minimized', // 'full', 'normal', 'minimized'
    status: 'inactive',
    nodeDetails: {},
    pipMode: false
  };
}

var state = initialState;

var getters = {
  isInitialized: function isInitialized(state) {
    return state.status !== 'inactive';
  },

  isPlaying: function isPlaying(state) {
    return state.play_mode === 'playing';
  },

  hasFrame: function hasFrame(state) {
    // return state.status !== 'inactive' && state.frame_mode !== 'minimized'
    return state.frame_mode !== 'minimized';
  }
};

var actions = {
  // setUser ({ commit }, user) {
  //   commit('setUser', user)
  // },

  updateFollowingStatus: function updateFollowingStatus(_ref, status) {
    var commit = _ref.commit;

    commit('updateFollowingStatus', status);
  },
  setStream: function setStream(_ref2, stream) {
    var commit = _ref2.commit;

    commit('setStream', stream);
  },
  updateStreamAssoc: function updateStreamAssoc(_ref3, info) {
    var commit = _ref3.commit;

    commit('updateStreamAssoc', info);
  },
  setStats: function setStats(_ref4, stats) {
    var commit = _ref4.commit;

    console.log('setStats', stats);
    commit('setStats', stats);
  },
  addStats: function addStats(_ref5, stats) {
    var commit = _ref5.commit;

    commit('addStats', stats);
  },
  setPlayMode: function setPlayMode(_ref6, playMode) {
    var commit = _ref6.commit;

    commit('setPlayMode', playMode);
  },
  setFrameMode: function setFrameMode(_ref7, frameMode) {
    var commit = _ref7.commit;

    console.log('setFrameMode', frameMode);
    commit('setFrameMode', frameMode);
  },
  setStatus: function setStatus(_ref8, status) {
    var commit = _ref8.commit;

    commit('setStatus', status);
  },
  setPipParentNode: function setPipParentNode(_ref9, node) {
    var commit = _ref9.commit;

    commit('setPipParentNode', node);
  },
  setPipPipMode: function setPipPipMode(_ref10, node) {
    var commit = _ref10.commit;

    commit('setPipPipMode', node);
  }
};

var mutations = {
  // setUser (state, user) {
  //   state.user = _.cloneDeep(user)
  // },

  updateFollowingStatus: function updateFollowingStatus(state, status) {
    if (state.stream.user) {
      state.stream.user.is_following = status;
    }
  },
  setStream: function setStream(state, stream) {
    // state.stream = _.cloneDeep(stream)
    state.stream = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.assignIn({
      stats: {
        views_size: 0,
        downloads_size: 0,
        carts_size: 0,
        followed_size: 0
      }
    }, stream);
  },
  repostStream: function repostStream(state) {
    state.stream.is_reposted = true;
  },
  updateStreamAssoc: function updateStreamAssoc(state, info) {
    state.stream.assoc_type = info.assoc_type;
    state.stream.assoc = info.assoc;
  },
  setStats: function setStats(state, stats) {
    state.stream.stats = stats;
  },
  addStats: function addStats(state, stats) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(stats).forEach(function (key) {
      state.stream.stats[key] += stats[key];
    });
  },
  setPlayMode: function setPlayMode(state, playMode) {
    state.play_mode = playMode;
  },
  setFrameMode: function setFrameMode(state, frameMode) {
    // console.log('setFrameMode', frameMode)
    state.frame_mode = frameMode;
  },
  setStatus: function setStatus(state, status) {
    state.status = status;
  },
  reset: function reset(state) {
    console.log('stream_player reset state');
    var s = initialState();
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(s).forEach(function (key) {
      state[key] = s[key];
    });
  },
  setPipParentNode: function setPipParentNode(state, nodeDetails) {
    console.log('pip dom toggle');
    console.log('Store nodeDetails:--- ', nodeDetails);

    state.nodeDetails = nodeDetails;
  },
  setPipPipMode: function setPipPipMode(state, status) {
    console.log('pip:', status);
    state.pipMode = status;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  strict: "production" !== 'production',
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// import { Utils } from '@/helper'
// import * as types from '@/store/mutation-types'

var state = {
  // user: Utils.parseJSON(Storage.get('user')),
  tracks: [],
  isUploadingTracks: false
};

var getters = {};

var actions = {
  setUploadingStatus: function setUploadingStatus(_ref, status) {
    var commit = _ref.commit;

    commit('setUploadingStatus', status);
  },
  pushTrack: function pushTrack(_ref2, track) {
    var commit = _ref2.commit;

    commit('pushTrack', track);
  },
  popTrack: function popTrack(_ref3, index) {
    var commit = _ref3.commit;

    commit('popTrack', index);
  },
  clearTracks: function clearTracks(_ref4) {
    var commit = _ref4.commit;

    commit('clearTracks');
  }
};

var mutations = {
  setUploadingStatus: function setUploadingStatus(state, status) {
    state.isUploadingTracks = status;
  },
  pushTrack: function pushTrack(state, track) {
    state.tracks.push(track);
  },
  clearTracks: function clearTracks(state) {
    state.tracks = [];
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  strict: "production" !== 'production',
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_search__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_stream__ = __webpack_require__(18);





var state = {
  albums: [],
  videos: [],
  products: []
};

var getters = {};

var actions = {
  getTrendingMusic: function getTrendingMusic(_ref, params) {
    var _this = this;

    var commit = _ref.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2__services_search__["a" /* default */].searchDiscoverPublicUser(params).then(function (response) {
                return commit('setTrendingMusic', response.body.albums);
              });

            case 2:
              return _context.abrupt('return', _context.sent);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getTrendingVideos: function getTrendingVideos(_ref2, params) {
    var _this2 = this;

    var commit = _ref2.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_3__services_stream__["a" /* default */].getStreamsPublicUsers(params).then(function (response) {
                return commit('setTrendingVideos', response.body.streams);
              });

            case 2:
              return _context2.abrupt('return', _context2.sent);

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  getTrendingProducts: function getTrendingProducts(_ref3, params) {
    var _this3 = this;

    var commit = _ref3.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2__services_search__["a" /* default */].searchDiscoverPublicUser(params).then(function (response) {
                return commit('setTrendingProducts', response.body.products);
              });

            case 2:
              return _context3.abrupt('return', _context3.sent);

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  }
};

var mutations = {
  setTrendingMusic: function setTrendingMusic(state, feed) {
    state.albums = feed;
  },
  setTrendingVideos: function setTrendingVideos(state, feed) {
    state.videos = feed;
  },
  setTrendingProducts: function setTrendingProducts(state, feed) {
    state.products = feed;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  strict: "production" !== 'production',
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  stripe: null,
  cartItems: []
};

var getters = {};

var actions = {
  setStripe: function setStripe(_ref, stripe) {
    var commit = _ref.commit;

    commit('setStripe', stripe);
  },
  setCartItems: function setCartItems(_ref2, cartItems) {
    var commit = _ref2.commit;

    commit('setCartItems', cartItems);
  }
};

var mutations = {
  setStripe: function setStripe(state, stripe) {
    state.stripe = stripe;
  },
  setCartItems: function setCartItems(state, cartItems) {
    state.cartItems = cartItems;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  strict: "production" !== 'production',
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_video_js__ = __webpack_require__(1566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_activity__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_auth__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_category__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_genre__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_setting__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_user__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_header__ = __webpack_require__(1577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_footer__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_earn_money__ = __webpack_require__(1576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_earn_money___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_earn_money__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_player__ = __webpack_require__(1591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_player___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_player__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_mobile_player__ = __webpack_require__(1586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_mobile_player___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_mobile_player__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_stream_player__ = __webpack_require__(1596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_stream_player___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_stream_player__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_login_dialog__ = __webpack_require__(1585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_login_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_login_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_sidebar__ = __webpack_require__(1594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_sidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_sidebar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_appLoader__ = __webpack_require__(1573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_appLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_appLoader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_SMS__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_SMS___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_SMS__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__helper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__views_mobile_components_header__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__views_mobile_components_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__views_mobile_components_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__views_mobile_components_footer__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__views_mobile_components_footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__views_mobile_components_footer__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

























var ActionCable = __webpack_require__(52);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',

  components: {
    appHeader: __WEBPACK_IMPORTED_MODULE_10__components_header___default.a,
    appFooter: __WEBPACK_IMPORTED_MODULE_11__components_footer___default.a,
    earnMoneySticker: __WEBPACK_IMPORTED_MODULE_12__components_earn_money___default.a,
    loginDialog: __WEBPACK_IMPORTED_MODULE_16__components_login_dialog___default.a,
    audioPlayer: __WEBPACK_IMPORTED_MODULE_13__components_player___default.a,
    mobilePlayer: __WEBPACK_IMPORTED_MODULE_14__components_mobile_player___default.a,
    streamPlayer: __WEBPACK_IMPORTED_MODULE_15__components_stream_player___default.a,
    Sidebar: __WEBPACK_IMPORTED_MODULE_17__components_sidebar___default.a,
    AppLoader: __WEBPACK_IMPORTED_MODULE_18__components_appLoader___default.a,
    mobileHeader: __WEBPACK_IMPORTED_MODULE_22__views_mobile_components_header___default.a,
    mobileFooter: __WEBPACK_IMPORTED_MODULE_23__views_mobile_components_footer___default.a,
    SMS: __WEBPACK_IMPORTED_MODULE_19__components_SMS___default.a
  },

  data: function data() {
    return {
      loadValue: null,
      direction: 'none',
      cable: null,
      notification_subscription: null,
      show_login_dialog: false
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21_vuex__["a" /* mapState */])({
    sideBarWidth: function sideBarWidth(state) {
      return state.app.sideBarWidth;
    },
    sideBarMini: function sideBarMini(state) {
      return state.app.sideBarMini;
    },
    mHeaderOp: function mHeaderOp(state) {
      return state.appMobile.mobileHeaderOptions;
    },
    mFooterOp: function mFooterOp(state) {
      return state.appMobile.mobileFooterOptions;
    },
    mobilePlayerActive: function mobilePlayerActive(state) {
      return state.player.isMobilePlayerActive;
    }
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21_vuex__["b" /* mapGetters */])({
    isAuthenticated: "auth/isAuthenticated",
    globalSMSactive: "app/globalSMSactive"
  }), {
    showSidebar: function showSidebar() {
      return !['Home', 'ForCreators', 'LoginPage', 'SignUpPage'].includes(this.$route.name);
    },
    noSidebar: function noSidebar() {
      return this.$route.meta.noSidebar;
    },
    noSideSpace: function noSideSpace() {
      return this.$route.meta.noSideSpace;
    },
    authPage: function authPage() {
      return this.$route.meta.authPage;
    },
    QRPage: function QRPage() {
      return this.$route.meta.QRPage;
    },
    welcomePage: function welcomePage() {
      return this.$route.meta.welcomePage;
    },
    bgLight: function bgLight() {
      return this.$route.meta.bgLight;
    },
    noPadding: function noPadding() {
      return this.$route.meta.noPadding;
    },
    noMargin: function noMargin() {
      return this.$route.meta.noMargin;
    },
    bgGrey: function bgGrey() {
      return this.$route.meta.bgGrey;
    },
    bgNaturalGrey: function bgNaturalGrey() {
      return this.$route.meta.bgNaturalGrey;
    },
    bgDark: function bgDark() {
      return this.$route.meta.bgDark;
    },
    bgBlack: function bgBlack() {
      return this.$route.meta.bgBlack;
    },
    onlyOnMobile: function onlyOnMobile() {
      return this.$route.meta.onlyOnMobile;
    },
    onMobile: function onMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    currentUser: function currentUser() {
      return this.$store.state.auth.user;
    },
    currentPage: function currentPage() {
      return this.$store.state.navigator.current.page;
    },

    showError: {
      get: function get() {
        return this.$store.state.error.showError;
      },
      set: function set(newValue) {
        this.$store.dispatch('error/hideToast');
      }
    },
    hideMobileHeader: function hideMobileHeader() {
      return this.$route.meta.hideMobileHeader;
    },
    wrapFullHeight: function wrapFullHeight() {
      return this.$route.meta.wrapFullHeight;
    }
  }),

  watch: {
    mobilePlayerActive: function mobilePlayerActive(val) {
      console.log('mobilePlayerActive: ', val);
    },
    $route: function $route(to, from) {
      var _this = this;

      this.initLoader();
      var parentNode = document.getElementById('myVideoPlayer');
      this.$nextTick(function () {
        return _this.watchPip(to, from, parentNode);
      });
      var toPath = to.path.split('/');
      var type = toPath[1];
      if (this.$store.state.auth.token) {
        if (type === 'activity' || type === 'feed') {
          __WEBPACK_IMPORTED_MODULE_4__services_activity__["a" /* default */].makeRead(type === 'feed' ? 'stream' : type).then(function (response) {
            __WEBPACK_IMPORTED_MODULE_4__services_activity__["a" /* default */].getUnread().then(function (response) {
              _this.$store.dispatch('activity/setBadge', response.body);
            });
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_4__services_activity__["a" /* default */].getUnread().then(function (response) {
            _this.$store.dispatch('activity/setBadge', response.body);
          });
        }
      }
      if (this.$store.state.app.toggleActivity) {
        this.$store.dispatch('app/toggleActivityPopup', false);
      }
    }
  },
  mounted: function mounted() {
    this.initLoader();
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
  },
  created: function created() {
    var _this2 = this;

    console.log('App created');
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.interceptors.push(function (req, next) {
      next(function (res) {
        if (res.url.startsWith("https://api.yousound.com") && res.status === 401) {
          __WEBPACK_IMPORTED_MODULE_5__services_auth__["a" /* default */].clearTokenAndUserInfo();
          _this2.$router.push({ path: '/' });
        }
      });
    });
    this.$root.$on(__WEBPACK_IMPORTED_MODULE_20__helper__["b" /* MyEvents */].AUTH_SIGNIN, this.doAfterSignIn);
    this.$root.$on(__WEBPACK_IMPORTED_MODULE_20__helper__["b" /* MyEvents */].AUTH_SIGNOUT, this.doAfterSignOut);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_8__services_setting__["a" /* default */].getSettings(), __WEBPACK_IMPORTED_MODULE_7__services_genre__["a" /* default */].getGenres2(), __WEBPACK_IMPORTED_MODULE_6__services_category__["a" /* default */].getCategories(), __WEBPACK_IMPORTED_MODULE_9__services_user__["a" /* default */].getUserInfo(__WEBPACK_IMPORTED_MODULE_20__helper__["c" /* PublicRelationsUsername */])]).then(function (values) {
      console.log('App initializing...');
      _this2.$store.dispatch('app/setSettings', values[0].body);
      _this2.$store.dispatch('app/setGenres', values[1].body);
      _this2.$store.dispatch('app/setProductCategories', values[2].body);
      _this2.$store.dispatch('app/setPublicRelationsUser', values[3].body);
    });
    if (__WEBPACK_IMPORTED_MODULE_5__services_auth__["a" /* default */].isAuthenticated()) {
      __WEBPACK_IMPORTED_MODULE_5__services_auth__["a" /* default */].checkTokenValidation().then(function (response) {
        if (response.body !== false) {
          __WEBPACK_IMPORTED_MODULE_5__services_auth__["a" /* default */].setUser(response.body);
          _this2.$root.$emit(__WEBPACK_IMPORTED_MODULE_20__helper__["b" /* MyEvents */].AUTH_SIGNIN);
        } else {
          __WEBPACK_IMPORTED_MODULE_5__services_auth__["a" /* default */].clearTokenAndUserInfo();
          _this2.$router.push({ path: '/login' });
        }
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (typeof window !== "undefined") {
      window.removeEventListener('resize', this.onResize, { passive: true });
    }
    this.$root.$off(__WEBPACK_IMPORTED_MODULE_20__helper__["b" /* MyEvents */].AUTH_SIGNIN, this.doAfterSignIn);
    this.$root.$off(__WEBPACK_IMPORTED_MODULE_20__helper__["b" /* MyEvents */].AUTH_SIGNOUT, this.doAfterSignOut);
  },

  methods: {
    createFallback: function createFallback() {
      var body = document.querySelector("body");
      body.className = "allChildrenCenter";
      body.style = "height: 100vh";
      var fallback = document.createElement("div");
      fallback.className = "text-center";
      var fallbackText = document.createElement("h3");
      fallbackText.className = "text-center";
      fallbackText.innerText = "Please use desktop or Tablet to continue";
      var fallbackAction = document.createElement("button");
      fallbackAction.innerText = "Reload";
      fallbackAction.onclick = function () {
        return location.reload();
      };
      fallback.append(fallbackText, fallbackAction);
      body.replaceChildren(fallback);
    },
    onResize: function onResize() {
      this.$store.dispatch("app/setWindowsWidth", window.innerWidth);
    },
    initLoader: function initLoader() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (!this.onMobile && this.isAuthenticated) {
        this.$refs.appLoader.updateLoader(value);
      }
    },
    getLoadUpdate: function getLoadUpdate(val) {
      this.loadValue = val;
    },
    doAfterSignIn: function doAfterSignIn() {
      var _this3 = this;

      var vm = this;
      this.cable = ActionCable.createConsumer("wss://api.yousound.com/cable" + '?token=' + this.$store.state.auth.token);
      this.notification_subscription = this.cable.subscriptions.create({
        channel: 'NotificationsChannel'
      }, {
        connected: function connected() {
          console.log('connected to NotificationsChannel');
        },
        received: function received(data) {
          console.log('notification_subscription');
          console.log(data);
          vm.$store.dispatch('activity/addBadge', data);
          __WEBPACK_IMPORTED_MODULE_9__services_user__["a" /* default */].cartItems(vm.currentUser.id).then(function (response) {
            vm.$store.dispatch('user/setCartItems', response.body);
          });
        },
        disconnected: function disconnected() {
          console.log('disconnected to NotificationsChannel :(');
        }
      });
      this.$intercom.boot({
        user_id: this.currentUser.id,
        name: this.currentUser.display_name,
        email: this.currentUser.email,
        avatar: {
          type: 'avatar',
          image_url: this.currentUser.avatar.url
        },
        user_hash: this.$store.state.auth.hmac,
        hide_default_launcher: true
      });
      this.$store.dispatch('error/showLoadingActivity', true);
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_9__services_user__["a" /* default */].getUserInfo(this.currentUser.id), __WEBPACK_IMPORTED_MODULE_4__services_activity__["a" /* default */].getUnread(), __WEBPACK_IMPORTED_MODULE_9__services_user__["a" /* default */].cartItems(this.currentUser.id)]).then(function (values) {
        __WEBPACK_IMPORTED_MODULE_5__services_auth__["a" /* default */].setUser(values[0].body);
        _this3.$store.dispatch('activity/setBadge', values[1].body);
        _this3.$store.dispatch('user/setCartItems', values[2].body);
        _this3.$store.dispatch('error/showLoadingActivity', false);
      }).catch(function (reason) {
        _this3.$store.dispatch('error/showLoadingActivity', false);
      });
    },
    doAfterSignOut: function doAfterSignOut() {
      if (this.notification_subscription) {
        this.notification_subscription.unsubscribe();
        this.notification_subscription = null;
      }
      this.$intercom.shutdown();
    },
    openLoginDialog: function openLoginDialog() {
      this.show_login_dialog = true;
    },
    closeLoginDialog: function closeLoginDialog() {
      this.show_login_dialog = false;
    },
    watchPip: function watchPip(to, from, parentNode) {
      var videoId = void 0;
      var stream_pipMode = this.$store.state.streamPlayer.pipMode;
      if (to.name === 'VideoShow') {
        var pp = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_video_js__["a" /* default */])('myVideoPlayer');
        videoId = to.params.videoId;
        var nodeDetails = this.$store.state.streamPlayer.nodeDetails;
        if (from.name === 'VideoShow' || nodeDetails.videoId && videoId !== nodeDetails.videoId) {
          if (stream_pipMode) {
            pp.exitPictureInPicture();
            pp.dispose();
          }
        } else {}
      } else if (from.name === 'VideoShow') {
        if (stream_pipMode) {
          videoId = from.params.videoId;
          var _nodeDetails = {};
          _nodeDetails.parent = parentNode;
          _nodeDetails.videoId = videoId;
          try {
            this.$store.dispatch('streamPlayer/setPipParentNode', _nodeDetails);
          } catch (error) {
            return error;
          }
        }
      } else {
        this.closeVideoInDOM();
      }
    },
    closeVideoInDOM: function closeVideoInDOM() {
      try {
        var pp = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_video_js__["a" /* default */])('myVideoPlayer');
        if (pp && !pp.isInPictureInPicture()) {
          pp.dispose();
          this.$store.dispatch('streamPlayer/setPipParentNode', {});
        }
      } catch (error) {
        return error;
      }
    },
    closeSMS: function closeSMS() {
      this.$store.dispatch('app/toggleGlobalSMS', false);
    },
    openSMS: function openSMS() {
      this.$store.dispatch('app/toggleGlobalSMS', true);
    }
  }
});

/***/ }),
/* 864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      transformProp: {
        x: 0,
        y: 0,
        rotation: 0
      },
      slideRight: false,
      slideLeft: false,
      xDown: null,
      yDown: null,
      xUp: null,
      yUp: null
    };
  },

  computed: {
    elSwipe: function elSwipe() {
      return this.$refs.swipeEle;
    }
  },
  watch: {
    // slideLeft(val) {
    //     if (val) {
    // }
  },
  methods: {
    initEvent: function initEvent() {
      this.elSwipe.addEventListener("touchstart", this.handleTouchStart, false);
      this.elSwipe.addEventListener("touchmove", this.handleTouchMove, false);
    },
    removeEvent: function removeEvent() {
      this.elSwipe.removeEventListener("touchstart", this.handleTouchStart, false);
      this.elSwipe.removeEventListener("touchmove", this.handleTouchMove, false);
    },
    getTouches: function getTouches(evt) {
      return evt.touches;
    },
    handleTouchStart: function handleTouchStart(evt) {
      var firstTouch = this.getTouches(evt)[0];
      this.xDown = firstTouch.clientX;
      this.yDown = firstTouch.clientY;
    },
    handleTouchMove: function handleTouchMove(evt) {
      if (!this.xDown || !this.yDown) {
        return;
      }

      this.xUp = evt.touches[0].clientX;
      this.yUp = evt.touches[0].clientY;

      var xDiff = this.xDown - this.xUp;
      var yDiff = this.yDown - this.yUp;

      if (Math.abs(xDiff) > Math.abs(yDiff)) {
        /* most significant */
        if (xDiff > 0) {
          /* right swipe */
          this.slideRight = true;
          this.slideLeft = false;
        } else {
          /* left swipe */
          this.slideLeft = true;
          this.slideRight = false;
        }
      } else {
        if (yDiff > 0) {
          /* down swipe */
        } else {
            /* up swipe */
          }
      }
      /* reset values */
      this.xDown = null;
      this.yDown = null;
    }
  },
  mounted: function mounted() {
    this.initEvent();
  },
  beforeDestroy: function beforeDestroy() {
    this.removeEvent();
  }
});

/***/ }),
/* 865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_sms__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_user_tag__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_user_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_user_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_attachSlide__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_attachSlide___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_attachSlide__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_mobile_messages_SMS_smsEngagement__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_mobile_messages_SMS_smsEngagement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__views_mobile_messages_SMS_smsEngagement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_user__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_auth__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_stripe_elements__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_stripe_elements___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_stripe_elements__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_subscription_js__ = __webpack_require__(47);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    UserTag: __WEBPACK_IMPORTED_MODULE_3__components_user_tag___default.a,
    AttachSlide: __WEBPACK_IMPORTED_MODULE_4__components_attachSlide___default.a,
    smsEngagement: __WEBPACK_IMPORTED_MODULE_5__views_mobile_messages_SMS_smsEngagement___default.a,
    createToken: __WEBPACK_IMPORTED_MODULE_9_vue_stripe_elements__["createToken"],
    Card: __WEBPACK_IMPORTED_MODULE_9_vue_stripe_elements__["Card"]
  },
  data: function data() {
    return {
      telDigits: [],
      digitsLen: 10,
      digitEntered: false,
      signUpDone: false,
      complete: false,
      number: false,
      expiry: false,
      cvc: false,
      addCardLoading: false,
      stripePubkey: "pk_live_fXEdJ0v6E2ROxT8rufDCby12",
      options: { hidePostalCode: true },
      showCardPanel: false,
      textMessage: "",
      smsMaxChar: 150,
      attachment: {},
      postSMSactive: false,
      confirmSendSMS: false,
      sendSuccess: false,
      smsEngagementActive: false
    };
  },

  watch: {
    telDigits: {
      handler: function handler(val) {
        if (val.length < this.digitsLen) {
          this.$refs["input" + [val.length]][0].focus();
        }
      },

      deep: true
    }
  },
  methods: {
    outsideClick: function outsideClick() {
      console.log("outside click");
      this.closeSMS();
    },
    openEngagement: function openEngagement() {
      this.smsEngagementActive = true;
    },
    closeEngagement: function closeEngagement() {
      this.smsEngagementActive = false;
    },
    sendSMS: function sendSMS() {
      var _this = this;

      this.confirmSendSMS = false;
      var params = {
        message: this.textMessage
      };

      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.attachment).length) {
        params.attachment = this.attachment.value;
      }

      __WEBPACK_IMPORTED_MODULE_2__services_sms__["a" /* default */].sendSMS(params).then(function (response) {
        console.log({ response: response });

        _this.$store.dispatch("error/showSuccessToast", ["SMS Sent successfully" + (" - " + response.body.message)]);

        if (_this.onMobile) {
          _this.sendSuccess = true;
        } else {
          _this.closeSMS();
        }
      }).catch(function () {
        _this.$store.dispatch("error/showErrorToast", ["Error Sending SMS"]);
      });
    },
    confirmSend: function confirmSend() {
      this.confirmSendSMS = true;
    },
    getSelected: function getSelected(data) {
      console.log(data);
      this.attachment = data;
    },
    showCard: function showCard() {
      this.showCardPanel = true;
    },
    submitTel: function submitTel() {
      var validate = this.telDigits.length === this.digitsLen && this.telDigits.every(function (tel) {
        return typeof tel === "number";
      });

      if (validate) {
        this.digitEntered = true;
      }
    },
    delDigit: function delDigit(evt, idx) {
      this.telDigits.splice(idx, 1, "");
    },
    closeSMS: function closeSMS() {
      this.digitEntered = false;
      this.$emit("closeSMS");
    },
    updatePhoneNo: function updatePhoneNo() {
      var _this2 = this;

      var params = {
        phone_number: this.tel
      };

      __WEBPACK_IMPORTED_MODULE_7__services_user__["a" /* default */].updateUserInfo(this.currentUser.id, params).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_8__services_auth__["a" /* default */].setUser(response.body);
        _this2.signUpDone = true;
        // this.isUserSignedUp = true // shouldn't update computed
        _this2.$store.dispatch('error/showSuccessToast', ["Phone number updated successfully."]);
      }).catch(function (e) {
        console.log(e);

        _this2.$store.dispatch('error/showErrorToast', ["There was an error registering your phone number"]);
      });
    },
    paymentMethod: function paymentMethod() {
      var _this3 = this;

      this.addCardLoading = true;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vue_stripe_elements__["createToken"])().then(function (data) {
        _this3.subscribe(_this3.stripePriceId, data.token);
      });
    },
    subscribe: function subscribe(priceId, tokenResponse) {
      var _this4 = this;

      this.$store.dispatch('error/showLoadingActivity', true);

      __WEBPACK_IMPORTED_MODULE_10__services_subscription_js__["a" /* default */].createSubscriptionn({ price_id: priceId, token_id: tokenResponse.id, token_response: tokenResponse }).then(function (response) {
        if (response.body.message != null) {
          _this4.$store.dispatch('error/showLoadingActivity', false);
          _this4.closeSMS();
          _this4.$store.dispatch('error/showSuccessToast', response.body.message);
        } else {
          _this4.$store.dispatch('error/showLoadingActivity', false);
          _this4.$store.dispatch('error/showErrorToast', response.body.errors || [response.body]);
        }
      }).catch(function (e) {
        _this4.$store.dispatch('error/showLoadingActivity', false);
        _this4.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      }).finally(function () {
        _this4.addCardLoading = false;
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapState */])({
    sideBarWidth: function sideBarWidth(state) {
      return state.app.sideBarWidth;
    },
    sideBarMini: function sideBarMini(state) {
      return state.app.sideBarMini;
    }
  }), {
    charCount: function charCount() {
      return this.textMessage.length;
    },
    valAddCard: function valAddCard() {
      var valMM = this.card.mm.length === 2 && this.card.mm < 12 && this.card.mm > 0;
      var valYY = this.cardNo.length && this.mm.length && this.yy.length;

      var validate = valMM && valYY;
      return validate;
    },
    tel: function tel() {
      return this.telDigits.join("");
    },
    telFormatted: function telFormatted() {
      return ("+1" + this.tel).replace(/(.{4})/g, "$1-");
    },
    sizeSMS: function sizeSMS() {
      if (this.sidebarMini) {
        return { width: "calc(100% - " + this.sideBarWidth + "px)" };
      }
    },
    onMobile: function onMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    currentUser: function currentUser() {
      return this.$store.state.auth.user;
    },
    isUserSubscribed: function isUserSubscribed() {
      return this.currentUser.stripe_subscription_id;
      // return false
    },
    setIsUserSubscribed: function setIsUserSubscribed(stripeSubscriptionId) {
      this.currentUser.stripe_subscription_id = stripeSubscriptionId;
    },
    isUserSignedUp: function isUserSignedUp() {
      return this.currentUser.phone_number;
      // return false
    },
    stripePriceId: function stripePriceId() {
      return __webpack_require__.i({"NODE_ENV":"production","CHAT_SERVER_URL":"https://chat.yousound.com","API_BASE_URL":"https://api.yousound.com","SOCKET_BASE_URL":"wss://api.yousound.com/cable","SECRET_CODE":"e82a084c96d055241d1883bb219377cfd1804594d019a331db83cd054ccd9404","INTERCOM_APP_ID":"c87vjth9","STRIPE_PUBLISHABLE_KEY":"pk_live_fXEdJ0v6E2ROxT8rufDCby12","STRIPE_SECRET_KEY":"sk_live_pntvln2j8e8tB8Euf3xAy2dG","STRIPE_CONNECT_CLIENT_ID":"ca_CC74CVRdkHTZqAIPQVJS04XoPwiVB1Kx"}).PRO_PRICE_ID;
    }
  }),
  mounted: function mounted() {
    if (!this.isUserSignedUp && this.$refs.input0) {
      this.$refs.input0[0].focus();
    }
  }
});

/***/ }),
/* 866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_sms__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_user_tag_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_user_tag_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_user_tag_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: { UserTag: __WEBPACK_IMPORTED_MODULE_1__components_user_tag_vue___default.a },
  data: function data() {
    return {
      smsList: [],
      smsEngagementActive: false,
      currentMessage: {}
    };
  },

  computed: {
    currentUser: function currentUser() {
      return this.$store.state.auth.user;
    },
    smsCount: function smsCount() {
      return this.smsList.length;
    },
    isUserSubscribed: function isUserSubscribed() {
      return this.currentUser.creator_verified;
    }
  },
  methods: {
    openMessage: function openMessage(smsId) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__services_sms__["a" /* default */].getSMS(smsId).then(function (response) {
        _this.currentMessage = response.body;
        _this.smsEngagementActive = true;
      }).catch(function (e) {
        console.log(e);
        console.log(e.response);
        console.log(e.message);
        _this.$store.dispatch("error/showErrorToast", ["There was an error opening message"]);
      });
    },
    closeEngagement: function closeEngagement() {
      this.smsEngagementActive = false;
      this.currentMessage = {};
    },
    initSubscribe: function initSubscribe() {
      if (!this.currentUser.creator_verified) {
        this.$router.push({ path: '/subscribe#plans' });
      }
    },
    listAllSMS: function listAllSMS() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__services_sms__["a" /* default */].listSMS().then(function (response) {
        _this2.smsList = response.body;
      }).catch(function (e) {
        _this2.$store.dispatch("error/showErrorToast", e.body.errors || [e.body]);
      });
    }
  },
  created: function created() {
    this.listAllSMS();
  }
});

/***/ }),
/* 867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    accordions: {
      type: Array,
      default: []
    },
    title: {
      type: String,
      default: 'Title'
    },
    leftIcon: {
      type: String
    },
    rightIcon: {
      type: String
    },
    content: {
      type: String,
      default: 'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Ipsum, reiciendis!'
    }
  },

  data: function data() {
    return {
      name: 'bee'
    };
  },
  mounted: function mounted() {
    var acc = document.getElementsByClassName('accordion');
    var i;

    for (i = 0; i < acc.length; i++) {
      acc[i].addEventListener('click', function () {
        this.classList.toggle('active');
        var panel = this.nextElementSibling;
        if (panel.style.display === 'block') {
          panel.style.display = 'none';
        } else {
          panel.style.display = 'block';
        }
      });
    }
  }
});

/***/ }),
/* 868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_album__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_downloadmodal__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_downloadmodal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_downloadmodal__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    downloadModal: __WEBPACK_IMPORTED_MODULE_5__components_downloadmodal___default.a
  },

  props: {
    object: {
      type: Object
    }
  },

  data: function data() {
    return {
      showDownloadModal: false,
      page: ''
    };
  },


  computed: {
    item: function item() {
      if (this.object.assoc_type) {
        return this.object.assoc;
      } else {
        return this.object;
      }
    },
    album1Cover: function album1Cover() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(this.item.tracks, '[0].album.cover.url');
    },
    album2Cover: function album2Cover() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(this.item.tracks, '[1].album.cover.url');
    },
    album3Cover: function album3Cover() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(this.item.tracks, '[2].album.cover.url');
    },
    album4Cover: function album4Cover() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(this.item.tracks, '[3].album.cover.url');
    },
    isPlaying: function isPlaying() {
      var playingItem = this.$store.state.player.list[this.$store.state.player.listIndex];
      if (playingItem !== undefined) {
        if (playingItem.assoc_type === 'Album') {
          playingItem = playingItem.assoc;
        }
        var currentItem = this.object;
        if (currentItem.assoc_type === 'Album') {
          currentItem = currentItem.assoc;
        }
        if (playingItem.id === currentItem.id) {
          return true;
        }
      }
      return false;
    }
  },

  created: function created() {
    // console.log(this.objects, this.objectIndex)
  },


  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])({
    setPlaylist: 'player/setPlaylist',
    setPlaylistIndex: 'player/setListIndex',
    setPlaying: 'player/setPlayingStatus'
  }), {
    dismissDownloadModal: function dismissDownloadModal() {
      this.showDownloadModal = false;
    },
    repostItem: function repostItem() {
      __WEBPACK_IMPORTED_MODULE_4__services_album__["a" /* default */].repostAlbum(this.item.id).then(function (response) {
        console.log(response);
      }).catch(function (e) {
        console.log(e);
      });
    },
    playSong: function playSong() {
      if (this.$store.state.player.isPaused && this.$store.getters['player/currentAlbum'].id === this.item.id) {
        this.$root.$emit(__WEBPACK_IMPORTED_MODULE_3__helper__["b" /* MyEvents */].AUDIO_PLAYER_REPLAY);
      } else {
        this.setPlaylist([this.object]);
        this.setPlaylistIndex(0);
        this.setPlaying(true);
        this.$root.$emit(__WEBPACK_IMPORTED_MODULE_3__helper__["b" /* MyEvents */].AUDIO_PLAYER_PLAY);
      }
    },
    pauseSong: function pauseSong() {
      this.$root.$emit(__WEBPACK_IMPORTED_MODULE_3__helper__["b" /* MyEvents */].AUDIO_PLAYER_PAUSE);
    },
    shareItem: function shareItem() {},
    flagItem: function flagItem() {},
    addComment: function addComment() {},
    addToPlaylist: function addToPlaylist() {},
    choosePage: function choosePage(path) {
      // console.log(path)
      this.$router.push({ path: '/' + path });
    },
    goToAlbum: function goToAlbum() {
      this.choosePage(this.item.album_type + '/' + this.item.slug);
    }
  })
});

/***/ }),
/* 869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_profileitem__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_profileitem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_profileitem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_merchmodal__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_merchmodal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_merchmodal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_activityalbumcard__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_activityalbumcard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_activityalbumcard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_activityproductcard__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_activityproductcard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_activityproductcard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_video_box__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_video_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_video_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__user_tag__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__user_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__user_tag__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    profileItem: __WEBPACK_IMPORTED_MODULE_1__components_profileitem___default.a,
    merchModal: __WEBPACK_IMPORTED_MODULE_2__components_merchmodal___default.a,
    activityAlbumCard: __WEBPACK_IMPORTED_MODULE_3__components_activityalbumcard___default.a,
    activityProductCard: __WEBPACK_IMPORTED_MODULE_4__components_activityproductcard___default.a,
    videoBox: __WEBPACK_IMPORTED_MODULE_5__components_video_box___default.a,
    userTag: __WEBPACK_IMPORTED_MODULE_6__user_tag___default.a
  },

  props: {
    activityItem: {
      type: Object
    }
  },

  data: function data() {
    return {
      showSendMessage: false,
      showMerchModal: false
    };
  },


  computed: {
    testVid: function testVid() {
      return {
        id: 65,
        name: "Ruckazoid - Don’t Let Me Go",
        slug: "ruckazoid-don-t-let-me-go",
        description: "An experimental, surreal journey depicting the need of lifeforms to make contact, while showing the fear of providing oneself as a target at the same time.",
        cover: {
          url: "https://d19mruzykfu6hg.cloudfront.net/uploads/stream/cover/65/22d48ff9-a2de-4ad9-866d-cd4c568cbd2c.png",
          large: {
            url: "https://d19mruzykfu6hg.cloudfront.net/uploads/stream/cover/65/large_22d48ff9-a2de-4ad9-866d-cd4c568cbd2c.png"
          },
          thumb: {
            url: "https://d19mruzykfu6hg.cloudfront.net/uploads/stream/cover/65/thumb_22d48ff9-a2de-4ad9-866d-cd4c568cbd2c.png"
          }
        },
        video_type: "uploaded",
        status: "archived",
        started_at: null,
        stopped_at: null,
        mp_channel_1_ep_1_url: "https://stream.mux.com/xK02Gq202joat9j5hl4HM00XWyqFDT4EuvA5KcbZp0236YA.m3u8",
        mp_channel_2_url: "https://storage.googleapis.com/video-storage-us-east1-uploads/6eYhrvZ62IwreFQBeT34ID6ygEVzEGslAU1wOwp4KWg?Expires=1634950949&GoogleAccessId=direct-uploads-writer-prod%40mux-cloud.iam.gserviceaccount.com&Signature=S01ZU52XWg%2BXKPGz1h9MnBlO8rttVaBn%2FS8CkNngbV%2Bak8Oflc%2FILxYf0Ej51gKXF6kWbHrvADT%2FyCWv2YZg1fjsZA7KOGzIQE%2FL9fRT%2FhwymdC5rasgC8cslGOQV9Q8Gbf4A33nJ1gg2MKqKr7mTEt%2FwRQk%2BPSz5BqBCYojdnq6ESe9gOgjt%2FTM6Ko05gY6ZU3NmcRDr60dHb2vQZTGMzEcmVJ18kr8KU87WqiSSQG%2BxteeQ%2Bh08Orea2S7BRJTeIdLcmCFlpfUlVACschyTCg3r%2BLCc9Jspm%2FadOvXFgGLSKlDYt9WzB1ZxOuAM6OciIsmPUmjIrNmoKuokrE7AA%3D%3D&upload_id=ADPycdtD7NNVYT1xaJQOvj1trbvkyNMzGuaMkKoIUfM2hm9HaxHwKvpRSQgL_5R8ZO7vsF79qkJBMEa6ELpZ1cbOW2c",
        duration: 100,
        valid_period: 0,
        remaining_seconds: -1,
        assoc_type: "ShopProduct",
        account_ids: [],
        digital_content_name: null,
        view_price: 0,
        viewers_limit: 0,
        notified: true,
        assoc: {
          id: 9,
          name: "Action Bronson 7000 Vinyl",
          description: 'LISTENING TO BLUE CHIPS 7000, THE THIRD INSTALLMENT IN ACTION BRONSON\'S BLUE CHIPS SERIES ("the 7000 is just because it\'s beyond. it\'s not part three, it\'s part 7000."), is just like watching the larger-than-life rapper do his thing on TV. As he spits out brilliant stream-of-consciousness bars filled with humor, knowledge, braggadocio, and self-awareness ("you can never score a point against my defense / for many years, my mind been going off the deep end / uh, like Tom Hanks with the soccer ball / you get turned into a taco / uh, they thought Body was Bruce Willis in Morocco."), you immediately get sucked into his engaging personality & beautiful, Queens-bred mind. Whether he is weaving in obscure pop-culture references or bragging about his expensive/goon-ish lifestyle ("and that\'s my life, 60k for the glass pipe/I\'ll break it on your head if you don\'t act right), he commands the listeners\' full attention, and the funky, rare-grooves-based beats, produced by Alchemist, Harry Fraud, Knxwledge, Daringer, and Party Supplies, are the perfect accompaniments to Action\'s accessible genius. Check out "Let Me Breathe," "9-24-7000," "The Chairman\'s Intent," and "La Luna," and we\'ll go ahead and say it… Big Body Bes needs to do a full album!',
          price: 1998,
          reposted: 1,
          stock: 544,
          sold: 0,
          stock_status: "active",
          collaborators_count: 0,
          show_status: "show_all",
          tax_percent: "0.0",
          is_vat: false,
          seller_location: null,
          status: "published",
          created_at: "2018-02-11T01:32:17.780Z",
          collaborators: [],
          creator_share: 100,
          creator_recoup_cost: 0,
          digital_content_name: null,
          merchant: {
            id: 26,
            slug: "testartist1",
            username: "testartist1",
            display_name: "Hudson Mohawke",
            first_name: null,
            last_name: null,
            contact_url: null,
            user_type: "listener",
            avatar: {
              url: "https://d19mruzykfu6hg.cloudfront.net/uploads/user/avatar/26/e296aa7c-5107-47a1-8eea-e9813097ed37.jpg",
              thumb: {
                url: "https://d19mruzykfu6hg.cloudfront.net/uploads/user/avatar/26/thumb_e296aa7c-5107-47a1-8eea-e9813097ed37.jpg"
              }
            },
            repost_price: 100,
            repost_price_end_at: null,
            max_repost_price: 100,
            status: "active",
            size_chart: "",
            shipping_policy: "",
            return_policy: "",
            privacy_policy: "",
            followers: 2,
            followings: 2,
            stripe_connected: false,
            is_following: true,
            invited_at: null,
            request_role: null,
            request_status: null
          },
          category: {
            id: 6,
            name: "Vinyl",
            description: null,
            is_digital: false
          },
          variants: [{
            id: 3,
            name: "Black Vinyl",
            price: 1998,
            quantity: 544
          }],
          shipments: [{
            id: 9,
            country: "United States",
            shipment_alone_price: 1000,
            shipment_with_price: 500
          }],
          covers: [{
            id: 8,
            cover: {
              url: "https://d19mruzykfu6hg.cloudfront.net/uploads/shop_product_cover/cover/8/a21e6a20-63f6-4aac-b09a-39539bb75b27.jpg",
              large: {
                url: "https://d19mruzykfu6hg.cloudfront.net/uploads/shop_product_cover/cover/8/large_a21e6a20-63f6-4aac-b09a-39539bb75b27.jpg"
              },
              thumb: {
                url: "https://d19mruzykfu6hg.cloudfront.net/uploads/shop_product_cover/cover/8/thumb_a21e6a20-63f6-4aac-b09a-39539bb75b27.jpg"
              }
            },
            position: 0
          }, {
            id: 9,
            cover: {
              url: null,
              large: {
                url: null
              },
              thumb: {
                url: null
              }
            },
            position: 1
          }, {
            id: 10,
            cover: {
              url: null,
              large: {
                url: null
              },
              thumb: {
                url: null
              }
            },
            position: 2
          }]
        },
        guests: [],
        ml_input_id: null,
        ml_input_dest_1_url: "rtmp://live.yousound.com:5222/app",
        is_reposted: false,
        broadcast_seconds: 0,
        digital_content_url: null,
        accounts: [],
        user: {
          id: 46,
          slug: "ruckazoid",
          username: "ruckazoid",
          display_name: "RUCKAZOID",
          first_name: null,
          last_name: null,
          contact_url: "",
          user_type: "artist",
          avatar: {
            url: "https://d19mruzykfu6hg.cloudfront.net/uploads/user/avatar/46/4001747e-460d-4fc5-a7c7-c5165bd1a27a.png",
            thumb: {
              url: "https://d19mruzykfu6hg.cloudfront.net/uploads/user/avatar/46/thumb_4001747e-460d-4fc5-a7c7-c5165bd1a27a.png"
            }
          },
          repost_price: 100,
          repost_price_end_at: null,
          max_repost_price: 100,
          status: "active",
          size_chart: "Standard US sizing",
          shipping_policy: "All orders shipped VIA USPS same day before 2pm.",
          return_policy: "No returns dog, don't waste my time!",
          privacy_policy: "",
          followers: 13,
          followings: 10,
          enable_alert: true,
          balance_amount: 913785,
          available_amount: 913785,
          stripe_connected: true,
          sign_in_count: 950,
          stream_rolled_time: 0,
          stream_rolled_cost: 0,
          data: {
            discover_page_visited: 1,
            video_page_visited: 1,
            message_page_visited: 1,
            sell_page_visited: 1,
            stream_page_visited: 1
          },
          is_following: false,
          invited_at: null,
          request_role: "artist",
          request_status: "accepted"
        },
        genre: {
          id: 276,
          slug: "r-b-soul",
          name: "R&B / SOUL",
          region: "",
          color: "#67ACD0",
          sequence: 15,
          users_size: 0
        }
      };
    },
    onMobile: function onMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    toLocalTimeString: function toLocalTimeString() {
      return __WEBPACK_IMPORTED_MODULE_0__helper__["f" /* Utils */].toLocalTimeString;
    },
    actionText: function actionText() {
      if (this.activityItem.action_type === "release") {
        return "released";
      } else if (this.activityItem.action_type === "repost") {
        return "reposted";
      } else if (this.activityItem.action_type === "unrepost") {
        return "unreposted";
      } else if (this.activityItem.action_type === "follow") {
        return "followed you";
      } else if (this.activityItem.action_type === "unfollow") {
        return "unfollowed you";
      } else if (this.activityItem.action_type === "play") {
        return "played";
      } else if (this.activityItem.action_type === "download") {
        return "downloaded";
      } else {
        return "commented";
      }
    },
    activityIcon: function activityIcon() {
      switch (this.activityItem.action_type) {
        case "repost":
          // return require("../../static/images/repost_blue.svg");
          return 'repeat';
        case "comment":
          // return require("../../static/images/comment.svg");
          return 'comment';
        case "order_product":
          // return require("../../static/images/dollar.svg");
          return 'paid';
        case "donation":
          // return require("../../static/images/dollar.svg");
          return 'paid';
        default:
          return null;
      }
    },
    followButtonText: function followButtonText() {
      if (this.activityItem.sender.is_following) {
        return this.buttonHover ? "Unfollow" : "Following";
      }
      return "Follow";
    }
  },

  created: function created() {},


  methods: {
    showMessageDialog: function showMessageDialog() {
      this.showSendMessage = true;
    },
    dismissMessageModal: function dismissMessageModal() {
      this.showSendMessage = false;
    },
    imageURL: function imageURL(item) {
      if (item.cover) {
        return item.cover.thumb.url;
      } else {
        return item.covers[0].cover.thumb.url;
      }
    },
    blockUser: function blockUser() {},
    doAction: function doAction() {
      switch (this.activityItem.assoc_type) {
        case "ShopProduct":
          this.showMerchModal = !true;
          break;
        case "Album":
          this.$router.push({
            path: this.activityItem.assoc.album_type + "/" + this.activityItem.assoc.slug
          });
          break;
        default:
          if (this.activityItem.assoc.commentable_type === "Album") {
            this.$router.push({
              path: this.activityItem.assoc.commentable.album_type + "/" + this.activityItem.assoc.commentable.slug
            });
          }
      }
    },
    dimissMerchModal: function dimissMerchModal() {
      this.showMerchModal = false;
    }
  }
});

/***/ }),
/* 870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_merchmodal__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_merchmodal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_merchmodal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_profileitem__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_profileitem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_profileitem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_product__ = __webpack_require__(15);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    merchModal: __WEBPACK_IMPORTED_MODULE_0__components_merchmodal___default.a,
    profileItem: __WEBPACK_IMPORTED_MODULE_1__components_profileitem___default.a
  },

  props: {
    object: {
      type: Object
    },

    priceShow: {
      type: Boolean,
      default: true
    }
  },

  data: function data() {
    return {
      dialog: false,
      showMerchModal: false
    };
  },


  computed: {
    item: function item() {
      if (this.object.assoc_type) {
        return this.object.assoc;
      } else {
        return this.object;
      }
    }
  },

  created: function created() {},


  methods: {
    dimissMerchModal: function dimissMerchModal() {
      this.showMerchModal = false;
    },
    showModal: function showModal() {
      this.showMerchModal = true;
    },
    repostProduct: function repostProduct() {
      var _this = this;

      this.dialog = false;
      __WEBPACK_IMPORTED_MODULE_2__services_product__["a" /* default */].repostProduct(this.item.id).then(function (response) {
        _this.$store.dispatch("error/showSuccessToast", ["You just reposted " + _this.item.name]);
      }).catch(function (e) {
        _this.$store.dispatch("error/showErrorToast", e.body.errors || [e.body]);
      });
    }
  },

  mounted: function mounted() {}
});

/***/ }),
/* 871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},

  props: {
    object: {
      type: Object
    }
  },

  data: function data() {
    return {};
  },


  computed: {
    item: function item() {
      return this.object;
    }
  },

  created: function created() {},


  methods: {
    choosePage: function choosePage(path) {
      // console.log(path)
      this.$router.push({ path: '/' + path });
    }
  },

  mounted: function mounted() {}
});

/***/ }),
/* 872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_album__ = __webpack_require__(11);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},

  props: {
    album: {
      type: Object
    },

    dismiss: {
      type: Function
    }
  },

  data: function data() {
    return {
      active_violation: '',
      reason: '',
      description: '',
      show_confirm_view: false,
      violations: [{
        value: 'sexual_content',
        label: 'Sexual Content',
        options: ['Graphic sexual activity', 'Nudity', 'Abusive title or description', 'Other sexual content']
      }, {
        value: 'repulsive_content',
        label: 'Violent or repulsive content',
        options: ['Physical attack', 'Animal abuse']
      }, {
        value: 'abusive_content',
        label: 'Hateful or abusive content',
        options: ['Promotes hatred or violence', 'Bullying', 'Abusive title or description']
      }, {
        value: 'dangerous_acts',
        label: 'Harmful dangerous acts',
        options: ['Pharmaceutical or drug abuse', 'Abuse of fire or explosives', 'Suicide or self injury', 'Other dangerous acts']
      }, {
        value: 'child_abuse',
        label: 'Child abuse',
        options: []
      }, {
        value: 'terrorism',
        label: 'Promotes terrorism',
        options: []
      }, {
        value: 'spam',
        label: 'Spam or misleading',
        options: ['Mass advertising', 'Pharmaceutical drugs for sale', 'Misleading text', 'Misleading thumbnail', 'Scams / fraud']
      }, {
        value: 'infringe',
        label: 'Infringes my rights',
        options: []
      }]
    };
  },


  computed: {
    violation: function violation() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(this.violations, function (v) {
        return v.value === _this.active_violation;
      }) || {
        options: []
      };
    }
  },

  created: function created() {
    this.active_violation = 'sexual_content';
  },


  methods: {
    submit: function submit() {
      var _this2 = this;

      this.$validator.validateAll().then(function (response) {
        if (response === true) {
          var params = {
            reason: _this2.reason,
            description: _this2.description
          };
          __WEBPACK_IMPORTED_MODULE_1__services_album__["a" /* default */].reportAlbum(_this2.album.id, params).then(function (response) {
            _this2.show_confirm_view = true;
          });
        } else {
          // console.log(this.errors)
        }
      }).catch(function (e) {
        console.log('error', e);
      });
    },
    closeConfirmView: function closeConfirmView() {
      this.show_confirm_view = false;
      this.dismiss();
    }
  }
});

/***/ }),
/* 873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    item: {
      type: Object,
      required: true
    },
    promote: {
      type: Function,
      required: true
    },
    dismiss: {
      type: Function,
      required: true
    },
    type: String
  },

  components: {},

  data: function data() {
    return {
      showPromoteMessage: false,
      albumURL: ""
    };
  },


  computed: {
    itemProduct: function itemProduct() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(this.item, "products[0]");
    },
    itemCover: function itemCover() {
      if (this.item.slug) {
        return this.item.cover.url;
      } else {
        var coverURL = "";
        for (var index in this.item.covers) {
          var cover = this.item.covers[index].cover;
          if (cover.url) {
            coverURL = cover.url;
            break;
          }
        }
        return coverURL;
      }
    }
  },

  created: function created() {
    if (this.type === 'album') {
      this.albumURL = window.location.origin + "/album/" + this.item.slug;
    } else if (this.type === 'stream') {
      this.albumURL = window.location.origin + "/video/" + this.item.id + "/show";
    } else {
      this.albumURL = window.location.origin + "/product/" + this.item.id;
    }
  },


  methods: {
    showPromoteModal: function showPromoteModal() {
      this.promote();
    },


    onCopy: function onCopy(e) {
      this.$store.dispatch("error/showSuccessToast", ["You just copied: " + e.text]);
      // alert('You just copied: ' + e.text)
    },

    onError: function onError(e) {
      this.$store.dispatch("error/showErrorToast", ["Failed to copy link"]);
      // alert('Failed to copy link')
    }
  }
});

/***/ }),
/* 874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_album__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_downloadmodal__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_downloadmodal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_downloadmodal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_profileitem__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_profileitem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_profileitem__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    downloadModal: __WEBPACK_IMPORTED_MODULE_4__components_downloadmodal___default.a,
    profileItem: __WEBPACK_IMPORTED_MODULE_5__components_profileitem___default.a
  },

  props: {
    objects: {
      type: Array
    },

    objectIndex: {
      type: Number
    }
  },

  data: function data() {
    return {
      showDownloadModal: false,
      page: ''
    };
  },


  computed: {
    item: function item() {
      if (this.objects[this.objectIndex].assoc_type) {
        return this.objects[this.objectIndex].assoc;
      } else {
        return this.objects[this.objectIndex];
      }
    },
    isPlaying: function isPlaying() {
      // if (this.$store.state.player.isPlaying) {
      //   const currentItem = this.$store.state.player.list[this.$store.state.player.listIndex]
      //   if (currentItem.assoc_type) {
      //     if (currentItem.assoc.id === this.item.id) {
      //       return true
      //     }
      //   } else {
      //     if (currentItem.id === this.item.id) {
      //       return true
      //     }
      //   }
      // }
      var playingItem = this.$store.state.player.list[this.$store.state.player.listIndex];
      if (playingItem !== undefined) {
        if (playingItem.assoc_type === 'Album') {
          playingItem = playingItem.assoc;
        }
        var currentItem = this.objects[this.objectIndex];
        if (currentItem.assoc_type === 'Album') {
          currentItem = currentItem.assoc;
        }
        if (playingItem.id === currentItem.id) {
          return true;
        }
      }
      return false;
    }
  },

  created: function created() {
    // console.log(this.objects, this.objectIndex)
  },


  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])({
    setPlaylist: 'player/setPlaylist',
    setPlaylistIndex: 'player/setListIndex',
    setPlaying: 'player/setPlayingStatus'
  }), {
    dismissDownloadModal: function dismissDownloadModal() {
      this.showDownloadModal = false;
    },
    repostItem: function repostItem() {
      __WEBPACK_IMPORTED_MODULE_3__services_album__["a" /* default */].repostAlbum(this.item.id).then(function (response) {
        console.log(response);
      }).catch(function (e) {
        console.log(e);
      });
    },
    playSong: function playSong() {
      if (this.$store.state.player.isPaused) {
        this.$root.$emit(__WEBPACK_IMPORTED_MODULE_2__helper__["b" /* MyEvents */].AUDIO_PLAYER_REPLAY);
      } else {
        this.setPlaylist(this.objects);
        this.setPlaylistIndex(this.objectIndex);
        this.setPlaying(true);
        this.$root.$emit(__WEBPACK_IMPORTED_MODULE_2__helper__["b" /* MyEvents */].AUDIO_PLAYER_PLAY);
      }
    },
    pauseSong: function pauseSong() {
      this.$root.$emit(__WEBPACK_IMPORTED_MODULE_2__helper__["b" /* MyEvents */].AUDIO_PLAYER_PAUSE);
    },
    shareItem: function shareItem() {},
    flagItem: function flagItem() {},
    addComment: function addComment() {},
    addToPlaylist: function addToPlaylist() {},
    choosePage: function choosePage(path) {
      console.log(path);
      this.$router.push({ path: '/' + path });
    }
  })
});

/***/ }),
/* 875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    bgColor: {
      type: String,
      default: 'transparent'
    },
    loaderType: {
      type: String,
      default: 'linear'
    }
  },
  data: function data() {
    return {
      loadValue: 0,
      trackLoader: null,
      loaderWithhold: false
    };
  },

  computed: {
    loadStatus: function loadStatus() {
      return this.$store.getters['error/isLoading'];
    }
  },
  methods: {
    updateLoader: function updateLoader(val) {
      // update load value
      this.loadValue = val;
    }
  },
  watch: {
    loadStatus: function loadStatus(val) {
      var _this = this;

      if (!val) {
        // update load value to almost hundred
        this.loadValue = 99;

        // update load value too full after delay
        setTimeout(function () {
          _this.loadValue = 100;
        }, 500);

        // close and finish load experience
        clearInterval(this.trackLoader);
      }
    },
    loadValue: function loadValue(val) {
      var _this2 = this;

      // only run when loader is not in domant null state
      if (val !== null) {
        // by 0, means app loader has been triggered
        if (val === 0) {
          // IMPORTANT
          // fix glitch on brute back btn click
          clearInterval(this.trackLoader);

          // init loader
          this.trackLoader = setInterval(function () {
            _this2.loadValue += 10;
          }, 500);
        }

        // when load value is full
        if (val > 100) {
          clearInterval(this.trackLoader);
          this.loadValue = null;
          // this.trackLoader = null
        } else if (val === 100) {
          clearInterval(this.trackLoader);

          // reset loaderWithhold
          this.loaderWithhold = false;
        } else if (val > 50 && this.loadStatus === true) {
          // stop adding to loader value
          // means at this stage, api is still loading i.e loadStatus
          clearInterval(this.trackLoader);

          // re-init loader with lower pace
          this.trackLoader = setInterval(function () {
            _this2.loadValue += 5;
          }, 500);
        } else if (val > 60 && this.loadStatus === true) {
          // stop adding to loader value
          this.loaderWithhold = true;
          clearInterval(this.trackLoader);

          // withhold loader state
          // means at this stage, api is still loading i.e loadStatus
          if (this.loaderWithhold === true) {
            // re-init loader with lower pace
            this.trackLoader = setInterval(function () {
              _this2.loadValue += 1;
            }, 500);
          }
        }

        // emit load value to listener
        this.$emit('getLoadUpdate', val);
      }
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.trackLoader = setInterval(function () {
      _this3.loadValue += 10;
    }, 100);
  }
});

/***/ }),
/* 876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_userFollowBtn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_userFollowBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_userFollowBtn__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    UserFollowBtn: __WEBPACK_IMPORTED_MODULE_1__components_userFollowBtn___default.a
  },

  props: {
    artist: {
      type: Object
    }
  },

  data: function data() {
    return {
      PublicRelationsUsername: __WEBPACK_IMPORTED_MODULE_0__helper__["c" /* PublicRelationsUsername */],
      buttonHover: false
    };
  },


  computed: {
    currentUser: function currentUser() {
      return this.$store.state.auth.user;
    },
    followButtonText: function followButtonText() {
      if (this.artist.is_following) {
        return this.buttonHover ? "Unfollow" : "Following";
      }
      return "Follow";
    },
    followButtonVisible: function followButtonVisible() {
      return this.currentUser && this.currentUser.id !== this.artist.id && ["admin", "superadmin"].indexOf(this.artist.user_type) === -1 && this.artist.username !== __WEBPACK_IMPORTED_MODULE_0__helper__["c" /* PublicRelationsUsername */];
    },
    canViewProfile: function canViewProfile() {
      return ["admin", "superadmin"].indexOf(this.artist.user_type) === -1;
    }
  },

  created: function created() {},


  methods: {
    showMessageDialog: function showMessageDialog() {
      this.showSendMessage = true;
    },
    dismissMessageModal: function dismissMessageModal() {
      this.showSendMessage = false;
    },
    imageURL: function imageURL(item) {
      if (item.cover) {
        return item.cover.thumb.url;
      } else {
        return item.covers[0].cover.thumb.url;
      }
    },
    blockUser: function blockUser() {},
    afterFollow: function afterFollow(isfollowing) {
      if (isfollowing === "unfollow") {
        this.artist.is_following = false;
      } else if (isfollowing === "follow") {
        this.artist.is_following = true;
      }
    }
  }
});

/***/ }),
/* 877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_me__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_stream__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_video_components_attach_picker__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_video_components_attach_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__views_video_components_attach_picker__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    // assoc: {
    //   type: Object,
    //   required: true,
    // },
    customAlbums: {
      type: Array
    },
    customProducts: {
      type: Array
    },
    attachPickerTitle: String,
    ctaTitle: String
  },
  data: function data() {
    return {
      assoc: {},
      truncAttachment: [],
      show_attach_picker: false,
      albums: [],
      products: [],
      videos: []
    };
  },

  components: {
    AttachPicker: __WEBPACK_IMPORTED_MODULE_5__views_video_components_attach_picker___default.a
  },
  watch: {
    customAlbums: function customAlbums() {
      this.getAttachments();
    },
    customProducts: function customProducts() {
      this.getAttachments();
    }
  },
  methods: {
    removeAttach: function removeAttach() {
      this.assoc = {};
      this.$emit("getAttachment", this.assoc);
    },
    closeAttachPicker: function closeAttachPicker() {
      this.show_attach_picker = false;
    },
    selectAttachment: function selectAttachment(data) {
      this.assoc = data;

      this.$emit("getAttachment", data);
    },
    getBGUrl: function getBGUrl(attachment) {
      if (attachment.merchant && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(attachment.merchant).length) {
        return attachment.covers[0].cover.thumb.url;
      } else {
        return attachment.cover.thumb.url;
      }
    },
    getCustomClass: function getCustomClass(attachment) {
      if (attachment.album_type && attachment.album_type === "album") {
        return "attach_album";
      } else if (attachment.video_type) {
        return "attach_video";
      } else if (attachment.merchant && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(attachment.merchant).length) {
        return "attach_product";
      }
    },
    getAssocType: function getAssocType(attachment) {
      if (attachment.album_type && attachment.album_type === "album") {
        return "Album";
      } else if (attachment.video_type) {
        return "Video";
      } else if (attachment.merchant && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(attachment.merchant).length) {
        return "ShopProduct";
      }
    },
    shuffleData: function shuffleData(arr) {
      // let arr = [1,2,3]
      var newArr = [];
      var allIdx = arr.length - 1;
      var currentIdx = void 0;

      while (allIdx > -1) {
        currentIdx = Math.floor(Math.random() * arr.length);
        newArr[allIdx] = arr[currentIdx];
        allIdx--;
      }

      return newArr;
    },
    getAttachments: function getAttachments() {
      var _this = this;

      var vid_params = {
        genre_id: 0,
        only_follows: false,
        page: 1,
        per_page: 10
      };

      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_3__services_me__["a" /* default */].videoAttachAlbums(), __WEBPACK_IMPORTED_MODULE_3__services_me__["a" /* default */].videoAttachProducts(), __WEBPACK_IMPORTED_MODULE_4__services_stream__["a" /* default */].getStreams(vid_params)] // take further appro. look at data from backend
      ).then(function (values) {
        _this.albums = _this.customAlbums || values[0].body;
        _this.products = _this.customProducts || values[1].body;
        _this.videos = values[2].body.streams;

        var all = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this.albums), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this.products), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this.videos));
        _this.truncAttachment = _this.shuffleData(all).slice(0, 12);
        console.log(_this.truncAttachment);
      }).catch(function (reason) {
        console.log(reason);
        _this.$store.dispatch("error/showErrorToast", [reason]);
      });
    }
  },
  computed: {
    attachCover: function attachCover() {
      switch (this.assoc.type) {
        case "ShopProduct":
          return this.assoc.value.covers[0].cover.thumb.url;
        case "Album":
          return this.assoc.value.cover.thumb.url;
        default:
          break;
      }
    }
  },
  created: function created() {
    this.getAttachments();
  }
});

/***/ }),
/* 878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    keyword: [String, Number],
    options: Array,
    identifier: String,
    itemName: String
  },
  data: function data() {
    return {
      current: null,
      showPanel: false
    };
  },

  watch: {
    options: function options(val) {
      if (val.length) {
        this.setCurrent();
      }
    },
    keyword: function keyword() {
      this.showPanel = true;
    },
    showPanel: function showPanel(val) {
      console.log(val);
    }
  },
  methods: {
    selectOption: function selectOption(option) {
      var _this = this;

      // Bug: had to combine bothe false instance
      this.showPanel = false;
      this.$nextTick(function () {
        _this.showPanel = false;
      });

      this.$emit("selected", this.identifier, option);
    },
    setCurrent: function setCurrent() {
      if (this.options.length) {
        this.current = this.options[0];
      }
    }
  },
  destroyed: function destroyed() {
    this.showPanel = false;
  }
});

/***/ }),
/* 879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    image: String,
    imageLink: String,
    roundImage: Boolean,
    title: String,
    titleLink: String,
    subtitle: String,
    description: String,
    meta: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },

  computed: {
    imageRounded: function imageRounded() {
      return this._.get(this.meta, 'type') === 'user';
    }
  }
});

/***/ }),
/* 880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      dialog: false,
      typeQR: __WEBPACK_IMPORTED_MODULE_0__helper__["e" /* QrCodeTypeList */].IOS,
      qrCodeTypeList: __WEBPACK_IMPORTED_MODULE_0__helper__["e" /* QrCodeTypeList */]
    };
  },

  methods: {
    openQrCode: function openQrCode(type) {
      this.typeQR = type;
      this.dialog = true;
    }
  }
});

/***/ }),
/* 881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_comment__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ItemSwipe__ = __webpack_require__(1571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ItemSwipe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_ItemSwipe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_user_tag__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_user_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_user_tag__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    items: Array,
    hideDatedString: Boolean,
    showShortAge: Boolean
  },
  components: {
    ItemSwipe: __WEBPACK_IMPORTED_MODULE_2__components_ItemSwipe___default.a,
    UserTag: __WEBPACK_IMPORTED_MODULE_3__components_user_tag___default.a
  },
  data: function data() {
    return {
      toLocalTimeString: __WEBPACK_IMPORTED_MODULE_0__helper__["f" /* Utils */].toLocalTimeString
    };
  },

  methods: {
    deleteComment: function deleteComment() {
      var _this = this;

      var comment = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.coment.id;

      __WEBPACK_IMPORTED_MODULE_1__services_comment__["a" /* default */].deleteComment(comment.id).then(function (response) {
        _this.$store.dispatch("error/showSuccessToast", ["Comment Deleted"]);
      }).catch(function (e) {
        _this.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    }
  },
  computed: {
    onMobile: function onMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    }
  }
});

/***/ }),
/* 882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__usermodal__ = __webpack_require__(1575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__usermodal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__usermodal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_user__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['admin', 'room'],
  components: {
    UserModal: __WEBPACK_IMPORTED_MODULE_1__usermodal___default.a
  },
  data: function data() {
    return {
      rules: {
        number: function number(value) {
          var pattern = /^(0|[1-9][0-9]*)$/;
          if (value === '') return 'Please enter a number.';
          if (!pattern.test(value)) return 'Please enter a number.';
          if (!(parseInt(value) <= 500 && parseInt(value) >= 1)) {
            return 'Please enter a number between 1-500';
          }
          return true;
        }
      },
      onlineUsers: [],
      idleUsers: []
    };
  },

  watch: {
    room: function room(r) {
      var that = this;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(that.room.online.map(function (e) {
        if (e) return __WEBPACK_IMPORTED_MODULE_2__services_user__["a" /* default */].getUserInfo(e);
      })).then(function (v) {
        that.onlineUsers = v;
      });
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(that.room.idle.map(function (e) {
        if (e) return __WEBPACK_IMPORTED_MODULE_2__services_user__["a" /* default */].getUserInfo(e);
      })).then(function (v) {
        that.idleUsers = v;
      });
    },

    deep: true
  }
});

/***/ }),
/* 883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["user"],
  methods: {},
  data: function data() {
    return {
      x: -85,
      y: 40
    };
  }
});

/***/ }),
/* 884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_user_tag__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_user_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_user_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_comment__ = __webpack_require__(50);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    item: Object,
    roundInput: Boolean,
    noBorder: Boolean,
    placeholder: {
      type: String,
      default: 'Leave a comment...'
    },
    aviHeight: {
      type: [String, Number]
    },
    aviWidth: {
      type: [String, Number]
    }
  },
  components: {
    UserTag: __WEBPACK_IMPORTED_MODULE_0__components_user_tag___default.a
  },
  data: function data() {
    return {
      commentText: ''
    };
  },

  computed: {
    currentUser: function currentUser() {
      return this.$store.state.auth.user;
    }
  },
  watch: {},
  methods: {
    addComment: function addComment() {
      var _this = this;

      if (this.commentText === '') return;

      var params = {
        comment: {
          commentable_type: 'Stream',
          commentable_id: this.item.id,
          body: this.commentText,
          status: 'published'
        }
      };

      __WEBPACK_IMPORTED_MODULE_1__services_comment__["a" /* default */].sendComment(params).then(function (res) {
        _this.comments.unshift(res.body);
        _this.commentText = '';
      }).catch(function (e) {
        _this.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    }
  }
});

/***/ }),
/* 885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    absolute: Boolean,
    height: {
      default: '71'
    }
  }
});

/***/ }),
/* 886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "DashboardItem",
  props: {
    title: {
      type: String,
      default: ""
    },
    number: {
      type: String | Number,
      default: ""
    }
  }
});

/***/ }),
/* 887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "DonutChart",
  data: function data() {
    return {
      series: [44, 55],
      chartOptions: {
        chart: {
          type: "donut"
        }
      }
    };
  }
});

/***/ }),
/* 888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "LineChart",
  data: function data() {
    return {
      series: [{
        name: "Line",
        data: [10, 41, 35, 51, 49, 62, 69, 91, 148, 200, 500, 150]
      }],
      chartOptions: {
        chart: {
          height: 350,
          type: "line",
          zoom: {
            enabled: false
          },
          toolbar: {
            show: false
          }
        },
        stroke: {
          curve: "smooth"
        },
        grid: {
          show: false
        },
        xaxis: {
          categories: ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"],
          labels: {
            style: {
              colors: "#838383",
              fontFamily: "Inter",
              fontWeight: 500
            }
          },
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false
          }
        },
        yaxis: {
          labels: {
            style: {
              colors: "#838383",
              fontFamily: "Inter",
              fontWeight: 600
            }
          }
        }
      }
    };
  }
});

/***/ }),
/* 889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_contentTopHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_contentTopHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_contentTopHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_searchInput__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_searchInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_searchInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_genre_dialog__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_genre_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_genre_dialog__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    pageName: String,
    searchShow: Boolean,
    filterShow: String
  },
  components: {
    contentTopHeader: __WEBPACK_IMPORTED_MODULE_0__components_contentTopHeader___default.a,
    SearchInput: __WEBPACK_IMPORTED_MODULE_1__components_searchInput___default.a,
    genreDialog: __WEBPACK_IMPORTED_MODULE_2__components_genre_dialog___default.a
  },
  data: function data() {
    return {
      keyword: "",
      activeTab: '',
      tabs: [{ id: 'music', title: 'RELEASES' }],
      show_genre_selector_dialog: false,
      got_genre_tooltip: false,
      hover_on_genre_button: false,
      hover_on_genre_tooltip: false
    };
  },

  computed: {
    onMobile: function onMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    currentUser: function currentUser() {
      return this.$store.state.auth.user;
    },
    showGenreTooltip: function showGenreTooltip() {
      return !this.got_genre_tooltip && (this.hover_on_genre_button || this.hover_on_genre_tooltip);
    }
  },
  methods: {
    closeGenreSelectorDialog: function closeGenreSelectorDialog() {
      this.show_genre_selector_dialog = false;
      this.setTab(this.activeTab);
    },
    openGenreSelectorDialog: function openGenreSelectorDialog() {
      this.show_genre_selector_dialog = true;
    },
    isActiveTab: function isActiveTab(tab) {
      return this.activeTab === tab;
    },
    onTab: function onTab(tab) {
      this.activeTab = tab;
      if (tab === 'music') {
        this.$router.push({ name: 'AlbumIndex' });
      }
    }
  },
  created: function created() {
    if (this.pageName) {
      this.activeTab = this.pageName;
    }
  }
});

/***/ }),
/* 890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_user_tag__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_user_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_user_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_mobile_auth_onboarding_authPlan__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_mobile_auth_onboarding_authPlan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_mobile_auth_onboarding_authPlan__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import AuthPlan from "@/views/mobile/auth/onboarding/authPlan"


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    type: {
      default: "type1",
      type: String
    }
  },
  components: {
    UserTag: __WEBPACK_IMPORTED_MODULE_2__components_user_tag___default.a,
    AuthPlan: __WEBPACK_IMPORTED_MODULE_3__views_mobile_auth_onboarding_authPlan___default.a
  },
  data: function data() {
    return {
      iosStore: __webpack_require__(311),
      androidPlaystore: __webpack_require__(312),
      showPlan: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    isiOS: "app/isiOS",
    isAndroid: "app/isAndroid"
  }), {
    mobileDeviceType: function mobileDeviceType() {
      return this.isiOS ? "ios" : this.isAndroid ? "android" : null;
    },
    renderQR: function renderQR() {
      var iOSQR = __webpack_require__(594);
      // TODO update Androiid QR SVG
      var androidQR = __webpack_require__(594);

      if (this.isAndroid) {
        return androidQR;
      }

      return iOSQR;
    },
    altText: function altText() {
      if (this.isAndroid) {
        return "download yousound android qr code";
      }

      return "download yousound ios qr code";
    },
    currentUser: function currentUser() {
      return this.$store.state.auth.user;
    },
    userImage: function userImage() {
      return this.currentUser.avatar.url;
    }
  })
});

/***/ }),
/* 891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_album__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_track__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_user__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_paymentmodal__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_paymentmodal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_paymentmodal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_userFollowBtn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_userFollowBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_userFollowBtn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helper__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







// import { Utils } from '@/helper'


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    PaymentModal: __WEBPACK_IMPORTED_MODULE_4__components_paymentmodal___default.a,
    UserFollowBtn: __WEBPACK_IMPORTED_MODULE_5__components_userFollowBtn___default.a
  },

  props: {
    item: {
      type: Object,
      required: true
    },

    track: {
      type: Object
    },

    dismiss: {
      type: Function,
      required: true
    }
  },

  data: function data() {
    return {
      donate_amount: 0,
      showPaymentModal: false,
      buttonHover: false
    };
  },


  computed: {
    currentUser: function currentUser() {
      return this.$store.state.auth.user;
    },
    trackUser: function trackUser() {
      if (this.item.album_type === "album") {
        return this.item.user;
      } else {
        return this.track ? this.track.user : this.item.user;
      }
    },
    coverUrl: function coverUrl() {
      if (this.track) {
        return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(this.track, "album.cover.url");
      } else {
        return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(this.item, "cover.url");
      }
    },
    donate_amount_by_cent: function donate_amount_by_cent() {
      return this.donate_amount * 100;
    }
  },

  created: function created() {},


  methods: {
    donateAmount: function donateAmount(amount) {
      this.donate_amount = amount;
    },
    afterFollow: function afterFollow(isfollowing) {
      if (isfollowing === "unfollow") {
        this.track.user.is_following = false;
      } else if (isfollowing === "follow") {
        this.track.user.is_following = true;
      }
    },
    showPaymentDialog: function showPaymentDialog() {
      if (this.donate_amount > 0) {
        this.showPaymentModal = true;
      } else {
        this.downloadItem();
      }
    },
    hidePaymentDialog: function hidePaymentDialog() {
      this.showPaymentModal = false;
    },
    downloadItem: function downloadItem() {
      var _this = this;

      this.dismiss();
      if (this.track) {
        __WEBPACK_IMPORTED_MODULE_2__services_track__["a" /* default */].downloadTrack(this.track.id);

        var a = document.createElement("A");
        a.href = this.track.audio_download_url;
        a.download = "";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        // window.download(this.track.audio.url, Utils.getFilenameWithExtension(this.track.name)
        // const filename = Utils.getFilenameWithExtension(this.track.name)
        // window.jQuery.ajax({
        //   url: this.track.audio.url,
        //   dataType: 'binary',
        //   success: window.download.bind(true, 'application/octet-stream', filename)
        // })
      } else {
        __WEBPACK_IMPORTED_MODULE_1__services_album__["a" /* default */].downloadAlbum(this.item.id).then(function (response) {
          // this.$store.dispatch('error/showSuccessToast', ['You just download ' + this.item.name])
          var a = document.createElement("A");
          a.href = response.body.url;
          a.download = "";
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }).catch(function (e) {
          _this.$store.dispatch("error/showErrorToast", e.body.errors || [e.body]);
        });
      }
    },
    sendLove: function sendLove(token) {
      var _this2 = this;

      this.dismiss();
      var params = {
        amount: this.donate_amount_by_cent,
        description: "Donation"
      };
      if (token) {
        params["payment_token"] = token.id;
      }
      __WEBPACK_IMPORTED_MODULE_3__services_user__["a" /* default */].donateMoney(this.trackUser.slug, params).then(function (response) {
        _this2.$store.dispatch("error/showSuccessToast", ["You've sent user $" + __WEBPACK_IMPORTED_MODULE_6__helper__["a" /* Filter */].formatNumber(_this2.donate_amount_by_cent)]);
        _this2.downloadItem();
      }).catch(function (e) {
        _this2.$store.dispatch("error/showErrorToast", e.body.errors || [e.body]);
      });
    }
  }
});

/***/ }),
/* 892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuedraggable__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuedraggable__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global $:true */




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    draggable: __WEBPACK_IMPORTED_MODULE_1_vuedraggable___default.a
  },
  props: {
    album: {
      type: Object
    },

    accept: {
      type: String,
      default: '*/*'
    },

    category: {
      type: String
    },

    autoUpload: {
      type: Boolean,
      default: true
    }
  },

  data: function data() {
    return {
      show_unauthorized_content_dialog: false,
      show_duplicate_content_dialog: false,
      currentFile: {
        track_title: '',
        artist_name: ''
      },
      status: {
        uploading: 1,
        success: 2,
        failed: 3
      },
      currentStatus: null,
      uploadFieldName: 'files'
    };
  },


  computed: {
    // dragDisabled() {
    //   const hasEditing = _.find(this.album.tracks, (file) => (file.editing)) == null
    //   // console.log('dragDisabled', !hasEditing)
    //   return !hasEditing
    // }
  },

  created: function created() {},


  methods: {
    fileIsPicked: function fileIsPicked(status, fileList) {
      if (status) this.$emit('filePicked', fileList);
    },
    cancelTrack: function cancelTrack() {
      var _this = this;

      var idx = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.findIndex(this.album.tracks, function (f) {
        return f === _this.currentFile;
      });
      // console.log('cancelTrack', idx)
      if (idx > -1) {
        this.deleteTrack(idx);
      }

      if (this.show_unauthorized_content_dialog) {
        this.show_unauthorized_content_dialog = false;
      }

      if (this.show_duplicate_content_dialog) {
        this.show_duplicate_content_dialog = false;
      }
    },
    filesChange: function filesChange(fileList) {
      var file_list = [];
      for (var i = 0; i < fileList.length; i++) {
        var f = fileList[i];
        // Min. 160k
        if (f.size / 1000 < 160 && this.category !== 'product') {
          this.$store.dispatch('error/showErrorToast', ['File size too small, must be at least 160k']);
        } else {
          file_list.push(f);
        }
      }
      if (file_list.length) this.fileIsPicked(true, file_list);
    },
    enableEditing: function enableEditing(file) {
      // console.log('enableEditing', file)
      file.editing = true;
    },
    disableEditing: function disableEditing(file) {
      // console.log('disableEditing', file)
      file.editing = false;
    },
    onInputFocus: function onInputFocus(index, evt) {
      // console.log('focus', $(evt.target).val())
      evt.target.select();
    },
    onInputBlur: function onInputBlur(index, evt) {
      // console.log('blur', index, $(evt.target).val())
      // this.disableEditing(this.album.tracks[index])
      this.updateTrack(index);
    },
    deleteAttachedVideo: function deleteAttachedVideo() {
      document.querySelector('#file').value = '';
    }
  },

  mounted: function mounted() {
    var vm = this;
    var uploaderBox = $('.uploaderBox');
    uploaderBox.on('drag dragstart dragend dragover dragenter dragleave drop', function (e) {
      e.preventDefault();
      e.stopPropagation();
    }).on('dragover dragenter', function () {
      uploaderBox.addClass('is-dragover');
    }).on('dragleave dragend drop', function () {
      uploaderBox.removeClass('is-dragover');
    }).on('drop', function (e) {
      var droppedFiles = e.originalEvent.dataTransfer.files;

      // Register files on dom input after dropping
      document.querySelector('#file').files = droppedFiles;
      vm.filesChange(droppedFiles);
    });
  }
});

/***/ }),
/* 893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  methods: {
    learnMore: function learnMore() {
      this.$store.dispatch('auth/setFirstVisit', false);
      this.$router.push({
        path: '/settings#bank-details'
      });
    }
  }
});

/***/ }),
/* 894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    hideDownload: Boolean
  }
});

/***/ }),
/* 895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    minHeight: {
      type: [String, Number],
      default: 275
    },
    mode: {
      type: String,
      default: "swipe"
    }
  },
  computed: {
    isSwipe: function isSwipe() {
      return this.mode === "swipe";
    },
    isGrid: function isGrid() {
      return this.mode === "grid";
    }
  }
});

/***/ }),
/* 896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "CRow",
  props: ["title", "title2", "ctaAction", "ctaText", "imgSrc", "order2", "order1", "fullWidth", "bigImage", "moneyImage", "coverxspace"]
});

/***/ }),
/* 897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "CommonSection",
  props: ["title", "title2", "title3", "title4", "imgSrc", "imgSrc1", "order2", "order1", "order3", "order4", "bg", "list1", "list2"]
});

/***/ }),
/* 898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "TimeLine",
  data: function data() {
    return {
      timelines: [{
        date: "Q1 - 2018",
        title: "Journey to creative sustainability",
        text: ["\n                YouSound set out to be the best platform for creators to grow\n                their audience and sustain their careers using ethical tools\n                and transparency built into the platform itself.", "We bootstrapped every aspect of this platform and self\n                funded the platform with a network of independent artists,\n                creators & entrepreneurs. Since then, we\u2019ve turned down\n                millions of dollars from VCs to maintain the trajectory of our\n                mission. The first line of code was the start of our journey. "]
      }, {
        date: "Q1 - 2021",
        title: "Public Beta",
        text: ["While the first official line of code was written in 2018, the idea and road actually started in 2006, we\u2019ve quietly come a long way.", "Launching our app was a huge milestone.  Thousands of people have signed up through word of mouth and we\u2019ve listened to all of the feedback & fine tuned everything to prepare for our public launch in 2022."]
      }, {
        date: "Q2 - 2022",
        title: "Public Launch",
        text: ["We did it!  \uD83C\uDF89 \uD83C\uDF89", "Over 1 million lines of code and years of testing, this launch represents all of our core ideas we initially set out to build.  We are now focusing on finalizing our ad monetization features to have ready for Q4 of 2022.  The hard times might seem behind us, but we\u2019re ready to thug it out as long as we have to."]
      }, {
        date: "Q4 - 2022",
        title: "YouSound Partners Launch",
        text: ["We first started this platform solely as a place for artists to buy & sell but over the years streaming became the main way that people consume content.  Streaming has been unfair for most creators, that\u2019s why we\u2019re making sure creators take the lions share of revenue we generate.", "We\u2019ve come up with an innovative way that allow creators to make a liveable income without needing tons of streams. We will provide more info about how we do this later in the year.  In the meantime, join the community and spread the word, the new renaissance is upon us.", "\uD83D\uDE80"]
      }]
    };
  }
});

/***/ }),
/* 899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Banner",
  props: ["title", "title2", "title3"]
});

/***/ }),
/* 900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_landing3_cardModal_vue__ = __webpack_require__(1583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_landing3_cardModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_landing3_cardModal_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Plan",
  props: {
    plan: Object
  },
  components: {
    cardModal: __WEBPACK_IMPORTED_MODULE_0__components_landing3_cardModal_vue___default.a
  },
  data: function data() {
    return {
      showCardModal: false,
      priceId: null,
      isPageReady: false
    };
  },

  methods: {
    openPaymentDialog: function openPaymentDialog() {
      this.showCardModal = true;
    },
    closePaymentDialog: function closePaymentDialog() {
      this.showCardModal = false;
    }
  }
});

/***/ }),
/* 901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Plan_vue__ = __webpack_require__(1581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Plan_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Plan_vue__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { Plan: __WEBPACK_IMPORTED_MODULE_2__Plan_vue___default.a },
  name: "Plans",
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])({
    plansData: function plansData(state) {
      return state.app.plansData;
    }
  }))
});

/***/ }),
/* 902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_stripe_elements__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_stripe_elements___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_stripe_elements__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_subscription_js__ = __webpack_require__(47);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    amount: {
      type: String
    },
    stripePriceId: {
      type: String
    },
    dismiss: {
      type: Function,
      required: true
    }
  },
  data: function data() {
    return {
      complete: false,
      number: false,
      expiry: false,
      cvc: false,
      fee: 0,
      loading: true,
      stripePubkey: "pk_live_fXEdJ0v6E2ROxT8rufDCby12",
      options: {},
      finalAmount: 0
    };
  },

  components: { CardNumber: __WEBPACK_IMPORTED_MODULE_0_vue_stripe_elements__["CardNumber"], CardExpiry: __WEBPACK_IMPORTED_MODULE_0_vue_stripe_elements__["CardExpiry"], CardCvc: __WEBPACK_IMPORTED_MODULE_0_vue_stripe_elements__["CardCvc"], createToken: __WEBPACK_IMPORTED_MODULE_0_vue_stripe_elements__["createToken"] },
  computed: {
    currentUser: function currentUser() {
      return this.$store.state.auth.user;
    },
    receiverAvatar: function receiverAvatar() {
      return this._.get(this.receiver, 'avatar.thumb.url');
    },
    receiverName: function receiverName() {
      return this._.get(this.receiver, 'display_name', 'Receiver');
    }
  },
  created: function created() {
    this.loading = true;
    this.show_error_dialog = false;
    this.$store.dispatch('error/showLoadingActivity', true);
    console.log("created....");
    this.fee = __WEBPACK_IMPORTED_MODULE_1__helper__["d" /* Stripe */].calculateSubFee(this.amount);
    var finalAmount = parseFloat(this.fee) + parseFloat(this.amount);
    this.finalAmount = finalAmount.toFixed(2);
    console.log("finalAmount====>", finalAmount);
  },

  methods: {
    update: function update() {
      this.complete = this.number && this.expiry && this.cvc;
      console.log("stripePriceId==>", this.stripePriceId, this.amount, this.fee);
      // field completed, find field to focus next
      if (this.number) {
        if (!this.expiry) {
          this.$refs.cardExpiry.focus();
        } else if (!this.cvc) {
          this.$refs.cardCvc.focus();
        }
      } else if (this.expiry) {
        if (!this.cvc) {
          this.$refs.cardCvc.focus();
        } else if (!this.number) {
          this.$refs.cardNumber.focus();
        }
      }
      // no focus magic for the CVC field as it gets complete with three
      // numbers, but can also have four
    },
    paymentMethod: function paymentMethod() {
      var _this = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_stripe_elements__["createToken"])().then(function (data) {
        _this.subscribe(_this.stripePriceId, data.token);
        _this.dismiss();
      });
    },
    subscribe: function subscribe(priceId, tokenResponse) {
      var _this2 = this;

      this.$store.dispatch('error/showLoadingActivity', true);
      console.log("priceId===>", this.stripePriceId, this.amount, tokenResponse, tokenResponse.id);
      __WEBPACK_IMPORTED_MODULE_2__services_subscription_js__["a" /* default */].createSubscription({ price_id: priceId, token_id: tokenResponse.id, token_response: tokenResponse }).then(function (response) {
        console.log("==response==", response);

        _this2.$store.dispatch('error/showLoadingActivity', false);
        _this2.$router.push({ name: 'AlbumIndex' });
        _this2.$store.dispatch('error/showSuccessToast', response.body.message);
      }).catch(function (e) {
        _this2.$store.dispatch('error/showLoadingActivity', false);
        _this2.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    }
  },
  watch: {
    number: function number() {
      this.update();
    },
    expiry: function expiry() {
      this.update();
    },
    cvc: function cvc() {
      this.update();
    }
  }
});

/***/ }),
/* 903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Banner",
  props: ["title", "imgSrc"]
});

/***/ }),
/* 904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Footer",
  computed: {
    onMobile: function onMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    }
  },
  data: function data() {
    return {
      aboutLinks: [{ text: "Discover", route: "/yousound#video" }, { text: "Download apps", route: "/yousound#video" }, {
        text: "Case studies",
        ext: true,
        route: "https://support.yousound.com/en/collections/2401816-careers"
      }],
      companyLinks: [{ text: "About", route: "/terms#privacy_policy" }, { text: "Careers", route: "/terms#terms_of_use" }, { text: "Terms", ext: true, route: "https://support.yousound.com/" }, { text: "Privacy", ext: true, route: "https://support.yousound.com/" }],
      supportLinks: [{ text: "Help Center", route: "/terms#privacy_policy" }, { text: "FAQ", route: "/terms#terms_of_use" }, {
        text: "Server Status",
        ext: true,
        route: "https://support.yousound.com/"
      }, {
        text: "Report a bug",
        ext: true,
        route: "https://support.yousound.com/"
      }]
    };
  }
});

/***/ }),
/* 905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Footer",
  data: function data() {
    return {
      aboutLinks: [{ text: "Podcast", route: "/yousound#video" }, { text: "Career", ext: true, route: "https://support.yousound.com/en/collections/2401816-careers" }],
      companyLinks: [{ text: "Privacy", route: "/terms#privacy_policy" }, { text: "Terms", route: "/terms#terms_of_use" }, { text: "Support", ext: true, route: "https://support.yousound.com/" }]
    };
  }
});

/***/ }),
/* 906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import Popup from './Popup.vue'
/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      drawer: false,
      links: [{ text: "Artists & Brands", route: "Creators" }, { text: "Go Ad-Free", route: "AdFree" }]
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    isAuthenticated: "auth/isAuthenticated"
  }))
});

/***/ }),
/* 907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Join",
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    isAuthenticated: "auth/isAuthenticated"
  }))
});

/***/ }),
/* 908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_auth__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_playlist__ = __webpack_require__(94);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    dismiss: {
      type: Function,
      required: true
    }
  },

  data: function data() {
    return {
      remember: false,
      user: {
        email: '',
        password: ''
      }
    };
  },


  computed: {},

  created: function created() {
    var user = __WEBPACK_IMPORTED_MODULE_0__services_auth__["a" /* default */].loadCredential();
    if (user !== null) {
      this.user = user;
    } else {
      this.user = {
        email: '',
        password: ''
      };
    }
  },


  methods: {
    choosePage: function choosePage(path) {
      this.dismiss();
      this.$router.push({ path: '/' + path });
    },
    submit: function submit() {
      var _this = this;

      this.$store.dispatch('error/showLoadingActivity', true);
      __WEBPACK_IMPORTED_MODULE_0__services_auth__["a" /* default */].login(this.user).then(function (response) {
        _this.dismiss();
        _this.$store.dispatch('error/showLoadingActivity', false);
        if (_this.remember) {
          __WEBPACK_IMPORTED_MODULE_0__services_auth__["a" /* default */].saveCredential(_this.user);
        }
        __WEBPACK_IMPORTED_MODULE_0__services_auth__["a" /* default */].setTokenAndUserInfo(response.body);

        if (response.body.sign_in_count <= 1) {
          _this.$store.dispatch('auth/setFirstVisit', true);
        }

        __WEBPACK_IMPORTED_MODULE_1__services_playlist__["a" /* default */].getPlaylists().then(function (response) {
          _this.$store.dispatch('playlist/setPlaylists', response.body);
          _this.$router.push({ path: '/album' });
        });
      }).catch(function (e) {
        _this.$store.dispatch('error/showLoadingActivity', false);
        _this.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    }
  }
});

/***/ }),
/* 909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_profileitem__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_profileitem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_profileitem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_item__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_product__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_user_tag__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_user_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_user_tag__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    profileItem: __WEBPACK_IMPORTED_MODULE_1__components_profileitem___default.a,
    UserTag: __WEBPACK_IMPORTED_MODULE_4__components_user_tag___default.a
  },

  props: {
    item: {
      type: Object,
      required: true
    },
    shareProduct: {
      type: Function
    },
    dismiss: {
      type: Function,
      required: true
    }
  },

  data: function data() {
    return {
      selectedCover: null,
      product_categories: [],
      buttonHover: false,
      option: null,
      showPolicySection: false
    };
  },


  computed: {
    initImgSelection: function initImgSelection() {
      console.log(this.covers);
      return this.covers[0];
    },
    covers: function covers() {
      var imgs = this.item.covers || [];
      var covers = [];
      imgs.forEach(function (img) {
        if (img.cover.url) {
          covers.push(img.cover.url);
        }
      });

      // imgs = [
      //   'https://d19mruzykfu6hg.cloudfront.net/uploads/shop_product_cover/cover/125/523b9cda-b1a7-4cf0-9fe2-619c63a15f34.jpg',
      //   'https://d19mruzykfu6hg.cloudfront.net/uploads/album/cover/42/b5fe3a4c-4221-402d-ab22-4b1a52e474ac.jpg',
      //   'https://d19mruzykfu6hg.cloudfront.net/uploads/album/cover/33/73c40199-a5ac-463e-9154-09581f92c987.jpg',
      // ]

      // return imgs
      return covers;
    },
    user: function user() {
      if (this.item.slug) {
        return this.item.user;
      } else {
        return this.item.merchant;
      }
    },
    currentUser: function currentUser() {
      return this.$store.state.auth.user;
    },
    productCategoryName: function productCategoryName() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(this.product_categories, function (pc) {
        return pc.id === _this.item.category;
      }), 'name', '');
    },
    policyButtonText: function policyButtonText() {
      return this.showPolicySection ? "Close" : "Size Chart & Seller Policies";
    },
    isDigitalProduct: function isDigitalProduct() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(this.item, "category.is_digital", false);
    },
    options: function options() {
      var options = [];
      // const defaultOption = {
      //   id: '',
      //   name: '-----'
      // }
      // options.push(defaultOption)
      for (var index in this.item.variants) {
        var variant = this.item.variants[index];
        if (this.isDigitalProduct || variant.quantity > 0) {
          var option = {
            id: variant.id,
            name: variant.name
          };
          options.push(option);
        }
      }
      return options;
    },
    price: function price() {
      if (this.option !== "") {
        for (var index in this.item.variants) {
          var variant = this.item.variants[index];
          if (variant.id === this.option) {
            return variant.price;
          }
        }
      }
      return this.item.price;
    },
    canAdd: function canAdd() {
      var stripe_connected = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(this.item, "merchant.stripe_connected", false);
      var product_stock_status = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(this.item, "stock_status", "inactive");
      return this.option === "" || this.option === null || !stripe_connected || product_stock_status !== "active";
    }
  },

  created: function created() {
    // this.option = _.get(_.find(this.item.variants, (v) => (v.quantity > 0)), 'id', null)
    this.option = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(this.options, "[0].id", null);
  },


  watch: {
    initImgSelection: {
      handler: function handler(newVal, oldVal) {
        this.selectedCover = newVal;
      },

      immediate: true
    }
  },

  methods: {
    changeFeaturedImage: function changeFeaturedImage(img) {
      if (this.selectedCover == null) {
        this.selectedCover = this.initImgSelection;
      } else {
        this.selectedCover = img;
      }
    },
    addToCart: function addToCart() {
      var _this2 = this;

      if (this.option === "" || this.option === null) {
        this.$store.dispatch("error/showErrorToast", ["Please select valid variant."]);
      } else {
        var pageTrack = "";
        if (this.$store.state.streamPlayer.frame_mode === "full") {
          var streamId = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(this.$store.state.streamPlayer.stream, "id", "");
          if (streamId !== "") {
            pageTrack = "Stream: " + streamId;
          }
        }
        var params = {
          product_variant_id: this.option,
          quantity: 1,
          page_track: pageTrack
        };
        __WEBPACK_IMPORTED_MODULE_2__services_item__["a" /* default */].addToCart(params).then(function (response) {
          if (response.body.errors) {
            _this2.$store.dispatch("error/showErrorToast", response.body.errors);
          } else {
            _this2.dismiss();
            _this2.$store.dispatch("error/showSuccessToast", ["Added successfully to Cart."]);
          }
        }).catch(function (e) {
          _this2.$store.dispatch("error/showErrorToast", e.body.errors || [e.body]);
        });
      }
    },
    repostProduct: function repostProduct() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_3__services_product__["a" /* default */].repostProduct(this.item.id).then(function (response) {
        if (response.body.errors) {
          _this3.$store.dispatch("error/showErrorToast", response.body.errors);
        } else {
          _this3.$store.dispatch("error/showSuccessToast", ["You just reposted " + _this3.item.name]);
        }
      }).catch(function (e) {
        _this3.$store.dispatch("error/showErrorToast", e.body.errors || [e.body]);
      });
    },
    togglePolicy: function togglePolicy() {
      this.showPolicySection = !this.showPolicySection;
    },
    zoomOut: function zoomOut() {
      console.log("test");
    }
  }
});

/***/ }),
/* 910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_howler__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_howler___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_howler__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_album__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_comment__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_track__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_downloadmodal__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_downloadmodal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_downloadmodal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_sharemodal__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_sharemodal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_sharemodal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_user_tag__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_user_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_user_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_mobile_components_mobileComments__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_mobile_components_mobileComments___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__views_mobile_components_mobileComments__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_trackcardsimple__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_trackcardsimple___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_trackcardsimple__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_userFollowBtn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_userFollowBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_userFollowBtn__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







// import PaymentService from '@/services/payment'









var ActionCable = __webpack_require__(52);

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    isMini: Boolean,
    isPlayerOpened: Boolean
  },

  components: {
    downloadModal: __WEBPACK_IMPORTED_MODULE_11__components_downloadmodal___default.a,
    shareModal: __WEBPACK_IMPORTED_MODULE_12__components_sharemodal___default.a,
    UserTag: __WEBPACK_IMPORTED_MODULE_13__components_user_tag___default.a,
    mobileComments: __WEBPACK_IMPORTED_MODULE_14__views_mobile_components_mobileComments___default.a,
    trackcardsimple: __WEBPACK_IMPORTED_MODULE_15__components_trackcardsimple___default.a,
    UserFollowBtn: __WEBPACK_IMPORTED_MODULE_16__components_userFollowBtn___default.a
  },

  data: function data() {
    return {
      optionModalActive: false,
      modalMode: false,
      playlist: [],
      index: 0,
      isLoaded: false,
      isRepeated: false,
      isPlaying: false,
      trackIndex: null,
      trackName: null,
      track: {},
      playedTime: 0,
      progress: 0,
      volume: 100,
      lastVolume: 100,
      showDownloadModal: false,
      showShareModal: false,
      showReminder: false,
      totalTime: null,
      buttonHover: false,
      showCredit: false,
      comments: [],
      cable: null,
      comments_subscription: null,
      comment_pagination: {
        count: 0,
        current_page: 0,
        per_page: 5,
        total_count: 0,
        total_pages: 0
      }
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])({
    reminderTracksCount: "app/reminderTracksCount"
  }), {
    coverThumbImageURL: function coverThumbImageURL() {
      if (this.item.cover) {
        return this.item.cover.thumb.url + "?" + new Date();
      } else {
        return "";
      }
    },
    currentUser: function currentUser() {
      return this.$store.state.auth.user;
    },
    MyEvents: function MyEvents() {
      return __WEBPACK_IMPORTED_MODULE_10__helper__["b" /* MyEvents */];
    },


    item: {
      cache: false,
      get: function get() {
        var item = this.$store.state.player.list[this.$store.state.player.listIndex];

        if (!item) {
          return null;
        }

        if (item.assoc_type) {
          return item.assoc;
        } else {
          return item;
        }
      }
    },
    user: function user() {
      if (!this.item) {
        return null;
      }

      if (this.item.album_type === "album") {
        return this.item.user;
      } else {
        return this.track.user;
      }
    },
    stripeConnected: function stripeConnected() {
      return this.user.stripe_connected;
    },
    albumCover: function albumCover() {
      return this.item.cover.thumb.url;
    },
    followButtonText: function followButtonText() {
      if (this.user.is_following) {
        return this.buttonHover ? "Unfollow" : "Following";
      }
      return "Follow";
    },
    genres: function genres() {
      return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(this.item.genres, "name").join(", ");
    }
  }),

  created: function created() {
    __WEBPACK_IMPORTED_MODULE_6_howler__["Howler"].volume(this.volume / 100);
  },


  watch: {
    isPlayerOpened: function isPlayerOpened(val) {
      if (val) {
        this.fetchComments();
      }
    },
    item: function item(val) {
      this.changeBackground();
    },
    showDownloadModal: function showDownloadModal(val) {
      this.triggerModalMode(val);
    },
    showShareModal: function showShareModal(val) {
      this.triggerModalMode(val);
    },
    isPlaying: function isPlaying(val) {
      if (val) {
        // Pause video on audio play
        try {
          // eslint-disable-next-line no-undef
          var pp = videojs("myVideoPlayer");
          if (!pp.paused()) {
            pp.pause();
          }
        } catch (error) {
          // console.log(error)
        }
      }
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapActions */])({
    setPlaying: "player/setPlayingStatus",
    setPauseStatus: "player/setPauseStatus"
  }), {
    showAlbumCredit: function showAlbumCredit() {
      this.showCredit = true;
      this.closeOptions();
    },
    showComments: function showComments() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.fetchComments();

              case 2:
                _this.$refs.mobileComments.showComments(true);

                _this.closeOptions();

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    fetchComments: function fetchComments() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var vm;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                vm = _this2;

                if (!(_this2.item && _this2.currentUser)) {
                  _context2.next = 4;
                  break;
                }

                _context2.next = 4;
                return _this2.loadMoreComments();

              case 4:

                if (_this2.comments_subscription) {
                  _this2.comments_subscription.unsubscribe();
                }
                _this2.cable = ActionCable.createConsumer("wss://api.yousound.com/cable" + "?token=" + _this2.$store.state.auth.token);
                _context2.next = 8;
                return _this2.cable.subscriptions.create({
                  channel: "CommentsChannel",
                  album_id: vm.item.id
                }, {
                  connected: function connected() {
                    console.log("connected to CommentsChannel");
                  },
                  received: function received(data) {
                    console.log("comments_subscription");
                    console.log(data);
                    switch (data.action) {
                      case "create":
                      case "update":
                        if (data.comment.status === "published" || data.comment.readable_user_ids.indexOf(vm.currentUser.id) > -1) {
                          var commentIndex = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.findIndex(vm.comments, function (comment) {
                            return comment.id === data.comment.id;
                          });
                          if (commentIndex === -1) {
                            vm.comments.push(data.comment);
                          } else {
                            vm.comments[commentIndex] = data.comment;
                          }
                        } else {
                          __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.remove(vm.comments, function (item) {
                            return item.id === data.comment.id;
                          });
                        }
                        break;
                      case "delete":
                        __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.remove(vm.comments, function (item) {
                          return item.id === data.comment_id;
                        });
                        break;
                    }
                    vm.comments = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.orderBy(vm.comments, ["created_at"], ["desc"]);
                    // const arr = vm.comments.slice()
                    // vm.comments = arr
                  },
                  disconnected: function disconnected() {
                    console.log("disconnected to CommentsChannel :(");
                  }
                });

              case 8:
                _this2.comments_subscription = _context2.sent;

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    loadMoreComments: function loadMoreComments() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var params;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                params = {
                  commentable_type: 'Album',
                  commentable_id: _this3.item.id,
                  page: _this3.comment_pagination.current_page + 1,
                  per_page: _this3.comment_pagination.per_page
                };

                __WEBPACK_IMPORTED_MODULE_8__services_comment__["a" /* default */].getComments(params).then(function (response) {
                  _this3.comments = _this3.comments.concat(response.body.comments);
                  _this3.comment_pagination = response.body.pagination;
                }).catch(function (e) {
                  _this3.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
                });

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    openShareModal: function openShareModal() {
      this.showShareModal = true;
      this.modalMode = true;

      this.closeOptions();
    },
    changeBackground: function changeBackground() {
      var canvas = document.getElementById("canvas");

      var cctx = canvas.getContext("2d");
      var buff = document.createElement("canvas");
      buff.width = canvas.width;
      buff.height = canvas.height;

      var imageObj = new Image();
      // this will make CORS happy because the server is well configured
      imageObj.crossOrigin = "anonymous";
      // Easiest is to always host your images on your own server
      // imageObj.src = 'https://dl.dropboxusercontent.com/s/8q8sjnqmmto13h5/lionCMYK.jpg'
      imageObj.src = this.coverThumbImageURL;

      imageObj.onload = function () {
        // canvas.width = imageObj.height
        // canvas.height = imageObj.height
        cctx.drawImage(imageObj, 0, 0);
        // eslint-disable-next-line no-undef
        StackBlur.image(imageObj, canvas, 100, false);

        var wrapper_height = __WEBPACK_IMPORTED_MODULE_4_jquery___default()(".album-pages").height() + 130;
        var height = wrapper_height;

        if (canvas) {
          // $("#canvas").css("cssText", "height: " + height + "px !important;");
        }
        __WEBPACK_IMPORTED_MODULE_4_jquery___default()("#back_image").css("cssText", "height: " + height + "px !important;");
      };
    },
    closeOptions: function closeOptions() {
      this.optionModalActive = false;
    },
    minModal: function minModal() {
      this.$store.dispatch("player/toggleMobilePlayer", false);
    },
    startPlaying: function startPlaying(index) {
      this.setPlaylist("next");
      this.play(index);
      this.$forceUpdate();
    },
    triggerModalMode: function triggerModalMode(val) {
      if (!val) {
        this.modalMode = false;
      }
    },
    resetPlayer: function resetPlayer() {
      if (this.$store.state.player.isPlaying) {
        this.setPlaying(false);
        this.pause();
        this.setPauseStatus(false);
        this.$store.dispatch("player/setPlaylist", []);
        this.$store.dispatch("player/setListIndex", -1);
        this.$store.dispatch("player/setTrackIndex", -1);
        for (var index in this.playlist) {
          var item = this.playlist[index];
          if (item) {
            if (item.howl) {
              item.howl.unload();
            }
          }
        }
        this.playlist = [];
        this.index = 0;
        this.isLoaded = false;
        this.isRepeated = false;
        this.isPlaying = false;
        this.trackIndex = null;
        this.trackName = null;
        this.track = {};
        this.playedTime = 0;
        this.progress = 0;
        this.showDownloadModal = false;
        this.totalTime = null;
        this.buttonHover = false;
      }
    },
    play: function play(index) {
      var _this4 = this;

      // console.log('player', index, this.index, this.playlist)
      var self = this;
      var sound;
      index = typeof index === "number" ? index : this.index;
      var data = this.playlist[index];

      // Update the track display.
      // track.innerHTML = (index + 1) + '. ' + data.title
      // this.trackName = this.playlist[index].track.name
      this.trackIndex = index + 1 + " of " + this.playlist.length;
      this.track = this.playlist[index].track;
      console.log("player play track mobile_player", this.track);
      this.$store.dispatch("player/setCurrentPlayingTrack", this.track);

      // If we already loaded self track, use the current one.
      // Otherwise, setup and load a new Howl.
      if (data.howl) {
        sound = data.howl;
      } else {
        sound = data.howl = new __WEBPACK_IMPORTED_MODULE_6_howler__["Howl"]({
          src: data.track.audio.url,
          html5: true, // Force to HTML5 so that the audio can stream in (best for large files).
          onplay: function onplay() {
            // Display the duration.
            self.totalTime = self.formatTime(Math.round(sound.duration()));

            // Start upating the progress of the track.
            requestAnimationFrame(self.step.bind(this));

            // Start the wave animation if we have already loaded
            self.isPlaying = true;
            self.setPauseStatus(false);
          },
          onload: function onload() {
            // Start the wave animation.
            self.isLoaded = true;
          },
          onend: function onend() {
            // Stop the wave animation.
            // this.isLoaded = false
            // this.isPlaying = false
            if (self.isRepeated) {
              self.skipTo(self.index);
            } else {
              self.skip("right");
            }
          },
          onpause: function onpause() {
            // Stop the wave animation.
            // this.isPlaying = false
          },
          onstop: function onstop() {
            // Stop the wave animation.
            // this.isPlaying = false
          }
        });
      }

      __WEBPACK_IMPORTED_MODULE_9__services_track__["a" /* default */].playTrack(this.track.id).then(function (response) {
        return console.log("playing - track", _this4.track.id);
      });
      // Begin playing the sound.
      sound.play();

      // Show the pause button.
      if (sound.state() === "loaded") {
        this.isPlaying = true;
      } else {
        this.isLoaded = false;
        this.isPlaying = false;
      }

      // Keep track of the index we are currently playing.
      this.index = index;
      this.$store.dispatch("player/setTrackIndex", index);

      // / Show the reminder on the audio player
      // if (this.index > 0 && this.index % this.reminderTracksCount == 0) {
      //   PaymentService.hasTransactionInPeriod().then(res => {
      //     if (res.body != true) {
      //       this.showReminder = true
      //       setTimeout(() => { this.showReminder = false }, 5000)
      //     }
      //   })
      // }
    },


    /**
     * Pause the currently playing track.
     */
    pause: function pause() {
      // player is not initialized yet.
      if (!this.$store.state.player.isPlaying) return;

      // Get the Howl we want to manipulate.
      var sound = this.playlist[this.index].howl;

      // Puase the sound.
      sound.pause();

      // Show the play button.
      this.isPlaying = false;
      this.setPauseStatus(true);
      // this.setPlaying(false)

      // update current track playing
      this.$store.dispatch("player/setCurrentPlayingTrack", this.track);
    },
    skip: function skip(direction) {
      // Get the next track based on the direction of the track.
      var index = 0;
      if (direction === "prev") {
        index = this.index - 1;
        if (index < 0) {
          this.$store.dispatch("player/setListIndex", this.$store.state.player.listIndex - 1);
          this.setPlaylist("prev");
          index = this.playlist.length - 1;
          // this.$root.$emit('index_change')
        }
      } else {
        index = this.index + 1;
        if (index >= this.playlist.length) {
          index = 0;
          this.$store.dispatch("player/setListIndex", this.$store.state.player.listIndex + 1);
          this.setPlaylist("next");
          // this.$root.$emit('index_change')
        }
      }
      this.$store.dispatch("player/setTrackIndex", index);
      this.skipTo(index);
    },


    /**
     * Skip to a specific track based on its playlist index.
     * @param  {Number} index Index in the playlist.
     */
    skipTo: function skipTo(index) {
      // Stop the current track.
      var sound = null;
      if (this.playlist[this.index] !== null && this.playlist[this.index] !== undefined) {
        if (this.playlist[this.index].howl !== undefined && this.playlist[this.index].howl !== null) {
          sound = this.playlist[this.index].howl;
          sound.stop();
        }
      }

      // Reset progress.
      this.progress = 0;

      if (this.playlist.length > 0) {
        // Play the new track.
        this.play(index);
      }
    },


    /**
     * Seek to a new position in the currently playing track.
     * @param  {Number} per Percentage through the song to skip.
     */
    seek: function seek(per) {
      // Get the Howl we want to manipulate.
      var sound = this.playlist[this.index].howl;

      // Convert the percent into a seek position.
      if (sound.playing()) {
        sound.seek(sound.duration() * per / 100);
      }
    },


    /**
     * The step called within requestAnimationFrame to update the playback position.
     */
    step: function step() {
      // Get the Howl we want to manipulate.
      var sound = null;
      // var sound = this.playlist[this.index].howl
      if (this.playlist[this.index] !== null && this.playlist[this.index] !== undefined) {
        if (this.playlist[this.index].howl !== undefined && this.playlist[this.index].howl !== null) {
          sound = this.playlist[this.index].howl;

          // Determine our current seek position.
          var seek = sound.seek() || 0;
          this.playedTime = this.formatTime(Math.round(seek));
          this.progress = seek / sound.duration() * 100 || 0;

          // If the sound is still playing, continue stepping.
          if (sound.playing()) {
            requestAnimationFrame(this.step.bind(this));
          }
        }
      }
    },
    setPlaylist: function setPlaylist(direction) {
      // Display the title of the first track.
      var object = this.$store.state.player.list[this.$store.state.player.listIndex];
      var tracks = [];
      if (direction === "next") {
        for (var i = this.$store.state.player.listIndex; i < this.$store.state.player.list.length; i++) {
          object = this.$store.state.player.list[i];
          if (object.assoc_type) {
            if (object.assoc_type === "Album") {
              tracks = object.assoc.tracks;
              this.$store.dispatch("player/setListIndex", i);
              this.$root.$emit("index_change");
              break;
            }
          } else {
            tracks = object.tracks;
            this.$store.dispatch("player/setListIndex", i);
            this.$root.$emit("index_change");
            break;
          }
        }
      } else {
        for (i = this.$store.state.player.listIndex; i >= 0; i--) {
          object = this.$store.state.player.list[i];
          if (object.assoc_type) {
            if (object.assoc_type === "Album") {
              tracks = object.assoc.tracks;
              this.$store.dispatch("player/setListIndex", i);
              this.$root.$emit("index_change");
              break;
            }
          } else {
            tracks = object.tracks;
            this.$store.dispatch("player/setListIndex", i);
            this.$root.$emit("index_change");
            break;
          }
        }
      }
      for (var index in this.playlist) {
        var item = this.playlist[index];
        if (item) {
          if (item.howl) {
            item.howl.unload();
          }
        }
      }
      this.playlist = [];
      this.index = 0;
      if (tracks.length > 0) {
        if (this.currentUser) {
          var album = object.assoc || object;
          __WEBPACK_IMPORTED_MODULE_7__services_album__["a" /* default */].playAlbum(album.id).then(function (response) {
            return console.log("playing - album", album.id);
          });
        }

        for (var track in tracks) {
          this.playlist.push({
            track: tracks[track],
            played: false,
            howl: null
          });
        }
        // if (this.$store.state.player.trackIndex > -1) {
        //   this.index = this.$store.state.player.trackIndex
        // }
        this.$store.dispatch("player/setTrackIndex", 0);
        this.trackIndex = this.index + 1 + " of " + this.playlist.length;
        // this.trackName = this.playlist[this.index].track.name
        this.track = this.playlist[this.index].track;
        // console.log('player setPlaylist track', this.track)
      } else {
        this.$store.dispatch("player/setListIndex", -1);
        this.$store.dispatch("player/setPlayingStatus", false);
      }
    },
    formatTime: function formatTime(secs) {
      var minutes = Math.floor(secs / 60) || 0;
      var seconds = secs - minutes * 60 || 0;

      return minutes + ":" + (seconds < 10 ? "0" : "") + seconds;
    },
    choosePage: function choosePage(path) {
      this.$router.push({ path: "/" + path });
    },
    dismissDownloadDialog: function dismissDownloadDialog() {
      this.showDownloadModal = false;
    },
    dismissShareDialog: function dismissShareDialog() {
      this.showShareModal = false;
    },
    setRepeated: function setRepeated() {
      this.isRepeated = !this.isRepeated;
    },
    repostItem: function repostItem() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_7__services_album__["a" /* default */].repostAlbum(this.item.id).then(function (response) {
        _this5.$store.dispatch("error/showSuccessToast", ["You just reposted " + _this5.item.name]);
      }).catch(function (e) {
        _this5.$store.dispatch("error/showErrorToast", e.body.errors || [e.body]);
      });
    },
    setFollowingStatus: function setFollowingStatus(userId, isFollowing) {
      // console.log('player setFollowingStatus', status)
      // console.log(this.user)
      if (this.user && this.user.id === userId) {
        this.$store.dispatch("player/updateFollowingStatus", isFollowing);
      }
    },
    skipTrack: function skipTrack(index) {
      this.skipTo(index);
    },


    // onVolumeChange (evt) {
    //   // console.log('onVolumeChange', evt, this.volume)
    //   this.updateVolume(this.volume)
    // },

    updateVolume: function updateVolume() {
      // console.log('updateVolume', volume)
      __WEBPACK_IMPORTED_MODULE_6_howler__["Howler"].volume(this.volume / 100);
    },
    randomPlay: function randomPlay() {
      this.$store.dispatch("player/setShuffleStatus", !this.$store.state.player.isShuffle);
    }
  }),

  mounted: function mounted() {
    this.$root.$on(__WEBPACK_IMPORTED_MODULE_10__helper__["b" /* MyEvents */].AUDIO_PLAYER_PLAY, this.startPlaying);
    this.$root.$on(__WEBPACK_IMPORTED_MODULE_10__helper__["b" /* MyEvents */].AUDIO_PLAYER_REPLAY, this.play);
    this.$root.$on(__WEBPACK_IMPORTED_MODULE_10__helper__["b" /* MyEvents */].AUDIO_PLAYER_PAUSE, this.pause);
    this.$root.$on(__WEBPACK_IMPORTED_MODULE_10__helper__["b" /* MyEvents */].AUDIO_PLAYER_SKIPTO, this.skipTrack);
    this.$root.$on(__WEBPACK_IMPORTED_MODULE_10__helper__["b" /* MyEvents */].AUTH_SIGNOUT, this.resetPlayer);
    this.$root.$on(__WEBPACK_IMPORTED_MODULE_10__helper__["b" /* MyEvents */].USER_FOLLOW, this.setFollowingStatus);
    this.$root.$on(__WEBPACK_IMPORTED_MODULE_10__helper__["b" /* MyEvents */].STREM_PLAYER_FULLSCREEN_ENTER, this.pause);
  }
});

/***/ }),
/* 911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_demo_person_png__ = __webpack_require__(1451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_demo_person_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_demo_person_png__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    leftPos: {
      type: Number,
      default: 300
    }
  },
  data: function data() {
    return {
      demoPerson: __WEBPACK_IMPORTED_MODULE_0__assets_demo_person_png___default.a,
      inviteShow: false,
      notify_container_Class: "notify-wrapper"
    };
  },

  methods: {
    toggleNotify: function toggleNotify() {
      if (this.inviteShow) {
        this.notify_container_Class = "notify-wrapper";
        this.inviteShow = false;
      } else {
        this.notify_container_Class = "invite-wrapper";
        this.inviteShow = true;
      }
    }
  }
});

/***/ }),
/* 912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_stripe_elements__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_stripe_elements___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_stripe_elements__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    hidePayBtn: Boolean,
    totalPayable: Number
  },
  components: { CardNumber: __WEBPACK_IMPORTED_MODULE_0_vue_stripe_elements__["CardNumber"], CardExpiry: __WEBPACK_IMPORTED_MODULE_0_vue_stripe_elements__["CardExpiry"], CardCvc: __WEBPACK_IMPORTED_MODULE_0_vue_stripe_elements__["CardCvc"] },
  data: function data() {
    return {
      complete: false,
      number: false,
      expiry: false,
      cvc: false,
      fee: 0,
      stripePubkey: "pk_live_fXEdJ0v6E2ROxT8rufDCby12",
      options: {
        showIcon: true
      }
    };
  }
});

/***/ }),
/* 913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_paymentCard_cardDetails__ = __webpack_require__(1588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_paymentCard_cardDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_paymentCard_cardDetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_paymentCard_packageDetails__ = __webpack_require__(1589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_paymentCard_packageDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_paymentCard_packageDetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_stripe_elements__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_stripe_elements___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_stripe_elements__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_subscription_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_mobile_auth_onboarding_checkEmail_vue__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_mobile_auth_onboarding_checkEmail_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__views_mobile_auth_onboarding_checkEmail_vue__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    item: {
      required: true,
      type: Object
    },
    totalPayable: Number,
    closePayment: {
      type: Function
    }
  },
  data: function data() {
    return {
      country: "",
      zipCode: "",
      paymentSuccessful: false,
      paymentFailed: false,
      confirmPayment: false
    };
  },

  components: { cardDetails: __WEBPACK_IMPORTED_MODULE_1__components_paymentCard_cardDetails___default.a, PackageDetails: __WEBPACK_IMPORTED_MODULE_2__components_paymentCard_packageDetails___default.a, checkEmail: __WEBPACK_IMPORTED_MODULE_6__views_mobile_auth_onboarding_checkEmail_vue___default.a },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])({
    countries: function countries(state) {
      return state.app.countries;
    },
    userEmail: function userEmail(state) {
      return state.app.onboarding.email;
    }
  }), {
    itemType: function itemType() {
      var list = this.item.list; // update when real data is available

      if (list) {
        return "plan";
      }
    },
    subtitleAppend: function subtitleAppend() {
      var type = this.itemType;

      switch (type) {
        case "plan":
          return "Subscription";
        default:
          break;
      }
    },
    itemPrice: function itemPrice() {
      var type = this.itemType;

      switch (type) {
        case "plan":
          return this.item.price;
        default:
          break;
      }
    },
    stripePriceId: function stripePriceId() {
      var type = this.itemType;

      switch (type) {
        case "plan":
          return this.item.stripePriceId;
        default:
          break;
      }
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])({
    getCountries: "app/getCountries"
  }), {
    hideConfirmationPayment: function hideConfirmationPayment() {
      this.closePayment("success");
    },
    handlePayment: function handlePayment() {
      var _this = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vue_stripe_elements__["createToken"])().then(function (data) {
        _this.subscribe(_this.stripePriceId, data.token);
      });
      // console.log({response});
      // this.subscribe(this.stripePriceId, response.data.token);
    },
    subscribe: function subscribe(priceId, tokenResponse) {
      var _this2 = this;

      this.$store.dispatch('error/showLoadingActivity', true);

      console.log("priceId===>", this.stripePriceId, this.amount, tokenResponse, tokenResponse.id);
      var params = { price_id: priceId, token_response: tokenResponse, token_id: tokenResponse.id };
      __WEBPACK_IMPORTED_MODULE_5__services_subscription_js__["a" /* default */].createSubscription(params).then(function (response) {
        _this2.paymentSuccessful = true;
        _this2.$store.dispatch('error/showLoadingActivity', false);
        _this2.$store.dispatch('error/showSuccessToast', ["You have successfully subscribed."]);
        // this.closePayment("success");
        if (_this2.$store.state.auth.user != null) {
          _this2.$router.push({ name: 'AlbumIndex' });
        }
      }).catch(function (e) {
        _this2.$store.dispatch('error/showLoadingActivity', false);
        _this2.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    }
  }),
  created: function created() {
    this.getCountries();
  }
});

/***/ }),
/* 914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "packageDetails",
  props: {
    hideTitle: Boolean,
    noBorder: Boolean,
    altMeta: Boolean,
    item: {
      required: true,
      type: Object
    },
    itemType: String,
    itemPrice: String
  },
  computed: {
    subtitleAppend: function subtitleAppend() {
      var type = this.itemType;

      switch (type) {
        case "plan":
          return "Subscription";
        default:
          break;
      }
    },
    currentDate: function currentDate() {
      var myCurrentDate = new Date();
      var myFutureDate = new Date(myCurrentDate);
      myFutureDate.setDate(myFutureDate.getDate() + 30);

      return myFutureDate;
    }
  }
});

/***/ }),
/* 915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_base_qr_code__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_base_qr_code___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_base_qr_code__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    accountCategory: {
      type: String,
      default: "creator"
    }
  },
  components: {
    QrCode: __WEBPACK_IMPORTED_MODULE_0__components_base_qr_code___default.a
  },
  data: function data() {
    return {
      dialog: false,
      qrCodeTypeList: __WEBPACK_IMPORTED_MODULE_1__helper__["e" /* QrCodeTypeList */]
    };
  },

  methods: {
    openPaymentSuccess: function openPaymentSuccess() {
      this.dialog = true;
    },
    openQrCode: function openQrCode(type) {
      return this.$refs.qrCode.openQrCode(type);
    }
  }
});

/***/ }),
/* 916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_stripe_elements__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_stripe_elements___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_stripe_elements__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_user__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    // receiver: {
    //   type: Object,
    // },

    receivers: {
      type: Array
    },

    amount: {
      type: Number,
      required: true
    },

    dismiss: {
      type: Function,
      required: true
    },

    finish: {
      type: Function,
      required: true
    }
  },

  components: {
    Card: __WEBPACK_IMPORTED_MODULE_1_vue_stripe_elements__["Card"],
    CardNumber: __WEBPACK_IMPORTED_MODULE_1_vue_stripe_elements__["CardNumber"],
    CardExpiry: __WEBPACK_IMPORTED_MODULE_1_vue_stripe_elements__["CardExpiry"],
    CardCvc: __WEBPACK_IMPORTED_MODULE_1_vue_stripe_elements__["CardCvc"]
  },

  data: function data() {
    return {
      stripe_publishable_key: "pk_live_fXEdJ0v6E2ROxT8rufDCby12",
      receiver: {},
      sent_payment: false,
      complete: false,
      stripeOptions: {},
      show_error_dialog: false,
      fee: 0,
      loading: true,
      cardNumber: null,
      cardExpiry: null,
      cardCvc: null
    };
  },


  computed: {
    currentUser: function currentUser() {
      return this.$store.state.auth.user;
    },
    receiverAvatar: function receiverAvatar() {
      return this._.get(this.receiver, 'avatar.thumb.url');
    },
    receiverName: function receiverName() {
      return this._.get(this.receiver, 'display_name', 'Receiver');
    }
  },

  created: function created() {
    var _this = this;

    // if (!this.stripeConnected) {
    //   this.show_error_dialog = true
    // }

    this.loading = true;
    this.show_error_dialog = false;
    this.$store.dispatch('error/showLoadingActivity', true);

    // const funcs = (this.receivers || []).map((user) =>
    //   UserService.checkStripeConnection(user.id)
    // )
    // Promise.all(funcs)
    //   .then((values) => {
    //     this.loading = false
    //     this.$store.dispatch('error/showLoadingActivity', false)
    //   })
    //   .catch((reason) => {
    //     this.loading = false
    //     this.show_error_dialog = true
    //     this.$store.dispatch('error/showLoadingActivity', false)
    //   })

    var funcs = (this.receivers || []).map(function (user) {
      return __WEBPACK_IMPORTED_MODULE_2__services_user__["a" /* default */].checkStripeConnection(user.id).then(function (value) {
        return { status: 'fulfilled', user: user, value: value };
      }, function (reason) {
        return { status: 'rejected', user: user, reason: reason };
      });
    });
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(funcs).then(function (values) {
      var error = _this._.find(values, function (v) {
        return v.status === 'rejected';
      });

      _this.loading = false;
      _this.$store.dispatch('error/showLoadingActivity', false);
      if (error) {
        _this.receiver = error.user;
        _this.show_error_dialog = true;
      }
    });

    this.fee = __WEBPACK_IMPORTED_MODULE_3__helper__["d" /* Stripe */].calculateFee(this.amount);
  },
  beforeDestroy: function beforeDestroy() {},


  methods: {
    sendPayment: function sendPayment() {
      var _this2 = this;

      this.sent_payment = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_stripe_elements__["createToken"])().then(function (data) {
        _this2.dismiss();
        _this2.finish(data.token);
      });
    }
  }
});

/***/ }),
/* 917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_merchmodal__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_merchmodal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_merchmodal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_profileitem__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_profileitem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_profileitem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_product__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_collection__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_sharemodal__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_sharemodal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_sharemodal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_user_tag__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_user_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_user_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_LogoutModal__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_LogoutModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__views_LogoutModal__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    merchModal: __WEBPACK_IMPORTED_MODULE_0__components_merchmodal___default.a,
    shareModal: __WEBPACK_IMPORTED_MODULE_4__components_sharemodal___default.a,
    profileItem: __WEBPACK_IMPORTED_MODULE_1__components_profileitem___default.a,
    UserTag: __WEBPACK_IMPORTED_MODULE_5__components_user_tag___default.a,
    logoutModal: __WEBPACK_IMPORTED_MODULE_6__views_LogoutModal___default.a
  },

  props: {
    altMetaPrice: Boolean,
    altMeta: {
      type: Boolean,
      default: false
    },
    noMeta: {
      type: Boolean,
      default: false
    },
    hideOptionCount: {
      type: Boolean,
      default: false
    },
    hideMoreOptions: {
      type: Boolean,
      default: false
    },
    hidePriceOverlay: {
      type: Boolean,
      default: false
    },
    hideOverlay: {
      type: Boolean,
      default: false
    },
    forCollection: {
      type: Boolean,
      default: false
    },
    playlistId: {
      type: Number,
      default: null
    },
    dataObject: {
      type: Object
    },
    hideButtonAction: {
      type: Function
    },
    sideTabView: {
      type: Boolean
    },
    showFullOverlay: Boolean,
    getCollections: Function,
    removeFromPlaylist: {
      type: Function,
      default: null
    }
  },

  data: function data() {
    return {
      showMerchModal: false,
      showShareModal: false,
      show_hide_dialog: false,
      is_component_hover: false,
      is_menu_hover: false,
      show_logout_modal: false,
      show_remove_from_collection_modal: false
    };
  },


  computed: {
    onMobile: function onMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    currentUser: function currentUser() {
      return this.$store.state.auth.user;
    },
    willMenuRender: function willMenuRender() {
      // console.log('willMenuRender', this.item.id, this.is_component_hover, this.is_menu_hover)
      return this.is_menu_hover || this.is_component_hover;
    },


    // publisher() {
    //   if (this.dataObject.assoc_type) {
    //     return this.dataObject.publisher
    //   } else {
    //     return this.dataObject.merchant
    //   }
    // },

    item: function item() {
      if (this.dataObject.assoc_type) {
        return this.dataObject.assoc;
      } else {
        return this.dataObject;
      }
    },
    owner: function owner() {
      if (this.dataObject.assoc_type) {
        return this.dataObject.assoc.merchant;
      } else {
        return this.dataObject.merchant;
      }
    }
  },

  methods: {
    spotlightVideo: function spotlightVideo() {
      this.show_logout_modal = true;
    },
    openMerchDialog: function openMerchDialog() {
      this.showMerchModal = true;
    },
    closeMerchDialog: function closeMerchDialog() {
      this.showMerchModal = false;
    },
    openShareDialog: function openShareDialog() {
      this.showMerchModal = false;
      this.showShareModal = true;
    },
    closeShareDialog: function closeShareDialog() {
      this.showShareModal = false;
    },
    openHideDialog: function openHideDialog() {
      this.menu = false;
      this.submenu = false;
      this.show_hide_dialog = true;
    },
    hideProduct: function hideProduct() {
      var _this = this;

      this.menu = false;
      this.submenu = false;
      this.show_hide_dialog = false;

      __WEBPACK_IMPORTED_MODULE_2__services_product__["a" /* default */].hideProduct(this.item.id).then(function (response) {
        _this.$store.dispatch("error/showSuccessToast", ["You just hid " + _this.item.name]);
        if (_this.hideButtonAction) {
          _this.hideButtonAction(_this.objects[_this.objectIndex]);
        }
      }).catch(function (e) {
        _this.$store.dispatch("error/showErrorToast", e.body.errors || [e.body]);
      });
    },
    repostProduct: function repostProduct() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_2__services_product__["a" /* default */].repostProduct(this.item.id).then(function (response) {
        if (response.body.errors) {
          _this2.$store.dispatch("error/showErrorToast", response.body.errors);
        } else {
          _this2.$store.dispatch("error/showSuccessToast", ["You just reposted " + _this2.item.name]);
        }
      }).catch(function (e) {
        _this2.$store.dispatch("error/showErrorToast", e.body.errors || [e.body]);
      });
    },
    openRemoveFromCollectionModal: function openRemoveFromCollectionModal() {
      this.show_remove_from_collection_modal = true;
    },
    removeFromCollection: function removeFromCollection() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_3__services_collection__["a" /* default */].destroy('shop_product', this.item.id).then(function (response) {
        _this3.$store.dispatch('error/showSuccessToast', ['Product removed from collection']);
        _this3.show_remove_from_collection_modal = false;
        _this3.getCollections();
      }).catch(function (e) {
        _this3.$store.dispatch('error/showErrorToast', ['Unable to remove product from collection']);
        _this3.show_remove_from_collection_modal = false;
      });
    }
  },

  created: function created() {},
  mounted: function mounted() {}
});

/***/ }),
/* 918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_product__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_promotemodal__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_promotemodal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_promotemodal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_user__ = __webpack_require__(7);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global $:true */




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    promoteModal: __WEBPACK_IMPORTED_MODULE_1__components_promotemodal___default.a
  },

  props: {
    product: {
      type: Object
    },

    index: {
      type: Number
    },

    acceptItem: {
      type: Function
    },

    denyItem: {
      type: Function
    },

    deleteItem: {
      type: Function
    },

    status: {
      type: String
    },

    showPromoteButton: {
      type: Boolean,
      default: true
    },

    updateAccessLevelAction: {
      type: Function
    }
  },

  data: function data() {
    return {
      showPromoteMessage: false,
      dialog: false,
      access_levels: [],
      access_level: this.product.access_level,
      toggle_product_access_level_dialog: false
    };
  },


  computed: {
    count: function count() {
      var count = 0;
      for (var index in this.product.variants) {
        var variant = this.product.variants[index];
        count += variant.quantity;
      }
      return count;
    },
    currentUser: function currentUser() {
      return this.$store.state.auth.user;
    },
    currentUserOwnsProduct: function currentUserOwnsProduct() {
      return this.currentUser.id === this.product.merchant.id;
    },
    isUserCollaborator: function isUserCollaborator() {
      var _this = this;

      var collaborators = this.product.collaborators;
      var isCollaborator = collaborators.find(function (user) {
        return user.user_id === _this.currentUser.id;
      });
      return !!isCollaborator;
    },
    collaborationData: function collaborationData() {
      var _this2 = this;

      if (!this.isUserCollaborator) return null;

      var collaborators = this.product.collaborators;
      var collaboration = collaborators.find(function (user) {
        return user.user_id === _this2.currentUser.id;
      });
      return collaboration;
    },
    allCollaboratedAccepted: function allCollaboratedAccepted() {
      var collaborations = this.product.collaborators;
      var allAccepted = collaborations.every(function (collab) {
        return collab.status === "accepted";
      });
      return allAccepted;
    }
  },

  created: function created() {},


  methods: {
    releaseButtonAction: function releaseButtonAction() {
      this.$emit("releaseButtonAction", this.product);
    },
    acceptCollaboration: function acceptCollaboration() {
      this.$emit("acceptCollaboration", this.product);
    },
    denyCollaboration: function denyCollaboration() {
      this.$emit("denyCollaboration", this.product);
    },
    editProduct: function editProduct() {
      this.$router.push({ path: "/product/edit/" + this.product.id });
    },
    showPromoteModal: function showPromoteModal() {
      this.showPromoteMessage = true;
      $("body").css("overflow", "scroll");
    },
    dismissPromoteModal: function dismissPromoteModal() {
      this.showPromoteMessage = false;
      $("body").css("overflow", "scroll");
    },
    saveAndFinish: function saveAndFinish(users) {
      $("body").css("overflow", "scroll");
      this.showPromoteMessage = false;
    },
    openAccessLevelConfirmDialog: function openAccessLevelConfirmDialog(product) {
      this.product = product;
      this.toggle_product_access_level_dialog = true;
    },
    closeAccessLevelConfirmDialog: function closeAccessLevelConfirmDialog() {
      this.toggle_product_access_level_dialog = false;
    },
    updateAccessLevel: function updateAccessLevel() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0__services_product__["a" /* default */].updateAccessLevel(this.product.id, { access_level: this.access_level }).then(function (response) {
        _this3.closeAccessLevelConfirmDialog();
        _this3.$store.dispatch('error/showSuccessToast', ['Access level updated successfully']);
      }).catch(function (e) {
        _this3.closeAccessLevelConfirmDialog();
        _this3.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    }
  },

  mounted: function mounted() {
    var _this4 = this;

    __WEBPACK_IMPORTED_MODULE_2__services_user__["a" /* default */].getAccessLevels(this.product.merchant.id).then(function (response) {
      _this4.access_levels = response.body;
      _this4.access_level = _this4.product.access_level;
    });
  }
});

/***/ }),
/* 919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_merchmodal__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_merchmodal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_merchmodal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_profileitem__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_profileitem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_profileitem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_product__ = __webpack_require__(15);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    merchModal: __WEBPACK_IMPORTED_MODULE_0__components_merchmodal___default.a,
    profileItem: __WEBPACK_IMPORTED_MODULE_1__components_profileitem___default.a
  },

  props: {
    dataObject: {
      type: Object
    },

    showButtonAction: {
      type: Function
    }
  },

  data: function data() {
    return {
      dialog: false,
      showMerchModal: false
    };
  },


  computed: {
    item: function item() {
      if (this.dataObject.assoc_type) {
        return this.dataObject.assoc;
      } else {
        return this.dataObject;
      }
    },
    publisher: function publisher() {
      if (this.dataObject.assoc_type) {
        return this.dataObject.publisher;
      } else {
        return this.dataObject.merchant;
      }
    }
  },

  created: function created() {},


  methods: {
    dimissMerchDialog: function dimissMerchDialog() {
      this.showMerchModal = false;
    },
    showMerchDialog: function showMerchDialog() {
      this.showMerchModal = true;
    },
    repostProduct: function repostProduct() {
      var _this = this;

      this.dialog = false;
      __WEBPACK_IMPORTED_MODULE_2__services_product__["a" /* default */].repostProduct(this.item.id).then(function (response) {
        _this.$store.dispatch("error/showSuccessToast", ["You just reposted " + _this.item.name]);
      }).catch(function (e) {
        _this.$store.dispatch("error/showErrorToast", e.body.errors || [e.body]);
      });
    }
  },

  mounted: function mounted() {}
});

/***/ }),
/* 920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_sendmessage__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_sendmessage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_sendmessage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_userFollowBtn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_userFollowBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_userFollowBtn__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    sendMessage: __WEBPACK_IMPORTED_MODULE_0__components_sendmessage___default.a,
    UserFollowBtn: __WEBPACK_IMPORTED_MODULE_1__components_userFollowBtn___default.a
  },

  props: {
    user: {
      type: Object
    },
    className: {
      type: String
    }
  },

  data: function data() {
    return {
      showSendMessage: false,
      buttonHover: false
    };
  },


  computed: {
    followButtonText: function followButtonText() {
      if (this.user.is_following) {
        return this.buttonHover ? "Unfollow" : "Following";
      }
      return "Follow";
    }
  },

  created: function created() {},


  methods: {
    showMessageDialog: function showMessageDialog() {
      this.showSendMessage = true;
    },
    dismissMessageModal: function dismissMessageModal() {
      this.showSendMessage = false;
    },
    blockUser: function blockUser() {},
    afterFollow: function afterFollow(isfollowing) {
      if (isfollowing === "unfollow") {
        this.user.is_following = false;
      } else if (isfollowing === "follow") {
        this.user.is_following = true;
      }
    }
  }
});

/***/ }),
/* 921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_promote__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_user__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_activityalbumcard__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_activityalbumcard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_activityalbumcard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_activityproductcard__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_activityproductcard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_activityproductcard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_product__ = __webpack_require__(15);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global $:true */





/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    item: {
      type: Object,
      required: true
    },
    dismiss: {
      type: Function,
      required: true
    },
    success: {
      type: Function,
      required: true
    }
  },

  components: {
    activityAlbumCard: __WEBPACK_IMPORTED_MODULE_2__components_activityalbumcard___default.a,
    activityProductCard: __WEBPACK_IMPORTED_MODULE_3__components_activityproductcard___default.a
  },

  data: function data() {
    return {
      repost_prices: [{ title: "Any Amount", value: "any" }, { title: "$1", value: "100" }, { title: "$5", value: "500" }, { title: "$10", value: "1000" }, { title: "$20", value: "2000" }, { title: "$50", value: "5000" }, { title: "$100", value: "10000" }, { title: "$250", value: "25000" }, { title: "$500", value: "50000" }, { title: "$1000", value: "100000" }],
      amounts: [{ title: "Any Follower #", value: "any" }, { title: "less than 1K", value: "0" }, { title: "1K+", value: "1000" }, { title: "5K+", value: "5000" }, { title: "10K+", value: "10000" }, { title: "25K+", value: "25000" }, { title: "50K+", value: "50000" }, { title: "100K+", value: "100000" }],
      filters: [{ title: "All User Types", value: "any" }, { title: "Favorite Reposters", value: "favorite" }, { title: "Your Followers", value: "follower" }, { title: "New Users", value: "new" }, { title: "Artists", value: "artist" }, { title: "Listeners", value: "listener" }, { title: "Brands", value: "brand" }],
      tab: "suggested",
      repost_price: "any",
      amount: "any",
      filter: "any",
      keyword: "",
      users: [],
      user_ids: [],
      suggested_values: {
        total_cost: 0,
        total_potential_reach: 0
      },
      reposters: [],
      products: [],
      current_values: {
        total_actual_reach: 0,
        total_paid: 0,
        total_potential_reach: 0
      }
    };
  },


  computed: {
    favorite_ids: function favorite_ids() {
      var ids = [];
      for (var index in this.$store.state.auth.user.favorite_users) {
        var favoriteUser = this.$store.state.auth.user.favorite_users[index];
        ids.push(favoriteUser.id);
      }
      return ids;
    }
  },

  created: function created() {
    var _this = this;

    this.searchUsers();
    __WEBPACK_IMPORTED_MODULE_4__services_product__["a" /* default */].getProducts({
      statuses: "published, collaborated",
      stock_statuses: "active",
      user_statuses: "accepted"
    }).then(function (response) {
      _this.products = response.body;
    }).catch(function (e) {
      console.log(e);
    });
  },


  methods: {
    imageURL: function imageURL(item) {
      if (item.assoc_type === "Album") {
        return item.assoc.cover.thumb.url;
      } else {
        return item.assoc.covers[0].cover.thumb.url;
      }
    },
    selectUser: function selectUser(user) {
      var index = this.user_ids.indexOf(user.id);
      if (index > -1) {
        this.user_ids.splice(index, 1);
      } else {
        this.user_ids.push(user.id);
      }
      this.suggestedReposters();
    },
    addUserToFavorite: function addUserToFavorite(user) {
      var _this2 = this;

      var index = this.favorite_ids.indexOf(user.id);
      if (index > -1) {
        __WEBPACK_IMPORTED_MODULE_1__services_user__["a" /* default */].unfavoriteUser(user.id).then(function (response) {
          _this2.$store.dispatch("error/showErrorToast", ["removed <" + user.username + "> from Favorite successfully!"]);
          _this2.$store.dispatch("auth/removeFavoriteUser", user);
        }).catch(function (e) {
          _this2.$store.dispatch("error/showErrorToast", e.body.errors || [e.body]);
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_1__services_user__["a" /* default */].favoriteUser(user.id).then(function (response) {
          _this2.$store.dispatch("error/showErrorToast", ["added <" + user.username + "> to Favorite successfully!"]);
          _this2.$store.dispatch("auth/addFavoriteUser", user);
        }).catch(function (e) {
          _this2.$store.dispatch("error/showErrorToast", e.body.errors || [e.body]);
        });
      }
    },
    searchUsers: function searchUsers() {
      var _this3 = this;

      // this.$store.dispatch('error/showLoadingActivity', true)
      var params = new FormData();
      params.append("repost_price", this.repost_price);
      params.append("followers_count", this.amount);
      params.append("user_type", this.filter);
      if (this.keyword.length) {
        params.append("username", this.keyword);
      }
      __WEBPACK_IMPORTED_MODULE_0__services_promote__["a" /* default */].searchUsers(params).then(function (response) {
        // this.$store.dispatch('error/showLoadingActivity', false)
        _this3.users = response.body;
      }).catch(function (e) {
        // this.$store.dispatch('error/showLoadingActivity', false)
        _this3.$store.dispatch("error/showErrorToast", e.body.errors || [e.body]);
      });
    },
    suggestedReposters: function suggestedReposters() {
      var _this4 = this;

      // this.$store.dispatch('error/showLoadingActivity', true)
      var params = new FormData();
      params.append("user_ids", this.filter);
      __WEBPACK_IMPORTED_MODULE_0__services_promote__["a" /* default */].calculateSuggestedReposters(params).then(function (response) {
        // this.$store.dispatch('error/showLoadingActivity', false)
        _this4.suggested_values = response.body;
      }).catch(function (e) {
        // this.$store.dispatch('error/showLoadingActivity', false)
        _this4.$store.dispatch("error/showErrorToast", e.body.errors || [e.body]);
      });
    },
    getCurrentReposters: function getCurrentReposters() {
      var _this5 = this;

      this.$store.dispatch("error/showLoadingActivity", true);
      var params = new FormData();
      if (this.item.album_type) {
        params.append("assoc_type", "Album");
      } else {
        params.append("assoc_type", "ShopProduct");
      }
      params.append("assoc_id", this.item.id);
      __WEBPACK_IMPORTED_MODULE_0__services_promote__["a" /* default */].calculateCurrentReposters(params).then(function (response) {
        _this5.$store.dispatch("error/showLoadingActivity", false);
        _this5.reposters = response.body.reposters;
        _this5.current_values.total_paid = response.body.total_paid;
        _this5.current_values.total_potential_reach = response.body.total_potential_reach;
        _this5.current_values.total_actual_reach = response.body.total_actual_reach;
      }).catch(function (e) {
        _this5.$store.dispatch("error/showLoadingActivity", false);
        _this5.$store.dispatch("error/showErrorToast", e.body.errors || [e.body]);
      });
    },
    saveAndFinish: function saveAndFinish() {
      this.success(this.users);
    }
  },

  mounted: function mounted() {
    $("body").css("overflow", "hidden");
  }
});

/***/ }),
/* 922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      pauseChart: false
    };
  }
});

/***/ }),
/* 923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_stripe_elements__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_stripe_elements___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_stripe_elements__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    item: {
      type: Object,
      required: true
    },

    itemType: {
      type: String,
      required: true
    },

    receiver: {
      type: Object,
      required: true
    },

    dismiss: {
      type: Function,
      required: true
    },

    finish: {
      type: Function,
      required: true
    }
  },

  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_vue_stripe_elements__["Card"]
  },

  data: function data() {
    return {
      stripe_publishable_key: "pk_live_fXEdJ0v6E2ROxT8rufDCby12",
      sent_payment: false,
      complete: false,
      stripeOptions: {},
      fee: 0,
      show_error_dialog: false
    };
  },


  computed: {
    Filter: function Filter() {
      return __WEBPACK_IMPORTED_MODULE_1__helper__["a" /* Filter */];
    },
    itemCover: function itemCover() {
      if (this.itemType === "album") {
        return this.item.cover.url;
      } else {
        var coverURL = "";
        for (var index in this.item.covers) {
          var cover = this.item.covers[index].cover;
          if (cover.url) {
            coverURL = cover.url;
            break;
          }
        }
        return coverURL;
      }
    },
    itemOwner: function itemOwner() {
      if (this.itemType === "album") {
        return this.item.user.username;
      } else {
        return this.item.merchant.username;
      }
    },
    itemTitle: function itemTitle() {
      if (this.itemType === "album") {
        return this.item.name;
      } else {
        return this.item.name;
      }
    },
    amount: function amount() {
      return this.receiver.repost_price;
    },
    stripeConnected: function stripeConnected() {
      return this.receiver.stripe_connected;
    }
  },

  created: function created() {
    if (!this.stripeConnected) {
      this.show_error_dialog = true;
    }

    this.fee = __WEBPACK_IMPORTED_MODULE_1__helper__["d" /* Stripe */].calculateFee(this.amount);
  },


  methods: {
    sendPayment: function sendPayment() {
      var _this = this;

      this.sent_payment = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_stripe_elements__["createToken"])().then(function (data) {
        _this.finish(data.token);
      });
    }
  }
});

/***/ }),
/* 924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    searchTab: {
      type: String
    },
    senderRoute: {
      type: String
    },
    placeholder: {
      type: String,
      default: "Search artist, song or keyword"
    },
    isOnMobile: Boolean,
    theme: {
      type: String,
      default: "light"
    },
    isRound: {
      type: Boolean,
      default: true
    },
    preIcon: {
      type: String,
      default: "/static/images/search.svg"
    }
  },
  data: function data() {
    return {
      keyword: ""
    };
  },

  methods: {
    goToSearch: function goToSearch() {
      var keyword = this.keyword;
      var senderRoute = this.senderRoute;
      var searchTab = this.searchTab;

      this.$router.push({
        name: "Search",
        query: { q: keyword },
        params: { senderRoute: senderRoute, searchTab: searchTab }
      });
    }
  },
  created: function created() {
    this.keyword = this.$route.query.q;
  }
});

/***/ }),
/* 925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_user__ = __webpack_require__(7);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    title: {
      type: String,
      required: true
    },

    type: {
      type: String
    },

    dismiss: {
      type: Function,
      required: true
    },

    selectUser: {
      type: Function,
      required: true
    }
  },

  data: function data() {
    return {
      keyword: "",
      users: [],
      page_index: 1,
      total_pages: 1,
      items_per_page: 20 * 5
    };
  },


  computed: {
    filtered_users: function filtered_users() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(this.users, function (user) {
        return user.user_type === _this.type;
      });
    }
  },

  created: function created() {
    this.loadUsers();
  },


  methods: {
    loadUsers: function loadUsers() {
      var _this2 = this;

      var params = {
        page: this.page_index,
        per_page: this.items_per_page
      };
      if (this.keyword.length) {
        params["q"] = this.keyword;
      }
      __WEBPACK_IMPORTED_MODULE_1__services_user__["a" /* default */].searchUsers(params).then(function (response) {
        _this2.users = response.body.users;
      }).catch(function (e) {
        _this2.$store.dispatch("error/showErrorToast", e.body.errors || [e.body]);
      });
    },
    onSelectUser: function onSelectUser(user) {
      this.dismiss();
      this.selectUser(user);
    }
  }
});

/***/ }),
/* 926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_user__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_paymentmodal__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_paymentmodal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_paymentmodal__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    paymentModal: __WEBPACK_IMPORTED_MODULE_1__components_paymentmodal___default.a
  },

  props: {
    item: {
      type: Object,
      required: true
    },

    dismiss: {
      type: Function,
      required: true
    }
  },

  data: function data() {
    return {
      donate_amount: 0,
      description: "Donation",
      // descriptions: [
      //   'Donation',
      //   // 'Remix',
      //   // 'Vocalist',
      //   // 'Production',
      //   // 'Vocal Production',
      //   // 'Mixing',
      //   // 'Mastering',
      //   // 'Artwork',
      //   // 'Writer',
      //   // 'Session Musician'
      // ],
      showPaymentModal: false,
      buttonHover: false
    };
  },


  computed: {
    onMobile: function onMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    followButtonText: function followButtonText() {
      if (this.item.is_following) {
        return this.buttonHover ? "Unfollow" : "Following";
      }
      return "Follow";
    },
    donate_amount_by_cent: function donate_amount_by_cent() {
      return this.donate_amount * 100;
    },
    isVideoCreditSelected: function isVideoCreditSelected() {
      return this.description === "Add Video Credit";
    },
    descriptions: function descriptions() {
      if (["listener"].indexOf(this.item.user_type) > -1) {
        return ["Donation"];
      } else {
        return ["Donation", "Add Video Credit"];
      }
    }
  },

  created: function created() {},


  methods: {
    donateAmount: function donateAmount(amount) {
      this.donate_amount = amount;
    },
    showPaymentDialog: function showPaymentDialog() {
      if (this.donate_amount > 0) {
        this.showPaymentModal = true;
      }
    },
    hidePaymentDialog: function hidePaymentDialog() {
      this.showPaymentModal = false;
    },
    sendLove: function sendLove(token) {
      var _this = this;

      this.dismiss();
      var params = {
        amount: this.donate_amount_by_cent,
        description: this.description
      };
      if (token) {
        params["payment_token"] = token.id;
      }

      if (this.isVideoCreditSelected) {
        __WEBPACK_IMPORTED_MODULE_0__services_user__["a" /* default */].addVideoCredit(this.item.slug, params).then(function (response) {
          _this.$store.dispatch("error/showSuccessToast", ["You've added $" + _this.donate_amount + " video credit to " + _this.item.username]);
        }).catch(function (e) {
          _this.$store.dispatch("error/showErrorToast", e.body.errors || [e.body]);
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_0__services_user__["a" /* default */].donateMoney(this.item.slug, params).then(function (response) {
          _this.$store.dispatch("error/showSuccessToast", ["You've donated $" + _this.donate_amount + " to " + _this.item.username]);
        }).catch(function (e) {
          _this.$store.dispatch("error/showErrorToast", e.body.errors || [e.body]);
        });
      }
    }
  }
});

/***/ }),
/* 927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_emoji_mart_vue__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_emoji_mart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_emoji_mart_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_album__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_message__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_product__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_user__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_repost_payment_modal__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_repost_payment_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_repost_payment_modal__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











var DefaultRepostMessage = "Hi, if you like this please repost it, thank you.";

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    receiver: {
      type: Object,
      required: true
    },

    dismiss: {
      type: Function,
      required: true
    }
  },

  components: {
    Picker: __WEBPACK_IMPORTED_MODULE_2_emoji_mart_vue__["Picker"],
    repostPaymentModal: __WEBPACK_IMPORTED_MODULE_7__components_repost_payment_modal___default.a
  },

  data: function data() {
    return {
      showEmojiPicker: false,
      show_repost_payment_modal: false,
      tab: "album",
      item: null,
      albums: [],
      products: [],
      itemType: {
        album: "Album",
        merch: "ShopProduct"
      },
      repostedFeeeds: [],
      message: ""
    };
  },


  computed: {
    current_repost_price: function current_repost_price() {
      return this.receiver.repost_price;
    }
  },

  created: function created() {
    var _this = this;

    // console.log(this.receiver)
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_3__services_album__["a" /* default */].getAlbums({
      statuses: "published, collaborated",
      user_statuses: "accepted"
    }), __WEBPACK_IMPORTED_MODULE_5__services_product__["a" /* default */].getProducts({
      statuses: "published, collaborated",
      stock_statuses: "active",
      user_statuses: "accepted"
    }), __WEBPACK_IMPORTED_MODULE_6__services_user__["a" /* default */].repostedFeeds(this.receiver.id)]).then(function (values) {
      _this.albums = values[0].body;
      _this.products = values[1].body;
      _this.repostedFeeds = values[2].body;
      // this.$forceUpdate()
    }).catch(function (reason) {
      console.log(reason);
      // this.$store.dispatch('error/showErrorToast', [reason])
    });
  },


  methods: {
    InBanned: function InBanned(album) {
      return this.InHiddenGenres(album) || this.InReposted(album);
    },


    // true : in hidden genres
    InHiddenGenres: function InHiddenGenres(album) {
      var genreId = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(album.genres, "[0].id", "");
      var genre = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(this.receiver.hidden_genres, function (genre) {
        return genre.id === genreId;
      });
      // return !(genre === undefined || genre === null)
      return !!genre;
    },
    InReposted: function InReposted(item) {
      var _this2 = this;

      var feed = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(this.repostedFeeds, function (f) {
        return f.assoc_type === _this2.itemType[_this2.tab] && f.assoc_id === item.id;
      });
      return !!feed;
    },
    openRepostPaymentModal: function openRepostPaymentModal() {
      // console.log(this.item)
      this.show_repost_payment_modal = true;
    },
    closeRepostPaymentModal: function closeRepostPaymentModal() {
      this.show_repost_payment_modal = false;
    },
    checkMessage: function checkMessage() {
      if (this.item) {
        this.openRepostPaymentModal();
      } else {
        this.sendMessage();
      }
    },
    sendMessage: function sendMessage(token) {
      var _this3 = this;

      this.dismiss();
      var params = {
        body: this.message
      };
      this.message = "";
      params["receiver_id"] = this.receiver.id;
      if (this.item) {
        if (this.tab === "album") {
          params["attachable_type"] = "Album";
          params["attachable_id"] = this.item.id;
        } else {
          params["attachable_type"] = "ShopProduct";
          params["attachable_id"] = this.item.id;
        }
        this.item = null;
      }
      if (token) {
        params["payment_token"] = token.id;
      }
      __WEBPACK_IMPORTED_MODULE_4__services_message__["a" /* default */].addMessage(params).then(function (response) {
        _this3.$store.dispatch("error/showSuccessToast", ["Sent message successfully."]);
      }).catch(function (e) {
        _this3.$store.dispatch("error/showErrorToast", e.body.errors || [e.body]);
      });
    },
    onTab: function onTab(tab) {
      this.tab = tab;
      this.item = null;
    },
    selectItem: function selectItem(item) {
      // console.log(this.item === item, this.item, item)
      if (this.item === item) {
        this.item = null;
        if (this.message === DefaultRepostMessage) {
          this.message = "";
        }
      } else {
        this.item = item;
        if (this.message === "") {
          this.message = DefaultRepostMessage;
        }
      }
    },
    addEmoji: function addEmoji(emoji, event) {
      this.showEmojiPicker = false;
      this.message += emoji.native;
      this.$refs.message.focus();
    }
  }
});

/***/ }),
/* 928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_album__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_userFollowBtn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_userFollowBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_userFollowBtn__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    item: {
      type: Object,
      required: true
    },
    type: {
      type: String
    },
    dismiss: {
      type: Function,
      required: true
    }
  },
  components: {
    UserFollowBtn: __WEBPACK_IMPORTED_MODULE_1__components_userFollowBtn___default.a
  },

  data: function data() {
    return {
      donate_amount: null,
      buttonHover: false,
      shareUrl: ""
    };
  },


  computed: {
    onMobile: function onMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    followButtonText: function followButtonText() {
      if (this.user.is_following) {
        return this.buttonHover ? "Unfollow" : "Following";
      }
      return "Follow";
    },
    itemType: function itemType() {
      switch (this.type) {
        case "Stream":
          return "Stream";
        default:
          if (this.item.slug) {
            return "Album";
          } else {
            return "ShopProduct";
          }
      }
    },
    user: function user() {
      if (this.item.slug) {
        return this.item.user;
      } else {
        return this.item.merchant;
      }
    },
    itemCover: function itemCover() {
      if (this.item.slug) {
        return this.item.cover.url;
      } else {
        var coverURL = "";
        for (var index in this.item.covers) {
          var cover = this.item.covers[index].cover;
          if (cover.url) {
            coverURL = cover.url;
            break;
          }
        }
        return coverURL;
      }
    }
  },

  created: function created() {
    switch (this.itemType) {
      case "Stream":
        this.shareUrl = window.location.origin + "/video/" + this.item.id + "/show";
        break;
      case "Album":
        this.shareUrl = window.location.origin + "/album/" + this.item.slug;
        break;
      case "ShopProduct":
        this.shareUrl = window.location.origin + "/product/" + this.item.id;
        break;
    }
  },


  methods: {
    donateAmount: function donateAmount(amount) {
      this.donate_amount = amount;
    },
    dismissModal: function dismissModal() {
      console.log("touched");
    },
    afterFollow: function afterFollow(isfollowing) {
      if (isfollowing === "unfollow") {
        this.item.user.is_following = false;
      } else if (isfollowing === "follow") {
        this.item.user.is_following = true;
      }
    },
    downloadItem: function downloadItem() {
      var _this = this;

      this.dismiss();
      __WEBPACK_IMPORTED_MODULE_0__services_album__["a" /* default */].downloadAlbum(this.item.id).then(function (response) {
        _this.$store.dispatch("error/showSuccessToast", ["You just download " + _this.item.name]);
      }).catch(function (e) {
        _this.$store.dispatch("error/showErrorToast", e.body.errors || [e.body]);
      });
    },


    onCopy: function onCopy(e) {
      this.$store.dispatch("error/showSuccessToast", ["You just copied: " + e.text]);
      // alert('You just copied: ' + e.text)
    },

    onError: function onError(e) {
      this.$store.dispatch("error/showErrorToast", ["Failed to copy link"]);
      // alert('Failed to copy link')
    }
  }
});

/***/ }),
/* 929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_search__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(6);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    currentUser: function currentUser() {
      return this.$store.state.auth.user;
    },
    playlists: function playlists() {
      return this.$store.state.playlist.playlists;
    }
  },

  data: function data() {
    return {
      albums: [],
      albumIndex: 0,
      playlist: {
        name: '',
        image: null
      },
      isPlaying: false,
      loading: false
    };
  },


  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])({
    setPlaylist: 'player/setPlaylist',
    setPlaylistIndex: 'player/setListIndex',
    setTrackIndex: 'player/setTrackIndex',
    setPlaying: "player/setPlayingStatus"
  }), {
    loadFeeds: function loadFeeds(tab, page) {
      var _this = this;

      this.loading = true;
      var params = {
        filter: tab,
        page: page,
        genre: 'any',
        category: 'any',
        per_page: 50
      };
      var api_response = this.currentUser != null ? __WEBPACK_IMPORTED_MODULE_1__services_search__["a" /* default */].searchDiscover(params) : __WEBPACK_IMPORTED_MODULE_1__services_search__["a" /* default */].searchDiscoverPublicUser(params);
      api_response.then(function (response) {
        _this.loading = false;
        _this.$store.dispatch('error/showLoadingActivity', false);
        _this.albums = response.body.albums;
        _this.playSong();
      }).catch(function (e) {
        _this.loading = false;
        _this.$store.dispatch('error/showLoadingActivity', false);
        _this.$store.dispatch('error/showLoadingActivity', false);
        console.log('discover error', e);
      });
    },
    playSong: function playSong() {
      this.albumIndex = Math.floor(Math.random() * this.albums.length);
      console.log("================", this.albumIndex);
      this.setPlaylist(this.albums);
      this.setPlaylistIndex(this.albumIndex);
      this.setPlaying(true);
      this.$root.$emit(__WEBPACK_IMPORTED_MODULE_2__helper__["b" /* MyEvents */].AUDIO_PLAYER_PLAY, 0);
    },
    pauseSong: function pauseSong() {
      this.$root.$emit(__WEBPACK_IMPORTED_MODULE_2__helper__["b" /* MyEvents */].AUDIO_PLAYER_PAUSE);
    }
  })
});

/***/ }),
/* 930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_howler__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_howler___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_howler__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_album__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_tracking__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_track__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_user__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_auth__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_stream__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_downloadmodal__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_downloadmodal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_downloadmodal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_sharemodal__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_sharemodal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_sharemodal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_userFollowBtn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_userFollowBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_userFollowBtn__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import PaymentService from '@/services/payment'










/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    isMini: Boolean
  },

  components: {
    downloadModal: __WEBPACK_IMPORTED_MODULE_10__components_downloadmodal___default.a,
    shareModal: __WEBPACK_IMPORTED_MODULE_11__components_sharemodal___default.a,
    UserFollowBtn: __WEBPACK_IMPORTED_MODULE_12__components_userFollowBtn___default.a
  },

  data: function data() {
    return {
      prvTrack: false,
      modalMode: false,
      playlist: [],
      index: 0,
      isLoaded: false,
      isRepeated: false,
      isPlaying: false,
      trackIndex: null,
      trackName: null,
      track: {},
      playedTime: 0,
      progress: 0,
      volume: 100,
      lastVolume: 100,
      showDownloadModal: false,
      showShareModal: false,
      showListeningMessage: false,
      showReminder: false,
      totalTime: null,
      buttonHover: false,
      stillListeningTimer: null,
      remainingTimerCalculator: null,
      remainingTime: 0,
      remainingStillListenerTimer: 0,
      isSubscribed: false,
      previewTimeCompleted: false,
      show_logout_modal: false,
      endPlayTime: 0,
      totalPlayTime: 0,
      playingSound: null,
      lastSeekTime: 0,
      bgDemoImg: __webpack_require__(148),
      videoLoading: __webpack_require__(147),
      show_modalCard1: false,
      show_modalCard2: false,
      show_modalCard3: false,
      show_modalCard4: false,
      spotlightVideoSource: null
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    reminderTracksCount: "app/reminderTracksCount"
  }), {
    currentUser: function currentUser() {
      return this.$store.state.auth.user;
    },
    MyEvents: function MyEvents() {
      return __WEBPACK_IMPORTED_MODULE_9__helper__["b" /* MyEvents */];
    },
    item: function item() {
      console.log(item);
      var item = this.$store.state.player.list[this.$store.state.player.listIndex];
      if (!item) {
        return null;
      }

      if (item.assoc_type) {
        return item.assoc;
      } else {
        return item;
      }
    },
    user: function user() {
      if (!this.item) {
        return null;
      }

      if (this.item.album_type === "album") {
        return this.item.user;
      } else {
        return this.track.user;
      }
    },
    stripeConnected: function stripeConnected() {
      return this.user.stripe_connected;
    },
    album1Cover: function album1Cover() {
      return this._.get(this.item.tracks, "[0].album.cover.url");
    },
    album2Cover: function album2Cover() {
      return this._.get(this.item.tracks, "[1].album.cover.url");
    },
    album3Cover: function album3Cover() {
      return this._.get(this.item.tracks, "[2].album.cover.url");
    },
    album4Cover: function album4Cover() {
      return this._.get(this.item.tracks, "[3].album.cover.url");
    }
  }),

  created: function created() {
    __WEBPACK_IMPORTED_MODULE_2_howler__["Howler"].volume(this.volume / 100);
  },


  watch: {
    showDownloadModal: function showDownloadModal(val) {
      this.triggerModalMode(val);
    },
    showShareModal: function showShareModal(val) {
      this.triggerModalMode(val);
    },
    isPlaying: function isPlaying(val) {
      if (val) {
        // Pause video on audio play
        try {
          // eslint-disable-next-line no-undef
          var pp = videojs("myVideoPlayer");
          if (!pp.paused()) {
            pp.pause();
          }
        } catch (error) {
          // console.log(error)
        }
      }
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])({
    setPlaying: "player/setPlayingStatus",
    setPauseStatus: "player/setPauseStatus"
  }), {
    startPlaying: function startPlaying(index) {
      this.setPlaylist("next");
      this.play(index);
      this.$forceUpdate();
    },
    triggerModalMode: function triggerModalMode(val) {
      if (!val) {
        this.modalMode = false;
      }
    },
    resetPlayer: function resetPlayer() {
      if (this.$store.state.player.isPlaying) {
        this.setPlaying(false);
        this.pause();
        this.setPauseStatus(false);
        this.$store.dispatch("player/setPlaylist", []);
        this.$store.dispatch("player/setListIndex", -1);
        this.$store.dispatch("player/setTrackIndex", -1);
        for (var index in this.playlist) {
          var item = this.playlist[index];
          if (item) {
            if (item.howl) {
              item.howl.unload();
            }
          }
        }
        this.playlist = [];
        this.index = 0;
        this.isLoaded = false;
        this.isRepeated = false;
        this.isPlaying = false;
        this.trackIndex = null;
        this.trackName = null;
        this.track = {};
        this.playedTime = 0;
        this.progress = 0;
        this.showDownloadModal = false;
        this.totalTime = null;
        this.buttonHover = false;
      }
    },
    fetchSpotlightVideo: function fetchSpotlightVideo() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_8__services_stream__["a" /* default */].getSpotlightStream(this.user.id).then(function (response) {
        console.log("response", response);
        _this.spotlightVideoSource = response.body.mp_channel_1_ep_1_id;
        if (_this.currentUser == null) {
          _this.show_modalCard3 = true;
        } else {
          _this.show_modalCard4 = true;
        }
      }).catch(function (e) {
        if (_this.currentUser == null) {
          _this.show_modalCard1 = true;
        } else {
          _this.show_modalCard2 = true;
        }
      });
    },
    trigger: function trigger() {
      var _this2 = this;

      document.addEventListener('keydown', function (e) {
        if (e.key != null && _this2.isPlaying) {
          _this2.clearStillListeningTimer(true);
        }
      });

      document.addEventListener('mousemove', function (e) {
        if (_this2.isPlaying) {
          _this2.clearStillListeningTimer(true);
        }
      });
    },
    play: function play(index) {
      var _this3 = this;

      this.previewTimeCompleted = false;
      this.remainingTime = 0;
      clearInterval(this.remainingTimerCalculator);
      if (this.currentUser) {
        if (this.track.id === this.prvTrack && !this.isSubscribed) {
          this.previewTimeCompleted = true;
          this.pause();
          this.fetchSpotlightVideo();
          sound.seek();
        }
        this.remainingTimerCalculator = setInterval(this.timeCounter, 1000);
        this.fetchSubscriptionDetails();
        this.clearStillListeningTimer();
      }

      // console.log('player', index, this.index, this.playlist)
      // unload and stop all previous sounds.
      for (var i = 0; i < __WEBPACK_IMPORTED_MODULE_2_howler__["Howler"]._howls.length; i++) {
        __WEBPACK_IMPORTED_MODULE_2_howler__["Howler"]._howls[i].unload();
      }
      var self = this;
      var sound;
      index = typeof index === "number" ? index : this.index;
      var data = this.playlist[index];

      // Update the track display.
      // track.innerHTML = (index + 1) + '. ' + data.title
      // this.trackName = this.playlist[index].track.name
      this.trackIndex = index + 1 + " of " + this.playlist.length;
      this.track = this.playlist[index].track;
      console.log("player play track sideAudioPlayer", this.track);
      this.$store.dispatch("player/setCurrentPlayingTrack", this.track);

      // If we already loaded self track, use the current one.
      // Otherwise, setup and load a new Howl.
      if (data.howl) {
        console.log("--data.howl---->", data.howl);
        sound = data.howl;
        this.playingSound = sound;
        try {
          sound.seek();
        } catch (error) {
          this.endPlayTime = 0;
        }
      } else {
        console.log("--data.track.audio---->", data.track);
        sound = data.howl = new __WEBPACK_IMPORTED_MODULE_2_howler__["Howl"]({
          src: data.track.mp_channel_1_ep_1_url,
          html5: true, // Force to HTML5 so that the audio can stream in (best for large files).
          onplay: function onplay() {
            // Display the duration.
            self.totalTime = self.formatTime(Math.round(sound.duration()));

            // Start upating the progress of the track.
            requestAnimationFrame(self.step.bind(this));

            // Start the wave animation if we have already loaded
            self.isPlaying = true;
            self.setPauseStatus(false);
            if (self.currentUser == null) {
              var publicUserLimit = setInterval(function () {
                if (sound.seek() >= 30) {
                  self.setPauseStatus(true);
                  self.isPlaying = false;
                  sound.pause();
                  self.fetchSpotlightVideo();
                  clearInterval(publicUserLimit);
                }
              }, 1000);
            }
          },
          onload: function onload() {
            // Start the wave animation.
            self.isLoaded = true;
          },
          onend: function onend() {
            // Stop the wave animation.
            // this.isLoaded = false
            // this.isPlaying = false
            if (self.currentUser) {
              localStorage.setItem("remainingTime", localStorage.getItem("remainingTime") - self.remainingStillListenerTimer * 1000);
            }
            if (self.isRepeated) {
              self.skipTo(self.index);
            } else {
              self.skip("right");
            }
          },
          onpause: function onpause() {
            // Stop the wave animation.
            // this.isPlaying = false
          },
          onstop: function onstop() {
            // Stop the wave animation.
            // this.isPlaying = false
            if (window.location.href.includes("discover")) {
              if (self.totalPlayTime >= 30 && self.isSubscribed) {
                var params = { track_id: self.track.id, duration: Math.floor(self.totalPlayTime) };

                __WEBPACK_IMPORTED_MODULE_4__services_tracking__["a" /* default */].createPlayRecord(params).then(function (response) {
                  console.log(response);
                }).catch(function (e) {
                  console.log("error in updating record");
                });
              }
              self.totalPlayTime = 0;
              self.endPlayTime = 0;
              self.lastSeekTime = 0;
            }
          }
        });
        this.playingSound = sound;

        var api_call = this.currentUser ? __WEBPACK_IMPORTED_MODULE_5__services_track__["a" /* default */].playTrack(this.track.id) : __WEBPACK_IMPORTED_MODULE_5__services_track__["a" /* default */].playTrackPublicUser(this.track.id);
        api_call.then(function (response) {
          return console.log("playing - track", _this3.track.id);
        });
      };
      // Begin playing the sound.
      sound.play();

      this.$store.dispatch("player/setProgressiveTrack", data);

      // Show the pause button.
      if (sound.state() === "loaded") {
        this.isPlaying = true;
        this.isLoaded = true;
      } else {
        this.isLoaded = false;
        this.isPlaying = false;
      }
      // Keep track of the index we are currently playing.
      this.index = index;
      this.$store.dispatch("player/setTrackIndex", index);

      // / Show the reminder on the audio player
      // if (this.index > 0 && this.index % this.reminderTracksCount == 0) {
      //   PaymentService.hasTransactionInPeriod().then(res => {
      //     if (res.body != true) {
      //       this.showReminder = true
      //       setTimeout(() => { this.showReminder = false }, 5000)
      //     }
      //   })
      // }
    },
    clearStillListeningTimer: function clearStillListeningTimer() {
      var setTimer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (localStorage.getItem("remainingTime") == null || setTimer) {
        this.remainingStillListenerTimer = 0;
        localStorage.setItem("remainingTime", 3600000);
      }
      if (typeof this.stillListeningTimer === 'number') {
        clearTimeout(this.stillListeningTimer);
        this.stillListeningTimer = null;
      }
      this.stillListeningTimer = setTimeout(this.stillListening, localStorage.getItem("remainingTime"));
    },


    /**
     * Pause the currently playing track.
     */
    pause: function pause() {
      if (this.currentUser) {
        this.updateUserInfo();
      }
      // player is not initialized yet.
      if (!this.$store.state.player.isPlaying) return;

      // Get the Howl we want to manipulate.
      var sound = this.playlist[this.index].howl;

      if (this.totalPlayTime === 0) {
        this.totalPlayTime = Math.floor(sound.seek());
      } else {
        this.totalPlayTime = this.totalPlayTime + (Math.floor(sound.seek()) - this.endPlayTime);
      }
      this.endPlayTime = sound.seek();
      // Puase the sound.
      sound.pause();

      // Show the play button.
      this.isPlaying = false;
      this.setPauseStatus(true);
      // this.setPlaying(false)

      // update current track playing
      this.$store.dispatch("player/setCurrentPlayingTrack", this.track);
    },
    skip: function skip(direction) {
      // Get the next track based on the direction of the track.
      if (this.playlist.length === 1 || this.playlist.length > 1 && direction === 'next' && this.index === this.playlist.length - 1) {
        var _sound = this.playlist[this.index].howl;
        this.lastSeekTime = _sound.seek() > 0 ? _sound.seek() : _sound.duration();
      }

      var index = 0;
      if (direction === "prev") {
        index = this.index - 1;
        if (index < 0) {
          this.$store.dispatch("player/setListIndex", this.$store.state.player.listIndex - 1);
          this.setPlaylist("prev");
          index = this.playlist.length - 1;
          // this.$root.$emit('index_change')
        }
      } else {
        index = this.index + 1;
        if (index >= this.playlist.length) {
          index = 0;
          this.$store.dispatch("player/setListIndex", this.$store.state.player.listIndex + 1);
          this.setPlaylist("next");
          // this.$root.$emit('index_change')
        } else {
          this.setPlaylist("next");
        }
      }
      this.$store.dispatch("player/setTrackIndex", index);
      this.skipTo(index);
    },


    /**
     * Skip to a specific track based on its playlist index.
     * @param  {Number} index Index in the playlist.
     */
    skipTo: function skipTo(index) {
      if (this.currentUser) {
        this.updateUserInfo();
      }
      // Stop the current track.
      var sound = null;
      if (this.playlist[this.index] !== null && this.playlist[this.index] !== undefined) {
        if (this.playlist[this.index].howl !== undefined && this.playlist[this.index].howl !== null) {
          sound = this.playlist[this.index].howl;
          this.lastSeekTime = sound.seek() > 0 ? sound.seek() : sound.duration();
          sound.stop();
        }
      }

      if (this.totalPlayTime === 0) {
        this.totalPlayTime = Math.floor(this.lastSeekTime);
      } else {
        this.totalPlayTime = this.totalPlayTime + Math.floor(this.lastSeekTime - this.endPlayTime);
      }
      console.log("total play time =========", this.totalPlayTime);
      if (this.totalPlayTime >= 30 && this.isSubscribed) {
        var params = { track_id: this.track.id, duration: Math.floor(this.totalPlayTime) };

        __WEBPACK_IMPORTED_MODULE_4__services_tracking__["a" /* default */].createPlayRecord(params).then(function (response) {
          console.log(response);
        }).catch(function (e) {
          console.log("error in updating record");
        });
      }
      this.totalPlayTime = 0;
      this.endPlayTime = 0;
      this.lastSeekTime = 0;
      // Reset progress.
      this.progress = 0;

      if (this.playlist.length > 0) {
        // Play the new track.
        this.play(index);
      }
    },


    /**
     * Seek to a new position in the currently playing track.
     * @param  {Number} per Percentage through the song to skip.
     */
    seek: function seek(per) {
      // Get the Howl we want to manipulate.
      var sound = this.playlist[this.index].howl;
      var seekTime1 = Math.floor(sound.seek());
      // Convert the percent into a seek position.
      if (sound.playing()) {
        sound.seek(sound.duration() * per / 100);
      }
      var seekTime2 = Math.floor(sound.seek());

      if (this.totalPlayTime === 0) {
        this.totalPlayTime = this.totalPlayTime + seekTime1;
        this.endPlayTime = seekTime2;
      } else {
        this.totalPlayTime = this.totalPlayTime + (seekTime1 - this.endPlayTime);
        this.endPlayTime = seekTime2;
      }
      console.log("total play time", this.totalPlayTime);
    },


    /**
     * The step called within requestAnimationFrame to update the playback position.
     */
    step: function step() {
      // Get the Howl we want to manipulate.
      var sound = null;
      // var sound = this.playlist[this.index].howl
      if (this.playlist[this.index] !== null && this.playlist[this.index] !== undefined) {
        if (this.playlist[this.index].howl !== undefined && this.playlist[this.index].howl !== null) {
          sound = this.playlist[this.index].howl;

          // Determine our current seek position.
          var seek = sound.seek() || 0;
          this.playedTime = this.formatTime(Math.round(seek));
          this.progress = seek / sound.duration() * 100 || 0;

          // If the sound is still playing, continue stepping.
          if (sound.playing()) {
            requestAnimationFrame(this.step.bind(this));
          }
        }
      }
    },
    setPlaylist: function setPlaylist(direction) {
      // Display the title of the first track.
      var object = this.$store.state.player.list[this.$store.state.player.listIndex];
      var tracks = [];
      if (direction === "next") {
        for (var i = this.$store.state.player.listIndex; i < this.$store.state.player.list.length; i++) {
          object = this.$store.state.player.list[i];
          if (object.assoc_type) {
            if (object.assoc_type === "Album") {
              tracks = object.assoc.tracks;
              this.$store.dispatch("player/setListIndex", i);
              this.$root.$emit("index_change");
              break;
            }
          } else {
            if (window.location.href.includes("collection") || window.location.href.includes("playlist")) {
              if (object.tracks && object.tracks.length > 0) {
                // Surprise me case in collections and playlists
                tracks = object.tracks;
              } else {
                tracks.push(object.track);
              }
            } else {
              tracks = object.tracks;
            }
            this.$store.dispatch("player/setListIndex", i);
            this.$root.$emit("index_change");
            break;
          }
        }
      } else {
        for (i = this.$store.state.player.listIndex; i >= 0; i--) {
          object = this.$store.state.player.list[i];
          if (object.assoc_type) {
            if (object.assoc_type === "Album") {
              tracks = object.assoc.tracks;
              this.$store.dispatch("player/setListIndex", i);
              this.$root.$emit("index_change");
              break;
            }
          } else {
            tracks = object.tracks;
            this.$store.dispatch("player/setListIndex", i);
            this.$root.$emit("index_change");
            break;
          }
        }
      }
      for (var index in this.playlist) {
        var item = this.playlist[index];
        if (item) {
          if (item.howl) {
            var track_id = item.track.id;
            var track_play_time = item.howl.seek();
            if (window.location.href.includes("discover")) {
              if (track_play_time >= 30 && this.isSubscribed) {
                var params = { track_id: track_id, duration: Math.floor(track_play_time) };
                __WEBPACK_IMPORTED_MODULE_4__services_tracking__["a" /* default */].createPlayRecord(params).then(function (response) {
                  console.log(response);
                }).catch(function (e) {
                  console.log("error in updating record");
                });
              }
            }
            item.howl.unload();
          }
        }
      }
      this.playlist = [];
      this.index = 0;
      if (tracks.length > 0) {
        if (this.currentUser) {
          var album = object.assoc || object;
          __WEBPACK_IMPORTED_MODULE_3__services_album__["a" /* default */].playAlbum(album.id).then(function (response) {
            return console.log("playing - album", album.id);
          });
        }

        for (var track in tracks) {
          this.playlist.push({
            track: tracks[track],
            played: false,
            howl: null
          });
        }
        // if (this.$store.state.player.trackIndex > -1) {
        //   this.index = this.$store.state.player.trackIndex
        // }
        this.$store.dispatch("player/setTrackIndex", 0);
        this.trackIndex = this.index + 1 + " of " + this.playlist.length;
        // this.trackName = this.playlist[this.index].track.name
        this.track = this.playlist[this.index].track;
        // console.log('player setPlaylist track', this.track)
      } else {
        this.$store.dispatch("player/setListIndex", -1);
        this.$store.dispatch("player/setPlayingStatus", false);
      }
    },
    formatTime: function formatTime(secs) {
      var minutes = Math.floor(secs / 60) || 0;
      var seconds = secs - minutes * 60 || 0;

      return minutes + ":" + (seconds < 10 ? "0" : "") + seconds;
    },
    stillListening: function stillListening() {
      this.pause();
      this.showListeningMessage = true;
    },
    timeCounter: function timeCounter() {
      if (this.previewTimeCompleted) {
        this.previewTimeCompleted = false;
        this.pause();
        this.fetchSpotlightVideo();
      } else {
        if (this.currentUser && this.currentUser.free_trial_time <= this.remainingTime && !this.isSubscribed && this.remainingTime >= 15) {
          this.previewTimeCompleted = true;
          this.pause();
          this.updateUserInfo();
          this.fetchSpotlightVideo();
          this.prvTrack = this.track.id;
        }
        this.remainingTime = this.remainingTime + 1;
      }
      this.remainingStillListenerTimer = this.remainingStillListenerTimer + 1;
    },
    choosePage: function choosePage(path) {
      this.$router.push({ path: "/" + path });
    },
    dismissDownloadDialog: function dismissDownloadDialog() {
      this.showDownloadModal = false;
    },
    dismissShareDialog: function dismissShareDialog() {
      this.showShareModal = false;
    },
    setRepeated: function setRepeated() {
      this.isRepeated = !this.isRepeated;
    },
    hideListeningMessage: function hideListeningMessage() {
      localStorage.setItem("remainingTime", 3600000);
      this.showListeningMessage = false;
    },
    fetchSubscriptionDetails: function fetchSubscriptionDetails() {
      var _this4 = this;

      if (this.currentUser) {
        __WEBPACK_IMPORTED_MODULE_6__services_user__["a" /* default */].getSubscriptionDetail(this.currentUser.id).then(function (response) {
          if (response.bodyText === "Subscribed") {
            _this4.isSubscribed = true;
          }
        }).catch(function (e) {
          _this4.$store.dispatch('error/showErrorToast', ["There was an error on fetching user info "]);
        });
      }
    },
    updateUserInfo: function updateUserInfo() {
      var _this5 = this;

      var params = {
        user: { free_trial_time: this.remainingTime }
      };
      __WEBPACK_IMPORTED_MODULE_6__services_user__["a" /* default */].updateUserInfo(this.currentUser.id, params).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_7__services_auth__["a" /* default */].setUser(response.body);
      }).catch(function (e) {
        console.log(e);

        _this5.$store.dispatch('error/showErrorToast', ["There was an error on updating user info "]);
      });
      clearInterval(this.remainingTimerCalculator);
      clearTimeout(this.stillListeningTimer);
      this.remainingTime = 0;
    },
    repostItem: function repostItem() {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_3__services_album__["a" /* default */].repostAlbum(this.item.id).then(function (response) {
        _this6.$store.dispatch("error/showSuccessToast", ["You just reposted " + _this6.item.name]);
      }).catch(function (e) {
        _this6.$store.dispatch("error/showErrorToast", e.body.errors || [e.body]);
      });
    },
    setFollowingStatus: function setFollowingStatus(userId, isFollowing) {
      // console.log('player setFollowingStatus', status)
      // console.log(this.user)
      if (this.user && this.user.id === userId) {
        this.$store.dispatch("player/updateFollowingStatus", isFollowing);
      }
    },
    skipTrack: function skipTrack(index) {
      this.skipTo(index);
    },


    // onVolumeChange (evt) {
    //   // console.log('onVolumeChange', evt, this.volume)
    //   this.updateVolume(this.volume)
    // },

    updateVolume: function updateVolume() {
      // console.log('updateVolume', volume)
      __WEBPACK_IMPORTED_MODULE_2_howler__["Howler"].volume(this.volume / 100);
    },
    randomPlay: function randomPlay() {
      this.$store.dispatch("player/setShuffleStatus", !this.$store.state.player.isShuffle);
    },
    setupPlayerOnStart: function setupPlayerOnStart() {
      var track = this.$store.state.player.progressiveTrack;
      var sound = track.howl;
      var seek = sound.seek() || 0;
      this.playlist[this.$store.state.player.trackIndex] = track;
      this.isPlaying = this.$store.state.player.isPlaying && !this.$store.state.player.isPaused;
      this.totalTime = this.formatTime(Math.round(sound.duration()));
      this.playedTime = this.formatTime(Math.round(seek));
      this.progress = seek / sound.duration() * 100 || 0;
      this.isLoaded = true;
      requestAnimationFrame(this.step.bind(this));
    }
  }),

  mounted: function mounted() {
    this.$root.$on(__WEBPACK_IMPORTED_MODULE_9__helper__["b" /* MyEvents */].AUDIO_PLAYER_PLAY, this.startPlaying);
    this.$root.$on(__WEBPACK_IMPORTED_MODULE_9__helper__["b" /* MyEvents */].AUDIO_PLAYER_REPLAY, this.play);
    this.$root.$on(__WEBPACK_IMPORTED_MODULE_9__helper__["b" /* MyEvents */].AUDIO_PLAYER_PAUSE, this.pause);
    this.$root.$on(__WEBPACK_IMPORTED_MODULE_9__helper__["b" /* MyEvents */].AUDIO_PLAYER_SKIPTO, this.skipTrack);
    this.$root.$on(__WEBPACK_IMPORTED_MODULE_9__helper__["b" /* MyEvents */].AUTH_SIGNOUT, this.resetPlayer);
    this.$root.$on(__WEBPACK_IMPORTED_MODULE_9__helper__["b" /* MyEvents */].USER_FOLLOW, this.setFollowingStatus);
    this.$root.$on(__WEBPACK_IMPORTED_MODULE_9__helper__["b" /* MyEvents */].STREM_PLAYER_FULLSCREEN_ENTER, this.pause);
    this.trigger();
    if (this.$store.state.player.isPlaying) {
      this.setupPlayerOnStart(this.$store.state.player.trackIndex);
    }
  }
});

/***/ }),
/* 931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_autoplay__ = __webpack_require__(840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Controls_vue__ = __webpack_require__(1595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Controls_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Controls_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Slide_vue__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Slide_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Slide_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global $:true */




var noop = function noop() {};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'carousel3d',
  components: {
    Controls: __WEBPACK_IMPORTED_MODULE_1__Controls_vue___default.a,
    Slide: __WEBPACK_IMPORTED_MODULE_2__Slide_vue___default.a
  },
  props: {
    count: {
      type: [Number, String],
      default: 0
    },
    perspective: {
      type: [Number, String],
      default: 35
    },
    display: {
      type: [Number, String],
      default: 5
    },
    loop: {
      type: Boolean,
      default: true
    },
    animationSpeed: {
      type: [Number, String],
      default: 500
    },
    dir: {
      type: String,
      default: 'rtl'
    },
    width: {
      type: [Number, String],
      default: 360
    },
    height: {
      type: [Number, String],
      default: 270
    },
    border: {
      type: [Number, String],
      default: 1
    },
    space: {
      type: [Number, String],
      default: 'auto'
    },
    startIndex: {
      type: [Number, String],
      default: 0
    },
    clickable: {
      type: Boolean,
      default: true
    },
    disable3d: {
      type: Boolean,
      default: false
    },
    minSwipeDistance: {
      type: Number,
      default: 10
    },
    inverseScaling: {
      type: [Number, String],
      default: 300
    },
    controlsVisible: {
      type: Boolean,
      default: false
    },
    controlsPrevHtml: {
      type: String,
      default: '&lsaquo;'
    },
    controlsNextHtml: {
      type: String,
      default: '&rsaquo;'
    },
    controlsWidth: {
      type: [String, Number],
      default: 50
    },
    controlsHeight: {
      type: [String, Number],
      default: 50
    },
    onLastSlide: {
      type: Function,
      default: noop
    },
    onSlideChange: {
      type: Function,
      default: noop
    }
  },
  data: function data() {
    return {
      viewport: 0,
      currentIndex: 0,
      total: 0,
      lock: false,
      dragOffset: 0,
      dragStartX: 0,
      mousedown: false,
      zIndex: 998,
      size: 0
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_autoplay__["a" /* default */]],
  watch: {
    count: function count() {
      this.computeData();
    }
  },
  computed: {
    isLastSlide: function isLastSlide() {
      return this.currentIndex === this.total - 1;
    },
    isFirstSlide: function isFirstSlide() {
      return this.currentIndex === 0;
    },
    isNextPossible: function isNextPossible() {
      return !(!this.loop && this.isLastSlide);
    },
    isPrevPossible: function isPrevPossible() {
      return !(!this.loop && this.isFirstSlide);
    },
    slideWidth: function slideWidth() {
      var vw = this.viewport;
      var screenHeight = $(window).height();
      this.size = screenHeight - 150 - 170 - 150;
      var sw = parseInt(this.size) + parseInt(this.border, 10) * 2;
      if (vw <= 0) {
        vw = sw;
      }
      return vw < sw ? vw : sw;
    },
    slideHeight: function slideHeight() {
      var screenHeight = $(window).height();
      this.size = screenHeight - 150 - 170 - 150;
      var sw = parseInt(this.size, 10) + parseInt(this.border, 10) * 2;
      var sh = parseInt(parseInt(this.size) + this.border * 2, 10);
      var ar = this.calculateAspectRatio(sw, sh);
      return this.slideWidth / ar;
    },
    visible: function visible() {
      var v = this.display > this.total ? this.total : this.display;

      return v !== 2 ? v % 2 ? v : v - 1 : v;
    },
    hasHiddenSlides: function hasHiddenSlides() {
      return this.total > this.visible;
    },
    leftIndices: function leftIndices() {
      var n = Math.floor(this.visible / 2) + 1;
      var indices = [];

      for (var m = 1; m < n; m++) {
        indices.push(this.dir === 'ltr' ? (this.currentIndex + m) % this.total : (this.currentIndex - m) % this.total);
      }

      return indices;
    },
    rightIndices: function rightIndices() {
      var n = Math.floor(this.visible / 2) + 1;
      var indices = [];

      for (var m = 1; m < n; m++) {
        indices.push(this.dir === 'ltr' ? (this.currentIndex - m) % this.total : (this.currentIndex + m) % this.total);
      }

      return indices;
    },
    leftOutIndex: function leftOutIndex() {
      var n = Math.floor(this.visible / 2) + 1;

      if (this.dir === 'ltr') {
        return this.total - this.currentIndex - n <= 0 ? -parseInt(this.total - this.currentIndex - n) : this.currentIndex + n;
      } else {
        return this.currentIndex - n;
      }
    },
    rightOutIndex: function rightOutIndex() {
      var n = Math.floor(this.visible / 2) + 1;

      if (this.dir === 'ltr') {
        return this.currentIndex - n;
      } else {
        return this.total - this.currentIndex - n <= 0 ? -parseInt(this.total - this.currentIndex - n, 10) : this.currentIndex + n;
      }
    }
  },
  methods: {
    /**
     * Go to next slide
     */
    goNext: function goNext() {
      if (this.isNextPossible) {
        this.isLastSlide ? this.goSlide(0) : this.goSlide(this.currentIndex + 1);
      }
    },

    /**
     * Go to previous slide
     */
    goPrev: function goPrev() {
      if (this.isPrevPossible) {
        this.isFirstSlide ? this.goSlide(this.total - 1) : this.goSlide(this.currentIndex - 1);
      }
    },

    /**
     * Go to slide
     * @param  {String} index of slide where to go
     */
    goSlide: function goSlide(index) {
      var _this = this;

      this.currentIndex = index < 0 || index > this.total - 1 ? 0 : index;
      this.lock = true;

      if (this.isLastSlide) {
        if (this.onLastSlide !== noop) {
          console.warn('onLastSlide deprecated, please use @last-slide');
        }
        this.onLastSlide(this.currentIndex);

        this.$emit('last-slide', this.currentIndex);
      }

      this.$emit('before-slide-change', this.currentIndex);

      setTimeout(function () {
        return _this.animationEnd();
      }, this.animationSpeed);
    },

    /**
     * Go to slide far slide
     */
    goFar: function goFar(index) {
      var _this2 = this;

      var diff = index === this.total - 1 && this.isFirstSlide ? -1 : index - this.currentIndex;

      if (this.isLastSlide && index === 0) {
        diff = 1;
      }

      var diff2 = diff < 0 ? -diff : diff;
      var timeBuff = 0;
      var i = 0;

      while (i < diff2) {
        i += 1;
        var timeout = diff2 === 1 ? 0 : timeBuff;

        setTimeout(function () {
          return diff < 0 ? _this2.goPrev(diff2) : _this2.goNext(diff2);
        }, timeout);

        timeBuff += this.animationSpeed / diff2;
      }
    },

    /**
     * Trigger actions when animation ends
     */
    animationEnd: function animationEnd() {
      this.lock = false;

      if (this.onSlideChange !== noop) {
        console.warn('onSlideChange deprecated, please use @after-slide-change');
      }
      this.onSlideChange(this.currentIndex);

      this.$emit('after-slide-change', this.currentIndex);
    },

    /**
     * Trigger actions when mouse is released
     * @param  {Object} e The event object
     */
    handleMouseup: function handleMouseup() {
      this.mousedown = false;
      this.dragOffset = 0;
    },

    /**
     * Trigger actions when mouse is pressed
     * @param  {Object} e The event object
     */
    handleMousedown: function handleMousedown(e) {
      if (!e.touches) {
        e.preventDefault();
      }

      this.mousedown = true;
      this.dragStartX = 'ontouchstart' in window ? e.touches[0].clientX : e.clientX;
    },

    /**
     * Trigger actions when mouse is pressed and then moved (mouse drag)
     * @param  {Object} e The event object
     */
    handleMousemove: function handleMousemove(e) {
      if (!this.mousedown) {
        return;
      }

      var eventPosX = 'ontouchstart' in window ? e.touches[0].clientX : e.clientX;
      var deltaX = this.dragStartX - eventPosX;

      this.dragOffset = deltaX;

      if (this.dragOffset > this.minSwipeDistance) {
        this.handleMouseup();
        this.goNext();
      } else if (this.dragOffset < -this.minSwipeDistance) {
        this.handleMouseup();
        this.goPrev();
      }
    },

    /**
     * A mutation observer is used to detect changes to the containing node
     * in order to keep the magnet container in sync with the height its reference node.
     */
    attachMutationObserver: function attachMutationObserver() {
      var _this3 = this;

      var MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;

      if (MutationObserver) {
        var config = {
          attributes: true,
          childList: true,
          characterData: true
        };

        this.mutationObserver = new MutationObserver(function () {
          _this3.$nextTick(function () {
            _this3.computeData();
          });
        });

        if (this.$el) {
          this.mutationObserver.observe(this.$el, config);
        }
      }
    },

    /**
     * Stop listening to mutation changes
     */
    detachMutationObserver: function detachMutationObserver() {
      if (this.mutationObserver) {
        this.mutationObserver.disconnect();
      }
    },

    /**
     * Get the number of slides
     * @return {Number} Number of slides
     */
    getSlideCount: function getSlideCount() {
      if (this.$slots.default !== undefined) {
        return this.$slots.default.filter(function (value) {
          return value.tag !== void 0;
        }).length;
      }

      return 0;
    },

    /**
     * Calculate slide with and keep defined aspect ratio
     * @return {Number} Aspect ratio number
     */
    calculateAspectRatio: function calculateAspectRatio(width, height) {
      return Math.min(width / height);
    },

    /**
     * Re-compute the number of slides and current slide
     */
    computeData: function computeData() {
      this.total = this.getSlideCount();
      this.currentIndex = parseInt(this.startIndex) > this.total - 1 ? this.total - 1 : parseInt(this.startIndex);
      this.viewport = this.$el.clientWidth;
    },
    setSize: function setSize() {
      this.$el.style.cssText += 'height:' + this.slideHeight + 'px;';
      this.$el.childNodes[0].style.cssText += 'width:' + this.slideWidth + 'px;' + ' height:' + this.slideHeight + 'px;';
    },
    moveSlide: function moveSlide() {
      this.goSlide(this.$store.state.player.listIndex);
    }
  },

  mounted: function mounted() {
    this.computeData();
    this.attachMutationObserver();

    if (!this.$isServer) {
      window.addEventListener('resize', this.setSize);

      if ('ontouchstart' in window) {
        this.$el.addEventListener('touchstart', this.handleMousedown);
        this.$el.addEventListener('touchend', this.handleMouseup);
        this.$el.addEventListener('touchmove', this.handleMousemove);
      } else {
        this.$el.addEventListener('mousedown', this.handleMousedown);
        this.$el.addEventListener('mouseup', this.handleMouseup);
        this.$el.addEventListener('mousemove', this.handleMousemove);
      }
    }
    // this.$root.$on('index_change', this.moveSlide)
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.$isServer) {
      this.detachMutationObserver();

      if ('ontouchstart' in window) {
        this.$el.removeEventListener('touchmove', this.handleMousemove);
      } else {
        this.$el.removeEventListener('mousemove', this.handleMousemove);
      }

      window.removeEventListener('resize', this.setSize);
    }
  }
});

/***/ }),
/* 932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'controls',
  props: {
    /**
     * Width in pixels of the navigation buttons
     */
    width: {
      type: [String, Number],
      default: 50
    },
    /**
     * Height in pixels of the navigation buttons
     */
    height: {
      type: [String, Number],
      default: 60
    },
    /**
     * Text content of the navigation prev button
     */
    prevHtml: {
      type: String,
      default: '&lsaquo;'
    },
    /**
     * Text content of the navigation next button
     */
    nextHtml: {
      type: String,
      default: '&rsaquo;'
    }
  },
  data: function data() {
    return {
      parent: this.$parent
    };
  }
});

/***/ }),
/* 933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'slide',
  props: {
    index: {
      type: Number
    }
  },
  data: function data() {
    return {
      parent: this.$parent,
      styles: {},
      zIndex: 999
    };
  },

  computed: {
    isCurrent: function isCurrent() {
      return this.index === this.parent.currentIndex;
    },
    slideStyle: function slideStyle() {
      var styles = {};

      if (!this.isCurrent) {
        var rIndex = this.getSideIndex(this.parent.rightIndices);
        var lIndex = this.getSideIndex(this.parent.leftIndices);

        if (rIndex >= 0 || lIndex >= 0) {
          styles = rIndex >= 0 ? this.calculatePosition(rIndex, true, this.zIndex) : this.calculatePosition(lIndex, false, this.zIndex);
          styles.opacity = 1;
          styles.visibility = 'visible';
        }

        if (this.parent.hasHiddenSlides) {
          if (this.matchIndex(this.parent.leftOutIndex)) {
            styles = this.calculatePosition(this.parent.leftIndices.length - 1, false, this.zIndex);
          } else if (this.matchIndex(this.parent.rightOutIndex)) {
            styles = this.calculatePosition(this.parent.rightIndices.length - 1, true, this.zIndex);
          }
        }
      }

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(styles, {
        'border-width': this.parent.border + 'px',
        width: this.parent.slideWidth + 'px',
        height: this.parent.slideHeight + 'px',
        transition: ' transform ' + this.parent.animationSpeed + 'ms, ' + '               opacity ' + this.parent.animationSpeed + 'ms, ' + '               visibility ' + this.parent.animationSpeed + 'ms'
      });
    }
  },
  methods: {
    getSideIndex: function getSideIndex(array) {
      var _this = this;

      var index = -1;

      array.forEach(function (pos, i) {
        if (_this.matchIndex(pos)) {
          index = i;
        }
      });

      return index;
    },
    matchIndex: function matchIndex(index) {
      return index >= 0 ? this.index === index : this.parent.total + index === this.index;
    },
    calculatePosition: function calculatePosition(i, positive, zIndex) {
      // const z = !this.parent.disable3d ? parseInt(this.parent.inverseScaling) + ((i + 1) * 100) : 0
      var z = !this.parent.disable3d ? parseInt(this.parent.inverseScaling) + 1 * 100 : 0;
      var y = !this.parent.disable3d ? parseInt(this.parent.perspective) : 0;
      // const leftRemain = (this.parent.space === 'auto')
      //   ? parseInt((i + 1) * (this.parent.width / 1.5), 10)
      //   : parseInt((i + 1) * (this.parent.size + 30), 10) + 36
      var leftRemain = parseInt((i + 1) * (this.parent.size + 2 + 30), 10) + this.parent.size * 0.1;
      if (i > 0) {
        // leftRemain -= 20
      }
      var transform = positive ? 'translateX(' + leftRemain + 'px) translateZ(-' + z + 'px) ' + 'rotateY(-' + y + 'deg)' : 'translateX(-' + leftRemain + 'px) translateZ(-' + z + 'px) ' + 'rotateY(' + y + 'deg)';
      var top = this.parent.space === 'auto' ? 0 : parseInt((i + 1) * this.parent.space);

      return {
        transform: transform,
        top: top,
        zIndex: zIndex - (Math.abs(i) + 1)
      };
    },
    goTo: function goTo() {
      if (this.parent.clickable === true) {
        this.parent.goFar(this.index);
      }
    }
  }
});

/***/ }),
/* 934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    content: '',
    ctaTitle: '',
    cta: ''
  },
  data: function data() {
    return {
      defBody: '',
      defbodyContent: ''
    };
  },

  computed: {
    currentUser: function currentUser() {
      console.log(this.$store.state.auth.user);
      return this.$store.state.auth.user;
    }
  },
  methods: {
    adjustForTopBar: function adjustForTopBar() {
      var user = this.currentUser;
      var bodyContent = document.querySelector('.top-menu') || document.querySelector('.page-content') || document.querySelector('.content--wrap');

      this.defBody = document.body.style.height;
      this.defbodyContent = bodyContent.style.height;

      if (user) {
        if (bodyContent.classList.includes('top-menu')) {
          bodyContent.style.top = '43px';
          document.body.style.paddingTop = '40px';
        } else if (bodyContent) {
          document.body.style.paddingTop = '40px';
        }
      }
    },
    resetAdjust: function resetAdjust() {
      var bodyContent = document.querySelector('.top-menu') || document.querySelector('.page-content') || document.querySelector('.content--wrap');
      bodyContent.style.top = this.defBody;
      document.body.style.paddingTop = this.defbodyContent;
    }
  },
  mounted: function mounted() {
    this.adjustForTopBar();
  },
  beforeDestroy: function beforeDestroy() {
    this.resetAdjust();
  }
});

/***/ }),
/* 935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    item: {
      type: Object
    },
    width: {
      type: [String, Number],
      default: 70
    },
    height: {
      type: [String, Number],
      default: 70
    },
    isVideo: Boolean,
    cover: String,
    title: String,
    subtitle: String,
    coverRadius: Boolean,
    round: Boolean,
    id: Number
  },
  computed: {
    videoWidth: function videoWidth() {
      return 100;
    },
    noCover: function noCover() {
      return true;
    }
  }
});

/***/ }),
/* 936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mux_upchunk__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mux_upchunk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__mux_upchunk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_track_js__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuedraggable__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_contentTopHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_contentTopHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_contentTopHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_dragFileUploader__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_dragFileUploader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_dragFileUploader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_topbarNotification__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_topbarNotification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_topbarNotification__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global $:true */









/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    draggable: __WEBPACK_IMPORTED_MODULE_4_vuedraggable___default.a,
    contentTopHeader: __WEBPACK_IMPORTED_MODULE_5__components_contentTopHeader___default.a,
    dragFileUploader: __WEBPACK_IMPORTED_MODULE_6__components_dragFileUploader___default.a,
    topbarNotification: __WEBPACK_IMPORTED_MODULE_7__components_topbarNotification___default.a
  },

  props: {
    album: {
      type: Object
    },

    accept: {
      type: String,
      default: '*/*'
    },

    autoUpload: {
      type: Boolean,
      default: true
    }
  },

  data: function data() {
    return {
      topBarContent: 'Connect your Stripe account to start accepting payments',
      show_unauthorized_content_dialog: false,
      show_duplicate_content_dialog: false,
      currentFile: {
        track_title: '',
        artist_name: ''
      },
      status: {
        uploading: 1,
        success: 2,
        failed: 3
      },
      currentStatus: null,
      uploadFieldName: 'files',
      file: null
    };
  },


  computed: {
    // dragDisabled() {
    //   const hasEditing = _.find(this.album.tracks, (file) => (file.editing)) == null
    //   // console.log('dragDisabled', !hasEditing)
    //   return !hasEditing
    // }
  },

  created: function created() {
    var files = [];
    for (var index in this.album.tracks) {
      var track = this.album.tracks[index];
      var file = {
        editing: false,
        status: this.status.success,
        file_name: track.name,
        track: track
      };
      files.push(file);
    }
    this.album.tracks = files;
  },


  watch: {
    album: {
      deep: true,
      handler: function handler(val) {
        if (val.tracks.length < 1) {
          this.file = null;
        }
      }
    }
  },

  methods: {
    pickedFile: function pickedFile(file) {
      this.file = file;
      this.filesChange(file);
    },
    saveTrack: function saveTrack(file) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_3__services_track_js__["a" /* default */].uploadTrack(file.formData).then(function (response) {
        file.editing = false;
        file.status = _this.status.success;
        file.track = response.body;
        file.download_price = file.track.download_price;

        // upload mux
        file.track = response.body;
        console.log("track response===", response.body);
        var upload_url = file.track.mux_audio_url_1;
        var index = _this.file.findIndex(function (x) {
          return x.name.includes(file.file_name);
        });
        console.log('File index', index);
        var upload = __WEBPACK_IMPORTED_MODULE_2__mux_upchunk__["createUpload"]({
          endpoint: upload_url,
          file: _this.file[index],
          chunkSize: 5120 // Uploads the file in ~5mb chunks
        });

        upload.on('error', function (err) {
          _this.$store.dispatch('error/showLoadingActivity', false);
          console.error('💥', err.detail);
        });

        upload.on('progress', function (progress) {
          _this.$store.commit('error/setProgressBarValue', parseInt(progress.detail));
        });

        upload.on('success', function () {
          _this.$store.dispatch('error/showLoadingActivity', false);
          console.log("Audio uploaded successfully with mux.");
          // this.$router.push({ path: `/video/${this.video.id}/show` })
        });
      }).catch(function (e) {
        file.editing = false;
        file.status = _this.status.failed;
        console.log('catch saveTrack', e.body);
        switch (e.body.code) {
          case 1:
            if (!_this.show_unauthorized_content_dialog) {
              _this.currentFile = file;
              _this.currentFile.track_title = e.body.track_title;
              _this.currentFile.artist_name = e.body.artist_name;
              _this.show_unauthorized_content_dialog = true;
            }
            break;
          case 2:
            if (!_this.show_duplicate_content_dialog) {
              _this.currentFile = file;
              _this.currentFile.track_title = e.body.track_title;
              _this.currentFile.artist_name = e.body.artist_name;
              _this.show_duplicate_content_dialog = true;
            }
            break;
          default:
            _this.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
            break;
        }
      });
    },
    deleteTrack: function deleteTrack(index) {
      var track = this.album.tracks[index].track;
      this.album.tracks.splice(index, 1);
      if (track) {
        __WEBPACK_IMPORTED_MODULE_3__services_track_js__["a" /* default */].deleteTrack(track.id);
      }
    },
    cancelTrack: function cancelTrack() {
      var _this2 = this;

      var idx = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.findIndex(this.album.tracks, function (f) {
        return f === _this2.currentFile;
      });
      // console.log('cancelTrack', idx)
      if (idx > -1) {
        this.deleteTrack(idx);
      }

      if (this.show_unauthorized_content_dialog) {
        this.show_unauthorized_content_dialog = false;
      }

      if (this.show_duplicate_content_dialog) {
        this.show_duplicate_content_dialog = false;
      }
    },
    filesChange: function filesChange(fileList) {
      var _this3 = this;

      console.log(456);
      // console.log('uploader filesChange', fileList)
      var vm = this;
      // handle file changes
      if (!fileList.length) return;
      // append the files to FormData
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(Array(fileList.length).keys()).map(function (x) {
        var filesize = fileList[x].size / 1024 / 1024;
        var filename = fileList[x].name;
        if (fileList[x].size / 1000 < 160) {
          _this3.$store.dispatch('error/showErrorToast', ['File size too small, must be at least 160k']);
        } else if (filename.toLowerCase().endsWith(_this3.accept)) {
          if (filesize <= 300) {
            filename = filename.replace('.mp3', '');
            filename = filename.replace('.wav', '');
            filename = filename.replace('.wma', '');
            filename = filename.replace('.ogg', '');
            var formData = new FormData();
            formData.append('track[name]', filename);
            formData.append('track[description]', fileList[x].name);
            formData.append('track[audio]', fileList[x]);
            var file = {
              editing: false,
              status: vm.status.uploading,
              file_name: filename,
              new_name: '',
              formData: formData
            };
            vm.album.tracks.push(file);
            if (vm.autoUpload) {
              vm.saveTrack(file);
            }
          } else {
            _this3.$store.dispatch('error/showErrorToast', [fileList[x].name + ' size is over 100MB.']);
          }
        }
      });

      setTimeout(function () {
        if ($('#track_list').length) {
          $('html, body').animate({
            scrollTop: $('#track_list').offset().top - 37.5
          }, 700);
        }
      }, 100);
    },
    enableEditing: function enableEditing(file) {
      // console.log('enableEditing', file)
      file.editing = true;
    },
    disableEditing: function disableEditing(file) {
      // console.log('disableEditing', file)
      file.editing = false;
    },
    onInputFocus: function onInputFocus(index, evt) {
      // console.log('focus', $(evt.target).val())
      evt.target.select();
    },
    onInputBlur: function onInputBlur(index, evt) {
      // console.log('blur', index, $(evt.target).val())
      // this.disableEditing(this.album.tracks[index])
      this.updateTrack(index);
    },


    // onStart (evt) {
    //   // console.log('dragging start...', $(evt.item).find('input').val())
    // },

    // onEnd (evt) {
    //   // console.log('dragging end...', $(evt.item).find('input').val())
    // },

    // onClone (evt) {
    //   // console.log('dragging clone...', evt)
    // },

    updateTrack: function updateTrack(index) {
      var _this4 = this;

      var file = this.album.tracks[index];
      var params = new FormData();
      console.log(file);
      params.append('track[name]', file.file_name);
      params.append('track[download_price]', file.download_price);
      __WEBPACK_IMPORTED_MODULE_3__services_track_js__["a" /* default */].patchTrack(file.track.id, params).then(function (response) {
        // JSON responses are automatically parsed.
        _this4.album.tracks[index].track = response.body;
        // file.file_name = ''
      }).catch(function (e) {
        _this4.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    }
  },

  mounted: function mounted() {
    // const vm = this
    // const uploaderBox = $('.uploaderBox')
    // uploaderBox
    //   .on(
    //     'drag dragstart dragend dragover dragenter dragleave drop',
    //     function (e) {
    //       e.preventDefault()
    //       e.stopPropagation()
    //     }
    //   )
    //   .on('dragover dragenter', function () {
    //     uploaderBox.addClass('is-dragover')
    //   })
    //   .on('dragleave dragend drop', function () {
    //     uploaderBox.removeClass('is-dragover')
    //   })
    //   .on('drop', function (e) {
    //     let droppedFiles = e.originalEvent.dataTransfer.files
    //     vm.filesChange(droppedFiles)
    //   })
  }
});

/***/ }),
/* 937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_user__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    type: {
      type: String,
      required: true
    },
    user: {
      type: Object,
      required: true
    },
    theme: {
      type: String,
      default: "light"
    },
    followParam: {
      type: Object
    },
    btnBlock: Boolean,
    borderRadius: Boolean
  },
  data: function data() {
    return {
      buttonHover: false
    };
  },

  methods: {
    followUser: function followUser() {
      var _this = this;

      if (!this.isUserSignedUp) {
        return this.$store.dispatch('app/toggleGlobalSMS', true);
      }

      if (this.userIsFollowing) {
        __WEBPACK_IMPORTED_MODULE_0__services_user__["a" /* default */].unfollowUser(this.user.id).then(function (response) {
          _this.$store.dispatch('error/showSuccessToast', ['You have unfollowed ' + _this.user.display_name]);

          _this.postFollow("unfollow");
        }).catch(function (e) {
          console.log('unfollowUser error', e);
          _this.$store.dispatch("error/showErrorToast", ["There was an issue unfollowing " + _this.user.display_name]);
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_0__services_user__["a" /* default */].followUser(this.user.id, this.followParam).then(function (response) {
          _this.$store.dispatch('error/showSuccessToast', ['You just followed ' + _this.user.display_name]);

          _this.postFollow("follow");
        }).catch(function (e) {
          console.log('followUser error', e);

          _this.$store.dispatch("error/showErrorToast", ["There was an issue following " + _this.user.display_name]);
        });
      }
    },
    postFollow: function postFollow(isfollowing) {
      if (this.type === "player") {
        if (isfollowing === "unfollow") {
          this.$store.dispatch('player/updateFollowingStatus', false);
        } else if (isfollowing === "follow") {
          this.$store.dispatch('player/updateFollowingStatus', true);
        }
      } else if (this.type === "default") {
        if (isfollowing === "unfollow") {
          this.$root.$emit(__WEBPACK_IMPORTED_MODULE_1__helper__["b" /* MyEvents */].USER_FOLLOW, this.user.id, false);
        } else if (isfollowing === "follow") {
          this.$root.$emit(__WEBPACK_IMPORTED_MODULE_1__helper__["b" /* MyEvents */].USER_FOLLOW, this.user.id, true);
        }
      }

      // update triggerer
      this.$emit("afterFollow", isfollowing);
    }
  },
  computed: {
    currentUser: function currentUser() {
      return this.$store.state.auth.user;
    },
    isUserSignedUp: function isUserSignedUp() {
      return this.currentUser.phone_number;
    },
    userIsFollowing: function userIsFollowing() {
      return this.user.is_following;
    },
    followButtonText: function followButtonText() {
      if (this.userIsFollowing) {
        return this.buttonHover ? "Unfollow" : "Following";
      }
      return "Follow";
    }
  }
});

/***/ }),
/* 938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_base_app_card__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_base_app_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_base_app_card__);
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    AppCard: __WEBPACK_IMPORTED_MODULE_0__components_base_app_card___default.a
  },

  props: {
    user: Object
  },

  computed: {
    userImage: function userImage() {
      if (this.user.user_type === 'superadmin' && this.currentUser.user_type !== 'superadmin') {
        return this._.get(this.publicRelationsUser, 'avatar.thumb.url');
      } else {
        return this._.get(this.user, 'avatar.thumb.url');
      }
    },
    userName: function userName() {
      if (this.user.user_type === 'superadmin' && this.currentUser.user_type !== 'superadmin') {
        return this._.get(this.publicRelationsUser, 'display_name');
      } else {
        return this._.get(this.user, 'display_name');
      }
    },
    userType: function userType() {
      if (this.user.user_type === 'superadmin' && this.currentUser.user_type !== 'superadmin') {
        return this._.get(this.publicRelationsUser, 'user_type');
      } else {
        return this._.get(this.user, 'user_type');
      }
    },
    userMeta: function userMeta() {
      return {
        type: 'user',
        verified: this.userType !== 'listener'
      };
    },
    publicRelationsUser: function publicRelationsUser() {
      return this.$store.state.app.public_relations_user;
    },
    currentUser: function currentUser() {
      return this.$store.state.auth.user;
    }
  }
});

/***/ }),
/* 939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    user: Object,
    showAvatar: Boolean,
    hideName: Boolean,
    showUserType: Boolean,
    hideTick: Boolean,
    fitContent: Boolean,
    marginRight: {
      type: String
    },
    width: {
      type: [String, Number],
      default: 20
    },
    height: {
      type: [String, Number],
      default: 20
    },
    clickUser: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    gotoUser: function gotoUser() {
      this.$router.push("/" + this.user.slug);
    }
  }
});

/***/ }),
/* 940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_sendmessage__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_sendmessage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_sendmessage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_userFollowBtn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_userFollowBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_userFollowBtn__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    sendMessage: __WEBPACK_IMPORTED_MODULE_0__components_sendmessage___default.a,
    UserFollowBtn: __WEBPACK_IMPORTED_MODULE_1__components_userFollowBtn___default.a
  },

  props: {
    userItem: {
      type: Object
    },
    last: {
      type: Boolean
    }
  },

  data: function data() {
    return {
      showSendMessage: false,
      buttonHover: false
    };
  },


  computed: {
    followButtonText: function followButtonText() {
      if (this.userItem.is_following) {
        return this.buttonHover ? "Unfollow" : "Following";
      }
      return "Follow";
    }
  },

  created: function created() {},


  methods: {
    showMessageDialog: function showMessageDialog() {
      this.showSendMessage = true;
    },
    dismissMessageModal: function dismissMessageModal() {
      this.showSendMessage = false;
    },
    imageURL: function imageURL(item) {
      if (item.cover) {
        return item.cover.thumb.url;
      } else {
        return item.covers[0].cover.thumb.url;
      }
    },
    blockUser: function blockUser() {},
    afterFollow: function afterFollow(isfollowing) {
      if (isfollowing === "unfollow") {
        this.userItem.is_following = false;
      } else if (isfollowing === "follow") {
        this.userItem.is_following = true;
      }
    }
  }
});

/***/ }),
/* 941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__video_detail_box__ = __webpack_require__(1597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__video_detail_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__video_detail_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_user_tag__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_user_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_user_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_stream__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_collection__ = __webpack_require__(70);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    VideoDetailBox: __WEBPACK_IMPORTED_MODULE_0__video_detail_box___default.a,
    UserTag: __WEBPACK_IMPORTED_MODULE_1__components_user_tag___default.a
  },

  props: {
    item: Object,
    hideFreeTag: {
      type: Boolean,
      default: false
    },
    sideTabView: {
      type: Boolean,
      default: false
    },
    showUsername: {
      type: Boolean,
      default: false
    },
    showViews: {
      type: Boolean,
      default: false
    },
    hideUser: {
      type: Boolean,
      default: false
    },
    forCollection: {
      type: Boolean,
      default: false
    },
    playlistId: {
      type: Number,
      default: null
    },
    noMeta: {
      type: Boolean,
      default: false
    },
    altMeta: {
      type: Boolean,
      default: false
    },
    hoverOverlay: {
      type: Boolean,
      default: true
    },
    showFullOverlay: Boolean,
    coverOnly: {
      type: Boolean,
      default: false
    },
    coverRadius: Boolean,
    getCollections: Function,
    removeFromPlaylist: {
      type: Function,
      default: null
    }
  },

  data: function data() {
    return {
      bgDemoImg: __webpack_require__(148),
      videoLoading: __webpack_require__(147),
      show_modalCard1: false,
      show_modalCard2: false,
      show_modalCard3: false,
      show_modalCard4: false,
      spotlightVideoSource: null,
      show_remove_from_collection_modal: false
    };
  },


  computed: {
    isVideoFree: function isVideoFree() {
      return this.item.view_price < 1 ? 'Free' : '';
    },
    onMobile: function onMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    isLive: function isLive() {
      return this._.get(this.item, "status") === "running";
    },
    calcAge: function calcAge() {
      var d = new Date();
      var created = void 0;
      if (this.item.assoc != null) {
        created = new Date(this.item.assoc.created_at);
      } else {
        return null;
      }
      var relative = void 0;

      var vid_dd = created.getDay();
      var vid_mm = created.getMonth();
      var vid_yy = created.getFullYear();

      var dd = d.getDay();
      var mm = d.getMonth();
      var yy = d.getFullYear();

      if (yy > vid_yy) {
        var duration = yy - vid_yy;
        var rel_str = duration > 1 ? "years" : "year";
        relative = duration + ' ' + rel_str + ' ago';
      } else if (mm > vid_mm) {
        var _duration = yy - vid_yy;
        var _rel_str = _duration > 1 ? "months" : "month";
        relative = _duration + ' ' + _rel_str + ' ago';
      } else if (dd > vid_dd) {
        var _duration2 = dd - vid_dd;
        var _rel_str2 = _duration2 > 1 ? "days" : "day";
        relative = _duration2 + ' ' + _rel_str2 + ' ago';
      }

      return relative || null;
    },
    durationTag: function durationTag() {
      var duration = this.item.duration;

      if (duration == null) {
        return null;
      }

      if (duration < 60) {
        duration = '00:' + duration;
      } else if (duration > 60) {
        var min = Math.floor(duration / 60);
        var sec = duration - min * 60;
        duration = min + ':' + sec.toFixed(0);
      }

      return duration;
    },
    currentUser: function currentUser() {
      return this.$store.state.auth.user;
    }
  },

  methods: {
    fetchSpotlightVideo: function fetchSpotlightVideo() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2__services_stream__["a" /* default */].getSpotlightStream(this.item.user.id).then(function (response) {
        console.log("response", response);
        _this.spotlightVideoSource = response.body.mp_channel_1_ep_1_id;
        if (_this.currentUser == null) {
          _this.show_modalCard3 = true;
        } else {
          _this.show_modalCard4 = true;
        }
      }).catch(function (e) {
        if (_this.currentUser == null) {
          _this.show_modalCard1 = true;
        } else {
          _this.show_modalCard2 = true;
        }
      });
    },
    openRemoveFromCollectionModal: function openRemoveFromCollectionModal() {
      this.show_remove_from_collection_modal = true;
    },
    removeFromCollection: function removeFromCollection() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_3__services_collection__["a" /* default */].destroy('stream', this.item.id).then(function (response) {
        _this2.$store.dispatch('error/showSuccessToast', ['Video removed from collection']);
        _this2.show_remove_from_collection_modal = false;
        _this2.getCollections();
      }).catch(function (e) {
        _this2.$store.dispatch('error/showErrorToast', ['Unable to remove video from collection']);
        _this2.show_remove_from_collection_modal = false;
      });
    }
  }
});

/***/ }),
/* 942 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    item: Object
  },

  methods: {}
});

/***/ }),
/* 943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_profileitem__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_profileitem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_profileitem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_stream__ = __webpack_require__(18);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    profileItem: __WEBPACK_IMPORTED_MODULE_1__components_profileitem___default.a
  },

  props: {
    dataObject: {
      type: Object
    }
  },

  data: function data() {
    return {};
  },


  computed: {
    item: function item() {
      if (this.dataObject.assoc_type === "Stream") {
        return this.dataObject.assoc;
      } else {
        return this.dataObject;
      }
    },
    owner: function owner() {
      if (this.dataObject.assoc_type === "Stream") {
        return this.dataObject.assoc.user;
      } else {
        return this.dataObject.user;
      }
    }
  },

  created: function created() {},


  methods: {
    viewStream: function viewStream() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(this.item.mp_channel_1_ep_1_url).then(function (response) {
        _this.$router.push({ path: "/" + _this.owner.slug });
      }).catch(function (e) {
        _this.$router.push({ path: "/user/" + _this.own.slug + "/chat" });
      });
    },
    repost: function repost() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_2__services_stream__["a" /* default */].repostStream(this.item.id).then(function (response) {
        _this2.$store.dispatch("error/showSuccessToast", ["You just reposted a live video from" + _this2.owner.username]);
      }).catch(function (e) {
        _this2.$store.dispatch("error/showErrorToast", e.body.errors || [e.body]);
      });
    }
  },

  mounted: function mounted() {}
});

/***/ }),
/* 944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),
/* 945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        MainHeading: String,
        MainText: String,
        MainImage: String,
        Icon: String
    }
});

/***/ }),
/* 946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_auth_loginInput__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_auth_loginInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__views_auth_loginInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_auth_forgotPasswordInput___ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_auth_forgotPasswordInput____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__views_auth_forgotPasswordInput___);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "LoginPage",
  components: {
    LoginInput: __WEBPACK_IMPORTED_MODULE_0__views_auth_loginInput___default.a,
    forgotPasswordInput: __WEBPACK_IMPORTED_MODULE_1__views_auth_forgotPasswordInput____default.a
  },
  data: function data() {
    return {
      loginAuth: "login"
    };
  },
  created: function created() {
    if (this.$store.state.auth.user != null) {
      this.$router.push({ name: "UserSettings" });
    }
  },
  mounted: function mounted() {
    $(".content").css("background", "black");
  },
  beforeDestroy: function beforeDestroy() {
    $(".content").css("background", "");
  },

  computed: {
    onMobile: function onMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    }
  },
  methods: {
    showForgotPassword: function showForgotPassword() {
      this.loginAuth = "forgotPassword";
    },
    showLogin: function showLogin() {
      this.loginAuth = "login";
      this.activeView = "loginView";
    }
  }
});

/***/ }),
/* 947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_trackcardsimple__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_trackcardsimple___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_trackcardsimple__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_collection_playlist__ = __webpack_require__(146);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: { trackcardsimple: __WEBPACK_IMPORTED_MODULE_0__components_trackcardsimple___default.a },
  props: {
    addToPlaylist: Boolean,
    selectedItems: Array,
    playlists: Array,
    selectedVideos: Array,
    type: String
  },
  data: function data() {
    return {
      getAddToPlaylist: this.addToPlaylist,
      newPlaylistActive: false,
      isNewPlaylistPublic: false,
      newPlaylistTitle: "",
      playlistAddedSuccess: false
    };
  },

  watch: {
    getAddToPlaylist: function getAddToPlaylist(val) {
      if (!val) {
        var isPartial = true;
        this.closeAddToPlaylist(isPartial);
      }
    }
  },
  methods: {
    addNewPlaylist: function addNewPlaylist() {
      var _this = this;

      if (this.newPlaylistTitle) {
        var params = new FormData();

        if (this.type === 'track') {
          var track_ids = this.selectedItems.map(function (track) {
            return track.id;
          });
          params.append('collection_playlist[track_ids]', track_ids);
          params.append('collection_playlist[playlist_type]', "tracks");
        } else if (this.type === 'stream') {
          var stream_ids = this.selectedItems.map(function (stream) {
            return stream.id;
          });
          params.append('collection_playlist[stream_ids]', stream_ids);
          params.append('collection_playlist[playlist_type]', "streams");
        } else if (this.type === 'product') {
          var product_ids = this.selectedItems.map(function (product) {
            return product.id;
          });
          params.append('collection_playlist[product_ids]', product_ids);
          params.append('collection_playlist[playlist_type]', "products");
        }
        params.append('collection_playlist[name]', this.newPlaylistTitle);
        params.append('collection_playlist[playlist_public]', this.isNewPlaylistPublic);
        __WEBPACK_IMPORTED_MODULE_1__services_collection_playlist__["a" /* default */].createCollectionPlaylist(params).then(function (response) {
          _this.playlistAddedSuccess = true;
          _this.$emit("methodThatForcesUpdate", true);
          _this.newPlaylistActive = false;

          _this.$store.dispatch('error/showSuccessToast', [response.body.success_response]);
        }).catch(function (e) {
          _this.$store.dispatch('error/showErrorToast', e.body.errors || [e.body] || [e.body.error]);
        });
      }
    },
    addToExistingPlaylist: function addToExistingPlaylist(playlist) {
      var _this2 = this;

      var params = new FormData();
      if (playlist.playlist_type === 'tracks') {
        var track_ids = this.selectedItems.map(function (track) {
          return track.id;
        });
        params.append('collection_playlist[track_ids]', track_ids);
        params.append('collection_playlist[playlist_type]', "tracks");
      } else if (playlist.playlist_type === 'streams') {
        var stream_ids = this.selectedItems.map(function (stream) {
          return stream.id;
        });
        params.append('collection_playlist[stream_ids]', stream_ids);
        params.append('collection_playlist[playlist_type]', "streams");
      } else if (playlist.playlist_type === 'products') {
        var product_ids = this.selectedItems.map(function (product) {
          return product.id;
        });
        params.append('collection_playlist[product_ids]', product_ids);
        params.append('collection_playlist[playlist_type]', "products");
      }
      params.append('collection_playlist[id]', playlist.id);
      __WEBPACK_IMPORTED_MODULE_1__services_collection_playlist__["a" /* default */].createCollectionPlaylist(params).then(function (response) {
        _this2.newPlaylistTitle = playlist.name;
        _this2.playlistAddedSuccess = true;
        _this2.methodThatForcesUpdate();
        _this2.$store.dispatch('error/showSuccessToast', [response.body.success_response]);
      }).catch(function (e) {
        _this2.$store.dispatch('error/showErrorToast', e.body.errors || [e.body] || [e.body.error]);
      });
    },
    closeAddToPlaylist: function closeAddToPlaylist(isPartial) {
      this.$emit("closeAddToPlaylist", isPartial);
    },
    methodThatForcesUpdate: function methodThatForcesUpdate() {
      this.$emit("methodThatForcesUpdate");
    },
    newPlaylist: function newPlaylist() {
      this.newPlaylistActive = true;
    }
  }
});

/***/ }),
/* 948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_trackcard__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_trackcard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_trackcard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_contentTopHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_contentTopHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_contentTopHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_sharemodal__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_sharemodal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_sharemodal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_collection_playlist__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_video_box__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_video_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_video_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_productcard__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_productcard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_productcard__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    contentTopHeader: __WEBPACK_IMPORTED_MODULE_1__components_contentTopHeader___default.a,
    trackCard: __WEBPACK_IMPORTED_MODULE_0__components_trackcard___default.a,
    shareModal: __WEBPACK_IMPORTED_MODULE_2__components_sharemodal___default.a,
    VideoBox: __WEBPACK_IMPORTED_MODULE_4__components_video_box___default.a,
    productCard: __WEBPACK_IMPORTED_MODULE_5__components_productcard___default.a
  },

  data: function data() {
    return {
      playlist: null,
      activeTab: "",
      tabs: [{ id: "music", title: "Music" }, { id: "videos", title: "Videos" }, { id: "products", title: "Products" }],
      playlistType: null,
      playlistId: null,
      share_dialog: false,
      pageReady: false,
      tracks: null,
      streams: null,
      products: null
    };
  },


  computed: {
    parseAlbum: function parseAlbum() {
      var albums = [];
      for (var i = 0; i < this.tracks.length; i++) {
        var track = this.tracks[i];
        var album = track.album;
        var user = track.user;

        albums.push({
          id: album.id,
          slug: album.slug,
          name: album.name,
          description: album.description,
          cover: {
            url: album.cover.url,
            large: {
              url: album.cover.large.url
            },
            thumb: {
              url: album.cover.thumb.url
            }
          },
          album_type: album.album_type,
          collaborators_count: album.collaborators_count,
          status: album.status,
          recommended: album.recommended,
          played: album.played,
          downloaded: album.downloaded,
          reposted: album.reposted,
          commented: album.commented,
          enabled_sample: album.enabled_sample,
          recommended_at: album.recommended_at,
          location: album.location,
          track: track,
          user: user
        });
      }

      return albums;
    }
  },
  methods: {
    onTab: function onTab(tab) {
      this.activeTab = tab;
      this.$router.push({
        name: "CollectionIndex",
        params: { activeTab: tab }
      });
    },
    isActiveTab: function isActiveTab(tab) {
      return this.activeTab === tab;
    },
    shareTrack: function shareTrack(track) {
      this.sharedAlbum = this.tempAlbum;
      this.share_dialog = true;
    },
    closeShareTrack: function closeShareTrack(tab) {
      this.share_dialog = false;
      this.sharedAlbum = {};
    },
    getPlaylistDetails: function getPlaylistDetails(params) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_3__services_collection_playlist__["a" /* default */].getPlaylistDetails(params).then(function (response) {
        _this.tracks = response.body.tracks;
        _this.streams = response.body.streams;
        _this.products = response.body.products;
        _this.playlist = response.body.playlists;
        if (_this.playlist.playlist_type == 'tracks') {
          _this.activeTab = "music";
        } else if (_this.playlist.playlist_type == 'streams') {
          _this.activeTab = 'videos';
        } else if (_this.playlist.playlist_type == 'products') {
          _this.activeTab = 'products';
        }
        _this.pageReady = true;
      }).catch(function (e) {
        _this.pageReady = true;
        _this.$store.dispatch('error/showErrorToast', e.body.errors || [e.body] || [e.body.error]);
      });
    },
    removeFromPlaylist: function removeFromPlaylist(type, id, playlistId) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_3__services_collection_playlist__["a" /* default */].removeFromPlaylist(playlistId, { content_type: type, content_id: id }).then(function (response) {
        _this2.$store.dispatch('error/showSuccessToast', [response.bodyText]);
        _this2.show_remove_from_collection_modal = false;
        _this2.getPlaylistDetails({ id: _this2.playlistId });
      }).catch(function (e) {
        _this2.$store.dispatch('error/showErrorToast', ["Unable to remove " + type.replace('_', ' ') + " from playlist"]);
        _this2.show_remove_from_collection_modal = false;
      });
    }
  },

  created: function created() {
    this.playlistId = this.$route.params.id;
    var params = { id: this.playlistId };

    this.getPlaylistDetails(params);
  }
});

/***/ }),
/* 949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_landingPages_Footer_2_vue__ = __webpack_require__(783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_landingPages_Footer_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_landingPages_Footer_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_mobile_auth_onboarding__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_mobile_auth_onboarding___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_mobile_auth_onboarding__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "SignUpPage",
  components: {
    Footer: __WEBPACK_IMPORTED_MODULE_1__components_landingPages_Footer_2_vue___default.a,
    Onboarding: __WEBPACK_IMPORTED_MODULE_3__views_mobile_auth_onboarding___default.a
  },
  data: function data() {
    return {
      default: true,
      ios: false,
      android: false,
      activeView: "signUpView"
    };
  },
  mounted: function mounted() {
    this.checkScreenSize();
    window.addEventListener('resize', this.checkScreenSize);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenSize);
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])({
    musicFeed: function musicFeed(state) {
      return state.trending.albums;
    },
    currentSignUpStage: function currentSignUpStage(state) {
      return state.app.onboarding.current;
    },
    signUpAccountCategory: function signUpAccountCategory(state) {
      return state.app.onboarding.accountCategory;
    }
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])({
    isAuthenticated: "auth/isAuthenticated",
    onMobileStrict: "app/onMobileStrict"
  }), {
    onMobile: function onMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])({
    getTrendingMusic: "trending/getTrendingMusic"
  }), {
    checkScreenSize: function checkScreenSize() {
      var screenWidth = window.innerWidth;
      if (screenWidth > 768) {
        this.$router.push('/');
      }
    },
    isActiveTab: function isActiveTab(tab) {
      return this.activeTab === tab;
    },
    showQR: function showQR(input) {
      input === "ios" ? this.ios = true : this.android = true;
    },
    reset: function reset() {
      this.ios = false;
      this.android = false;
    }
  })
});

/***/ }),
/* 950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	props: {
		daysRemaining: Number
	},
	methods: {
		hideModal: function hideModal() {
			this.$emit("remainingDaysModal", false);
		}
	}
});

/***/ }),
/* 951 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},

  props: {
    item: {
      type: Object,
      required: true
    },

    dismiss: {
      type: Function,
      required: true
    },

    submission: {
      type: Function,
      required: true
    },
    loading: null
  },

  data: function data() {
    return {
      denial_reasons: ["Did not complete application", "Music was not mixed/mastered", "Music was not your own", "Currently not accepting submissions", "Other reason"]
    };
  },


  computed: {
    userFullAddress: function userFullAddress() {
      return _.get(this.item, 'city', '') + ", " + _.get(this.item, 'country', '');
    }
  },

  created: function created() {},


  methods: {}
});

/***/ }),
/* 952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_promotemodal__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_promotemodal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_promotemodal__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    promoteModal: __WEBPACK_IMPORTED_MODULE_1__components_promotemodal___default.a
  },

  props: {
    album: {
      type: Object
    },

    type: {
      type: String
    },

    editButtonAction: {
      type: Function
    },

    publishButtonAction: {
      type: Function
    },

    privateButtonAction: {
      type: Function
    },

    videoOnlyButtonAction: {
      type: Function
    },

    deleteButtonAction: {
      type: Function
    },

    acceptButtonAction: {
      type: Function
    },

    denyButtonAction: {
      type: Function
    },

    releaseButtonAction: {
      type: Function
    },

    showPromoteButton: {
      type: Boolean,
      default: true
    }
  },

  data: function data() {
    return {
      isShowPromoteModal: false
    };
  },


  computed: {
    usersCountByStatus: function usersCountByStatus() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.countBy(this.album.collaborators, "status");
    },
    usersByStatus: function usersByStatus() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.groupBy(this.album.collaborators, "status");
    }
  },

  created: function created() {},


  methods: {
    showPromoteDialog: function showPromoteDialog() {
      this.isShowPromoteModal = true;
    },
    dismissPromoteDialog: function dismissPromoteDialog() {
      this.isShowPromoteModal = false;
    },
    saveAndFinish: function saveAndFinish() {
      this.dismissPromoteDialog();
    }
  }
});

/***/ }),
/* 953 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_promotemodal__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_promotemodal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_promotemodal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_album__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_user__ = __webpack_require__(7);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    promoteModal: __WEBPACK_IMPORTED_MODULE_1__components_promotemodal___default.a
  },

  props: {
    textBtnToRight: {
      type: Boolean
    },

    album: {
      type: Object
    },

    type: {
      type: String
    },

    editButtonAction: {
      type: Function
    },

    publishButtonAction: {
      type: Function
    },

    updateAccessLevelAction: {
      type: Function
    },

    videoOnlyButtonAction: {
      type: Function
    },

    deleteButtonAction: {
      type: Function
    },

    acceptButtonAction: {
      type: Function
    },

    denyButtonAction: {
      type: Function
    },

    releaseButtonAction: {
      type: Function
    },

    showPromoteButton: {
      type: Boolean,
      default: true
    }
  },

  data: function data() {
    return {
      isShowPromoteModal: false,
      toggle_album_access_level_dialog: false,
      show_album_delete_confirm_dialog: false,
      show_video_only_confirm_dialog: false,
      loading: false,
      access_levels: [],
      access_level: this.album.access_level
    };
  },


  computed: {
    usersCountByStatus: function usersCountByStatus() {
      console.log(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.countBy(this.album.collaborators, "status"));
      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.countBy(this.album.collaborators, "status");
    },
    usersByStatus: function usersByStatus() {
      console.log(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.groupBy(this.album.collaborators, "status"));
      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.groupBy(this.album.collaborators, "status");
    }
  },

  methods: {
    deleteAlbum: function deleteAlbum() {
      var _this = this;

      this.loading = true;
      this.$store.dispatch("error/showLoadingActivity", true);
      __WEBPACK_IMPORTED_MODULE_2__services_album__["a" /* default */].deleteAlbum(this.album.id).then(function (response) {
        _this.loading = false;
        _this.$store.dispatch("error/showLoadingActivity", false);
        _this.show_album_delete_confirm_dialog = false;
        _this.reRenderManageAlbum();
        _this.$store.dispatch("error/showSuccessToast", ["Album deleted successfully!"]);
      }).catch(function (e) {
        _this.loading = false;
        _this.$store.dispatch("error/showLoadingActivity", false);
        _this.show_album_delete_confirm_dialog = false;
        _this.$store.dispatch("error/showErrorToast", e.body.errors || [e.body]);
      });
    },
    reRenderManageAlbum: function reRenderManageAlbum() {
      this.$emit("reRenderManageAlbum");
    },
    updateAccessLevel: function updateAccessLevel(album) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_2__services_album__["a" /* default */].updateAccessLevel(this.album.id, {
        access_level: this.album.access_level
      }).then(function (response) {
        _this2.album.status = response.body.status;
        _this2.$store.dispatch("error/showSuccessToast", ["Access level updated successfully"]);
        _this2.toggle_album_access_level_dialog = false;
      }).catch(function (e) {
        _this2.toggle_album_access_level_dialog = false;
        _this2.$store.dispatch("error/showErrorToast", e.body.errors || [e.body]);
      });
    },
    videoOnlyAlbum: function videoOnlyAlbum() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_2__services_album__["a" /* default */].makeLiveVideoOnlyAlbum(this.album.id).then(function (response) {
        _this3.show_video_only_confirm_dialog = false;
        _this3.album.access_level = "published";
        _this3.album.status = "published";
        _this3.album.is_only_for_live_stream = true;
      }).catch(function (e) {
        _this3.show_video_only_confirm_dialog = false;
        _this3.$store.dispatch("error/showErrorToast", e.body.errors || [e.body]);
      });
    },
    editProduct: function editProduct() {
      this.$router.push({ path: "/album/" + this.album.slug + "/edit" });
    },
    showPromoteDialog: function showPromoteDialog() {
      this.isShowPromoteModal = true;
    },
    dismissPromoteDialog: function dismissPromoteDialog() {
      this.isShowPromoteModal = false;
    },
    saveAndFinish: function saveAndFinish() {
      this.dismissPromoteDialog();
    }
  },

  mounted: function mounted() {
    var _this4 = this;

    __WEBPACK_IMPORTED_MODULE_3__services_user__["a" /* default */].getAccessLevels(this.album.user.id).then(function (response) {
      _this4.access_levels = response.body;
    });
  }
});

/***/ }),
/* 954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    dismiss: {
      type: Function,
      required: true
    }
  },

  data: function data() {
    return {};
  }
});

/***/ }),
/* 955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_dashboardnav__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_dashboardnav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_dashboardnav__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_mobile_auth_onboarding_authPlan__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_mobile_auth_onboarding_authPlan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_mobile_auth_onboarding_authPlan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_paymentCard_index__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_paymentCard_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_paymentCard_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_subscription__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_user__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_auth__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		dashboardNav: __WEBPACK_IMPORTED_MODULE_1__components_dashboardnav___default.a, PaymentCard: __WEBPACK_IMPORTED_MODULE_4__components_paymentCard_index___default.a, AuthPlan: __WEBPACK_IMPORTED_MODULE_2__views_mobile_auth_onboarding_authPlan___default.a
	},

	data: function data() {
		return {
			socialChannel: "",
			socialUsername: "",
			initPayment: false,
			selectedPlan: {},
			plansUpgradeModal: false,
			plansName: { 'basic': 'Listener', plus: 'Creator', pro: 'Advance' },
			proBenefits: ['Content Performance', 'Listeners/Buyers by country', 'External Traffic Location', 'Average listening/watch time', 'Page Views', 'Watching/listening now', 'Product Conversion %', 'When songs are listened to most', 'When sales happen most'],
			showGetVerifiedModal: false
		};
	},


	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])({
		plansData: function plansData(state) {
			return state.app.plansData;
		},
		current: function current(state) {
			return state.app.onboarding.current;
		}
	}), {
		plans: function plans() {
			var plans = this.plansData.map(function (plan) {
				if (plan.id == "basic") {
					plan.title = "Everyone";
				}
				return plan;
			});

			return plans;
		},
		socialChannels: function socialChannels() {
			return [{
				title: "Instagram",
				id: "instagram"
			}, {
				title: "Tik Tok",
				id: "tiktok"
			}, {
				title: "Facebook",
				id: "facebook"
			}, {
				title: "Twitter",
				id: "twitter"
			}];
		},
		currentUser: function currentUser() {
			return this.$store.state.auth.user;
		},
		totalPayable: function totalPayable() {
			var fee = parseFloat(this.selectedPlan.price);
			var subFee = __WEBPACK_IMPORTED_MODULE_5__helper__["d" /* Stripe */].calculateSubFee(this.selectedPlan.price);

			var total = parseFloat(subFee) + parseFloat(fee);
			total = parseFloat(total.toFixed(2));

			return total;
		}
	}),

	methods: {
		openPaymentModal: function openPaymentModal() {
			this.initPayment = true;
		},
		closePaymentModal: function closePaymentModal() {
			this.initPayment = false;
			this.selectedPlan = {};
		},
		hideModal: function hideModal() {
			this.showGetVerifiedModal = false;
		},
		remainingDays: function remainingDays() {
			var reRequest = new Date(this.currentUser.re_requested_at);
			var todayDate = new Date();
			var diffTime = Math.abs(todayDate - reRequest);
			var diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
			return diffDays;
		},
		subscriptionChange: function subscriptionChange() {
			var _this = this;

			var params = { selectedPlan: 'pro', social_provider: this.socialChannel.id, social_user_name: this.socialUsername };
			__WEBPACK_IMPORTED_MODULE_6__services_subscription__["a" /* default */].subscriptionChange(params).then(function (response) {
				_this.hidePlanChangeModal();
				_this.$store.dispatch('error/showSuccessToast', [response.body.success_response]);
				setTimeout(function () {
					window.location.href = '/dashboard';
				}, 2000);
			}).catch(function (e) {
				_this.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
			});
		},
		verifyUserType: function verifyUserType() {
			if (this.currentUser && this.currentUser.stripe_customer_id == null) {
				this.openPaymentModal();
			} else {
				this.subscriptionChange();
			}
		},
		verifiedSocialAttributes: function verifiedSocialAttributes() {
			var _this2 = this;

			var params = { social_provider: this.socialChannel.id, social_user_name: this.socialUsername };
			this.$store.dispatch('error/showLoadingActivity', true);
			__WEBPACK_IMPORTED_MODULE_7__services_user__["a" /* default */].updateUserInfo(this.currentUser.id, params).then(function (response) {
				_this2.$store.dispatch('error/showLoadingActivity', false);
				_this2.$store.dispatch('error/showSuccessToast', ['Social Username and channel saved successfully']);
				__WEBPACK_IMPORTED_MODULE_8__services_auth__["a" /* default */].setUser(response.body);
				_this2.plansUpgradeModal = true;
				_this2.showGetVerifiedModal = false;
			}).catch(function (e) {
				_this2.$store.dispatch('error/showLoadingActivity', false);
				_this2.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
			});
		},
		planUpgrade: function planUpgrade() {
			if ((this.currentUser.plan == "basic" || this.currentUser.plan == null) && this.selectedPlan.id !== 'basic') {
				this.showGetVerifiedModal = true;
			} else {
				this.plansUpgradeModal = true;
			}
		},
		selectedChannel: function selectedChannel(channel) {
			this.socialChannel = channel;
		},
		hidePlanChangeModal: function hidePlanChangeModal() {
			this.plansUpgradeModal = false;
		}
	},

	mounted: function mounted() {
		this.selectedPlan = this.plans[2];
	}
});

/***/ }),
/* 956 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_auth_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    showLogin: Function
  },
  data: function data() {
    return {
      loading: false,
      email: null
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    onMobile: function onMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])({
    isAuthenticated: "auth/isAuthenticated"
  })),

  created: function created() {
    var _this = this;

    var myAlert = null;
    try {
      myAlert = JSON.parse(atob(this.$route.query["alert"]));
    } catch (e) {
      myAlert = null;
    }
    // console.log('login created', myAlert)

    if (this.isAuthenticated) {
      // this.$router.push({ name: "DiscoverIndex" });
      return;
    }

    var user = __WEBPACK_IMPORTED_MODULE_1__services_auth_js__["a" /* default */].loadCredential();
    if (user !== null) {
      this.user.email = user.email;
      this.user.password = user.password;
    }
    this.$store.dispatch("navigator/goNextState", { page: "login", tab: "" });

    if (myAlert) {
      switch (myAlert.type) {
        case "success":
          this.$store.dispatch("error/showSuccessToast", myAlert.messages);
          break;
        case "error":
          this.$store.dispatch("error/showErrorToast", myAlert.messages);
          break;
      }
    }

    this.$nextTick(function () {
      // console.log('after stream-player beforeDestroy ???')
      _this.$root.$emit(__WEBPACK_IMPORTED_MODULE_3__helper__["b" /* MyEvents */].AUTH_SIGNOUT);
    });
  },


  methods: {
    submit: function submit() {
      var _this2 = this;

      this.loading = true;
      this.$store.dispatch("error/showLoadingActivity", true);
      if (!this.email) return;

      var params = new FormData();
      params.append('email', this.email);
      __WEBPACK_IMPORTED_MODULE_1__services_auth_js__["a" /* default */].requestResetPassword(params).then(function (response) {
        _this2.loading = false;
        // JSON responses are automatically parsed.
        _this2.$store.dispatch('error/showSuccessToast', ['Email sent with password reset instructions.']);
        _this2.$store.dispatch("error/showLoadingActivity", false);
        _this2.resetSuccess = true;
      }).catch(function (e) {
        _this2.loading = false;
        _this2.$store.dispatch("error/showLoadingActivity", false);
        _this2.$store.dispatch('error/showErrorToast', ['Email does not exist or inactivated']);
      });
    }
  }
});

/***/ }),
/* 957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_auth_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    showForgotPassword: Function
  },
  data: function data() {
    return {
      loading: false,
      remember: false,
      user: {
        email: this.$route.query.email || "",
        password: ""
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    onMobile: function onMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])({
    isAuthenticated: "auth/isAuthenticated"
  }), {
    checkUserEmpty: function checkUserEmpty() {
      return this.user.email == "" || this.user.password == "";
    }
  }),
  created: function created() {
    var _this = this;

    var myAlert = null;
    try {
      myAlert = JSON.parse(atob(this.$route.query["alert"]));
    } catch (e) {
      myAlert = null;
    }
    if (this.isAuthenticated) {
      return;
    }
    var user = __WEBPACK_IMPORTED_MODULE_1__services_auth_js__["a" /* default */].loadCredential();
    if (user !== null) {
      this.user.email = user.email;
      this.user.password = user.password;
    }
    this.$store.dispatch("navigator/goNextState", { page: "login", tab: "" });

    if (myAlert) {
      switch (myAlert.type) {
        case "success":
          this.$store.dispatch("error/showSuccessToast", myAlert.messages);
          break;
        case "error":
          this.$store.dispatch("error/showErrorToast", myAlert.messages);
          break;
      }
    }

    this.$nextTick(function () {
      _this.$root.$emit(__WEBPACK_IMPORTED_MODULE_3__helper__["b" /* MyEvents */].AUTH_SIGNOUT);
    });
  },

  methods: {
    submit: function submit() {
      var _this2 = this;

      this.loading = true;
      this.$store.dispatch("error/showLoadingActivity", true);
      __WEBPACK_IMPORTED_MODULE_1__services_auth_js__["a" /* default */].login(this.user).then(function (response) {
        if (_this2.remember) {
          __WEBPACK_IMPORTED_MODULE_1__services_auth_js__["a" /* default */].saveCredential(_this2.user);
        }
        __WEBPACK_IMPORTED_MODULE_1__services_auth_js__["a" /* default */].setTokenAndUserInfo(response.body);

        if (response.body.sign_in_count <= 1) {
          _this2.$store.dispatch("auth/setFirstVisit", true);
        }

        _this2.$root.$emit(__WEBPACK_IMPORTED_MODULE_3__helper__["b" /* MyEvents */].AUTH_SIGNIN);

        _this2.$store.dispatch("error/showLoadingActivity", false);
        if (_this2.$store.state.auth.user.user_type === "listener" || _this2.$store.state.auth.user.user_type === "admin") window.location.href = "/settings";else window.location.href = "/upload/album";
      }).catch(function (e) {
        if (e.body.errors[0].message == "not authorized") {
          _this2.$router.push({ path: "/welcome?username=" + e.body.errors[0].username });
          return;
        }

        _this2.$router.push({ path: "/login?email=" + _this2.user.email });
        _this2.loading = false;

        _this2.$store.dispatch("error/showLoadingActivity", false);
        _this2.$store.dispatch("error/showErrorToast", e.body.errors || [e.body]);
      });
    }
  }
});

/***/ }),
/* 958 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha256__ = __webpack_require__(1411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha256___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_sha256__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      secret_code: ''
    };
  },
  created: function created() {
    // this.$store.dispatch('navigator/goNextState', { page: 'register', tab: 'protect' })
    this.$store.dispatch('navigator/goNextState', { page: '', tab: '' });
  },


  methods: {
    submit: function submit() {
      // console.log(sha256(this.secret_code))
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_js_sha256__["sha256"])(this.secret_code) === "e82a084c96d055241d1883bb219377cfd1804594d019a331db83cd054ccd9404") {
        this.$store.dispatch('auth/setSecretCode', "e82a084c96d055241d1883bb219377cfd1804594d019a331db83cd054ccd9404");
        // this.$router.push('/')
        this.$router.go(-1);
      }
    }
  }
});

/***/ }),
/* 959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_item__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_ticket__ = __webpack_require__(425);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    item: {
      type: Object,
      required: true
    },

    dismiss: {
      type: Function,
      required: true
    }
  },

  data: function data() {
    return {
      ticket_reasons: ["Incorrect size", "Product damaged", "Product not received", "Incorrect product", "Other"],
      ticket: {
        reason: "",
        description: ""
      },
      user: {
        avatar: {}
      },
      product: {
        covers: [{
          cover: {}
        }]
      },
      hasTicket: false,
      isDialogReady: false
    };
  },


  computed: {
    canSend: function canSend() {
      // let b = this.ticket.reason.trim() !== '' && this.ticket.description.trim() !== ''
      // console.log('canSend', b)
      return this.ticket.reason.trim() !== "" && this.ticket.description.trim() !== "";
    }
  },

  methods: {
    sendTicket: function sendTicket() {
      var _this = this;

      var params = {
        ticket: {
          reason: this.ticket.reason,
          description: this.ticket.description,
          item_id: this.item.id
        }
      };

      __WEBPACK_IMPORTED_MODULE_2__services_ticket__["a" /* default */].createTicket(params).then(function (response) {
        _this.dismiss();
      });
    }
  },

  created: function created() {
    var _this2 = this;

    // console.log('ticket_new_dialog', this.item)
    this.user = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(this.item, "product.merchant", { avatar: {} });
    this.product = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(this.item, "product", { covers: [{ cover: {} }] });

    this.isDialogReady = false;
    this.hasTicket = false;
    this.$store.dispatch("error/showLoadingActivity", true);
    __WEBPACK_IMPORTED_MODULE_1__services_item__["a" /* default */].tickets(this.item.id).then(function (response) {
      if (response.body.tickets.length > 0) {
        _this2.ticket = response.body.tickets[0];
        _this2.hasTicket = true;
      }
      _this2.isDialogReady = true;
      _this2.$store.dispatch("error/showLoadingActivity", false);
    }).catch(function (e) {
      _this2.isDialogReady = true;
      _this2.$store.dispatch("error/showLoadingActivity", false);
    });
  }
});

/***/ }),
/* 960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_trackcard__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_trackcard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_trackcard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_Playlists_addToPlaylist__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_Playlists_addToPlaylist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__views_Playlists_addToPlaylist__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		trackCard: __WEBPACK_IMPORTED_MODULE_0__components_trackcard___default.a,
		addToPlaylist: __WEBPACK_IMPORTED_MODULE_1__views_Playlists_addToPlaylist___default.a
	},
	props: {
		tracks: Array,
		playlists: Array,
		getCollections: Function,
		openDeletePlaylistModal: Function
	},
	data: function data() {
		return {
			showBanner: true,
			selectAlbumsMode: false,
			addToPlaylistActive: false,
			// playlists: [
			// 	{
			// 		title: "Workout",
			// 		cover: "",
			// 		tracks: 6,
			// 		status: "private",
			// 	},
			// ],
			// playlist: [],
			selectedAlbums: [],
			viewAllPlaylist: this.$parent.viewAllPlaylist
		};
	},


	methods: {
		methodThatForcesUpdate: function methodThatForcesUpdate() {
			this.$emit("methodThatForcesUpdate");
		},
		playlistImageList: function playlistImageList(playlist) {
			var playlistImages = [];
			var playlistDetails = playlist.playlist_details;
			for (var i = 0; i < playlistDetails.length; i++) {
				playlistImages.push(playlistDetails[i].cover.url);
			}
			if (playlistImages.length < 4) {
				while (playlistImages.length != 4) {
					console.log(playlistImages.length);
					playlistImages.push(__webpack_require__(307));
				}
			}
			return playlistImages;
		},
		toggleSelectAlbumsMode: function toggleSelectAlbumsMode(status) {
			this.selectAlbumsMode = status;
			if (!status) {
				this.selectedAlbums = [];
			}
		},
		closeBanner: function closeBanner() {
			this.showBanner = false;
		},
		openAddToPlaylist: function openAddToPlaylist() {
			if (this.selectedAlbums.length) {
				this.addToPlaylistActive = true;
			}
		},
		closeAddToPlaylist: function closeAddToPlaylist(isPartial) {
			if (!isPartial) {
				this.toggleSelectAlbumsMode();
			}
			this.addToPlaylistActive = false;
		},
		removeAlbum: function removeAlbum(track) {
			this.selectedAlbums = this.selectedAlbums.filter(function (album) {
				return album.id !== track.id;
			});
		},
		playlistLen: function playlistLen() {
			return this.playlists.length;;
		},


		displayAllPlaylists: function displayAllPlaylists() {
			this.$parent.viewAllPlaylist = true;
			this.viewAllPlaylist = true;
		},

		back: function back() {
			this.$parent.viewAllPlaylist = false;
			this.viewAllPlaylist = false;
		}
	},
	computed: {
		tempAlbum: function tempAlbum() {
			var albums = [];
			for (var i = 0; i < this.tracks.length; i++) {
				var track = this.tracks[i];
				var album = track.album;
				var user = track.user;

				albums.push({
					id: album.id,
					slug: album.slug,
					name: album.name,
					description: album.description,
					cover: {
						url: album.cover.url,
						large: {
							url: album.cover.large.url
						},
						thumb: {
							url: album.cover.thumb.url
						}
					},
					album_type: album.album_type,
					collaborators_count: album.collaborators_count,
					status: album.status,
					recommended: album.recommended,
					played: album.played,
					downloaded: album.downloaded,
					reposted: album.reposted,
					commented: album.commented,
					enabled_sample: album.enabled_sample,
					recommended_at: album.recommended_at,
					location: album.location,
					track: track,
					user: user
				});
			}

			return albums;
		}
	},

	created: function created() {
		console.log("=================", this.tracks);
	}
});

/***/ }),
/* 961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_productcard__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_productcard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_productcard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_Playlists_addToPlaylist__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_Playlists_addToPlaylist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__views_Playlists_addToPlaylist__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    productCard: __WEBPACK_IMPORTED_MODULE_0__components_productcard___default.a,
    addToPlaylist: __WEBPACK_IMPORTED_MODULE_1__views_Playlists_addToPlaylist___default.a
  },
  props: {
    products: Array,
    playlists: Array,
    getCollections: Function,
    openDeletePlaylistModal: Function
  },

  data: function data() {
    return {
      showBanner: true,
      addToPlaylistActive: false,
      selectProductsMode: false,
      selectedProducts: [],
      viewAllPlaylist: this.$parent.viewAllPlaylist
    };
  },

  methods: {
    methodThatForcesUpdate: function methodThatForcesUpdate() {
      this.$emit("methodThatForcesUpdate");
    },
    playlistLen: function playlistLen() {
      return this.playlists.length;;
    },
    toggleSelectProductsMode: function toggleSelectProductsMode(status) {
      this.selectProductsMode = status;
      if (!status) {
        this.selectedProducts = [];
      }
    },
    removeProduct: function removeProduct(id) {
      this.selectedProducts = this.selectedProducts.filter(function (product) {
        return product.id !== id;
      });
    },
    closeBanner: function closeBanner() {
      this.showBanner = false;
    },
    openAddToPlaylist: function openAddToPlaylist() {
      if (this.selectedProducts.length) {
        this.addToPlaylistActive = true;
      }
    },
    closeAddToPlaylist: function closeAddToPlaylist(isPartial) {
      if (!isPartial) {
        this.toggleSelectProductsMode();
      }
      this.addToPlaylistActive = false;
    },
    playlistImageList: function playlistImageList(playlist) {
      var playlistImages = [];
      var playlistDetails = playlist.playlist_details;
      for (var i = 0; i < playlistDetails.length; i++) {
        playlistImages.push(playlistDetails[i].covers[0].cover.url);
      }
      if (playlistImages.length < 4) {
        while (playlistImages.length != 4) {
          console.log(playlistImages.length);
          playlistImages.push(__webpack_require__(307));
        }
      }
      return playlistImages;
    },


    displayAllPlaylists: function displayAllPlaylists() {
      this.$parent.viewAllPlaylist = true;
      this.viewAllPlaylist = true;
    },

    back: function back() {
      this.$parent.viewAllPlaylist = false;
      this.viewAllPlaylist = false;
    }
  },
  computed: {
    tempProduct: function tempProduct() {
      var products = [];
      for (var i = 0; i < this.products.length; i++) {
        var product = this.products[i];
        var merchant = product.merchant;

        products.push({
          id: product.id,
          name: product.name,
          description: product.description,
          price: product.price,
          reposted: product.reposted,
          stock: product.stock,
          sold: product.sold,
          stock_status: product.stock_status,
          collaborators_count: 0,
          show_status: product.show_status,
          status: product.status,
          collaborators: product.collaborators,
          creator_share: product.creator_share,
          creator_recoup_cost: product.creator_recoup_cost,
          digital_content_name: product.digital_content_name,
          merchant: merchant,
          category: product.category,
          variants: product.variants,
          shipments: product.shipments,
          covers: product.covers
        });
      }

      return products;
    }
  }
});

/***/ }),
/* 962 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_video_box__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_video_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_video_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_Playlists_addToPlaylist__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_Playlists_addToPlaylist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__views_Playlists_addToPlaylist__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    VideoBox: __WEBPACK_IMPORTED_MODULE_0__components_video_box___default.a,
    addToPlaylist: __WEBPACK_IMPORTED_MODULE_1__views_Playlists_addToPlaylist___default.a
  },
  props: {
    streams: Array,
    playlists: Array,
    getCollections: Function,
    openDeletePlaylistModal: Function
  },

  data: function data() {
    return {
      showBanner: true,
      addToPlaylistActive: false,
      selectedVideos: [],
      selectVideosMode: false,
      viewAllPlaylist: this.$parent.viewAllPlaylist
    };
  },

  methods: {
    methodThatForcesUpdate: function methodThatForcesUpdate() {
      this.$emit("methodThatForcesUpdate");
    },
    playlistImageList: function playlistImageList(playlist) {
      var playlistImages = [];
      var playlistDetails = playlist.playlist_details;
      for (var i = 0; i < playlistDetails.length; i++) {
        playlistImages.push(playlistDetails[i].cover.url);
      }
      if (playlistImages.length < 4) {
        while (playlistImages.length != 4) {
          console.log(playlistImages.length);
          playlistImages.push(__webpack_require__(307));
        }
      }
      return playlistImages;
    },
    toggleSelectVideosMode: function toggleSelectVideosMode(status) {
      this.selectVideosMode = status;
      if (!status) {
        this.selectedVideos = [];
      }
    },
    removeVideo: function removeVideo(id) {
      this.selectedVideos = this.selectedVideos.filter(function (video) {
        return video.id !== id;
      });
    },
    closeBanner: function closeBanner() {
      this.showBanner = false;
    },
    openAddToPlaylist: function openAddToPlaylist() {
      if (this.selectedVideos.length) {
        this.addToPlaylistActive = true;
      }
    },
    closeAddToPlaylist: function closeAddToPlaylist(isPartial) {
      if (!isPartial) {
        this.toggleSelectVideosMode();
      }
      this.addToPlaylistActive = false;
    },
    playlistLen: function playlistLen() {
      return this.playlists.length;;
    },


    displayAllPlaylists: function displayAllPlaylists() {
      this.$parent.viewAllPlaylist = true;
      this.viewAllPlaylist = true;
    },

    back: function back() {
      this.$parent.viewAllPlaylist = false;
      this.viewAllPlaylist = false;
    }
  },
  computed: {
    tempVideo: function tempVideo() {
      var streams = [];
      for (var i = 0; i < this.streams.length; i++) {
        var stream = this.streams[i];
        var user = stream.user;

        streams.push({
          id: stream.id,
          name: stream.name,
          slug: stream.slug,
          description: stream.description,
          cover: {
            url: stream.cover.url,
            large: { url: stream.cover.large.url },
            thumb: { url: stream.cover.thumb.url }
          },
          video_type: stream.video_type,
          status: stream.status,
          started_at: stream.started_at,
          stopped_at: stream.stopped_at,
          mp_channel_1_ep_1_url: stream.mp_channel_1_ep_1_url,
          mp_channel_2_url: stream.mp_channel_2_url,
          duration: stream.duration,
          valid_period: stream.valid_period,
          remaining_seconds: stream.remaining_seconds,
          assoc_type: stream.assoc_type,
          account_ids: stream.account_ids,
          digital_content_name: stream.digital_content_name,
          view_price: stream.view_price,
          viewers_limit: stream.viewers_limit,
          notified: true,
          assoc: null,
          guests: [],
          is_reposted: stream.is_reposted,
          broadcast_seconds: 0,
          digital_content_url: null,
          accounts: [],
          user: user,
          genre: stream.genre
        });
      }

      return streams;
    }
  }
});

/***/ }),
/* 963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_album__ = __webpack_require__(11);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
	props: {
		album: Object
	},
	data: function data() {
		return {
			webTitle: this.album.web_title,
			webReview: this.album.web_review,
			mobileTitle: this.album.mobile_title,
			mobileReview: this.album.mobile_review,
			loading: false
		};
	},


	methods: {
		saveTitleAndReview: function saveTitleAndReview() {
			var _this = this;

			this.loading = true;
			this.$store.dispatch("error/showLoadingActivity", true);

			var params = { web_title: this.webTitle, web_review: this.webReview,
				mobile_title: this.mobileTitle, mobile_review: this.mobileReview
			};

			__WEBPACK_IMPORTED_MODULE_0__services_album__["a" /* default */].recommendAlbum(this.album.id, params).then(function (response) {
				_this.$store.dispatch('error/showSuccessToast', ['Album recommended successfully.']);
				setTimeout(function () {
					_this.loading = false;
					_this.$store.dispatch("error/showLoadingActivity", false);
					window.location.reload();
				}, 1500);
			}).catch(function (e) {
				_this.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
			});
		}
	}
});

/***/ }),
/* 964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },
  created: function created() {
    if (this.$store) {
      this.$store.dispatch('navigator/goNextState', { page: '', tab: '' });
    }
  }
});

/***/ }),
/* 965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_promotemodal__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_promotemodal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_promotemodal__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    promoteModal: __WEBPACK_IMPORTED_MODULE_0__components_promotemodal___default.a
  },

  props: {
    album: {
      type: Object
    },

    user: {
      type: Object
    },

    type: {
      type: String
    },

    deleteButtonFunc: {
      type: Function
    },

    deleteButtonText: {
      type: String,
      default: "Delete"
    },

    deleteButtonClass: {
      type: String
    },

    acceptButtonFunc: {
      type: Function
    },

    denyButtonFunc: {
      type: Function
    },

    status: {
      type: String
    },

    showPromoteButton: {
      type: Boolean,
      default: true
    }
  },

  data: function data() {
    return {
      isShowPromoteModal: false
    };
  },


  computed: {
    buttonText: function buttonText() {
      if (this.album.status === "published") {
        return "Make Private";
      } else if (this.album.status === "privated") {
        return "Make Public";
      }
    }
  },

  created: function created() {},


  methods: {
    showPromoteDialog: function showPromoteDialog() {
      this.isShowPromoteModal = true;
    },
    dismissPromoteDialog: function dismissPromoteDialog() {
      this.isShowPromoteModal = false;
    },
    saveAndFinish: function saveAndFinish() {
      this.dismissPromoteDialog();
    }
  }
});

/***/ }),
/* 966 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},

  props: {
    user: {
      type: Object
    },

    deleteFunc: {
      type: Function
    },

    deleteText: {
      type: String,
      default: "remove"
    },

    acceptFunc: {
      type: Function
    },

    denyFunc: {
      type: Function
    },

    status: {
      type: String,
      default: ""
    }
  }
});

/***/ }),
/* 967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_newsletter_reciepients__ = __webpack_require__(843);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Footer",
  data: function data() {
    return {
      email: ''
    };
  },


  methods: {
    storeEmail: function storeEmail() {
      var _this = this;

      if (!this.validateEmail(this.email)) {
        this.$store.dispatch('error/showErrorToast', ['Invalid email address!']);
        return;
      }

      var params = { email: this.email };

      __WEBPACK_IMPORTED_MODULE_0__services_newsletter_reciepients__["a" /* default */].storeRecipient(params).then(function (res) {
        console.log(res);
        _this.$store.dispatch('error/showSuccessToast', res.body || [res.bodyText]);
        _this.email = '';
      }).catch(function (error) {
        _this.$store.dispatch('error/showErrorToast', error.body.errors || [error.body]);
      });
    },
    validateEmail: function validateEmail(email) {
      var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    }
  }
});

/***/ }),
/* 968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UpgradePlan_vue__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UpgradePlan_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__UpgradePlan_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FooterLandingPage_vue__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FooterLandingPage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__FooterLandingPage_vue__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    UpgradePlan: __WEBPACK_IMPORTED_MODULE_1__UpgradePlan_vue___default.a,
    FooterLandingPage: __WEBPACK_IMPORTED_MODULE_2__FooterLandingPage_vue___default.a
  },
  data: function data() {
    return {
      isUpgrade: false,
      categoryPlan: "creator",
      creatorFaqs: [{
        question: "How much do creators keep on sales?",
        answer: "Creators keep 90% of all sales, including digital sales & membership revenue.",
        open: false
      }],
      generalFaqs: [{
        question: "What is YouSound?",
        answer: "YouSound is a unique music streaming service that combines traditional streaming with a membership model. It allows fans to enjoy a wide range of music while providing an option to support their favorite artists more deeply through memberships.",
        open: false
      }]
    };
  },

  methods: {
    navigateTo: function navigateTo(path) {
      this.isUpgrade = false;
      this.$router.push({ path: path });
    },
    toggleFaq: function toggleFaq(index, category) {
      var faqList = category === "creator" ? this.creatorFaqs : this.generalFaqs;
      faqList.forEach(function (faq, i) {
        if (i !== index) {
          faq.open = false;
        }
      });
      this.$set(faqList, index, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, faqList[index], {
        open: !faqList[index].open
      }));
    }
  },
  watch: {
    $route: function $route() {
      this.isUpgrade = false;
    }
  }
});

/***/ }),
/* 969 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "RevenueCalculator",
  data: function data() {
    return {
      formData: {
        range: 0
      },
      increments: [0, 50, 100, 500, 1000, 2500, 5000, 10000, 25000, 35000, 50000, 100000, 150000, 200000, 250000, 300000, 350000, 400000, 450000, 500000, 550000, 1000000, 2000000, 3000000, 4000000, 5000000, 6000000, 7000000, 8000000, 9000000, 10000000, 20000000, 30000000, 40000000, 50000000, 60000000, 70000000, 80000000, 90000000, 100000000, 110000000, 120000000, 130000000, 140000000, 150000000],
      youSoundRevenue: "",
      dspRevenue: "0",
      listenerCount: 0
    };
  },
  mounted: function mounted() {
    this.updateRangePrice();
  },

  methods: {
    updateRangePrice: function updateRangePrice() {
      var selectedValue = this.increments[this.formData.range];
      this.listenerCount = selectedValue;

      var totalStreams = selectedValue * 4; // High STL ratio for DSP calculation
      var dspRate = 0.003; // $0.003 per stream on DSPs
      var dspTotalRevenue = totalStreams * dspRate;

      var youSoundRateMin = 0.5; // $0.50 per listener
      var youSoundRateMax = 5.0; // $5.00 per listener

      // Calculate the YouSound revenue range
      var youSoundLowRatio = 1.0; // Use 100% of listeners for low STL ratio
      var youSoundHighRatio = 1.0; // High STL ratio (100% of listeners)

      var youSoundRevenueLow = selectedValue * youSoundLowRatio * youSoundRateMin;
      var youSoundRevenueHigh = selectedValue * youSoundHighRatio * youSoundRateMax;

      this.dspRevenue = "$" + this.formatNumber(Math.round(dspTotalRevenue));

      if (selectedValue === 0) {
        this.youSoundRevenue = "$0";
      } else {
        this.youSoundRevenue = "$" + this.formatNumber(Math.round(youSoundRevenueLow)) + " - $" + this.formatNumber(Math.round(youSoundRevenueHigh));
      }
    },
    formatNumber: function formatNumber(num) {
      if (num >= 1000000) {
        return (num / 1000000).toFixed(0) + "M";
      }
      if (num >= 1000) {
        return (num / 1000).toFixed(0) + "K";
      }
      return num.toString();
    },
    redirectToAppStore: function redirectToAppStore() {
      var userAgent = navigator.userAgent || navigator.vendor || window.opera;

      if (/android/i.test(userAgent)) {
        window.location.href = "https://play.google.com/store/apps/details?id=com.example.android"; // Replace with your Android app link
      } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        window.location.href = "https://apps.apple.com/us/app/yousound/id1452078262"; // Replace with your iOS app link
      } else {
        window.location.href = "/signup"; // Fallback for web browsers
      }
    }
  },
  computed: {
    formattedListenerCount: function formattedListenerCount() {
      return this.formatNumber(this.listenerCount);
    }
  }
});

/***/ }),
/* 970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stripe_stripe_js__ = __webpack_require__(819);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    categoryPlan: { type: String }
  },
  data: function data() {
    return {
      dialog: false,
      successDialog: false,
      tab: "yearly",
      tabList: [{ id: "yearly", title: "Yearly (Save 20%)" }, { id: "monthly", title: "Monthly" }],
      creators: {
        title: "Premium",
        subtitle: "All access for everyone!",
        option: ["Ad Free", "Unlimited Streaming", "See Creators You Support", "Offline Listening", "Human powered algorithm", "Fair Streaming Payouts (for artists)", "Analytics (for artists)"]
      },
      premium: {
        title: "Premium",
        subtitle: "All access for everyone. Cancel anytime.",
        option: ["Unlimited uploads", "Analytics for all content", "Unlimited streaming", "Offline listening", "No Ads"]
      },
      stripe: null,
      elements: null,
      cardElement: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])("auth", ["isAuthenticated", "currentUser"])),
  methods: {
    setTab: function setTab(tab) {
      this.tab = tab;
    },
    openDialog: function openDialog() {
      if (!this.isAuthenticated) {
        this.$store.dispatch("auth/setRedirectPath", "upgrade");
        this.$router.push({ name: "login" });
      } else {
        this.dialog = true;
      }
    },
    closeDialog: function closeDialog() {
      this.dialog = false;
    },
    closeSuccessDialog: function closeSuccessDialog() {
      this.successDialog = false;
    },
    purchase: function purchase() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref, token, error, response;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this.stripe.createToken(_this.cardElement);

              case 3:
                _ref = _context.sent;
                token = _ref.token;
                error = _ref.error;

                if (!error) {
                  _context.next = 10;
                  break;
                }

                console.error("Stripe token creation error:", error);
                alert(error.message);
                return _context.abrupt("return");

              case 10:
                _context.next = 12;
                return _this.$http.post("/v2/subscriptions", {
                  token: token.id,
                  plan: _this.tab === "yearly" ? "yearly_plan_id" : "monthly_plan_id"
                });

              case 12:
                response = _context.sent;


                if (response.status === 200) {
                  _this.dialog = false;
                  _this.successDialog = true;
                } else {
                  console.error("Backend error:", response.data);
                  alert("An error occurred while processing your payment.");
                }
                _context.next = 20;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context["catch"](0);

                console.error("Error processing payment:", _context.t0);
                alert("An error occurred while processing your payment.");

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 16]]);
      }))();
    },
    goToDashboard: function goToDashboard() {
      this.$router.push({ name: "dashboard" });
    },
    handleGetStarted: function handleGetStarted() {
      // if (!this.isAuthenticated) {
      //   this.$store.dispatch("auth/showLoginModal", {
      //     redirect: "subscriptionModal",
      //   });
      // } else {
      this.dialog = true;
      // }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__stripe_stripe_js__["a" /* loadStripe */])("pk_live_fXEdJ0v6E2ROxT8rufDCby12");

            case 2:
              _this2.stripe = _context2.sent;

              _this2.elements = _this2.stripe.elements();
              _this2.cardElement = _this2.elements.create("card");
              _this2.cardElement.mount("#card-element");

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  created: function created() {
    if (this.$store.state.auth.redirectPath === "upgrade" && this.isAuthenticated) {
      this.dialog = true;
      this.$store.dispatch("auth/setRedirectPath", null);
    }
  }
});

/***/ }),
/* 971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_UpgradePlan_vue__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_UpgradePlan_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_UpgradePlan_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_RevenueCalculator_vue__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_RevenueCalculator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_RevenueCalculator_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FooterLandingPage_vue__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FooterLandingPage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_FooterLandingPage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_base_qr_code__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_base_qr_code___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_base_qr_code__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    UpgradePlan: __WEBPACK_IMPORTED_MODULE_0__components_UpgradePlan_vue___default.a,
    RevenueCalculator: __WEBPACK_IMPORTED_MODULE_1__components_RevenueCalculator_vue___default.a,
    FooterLandingPage: __WEBPACK_IMPORTED_MODULE_2__components_FooterLandingPage_vue___default.a,
    QrCode: __WEBPACK_IMPORTED_MODULE_3__components_base_qr_code___default.a
  },
  data: function data() {
    return {
      openQrCode: function openQrCode(type) {
        return this.$refs.qrCode.openQrCode(type);
      },

      qrCodeTypeList: __WEBPACK_IMPORTED_MODULE_4__helper__["e" /* QrCodeTypeList */],
      categoryPlan: "creator",
      tab: null,
      tabList: [
      // { text: "Go Premium", value: "go_premium" },
      { text: "Estimator", value: "revenue_calculator" }],
      isScrolled: false
    };
  },

  methods: {
    navigateTo: function navigateTo(path) {
      this.tab = null;
      this.$router.push({ path: path });
    },
    redirectToAppStore: function redirectToAppStore() {
      var userAgent = navigator.userAgent || navigator.vendor || window.opera;

      if (/android/i.test(userAgent)) {
        window.location.href = "https://play.google.com/store/apps/details?id=com.example.android"; // Replace with your Android app link
      } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        window.location.href = "https://apps.apple.com/us/app/yousound/id1452078262"; // Replace with your iOS app link
      } else {
        window.location.href = "/signup"; // Fallback for web browsers
      }
    },
    handleScroll: function handleScroll() {
      this.isScrolled = window.scrollY > 0;
    },
    scrollToTop: function scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    goToCalculator: function goToCalculator() {
      var _this = this;

      this.tab = "revenue_calculator";
      this.$nextTick(function () {
        _this.scrollToTop();
      });
    }
  },
  mounted: function mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },

  watch: {
    $route: function $route() {
      this.tab = null;
    }
  }
});

/***/ }),
/* 972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_landingPages_Join_vue__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_landingPages_Join_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_landingPages_Join_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_landingPages_Footer_vue__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_landingPages_Footer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_landingPages_Footer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_landingPages_Header_vue__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_landingPages_Header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_landingPages_Header_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_landingPages_Banner_vue__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_landingPages_Banner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_landingPages_Banner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_landing1_CRow_vue__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_landing1_CRow_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_landing1_CRow_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_footer__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_mobile_components_trending_music__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_mobile_components_trending_music___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__views_mobile_components_trending_music__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_mobile_components_trending_videos__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_mobile_components_trending_videos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__views_mobile_components_trending_videos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_mobile_components_trending_products__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_mobile_components_trending_products___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__views_mobile_components_trending_products__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_contentTopHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_contentTopHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_contentTopHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_mobile_auth_onboarding__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_mobile_auth_onboarding___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__views_mobile_auth_onboarding__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_auth_loginInput__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_auth_loginInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__views_auth_loginInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_mobile_auth_learnMore__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_mobile_auth_learnMore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__views_mobile_auth_learnMore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_auth_forgotPasswordInput___ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_auth_forgotPasswordInput____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__views_auth_forgotPasswordInput___);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

















/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Landing1",
  components: {
    Header: __WEBPACK_IMPORTED_MODULE_3__components_landingPages_Header_vue___default.a,
    Banner: __WEBPACK_IMPORTED_MODULE_4__components_landingPages_Banner_vue___default.a,
    CRow: __WEBPACK_IMPORTED_MODULE_5__components_landing1_CRow_vue___default.a,
    Join: __WEBPACK_IMPORTED_MODULE_1__components_landingPages_Join_vue___default.a,
    Footer: __WEBPACK_IMPORTED_MODULE_2__components_landingPages_Footer_vue___default.a,
    appFooter: __WEBPACK_IMPORTED_MODULE_6__components_footer___default.a,
    trendingMusic: __WEBPACK_IMPORTED_MODULE_8__views_mobile_components_trending_music___default.a,
    trendingVideo: __WEBPACK_IMPORTED_MODULE_9__views_mobile_components_trending_videos___default.a,
    trendingProduct: __WEBPACK_IMPORTED_MODULE_10__views_mobile_components_trending_products___default.a,
    contentTopHeader: __WEBPACK_IMPORTED_MODULE_11__components_contentTopHeader___default.a,
    Onboarding: __WEBPACK_IMPORTED_MODULE_12__views_mobile_auth_onboarding___default.a,
    LoginInput: __WEBPACK_IMPORTED_MODULE_13__views_auth_loginInput___default.a,
    LearnMore: __WEBPACK_IMPORTED_MODULE_14__views_mobile_auth_learnMore___default.a,
    forgotPasswordInput: __WEBPACK_IMPORTED_MODULE_15__views_auth_forgotPasswordInput____default.a
  },
  data: function data() {
    return {
      loginAuth: "login",
      iosStore: __webpack_require__(311),
      androidPlaystore: __webpack_require__(312),
      activeView: "landingView",
      activeTab: "music",
      tabs: [{ id: "music", title: "Music" }, { id: "videos", title: "Video" }, { id: "merch", title: "Shop" }],
      items_per_page: 20,
      touchstartX: null,
      touchstartY: null,
      touchendX: null
    };
  },
  created: function created() {
    if (this.$store.state.auth.user != null) {
      this.$router.push({ name: 'UserSettings' });
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapState */])({
    musicFeed: function musicFeed(state) {
      return state.trending.albums;
    },
    currentSignUpStage: function currentSignUpStage(state) {
      return state.app.onboarding.current;
    },
    signUpAccountCategory: function signUpAccountCategory(state) {
      return state.app.onboarding.accountCategory;
    }
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapGetters */])({
    isAuthenticated: "auth/isAuthenticated",
    onMobileStrict: "app/onMobileStrict"
  }), {
    showAuthCTA: function showAuthCTA() {
      if (!this.signUpAccountCategory || this.signUpAccountCategory == "creator" && this.currentSignUpStage !== 7) {
        return true;
      }
    },
    toDisplayGrid: function toDisplayGrid() {
      return this.activeView === "signUpView" || this.activeView === "loginView";
    },
    showSignupBtn: function showSignupBtn() {
      return this.activeView !== "signUpView";
    },
    showLoginBtn: function showLoginBtn() {
      return this.activeView !== "loginView";
    },
    showAuthCancelBtn: function showAuthCancelBtn() {
      return this.activeView === "signUpView" && this.currentSignUpStage < 7 || this.activeView === "loginView" || this.activeView === "learnMoreView";
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapActions */])({
    getTrendingMusic: "trending/getTrendingMusic"
  }), {
    isActiveTab: function isActiveTab(tab) {
      return this.activeTab === tab;
    },
    showForgotPassword: function showForgotPassword() {
      this.loginAuth = "forgotPassword";
    },
    showLogin: function showLogin() {
      this.loginAuth = "login";
      this.activeView = 'loginView';
    },
    onTab: function onTab(tab) {
      this.activeTab = tab;
    },
    loadTrendingMusic: function loadTrendingMusic() {
      if (this.musicFeed.length) return;

      var params = {
        filter: "new",
        genre: "any",
        category: "any",
        page: 1,
        per_page: this.items_per_page
      };

      this.getTrendingMusic(params);
    },
    handleLearnMore: function handleLearnMore() {
      this.activeView = 'learnMoreView';
    },
    touchEnd: function touchEnd(evt) {
      if (!this.onMobileStrict) return;

      var touchstartX = evt.changedTouches[0].screenY;
      var touchendX = this.touchendX;

      if (touchendX < touchstartX) {
        console.log('Swiped Left');
        this.activeView = "learnMoreView";

        if (this.endRight) {
          evt.stopPropagation();
        }
      }

      if (touchendX > touchstartX) {
        console.log('Swiped Right');
        this.activeView = "landingView";

        if (this.endLeft) {
          evt.stopPropagation();
        }
      }

      this.touchendX = null;
    },
    touchStart: function touchStart(evt) {
      if (!this.onMobileStrict) return;

      this.touchendX = evt.changedTouches[0].screenY;
    }
  })
});

/***/ }),
/* 973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_landingPages_Header_vue__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_landingPages_Header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_landingPages_Header_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_landingPages_Banner_vue__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_landingPages_Banner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_landingPages_Banner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_landingPages_Join_vue__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_landingPages_Join_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_landingPages_Join_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_landingPages_Footer_vue__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_landingPages_Footer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_landingPages_Footer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_landing2_CommonSection_vue__ = __webpack_require__(1578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_landing2_CommonSection_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_landing2_CommonSection_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_landing2_TimeLine_vue__ = __webpack_require__(1579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_landing2_TimeLine_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_landing2_TimeLine_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Landing2",
  components: { Header: __WEBPACK_IMPORTED_MODULE_0__components_landingPages_Header_vue___default.a, Banner: __WEBPACK_IMPORTED_MODULE_1__components_landingPages_Banner_vue___default.a, Join: __WEBPACK_IMPORTED_MODULE_2__components_landingPages_Join_vue___default.a, Footer: __WEBPACK_IMPORTED_MODULE_3__components_landingPages_Footer_vue___default.a, CommonSection: __WEBPACK_IMPORTED_MODULE_4__components_landing2_CommonSection_vue___default.a, TimeLine: __WEBPACK_IMPORTED_MODULE_5__components_landing2_TimeLine_vue___default.a },
  data: function data() {
    return {
      bannerImg: __webpack_require__(221),
      img: __webpack_require__(1551),
      img1: __webpack_require__(1553),
      img2: __webpack_require__(1529),
      img3: __webpack_require__(1535),
      img4: __webpack_require__(1458),
      img5: __webpack_require__(1554),
      musicList: ["Add collaborators", "Share direct-to-listeners", "Attach products to albums"],
      videoList: ["Attach albums to videos", "Attach products to videos", "Accept donations"],
      productList: ["Sell physical & digital products", "Collaborate, split revenue & recoup", "Keep 100% of product sales"],
      streamsList: ["Sales, pay-perview, donations", "Get paid to share", "Become a YouSound Partner"],

      growList: ["Track your stats", "Advanced analytics"],
      partnerList: ["Share Ad & Subscription revenue", "User-centric payout model", "Earn a liveable income without lots of plays"]
    };
  }
});

/***/ }),
/* 974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_landingPages_Header_vue__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_landingPages_Header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_landingPages_Header_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_landing3_Banner_vue__ = __webpack_require__(1580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_landing3_Banner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_landing3_Banner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_landingPages_Footer_vue__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_landingPages_Footer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_landingPages_Footer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_landing1_CRow_vue__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_landing1_CRow_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_landing1_CRow_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_landing3_Plans_vue__ = __webpack_require__(1582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_landing3_Plans_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_landing3_Plans_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Landing3",
  components: { Header: __WEBPACK_IMPORTED_MODULE_0__components_landingPages_Header_vue___default.a, Banner: __WEBPACK_IMPORTED_MODULE_1__components_landing3_Banner_vue___default.a, Footer: __WEBPACK_IMPORTED_MODULE_2__components_landingPages_Footer_vue___default.a, CRow: __WEBPACK_IMPORTED_MODULE_3__components_landing1_CRow_vue___default.a, Plans: __WEBPACK_IMPORTED_MODULE_4__components_landing3_Plans_vue___default.a },
  data: function data() {
    return {
      img: __webpack_require__(1449),
      img1: __webpack_require__(1450),
      img2: __webpack_require__(1447)
    };
  }
});

/***/ }),
/* 975 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_activityitem__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_activityitem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_activityitem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_contentTopHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_contentTopHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_contentTopHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_album_components_manageAlbum__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_album_components_manageAlbum___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_album_components_manageAlbum__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_payments__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_payments___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_payments__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_settings__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_settings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__upload_components_nav__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__upload_components_nav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__upload_components_nav__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import { mapGetters } from 'vuex'


// import manageProduct from '@/views/product/components/manageProduct'

// import manageVideo from '@/views/video/components/manageVideo'




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    activityItem: __WEBPACK_IMPORTED_MODULE_0__components_activityitem___default.a,
    contentTopHeader: __WEBPACK_IMPORTED_MODULE_1__components_contentTopHeader___default.a,
    // manageProduct,
    manageAlbum: __WEBPACK_IMPORTED_MODULE_2__views_album_components_manageAlbum___default.a,
    // manageVideo,
    payments: __WEBPACK_IMPORTED_MODULE_3__views_payments___default.a,
    settings: __WEBPACK_IMPORTED_MODULE_4__views_settings___default.a,
    uploadNav: __WEBPACK_IMPORTED_MODULE_5__upload_components_nav___default.a
  },

  data: function data() {
    return {
      replaceTopMenu: [{ id: 'manage', title: 'Manage', pathName: 'ManageIndex', icon: __webpack_require__(428) }],
      active_tab: 'content',
      activeInnerFilter: 'albums',
      activeInnerTab: 'published',
      tabFilterOptions: [{
        title: 'Albums', value: 'albums'
      }],
      page_index: 1,
      total_pages: 1,
      items_per_page: 8 * 1,
      activities: [],
      isPageReady: false
    };
  },


  computed: {
    userType: function userType() {
      return this.$store.getters['auth/userType'];
    },
    videosMenuTabs: function videosMenuTabs() {
      var tabs = [];
      return tabs;
    },
    productMenuTabs: function productMenuTabs() {
      var tabs = [{ id: 'published', title: 'Inventory' }, { id: 'privated', title: 'Private' }, { id: 'collaborated', title: 'Collaborations' }];
      return tabs;
    },
    albumsMenuTabs: function albumsMenuTabs() {
      var tabs = [{ id: 'published', title: 'Published' }, { id: 'privated', title: 'Private' },
      // { id: 'exclusives', title: 'Video Exclusives' },
      // { id: 'video_only', title: 'Video Attachments' },
      { id: 'collaborated', title: 'Collaborations' }];
      return tabs;
    },
    currentUser: function currentUser() {
      return this.$store.state.auth.user;
    }
  },
  methods: {
    setActiveInnerFilter: function setActiveInnerFilter(filter) {
      this.activeInnerFilter = filter;
    },
    isActiveFilter: function isActiveFilter(filter) {
      return this.activeInnerFilter === filter;
    },
    setInnerTab: function setInnerTab(id) {
      this.activeInnerTab = id;

      switch (this.activeInnerFilter) {
        case 'products':
          // this.$refs.manageProduct.setProductFilter(id)
          break;

        case 'albums':
          this.$refs.manageAlbum.setAlbumFilter(id);
          break;

        // case 'videos':
        //   this.$refs.manageVideo.setVideoFilter(id)
        //   break

        default:
          return;
      }
    },
    getInnerMenuTabs: function getInnerMenuTabs(filter) {
      switch (filter) {
        case 'products':
          return this.productMenuTabs;
        case 'albums':
          return this.albumsMenuTabs;
        // case 'videos':
        //   return this.videosMenuTabs
        default:
          [];
      }
    },
    isActiveTab: function isActiveTab(tab) {
      return this.active_tab == tab;
    },
    isActiveInnerTab: function isActiveInnerTab(tab) {
      return this.activeInnerTab == tab;
    }
  },
  watch: {
    activeInnerFilter: function activeInnerFilter(val) {
      var _this = this;

      var getInnerTab = this.getInnerMenuTabs(val).find(function (tab) {
        return tab.id == _this.activeInnerTab;
      });
      // if (val === 'videos') return

      var fallback = this.getInnerMenuTabs(val)[0].id || '';
      if (!getInnerTab) {
        this.activeInnerTab = fallback;
      } else {
        this.activeInnerTab = getInnerTab.id;
      }

      this.setInnerTab(this.activeInnerTab);
    }
  },
  created: function created() {
    if (this.userType === 'listener') {
      this.active_tab = 'payment';
    }
    if (localStorage.getItem("release_product")) {
      this.activeInnerFilter = 'products';
    } // else if (localStorage.getItem("release_video")) {
    //   this.activeInnerFilter = 'videos'
    // }
  },
  mounted: function mounted() {
    var _$route$params = this.$route.params,
        activeInnerFilter = _$route$params.activeInnerFilter,
        activeInnerTab = _$route$params.activeInnerTab;

    if (this.$route.query['tab']) {
      this.activeInnerFilter = this.$route.query['tab'];
    }
    if (activeInnerFilter) {
      this.activeInnerFilter = activeInnerFilter;
    }

    if (activeInnerTab) {
      this.activeInnerTab = activeInnerTab;
    } else {
      this.activeInnerTab = 'published';
    }

    this.setInnerTab(this.activeInnerTab);
  }
});

/***/ }),
/* 976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_album__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_message__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_user__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_activityalbumcard__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_activityalbumcard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_activityalbumcard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_activityproductcard__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_activityproductcard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_activityproductcard__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    activityAlbumCard: __WEBPACK_IMPORTED_MODULE_5__components_activityalbumcard___default.a,
    activityProductCard: __WEBPACK_IMPORTED_MODULE_6__components_activityproductcard___default.a
  },

  props: ["message", "isOwn"],

  data: function data() {
    return {};
  },


  computed: {
    currentUser: function currentUser() {
      return this.$store.state.auth.user;
    },
    toLocalTimeString: function toLocalTimeString() {
      return __WEBPACK_IMPORTED_MODULE_4__helper__["f" /* Utils */].toLocalTimeString;
    },
    toLocalDateString: function toLocalDateString() {
      return __WEBPACK_IMPORTED_MODULE_4__helper__["f" /* Utils */].toLocalDateString;
    }
  },

  methods: {
    removeRepostRequest: function removeRepostRequest(message) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2__services_message__["a" /* default */].removeRepost(message.id).then(function (response) {
        _this.$store.dispatch("error/showSuccessToast", ["Removed a repost request!"]);
        _this.$emit("updated");
      }).catch(function (e) {
        _this.$store.dispatch("error/showErrorToast", e.body.errors || [e.body]);
      });
    },
    acceptRepostRequest: function acceptRepostRequest(message) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_2__services_message__["a" /* default */].acceptRepost(message.id).then(function (response) {
        _this2.$store.dispatch("error/showSuccessToast", ["Accepted a repost request!"]);
        _this2.$emit("updated");
      }).catch(function (e) {
        _this2.$store.dispatch("error/showErrorToast", e.body.errors || [e.body]);
      });
    },
    denyRepostRequest: function denyRepostRequest(message) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_2__services_message__["a" /* default */].denyRepost(message.id).then(function (response) {
        _this3.$store.dispatch("error/showErrorToast", ["Denied a repost request!"]);
        _this3.$emit("updated");
      }).catch(function (e) {
        _this3.$store.dispatch("error/showErrorToast", e.body.errors || [e.body]);
      });
    },
    acceptRepostRequestOnFree: function acceptRepostRequestOnFree(message) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_2__services_message__["a" /* default */].acceptRepostOnFree(message.id).then(function (response) {
        _this4.$store.dispatch("error/showSuccessToast", ["Accepted a repost request on free!"]);
        _this4.$emit("updated");
      }).catch(function (e) {
        _this4.$store.dispatch("error/showErrorToast", e.body.errors || [e.body]);
      });
    },


    // viewPendingCollaboration (message) {
    //   if (message.attachment.attachable_type == 'Album') {
    //     this.$store.dispatch('navigator/setCurrentState', {page: 'messages', tab: '', action: 'view_pending_collaboration'})
    //     this.$router.push({ path: '/albums' })
    //   } else if (message.attachment.attachable_type == 'ShopProduct') {
    //     this.$store.dispatch('navigator/setCurrentState', {page: 'messages', tab: '', action: 'view_pending_collaboration'})
    //     this.$router.push({ path: '/sell' })
    //   }
    // },

    // acceptCollaboration (message) {
    //   if (message.attachment.attachable_type == 'Album') {
    //     AlbumService.acceptCollaboration(message.attachment.assoc.id).then(response => {
    //       this.refreshMessages()
    //     })
    //   } else if (message.attachment.attachable_type == 'ShopProduct') {
    //     ProductService.acceptCollaboration(message.attachment.assoc.id).then(response => {
    //       this.refreshMessages()
    //     })
    //   }
    // },

    // denyCollaboration (message) {
    //   if (message.attachment.attachable_type == 'Album') {
    //     AlbumService.denyCollaboration(message.attachment.assoc.id).then(response => {
    //       this.refreshMessages()
    //     })
    //   } else if (message.attachment.attachable_type == 'ShopProduct') {
    //     ProductService.denyCollaboration(message.attachment.assoc.id).then(response => {
    //       this.refreshMessages()
    //     })
    //   }
    // },

    acceptLabelUser: function acceptLabelUser(message) {
      __WEBPACK_IMPORTED_MODULE_3__services_user__["a" /* default */].acceptLabelRequest(message.sender.id);
    },
    denyLabelUser: function denyLabelUser(message) {
      __WEBPACK_IMPORTED_MODULE_3__services_user__["a" /* default */].denyLabelRequest(message.sender.id);
    },
    acceptLabelAlbum: function acceptLabelAlbum(message) {
      var params = {
        label_id: message.sender.id
      };
      __WEBPACK_IMPORTED_MODULE_1__services_album__["a" /* default */].acceptLabelRequest(message.attachment.assoc.id, params);
    },
    denyLabelAlbum: function denyLabelAlbum(message) {
      var params = {
        label_id: message.sender.id
      };
      __WEBPACK_IMPORTED_MODULE_1__services_album__["a" /* default */].denyLabelRequest(message.attachment.assoc.id, params);
    },
    timePeriodFormat: function timePeriodFormat(date) {
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? '0' + minutes : minutes;
      var strTime = hours + ':' + minutes + ' ' + ampm;
      return strTime;
    }
  }
});

/***/ }),
/* 977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_numeral__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_numeral__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      default: true,
      ios: false,
      android: false
    };
  },

  methods: {
    showQR: function showQR(input) {
      input == "ios" ? this.ios = true : this.android = true;
    },
    reset: function reset() {
      this.ios = false;
      this.android = false;
    }
  }

});

/***/ }),
/* 978 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_auth__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_mobile_components_header__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_mobile_components_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__views_mobile_components_header__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    MobileHeader: __WEBPACK_IMPORTED_MODULE_1__views_mobile_components_header___default.a
  },

  data: function data() {
    return {
      loading: true,
      token: null,
      confirmed: false
    };
  },
  created: function created() {
    var _this = this;

    this.token = this.$route.params.token;

    var params = {
      confirmation_token: this.token
    };

    __WEBPACK_IMPORTED_MODULE_0__services_auth__["a" /* default */].activeAccount(params).then(function (response) {
      console.log('done');
      _this.confirmed = true;
      _this.loading = false;
    }).catch(function (e) {
      console.log('error', e.status, e);
      if (e.body.errors[0].detail === 'was already confirmed, please try signing in') {
        _this.confirmed = true;
        _this.loading = false;
      } else {
        _this.loading = false;
      }
    });
  },
  mounted: function mounted() {
    $('.sidebar').css('display', 'none');
    $('.mobile-header').css('display', 'none');
    setTimeout(function () {
      $('main').css('padding', 'unset');
    }, 0);
  },


  methods: {
    sendConfirmEmail: function sendConfirmEmail() {
      var _this2 = this;

      var params = {
        email: this.email
      };
      __WEBPACK_IMPORTED_MODULE_0__services_auth__["a" /* default */].sendConfirmEmail(params).then(function (response) {
        _this2.$store.dispatch('error/showSuccessToast', ['Resent a confirmation email']);
      }).catch(function (e) {
        _this2.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    }
  }
});

/***/ }),
/* 979 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_contentTopHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_contentTopHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_contentTopHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_footer__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_footer__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    pageMode: Boolean,
    setOnMobile: Boolean,
    hideFooter: Boolean,
    fromLanding: Boolean
  },
  components: {
    contentTopHeader: __WEBPACK_IMPORTED_MODULE_0__components_contentTopHeader___default.a,
    appFooter: __WEBPACK_IMPORTED_MODULE_1__components_footer___default.a
  },
  data: function data() {
    return {
      activeTab: "listener",
      tabs: [{ id: "listener", title: "Features for Everyone" }, { id: "creator", title: "For Creators" }],
      tile1: __webpack_require__(1544),
      tile2: __webpack_require__(1536),
      tile3: __webpack_require__(1537),
      tile4: __webpack_require__(1538),
      tile5: __webpack_require__(1539),
      tile6: __webpack_require__(1540),
      tile7: __webpack_require__(1541),
      tile8: __webpack_require__(1542),
      tile9: __webpack_require__(1543),
      iosStore: __webpack_require__(311),
      androidPlaystore: __webpack_require__(312)
    };
  },

  methods: {
    isActiveTab: function isActiveTab(tab) {
      return this.activeTab === tab;
    },
    onTab: function onTab(tab) {
      this.activeTab = tab;
    }
  },
  computed: {
    onMobile: function onMobile() {
      return this.setOnMobile || this.$vuetify.breakpoint.smAndDown;
    }
  }
});

/***/ }),
/* 980 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_auth__ = __webpack_require__(5);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      fullName: "",
      email: "",
      password: ""
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])({
    current: function current(state) {
      return state.app.onboarding.current;
    },
    getFullName: function getFullName(state) {
      return state.app.onboarding.fullName;
    },
    getEmail: function getEmail(state) {
      return state.app.onboarding.email;
    },
    getPassword: function getPassword(state) {
      return state.app.onboarding.password;
    }
  }), {
    checkDataEmpty: function checkDataEmpty() {
      return this.fullName == "" || this.email == "" || this.password == "";
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])({
    gotoNextStage: "app/nextOnboardingStage",
    gotoPrevStage: "app/prevOnboardingStage"
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["e" /* mapMutations */])({
    updateOnboarding: "app/updateOnboarding"
  }), {
    validated: function validated(toastStatus) {
      var _this = this;

      var skipToast = toastStatus === "skipToast";

      var fullName = this.fullName,
          email = this.email,
          password = this.password;

      var valEmail = this.validateEmail(email);
      var toValidate = [valEmail];

      var errors = ["Please enter a valid email address"];

      var isValid = toValidate.every(function (item, index) {
        if (!skipToast && !item) {
          _this.$store.dispatch("error/showErrorToast", [errors[index]]);
          return item;
        }
        return item;
      });
      return isValid;
    },
    validateEmail: function validateEmail(email) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
        return true;
      }
      return false;
    },
    validatePassword: function validatePassword(password) {
      if (/^(?=\S*[a-z])(?=\S*[A-Z])(?=\S*\d)(?=\S*([^\w\s]|[_]))\S{8,}$/.test(password)) {
        return true;
      }
      return false;
    },
    handleNextStage: function handleNextStage() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var isEmailAvailable, data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                isEmailAvailable = false;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4__services_auth__["a" /* default */].isEmailAvailable({ email: _this2.email }).then(function (res) {
                  isEmailAvailable = true;
                }).catch(function (e) {
                  _this2.$store.dispatch("error/showErrorToast", ["Email already exist"]);
                  isEmailAvailable = false;
                });

              case 3:

                if (_this2.validated() && isEmailAvailable) {
                  data = {
                    fullName: _this2.fullName,
                    first_name: _this2.fullName.split(" ").slice(0, 1).join(" "),
                    last_name: _this2.fullName.split(" ").slice(1, _this2.fullName.length).join(" "),
                    email: _this2.email,
                    password: _this2.password
                  };

                  _this2.updateOnboarding(data);

                  _this2.gotoNextStage(_this2.current + 1);
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    handlePrevStage: function handlePrevStage() {
      if (this.current !== 1) {
        this.gotoPrevStage(this.current - 1);
      }
    }
  }),
  created: function created() {
    this.fullName = this.getFullName;
    this.email = this.getEmail;
    this.password = this.getPassword;
  }
});

/***/ }),
/* 981 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_auth__ = __webpack_require__(5);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      accountType: "",
      username: ""
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])({
    current: function current(state) {
      return state.app.onboarding.current;
    },
    getAccountType: function getAccountType(state) {
      return state.app.onboarding.accountType;
    },
    getUsername: function getUsername(state) {
      return state.app.onboarding.username;
    }
  }), {
    accountTypes: function accountTypes() {
      var accountTypes = [];
      if (this.$store.state.app.onboarding.accountCategory === "creator") {
        accountTypes = [{
          id: "artist",
          title: "Artist",
          tags: "Bands, rappers, producers, podcasters + more"
        }, {
          id: "brand",
          title: "Brand",
          tags: "Clothing, record labels, lifestyle + more"
        }];
      } else {
        accountTypes = [{
          id: "listener",
          title: "Listener"
        }];
      }

      return accountTypes;
    },
    checkDataEmpty: function checkDataEmpty() {
      return this.accountType == "" || this.username == "";
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])({
    gotoNextStage: "app/nextOnboardingStage",
    gotoPrevStage: "app/prevOnboardingStage"
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["e" /* mapMutations */])({
    updateOnboarding: "app/updateOnboarding"
  }), {
    validated: function validated(toastStatus) {
      var _this = this;

      var skipToast = toastStatus === "skipToast";

      var accountType = this.accountType,
          username = this.username;

      var toValidate = [accountType, username];

      var errors = ["Please choose an account type", "Please enter a valid username"];

      var isValid = toValidate.every(function (item, index) {
        if (index == 1) {
          var regularExpression = /^[A-Za-z0-9_.]{3,20}$/;
          return regularExpression.test(item);
        }
        if (!skipToast && !item) {
          _this.$store.dispatch("error/showErrorToast", [errors[index]]);
          return item;
        }
        return item;
      });

      return isValid;
    },
    selectedAccount: function selectedAccount(account) {
      this.accountType = account;
    },
    handleNextStage: function handleNextStage() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var isUsernameAvailable, regularExpression, data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                isUsernameAvailable = false;
                regularExpression = /^[A-Za-z0-9_.]{3,20}$/;

                if (!(_this2.username == "" || !regularExpression.test(_this2.username))) {
                  _context.next = 6;
                  break;
                }

                _this2.$store.dispatch("error/showErrorToast", ["Username must be between 3 to 20 characters without special characters in it"]);
                _context.next = 8;
                break;

              case 6:
                _context.next = 8;
                return __WEBPACK_IMPORTED_MODULE_4__services_auth__["a" /* default */].isUsernameAvailable({ username: _this2.username }).then(function (res) {
                  isUsernameAvailable = true;
                }).catch(function (e) {
                  _this2.$store.dispatch("error/showErrorToast", ["Username already exist"]);
                  isUsernameAvailable = false;
                });

              case 8:

                if (_this2.validated() && isUsernameAvailable) {
                  data = {
                    accountType: _this2.accountType,
                    user_type: _this2.accountType.id,
                    username: _this2.username
                  };

                  _this2.updateOnboarding(data);

                  _this2.gotoNextStage(_this2.current + 1);
                }

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    handlePrevStage: function handlePrevStage() {
      if (this.current !== 1) {
        this.gotoPrevStage(this.current - 1);
      }
    }
  }),
  created: function created() {
    this.accountType = this.getAccountType;
    this.username = this.getUsername;
  },
  mounted: function mounted() {
    if (this.$store.state.app.onboarding.accountCategory === "listener") {
      this.accountType = {
        id: "listener",
        title: "Listener"
      };
    }
  }
});

/***/ }),
/* 982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_autocomplete_vue__ = __webpack_require__(1574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_autocomplete_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_autocomplete_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_button__ = __webpack_require__(1880);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    autocomplete: __WEBPACK_IMPORTED_MODULE_3__components_autocomplete_vue___default.a,
    VueLoadingButton: __WEBPACK_IMPORTED_MODULE_5_vue_loading_button__["a" /* default */]
  },
  data: function data() {
    return {
      isLoading: false,
      ageRange: null,
      ageGroups: [{
        id: 1,
        title: "14-21"
      }, {
        id: 2,
        title: "22-34"
      }, {
        id: 3,
        title: "35-49"
      }, {
        id: 4,
        title: "50-85+"
      }],
      country: "",
      city: "",
      cityAutoActive: false,
      proceedToCities: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])({
    current: function current(state) {
      return state.app.onboarding.current;
    },
    countries: function countries(state) {
      return state.app.countries;
    },
    cities: function cities(state) {
      return state.app.cities;
    },
    getAgeRange: function getAgeRange(state) {
      return state.app.onboarding.ageRange;
    },
    getCountry: function getCountry(state) {
      return state.app.onboarding.country;
    },
    getCity: function getCity(state) {
      return state.app.onboarding.city;
    }
  }), {
    getCountryList: function getCountryList() {
      var _this = this;

      var getCountries = this.countries.map(function (c) {
        return c.country;
      });
      var countries = getCountries.filter(function (country) {
        if (country.toLowerCase().includes(_this.country.toLowerCase())) {
          return country;
        }
      });

      return countries;
    },
    getCityList: function getCityList() {
      var _this2 = this;

      var cities = this.cities.filter(function (city) {
        if (city.toLowerCase().includes(_this2.city.toLowerCase())) {
          return city;
        }
      });

      return cities;
    },
    checkDataEmpty: function checkDataEmpty() {
      return this.ageRange == null || this.country == "" || this.city == "";
    }
  }),
  watch: {
    country: function country() {
      this.proceedToCities = false;
    },
    proceedToCities: function proceedToCities(val) {
      if (val) {
        this.getCities(this.country);
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])({
    getCountries: "app/getCountries",
    getCities: "app/getCities",
    gotoNextStage: "app/nextOnboardingStage",
    gotoPrevStage: "app/prevOnboardingStage"
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["e" /* mapMutations */])({
    updateOnboarding: "app/updateOnboarding"
  }), {
    validated: function validated(toastStatus) {
      var _this3 = this;

      var skipToast = toastStatus === "skipToast";

      var ageRange = this.ageRange,
          country = this.country,
          city = this.city;

      var valCountry = this.getCountryList.includes(country);
      var valCity = this.getCityList.includes(city);
      var toValidate = [ageRange, valCountry, valCity];

      var errors = ["Please choose an age range", "Please select a valid country from list", "Please select a valid city from list"];

      var isValid = toValidate.every(function (item, index) {
        if (!skipToast && !item) {
          _this3.$store.dispatch("error/showErrorToast", [errors[index]]);
          return item;
        }
        return item;
      });
      return isValid;
    },
    selectAgeRange: function selectAgeRange(age) {
      this.ageRange = age.title;
    },
    selected: function selected(identifier, option) {
      var _this4 = this;

      switch (identifier) {
        case "country":
          this.country = option;
          this.city = "";

          // Bug: had to combine bothe false instance
          this.proceedToCities = true;
          this.$nextTick(function () {
            _this4.proceedToCities = true;
          });
          break;
        case "city":
          this.city = option;
          break;
        default:
          break;
      }
    },
    handleNextStage: function handleNextStage() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data, user_params;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this5.validated()) {
                  data = {
                    age_group: _this5.ageRange,
                    country: _this5.country,
                    city: _this5.city
                  };

                  _this5.updateOnboarding(data);
                  user_params = _this5.$store.state.app.onboarding;

                  _this5.gotoNextStage(_this5.current + 1);
                }

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this5);
      }))();
    },
    handlePrevStage: function handlePrevStage() {
      if (this.current !== 1) {
        this.gotoPrevStage(this.current - 1);
      }
    },
    handleClick: function handleClick() {
      if (this.validated()) {
        this.isLoading = true;
        this.$store.dispatch("error/showLoadingActivity", true);
      }
    }
  }),
  created: function created() {
    this.getCountries();

    this.ageRange = this.getAgeRange;
    this.country = this.getCountry;
    this.city = this.getCity;
  }
});

/***/ }),
/* 983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_paymentCard_index__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_paymentCard_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_paymentCard_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_paymentCard_paymentSuccess__ = __webpack_require__(1590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_paymentCard_paymentSuccess___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_paymentCard_paymentSuccess__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_user_js__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    PaymentCard: __WEBPACK_IMPORTED_MODULE_1__components_paymentCard_index___default.a,
    PaymentSuccess: __WEBPACK_IMPORTED_MODULE_2__components_paymentCard_paymentSuccess___default.a
  },
  data: function data() {
    return {
      initPayment: false,
      selectedPlan: {},
      accountCategory: "",
      artist_plans: [{
        id: "free",
        title: "Free",
        price: 0,
        list: []
      }, {
        id: "standard",
        title: "Standard",
        price: 29,
        list: ["All access / No Ads", "Sell products & keep 100%", "Share to Earn $2/month / person", "Upload music, videos, PPV", "Collections & playlists", "Offline listening"]
      }, {
        id: "business",
        title: "Business",
        price: 299,
        list: ["All access / No Ads", "Sell products & keep 100%", "Share to Earn $2/month / person", "Upload music, videos, PPV", "Collections & playlists", "Offline listening"]
      }],
      listener_plans: [{
        id: "free",
        title: "Free",
        price: 0,
        list: []
      }, {
        id: "listener",
        title: "Listener",
        price: 12,
        list: ["All access / No Ads", "Collections & playlists", "Offline listening", "Share to earn $2.month/person"]
      }, {
        id: "vip",
        title: "VIP",
        price: 48,
        list: ["All access / No Ads", "Collections & playlists", "Offline listening", "Share to earn $2.month/person"]
      }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])({
    plansData: function plansData(state) {
      return state.app.plansData;
    },
    current: function current(state) {
      return state.app.onboarding.current;
    },
    getAccountCategory: function getAccountCategory(state) {
      return state.app.onboarding.accountCategory;
    }
  }), {
    plans: function plans() {
      return this.plansData.filter(function (plan) {
        return plan.id != "basic";
      });
    },
    totalPayable: function totalPayable() {
      var fee = parseFloat(this.selectedPlan.price);
      var subFee = __WEBPACK_IMPORTED_MODULE_4__helper__["d" /* Stripe */].calculateSubFee(this.selectedPlan.price);

      var total = parseFloat(subFee) + parseFloat(fee);
      total = parseFloat(total.toFixed(2));

      return total;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])({
    gotoNextStage: "app/nextOnboardingStage"
  }), {
    makeListener: function makeListener() {
      var _this = this;

      var params = { id: this.$store.state.app.onboarding.username };
      __WEBPACK_IMPORTED_MODULE_5__services_user_js__["a" /* default */].changeCreatorRoleIntoListener(params).then(function (response) {
        _this.$store.dispatch("error/showSuccessToast", [response.bodyText]);
      }).catch(function (e) {
        _this.$store.dispatch("error/showErrorToast", ["There was an error on updating user role."]);
      });

      this.handleNextStage();
    },
    handleNextStage: function handleNextStage() {
      this.gotoNextStage(this.current + 1);
    },
    selectplanTab: function selectplanTab(plan) {
      this.selectedPlan = plan;
    },
    openPaymentSuccess: function openPaymentSuccess() {
      this.$refs.paymentSuccess.openPaymentSuccess();
    }
  }),
  created: function created() {
    this.accountCategory = this.getAccountCategory;
  },
  mounted: function mounted() {
    this.openPaymentSuccess();
    if (this.accountCategory == "creator") {
      this.selectedPlan = this.artist_plans[0];
    } else {
      this.selectedPlan = this.listener_plans[0];
    }
  }
});

/***/ }),
/* 984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_auth__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      initAppDownload: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])({
    current: function current(state) {
      return state.app.onboarding.current;
    },
    userEmail: function userEmail(state) {
      return state.app.onboarding.email;
    }
  })),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])({
    gotoNextStage: "app/nextOnboardingStage",
    gotoPrevStage: "app/prevOnboardingStage"
  }), {
    handleNextStage: function handleNextStage() {
      this.gotoNextStage(this.current + 1);
    },
    handlePrevStage: function handlePrevStage() {
      if (this.current !== 1) {
        this.gotoPrevStage(this.current - 1);
      }
    },
    sendConfirmEmail: function sendConfirmEmail() {
      var _this = this;

      var params = {
        email: this.userEmail
      };
      __WEBPACK_IMPORTED_MODULE_2__services_auth__["a" /* default */].sendConfirmEmail(params).then(function (response) {
        _this.$store.dispatch("error/showSuccessToast", ["Resent a confirmation email"]);
      }).catch(function (e) {
        _this.$store.dispatch("error/showErrorToast", e.body.errors || [e.body]);
      });
    }
  }),
  created: function created() {
    document.getElementById('signup-back-button').remove();
    // this.sendConfirmEmail();
  },
  mounted: function mounted() {
    $(".bg-natural-grey").removeClass("bg-natural-grey");
  }
});

/***/ }),
/* 985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      accountCategory: "",
      forceShowNextIcon: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])({
    current: function current(state) {
      return state.app.onboarding.current;
    },
    getAccountCategory: function getAccountCategory(state) {
      return state.app.onboarding.accountCategory;
    }
  }), {
    validated: function validated() {
      var accountCategory = this.accountCategory;

      var toValidate = [accountCategory];

      var isValid = toValidate.every(function (item) {
        return item;
      });
      return isValid;
    },
    checkDataEmpty: function checkDataEmpty() {
      return this.accountCategory == "";
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])({
    gotoNextStage: "app/nextOnboardingStage",
    gotoPrevStage: "app/prevOnboardingStage"
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["e" /* mapMutations */])({
    updateOnboarding: "app/updateOnboarding"
  }), {
    chooseAccount: function chooseAccount(category) {
      this.accountCategory = category;
      this.forceShowNextIcon = true;

      if (this.validated) {
        var data = {
          accountCategory: this.accountCategory
        };
        this.updateOnboarding(data);
      }
    },
    handleNextStage: function handleNextStage() {
      if (this.validated) {
        var data = {
          accountCategory: this.accountCategory
        };
        this.updateOnboarding(data);
        return this.gotoNextStage(this.current + 1);
      }
    }
  }),
  created: function created() {
    this.accountCategory = this.getAccountCategory;
  }
});

/***/ }),
/* 986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])({
    userEmail: function userEmail(state) {
      return state.app.onboarding.email;
    }
  }))
});

/***/ }),
/* 987 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_auth__ = __webpack_require__(5);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isLoading: false,
      socialChannel: "",
      socialUsername: "@"
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])({
    current: function current(state) {
      return state.app.onboarding.current;
    },
    getSocialChannel: function getSocialChannel(state) {
      return state.app.onboarding.social_provider;
    },
    getSocialUsername: function getSocialUsername(state) {
      return state.app.onboarding.social_user_name;
    }
  }), {
    socialChannels: function socialChannels() {
      return [{
        title: "Instagram",
        id: "instagram"
      }, {
        title: "Tik Tok",
        id: "tiktok"
      }, {
        title: "Facebook",
        id: "facebook"
      }, {
        title: "Twitter",
        id: "twitter"
      }];
    },
    checkDataEmpty: function checkDataEmpty() {
      return this.socialChannel == "" || this.socialUsername == "@";
    }
  }),
  watch: {
    socialUsername: function socialUsername(val) {
      if (val.length < 2) {
        this.socialUsername = "@";
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])({
    gotoNextStage: "app/nextOnboardingStage",
    gotoPrevStage: "app/prevOnboardingStage"
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["e" /* mapMutations */])({
    updateOnboarding: "app/updateOnboarding"
  }), {
    validated: function validated(toastStatus) {
      var _this = this;

      var skipToast = toastStatus === "skipToast";

      var socialChannel = this.socialChannel,
          socialUsername = this.socialUsername;

      var valSocialUsername = socialUsername.length > 1;
      var toValidate = [socialChannel, valSocialUsername];

      var errors = ["Please choose a social channel", "Please enter a valid social handle"];

      var isValid = toValidate.every(function (item, index) {
        if (!skipToast && !item) {
          _this.$store.dispatch("error/showErrorToast", [errors[index]]);
          return item;
        }
        return item;
      });
      return isValid;
    },
    selectedChannel: function selectedChannel(channel) {
      this.socialChannel = channel;
    },
    handleNextStage: function handleNextStage() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data, user_params, formData;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.handleClick();

                if (!_this2.validated()) {
                  _context.next = 27;
                  break;
                }

                data = {
                  social_provider: _this2.socialChannel.title,
                  social_user_name: _this2.socialUsername
                };

                _this2.updateOnboarding(data);
                user_params = _this2.$store.state.app.onboarding;
                formData = new FormData();


                formData.append("user[email]", user_params.email);
                formData.append("user[password]", user_params.password);
                formData.append("user[username]", user_params.username);
                formData.append("user[display_name]", user_params.fullName);
                formData.append("user[avatar]", user_params.avatar);
                formData.append("user[first_name]", user_params.first_name);
                formData.append("user[last_name]", user_params.last_name);
                formData.append("user[country]", user_params.country);
                formData.append("user[city]", user_params.city);
                formData.append("user[age_group]", user_params.age_group);
                formData.append("user[social_provider]", user_params.social_provider);
                formData.append("user[social_user_id]", user_params.social_user_name);
                formData.append("user[user_type]", user_params.user_type);
                formData.append("user[initial_signup_type]", user_params.user_type);

                if (!(user_params.accountCategory === "listener")) {
                  _context.next = 25;
                  break;
                }

                _context.next = 23;
                return __WEBPACK_IMPORTED_MODULE_4__services_auth__["a" /* default */].registerAsListener(formData).then(function (response) {
                  _this2.updateOnboarding(data);
                  _this2.gotoNextStage(_this2.current + 1);
                }).catch(function (e) {
                  _this2.$store.dispatch("error/showErrorToast", e.body.errors);
                });

              case 23:
                _context.next = 27;
                break;

              case 25:
                _context.next = 27;
                return __WEBPACK_IMPORTED_MODULE_4__services_auth__["a" /* default */].registerAsArtist(formData).then(function (response) {
                  _this2.gotoNextStage(_this2.current + 1);
                }).catch(function (e) {
                  _this2.$store.dispatch("error/showErrorToast", e.body.errors);
                });

              case 27:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    handlePrevStage: function handlePrevStage() {
      if (this.current !== 1) {
        this.gotoPrevStage(this.current - 1);
      }
    },
    handleClick: function handleClick() {
      var _this3 = this;

      if (this.validated()) {
        this.isLoading = true;
        this.$store.dispatch("error/showLoadingActivity", true).catch(function (e) {
          _this3.$store.dispatch("error/showErrorToast", e.body.errors);
        });
      }
    }
  }),
  created: function created() {
    this.socialChannel = this.getSocialChannel;
    this.social_user_name = this.getsocial_user_name;
  }
});

/***/ }),
/* 988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      profileImage: ""
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])({
    current: function current(state) {
      return state.app.onboarding.current;
    },
    getProfileImage: function getProfileImage(state) {
      return state.app.onboarding.profileImage;
    }
  }), {
    pickerImg: function pickerImg() {
      return __webpack_require__(1455);
    },
    checkDataEmpty: function checkDataEmpty() {
      return this.profileImage == "";
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])({
    gotoNextStage: "app/nextOnboardingStage",
    gotoPrevStage: "app/prevOnboardingStage"
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["e" /* mapMutations */])({
    updateOnboarding: "app/updateOnboarding"
  }), {
    validated: function validated(toastStatus) {
      var _this = this;

      var skipToast = toastStatus === "skipToast";

      var profileImage = this.profileImage;

      var toValidate = [profileImage];

      var errors = ["Please upload a valid profile image"];

      var isValid = toValidate.every(function (item, index) {
        if (!skipToast && !item) {
          _this.$store.dispatch("error/showErrorToast", [errors[index]]);
          return item;
        }
        return item;
      });
      return isValid;
    },
    imageChanged: function imageChanged(e) {
      var _this2 = this;

      if (e.target.files[0].size > 2097152) {
        this.$store.dispatch("error/showErrorToast", ["You can upload an image 2MB in maximum"]);
        return;
      }

      this.avatar = e.target.files[0];
      var reader = new FileReader();
      reader.addEventListener("load", function (event) {
        _this2.profileImage = event.target.result;
      }, false);
      reader.readAsDataURL(this.avatar);
    },
    handleNextStage: function handleNextStage() {
      if (this.validated()) {
        var data = {
          profileImage: this.profileImage,
          avatar: this.avatar
        };

        this.updateOnboarding(data);
        this.gotoNextStage(this.current + 1);
      }
    },
    handlePrevStage: function handlePrevStage() {
      if (this.current !== 1) {
        this.gotoPrevStage(this.current - 1);
      }
    }
  }),
  created: function created() {
    this.profileImage = this.getProfileImage;
  }
});

/***/ }),
/* 989 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    staging: {
      type: String,
      required: true
    },
    ownCurrent: Number,
    ownStages: Array
  },
  data: function data() {
    return {
      current: 1,
      stages: [],
      currentStage: {}
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    onboardingStages: "app/onboardingStages",
    onboardingCurrentStage: "app/onboardingCurrentStage",
    activationStages: "app/activationStages",
    activationCurrentStage: "app/activationCurrentStage"
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])({
    onboardingCurrent: function onboardingCurrent(state) {
      return state.app.onboarding.current;
    }
  }), {
    hideStagerBar: function hideStagerBar() {
      return !this.onboardingCurrentStage.hideStagerBar;
    },
    hideStagerTitle: function hideStagerTitle() {
      return !this.onboardingCurrentStage.hideStagerBar;
    },
    onMobile: function onMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    }
  }),
  watch: {
    onboardingCurrent: function onboardingCurrent(val) {
      this.current = val;
      this.stages = this.onboardingStages;
      this.currentStage = this.onboardingCurrentStage;
    },

    ownCurrent: {
      handler: function handler(val) {
        switch (this.staging) {
          case "onboarding":
            break;
          case "activation":
            this.current = val;
            this.stages = this.activationStages;
            this.currentStage = this.activationCurrentStage;
            break;
          default:
            break;
        }
      },

      immediate: true
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])({
    nextActivationStage: "app/nextActivationStage",
    prevActivationStage: "app/prevActivationStage"
  }), {
    handleCTA: function handleCTA(action) {
      switch (action) {
        case "next":
          if (this.staging == "activation") {
            return this.$emit("updateCurrent", this.current + 1);
          }

          break;

        default:
          break;
      }
    },
    initStaging: function initStaging() {
      switch (this.staging) {
        case "onboarding":
          this.current = this.$store.state.app.onboarding.current;
          this.stages = this.onboardingStages;
          this.currentStage = this.onboardingCurrentStage;
          break;
        case "activation":
          this.current = this.ownCurrent;
          this.stages = this.activationStages;
          this.currentStage = this.activationCurrentStage;
          break;
        default:
          break;
      }
    }
  }),
  created: function created() {
    this.initStaging();
  }
});

/***/ }),
/* 990 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_trackcardsimple__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_trackcardsimple___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_trackcardsimple__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    customDirectory: Array,
    isComp: Boolean,
    height: [String, Number],
    separator: Boolean
  },
  components: { trackcardsimple: __WEBPACK_IMPORTED_MODULE_0__components_trackcardsimple___default.a },
  data: function data() {
    return {
      directory: []
    };
  },

  methods: {
    closeDirectory: function closeDirectory() {
      this.$emit("closeDirectory");
    }
  },
  computed: {
    directoryLen: function directoryLen() {
      return 200;
    }
  }
});

/***/ }),
/* 991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      footers: [{
        id: 'discover',
        title: 'discover',
        icon: __webpack_require__(593),
        activeIcon: __webpack_require__(593),
        path: 'AlbumIndex',
        isNotificationActive: false
      }, {
        id: 'home',
        title: 'home',
        icon: __webpack_require__(1460),
        activeIcon: __webpack_require__(1461),
        path: 'Feed',
        isNotificationActive: false
      }, {
        id: 'messages',
        title: 'messages',
        icon: __webpack_require__(1444),
        activeIcon: __webpack_require__(1445),
        path: 'Messages',
        isNotificationActive: false
      }],
      notificationIcon: __webpack_require__(1526)
    };
  },

  watch: {
    isUnreadActivity: {
      handler: function handler(val) {
        if (val == true) {
          this.footers = this.footers.map(function (f) {
            if (f.id == 'notification') {
              f.isNotificationActive = true;
            }
            return f;
          });
        }
      },

      immediate: true
    },
    isUnreadMessages: {
      handler: function handler(val) {
        if (val == true) {
          this.footers = this.footers.map(function (f) {
            if (f.id == 'messages') {
              f.isNotificationActive = true;
            }
          });
        }
      },

      immediate: true
    }
  },
  computed: {
    badge: function badge() {
      return this.$store.state.activity.badge;
    },
    isUnreadActivity: function isUnreadActivity() {
      return this.badge.activity > 0;
    },
    isUnreadMessages: function isUnreadMessages() {
      return this.badge.message > 0;
    },
    currentRoute: function currentRoute() {
      return this.$route.name;
    }
  }
});

/***/ }),
/* 992 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_user_tag__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_user_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_user_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_mobile_components_search__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_mobile_components_search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_mobile_components_search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(6);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    hideUser: {
      type: Boolean,
      default: false
    },
    showMenu: {
      type: Boolean,
      default: true
    },

    leftAltIcon: {
      type: String,
      default: '/static/images/search.svg'
    },
    rightAltIcon: {
      type: String,
      default: '/static/images/graph-bar.svg'
    },
    closeCallBack: Object,
    centerImg: String,
    menuImg: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'dark'
    }
  },
  components: {
    userTag: __WEBPACK_IMPORTED_MODULE_1__components_user_tag___default.a,
    Search: __WEBPACK_IMPORTED_MODULE_2__views_mobile_components_search___default.a
  },
  data: function data() {
    return {
      // logoImgSrc: '',
      avatarWidth: 30,
      avatarHeight: 30,
      searchModalActive: false
      // menuImgSrc: '',
    };
  },

  watch: {},
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])({
    toggleMobilePlayer: "player/toggleMobilePlayer"
  }), {
    openSearchModal: function openSearchModal() {
      this.searchModalActive = true;
    },
    closeSearchModal: function closeSearchModal() {
      this.searchModalActive = false;
    },
    openMusicPlayer: function openMusicPlayer() {
      this.toggleMobilePlayer(true);
    },
    goBack: function goBack() {
      if (this.$route.name == 'AlbumDetail') {
        var prev = this.albumPrevRoute;

        return this.$router.push({ name: prev });
      }

      var senderRoute = this.senderRoute;
      var referrer = document.referrer;
      var prevRoute = referrer.split('://')[1].split('/')[1] || '';

      console.log({ referrer: referrer, prevRoute: prevRoute, senderRoute: senderRoute });

      switch (senderRoute) {
        case 'video':
        case 'music':
        case 'product':
          return this.$router.push({ name: 'AlbumIndex', params: { activeDiscover: senderRoute } });
        default:
          return this.$router.go(-1);
      }
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])({
    isAuthenticated: "auth/isAuthenticated"
  }), {
    isPlaying: function isPlaying() {
      var isPlaying = this.$store.state.player.isPlaying && !this.$store.state.player.isPaused;

      return isPlaying;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])({
    albumPrevRoute: function albumPrevRoute(state) {
      return state.appMobile.albumPrevRoute;
    }
  }), {
    appLogo: function appLogo() {
      return '/static/images/nav_logo_primary.png';
    },
    currentUser: function currentUser() {
      return this.$store.state.auth.user;
    },
    isDarkTheme: function isDarkTheme() {
      return this.theme === 'dark';
    },
    isModalComp: function isModalComp() {
      return this.$route.meta.isModalComp;
    },
    showModalCompLeftIcon: function showModalCompLeftIcon() {
      return this.$route.meta.showModalCompLeftIcon;
    },
    showRightAltIcon: function showRightAltIcon() {
      return this.$route.meta.showRightAltIcon;
    },
    senderRoute: function senderRoute() {
      return this.$route.meta.senderRoute;
    },
    showGoBack: function showGoBack() {
      return this.$route.meta.showGoBack;
    },
    onProfilePage: function onProfilePage() {
      return this.$route.name === "UserProfile";
    }
  }),

  created: function created() {}
});

/***/ }),
/* 993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_comment__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_chat__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_chat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_chat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_user_tag__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_user_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_user_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_commentInput__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_commentInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_commentInput__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    comments: Array,
    item: Object,
    roundAvatar: Boolean,
    roundInput: Boolean,
    noBorder: Boolean,
    placeholder: String,
    aviHeight: {
      type: [String, Number]
    },
    aviWidth: {
      type: [String, Number]
    },
    hideComments: Boolean,
    hideCommentCount: Boolean
  },
  components: {
    Chat: __WEBPACK_IMPORTED_MODULE_1__components_chat___default.a,
    UserTag: __WEBPACK_IMPORTED_MODULE_2__components_user_tag___default.a,
    commentInput: __WEBPACK_IMPORTED_MODULE_3__components_commentInput___default.a
  },
  data: function data() {
    return {
      commentText: '',
      initComment: false
    };
  },

  computed: {
    currentUser: function currentUser() {
      return this.$store.state.auth.user;
    },
    isAssocPassed: function isAssocPassed() {
      return this.$slots._assoc;
    }
  },
  methods: {
    closeCommentDialog: function closeCommentDialog() {
      this.initComment = false;

      this.$emit('comment-closed');
    },
    showComments: function showComments(val) {
      console.log(val);
      // this fn is called via component's ref
      this.initComment = val;
    },
    addComment: function addComment() {
      var _this = this;

      if (this.commentText === '') return;

      var params = {
        comment: {
          commentable_type: 'Stream',
          commentable_id: this.item.id,
          body: this.commentText,
          status: 'published'
        }
      };

      __WEBPACK_IMPORTED_MODULE_0__services_comment__["a" /* default */].sendComment(params).then(function (res) {
        _this.comments.unshift(res.body);
        _this.commentText = '';
      }).catch(function (e) {
        _this.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    }
  }
});

/***/ }),
/* 994 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_search__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_user_tag__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_user_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_user_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_userFollowBtn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_userFollowBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_userFollowBtn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_trackcardsimple__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_trackcardsimple___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_trackcardsimple__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_video_box__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_video_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_video_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_productcard__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_productcard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_productcard__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    UserTag: __WEBPACK_IMPORTED_MODULE_1__components_user_tag___default.a,
    UserFollowBtn: __WEBPACK_IMPORTED_MODULE_2__components_userFollowBtn___default.a,
    trackcardsimple: __WEBPACK_IMPORTED_MODULE_3__components_trackcardsimple___default.a,
    VideoBox: __WEBPACK_IMPORTED_MODULE_4__components_video_box___default.a,
    productCard: __WEBPACK_IMPORTED_MODULE_5__components_productcard___default.a
  },
  data: function data() {
    return {
      searchQuery: "",
      searchDone: false,
      searchSuccessful: false,
      searchFailed: false,
      isSearchLoading: false,
      results: {
        users: [],
        albums: [],
        streams: [],
        products: []
      }
    };
  },

  methods: {
    initSearch: function initSearch() {
      var _this = this;

      if (!this.searchQuery) return;

      this.isSearchLoading = true;

      __WEBPACK_IMPORTED_MODULE_0__services_search__["a" /* default */].searchGlobal({ q: this.searchQuery }).then(function (response) {
        _this.searchSuccessful = true;
        _this.results = response.body;
      }).catch(function (e) {
        _this.searchFailed = true;
        _this.$store.dispatch('error/showErrorToast', ["There was a problem completing search"]);
      }).finally(function () {
        _this.searchDone = true;
        _this.isSearchLoading = false;
      });
    },
    resetSearch: function resetSearch() {
      this.searchDone = false;
      this.searchSuccessful = false;
      this.searchFailed = false;
      this.searchQuery = "";
      this.results = [];
    },
    closeSearchModal: function closeSearchModal() {
      this.$emit("closeSearchModal");
      this.resetSearch();
    }
  },
  computed: {
    usersResults: function usersResults() {
      return this.results.users;
    },
    albumResults: function albumResults() {
      return this.results.albums;
    },
    videoResults: function videoResults() {
      return this.results.streams;
    },
    productResults: function productResults() {
      return this.results.products;
    }
  },
  created: function created() {
    this.$store.dispatch("error/showLoadingActivity", true);
  }
});

/***/ }),
/* 995 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_itemTab__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_itemTab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_itemTab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_trackcard__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_trackcard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_trackcard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_search__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vue_runtime_dom__ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(6);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    title: {
      type: String,
      default: "Curated Music"
    },
    listLimit: Number,
    classAttr: {
      type: String,
      default: "xs6 md6"
    },
    hideTrackLength: Boolean,
    noAction: Boolean,
    noMeta: Boolean,
    hideCta: Boolean,
    showHoverTrackInfo: Boolean,
    playButton2: Boolean,
    playButton2IconHasWhiteBG: Boolean
  },
  components: {
    itemTab: __WEBPACK_IMPORTED_MODULE_2__components_itemTab___default.a,
    trackCard: __WEBPACK_IMPORTED_MODULE_3__components_trackcard___default.a
  },
  data: function data() {
    return {
      selected_genre: null,
      page_index: 1,
      total_pages: 1,
      genres: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapState */])({
    musicFeed: function musicFeed(state) {
      return state.trending.albums;
    }
  }), {
    items_per_page: function items_per_page() {
      return 1 * this.listLimit || 50;
    },
    musicFeed1: function musicFeed1() {
      // console.log('albums: ', this.musicFeed);
      var split = this.musicFeed.slice(0, this.musicFeed.length / 2);
      return split;
    },
    musicFeed2: function musicFeed2() {
      var split = this.musicFeed.slice(this.musicFeed.length / 2, this.musicFeed.length);
      return split;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapActions */])({
    getTrendingMusic: "trending/getTrendingMusic"
  }), {
    loadTrendingMusic: function loadTrendingMusic() {
      if (this.musicFeed.length) return;

      var params = {
        filter: "new",
        genre: "any",
        category: "any",
        page: 1,
        per_page: this.items_per_page
      };

      this.getTrendingMusic(params);
    },
    loadFeeds: function loadFeeds(tab, page) {
      var _this = this;

      var vm = this;
      if (page === 1) {
        this.isPageReady = false;
      }
      this.$store.dispatch("error/showLoadingActivity", true);
      var genre = _.get(this.selected_genre, "id", "any");
      var category = _.get(this.selected_category, "id", "any");
      var params = {
        filter: tab,
        genre: genre,
        category: category,
        page: page,
        per_page: this.items_per_page
      };
      if (tab !== "recommended") {
        params["seed"] = this.seed;
      }
      __WEBPACK_IMPORTED_MODULE_4__services_search__["a" /* default */].searchDiscoverPublicUser(params).then(function (response) {
        vm.$store.dispatch("error/showLoadingActivity", false);
        var musicFeed = vm.musicFeed.concat(response.body.albums);
        var genres = _.chain(musicFeed).map("genres").flatMap().keyBy("id").map(function (v, k) {
          return v;
        }).sortBy("name").value();
        __WEBPACK_IMPORTED_MODULE_5__vue_runtime_dom__["a" /* vModelCheckbox */].genres = [
        // { id: 'go_to_filters', name: 'Set Genre Filters' },
        { id: "any", name: "All" }].concat(genres);
        vm.page_index = response.body.pagination.current_page;
        vm.total_pages = response.body.pagination.total_pages;

        if (page === 0) {
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_4__services_search__["a" /* default */].searchDiscoverPublicUser(_.extend(params, { page: 2 })), __WEBPACK_IMPORTED_MODULE_4__services_search__["a" /* default */].searchDiscoverPublicUser(_.extend(params, { page: 3 })), __WEBPACK_IMPORTED_MODULE_4__services_search__["a" /* default */].searchDiscoverPublicUser(_.extend(params, { page: 4 }))]).then(function (values) {
            var musicFeed = vm.musicFeed.concat(values[0].body.albums, values[1].body.albums, values[2].body.albums);
            var genres = _.chain(musicFeed).map("genres").flatMap().keyBy("id").map(function (v, k) {
              return v;
            }).sortBy("name").value();
            vm.genres = [{ id: "any", name: "All" }].concat(genres);
            vm.page_index = values[2].body.pagination.total_pages > 4 ? 4 : values[2].body.pagination.total_pages;
            vm.isPageReady = true;
          });
        }
      }).catch(function (e) {
        _this.$store.dispatch("error/showLoadingActivity", false);
        // this.$store.dispatch('error/showErrorToast', e.body.errors || [e.body])
        console.log("discover error", e);
      });
    }
  }),
  created: function created() {
    // needs to be updated to trending
    this.loadFeeds("trending", 0);

    this.loadTrendingMusic();
  }
});

/***/ }),
/* 996 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_itemTab__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_itemTab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_itemTab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_productcard__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_productcard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_productcard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(6);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    title: {
      type: String,
      default: "Exclusive Drops"
    },
    listLimit: Number,
    classAttr: {
      type: String,
      default: "xs6 md6"
    },
    hideCta: Boolean,
    altMeta: Boolean,
    showFullOverlay: Boolean
  },
  components: {
    itemTab: __WEBPACK_IMPORTED_MODULE_2__components_itemTab___default.a,
    productCard: __WEBPACK_IMPORTED_MODULE_3__components_productcard___default.a
  },
  data: function data() {
    return {
      selected_genre: null,
      page_index: 1,
      total_pages: 1,
      genres: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])({
    productFeed: function productFeed(state) {
      return state.trending.products;
    }
  }), {
    items_per_page: function items_per_page() {
      return 1 * this.listLimit || 50;
    },
    productFeed1: function productFeed1() {
      var split = this.productFeed.slice(0, this.productFeed.length / 2);
      return split;
    },
    productFeed2: function productFeed2() {
      var split = this.productFeed.slice(this.productFeed.length / 2, this.productFeed.length);
      return split;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])({
    getTrendingProducts: "trending/getTrendingProducts"
  }), {
    loadTrendingProducts: function loadTrendingProducts() {
      // if (this.productFeed.length) return;

      var params = {
        genre: "any",
        category: "any",
        page: 1,
        per_page: this.items_per_page,
        seed: this.seed
      };

      this.getTrendingProducts(params);
    },
    loadFeeds: function loadFeeds(page) {
      var _this = this;

      var vm = this;
      if (page === 1) {
        this.isPageReady = false;
      }
      this.$store.dispatch("error/showLoadingActivity", true);
      var genre = _.get(this.selected_genre, "id", "any");
      var category = _.get(this.selected_category, "id", "any");
      var params = {
        genre: genre,
        category: category,
        page: page,
        per_page: this.items_per_page,
        seed: this.seed
      };

      SearchService.searchDiscoverPublicUser(params).then(function (response) {
        _this.$store.dispatch("error/showLoadingActivity", false);
        _this.products = _this.products.concat(response.body.products);

        // this will return a a prop limit if available
        _this.products = _this.products.slice(0, _this.listLimit || _this.products.length);

        // remove products duplicate
        _this.products = _.uniqBy(_this.products, "id");

        // const categories = _.chain(this.products).map('category').keyBy('id').map((v, k) => {return v}).sortBy('name').value()
        var categories = response.body.categories.map(function (c) {
          return {
            id: c,
            name: c
          };
        });
        _this.categories = [{ id: "any", name: "All" }].concat(categories);

        _this.page_index = response.body.pagination.current_page;
        _this.total_pages = response.body.pagination.total_pages;

        if (page === 1) {
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([SearchService.searchDiscoverPublicUser(_.extend(params, { page: 2 })), SearchService.searchDiscoverPublicUser(_.extend(params, { page: 3 })), SearchService.searchDiscoverPublicUser(_.extend(params, { page: 4 }))]).then(function (values) {
            vm.products = vm.products.concat(values[0].body.products, values[1].body.products, values[2].body.products);

            // this will return a a prop limit if available
            vm.products = _this.products.slice(0, _this.listLimit || _this.products.length);

            // remove products duplicate
            _this.products = _.uniqBy(_this.products, "id");

            vm.page_index = values[2].body.pagination.total_pages > 4 ? 4 : values[2].body.pagination.total_pages;

            vm.isPageReady = true;
          });
        }
      }).catch(function (e) {
        _this.$store.dispatch("error/showLoadingActivity", false);
        // this.$store.dispatch('error/showErrorToast', e.body.errors || [e.body])
        console.log("discover error", e);
      });
    }
  }),
  created: function created() {
    this.seed = Math.random();

    this.loadTrendingProducts();
  }
});

/***/ }),
/* 997 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_itemTab__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_itemTab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_itemTab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_video_box__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_video_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_video_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(6);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    title: {
      type: String,
      default: "Trending Videos"
    },
    classAttr: {
      type: String,
      default: "xs6 md6"
    },
    listLimit: Number,
    hideCta: Boolean,
    showFullOverlay: Boolean,
    coverOnly: Boolean,
    coverRadius: Boolean
  },
  components: {
    itemTab: __WEBPACK_IMPORTED_MODULE_1__components_itemTab___default.a,
    VideoBox: __WEBPACK_IMPORTED_MODULE_2__components_video_box___default.a
  },
  data: function data() {
    return {
      only_follows: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])({
    videoFeed: function videoFeed(state) {
      return state.trending.videos;
    }
  }), {
    items_per_page: function items_per_page() {
      return 1 * this.listLimit || 50;
    },
    videoFeed1: function videoFeed1() {
      var split = this.videoFeed.slice(0, this.videoFeed.length / 2);
      return split;
    },
    videoFeed2: function videoFeed2() {
      var split = this.videoFeed.slice(this.videoFeed.length / 2, this.videoFeed.length);
      return split;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])({
    getTrendingVideos: "trending/getTrendingVideos"
  }), {
    loadTrendingVideos: function loadTrendingVideos() {
      if (this.videoFeed.length) return;

      var params = {
        genre_id: 0,
        only_follows: this.only_follows,
        page: 1,
        per_page: this.items_per_page
      };

      this.getTrendingVideos(params);
    },
    loadData: function loadData(tab, page) {
      var _this = this;

      var params = {
        genre_id: tab,
        only_follows: this.only_follows,
        page: page,
        per_page: this.items_per_page
      };
      StreamService.getStreamsPublicUsers(params).then(function (response) {
        _this.videos = _this.videos.concat(response.body.streams);

        // this will return a a prop limit if available
        _this.videos = _this.videos.slice(0, _this.listLimit || _this.videos.length);

        // this.videos.filter((v) => )
        // this.videos = [ ...this.videos, ...this.videos]
        console.log(_this.videos);
        _this.pagination = response.body.pagination;
        _this.videoGenres = response.body.genres;
        _this.$store.dispatch("error/showLoadingActivity", false);
        _this.isPageReady = true;
      }).catch(function () {
        _this.$store.dispatch("error/showLoadingActivity", false);
      });
    }
  }),
  created: function created() {
    this.loadTrendingVideos();
  }
});

/***/ }),
/* 998 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_user_tag__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_user_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_user_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_trackcardsimple__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_trackcardsimple___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_trackcardsimple__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_contacts_directory_vue__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_contacts_directory_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_contacts_directory_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: { UserTag: __WEBPACK_IMPORTED_MODULE_0__components_user_tag___default.a, Trackcardsimple: __WEBPACK_IMPORTED_MODULE_1__components_trackcardsimple___default.a, Directory: __WEBPACK_IMPORTED_MODULE_2__components_contacts_directory_vue___default.a },
  data: function data() {
    return {
      attachment: {
        type: "Video",
        title: "Test Title",
        subtitle: "Test Subtitle"
      },
      recipients: {}
    };
  },

  methods: {
    closeEngagement: function closeEngagement() {
      this.$emit("closeEngagement");
    }
  },
  computed: {
    currentUser: function currentUser() {
      return this.$store.state.auth.user;
    },
    recipientsLen: function recipientsLen() {
      return 200;
    },
    attachType: function attachType() {
      switch (this.attachment.type) {
        case "ShopProduct":
          return "ShopProduct";
        case "Album":
          return "Album";
        case "Video":
          return "Video";
        default:
          break;
      }
    }
  }
});

/***/ }),
/* 999 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),
/* 1000 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  }
});

/***/ }),
/* 1001 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_card_vue__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_card_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_card_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0__components_card_vue___default.a
  }
});

/***/ }),
/* 1002 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_footer__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_footer__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Footer: __WEBPACK_IMPORTED_MODULE_0__components_footer___default.a
  }
});

/***/ }),
/* 1003 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Card"
});

/***/ }),
/* 1004 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Footer"
});

/***/ }),
/* 1005 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Payment"
});

/***/ }),
/* 1006 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  }
});

/***/ }),
/* 1007 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),
/* 1008 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_card_vue__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_card_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_card_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0__components_card_vue___default.a
  }
});

/***/ }),
/* 1009 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_footer__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_footer__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Footer: __WEBPACK_IMPORTED_MODULE_0__components_footer___default.a
  },
  data: function data() {
    return {
      categoryList: [{
        text: "All",
        active: true
      }, {
        text: "Rap / Hip Hop",
        active: false
      }, {
        text: "House",
        active: false
      }, {
        text: "Electronic",
        active: false
      }]
    };
  }
});

/***/ }),
/* 1010 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  }
});

/***/ }),
/* 1011 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),
/* 1012 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_footer__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_footer__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Footer: __WEBPACK_IMPORTED_MODULE_0__components_footer___default.a
  }
});

/***/ }),
/* 1013 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  }
});

/***/ }),
/* 1014 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_plan_detail_plan_detail__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_plan_detail_plan_detail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_plan_detail_plan_detail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plan_detail_payment__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plan_detail_payment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_plan_detail_payment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plan_detail_success__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plan_detail_success___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_plan_detail_success__);
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    PlanDetail: __WEBPACK_IMPORTED_MODULE_0__components_plan_detail_plan_detail___default.a,
    Payment: __WEBPACK_IMPORTED_MODULE_1__components_plan_detail_payment___default.a,
    Success: __WEBPACK_IMPORTED_MODULE_2__components_plan_detail_success___default.a
  },
  data: function data() {
    return {
      step: 1
    };
  },

  methods: {
    nexStep: function nexStep() {
      this.step++;
    },
    previousStep: function previousStep() {
      this.step--;
    }
  }
});

/***/ }),
/* 1015 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      playList: [{ title: "The Origin", name: "SALVA", isPlay: true }, { title: "What is love?", name: "SALVA, Teeko", isPlay: false }]
    };
  }
});

/***/ }),
/* 1016 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      categoryList: [{
        text: "Free",
        active: true
      }, {
        text: "Loud Pack",
        active: false
      }, {
        text: "Gold",
        active: false
      }, {
        text: "Platinum",
        active: false
      }, {
        text: "Sample packs",
        active: false
      }]
    };
  }
});

/***/ }),
/* 1017 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_footer__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_footer__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Footer: __WEBPACK_IMPORTED_MODULE_0__components_footer___default.a
  },
  data: function data() {
    return {
      isComment: false,
      isSend: false,
      currentIndex: 0
    };
  },
  methods: {
    swipe: function swipe(isDown) {
      if (isDown) {
        this.currentIndex = this.currentIndex < 3 ? this.currentIndex + 1 : this.currentIndex;
      } else {
        this.currentIndex = this.currentIndex == 0 ? this.currentIndex : this.currentIndex - 1;
      }
      console.log(this.currentIndex, "222222222222222222222222222");
    }
  }
});

/***/ }),
/* 1018 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_footer__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_footer__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Footer: __WEBPACK_IMPORTED_MODULE_0__components_footer___default.a
  },
  data: function data() {
    var _this = this;

    return {
      itemList: [{
        icon: __webpack_require__(1492),
        text: "Library",
        number: 0,
        handle: function handle() {
          return _this.$router.push({ name: "LibraryMobile" });
        }
      }, {
        icon: __webpack_require__(1483),
        text: "Cart",
        number: 3,
        handle: function handle() {
          return _this.$router.push({ name: "CartMobile" });
        }
      }, {
        icon: __webpack_require__(1508),
        text: "My Top Creators",
        number: 0
      }, {
        icon: __webpack_require__(1504),
        text: "Settings",
        number: 0
      }, {
        icon: __webpack_require__(1509),
        text: "Learn",
        number: 0
      }]
    };
  }
});

/***/ }),
/* 1019 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shop_item__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shop_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__shop_item__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import PaymentService from '@/services/payment'


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ShopItem: __WEBPACK_IMPORTED_MODULE_0__shop_item___default.a
  },

  props: {
    value: Object
  },

  data: function data() {
    return {
      refund_all: false,
      items_available: false,
      items_selected: false,
      payment: {}
    };
  },


  computed: {},

  methods: {
    evaluate: function evaluate() {
      var item = this._.find(this.payment.order.items, { refund: true });
      this.items_selected = !!item;
    },
    toggleRefundAll: function toggleRefundAll(event) {
      this.payment.order.items.forEach(function (item) {
        if (item.status !== 'item_refunded') {
          item.refund = event;
          var itemQuantity = item.quantity > 0 ? item.quantity : 1;
          item.refund_amount_in_dollar = (item.price + item.shipping_cost) * itemQuantity / 100;
        }
      });
      this.evaluate();
    },
    changeOrderItem: function changeOrderItem(event) {
      var item = this._.find(this.payment.order.items, { id: event.id });
      item.refund = event.refund;
      item.refund_amount_in_dollar = event.refund_amount_in_dollar;
      this.evaluate();
    }
  },

  created: function created() {
    var _this = this;

    this.payment = this.value;
    this.payment.order.items.forEach(function (item) {
      if (item.status !== 'item_refunded') {
        _this.items_available = true;
        var itemQuantity = item.quantity > 0 ? item.quantity : 1;
        item.refund_amount_in_dollar = (item.price + item.shipping_cost) * itemQuantity / 100;
      }
    });
  }
});

/***/ }),
/* 1020 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_profileitem__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_profileitem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_profileitem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_product__ = __webpack_require__(15);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    profileItem: __WEBPACK_IMPORTED_MODULE_0__components_profileitem___default.a
  },

  props: {
    item: {
      type: Object,
      required: true
    },

    shareProduct: {
      type: Function
    },

    dismiss: {
      type: Function,
      required: true
    }
  },

  data: function data() {
    return {
      showPolicySection: false,
      option: null
    };
  },


  computed: {
    policyButtonText: function policyButtonText() {
      return this.showPolicySection ? "Close Policy" : "Return Policy";
    },
    price: function price() {
      if (this.option !== "") {
        for (var index in this.item.variants) {
          var variant = this.item.variants[index];
          if (variant.id === this.option) {
            return variant.price;
          }
        }
      }
      return this.item.price;
    },
    covers: function covers() {
      var covers = [];
      for (var index in this.item.covers) {
        var cover = this.item.covers[index];
        if (cover.cover.url) {
          covers.push(cover);
        }
      }
      return covers;
    }
  },

  created: function created() {
    this.option = this.item.variants[0].id;
  },


  methods: {
    repostProduct: function repostProduct() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1__services_product__["a" /* default */].repostProduct(this.item.id).then(function (response) {
        if (response.body.errors) {
          _this.$store.dispatch("error/showErrorToast", response.body.errors);
        } else {
          _this.$store.dispatch("error/showSuccessToast", ["You just reposted " + _this.item.name]);
        }
      }).catch(function (e) {
        _this.$store.dispatch("error/showErrorToast", e.body.errors || [e.body]);
      });
    },
    togglePolicy: function togglePolicy() {
      this.showPolicySection = !this.showPolicySection;
    },
    zoomOut: function zoomOut() {
      console.log("test");
    }
  }
});

/***/ }),
/* 1021 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_base_app_card__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_base_app_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_base_app_card__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    AppCard: __WEBPACK_IMPORTED_MODULE_0__components_base_app_card___default.a
  },

  props: {
    value: Object
  },

  data: function data() {
    return {
      item: {}
    };
  },


  computed: {
    productImage: function productImage() {
      return this._.get(this.item, 'product.covers[0].cover.url');
    },
    productName: function productName() {
      return this._.get(this.item, 'product.name');
    },
    itemQuantity: function itemQuantity() {
      var quantity = this._.get(this.item, 'quantity', 0);
      return quantity > 0 ? quantity : 1;
    },
    itemPrice: function itemPrice() {
      return '$' + this.$options.filters.formatNumber(this._.get(this.item, 'price', 0));
    },
    itemMaxRefundAmount: function itemMaxRefundAmount() {
      return (this.item.price + this.item.shipping_cost) * this.itemQuantity / 100;
    },
    itemShippingCost: function itemShippingCost() {
      var shippingCost = this._.get(this.item, 'shipping_cost', 0);
      return shippingCost > 0 ? '$' + this.$options.filters.formatNumber(shippingCost) : '';
    },
    itemStatus: function itemStatus() {
      switch (this._.get(this.item, 'status')) {
        case 'item_ordered':
          return 'Unshipped';
        case 'item_shipped':
          return 'Shipped';
        case 'item_refunded':
          return 'Refunded';
      }
    }
  },

  watch: {
    value: function value(val) {
      this.item = val;
    }
  },

  created: function created() {
    this.item = this.value;
  }
});

/***/ }),
/* 1022 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_promotemodal__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_promotemodal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_promotemodal__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    promoteModal: __WEBPACK_IMPORTED_MODULE_1__components_promotemodal___default.a
  },

  props: {
    product: {
      type: Object
    },

    editButtonAction: {
      type: Function
    },

    updateButtonAction: {
      type: Function
    },

    deleteButtonAction: {
      type: Function
    },

    acceptButtonAction: {
      type: Function
    },

    denyButtonAction: {
      type: Function
    },

    releaseButtonAction: {
      type: Function
    },

    showPromoteButton: {
      type: Boolean,
      default: true
    }
  },

  data: function data() {
    return {
      isShowPromoteModal: false
    };
  },


  computed: {
    usersCountByStatus: function usersCountByStatus() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.countBy(this.product.collaborators, "status");
    },
    usersByStatus: function usersByStatus() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.groupBy(this.product.collaborators, "status");
    },
    ownerShare: function ownerShare() {
      return 100 - __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.sumBy(this.product.collaborators, "user_share");
    }
  },

  created: function created() {},


  methods: {
    showPromoteDialog: function showPromoteDialog() {
      this.isShowPromoteModal = true;
    },
    dismissPromoteDialog: function dismissPromoteDialog() {
      this.isShowPromoteModal = false;
    },
    saveAndFinish: function saveAndFinish() {
      this.dismissPromoteDialog();
    }
  }
});

/***/ }),
/* 1023 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},

  props: {
    digitalContent: {
      type: Object
    },

    accept: {
      type: String,
      default: '.zip'
    },

    autoUpload: {
      type: Boolean,
      default: true
    }
  },

  data: function data() {
    return {};
  },


  computed: {
    fileName: function fileName() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(this.digitalContent, 'file.name', '');
    }
  },

  created: function created() {},


  methods: {
    deleteFile: function deleteFile() {
      this.digitalContent.file = null;
    },
    filesChange: function filesChange(fileList) {
      var _this = this;

      // console.log('digital_uploader filesChange', fileList)
      var vm = this;
      // handle file changes
      if (!fileList.length) return;

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(Array(fileList.length).keys()).map(function (x) {
        var filesize = fileList[x].size / 1024 / 1024;
        if (filesize <= 2048) {
          vm.digitalContent.file = fileList[x];
          // console.log(vm.file)
        } else {
          _this.$store.dispatch('error/showErrorToast', [fileList[x].name + ' size is over 2GB.']);
        }
      });
    }
  },

  mounted: function mounted() {}
});

/***/ }),
/* 1024 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "AccountDownload"
});

/***/ }),
/* 1025 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BannerUpload__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BannerUpload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__BannerUpload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_flashlight_white_svg__ = __webpack_require__(1456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_flashlight_white_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_flashlight_white_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_music_drop_gif__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_music_drop_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_music_drop_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_dragFileUploader__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_dragFileUploader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_dragFileUploader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_video__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mux_upchunk__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mux_upchunk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__mux_upchunk__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		BannerUpload: __WEBPACK_IMPORTED_MODULE_3__BannerUpload___default.a,
		dragFileUploader: __WEBPACK_IMPORTED_MODULE_6__components_dragFileUploader___default.a
	},
	data: function data() {
		return {
			iconImage: __WEBPACK_IMPORTED_MODULE_4__assets_flashlight_white_svg___default.a,
			bannerImage: __WEBPACK_IMPORTED_MODULE_5__assets_music_drop_gif___default.a,
			videoUploaded: false,
			videoFile: null,
			video: null,
			submitLoading: false,
			duration: null,
			isSpotlightVideoAvailable: false
		};
	},


	computed: {
		currentUser: function currentUser() {
			return this.$store.state.auth.user;
		},
		onMobile: function onMobile() {
			return this.$vuetify.breakpoint.smAndDown;
		}
	},
	methods: {
		pickedFile: function pickedFile(file) {
			var _this = this;

			return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
				var video;
				return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.next = 2;
								return _this.validateDuration(file);

							case 2:
								video = _context.sent;

								if (video.duration > 20) {
									_this.videoFile = null;
									_this.$store.dispatch('error/showErrorToast', ['You can\'t upload video which is more than 20 seconds.']);
								} else {
									_this.videoUploaded = true;
									_this.videoFile = file;
									_this.duration = video.duration;
								}

							case 4:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this);
			}))();
		},
		submit: function submit() {
			var _this2 = this;

			this.loading = true;
			var stream = this.videoFile[0];
			this.submitLoading = true;
			var formData = new FormData();
			formData.append('stream[name]', stream.name);
			formData.append('stream[description]', "Spotlight Video");
			formData.append('stream[duration]', this.duration);
			formData.append('stream[spotlight_video]', true);

			this.$store.dispatch('error/showLoadingActivity', true);
			__WEBPACK_IMPORTED_MODULE_7__services_video__["a" /* default */].createVideo(formData).then(function (response) {
				_this2.video = response.body;
				var upload_url = _this2.video.upload_url;

				var upload = __WEBPACK_IMPORTED_MODULE_8__mux_upchunk__["createUpload"]({
					endpoint: upload_url,
					file: _this2.videoFile[0],
					chunkSize: 5120 // Uploads the file in ~5mb chunks
				});

				upload.on('error', function (err) {
					_this2.loading = false;
					_this2.$store.dispatch('error/showLoadingActivity', false);
					console.error('💥', err.detail);
				});

				upload.on('progress', function (progress) {
					_this2.loading = false;
					_this2.$store.commit('error/setProgressBarValue', parseInt(progress.detail));
				});

				upload.on('success', function () {
					_this2.$store.dispatch('error/showLoadingActivity', false);
					console.log("Wrap it up, we're done here. 👋");
					_this2.$router.push({ path: '/video/' + _this2.video.id + '/show' });
					_this2.$store.dispatch('error/showSuccessToast', ["Spotlight video has been uploaded successfully."]);
					_this2.loading = false;
				});
			}).catch(function (e) {
				_this2.loading = false;
				console.log(e);
				console.log(e.message);
				_this2.$store.dispatch('error/showLoadingActivity', false);
				_this2.$store.dispatch('error/showErrorToast', e.message || e.body.errors || [e.body]);

				_this2.submitLoading = false;
			});
		},
		validateDuration: function validateDuration(file) {
			var _this3 = this;

			return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
				return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
					while (1) {
						switch (_context3.prev = _context3.next) {
							case 0:
								return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
									try {
										_this3.video = document.createElement('video');
										_this3.video.preload = 'metadata';

										_this3.video.onloadedmetadata = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
											return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
												while (1) {
													switch (_context2.prev = _context2.next) {
														case 0:
															resolve(this);

														case 1:
														case 'end':
															return _context2.stop();
													}
												}
											}, _callee2, this);
										}));

										_this3.video.onerror = function () {
											reject("Invalid video. Please select a video file.");
										};

										_this3.video.src = window.URL.createObjectURL(file[0]);
									} catch (e) {
										reject(e);
									}
								}));

							case 1:
							case 'end':
								return _context3.stop();
						}
					}
				}, _callee3, _this3);
			}))();
		},
		replaceVideo: function replaceVideo() {
			this.video = null;
			this.videoFile = null;
			this.videoUploaded = false;
		}
	}
});

/***/ }),
/* 1026 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_mobile_auth_learnMore__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_mobile_auth_learnMore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__views_mobile_auth_learnMore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_mobile_auth_onboarding_authPlan__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_mobile_auth_onboarding_authPlan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_mobile_auth_onboarding_authPlan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_paymentCard_index__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_paymentCard_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_paymentCard_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_subscription__ = __webpack_require__(47);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
	components: { LearnMore: __WEBPACK_IMPORTED_MODULE_1__views_mobile_auth_learnMore___default.a, AuthPlan: __WEBPACK_IMPORTED_MODULE_2__views_mobile_auth_onboarding_authPlan___default.a, PaymentCard: __WEBPACK_IMPORTED_MODULE_4__components_paymentCard_index___default.a },
	data: function data() {
		return {
			// banner:
			initPayment: false,
			selectedPlan: {},
			plansUpgradeModal: false,
			plansList: { 'basic': 1, plus: '2', pro: '3' },
			plansName: { 'basic': 'Listener', plus: 'Creator', pro: 'Advance' },
			planChangeText: null
		};
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])({
		plansData: function plansData(state) {
			return state.app.plansData;
		},
		current: function current(state) {
			return state.app.onboarding.current;
		}
	}), {
		plans: function plans() {
			var plans = this.plansData.map(function (plan) {
				if (plan.id == "basic") {
					plan.title = "Everyone";
				}
				return plan;
			});

			return plans;
		},
		currentUser: function currentUser() {
			return this.$store.state.auth.user;
		},
		totalPayable: function totalPayable() {
			var fee = parseFloat(this.selectedPlan.price);
			var subFee = __WEBPACK_IMPORTED_MODULE_5__helper__["d" /* Stripe */].calculateSubFee(this.selectedPlan.price);

			var total = parseFloat(subFee) + parseFloat(fee);
			total = parseFloat(total.toFixed(2));

			return total;
		}
	}),

	methods: {
		openPaymentModal: function openPaymentModal(plan) {
			this.initPayment = true;
			this.selectedPlan = plan;
		},
		verifyUserType: function verifyUserType(plan) {
			this.selectedPlan = plan;
			if (this.currentUser == null) {
				this.$router.push({ path: '/signup' });
			} else if (this.currentUser && this.currentUser.stripe_customer_id == null) {
				this.openPaymentModal(plan);
			} else {
				this.planChangeText = this.plansCategory(this.currentUser.plan, this.plansList[plan.id]);
				if (!(this.planChangeText === 'Current Plan' || this.planChangeText === null)) {
					this.plansUpgradeModal = true;
				}
			}
		},
		closePaymentModal: function closePaymentModal() {
			this.initPayment = false;
			this.selectedPlan = {};
		},
		plansDescription: function plansDescription(plan) {
			if (this.currentUser == null || this.currentUser.plan === null) {
				if (plan == 'basic') {
					return 'Start free 30 day trial';
				} else {
					return 'Get Verified';
				}
			} else {
				return this.plansCategory(this.currentUser.plan, this.plansList[plan]);
			}
		},
		plansCategory: function plansCategory(userPlan, planCategory) {
			if (this.plansList[userPlan] == planCategory) {
				return 'Current Plan';
			} else if (planCategory <= this.plansList[userPlan]) {
				return 'Downgrade Plan';
			} else {
				return 'Upgrade Plan';
			}
		},
		subscriptionChange: function subscriptionChange() {
			var _this = this;

			var params = { selectedPlan: this.selectedPlan.id };
			__WEBPACK_IMPORTED_MODULE_6__services_subscription__["a" /* default */].subscriptionChange(params).then(function (response) {
				_this.hidePlanChangeModal();
				_this.$store.dispatch('error/showSuccessToast', [response.body.success_response]);
				setTimeout(function () {
					window.location.href = '/subscribe';
				}, 2000);
			}).catch(function (e) {
				_this.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
			});
		},
		hidePlanChangeModal: function hidePlanChangeModal() {
			this.plansUpgradeModal = false;
			this.planChangeText = null;
		}
	},

	mounted: function mounted() {
		this.selectedPlan = this.plans[0];
	}
});

/***/ }),
/* 1027 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__attach_card__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__attach_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__attach_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__attach_picker__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__attach_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__attach_picker__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    AttachCard: __WEBPACK_IMPORTED_MODULE_0__attach_card___default.a,
    AttachPicker: __WEBPACK_IMPORTED_MODULE_1__attach_picker___default.a
  },

  props: {
    fullscreen: Boolean,
    customAlbums: {
      type: Array
    },
    customProducts: {
      type: Array
    },
    attachPickerTitle: String,
    hideMetaActions: Boolean,
    value: Object,
    dataOnlyMode: Boolean,
    ctaTitle: {
      type: String,
      default: 'Add'
    }
  },

  data: function data() {
    return {
      stream_assoc: {
        type: "Album",
        value: null
      },
      show_attach_picker: false
    };
  },


  watch: {
    stream_assoc: function stream_assoc(newVal) {
      // console.log('from <attach>', newVal)
    },
    value: function value(newVal) {
      // console.log('value changed', newVal)
      // this.stream_assoc = newVal;
    }
  },

  methods: {
    getSelected: function getSelected(data) {
      this.stream_assoc = data;
      this.$emit("getAssoc", data);
    },
    openAttachPicker: function openAttachPicker() {
      console.log('openAttach ran');
      this.show_attach_picker = true;
    },
    closeAttachPicker: function closeAttachPicker() {
      console.log('closeAttach ran');
      this.show_attach_picker = false;
    },
    removeAttach: function removeAttach() {
      console.log('removeAttach ran');
      this.stream_assoc = {
        type: "Album",
        value: null
      };
    }
  },

  created: function created() {
    // this.stream_assoc = {
    //   type: this._props.value.type,
    //   value: this._props.value.value,
    // };
  }
});

/***/ }),
/* 1028 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    image: String,
    title: String,
    subtitle: String,
    type: String
  }
});

/***/ }),
/* 1029 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_me__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_stream__ = __webpack_require__(18);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import AlbumService from '@/services/album'
// import ProductService from '@/services/product'



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    altFullscreenHeader: {
      type: Boolean
    },
    customAlbums: {
      type: Array
    },
    customProducts: {
      type: Array
    },
    showVideo: {
      type: Boolean
    },
    fullscreen: {
      type: Boolean
    },
    dismiss: {
      type: Function,
      required: true
    },

    title: {
      type: String,
      default: "Attach content to live video"
    },
    value: {
      type: Object
    }
  },

  data: function data() {
    return {
      active_tab: "Album",
      item: {
        type: "Album",
        value: null
      },
      albums: [],
      products: [],
      videos: [],
      userSearchKeyword: ""
    };
  },


  computed: {
    onMobile: function onMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    attachId: function attachId() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(this.item.value, "id", 0);
    }
  },

  methods: {
    onTab: function onTab(tab) {
      this.active_tab = tab;
    },
    selectItem: function selectItem(type, value) {
      // console.log("selectItem Item:", type, value);
      // console.log("selectItem Value:", value);
      // var item = {
      //   type: type,
      //   value: value,
      // };

      this.$emit("getSelected", { type: type, value: value });
      // console.log("selectItem emitted:", {type, value});
      this.dismiss();
    },
    loadUsers: function loadUsers() {
      console.log("loadUsers");
    }
  },

  created: function created() {
    var _this = this;

    // console.log('on created value: ', this._props.value);
    // this.item = {
    //   type: this._props.value.type,
    //   value: this._props.value.value,
    // };

    this.active_tab = this.item.type;

    this.$store.dispatch("error/showLoadingActivity", true);

    var vid_params = {
      genre_id: 0,
      only_follows: false,
      page: 1,
      per_page: 10
    };

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([
    // AlbumService.getAlbums({
    //   statuses: 'published, collaborated',
    //   user_statuses: 'accepted',
    // }),
    // ProductService.getProducts({
    //   statuses: 'published, collaborated',
    //   stock_statuses: 'active',
    //   user_statuses: 'accepted',
    // }),
    __WEBPACK_IMPORTED_MODULE_2__services_me__["a" /* default */].videoAttachAlbums(), __WEBPACK_IMPORTED_MODULE_2__services_me__["a" /* default */].videoAttachProducts(), __WEBPACK_IMPORTED_MODULE_3__services_stream__["a" /* default */].getStreams(vid_params) // take further appro. look at data from backend
    ]).then(function (values) {
      _this.albums = _this.customAlbums || values[0].body;
      _this.products = _this.customProducts || values[1].body;
      _this.videos = values[2].body.streams;
      _this.$store.dispatch("error/showLoadingActivity", false);
    }).catch(function (reason) {
      console.log(reason);
      _this.$store.dispatch("error/showLoadingActivity", false);
      _this.$store.dispatch("error/showErrorToast", [reason]);
    });
  }
});

/***/ }),
/* 1030 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},

  props: {
    digitalContent: {
      type: Object
    },

    accept: {
      type: String,
      default: '.zip'
    },

    autoUpload: {
      type: Boolean,
      default: true
    }
  },

  data: function data() {
    return {};
  },


  computed: {
    fileName: function fileName() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(this.digitalContent, 'file.name', '');
    }
  },

  created: function created() {},


  methods: {
    deleteFile: function deleteFile() {
      this.digitalContent.file = null;
    },
    filesChange: function filesChange(fileList) {
      var _this = this;

      // console.log('digital_uploader filesChange', fileList)
      var vm = this;
      // handle file changes
      if (!fileList.length) return;

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(Array(fileList.length).keys()).map(function (x) {
        var filesize = fileList[x].size / 1024 / 1024;
        if (filesize <= 25) {
          vm.digitalContent.file = fileList[x];
          // console.log(vm.file)
        } else {
          _this.$store.dispatch('error/showErrorToast', [fileList[x].name + ' size is over 25MB.']);
        }
      });
    }
  },

  mounted: function mounted() {}
});

/***/ }),
/* 1031 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_user_tag__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_user_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_user_tag__);
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    UserTag: __WEBPACK_IMPORTED_MODULE_0__components_user_tag___default.a
  },

  props: {
    user: Object
  }
});

/***/ }),
/* 1032 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_user__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_auth__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_tracking__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_stream__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_discoverNav__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_discoverNav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_discoverNav__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_item__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_sendlovemodal__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_sendlovemodal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_sendlovemodal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_userFollowBtn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_userFollowBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_userFollowBtn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__services_collection__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_sharemodal__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_sharemodal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_sharemodal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vuex__ = __webpack_require__(6);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














/* harmony default export */ __webpack_exports__["default"] = ({
	props: {
		// video: Object,
		src: {
			type: String
		}
	},
	components: {
		discoverNav: __WEBPACK_IMPORTED_MODULE_9__components_discoverNav___default.a,
		sendLoveModal: __WEBPACK_IMPORTED_MODULE_11__components_sendlovemodal___default.a,
		UserFollowBtn: __WEBPACK_IMPORTED_MODULE_12__components_userFollowBtn___default.a,
		shareModal: __WEBPACK_IMPORTED_MODULE_14__components_sharemodal___default.a
	},

	data: function data() {
		return {
			timeLimit: false,
			unSubscribed: false,
			player: null,
			pipMode: false,
			videoId: null,
			show_video_overlay: true,
			show_nav: true,
			firstTimePlay: false,
			remainingTimerCalculator: null,
			remainingTime: 0,
			stillListeningTimer: null,
			showListeningMessage: false,
			isSubscribed: false,
			endPlayTime: 0,
			totalPlayTime: 0,
			seekTime1: 0,
			seekTime2: 0,
			bgDemoImg: __webpack_require__(148),
			videoLoading: __webpack_require__(147),
			show_modalCard1: false,
			show_modalCard2: false,
			show_modalCard3: false,
			show_modalCard4: false,
			spotlightVideoSource: null,
			user: null,
			displayListingProduct: false,
			video: null,
			assoc: {
				username: null,
				userImageUrl: null,
				itemPic: null,
				category: null,
				price: null,
				name: null,
				assoc_type: null,
				variants: null,
				stock: 0
			},
			option: '',
			showSendLoveModal: false,
			showShareModal: false,
			buttonHover: false
		};
	},
	mounted: function mounted() {
		var _this = this;

		return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
			return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
				while (1) {
					switch (_context.prev = _context.next) {
						case 0:
							_context.next = 2;
							return _this.fetchSubscriptionDetails();

						case 2:
							_context.next = 4;
							return _this.getUserDetailFromStream();

						case 4:
							_this.videoId = _this.$route.params.videoId;

							console.log('video_player created adfasdfsdfsdf');
							_this.$nextTick(function () {
								if (!_this.pipMode && _this.allVideosCount < 1) {
									console.log('init player');

									console.log(_this.allVideos);
									// no player in DOM, init a new player
									_this.initPlayer();
									var vm = _this;
									vm.player.exitPictureInPicture();
								} else {
									var nodeDetails2 = _this.$store.state.streamPlayer.nodeDetails;
									console.log('nodeDetails :', nodeDetails2);

									console.log('player already init');
									console.log(_this.$store.state.streamPlayer.nodeDetails);

									console.log(_this.allVideos);
									// there is a player in DOM, update original div wrapper
									// this is a fix for the DOM dissapearing when video page is re-visited
									var nodeDetails = _this.$store.state.streamPlayer.nodeDetails;
									var glitchedVid = document.getElementById('myVideoPlayer');

									console.log('nodeDetails', nodeDetails);
									console.log('glitchedVid', glitchedVid);

									console.log('replace');

									glitchedVid.replaceWith(nodeDetails.parent);
								}
							});

						case 7:
						case 'end':
							return _context.stop();
					}
				}
			}, _callee, _this);
		}))();
	},
	created: function created() {
		this.$root.$on(__WEBPACK_IMPORTED_MODULE_4__helper__["b" /* MyEvents */].USER_FOLLOW, this.setFollowingStatus);
	},
	beforeDestroy: function beforeDestroy() {
		this.$root.$off(__WEBPACK_IMPORTED_MODULE_4__helper__["b" /* MyEvents */].USER_FOLLOW, this.setFollowingStatus);

		try {
			var vm = this;
			//send tracking request to server when video stops play
			if (vm.totalPlayTime === 0) {
				vm.totalPlayTime = vm.player.currentTime();
			} else {
				vm.totalPlayTime = vm.totalPlayTime + Math.floor(vm.player.duration() - vm.endPlayTime);
			}
			if (vm.totalPlayTime >= 30 && vm.isSubscribed) {
				var params = { stream_id: vm.videoId, duration: Math.floor(vm.totalPlayTime) };

				__WEBPACK_IMPORTED_MODULE_7__services_tracking__["a" /* default */].createPlayRecord(params).then(function (response) {
					console.log(response);
				}).catch(function (e) {
					console.log("error in updating record");
				});
			}
			if (vm.player && !vm.player.paused()) {
				// player is playing, toggle pipmode
				this.togglePip();
			} else {
				// player is not playing, close player
				this.closePlayer();
			}
		} catch (error) {
			return error;
		}
	},


	watch: {
		src: function src(newVal, oldVal) {
			console.log('video_player watchingjjkjkjk   jkjkjk ');
			console.log(newVal, oldVal);
			console.log("this.src--->", this.src);
			this.player.src([{
				type: 'application/x-mpegURL',
				src: "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4"
			}]);
		}
	},
	methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_vuex__["c" /* mapActions */])({
		setPlaylist: 'player/setPlaylist',
		setPlaylistIndex: 'player/setListIndex',
		setTrackIndex: 'player/setTrackIndex',
		setPlaying: "player/setPlayingStatus"
	}), {
		playSong: function playSong() {
			this.player.pause();
			this.setPlaylist([_.cloneDeep(this.video.assoc)]);
			this.setPlaylistIndex(0);
			this.setPlaying(true);
			this.$root.$emit(__WEBPACK_IMPORTED_MODULE_4__helper__["b" /* MyEvents */].AUDIO_PLAYER_PLAY, 0);
		},
		setFollowingStatus: function setFollowingStatus(userId, isFollowing) {
			if (this.video.user && this.video.user.id === userId) {
				this.video.user.is_following = isFollowing;
			}
		},
		openShareModal: function openShareModal() {
			this.showShareModal = true;
		},
		dismissShareDialog: function dismissShareDialog() {
			this.showShareModal = false;
		},
		addToCollection: function addToCollection() {
			var _this2 = this;

			var params = { stream_id: this.video.id };
			__WEBPACK_IMPORTED_MODULE_13__services_collection__["a" /* default */].createCollection(params).then(function (response) {
				_this2.$store.dispatch('error/showSuccessToast', ['You just added ' + _this2.video.name + ' stream in your collection.']);
			}).catch(function (e) {
				_this2.$store.dispatch('error/showErrorToast', e.body.errors || [e.body] || [e.body.error]);
			});
		},
		showLoveDialog: function showLoveDialog() {
			if (this.currentUser.creator_verified && this.video.user.stripe_connected && this.video.user.creator_verified) {
				if (this.video.user.id !== this.currentUser.id) {
					this.showSendLoveModal = true;
				} else {
					this.$store.dispatch('error/showErrorToast', ['You cannot donate to your own.']);
				}
			} else {
				this.$store.dispatch('error/showErrorToast', ['Both creator and listeners must be verified and there stripes must be connected for donation.']);
			}
		},
		dismissLoveDialog: function dismissLoveDialog() {
			this.showSendLoveModal = false;
		},
		addToCart: function addToCart() {
			var _this3 = this;

			if (this.option === '' || this.option === null) {
				this.$store.dispatch('error/showErrorToast', ['Please select valid variant.']);
			} else {
				var params = {
					product_variant_id: this.option,
					quantity: 1
				};

				__WEBPACK_IMPORTED_MODULE_10__services_item__["a" /* default */].addToCart(params).then(function (response) {
					if (response.body.errors) {
						_this3.$store.dispatch('error/showErrorToast', response.body.errors);
					} else {
						_this3.$store.dispatch('error/showSuccessToast', ['Added successfully to Cart.']);
					}
				}).catch(function (e) {
					_this3.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
				});
			}
		},
		fetchSpotlightVideo: function fetchSpotlightVideo() {
			var _this4 = this;

			__WEBPACK_IMPORTED_MODULE_8__services_stream__["a" /* default */].getSpotlightStream(this.user.id).then(function (response) {
				console.log("response", response);
				_this4.spotlightVideoSource = response.body.mp_channel_1_ep_1_id;
				if (_this4.currentUser == null) {
					_this4.show_modalCard3 = true;
				} else {
					_this4.show_modalCard4 = true;
				}
			}).catch(function (e) {
				if (_this4.currentUser == null) {
					_this4.show_modalCard1 = true;
				} else {
					_this4.show_modalCard2 = true;
				}
			});
		},
		hideOverlay: function hideOverlay() {
			console.log('Hide Overlay');
			this.show_video_overlay = false;
			// this.show_video_overlay = false
			// setTimeout(() => {

			// }
			//   , 100
			// )
		},
		initPlayer: function initPlayer() {
			if (this.currentUser.free_trial_time <= 0 && !this.isSubscribed) {
				this.isSubscribed = true;
				this.timeLimit = true;
				this.unSubscribed = true;
			}
			var vm = this;
			console.log("this.src--->", this.src);
			vm.player = vm.player || window.videojs('myVideoPlayer', {
				autoplay: false,
				controls: true,
				sources: [{
					type: 'application/x-mpegURL',
					src: this.src
				}]
			});
			this.pauseMusicOnPlay();
			console.log("=====stripe_subscription_id=====", this.currentUser.stripe_subscription_id);
			if (this.currentUser.stripe_subscription_id === undefined || this.currentUser.stripe_subscription_id === null) {
				var options = {
					id: "myVideoPlayer"
				};
				vm.player.ima(options);
				vm.player.ima.initializeAdDisplayContainer();
				vm.player.ima.setContentWithAdTag(null, "https://servedbyadbutler.com/vast.spark?setID=14941&ID=182673&pid=141490", false);
				vm.player.ima.requestAds();
				// register method
			}
		},
		closePlayer: function closePlayer() {
			var vm = this;
			vm.updateUserInfo();
			if (vm.player) {
				vm.player.dispose();
				vm.player = null;

				// reset store
				this.$store.dispatch('streamPlayer/setPipParentNode', {});
			}
		},
		pauseMusicOnPlay: function pauseMusicOnPlay() {
			var _this5 = this;

			var vm = this;

			vm.player.on('ended', function () {
				this.show_video_overlay = true;
				if (vm.totalPlayTime === 0) {
					vm.totalPlayTime = vm.player.currentTime();
				} else {
					vm.totalPlayTime = vm.totalPlayTime + Math.floor(vm.player.duration() - vm.endPlayTime);
				}
				if (vm.totalPlayTime >= 30 && vm.isSubscribed) {
					var params = { stream_id: vm.videoId, duration: Math.floor(vm.totalPlayTime) };

					__WEBPACK_IMPORTED_MODULE_7__services_tracking__["a" /* default */].createPlayRecord(params).then(function (response) {
						console.log(response);
					}).catch(function (e) {
						console.log("error in updating record");
					});
				}
				vm.totalPlayTime = 0;
				vm.seekTime1 = 0;
				vm.seekTime2 = 0;
				vm.endPlayTime = 0;
			});

			vm.player.on('play', function () {
				if (_this5.unSubscribed === true && _this5.timeLimit === false) {
					_this5.player.pause();
					_this5.fetchSpotlightVideo();
				}
				_this5.show_video_overlay = false;
				vm.remainingTime = 0;
				_this5.firstTimePlay = true;
				clearTimeout(vm.stillListeningTimer);
				clearInterval(vm.remainingTimerCalculator);
				vm.stillListeningTimer = setTimeout(vm.stillPlaying, 3600000);
				vm.remainingTimerCalculator = setInterval(vm.timeCounter, 1000);
				vm.$root.$emit(__WEBPACK_IMPORTED_MODULE_4__helper__["b" /* MyEvents */].AUDIO_PLAYER_PAUSE);
			});

			vm.player.on('pause', function () {
				vm.updateUserInfo();
				vm.remainingTime = 0;
				clearTimeout(vm.stillListeningTimer);
				clearInterval(vm.remainingTimerCalculator);
				if (vm.totalPlayTime === 0) {
					vm.totalPlayTime = vm.totalPlayTime + Math.floor(vm.seekTime1);
				} else {
					vm.totalPlayTime = vm.totalPlayTime + Math.floor(vm.seekTime1 - vm.endPlayTime);
				}
				vm.endPlayTime = vm.seekTime2;
				console.log("================ playing time ", vm.totalPlayTime);
			});

			vm.player.on('mouseenter', function (event) {
				vm.player.inactivityTimeout = 0;
				vm.player.userActive(true);

				console.log("Mouse Enter", new Date());
				var vim = document.querySelector('.video-js').classList.remove('vjs-user-inactive');
				var vim = document.querySelector('.video-js').classList.remove('vjs-user-active');
				vm.displayListingProduct = false;
			});

			vm.player.on('mouseleave', function (event) {
				vm.player.inactivityTimeout = 0;
				vm.player.userActive(false);
				vm.displayListingProduct = false;
				console.log("Mouse Leave", new Date());
				var vim = document.querySelector('.video-js').classList.add('vjs-user-inactive');
				var vim = document.querySelector('.video-js').classList.add('vjs-user-active');
			});

			vm.player.on('timeupdate', function () {
				vm.seekTime1 = vm.seekTime2;
				vm.seekTime2 = vm.player.currentTime();
				if (vm.video.show_attachment_at === null && vm.player.currentTime() >= vm.video.duration / 2 && vm.player.currentTime() <= vm.video.duration / 2 + 5 || vm.video.show_attachment_at !== null && vm.player.currentTime() >= vm.video.show_attachment_at && vm.player.currentTime() <= vm.video.show_attachment_at + 5) {
					vm.displayListingProduct = true;
				} else {
					vm.displayListingProduct = false;
				}
			});
		},
		timeCounter: function timeCounter() {
			if (this.currentUser && this.currentUser.free_trial_time <= this.remainingTime && this.timeLimit && this.remainingTime >= 15) {
				this.player.pause();
				this.updateUserInfo();
				this.fetchSpotlightVideo();
				this.isSubscribed = true;
				this.timeLimit = false;
				this.unSubscribed = true;
			} else {
				this.remainingTime = this.remainingTime + 1;
			}
		},
		stillPlaying: function stillPlaying() {
			this.player.pause();
			this.showListeningMessage = true;
		},
		hideListeningMessage: function hideListeningMessage() {
			this.showListeningMessage = false;
		},
		updateUserInfo: function updateUserInfo() {
			var _this6 = this;

			var params = {
				user: { free_trial_time: this.remainingTime }
			};
			if (this.remainingTime > 0) {
				__WEBPACK_IMPORTED_MODULE_5__services_user__["a" /* default */].updateUserInfo(this.currentUser.id, params).then(function (response) {
					__WEBPACK_IMPORTED_MODULE_6__services_auth__["a" /* default */].setUser(response.body);
				}).catch(function (e) {
					console.log(e);

					_this6.$store.dispatch('error/showErrorToast', ["There was an error on updating user info "]);
				});
			}
			clearTimeout(this.stillListeningTimer);
			clearInterval(this.remainingTimerCalculator);
			this.remainingTime = 0;
		},
		fetchSubscriptionDetails: function fetchSubscriptionDetails() {
			var _this7 = this;

			return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
				return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								_context2.next = 2;
								return __WEBPACK_IMPORTED_MODULE_5__services_user__["a" /* default */].getSubscriptionDetail(_this7.currentUser.id).then(function (response) {
									if (response.bodyText === "Subscribed") {
										_this7.isSubscribed = true;
									}
								}).catch(function (e) {
									_this7.$store.dispatch('error/showErrorToast', ["There was an error on fetching user info "]);
								});

							case 2:
							case 'end':
								return _context2.stop();
						}
					}
				}, _callee2, _this7);
			}))();
		},
		togglePip: function togglePip() {
			var _this8 = this;

			return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
				var vm;
				return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
					while (1) {
						switch (_context3.prev = _context3.next) {
							case 0:
								vm = _this8;

								console.log('activate pip');
								vm.pipMode = true;

								// ontoggle, set pipMode status in store
								vm.$store.dispatch('streamPlayer/setPipPipMode', true);
								_context3.next = 6;
								return vm.player.requestPictureInPicture();

							case 6:

								// resume player play
								// fix for sudden pause of pip on activation
								vm.player.play();

							case 7:
							case 'end':
								return _context3.stop();
						}
					}
				}, _callee3, _this8);
			}))();
		},
		getUserDetailFromStream: function getUserDetailFromStream() {
			var _this9 = this;

			return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
				var stream_id;
				return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
					while (1) {
						switch (_context4.prev = _context4.next) {
							case 0:
								stream_id = _this9.$route.params.videoId;
								_context4.next = 3;
								return __WEBPACK_IMPORTED_MODULE_8__services_stream__["a" /* default */].getStream(stream_id).then(function (response) {
									_this9.video = response.body;
									_this9.user = response.body.user;
									var associatedItem = response.body.assoc;
									if (associatedItem !== null) {
										if (response.body.assoc_type === 'ShopProduct') {
											_this9.assoc.assoc_type = 'ShopProduct';
											_this9.assoc.username = associatedItem.merchant.username;
											_this9.assoc.category = associatedItem.category.name;
											_this9.assoc.name = associatedItem.name;
											_this9.assoc.userImageUrl = associatedItem.merchant.avatar.url;
											_this9.assoc.itemPic = associatedItem.covers[0].cover.url;
											_this9.assoc.price = associatedItem.price;
											_this9.assoc.variants = associatedItem.variants;
											_this9.assoc.stock = associatedItem.stock;
										} else if (response.body.assoc_type === 'Album') {
											_this9.assoc.assoc_type = 'Album';
											_this9.assoc.username = associatedItem.user.username;
											_this9.assoc.category = associatedItem.album_type;
											_this9.assoc.userImageUrl = associatedItem.user.avatar.url;
											_this9.assoc.name = associatedItem.name;
											_this9.assoc.itemPic = associatedItem.cover.url;
											_this9.assoc.price = associatedItem.price;
										}
									}
								}).catch(function (e) {
									console.log(e);
								});

							case 3:
							case 'end':
								return _context4.stop();
						}
					}
				}, _callee4, _this9);
			}))();
		},
		options: function options() {
			var options = [];
			// const defaultOption = {
			//   id: '',
			//   name: '-----'
			// }
			// options.push(defaultOption)
			for (var index in this.assoc.variants) {
				var variant = this.assoc.variants[index];
				if (this.isDigitalProduct || variant.quantity > 0) {
					var option = {
						id: variant.id,
						name: variant.name
					};
					options.push(option);
				}
			}

			return options;
		}
	}),

	computed: {
		followButtonText: function followButtonText() {
			if (this.video.user.is_following) {
				return this.buttonHover ? 'Unfollow' : 'Following';
			}
			return 'Follow';
		},
		allVideos: function allVideos() {
			// eslint-disable-next-line no-undef
			return videojs.getAllPlayers();
		},
		allVideosCount: function allVideosCount() {
			return this.allVideos.length;
		},
		onMobile: function onMobile() {
			return this.$vuetify.breakpoint.smAndDown;
		},
		currentUser: function currentUser() {
			return this.$store.state.auth.user;
		},
		mergedAttachmentItems: function mergedAttachmentItems() {
			var combined = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.albums), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.products));
			console.log('combined: ', combined);
			return combined;
		}
	}
});

/***/ }),
/* 1033 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      username: ""
    };
  },
  mounted: function mounted() {
    this.username = this.$route.query.username || "Guest";
  },

  methods: {
    copyLink: function copyLink() {
      var message = "Hi, " + this.username + " is inviting you to visit https://yousound.com/";
      navigator.clipboard.writeText(message);
      this.$store.dispatch("error/showSuccessToast", ["Invite Link has been copied"]);
    }
  }
});

/***/ }),
/* 1034 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_album__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_playlist__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_downloadmodal__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_downloadmodal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_downloadmodal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_sharemodal__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_sharemodal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_sharemodal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_profileitem__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_profileitem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_profileitem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_user__ = __webpack_require__(7);













/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    downloadModal: __WEBPACK_IMPORTED_MODULE_8__components_downloadmodal___default.a,
    shareModal: __WEBPACK_IMPORTED_MODULE_9__components_sharemodal___default.a,
    profileItem: __WEBPACK_IMPORTED_MODULE_10__components_profileitem___default.a
  },

  props: {
    hideMoreBtn: Boolean,
    album: {
      type: Object
    },

    trackIndex: {
      type: Number
    },

    removeTrack: {
      type: Function
    },

    showStats: {
      type: Boolean,
      default: false
    },

    showIndexPlayIcon: {
      type: Boolean,
      default: false
    },

    openDownloadModal: Function
  },

  data: function data() {
    return {
      buttonHover: false,
      share_dialog: false,
      playlist_dialog: false,
      menu: false,
      submenu: false,
      playlist: {
        name: '',
        image: null
      },
      selectedImage: null,
      isSubscribed: false
    };
  },

  watch: {
    track: {
      immediate: true,
      handler: function handler(val) {}
    }
  },

  computed: {
    onMobile: function onMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    currentUser: function currentUser() {
      return this.$store.state.auth.user;
    },
    track: function track() {
      return this.album.tracks[this.trackIndex];
    },
    selectedTrackIsPlaying: function selectedTrackIsPlaying() {
      var playerActive = this.$store.state.player.isPlaying;
      var currentTrackPlaying = this.$store.state.player.currentTrackPlaying;
      var current = this.album.tracks[this.trackIndex];
      if (playerActive) {
        console.log(current.id);
        console.log(currentTrackPlaying);
        if (current.id === currentTrackPlaying.id) {
          console.log(true);
          return true;
        }
      }
      return false;
    },
    isPlaying: function isPlaying() {
      if (this.$store.state.player.isPlaying) {
        return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.$store.state.player.list[this.$store.state.player.listIndex], 'id') === this.album.id;
      }
      return false;
    },
    input_id: function input_id() {
      return 'playlist_image_file_' + this.track.id;
    },
    playlists: function playlists() {
      return this.$store.state.playlist.playlists;
    },
    stripeConnected: function stripeConnected() {
      return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.album, 'user.stripe_connected', false);
    }
  },

  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!_this.currentUser) {
                _context.next = 3;
                break;
              }

              _context.next = 3;
              return _this.fetchSubscriptionDetails();

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },


  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])({
    setPlaylist: 'player/setPlaylist',
    setPlaylistIndex: 'player/setListIndex',
    setTrackIndex: 'player/setTrackIndex',
    setPlaying: 'player/setPlayingStatus'
  }), {
    fetchSubscriptionDetails: function fetchSubscriptionDetails() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_11__services_user__["a" /* default */].getSubscriptionDetail(_this2.currentUser.id).then(function (response) {
                  if (response.bodyText === "Subscribed") {
                    _this2.isSubscribed = true;
                  }
                }).catch(function (e) {
                  _this2.$store.dispatch('error/showErrorToast', ["There was an error on fetching user info "]);
                });

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    removeItem: function removeItem() {
      this.menu = false;
      this.submenu = false;
      this.removeTrack(this.track);
    },
    repostItem: function repostItem() {
      var _this3 = this;

      if (this.isSubscribed) {
        this.menu = false;
        this.submenu = false;
        var params = { track_id: this.track.id };
        __WEBPACK_IMPORTED_MODULE_6__services_album__["a" /* default */].repostAlbum(this.album.id, params).then(function (response) {
          _this3.$store.dispatch('error/showSuccessToast', ['You just added ' + _this3.track.name + ' track in your collection.']);
        }).catch(function (e) {
          _this3.$store.dispatch('error/showErrorToast', e.body.errors || [e.body] || [e.body.error]);
        });
      } else {
        this.$router.push({ path: '/subscribe#plans' });
      }
    },
    showDownloadDialog: function showDownloadDialog() {
      this.menu = false;
      this.submenu = false;
      this.openDownloadModal(this.track);
    },
    dismissDownloadDialog: function dismissDownloadDialog() {
      this.download_dialog = false;
    },
    showShareDialog: function showShareDialog() {
      this.menu = false;
      this.submenu = false;
      this.share_dialog = true;
    },
    dismissShareDialog: function dismissShareDialog() {
      this.share_dialog = false;
    },
    flagItem: function flagItem() {
      this.menu = false;
      this.submenu = false;
    },
    addComment: function addComment() {
      this.menu = false;
      this.submenu = false;
    },
    addToNewPlaylist: function addToNewPlaylist() {
      this.menu = false;
      this.playlist = {
        name: '',
        image: null
      };
      this.selectedImage = null;
    },
    createPlaylist: function createPlaylist() {
      var _this4 = this;

      if (this.playlist.name == '') {
        this.$store.dispatch('error/showErrorToast', ['Please input Playlist name.']);
        return;
      }

      this.playlist_dialog = false;

      var params = new FormData();
      params.append('name', this.playlist.name);
      params.append('description', this.playlist.name);
      // if (this.playlist.image) {
      //   params.append('cover', this.playlist.image)
      // }
      params.append('assoc_id', this.track.id);
      params.append('assoc_type', 'Track');
      this.$store.dispatch('error/showLoadingActivity', true);
      __WEBPACK_IMPORTED_MODULE_7__services_playlist__["a" /* default */].createPlaylist(params).then(function (response) {
        _this4.$store.dispatch('error/showLoadingActivity', false);
        _this4.$store.dispatch('error/showSuccessToast', ['Added the track to New Playlist ']);

        __WEBPACK_IMPORTED_MODULE_7__services_playlist__["a" /* default */].getPlaylists().then(function (response) {
          _this4.$store.dispatch('playlist/setPlaylists', response.body);
        });
      }).catch(function (e) {
        _this4.$store.dispatch('error/showLoadingActivity', false);
        _this4.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    addToPlaylist: function addToPlaylist(list) {
      var _this5 = this;

      this.menu = false;
      this.submenu = false;
      var params = {
        assoc_id: this.track.id,
        assoc_type: 'Track'
      };
      __WEBPACK_IMPORTED_MODULE_7__services_playlist__["a" /* default */].updatePlaylist(list.id, params).then(function (response) {
        _this5.$store.dispatch('error/showSuccessToast', ['Added the track to <' + list.name + '>']);
      }).catch(function (e) {
        _this5.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    imageChanged: function imageChanged(e) {
      var _this6 = this;

      this.playlist.image = e.target.files[0];
      var reader = new FileReader();
      reader.addEventListener('load', function (event) {
        _this6.selectedImage = event.target.result;
      }, false);
      reader.readAsDataURL(this.playlist.image);
    },
    selectTrack: function selectTrack() {
      if (this.onMobile) {
        console.log("toggle modal");
        this.$store.dispatch('player/toggleMobilePlayer', true);

        if (this.selectedTrackIsPlaying) return;
      }

      // console.log('album-track-item selectTrack', this.trackIndex, this.isPlaying)
      if (this.isPlaying) {
        this.$root.$emit(__WEBPACK_IMPORTED_MODULE_5__helper__["b" /* MyEvents */].AUDIO_PLAYER_SKIPTO, this.trackIndex);
      } else {
        this.setPlaylist([this.album]);
        this.setPlaylistIndex(0);
        this.setPlaying(true);
        this.$root.$emit(__WEBPACK_IMPORTED_MODULE_5__helper__["b" /* MyEvents */].AUDIO_PLAYER_PLAY, this.trackIndex);
      }
    },
    goToAlbumStats: function goToAlbumStats(stats) {
      this.$router.push({ path: '/album/' + this.album.slug + '/stats#' + stats });
    }
  })
});

/***/ }),
/* 1035 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_chat__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_chat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_chat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_comment__ = __webpack_require__(50);



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    comments: Array,
    commentTableType: String,
    item: Object,
    roundAvatar: Boolean,
    roundInput: Boolean,
    aviHeight: {
      type: [String, Number]
    },
    aviWidth: {
      type: [String, Number]
    },
    hideComments: Boolean,
    hideCommentCount: Boolean
  },
  components: {
    Chat: __WEBPACK_IMPORTED_MODULE_0__components_chat___default.a
  },
  data: function data() {
    return {
      commentText: ''
    };
  },

  computed: {
    currentUser: function currentUser() {
      return this.$store.state.auth.user;
    }
  },
  methods: {
    addComment: function addComment() {
      var _this = this;

      if (this.commentText === '') return;
      console.log("====commentTableType=====", this.commentTableType);
      if (this.commentTableType === undefined || this.commentTableType === "") this.commentTableType = "Stream";

      var params = {
        comment: {
          commentable_type: this.commentTableType,
          commentable_id: this.item.id,
          body: this.commentText,
          status: 'published'
        }
      };

      __WEBPACK_IMPORTED_MODULE_1__services_comment__["a" /* default */].sendComment(params).then(function (res) {
        _this.commentText = '';
        _this.reRenderComments();
      }).catch(function (e) {
        console.log("e.body===", e.body);
        _this.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    reRenderComments: function reRenderComments() {
      this.$emit('reRenderComments');
    }
  }
});

/***/ }),
/* 1036 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_contentTopHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_contentTopHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_contentTopHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_auth__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_user_tag__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_user_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_user_tag__);







/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    name: String,
    replaceMenuWith: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tabActivePill: Boolean
  },
  components: {
    contentTopHeader: __WEBPACK_IMPORTED_MODULE_2__components_contentTopHeader___default.a,
    UserTag: __WEBPACK_IMPORTED_MODULE_5__components_user_tag___default.a
  },
  data: function data() {
    return {
      activeTab: "",
      daysFilter: 7,
      tabs: [{
        id: "dashboard",
        title: "Analytics",
        pathName: "Dashboard"
        // icon: require("../../../static/images/edit-curves.svg"),
      }],
      dropdownMenu: [{
        id: "profile",
        title: "Profile",
        pathName: "UserProfile",
        icon: __webpack_require__(428)
      }, {
        id: "settings",
        title: "Settings",
        pathName: "UserSettings",
        icon: __webpack_require__(430)
      }, {
        id: "signOut",
        title: "Sign Out",
        icon: __webpack_require__(1561)
      }]
    };
  },


  computed: {
    currentUser: function currentUser() {
      return this.$store.state.auth.user;
    }
  },

  methods: {
    isActiveTab: function isActiveTab(tab) {
      return this.name === tab;
    },
    isActiveInnerTab: function isActiveInnerTab(tab) {
      return this.activeInnerTab === tab;
    },
    signOut: function signOut() {
      __WEBPACK_IMPORTED_MODULE_3__services_auth__["a" /* default */].signout();
      this.$router.push({ path: '/' });
      this.$root.$emit(__WEBPACK_IMPORTED_MODULE_4__helper__["b" /* MyEvents */].AUTH_SIGNOUT);
    },
    setTab: function setTab(pathName) {
      this.$router.push({ name: pathName });
    },
    setMenuAction: function setMenuAction(menu) {
      switch (menu.id) {
        case "profile":
          this.$router.push("/" + this.currentUser.slug);
          break;
        case "signOut":
          this.signOut();
          break;
        default:
          this.$router.push({ name: menu.pathName });
          break;
      }
    },
    isCreatorVerified: function isCreatorVerified() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!__WEBPACK_IMPORTED_MODULE_3__services_auth__["a" /* default */].isAuthenticated()) {
                  _context.next = 3;
                  break;
                }

                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3__services_auth__["a" /* default */].checkTokenValidation().then(function (response) {
                  if (response.body !== false) {
                    __WEBPACK_IMPORTED_MODULE_3__services_auth__["a" /* default */].setUser(response.body);
                  }
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },

  created: function created() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this2.isCreatorVerified();

            case 2:

              _this2.activeTab = _this2.name;
              if (!(_this2.currentUser.user_type === "artist" || _this2.currentUser.user_type === 'brand')) {
                _this2.tabs = _this2.tabs.filter(function (tab) {
                  return tab.id !== 'sales' && tab.id !== 'manage';
                });
              }
              if (['artist', 'brand'].indexOf(_this2.currentUser.user_type) > -1 && _this2.currentUser.creator_verified !== true) {
                _this2.tabs = _this2.tabs.filter(function (tab) {
                  return tab.id !== 'sales' && tab.id !== 'manage';
                });
              }

              if (_this2.replaceMenuWith.length) {
                _this2.tabs = _this2.replaceMenuWith;
              }

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  }
});

/***/ }),
/* 1037 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_auth__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_genre__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_user__ = __webpack_require__(7);






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    dismiss: {
      type: Function,
      required: true
    }
  },

  data: function data() {
    return {
      // genres: [],
      parent: null,
      region: {},
      parent_index: 0,
      inputDropdown: false,
      show_selector_view: true,
      isPageReady: true,
      selectDemoItems: ['Vuetify', 'Programming'],
      demoItems: ['Programming', 'Design', 'Vue', 'Vuetify'],
      selectedMainGenresIds: [],
      selectedSubgenresIds: [],
      subGenresName: [],
      loading: false
    };
  },


  // created() {
  //   this.isPageReady = false
  //   this.$store.dispatch('error/showLoadingActivity', true)
  //   GenreService.getGenres2().then(response => {
  //     this.genres = response.body
  //     _.each(this.genres, (genre) => {
  //       _.each(genre.children, (g) => { g.value = false })
  //     })
  //     // it stores only child genres statuses
  //     _.each(this.genres, (genre) => {
  //       if (!_.countBy(genre.children, 'value')['false']) {
  //         genre.value = true
  //       }
  //     })
  //     this.isPageReady = true
  //     this.$store.dispatch('error/showLoadingActivity', false)
  //     this.$forceUpdate()
  //   }).catch(e => {
  //     this.$store.dispatch('error/showLoadingActivity', false)
  //   })
  // },

  computed: {
    onMobile: function onMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    currentUser: function currentUser() {
      return this.$store.state.auth;
    },
    genres: function genres() {
      var _this = this;

      var genres = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(this.$store.state.app.genres);
      var hiddenGenres = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.keyBy(this.currentUser.hidden_genres, 'id');

      __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(genres, function (genre) {
        __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(genre.children, function (g) {
          g.value = !hiddenGenres[g.id];
        });
      });

      // it stores only child genres statuses
      __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(genres, function (genre) {
        if (!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.countBy(genre.children, 'value')['false']) {
          genre.value = true;
        }
      });

      if (this.subGenresName.length === 0) {
        genres.forEach(function (genre) {
          genre.children.forEach(function (child) {
            _this.subGenresName.push(child.name.toLowerCase());
            if (_this.selectedSubgenresIds.includes(child.id)) {
              if (!_this.selectedMainGenresIds.includes(genre.id)) {
                _this.selectedMainGenresIds.push(genre.id);
              }
            }
          });
        });
      }

      return genres;
    }
  },

  created: function created() {
    this.selectedSubgenresIds = this.currentUser.user.hidden_genres.map(function (genre) {
      return genre.id;
    });
    // this.genres = _.cloneDeep(this.$store.state.app.genres)
    // let hiddenGenres = _.keyBy(this.$store.state.auth.user.hidden_genres, 'id')
    // _.each(this.genres, (genre) => {
    //   _.each(genre.children, (g) => {
    //     g.value = !hiddenGenres[g.id]
    //   })
    // })
    // // it stores only child genres statuses
    // _.each(this.genres, (genre) => {
    //   if (!_.countBy(genre.children, 'value')['false']) {
    //     genre.value = true
    //   }
    // })
  },


  methods: {
    selectParentGenre: function selectParentGenre(parent) {
      if (this.selectedMainGenresIds.includes(parent.id)) {
        this.selectedMainGenresIds = this.selectedMainGenresIds.filter(function (genre) {
          return genre !== parent.id;
        });
        var childIds = parent.children.map(function (child) {
          return child.id;
        });
        this.selectedSubgenresIds = this.selectedSubgenresIds.filter(function (subgenre) {
          return !childIds.includes(subgenre);
        });
      } else {
        this.selectedMainGenresIds.push(parent.id);
        for (var i = 0; i < parent.children.length; i++) {
          if (!this.selectedSubgenresIds.includes(parent.children[i].id)) {
            this.selectedSubgenresIds.push(parent.children[i].id);
          }
        }
      }
      console.log("main genres ", this.selectedMainGenresIds);
      console.log("Sub genres", this.selectedSubgenresIds);
    },
    selectSubGenre: function selectSubGenre(child, parent) {
      var _this2 = this;

      if (event.target.checked === true) {
        if (!this.selectedMainGenresIds.includes(parent.id)) {
          this.selectedMainGenresIds.push(parent.id);
        }
        this.selectedSubgenresIds.push(child.id);
      } else {
        if (this.selectedSubgenresIds.includes(child.id)) {
          var index = this.selectedSubgenresIds.indexOf(child.id);
          this.selectedSubgenresIds.splice(index, 1);
          // remove select state from parent if no child is present.
          var child_ids = parent.children.map(function (child) {
            return child.id;
          });
          var removeParent = child_ids.filter(function (child) {
            return _this2.selectedSubgenresIds.includes(child);
          }).length === 0;
          if (removeParent) {
            var parentIndex = this.selectedMainGenresIds.indexOf(parent.id);
            this.selectedMainGenresIds.splice(parentIndex, 1);
          }
        }
      }
      console.log("selected subgenres", this.selectedSubgenresIds);
    },
    checkParentGenre: function checkParentGenre(parent, value) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(parent.children, function (g) {
        if (event.target.checked) {
          if (!_this3.selectedMainGenresIds.includes(parent.id)) {
            _this3.selectedMainGenresIds.push(parent.id);
          }
          if (!_this3.selectedSubgenresIds.includes(g.id)) {
            _this3.selectedSubgenresIds.push(g.id);
          }
        } else {
          if (_this3.selectedSubgenresIds.includes(g.id)) {
            var index = _this3.selectedSubgenresIds.indexOf(g.id);
            _this3.selectedSubgenresIds.splice(index, 1);
            // remove select state from parent if no child is present.
            var child_ids = parent.children.map(function (child) {
              return child.id;
            });
            var removeParent = child_ids.filter(function (child) {
              return _this3.selectedSubgenresIds.includes(child);
            }).length === 0;
            if (removeParent) {
              var parentIndex = _this3.selectedMainGenresIds.indexOf(parent.id);
              _this3.selectedMainGenresIds.splice(parentIndex, 1);
            }
          }
        }
      });
      this.$forceUpdate();
    },
    checkRegionGenre: function checkRegionGenre(parent, region) {
      var _this4 = this;

      var key = parent.id + '-' + region;
      // console.log('checkRegionGenre', region, this.region[key])
      __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(parent.children, function (g) {
        if (g.region === region) {
          g.value = !_this4.region[key];
        }
      });
      if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.countBy(parent.children, 'value')['false'] > 0) {
        parent.value = false;
      } else {
        parent.value = true;
      }
      this.$forceUpdate();
    },
    filterRecords: function filterRecords() {
      var _this5 = this;

      var value = event.target.value;

      if (event.key !== 'Backspace') {
        this.subGenresName = this.subGenresName.filter(function (item) {
          return value.toLowerCase().split(' ').every(function (v) {
            return item.toLowerCase().includes(v);
          });
        });
        console.log("this.subGenres ", this.subGenresName);
      } else {
        this.genres.forEach(function (genre) {
          genre.children.forEach(function (child) {
            _this5.subGenresName.push(child.name.toLowerCase());
          });
          _this5.subGenresName = _this5.subGenresName.filter(function (item) {
            return value.toLowerCase().split(' ').every(function (v) {
              return item.toLowerCase().includes(v);
            });
          });
        });
      }
    },
    checkChildGenre: function checkChildGenre(parent, child) {
      var _this6 = this;

      if (event.target.checked) {
        if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.countBy(parent.children, 'value')['false'] == 1) {
          parent.value = true;
          // this.genres = this.genres.slice()
        }
        // checking subgenre
        if (!this.selectedMainGenresIds.includes(parent.id)) {
          this.selectedMainGenresIds.push(parent.id);
        }
        this.selectedSubgenresIds.push(child.id);
      } else {
        if (this.selectedSubgenresIds.includes(child.id)) {
          var index = this.selectedSubgenresIds.indexOf(child.id);
          this.selectedSubgenresIds.splice(index, 1);
          // remove select state from parent if no child is present.
          var child_ids = parent.children.map(function (child) {
            return child.id;
          });
          var removeParent = child_ids.filter(function (child) {
            return _this6.selectedSubgenresIds.includes(child);
          }).length === 0;
          if (removeParent) {
            var parentIndex = this.selectedMainGenresIds.indexOf(parent.id);
            this.selectedMainGenresIds.splice(parentIndex, 1);
          }
        }
      }

      console.log("selected subgenres", this.selectedSubgenresIds);
      this.$forceUpdate();
    },
    getSelectedChildrenCount: function getSelectedChildrenCount(parent) {
      var _this7 = this;

      var c = 0;
      if (this.show_selector_view) {
        c = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.countBy(parent.children, 'value')['true'];
      } else {
        parent.children.map(function (child) {
          if (_this7.selectedSubgenresIds.includes(child.id)) {
            c = c + 1;
          }
        });
      }
      return c;
    },
    groupChildrenByRegion: function groupChildrenByRegion(parent) {
      var _this8 = this;

      var group = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.groupBy(parent.children, 'region');
      __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.forEach(group, function (values, k) {
        var key = parent.id + '-' + k;
        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(_this8.region[key]) !== undefined) {
          _this8.region[key] = true;
          if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.countBy(values, 'value')['false'] > 0) {
            _this8.region[key] = false;
          }
        }
      });
      return group;
    },
    selectParent: function selectParent(parent, index) {
      this.show_selector_view = false;
      this.parent = parent;
      this.parent_index = index;
    },
    saveGenreFilters: function saveGenreFilters() {
      var _this9 = this;

      this.loading = true;
      this.$store.dispatch('error/showLoadingActivity', true);
      this.$store.dispatch('auth/setGenreIds', this.selectedSubgenresIds.join(','));
      var userId = this.$store.state.auth.user.id;
      var params = {
        genre_ids: this.selectedSubgenresIds.join(',')
      };
      __WEBPACK_IMPORTED_MODULE_4__services_user__["a" /* default */].hiddenUserGenres(userId, params).then(function (res) {
        _this9.loading = false;
        _this9.$store.dispatch('error/showLoadingActivity', false);
        _this9.$store.dispatch('error/showSuccessToast', ['Genres Saved successfully.']);
        __WEBPACK_IMPORTED_MODULE_4__services_user__["a" /* default */].getUserInfo(userId).then(function (response) {
          __WEBPACK_IMPORTED_MODULE_2__services_auth__["a" /* default */].setUser(response.body);
          window.location.reload();
        });
      }).catch(function (e) {
        _this9.loading = false;
        _this9.$store.dispatch('error/showLoadingActivity', false);
        _this9.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    }
  }
});

/***/ }),
/* 1038 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_auth__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_genre__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_user__ = __webpack_require__(7);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    dismiss: {
      type: Function,
      required: true
    }
  },

  data: function data() {
    return {
      // genres: [],
      parent: null,
      parent_index: 0,
      show_selector_view: true,
      isPageReady: true
    };
  },


  computed: {
    genres: function genres() {
      var _this = this;

      var genres = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.$store.state.app.genres);

      __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(genres, function (pg) {
        pg.value = false;
      });

      __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(genres, function (pg) {
        __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(pg.children, function (cg) {
          if (cg.id === _this.genre.id) {
            pg.value = true;
          }
        });
      });

      return genres;
    },


    genre: {
      get: function get() {
        return this.$store.getters['genreSelector/genre'];
      },

      set: function set(newValue) {
        this.$store.dispatch('genreSelector/setGenres', [newValue]);
      }
    }
  },

  created: function created() {
    // console.log('genreSelector', this.genre)
    // this.genres = _.cloneDeep(this.$store.state.app.genres)
    // _.each(this.genres, (pg) => {
    //   pg.value = false
    // })
    // _.each(this.genres, (pg) => {
    //   _.each(pg.children, (cg) => {
    //     if (cg.id == this.genre.id) {
    //       pg.value = true
    //     }
    //   })
    // })
  },


  methods: {
    checkChildGenre: function checkChildGenre(parent, child) {
      // console.log('checkChildGenre', parent, child)
      __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(this.genres, function (pg) {
        pg.value = false;
      });

      parent.value = true;

      this.genre = child;
    },
    selectParent: function selectParent(parent, index) {
      this.show_selector_view = false;
      this.parent = parent;
      this.parent_index = index;
    },
    groupChildrenByRegion: function groupChildrenByRegion(parent) {
      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.groupBy(parent.children, 'region');
    }
  }
});

/***/ }),
/* 1039 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_auth__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_twitter__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_invitation__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      keyword: '',
      show_twitter_confirm_dialog: false,
      show_invite_dialog: false,
      link_copied: false
    };
  },


  computed: {
    currentUser: function currentUser() {
      return this.$store.state.auth.user;
    },
    currentPage: function currentPage() {
      return this.$store.state.navigator.current.page;
    }
  },

  watch: {
    $route: function $route(toPath, fromPath) {
      // console.log('header', toPath.path, fromPath.path)
      var keyword = this.$route.query.q;
      if (keyword === undefined) {
        this.keyword = '';
      }
    }
  },

  created: function created() {},
  beforeDestroy: function beforeDestroy() {
    if (this.notification_subscription) {
      this.notification_subscription.unsubscribe();
    }
  },


  methods: {
    openInviteDialog: function openInviteDialog() {
      this.link_copied = false;
      this.show_invite_dialog = true;
    },
    closeInviteDialog: function closeInviteDialog() {
      this.show_invite_dialog = false;
    },
    createInvitation: function createInvitation() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_3__services_invitation__["a" /* default */].createInvitation().then(function (res) {
        // console.log('createInvitation', res.body)
        _this.$copyText(res.body.url);
        _this.link_copied = true;
      }).catch(function (err) {
        return console.log(err);
      });
    },
    goTwitter: function goTwitter(request_type) {
      __WEBPACK_IMPORTED_MODULE_2__services_twitter__["a" /* default */].getRequestToken({
        oauth_callback: window.location.origin + '/_oauth/twitter_callback?user_type=' + request_type + '&code=' + this.$store.state.auth.secret_code
      }).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_4__helper__["g" /* Storage */].set('twitter_info', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.body));
        location.href = 'https://api.twitter.com/oauth/authenticate?oauth_token=' + response.body.oauth_token;
      });
    },
    choosePage: function choosePage(path) {
      this.$router.push({ path: '/' + path });
    },
    goToSearch: function goToSearch() {
      var keyword = this.keyword;
      this.$router.push({ path: '/search', query: { q: keyword } });
    },
    goSupport: function goSupport() {
      window.open('//support.yousound.com', '_blank');
    },
    signOut: function signOut() {
      // const _user = _.cloneDeep(this.$store.state.auth.user)
      __WEBPACK_IMPORTED_MODULE_1__services_auth__["a" /* default */].signout();
      this.$router.push({ path: '/login' });
      this.$root.$emit(__WEBPACK_IMPORTED_MODULE_4__helper__["b" /* MyEvents */].AUTH_SIGNOUT);
    }
  }
});

/***/ }),
/* 1040 */
/***/ (function(module, exports) {



/***/ }),
/* 1041 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_howler__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_howler___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_howler__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_album__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_user__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_downloadmodal__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_downloadmodal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_downloadmodal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_sharemodal__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_sharemodal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_sharemodal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_userFollowBtn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_userFollowBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_userFollowBtn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_track__ = __webpack_require__(55);




// import PaymentService from '@/services/payment'







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    downloadModal: __WEBPACK_IMPORTED_MODULE_6__components_downloadmodal___default.a,
    shareModal: __WEBPACK_IMPORTED_MODULE_7__components_sharemodal___default.a,
    UserFollowBtn: __WEBPACK_IMPORTED_MODULE_8__components_userFollowBtn___default.a
  },

  data: function data() {
    return {
      playlist: [],
      index: 0,
      isLoaded: false,
      isRepeated: false,
      isPlaying: false,
      trackIndex: null,
      trackName: null,
      track: {},
      playedTime: 0,
      progress: 0,
      volume: 100,
      lastVolume: 100,
      showDownloadModal: false,
      showShareModal: false,
      showReminder: false,
      totalTime: null,
      buttonHover: false
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    reminderTracksCount: 'app/reminderTracksCount'
  }), {
    currentUser: function currentUser() {
      return this.$store.state.auth.user;
    },
    MyEvents: function MyEvents() {
      return __WEBPACK_IMPORTED_MODULE_5__helper__["b" /* MyEvents */];
    },
    item: function item() {
      var item = this.$store.state.player.list[this.$store.state.player.listIndex];
      if (!item) {
        return null;
      }

      if (item.assoc_type) {
        return item.assoc;
      } else {
        return item;
      }
    },
    user: function user() {
      if (!this.item) {
        return null;
      }

      if (this.item.album_type === 'album') {
        return this.item.user;
      } else {
        return this.track.user;
      }
    },
    stripeConnected: function stripeConnected() {
      return this.user.stripe_connected;
    },
    album1Cover: function album1Cover() {
      return this._.get(this.item.tracks, '[0].album.cover.url');
    },
    album2Cover: function album2Cover() {
      return this._.get(this.item.tracks, '[1].album.cover.url');
    },
    album3Cover: function album3Cover() {
      return this._.get(this.item.tracks, '[2].album.cover.url');
    },
    album4Cover: function album4Cover() {
      return this._.get(this.item.tracks, '[3].album.cover.url');
    },
    followButtonText: function followButtonText() {
      if (this.user.is_following) {
        return this.buttonHover ? 'Unfollow' : 'Following';
      }
      return 'Follow';
    }
  }),

  created: function created() {
    __WEBPACK_IMPORTED_MODULE_2_howler__["Howler"].volume(this.volume / 100);
  },


  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])({
    setPlaying: 'player/setPlayingStatus',
    setPauseStatus: 'player/setPauseStatus'
  }), {
    startPlaying: function startPlaying(index) {
      this.setPlaylist('next');
      this.play(index);
      this.$forceUpdate();
    },
    resetPlayer: function resetPlayer() {
      if (this.$store.state.player.isPlaying) {
        this.setPlaying(false);
        this.pause();
        this.setPauseStatus(false);
        this.$store.dispatch('player/setPlaylist', []);
        this.$store.dispatch('player/setListIndex', -1);
        this.$store.dispatch('player/setTrackIndex', -1);
        for (var index in this.playlist) {
          var item = this.playlist[index];
          if (item) {
            if (item.howl) {
              item.howl.unload();
            }
          }
        }
        this.playlist = [];
        this.index = 0;
        this.isLoaded = false;
        this.isRepeated = false;
        this.isPlaying = false;
        this.trackIndex = null;
        this.trackName = null;
        this.track = {};
        this.playedTime = 0;
        this.progress = 0;
        this.showDownloadModal = false;
        this.totalTime = null;
        this.buttonHover = false;
      }
    },
    play: function play(index) {
      var _this = this;

      // console.log('player', index, this.index, this.playlist)
      var self = this;
      var sound;
      index = typeof index === 'number' ? index : this.index;
      var data = this.playlist[index];

      // Update the track display.
      // track.innerHTML = (index + 1) + '. ' + data.title
      // this.trackName = this.playlist[index].track.name
      this.trackIndex = index + 1 + ' of ' + this.playlist.length;
      this.track = this.playlist[index].track;
      console.log('player play track player.ctrl', this.track);

      // If we already loaded self track, use the current one.
      // Otherwise, setup and load a new Howl.
      if (data.howl) {
        sound = data.howl;
      } else {
        sound = data.howl = new __WEBPACK_IMPORTED_MODULE_2_howler__["Howl"]({
          src: data.track.audio.url,
          html5: true, // Force to HTML5 so that the audio can stream in (best for large files).
          onplay: function onplay() {
            // Display the duration.
            self.totalTime = self.formatTime(Math.round(sound.duration()));

            // Start upating the progress of the track.
            requestAnimationFrame(self.step.bind(this));

            // Start the wave animation if we have already loaded
            self.isPlaying = true;
            self.setPauseStatus(false);
          },
          onload: function onload() {
            // Start the wave animation.
            self.isLoaded = true;
          },
          onend: function onend() {
            // Stop the wave animation.
            // this.isLoaded = false
            // this.isPlaying = false
            if (self.isRepeated) {
              self.skipTo(self.index);
            } else {
              self.skip('right');
            }
          },
          onpause: function onpause() {
            // Stop the wave animation.
            // this.isPlaying = false
          },
          onstop: function onstop() {
            // Stop the wave animation.
            // this.isPlaying = false
          }
        });
        __WEBPACK_IMPORTED_MODULE_9__services_track__["a" /* default */].playTrack(this.track.id).then(function (response) {
          return console.log("playing - track", _this.track.id);
        });
      }
      // Begin playing the sound.
      sound.play();

      // Show the pause button.
      if (sound.state() === 'loaded') {
        this.isPlaying = true;
      } else {
        this.isLoaded = false;
        this.isPlaying = false;
      }

      // Keep track of the index we are currently playing.
      this.index = index;
      this.$store.dispatch('player/setTrackIndex', index);

      // / Show the reminder on the audio player
      // if (this.index > 0 && this.index % this.reminderTracksCount == 0) {
      //   PaymentService.hasTransactionInPeriod().then(res => {
      //     if (res.body != true) {
      //       this.showReminder = true
      //       setTimeout(() => { this.showReminder = false }, 5000)
      //     }
      //   })
      // }
    },


    /**
     * Pause the currently playing track.
     */
    pause: function pause() {
      // player is not initialized yet.
      if (!this.$store.state.player.isPlaying) return;

      // Get the Howl we want to manipulate.
      var sound = this.playlist[this.index].howl;

      // Puase the sound.
      sound.pause();

      // Show the play button.
      this.isPlaying = false;
      this.setPauseStatus(true);
      // this.setPlaying(false)
    },
    skip: function skip(direction) {
      // Get the next track based on the direction of the track.
      var index = 0;
      if (direction === 'prev') {
        index = this.index - 1;
        if (index < 0) {
          this.$store.dispatch('player/setListIndex', this.$store.state.player.listIndex - 1);
          this.setPlaylist('prev');
          index = this.playlist.length - 1;
          // this.$root.$emit('index_change')
        }
      } else {
        index = this.index + 1;
        if (index >= this.playlist.length) {
          index = 0;
          this.$store.dispatch('player/setListIndex', this.$store.state.player.listIndex + 1);
          this.setPlaylist('next');
          // this.$root.$emit('index_change')
        }
      }
      this.$store.dispatch('player/setTrackIndex', index);
      this.skipTo(index);
    },


    /**
     * Skip to a specific track based on its playlist index.
     * @param  {Number} index Index in the playlist.
     */
    skipTo: function skipTo(index) {
      // Stop the current track.
      var sound = null;
      if (this.playlist[this.index] !== null && this.playlist[this.index] !== undefined) {
        if (this.playlist[this.index].howl !== undefined && this.playlist[this.index].howl !== null) {
          sound = this.playlist[this.index].howl;
          sound.stop();
        }
      }

      // Reset progress.
      this.progress = 0;

      if (this.playlist.length > 0) {
        // Play the new track.
        this.play(index);
      }
    },


    /**
     * Seek to a new position in the currently playing track.
     * @param  {Number} per Percentage through the song to skip.
     */
    seek: function seek(per) {
      // Get the Howl we want to manipulate.
      var sound = this.playlist[this.index].howl;

      // Convert the percent into a seek position.
      if (sound.playing()) {
        sound.seek(sound.duration() * per / 100);
      }
    },


    /**
     * The step called within requestAnimationFrame to update the playback position.
     */
    step: function step() {
      // Get the Howl we want to manipulate.
      var sound = null;
      // var sound = this.playlist[this.index].howl
      if (this.playlist[this.index] !== null && this.playlist[this.index] !== undefined) {
        if (this.playlist[this.index].howl !== undefined && this.playlist[this.index].howl !== null) {
          sound = this.playlist[this.index].howl;

          // Determine our current seek position.
          var seek = sound.seek() || 0;
          this.playedTime = this.formatTime(Math.round(seek));
          this.progress = seek / sound.duration() * 100 || 0;

          // If the sound is still playing, continue stepping.
          if (sound.playing()) {
            requestAnimationFrame(this.step.bind(this));
          }
        }
      }
    },
    setPlaylist: function setPlaylist(direction) {
      // Display the title of the first track.
      var object = this.$store.state.player.list[this.$store.state.player.listIndex];
      var tracks = [];
      if (direction === 'next') {
        for (var i = this.$store.state.player.listIndex; i < this.$store.state.player.list.length; i++) {
          object = this.$store.state.player.list[i];
          if (object.assoc_type) {
            if (object.assoc_type === 'Album') {
              tracks = object.assoc.tracks;
              this.$store.dispatch('player/setListIndex', i);
              this.$root.$emit('index_change');
              break;
            }
          } else {
            tracks = object.tracks;
            this.$store.dispatch('player/setListIndex', i);
            this.$root.$emit('index_change');
            break;
          }
        }
      } else {
        for (i = this.$store.state.player.listIndex; i >= 0; i--) {
          object = this.$store.state.player.list[i];
          if (object.assoc_type) {
            if (object.assoc_type === 'Album') {
              tracks = object.assoc.tracks;
              this.$store.dispatch('player/setListIndex', i);
              this.$root.$emit('index_change');
              break;
            }
          } else {
            tracks = object.tracks;
            this.$store.dispatch('player/setListIndex', i);
            this.$root.$emit('index_change');
            break;
          }
        }
      }
      for (var index in this.playlist) {
        var item = this.playlist[index];
        if (item) {
          if (item.howl) {
            item.howl.unload();
          }
        }
      }
      this.playlist = [];
      this.index = 0;
      if (tracks.length > 0) {
        if (this.currentUser) {
          var album = object.assoc || object;
          __WEBPACK_IMPORTED_MODULE_3__services_album__["a" /* default */].playAlbum(album.id).then(function (response) {
            return console.log('playing - album', album.id);
          });
        }

        for (var track in tracks) {
          this.playlist.push({
            track: tracks[track],
            played: false,
            howl: null
          });
        }
        // if (this.$store.state.player.trackIndex > -1) {
        //   this.index = this.$store.state.player.trackIndex
        // }
        this.$store.dispatch('player/setTrackIndex', 0);
        this.trackIndex = this.index + 1 + ' of ' + this.playlist.length;
        // this.trackName = this.playlist[this.index].track.name
        this.track = this.playlist[this.index].track;
        console.log('player setPlaylist track', this.track);
      } else {
        this.$store.dispatch('player/setListIndex', -1);
        this.$store.dispatch('player/setPlayingStatus', false);
      }
    },
    formatTime: function formatTime(secs) {
      var minutes = Math.floor(secs / 60) || 0;
      var seconds = secs - minutes * 60 || 0;

      return minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
    },
    choosePage: function choosePage(path) {
      this.$router.push({ path: '/' + path });
    },
    dismissDownloadDialog: function dismissDownloadDialog() {
      this.showDownloadModal = false;
    },
    dismissShareDialog: function dismissShareDialog() {
      this.showShareModal = false;
    },
    setRepeated: function setRepeated() {
      this.isRepeated = !this.isRepeated;
    },
    repostItem: function repostItem() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_3__services_album__["a" /* default */].repostAlbum(this.item.id).then(function (response) {
        _this2.$store.dispatch('error/showSuccessToast', ['You just reposted ' + _this2.item.name]);
      }).catch(function (e) {
        _this2.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    setFollowingStatus: function setFollowingStatus(userId, isFollowing) {
      // console.log('player setFollowingStatus', status)
      // console.log(this.user)
      if (this.user && this.user.id === userId) {
        this.$store.dispatch('player/updateFollowingStatus', isFollowing);
      }
    },
    skipTrack: function skipTrack(index) {
      this.skipTo(index);
    },


    // onVolumeChange (evt) {
    //   // console.log('onVolumeChange', evt, this.volume)
    //   this.updateVolume(this.volume)
    // },

    updateVolume: function updateVolume() {
      // console.log('updateVolume', volume)
      __WEBPACK_IMPORTED_MODULE_2_howler__["Howler"].volume(this.volume / 100);
    },
    randomPlay: function randomPlay() {
      this.$store.dispatch('player/setShuffleStatus', !this.$store.state.player.isShuffle);
    }
  }),

  mounted: function mounted() {
    this.$root.$on(__WEBPACK_IMPORTED_MODULE_5__helper__["b" /* MyEvents */].AUDIO_PLAYER_PLAY, this.startPlaying);
    this.$root.$on(__WEBPACK_IMPORTED_MODULE_5__helper__["b" /* MyEvents */].AUDIO_PLAYER_REPLAY, this.play);
    this.$root.$on(__WEBPACK_IMPORTED_MODULE_5__helper__["b" /* MyEvents */].AUDIO_PLAYER_PAUSE, this.pause);
    this.$root.$on(__WEBPACK_IMPORTED_MODULE_5__helper__["b" /* MyEvents */].AUDIO_PLAYER_SKIPTO, this.skipTrack);
    this.$root.$on(__WEBPACK_IMPORTED_MODULE_5__helper__["b" /* MyEvents */].AUTH_SIGNOUT, this.resetPlayer);
    this.$root.$on(__WEBPACK_IMPORTED_MODULE_5__helper__["b" /* MyEvents */].USER_FOLLOW, this.setFollowingStatus);
    this.$root.$on(__WEBPACK_IMPORTED_MODULE_5__helper__["b" /* MyEvents */].STREM_PLAYER_FULLSCREEN_ENTER, this.pause);
  }
});

/***/ }),
/* 1042 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_sideAudioPlayer__ = __webpack_require__(1593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_sideAudioPlayer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_sideAudioPlayer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_sideAudioPlaceholder__ = __webpack_require__(1592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_sideAudioPlaceholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_sideAudioPlaceholder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_sharemodal__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_sharemodal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_sharemodal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_searchInput__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_searchInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_searchInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_auth__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__notificationDrawer__ = __webpack_require__(1587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__notificationDrawer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__notificationDrawer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__languageModal__ = __webpack_require__(1584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__languageModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__languageModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_LogoutModal__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_LogoutModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__views_LogoutModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_base_qr_code__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_base_qr_code___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_base_qr_code__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__helper__ = __webpack_require__(2);















/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    sideAudioPlayer: __WEBPACK_IMPORTED_MODULE_3__components_sideAudioPlayer___default.a,
    sideAudioPlaceholder: __WEBPACK_IMPORTED_MODULE_4__components_sideAudioPlaceholder___default.a,
    shareModal: __WEBPACK_IMPORTED_MODULE_5__components_sharemodal___default.a,
    searchInput: __WEBPACK_IMPORTED_MODULE_6__components_searchInput___default.a,
    notifcationDrawer: __WEBPACK_IMPORTED_MODULE_9__notificationDrawer___default.a,
    languageModal: __WEBPACK_IMPORTED_MODULE_10__languageModal___default.a,
    logoutModal: __WEBPACK_IMPORTED_MODULE_11__views_LogoutModal___default.a,
    QrCode: __WEBPACK_IMPORTED_MODULE_12__components_base_qr_code___default.a
  },
  data: function data() {
    return {
      mini: false,
      customActive: '',
      show_language_modal: false,
      selectedTab: 1,
      searchActive: false,
      show_logout_modal: false,
      showNotification: false,
      tabs: [{
        name: '',
        items: [{
          title: 'You',
          id: 'you',
          icon: 'circle',
          directPath: true,
          path: 'dashboard'
        }, {
          title: 'Feed',
          id: 'feed',
          icon: 'home',
          path: 'Feed'
        }, {
          title: 'Messages',
          id: 'notifications',
          icon: 'mode_comment',
          path: 'NotificationIndex'
        }, {
          title: 'Cart',
          id: 'cart',
          icon: 'shopping_cart',
          path: 'Cart'
        }, {
          title: 'Discover',
          id: 'music',
          icon: 'library_music',
          path: '/music/path'
        }]
      }],
      qrCodeTypeList: __WEBPACK_IMPORTED_MODULE_13__helper__["e" /* QrCodeTypeList */]
    };
  },

  watch: {
    mini: function mini(val) {
      // inform store of Mini's update
      this.$store.dispatch('app/toggleSideBarMini', val);
    },
    onMobile: function onMobile(val) {
      // trigger mini on mobile or screen width reduction
      if (!val) {
        this.mini = false;
      } else {
        this.mini = true;
      }
    },

    isAuthenticated: {
      immediate: true,
      handler: function handler(val) {
        if (!val) {
          this.tabs = this.allTabs;
        } else if (val) {
          this.tabs = this.allTabs;

          // reset username
          this.setUsername();
        }
      }
    }
  },
  methods: {
    openQrCode: function openQrCode(type) {
      return this.$refs.qrCode.openQrCode(type);
    },
    toggleSearch: function toggleSearch() {
      var _this = this;

      this.mini = false;
      this.$nextTick(function () {
        return _this.$refs.search.$el.querySelector('input').focus();
      });
    },
    toggleNotification: function toggleNotification() {
      if (this.showNotification) {
        this.showNotification = false;
      } else {
        this.showNotification = true;
      }
    },
    customActiveTab: function customActiveTab(subMenu) {
      var path = subMenu.path;

      var currentRouteName = this.$route.name;
      var dashboardInherits = ['Dashboard', 'Sell'];

      var discoverInherits = ['VideoIndex', 'ProductIndex'];

      // customization for Dashboard
      if (subMenu.path == 'dashboard' && dashboardInherits.includes(currentRouteName)) {
        path = 'Dashboard';

        return true;
      }

      // customization for DiscoverIndex
      if (subMenu.path == 'AlbumIndex' && discoverInherits.includes(currentRouteName)) {
        path = 'AlbumIndex';
        return true;
      }

      var uploadRouteName = ["UploadAlbum", "ManageIndex", "AddProduct", "UploadIndex", "VideoCreate"];

      if (subMenu.path == 'upload/album' && uploadRouteName.includes(currentRouteName)) {
        return true;
      }

      // return default config
      var active = this.$route.name === path;
      return active;
    },
    menuAction: function menuAction(subMenu) {
      // redundant
      if (subMenu.id === 'activity') {
        // const status = this.$store.state.app.toggleActivity;

        // this.$store.dispatch('app/toggleActivityPopup', !status)
      } else if (subMenu.directPath) {
        this.$router.push('/' + subMenu.path);
      } else {
        this.$router.push({ name: subMenu.path });
      }
    },
    setUsername: function setUsername() {
      // this.tabs.forEach((parent) =>
      //   parent.items.forEach((item) => {
      //     if (item.id === 'you') {
      //       // item.path = this.username
      //       item.title = this.username.toUpperCase()
      //     }
      //   })
      // )
    },
    verifyUser: function verifyUser(subMenu) {
      if (!(subMenu.id === 'music' || subMenu.id === 'subscribe')) {
        this.show_logout_modal = true;
        this.$router.push({ name: 'AlbumIndex' });
      }
    },
    isCreatorVerified: function isCreatorVerified() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!__WEBPACK_IMPORTED_MODULE_8__services_auth__["a" /* default */].isAuthenticated()) {
                  _context.next = 3;
                  break;
                }

                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_8__services_auth__["a" /* default */].checkTokenValidation().then(function (response) {
                  if (response.body !== false) {
                    __WEBPACK_IMPORTED_MODULE_8__services_auth__["a" /* default */].setUser(response.body);
                  }
                });

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    signOut: function signOut() {
      __WEBPACK_IMPORTED_MODULE_8__services_auth__["a" /* default */].signout();
      this.$router.push({ path: '/' });
      this.$root.$emit(MyEvents.AUTH_SIGNOUT);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapGetters */])({
    isAuthenticated: 'auth/isAuthenticated',
    allTabs: 'app/tabs'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapState */])({
    sideBarWidth: function sideBarWidth(state) {
      return state.app.sideBarWidth;
    }
  }), {
    onMobile: function onMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    currentUser: function currentUser() {
      return this.$store.state.auth.user;
    },
    username: function username() {
      return this.$store.state.auth.user.slug;
    },
    badge: function badge() {
      return this.$store.state.activity.badge;
    }
  }),
  mounted: function mounted() {
    if (this.currentUser != null) {
      if (this.currentUser.plan === "pro" && this.currentUser.creator_verified !== true || this.currentUser.plan !== "pro") {
        this.tabs[0].items[0].path = "settings";
      }
      this.setUsername();
      if (this.onMobile) {
        this.mini = true;
      }
    }
  },
  created: function created() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(_this3.currentUser != null)) {
                _context2.next = 4;
                break;
              }

              _context2.next = 3;
              return _this3.isCreatorVerified();

            case 3:
              if (!_this3.currentUser.creator_verified) {
                _this3.tabs[0].items = _this3.tabs[0].items.filter(function (tab) {
                  return tab.id !== "upload";
                });
              }

            case 4:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this3);
    }))();
  }
});

/***/ }),
/* 1043 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_chat__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_auth__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_activity__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_album__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_item__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_product__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_stream__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_user__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_activityalbumcard__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_activityalbumcard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_activityalbumcard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_activityproductcard__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_activityproductcard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_activityproductcard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_activityusercard__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_activityusercard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_activityusercard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_downloadmodal__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_downloadmodal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_downloadmodal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_merchmodal__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_merchmodal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_merchmodal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_paymentmodal__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_paymentmodal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_paymentmodal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_sharemodal__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_sharemodal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_sharemodal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_userFollowBtn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_userFollowBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_userFollowBtn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__helper__ = __webpack_require__(2);

/* global $:true */

























var LATENCY_TIME = 3;
var ActionCable = __webpack_require__(52);
var linkRegex = /(http|ftp|https):\/\/[\w-]+(\.[\w-]+)+([\w.,@?^=%&amp;:/~+#-]*[\w@?^=%&amp;/~+#-])?/;

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    activityAlbumCard: __WEBPACK_IMPORTED_MODULE_12__components_activityalbumcard___default.a,
    activityProductCard: __WEBPACK_IMPORTED_MODULE_13__components_activityproductcard___default.a,
    activityUserCard: __WEBPACK_IMPORTED_MODULE_14__components_activityusercard___default.a,
    downloadModal: __WEBPACK_IMPORTED_MODULE_15__components_downloadmodal___default.a,
    merchModal: __WEBPACK_IMPORTED_MODULE_16__components_merchmodal___default.a,
    paymentModal: __WEBPACK_IMPORTED_MODULE_17__components_paymentmodal___default.a,
    shareModal: __WEBPACK_IMPORTED_MODULE_18__components_sharemodal___default.a,
    UserFollowBtn: __WEBPACK_IMPORTED_MODULE_19__components_userFollowBtn___default.a
  },

  data: function data() {
    return {
      can_view: false,
      exceed_capacity: false,
      player: null,
      time: 0,
      latency_time: LATENCY_TIME,
      watching_interval: null,
      latency_time_interval: null,
      show_payment_dialog: false,
      show_streaming_confirm_dialog: false,
      show_stream_delete_confirm_dialog: false,
      show_album_merch_popup: false,
      show_download_modal: false,
      show_merch_modal: false,
      show_share_dialog: false,
      request_tab: 'Album',
      userSearchKeyword: '',
      assoc: {},
      albums: [],
      products: [],
      users: [],
      buttonHover: false,
      cable: null,
      stream_subscription: null,
      chat_socket: null,
      moment: __WEBPACK_IMPORTED_MODULE_3_moment___default.a,
      room: {
        settings: {
          links: false,
          charLimitBool: false,
          charLimit: 100,
          attachments: true
        },
        online: [],
        idle: []
      },
      message: '',
      messages: [],
      albumLinks: {},
      merchLinks: {},
      userLinks: {},
      notAttachments: [],
      isPageReady: false
    };
  },


  computed: {
    currentUser: function currentUser() {
      return this.$store.state.auth.user;
    },
    stream: function stream() {
      return this.$store.state.streamPlayer.stream;
    },
    streamGenreName: function streamGenreName() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(this.stream, 'genre.name', '');
    },


    // #TODO change user -> streamingUser
    user: function user() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(this.stream, 'user', null);
    },
    album: function album() {
      // return this.albums[0]
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(this.stream, 'assoc');
    },
    product: function product() {
      // return this.products[0]
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(this.stream, 'assoc');
    },
    reverseMessages: function reverseMessages() {
      return this.messages.slice(0, 3).reverse();
    },
    isInCart: function isInCart() {
      var _this = this;

      if (this.stream.assoc_type !== 'ShopProduct') {
        return false;
      }

      var item = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(this.$store.state.user.cartItems, function (item) {
        return item.product_id === _this.stream.assoc.id;
      });

      return !!item;
    },
    showAttachButton: function showAttachButton() {
      return this.stream && ['Album', 'ShopProduct', 'User'].indexOf(this.stream.assoc_type) === -1;
    },


    /* add latency on playing video confirmation dialog */
    enabledPlaying: function enabledPlaying() {
      return this.latency_time <= 0;
    },
    latencyTime: function latencyTime() {
      return this.enabledPlaying ? '' : ' (' + this.latency_time + ')';
    },
    followButtonText: function followButtonText() {
      if (this.user.is_following) {
        return this.buttonHover ? 'Unfollow' : 'Following';
      }
      return 'Follow';
    }
  },

  watch: {
    $route: function $route(toPath, fromPath) {
      // console.log('stream-player', toPath.path, fromPath.path)
      this.show_payment_dialog = false;
      this.show_streaming_confirm_dialog = false;
    },


    message: function message(newVal, oldVal) {
      // console.log('message', newVal, oldVal)
      if (newVal === '') {
        $('#my_video').removeClass('is-chatting');
      } else {
        $('#my_video').addClass('is-chatting');
      }
    },

    show_streaming_confirm_dialog: function show_streaming_confirm_dialog(val) {
      if (!val) {
        if (this.latency_time_interval) {
          clearInterval(this.latency_time_interval);
          this.latency_time_interval = null;
        }
      }
    }
  },

  created: function created() {
    var _this2 = this;

    // console.log('stream-player created')
    // this.$root.$on(MyEvents.AUTH_SIGNOUT, this.archiveStream)
    this.$root.$on(__WEBPACK_IMPORTED_MODULE_20__helper__["b" /* MyEvents */].AUDIO_PLAYER_PLAY, this.mutePlayer);
    this.$root.$on(__WEBPACK_IMPORTED_MODULE_20__helper__["b" /* MyEvents */].AUDIO_PLAYER_REPLAY, this.mutePlayer);
    this.$root.$on(__WEBPACK_IMPORTED_MODULE_20__helper__["b" /* MyEvents */].AUDIO_PLAYER_PAUSE, this.unmutePlayer);
    this.$root.$on(__WEBPACK_IMPORTED_MODULE_20__helper__["b" /* MyEvents */].STREM_PLAYER_INIT, this.init);
    this.$root.$on(__WEBPACK_IMPORTED_MODULE_20__helper__["b" /* MyEvents */].STREM_PLAYER_SHUTDOWN, this.closePlayer);
    this.$root.$on(__WEBPACK_IMPORTED_MODULE_20__helper__["b" /* MyEvents */].USER_FOLLOW, this.setFollowingStatus);

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_7__services_album__["a" /* default */].getAlbums({
      statuses: 'published, collaborated',
      user_statuses: 'accepted'
    }), __WEBPACK_IMPORTED_MODULE_9__services_product__["a" /* default */].getProducts({
      statuses: 'published, collaborated',
      stock_statuses: 'active',
      user_statuses: 'accepted'
    })]).then(function (values) {
      _this2.albums = values[0].body;
      _this2.products = values[1].body;
    }).catch(function (reason) {
      console.log(reason);
      // this.$store.dispatch('error/showErrorToast', [reason])
    });

    this.cable = ActionCable.createConsumer("wss://api.yousound.com/cable" + '?token=' + this.$store.state.auth.token);
  },
  beforeDestroy: function beforeDestroy() {
    console.log('stream-player beforeDestroy');
    // this.$root.$off(MyEvents.AUTH_SIGNOUT, this.archiveStream)
    this.$root.$off(__WEBPACK_IMPORTED_MODULE_20__helper__["b" /* MyEvents */].AUDIO_PLAYER_PLAY, this.mutePlayer);
    this.$root.$off(__WEBPACK_IMPORTED_MODULE_20__helper__["b" /* MyEvents */].AUDIO_PLAYER_REPLAY, this.mutePlayer);
    this.$root.$off(__WEBPACK_IMPORTED_MODULE_20__helper__["b" /* MyEvents */].AUDIO_PLAYER_PAUSE, this.unmutePlayer);
    this.$root.$off(__WEBPACK_IMPORTED_MODULE_20__helper__["b" /* MyEvents */].STREM_PLAYER_INIT, this.init);
    this.$root.$off(__WEBPACK_IMPORTED_MODULE_20__helper__["b" /* MyEvents */].STREM_PLAYER_SHUTDOWN, this.closePlayer);
    this.$root.$off(__WEBPACK_IMPORTED_MODULE_20__helper__["b" /* MyEvents */].USER_FOLLOW, this.setFollowingStatus);
    this.closePlayer();
  },


  methods: {
    init: function init() {
      var _this3 = this;

      console.log('stream-player initializing...');
      // this.player.load('https://edge.flowplayer.org/functional.m3u8')
      // this.initPlayer('https://edge.flowplayer.org/functional.m3u8')
      // this.openStreamingConfirmDialog()
      this.can_view = false;
      this.exceed_capacity = false;
      __WEBPACK_IMPORTED_MODULE_10__services_stream__["a" /* default */].canViewStream(this.stream.id).then(function (response) {
        if (response.body.code) {
          // console.log(1, response.body.code)
          _this3.can_view = true;
          _this3.openStreamingConfirmDialog();
        } else if (response.body.amount > 0) {
          // console.log(2, response.body.amount)
          _this3.openStreamingConfirmDialog();
          // this.openPaymentDialog()
        } else if (response.body.amount === 0) {
          _this3.exceed_capacity = true;
          _this3.show_streaming_confirm_dialog = true;
        } else {
          // console.log(3, response.body.message)
          _this3.$store.dispatch('error/showErrorToast', [response.body.message]);
        }
      });
    },
    initPlayer: function initPlayer(url) {
      var _this4 = this;

      var vm = this;
      // console.log(vm.$refs.myVideoPlayer)
      // vm.$refs.myVideoPlayer.appendChild(
      //   $(
      //     '<video ref="myVideo" id="my_video" class="video-js vjs-default-skin vjs-fluid" controls width="640" height="264"></video>'
      //   )
      // )
      vm.player = vm.player || window.videojs('my_video', {
        autoplay: true,
        controls: true,
        sources: [{
          type: 'application/x-mpegURL',
          src: url
        }]
      }, function () {
        console.log('stream_player ready', this);
        vm.player = this;

        vm.$store.dispatch('streamPlayer/setStatus', 'active');

        // change to full screen
        // vm.player.requestFullscreen()

        // console.log(vm.$refs.myVideo)
        // console.log(vm.$refs.closeButton)
        // vm.$refs.myVideo.parentNode.appendChild(vm.$refs.closeButton)
        document.getElementById('my_video').appendChild(vm.$refs.myOverlay);
        document.getElementById('my_video').appendChild(vm.$refs.closeButton);

        vm.player.on('fullscreenchange', function () {
          if (vm.player.isFullscreen()) {
            console.log('stream_player fullscreen');
            vm.$store.dispatch('streamPlayer/setFrameMode', 'full');
            vm.$root.$emit(__WEBPACK_IMPORTED_MODULE_20__helper__["b" /* MyEvents */].STREM_PLAYER_FULLSCREEN_ENTER);
            vm.player.muted(false);
            vm.player.volume(1.0);
          } else {
            console.log('stream_player fullscreen-exit');
            vm.$store.dispatch('streamPlayer/setFrameMode', 'normal');
            if (vm.$store.state.player.isPlaying && !vm.$store.state.player.isPaused) {
              vm.player.muted(false);
            }
          }
        });

        vm.player.on('dispose', function () {
          vm.$root.$emit(__WEBPACK_IMPORTED_MODULE_20__helper__["b" /* MyEvents */].STREM_PLAYER_EXIT, __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(vm.$store.state.streamPlayer.stream, 'user.username', ''));
          vm.$store.commit('streamPlayer/reset');

          var videoElement = document.createElement('video');
          videoElement.ref = 'myVideo';
          videoElement.id = 'my_video';
          videoElement.className = 'video-js vjs-default-skin vjs-fluid';
          videoElement.controls = true;
          vm.$refs.myVideoPlayer.appendChild(videoElement);
          vm.$forceUpdate();
        });
      });

      this.stream_subscription = this.cable.subscriptions.create({
        channel: 'StreamsChannel',
        stream_id: vm.$store.state.streamPlayer.stream.id
      }, {
        connected: function connected() {
          console.log('connected to StreamsChannel');
        },
        received: function received(data) {
          console.log('stream_subscription');
          console.log(data);
          if (data.assoc_type) {
            vm.$store.dispatch('streamPlayer/updateStreamAssoc', data);
          } else if (data.notified) {
            console.log('signal comming');
          } else {
            vm.$store.dispatch('streamPlayer/addStats', data);
          }
        },
        disconnected: function disconnected() {
          console.log('disconnected to StreamsChannel :(');
        }
      });

      this.watching_interval = setInterval(function () {
        __WEBPACK_IMPORTED_MODULE_10__services_stream__["a" /* default */].watchingStream(_this4.stream.id);
      }, 60000);

      /*
      this.chat_socket = new SocketManager(
        process.env.CHAT_SERVER_URL,
        this.user.slug,
        AuthService.getToken(),
        () => {
          this.chat_socket.onDisconnect = () => {
            console.log('streamPlayer onDisconnect')
          }
           this.chat_socket.onMessage = function (message) {
            // console.log('streamPlayer onMessage', message)
            if (!message) return
             // look up the username in message.from to get image, etc.
            if (message.from === vm.currentUser.username) {
              message.me = true
              message.fromUser = vm.currentUser
              vm.messages.unshift(message)
            } else {
              UserService.getUserInfo(message.from).then((response) => {
                message.fromUser = response.body
                if (vm.messages.length) {
                  if (vm.messages[0].localId !== message.localId) {
                    vm.messages.unshift(message)
                  }
                }
              })
            }
             if (vm.isAlbumLink(message.text)) {
              vm.getAlbumFromLink(message.text)
            }
             if (vm.isMerchLink(message.text)) {
              vm.getMerchFromLink(message.text)
            }
             if (vm.isUserLink(message.text)) {
              vm.getUserFromLink(message.text)
            }
          }
           // this.chat_socket.onUserInfo = function (user) {
          //   console.log('streamPlayer onUserInfo')
          //   vm.user = user
          // }
           this.chat_socket.onRoomInfo = async (room) => {
            console.log('streamPlayer onRoomInfo', room)
            // Vue.set(vm, 'room', room)
            vm.room = room
          }
           this.chat_socket.onLoadMessages = function (loadMessageObj) {
            // console.log('streamPlayer onLoadMessages')
            // loadMessageObj is an object {chunk: <chunk number>, data: <array of messages in chunk>, last: <if it's the last chunk>}
            for (
              var i = loadMessageObj.chunk * 500;
              i < (loadMessageObj.chunk + 1) * 500;
              i++
            ) {
              var nextMessage =
                loadMessageObj.data[i - loadMessageObj.chunk * 500]
              if (nextMessage) {
                Vue.set(vm.messages, i, nextMessage)
              }
            }
            vm.messages.map((message) => {
              if (message) {
                if (vm.isAlbumLink(message.text)) {
                  vm.getAlbumFromLink(message.text)
                }
                if (vm.isMerchLink(message.text)) {
                  vm.getMerchFromLink(message.text)
                }
                if (vm.isUserLink(message.text)) {
                  vm.getUserFromLink(message.text)
                }
                if (message.from === vm.currentUser.username) {
                  message.me = true
                }
                UserService.getUserInfo(message.from).then((response) => {
                  Vue.set(message, 'fromUser', response.body)
                })
                return message
              }
            })
          }
        }
      ) */

      // navigate to own video page
      this.$router.push({ name: 'VideoShow', params: { videoId: this.stream.id } });
    },
    getMetrics: function getMetrics() {
      var _this5 = this;

      if (this.user.id !== this.currentUser.id) {
        return;
      }

      var params = {
        page_track: 'Stream: ' + this.stream.id
      };
      __WEBPACK_IMPORTED_MODULE_6__services_activity__["a" /* default */].getMetrics(params).then(function (response) {
        // console.log('getMetrics', response.body)
        _this5.$store.dispatch('streamPlayer/setStats', response.body);
      }).catch(function (e) {
        console.log('getMetrics', e.body.errors || [e.body]);
      });
    },
    onRequestTab: function onRequestTab(tab) {
      if (this.request_tab === tab) {
        return;
      }

      this.request_tab = tab;
      if (this.request_tab === 'User') {
        this.loadUsers();
      }
    },
    loadUsers: function loadUsers() {
      var _this6 = this;

      var params = {
        page: 1,
        per_page: 10
      };
      if (this.userSearchKeyword.length) {
        params['q'] = this.userSearchKeyword;
      }
      __WEBPACK_IMPORTED_MODULE_11__services_user__["a" /* default */].searchUsers(params).then(function (response) {
        _this6.users = response.body.users;
        console.log('loadUser', _this6.assoc);
      }).catch(function (e) {
        _this6.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    selectItem: function selectItem(assoc_type, assoc) {
      var _this7 = this;

      // console.log(assoc_type, assoc)
      this.show_album_merch_popup = false;
      if (assoc.id !== this.assoc.id) {
        this.assoc = assoc;
        var params = {
          stream: {
            assoc_type: assoc_type,
            assoc_id: assoc.id
          }
        };
        __WEBPACK_IMPORTED_MODULE_10__services_stream__["a" /* default */].updateStream(this.stream.id, params).then(function (response) {}).catch(function (e) {
          _this7.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
        });
      }
    },
    removeItem: function removeItem() {
      var _this8 = this;

      this.assoc = {};
      var params = {
        stream: {
          assoc_type: '',
          assoc_id: 0
        }
      };
      __WEBPACK_IMPORTED_MODULE_10__services_stream__["a" /* default */].updateStream(this.stream.id, params).then(function (response) {}).catch(function (e) {
        _this8.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    removeProductFromCart: function removeProductFromCart() {
      var _this9 = this;

      var item = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(this.$store.state.user.cartItems, function (item) {
        return item.product_id === _this9.stream.assoc.id;
      });

      if (item) {
        __WEBPACK_IMPORTED_MODULE_8__services_item__["a" /* default */].deleteCartItem(item.id);
      }
    },
    choosePage: function choosePage(path) {
      this.player.exitFullscreen();
      this.$router.push({ path: '/' + path });
    },
    openPaymentDialog: function openPaymentDialog() {
      this.show_payment_dialog = true;
    },
    closePaymentDialog: function closePaymentDialog() {
      this.show_payment_dialog = false;
    },
    openDownloadModal: function openDownloadModal() {
      this.show_download_modal = true;
    },
    closeDownloadModal: function closeDownloadModal() {
      this.show_download_modal = false;
    },
    openMerchModal: function openMerchModal() {
      this.show_merch_modal = true;
    },
    closeMerchModal: function closeMerchModal() {
      this.show_merch_modal = false;
    },
    openAlbumMerchPopup: function openAlbumMerchPopup() {
      this.show_album_merch_popup = true;
    },
    closeAlbumMerchPopup: function closeAlbumMerchPopup() {
      this.show_album_merch_popup = false;
    },
    openStreamingConfirmDialog: function openStreamingConfirmDialog() {
      this.latency_time = LATENCY_TIME;
      this.show_streaming_confirm_dialog = true;

      var vm = this;
      vm.latency_time_interval = setInterval(function () {
        vm.latency_time--;
        if (vm.enabledPlaying) {
          clearInterval(vm.latency_time_interval);
          vm.latency_time_interval = null;
        }
      }, 1000);
    },
    closeStreamingConfirmDialog: function closeStreamingConfirmDialog() {
      this.show_streaming_confirm_dialog = false;
    },
    openStreamDeleteConfirmDialog: function openStreamDeleteConfirmDialog() {
      this.show_stream_delete_confirm_dialog = true;
    },
    closeStreamDeleteConfirmDialog: function closeStreamDeleteConfirmDialog() {
      this.show_stream_delete_confirm_dialog = false;
    },
    openShareDialog: function openShareDialog() {
      this.show_share_dialog = true;
    },
    closeShareDialog: function closeShareDialog() {
      this.show_share_dialog = false;
    },
    downloadAlbum: function downloadAlbum() {
      var _this10 = this;

      // this.openShareDialog()
      var params = {
        page_track: 'Stream: ' + this.stream.id
      };
      __WEBPACK_IMPORTED_MODULE_7__services_album__["a" /* default */].downloadAlbum(this.stream.assoc.id, params).then(function (response) {
        var a = document.createElement('A');
        a.href = response.body.url;
        a.target = '_blank';
        a.download = '';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }).catch(function (e) {
        _this10.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    visitProfile: function visitProfile() {
      this.player.exitFullscreen();
      this.$router.push({ path: '/' + this.stream.assoc.slug });
    },
    archiveStream: function archiveStream() {
      var _this11 = this;

      console.log('archiveStream', this.user);
      this.closePlayer();
      if (this.stream) {
        __WEBPACK_IMPORTED_MODULE_10__services_stream__["a" /* default */].archiveStream(this.stream.id).then(function (response) {
          _this11.$store.dispatch('auth/setStream', null);
          _this11.$router.push({ path: '/' });
        }).catch(function (e) {
          _this11.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
        });
      }
    },
    repostStream: function repostStream() {
      var _this12 = this;

      __WEBPACK_IMPORTED_MODULE_10__services_stream__["a" /* default */].repostStream(this.stream.id).then(function (response) {
        _this12.$store.commit('streamPlayer/repostStream');
        _this12.$store.dispatch('error/showSuccessToast', ['You just reposted this live stream']);
      }).catch(function (e) {
        _this12.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    payViewStream: function payViewStream(token) {
      var _this13 = this;

      var params = {
        amount: this.stream.view_price
      };
      if (token) {
        params['payment_token'] = token.id;
      }
      __WEBPACK_IMPORTED_MODULE_10__services_stream__["a" /* default */].payViewStream(this.stream.id, params).then(function (response) {
        _this13.closePaymentDialog();
        // this.openStreamingConfirmDialog()
        _this13.can_view = true;
        _this13.onClick();
      }).catch(function (e) {
        _this13.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    viewStream: function viewStream() {
      var _this14 = this;

      __WEBPACK_IMPORTED_MODULE_10__services_stream__["a" /* default */].viewStream(this.stream.id).then(function (response) {
        _this14.getMetrics();
      });
    },
    setFollowingStatus: function setFollowingStatus(userId, isFollowing) {
      if (this.user && this.user.id === userId) {
        this.$store.dispatch('streamPlayer/updateFollowingStatus', isFollowing);
      }
    },
    closeSocket: function closeSocket() {
      if (this.stream_subscription) {
        this.stream_subscription.unsubscribe();
        this.stream_subscription = null;
      }

      if (this.chat_socket) {
        this.chat_socket.close();
        this.chat_socket = null;
      }
    },
    closePlayer: function closePlayer() {
      if (this.player) {
        this.$refs.myVideoPlayer.appendChild(this.$refs.myOverlay);
        this.$refs.myVideoPlayer.appendChild(this.$refs.closeButton);
        this.player.dispose();
        this.player = null;
      }
      // if (this.player) {
      //   this.player.src()
      //   this.player.load()
      //   this.player.hide()
      // }

      if (this.latency_time_interval) {
        clearInterval(this.latency_time_interval);
        this.latency_time_interval = null;
      }

      if (this.watching_interval) {
        clearInterval(this.watching_interval);
        this.watching_interval = null;
      }

      this.closeSocket();
    },
    mutePlayer: function mutePlayer() {
      if (this.player) {
        this.player.muted(true);
      }
    },
    unmutePlayer: function unmutePlayer() {
      if (this.player) {
        this.player.muted(false);
      }
    },
    isAttachmentLink: function isAttachmentLink(string) {
      // const attachmentRegex = /\/((album)|(merch)\/\w{8}-\w{4}-\w{4}-\w{4}-\w{12})|user\/\w+/g
      var attachmentRegex = /\/((album)|(merch)\/\d+)|user\/\w+/g;
      return this.notAttachments.indexOf(string) < 0 && attachmentRegex.test(string);
    },
    isAlbumLink: function isAlbumLink(string) {
      // const albumLinkRegex = /\/album\/\w{8}-\w{4}-\w{4}-\w{4}-\w{12}/g
      var albumLinkRegex = /\/album\/\d+/g;
      return albumLinkRegex.test(string);
    },
    isMerchLink: function isMerchLink(string) {
      // const merchLinkRegex = /\/merch\/\w{8}-\w{4}-\w{4}-\w{4}-\w{12}/g
      var merchLinkRegex = /\/merch\/\d+/g;
      return merchLinkRegex.test(string);
    },
    isUserLink: function isUserLink(string) {
      var userLinkRegex = /\/user\/\w+/g;
      return this.isAttachmentLink(string) && userLinkRegex.test(string);
    },
    getAlbumFromLink: function getAlbumFromLink(string) {
      var _this15 = this;

      var albumId = string.split('/')[2];
      __WEBPACK_IMPORTED_MODULE_7__services_album__["a" /* default */].getAlbum(albumId).then(function (res) {
        if (res.ok) {
          __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(_this15.albumLinks, string, res.body);
        } else {
          _this15.notAttachments.push(string);
        }
      }).catch(function () {
        _this15.notAttachments.push(string);
      });
    },
    getMerchFromLink: function getMerchFromLink(string) {
      var _this16 = this;

      var merchId = string.split('/')[2];
      __WEBPACK_IMPORTED_MODULE_9__services_product__["a" /* default */].getProduct(merchId).then(function (res) {
        if (res.ok) {
          __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(_this16.merchLinks, string, res.body);
        } else {
          _this16.notAttachments.push(string);
        }
      }).catch(function () {
        _this16.notAttachments.push(string);
      });
    },
    getUserFromLink: function getUserFromLink(string) {
      var _this17 = this;

      var userId = string.split('/')[2];
      __WEBPACK_IMPORTED_MODULE_11__services_user__["a" /* default */].getUserInfo(userId).then(function (res) {
        if (res && res.ok) {
          __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(_this17.userLinks, string, res.body);
        } else {
          _this17.notAttachments.push(string);
        }
      }).catch(function () {
        _this17.notAttachments.push(string);
      });
    },
    sendMessage: function sendMessage(messageText) {
      if (this.room.settings.charLimitBool && this.message.length > this.room.settings.charLimit) {
        return false;
      }
      if (!this.room.settings.links && linkRegex.test(this.message)) return; // TODO error instead of returning
      this.chat_socket.sendMessage(messageText, this.currentUser.username);
      this.message = ''; // clear textbox
      $('#msg-container').scrollTop = $('#msg-container').scrollHeight;
      return false;
    },


    onClick: function onClick(e) {
      this.closeStreamingConfirmDialog();

      if (!this.can_view) {
        this.openPaymentDialog();
        return;
      }

      this.closeSocket();
      // this.initPlayer('https://edge.flowplayer.org/functional.m3u8')
      // this.initPlayer('https://edge.flowplayer.org/FlowplayerHTML5forWordPress.m3u8')
      // this.getMetrics()
      // console.log('this.stream.assoc_type', this.stream.assoc_type)
      this.viewStream();
      this.initPlayer(this.stream.mp_channel_1_ep_1_url);
    }
  },

  mounted: function mounted() {}
});

/***/ }),
/* 1044 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_album__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_playlist__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_album_report_dialog__ = __webpack_require__(1572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_album_report_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_album_report_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_downloadmodal__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_downloadmodal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_downloadmodal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_sharemodal__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_sharemodal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_sharemodal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_featureModal__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_featureModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__views_featureModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_track__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_collection__ = __webpack_require__(70);















/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    albumReportDialog: __WEBPACK_IMPORTED_MODULE_6__components_album_report_dialog___default.a,
    downloadModal: __WEBPACK_IMPORTED_MODULE_7__components_downloadmodal___default.a,
    shareModal: __WEBPACK_IMPORTED_MODULE_8__components_sharemodal___default.a,
    featureModal: __WEBPACK_IMPORTED_MODULE_9__views_featureModal___default.a,
    CollectionService: __WEBPACK_IMPORTED_MODULE_11__services_collection__["a" /* default */]
  },

  props: {
    noMeta: {
      type: Boolean,
      default: false
    },
    forCollection: {
      type: Boolean,
      default: false
    },
    playlistId: {
      type: Number,
      default: null
    },
    removeFromPlaylist: {
      type: Function,
      default: null
    },
    meatBall: {
      type: Boolean,
      default: false
    },
    noAction: {
      type: Boolean,
      default: false
    },
    displayDuration: {
      type: Boolean,
      default: false
    },
    hideTrackLength: {
      type: Boolean,
      default: false
    },
    hidePlayButton: {
      type: Boolean,
      default: false
    },
    hideMoreMenu: {
      type: Boolean,
      default: false
    },
    objects: {
      type: Array
    },

    objectIndex: {
      type: Number
    },
    hideButtonAction: {
      type: Function
    },
    showHoverTrackInfo: Boolean,
    playButton2: Boolean,
    playButton2IconHasWhiteBG: Boolean,
    getCollections: Function
  },

  data: function data() {
    return {
      showDownloadModal: false,
      showShareModal: false,
      showFeatureModal: false,
      hide_dialog: false,
      show_report_dialog: false,
      playlist_dialog: false,
      is_component_hover: false,
      is_menu_hover: false,
      menu: false,
      submenu: false,
      playlist: {
        name: '',
        image: null
      },
      page: '',
      selectedImage: null,
      showMenu: false,
      x: 0,
      y: 0,
      show_remove_from_collection_modal: false
    };
  },


  computed: {
    onMobile: function onMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    currentUser: function currentUser() {
      return this.$store.state.auth.user;
    },
    willMenuRender: function willMenuRender() {
      // console.log('willMenuRender', this.item.id, this.is_component_hover, this.is_menu_hover)
      return this.is_menu_hover || this.is_component_hover;
    },
    item: function item() {
      if (this.objects[this.objectIndex].assoc_type) {
        return this.objects[this.objectIndex].assoc;
      } else {
        return this.objects[this.objectIndex];
      }
    },
    isEmptyAlbum: function isEmptyAlbum() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(this.item);
    },


    // isShowUserInfo() {
    //   if (this.$store.state.navigator.current.page === 'stream') {
    //     return true
    //   } else {
    //     return false
    //   }
    // },

    // publisher() {
    //   if (this.objects[this.objectIndex].assoc_type) {
    //     return this.objects[this.objectIndex].publisher
    //   } else {
    //     return this.objects[this.objectIndex].user
    //   }
    // },

    owner: function owner() {
      if (this.objects[this.objectIndex].assoc_type) {
        return this.objects[this.objectIndex].assoc.user;
      } else {
        return this.objects[this.objectIndex].user;
      }
    },
    isPlaying: function isPlaying() {
      var playingItem = this.$store.state.player.list[this.$store.state.player.listIndex];
      if (playingItem !== undefined) {
        if (playingItem.assoc_type === 'Album') {
          playingItem = playingItem.assoc;
        }
        var currentItem = this.objects[this.objectIndex];
        if (currentItem.assoc_type === 'Album') {
          currentItem = currentItem.assoc;
        }
        if (window.location.href.includes("collection") || window.location.href.includes("playlist")) {
          if (playingItem.track && currentItem.track && playingItem.track.id === currentItem.track.id) {
            return true;
          }
        } else {
          if (playingItem.id === currentItem.id) {
            return true;
          }
        }
      }
      return false;
    },
    album1Cover: function album1Cover() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(this.item.tracks, '[0].album.cover.url');
    },
    album2Cover: function album2Cover() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(this.item.tracks, '[1].album.cover.url');
    },
    album3Cover: function album3Cover() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(this.item.tracks, '[2].album.cover.url');
    },
    album4Cover: function album4Cover() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(this.item.tracks, '[3].album.cover.url');
    },
    input_id: function input_id() {
      return 'playlist_image_file_' + this.item.slug + '_' + parseInt(Math.random() * 999999);
    },
    playlists: function playlists() {
      return this.$store.state.playlist.playlists;
    }
  },

  created: function created() {},


  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])({
    setPlaylist: 'player/setPlaylist',
    setPlaylistIndex: 'player/setListIndex',
    setTrackIndex: 'player/setTrackIndex',
    setPlaying: "player/setPlayingStatus"
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["e" /* mapMutations */])({
    setAlbumPrevRoute: 'appMobile/setAlbumPrevRoute'
  }), {
    addToCollection: function addToCollection(album) {
      var _this = this;

      var params = { album_id: album.id };
      __WEBPACK_IMPORTED_MODULE_11__services_collection__["a" /* default */].createCollection(params).then(function (response) {
        _this.$store.dispatch('error/showSuccessToast', ['You just added ' + album.name + ' album in your collection.']);
      }).catch(function (e) {
        _this.$store.dispatch('error/showErrorToast', e.body.errors || [e.body] || [e.body.error]);
      });
    },
    gotoItem: function gotoItem() {
      // store entry point before album page entry
      var currentRoute = this.$route.name;
      if (this.onMobile && currentRoute !== 'AlbumDetail') {
        this.setAlbumPrevRoute(currentRoute);
        return this.$router.push('/' + this.item.album_type + '/' + this.item.slug);
      } else {
        return this.$router.push('/' + this.item.album_type + '/' + this.item.slug);
      }
    },
    playSong: function playSong() {
      if (this.isPlaying && this.$store.state.player.isPaused) {
        this.$root.$emit(__WEBPACK_IMPORTED_MODULE_3__helper__["b" /* MyEvents */].AUDIO_PLAYER_REPLAY, 0);
      } else {
        this.setPlaylist(this.objects);
        this.setPlaylistIndex(this.objectIndex);
        this.setPlaying(true);
        this.$root.$emit(__WEBPACK_IMPORTED_MODULE_3__helper__["b" /* MyEvents */].AUDIO_PLAYER_PLAY, 0);
      }
    },
    pauseSong: function pauseSong() {
      this.$root.$emit(__WEBPACK_IMPORTED_MODULE_3__helper__["b" /* MyEvents */].AUDIO_PLAYER_PAUSE);
    },
    repostItem: function repostItem() {
      var _this2 = this;

      this.menu = false;
      this.submenu = false;
      __WEBPACK_IMPORTED_MODULE_4__services_album__["a" /* default */].repostAlbum(this.item.id).then(function (response) {
        _this2.$store.dispatch('error/showSuccessToast', ['You just reposted ' + _this2.item.name]);
      }).catch(function (e) {
        _this2.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    totalTime: function totalTime() {
      if (this.displayDuration) {
        var duration = window.location.href.includes("collection") || window.location.href.includes("playlist") ? this.item.track.duration : this.item.tracks[0].duration;
        var secs = Math.round(duration);
        var minutes = Math.floor(secs / 60) || 0;
        var seconds = secs - minutes * 60 || 0;

        return minutes + ":" + (seconds < 10 ? "0" : "") + seconds;
      }
    },
    openReportDialog: function openReportDialog() {
      this.menu = false;
      this.submenu = false;
      this.show_report_dialog = true;
    },
    closeReportDialog: function closeReportDialog() {
      this.show_report_dialog = false;
    },
    reportAlbum: function reportAlbum() {
      console.log('reportAlbum');
    },
    showDownloadDialog: function showDownloadDialog() {
      this.menu = false;
      this.submenu = false;
      this.showDownloadModal = true;
    },
    dismissDownloadDialog: function dismissDownloadDialog() {
      this.showDownloadModal = false;
    },
    showShareDialog: function showShareDialog() {
      this.menu = false;
      this.submenu = false;
      this.showShareModal = true;
    },
    dismissShareDialog: function dismissShareDialog() {
      this.showShareModal = false;
    },
    showHideAlbumDialog: function showHideAlbumDialog() {
      this.menu = false;
      this.submenu = false;
      this.hide_dialog = true;
    },
    showTrackMenu: function showTrackMenu(e) {
      var _this3 = this;

      e.preventDefault();
      this.menu = false;
      this.x = e.clientX;
      this.y = e.clientY;
      this.$nextTick(function () {
        _this3.menu = true;
        _this3.is_menu_hover = true;
      });
    },
    hideAlbum: function hideAlbum() {
      var _this4 = this;

      this.menu = false;
      this.submenu = false;
      this.hide_dialog = false;

      __WEBPACK_IMPORTED_MODULE_4__services_album__["a" /* default */].hideAlbum(this.item.id).then(function (response) {
        _this4.$store.dispatch('error/showSuccessToast', ['You just hid ' + _this4.item.name]);
        if (_this4.hideButtonAction) {
          _this4.hideButtonAction(_this4.objects[_this4.objectIndex]);
        }
      }).catch(function (e) {
        _this4.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    addComment: function addComment() {
      this.menu = false;
      this.submenu = false;
    },
    addToMyLabel: function addToMyLabel() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_4__services_album__["a" /* default */].sendLabelRequest(this.item.id).then(function (response) {
        _this5.$store.dispatch('error/showSuccessToast', ['You just send a label request on <' + _this5.item.name + '>']);
      }).catch(function (e) {
        _this5.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    addToNewPlaylist: function addToNewPlaylist() {
      this.menu = false;
      this.playlist = {
        name: '',
        image: null
      };
      this.selectedImage = null;
      this.playlist_dialog = true;
    },
    createPlaylist: function createPlaylist() {
      var _this6 = this;

      if (this.playlist.name == '') {
        this.$store.dispatch('error/showErrorToast', ['Please input Playlist name.']);
        return;
      }

      var params = new FormData();
      params.append('name', this.playlist.name);
      params.append('description', this.playlist.name);
      // if (this.playlist.image) {
      //   params.append('cover', this.playlist.image)
      // }
      // params.append('assoc_id', this.item.id)
      // params.append('assoc_type', 'Album')
      params.append('assoc_id', this.item.tracks[0].id);
      params.append('assoc_type', 'Track');
      this.$store.dispatch('error/showLoadingActivity', true);
      __WEBPACK_IMPORTED_MODULE_5__services_playlist__["a" /* default */].createPlaylist(params).then(function (response) {
        _this6.playlist_dialog = false;
        _this6.$store.dispatch('error/showLoadingActivity', false);
        _this6.$store.dispatch('error/showSuccessToast', ['Added the album to New Playlist ']);

        __WEBPACK_IMPORTED_MODULE_5__services_playlist__["a" /* default */].getPlaylists().then(function (response) {
          _this6.$store.dispatch('playlist/setPlaylists', response.body);
        });
      }).catch(function (e) {
        _this6.$store.dispatch('error/showLoadingActivity', false);
        _this6.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    addToPlaylist: function addToPlaylist(list) {
      var _this7 = this;

      this.menu = false;
      this.submenu = false;
      // const params = new FormData()
      // params.append('assoc_id', this.item.id)
      // params.append('assoc_type', 'Album')
      var params = {
        assoc_id: this.item.tracks[0].id,
        assoc_type: 'Track'
      };
      __WEBPACK_IMPORTED_MODULE_5__services_playlist__["a" /* default */].updatePlaylist(list.id, params).then(function (response) {
        _this7.$store.dispatch('error/showSuccessToast', ['Added the track to <' + list.name + '>']);
      }).catch(function (e) {
        _this7.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    recommendAlbum: function recommendAlbum() {
      var _this8 = this;

      this.menu = false;
      this.submenu = false;
      __WEBPACK_IMPORTED_MODULE_4__services_album__["a" /* default */].recommendAlbum(this.item.id).then(function (response) {
        _this8.item.recommended = true;
        _this8.$store.dispatch('error/showSuccessToast', ['You just recommended ' + _this8.item.name]);
      }).catch(function (e) {
        _this8.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    unrecommendAlbum: function unrecommendAlbum() {
      var _this9 = this;

      this.menu = false;
      this.submenu = false;
      __WEBPACK_IMPORTED_MODULE_4__services_album__["a" /* default */].unrecommendAlbum(this.item.id).then(function (response) {
        _this9.item.recommended = false;
        _this9.$store.dispatch('error/showSuccessToast', ['You just unfeatured ' + _this9.item.name]);
        setTimeout(function () {
          window.location.reload();
        }, 1500);
      }).catch(function (e) {
        _this9.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    imageChanged: function imageChanged(e) {
      var _this10 = this;

      if (e.target.files[0].size > 2097152) {
        // console.log(e.target.files)
        this.$store.dispatch('error/showErrorToast', ['You can upload an image 2MB in maximum']);
        return;
      }

      this.playlist.image = e.target.files[0];
      var reader = new FileReader();
      reader.addEventListener('load', function (event) {
        _this10.selectedImage = event.target.result;
      }, false);
      reader.readAsDataURL(this.playlist.image);
    },
    openRemoveFromCollectionModal: function openRemoveFromCollectionModal() {
      this.show_remove_from_collection_modal = true;
    },
    removeFromCollection: function removeFromCollection() {
      var _this11 = this;

      __WEBPACK_IMPORTED_MODULE_11__services_collection__["a" /* default */].destroy('track', this.item.track.id).then(function (response) {
        _this11.$store.dispatch('error/showSuccessToast', ['Album removed from collection']);
        _this11.show_remove_from_collection_modal = false;
        _this11.getCollections();
      }).catch(function (e) {
        _this11.$store.dispatch('error/showErrorToast', ['Unable to remove track from collection']);
        _this11.show_remove_from_collection_modal = false;
      });
    }
  })
});

/***/ }),
/* 1045 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_activity__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_activityitem__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_activityitem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_activityitem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_invitation__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_contentTopHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_contentTopHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_contentTopHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_user_tag__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_user_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_user_tag__);

// import { mapGetters } from 'vuex'






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    isComp: Boolean
  },
  components: {
    activityItem: __WEBPACK_IMPORTED_MODULE_2__components_activityitem___default.a,
    contentTopHeader: __WEBPACK_IMPORTED_MODULE_4__components_contentTopHeader___default.a,
    userTag: __WEBPACK_IMPORTED_MODULE_5__components_user_tag___default.a
  },

  data: function data() {
    return {
      loading: true,
      show_invite_dialog: false,
      link_copied: false,
      youLogo: __webpack_require__(772),
      active_tab: 'any',
      tabs: [{ id: 'any', title: 'Everything' }, { id: 'repost', title: 'Reposts' }, { id: 'comment', title: 'Commented' }, { id: 'follow', title: 'Followed' }],
      page_index: 1,
      total_pages: 1,
      items_per_page: 8 * 1,
      activities: [],
      isPageReady: false
    };
  },


  watch: {
    show_invite_dialog: function show_invite_dialog(val) {
      if (val === true) {
        this.link_copied = false;
      }
    },
    activities: function activities(val) {
      console.log('activities:', val);
    }
  },

  computed: {
    currentUser: function currentUser() {
      return this.$store.state.auth.user;
    }
  },

  methods: {
    isActiveTab: function isActiveTab(tab) {
      return this.active_tab == tab;
    },
    loadActivities: function loadActivities() {
      var _this = this;

      this.loading = true;
      var params = {
        page: this.page_index,
        per_page: this.items_per_page,
        action_types: this.active_tab
      };

      console.log('params:', params);
      __WEBPACK_IMPORTED_MODULE_1__services_activity__["a" /* default */].getActivities(params).then(function (response) {
        console.log(response);
        _this.activities = _this.activities.concat(response.body.activities);
        _this.page_index = response.body.pagination.current_page;
        _this.total_pages = response.body.pagination.total_pages;
        _this.loading = false;
        _this.isPageReady = true;
      }).catch(function (e) {
        _this.loading = false;
        _this.isPageReady = true;
        _this.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    loadMore: function loadMore() {
      this.page_index += 1;
      this.loadActivities();
    },
    setTab: function setTab(tab) {
      var _this2 = this;

      if (!tab) {
        tab = 'any';
      }
      this.page_index = 1;
      this.total_pages = 1;
      // this.activities = []
      this.$store.dispatch('navigator/goNextState', {
        page: 'activity',
        tab: tab
      });
      this.$nextTick(function () {
        _this2.loadActivities(_this2.activeTab, 1);
      });
    },
    createInvitation: function createInvitation() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_3__services_invitation__["a" /* default */].createInvitation().then(function (res) {
        // console.log('createInvitation', res.body)
        _this3.$copyText(res.body.url);
        _this3.link_copied = true;
      }).catch(function (err) {
        return console.log(err);
      });
    }
  },

  created: function created() {
    var tab = this.$route.hash.substr(1);
    this.setTab(tab);
  }
});

/***/ }),
/* 1046 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_search__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_albums__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_albums___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_albums__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_attendees__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_attendees___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_attendees__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_genres__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_genres___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_genres__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_global_stats__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_global_stats___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_global_stats__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_payments__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_payments___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_payments__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_settings__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_settings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_signups__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_signups___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_signups__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_subscriptions__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_subscriptions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_subscriptions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_streams__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_streams___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_streams__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_users__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_users___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_users__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_contentTopHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_contentTopHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_contentTopHeader__);














/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    albumTab: __WEBPACK_IMPORTED_MODULE_1__components_albums___default.a,
    attendeeTab: __WEBPACK_IMPORTED_MODULE_2__components_attendees___default.a,
    genreTab: __WEBPACK_IMPORTED_MODULE_3__components_genres___default.a,
    globalstatsTab: __WEBPACK_IMPORTED_MODULE_4__components_global_stats___default.a,
    paymentTab: __WEBPACK_IMPORTED_MODULE_5__components_payments___default.a,
    settingTab: __WEBPACK_IMPORTED_MODULE_6__components_settings___default.a,
    signupTab: __WEBPACK_IMPORTED_MODULE_7__components_signups___default.a,
    subscriptionTab: __WEBPACK_IMPORTED_MODULE_8__components_subscriptions___default.a,
    streamTab: __WEBPACK_IMPORTED_MODULE_9__components_streams___default.a,
    userTab: __WEBPACK_IMPORTED_MODULE_10__components_users___default.a,
    contentTopHeader: __WEBPACK_IMPORTED_MODULE_11__components_contentTopHeader___default.a
  },

  data: function data() {
    return {
      tabs: [{ id: 'globalstats', title: 'Dashboard' }, { id: 'signups', title: 'Verification' }, { id: 'users', title: 'Users' }, { id: 'subscriptions', title: 'Subscribers' }, { id: 'albums', title: 'Content' }, { id: 'settings', title: 'Settings' },
      // { id: 'payments', title: 'Payments' },
      { id: 'genres', title: 'Genres' }],
      item: null,
      page_index: 0,
      total_pages: 1,
      items_per_page: 5 * 10,
      feeds: [],
      max25chars: function max25chars(v) {
        return v.length <= 25 || 'Input too long!';
      },
      tmp: '',
      signups_search: '',
      pagination: {},
      genre_headers: [{ text: 'Subgenre', value: 'name', align: 'left' }],
      settings: {
        signups: false,
        login: false,
        uploads: false,
        merch_uploads: false,
        maintenance: false,
        message: 'Test'
      },
      isPageReady: false
    };
  },


  computed: {},

  created: function created() {
    this.$store.dispatch('navigator/goNextState', {
      page: 'admin',
      tab: 'users'
    });
  },


  methods: {
    loadFeeds: function loadFeeds(filter) {
      // this.$store.dispatch('error/showLoadingActivity', true)
      // const params = new FormData()
      // params.append('filter', filter)
      // params.append('page', this.page_index + 1)
      // params.append('per_page', this.items_per_page)
      // // var params = {
      // //   filter: filter
      // // }
      // SearchService.searchStream(params).then(response=> {
      //   this.$store.dispatch('error/showLoadingActivity', false)
      //   this.feeds = this.feeds.concat(response.body.feeds)
      //   this.page_index = response.body.pagination.current_page
      //   this.total_pages = response.body.pagination.total_pages
      // }).catch(e => {
      //   this.$store.dispatch('error/showLoadingActivity', false)
      //   this.$store.dispatch('error/showErrorToast', e.body.errors || [e.body])
      // })
    },
    availableTab: function availableTab(tab) {
      return this.$store.state.auth.user.user_type === 'admin' || this.$store.state.auth.user.user_type === 'moderator' && ['users', 'albums', 'signups', 'attendees', 'subscriptions'].indexOf(tab.id) > -1;
    },
    onTab: function onTab(tab) {
      this.$store.dispatch('navigator/goNextState', { page: 'admin', tab: tab });
    }
  },

  mounted: function mounted() {
    this.$store.state.navigator.current.tab = "globalstats";
  }
});

/***/ }),
/* 1047 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_album__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_track__ = __webpack_require__(55);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    item: {
      type: Object,
      required: true
    },

    dismiss: {
      type: Function,
      required: true
    }
  },

  data: function data() {
    return {
      tracks_headers: [{ text: 'Track Title', value: 'name', align: 'left', sortable: false }, {
        text: 'Sampled from Yousound',
        value: 'status',
        align: 'center',
        sortable: false
      }, { text: 'Played', value: 'status', align: 'played', sortable: false }, { text: '', value: 'status', align: 'center', sortable: false }],
      album: {
        cover: {}
      },
      user: {
        avatar: {}
      },
      tracks: [],
      show_album_credit_dialog: false,
      isPageReady: true
    };
  },


  computed: {
    album_product: function album_product() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(this.album, 'products[0]', null);
    },
    genres: function genres() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(this.album.genres, 'name').join(', ');
    }
  },

  methods: {
    loadData: function loadData() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_2__services_album__["a" /* default */].getAlbum(this.item.slug)]).then(function (values) {
        _this.album = values[0].body;
        _this.user = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.album, 'user', { avatar: {} });
        _this.tracks = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(_this.album, 'tracks', []);
      });
    },
    isSampledTrack: function isSampledTrack(track_id) {
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(this.album.samplings, function (s) {
        return s.sampling_track_id == track_id;
      });
    },
    deleteAlbum: function deleteAlbum() {
      var _this2 = this;

      // console.log('deleteAlbum', this.album.id)
      this.$store.dispatch('error/showLoadingActivity', true);
      __WEBPACK_IMPORTED_MODULE_2__services_album__["a" /* default */].deleteAlbum(this.album.id).then(function (response) {
        _this2.$store.dispatch('error/showLoadingActivity', false);
        _this2.dismiss();
      }).catch(function (e) {
        _this2.$store.dispatch('error/showLoadingActivity', false);
        _this2.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    deleteTrack: function deleteTrack(track_id) {
      var _this3 = this;

      // console.log('deleteTrack', track_id)
      this.$store.dispatch('error/showLoadingActivity', true);
      __WEBPACK_IMPORTED_MODULE_3__services_track__["a" /* default */].deleteTrack(track_id).then(function (response) {
        _this3.$store.dispatch('error/showLoadingActivity', false);
        __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.remove(_this3.tracks, function (item) {
          return item.id == track_id;
        });
        var arr = _this3.tracks.slice();
        _this3.tracks = arr;
        if (_this3.tracks.length === 0) {
          _this3.dismiss();
        }
      }).catch(function (e) {
        _this3.$store.dispatch('error/showLoadingActivity', false);
        _this3.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    }
  },

  created: function created() {
    // this.user = _.get(this.item, 'user', {avatar: {}})
    // this.tracks = _.get(this.item, 'tracks', [])
    this.loadData();
    console.log('album_product', this.album_product);
  }
});

/***/ }),
/* 1048 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_admin__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_album__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_product__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__album_detail_dialog__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__album_detail_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__album_detail_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__product_detail_dialog__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__product_detail_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__product_detail_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_contentTopHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_contentTopHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_contentTopHeader__);










/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    albumDetailDialog: __WEBPACK_IMPORTED_MODULE_4__album_detail_dialog___default.a,
    productDetailDialog: __WEBPACK_IMPORTED_MODULE_5__product_detail_dialog___default.a,
    contentTopHeader: __WEBPACK_IMPORTED_MODULE_6__components_contentTopHeader___default.a
  },

  data: function data() {
    return {
      albums_tabs: [{ id: 'published', title: 'Published Albums' }, { id: 'privated', title: 'Privated Albums' }, { id: 'product', title: 'Products' }],
      albums_tab: 'published',
      small_input: false,
      album_headers: [{ text: 'Title', value: 'name', align: 'left' }, { text: 'Artist Name', value: 'publisher_name', align: 'left' }, { text: '# of Plays', value: 'played', align: 'center' }, { text: '# of Downloads', value: 'downloaded', align: 'center' }, { text: '# of Reposts', value: 'reposted', align: 'center' }, { text: 'Recommended?', value: 'recommended', align: 'center' }],
      product_headers: [{ text: 'Title', value: 'name', align: 'left' }, { text: 'Vendor Name', value: 'vendor_name', align: 'left' }, { text: 'Sales', value: 'sales', align: 'center' }, { text: 'Date Listed', value: 'listed_date', align: 'center' }, { text: '# of Reposts', value: 'reposted', align: 'center' }, { text: 'Recommended?', value: 'recommended', align: 'center' }],
      searchValue: '',
      per_page_options: [10, 20, 30],
      show_album_detail_dialog: false,
      show_product_detail_dialog: false,
      show_album_delete_confirm_modal: false,
      show_product_delete_confirm_modal: false,
      album: {},
      product: {},
      published_albums: [],
      privated_albums: [],
      products: [],
      published_pagination: {
        page: 1,
        rowsPerPage: 10
      },
      privated_pagination: {
        page: 1,
        rowsPerPage: 10
      },
      product_pagination: {
        page: 1,
        rowsPerPage: 10
      },
      total_published_albums: 0,
      total_privated_albums: 0,
      total_products: 0,
      published_loading: false,
      privated_loading: false,
      product_loading: false,
      isPageReady: true
    };
  },
  mounted: function mounted() {
    $(".custom-data-table tfoot").css("display", "table-footer-group");
  },


  methods: {
    loadPublishedAlbums: function loadPublishedAlbums() {
      var _this = this;

      var params = {
        q: this.searchValue,
        statuses: 'published, collaborated',
        page: this.published_pagination.page,
        per_page: this.published_pagination.rowsPerPage
      };
      this.$store.dispatch('error/showLoadingActivity', true);
      __WEBPACK_IMPORTED_MODULE_1__services_admin__["a" /* default */].getAlbums(params).then(function (response) {
        _this.published_albums = response.body.albums;
        _this.total_published_albums = response.body.pagination.total_count;
        _this.$store.dispatch('error/showLoadingActivity', false);
      }).catch(function (e) {
        _this.$store.dispatch('error/showLoadingActivity', false);
      });
    },
    loadPrivatedAlbums: function loadPrivatedAlbums() {
      var _this2 = this;

      var params = {
        q: this.searchValue,
        statuses: 'privated',
        page: this.privated_pagination.page,
        per_page: this.privated_pagination.rowsPerPage
      };
      this.$store.dispatch('error/showLoadingActivity', true);
      __WEBPACK_IMPORTED_MODULE_1__services_admin__["a" /* default */].getAlbums(params).then(function (response) {
        _this2.privated_albums = response.body.albums;
        _this2.total_privated_albums = response.body.pagination.total_count;
        _this2.$store.dispatch('error/showLoadingActivity', false);
      }).catch(function (e) {
        _this2.$store.dispatch('error/showLoadingActivity', false);
      });
    },
    loadProducts: function loadProducts() {
      var _this3 = this;

      var params = {
        statuses: 'published',
        page: this.product_pagination.page,
        per_page: this.product_pagination.rowsPerPage
      };
      this.$store.dispatch('error/showLoadingActivity', true);
      __WEBPACK_IMPORTED_MODULE_1__services_admin__["a" /* default */].getProducts(params).then(function (response) {
        _this3.products = response.body.products;
        _this3.total_products = response.body.pagination.total_count;
        _this3.$store.dispatch('error/showLoadingActivity', false);
      }).catch(function (e) {
        _this3.$store.dispatch('error/showLoadingActivity', false);
      });
    },
    onTab: function onTab(tab) {
      this.albums_tab = tab;
    },
    onKeyEnter: function onKeyEnter(e) {
      // console.log('onKeyEnter', this.albums_tab, this.searchValue, e)
      switch (this.albums_tab) {
        case 'published':
          this.loadPublishedAlbums();
          break;
        case 'privated':
          this.loadPrivatedAlbums();
          break;
        case 'product':
          break;
      }
    },
    openAlbumDeleteConfirmModal: function openAlbumDeleteConfirmModal(album) {
      this.album = album;
      this.show_album_delete_confirm_modal = true;
    },
    closeAlbumDeleteConfirmModal: function closeAlbumDeleteConfirmModal() {
      this.show_album_delete_confirm_modal = false;
    },
    deleteAlbum: function deleteAlbum(album) {
      var _this4 = this;

      this.closeAlbumDeleteConfirmModal();
      __WEBPACK_IMPORTED_MODULE_2__services_album__["a" /* default */].deleteAlbum(album.id).then(function (res) {
        var arr = void 0;
        switch (_this4.albums_tab) {
          case 'published':
            __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.remove(_this4.published_albums, function (item) {
              return item.id === album.id;
            });
            arr = _this4.published_albums.slice();
            _this4.published_albums = arr;
            break;
          case 'privated':
            __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.remove(_this4.privated_albums, function (item) {
              return item.id === album.id;
            });
            arr = _this4.privated_albums.slice();
            _this4.privated_albums = arr;
            break;
        }
      }).catch(function (e) {
        _this4.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    recommendAlbum: function recommendAlbum(album) {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_2__services_album__["a" /* default */].recommendAlbum(album.id).then(function (response) {
        var arr = void 0;
        switch (_this5.albums_tab) {
          case 'published':
            __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(_this5.published_albums, function (item) {
              if (item.id === album.id) item.recommended = true;
            });
            arr = _this5.published_albums.slice();
            _this5.published_albums = arr;
            break;
          case 'privated':
            __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.remove(_this5.privated_albums, function (item) {
              if (item.id === album.id) item.recommended = true;
            });
            arr = _this5.privated_albums.slice();
            _this5.privated_albums = arr;
            break;
        }
      }).catch(function (e) {
        _this5.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    unrecommendAlbum: function unrecommendAlbum(album) {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_2__services_album__["a" /* default */].unrecommendAlbum(album.id).then(function (response) {
        switch (_this6.albums_tab) {
          case 'published':
            {
              __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(_this6.published_albums, function (item) {
                if (item.id === album.id) item.recommended = false;
              });
              var arr = _this6.published_albums.slice();
              _this6.published_albums = arr;
              break;
            }
          case 'privated':
            {
              __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.remove(_this6.privated_albums, function (item) {
                if (item.id === album.id) item.recommended = false;
              });
              var _arr = _this6.privated_albums.slice();
              _this6.privated_albums = _arr;
              break;
            }
        }
      }).catch(function (e) {
        _this6.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    openAlbumDetailDialog: function openAlbumDetailDialog(album) {
      this.album = album;
      this.show_album_detail_dialog = true;
    },
    closeAlbumDetailDialog: function closeAlbumDetailDialog() {
      this.show_album_detail_dialog = false;
    },
    openProductDetailDialog: function openProductDetailDialog(product) {
      this.product = product;
      this.show_product_detail_dialog = true;
    },
    closeProductDetailDialog: function closeProductDetailDialog() {
      this.show_product_detail_dialog = false;
    },
    openProductDeleteConfirmModal: function openProductDeleteConfirmModal(product) {
      this.product = product;
      this.show_product_delete_confirm_modal = true;
    },
    closeProductDeleteConfirmModal: function closeProductDeleteConfirmModal() {
      this.show_product_delete_confirm_modal = false;
    },
    deleteProduct: function deleteProduct(product) {
      var _this7 = this;

      this.closeProductDeleteConfirmModal();
      __WEBPACK_IMPORTED_MODULE_3__services_product__["a" /* default */].deleteProduct(this.product.id).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.remove(_this7.products, function (item) {
          return item.id === product.id;
        });
        var arr = _this7.products.slice();
        _this7.products = arr;
      }).catch(function (e) {
        _this7.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    }
  },

  watch: {
    published_pagination: {
      handler: function handler() {
        this.loadPublishedAlbums();
      }
    },

    privated_pagination: {
      handler: function handler() {
        this.loadPrivatedAlbums();
      }
    },

    product_pagination: {
      handler: function handler() {
        this.loadProducts();
      }
    }
  }
});

/***/ }),
/* 1049 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_attendee__ = __webpack_require__(411);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},

  data: function data() {
    return {
      current_tab: 'all',
      tabs: [{ id: 'all', title: 'All Attendees' }],
      attendee_headers: [{
        text: 'Full Name',
        value: 'full_name',
        align: 'left'
      }, {
        text: 'Artist / Brand / Label Name',
        value: 'display_name',
        align: 'left'
      }, { text: 'Email', value: 'email', align: 'left' }, { text: 'Account Type', value: 'account_type', align: 'left' }, { text: 'Referred By', value: 'referred_by', align: 'left' }, { text: 'Status', value: 'status', align: 'center' }, { text: '', value: '', align: 'center' }],
      search_keyword: '',
      attendees: [],
      attendee: {},
      pagination: {
        sortBy: 'created_at',
        descending: true,
        page: 1,
        rowsPerPage: 10,
        totalItems: 0
      },
      per_page_options: [50, 100, 150],
      show_attendee_delete_confirm_dialog: false,
      isPageReady: true
    };
  },


  computed: {
    currentUser: function currentUser() {
      return this.$store.state.auth.user;
    }
  },

  created: function created() {
    var _this = this;

    this.$store.dispatch('error/showLoadingActivity', true);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_2__services_attendee__["a" /* default */].getAttendees()]).then(function (values) {
      _this.attendees = values[0].body;
      _this.$store.dispatch('error/showLoadingActivity', false);
    }).catch(function (reason) {
      console.log(reason);
      _this.$store.dispatch('error/showLoadingActivity', false);
    });
  },


  methods: {
    inviteAttendee: function inviteAttendee(attendee) {
      var _this2 = this;

      var attendee_id = attendee.id;
      __WEBPACK_IMPORTED_MODULE_2__services_attendee__["a" /* default */].inviteAttendee(attendee_id).then(function (response) {
        var attendeeIndex = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.findIndex(_this2.attendees, function (attendee) {
          return attendee.id === attendee_id;
        });
        _this2.attendees[attendeeIndex].status = 'invited';
        _this2.attendees[attendeeIndex].inviter = _this2.currentUser;
        var arr = _this2.attendees.slice();
        _this2.attendees = arr;
      }).catch(function (e) {
        _this2.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    openAttendeeDeleteConfirmDialog: function openAttendeeDeleteConfirmDialog(attendee) {
      this.attendee = attendee;
      this.show_attendee_delete_confirm_dialog = true;
    },
    closeAttendeeDeleteConfirmDialog: function closeAttendeeDeleteConfirmDialog() {
      this.show_attendee_delete_confirm_dialog = false;
    },
    deleteAttendee: function deleteAttendee(attendee) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_2__services_attendee__["a" /* default */].deleteAttendee(attendee.id).then(function () {
        _this3.closeAttendeeDeleteConfirmDialog();
        _this3.attendees = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(_this3.attendees, function (item) {
          return item.id !== attendee.id;
        });
      }).catch(function (e) {
        _this3.closeAttendeeDeleteConfirmDialog();
        _this3.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    }
  }
});

/***/ }),
/* 1050 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_genre__ = __webpack_require__(93);


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},

  data: function data() {
    return {
      genre_headers: [{ text: 'Subgenre', value: 'name', align: 'left' }],
      genre_category: '',
      genres: [],
      genre: {},
      genre_search: '',
      pagination: {
        sortBy: 'name',
        descending: false,
        rowsPerPage: 10
        // page: 1,
        // totalItems: 0
      },
      per_page_options: [50],
      isPageReady: false
    };
  },


  computed: {
    genre_categories: function genre_categories() {
      var genre_categories = [];
      genre_categories.push({ id: 'main', name: 'Main Category', children: [] });
      genre_categories.push({ id: '', name: 'All', children: [] });
      genre_categories = genre_categories.concat(this.genres);
      return genre_categories;
    },
    filtered_genres: function filtered_genres() {
      if (this.genre_category === '') {
        var genres = [];
        for (var index in this.genres) {
          var genre = this.genres[index];
          if (genre.children.length) {
            genres = genres.concat(genre.children);
          }
        }
        return genres;
      } else if (this.genre_category === 'main') {
        return this.genres;
      } else {
        for (var _index in this.genres) {
          var _genre = this.genres[_index];
          if (_genre.id === this.genre_category) {
            return _genre.children;
          }
        }
      }
    }
  },

  created: function created() {
    // console.log('admin / users created')
    this.loadGenres(false);
  },


  methods: {
    loadGenres: function loadGenres(reload) {
      var _this = this;

      if (!reload) {
        this.$store.dispatch('error/showLoadingActivity', true);
        this.isPageReady = false;
      }
      __WEBPACK_IMPORTED_MODULE_0__services_genre__["a" /* default */].getGenres2().then(function (response) {
        _this.$store.dispatch('error/showLoadingActivity', false);
        _this.isPageReady = true;
        // this.genres.push({id:'main', name: 'Main Category', children:[]})
        // this.genres.push({id:'', name: 'All', children:[]})
        _this.genres = response.body;
      }).catch(function (e) {
        _this.$store.dispatch('error/showLoadingActivity', false);
        _this.isPageReady = true;
        _this.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    addGenre: function addGenre() {
      var _this2 = this;

      var params = new FormData();
      if (this.genre_search.length) {
        console.log(params);
        params.append('genre[name]', this.genre_search);
        if (this.genre_category !== '' && this.genre_category !== 'main') {
          params.append('genre[ancestry]', this.genre_category);
        }
      } else {
        this.$store.dispatch('error/showErrorToast', ['Please input genre name.']);
      }
      __WEBPACK_IMPORTED_MODULE_0__services_genre__["a" /* default */].addGenre2(params).then(function (response) {
        _this2.genre_search = '';
        _this2.loadGenres(true);
      }).catch(function (e) {
        _this2.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    updateGenre: function updateGenre(genre) {
      var _this3 = this;

      var params = new FormData();
      if (genre.name.length) {
        params.append('genre[name]', genre.name);
      } else {
        this.$store.dispatch('error/showErrorToast', ['Please input genre name.']);
      }
      __WEBPACK_IMPORTED_MODULE_0__services_genre__["a" /* default */].updateGenre2(genre.id, params).then(function (response) {
        console.log(response);
      }).catch(function (e) {
        _this3.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    deleteGenre: function deleteGenre(genre) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_0__services_genre__["a" /* default */].deleteGenres2(genre.id).then(function (response) {
        if (_this4.genre_category === 'main') {
          _.remove(_this4.genres, function (item) {
            return item.id === genre.id;
          });
          var arr = _this4.genres.slice();
          _this4.genres = arr;
        } else {
          _this4.loadGenres(true);
        }
      }).catch(function (e) {
        _this4.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    }
  },

  mounted: function mounted() {}
});

/***/ }),
/* 1051 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_admin__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_dashboard_DashboardItem_vue__ = __webpack_require__(779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_dashboard_DashboardItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_dashboard_DashboardItem_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_dashboard_LineChart_vue__ = __webpack_require__(781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_dashboard_LineChart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_dashboard_LineChart_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_dashboard_DonutChart_vue__ = __webpack_require__(780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_dashboard_DonutChart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_dashboard_DonutChart_vue__);








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    DashboardItem: __WEBPACK_IMPORTED_MODULE_4__components_dashboard_DashboardItem_vue___default.a,
    LineChart: __WEBPACK_IMPORTED_MODULE_5__components_dashboard_LineChart_vue___default.a,
    DonutChart: __WEBPACK_IMPORTED_MODULE_6__components_dashboard_DonutChart_vue___default.a
  },

  data: function data() {
    return {
      statsList: null,
      topList: [{ title: "Rap / Hip Hop", number: "12.3m" }, { title: "Latin", number: "12.3m" }, { title: "Rock", number: "12.3m" }, { title: "Future R&B", number: "12.3m" }, { title: "Classical", number: "12.3m" }],
      globalstats_categories: ['YESTERDAY', 'LAST MONTH', 'TOTAL'],
      globalstats_category: 'TOTAL',
      globalstats: [{ name: 'Total Users', value: 0 }, { name: 'Logins', value: 0 }, { name: 'Listener Signups', value: 0 }, { name: 'Artist Signups', value: 0 }, { name: 'Brand Signups', value: 0 }, { name: 'Label Signups', value: 0 }, { name: 'Uploads', value: 0 }, { name: 'Downloads', value: 0 }, { name: 'Plays', value: 0 }, { name: 'Product Uploads', value: 0 }, { name: 'Product Sales', value: 0 }, { name: 'Reposted Albums', value: 0 }, { name: 'Reposted Products', value: 0 }, { name: 'Free Stream Hours', value: '00:00' }, { name: 'Demand Stream Hours', value: '00:00' }, { name: '# of Donations', value: 0 }, { name: 'Revenue made from Donations', value: '0.00' }, { name: 'Playlists Created', value: 0 }, { name: 'Top 5 downloaded genres', value: '' }, { name: 'Top 5 listened genres', value: '' }, { name: 'Cancelled Accounts', value: 0 }],
      per_page_options: [50, { text: 'All', value: -1 }],
      isPageReady: false
    };
  },
  created: function created() {
    this.loadData();
  },


  methods: {
    loadData: function loadData() {
      var _this = this;

      // this.isPageReady = false
      // this.$store.dispatch('error/showLoadingActivity', true)
      var now = __WEBPACK_IMPORTED_MODULE_1_moment___default()();
      var params = {};
      switch (this.globalstats_category) {
        case 'YESTERDAY':
          params = {
            start_date: now.clone().subtract(1, 'days').startOf('day').format(),
            end_date: now.clone().subtract(1, 'days').endOf('day').format()
          };
          break;
        case 'LAST MONTH':
          params = {
            start_date: now.clone().subtract(1, 'months').startOf('month').format(),
            end_date: now.clone().subtract(1, 'months').endOf('month').format()
          };
          break;
      }
      __WEBPACK_IMPORTED_MODULE_3__services_admin__["a" /* default */].getGlobalStats(params).then(function (response) {
        var stats = response.body;
        _this.statsList = response.body;
        _this.globalstats = [{ name: 'Total Users', value: stats.total_users }, { name: 'Logins', value: stats.login_users }, { name: 'Listener Signups', value: stats.signup_listener_users }, { name: 'Artist Signups', value: stats.signup_artist_users }, { name: 'Brand Signups', value: stats.signup_brand_users }, { name: 'Label Signups', value: stats.signup_label_users }, { name: 'Uploads', value: stats.uploaded_albums }, { name: 'Downloads', value: stats.downloaded_albums }, { name: 'Plays', value: stats.played_albums }, { name: 'Product Uploads', value: stats.uploaded_products }, { name: 'Product Sales', value: stats.sold_products }, { name: 'Reposted Albums', value: stats.reposted_albums }, { name: 'Reposted Products', value: stats.reposted_products }, {
          name: 'Free Stream Hours',
          value: __WEBPACK_IMPORTED_MODULE_2__helper__["a" /* Filter */].timeInHours(stats.free_stream_seconds)
        }, {
          name: 'Demand Stream Hours',
          value: __WEBPACK_IMPORTED_MODULE_2__helper__["a" /* Filter */].timeInHours(stats.demand_stream_seconds)
        }, { name: '# of Donations', value: stats.donations_count }, {
          name: 'Revenue made from Donations',
          value: __WEBPACK_IMPORTED_MODULE_2__helper__["a" /* Filter */].formatNumber(stats.donations_revenue)
        }, { name: 'Playlists Created', value: stats.created_playlists }, {
          name: 'Top 5 downloaded genres',
          value: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(stats.top_5_downloaded_genres, 'name').join(', ')
        }, {
          name: 'Top 5 listened genres',
          value: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(stats.top_5_played_genres, 'name').join(', ')
        }, { name: 'Cancelled Accounts', value: stats.cancelled_accounts }];
      }).catch(function (e) {
        console.log(e);
      });
    }
  },

  watch: {
    globalstats_category: {
      handler: function handler() {
        this.loadData();
      }
    }
  }
});

/***/ }),
/* 1052 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_payment__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_contentTopHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_contentTopHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_contentTopHeader__);
// import AdminService from '@/services/admin'




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    contentTopHeader: __WEBPACK_IMPORTED_MODULE_2__components_contentTopHeader___default.a
  },

  data: function data() {
    return {
      tabs: [{ id: 'all', title: 'All Transactions' }],
      active_tab: 'all',
      small_input: false,
      headers: [{ text: 'Sender', value: 'sender.display_name', align: 'left' }, { text: 'Receiver', value: 'receiver.display_name', align: 'left' }, { text: 'Sent Amount', value: 'sent_amount', align: 'center' }, { text: 'Received Amount', value: 'received_amount', align: 'center' }, { text: 'Type', value: 'payment_type', align: 'center' }, { text: 'Status', value: 'status', align: 'center' }, { text: 'Created', value: 'created_at', align: 'center' }],
      searchValue: '',
      per_page_options: [50, 100, 150],
      all_transactions: [],
      refunded_transactions: [],
      all_pagination: {
        page: 1,
        rowsPerPage: 10
      },
      refunded_pagination: {
        page: 1,
        rowsPerPage: 10
      },
      total_all_transactions: 0,
      total_refunded_transactions: 0,
      calculateFee: __WEBPACK_IMPORTED_MODULE_1__helper__["d" /* Stripe */].calculateFee,
      isPageReady: true
    };
  },
  created: function created() {},


  methods: {
    loadAllTransactions: function loadAllTransactions() {
      var _this = this;

      var params = {
        q: this.searchValue,
        page: this.all_pagination.page,
        per_page: this.all_pagination.rowsPerPage
      };
      this.$store.dispatch('error/showLoadingActivity', true);
      __WEBPACK_IMPORTED_MODULE_0__services_payment__["a" /* default */].getAllPayments(params).then(function (response) {
        _this.all_transactions = response.body.payments;
        _this.total_all_transactions = response.body.pagination.total_count;
        _this.$store.dispatch('error/showLoadingActivity', false);
      }).catch(function (e) {
        _this.$store.dispatch('error/showLoadingActivity', false);
      });
    },
    loadRefundedTransactions: function loadRefundedTransactions() {
      var _this2 = this;

      var params = {
        q: this.searchValue,
        payment_types: 'refund',
        page: this.all_pagination.page,
        per_page: this.all_pagination.rowsPerPage
      };
      this.$store.dispatch('error/showLoadingActivity', true);
      __WEBPACK_IMPORTED_MODULE_0__services_payment__["a" /* default */].getAllPayments(params).then(function (response) {
        _this2.refunded_transactions = response.body.payments;
        _this2.total_refunded_transactions = response.body.pagination.total_count;
        _this2.$store.dispatch('error/showLoadingActivity', false);
      }).catch(function (e) {
        _this2.$store.dispatch('error/showLoadingActivity', false);
      });
    },
    onTab: function onTab(tab) {
      this.active_tab = tab;
    },
    onKeyEnter: function onKeyEnter(e) {
      // console.log('onKeyEnter', this.active_tab, this.searchValue, e)
      switch (this.active_tab) {
        case 'all':
          this.loadAllTransactions();
          break;
        case 'refunded':
          this.loadRefundedTransactions();
          break;
      }
    }
  },

  watch: {
    all_pagination: {
      handler: function handler() {
        this.loadAllTransactions();
      }
    },

    refunded_pagination: {
      handler: function handler() {
        this.loadRefundedTransactions();
      }
    }
  }
});

/***/ }),
/* 1053 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_product__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_item__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_ticket__ = __webpack_require__(425);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    item: {
      type: Object,
      required: true
    },

    dismiss: {
      type: Function,
      required: true
    }
  },

  data: function data() {
    return {
      tabs: [{ id: 'items', title: 'Orders' }, { id: 'open_tickets', title: 'Open Cases' }, { id: 'closed_tickets', title: 'Closed Cases' }],
      active_tab: 'items',
      items_headers: [{
        text: 'Username',
        value: 'username',
        align: 'left',
        sortable: false,
        width: '1%'
      }, {
        text: 'Date',
        value: 'order.created_at',
        align: 'left',
        sortable: false,
        width: '1%'
      }, {
        text: 'Price',
        value: 'price',
        align: 'center',
        sortable: false,
        width: '1%'
      }, {
        text: 'Quantity',
        value: 'quantity',
        align: 'center',
        sortable: false,
        width: '1%'
      }, {
        text: 'Shipping',
        value: 'shipping_cost',
        align: 'center',
        sortable: false,
        width: '1%'
      }, {
        text: 'Tax',
        value: 'tax_cost',
        align: 'center',
        sortable: false,
        width: '1%'
      }, { text: 'Address', value: 'status', align: 'center', sortable: false }],
      open_tickets_headers: [{ text: 'Username', value: 'username', align: 'left', sortable: false }, {
        text: 'Date Opened',
        value: 'created_at',
        align: 'left',
        sortable: false
      }, { text: 'Reason', value: 'reason', align: 'center', sortable: false }, {
        text: 'Explanation',
        value: 'description',
        align: 'center',
        sortable: false
      }, {
        text: 'Close Case',
        value: 'status',
        align: 'center',
        sortable: false
      }],
      closed_tickets_headers: [{ text: 'Username', value: 'username', align: 'left', sortable: false }, {
        text: 'Date Opened',
        value: 'created_at',
        align: 'left',
        sortable: false
      }, {
        text: 'Date Closed',
        value: 'closed_at',
        align: 'left',
        sortable: false
      }, { text: 'Reason', value: 'reason', align: 'center', sortable: false }, {
        text: 'Explanation',
        value: 'description',
        align: 'center',
        sortable: false
      }],
      searchValue: '',
      product: {},
      user: {
        avatar: {}
      },
      items: [],
      open_tickets: [],
      closed_tickets: [],
      per_page_options: [50, 100, 150],
      items_loading: false,
      open_tickets_loading: false,
      closed_tickets_loading: false,
      total_items: 0,
      total_open_tickets: 0,
      total_closed_tickets: 0,
      items_pagination: {
        page: 1,
        rowsPerPage: 10
      },
      open_tickets_pagination: {
        page: 1,
        rowsPerPage: 10
      },
      closed_tickets_pagination: {
        page: 1,
        rowsPerPage: 10
      },
      // total_items: 0,
      // pagination: {
      //   page: 1,
      //   rowsPerPage: 10
      // },
      isPageReady: true
    };
  },


  computed: {
    currentUser: function currentUser() {
      return this.$store.state.auth.user;
    }
  },

  methods: {
    loadProduct: function loadProduct() {
      // ProductService.getProduct(this.item.id)
    },
    loadItems: function loadItems() {
      var _this = this;

      var params = {
        page: this.items_pagination.page,
        per_page: this.items_pagination.rowsPerPage
      };
      this.$store.dispatch('error/showLoadingActivity', true);
      __WEBPACK_IMPORTED_MODULE_1__services_product__["a" /* default */].orderedItems(this.product.id, params).then(function (response) {
        _this.items = response.body.items;
        _this.total_items = response.body.pagination.total_count;
        _this.$store.dispatch('error/showLoadingActivity', false);
      }).catch(function (e) {
        _this.$store.dispatch('error/showLoadingActivity', false);
      });
    },
    loadOpenTickets: function loadOpenTickets() {
      var _this2 = this;

      var params = {
        status: 'open',
        page: this.open_tickets_pagination.page,
        per_page: this.open_tickets_pagination.rowsPerPage
      };
      this.$store.dispatch('error/showLoadingActivity', true);
      __WEBPACK_IMPORTED_MODULE_1__services_product__["a" /* default */].tickets(this.product.id, params).then(function (response) {
        _this2.open_tickets = response.body.tickets;
        _this2.total_open_tickets = response.body.pagination.total_count;
        _this2.$store.dispatch('error/showLoadingActivity', false);
      }).catch(function (e) {
        _this2.$store.dispatch('error/showLoadingActivity', false);
      });
    },
    loadClosedTickets: function loadClosedTickets() {
      var _this3 = this;

      var params = {
        status: 'close',
        page: this.closed_tickets_pagination.page,
        per_page: this.closed_tickets_pagination.rowsPerPage
      };
      this.$store.dispatch('error/showLoadingActivity', true);
      __WEBPACK_IMPORTED_MODULE_1__services_product__["a" /* default */].tickets(this.product.id, params).then(function (response) {
        _this3.closed_tickets = response.body.tickets;
        _this3.total_closed_tickets = response.body.pagination.total_count;
        _this3.$store.dispatch('error/showLoadingActivity', false);
      }).catch(function (e) {
        _this3.$store.dispatch('error/showLoadingActivity', false);
      });
    },
    fullAddress: function fullAddress(address) {
      return address.street_1 + ', ' + address.city + ', ' + address.state + ', ' + address.country;
    },
    closeTicket: function closeTicket(ticket) {
      var _this4 = this;

      // console.log('closeTicket', ticket)
      var params = {
        ticket: {
          closed_user_id: this.currentUser.id,
          status: 'close'
        }
      };
      __WEBPACK_IMPORTED_MODULE_3__services_ticket__["a" /* default */].updateTicket(ticket.id, params).then(function (response) {
        _this4.loadOpenTickets();
        _this4.loadClosedTickets();
      });
    }
  },

  created: function created() {
    var _this5 = this;

    this.product = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.item);
    this.user = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(this.item, 'merchant', { avatar: {} });
    console.log('product_detail_dialog', this.product);
    __WEBPACK_IMPORTED_MODULE_1__services_product__["a" /* default */].getProduct(this.item.id).then(function (response) {
      _this5.product = response.body;
    });
  },


  watch: {
    items_pagination: {
      handler: function handler() {
        this.loadItems();
      }
    },

    open_tickets_pagination: {
      handler: function handler() {
        // console.log('open_tickets_pagination', this.open_tickets_pagination)
        this.loadOpenTickets();
      }
    },

    closed_tickets_pagination: {
      handler: function handler() {
        this.loadClosedTickets();
      }
    }
  }
});

/***/ }),
/* 1054 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_admin__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_setting__ = __webpack_require__(156);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      settings: {
        disable_sign_up: false,
        disable_live_video: false,
        disable_verification: false,
        disable_merch_upload: false
      },
      message: '',
      isPageReady: false
    };
  },


  computed: {},

  methods: {
    loadSettings: function loadSettings() {
      var _this = this;

      this.isPageReady = false;
      this.$store.dispatch('error/showLoadingActivity', true);
      __WEBPACK_IMPORTED_MODULE_2__services_setting__["a" /* default */].getSettings().then(function (response) {
        _this.isPageReady = true;
        _this.$store.dispatch('error/showLoadingActivity', false);
        __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.assignIn(_this.settings, response.body);
      }).catch(function (e) {
        _this.$store.dispatch('error/showLoadingActivity', false);
        _this.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    updateSetting: function updateSetting(key) {
      var _this2 = this;

      var params = {
        key: key,
        value: (!this.settings[key]).toString()
      };
      console.log(params);
      __WEBPACK_IMPORTED_MODULE_2__services_setting__["a" /* default */].updateSetting(params).then(function (response) {
        _this2.settings[key] = !_this2.settings[key];
        // console.log(key, this.settings.disable_sign_up, this.settings[key])
      });
    },
    sendGlobalMessage: function sendGlobalMessage() {
      var _this3 = this;

      this.message = this.message.trim();
      if (this.message == '') return;

      var params = {
        message: this.message
      };
      __WEBPACK_IMPORTED_MODULE_1__services_admin__["a" /* default */].sendGlobalMessage(params).then(function (response) {
        _this3.message = '';
      });
    }
  },

  created: function created() {
    this.loadSettings();
  },
  mounted: function mounted() {}
});

/***/ }),
/* 1055 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_profileitem__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_profileitem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_profileitem__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    profileItem: __WEBPACK_IMPORTED_MODULE_3__components_profileitem___default.a
  },

  props: {
    item: {
      type: Object,
      required: true
    },

    dismiss: {
      type: Function,
      required: true
    },

    approveButtonAction: {
      type: Function,
      required: true
    },

    denyButtonAction: {
      type: Function,
      required: true
    },
    activeTab: null,
    loading: null
  },

  data: function data() {
    return {
      main_genres: [],
      sub_genres: []
    };
  },


  computed: {
    country_options: function country_options() {
      return __WEBPACK_IMPORTED_MODULE_2__helper__["s" /* Countries */];
    },
    boolean_options: function boolean_options() {
      return __WEBPACK_IMPORTED_MODULE_2__helper__["u" /* UserBooleanOptions */];
    },
    userMainGenreName: function userMainGenreName() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(this.item, 'genre.name');
    },
    userSubGenreName: function userSubGenreName() {
      var sub_genre_id = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(this.item, 'sub_genre_id');
      if (sub_genre_id) {
        var sub_genre = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(this.sub_genres, function (g) {
          return g.id == sub_genre_id;
        });
        return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(sub_genre, 'name', '');
      } else {
        return '';
      }
    },
    userReleasedAlbumsCount: function userReleasedAlbumsCount() {
      return this.getNameById(__WEBPACK_IMPORTED_MODULE_2__helper__["w" /* UserReleasedAlbumsCountOptions */], this.item.released_albums_count);
    },
    userYearsSinceFirstReleased: function userYearsSinceFirstReleased() {
      return this.getNameById(__WEBPACK_IMPORTED_MODULE_2__helper__["F" /* UserYearsInBusinessOptions */], this.item.years_since_first_released);
    },
    userAnnualIncomeOnMerchSales: function userAnnualIncomeOnMerchSales() {
      return this.getNameById(__WEBPACK_IMPORTED_MODULE_2__helper__["y" /* UserAnnualIncomeOnMerchSalesOptions */], this.item.annual_income_on_merch_sales);
    },
    userAnnualPerformancesCount: function userAnnualPerformancesCount() {
      return this.getNameById(__WEBPACK_IMPORTED_MODULE_2__helper__["z" /* UserAnnualPerformancesCountOptions */], this.item.annual_performances_count);
    },
    userPerformanceRightsOrganization: function userPerformanceRightsOrganization() {
      return this.getNameById(__WEBPACK_IMPORTED_MODULE_2__helper__["B" /* UserPerformanceRightsOrganizationOptions */], this.item.performance_rights_organization);
    },
    userArtistsCount: function userArtistsCount() {
      return this.getNameById(__WEBPACK_IMPORTED_MODULE_2__helper__["C" /* UserArtistsCountOptions */], this.item.artists_count);
    },
    userEmployeesCount: function userEmployeesCount() {
      return this.getNameById(__WEBPACK_IMPORTED_MODULE_2__helper__["E" /* UserEmployeesCountOptions */], this.item.employees_count);
    },
    userYearsInBusiness: function userYearsInBusiness() {
      return this.getNameById(__WEBPACK_IMPORTED_MODULE_2__helper__["F" /* UserYearsInBusinessOptions */], this.item.years_in_business);
    },
    userProductsCount: function userProductsCount() {
      return this.getNameById(__WEBPACK_IMPORTED_MODULE_2__helper__["G" /* UserProductsCountOptions */], this.item.products_count);
    },
    userAnnualIncome: function userAnnualIncome() {
      return this.getNameById(__WEBPACK_IMPORTED_MODULE_2__helper__["H" /* UserAnnualIncomeOptions */], this.item.annual_income);
    },
    userFullName: function userFullName() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(this.item, 'first_name', '') + ', ' + __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(this.item, 'last_name', '');
    },
    userAge: function userAge() {
      var y = parseInt(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(this.item, 'year_of_birth', ''));
      return y > 0 ? __WEBPACK_IMPORTED_MODULE_1_moment___default()().year() - y : '--';
    },
    userFullAddress: function userFullAddress() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(this.item, 'city', '') + ', ' + __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(this.item, 'country', '');
    }
  },

  created: function created() {
    this.main_genres = this.$store.state.app.genres;
    this.sub_genres = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.flatMap(this.$store.state.app.genres, 'children');
  },


  methods: {
    getNameById: function getNameById(options, id) {
      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(options, function (o) {
        return o.id == id;
      }), 'name', '');
    }
  }
});

/***/ }),
/* 1056 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_admin__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__signup_approve_modal__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__signup_approve_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__signup_approve_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__signup_deny_modal__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__signup_deny_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__signup_deny_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_contentTopHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_contentTopHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_contentTopHeader__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    signupApproveModal: __WEBPACK_IMPORTED_MODULE_2__signup_approve_modal___default.a,
    signupDenyModal: __WEBPACK_IMPORTED_MODULE_3__signup_deny_modal___default.a,
    contentTopHeader: __WEBPACK_IMPORTED_MODULE_4__components_contentTopHeader___default.a
  },

  data: function data() {
    return {
      active_tab: 'waiting',
      small_input: false,
      signups_tabs: [{ id: 'waiting', title: 'Waiting For Approval' }, { id: 'approved', title: 'Approved' }, { id: 'denied', title: 'Denied' }],
      waiting_headers: [{ text: 'User', value: 'display_name', align: 'left' }, { text: 'User Type', value: 'request_role', align: 'left' }, { text: 'Genre', value: 'genre.name', align: 'left' }, { text: 'Date Signed Up', value: 'created_at', align: 'left' }, { text: 'Invited By', value: 'invited_by', align: 'left' }, { text: '', value: 'id', align: 'left' }],
      invited_headers: [{ text: 'User', value: 'display_name', align: 'left' }, { text: 'User Type', value: 'user_type', align: 'left' }, { text: 'Genre', value: 'genre.name', align: 'left' }, { text: 'Date', value: 'joined_date', align: 'left' }, { text: 'Status', value: 'status', align: 'left' }, { text: 'Invited By', value: 'invited_by', align: 'left' }, { text: '', value: 'id', align: 'left' }],
      approved_headers: [{ text: 'User', value: 'display_name', align: 'left' }, { text: 'User Type', value: 'user_type', align: 'left' }, { text: 'Date Signed Up', value: 'signed_up_date', align: 'center' }, { text: 'Date Accepted', value: 'approved_date', align: 'center' }, { text: 'Verified By', value: 'verified_by', align: 'left' }, { text: '', value: '', align: 'left' }],
      denied_headers: [{ text: 'User', value: 'display_name', align: 'left' }, { text: 'User Type', value: 'user_type', align: 'left' }, { text: 'Date Signed Up', value: 'signed_up_date', align: 'center' }, { text: 'Date Denied', value: 'denied_date', align: 'center' }, { text: 'Verified By', value: 'verified_by', align: 'left' }, { text: '', value: 'id', align: 'left' }],
      search_value: '',
      show_approve_modal: false,
      show_deny_modal: false,
      user: {},
      per_page_options: [50, 100, 150],
      signups: [],
      total_signups: 0,
      pagination: {
        // sortBy: 'created_at',
        // descending: true,
        // totalItems: 0,
        page: 1,
        rowsPerPage: 10
      },
      isPageReady: true,
      loading: false
    };
  },


  computed: {
    headers: function headers() {
      switch (this.active_tab) {
        case 'waiting':
          return this.waiting_headers;
        case 'co-signed':
          return this.invited_headers;
        case 'approved':
          return this.approved_headers;
        case 'denied':
          return this.denied_headers;
      }
    }
  },

  methods: {
    loadUsers: function loadUsers() {
      var _this = this;

      this.$store.dispatch('error/showLoadingActivity', true);
      var params = {
        q: this.search_value,
        filter: this.active_tab,
        page: this.pagination.page,
        per_page: this.pagination.rowsPerPage
      };
      __WEBPACK_IMPORTED_MODULE_1__services_admin__["a" /* default */].getSignupUsers(params).then(function (response) {
        _this.$store.dispatch('error/showLoadingActivity', false);
        _this.signups = response.body.users;
        _this.total_signups = response.body.pagination.total_count;
      }).catch(function (e) {
        _this.$store.dispatch('error/showLoadingActivity', false);
        _this.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    onTab: function onTab(tab) {
      if (this.active_tab === tab) return;

      this.active_tab = tab;
      this.pagination = {
        page: 1,
        rowsPerPage: 10
      };
    },
    onKeyEnter: function onKeyEnter(e) {
      this.loadUsers();
    },
    openApproveModal: function openApproveModal(user) {
      this.user = user;
      this.show_approve_modal = true;
    },
    closeApproveModal: function closeApproveModal() {
      this.show_approve_modal = false;
    },
    showDenyModal: function showDenyModal() {
      this.show_deny_modal = true;
    },
    closeDenyModal: function closeDenyModal() {
      this.show_deny_modal = false;
    },
    approveUser: function approveUser(user) {
      var _this2 = this;

      // console.log('approveUser', user)
      this.loading = true;
      this.$store.dispatch('error/showLoadingActivity', true);

      __WEBPACK_IMPORTED_MODULE_1__services_admin__["a" /* default */].approveUser({ user_id: user.id }).then(function (response) {
        // console.log('approveUser', user)
        // user.request_status = 'accepted'
        // user.user_type = user.request_role
        _this2.loading = false;
        _this2.$store.dispatch('error/showLoadingActivity', false);
        __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.assignIn(user, response.body);
        _this2.signups = _this2.signups.filter(function (u) {
          return u.id != user.id;
        });
        _this2.$store.dispatch('error/showSuccessToast', ["User account has been successfully approved."]);
        _this2.closeApproveModal();
      }).catch(function (e) {
        _this2.loading = false;
        _this2.$store.dispatch('error/showLoadingActivity', false);
        _this2.$store.dispatch('error/showErrorToast', [e.body.errors] || [e.body.exception]);
      });
    },
    denyUser: function denyUser() {
      this.show_approve_modal = false;
      this.show_deny_modal = true;
    },
    viewSubmission: function viewSubmission(user) {
      var _this3 = this;

      // console.log('viewSubmission', user, this.user)
      if (!user.denial_reason || !user.denial_description) {
        return;
      }

      var params = {
        user_id: user.id,
        denial_reason: user.denial_reason,
        denial_description: user.denial_description
      };
      this.loading = true;
      this.$store.dispatch('error/showLoadingActivity', true);
      __WEBPACK_IMPORTED_MODULE_1__services_admin__["a" /* default */].denyUser(params).then(function (response) {
        console.log('viewSubmission', user);
        user.request_status = 'denied';
        _this3.signups = _this3.signups.filter(function (u) {
          return u.id != user.id;
        });
        _this3.closeDenyModal();
        _this3.loading = false;
        _this3.$store.dispatch('error/showLoadingActivity', false);
        _this3.$store.dispatch('error/showSuccessToast', ["User account has been successfully denied."]);
      }).catch(function (e) {
        _this3.loading = false;
        _this3.$store.dispatch('error/showLoadingActivity', false);
        _this3.$store.dispatch('error/showErrorToast', [e.body.errors]);
      });
    }
  },

  created: function created() {},


  watch: {
    pagination: {
      handler: function handler() {
        this.loadUsers();
      }
    }
  }
});

/***/ }),
/* 1057 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_admin__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_stream__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper__ = __webpack_require__(2);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      StreamStatuses: __WEBPACK_IMPORTED_MODULE_2__helper__["i" /* StreamStatuses */],
      active_tab: 'all',
      tabs: [{ id: 'all', title: 'All Users' }, { id: 'artists', title: 'Artists' }, { id: 'brands', title: 'Brands' }],
      headers: [{ text: 'Username', value: 'user.username', align: 'left' }, { text: 'Title', value: 'name', align: 'left' }, { text: 'Date', value: 'created_at', align: 'center' }, { text: 'Broadcast Time', value: 'broadcast_time', align: 'center' }, { text: 'Total Viewers', value: 'total_viewers', align: 'center' }, { text: 'Genre', value: 'genre.name', align: 'left' }, { text: 'Pay Per View', value: 'view_price', align: 'left' }, { text: '', value: 'status', align: 'left' }],
      show_stream_stop_confirm_dialog: false,
      search_value: '',
      per_page_options: [50, 100, 150],
      items: [],
      item: null,
      pagination: {
        page: 1,
        rowsPerPage: 10
      },
      total_items: 0,
      isPageReady: true
    };
  },


  methods: {
    loadItems: function loadItems() {
      var _this = this;

      this.$store.dispatch('error/showLoadingActivity', true);
      var params = {
        q: this.search_value,
        page: this.pagination.page,
        per_page: this.pagination.rowsPerPage
      };
      __WEBPACK_IMPORTED_MODULE_0__services_admin__["a" /* default */].getStreams(params).then(function (response) {
        _this.items = response.body.streams;
        _this.total_items = response.body.pagination.total_count;
        _this.$store.dispatch('error/showLoadingActivity', false);
      }).catch(function (e) {
        _this.$store.dispatch('error/showLoadingActivity', false);
      });
      return [];
    },
    onTab: function onTab(tab) {
      if (this.active_tab === tab) return;

      this.active_tab = tab;
      this.pagination = {
        page: 1,
        rowsPerPage: 10
      };
    },
    openStreamStopConfirmDialog: function openStreamStopConfirmDialog(item) {
      this.item = item;
      this.show_stream_stop_confirm_dialog = true;
    },
    closeStreamStopConfirmDialog: function closeStreamStopConfirmDialog() {
      this.show_stream_stop_confirm_dialog = false;
    },
    deleteStream: function deleteStream() {
      var _this2 = this;

      this.closeStreamStopConfirmDialog();
      this.$store.dispatch('error/showLoadingActivity', true);
      __WEBPACK_IMPORTED_MODULE_1__services_stream__["a" /* default */].deleteStream(this.item.id).then(function (response) {
        _this2.$store.dispatch('error/showLoadingActivity', false);
        _this2.item.status = 'deleted';
        _this2.item = null;
      }).catch(function (e) {
        _this2.$store.dispatch('error/showLoadingActivity', false);
        _this2.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
        _this2.item = null;
      });
    }
  },

  watch: {
    pagination: {
      handler: function handler() {
        this.loadItems();
      }
    }
  },

  created: function created() {}
});

/***/ }),
/* 1058 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_admin__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__signup_approve_modal__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__signup_approve_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__signup_approve_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__signup_deny_modal__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__signup_deny_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__signup_deny_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_subscription__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_contentTopHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_contentTopHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_contentTopHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_json_to_csv__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_json_to_csv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_json_to_csv__);











/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    signupApproveModal: __WEBPACK_IMPORTED_MODULE_4__signup_approve_modal___default.a,
    signupDenyModal: __WEBPACK_IMPORTED_MODULE_5__signup_deny_modal___default.a,
    contentTopHeader: __WEBPACK_IMPORTED_MODULE_8__components_contentTopHeader___default.a,
    VueJsonToCsv: __WEBPACK_IMPORTED_MODULE_9_vue_json_to_csv___default.a
  },

  data: function data() {
    return {
      active_tab: 'artists',
      small_input: false,
      tabs_count: [],
      cancelledEmails: [],
      selectedExportOption: 'All',
      search: '',
      subscriptions_tabs: [{ id: 'artists', title: 'Artists' }, { id: 'brands', title: 'Brands' }, { id: 'listeners', title: 'Listeners' }, { id: 'trial', title: 'Trial' }, { id: 'trial_drop_off', title: 'Trial Drop Off' }, { id: 'cancelled', title: 'Cancelled' }, { id: 'free_credit', title: 'Free Credit', sort: 'falsesrc/views/admin/components/general.scss' }],
      artists_headers: [{ text: 'Username', value: 'username', align: 'left' }, { text: 'User Type', value: 'user_type', align: 'left' }, { text: 'Name', value: 'first_name last_name', align: 'left' }, { text: 'Activate Date', value: 'activate_date', align: 'left' }, { text: 'Tier', value: 'plan', align: 'left' }, { text: 'Email', value: 'email', align: 'left' }, { text: 'Member For (mo)', value: 'member_for_months', align: 'left' }, { text: 'Credits', value: 'trial_end', align: 'left' }],

      brands_headers: [{ text: 'Username', value: 'username', align: 'left' }, { text: 'User Type', value: 'user_type', align: 'left' }, { text: 'Name', value: 'first_name last_name', align: 'left' }, { text: 'Activate Date', value: 'trial_start', align: 'left' }, { text: 'Tier', value: 'plan', align: 'left' }, { text: 'Email', value: 'email', align: 'left' }, { text: 'Member For Months', value: 'member_for_months', align: 'left' }, { text: 'Credits', value: 'trial_end', align: 'left' }],

      listeners_headers: [{ text: 'Username', value: 'username', align: 'left' }, { text: 'User Type', value: 'user_type', align: 'left' }, { text: 'Name', value: 'first_name last_name', align: 'left' }, { text: 'Activate Date', value: 'activate_date', align: 'left' }, { text: 'Tier', value: 'plan', align: 'left' }, { text: 'Email', value: 'email', align: 'left' }, { text: 'Member For Months', value: 'member_for_months', align: 'left' }, { text: 'Credits', value: 'trial_end', align: 'left' }],
      trial_headers: [{ text: 'Users', value: 'username', align: 'left' }, { text: 'User type', value: 'user_type', align: 'left' }, { text: 'First / Last Name', value: 'first_name last_name', align: 'left' }, { text: 'Email', value: 'email', align: 'left' }, { text: 'Member For (mo)', value: 'member_for_months', align: 'left' }, { text: 'Ghost trial remaining', value: 'free_trial_time', align: 'left' }, { text: 'Credits', value: 'trial_end', align: 'left' }],
      trial_drop_off_headers: [{ text: 'Users', value: 'username', align: 'left' }, { text: 'User type', value: 'user_type', align: 'left' }, { text: 'Initial signup type', value: 'initial_signup_type', align: 'left' }, { text: 'First / Last Name', value: 'first_name', align: 'left' }, { text: 'Email', value: 'email', align: 'left' }, { text: 'Credits', value: 'trial_end', align: 'left' }],
      cancelled_headers: [{ text: 'Users', value: 'username', align: 'left' }, { text: 'User type', value: 'user_type', align: 'left' }, { text: 'Initial signup type', value: 'initial_signup_type', align: 'left' }, { text: 'First / Last Name', value: 'first_name last_name', align: 'left' }, { text: 'Email', value: 'email', align: 'left' }, { text: 'Credits', value: 'trial_end', align: 'left' }],

      free_credit_headers: [{ text: 'Users', value: 'username', align: 'left' }, { text: 'User Type', value: 'user_type', align: 'left' }, { text: 'Name', value: 'first_name last_name', align: 'left' }, { text: 'Activate date', value: 'trial_start', align: 'left' }, { text: 'Tier', value: 'plan', align: 'left' }, { text: 'Credit Remaining', value: 'trial_end', align: 'left' }, { text: 'Email', value: 'email', align: 'left' }, { text: 'Member For (mo)', value: 'trial_start', align: 'left' },
      // { text: 'Credits', value: 'trial_end', align: 'center' },
      { text: 'Credit Increase', value: 'free_month_credits', align: 'left' }, { text: 'Action', value: 'Action', align: 'center' }],
      search_value: '',
      show_verification_modal: false,
      user: {},
      per_page_options: [50, 100, 150],
      subscriptions: [],
      total_subscriptions: 0,
      pagination: {
        // sortBy: 'created_at',
        // descending: true,
        // totalItems: 0,
        page: 1,
        rowsPerPage: 10
      },
      isPageReady: true,
      choose_month: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, "Forever"],
      selectedMonth: []
    };
  },


  computed: {
    headers: function headers() {
      switch (this.active_tab) {
        case 'artists':
          return this.artists_headers;
        case 'brands':
          return this.brands_headers;
        case 'listeners':
          return this.listeners_headers;
        case 'trial':
          return this.trial_headers;
        case 'cancelled':
          return this.cancelled_headers;
        case 'free_credit':
          return this.free_credit_headers;
        case 'trial_drop_off':
          return this.trial_drop_off_headers;
      }
    }
  },

  methods: {
    activeTab: function activeTab(tab) {
      this.active_tab = tab.id;
    },
    loadUsers: function loadUsers() {
      var _this = this;

      this.$store.dispatch('error/showLoadingActivity', true);
      var params = {
        q: this.search_value,
        filter: this.active_tab,
        page: this.pagination.page,
        per_page: this.pagination.rowsPerPage
      };
      __WEBPACK_IMPORTED_MODULE_3__services_admin__["a" /* default */].getFreeAccountCreditUsers(params).then(function (response) {
        _this.$store.dispatch('error/showLoadingActivity', false);
        _this.subscriptions = response.body.users;
        _this.total_subscriptions = response.body.pagination.total_count;
        _this.tabs_count = response.body.tabs_count;
        if (_this.active_tab == 'cancelled' || _this.active_tab == 'trial_drop_off') {
          _this.cancelledEmails = [];
          _this.selectedExportOption = 'All';
          _this.subscriptions.map(function (subscription) {
            _this.cancelledEmails.push({ email: subscription.email });
          });
        }
      }).catch(function (e) {
        _this.$store.dispatch('error/showLoadingActivity', false);
        _this.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    filterCsvData: function filterCsvData(value) {
      var _this2 = this;

      this.cancelledEmails = [];
      this.selectedExportOption = value;
      if (value == 'All') {
        this.subscriptions.map(function (subscription) {
          _this2.cancelledEmails.push({ email: subscription.email });
        });
      } else if (value == 'creator') {
        this.subscriptions.map(function (subscription) {
          if (subscription.user_type == 'artist' || subscription.user_type == 'brand') {
            _this2.cancelledEmails.push({ email: subscription.email });
          }
        });
      } else if (value == 'listener') {
        this.subscriptions.map(function (subscription) {
          if (subscription.user_type == 'listener') {
            _this2.cancelledEmails.push({ email: subscription.email });
          }
        });
      }
    },
    onTab: function onTab(tab) {
      if (this.active_tab === tab) return;

      this.active_tab = tab;
      this.pagination = {
        page: 1,
        rowsPerPage: 10
      };
    },
    onKeyEnter: function onKeyEnter(e) {
      this.loadUsers();
    },
    openVerificationModal: function openVerificationModal(user) {
      var month = this.selectedMonth.filter(function (m) {
        return m.id == user.id;
      })[0];
      if (month != null) {
        this.user = user;
        this.show_verification_modal = true;
      } else {
        this.$store.dispatch('error/showErrorToast', ["Please select a month"]);
      }
    },
    proceedFreeAccountCredit: function proceedFreeAccountCredit() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var row, month, params;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                row = _this3.selectedMonth.filter(function (m) {
                  return m.id == _this3.user.id;
                })[0];

                if (!(row != null)) {
                  _context.next = 8;
                  break;
                }

                month = row.month;
                params = { id: _this3.user.id, free_credit_month: month };
                _context.next = 6;
                return __WEBPACK_IMPORTED_MODULE_6__services_subscription__["a" /* default */].freeAccountCredit(params).then(function (response) {
                  _this3.subscriptions.map(function (subscription) {
                    return subscription.id == _this3.user.id ? subscription.trial_end = response.body.success_response : '';
                  });
                  var date = new Date(response.body.success_response);
                  var success_response = 'Trial of ' + _this3.user.username + ' has been updated to ' + _this3.formatDate(date) + '.';
                  _this3.$store.dispatch('error/showSuccessToast', [success_response]);
                  _this3.show_verification_modal = false;
                }).catch(function (e) {
                  _this3.$store.dispatch('error/showErrorToast', [e.body.exception]);
                });

              case 6:
                _context.next = 9;
                break;

              case 8:
                _this3.$store.dispatch('error/showErrorToast', ["Please select a month"]);

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    closeVerificationModal: function closeVerificationModal() {
      this.show_verification_modal = false;
    },
    selectMonth: function selectMonth(month, id) {
      if (this.selectedMonth.length == 0) {
        this.selectedMonth.push({ "id": id, "month": month });
      } else {
        for (var i = 0; i < this.selectedMonth.length; i++) {
          if (this.selectedMonth[i].id == id) {
            this.selectedMonth[i] = { "id": id, "month": month };
          } else {
            this.selectedMonth.push({ "id": id, "month": month });
          }
        }
      }
    },
    getNumberOfMonths: function getNumberOfMonths(signupDate) {
      var startDate = new Date(signupDate);
      var endDate = new Date();
      return endDate.getMonth() - startDate.getMonth() + 12 * (endDate.getFullYear() - startDate.getFullYear());
    },
    formatDate: function formatDate(value) {
      if (value) {
        return __WEBPACK_IMPORTED_MODULE_7_moment___default()(String(value)).format('MMM DD, YYYY');
      }
    }
  },

  created: function created() {},


  watch: {
    pagination: {
      handler: function handler() {
        this.loadUsers();
      }
    }
  }
});

/***/ }),
/* 1059 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_auth__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_admin__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_user__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_stream__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_contentTopHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_contentTopHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_contentTopHeader__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    contentTopHeader: __WEBPACK_IMPORTED_MODULE_4__components_contentTopHeader___default.a
  },

  data: function data() {
    return {
      users_tabs: [{ id: 'any', title: 'All Users' }, { id: 'artist', title: 'Artists' }, { id: 'listener', title: 'Listeners' }, { id: 'moderator', title: 'Moderators' }, { id: 'suspended', title: 'Suspended' }],
      active_tab: 'any',
      small_input: false,
      user_headers: [{ text: 'Username', value: 'username', align: 'left', sortable: false }, {
        text: 'View Direct Messages',
        value: 'enabled_view_direct_messages',
        align: 'left',
        sortable: false
      }, {
        text: 'Streaming',
        value: 'enabled_live_video',
        align: 'left',
        sortable: false
      }, {
        text: 'Free Streaming',
        value: 'enabled_live_video_free',
        align: 'left',
        sortable: false
      }, {
        text: 'Sign-in authorized',
        value: 'sign_in_authorized',
        align: 'left',
        sortable: false
      },
      // { text: 'Current Free Stream Hours', value: 'free_streamed_time' },
      // { text: 'Stop Streaming', value: 'id' },
      // { text: 'Free Stream Hours', value: 'free_stream_seconds' },
      // { text: 'Demand Stream Hours', value: 'demand_stream_seconds' },
      { text: 'Email', value: 'email', align: 'left', sortable: false }, {
        text: 'Social link',
        value: 'social_user_name',
        align: 'left',
        sortable: false
      }, {
        text: 'Date Joined',
        value: 'created_at',
        align: 'left',
        sortable: false
      }, {
        text: 'Verified By',
        value: 'verified_by',
        align: 'left',
        sortable: false
      }, { text: 'Status', value: 'status', align: 'left', sortable: false }, { text: '', value: '', sortable: false }],
      show_stream_delete_confirm_dialog: false,
      show_free_stream_toggle_confirm_dialog: false,
      show_user_delete_confirm_dialog: false,
      show_disconnect_stripe_confirm_dialog: false,
      search_value: '',
      user: null,
      per_page_options: [5, 10, 15],
      users: [],
      pagination: {
        sortBy: 'created_at',
        descending: true,
        page: 1,
        rowsPerPage: 10
      },
      total_users: 0,
      isPageReady: true
    };
  },


  computed: {
    headers: function headers() {
      if (this.active_tab === 'moderator') {
        return this.user_headers;
      } else {
        return this._.filter(this.user_headers, function (h) {
          return h.text !== 'View Direct Messages';
        });
      }
    }
  },

  methods: {
    loadUsers: function loadUsers() {
      var _this = this;

      this.$store.dispatch('error/showLoadingActivity', true);
      var params = {
        q: this.search_value,
        filter: this.active_tab,
        page: this.pagination.page,
        per_page: this.pagination.rowsPerPage
      };
      __WEBPACK_IMPORTED_MODULE_1__services_admin__["a" /* default */].getUsers(params).then(function (response) {
        _this.$store.dispatch('error/showLoadingActivity', false);
        _this.users = response.body.users;
        _this.total_users = response.body.pagination.total_count;
      }).catch(function (e) {
        _this.$store.dispatch('error/showLoadingActivity', false);
        _this.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    onTab: function onTab(tab) {
      if (this.active_tab === tab) return;

      this.active_tab = tab;
      this.pagination = {
        sortBy: 'created_at',
        descending: true,
        page: 1,
        rowsPerPage: 10
      };
    },
    onKeyEnter: function onKeyEnter(e) {
      this.loadUsers();
    },
    toggleViewDirectMessages: function toggleViewDirectMessages(user) {
      var params = {
        user_id: user.id
      };
      __WEBPACK_IMPORTED_MODULE_1__services_admin__["a" /* default */].toggleViewDirectMessages(params);
    },
    openStreamDeleteConfirmDialog: function openStreamDeleteConfirmDialog(user) {
      this.user = user;
      this.show_stream_delete_confirm_dialog = true;
    },
    closeStreamDeleteConfirmDialog: function closeStreamDeleteConfirmDialog() {
      this.show_stream_delete_confirm_dialog = false;
    },
    archiveStream: function archiveStream() {
      var _this2 = this;

      this.closeStreamDeleteConfirmDialog();
      this.$store.dispatch('error/showLoadingActivity', true);
      __WEBPACK_IMPORTED_MODULE_3__services_stream__["a" /* default */].archiveStream(this.user.stream.id).then(function (response) {
        _this2.$store.dispatch('error/showLoadingActivity', false);
        _this2.user.stream.status = 'deleted';
        _this2.user = null;
      }).catch(function (e) {
        _this2.$store.dispatch('error/showLoadingActivity', false);
        _this2.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
        _this2.user = null;
      });
    },
    openDisconnectStripeConfirmDialog: function openDisconnectStripeConfirmDialog(user) {
      this.user = user;
      this.show_disconnect_stripe_confirm_dialog = true;
    },
    closeDisconnectStripeConfirmDialog: function closeDisconnectStripeConfirmDialog() {
      this.show_disconnect_stripe_confirm_dialog = false;
    },
    disconnectStripe: function disconnectStripe() {
      var _this3 = this;

      this.closeDisconnectStripeConfirmDialog();
      this.$store.dispatch('error/showLoadingActivity', true);
      var params = {
        user_id: this.user.id
      };
      __WEBPACK_IMPORTED_MODULE_1__services_admin__["a" /* default */].disconnectStripe(params).then(function () {
        _this3.$store.dispatch('error/showLoadingActivity', false);
        _this3.user.stripe_connected = false;
        _this3.user = null;
      }).catch(function (e) {
        _this3.$store.dispatch('error/showLoadingActivity', false);
        _this3.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
        _this3.user = null;
      });
    },
    toggleLiveVideo: function toggleLiveVideo(user) {
      var params = {
        user_id: user.id
      };
      __WEBPACK_IMPORTED_MODULE_1__services_admin__["a" /* default */].toggleLiveVideo(params);
    },
    openFreeStreamToggleConfirmDialog: function openFreeStreamToggleConfirmDialog() {
      this.show_free_stream_toggle_confirm_dialog = true;
    },
    closeFreeStreamToggleConfirmDialog: function closeFreeStreamToggleConfirmDialog() {
      this.show_free_stream_toggle_confirm_dialog = false;
    },
    toggleLiveVideoFree: function toggleLiveVideoFree(user) {
      if (user.stream && user.stream.status === 'running') {
        this.openFreeStreamToggleConfirmDialog();
        user.enabled_live_video_free = !user.enabled_live_video_free;
        return;
      }

      var params = {
        user_id: user.id
      };
      __WEBPACK_IMPORTED_MODULE_1__services_admin__["a" /* default */].toggleLiveVideoFree(params);
    },
    toggleSignInAuthorized: function toggleSignInAuthorized(user) {
      var params = {
        user_id: user.id
      };

      __WEBPACK_IMPORTED_MODULE_1__services_admin__["a" /* default */].toggleSignInAuthorized(params);
    },
    openUserDeleteConfirmDialog: function openUserDeleteConfirmDialog(user) {
      this.user = user;
      this.show_user_delete_confirm_dialog = true;
    },
    closeUserDeleteConfirmDialog: function closeUserDeleteConfirmDialog() {
      this.show_user_delete_confirm_dialog = false;
    },
    sendConfirmEmail: function sendConfirmEmail(user) {
      var _this4 = this;

      var params = {
        email: user.email
      };
      __WEBPACK_IMPORTED_MODULE_0__services_auth__["a" /* default */].sendConfirmEmail(params).then(function (response) {
        // this.$store.dispatch('error/showSuccessToast', ['Resent a confirmation email'])
      }).catch(function (e) {
        _this4.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    removeAccount: function removeAccount(user) {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_2__services_user__["a" /* default */].deleteUser(user.id).then(function (response) {
        _this5.users = _this5._.filter(_this5.users, function (item) {
          return item.id !== user.id;
        });
        _this5.closeUserDeleteConfirmDialog();
      }).catch(function () {
        _this5.closeUserDeleteConfirmDialog();
      });
    },
    suspendAccount: function suspendAccount(user) {
      var _this6 = this;

      var params = {
        status: 'suspended'
      };
      __WEBPACK_IMPORTED_MODULE_2__services_user__["a" /* default */].updateUserStatus(user.id, params).then(function (response) {
        user.status = 'suspended';
      }).catch(function (e) {
        _this6.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    activateAccount: function activateAccount(user) {
      var _this7 = this;

      var params = {
        status: 'active'
      };
      __WEBPACK_IMPORTED_MODULE_2__services_user__["a" /* default */].updateUserStatus(user.id, params).then(function (response) {
        user.status = 'active';
      }).catch(function (e) {
        _this7.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    updateUserRole: function updateUserRole(user, role) {
      var _this8 = this;

      var params = {
        role: role
      };
      __WEBPACK_IMPORTED_MODULE_2__services_user__["a" /* default */].updateUserRole(user.id, params).then(function (response) {
        user.user_type = role;
        _this8.users = _this8._.filter(_this8.users, function (item) {
          return item.id !== user.id;
        });
      }).catch(function (e) {
        _this8.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    }
  },

  created: function created() {},
  mounted: function mounted() {
    $("tfoot").css("width", "500px");
  },


  watch: {
    pagination: {
      handler: function handler() {
        this.loadUsers();
      }
    }
  }
});

/***/ }),
/* 1060 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_genre_single_selector__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_genre_single_selector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_genre_single_selector__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_promotemodal__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_promotemodal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_promotemodal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_sample_license_dialog__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_sample_license_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_sample_license_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_trackuploader__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_trackuploader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_trackuploader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_album__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_me__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_product__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_profile__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_nav_vue__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_nav_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_nav_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__helper__ = __webpack_require__(2);


/* global $:true */















// import UserService from '@/services/user'


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    genreSingleSelector: __WEBPACK_IMPORTED_MODULE_4__components_genre_single_selector___default.a,
    promoteModal: __WEBPACK_IMPORTED_MODULE_5__components_promotemodal___default.a,
    sampleLicenseDialog: __WEBPACK_IMPORTED_MODULE_6__components_sample_license_dialog___default.a,
    trackUploader: __WEBPACK_IMPORTED_MODULE_7__components_trackuploader___default.a,
    uploadNav: __WEBPACK_IMPORTED_MODULE_12__components_nav_vue___default.a
  },

  data: function data() {
    return {
      isNeededToRelease: false,
      showPromoteMessage: false,
      locations: [],
      followings: [],
      users: [],
      genres: [],
      products: [],
      potential_collaborators: [],
      potential_contributors: [],
      collaborators: [],
      contributors: [],
      samplings: [],
      // sampling: {},
      artists: [],
      selected_product: null,
      album: null,
      album_image: null,
      album_image_url: null,
      genre: '',
      sampling_min_id: 0,
      slug: null,
      show_collaborators_confirm_dialog: false,
      show_genre_selector_dialog: false,
      show_sample_clearance_license_modal: false,
      isPageReady: false
    };
  },


  computed: {
    currentUser: function currentUser() {
      return this.$store.state.auth.user;
    },
    isAvailableToEditAlbum: function isAvailableToEditAlbum() {
      // console.log('isAvailableToUploadAlbum', this.album.tracks)
      var failed_track = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(this.album.tracks, function (track) {
        return track.status !== 2;
      });
      var has_failed_track = !!failed_track;
      var isSamplingsGood = true;
      var sampling_track_id = 0;
      var sample_track_id = 0;
      var sample_album_id = 0;
      var sample_user_id = 0;
      for (var i = 0; i < this.samplings.length; i++) {
        sampling_track_id = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.samplings[i], 'sampling_track_id', 0);
        sample_track_id = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.samplings[i], 'sample_track_id', 0);
        sample_album_id = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.samplings[i], 'sample_album_id.id', this.samplings[i].sample_album_id);
        sample_user_id = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.samplings[i], 'sample_user_id.id', this.samplings[i].sample_user_id);
        // console.log(i, sampling_track_id, sample_track_id, sample_album_id, sample_user_id)
        if (!(sampling_track_id > 0 && sample_track_id > 0 && sample_album_id > 0 && sample_user_id > 0)) {
          isSamplingsGood = false;
          break;
        }
      }
      return isSamplingsGood && this.album.tracks.length > 0 && !has_failed_track && this.album.name.length && this.album_image_url && this.$store.state.genreSelector.genres.length > 0;
    },
    role_types: function role_types() {
      return __WEBPACK_IMPORTED_MODULE_13__helper__["K" /* CollaboratorRoleTypes */];
    }
  },

  created: function created() {
    var _this = this;

    this.$store.dispatch('navigator/goNextState', {
      page: 'album_edit',
      tab: ''
    });
    if (this.currentUser) {
      if (this.currentUser.user_type !== 'artist') {
        this.$router.push({ path: '/' });
      } else {
        var vm = this;
        this.isPageReady = false;
        this.$store.dispatch('error/showLoadingActivity', true);
        this.slug = this.$route.params.slug;
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([
        // UserService.searchUsers(params)
        __WEBPACK_IMPORTED_MODULE_10__services_product__["a" /* default */].getProducts({
          statuses: 'published, collaborated',
          stock_statuses: 'active',
          user_statuses: 'accepted'
        }), __WEBPACK_IMPORTED_MODULE_8__services_album__["a" /* default */].getAlbum(this.slug), __WEBPACK_IMPORTED_MODULE_9__services_me__["a" /* default */].mutualUsers({
          per_page: -1
        }), __WEBPACK_IMPORTED_MODULE_11__services_profile__["a" /* default */].getItems(this.currentUser.id, 'sample_followings', {
          per_page: -1
        })]).then(function (values) {
          _this.genres = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.flatMap(_this.$store.state.app.genres, 'children');
          _this.products = values[0].body;

          _this.potential_collaborators = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(values[2].body.users);
          _this.potential_contributors = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(values[2].body.users);
          _this.potential_contributors.unshift(_this.currentUser);
          _this.artists = values[3].body.users;

          _this.album = values[1].body;
          _this.album_image_url = _this.album.cover.url;
          if (_this.album.released_at) {
            _this.album.released_at = __WEBPACK_IMPORTED_MODULE_3_moment___default()(_this.album.released_at).format('YYYY-MM-DD');
          } else {
            _this.album.released_at = __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD');
          }
          _this.album.enabled_sample = _this.album.enabled_sample.toString();

          _this.$store.dispatch('genreSelector/setGenres', _this.album.genres);
          if (_this.album.products.length > 0) {
            _this.selected_product = _this.album.products[0].id;
          }
          if (_this.album.collaborators.length > 0) {
            _this.collaborators = _this.album.collaborators;
          }
          if (_this.album.contributors.length > 0) {
            _this.contributors = _this.album.contributors;
          }
          if (_this.album.samplings.length > 0) {
            _this.samplings = _this.album.samplings;
            __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(_this.samplings, function (sampling) {
              var artists = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(_this.artists);
              __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(artists, function (u) {
                u.sampling_id = sampling.id;
              });
              sampling.artists = artists;
            });

            var users_ids = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.chain(_this.samplings).map('sample_user_id').uniq().value();
            var fns = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(users_ids, function (user_id) {
              return __WEBPACK_IMPORTED_MODULE_8__services_album__["a" /* default */].getAlbums({
                statuses: 'published, collaborated',
                user_statuses: 'accepted',
                user_id: user_id,
                enabled_sample: true
              });
            });
            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(fns).then(function (values) {
              var _loop = function _loop(i) {
                var samplings = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(_this.samplings, function (s) {
                  return s.sample_user_id === users_ids[i];
                });
                __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(samplings, function (sampling) {
                  var albums = values[i].body;
                  __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(albums, function (a) {
                    a.sampling_id = sampling.id;
                  });
                  sampling.artist_albums = albums;
                  sampling.artist_album_tracks = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(albums, function (a) {
                    return a.id === sampling.sample_album_id;
                  }).tracks;
                  // console.log('samplings', this.samplings)
                });
              };

              for (var i = 0; i < values.length; i++) {
                _loop(i);
              }

              _this.isPageReady = true;
              _this.$store.dispatch('error/showLoadingActivity', false);
            });
          } else {
            _this.isPageReady = true;
            _this.$store.dispatch('error/showLoadingActivity', false);
          }
          // console.log('album_edit created', this.users)
          setTimeout(function () {
            $('#album_image').css('background-image', 'url(' + vm.album.cover.url + ')');
          }, 200);
        }).catch(function (reason) {
          console.log(reason);
          _this.$store.dispatch('error/showLoadingActivity', false);
          _this.$store.dispatch('error/showErrorToast', reason);
          // this.isPageReady = true
        });
      }
    } else {
      this.$router.push({ path: '/' });
    }
  },


  methods: {
    imageChanged: function imageChanged(e) {
      var _this2 = this;

      this.album_image = e.target.files[0];
      var reader = new FileReader();
      reader.addEventListener('load', function (event) {
        _this2.album_image_url = event.target.result;
      }, false);
      reader.readAsDataURL(this.album_image);
      this.$forceUpdate();
    },
    learnMore: function learnMore() {},
    addCollaborator: function addCollaborator() {
      this.collaborators.push({
        user_id: '',
        user_role: '',
        status: 'pending'
      });
    },
    deleteCollaborator: function deleteCollaborator(index) {
      this.collaborators.splice(index, 1);
    },
    addContributor: function addContributor() {
      this.contributors.push({
        user_id: '',
        user_role: ''
      });
    },
    deleteContributor: function deleteContributor(index) {
      this.contributors.splice(index, 1);
    },
    addSampling: function addSampling() {
      this.sampling_min_id -= 1;
      var sampling = {
        id: this.sampling_min_id,
        sampling_track_id: '',
        sample_track_id: '',
        sample_album_id: '',
        sample_user_id: ''
      };
      var artists = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(this.artists);
      __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(artists, function (u) {
        u.sampling_id = sampling.id;
      });
      sampling.artists = artists;
      this.samplings.push(sampling);
    },
    deleteSampling: function deleteSampling(index) {
      this.samplings.splice(index, 1);
    },
    onChangeSampleArtist: function onChangeSampleArtist(user) {
      var _this3 = this;

      // console.log('onChangeSampleArtist', user.sampling_id, user.id, user.display_name)
      __WEBPACK_IMPORTED_MODULE_8__services_album__["a" /* default */].getAlbums({
        statuses: 'published, collaborated',
        user_statuses: 'accepted',
        user_id: user.id,
        enabled_sample: true
      }).then(function (response) {
        var sampling = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(_this3.samplings, function (s) {
          return s.id === user.sampling_id;
        });
        var albums = response.body;
        __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(albums, function (a) {
          a.sampling_id = user.sampling_id;
        });
        sampling.artist_albums = albums;
        sampling.artist_album_tracks = [];
        sampling.sample_album_id = 0;
        sampling.sample_track_id = 0;
        _this3.$forceUpdate();
      });
    },
    onChangeSampleArtistAlbum: function onChangeSampleArtistAlbum(album) {
      // console.log('onChangeSampleArtistAlbum', album.sampling_id, album.name)
      var sampling = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(this.samplings, function (s) {
        return s.id === album.sampling_id;
      });
      sampling.artist_album_tracks = album.tracks;
      sampling.sample_track_id = 0;
      this.$forceUpdate();
    },
    deleteAlbum: function deleteAlbum() {
      var _this4 = this;

      var id = '';
      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_8__services_album__["a" /* default */].deleteAlbum(id).then(function (res) {
        _this4.isLoading = false;
        _this4.$router.push({ path: '/album' });
      }).catch(function (e) {
        _this4.isLoading = false;
        _this4.errorMessage = e.body.errors[0].detail;
        _this4.showError = true;
      });
    },
    showCollaboratorsConfirmDialog: function showCollaboratorsConfirmDialog() {
      this.show_collaborators_confirm_dialog = true;
    },
    hideCollaboratorsConfirmDialog: function hideCollaboratorsConfirmDialog() {
      this.show_collaborators_confirm_dialog = false;
    },
    openGenreSelectorDialog: function openGenreSelectorDialog() {
      this.show_genre_selector_dialog = true;
    },
    closeGenreSelectorDialog: function closeGenreSelectorDialog() {
      this.show_genre_selector_dialog = false;
    },
    openSampleClearanceLicenseModal: function openSampleClearanceLicenseModal() {
      this.show_sample_clearance_license_modal = true;
    },
    closeSampleClearanceLicenseModal: function closeSampleClearanceLicenseModal() {
      this.show_sample_clearance_license_modal = false;
    },
    beforeReleaseNow: function beforeReleaseNow() {
      if (this.album.status === 'pending') {
        this.showCollaboratorsConfirmDialog();
      } else {
        this.releaseNow();
      }
    },
    releaseNow: function releaseNow() {
      this.hideCollaboratorsConfirmDialog();
      this.isNeededToRelease = true;
      this.uploadAlbum();
    },
    uploadAlbum: function uploadAlbum() {
      var _this5 = this;

      this.$store.dispatch('error/showLoadingActivity', true);
      var tracks = [];
      for (var index in this.album.tracks) {
        var track = this.album.tracks[index].track;
        if (track) {
          tracks.push(track.id);
        }
      }

      var track_ids = tracks.join(',');
      var genre_ids = this.$store.getters['genreSelector/genre'].id;
      var product_ids = this.selected_product;
      var formData = new FormData();
      formData.append('album[name]', this.album.name);
      formData.append('album[description]', this.album.description);
      formData.append('album[released_at]', this.album.released_at);
      formData.append('album[location]', this.album.location || '');
      formData.append('album[is_only_for_live_stream]', this.album.is_only_for_live_stream);
      formData.append('album[is_content_acapella]', this.album.is_content_acapella);
      formData.append('album[is_content_instrumental]', this.album.is_content_instrumental);
      formData.append('album[is_content_stems]', this.album.is_content_stems);
      formData.append('album[is_content_remix]', this.album.is_content_remix);
      formData.append('album[is_content_dj_mix]', this.album.is_content_dj_mix);
      formData.append('album[enabled_sample]', this.album.enabled_sample === 'true');
      if (this.album_image) {
        formData.append('album[cover]', this.album_image);
      }
      formData.append('album[track_ids]', track_ids);
      formData.append('album[genre_ids]', genre_ids);
      // #TODO pass null when no selection
      formData.append('album[product_ids]', product_ids);
      formData.append('album[collaborators]', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.collaborators));
      formData.append('album[contributors]', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.contributors));

      var samplings = [];
      __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(this.samplings, function (sampling) {
        var s = {
          sampling_track_id: sampling.sampling_track_id,
          sample_track_id: sampling.sample_track_id,
          sample_album_id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(sampling, 'sample_album_id.id', sampling.sample_album_id),
          sample_user_id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(sampling, 'sample_user_id.id', sampling.sample_user_id)
        };
        if (sampling.id > 0) {
          s['id'] = sampling.id;
        }
        samplings.push(s);
      });
      // console.log('samplings', samplings)
      formData.append('album[samplings]', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(samplings));

      __WEBPACK_IMPORTED_MODULE_8__services_album__["a" /* default */].updateAlbum(this.album.id, formData).then(function (res) {
        var id = res.body.id;
        if (_this5.isNeededToRelease) {
          var accepted = true;
          __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(_this5.collaborators, function (collaborator) {
            if (collaborator.status !== 'accepted') {
              accepted = false;
            }
          });
          if (accepted) {
            _this5.releaseAlbum(id);
          } else {
            _this5.$store.dispatch('error/showLoadingActivity', false);
            _this5.$router.push({ path: '/albums' });
          }
        } else {
          if (_this5.album.promote) {
            _this5.repostAlbum(id);
          } else {
            _this5.$store.dispatch('error/showLoadingActivity', false);
            _this5.$router.push({ path: '/albums' });
          }
        }
      }).catch(function (e) {
        _this5.$store.dispatch('error/showLoadingActivity', false);
        _this5.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    releaseAlbum: function releaseAlbum(id) {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_8__services_album__["a" /* default */].releaseAlbum(id).then(function (res) {
        if (_this6.album.promote) {
          _this6.repostAlbum(id);
        } else {
          _this6.$store.dispatch('error/showLoadingActivity', false);
          _this6.$router.push({ path: '/album/' + _this6.album.slug });
          // this.$store.dispatch('navigator/setParams', { album_id: id })
          // this.$router.push({ path: '/album/' + id })
        }
      }).catch(function (e) {
        _this6.$store.dispatch('error/showLoadingActivity', false);
        _this6.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    saveAndFinish: function saveAndFinish(users) {
      this.isNeededToRelease = false;
      this.uploadAlbum();
    }
  },

  mounted: function mounted() {
    var vm = this;
    $.getJSON('../../static/cities.json', function (data) {
      vm.locations = data;
    });
  }
});

/***/ }),
/* 1061 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_activity__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_album__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_activityitem__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_activityitem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_activityitem__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    activityItem: __WEBPACK_IMPORTED_MODULE_3__components_activityitem___default.a
  },

  data: function data() {
    return {
      tabs: [
      // { id: 'reposted_by', title: 'Reposted By' },
      // { id: 'downloaded_by', title: 'Downloaded By' },
      { id: 'played_by', title: 'Played By' }],
      currentTab: null,
      slug: null,
      album: null,
      activities: [],
      isPageReady: false
    };
  },


  computed: {},

  watch: {
    $route: function $route(toPath, fromPath) {
      var tab = toPath.hash.substr(1);
      var slug = toPath.params.slug;
      this.init(slug, tab);
    }
  },

  created: function created() {
    this.$store.dispatch('navigator/goNextState', {
      page: 'album_stats',
      tab: this.currentTab
    });
    var slug = this.$route.params.slug;
    var tab = this.$route.hash.substr(1);
    this.init(slug, tab);
  },


  methods: {
    init: function init(slug, tab) {
      var _this = this;

      // this.currentTab = tab || 'reposted_by'
      // let apis = null
      // switch (this.currentTab) {
      //   case 'reposted_by':
      //     apis = [
      //       AlbumService.getAlbum(slug),
      //       ActivityService.repostedBy(slug)
      //     ]
      //     break
      //   case 'downloaded_by':
      //     apis = [
      //       AlbumService.getAlbum(slug),
      //       ActivityService.downloadedBy(slug)
      //     ]
      //     break
      //   case 'played_by':
      //     apis = [
      //       AlbumService.getAlbum(slug),
      //       ActivityService.playedBy(slug)
      //     ]
      //     break
      // }
      // this.isPageReady = false
      // this.$store.dispatch('error/showLoadingActivity', true)
      // Promise.all(apis).then(values => {
      //   this.album = values[0].body
      //   this.activities = values[1].body.activities
      //   this.isPageReady = true
      //   this.$store.dispatch('error/showLoadingActivity', false)
      // }).catch(reason => {
      //   this.$store.dispatch('error/showLoadingActivity', false)
      // })

      this.currentTab = tab || 'played_by';
      var params = { action_type: 'repost' };
      switch (this.currentTab) {
        case 'reposted_by':
          params['action_type'] = 'repost';
          break;
        case 'downloaded_by':
          params['action_type'] = 'download';
          break;
        case 'played_by':
          params['action_type'] = 'play';
          break;
      }

      this.isPageReady = false;
      this.$store.dispatch('error/showLoadingActivity', true);
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_2__services_album__["a" /* default */].getAlbum(slug), __WEBPACK_IMPORTED_MODULE_1__services_activity__["a" /* default */].getAlbumActivities(slug, params), __WEBPACK_IMPORTED_MODULE_1__services_activity__["a" /* default */].getAlbumStats(slug)]).then(function (values) {
        _this.album = values[0].body;
        _this.activities = values[1].body.activities;
        _this.album.stats = values[2].body;
        _this.isPageReady = true;
        _this.$store.dispatch('error/showLoadingActivity', false);
      }).catch(function (reason) {
        _this.$store.dispatch('error/showLoadingActivity', false);
      });
    },
    onTab: function onTab(tab) {
      if (tab != this.currentTab) {
        this.$router.push({
          path: this.$route.path,
          hash: tab
        });
      }
    }
  },

  mounted: function mounted() {}
});

/***/ }),
/* 1062 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_album__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_album_components_albumList__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_album_components_albumList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_album_components_albumList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_contentTopHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_contentTopHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_contentTopHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_albumfinishmodal__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_albumfinishmodal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_albumfinishmodal__);






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    textBtnToRight: {
      type: Boolean
    }
  },
  components: {
    contentTopHeader: __WEBPACK_IMPORTED_MODULE_3__components_contentTopHeader___default.a,
    albumList: __WEBPACK_IMPORTED_MODULE_2__views_album_components_albumList___default.a,
    albumFinishModal: __WEBPACK_IMPORTED_MODULE_4__components_albumfinishmodal___default.a
  },

  data: function data() {
    return {
      albumTab: 'published',
      active_tab: 'orders',
      tabs: [{ id: 'orders', title: 'Orders' }, { id: 'products', title: 'Products' }, { id: 'collaborations', title: 'Collaborations' }, { id: 'pendings', title: 'Pending collaborations' }],
      filters: [{ id: '', name: 'All' }, { id: 'creator_unshipped', name: 'Unshipped' }, { id: 'creator_shipped', name: 'Shipped' }, { id: 'collaborator_unshipped', name: 'Collaborated Unshipped' }, { id: 'collaborator_shipped', name: 'Collaborated Shipped' }],
      activeFilter: null,
      exportPeriod: null,
      albums: [],
      album: {},
      show_album_delete_confirm_dialog: false,
      show_publish_confirm_dialog: false,
      show_access_level_confirm_dialog: false,
      show_video_only_confirm_dialog: false,
      show_album_finish_modal: false,
      isPageReady: false,
      showReleaseAlbumModal: false,
      releaseAlbumList: null
    };
  },


  computed: {
    currentUser: function currentUser() {
      return this.$store.state.auth.user;
    },
    user: function user() {
      return this.order_detail.customer;
    },
    published_albums: function published_albums() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(this.albums, function (item) {
        return item.status === 'published' && !item.is_only_for_live_stream;
      });
    },
    private_albums: function private_albums() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(this.albums, function (item) {
        return item.status === 'privated';
      });
    },
    video_only_albums: function video_only_albums() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(this.albums, function (item) {
        return item.status === 'published' && item.is_only_for_live_stream;
      });
    },
    pending_albums: function pending_albums() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(this.albums, function (item) {
        return item.status === 'pending';
      });
    },
    collaborated_albums: function collaborated_albums() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(this.albums, function (item) {
        return item.status === 'collaborated';
      });
    },
    albumStatus: function albumStatus() {
      if (this.album.status === 'published' && !this.album.is_only_for_live_stream) {
        return 'published';
      }

      if (this.album.status === 'published' && this.album.is_only_for_live_stream) {
        return 'video_only';
      }

      return 'privated';
    },
    activeFilterName: function activeFilterName() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(this.activeFilter, 'name', 'All');
    },
    activeFilterItemStatus: function activeFilterItemStatus() {
      var status = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(this.activeFilter, 'id', '').split('_')[1] || '';
      var item_status = '';
      switch (status) {
        case 'shipped':
          item_status = 'item_shipped';
          break;
        case 'unshipped':
          item_status = 'item_ordered';
          break;
        default:
          item_status = '';
          break;
      }
      return item_status;
    }
  },
  watch: {
    $route: function $route(toPath, fromPath) {
      var tab = toPath.hash.substr(1);
      this.setTab(tab);
    }
  },
  methods: {
    reRenderManageAlbum: function reRenderManageAlbum() {
      this.loadAlbums();
    },
    showPromoteModal: function showPromoteModal() {},
    dismissFinishDialog: function dismissFinishDialog() {
      this.showReleaseAlbumModal = false;
    },
    setAlbumFilter: function setAlbumFilter(id) {
      //   update status if id is valid
      //   albumTab will be fallback idf id is not valid
      //   id will always be updated in future
      var status = id || this.albumTab;

      // this.albums.map((a) => console.log(a.status))
      // this.albums.map((a) => console.log(a.is_only_for_live_stream))

      //   update albumTab with valid instance
      this.albumTab = status;

      var filtered = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(this.albums, function (item) {
        return item.status === status;
      });

      //   console.log(this.albums)
      // console.log(this.products.filter((p) => p.status == 'published'))
      //   console.log(this.products.map((p) => p.status))
      // console.log(this.products.map((p) => p.collaborators))
      // console.log(filtered)
      return filtered;
    },
    loadAlbums: function loadAlbums() {
      var _this = this;

      this.$store.dispatch('error/showLoadingActivity', true);
      this.isPageReady = false;
      __WEBPACK_IMPORTED_MODULE_1__services_album__["a" /* default */].getAlbums().then(function (response) {
        _this.albums = response.body;
        // console.log(response)
        _this.$store.dispatch('error/showLoadingActivity', false);
        _this.isPageReady = true;
      }).catch(function (e) {
        _this.$store.dispatch('error/showLoadingActivity', false);
        _this.isPageReady = true;
        _this.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    openAlbumDeleteConfirmDialog: function openAlbumDeleteConfirmDialog(album) {
      this.album = album;
      this.show_album_delete_confirm_dialog = true;
    },
    closeAlbumDeleteConfirmDialog: function closeAlbumDeleteConfirmDialog() {
      this.album = {};
      this.show_album_delete_confirm_dialog = false;
    },
    deleteAlbum: function deleteAlbum() {
      var _this2 = this;

      // console.log('deleteAlbum', this.album)
      __WEBPACK_IMPORTED_MODULE_1__services_album__["a" /* default */].deleteAlbum(this.album.id).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.remove(_this2.albums, function (item) {
          return item.id == _this2.album.id;
        });
        var arr = _this2.albums.slice();
        _this2.albums = arr;
        _this2.closeAlbumDeleteConfirmDialog();
      }).catch(function (e) {
        _this2.closeAlbumDeleteConfirmDialog();
        _this2.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    editAlbum: function editAlbum(album) {
      // console.log('editAlbum', album)
      this.$router.push('/album/' + album.slug + '/edit');
    },
    openPublishConfirmDialog: function openPublishConfirmDialog(album) {
      this.album = album;
      this.show_publish_confirm_dialog = true;
    },
    openAccessLevelConfirmDialog: function openAccessLevelConfirmDialog(album) {
      this.album = album;
      this.show_access_level_confirm_dialog = true;
    },
    closeAccessLevelConfirmDialog: function closeAccessLevelConfirmDialog() {
      this.album = {};
      this.show_access_level_confirm_dialog = false;
    },
    openVideoOnlyConfirmDialog: function openVideoOnlyConfirmDialog(album) {
      this.album = album;
      this.show_video_only_confirm_dialog = true;
    },
    closeVideoOnlyConfirmDialog: function closeVideoOnlyConfirmDialog() {
      this.album = {};
      this.show_video_only_confirm_dialog = false;
    },
    updateAccessLevel: function updateAccessLevel() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_1__services_album__["a" /* default */].makeUpdateAccessLevel(this.album.id).then(function (response) {
        _this3.album.status = 'privated';
        _this3.closeAccessLevelConfirmDialog();
      }).catch(function (e) {
        _this3.closeAccessLevelConfirmDialog();
        _this3.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    videoOnlyAlbum: function videoOnlyAlbum() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_1__services_album__["a" /* default */].makeLiveVideoOnlyAlbum(this.album.id).then(function (response) {
        _this4.closeVideoOnlyConfirmDialog();
        _this4.album.status = 'published';
        _this4.album.is_only_for_live_stream = true;
      }).catch(function (e) {
        _this4.closeVideoOnlyConfirmDialog();
        _this4.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    acceptAlbum: function acceptAlbum(album) {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_1__services_album__["a" /* default */].acceptCollaboration(album.id).then(function (response) {
        _this5.loadAlbums();
      });
    },
    denyAlbum: function denyAlbum(album) {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_1__services_album__["a" /* default */].denyCollaboration(album.id).then(function (response) {
        _this6.loadAlbums();
      });
    },
    releaseAlbum: function releaseAlbum(album) {
      var _this7 = this;

      __WEBPACK_IMPORTED_MODULE_1__services_album__["a" /* default */].releaseAlbum(album.id).then(function (response) {
        _this7.active_tab = 'collaborated';
        _this7.$store.dispatch('error/showSuccessToast', ['Successfully released album.']);
        _this7.loadAlbums();
      });
    },
    isActiveTab: function isActiveTab(tab) {
      return this.active_tab === tab;
    },
    onTab: function onTab(tab) {
      this.$router.push({
        path: this.$route.path,
        hash: tab
      });
    },
    setTab: function setTab(tab) {
      if (!tab) {
        tab = 'orders';
      }

      this.active_tab = tab;
      // this.$store.dispatch('navigator/setCurrentState', { page: 'sell', tab: tab })
      this.$store.dispatch('navigator/goNextState', { page: 'sell', tab: tab });
    },
    isDigitalProduct: function isDigitalProduct(item) {
      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(item, 'product.category.is_digital', false);
    },
    isCollaborated: function isCollaborated(item) {
      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(item.product.collaborators, {
        user_id: this.currentUser.id
      });
    },
    editProduct: function editProduct(product) {
      this.$router.push('/product/edit/' + product.id);
    },
    openHelpDialog: function openHelpDialog() {
      this.show_help_dialog = true;
    },
    openProductFinishModal: function openProductFinishModal() {
      this.show_product_finish_modal = true;
    },
    closeProductFinishModal: function closeProductFinishModal() {
      this.show_product_finish_modal = false;
    },
    closeShipConfirmModal: function closeShipConfirmModal() {
      this.$refs.valid_tracking_form.reset();
      this.show_ship_confirm_modal = false;
    },
    openUnshipConfirmModal: function openUnshipConfirmModal(item) {
      this.selected_item = item;
      this.show_unship_confirm_modal = true;
    },
    closeUnshipConfirmModal: function closeUnshipConfirmModal() {
      this.show_unship_confirm_modal = false;
    },
    showMessageDialog: function showMessageDialog(order) {
      this.order_detail = order;
      this.showSendMessage = true;
    },
    dismissMessageModal: function dismissMessageModal() {
      this.showSendMessage = false;
    },
    openProductDeleteConfirmDialog: function openProductDeleteConfirmDialog(product) {
      this.product = product;
      this.product_delete_confirm_dialog = true;
    },
    closeProductDeleteConfirmDialog: function closeProductDeleteConfirmDialog() {
      this.product = {};
      this.product_delete_confirm_dialog = false;
    },
    notResponded: function notResponded(product) {
      var _this8 = this;

      var collaborator = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(product.collaborators, function (c) {
        return c.user_id == _this8.$store.state.auth.user.id;
      });
      // console.log('notResponded', this.$store.state.auth.user.id, collaborator)
      return collaborator && collaborator.status == 'pending';
    }
  },
  created: function created() {
    var _this9 = this;

    // if (this.$store.state.auth.user.user_type !== 'artist') {
    //   this.$router.push({ path: '/' })
    //   return
    // }
    var tab = this.$route.hash.substr(1);
    this.setTab(tab);
    var albumParams = localStorage.getItem("release_album");
    if (albumParams) {
      __WEBPACK_IMPORTED_MODULE_1__services_album__["a" /* default */].getAlbum(parseInt(albumParams)).then(function (resp) {
        _this9.releaseAlbumList = resp.body;
        if (_this9.releaseAlbumList) {
          _this9.showReleaseAlbumModal = true;
          localStorage.removeItem("release_album");
        }
      });
    }

    var lastState = this.$store.getters['navigator/last'];
    // console.log(lastState)
    if (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(lastState, 'params.album_id')) {
      __WEBPACK_IMPORTED_MODULE_1__services_album__["a" /* default */].getAlbum(lastState.params.album_id).then(function (response) {
        _this9.album = response.body;

        // console.log(response.body);
        _this9.openAlbumFinishModal();
      });
    }
    this.loadAlbums();
  },
  mounted: function mounted() {}
});

/***/ }),
/* 1063 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_contentTopHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_contentTopHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_contentTopHeader__);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    name: String,
    tabActivePill: Boolean
  },
  components: {
    contentTopHeader: __WEBPACK_IMPORTED_MODULE_2__components_contentTopHeader___default.a
  },
  data: function data() {
    return {
      activeTab: "",
      tabs: [{
        id: "upload",
        title: "Upload",
        pathName: "UploadAlbum"
      }, {
        id: "manage",
        title: "Manage",
        pathName: "ManageIndex"
      }]
    };
  },


  computed: {
    currentUser: function currentUser() {
      return this.$store.state.auth.user;
    }
  },

  methods: {
    isActiveTab: function isActiveTab(tab) {
      return this.name === tab;
    },
    isActiveInnerTab: function isActiveInnerTab(tab) {
      return this.activeInnerTab === tab;
    },
    setTab: function setTab(pathName) {
      this.$router.push({ name: pathName });
    }
  },

  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.activeTab = _this.name;

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 1064 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_auth__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_album__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_search__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_slick_carousel__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_slick_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_slick_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_slick_carousel_dist_vue_slick_carousel_css__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_slick_carousel_dist_vue_slick_carousel_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_slick_carousel_dist_vue_slick_carousel_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_slick_carousel_dist_vue_slick_carousel_theme_css__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_slick_carousel_dist_vue_slick_carousel_theme_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_slick_carousel_dist_vue_slick_carousel_theme_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__static_styles_vue_slick_carousel_scss__ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__static_styles_vue_slick_carousel_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__static_styles_vue_slick_carousel_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_genre_dialog__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_genre_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_genre_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_trackcard__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_trackcard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_trackcard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_contentTopHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_contentTopHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_contentTopHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_discoverNav__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_discoverNav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_discoverNav__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_userFollowBtn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_userFollowBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_userFollowBtn__);


/* global $:true */



















var filterArrowDownString = '<i class="material-icons icon icon--right theme--dark">keyboard_arrow_down</i>';

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    isComp: Boolean,
    listLimit: Number
  },
  components: {
    genreDialog: __WEBPACK_IMPORTED_MODULE_12__components_genre_dialog___default.a,
    trackCard: __WEBPACK_IMPORTED_MODULE_13__components_trackcard___default.a,
    contentTopHeader: __WEBPACK_IMPORTED_MODULE_14__components_contentTopHeader___default.a,
    discoverNav: __WEBPACK_IMPORTED_MODULE_15__components_discoverNav___default.a,
    VueSlickCarousel: __WEBPACK_IMPORTED_MODULE_8_vue_slick_carousel___default.a,
    UserFollowBtn: __WEBPACK_IMPORTED_MODULE_16__components_userFollowBtn___default.a
  },

  data: function data() {
    return {
      slickOptions: {
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 4,
        dots: false,
        cssEase: 'linear',
        arrows: true,
        nextArrow: '<button class="slider-move-icons next-icon"> ' + filterArrowDownString + ' </button>',
        prevArrow: '<button class="slider-move-icons next-icon"> ' + filterArrowDownString + ' </button>'
        //autoplay: true,
        //autoplaySpeed: 6000,
      },
      activeGenre: 'any',
      activeTab: '',
      tabs: [{ id: 'recommended', title: 'Trending' }, { id: 'new', title: 'New' }, { id: 'popular', title: 'Popular' }],
      seed: '',
      show_genre_selector_dialog: false,
      got_genre_tooltip: false,
      hover_on_genre_button: false,
      hover_on_genre_tooltip: false,
      page_index: 1,
      total_pages: 1,
      items_per_page: 1 * 50,
      genres: [],
      selected_genre: null,
      categories: [],
      selected_category: null,
      feeds: [],
      isPageReady: false,
      albumData: [],
      recommendedAlbums: [],
      newAlbums: [],
      popularAlbums: [],
      mainAlbum: null,
      viewAllNew: false,
      viewAllPopular: false,
      viewAllTrending: true,
      chosenGenres: [],
      buttonHover: false,
      busy: false
    };
  },


  computed: {
    followButtonText: function followButtonText() {
      if (this.mainAlbum.user.is_following) {
        return this.buttonHover ? 'Unfollow' : 'Following';
      }
      return 'Follow';
    },
    onMobile: function onMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    currentUser: function currentUser() {
      if (this.$store.state.auth.user) {
        this.fetchGenres();
      }
      return this.$store.state.auth.user;
    },
    showGenreTooltip: function showGenreTooltip() {
      return !this.got_genre_tooltip && (this.hover_on_genre_button || this.hover_on_genre_tooltip);
    },
    selectedGenreName: function selectedGenreName() {
      return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.selected_genre, 'name', 'All');
    },
    selectedCategoryName: function selectedCategoryName() {
      return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.selected_category, 'name', 'All Categories');
    },
    filtered_feeds: function filtered_feeds() {
      var _this = this;

      if (this.selected_genre) {
        var feeds = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(this.feeds, function (feed) {
          return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(feed.genres, function (genre) {
            return genre.id === _this.selected_genre.id;
          });
        });
        // this will return a a prop limit if available
        return feeds.slice(0, this.listLimit || this.feeds.length);
      } else {
        // this will return a a prop limit if available
        return this.feeds.slice(0, this.listLimit || this.feeds.length);
      }
    }
  },

  watch: {
    $route: function $route(toPath, fromPath) {
      var tab = toPath.hash.substr(1);
      this.setTab(tab);
    },

    '$store.state.app.sideBarMini': {
      handler: function handler(isMini) {
        if (isMini) {
          document.getElementById("new-album-container").className = 'sidebar-collapsed';
          document.getElementById("popular-album-container").className = 'sidebar-collapsed';
          this.popularAlbums = this.albumData.popular.slice(0, 12);
          this.newAlbums = this.albumData.new.slice(0, 12);
        } else {
          document.getElementById("new-album-container").className = 'container fluid grid-list-lg px-0 pt-4';
          document.getElementById("popular-album-container").className = 'container fluid grid-list-lg px-0 pt-4';
          this.popularAlbums = this.albumData.popular.slice(0, 10);
          this.newAlbums = this.albumData.new.slice(0, 10);
        }
      }
    }
  },

  beforeCreate: function beforeCreate() {
    this.$parent.$el.classList.add("loading");
  },
  created: function created() {
    this.$root.$on(__WEBPACK_IMPORTED_MODULE_5__helper__["b" /* MyEvents */].USER_FOLLOW, this.setFollowingStatus);
    // if (!this.currentUser) {
    //   AuthService.clearTokenAndUserInfo()
    //   this.$router.push({ path: '/login' })
    //   return
    // }

    // this.seed = parseInt(Date.now() * Math.random())
    this.seed = Math.random();
    var tab = this.$route.hash.substr(1);
    this.setTab(tab);
    // this.filterByGenre({id: 'any', name: 'All'})
  },
  beforeDestroy: function beforeDestroy() {
    this.$root.$off(__WEBPACK_IMPORTED_MODULE_5__helper__["b" /* MyEvents */].USER_FOLLOW, this.setFollowingStatus);
  },


  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])({
    setPlaylist: 'player/setPlaylist',
    setPlaylistIndex: 'player/setListIndex',
    setTrackIndex: 'player/setTrackIndex',
    setPlaying: 'player/setPlayingStatus'
  }), {
    setFollowingStatus: function setFollowingStatus(userId, isFollowing) {
      if (this.mainAlbum.user && this.mainAlbum.user.id === userId) {
        this.mainAlbum.user.is_following = isFollowing;
      }
    },
    fetchGenres: function fetchGenres() {
      var _this2 = this;

      this.chosenGenres = [];
      var genres = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(this.$store.state.app.genres);
      var hiddenGenres = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.keyBy(this.$store.state.auth.user.hidden_genres, 'id');

      __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(genres, function (genre) {
        __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(genre.children, function (child) {
          if (hiddenGenres[child.id]) {
            if (!_this2.chosenGenres.includes(genre)) {
              _this2.chosenGenres.push(genre);
            }
          }
        });
      });
    },
    displayNewTracks: function displayNewTracks() {
      this.page_index = 0;
      this.viewAllNew = true;
      this.viewAllPopular = false;
      this.viewAllTrending = false;
      this.newAlbums = [];
      this.loadMore();
    },
    displayPopularTracks: function displayPopularTracks() {
      this.page_index = 0;
      this.viewAllNew = false;
      this.viewAllPopular = true;
      this.viewAllTrending = false;
      this.popularAlbums = [];
      this.loadMore();
    },
    displayTrendingTracks: function displayTrendingTracks() {
      this.page_index = 0;
      this.viewAllNew = false;
      this.viewAllPopular = false;
      this.viewAllTrending = true;
      this.recommendedAlbums = [];
      this.loadMore();
    },
    isActiveTab: function isActiveTab(tab) {
      return this.activeTab === tab;
    },
    changeMainAlbum: function changeMainAlbum(selectedAlbum) {
      this.mainAlbum = selectedAlbum;
    },
    repostAlbum: function repostAlbum() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_6__services_album__["a" /* default */].repostAlbum(this.mainAlbum.id).then(function (response) {
        _this3.$store.dispatch('error/showSuccessToast', ['You added ' + _this3.mainAlbum.name + ' album in your collection.']);
      }).catch(function (e) {
        console.log(e);
        _this3.$store.dispatch("error/showErrorToast", e.body.errors || [e.body]);
      });
    },
    isPlaying: function isPlaying() {
      return this.$store.state.player.isPlaying && __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.$store.state.player.list[this.$store.state.player.listIndex], 'id') === this.mainAlbum.id;
    },
    pauseSong: function pauseSong() {
      this.$root.$emit(__WEBPACK_IMPORTED_MODULE_5__helper__["b" /* MyEvents */].AUDIO_PLAYER_PAUSE);
    },
    loadFeeds: function loadFeeds(tab, page) {
      var _this4 = this;

      if (this.busy) {
        return;
      }

      this.busy = true;
      var vm = this;
      this.$parent.$el.classList.add("loading");
      if (page === 1) {
        this.isPageReady = false;
      }
      this.$store.dispatch('error/showLoadingActivity', true);
      var genre = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.selected_genre, 'id', 'any');
      var category = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.selected_category, 'id', 'any');
      var params = {
        filter: tab,
        genre: genre,
        category: category,
        page: page,
        per_page: this.items_per_page
      };
      if (tab !== 'recommended') {
        params['seed'] = this.seed;
      }
      var api_response = this.currentUser != null ? __WEBPACK_IMPORTED_MODULE_7__services_search__["a" /* default */].searchDiscover(params) : __WEBPACK_IMPORTED_MODULE_7__services_search__["a" /* default */].searchDiscoverPublicUser(params);
      api_response.then(function (response) {
        var _recommendedAlbums, _newAlbums, _popularAlbums;

        _this4.$store.dispatch('error/showLoadingActivity', false);
        _this4.feeds = _this4.feeds.concat(response.body.new);
        _this4.albumData = response.body;
        (_recommendedAlbums = _this4.recommendedAlbums).push.apply(_recommendedAlbums, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(response.body.recommended));
        _this4.mainAlbum = _this4.recommendedAlbums[0];
        (_newAlbums = _this4.newAlbums).push.apply(_newAlbums, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(response.body.new));
        (_popularAlbums = _this4.popularAlbums).push.apply(_popularAlbums, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(response.body.popular));
        _this4.isPageReady = true;
        _this4.$parent.$el.classList.remove("loading");
        var genres = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.chain(_this4.feeds).map('genres').flatMap().keyBy('id').map(function (v, k) {
          return v;
        }).sortBy('name').value();
        _this4.genres = [
        // { id: 'go_to_filters', name: 'Set Genre Filters' },
        { id: 'any', name: 'All' }].concat(genres);

        _this4.page_index = response.body.pagination.current_page;
        _this4.total_pages = response.body.pagination.total_pages;

        // if (page === 1) {
        //   Promise.all([
        //     this.currentUser != null ? SearchService.searchDiscover(_.extend(params, { page: 2 })) : SearchService.searchDiscoverPublicUser(_.extend(params, { page: 2 })),
        //     this.currentUser != null ? SearchService.searchDiscover(_.extend(params, { page: 3 })) : SearchService.searchDiscoverPublicUser(_.extend(params, { page: 3 })),
        //     this.currentUser != null ? SearchService.searchDiscover(_.extend(params, { page: 4 })) : SearchService.searchDiscoverPublicUser(_.extend(params, { page: 4 })),
        //   ]).then((values) => {
        //     vm.feeds = vm.feeds.concat(
        //       values[0].body.albums,
        //       values[1].body.albums,
        //       values[2].body.albums
        //     )
        //     const genres = _.chain(vm.feeds)
        //       .map('genres')
        //       .flatMap()
        //       .keyBy('id')
        //       .map((v, k) => {
        //         return v
        //       })
        //       .sortBy('name')
        //       .value()
        //     vm.genres = [{ id: 'any', name: 'All' }].concat(genres)
        //     vm.page_index =
        //       values[2].body.pagination.total_pages > 4
        //         ? 4
        //         : values[2].body.pagination.total_pages
        //     // vm.isPageReady = true
        //   })
        // }
        _this4.busy = false;
      }).catch(function (e) {
        _this4.$store.dispatch('error/showLoadingActivity', false);
        // this.$store.dispatch('error/showErrorToast', e.body.errors || [e.body])
        console.log('discover error', e);
        _this4.busy = false;
      });
    },
    openGenreSelectorDialog: function openGenreSelectorDialog() {
      this.show_genre_selector_dialog = true;
    },
    closeGenreSelectorDialog: function closeGenreSelectorDialog() {
      this.show_genre_selector_dialog = false;
      this.setTab(this.activeTab);
    },
    filterByGenre: function filterByGenre(genre) {
      $('#genre_selector .btn__content').html(genre.name + filterArrowDownString);
      switch (genre.id) {
        // case 'go_to_filters':
        //   // this.$router.push({ path: '/settings#genre-filter' })
        //   this.openGenreSelectorDialog()
        //   break
        case 'any':
          this.selected_genre = null;
          break;
        default:
          this.selected_genre = genre;
      }
    },
    filterByCategory: function filterByCategory(category) {
      if (this.selected_category === category) return;

      $('#category_selector .btn__content').html(category.name + filterArrowDownString);
      switch (category.id) {
        case 'any':
          this.selected_category = null;
          break;
        default:
          this.selected_category = category;
      }

      // this.page_index = 1
      this.total_pages = 1;
      this.loadFeeds(this.activeTab, 1);
    },
    loadMore: function loadMore() {
      // this.page_index += 1
      this.loadFeeds(this.activeTab, this.page_index + 1);
    },
    hideAlbum: function hideAlbum(album) {
      __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.remove(this.feeds, function (item) {
        return item.id === album.id;
      });
      var arr = this.feeds.slice();
      this.feeds = arr;
    },
    onTab: function onTab(tab) {
      if (this.isComp) {
        this.$router.push({ name: 'AlbumIndex', params: { filter: tab } });
      } else {
        this.$router.push({
          path: this.$route.path,
          hash: tab
        });
      }
    },
    setTab: function setTab(tab) {
      var _this5 = this;

      if (!tab) {
        tab = 'recommended';
      }

      var paramFilter = this.$route.params.filter || '';

      if (paramFilter) {
        this.activeTab = paramFilter;
      } else {
        this.activeTab = tab;
      }

      // console.log(tab, this.activeTab)
      this.page_index = 1;
      this.total_pages = 1;
      this.feeds = [];
      this.selected_genre = null;
      this.selected_category = null;
      this.$store.dispatch('navigator/goNextState', {
        page: 'album',
        tab: tab
      });
      $('#genre_selector .btn__content').html('Any genre' + filterArrowDownString);
      this.$nextTick(function () {
        _this5.loadFeeds(_this5.activeTab, 1);
      });
    },
    playSong: function playSong() {
      if (this.$store.state.player.isPaused && this.$store.getters['player/currentAlbum'] && this.$store.getters['player/currentAlbum'].id == this.mainAlbum.id) {
        this.$root.$emit(__WEBPACK_IMPORTED_MODULE_5__helper__["b" /* MyEvents */].AUDIO_PLAYER_REPLAY);
      } else {
        this.setPlaylist([__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(this.mainAlbum)]);
        this.setPlaylistIndex(0);
        this.setPlaying(true);
        this.$root.$emit(__WEBPACK_IMPORTED_MODULE_5__helper__["b" /* MyEvents */].AUDIO_PLAYER_PLAY);
      }
    },
    back: function back() {
      this.loadFeeds(this.activeTab, 1);
      this.viewAllNew = false;
      this.viewAllPopular = false;
      this.viewAllTrending = false;
    },


    loadMoreOnScroll: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
      this.loadMore();
    }, 500),

    handleScroll: function handleScroll(e) {
      var element = e.target;
      var scrollTop = element.scrollTop;
      var halfScrollHeight = element.scrollHeight / 2;
      var gapHeight = halfScrollHeight + 200;
      if (scrollTop >= halfScrollHeight && scrollTop <= gapHeight) {
        this.loadMoreOnScroll();
      }
    }
  }),

  mounted: function mounted() {}
});

/***/ }),
/* 1065 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_album__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_album__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_album___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_album__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    albumCard: __WEBPACK_IMPORTED_MODULE_2__components_album___default.a
  },

  data: function data() {
    return {
      active_tab: null,
      tabs: [{ id: 'published', title: 'Published' }, { id: 'privated', title: 'Private' }, { id: 'video_only', title: 'Video Attachments' }, { id: 'collaborated', title: 'Collaborations' }, { id: 'pending', title: 'Pending Collaborations' }],
      albums: [],
      album: {},
      show_album_delete_confirm_dialog: false,
      show_publish_confirm_dialog: false,
      show_private_confirm_dialog: false,
      show_video_only_confirm_dialog: false,
      show_album_finish_modal: false,
      isPageReady: false
    };
  },


  computed: {
    currentUser: function currentUser() {
      return this.$store.state.auth.user;
    },
    published_albums: function published_albums() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(this.albums, function (item) {
        return item.status === 'published' && !item.is_only_for_live_stream;
      });
    },
    private_albums: function private_albums() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(this.albums, function (item) {
        return item.status === 'privated';
      });
    },
    video_only_albums: function video_only_albums() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(this.albums, function (item) {
        return item.status === 'published' && item.is_only_for_live_stream;
      });
    },
    pending_albums: function pending_albums() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(this.albums, function (item) {
        return item.status === 'pending';
      });
    },
    collaborated_albums: function collaborated_albums() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(this.albums, function (item) {
        return item.status === 'collaborated';
      });
    },
    albumStatus: function albumStatus() {
      if (this.album.status === 'published' && !this.album.is_only_for_live_stream) {
        return 'published';
      }

      if (this.album.status === 'published' && this.album.is_only_for_live_stream) {
        return 'video_only';
      }

      return 'privated';
    }
  },

  watch: {
    $route: function $route(toPath, fromPath) {
      var tab = toPath.hash.substr(1);
      this.setTab(tab);
    }
  },

  created: function created() {
    var _this = this;

    if (!this.$store.state.auth.user) {
      AuthService.clearTokenAndUserInfo();
      this.$router.push({ path: '/login' });
      return;
    }

    if (this.$store.state.auth.user.user_type !== 'artist') {
      this.$router.push({ path: '/' });
      return;
    }

    var tab = this.$route.hash.substr(1);
    this.setTab(tab);

    var lastState = this.$store.getters['navigator/last'];
    if (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(lastState, 'params.album_id')) {
      __WEBPACK_IMPORTED_MODULE_1__services_album__["a" /* default */].getAlbum(lastState.params.album_id).then(function (response) {
        _this.album = response.body;
        _this.openAlbumFinishModal();
      });
    }
    this.loadAlbums();
  },


  methods: {
    isActiveTab: function isActiveTab(tab) {
      return this.active_tab == tab;
    },
    loadAlbums: function loadAlbums() {
      var _this2 = this;

      this.$store.dispatch('error/showLoadingActivity', true);
      this.isPageReady = false;
      __WEBPACK_IMPORTED_MODULE_1__services_album__["a" /* default */].getAlbums().then(function (response) {
        _this2.albums = response.body;
        _this2.$store.dispatch('error/showLoadingActivity', false);
        _this2.isPageReady = true;
      }).catch(function (e) {
        _this2.$store.dispatch('error/showLoadingActivity', false);
        _this2.isPageReady = true;
        _this2.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    openAlbumFinishModal: function openAlbumFinishModal() {
      this.show_album_finish_modal = true;
    },
    closeAlbumFinishModal: function closeAlbumFinishModal() {
      this.show_album_finish_modal = false;
    },
    openAlbumDeleteConfirmDialog: function openAlbumDeleteConfirmDialog(album) {
      this.album = album;
      this.show_album_delete_confirm_dialog = true;
    },
    closeAlbumDeleteConfirmDialog: function closeAlbumDeleteConfirmDialog() {
      this.album = {};
      this.show_album_delete_confirm_dialog = false;
    },
    deleteAlbum: function deleteAlbum() {
      var _this3 = this;

      // console.log('deleteAlbum', this.album)
      __WEBPACK_IMPORTED_MODULE_1__services_album__["a" /* default */].deleteAlbum(this.album.id).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.remove(_this3.albums, function (item) {
          return item.id == _this3.album.id;
        });
        var arr = _this3.albums.slice();
        _this3.albums = arr;
        _this3.closeAlbumDeleteConfirmDialog();
      }).catch(function (e) {
        _this3.closeAlbumDeleteConfirmDialog();
        _this3.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    editAlbum: function editAlbum(album) {
      // console.log('editAlbum', album)
      this.$router.push('/album/' + album.slug + '/edit');
    },
    openPublishConfirmDialog: function openPublishConfirmDialog(album) {
      this.album = album;
      this.show_publish_confirm_dialog = true;
    },
    closePublishConfirmDialog: function closePublishConfirmDialog() {
      this.album = {};
      this.show_publish_confirm_dialog = false;
    },
    openPrivateConfirmDialog: function openPrivateConfirmDialog(album) {
      this.album = album;
      this.show_private_confirm_dialog = true;
    },
    closePrivateConfirmDialog: function closePrivateConfirmDialog() {
      this.album = {};
      this.show_private_confirm_dialog = false;
    },
    openVideoOnlyConfirmDialog: function openVideoOnlyConfirmDialog(album) {
      this.album = album;
      this.show_video_only_confirm_dialog = true;
    },
    closeVideoOnlyConfirmDialog: function closeVideoOnlyConfirmDialog() {
      this.album = {};
      this.show_video_only_confirm_dialog = false;
    },
    publishAlbum: function publishAlbum() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_1__services_album__["a" /* default */].makePublicAlbum(this.album.id).then(function (response) {
        _this4.album.status = 'published';
        _this4.album.is_only_for_live_stream = false;
        _this4.closePublishConfirmDialog();
      }).catch(function (e) {
        _this4.closePublishConfirmDialog();
        _this4.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    privateAlbum: function privateAlbum() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_1__services_album__["a" /* default */].makePrivateAlbum(this.album.id).then(function (response) {
        _this5.album.status = 'privated';
        _this5.closePrivateConfirmDialog();
      }).catch(function (e) {
        _this5.closePrivateConfirmDialog();
        _this5.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    videoOnlyAlbum: function videoOnlyAlbum() {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_1__services_album__["a" /* default */].makeLiveVideoOnlyAlbum(this.album.id).then(function (response) {
        _this6.closeVideoOnlyConfirmDialog();
        _this6.album.status = 'published';
        _this6.album.is_only_for_live_stream = true;
      }).catch(function (e) {
        _this6.closeVideoOnlyConfirmDialog();
        _this6.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    notResponded: function notResponded(album) {
      var _this7 = this;

      var collaborator = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(album.collaborators, function (c) {
        return c.user_id == _this7.$store.state.auth.user.id;
      });
      // console.log('notResponded', this.$store.state.auth.user.id, collaborator)
      return collaborator && collaborator.status == 'pending';
    },
    acceptAlbum: function acceptAlbum(album) {
      var _this8 = this;

      __WEBPACK_IMPORTED_MODULE_1__services_album__["a" /* default */].acceptCollaboration(album.id).then(function (response) {
        _this8.loadAlbums();
      });
    },
    denyAlbum: function denyAlbum(album) {
      var _this9 = this;

      __WEBPACK_IMPORTED_MODULE_1__services_album__["a" /* default */].denyCollaboration(album.id).then(function (response) {
        _this9.loadAlbums();
      });
    },
    releaseAlbum: function releaseAlbum(album) {
      var _this10 = this;

      __WEBPACK_IMPORTED_MODULE_1__services_album__["a" /* default */].releaseAlbum(album.id).then(function (response) {
        _this10.active_tab = 'collaborated';
        _this10.loadAlbums();
      });
    },
    onTab: function onTab(tab) {
      this.$router.push({
        path: this.$route.path,
        hash: tab
      });
    },
    setTab: function setTab(tab) {
      if (!tab) {
        tab = 'published';
      }

      this.active_tab = tab;
      // this.$store.dispatch('navigator/setCurrentState', { page: 'manage', tab: tab })
      this.$store.dispatch('navigator/goNextState', {
        page: 'manage',
        tab: tab
      });
    }
  },

  mounted: function mounted() {}
});

/***/ }),
/* 1066 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_emoji_mart_vue__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_emoji_mart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_emoji_mart_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuedraggable__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_album__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_playlist__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_comment__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_user__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_activityitem__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_activityitem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_activityitem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_albumtrackitem__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_albumtrackitem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_albumtrackitem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_downloadmodal__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_downloadmodal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_downloadmodal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_productcard__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_productcard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_productcard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_profileitem__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_profileitem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_profileitem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_trackcard__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_trackcard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_trackcard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_videocard__ = __webpack_require__(636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_videocard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_videocard__);




















/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    activityItem: __WEBPACK_IMPORTED_MODULE_10__components_activityitem___default.a,
    albumTrackItem: __WEBPACK_IMPORTED_MODULE_11__components_albumtrackitem___default.a,
    downloadModal: __WEBPACK_IMPORTED_MODULE_12__components_downloadmodal___default.a,
    productCard: __WEBPACK_IMPORTED_MODULE_13__components_productcard___default.a,
    profileItem: __WEBPACK_IMPORTED_MODULE_14__components_profileitem___default.a,
    trackCard: __WEBPACK_IMPORTED_MODULE_15__components_trackcard___default.a,
    videoCard: __WEBPACK_IMPORTED_MODULE_16__components_videocard___default.a,
    Picker: __WEBPACK_IMPORTED_MODULE_3_emoji_mart_vue__["Picker"],
    draggable: __WEBPACK_IMPORTED_MODULE_4_vuedraggable___default.a
  },

  data: function data() {
    return {
      showDownloadModal: false,
      showEmojiPicker: false,
      slug: null,
      playlist: null,
      selectedImage: null,
      playlist_dialog: false,
      trackIndex: 0,
      comments: [],
      commentString: '',
      comment_pagination: {
        count: 0,
        current_page: 0,
        per_page: 5,
        total_count: 0,
        total_pages: 0
      },
      buttonHover: []
    };
  },


  computed: {
    currentUser: function currentUser() {
      return this.$store.state.auth.user;
    },
    coverImageURL: function coverImageURL() {
      if (this.playlist.cover) {
        return this.playlist.cover.large.url;
      } else {
        return '';
      }
    },
    coverThumbImageURL: function coverThumbImageURL() {
      if (this.playlist.cover) {
        return this.playlist.cover.thumb.url + '?' + new Date();
      } else {
        return '';
      }
    },
    commentsCount: function commentsCount() {
      if (this.comment_pagination.total_count > 0) {
        return this.comment_pagination.total_count;
      } else {
        return 'No';
      }
    },
    hasMoreComments: function hasMoreComments() {
      return this.comment_pagination.current_page < this.comment_pagination.total_pages;
    },
    isPlaying: function isPlaying() {
      return this.$store.state.player.isPlaying && __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(this.$store.state.player.list[this.$store.state.player.listIndex], 'id') === this.playlist.id;
    },
    album1Cover: function album1Cover() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(this.playlist.tracks, '[0].album.cover.url');
    },
    album2Cover: function album2Cover() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(this.playlist.tracks, '[1].album.cover.url');
    },
    album3Cover: function album3Cover() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(this.playlist.tracks, '[2].album.cover.url');
    },
    album4Cover: function album4Cover() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(this.playlist.tracks, '[3].album.cover.url');
    },
    input_id: function input_id() {
      return 'playlist_image_file_' + this.playlist.slug + '_' + parseInt(Math.random() * 999999);
    }
  },

  watch: {
    $route: function $route(to, from) {
      var toPath = to.path.split('/');
      this.slug = toPath[2];
      this.trackIndex = 0;
      this.getPlaylist(this.slug);
    }
  },

  created: function created() {
    this.$store.dispatch('navigator/goNextState', { page: 'playlist', tab: '' });
    this.slug = this.$route.params.slug;
    this.getPlaylist(this.slug);
  },


  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])({
    setPlaylist: 'player/setPlaylist',
    setPlaylistIndex: 'player/setListIndex',
    setTrackIndex: 'player/setTrackIndex',
    setPlaying: 'player/setPlayingStatus'
  }), {
    convertedHTML: function convertedHTML(text) {
      var matches = text.match(/@[A-Za-z0-9]+(?:[_-][A-Za-z0-9]+)*/g);
      for (var index in matches) {
        var match = matches[index];
        var user_name = match.substr(1);
        var reg = new RegExp(match, 'g');
        // text = text.replace(reg, `<a href="/${user_name}">${match}</a>`)
        text = text.replace(reg, '<a href="/' + user_name + '">' + match + '</a>');
      }
      return text;
    },
    getPlaylist: function getPlaylist(slug) {
      var _this = this;

      this.$store.dispatch('error/showLoadingActivity', true);
      var vm = this;
      __WEBPACK_IMPORTED_MODULE_6__services_album__["a" /* default */].getAlbum(slug).then(function (response) {
        _this.$store.dispatch('error/showLoadingActivity', false);
        _this.playlist = response.body;
        for (var index in _this.playlist.tracks) {
          _this.buttonHover.push(false);
        }
        _this.loadMoreComments();
        _this.selectedImage = _this.playlist.cover.url;
        setTimeout(function () {
          vm.changeBackground();
          var height = $('#album_info_page').height() + 230;
          var screen_height = $(window).height();
          if (height > screen_height) {
            height += 50;
          } else {
            height = screen_height;
          }
          var canvas = document.getElementById('canvas');
          canvas.height = height;
          // $('#back_image').css("cssText", "height: " + height + "px !important;")
        }, 200);
      }).catch(function (e) {
        _this.$store.dispatch('error/showLoadingActivity', false);
        _this.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    changeBackground: function changeBackground() {
      var canvas = document.getElementById('canvas');
      var cctx = canvas.getContext('2d');
      var buff = document.createElement('canvas');
      buff.width = canvas.width;
      buff.height = canvas.height;

      var imageObj = new Image();
      // this will make CORS happy because the server is well configured
      imageObj.crossOrigin = 'anonymous';
      // Easiest is to always host your images on your own server
      // imageObj.src = 'https://dl.dropboxusercontent.com/s/8q8sjnqmmto13h5/lionCMYK.jpg'
      imageObj.src = this.coverThumbImageURL;
      imageObj.onload = function () {
        // canvas.width = imageObj.height
        // canvas.height = imageObj.height
        cctx.drawImage(imageObj, 0, 0);
        StackBlur.image(imageObj, canvas, 70, false);
        var height = $('#album_info_page').height() + 230;
        var screen_height = $(window).height();
        if (height > screen_height) {
          height += 50;
        } else {
          height = screen_height;
        }
        if (canvas) {
          $('#canvas').css('cssText', 'height: ' + height + 'px !important;');
        }
        $('#back_image').css('cssText', 'height: ' + height + 'px !important;');
      };
    },
    addComments: function addComments() {
      var _this2 = this;

      var params = new FormData();
      params.append('comment[commentable_type]', 'Album');
      params.append('comment[commentable_id]', this.playlist.id);
      params.append('comment[body]', this.commentString);
      this.commentString = '';
      __WEBPACK_IMPORTED_MODULE_8__services_comment__["a" /* default */].sendComment(params).then(function (response) {
        _this2.comments.unshift(response.body);
        _this2.comment_pagination.total_count += 1;
      }).catch(function (e) {
        _this2.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    loadMoreComments: function loadMoreComments() {
      var _this3 = this;

      var params = {
        commentable_type: 'Album',
        commentable_id: this.playlist.id,
        page: this.comment_pagination.current_page + 1,
        per_page: this.comment_pagination.per_page
      };
      __WEBPACK_IMPORTED_MODULE_8__services_comment__["a" /* default */].getComments(params).then(function (response) {
        _this3.comments = _this3.comments.concat(response.body.comments);
        _this3.comment_pagination = response.body.pagination;
      }).catch(function (e) {
        _this3.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    makePublicComment: function makePublicComment(comment) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_8__services_comment__["a" /* default */].makePublicComment(comment.id).then(function (response) {
        _this4.$store.dispatch('error/showSuccessToast', ['You made a comment public!']);
      }).catch(function (e) {
        _this4.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    makePrivateComment: function makePrivateComment(comment) {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_8__services_comment__["a" /* default */].makePrivateComment(comment.id).then(function (response) {
        _this5.$store.dispatch('error/showSuccessToast', ['You made a comment private!']);
      }).catch(function (e) {
        _this5.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    blockUser: function blockUser(comment) {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_9__services_user__["a" /* default */].blockUser(comment.user.id).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.remove(_this6.comments, function (item) {
          return item.user.id == comment.user.id;
        });
        var arr = _this6.comments.slice();
        _this6.comments = arr;
      }).catch(function (e) {
        _this6.$store.dispatch('error/showLoadingActivity', false);
        _this6.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    deleteComment: function deleteComment(comment) {
      var _this7 = this;

      __WEBPACK_IMPORTED_MODULE_8__services_comment__["a" /* default */].deleteComment(comment.id).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.remove(_this7.comments, function (item) {
          return item.id == comment.id;
        });
        var arr = _this7.comments.slice();
        _this7.comments = arr;
      }).catch(function (e) {
        _this7.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    selectTrack: function selectTrack(index) {
      this.trackIndex = index;
      if (this.isPlaying) {
        this.$root.$emit(__WEBPACK_IMPORTED_MODULE_5__helper__["b" /* MyEvents */].AUDIO_PLAYER_SKIPTO, index);
      } else {
        this.setPlaylist([this.playlist]);
        this.setPlaylistIndex(0);
        this.setPlaying(true);
        this.$root.$emit(__WEBPACK_IMPORTED_MODULE_5__helper__["b" /* MyEvents */].AUDIO_PLAYER_PLAY, index);
      }
    },
    playSong: function playSong() {
      if (this.$store.state.player.isPaused) {
        this.$root.$emit(__WEBPACK_IMPORTED_MODULE_5__helper__["b" /* MyEvents */].AUDIO_PLAYER_REPLAY);
      } else {
        this.setPlaylist([this.playlist]);
        this.setPlaylistIndex(0);
        this.setPlaying(true);
        this.$root.$emit(__WEBPACK_IMPORTED_MODULE_5__helper__["b" /* MyEvents */].AUDIO_PLAYER_PLAY);
      }
    },
    pauseSong: function pauseSong() {
      this.$root.$emit(__WEBPACK_IMPORTED_MODULE_5__helper__["b" /* MyEvents */].AUDIO_PLAYER_PAUSE);
    },
    dismissDownloadModal: function dismissDownloadModal() {
      this.showDownloadModal = false;
    },
    repostItem: function repostItem() {
      var _this8 = this;

      __WEBPACK_IMPORTED_MODULE_6__services_album__["a" /* default */].repostAlbum(this.playlist.id).then(function (response) {
        console.log(response);
        _this8.$store.dispatch('error/showSuccessToast', ['You just reposted ' + _this8.playlist.name]);
      }).catch(function (e) {
        _this8.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    hoverTrackItem: function hoverTrackItem(index, status) {
      this.buttonHover[index] = status;
      this.buttonHover = this.buttonHover.slice();
    },
    imageChanged: function imageChanged(e) {
      var _this9 = this;

      this.playlist.image = e.target.files[0];
      var reader = new FileReader();
      reader.addEventListener('load', function (event) {
        _this9.selectedImage = event.target.result;
      }, false);
      reader.readAsDataURL(this.playlist.image);
    },
    updatePlaylist: function updatePlaylist() {
      var _this10 = this;

      if (this.playlist.name.replace(' ', '').length > 0) {
        var params = new FormData();
        params.append('name', this.playlist.name);
        params.append('description', this.playlist.name);
        // if (this.playlist.image) {
        //   params.append('cover', this.playlist.image)
        // }
        this.$store.dispatch('error/showLoadingActivity', true);
        __WEBPACK_IMPORTED_MODULE_7__services_playlist__["a" /* default */].updatePlaylist(this.playlist.id, params).then(function (response) {
          _this10.playlist_dialog = false;
          _this10.$store.dispatch('error/showLoadingActivity', false);
          _this10.$store.dispatch('error/showSuccessToast', ['Updated Playlist ']);
          _this10.getPlaylist(_this10.playlist.slug);
        }).catch(function (e) {
          _this10.$store.dispatch('error/showLoadingActivity', false);
          _this10.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
        });
      } else {
        this.$store.dispatch('error/showErrorToast', ['Please input Playlist name.']);
      }
    },
    removeTrack: function removeTrack(track) {
      var _this11 = this;

      if (this.playlist.tracks.length == 1) {
        this.$store.dispatch('error/showErrorToast', ['You have only one track']);
        return;
      }

      var params = {
        track_id: track.id
      };
      __WEBPACK_IMPORTED_MODULE_7__services_playlist__["a" /* default */].removeTrack(this.playlist.id, params).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.remove(_this11.playlist.tracks, function (item) {
          return item.id == params.track_id;
        });
        var arr = _this11.playlist.tracks.slice();
        _this11.playlist.tracks = arr;
      });
    },
    deletePlaylist: function deletePlaylist() {
      var _this12 = this;

      __WEBPACK_IMPORTED_MODULE_7__services_playlist__["a" /* default */].deletePlaylist(this.playlist.id).then(function (response) {
        _this12.playlist_dialog = false;
        _this12.$store.dispatch('error/showSuccessToast', ['Deleted Playlist ']);

        __WEBPACK_IMPORTED_MODULE_7__services_playlist__["a" /* default */].getPlaylists().then(function (response) {
          _this12.$store.dispatch('playlist/setPlaylists', response.body);
          _this12.$router.push({ path: '/album' });
        });
      }).catch(function (e) {
        _this12.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    addEmoji: function addEmoji(emoji, event) {
      this.showEmojiPicker = false;
      this.commentString += emoji.native;
      this.$refs.comment.focus();
    },
    onEnd: function onEnd() {
      var _this13 = this;

      var tracks_ids = [];
      for (var index in this.playlist.tracks) {
        var track = this.playlist.tracks[index];
        tracks_ids.push(track.id);
        var params = new FormData();
        params.append('track_ids', tracks_ids.join(','));
        __WEBPACK_IMPORTED_MODULE_6__services_album__["a" /* default */].rearrangeTracks(this.playlist.id, params).then(function (response) {
          _this13.$store.dispatch('error/showSuccessToast', ['Updated order of tracks.']);
        }).catch(function (e) {
          _this13.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
        });
      }
    }
  }),

  mounted: function mounted() {
    var vm = this;
    $(window).resize(function () {
      var height = $('#album_info_page').height() + 230;
      var screen_height = $(window).height();
      if (height > screen_height) {
        height += 50;
      } else {
        height = screen_height;
      }
      var canvas = document.getElementById('canvas');
      if (canvas) {
        $('#canvas').css('cssText', 'height: ' + height + 'px !important;');
      }
      $('#back_image').css('cssText', 'height: ' + height + 'px !important;');
    }).trigger('resize');
  },
  updated: function updated() {}
});

/***/ }),
/* 1067 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_genre_single_selector__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_genre_single_selector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_genre_single_selector__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_sample_license_dialog__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_sample_license_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_sample_license_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_trackuploader__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_trackuploader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_trackuploader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_contentTopHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_contentTopHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_contentTopHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__BannerUpload__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__BannerUpload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__BannerUpload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_me__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_album__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_user__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_product__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__services_profile__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__helper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_music_sound_svg__ = __webpack_require__(763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_music_sound_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_music_sound_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_album_drop_gif__ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_album_drop_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__assets_album_drop_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_nav_vue__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_nav_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_nav_vue__);




















/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    genreSingleSelector: __WEBPACK_IMPORTED_MODULE_4__components_genre_single_selector___default.a,
    sampleLicenseDialog: __WEBPACK_IMPORTED_MODULE_5__components_sample_license_dialog___default.a,
    trackUploader: __WEBPACK_IMPORTED_MODULE_6__components_trackuploader___default.a,
    contentTopHeader: __WEBPACK_IMPORTED_MODULE_7__components_contentTopHeader___default.a,
    BannerUpload: __WEBPACK_IMPORTED_MODULE_8__BannerUpload___default.a,
    uploadNav: __WEBPACK_IMPORTED_MODULE_17__components_nav_vue___default.a
  },

  data: function data() {
    return {
      activeTab: 'music',
      loading: false,
      iconImage: __WEBPACK_IMPORTED_MODULE_15__assets_music_sound_svg___default.a,
      bannerImage: __WEBPACK_IMPORTED_MODULE_16__assets_album_drop_gif___default.a,
      majorDropdown: false,
      keyDropdown: false,
      majorValue: "none",
      keyValue: "none",
      keyOptions: ["C", "C#", "D", "Eb", "E", "F", "F#", "G", "Ab", "A", "Bb", "B"],
      tabs: [{ id: 'upload', title: 'Upload', isParent: true, path: 'UploadIndex' }, { id: 'music', title: 'Music', path: 'UploadAlbum' }, { id: 'video', title: 'Video', path: 'VideoUpload' }, { id: 'product', title: 'Product', path: 'AddProduct' }, { id: 'live', title: 'Broadcast Live', path: 'CreateLive' }],
      isNeededToRelease: false,
      genres: [],
      products: [],
      selected_product: null,
      album: {
        name: '',
        released_at: null,
        location: '',
        genres: '',
        description: '',
        is_only_for_live_stream: false,
        is_content_acapella: false,
        is_content_instrumental: false,
        is_content_stems: false,
        is_content_remix: false,
        is_content_dj_mix: false,
        enabled_sample: 'false',
        image: null,
        cover: null,
        tracks: [],
        slug: null,
        user: {},
        bpm: '',
        access_level: [],
        download_price: 1
      },
      album_image_url: null,
      locations: [],
      followings: [],
      users: [],
      potential_collaborators: [],
      potential_contributors: [],
      collaborators: [],
      contributors: [],
      samplings: [],
      artists: [],
      sampling_min_id: 0,
      page_index: 1,
      total_pages: 1,
      items_per_page: 30,
      show_genre_selector_dialog: false,
      show_sample_clearance_license_modal: false,
      isPageReady: false,
      albumUrl: null,
      access_levels: [],
      slug: null
    };
  },


  computed: {
    onMobile: function onMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    currentUser: function currentUser() {
      return this.$store.state.auth.user;
    },
    isAvailableToUploadAlbum: function isAvailableToUploadAlbum() {
      // console.log('isAvailableToUploadAlbum', this.album.tracks)
      var failed_track = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(this.album.tracks, function (track) {
        return track.status != 2;
      });
      var has_failed_track = !!failed_track;
      var bpmLevelGood = false;
      if (this.album.bpm == '' || this.album.bpm >= 1 && this.album.bpm <= 999) {
        bpmLevelGood = true;
      }
      var isSamplingsGood = true;
      var sampling_track_id = 0;
      var sample_track_id = 0;
      var sample_album_id = 0;
      var sample_user_id = 0;
      for (var i = 0; i < this.samplings.length; i++) {
        sampling_track_id = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.samplings[i], 'sampling_track_id', 0);
        sample_track_id = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.samplings[i], 'sample_track_id', 0);
        sample_album_id = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.samplings[i], 'sample_album_id.id', this.samplings[i].sample_album_id);
        sample_user_id = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.samplings[i], 'sample_user_id.id', this.samplings[i].sample_user_id);
        // console.log(i, sampling_track_id, sample_track_id, sample_album_id, sample_user_id)
        if (!(sampling_track_id > 0 && sample_track_id > 0 && sample_album_id > 0 && sample_user_id > 0)) {
          isSamplingsGood = false;
          break;
        }
      }

      return isSamplingsGood && this.album.tracks.length > 0 && !has_failed_track && this.album.name.length && this.album.image && (this.album.tracks.length > 1 && this.album.download_price >= 1 && this.album.download_price <= 1000 || this.album.tracks.length == 1) && this.$store.state.genreSelector.genres.length > 0 && bpmLevelGood;
    },
    isAvailableToEditAlbum: function isAvailableToEditAlbum() {
      // console.log('isAvailableToUploadAlbum', this.album.tracks)
      var failed_track = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(this.album.tracks, function (track) {
        return track.status !== 2;
      });
      var has_failed_track = !!failed_track;
      var isSamplingsGood = true;
      var sampling_track_id = 0;
      var sample_track_id = 0;
      var sample_album_id = 0;
      var sample_user_id = 0;
      var bpmLevelGood = false;
      if (this.album.bpm == '' || this.album.bpm >= 1 && this.album.bpm <= 999) {
        bpmLevelGood = true;
      }
      for (var i = 0; i < this.samplings.length; i++) {
        sampling_track_id = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.samplings[i], 'sampling_track_id', 0);
        sample_track_id = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.samplings[i], 'sample_track_id', 0);
        sample_album_id = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.samplings[i], 'sample_album_id.id', this.samplings[i].sample_album_id);
        sample_user_id = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.samplings[i], 'sample_user_id.id', this.samplings[i].sample_user_id);
        // console.log(i, sampling_track_id, sample_track_id, sample_album_id, sample_user_id)
        if (!(sampling_track_id > 0 && sample_track_id > 0 && sample_album_id > 0 && sample_user_id > 0)) {
          isSamplingsGood = false;
          break;
        }
      }
      return isSamplingsGood && this.album.tracks.length > 0 && !has_failed_track && this.album.name.length && this.album_image_url && this.$store.state.genreSelector.genres.length > 0 && bpmLevelGood;
    },
    role_types: function role_types() {
      return __WEBPACK_IMPORTED_MODULE_14__helper__["K" /* CollaboratorRoleTypes */];
    }
  },

  created: function created() {
    var _this = this;

    if (this.onMobile) {
      this.$router.push({ name: "UploadIndex" });
    }

    var slug = this.$route.params.slug;

    this.$store.dispatch('navigator/goNextState', { page: 'upload', tab: '' });
    if (this.currentUser && (this.currentUser.user_type === 'artist' || this.currentUser.user_type === 'brand')) {

      // check if its edit mode or create mode
      if (slug) {
        var vm = this;
        this.isPageReady = false;
        this.$store.dispatch('error/showLoadingActivity', true);
        this.slug = this.$route.params.slug;
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([
        // UserService.searchUsers(params)
        __WEBPACK_IMPORTED_MODULE_12__services_product__["a" /* default */].getProducts({
          statuses: 'published, collaborated',
          stock_statuses: 'active',
          user_statuses: 'accepted'
        }), __WEBPACK_IMPORTED_MODULE_10__services_album__["a" /* default */].getAlbum(this.slug), __WEBPACK_IMPORTED_MODULE_9__services_me__["a" /* default */].mutualUsers({
          per_page: -1
        }), __WEBPACK_IMPORTED_MODULE_13__services_profile__["a" /* default */].getItems(this.currentUser.id, 'sample_followings', {
          per_page: -1
        })]).then(function (values) {
          _this.genres = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.flatMap(_this.$store.state.app.genres, 'children');
          _this.products = values[0].body;

          _this.potential_collaborators = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(values[2].body.users);
          _this.potential_contributors = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(values[2].body.users);
          _this.potential_contributors.unshift(_this.currentUser);
          _this.artists = values[3].body.users;

          _this.album = values[1].body;
          _this.majorValue = _this.album.bpm_key;
          _this.keyValue = _this.album.bpm_value;
          _this.album_image_url = _this.album.cover.url;
          if (_this.album.released_at) {
            _this.album.released_at = __WEBPACK_IMPORTED_MODULE_3_moment___default()(_this.album.released_at).format('YYYY-MM-DD');
          } else {
            _this.album.released_at = __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD');
          }
          _this.album.enabled_sample = _this.album.enabled_sample.toString();

          _this.$store.dispatch('genreSelector/setGenres', _this.album.genres);
          if (_this.album.products.length > 0) {
            _this.selected_product = _this.album.products[0].id;
          }
          if (_this.album.collaborators.length > 0) {
            _this.collaborators = _this.album.collaborators;
          }
          if (_this.album.contributors.length > 0) {
            _this.contributors = _this.album.contributors;
          }
          if (_this.album.samplings.length > 0) {
            _this.samplings = _this.album.samplings;
            __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(_this.samplings, function (sampling) {
              var artists = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(_this.artists);
              __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(artists, function (u) {
                u.sampling_id = sampling.id;
              });
              sampling.artists = artists;
            });

            var users_ids = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.chain(_this.samplings).map('sample_user_id').uniq().value();
            var fns = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(users_ids, function (user_id) {
              return __WEBPACK_IMPORTED_MODULE_10__services_album__["a" /* default */].getAlbums({
                statuses: 'published, collaborated',
                user_statuses: 'accepted',
                user_id: user_id,
                enabled_sample: true
              });
            });
            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(fns).then(function (values) {
              var _loop = function _loop(i) {
                var samplings = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(_this.samplings, function (s) {
                  return s.sample_user_id === users_ids[i];
                });
                __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(samplings, function (sampling) {
                  var albums = values[i].body;
                  __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(albums, function (a) {
                    a.sampling_id = sampling.id;
                  });
                  sampling.artist_albums = albums;
                  sampling.artist_album_tracks = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(albums, function (a) {
                    return a.id === sampling.sample_album_id;
                  }).tracks;
                  // console.log('samplings', this.samplings)
                });
              };

              for (var i = 0; i < values.length; i++) {
                _loop(i);
              }

              _this.isPageReady = true;
              _this.$store.dispatch('error/showLoadingActivity', false);
            });
          } else {
            _this.isPageReady = true;
            _this.$store.dispatch('error/showLoadingActivity', false);
          }
          // console.log('album_edit created', this.users)
          setTimeout(function () {
            $('#album_image').css('background-image', 'url(' + vm.album.cover.url + ')');
          }, 200);
        }).catch(function (reason) {
          console.log(reason);
          _this.$store.dispatch('error/showLoadingActivity', false);
          _this.$store.dispatch('error/showErrorToast', reason);
          // this.isPageReady = true
        });
      } else {
        this.album.released_at = __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD');
        this.isPageReady = false;
        this.$store.dispatch('error/showLoadingActivity', true);
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([
        // UserService.searchUsers(params),
        __WEBPACK_IMPORTED_MODULE_12__services_product__["a" /* default */].getProducts({
          statuses: 'published, collaborated',
          stock_statuses: 'active',
          user_statuses: 'accepted'
        }), __WEBPACK_IMPORTED_MODULE_9__services_me__["a" /* default */].mutualUsers({
          per_page: -1
        }), __WEBPACK_IMPORTED_MODULE_13__services_profile__["a" /* default */].getItems(this.currentUser.id, 'sample_followings', {
          per_page: -1
        })]).then(function (values) {
          _this.products = values[0].body;
          _this.$store.dispatch('genreSelector/setGenres', []);

          _this.genres = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.flatMap(_this.$store.state.app.genres, 'children');

          // this.followings = _.cloneDeep(values[1].body.users)
          // this.users = _.cloneDeep(values[1].body.users)
          // this.users.unshift(this.currentUser)
          // // this.artists = _.filter(this.followings, (user) => (user.user_type === 'artist'))
          // this.artists = _.cloneDeep(values[2].body.users)

          _this.potential_collaborators = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(values[1].body.users);
          _this.potential_contributors = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(values[1].body.users);
          _this.potential_contributors.unshift(_this.currentUser);
          _this.artists = values[2].body.users;

          _this.isPageReady = true;
          _this.$store.dispatch('error/showLoadingActivity', false);
        }).catch(function (reason) {
          // console.log(reason)
          _this.$store.dispatch('error/showLoadingActivity', false);
          _this.$store.dispatch('error/showErrorToast', reason);
        });
      }
    } else {
      this.$router.push({ path: '/' });
    }
  },


  methods: {
    setKeyValue: function setKeyValue(value) {
      this.keyValue = value;
    },

    onCopy: function onCopy(e) {
      this.$store.dispatch("error/showSuccessToast", ["You just copied: " + e.text]);
      // alert('You just copied: ' + e.text)
    },

    onError: function onError(e) {
      this.$store.dispatch("error/showErrorToast", ["Failed to copy link"]);
      // alert('Failed to copy link')
    },

    isUploaded: function isUploaded() {
      if (this.isUpload) {
        this.isUpload = false;
      } else {
        this.isUpload = true;
      }
    },
    isActiveTab: function isActiveTab(tab) {
      return this.activeTab === tab;
    },
    onTab: function onTab(tab) {
      if (tab.path) {
        this.$router.push({ name: tab.path });
      }
    },
    imageChanged: function imageChanged(e) {
      var _this2 = this;

      this.album.image = e.target.files[0];
      var reader = new FileReader();
      reader.addEventListener('load', function (event) {
        _this2.album_image_url = event.target.result;
      }, false);
      reader.readAsDataURL(this.album.image);
    },
    deleteMerch: function deleteMerch(item) {
      console.log('deleted');
    },
    learnMore: function learnMore() {},
    addCollaborator: function addCollaborator() {
      this.collaborators.push({
        user_id: '',
        user_role: ''
      });
    },
    deleteCollaborator: function deleteCollaborator(index) {
      this.collaborators.splice(index, 1);
    },
    addContributor: function addContributor() {
      this.contributors.push({
        user_id: '',
        user_role: ''
      });
    },
    deleteContributor: function deleteContributor(index) {
      this.contributors.splice(index, 1);
    },
    addSampling: function addSampling() {
      this.sampling_min_id -= 1;
      var sampling = {
        id: this.sampling_min_id,
        sampling_track_id: '',
        sample_track_id: '',
        sample_album_id: '',
        sample_user_id: ''
      };
      var artists = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(this.artists);
      __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(artists, function (u) {
        u.sampling_id = sampling.id;
      });
      sampling.artists = artists;
      this.samplings.push(sampling);
    },
    deleteSampling: function deleteSampling(index) {
      this.samplings.splice(index, 1);
    },
    onChangeSampleArtist: function onChangeSampleArtist(user) {
      var _this3 = this;

      // console.log('onChangeSampleArtist', user.sampling_id, user.id, user.display_name)
      __WEBPACK_IMPORTED_MODULE_10__services_album__["a" /* default */].getAlbums({
        statuses: 'published, collaborated',
        user_statuses: 'accepted',
        user_id: user.id,
        enabled_sample: true
      }).then(function (response) {
        var sampling = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(_this3.samplings, function (s) {
          return s.id == user.sampling_id;
        });
        var albums = response.body;
        __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(albums, function (a) {
          a.sampling_id = user.sampling_id;
        });
        sampling.artist_albums = albums;
        sampling.artist_album_tracks = [];
        sampling.sample_album_id = 0;
        sampling.sample_track_id = 0;
        _this3.$forceUpdate();
      });
    },
    onChangeSampleArtistAlbum: function onChangeSampleArtistAlbum(album) {
      // console.log('onChangeSampleArtistAlbum', album.sampling_id, album.name)
      var sampling = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(this.samplings, function (s) {
        return s.id == album.sampling_id;
      });
      sampling.artist_album_tracks = album.tracks;
      sampling.sample_track_id = 0;
      this.$forceUpdate();
    },
    deleteAlbum: function deleteAlbum() {
      var _this4 = this;

      var id = '';
      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_10__services_album__["a" /* default */].deleteAlbum(id).then(function (response) {
        _this4.isLoading = false;
        _this4.$router.push({ path: '/album' });
      }).catch(function (e) {
        _this4.isLoading = false;
        _this4.errorMessage = e.body.errors[0].detail;
        _this4.showError = true;
      });
    },
    saveForLater: function saveForLater() {
      this.uploadAlbum();
    },
    openGenreSelectorDialog: function openGenreSelectorDialog() {
      this.show_genre_selector_dialog = true;
    },
    closeGenreSelectorDialog: function closeGenreSelectorDialog() {
      this.show_genre_selector_dialog = false;
    },
    openSampleClearanceLicenseModal: function openSampleClearanceLicenseModal() {
      this.show_sample_clearance_license_modal = true;
    },
    closeSampleClearanceLicenseModal: function closeSampleClearanceLicenseModal() {
      this.show_sample_clearance_license_modal = false;
    },
    releaseNow: function releaseNow() {
      if (this.collaborators.length == 0) {
        this.isNeededToRelease = true;
      }
      this.uploadAlbum();
    },
    uploadAlbum: function uploadAlbum() {
      var _this5 = this;

      this.loading = true;
      this.$store.dispatch('error/showLoadingActivity', true);
      var tracks = [];
      for (var index in this.album.tracks) {
        var track = this.album.tracks[index].track;
        if (track) {
          tracks.push(track.id);
        }
      }

      var track_ids = tracks.join(',');
      var genre_ids = this.$store.getters['genreSelector/genre'].id;
      var formData = new FormData();
      formData.append('album[name]', this.album.name);
      formData.append('album[description]', this.album.description);
      formData.append('album[released_at]', this.album.released_at);
      formData.append('album[location]', this.album.location || '');
      formData.append('album[bpm]', this.album.bpm);
      formData.append('album[access_level]', this.album.access_level);
      formData.append('album[download_price]', this.album.tracks.length > 1 ? this.album.download_price : this.album.tracks[0].download_price);
      if (this.majorValue !== 'none') {
        formData.append('album[bpm_key]', this.majorValue);
        formData.append('album[bpm_value]', this.keyValue);
      }

      formData.append('album[is_only_for_live_stream]', this.album.is_only_for_live_stream);
      formData.append('album[is_content_acapella]', this.album.is_content_acapella);
      formData.append('album[is_content_instrumental]', this.album.is_content_instrumental);
      formData.append('album[is_content_stems]', this.album.is_content_stems);
      formData.append('album[is_content_remix]', this.album.is_content_remix);
      formData.append('album[is_content_dj_mix]', this.album.is_content_dj_mix);
      formData.append('album[enabled_sample]', this.album.enabled_sample === 'true');
      formData.append('album[cover]', this.album.image);
      formData.append('album[track_ids]', track_ids);
      formData.append('album[genre_ids]', genre_ids);
      // #TODO pass null when no selection
      formData.append('album[product_ids]', this.selected_product);
      formData.append('album[collaborators]', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.collaborators));
      formData.append('album[contributors]', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.contributors));

      var samplings = [];
      __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(this.samplings, function (sampling) {
        var s = {
          sampling_track_id: sampling.sampling_track_id,
          sample_track_id: sampling.sample_track_id,
          sample_album_id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(sampling, 'sample_album_id.id', sampling.sample_album_id),
          sample_user_id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(sampling, 'sample_user_id.id', sampling.sample_user_id)
        };
        samplings.push(s);
      });
      // console.log('samplings', samplings)
      formData.append('album[samplings]', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(samplings));

      __WEBPACK_IMPORTED_MODULE_10__services_album__["a" /* default */].createAlbum(formData).then(function (response) {
        if (_this5.isNeededToRelease) {
          _this5.album = response.body;
          _this5.albumURL = window.location.origin + "/album/" + _this5.album.slug;
          _this5.releaseAlbum(response.body.id);
        } else {
          _this5.loading = false;
          _this5.$store.dispatch('error/showLoadingActivity', false);
          if (_this5.collaborators.length > 0) {
            _this5.$store.dispatch('navigator/setParams', {
              album_id: response.body.id
            });
            _this5.$router.push({ path: '/album/' + response.body.id });
          } else {
            _this5.$router.push({ path: '/albums' });
          }
        }
      }).catch(function (e) {
        _this5.loading = false;
        _this5.$store.dispatch('error/showLoadingActivity', false);
        _this5.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    releaseAlbum: function releaseAlbum(album_id) {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_10__services_album__["a" /* default */].releaseAlbum(album_id).then(function (response) {
        _this6.loading = false;
        _this6.$store.dispatch('error/showLoadingActivity', false);
        _this6.$store.dispatch('navigator/setParams', { album_id: album_id });
        if (album_id) {
          localStorage.setItem("release_album", album_id);
          _this6.$router.push({ path: '/album/' + album_id });
        }
      }).catch(function (e) {
        _this6.loading = false;
        _this6.$store.dispatch('error/showLoadingActivity', false);
        _this6.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    repostAlbum: function repostAlbum(album_id) {
      var _this7 = this;

      __WEBPACK_IMPORTED_MODULE_10__services_album__["a" /* default */].repostAlbum(album_id).then(function (response) {
        _this7.$store.dispatch('error/showLoadingActivity', false);
        // this.$router.push({ path: '/album' })
      }).catch(function (e) {
        _this7.$store.dispatch('error/showLoadingActivity', false);
        _this7.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    }
  },

  mounted: function mounted() {
    var _this8 = this;

    var vm = this;
    $.getJSON('../../static/cities.json', function (data) {
      vm.locations = data;
    });
    __WEBPACK_IMPORTED_MODULE_11__services_user__["a" /* default */].getAccessLevels(this.currentUser.id).then(function (response) {
      _this8.access_levels = response.body;
      _this8.album.access_level.push('published');
    }).catch(function (e) {
      _this8.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
    });
  }
});

/***/ }),
/* 1068 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__register_by_listener__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__register_by_listener___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__register_by_listener__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_auth_register_by_invited__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_auth_register_by_invited___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__views_auth_register_by_invited__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_user_tag__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_user_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_user_tag__);
// import Login from '../login'
// import ArtistRegister from '../register_by_artist'
// import AttendeeRegister from '../register_by_attendee'
// import BrandRegister from '../register_by_brand'
// import LabelRegister from '../register_by_label'
// import RegisterAs from '@/views/auth/register_as'




// import ArtistRegister from '@/views/auth/register_by_artist'
// import LabelRegister from '@/views/auth/register_by_label'
// import BrandRegister from '@/views/auth/register_by_brand'

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    // Login,
    // ArtistRegister,
    // AttendeeRegister,
    // BrandRegister,
    // LabelRegister,
    // RegisterAs,
    ListenerRegister: __WEBPACK_IMPORTED_MODULE_0__register_by_listener___default.a,
    InviteRegister: __WEBPACK_IMPORTED_MODULE_1__views_auth_register_by_invited___default.a,
    UserTag: __WEBPACK_IMPORTED_MODULE_2__components_user_tag___default.a
  },

  data: function data() {
    return {
      sideLists: [],
      register_success: false,
      activeTab: 'everyone',
      inviter: {},
      inviter2: {
        id: 46,
        slug: 'ruckazoid',
        username: 'ruckazoid',
        display_name: 'RUCKAZOID',
        user_type: 'artist',
        avatar: {
          'url': 'https://d26c3hjihgh1hc.cloudfront.net/uploads/user/avatar/46/2c6737ff-37a1-4f37-b982-c5c082484baa.gif',
          'thumb': {
            'url': 'https://d26c3hjihgh1hc.cloudfront.net/uploads/user/avatar/46/thumb_2c6737ff-37a1-4f37-b982-c5c082484baa.gif'
          }
        },
        status: 'active',
        stripe_connected: true
      },
      inviteMode: false
    };
  },

  watch: {
    activeTab: function activeTab(val) {
      switch (val) {
        case 'everyone':
          this.sideLists = this.everyOneContent;
          break;
        case 'artistBrand':
          this.sideLists = this.artistBrand;
          break;

        default:
          break;
      }
    }
  },
  methods: {
    setInviteMode: function setInviteMode(data) {
      this.activeTab = 'artistBrand';
      this.inviter = data;
      this.inviteMode = true;
    }
  },
  computed: {
    onMobile: function onMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    onMediumScreen: function onMediumScreen() {
      return this.$vuetify.breakpoint.mdAndDown;
    },
    everyOneContent: function everyOneContent() {
      var sideContent = [{
        title: 'Create Playlists.',
        content: 'Discover music from a world of verified artists.'
      }, {
        title: 'Shop Artists & Brands.',
        content: 'Get exclusive drops and products.'
      }, {
        title: 'Build Your Community.',
        content: 'Chat & comment on live videos, albums and products.'
      }, {
        title: 'Get Paid to Share.',
        content: 'Make money sharing your favorite albums, videos, and products.'
      }];
      return sideContent;
    },
    artistBrand: function artistBrand() {
      var sideContent = [{
        title: 'Multiple Revenue Streams.',
        content: 'Get paid from video/music streams & products.'
      }, {
        title: 'Sell Digital & Physical.',
        content: 'Keep 90% of your digital & physical sales.'
      }, {
        title: 'Share Your Albums & Videos.',
        content: 'Upload videos, albums & broadcast live.'
      }, {
        title: 'Collaborate With Creators.',
        content: 'Receive direct payouts from sales, add recoups & splits.'
      }];
      return sideContent;
    }
  },
  created: function created() {
    console.log(this.$route);
  }
});

/***/ }),
/* 1069 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_auth_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},

  data: function data() {
    return {
      token: '',
      email: '',
      user_type: 0,
      message: '',
      isActivated: false,
      isLoading: false,
      isPageReady: false,
      user: {
        email: '',
        password: ''
      },
      remember: false
    };
  },


  computed: {},

  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var params, myAlert;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.$store.dispatch('navigator/goNextState', { page: 'register', tab: '' });
              _this.token = _this.$route.params.token;
              _this.email = _this.$route.query['email'];
              _this.user_type = _this.$route.query['type'] || 1;

              if (!(_this.token === 'being')) {
                _context.next = 8;
                break;
              }

              if (!_this.email) {
                _this.$router.push('/');
              }
              _context.next = 15;
              break;

            case 8:
              _this.isPageReady = false;
              // this.$store.dispatch('error/showLoadingActivity', true)
              params = {
                confirmation_token: _this.token
                // AuthService.activeAccount(params).then(response => {
                //   this.isPageReady = true
                //   this.$store.dispatch('error/showLoadingActivity', false)
                //   this.$store.dispatch('error/showSuccessToast', ['Your account has been activated.'])
                // }).catch(e => {
                //   this.$store.dispatch('error/showLoadingActivity', false)
                //   if (e.body.status === 500) {
                //     this.$store.dispatch('error/showErrorToast', ['Failed in seding confirmation email'])
                //   } else if (e.body.errors[0].detail === 'was already confirmed, please try signing in') {
                //     this.isPageReady = true
                //     this.$store.dispatch('error/showSuccessToast', ['Your account was already activated!'])
                //   } else {
                //     this.$store.dispatch('error/showErrorToast', e.body.errors || [e.body])
                //   }
                // })
              };
              _this.user.email = localStorage.getItem("user_email");
              _this.user.password = localStorage.getItem("user_pass");

              myAlert = void 0;
              _context.next = 15;
              return __WEBPACK_IMPORTED_MODULE_3__services_auth_js__["a" /* default */].activeAccount(params).then(function (response) {
                myAlert = {
                  type: 'success',
                  messages: ['Your account has been activated.']
                  // if(this.user.email !== '' && this.user.password !== '') {
                  //   AuthService.login(this.user)
                  //   .then((response) => {
                  //     if (this.remember) {
                  //       AuthService.saveCredential(this.user)
                  //     }
                  //     AuthService.setTokenAndUserInfo(response.body)

                  //     if (response.body.sign_in_count <= 1) {
                  //       this.$store.dispatch('auth/setFirstVisit', true)
                  //     }

                  //     this.$root.$emit(MyEvents.AUTH_SIGNIN)

                  //     this.$store.dispatch('error/showLoadingActivity', false)

                  //     if(this.user_type === 1) this.$router.push({ name: 'UserSettings' });
                  //     else this.$router.push({ name: 'UploadIndex' });

                  //     localStorage.removeItem("user_email")
                  //     localStorage.removeItem("user_pass")
                  //   })
                  //   .catch((e) => {
                  //     this.$store.dispatch('error/showLoadingActivity', false)
                  //     this.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]
                  //     )
                  //   })
                  // } else {
                  //   this.$router.push({
                  //     path: '/login',
                  //     query: { alert: btoa(JSON.stringify(myAlert)) },
                  //   })
                  // }
                };
              }).catch(function (e) {
                if (e.body.status === 500) {
                  myAlert = {
                    type: 'error',
                    messages: ['Failed in sending confirmation email']
                  };
                } else if (e.body.errors[0].detail === 'was already confirmed, please try signing in') {
                  myAlert = {
                    type: 'success',
                    messages: ['Your account was already activated!']
                  };
                } else {
                  myAlert = {
                    type: 'error',
                    messages: ['Invalid confirmation token']
                    // messages: e.body.errors || [e.body]
                  };
                }
                _this.$router.push({
                  path: '/login',
                  query: { alert: btoa(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(myAlert)) }
                });
              });

            case 15:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  mounted: function mounted() {
    $('.sidebar').css('display', 'none');
    setTimeout(function () {
      $('main').css('padding', 'unset');
    }, 0);
  },


  methods: {
    sendConfirmEmail: function sendConfirmEmail() {
      var _this2 = this;

      var params = {
        email: this.email
      };
      __WEBPACK_IMPORTED_MODULE_3__services_auth_js__["a" /* default */].sendConfirmEmail(params).then(function (response) {
        _this2.$store.dispatch('error/showSuccessToast', ['Resent a confirmation email']);
      }).catch(function (e) {
        _this2.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    }
  }
});

/***/ }),
/* 1070 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_auth_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_auth_forgotPasswordInput___ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_auth_forgotPasswordInput____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__views_auth_forgotPasswordInput___);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { forgotPasswordInput: __WEBPACK_IMPORTED_MODULE_1__views_auth_forgotPasswordInput____default.a },

  data: function data() {
    return {
      email: null,
      resetSuccess: false
    };
  },


  computed: {
    onMobile: function onMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    }
  },

  created: function created() {
    this.$store.dispatch('navigator/goNextState', { page: 'register', tab: '' });
  },


  methods: {
    toLogin: function toLogin() {
      this.$router.push({ name: 'Login' });
    }
  }
});

/***/ }),
/* 1071 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_activity_js__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_auth_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_playlist__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loginInput__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loginInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__loginInput__);









/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    LoginInput: __WEBPACK_IMPORTED_MODULE_5__loginInput___default.a
  },

  data: function data() {
    return {
      remember: false
    };
  },


  computed: {
    onMobile: function onMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    }
  }
});

/***/ }),
/* 1072 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_invitation__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_auth__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_genre_dialog__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_genre_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_genre_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_user_tag__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_user_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_user_tag__);





// import UserService from '@/services/user'




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    GenreDialog: __WEBPACK_IMPORTED_MODULE_4__components_genre_dialog___default.a,
    UserTag: __WEBPACK_IMPORTED_MODULE_5__components_user_tag___default.a
  },

  data: function data() {
    return {
      is_username_available: true,
      UserTypeOptions: __WEBPACK_IMPORTED_MODULE_1__helper__["M" /* UserTypeOptions */],
      token: '',
      terms: false,
      newsletter_terms: false,
      user: {
        email: '',
        password: '',
        username: '',
        display_name: '',
        avatar_file: null,

        genre_id: null,
        social_user_name: '',
        request_role: null
      },
      inviter: {},
      show_register_success_dialog: false,
      isPageReady: false,
      age_group: ['14-21', '22-34', '35-49', '50-65+'],
      social_platform: ['Facebook', 'Instagram', 'Twitter', 'LinkedIn', 'Snapchat']
    };
  },


  computed: {
    main_genres: function main_genres() {
      return this.$store.state.app.genres;
    }
  },

  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3__services_auth__["a" /* default */].clearTokenAndUserInfo();
    // this.$store.dispatch('navigator/goNextState', { page: 'register', tab: '' })

    this.token = this.$route.params.token;
    this.isPageReady = false;
    var params = {
      token: this.token
    };
    if (this.token) {
      console.log(this.token);
      this.$store.dispatch('error/showLoadingActivity', true);
      __WEBPACK_IMPORTED_MODULE_2__services_invitation__["a" /* default */].findByToken(params).then(function (res) {
        _this.inviter = res.body;
        _this.isPageReady = true;

        // send inviter and inform any parent of invite mode
        _this.$emit('invite-mode', _this.inviter);

        _this.$store.dispatch('error/showLoadingActivity', false);
      }).catch(function (err) {
        _this.$store.dispatch('error/showErrorToast', err.body.errors || [err.body]);
        _this.$router.push({ path: '/' });
        _this.$store.dispatch('error/showLoadingActivity', false);
      });
    } else {
      this.isPageReady = true;
    }
    // this.show_register_success_dialog = true
  },


  methods: {
    submit: function submit() {
      var _this2 = this;

      this.$validator.validateAll().then(function (res) {
        // console.log(this.errors)
        if (res === true) {
          var formData = new FormData();
          // formData.append('user[invitation_token]', this.token)
          formData.append('user[email]', _this2.user.email);
          formData.append('user[password]', _this2.user.password);
          formData.append('user[username]', _this2.user.username);
          formData.append('user[name]', _this2.user.name);
          formData.append('user[avatar]', _this2.user.avatar_file);
          formData.append('user[request_role]', _this2.user.request_role);
          formData.append('user[social_url]', _this2.user.social_url);
          // formData.append('user[display_name]', this.user.display_name)
          // formData.append('user[genre_id]', this.user.genre_id)
          // formData.append(
          //   'user[social_user_name]',
          //   this.user.social_user_name
          // )
          // for (var pair of formData.entries()) {
          //   console.log(pair[0]+ ' - ' + pair[1]); 
          // }
          __WEBPACK_IMPORTED_MODULE_3__services_auth__["a" /* default */].registerAsArtist(formData).then(function (res) {
            _this2.$store.dispatch('error/showLoadingActivity', false);
            _this2.show_register_success_dialog = true;
            // this.$router.push({
            //   path: `/confirm/being?email=${this.user.email}`,
            // })
          }).catch(function (e) {
            _this2.$store.dispatch('error/showLoadingActivity', false);
            if (e.status === 500) {
              _this2.$store.dispatch('error/showErrorToast', ['Failed in seding confirmation email']);
              _this2.$router.push({
                path: '/confirm/being?email=' + _this2.user.email + '&type=0'
              });
            } else {
              _this2.$store.dispatch('error/showErrorToast', e.body.errors);
            }
          });
        } else {
          _this2.$store.dispatch('error/showErrorToast', [_this2.errors.items[0].msg]);
        }
      }).catch(function (e) {
        console.log('error', e);
      });
    },
    imageChanged: function imageChanged(e) {
      if (e.target.files[0].size > 2097152) {
        this.$refs.avatar_file.value = null;
        this.$refs.avatar.src = '/static/images/placeholder.png';
        this.$store.dispatch('error/showErrorToast', ['You can upload an avatar 2MB in maximum']);
        return;
      }
      this.user.avatar_file = e.target.files[0];
      var reader = new FileReader();
      reader.addEventListener('load', function (event) {
        document.getElementById('avatar').src = event.target.result;
      }, false);
      reader.readAsDataURL(this.user.avatar_file);
    },
    onBlur: function onBlur(e) {
      var _this3 = this;

      // console.log('onBlur', e)
      var params = {
        username: this.user.username
      };
      __WEBPACK_IMPORTED_MODULE_3__services_auth__["a" /* default */].isUsernameAvailable(params).then(function (res) {
        _this3.is_username_available = true;
      }).catch(function (e) {
        _this3.is_username_available = false;
      });
    }
  }
});

/***/ }),
/* 1073 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_auth_js__ = __webpack_require__(5);

// import UserService from '@/services/user.js'


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},

  data: function data() {
    return {
      is_username_available: true,
      register_success: false,
      terms: false,
      newsletter_terms: false,
      country: '',
      age_group: ['14-21', '22-34', '35-49', '50-65+'],
      social_platform: ['Facebook', 'Instagram', 'Twitter', 'LinkedIn', 'Snapchat'],
      region: '',
      user: {
        email: '',
        password: '',
        username: '',
        display_name: '',
        avatar_file: null
      }
    };
  },


  computed: {},

  created: function created() {
    __WEBPACK_IMPORTED_MODULE_0__services_auth_js__["a" /* default */].clearTokenAndUserInfo();
    this.$store.dispatch('navigator/goNextState', { page: 'register', tab: '' });
  },


  methods: {
    submit: function submit() {
      var _this = this;

      this.$validator.validateAll().then(function (response) {
        if (response === true) {
          _this.$store.dispatch('error/showLoadingActivity', true);
          var formData = new FormData();
          formData.append('user[email]', _this.user.email);
          formData.append('user[password]', _this.user.password);
          formData.append('user[username]', _this.user.username);
          // formData.append('user[display_name]', this.user.display_name)
          formData.append('user[avatar]', _this.user.avatar_file);
          formData.append('user[city]', _this.user.city);
          formData.append('user[country]', _this.user.country);
          formData.append('user[social_provider]', _this.user.social_provider);
          formData.append('user[social_user_name]', _this.user.social_user_name);
          formData.append('user[age_group]', _this.user.age_group);
          __WEBPACK_IMPORTED_MODULE_0__services_auth_js__["a" /* default */].registerAsListener(formData).then(function (response) {
            // const userId = response.body.id
            // const params = {
            //   genre_ids: this.$store.state.auth.genreIds
            // }
            // UserService.hiddenUserGenres(userId, params)
            _this.$store.dispatch('error/showLoadingActivity', false);
            _this.$router.push({
              path: '/confirm/being?email=' + _this.user.email
            });
          }).catch(function (e) {
            _this.$store.dispatch('error/showLoadingActivity', false);
            if (e.status === 500) {
              _this.$store.dispatch('error/showErrorToast', ['Failed in seding confirmation email']);
              _this.$router.push({
                path: '/confirm/being?email=' + _this.user.email + '&type=0'
              });
            } else {
              _this.$store.dispatch('error/showErrorToast', e.body.errors);
            }
          });
        } else {
          _this.$store.dispatch('error/showErrorToast', [_this.errors.items[0].msg]);
        }
      }).catch(function (e) {
        console.log('error', e);
      });
    },
    onBlur: function onBlur(e) {
      var _this2 = this;

      // console.log('onBlur', e)
      var params = {
        username: this.user.username
      };
      __WEBPACK_IMPORTED_MODULE_0__services_auth_js__["a" /* default */].isUsernameAvailable(params).then(function (res) {
        _this2.is_username_available = true;
      }).catch(function (e) {
        _this2.is_username_available = false;
      });
    },
    imageChanged: function imageChanged(e) {
      if (e.target.files[0].size > 2097152) {
        this.$refs.avatar_file.value = null;
        this.$refs.avatar.src = '/static/images/placeholder.png';
        this.$store.dispatch('error/showErrorToast', ['You can upload an avatar 2MB in maximum']);
        return;
      }
      this.user.avatar_file = e.target.files[0];
      var reader = new FileReader();
      reader.addEventListener('load', function (event) {
        document.getElementById('avatar').src = event.target.result;
      }, false);
      reader.readAsDataURL(this.user.avatar_file);
    }
  }
});

/***/ }),
/* 1074 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_auth_js__ = __webpack_require__(5);


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},

  data: function data() {
    return {
      password: '',
      confirm_password: ''
    };
  },


  computed: {},

  created: function created() {
    this.$store.dispatch('navigator/goNextState', { page: 'register', tab: '' });
  },
  mounted: function mounted() {
    $('.container').css("padding", "unset");
    $('.container').css("height", "100vh");
  },


  methods: {
    submit: function submit() {
      var vm = this;
      this.$validator.validateAll().then(function (response) {
        if (response === true) {
          var params = {
            reset_token: vm.$route.params.token,
            password: vm.password
          };
          __WEBPACK_IMPORTED_MODULE_0__services_auth_js__["a" /* default */].resetPassword(params).then(function () {
            vm.$store.dispatch('error/showSuccessToast', ['Password has been updated successfully.']);
            vm.$router.push({ path: '/login' });
          }).catch(function (e) {
            vm.$store.dispatch('error/showErrorToast',
            // e.body.errors || [e.body]
            vm._.map(e.body.errors, function (msg) {
              return 'reset_password_token ' + msg.detail;
            }));
          });
        }
      }).catch(function (e) {
        console.log('error', e);
      });
    }
  }
});

/***/ }),
/* 1075 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_auth_js__ = __webpack_require__(5);


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},

  data: function data() {
    return {
      isLoading: false,
      showError: false,
      errorMessage: '',
      timeout: 3000,
      query_string: []
    };
  },


  computed: {},

  created: function created() {
    this.$store.dispatch('navigator/goNextState', { page: 'register', tab: '' });
  },


  methods: {
    submit: function submit() {}
  }
});

/***/ }),
/* 1076 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_auth_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_twitter__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_user_js__ = __webpack_require__(7);








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},

  data: function data() {
    return {
      query_string: [],
      twitter_info: null,
      user: {},
      // main_genres: [],
      // sub_genres: [],
      year_of_birth_options: [],
      isPageReady: false
    };
  },


  computed: {
    currentUser: function currentUser() {
      return this.$store.state.auth.user;
    },
    main_genres: function main_genres() {
      return this.$store.state.app.genres;
    },
    sub_genres: function sub_genres() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.flatMap(this.$store.state.app.genres, 'children');
    },
    country_options: function country_options() {
      return __WEBPACK_IMPORTED_MODULE_2__helper__["s" /* Countries */];
    },
    boolean_options: function boolean_options() {
      return __WEBPACK_IMPORTED_MODULE_2__helper__["u" /* UserBooleanOptions */];
    },
    gender_options: function gender_options() {
      return __WEBPACK_IMPORTED_MODULE_2__helper__["t" /* UserGenderOptions */];
    },
    artist_type_options: function artist_type_options() {
      return __WEBPACK_IMPORTED_MODULE_2__helper__["v" /* UserArtistTypeOptions */];
    },
    released_albums_count_options: function released_albums_count_options() {
      return __WEBPACK_IMPORTED_MODULE_2__helper__["w" /* UserReleasedAlbumsCountOptions */];
    },
    years_since_first_released_options: function years_since_first_released_options() {
      return __WEBPACK_IMPORTED_MODULE_2__helper__["x" /* UserYearsSinceFirstReleasedOptions */];
    },
    annual_income_on_merch_sales_options: function annual_income_on_merch_sales_options() {
      return __WEBPACK_IMPORTED_MODULE_2__helper__["y" /* UserAnnualIncomeOnMerchSalesOptions */];
    },
    annual_performances_count_options: function annual_performances_count_options() {
      return __WEBPACK_IMPORTED_MODULE_2__helper__["z" /* UserAnnualPerformancesCountOptions */];
    },
    signed_status_options: function signed_status_options() {
      return __WEBPACK_IMPORTED_MODULE_2__helper__["A" /* UserSignedStatusOptions */];
    },
    performance_rights_organization_options: function performance_rights_organization_options() {
      return __WEBPACK_IMPORTED_MODULE_2__helper__["B" /* UserPerformanceRightsOrganizationOptions */];
    },
    artists_count_options: function artists_count_options() {
      return __WEBPACK_IMPORTED_MODULE_2__helper__["C" /* UserArtistsCountOptions */];
    },
    standard_brand_type_options: function standard_brand_type_options() {
      return __WEBPACK_IMPORTED_MODULE_2__helper__["D" /* UserStandardBrandTypeOptions */];
    },
    employees_count_options: function employees_count_options() {
      return __WEBPACK_IMPORTED_MODULE_2__helper__["E" /* UserEmployeesCountOptions */];
    },
    years_in_business_options: function years_in_business_options() {
      return __WEBPACK_IMPORTED_MODULE_2__helper__["F" /* UserYearsInBusinessOptions */];
    },
    products_count_options: function products_count_options() {
      return __WEBPACK_IMPORTED_MODULE_2__helper__["G" /* UserProductsCountOptions */];
    },
    annual_income_options: function annual_income_options() {
      return __WEBPACK_IMPORTED_MODULE_2__helper__["H" /* UserAnnualIncomeOptions */];
    }
  },

  // beforeRouteEnter (to, from, next) {
  //   console.log('tiwtter_calllback beforeRouteEnter', to, from)
  //   next()
  // },

  created: function created() {
    var _this = this;

    this.$store.dispatch('navigator/goNextState', { page: 'register', tab: '' });
    this.twitter_info = JSON.parse(__WEBPACK_IMPORTED_MODULE_2__helper__["g" /* Storage */].get('twitter_info'));
    if (this.twitter_info && this.twitter_info.oauth_token === this.$route.query['oauth_token']) {
      var params = {
        oauth_token: this.$route.query['oauth_token'],
        oauth_token_secret: this.twitter_info.oauth_token_secret,
        oauth_verifier: this.$route.query['oauth_verifier']
      };
      __WEBPACK_IMPORTED_MODULE_4__services_twitter__["a" /* default */].getAccessToken(params).then(function (response) {
        _this.twitter_info = response.body;
        __WEBPACK_IMPORTED_MODULE_2__helper__["g" /* Storage */].remove('twitter_info');
        // Storage.set('twitter_info', JSON.stringify(this.twitter_info))

        _this.user = {
          // display_name: this.twitter_info.screen_name,
          social_user_id: _this.twitter_info.user_id,
          request_role: _this.$route.query['user_type'] || 'artist',

          first_name: null,
          last_name: null,
          year_of_birth: null,
          gender: null,
          country: null,
          city: null,

          genre_id: null,
          artist_type: null,
          released_albums_count: null,
          years_since_first_released: null,
          will_run_live_video: null,
          will_sell_products: null,
          will_sell_physical_copies: null,
          annual_income_on_merch_sales: null,
          annual_performances_count: null,
          signed_status: null,
          performance_rights_organization: null,
          ipi_cae_number: null,
          website_1_url: null,
          website_2_url: null,
          history: null,

          sub_genre_id: null,
          is_business_registered: null,
          artists_count: null,

          standard_brand_type: null,
          customized_brand_type: null,
          employees_count: null,
          years_in_business: null,
          will_sell_music_related_products: null,
          products_count: null,
          annual_income: null

          // console.log('twitter callback created', this.currentUser)
          // console.log(this.$route.query['code'])
        };_this.$store.dispatch('auth/setSecretCode', _this.$route.query['code']);

        // this.main_genres = this.$store.state.app.genres
        // this.sub_genres = _.flatMap(this.$store.state.app.genres, 'children')

        var current_year = __WEBPACK_IMPORTED_MODULE_1_moment___default()().year();
        for (var i = 1900; i < current_year; i++) {
          _this.year_of_birth_options.push(i);
        }

        _this.isPageReady = true;
      });
    } else {
      __WEBPACK_IMPORTED_MODULE_2__helper__["g" /* Storage */].remove('twitter_info');
      // this.$router.push('/register')
      this.$router.push('/');
    }
  },


  methods: {
    submit: function submit() {
      var _this2 = this;

      // console.log('twitter_callback submit', this.currentUser)
      var vm = this;
      this.$validator.validateAll().then(function (response) {
        if (response === true) {
          if (_this2.currentUser && _this2.currentUser.id) {
            var params = {
              user: _this2.user
            };
            _this2.$store.dispatch('error/showLoadingActivity', true);
            __WEBPACK_IMPORTED_MODULE_5__services_user_js__["a" /* default */].updateUserInfo(_this2.currentUser.id, params).then(function (response) {
              __WEBPACK_IMPORTED_MODULE_3__services_auth_js__["a" /* default */].setUser(response.body);
              vm.$store.dispatch('error/showLoadingActivity', false);
              vm.$router.push('/settings#verify-status');
            }).catch(function (e) {
              vm.$store.dispatch('error/showLoadingActivity', false);
              vm.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
            });
            // vm.$store.dispatch('auth/setPendingUser', vm.user)
            // vm.$router.push(`/register/${this.user.request_role}`)
          } else {
            vm.$store.dispatch('error/showErrorToast', ['Please sign in first']);
            vm.$router.push('/login');
          }
        } else {
          vm.$store.dispatch('error/showErrorToast', [vm.errors.items[0].msg]);
        }
      }).catch(function (e) {
        console.log('error', e);
      });
    }
  }
});

/***/ }),
/* 1077 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},

  data: function data() {
    return {};
  },
  created: function created() {
    // this.$store.dispatch('auth/setSecretCode', this.$route.query['code'])
  }
});

/***/ }),
/* 1078 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_auth__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_item__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_order__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_user__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_activityproductcard__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_activityproductcard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_activityproductcard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_profileitem__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_profileitem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_profileitem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_sendmessage__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_sendmessage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_sendmessage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_ticket_new_dialog__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_ticket_new_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_ticket_new_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_trackcard__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_trackcard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_trackcard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_contentTopHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_contentTopHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_contentTopHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_settings_components_address_tab__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_settings_components_address_tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__views_settings_components_address_tab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_paymentmodal__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_paymentmodal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_paymentmodal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_stripe_elements__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_stripe_elements___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue_stripe_elements__);




















/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		activityProductCard: __WEBPACK_IMPORTED_MODULE_7__components_activityproductcard___default.a,
		profileItem: __WEBPACK_IMPORTED_MODULE_8__components_profileitem___default.a,
		sendMessage: __WEBPACK_IMPORTED_MODULE_9__components_sendmessage___default.a,
		ticketNewDialog: __WEBPACK_IMPORTED_MODULE_10__components_ticket_new_dialog___default.a,
		trackCard: __WEBPACK_IMPORTED_MODULE_11__components_trackcard___default.a,
		contentTopHeader: __WEBPACK_IMPORTED_MODULE_12__components_contentTopHeader___default.a,
		addressTab: __WEBPACK_IMPORTED_MODULE_13__views_settings_components_address_tab___default.a,
		paymentModal: __WEBPACK_IMPORTED_MODULE_14__components_paymentmodal___default.a,
		Card: __WEBPACK_IMPORTED_MODULE_15_vue_stripe_elements__["Card"],
		CardNumber: __WEBPACK_IMPORTED_MODULE_15_vue_stripe_elements__["CardNumber"],
		CardExpiry: __WEBPACK_IMPORTED_MODULE_15_vue_stripe_elements__["CardExpiry"],
		CardCvc: __WEBPACK_IMPORTED_MODULE_15_vue_stripe_elements__["CardCvc"]
	},

	data: function data() {
		return {
			stripe_publishable_key: "pk_live_fXEdJ0v6E2ROxT8rufDCby12",
			stripeOptions: {},
			complete: false,
			cardNumber: null,
			cardExpiry: null,
			cardCvc: null,
			editDialog: false,
			loading: false,
			active_tab: 'cart',
			tabs: [{ id: 'cart', title: 'Cart', icon: __webpack_require__(768) }, { id: 'history', title: 'Order History', icon: __webpack_require__(773) }],
			showSendMessage: false,
			show_address_confirm_dialog: false,
			show_ticket_dialog: false,
			show_tracking_info_dialog: false,
			active_order: null,
			active_item: {},
			cartItems: [],
			orderHistories: [],
			cartCost: {
				total_cost: 0,
				subtotal_cost: 0,
				shipping_cost: 0,
				fee_cost: 0
			},
			ordersCost: {
				hasDeleted: false,
				shipping_cost: 0,
				tax_cost: 0,
				total_cost: 0
			},
			page_index: 1,
			total_pages: 1,
			items_per_page: 6 * 5,
			isPageReady: false,
			showPlaceOrderDialog: false,
			showPaymentModal: false,
			show_order_complete_dialog: false,
			shippingAddress: [],
			order_status: { 'item_ordered': 'Pending', 'item_shipped': 'Shipped', 'item_refunded': 'Refunded' }
		};
	},


	computed: {
		shipping_address: function shipping_address() {
			return this.$store.state.auth.user.default_address;
		},
		strippedAddress: function strippedAddress() {
			var addr = this.shipping_address;
			var stripped = {};

			if (addr) {
				stripped.lineOne = addr.first_name + ' ' + addr.last_name;
				stripped.lineTwo = addr.address_line;
				stripped.lineThree = addr.city + ' ' + addr.state;
				stripped.lineFour = addr.postcode;
				stripped.lineFive = addr.country;
			}

			return stripped || '';
			// return Object.values(stripped).join("\r\n")
		},
		currentUser: function currentUser() {
			return this.$store.state.auth.user;
		},
		user: function user() {
			return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(this.active_order, 'merchant', { avatar: {} });
		},


		// merchants
		receivers: function receivers() {
			var merchants = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.chain(this.cartItems).map('product.merchant').uniq('id').value();
			// console.log('receivers', merchants)
			return merchants;
		}
	},

	watch: {
		$route: function $route(toPath, fromPath) {
			var tab = toPath.hash.substr(1);
			this.init(tab);
		}
	},

	created: function created() {
		var tab = this.$route.hash.substr(1);
		this.init(tab);
		if (this.currentUser.default_address) {
			this.shippingAddress.push(this.currentUser.default_address);
		}
	},


	methods: {
		sendPayment: function sendPayment() {
			var _this = this;

			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_vue_stripe_elements__["createToken"])().then(function (data) {
				// this.closePaymentDialog()
				_this.orderItems(data.token);
			});
		},
		getItemDay: function getItemDay(item) {
			var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
			var date = new Date(item.created_at);
			date.setDate(date.getDate() + 21);
			var day = days[date.getDay()];
			return day;
		},
		getItemDate: function getItemDate(item) {
			var date = new Date(item.created_at);
			date.setDate(date.getDate() + 21);
			return date;
		},
		openOrderCompleteDialog: function openOrderCompleteDialog() {
			this.show_order_complete_dialog = true;
		},
		closeOrderCompleteDialog: function closeOrderCompleteDialog() {
			this.show_order_complete_dialog = false;
		},
		orderDetails: function orderDetails() {
			this.$router.push({ path: '/cart#history' });
		},
		orderItems: function orderItems(token) {
			var _this2 = this;

			if (this.shippingAddress.length > 0) {
				// console.log(token)
				this.$store.dispatch('error/showLoadingActivity', true);
				var params = {
					shipping_address_id: this.shippingAddress[0].id
				};
				if (token) {
					params['payment_token'] = token.id;
				}
				this.loading = true;
				this.$store.dispatch('error/showLoadingActivity', true);
				__WEBPACK_IMPORTED_MODULE_4__services_item__["a" /* default */].orderItems(params).then(function (response) {
					_this2.loading = false;
					_this2.$store.dispatch('error/showLoadingActivity', false);
					var orders = response.body || [];
					_this2.ordersCost.shipping_cost = _this2._.sumBy(orders, 'shipping_cost');

					_this2.ordersCost.tax_cost = _this2._.sumBy(orders, 'tax_cost');
					_this2.ordersCost.total_cost = _this2._.sumBy(orders, 'amount');
					var itemsSize = _this2._.reduce(orders, function (size, order) {
						return size + (order.items || []).length;
					}, 0);
					_this2.ordersCost.hasDeleted = _this2.cartItems.length !== itemsSize;
					// this.$store.dispatch('error/showSuccessToast', ['Ordered successfully.'])
					// this.$store.dispatch('navigator/goNextState', { page: 'cart', tab: 'history' })
					// this.$router.push({path : '/cart#history'})
					_this2.cartItems = [];
					_this2.openOrderCompleteDialog();
				}).catch(function (e) {
					_this2.loading = false;
					_this2.$store.dispatch('error/showLoadingActivity', false);
					_this2.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);

					__WEBPACK_IMPORTED_MODULE_4__services_item__["a" /* default */].getShoppingCartItems().then(function (response) {
						_this2.cartItems = response.body;
					});
				});
			} else {
				this.$store.dispatch('error/showErrorToast', ['Please add Shipping Address.']);
			}
		},
		openPaymentDialog: function openPaymentDialog() {
			if (this.shippingAddress.length === 0) {
				this.$store.dispatch('error/showErrorToast', ['Please add Shipping Address.']);
			} else {
				this.sendPayment();
			}
		},
		closePaymentDialog: function closePaymentDialog() {
			this.showPaymentModal = false;
			this.init(this.active_tab);
		},
		isActiveTab: function isActiveTab(tab) {
			return this.active_tab === tab;
		},
		init: function init(tab) {
			var _this3 = this;

			if (!this.currentUser) {
				__WEBPACK_IMPORTED_MODULE_3__services_auth__["a" /* default */].clearTokenAndUserInfo();
				this.$router.push({ path: '/login' });
				return;
			}

			this.active_tab = tab || 'cart';
			this.$store.dispatch('navigator/goNextState', {
				page: 'cart',
				tab: this.active_tab
			});

			var params = void 0;
			switch (this.active_tab) {
				case 'cart':
					params = {};
					if (this.$store.state.auth.user.default_address) {
						params.country = this.$store.state.auth.user.default_address.country;
						params.state = this.$store.state.auth.user.default_address.state;
					}

					this.isPageReady = false;
					this.$store.dispatch('error/showLoadingActivity', true);
					__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_4__services_item__["a" /* default */].getShoppingCartItems(), __WEBPACK_IMPORTED_MODULE_4__services_item__["a" /* default */].calculateCost(params)]).then(function (values) {
						_this3.cartItems = values[0].body;
						_this3.cartCost = values[1].body;
						_this3.isPageReady = true;
						_this3.$store.dispatch('error/showLoadingActivity', false);
					}).catch(function (reason) {
						_this3.$store.dispatch('error/showLoadingActivity', false);
						_this3.$store.dispatch('error/showErrorToast', reason);
					});
					break;
				case 'history':
					params = {
						page: this.page_index,
						per_page: this.items_per_page
					};
					this.isPageReady = false;
					this.$store.dispatch('error/showLoadingActivity', true);
					__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_5__services_order__["a" /* default */].getSentOrders(params)]).then(function (values) {
						_this3.orderHistories = values[0].body.orders;

						_this3.isPageReady = true;
						_this3.$store.dispatch('error/showLoadingActivity', false);
					}).catch(function (reason) {
						_this3.$store.dispatch('error/showLoadingActivity', false);
						_this3.$store.dispatch('error/showErrorToast', reason);
					});
					break;
			}
		},
		onTab: function onTab(tab) {
			this.$router.push({
				path: this.$route.path,
				hash: tab,
				query: {
					grid_view: this.grid_show
				}
			});
		},
		isDigitalProduct: function isDigitalProduct(item) {
			return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(item, 'product.category.is_digital', false);
		},
		isMenuAvailable: function isMenuAvailable(order) {
			return true;
		},
		isAddressEnabled: function isAddressEnabled(order) {
			return order.status === 'order_shipped' && order.enabled_address;
		},
		download: function download(item) {
			// console.log(item.product.digital_content_url, item.product.digital_content_name)
			__WEBPACK_IMPORTED_MODULE_2__helper__["f" /* Utils */].downloadFile(item.product.digital_content_url);
		},
		submit: function submit() {
			var _this4 = this;

			this.loading = true;
			this.$store.dispatch('error/showLoadingActivity', true);
			var funcs = (this.receivers || []).map(function (user) {
				return __WEBPACK_IMPORTED_MODULE_6__services_user__["a" /* default */].checkStripeConnection(user.id).then(function (value) {
					return { status: 'fulfilled', user: user, value: value };
				}, function (reason) {
					return { status: 'rejected', user: user, reason: reason };
				});
			});
			__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(funcs).then(function (values) {
				var error = _this4._.find(values, function (v) {
					return v.status === 'rejected';
				});

				if (error) {
					_this4.loading = false;
					_this4.$store.dispatch('error/showLoadingActivity', false);
					_this4.receiver = error.user;
					_this4.show_error_dialog = true;
				} else {
					// this.cartItems = []
					_this4.openPaymentDialog();
				}
			});
		},
		showMessageDialog: function showMessageDialog(order) {
			this.active_order = order;
			this.showSendMessage = true;
		},
		dismissMessageModal: function dismissMessageModal() {
			this.showSendMessage = false;
		},
		openTicketDialog: function openTicketDialog(order, item) {
			this.active_order = order;
			this.active_item = item;
			this.show_ticket_dialog = true;
		},
		closeTicketDialog: function closeTicketDialog() {
			this.show_ticket_dialog = false;
		},
		openTrackingInfoDialog: function openTrackingInfoDialog(item) {
			console.log('openTicketDialog', item);
			this.active_item = item;
			this.show_tracking_info_dialog = true;
		},
		openAddressConfimDialog: function openAddressConfimDialog(order) {
			this.active_order = order;
			this.show_address_confirm_dialog = true;
		},
		closeAddressConfimDialog: function closeAddressConfimDialog() {
			this.show_address_confirm_dialog = false;
		},
		removeMyAddress: function removeMyAddress() {
			var _this5 = this;

			this.closeAddressConfimDialog();
			__WEBPACK_IMPORTED_MODULE_5__services_order__["a" /* default */].hideMyAddress(this.active_order.id).then(function (response) {
				_this5.init(_this5.active_tab);
			});
		},
		productStatus: function productStatus(item) {
			if (this.isDigitalProduct(item)) {
				return {
					text: 'digital content',
					style: 'success'
				};
			} else if (['published', 'collaborated'].indexOf(item.product.status) === -1 || item.product.stock_status !== 'active') {
				return {
					text: 'out of stock',
					style: 'error'
				};
			} else if (item.quantity > item.product_variant.quantity) {
				return {
					text: 'limited stock',
					style: 'warning'
				};
			} else {
				return {
					text: 'in stock',
					style: 'success'
				};
			}
		},
		productStatusStyle: function productStatusStyle(item) {
			return this.productStatus(item).style;
		},
		productStatusText: function productStatusText(item) {
			return this.productStatus(item).text;
		},
		addQuantity: function addQuantity(item) {
			var _this6 = this;

			if (item.quantity >= 1 && item.product.single_order) {
				this.$store.dispatch('error/showErrorToast', ['The product owner has set a limit on this product to only one order per user.']);

				return;
			}

			__WEBPACK_IMPORTED_MODULE_4__services_item__["a" /* default */].updateCartItem(item.id, { quantity: item.quantity + 1 }).then(function (response) {
				item.quantity += 1;
				_this6.cartCost = response.body;
			}).catch(function (e) {
				_this6.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
			});
		},
		removeQuantity: function removeQuantity(item) {
			var _this7 = this;

			if (item.quantity > 1) {
				__WEBPACK_IMPORTED_MODULE_4__services_item__["a" /* default */].updateCartItem(item.id, { quantity: item.quantity - 1 }).then(function (response) {
					item.quantity -= 1;
					_this7.cartCost = response.body;
				}).catch(function (e) {
					_this7.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
				});
			}
		},
		removeCartItem: function removeCartItem(cartItem) {
			var _this8 = this;

			__WEBPACK_IMPORTED_MODULE_4__services_item__["a" /* default */].deleteCartItem(cartItem.id).then(function (response) {
				_this8.$store.dispatch('error/showSuccessToast', ['deleted ' + cartItem.product.name + ' successfully.']);
				_this8.cartCost = response.body;
				__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.remove(_this8.cartItems, function (item) {
					return item.id === cartItem.id;
				});
				var arr = _this8.cartItems.slice();
				_this8.cartItems = arr;
			}).catch(function (e) {
				_this8.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
			});
		}
	},

	mounted: function mounted() {}
});

/***/ }),
/* 1079 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_auth__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_address__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_item__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_paymentmodal__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_paymentmodal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_paymentmodal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_activityproductcard__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_activityproductcard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_activityproductcard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_contentTopHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_contentTopHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_contentTopHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_settings_components_address_tab__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_settings_components_address_tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__views_settings_components_address_tab__);











/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_1_vue__["default"].extend({
  components: {
    paymentModal: __WEBPACK_IMPORTED_MODULE_5__components_paymentmodal___default.a,
    activityProductCard: __WEBPACK_IMPORTED_MODULE_6__components_activityproductcard___default.a,
    contentTopHeader: __WEBPACK_IMPORTED_MODULE_8__components_contentTopHeader___default.a,
    addressTab: __WEBPACK_IMPORTED_MODULE_9__views_settings_components_address_tab___default.a
  },

  data: function data() {
    return {
      tabs: [{ id: 'checkout', title: 'Checkout' }],
      active_tab: 'checkout',
      editDialog: false,
      Stripe: __WEBPACK_IMPORTED_MODULE_7__helper__["d" /* Stripe */],
      ordersCost: {
        hasDeleted: false,
        shipping_cost: 0,
        tax_cost: 0,
        total_cost: 0
      },
      cartItems: [],
      shippingAddress: [],
      showAddress: true,
      showPaymentModal: false,
      show_order_complete_dialog: false,
      cartCost: {
        total_cost: 0,
        subtotal_cost: 0,
        shipping_cost: 0,
        fee_cost: 0
      },
      isPageReady: false
    };
  },


  computed: {
    shipping_address: function shipping_address() {
      return this.$store.state.auth.user.default_address;
    },
    strippedAddress: function strippedAddress() {
      var addr = this.shipping_address;
      var stripped = {};

      if (addr) {
        stripped.lineOne = addr.first_name + ' ' + addr.last_name;
        stripped.lineTwo = addr.address_line;
        stripped.lineThree = addr.city + ' ' + addr.state;
        stripped.lineFour = addr.postcode;
        stripped.lineFive = addr.country;
      }

      return stripped || '';
      // return Object.values(stripped).join("\r\n")
    },
    currentUser: function currentUser() {
      return this.$store.state.auth.user;
    },
    merchants: function merchants() {
      return this.cartItems.map(function (item) {
        return item.product.merchant;
      });
    },
    canOrder: function canOrder() {
      var _this = this;

      return this._.isEmpty(this._.find(this.cartItems, function (item) {
        return _this.productStatus(item).style !== 'success';
      }));
    }
  },

  created: function created() {
    var _this2 = this;

    if (!this.currentUser) {
      __WEBPACK_IMPORTED_MODULE_2__services_auth__["a" /* default */].clearTokenAndUserInfo();
      this.$router.push({ path: '/login' });
      return;
    }

    this.$store.dispatch('navigator/goNextState', { page: 'checkout', tab: '' });
    var params = {};
    if (this.currentUser.default_address) {
      this.shippingAddress.push(this.currentUser.default_address);
      params.country = this.currentUser.default_address.country;
      params.state = this.currentUser.default_address.state;
    }

    this.isPageReady = false;
    this.$store.dispatch('error/showLoadingActivity', true);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_4__services_item__["a" /* default */].getShoppingCartItems(), __WEBPACK_IMPORTED_MODULE_4__services_item__["a" /* default */].calculateCost(params), __WEBPACK_IMPORTED_MODULE_3__services_address__["a" /* default */].getAddresses()]).then(function (values) {
      _this2.cartItems = values[0].body;
      _this2.cartCost = values[1].body;
      // this.shippingAddress = values[2].body

      _this2.isPageReady = true;
      _this2.$store.dispatch('error/showLoadingActivity', false);
    }).catch(function (reason) {
      console.log(reason);
      _this2.$store.dispatch('error/showLoadingActivity', false);
      _this2.$store.dispatch('error/showErrorToast', reason);
    });
  },


  methods: {
    isActiveTab: function isActiveTab(tab) {
      return this.active_tab === tab;
    },
    onTab: function onTab(tab) {
      this.$router.push({
        path: this.$route.path,
        hash: tab,
        query: {
          grid_view: this.grid_show
        }
      });
    },
    isDigitalProduct: function isDigitalProduct(item) {
      return this._.get(item, 'product.category.is_digital', false);
    },
    productStatus: function productStatus(item) {
      if (this.isDigitalProduct(item)) {
        return {
          text: 'digital content',
          style: 'success'
        };
      } else if (['published', 'collaborated'].indexOf(item.product.status) === -1 || item.product.stock_status !== 'active') {
        return {
          text: 'out of stock',
          style: 'error'
        };
      } else if (item.quantity > item.product_variant.quantity) {
        return {
          text: 'limited stock',
          style: 'warning'
        };
      } else {
        return {
          text: 'in stock',
          style: 'success'
        };
      }
    },
    productStatusStyle: function productStatusStyle(item) {
      return this.productStatus(item).style;
    },
    productStatusText: function productStatusText(item) {
      return this.productStatus(item).text;
    },
    addQuantity: function addQuantity(item) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_4__services_item__["a" /* default */].updateCartItem(item.id, { quantity: item.quantity + 1 }).then(function (response) {
        item.quantity += 1;
        _this3.cartCost = response.body;
      }).catch(function (e) {
        _this3.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    removeQuantity: function removeQuantity(item) {
      var _this4 = this;

      if (item.quantity > 1) {
        __WEBPACK_IMPORTED_MODULE_4__services_item__["a" /* default */].updateCartItem(item.id, { quantity: item.quantity - 1 }).then(function (response) {
          item.quantity -= 1;
          _this4.cartCost = response.body;
        }).catch(function (e) {
          _this4.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
        });
      }
    },
    removeCartItem: function removeCartItem(cartItem) {
      var _this5 = this;

      // console.log(cartItem.product.name)
      __WEBPACK_IMPORTED_MODULE_4__services_item__["a" /* default */].deleteCartItem(cartItem.id).then(function (response) {
        _this5.$store.dispatch('error/showSuccessToast', ['deleted ' + cartItem.product.name + ' successfully.']);
        _this5.cartCost = response.body;
        _this5._.remove(_this5.cartItems, function (item) {
          return item.id === cartItem.id;
        });
        var arr = _this5.cartItems.slice();
        _this5.cartItems = arr;
      }).catch(function (e) {
        _this5.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    orderItems: function orderItems(token) {
      var _this6 = this;

      if (this.shippingAddress.length > 0) {
        // console.log(token)
        this.$store.dispatch('error/showLoadingActivity', true);
        var params = {
          shipping_address_id: this.shippingAddress[0].id
        };
        if (token) {
          params['payment_token'] = token.id;
        }
        __WEBPACK_IMPORTED_MODULE_4__services_item__["a" /* default */].orderItems(params).then(function (response) {
          _this6.$store.dispatch('error/showLoadingActivity', false);
          var orders = response.body || [];
          _this6.ordersCost.shipping_cost = _this6._.sumBy(orders, 'shipping_cost');
          _this6.ordersCost.tax_cost = _this6._.sumBy(orders, 'tax_cost');
          _this6.ordersCost.total_cost = _this6._.sumBy(orders, 'amount');
          var itemsSize = _this6._.reduce(orders, function (size, order) {
            return size + (order.items || []).length;
          }, 0);
          _this6.ordersCost.hasDeleted = _this6.cartItems.length !== itemsSize;
          // this.$store.dispatch('error/showSuccessToast', ['Ordered successfully.'])
          // this.$store.dispatch('navigator/goNextState', { page: 'cart', tab: 'history' })
          // this.$router.push({path : '/cart#history'})
          _this6.openOrderCompleteDialog();
        }).catch(function (e) {
          _this6.$store.dispatch('error/showLoadingActivity', false);
          _this6.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);

          __WEBPACK_IMPORTED_MODULE_4__services_item__["a" /* default */].getShoppingCartItems().then(function (response) {
            _this6.cartItems = response.body;
          });
        });
      } else {
        this.$store.dispatch('error/showErrorToast', ['Please add Shipping Address.']);
      }
    },
    viewOrderHistory: function viewOrderHistory() {
      this.closeOrderCompleteDialog();
      this.$router.push({ path: '/cart#history' });
    },
    openPaymentDialog: function openPaymentDialog() {
      if (this.shippingAddress.length === 0) {
        this.$store.dispatch('error/showErrorToast', ['Please add Shipping Address.']);
      } else {
        this.showPaymentModal = true;
      }
    },
    closePaymentDialog: function closePaymentDialog() {
      this.showPaymentModal = false;
    },
    openOrderCompleteDialog: function openOrderCompleteDialog() {
      this.show_order_complete_dialog = true;
    },
    closeOrderCompleteDialog: function closeOrderCompleteDialog() {
      this.show_order_complete_dialog = false;
    },
    hideShippingAddress: function hideShippingAddress() {
      console.log('test');
    }
  }
}));

/***/ }),
/* 1080 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_discoverNav__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_discoverNav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_discoverNav__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_radialProgressbar__ = __webpack_require__(785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_radialProgressbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_radialProgressbar__);

// import UserFollowBtn from "@/components/UserFollowBtn"


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    discoverNav: __WEBPACK_IMPORTED_MODULE_0__components_discoverNav___default.a,
    RadialProgress: __WEBPACK_IMPORTED_MODULE_1__components_radialProgressbar___default.a
  },

  data: function data() {
    return {
      data: true
    };
  }
});

/***/ }),
/* 1081 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_chat__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_user__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_auth__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_album__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_product__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_chat_chatsidebar__ = __webpack_require__(778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_chat_chatsidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_chat_chatsidebar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_activityalbumcard__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_activityalbumcard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_activityalbumcard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_activityproductcard__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_activityproductcard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_activityproductcard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_activityusercard__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_activityusercard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_activityusercard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_emoji_mart_vue__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_emoji_mart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_emoji_mart_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_chat_scroll__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_chat_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vue_chat_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__helper__ = __webpack_require__(2);











// import Message from '@/components/chat/message'
// import MessageInput from '@/components/chat/messageinput'







// import { EHOSTUNREACH } from 'constants';


__WEBPACK_IMPORTED_MODULE_17_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_16_vue_chat_scroll___default.a);

var linkRegex = /(http|ftp|https):\/\/[\w-]+(\.[\w-]+)+([\w.,@?^=%&amp;:\/~+#-]*[\w@?^=%&amp;\/~+#-])?/;

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    // Message,
    // MessageInput,
    ChatSidebar: __WEBPACK_IMPORTED_MODULE_11__components_chat_chatsidebar___default.a,
    Picker: __WEBPACK_IMPORTED_MODULE_15_emoji_mart_vue__["Picker"],
    activityAlbumCard: __WEBPACK_IMPORTED_MODULE_12__components_activityalbumcard___default.a,
    activityProductCard: __WEBPACK_IMPORTED_MODULE_13__components_activityproductcard___default.a,
    activityUserCard: __WEBPACK_IMPORTED_MODULE_14__components_activityusercard___default.a
  },

  data: function data() {
    var _ref;

    return _ref = {
      showEmojiPicker: false,
      show_broadcastPopup: false,
      show_confirmPopup: false,
      show_requestPopup: false,
      show_stream_live_button: false,
      chat_socket: null,
      moment: __WEBPACK_IMPORTED_MODULE_10_moment___default.a,
      artist: '',
      messages: [],
      sendingMessages: [],
      user: null,
      room: {
        settings: {
          links: false,
          charLimitBool: false,
          charLimit: 100,
          attachments: true
        },
        online: [],
        idle: []
      },
      onlineUsers: [],
      idleUsers: [],
      adminUsers: [],
      idleInterval: null,
      rules: {
        number: function number(value) {
          var pattern = /^(0|[1-9][0-9]*)$/;
          if (value == '') return 'Please enter a number.';
          if (!pattern.test(value)) return 'Please enter a number.';
          if (!(parseInt(value) <= 500 && parseInt(value) >= 1)) return 'Please enter a number between 1-500';
          return true;
        },
        link: function link(value) {
          if (linkRegex.test(value)) return 'Links have been disabled.';
          return true;
        }
      },
      admin: false,
      last: false,
      nextChunk: 0,
      message: '',
      meberList: true,
      request_tab: 'album',
      item_index: -1,
      albums: [],
      products: [],
      users: [],
      connected: false,
      albumLinks: {},
      merchLinks: {},
      userLinks: {}
    }, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'idleInterval', null), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'messageError', ''), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'notAttachments', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'userSearchKeyword', ''), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'user_page_index', 1), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'user_items_per_page', 50), _ref;
  },


  computed: {
    currentUser: function currentUser() {
      return this.$store.state.auth.user;
    },


    // settingsChange() {
    //   if (typeof this.room.settings.charLimit === 'string' && this.room.settings.charLimit !== '' && this.rules.number(this.room.settings.charLimit) !== 'string') {
    //     // this.room.settings.charLimit = parseInt(this.room.settings.charLimit);
    //   }
    //   return JSON.stringify(this.room.settings)
    // },

    reverseMessages: function reverseMessages() {
      return this.messages.slice().reverse();
    },
    disconnected: function disconnected() {
      return !this.connected;
    },
    isMessageErr: function isMessageErr() {
      return !!this.messageError;
    }
  },

  methods: {
    isStreaming: function isStreaming() {
      return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.user.stream, 'status', '') === 'running' && (__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.$store.state.streamPlayer.stream, 'user.slug', '') !== this.user.slug || !this.$store.getters['streamPlayer/hasFrame']);
      // return true
    },
    viewStream: function viewStream() {
      if (this.isStreaming()) {
        this.$store.dispatch('streamPlayer/setStream', this.user.stream);
        this.$root.$emit(__WEBPACK_IMPORTED_MODULE_18__helper__["b" /* MyEvents */].STREM_PLAYER_INIT);
      }
    },
    startBroadcasting: function startBroadcasting() {
      this.show_broadcastPopup = false;
    },
    startListenning: function startListenning() {
      this.show_confirmPopup = false;
    },
    sendMessage: function sendMessage(messageText) {
      if (this.room.settings.charLimitBool && this.message.length > this.room.settings.charLimit) return false;
      if (!this.room.settings.links && linkRegex.test(this.message)) return; // TODO error instead of returning
      this.chat_socket.sendMessage(messageText, this.currentUser.username);
      this.message = ''; // clear textbox
      this.$nextTick(function () {
        $('#msg-container').scrollTop($('#msg-container').prop('scrollHeight'));
      });
      return false;
    },
    getMessages: function getMessages(a, b) {
      return a, b;
    },
    addEmoji: function addEmoji(emoji, event) {
      this.showEmojiPicker = false;
      this.message += emoji.native;
      this.$refs.chat.focus();
    },
    loadAlbums: function loadAlbums() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_8__services_album__["a" /* default */].getAlbums().then(function (response) {
        _this.albums = response.body;
      }).catch(function (e) {
        _this.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    loadProducts: function loadProducts() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_9__services_product__["a" /* default */].getProducts({
        statuses: 'published, collaborated',
        stock_statuses: 'active',
        user_statuses: 'accepted'
      }).then(function (response) {
        _this2.products = response.body;
      }).catch(function (e) {
        _this2.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    loadUsers: function loadUsers() {
      var _this3 = this;

      var params = {
        page: this.user_page_index,
        per_page: this.user_items_per_page
      };
      if (this.userSearchKeyword.length) {
        params['q'] = this.userSearchKeyword;
      }
      __WEBPACK_IMPORTED_MODULE_6__services_user__["a" /* default */].searchUsers(params).then(function (response) {
        _this3.users = response.body.users;
      }).catch(function (e) {
        _this3.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    onRequestTab: function onRequestTab(tab) {
      this.request_tab = tab;
      this.item_index = -1;
      if (tab === 'album') {
        this.loadAlbums();
      } else {
        this.loadProducts();
      }
    },
    choosePage: function choosePage(path) {
      this.$router.push({ path: '/' + path });
    },
    selectItemIndex: function selectItemIndex(index) {
      var itemType = this.request_tab;
      var itemId = (this.request_tab === 'album' ? this.albums : this.products)[index].id;
      this.show_requestPopup = false;
      if (this.item_index != index) {
        this.item_index = index;
      } else {
        this.item_index = -1;
      }
      this.sendMessage('/' + itemType + '/' + itemId);
    },
    onSelectUser: function onSelectUser(a) {
      this.show_requestPopup = false;
      this.sendMessage('/user/' + a.slug);
    },
    isAttachmentLink: function isAttachmentLink(string) {
      // const attachmentRegex = /\/((album)|(merch)\/\w{8}-\w{4}-\w{4}-\w{4}-\w{12})|user\/\w+/g
      var attachmentRegex = /\/((album)|(merch)\/\d+)|user\/\w+/g;
      return this.notAttachments.indexOf(string) < 0 && attachmentRegex.test(string);
    },
    isAlbumLink: function isAlbumLink(string) {
      // const albumLinkRegex = /\/album\/\w{8}-\w{4}-\w{4}-\w{4}-\w{12}/g
      var albumLinkRegex = /\/album\/\d+/g;
      return albumLinkRegex.test(string);
    },
    isMerchLink: function isMerchLink(string) {
      // const merchLinkRegex = /\/merch\/\w{8}-\w{4}-\w{4}-\w{4}-\w{12}/g
      var merchLinkRegex = /\/merch\/\d+/g;
      return merchLinkRegex.test(string);
    },
    isUserLink: function isUserLink(string) {
      var userLinkRegex = /\/user\/\w+/g;
      return this.isAttachmentLink(string) && userLinkRegex.test(string);
    },
    getAlbumFromLink: function getAlbumFromLink(string) {
      var _this4 = this;

      var albumId = string.split('/')[2];
      __WEBPACK_IMPORTED_MODULE_8__services_album__["a" /* default */].getAlbum(albumId).then(function (res) {
        if (res.ok) {
          __WEBPACK_IMPORTED_MODULE_17_vue__["default"].set(_this4.albumLinks, string, res.body);
        } else {
          _this4.notAttachments.push(string);
        }
      }).catch(function (err) {
        _this4.notAttachments.push(string);
      });
    },
    getMerchFromLink: function getMerchFromLink(string) {
      var _this5 = this;

      var merchId = string.split('/')[2];
      __WEBPACK_IMPORTED_MODULE_9__services_product__["a" /* default */].getProduct(merchId).then(function (res) {
        if (res.ok) {
          __WEBPACK_IMPORTED_MODULE_17_vue__["default"].set(_this5.merchLinks, string, res.body);
        } else {
          _this5.notAttachments.push(string);
        }
      }).catch(function (err) {
        _this5.notAttachments.push(string);
      });
    },
    getUserFromLink: function getUserFromLink(string) {
      var _this6 = this;

      var userId = string.split('/')[2];
      __WEBPACK_IMPORTED_MODULE_6__services_user__["a" /* default */].getUserInfo(userId).then(function (res) {
        if (res && res.ok) {
          __WEBPACK_IMPORTED_MODULE_17_vue__["default"].set(_this6.userLinks, string, res.body);
        } else {
          _this6.notAttachments.push(string);
        }
      }).catch(function (err) {
        _this6.notAttachments.push(string);
      });
    },
    onExitVideoPlayer: function onExitVideoPlayer(username) {
      // console.log('exit video player...', username)
      var vm = this;
      if (this.user.username === username) {
        setTimeout(function () {
          console.log('back to online', username);
          vm.chat_socket.online();
        }, 1000);
      }
    },
    updateSettings: function updateSettings() {
      if (this.room.settings.charLimitBool && typeof this.rules.number(this.room.settings.charLimit) === 'string') {
        return;
      }
      if (typeof this.room.settings.charLimit === 'string' && this.room.settings.charLimit !== '') {
        this.room.settings.charLimit = parseInt(this.room.settings.charLimit);
      }
      this.chat_socket.updateSettings(this.room.settings);
    },
    loadPage: function loadPage() {
      var _this7 = this;

      this.unloadPage();

      var vm = this;
      var requestInProgress = false;
      vm.show_stream_live_button = false;

      this.$store.dispatch('navigator/goNextState', { page: 'chat', tab: '' });
      this.$store.dispatch('error/showLoadingActivity', true);
      __WEBPACK_IMPORTED_MODULE_6__services_user__["a" /* default */].getUserInfo(this.artist).then(function (response) {
        _this7.$store.dispatch('error/showLoadingActivity', false);
        _this7.user = response.body;
        _this7.loadAlbums();
        if (__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(_this7.user.stream, 'status', '') === 'running') {
          __WEBPACK_IMPORTED_MODULE_17_vue__["default"].http.get(_this7.user.stream.mp_channel_1_ep_1_url).then(function (response) {
            _this7.show_stream_live_button = true;
          });
        }
        _this7.chat_socket = new __WEBPACK_IMPORTED_MODULE_5__services_chat__["a" /* default */]("https://chat.yousound.com", _this7.user.slug, __WEBPACK_IMPORTED_MODULE_7__services_auth__["a" /* default */].getToken(), function () {
          _this7.chat_socket.onDisconnect = function () {
            console.log('chat disconnected :(');
            vm.connected = false;
          };
          _this7.chat_socket.onError = function (error) {
            vm.messageError = error;
          };
          _this7.chat_socket.onMessage = function (message) {
            if (!message) return;
            // Remove the message from sendingMessages
            vm.sendingMessages = $.grep(vm.sendingMessages, function (e) {
              return e.localId != message.localId;
            });

            // look up the username in message.from to get image, etc.
            if (message.from === vm.currentUser.username) {
              message.me = true;
              message.fromUser = vm.currentUser;
              vm.messages.unshift(message);
            } else {
              __WEBPACK_IMPORTED_MODULE_6__services_user__["a" /* default */].getUserInfo(message.from).then(function (response) {
                message.fromUser = response.body;
                if (vm.messages.length != 0) {
                  if (vm.messages[0].localId != message.localId) {
                    // This block of code runs twice for some reason
                    // So just make sure that we didn't already add this message
                    // if (!(vm.messages.length == 1)) {
                    vm.messages.unshift(message);
                    // }
                  }
                }
              });
            }

            if (vm.isAlbumLink(message.text)) {
              vm.getAlbumFromLink(message.text);
            }

            if (vm.isMerchLink(message.text)) {
              vm.getMerchFromLink(message.text);
            }

            if (vm.isUserLink(message.text)) {
              vm.getUserFromLink(message.text);
            }
          };

          _this7.chat_socket.onMessageSending = function (text) {
            vm.sendingMessages.push(text);
          };

          _this7.chat_socket.onUserInfo = function (user) {
            vm.user = user;
          };

          _this7.chat_socket.onRoomInfo = function () {
            var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(room) {
              var temponlineUsers, tempidleUsers;
              return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                while (1) {
                  switch (_context4.prev = _context4.next) {
                    case 0:
                      // console.log('chat onRoomInfo', room)
                      // Vue.set(vm, "room", room)
                      vm.room = room;
                      // Fetch user data (avatar image, etc)
                      _context4.next = 3;
                      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.chain(room.online).compact().map(function () {
                        var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(username) {
                          var res;
                          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                            while (1) {
                              switch (_context.prev = _context.next) {
                                case 0:
                                  _context.next = 2;
                                  return __WEBPACK_IMPORTED_MODULE_6__services_user__["a" /* default */].getUserInfo(username);

                                case 2:
                                  res = _context.sent;
                                  return _context.abrupt('return', res.body);

                                case 4:
                                case 'end':
                                  return _context.stop();
                              }
                            }
                          }, _callee, _this7);
                        }));

                        return function (_x2) {
                          return _ref3.apply(this, arguments);
                        };
                      }()).value());

                    case 3:
                      temponlineUsers = _context4.sent;
                      _context4.next = 6;
                      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(room.idle.map(function () {
                        var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(username) {
                          var res;
                          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                            while (1) {
                              switch (_context2.prev = _context2.next) {
                                case 0:
                                  _context2.next = 2;
                                  return __WEBPACK_IMPORTED_MODULE_6__services_user__["a" /* default */].getUserInfo(username);

                                case 2:
                                  res = _context2.sent;
                                  return _context2.abrupt('return', res.body);

                                case 4:
                                case 'end':
                                  return _context2.stop();
                              }
                            }
                          }, _callee2, _this7);
                        }));

                        return function (_x3) {
                          return _ref4.apply(this, arguments);
                        };
                      }()));

                    case 6:
                      tempidleUsers = _context4.sent;
                      _context4.next = 9;
                      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(room.admins.map(function () {
                        var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(username) {
                          var res;
                          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                            while (1) {
                              switch (_context3.prev = _context3.next) {
                                case 0:
                                  _context3.next = 2;
                                  return __WEBPACK_IMPORTED_MODULE_6__services_user__["a" /* default */].getUserInfo(username);

                                case 2:
                                  res = _context3.sent;
                                  return _context3.abrupt('return', res.body);

                                case 4:
                                case 'end':
                                  return _context3.stop();
                              }
                            }
                          }, _callee3, _this7);
                        }));

                        return function (_x4) {
                          return _ref5.apply(this, arguments);
                        };
                      }()));

                    case 9:
                      vm.adminUsers = _context4.sent;

                      // Remove admin users from online/idle list because they are displayed separately
                      __WEBPACK_IMPORTED_MODULE_17_vue__["default"].set(vm, 'onlineUsers', temponlineUsers.filter(function (u) {
                        return room.admins.indexOf(u.username) < 0;
                      }));
                      __WEBPACK_IMPORTED_MODULE_17_vue__["default"].set(vm, 'idleUsers', tempidleUsers.filter(function (u) {
                        return room.admins.indexOf(u.username) < 0;
                      }));
                      vm.admin = room.admins.filter(function (u) {
                        return u == vm.currentUser.username;
                      }).length == 1;

                    case 13:
                    case 'end':
                      return _context4.stop();
                  }
                }
              }, _callee4, _this7);
            }));

            return function (_x) {
              return _ref2.apply(this, arguments);
            };
          }();

          _this7.chat_socket.onLoadMessages = function (loadMessageObj) {
            // loadMessageObj is an object {chunk: <chunk number>, data: <array of messages in chunk>, last: <if it's the last chunk>}
            for (var i = loadMessageObj.chunk * 500; i < (loadMessageObj.chunk + 1) * 500; i++) {
              var nextMessage = loadMessageObj.data[i - loadMessageObj.chunk * 500];
              if (nextMessage) {
                __WEBPACK_IMPORTED_MODULE_17_vue__["default"].set(vm.messages, i, nextMessage);
              }
            }
            vm.last = loadMessageObj.last;
            vm.nextChunk = loadMessageObj.chunk + 1;
            requestInProgress = false;
            vm.messages.map(function (message) {
              if (message) {
                if (vm.isAlbumLink(message.text)) {
                  vm.getAlbumFromLink(message.text);
                }
                if (vm.isMerchLink(message.text)) {
                  vm.getMerchFromLink(message.text);
                }
                if (vm.isUserLink(message.text)) {
                  vm.getUserFromLink(message.text);
                }
                if (message.from === vm.currentUser.username) {
                  message.me = true;
                }
                __WEBPACK_IMPORTED_MODULE_6__services_user__["a" /* default */].getUserInfo(message.from).then(function (response) {
                  __WEBPACK_IMPORTED_MODULE_17_vue__["default"].set(message, 'fromUser', response.body);
                });
                return message;
              }
            });
            vm.connected = true;
            vm.messageError = '';
            $('#msg-container').scrollTop($('#msg-container').prop('scrollHeight'));

            // setTimeout(function() {
            //   scrollDown(loadMessageObj.chunk === 0);
            //   if (loadMessageObj.chunk > 0) {
            //     $("#msg-container").scrollTop($("#msg-container")[0].scrollHeight - oldHeight + oldScroll);
            //   }
            // }, 1);
            //   vm.artist = this.chat_socket.room;
            // };
          };
        });
      }).catch(function (e) {
        _this7.$store.dispatch('error/showLoadingActivity', false);
        console.log(e);
      });
    },
    unloadPage: function unloadPage() {
      if (this.idleInterval) {
        clearInterval(this.idleInterval);
      }

      if (this.chat_socket) {
        this.chat_socket.close();
        this.chat_socket = null;
      }
    }
  },

  watch: {
    $route: function $route(toPath, fromPath) {
      // const paths = toPath.path.split('/')
      // console.log(toPath, fromPath, toPath.params.user)
      this.artist = toPath.params.user;
      this.loadPage();
    }
  },

  created: function created() {
    this.artist = this.$route.params.user;

    this.$root.$on(__WEBPACK_IMPORTED_MODULE_18__helper__["b" /* MyEvents */].STREM_PLAYER_EXIT, this.onExitVideoPlayer);
    this.loadPage();
  },
  beforeDestroy: function beforeDestroy() {
    this.$root.$off(__WEBPACK_IMPORTED_MODULE_18__helper__["b" /* MyEvents */].STREM_PLAYER_EXIT, this.onExitVideoPlayer);
    this.unloadPage();
  },
  mounted: function mounted() {
    var idleTimeout = 3; // 3 minutes
    var vm = this;
    var idleTime = 0;
    $(document).ready(function () {
      // increment the idle time counter every 0.1 minutes.
      vm.idleInterval = setInterval(timerIncrement, 6000); // 1 minute

      // zero the idle timer on mouse movement.
      $(this).mousemove(function (e) {
        if (idleTime >= idleTimeout) vm.chat_socket.online(); // back online after being idle
        idleTime = 0;
      });
      $(this).keypress(function (e) {
        if (idleTime >= idleTimeout) vm.chat_socket.online(); // back online after being idle
        idleTime = 0;
      });
    });

    var requestInProgress = false;
    var oldHeight = $('#msg-container').height();
    var oldScroll = $('#msg-container').scrollTop();

    $('#msg-container').scroll(function () {
      if ($('#msg-container').scrollTop() < 50 && !vm.last) {
        if (!requestInProgress) {
          oldHeight = $('#msg-container').height();
          oldScroll = $('#msg-container').scrollTop();
          requestInProgress = true;
          vm.chat_socket.moreMessages(vm.nextChunk);
        }
      }
    });

    function timerIncrement() {
      idleTime = idleTime + 0.1;
      if (idleTime >= idleTimeout) {
        // 20 minutes
        vm.chat_socket.idle();
        clearInterval(vm.idleInterval);
      }
    }
  }
});

// function scrollDown(force) {
//   let container = $('#msg-container');
//   if (force || Math.abs(container.scrollHeight - container.scrollTop - container.clientHeight) < 70) {
//     container.scrollTop = container.scrollHeight;
//   }
// }

/***/ }),
/* 1082 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_stream__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_collection__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_productcard__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_productcard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_productcard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_trackcard__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_trackcard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_trackcard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_contentTopHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_contentTopHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_contentTopHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__repostMusic__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__repostMusic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__repostMusic__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__repostVideos__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__repostVideos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__repostVideos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__repostProducts__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__repostProducts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__repostProducts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_collection_playlist__ = __webpack_require__(146);














/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        productCard: __WEBPACK_IMPORTED_MODULE_4__components_productcard___default.a,
        trackCard: __WEBPACK_IMPORTED_MODULE_5__components_trackcard___default.a,
        contentTopHeader: __WEBPACK_IMPORTED_MODULE_6__components_contentTopHeader___default.a,
        repostMusic: __WEBPACK_IMPORTED_MODULE_7__repostMusic___default.a,
        repostVideos: __WEBPACK_IMPORTED_MODULE_8__repostVideos___default.a,
        repostProducts: __WEBPACK_IMPORTED_MODULE_9__repostProducts___default.a
    },
    data: function data() {
        return {
            activeTab: "music",
            tabs: [{ id: "music", title: "Music" }, { id: "videos", title: "Videos" }, { id: "products", title: "Products" }],
            tracks: null,
            streams: null,
            products: null,
            pageReady: false,
            playlist_data: null,
            playlistTracks: null,
            playlistStreams: null,
            viewAllPlaylist: false,
            show_delete_playlist_modal: false,
            playlist_id: null
        };
    },

    computed: {
        playlists: function playlists() {
            return this.$store.state.playlist.playlists;
        },
        currentUser: function currentUser() {
            return this.$store.state.auth.user;
        }
    },

    mounted: function mounted() {
        this.$parent.$el.classList.add("loading");
    },


    methods: {
        methodThatForcesUpdate: function methodThatForcesUpdate() {
            this.$parent.$el.classList.add("loading");
            this.getCollectionPlaylist();
            this.loadData();
            this.$parent.$el.classList.remove("loading");
        },
        onTab: function onTab(tab) {
            this.activeTab = tab;
        },
        isActiveTab: function isActiveTab(tab) {
            return this.activeTab === tab;
        },
        getStream: function getStream() {
            var _this = this;

            var vid_params = {
                genre_id: 0,
                only_follows: false,
                page: 1,
                per_page: 10
            };
            __WEBPACK_IMPORTED_MODULE_2__services_stream__["a" /* default */].getStreams(vid_params).then(function (response) {
                _this.videos = response.body.streams;
            }).catch(function (error) {
                _this.$store.dispatch("error/showErrorToast", [error]);
            });
        },
        getCollections: function getCollections() {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_3__services_collection__["a" /* default */].getCollections().then(function (response) {
                _this2.$parent.$el.classList.remove('bg-light');
                _this2.$parent.$el.classList.add('bg-grey');
                _this2.tracks = response.body.tracks;
                _this2.streams = response.body.streams;
                _this2.products = response.body.products;
                _this2.pageReady = true;
                _this2.$parent.$el.classList.remove("loading");
            }).catch(function (exception) {
                _this2.$store.dispatch("error/showErrorToast", [exception.body.error] || [exception]);
            });
        },
        loadData: function loadData() {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_3__services_collection__["a" /* default */].getCollections().then(function (response) {
                                    _this3.$parent.$el.classList.remove('bg-light');
                                    _this3.$parent.$el.classList.add('bg-grey');
                                    _this3.tracks = response.body.tracks;
                                    _this3.streams = response.body.streams;
                                    _this3.products = response.body.products;
                                    _this3.pageReady = true;
                                    _this3.$parent.$el.classList.remove("loading");
                                }).catch(function (exception) {
                                    _this3.$store.dispatch("error/showErrorToast", [exception.body.error] || [exception]);
                                });

                            case 2:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, _this3);
            }))();
        },
        getCollectionPlaylist: function getCollectionPlaylist() {
            var _this4 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_10__services_collection_playlist__["a" /* default */].getCollectionPlaylists().then(function (response) {
                                    _this4.playlist_data = response.body;
                                }).catch(function (e) {
                                    _this4.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
                                });

                            case 2:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this4);
            }))();
        },
        openDeletePlaylistModal: function openDeletePlaylistModal(playlistId) {
            this.show_delete_playlist_modal = true;
            this.playlist_id = playlistId;
        },
        deletePlaylist: function deletePlaylist() {
            var _this5 = this;

            __WEBPACK_IMPORTED_MODULE_10__services_collection_playlist__["a" /* default */].destroy(this.playlist_id).then(function (response) {
                _this5.$store.dispatch('error/showSuccessToast', [response.bodyText]);
                _this5.show_delete_playlist_modal = false;
                _this5.getCollectionPlaylist();
            }).carch(function (e) {
                _this5.$store.dispatch('error/showErrorToast', ['Unable to remove playlist from collection']);
                _this5.show_delete_playlist_modal = false;
            });
        }
    },

    created: function created() {
        var _this6 = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.next = 2;
                            return _this6.getCollectionPlaylist();

                        case 2:
                            _context3.next = 4;
                            return _this6.loadData();

                        case 4:
                            if (_this6.$route.params.activeTab !== undefined) {
                                _this6.activeTab = _this6.$route.params.activeTab;
                            }

                        case 5:
                        case "end":
                            return _context3.stop();
                    }
                }
            }, _callee3, _this6);
        }))();
    }
});

/***/ }),
/* 1083 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_contentTopHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_contentTopHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_contentTopHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_dashboardnav__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_dashboardnav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_dashboardnav__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_apexcharts__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_apexcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_apexcharts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_analyticsModal__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_analyticsModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__views_analyticsModal__);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    contentTopHeader: __WEBPACK_IMPORTED_MODULE_2__components_contentTopHeader___default.a,
    dashboardNav: __WEBPACK_IMPORTED_MODULE_3__components_dashboardnav___default.a,
    chart: __WEBPACK_IMPORTED_MODULE_4_vue_apexcharts___default.a,
    analyticsModal: __WEBPACK_IMPORTED_MODULE_5__views_analyticsModal___default.a
  },
  data: function data() {
    return {
      testcount: 0,
      activeTab: 'music',
      activeInnerTab: 'earnings',
      activeChart: '',
      selectedInnerTab: {},
      selectedChart: {},
      daysFilter: 0,
      dashboardStats: [],
      tabs: [{ id: 'music', title: 'Audio' },
      // { id: 'products', title: 'Products' },
      { id: 'topCreators', title: 'Top Creators' }],
      innerTabs: [{
        parent: 'overview',
        tabs: [{
          id: 'earnings',
          title: 'Earnings',
          value: 1000,
          size: 'custom',
          breakdown: [{
            title: 'All',
            value: 'all',
            series: [{
              name: 'series-1',
              data: [0, 10, 45, 50, 80, 60, 70, 45, 10, 0, 0, 0]
            }]
          }, {
            title: 'Sales',
            value: 'sales',
            series: [{
              name: 'series-1',
              data: [30, 40, 45, 50, 49, 60, 70, 81, 0, 0, 0, 0]
            }]
          }, {
            title: 'Donations',
            value: 'donations',
            series: [{
              name: 'series-1',
              data: [30, 40, 45, 50, 70, 81, 49, 60, 0, 0]
            }]
          }, {
            title: 'Repost Request',
            value: 'repostRequest',
            series: [{
              name: 'series-1',
              data: [30, 40, 0, 50, 49, 60, 70, 81, 0, 0, 0, 0]
            }]
          }]
        }, {
          id: 'followers',
          title: 'Followers',
          value: 2000,
          size: 'custom',
          breakdown: [{
            title: 'All',
            value: 'all',
            series: [{
              name: 'series-1',
              data: [0, 10, 45, 50, 80, 60, 70, 45, 10, 0, 0, 0]
            }]
          }, {
            title: 'Sales',
            value: 'sales',
            series: [{
              name: 'series-1',
              data: [30, 40, 45, 50, 49, 60, 70, 81, 0, 0, 0, 0]
            }]
          }, {
            title: 'Donations',
            value: 'donations',
            series: [{
              name: 'series-1',
              data: [30, 40, 45, 50, 70, 81, 49, 60, 0, 0]
            }]
          }, {
            title: 'Repost Request',
            value: 'repostRequest',
            series: [{
              name: 'series-1',
              data: [30, 40, 0, 50, 49, 60, 70, 81, 0, 0, 0, 0]
            }]
          }]
        }, {
          id: 'shares',
          title: 'Shares',
          value: 3000,
          size: 'custom',
          breakdown: [{
            title: 'All',
            value: 'all',
            series: [{
              name: 'series-1',
              data: [0, 10, 45, 50, 80, 60, 70, 45, 10, 0, 0, 0]
            }]
          }, {
            title: 'Sales',
            value: 'sales',
            series: [{
              name: 'series-1',
              data: [30, 40, 45, 50, 49, 60, 70, 81, 0, 0, 0, 0]
            }]
          }, {
            title: 'Donations',
            value: 'donations',
            series: [{
              name: 'series-1',
              data: [30, 40, 45, 50, 70, 81, 49, 60, 0, 0]
            }]
          }, {
            title: 'Repost Request',
            value: 'repostRequest',
            series: [{
              name: 'series-1',
              data: [30, 40, 0, 50, 49, 60, 70, 81, 0, 0, 0, 0]
            }]
          }]
        }, {
          id: 'comments',
          title: 'Comments',
          value: 4000,
          size: 'custom',
          breakdown: [{
            title: 'All',
            value: 'all',
            series: [{
              name: 'series-1',
              data: [0, 10, 45, 50, 80, 60, 70, 45, 10, 0, 0, 0]
            }]
          }, {
            title: 'Sales',
            value: 'sales',
            series: [{
              name: 'series-1',
              data: [30, 40, 45, 50, 49, 60, 70, 81, 0, 0, 0, 0]
            }]
          }, {
            title: 'Donations',
            value: 'donations',
            series: [{
              name: 'series-1',
              data: [30, 40, 45, 50, 70, 81, 49, 60, 0, 0]
            }]
          }, {
            title: 'Repost Request',
            value: 'repostRequest',
            series: [{
              name: 'series-1',
              data: [30, 40, 0, 50, 49, 60, 70, 81, 0, 0, 0, 0]
            }]
          }]
        }, {
          id: 'reposts',
          title: 'Reposts',
          value: 5000,
          size: 'custom',
          breakdown: [{
            title: 'All',
            value: 'all',
            series: [{
              name: 'series-1',
              data: [0, 10, 45, 50, 80, 60, 70, 45, 10, 0, 0, 0]
            }]
          }, {
            title: 'Sales',
            value: 'sales',
            series: [{
              name: 'series-1',
              data: [30, 40, 45, 50, 49, 60, 70, 81, 0, 0, 0, 0]
            }]
          }, {
            title: 'Donations',
            value: 'donations',
            series: [{
              name: 'series-1',
              data: [30, 40, 45, 50, 70, 81, 49, 60, 0, 0]
            }]
          }, {
            title: 'Repost Request',
            value: 'repostRequest',
            series: [{
              name: 'series-1',
              data: [30, 40, 0, 50, 49, 60, 70, 81, 0, 0, 0, 0]
            }]
          }]
        }, {
          id: 'subscriptionRevenue',
          title: 'Subscription Revenue',
          value: 6000,
          size: 4,
          breakdown: [{
            title: 'All',
            value: 'all',
            series: [{
              name: 'series-1',
              data: [0, 10, 45, 50, 80, 60, 70, 45, 10, 0, 0, 0]
            }]
          }, {
            title: 'Sales',
            value: 'sales',
            series: [{
              name: 'series-1',
              data: [30, 40, 45, 50, 49, 60, 70, 81, 0, 0, 0, 0]
            }]
          }, {
            title: 'Donations',
            value: 'donations',
            series: [{
              name: 'series-1',
              data: [30, 40, 45, 50, 70, 81, 49, 60, 0, 0]
            }]
          }, {
            title: 'Repost Request',
            value: 'repostRequest',
            series: [{
              name: 'series-1',
              data: [30, 40, 0, 50, 49, 60, 70, 81, 0, 0, 0, 0]
            }]
          }]
        }, {
          id: 'subscribersList',
          title: 'Subscribers List',
          value: 7000,
          size: 4,
          breakdown: [{
            title: 'All',
            value: 'all',
            series: [{
              name: 'series-1',
              data: [0, 10, 45, 50, 80, 60, 70, 45, 10, 0, 0, 0]
            }]
          }, {
            title: 'Sales',
            value: 'sales',
            series: [{
              name: 'series-1',
              data: [30, 40, 45, 50, 49, 60, 70, 81, 0, 0, 0, 0]
            }]
          }, {
            title: 'Donations',
            value: 'donations',
            series: [{
              name: 'series-1',
              data: [30, 40, 45, 50, 70, 81, 49, 60, 0, 0]
            }]
          }, {
            title: 'Repost Request',
            value: 'repostRequest',
            series: [{
              name: 'series-1',
              data: [30, 40, 0, 50, 49, 60, 70, 81, 0, 0, 0, 0]
            }]
          }]
        }, {
          id: 'adRevenue',
          title: 'Ad Revenue',
          value: 8000,
          size: 4,
          breakdown: [{
            title: 'All',
            value: 'all',
            series: [{
              name: 'series-1',
              data: [0, 10, 45, 50, 80, 60, 70, 45, 10, 0, 0, 0]
            }]
          }, {
            title: 'Sales',
            value: 'sales',
            series: [{
              name: 'series-1',
              data: [30, 40, 45, 50, 49, 60, 70, 81, 0, 0, 0, 0]
            }]
          }, {
            title: 'Donations',
            value: 'donations',
            series: [{
              name: 'series-1',
              data: [30, 40, 45, 50, 70, 81, 49, 60, 0, 0]
            }]
          }, {
            title: 'Repost Request',
            value: 'repostRequest',
            series: [{
              name: 'series-1',
              data: [30, 40, 0, 50, 49, 60, 70, 81, 0, 0, 0, 0]
            }]
          }]
        }]
      }, {
        parent: 'music',
        header: 'Plays',
        tabs: [{ id: 1, title: "TOTAL PLAYS", value: "1,110,2938", size: 3 }, { id: 2, title: "TOTAL STREAMING REVENUE", value: "$51,420.00", size: 3 }, { id: 3, title: "YOUR STREAMING REVENUE", value: "$4,222", size: 3 }, { id: 4, title: "TOTAL COLLABORATOR REVENUE", value: "$1,110,2938", size: 3 }],
        statsList: {
          title: "Tracks",
          count: 323,
          items_type: 'musics',
          items: [{
            "id": 999,
            "slug": "the-show-rush",
            "name": "The show Rush",
            "user": {
              "id": 999,
              "slug": "testartist1",
              "username": "testartist1",
              "display_name": "Hudson Mohawke",
              "user_type": "artist",
              "avatar": {
                "url": "../../../static/images/artist.png",
                "thumb": {
                  "url": "../../../static/images/artist.png"
                }
              }
            },
            "album": {
              "id": 999,
              "name": "Album Name",
              "slug": "album-name",
              "cover": {
                "url": "../../../static/images/album.jpg",
                "large": {
                  "url": "../../../static/images/album.jpg"
                }
              },
              "album_type": "album"
            }
          }]
        }
      },
      /*
      {
        parent: 'products',
        tabs: [
          { id: 1, title: "TOTAL SALES", value: "1,110,2938", size: 3 },
          { id: 2, title: "TOTAL SALES REVENUE", value: "$51,420.00", size: 3 },
          { id: 3, title: "YOUR TOTAL SALES REVENUE", value: "$4,222", size: 3 },
          { id: 4, title: "TOTAL COLLABORATOR REVENUE", value: "$1,110,2938", size: 3 },
        ],
        statsList: {
          title: "Products",
          count: 323,
          items_type: 'products',
          items: [
            {
              "id": 999,
              "name": "Cap",
              "description": "Black Cap",
              "cover": {
                  "url": "../../../static/images/product1.png",
              },
              "user": {
                  "id": 999,
                  "slug": "testartist1",
                  "username": "testartist1",
                  "display_name": "Hudson Mohawke",
                  "user_type": "artist",
                  "avatar": {
                      "url": "../../../static/images/artist.png",
                      "thumb": {
                          "url": "../../../static/images/artist.png",
                      },
                  },
              },
            },
          ],
        },
      },
      */
      {
        parent: 'topCreators',
        tabs: []
      }],
      tabFilterOptions: [{
        title: 'All Time', value: 0
      }, {
        title: 'Today', value: 1
      }, {
        title: 'Month', value: 2
      }, {
        title: 'Year', value: 3
      }],
      chartOptions: {
        colors: ["#5f78ff"],
        chart: {
          type: 'area',
          id: 'own-id',
          foreColor: '#eee',
          zoom: {
            enabled: false
          },

          toolbar: {
            show: false
          }
        },
        xaxis: {
          type: 'category',
          categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
        }
      },
      pieSeries: [44, 55, 41, 17, 15],
      pieChartOptions: {
        chart: {
          type: 'donut'
        },
        labels: ["Country A", "Country B", "Country C", "Country D", "Country E"],
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 100
            },
            legend: {
              position: 'bottom'
            }
          }
        }],
        dataLabels: {
          enabled: false
        },
        legend: {
          show: !false,
          position: 'bottom'
        },
        plotOptions: {
          pie: {
            customScale: 0.7,
            donut: {
              size: '80%'
            }
          }
        }
      },
      summaryTabs: [{
        parent: 'overview',
        colTabs: [{
          header: 'TOTAL PLAYS',
          avatarType: 'square',
          data: []
        }, {
          header: 'TOTAL STREAMING REVENUE',
          avatarType: 'square',
          data: []
        }]
      }, {
        parent: 'music',
        colTabs: [{
          header: 'Top albums',
          avatarType: 'square',
          data: []
        }, {
          header: 'Top listeners',
          avatarType: 'round',
          data: []
        }],
        dataTables: [{
          headers: [{
            text: 'External Traffic Source',
            align: 'left',
            sortable: false,
            value: 'name'
          }, {
            text: 'Visits',
            align: 'left',
            sortable: false,
            value: 'visits'
          }, {
            text: 'New Visitors',
            align: 'left',
            sortable: false,
            value: 'newVisitors'
          }, {
            text: 'Album Page Visited',
            align: 'left',
            sortable: false,
            value: 'videoPageVisited'
          }],
          data: [{
            name: 'google.com',
            visits: 159000,
            newVisitors: '40%',
            albumPageVisited: '1000'
          }, {
            name: 'google.com',
            visits: 237000,
            newVisitors: '40%',
            albumPageVisited: '1000'
          }, {
            name: 'google.com',
            visits: 262000,
            newVisitors: '60%',
            albumPageVisited: '7000'
          }, {
            name: 'google.com',
            visits: 305000,
            newVisitors: '40%',
            albumPageVisited: '8000'
          }, {
            name: 'google.com',
            visits: 356000,
            newVisitors: '30%',
            albumPageVisited: '16000'
          }, {
            name: 'google.com',
            visits: 375000,
            newVisitors: '00%',
            albumPageVisited: '0000'
          }, {
            name: 'google.com',
            visits: 392000,
            newVisitors: '100%',
            albumPageVisited: '2000'
          }, {
            name: 'google.com',
            visits: 408000,
            newVisitors: '60%',
            albumPageVisited: '45000'
          }, {
            name: 'google.com',
            visits: 452000,
            newVisitors: '40%',
            albumPageVisited: '22000'
          }, {
            name: 'google.com',
            visits: 518000,
            newVisitors: '10%',
            albumPageVisited: '6000'
          }]
        }]
      }, {
        parent: 'videos',
        colTabs: [{
          header: 'Top Videos',
          avatarType: 'rectangle',
          data: []
        }, {
          header: 'Plays by Countries',
          type: 'pie',
          data: []
        }, {
          header: 'Top Viewers',
          avatarType: 'round',
          data: []
        }],
        dataTables: [{
          headers: [{
            text: 'External Traffic Source',
            align: 'left',
            sortable: false,
            value: 'name'
          }, {
            text: 'Visits',
            align: 'left',
            sortable: false,
            value: 'visits'
          }, {
            text: 'New Visitors',
            align: 'left',
            sortable: false,
            value: 'newVisitors'
          }, {
            text: 'Product Page Visited',
            align: 'left',
            sortable: false,
            value: 'videoPageVisited'
          }],
          data: [{
            name: 'google.com',
            visits: 159000,
            newVisitors: '40%',
            albumPageVisited: '1000'
          }, {
            name: 'google.com',
            visits: 237000,
            newVisitors: '40%',
            albumPageVisited: '1000'
          }, {
            name: 'google.com',
            visits: 262000,
            newVisitors: '60%',
            albumPageVisited: '7000'
          }, {
            name: 'google.com',
            visits: 305000,
            newVisitors: '40%',
            albumPageVisited: '8000'
          }, {
            name: 'google.com',
            visits: 356000,
            newVisitors: '30%',
            albumPageVisited: '16000'
          }, {
            name: 'google.com',
            visits: 375000,
            newVisitors: '00%',
            albumPageVisited: '0000'
          }, {
            name: 'google.com',
            visits: 392000,
            newVisitors: '100%',
            albumPageVisited: '2000'
          }, {
            name: 'google.com',
            visits: 408000,
            newVisitors: '60%',
            albumPageVisited: '45000'
          }, {
            name: 'google.com',
            visits: 452000,
            newVisitors: '40%',
            albumPageVisited: '22000'
          }, {
            name: 'google.com',
            visits: 518000,
            newVisitors: '10%',
            albumPageVisited: '6000'
          }]
        }]
      },
      /*
      {
        parent: 'products',
        colTabs: [
          {
            header: 'Top Products',
            data: [],
          },
          {
            header: 'Top Customers',
            avatarType: 'round',
            data: [],
          },
        ],
        dataTables: [
          {
            headers: [
              {
                text: 'External Traffic Source',
                align: 'left',
                sortable: false,
                value: 'name',
              },
              {
                text: 'Visits',
                align: 'left',
                sortable: false,
                value: 'visits',
              },
              {
                text: 'New Visitors',
                align: 'left',
                sortable: false,
                value: 'newVisitors',
              },
              {
                text: 'Product Page Visited',
                align: 'left',
                sortable: false,
                value: 'videoPageVisited',
              },
            ],
            data: [
              {
                name: 'google.com',
                visits: 159000,
                newVisitors: '40%',
                albumPageVisited: '1000',
              },
              {
                name: 'google.com',
                visits: 237000,
                newVisitors: '40%',
                albumPageVisited: '1000',
              },
              {
                name: 'google.com',
                visits: 262000,
                newVisitors: '60%',
                albumPageVisited: '7000',
              },
              {
                name: 'google.com',
                visits: 305000,
                newVisitors: '40%',
                albumPageVisited: '8000',
              },
              {
                name: 'google.com',
                visits: 356000,
                newVisitors: '30%',
                albumPageVisited: '16000',
              },
              {
                name: 'google.com',
                visits: 375000,
                newVisitors: '00%',
                albumPageVisited: '0000',
              },
              {
                name: 'google.com',
                visits: 392000,
                newVisitors: '100%',
                albumPageVisited: '2000',
              },
              {
                name: 'google.com',
                visits: 408000,
                newVisitors: '60%',
                albumPageVisited: '45000',
              },
              {
                name: 'google.com',
                visits: 452000,
                newVisitors: '40%',
                albumPageVisited: '22000',
              },
              {
                name: 'google.com',
                visits: 518000,
                newVisitors: '10%',
                albumPageVisited: '6000',
              },
            ],
          },
        ],
      },
      */
      {
        parent: 'topCreators',
        colTabs: null,
        dataTables: [{
          title: 'Top Creators',
          headers: [{
            text: 'Creator',
            align: 'left',
            sortable: false,
            value: 'name'
          }, {
            text: 'Plays',
            align: 'left',
            sortable: false,
            value: 'plays'
          }, {
            text: 'Earnings',
            align: 'left',
            sortable: false,
            value: 'earnings'
          }],
          data: [{
            name: 'Hudson Mohawke',
            plays: '234 plays',
            earnings: '$0.50',
            avatar: '../../../static/images/artist.png'
          }]
        }]
      }],
      totalTrackList: [{ id: 1, title: "PLAYS", content: "1,110" }, { id: 2, title: "TOTAL REVENUE", content: "$51,420.00" }, { id: 3, title: "YOUR SALES REVENUE", content: "$4,222" }, { id: 4, title: "COLLABORATOR REVENUE", content: "$1,000" }]
    };
  },


  computed: {
    onMobile: function onMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    currentUser: function currentUser() {
      return this.$store.state.auth.user;
    },
    showChartHeader: function showChartHeader() {
      return ['overview', 'products'];
    }
  },

  watch: {
    activeTab: function activeTab(val) {
      // find and select first index of breakdown on menu change
      var inner = this.innerTabs.find(function (inner) {
        return inner.parent === val;
      });
      console.log(inner);
      var action = inner.tabs[0];

      this.activeInnerTab = action.id;
      if (action.breakdown) {
        this.selectedChart = action.breakdown[0] || null;
        this.activeChart = action.breakdown[0].value;
      } else {
        this.selectedChart = action.breakdown;
        this.activeChart = 'all';
      }
      this.setChartDetails(action);
    }
  },

  methods: {
    isActiveTab: function isActiveTab(tab) {
      return this.activeTab === tab;
    },
    isActiveInnerTab: function isActiveInnerTab(tab) {
      return this.activeInnerTab === tab;
    },
    isActiveChart: function isActiveChart(tab) {
      return this.activeChart === tab;
    },
    setTopMenu: function setTopMenu(filter) {
      var selected = this.tabs.find(function (f) {
        return f.id === filter;
      });
      this.activeTab = selected.id;
    },
    getInnerTab: function getInnerTab() {
      var _this = this;

      var inner = this.innerTabs.find(function (inner) {
        return inner.parent === _this.activeTab;
      });
      return inner.tabs;
    },
    getStatsList: function getStatsList() {
      var _this2 = this;

      var inner = this.innerTabs.find(function (inner) {
        return inner.parent === _this2.activeTab;
      });
      return inner.statsList;
    },
    setActiveChart: function setActiveChart(tab) {
      this.selectedChart = tab;
      if (tab == null) return;
      this.activeChart = tab.value;
    },
    setChartDetails: function setChartDetails(action) {
      if (action) {
        this.activeInnerTab = action.id;
        this.selectedInnerTab = action;

        // For Menus that do not have further inner tab selection
        if (this.showChartHeader.indexOf(this.activeTab) < 0) {
          // Just select first item in breakdown series
          if (action.breakdown) {
            this.setActiveChart(action.breakdown[0]);
          } else {
            this.setActiveChart(action.breakdown);
          }
        }
      }
    },
    getSummaryTabs: function getSummaryTabs() {
      var tab = this.activeTab;
      var col = this.summaryTabs.find(function (col) {
        return col.parent === tab;
      });

      return col.colTabs || null;
    },
    getDataTables: function getDataTables() {
      var tab = this.activeTab;
      var col = this.summaryTabs.find(function (col) {
        return col.parent === tab;
      });

      return col.dataTables || null;
    }
  },

  created: function created() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var innerTab, initSelection;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              innerTab = _this3.getInnerTab();
              initSelection = innerTab.find(function (f) {
                return f.id === _this3.activeInnerTab;
              });

              _this3.setChartDetails(initSelection);

              // this.selectedChart = this.selectedInnerTab.breakdown[0]
              // this.activeChart = this.selectedInnerTab.breakdown[0].value

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this3);
    }))();
  },
  mounted: function mounted() {
    if (this.currentUser.plan !== "pro") {
      this.tabs = [];
    }
    window.dispatchEvent(new Event('resize'));

    setTimeout(function () {
      $(".nav-z-index").removeClass("white");
    }, 0);
  }
});

/***/ }),
/* 1084 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_auth__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_user__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_paymentmodal__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_paymentmodal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_paymentmodal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_accordion__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_accordion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_accordion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(6);







/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    propMode: {
      type: Boolean,
      default: false
    }
  },
  components: {
    paymentModal: __WEBPACK_IMPORTED_MODULE_2__components_paymentmodal___default.a,
    accordion: __WEBPACK_IMPORTED_MODULE_3__components_accordion___default.a
  },

  data: function data() {
    return {
      prices: [100, 500, 1000, 2000, 5000, 10000, 25000, 50000, 100000, 250000, 500000, 1000000, 2500000, 5000000, 10000000, 25000000, 50000000, 100000000],
      repost_price: 100,
      proration: {
        add_amount: 0,
        expire_at: null
      },
      show_repost_price_confirm_modal: false,
      show_payment_modal: false,
      isPageReady: false,
      accordions: [{
        title: 'What is a repost request?',
        content: 'Verified artists & brands can pay you to share their albums, videos & products to your followers.  Artists and brands will send you a Direct Message and tap the Repost Request button to attach their content for you to share'
      }, {
        title: 'What if I don’t accept a request?',
        content: 'Accepted requests will stay on your feed for 7 days and you will receive payment in 2 days.  If you don’t respond to a request in 3 days it’s automatically cancelled and the sender is never charged.'
      }, {
        title: 'How do I start accepting Repost Requests?',
        content: 'You must have a monthly subscription that will remove audio & video ads and allow you to get paid to share.'
      }, {
        title: 'What is the difference between Plus & Pro?',
        content: 'You can charge up to 5k per repost with the <b>Plus</b> subscription plan, or up to 100k per repost for a <b>Pro</b> subscription plan. '
      }],
      plans: [{
        title: 'Basic',
        price: '9.99',
        benefits: ['1 account', 'Ad-free music &  video'],
        value: 'basic'
      }, {
        title: 'Plus',
        price: '19.99',
        benefits: ['1 account', 'Ad-free music &  video', 'Stats + Analytics', 'Make money sharing content. You can charge up to $5K per repost.'],
        value: 'plus'
      }, {
        title: 'Pro',
        price: '19.99',
        benefits: ['1 account', 'Ad-free music &  video', 'Stats + Analytics', 'Make money sharing content. You can charge up to $100k per repost.'],
        value: 'pro'
      }]
    };
  },


  computed: {
    stripeLink: function stripeLink() {
      return 'https://connect.stripe.com/oauth/authorize?response_type=code&client_id=' + "ca_CC74CVRdkHTZqAIPQVJS04XoPwiVB1Kx" + '&scope=read_write&state=' + this.$store.state.auth.secret_code;
    },
    currentUser: function currentUser() {
      console.log(this.$store.state.auth.user);
      return this.$store.state.auth.user;
    },
    repost_prices: function repost_prices() {
      var arr = [];
      for (var i in this.prices) {
        arr.push({
          name: '$' + this.prices[i] / 100 + (this.prices[i] > this.currentUser.max_repost_price ? ' Upgrade' : ''),
          value: this.prices[i]
        });
      }
      return arr;
    }
  },

  created: function created() {
    this.resetRepostPrice();
  },


  methods: {
    resetRepostPrice: function resetRepostPrice() {
      this.repost_price = this.currentUser.repost_price;
    },
    openRepostPriceConfirmModal: function openRepostPriceConfirmModal() {
      var _this = this;

      if (this.repost_price == this.currentUser.repost_price) {
        return;
      }

      var params = {
        new_repost_price: this.repost_price
      };
      this.$store.dispatch('error/showLoadingActivity', true);
      __WEBPACK_IMPORTED_MODULE_1__services_user__["a" /* default */].getRepostPriceProration(this.currentUser.id, params).then(function (response) {
        _this.$store.dispatch('error/showLoadingActivity', false);
        _this.proration = response.body;
        // console.log(this.proration)
        if (_this.proration.add_amount > 0) {
          _this.show_repost_price_confirm_modal = true;
        } else {
          _this.setRepostPrice(null);
        }
      }).catch(function (e) {
        _this.$store.dispatch('error/showLoadingActivity', false);
      });
    },
    closeRepostPriceConfirmModal: function closeRepostPriceConfirmModal() {
      this.show_repost_price_confirm_modal = false;
    },
    openPaymentModal: function openPaymentModal() {
      this.closeRepostPriceConfirmModal();
      if (this.proration.add_amount > 0) {
        this.show_payment_modal = true;
      } else {
        this.setRepostPrice(null);
      }
    },
    closePaymentModal: function closePaymentModal() {
      this.show_payment_modal = false;
    },
    setRepostPrice: function setRepostPrice(token) {
      var _this2 = this;

      var params = {
        repost_price: this.repost_price,
        payment_amount: this.proration.add_amount
        // console.log('setRepostPrice', params)
      };if (token) {
        params['payment_token'] = token.id;
      }
      this.$store.dispatch('error/showLoadingActivity', true);
      __WEBPACK_IMPORTED_MODULE_1__services_user__["a" /* default */].setRepostPrice(this.currentUser.id, params).then(function (response) {
        _this2.$store.dispatch('error/showLoadingActivity', false);
        _this2.$store.dispatch('error/showSuccessToast', ['Saved']);
        __WEBPACK_IMPORTED_MODULE_0__services_auth__["a" /* default */].setUser(response.body);
      }).catch(function (e) {
        _this2.$store.dispatch('error/showLoadingActivity', false);
        _this2.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    learnMore: function learnMore() {
      this.$router.push({
        path: '/terms'
      });
    }
  }
});

/***/ }),
/* 1085 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_attendee_js__ = __webpack_require__(411);


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},

  data: function data() {
    return {
      account_types: [{ id: 'artist', name: 'Artist' }, { id: 'brand', name: 'Brand' }, { id: 'label', name: 'Label' }],
      attendee: {
        full_name: '',
        display_name: '',
        email: '',
        account_type: '',
        referred_by: ''
      },
      show_attendee_confirm_dialog: false
    };
  },
  created: function created() {
    this.$store.dispatch('navigator/goNextState', { page: '', tab: '' });
  },


  methods: {
    submit: function submit() {
      var _this = this;

      this.$validator.validateAll().then(function (response) {
        if (response === true) {
          var params = {
            attendee: _this.attendee
          };
          _this.$store.dispatch('error/showLoadingActivity', true);
          __WEBPACK_IMPORTED_MODULE_0__services_attendee_js__["a" /* default */].createAttendee(params).then(function (response) {
            _this.$store.dispatch('error/showLoadingActivity', false);
            // this.$store.dispatch('error/showSuccessToast', ['You reserved your account'])
            _this.show_attendee_confirm_dialog = true;
          }).catch(function (e) {
            _this.$store.dispatch('error/showLoadingActivity', false);
            _this.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
          });
        } else {
          _this.$store.dispatch('error/showErrorToast', [_this.errors.items[0].msg]);
        }
      });
    }
  }
});

/***/ }),
/* 1086 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_auth__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_album__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_label__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_user__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_selectusermodal__ = __webpack_require__(786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_selectusermodal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_selectusermodal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_user__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_user___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_user__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_album__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_album___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_album__);












/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    selectUserModal: __WEBPACK_IMPORTED_MODULE_6__components_selectusermodal___default.a,
    labelUserItem: __WEBPACK_IMPORTED_MODULE_7__components_user___default.a,
    labelAlbumItem: __WEBPACK_IMPORTED_MODULE_8__components_album___default.a
  },

  data: function data() {
    return {
      navigatorState: {
        page: '',
        tab: ''
      },
      artist_tabs: [{ id: 'approved_labels', title: 'Labels' }, { id: 'approved_albums', title: 'Approved Albums' }, { id: 'pending_labels', title: 'Pending Labels' }, { id: 'pending_albums', title: 'Pending Albums' }],
      label_tabs: [{ id: 'approved_labels', title: 'Roster' }, { id: 'approved_albums', title: 'Albums' }, { id: 'pending_labels', title: 'Pending Artists' }, { id: 'pending_albums', title: 'Pending Albums' }],
      labels: [],
      albums: [],
      user: {},
      album: {},
      label_delete_confirm_dialog: false,
      album_delete_confirm_dialog: false,
      album_status_confirm_dialog: false,
      roster_delete_confirm_dialog: false,
      show_select_user_modal: false,
      show_help_dialog: false,
      isPageReady: false
    };
  },


  computed: {
    // currentTab: {
    //   get: function() {
    //     // return this.$store.state.navigator.current.tab
    //     return this.navigatorState.tab
    //   },
    //   set: function (newValue) {
    //   }
    // },

    currentUser: function currentUser() {
      return this.$store.state.auth.user;
    },
    approved_labels: function approved_labels() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(this.labels, function (item) {
        return item.status === 'accepted';
      });
    },
    not_approved_labels: function not_approved_labels() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(this.labels, function (item) {
        return item.status !== 'accepted';
      });
    },
    pending_labels: function pending_labels() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(this.labels, function (item) {
        return item.status === 'pending';
      });
    },
    approved_albums: function approved_albums() {
      console.log('approved_albums', __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(this.albums, function (item) {
        return item.status === 'accepted';
      }));
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(this.albums, function (item) {
        return item.status === 'accepted';
      });
    },
    not_approved_albums: function not_approved_albums() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(this.albums, function (item) {
        return item.status !== 'accepted';
      });
    },
    pending_albums: function pending_albums() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(this.albums, function (item) {
        return item.status === 'pending';
      });
    },
    status_dialog_title: function status_dialog_title() {
      if (this.album.status === 'published') {
        return 'Make Private an Album';
      } else if (this.album.status !== 'published') {
        return 'Make Public an Album';
      }
      return '';
    },
    status_dialog_text: function status_dialog_text() {
      if (this.album.status === 'published') {
        return 'If you click OK, the album will be private. Click OK to make private <' + this.album.name + '>, or click Cancel.';
      } else if (this.album.status !== 'published') {
        return 'If you click OK, the album will be published. Click OK to publish <' + this.album.name + '>, or click Cancel.';
      }
      return '';
    }
  },

  created: function created() {
    if (!this.currentUser) {
      __WEBPACK_IMPORTED_MODULE_2__services_auth__["a" /* default */].clearTokenAndUserInfo();
      this.$router.push({ path: '/login' });
      return;
    }

    if (this.currentUser.data['label_page_visited'] !== 1) {
      this.openHelpDialog();
    }

    this.navigatorState.page = 'label';
    if (this.$store.state.auth.user.user_type === 'artist') {
      this.loadData();
      this.navigatorState.tab = 'approved_labels';
    } else if (this.$store.state.auth.user.user_type === 'label') {
      this.loadData();
      this.navigatorState.tab = 'approved_labels';
    } else {
      this.$router.push({ path: '/' });
    }
    // console.log('calling navigator/setCurrentState', this.navigatorState)
    this.$store.dispatch('navigator/setCurrentState', __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(this.navigatorState));
  },


  methods: {
    isActiveTab: function isActiveTab(tab) {
      return this.navigatorState.tab == tab;
    },
    loadData: function loadData() {
      var _this = this;

      this.isPageReady = false;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_4__services_label__["a" /* default */].getLabelUsers(), __WEBPACK_IMPORTED_MODULE_4__services_label__["a" /* default */].getLabelAlbums()]).then(function (values) {
        _this.labels = values[0].body;
        _this.albums = values[1].body;
        _this.isPageReady = true;
      }).catch(function (reason) {
        console.log(reason);
        _this.$store.dispatch('error/showLoadingActivity', false);
        _this.$store.dispatch('error/showErrorToast', reason);
      });
    },
    openHelpDialog: function openHelpDialog() {
      this.show_help_dialog = true;
    },
    closeHelpDialog: function closeHelpDialog() {
      var _this2 = this;

      this.show_help_dialog = false;
      var params = {
        user: {
          label_page_visited: 1
        }
      };
      __WEBPACK_IMPORTED_MODULE_5__services_user__["a" /* default */].updateUserInfo(this.currentUser.id, params).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_2__services_auth__["a" /* default */].setUser(response.body);
        _this2.$store.dispatch('auth/setUser', response.body);
      });
    },
    onTab: function onTab(tab) {
      this.navigatorState.tab = tab;
      this.$store.dispatch('navigator/setCurrentState', __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(this.navigatorState));
    },
    acceptLabelUserRequest: function acceptLabelUserRequest(host) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_5__services_user__["a" /* default */].acceptLabelRequest(host.id).then(function (response) {
        _this3.loadData();
        _this3.navigatorState.tab = 'approved_labels';
        _this3.$store.dispatch('navigator/goNextState', __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(_this3.navigatorState));
      });
    },
    denyLabelUserRequest: function denyLabelUserRequest(host) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_5__services_user__["a" /* default */].denyLabelRequest(host.id).then(function (response) {
        _this4.loadData();
        _this4.navigatorState.tab = 'approved_labels';
        _this4.$store.dispatch('navigator/goNextState', __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(_this4.navigatorState));
      });
    },
    acceptLabelAlbumRequest: function acceptLabelAlbumRequest(album, label) {
      var _this5 = this;

      var params = {
        label_id: label.id
      };
      __WEBPACK_IMPORTED_MODULE_3__services_album__["a" /* default */].acceptLabelRequest(album.id, params).then(function (response) {
        _this5.loadData();
        _this5.navigatorState.tab = 'approved_albums';
        _this5.$store.dispatch('navigator/goNextState', __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(_this5.navigatorState));
      });
    },
    denyLabelAlbumRequest: function denyLabelAlbumRequest(album, label) {
      var _this6 = this;

      var params = {
        label_id: label.id
      };
      __WEBPACK_IMPORTED_MODULE_3__services_album__["a" /* default */].denyLabelRequest(album.id, params).then(function (response) {
        _this6.loadData();
        _this6.navigatorState.tab = 'approved_albums';
        _this6.$store.dispatch('navigator/goNextState', __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(_this6.navigatorState));
      });
    },
    showSelectUserDialog: function showSelectUserDialog() {
      this.show_select_user_modal = true;
    },
    hideSelectUserDialog: function hideSelectUserDialog() {
      this.show_select_user_modal = false;
    },
    sendRequestToAdd: function sendRequestToAdd(artist) {
      var _this7 = this;

      __WEBPACK_IMPORTED_MODULE_5__services_user__["a" /* default */].sendLabelRequest(artist.id).then(function (res) {
        // this.$router.push(`/album/${album.slug}/edit`)
        // this.$store.dispatch('navigator/setCurrentState', _.cloneDeep(this.navigatorState))
        _this7.loadData();
        _this7.navigatorState.tab = 'pending_labels';
        _this7.$store.dispatch('navigator/goNextState', __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(_this7.navigatorState));
      }).catch(function (e) {
        if (e.body.errors) {
          _this7.$store.dispatch('error/showErrorToast', e.body.errors);
        } else {
          _this7.$store.dispatch('error/showErrorToast', [e.body]);
        }
      });
    },
    showLabelDeleteConfirmDialog: function showLabelDeleteConfirmDialog(user) {
      this.user = user;
      this.label_delete_confirm_dialog = true;
    },
    hideLabelDeleteConfirmDialog: function hideLabelDeleteConfirmDialog() {
      this.user = {};
      this.label_delete_confirm_dialog = false;
    },
    removeLabel: function removeLabel() {
      var _this8 = this;

      __WEBPACK_IMPORTED_MODULE_5__services_user__["a" /* default */].removeLabel(this.user.id).then(function (response) {
        _this8.loadData();
        _this8.hideLabelDeleteConfirmDialog();
      }).catch(function (e) {
        _this8.hideLabelDeleteConfirmDialog();
        if (e.body.errors) {
          _this8.$store.dispatch('error/showErrorToast', e.body.errors);
        } else {
          _this8.$store.dispatch('error/showErrorToast', [e.body]);
        }
      });
    },
    showRosterDeleteConfirmDialog: function showRosterDeleteConfirmDialog(user) {
      this.user = user;
      this.roster_delete_confirm_dialog = true;
    },
    hideRosterDeleteConfirmDialog: function hideRosterDeleteConfirmDialog() {
      this.user = {};
      this.roster_delete_confirm_dialog = false;
    },
    removeRoster: function removeRoster() {
      var _this9 = this;

      __WEBPACK_IMPORTED_MODULE_5__services_user__["a" /* default */].removeLabel(this.user.id).then(function (response) {
        _this9.loadData();
        _this9.hideRosterDeleteConfirmDialog();
      }).catch(function (e) {
        _this9.hideRosterDeleteConfirmDialog();
        if (e.body.errors) {
          _this9.$store.dispatch('error/showErrorToast', e.body.errors);
        } else {
          _this9.$store.dispatch('error/showErrorToast', [e.body]);
        }
      });
    },
    showAlbumDeleteConfirmDialog: function showAlbumDeleteConfirmDialog(album, user) {
      this.album = album;
      if (user) this.user = user;
      this.album_delete_confirm_dialog = true;
    },
    hideAlbumDeleteConfirmDialog: function hideAlbumDeleteConfirmDialog() {
      this.album = {};
      this.album_delete_confirm_dialog = false;
    },
    removeAlbum: function removeAlbum() {
      var _this10 = this;

      var label_id = '';
      if (this.$store.state.auth.user.user_type == 'label') {
        label_id = this.$store.state.auth.user.id;
      } else {
        label_id = this.user.id;
      }
      // console.log('removeAlbum', label_id, this.album)

      var params = {
        label_id: label_id
      };
      __WEBPACK_IMPORTED_MODULE_3__services_album__["a" /* default */].removeLabel(this.album.id, params).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.remove(_this10.albums, function (item) {
          return item.album_id == _this10.album.id && item.user_id == label_id;
        });
        var arr = _this10.albums.slice();
        _this10.albums = arr;
        _this10.hideAlbumDeleteConfirmDialog();
      }).catch(function (e) {
        _this10.hideAlbumDeleteConfirmDialog();
        if (e.body.errors) {
          _this10.$store.dispatch('error/showErrorToast', e.body.errors);
        } else {
          _this10.$store.dispatch('error/showErrorToast', [e.body]);
        }
      });
    },


    // editAlbum (album) {
    //   // console.log('editAlbum', album)
    //   this.$router.push(`/album/${album.slug}/edit`)
    // },

    showAlbumStatusConfirmDialog: function showAlbumStatusConfirmDialog(album) {
      this.album = album;
      this.album_status_confirm_dialog = true;
    },
    hideAlbumStatusConfirmDialog: function hideAlbumStatusConfirmDialog() {
      this.album = {};
      this.album_status_confirm_dialog = false;
    },
    updateAlbumStatus: function updateAlbumStatus() {
      var _this11 = this;

      // console.log('makePrivateAlbum', this.album)
      if (this.album.status === 'published') {
        __WEBPACK_IMPORTED_MODULE_3__services_album__["a" /* default */].makePrivateAlbum(this.album.id).then(function (response) {
          _this11.album.status = 'privated';
          _this11.hideAlbumStatusConfirmDialog();
        }).catch(function (e) {
          _this11.hideAlbumStatusConfirmDialog();
          if (e.body.errors) {
            _this11.$store.dispatch('error/showErrorToast', e.body.errors);
          } else {
            _this11.$store.dispatch('error/showErrorToast', [e.body]);
          }
        });
      } else if (this.album.status !== 'published') {
        __WEBPACK_IMPORTED_MODULE_3__services_album__["a" /* default */].makePublicAlbum(this.album.id).then(function (response) {
          _this11.album.status = 'published';
          _this11.hideAlbumStatusConfirmDialog();
        }).catch(function (e) {
          _this11.hideAlbumStatusConfirmDialog();
          if (e.body.errors) {
            _this11.$store.dispatch('error/showErrorToast', e.body.errors);
          } else {
            _this11.$store.dispatch('error/showErrorToast', [e.body]);
          }
        });
      }
    }
  },

  mounted: function mounted() {}
});

/***/ }),
/* 1087 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_on_click_outside__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_on_click_outside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_on_click_outside__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_album__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_auth__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_message__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_user__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_product__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_profileitem__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_profileitem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_profileitem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_emoji_mart_vue__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_emoji_mart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_emoji_mart_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_repost_payment_modal__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_repost_payment_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_repost_payment_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_sendlovemodal__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_sendlovemodal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_sendlovemodal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_SMS__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_SMS___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_SMS__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_message__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_message__);


/* global $:true */


















var ActionCable = __webpack_require__(52);
var DefaultRepostMessage = 'Hi, if you like this please repost it, thank you.';

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    profileItem: __WEBPACK_IMPORTED_MODULE_10__components_profileitem___default.a,
    Picker: __WEBPACK_IMPORTED_MODULE_11_emoji_mart_vue__["Picker"],
    message: __WEBPACK_IMPORTED_MODULE_15__components_message___default.a,
    repostPaymentModal: __WEBPACK_IMPORTED_MODULE_12__components_repost_payment_modal___default.a,
    SendLoveModal: __WEBPACK_IMPORTED_MODULE_13__components_sendlovemodal___default.a,
    SMS: __WEBPACK_IMPORTED_MODULE_14__components_SMS___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_3_vue_on_click_outside__["mixin"]],

  data: function data() {
    return {
      tab: 'album',
      item: null,
      show_stopPopup: false,
      show_conversation_delete_confirm_dialog: false,
      show_block_user_confirm_dialog: false,
      show_repost_payment_modal: false,
      show_repost_modal: false,
      show_send_love_modal: false,
      showEmojiPicker: false,
      page_index: 0,
      total_pages: 1,
      items_per_page: 5 * 5,
      conversations: [],
      conversation: {},
      conversation_pagination: {
        count: 0,
        current_page: 0,
        per_page: 50,
        total_count: 0,
        total_pages: 0
      },
      messages: [],
      message: {
        body: ''
      },
      message_pagination: {
        count: 0,
        current_page: 0,
        per_page: 50,
        total_count: 0,
        total_pages: 0
      },
      timer: null,
      cable: null,
      message_subscription: null,
      albums: [],
      products: [],
      itemType: {
        album: 'Album',
        merch: 'ShopProduct'
      },
      repostedFeeds: [],
      isPageReady: false,
      smsActive: false,
      repostRequestActive: false,
      isSubscribed: false,
      darkMode: false
    };
  },


  computed: {
    currentUser: function currentUser() {
      return this.$store.state.auth.user;
    },
    otherName: function otherName() {
      return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.conversation, 'other.display_name', '');
    },
    otherStripeConnected: function otherStripeConnected() {
      return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.conversation, 'other.stripe_connected', false);
    },
    toLocalTimeString: function toLocalTimeString() {
      return __WEBPACK_IMPORTED_MODULE_4__helper__["f" /* Utils */].toLocalTimeString;
    },
    toLocalDateString: function toLocalDateString() {
      return __WEBPACK_IMPORTED_MODULE_4__helper__["f" /* Utils */].toLocalDateString;
    },
    current_repost_price: function current_repost_price() {
      return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.conversation, 'other.repost_price', 0);
    }
  },

  created: function created() {
    if (!this.currentUser) {
      __WEBPACK_IMPORTED_MODULE_6__services_auth__["a" /* default */].clearTokenAndUserInfo();
      this.$router.push({ path: '/login' });
      return;
    }

    this.$store.dispatch('navigator/goNextState', { page: 'messages', tab: '' });

    // if (this.currentUser.data['message_page_visited'] !== 1) {
    //   this.show_stopPopup = true
    // }

    if (['brand'].indexOf(this.currentUser.user_type) !== -1) {
      this.tab = 'merch';
    }
    this.loadConversations();
    this.loadAlbums();
    this.loadProducts();

    var vm = this;
    // this.timer = setInterval(function(){ vm.refreshMessages() }, 10000)

    this.cable = ActionCable.createConsumer("wss://api.yousound.com/cable" + '?token=' + this.$store.state.auth.token);
    this.message_subscription = this.cable.subscriptions.create({
      channel: 'MessagesChannel'
    }, {
      connected: function connected() {
        console.log('connected to MessagesChannel');
      },
      received: function received(data) {
        console.log('message_subscription');
        var other_id = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(vm.conversation, 'other.id', '');
        // console.log(data, data.sender.id, other_id)
        if (data.sender.id === other_id || data.sender.id === vm.currentUser.id) {
          var messageIndex = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.findIndex(vm.messages, function (message) {
            return message.id === data.id;
          });
          if (messageIndex === -1) {
            vm.messages.push(data);
          } else {
            vm.messages[messageIndex] = data;
            // console.log(messageIndex, vm.conversation.messages[messageIndex])
          }
          var arr = vm.messages.slice();
          vm.messages = arr;
          vm.$nextTick(function () {
            $('.message-list-section').scrollTop($('.message-list-section').prop('scrollHeight'));
          });
        }
      },
      disconnected: function disconnected() {
        console.log('disconnected to MessagesChannel :(');
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }

    if (this.message_subscription) {
      this.message_subscription.unsubscribe();
    }
  },


  methods: {
    fetchSubscriptionDetails: function fetchSubscriptionDetails() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_8__services_user__["a" /* default */].getSubscriptionDetail(_this.currentUser.id).then(function (response) {
                  if (response.bodyText === "Subscribed") {
                    _this.isSubscribed = true;
                  } else {
                    _this.isSubscribed = false;
                  }
                }).catch(function (e) {
                  _this.isSubscribe = false;
                });

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    loadConversations: function loadConversations(loadMore) {
      var _this2 = this;

      this.$store.dispatch('error/showLoadingActivity', true);
      var params = void 0;
      if (loadMore) {
        params = {
          page: this.conversation_pagination.current_page + 1,
          per_page: this.conversation_pagination.per_page
        };
      } else {
        params = {
          page: 1,
          per_page: this.conversation_pagination.per_page
        };
        this.messages = [];
      }
      __WEBPACK_IMPORTED_MODULE_7__services_message__["a" /* default */].getConversations(params).then(function (response) {
        _this2.$store.dispatch('error/showLoadingActivity', false);
        _this2.conversations = response.body.conversations;
        if (_this2.conversations.length) {
          _this2.conversation = _this2.conversations[0];

          __WEBPACK_IMPORTED_MODULE_8__services_user__["a" /* default */].repostedFeeds(_this2.conversation.other.id).then(function (response) {
            _this2.repostedFeeds = response.body;
            // console.log('repostedFeeds', this.repostedFeeds)
            // this.$forceUpdate()
          });

          _this2.loadMessages(_this2.conversation.id, false, true);
        }
      }).catch(function (e) {
        _this2.$store.dispatch('error/showLoadingActivity', false);
        _this2.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    loadMessages: function loadMessages(id, loadMore, scrollMove) {
      var _this3 = this;

      if (scrollMove) {
        this.$store.dispatch('error/showLoadingActivity', true);
      }
      var params = {
        conversation_id: id
      };
      __WEBPACK_IMPORTED_MODULE_7__services_message__["a" /* default */].getMessages(params).then(function (response) {
        if (loadMore) {
          // this.messages = this.conversation.concat(response.body.messages)
          _this3.messages = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.reverse(response.body.messages).concat(_this3.messages);
        } else {
          // this.conversation = response.body
          _this3.messages = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.reverse(response.body.messages);

          if (scrollMove) {
            _this3.$nextTick(function () {
              // $(".message-list-section").animate({ scrollTop: $(".message-list-section").prop("scrollHeight")}, 1000);
              $('.message-list-section').scrollTop($('.message-list-section').prop('scrollHeight'));
            });
          }
        }
        // this.$forceUpdate()
        _this3.$store.dispatch('error/showLoadingActivity', false);
      }).catch(function (e) {
        // console.log(e)
        // this.$store.dispatch('error/showErrorToast', e.body.errors || [e.body])
        _this3.$store.dispatch('error/showLoadingActivity', false);
      });
    },
    refreshMessages: function refreshMessages() {
      if (this.conversation && this.conversation.id !== undefined) {
        this.loadMessages(this.conversation.id, false, false);
      }
    },
    openConversationDeleteConfirmDialog: function openConversationDeleteConfirmDialog() {
      this.show_conversation_delete_confirm_dialog = true;
    },
    closeConversationDeleteConfirmDialog: function closeConversationDeleteConfirmDialog() {
      this.show_conversation_delete_confirm_dialog = false;
    },
    deleteEntireMessage: function deleteEntireMessage() {
      var _this4 = this;

      // console.log('deleteEntireMessage', this.conversation)
      __WEBPACK_IMPORTED_MODULE_7__services_message__["a" /* default */].deleteConversation({
        conversation_id: this.conversation.id
      }).then(function (response) {
        _this4.closeConversationDeleteConfirmDialog();
        // _.remove(this.conversations, (c) => (c.id == conversation.id))
        _this4.loadConversations();
      }).catch(function (e) {
        _this4.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    openBlockUserConfirmDialog: function openBlockUserConfirmDialog() {
      this.show_block_user_confirm_dialog = true;
    },
    closeBlockUserConfirmDialog: function closeBlockUserConfirmDialog() {
      this.show_block_user_confirm_dialog = false;
    },
    blockUser: function blockUser() {
      var _this5 = this;

      var user = this.conversation.other;
      __WEBPACK_IMPORTED_MODULE_8__services_user__["a" /* default */].blockUser(user.id).then(function (response) {
        _this5.$store.dispatch('error/showSuccessToast', ['You blocked ' + user.display_name + ', go to settings page to unblock']);
        _this5.loadConversations();
      }).catch(function (e) {
        _this5.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
      this.closeBlockUserConfirmDialog();
    },
    addEmoji: function addEmoji(emoji, event) {
      // console.log('addEmoji')
      this.showEmojiPicker = false;
      this.message.body += emoji.native;
      // this.$refs.message.focus()
    },
    showEmojiDialog: function showEmojiDialog() {
      // console.log('showEmojiDialog')
      this.showEmojiPicker = !this.showEmojiPicker;
      // this.$refs.message.focus()
    },
    hideEmojiDialog: function hideEmojiDialog() {
      // console.log('hideEmojiDialog')
      this.showEmojiPicker = false;
    },
    blurMessage: function blurMessage() {
      var vm = this;
      if (vm.showEmojiPicker) {
        setTimeout(function () {
          // console.log('hide')
          vm.showEmojiPicker = false;
        }, 200);
      }
    },
    InBanned: function InBanned(album) {
      return false;
      // return this.InHiddenGenres(album) || this.InReposted(album)
    },


    // true : in hidden genres
    InHiddenGenres: function InHiddenGenres(album) {
      if (this.conversation.other) {
        var genreId = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(album.genres, '[0].id', '');
        var genre = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(this.conversation.other.hidden_genres, function (genre) {
          return genre.id === genreId;
        });
        // return !(genre === undefined || genre === null)
        return !!genre;
      } else {
        return false;
      }
    },
    InReposted: function InReposted(item) {
      return false;
      // const feed = _.find(this.repostedFeeds, (f) => {
      //   return (
      //     f.assoc_type === this.itemType[this.tab] && f.assoc_id === item.id
      //   )
      // })
      // return !!feed
    },
    checkMessage: function checkMessage() {
      if (this.item) {
        this.openRepostPaymentModal();
      } else if (!this.currentUser.creator_verified) {
        this.$router.push({ path: '/subscribe#plans' });
      } else {
        this.sendMessage();
      }
    },
    sendMessage: function sendMessage(token) {
      var _this6 = this;

      this.closeRepostPaymentModal();
      // this.hidePaymentDialog()
      // const message = this.message.body.replace(' ', '')
      // if (message.length > 0) {
      var params = {
        body: this.message.body
      };
      this.message.body = '';
      params['receiver_id'] = this.conversation.other.id;
      if (this.item) {
        if (this.tab === 'album') {
          params['attachable_type'] = 'Album';
          params['attachable_id'] = this.item.id;
        } else {
          params['attachable_type'] = 'ShopProduct';
          params['attachable_id'] = this.item.id;
        }
        this.item = null;
      }
      if (token) {
        params['payment_token'] = token.id;
      }
      __WEBPACK_IMPORTED_MODULE_7__services_message__["a" /* default */].addMessage(params).then(function (response) {
        // this.loadMessages(this.conversation.id, false, true)
      }).catch(function (e) {
        _this6.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    selectedConversation: function selectedConversation(conv) {
      if (this.conversation.id === conv.id) {
        return;
      }

      this.item = null;
      this.conversation = conv;
      this.conversation.last_message.is_read = true;
      this.loadMessages(this.conversation.id, false, true);
    },
    setVisitedTime: function setVisitedTime() {
      var _this7 = this;

      this.show_stopPopup = false;
      if (this.$refs.message) this.$refs.message.focus();
      var params = {
        user: {
          message_page_visited: 1
        }
      };
      __WEBPACK_IMPORTED_MODULE_8__services_user__["a" /* default */].updateUserInfo(this.currentUser.id, params).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_6__services_auth__["a" /* default */].setUser(response.body);
        _this7.$store.dispatch('auth/setUser', response.body);
      }).catch(function (e) {
        console.log(e);
      });
    },
    loadAlbums: function loadAlbums() {
      var _this8 = this;

      var params = {
        statuses: 'published, collaborated',
        user_statuses: 'accepted'
      };
      __WEBPACK_IMPORTED_MODULE_5__services_album__["a" /* default */].getAlbums(params).then(function (response) {
        _this8.albums = response.body;
      }).catch(function (e) {
        _this8.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    loadProducts: function loadProducts() {
      var _this9 = this;

      var params = {
        statuses: 'published, collaborated',
        stock_statuses: 'active',
        user_statuses: 'accepted'
      };
      __WEBPACK_IMPORTED_MODULE_9__services_product__["a" /* default */].getProducts(params).then(function (response) {
        _this9.products = response.body;
      }).catch(function (e) {
        _this9.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    onTab: function onTab(tab) {
      this.tab = tab;
      this.item = null;
    },
    openRepostPaymentModal: function openRepostPaymentModal() {
      this.show_repost_payment_modal = true;
    },
    closeRepostPaymentModal: function closeRepostPaymentModal() {
      this.show_repost_payment_modal = false;
    },
    openRepostModal: function openRepostModal() {
      this.show_repost_modal = true;
    },
    closeRepostModal: function closeRepostModal() {
      this.show_repost_modal = false;
    },
    openSendLoveModal: function openSendLoveModal() {
      this.show_send_love_modal = true;
    },
    closeSendLoveModal: function closeSendLoveModal() {
      this.show_send_love_modal = false;
    },
    selectItem: function selectItem(item) {
      // console.log(this.item === item, this.item, item)
      if (this.item === item) {
        this.item = null;
        if (this.message.body === DefaultRepostMessage) {
          this.message.body = '';
        }
      } else {
        this.item = item;
        if (this.message.body === '') {
          this.message.body = DefaultRepostMessage;
        }
      }
    },
    initSMS: function initSMS() {
      if (!this.currentUser.creator_verified) {
        this.$router.push({ path: '/subscribe#plans' });
      } else {
        this.smsActive = true;
      }
    },
    closeSMS: function closeSMS() {
      this.smsActive = false;
    },
    modeToggle: function modeToggle() {
      var app_container = $(this.$parent.$parent.$el);
      if (this.darkMode) {
        this.darkMode = false;
        app_container.removeClass('bg-grey');
        app_container.removeClass('dark-mode');
        app_container.find('.app-container').removeClass('dark-mode');
        app_container.addClass('bg-light');
        app_container.find('.app-container').addClass('px-0');
        app_container.find('.app-container').addClass('py-0');
      } else {
        this.darkMode = true;
        app_container.removeClass('bg-light');
        app_container.addClass('bg-grey');
        app_container.addClass('dark-mode');
        app_container.find('.app-container').addClass('dark-mode');
        app_container.find('.app-container').addClass('px-0');
        app_container.find('.app-container').addClass('py-0');
      }
    },
    datetimePeriodFormat: function datetimePeriodFormat(date) {
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? '0' + minutes : minutes;
      var strTime = hours + ':' + minutes + ' ' + ampm;
      return strTime;
    }
  },

  mounted: function mounted() {
    this.modeToggle();
    this.fetchSubscriptionDetails();
    this.isPageReady = true;
  }
});

/***/ }),
/* 1088 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stager__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__stager__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Stager: __WEBPACK_IMPORTED_MODULE_2__stager___default.a
  },
  data: function data() {
    return {
      current: 0, // start ftom 0, vuetify uses index of 0
      test: "",
      xUp: null,
      yUp: null,
      xDown: null,
      yDown: null,
      touchstartX: null,
      touchstartY: null,
      touchendX: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    stages: "app/activationStages",
    isAuthenticated: "auth/isAuthenticated"
  }), {
    endLeft: function endLeft() {
      return this.current === 0;
    },
    endRight: function endRight() {
      return this.current === this.stages.length - 1;
    },
    stageSwipe: function stageSwipe() {
      return this.$refs.stageSwipe;
    },
    onMobile: function onMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    }
  }),
  watch: {
    current: {
      handler: function handler(newVal, oldVal) {
        if (!oldVal || newVal > oldVal) {
          return this.nextStage(newVal + 1);
        } else if (oldVal > newVal) {
          return this.prevStage(oldVal);
        }
      },

      immediate: true
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])({
    nextStage: "app/nextActivationStage",
    prevStage: "app/prevActivationStage"
  }), {
    updateCurrent: function updateCurrent(val) {
      console.log(val);
      this.current = val;
    },
    touchEnd: function touchEnd(evt) {
      var touchstartX = evt.changedTouches[0].screenY;
      var touchendX = this.touchendX;

      if (touchendX < touchstartX) {
        console.log('Swiped Left');
        if (this.endRight) {
          evt.stopPropagation();
        }
      }

      if (touchendX > touchstartX) {
        console.log('Swiped Right');
        if (this.endLeft) {
          evt.stopPropagation();
        }
      }

      // if (touchendY < touchstartY) {
      //     console.log('Swiped Up');
      // }

      // if (touchendY > touchstartY) {
      //     console.log('Swiped Down');
      // }

      // if (touchendY === touchstartY) {
      //     console.log('Tap');
      // }

      this.touchendX = null;
    },
    touchStart: function touchStart(evt) {
      this.touchendX = evt.changedTouches[0].screenY;
    }
  }),
  created: function created() {
    if (this.isAuthenticated || !this.onMobile) {
      this.$router.push({ name: "Dashboard" });
    }
  }
});

/***/ }),
/* 1089 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stager__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__stager__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chooseAccount__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chooseAccount___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__chooseAccount__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__accountType__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__accountType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__accountType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__profileImage__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__profileImage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__profileImage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__accountInfo__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__accountInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__accountInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ageLocation__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ageLocation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ageLocation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__getVerified__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__getVerified___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__getVerified__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__checkEmail__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__checkEmail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__checkEmail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__confirmEmail__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__confirmEmail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__confirmEmail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__authPlan__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__authPlan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__authPlan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuex__ = __webpack_require__(6);













/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Stager: __WEBPACK_IMPORTED_MODULE_1__stager___default.a,
    ChooseAccount: __WEBPACK_IMPORTED_MODULE_2__chooseAccount___default.a,
    AccountType: __WEBPACK_IMPORTED_MODULE_3__accountType___default.a,
    ProfileImage: __WEBPACK_IMPORTED_MODULE_4__profileImage___default.a,
    AccountInfo: __WEBPACK_IMPORTED_MODULE_5__accountInfo___default.a,
    AgeLocation: __WEBPACK_IMPORTED_MODULE_6__ageLocation___default.a,
    GetVerified: __WEBPACK_IMPORTED_MODULE_7__getVerified___default.a,
    CheckEmail: __WEBPACK_IMPORTED_MODULE_8__checkEmail___default.a,
    ConfirmEmail: __WEBPACK_IMPORTED_MODULE_9__confirmEmail___default.a,
    AuthPlan: __WEBPACK_IMPORTED_MODULE_10__authPlan___default.a
  },
  data: function data() {
    return {
      userEmail: ""
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_vuex__["a" /* mapState */])({
    accountCategory: function accountCategory(state) {
      return state.app.onboarding.accountCategory;
    },
    current: function current(state) {
      return state.app.onboarding.current;
    }
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_vuex__["b" /* mapGetters */])({
    stages: "app/onboardingStages",
    currentStage: "app/onboardingCurrentStage",
    isAuthenticated: "auth/isAuthenticated"
  }), {
    onMobile: function onMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_vuex__["c" /* mapActions */])({
    gotoPrevStage: "app/prevOnboardingStage"
  }), {
    handlePrevStage: function handlePrevStage() {
      if (this.current !== 1) {
        this.gotoPrevStage(this.current - 1);
      } else {
        return this.$router.push("/");
      }
    }
  }),
  created: function created() {
    // if (this.isAuthenticated) {
    //   this.$router.push({name: "Dashboard"})
    // }
  }
});

/***/ }),
/* 1090 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_contentTopHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_contentTopHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_contentTopHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_activity__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_activity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_activity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_messages__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_messages___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_messages__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_getPaidToShare__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_getPaidToShare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_getPaidToShare__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_SMS_landing__ = __webpack_require__(776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_SMS_landing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_SMS_landing__);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    contentTopHeader: __WEBPACK_IMPORTED_MODULE_1__components_contentTopHeader___default.a,
    Activity: __WEBPACK_IMPORTED_MODULE_2__views_activity___default.a,
    Messages: __WEBPACK_IMPORTED_MODULE_3__views_messages___default.a,
    getPaidToShare: __WEBPACK_IMPORTED_MODULE_4__views_getPaidToShare___default.a,
    SMS: __WEBPACK_IMPORTED_MODULE_5__components_SMS_landing___default.a
  },
  data: function data() {
    return {
      activeTab: 'sms',
      tabs: [{ id: 'messages', title: 'Messages', badge: 0 }, { id: 'sms', title: 'SMS', badge: 0 }]
    };
  },

  computed: {
    badge: function badge() {
      return this.$store.state.activity.badge;
    },
    onMobile: function onMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    }
  },
  methods: {
    isActiveTab: function isActiveTab(tab) {
      return this.activeTab === tab;
    },
    setTab: function setTab(tab) {
      this.activeTab = tab;
    },
    processNotifications: function processNotifications() {
      var _this = this;

      this.tabs = this.tabs.map(function (tab) {
        var id = tab.id;

        switch (id) {
          case "activity":
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, tab, { badge: _this.badge.activity });
            break;
          case "messages":
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, tab, { badge: _this.badge.message });
            break;
          default:
            break;
        }
        return tab;
      });
    }
  },
  watch: {
    $route: function $route(toPath, fromPath) {
      // console.log(toPath)
      // console.log(fromPath)
      var tab = toPath.hash.substr(1) || 'messages';
      this.setTab(tab);
    }
  },

  created: function created() {
    this.$store.dispatch('navigator/goNextState', { page: 'notification', tab: '' });

    var tab = this.$route.hash.substr(1) || 'messages';
    this.setTab(tab);
    if (!this.onMobile) {
      this.tabs = this.tabs.filter(function (tab) {
        return tab.id !== 'sms';
      });
    }
    this.processNotifications();
  }
});

/***/ }),
/* 1091 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_team_tab__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_team_tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_team_tab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_product_tab__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_product_tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_product_tab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_timeline_tab__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_timeline_tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_timeline_tab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_success_tab__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_success_tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_success_tab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_opportunity_tab__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_opportunity_tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_opportunity_tab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_features_tab__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_features_tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_features_tab__);
/* global $:true */








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    teamTab: __WEBPACK_IMPORTED_MODULE_0__components_team_tab___default.a,
    productTab: __WEBPACK_IMPORTED_MODULE_1__components_product_tab___default.a,
    timelineTab: __WEBPACK_IMPORTED_MODULE_2__components_timeline_tab___default.a,
    successTab: __WEBPACK_IMPORTED_MODULE_3__components_success_tab___default.a,
    opportunityTab: __WEBPACK_IMPORTED_MODULE_4__components_opportunity_tab___default.a,
    featuresTab: __WEBPACK_IMPORTED_MODULE_5__components_features_tab___default.a
  },

  data: function data() {
    return {
      tabs: [{ id: 'team', title: 'Team' }, { id: 'product', title: 'Product' }, { id: 'timeline', title: 'Timeline' }, { id: 'success', title: 'Success' }, { id: 'opportunity', title: 'Opportunity' }, { id: 'features', title: 'Features' }],
      active_tab: 'team',
      isPageReady: false
    };
  },


  methods: {
    onTab: function onTab(tab) {
      this.active_tab = tab;
      this.$nextTick(function () {
        $(window).scrollTop(0);
      });
    }
  },

  created: function created() {
    this.$store.dispatch('navigator/goNextState', {
      page: 'overview',
      tab: this.active_tab
    });
    this.onTab(this.active_tab);
  }
});

/***/ }),
/* 1092 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_accordion__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_accordion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_accordion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    accordion: __WEBPACK_IMPORTED_MODULE_0__components_accordion___default.a
  },
  data: function data() {
    return {
      accordions: [{
        title: 'How do I become a YouSound Partner?',
        content: 'You must have at least 2,000 followers.  When you reach the required amount of followers we will review your account and all of it\'s activity.If your account is approved we will send you an email to enroll.YouSound Partners program is set to begin by the end of Q4 2022.'
      }]
    };
  },

  computed: {}
});

/***/ }),
/* 1093 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_auth__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_order__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_payment__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_user__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_order_refund_dialog__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_order_refund_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_order_refund_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_product__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_product___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_product__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_sendmessage__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_sendmessage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_sendmessage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_sharemodal__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_sharemodal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_sharemodal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_user_card__ = __webpack_require__(788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_user_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_user_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_contentTopHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_contentTopHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_contentTopHeader__);















/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    isComp: Boolean
  },
  components: {
    OrderRefundDialog: __WEBPACK_IMPORTED_MODULE_6__components_order_refund_dialog___default.a,
    ProductModal: __WEBPACK_IMPORTED_MODULE_7__components_product___default.a,
    SendMessage: __WEBPACK_IMPORTED_MODULE_8__components_sendmessage___default.a,
    ShareModal: __WEBPACK_IMPORTED_MODULE_9__components_sharemodal___default.a,
    UserCard: __WEBPACK_IMPORTED_MODULE_10__components_user_card___default.a,
    contentTopHeader: __WEBPACK_IMPORTED_MODULE_11__components_contentTopHeader___default.a
  },

  data: function data() {
    return {
      replaceTopMenu: [{ id: 'payments', title: 'Payments', pathName: 'PaymentIndex', icon: __webpack_require__(769) }],
      active_tab: 'received',
      tabs: [{ id: 'received', title: 'Received' }, { id: 'sent', title: 'Sent' }],
      show_withdraw_dialog: false,
      show_withdraw_confirm_modal: false,
      withdraw_option: 'all',
      withdraw_amount: 1.0,
      show_refund_confirm_dialog: false,
      show_refund_dialog: false,
      refund_option: 'all',
      refund_amount: 1.0,
      refund_description: '',
      histories: [],
      payment: {},
      refund_item: {},
      show_product_modal: false,
      show_share_modal: false,
      send_message_dialog: false,
      messaging_user: {},
      page_index: 1,
      total_pages: 1,
      items_per_page: 6 * 5,
      calculateFee: __WEBPACK_IMPORTED_MODULE_1__helper__["d" /* Stripe */].calculateFee
    };
  },


  computed: {
    currentUser: function currentUser() {
      return this.$store.state.auth.user;
    },
    PaymentTypes: function PaymentTypes() {
      return __WEBPACK_IMPORTED_MODULE_1__helper__["J" /* PaymentTypes */];
    },
    disableWithdrawButton: function disableWithdrawButton() {
      return this.withdraw_option !== 'all' && (!this.withdraw_amount || this.withdraw_amount < 1 || this.currentUser.available_amount < this.withdraw_amount);
    },
    stripeLink: function stripeLink() {
      return 'https://connect.stripe.com/oauth/authorize?response_type=code&client_id=' + "ca_CC74CVRdkHTZqAIPQVJS04XoPwiVB1Kx" + '&scope=read_write&state=' + this.$store.state.auth.secret_code;
    },
    withdrawAmount: function withdrawAmount() {
      if (this.withdraw_option === 'all') {
        return this.currentUser.available_amount;
      } else {
        return parseInt(this.withdraw_amount * 100);
      }
    }
  },

  methods: {
    isActiveTab: function isActiveTab(tab) {
      return this.active_tab === tab;
    },
    showSendMessageDialog: function showSendMessageDialog(history) {
      this.send_message_dialog = true;
      if (this.active_tab === 'received') {
        this.messaging_user = history.sender;
      } else {
        this.messaging_user = history.receiver;
      }
    },
    hideSendMessageDialog: function hideSendMessageDialog() {
      this.send_message_dialog = false;
    },
    openProductModal: function openProductModal(payment) {
      this.payment = payment;
      this.show_product_modal = true;
    },
    closeProductModal: function closeProductModal() {
      this.show_product_modal = false;
    },
    shareProduct: function shareProduct() {
      this.closeProductModal();
      this.openShareModal();
    },
    openShareModal: function openShareModal() {
      this.show_share_modal = true;
    },
    closeShareModal: function closeShareModal() {
      this.show_share_modal = false;
    },
    openWithdrawModal: function openWithdrawModal() {
      this.show_withdraw_dialog = true;
    },
    closeWithdrawModal: function closeWithdrawModal() {
      this.show_withdraw_dialog = false;
    },
    openWithdrawConfirmModal: function openWithdrawConfirmModal() {
      this.closeWithdrawModal();
      this.show_withdraw_confirm_modal = true;
    },
    closeWithdrawConfirmModal: function closeWithdrawConfirmModal() {
      this.openWithdrawModal();
      this.show_withdraw_confirm_modal = false;
    },
    openRefundDialog: function openRefundDialog(payment) {
      var _this = this;

      this.payment = this._.cloneDeep(payment);
      switch (this.payment.payment_type) {
        case 'pay_view_stream':
          this.openRefundConfirmDialog();
          break;
        default:
          this.$store.dispatch('error/showLoadingActivity', true);
          __WEBPACK_IMPORTED_MODULE_3__services_order__["a" /* default */].getOrder(payment.order_id).then(function (response) {
            var order = response.body;
            order.items.forEach(function (item) {
              item.refund = false;
            });
            _this.payment.order = order;
            _this.show_refund_dialog = true;
            _this.$store.dispatch('error/showLoadingActivity', false);
          }).catch(function (error) {
            console.log('openRefundDialog error', error);
            _this.$store.dispatch('error/showLoadingActivity', false);
          });
      }
    },
    closeRefundDialog: function closeRefundDialog() {
      this.show_refund_dialog = false;
    },
    openRefundConfirmDialog: function openRefundConfirmDialog() {
      // console.log('order', this.payment.order)
      this.refund_amount = this.refundAmount();
      this.closeRefundDialog();
      this.show_refund_confirm_dialog = true;
    },
    closeRefundConfirmDialog: function closeRefundConfirmDialog() {
      // this.show_refund_dialog = true
      this.show_refund_confirm_dialog = false;
    },
    continueRefund: function continueRefund(payment) {
      // console.log('continueRefund', payment)
      this.closeRefundDialog();
      this.openRefundConfirmDialog();
    },
    canRefund: function canRefund(payment) {
      var val = 'Fully Refunded';
      switch (payment.payment_type) {
        case 'buy':
          if (payment.sent_amount > payment.refund_amount) {
            val = true;
          }
          break;
        case 'pay_view_stream':
          if (payment.received_amount > payment.refund_amount) {
            val = true;
          }
          break;
        default:
          val = '';
      }
      return val;
    },
    refundAmount: function refundAmount() {
      switch (this.payment.payment_type) {
        case 'buy':
          var items = this._.get(this.payment, 'order.items', []);
          // console.log('refundAmount', items)
          var refund_amount = 0;
          if (items.length > 0) {
            refund_amount = items.reduce(function (amount, item) {
              if (item.status !== 'item_refunded' && item.refund && item.refund_amount_in_dollar > 0) {
                return amount + item.refund_amount_in_dollar * 100;
              } else {
                return amount;
              }
            }, 0);
          }
          return refund_amount;
        case 'pay_view_stream':
          return this.payment.received_amount;
        default:
          // if (this.refund_option == 'all') {
          //   return this.payment.sent_amount - this.payment.refund_amount
          // } else {
          //   return parseInt(this.refund_amount * 100)
          // }
          return 0;
      }
    },
    refundMoney: function refundMoney() {
      var _this2 = this;

      // this.show_refund_confirm_dialog = false
      var params = void 0;
      var items = [];
      this.closeRefundConfirmDialog();
      switch (this.payment.payment_type) {
        case 'buy':
          this.payment.order.items.forEach(function (item) {
            if (item.status !== 'item_refunded' && item.refund && item.refund_amount_in_dollar > 0) {
              items.push({
                id: item.id,
                refund_amount: item.refund_amount_in_dollar * 100
              });
            }
          });
          params = {
            payment_id: this.payment.id,
            amount: this.refund_amount,
            description: this.refund_description,
            items: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(items)
          };
          console.log('refundOrder', params);
          this.$store.dispatch('error/showLoadingActivity', true);
          __WEBPACK_IMPORTED_MODULE_4__services_payment__["a" /* default */].refundOrder(this.payment.id, params).then(function (response) {
            __WEBPACK_IMPORTED_MODULE_2__services_auth__["a" /* default */].setUser(response.body);
            _this2.$store.dispatch('error/showLoadingActivity', false);
            _this2.$store.dispatch('error/showSuccessToast', ['Refunded $' + __WEBPACK_IMPORTED_MODULE_1__helper__["a" /* Filter */].formatNumber(_this2.refund_amount) + ' successfully.']);
            _this2.payment.refund_amount += _this2.refund_amount;
            var arr = _this2.histories.slice();
            _this2.histories = arr;
          }).catch(function (e) {
            _this2.$store.dispatch('error/showLoadingActivity', false);
            _this2.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
          });
          break;
        default:
          this.$store.dispatch('error/showLoadingActivity', true);
          params = {
            amount: this.refund_amount,
            description: this.refund_description
          };
          __WEBPACK_IMPORTED_MODULE_4__services_payment__["a" /* default */].refundMoney(this.payment.id, params).then(function (response) {
            __WEBPACK_IMPORTED_MODULE_2__services_auth__["a" /* default */].setUser(response.body);
            _this2.$store.dispatch('error/showLoadingActivity', false);
            _this2.$store.dispatch('error/showSuccessToast', ['Refunded $' + __WEBPACK_IMPORTED_MODULE_1__helper__["a" /* Filter */].formatNumber(_this2.refund_amount) + ' successfully.']);

            _this2.payment.refund_amount += _this2.refund_amount;
            var arr = _this2.histories.slice();
            _this2.histories = arr;
          }).catch(function (e) {
            _this2.$store.dispatch('error/showLoadingActivity', false);
            _this2.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
          });
      }
    },
    onTab: function onTab(tab) {
      this.$router.push({
        path: this.$route.path,
        hash: tab
      });
    },
    setTab: function setTab(tab) {
      if (!tab) {
        tab = 'received';
      }

      this.active_tab = tab;
      this.$store.dispatch('navigator/goNextState', {
        page: 'payments',
        tab: ''
      });
      this.page_index = 1;
      this.total_pages = 1;
      this.histories = [];
      this.loadPayments(tab, this.page_index);
    },
    loadPayments: function loadPayments(tab, page) {
      var _this3 = this;

      this.$store.dispatch('error/showLoadingActivity', true);
      var params = {
        page: page,
        per_page: this.items_per_page
      };
      if (tab === 'sent') {
        __WEBPACK_IMPORTED_MODULE_4__services_payment__["a" /* default */].getSentPayments(params).then(function (response) {
          _this3.$store.dispatch('error/showLoadingActivity', false);
          _this3.page_index = response.body.pagination.current_page;
          _this3.total_pages = response.body.pagination.total_pages;
          _this3.histories = _this3.histories.concat(response.body.payments);
        }).catch(function (e) {
          _this3.$store.dispatch('error/showLoadingActivity', false);
          _this3.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_4__services_payment__["a" /* default */].getReceivedPayments(params).then(function (response) {
          _this3.$store.dispatch('error/showLoadingActivity', false);
          _this3.page_index = response.body.pagination.current_page;
          _this3.total_pages = response.body.pagination.total_pages;
          _this3.histories = _this3.histories.concat(response.body.payments);
        }).catch(function (e) {
          _this3.$store.dispatch('error/showLoadingActivity', false);
          _this3.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
        });
      }
    },
    loadMore: function loadMore() {
      this.loadPayments(this.active_tab, this.page_index + 1);
    },
    withdrawMoney: function withdrawMoney() {
      var _this4 = this;

      this.show_withdraw_confirm_modal = false;
      this.$store.dispatch('error/showLoadingActivity', true);
      var params = {
        amount: this.withdrawAmount
      };
      __WEBPACK_IMPORTED_MODULE_4__services_payment__["a" /* default */].withdrawMoney(params).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_2__services_auth__["a" /* default */].setUser(response.body);
        _this4.$store.dispatch('error/showLoadingActivity', false);
        _this4.$store.dispatch('error/showSuccessToast', ['Withdrew $' + __WEBPACK_IMPORTED_MODULE_1__helper__["a" /* Filter */].formatNumber(_this4.withdrawAmount) + ' successfully.']);
      }).catch(function (e) {
        _this4.$store.dispatch('error/showLoadingActivity', false);
        _this4.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    }
  },

  watch: {
    $route: function $route(toPath, fromPath) {
      var tab = toPath.hash.substr(1);
      this.setTab(tab);
    }
  },

  created: function created() {
    var _this5 = this;

    __WEBPACK_IMPORTED_MODULE_5__services_user__["a" /* default */].getUserInfo(this.$store.state.auth.user.slug).then(function (response) {
      __WEBPACK_IMPORTED_MODULE_2__services_auth__["a" /* default */].setUser(response.body);
      var tab = _this5.$route.hash.substr(1);
      _this5.setTab(tab);
    }).catch(function (e) {
      _this5.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
    });
  }
});

/***/ }),
/* 1094 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_auth__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_item__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_search__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_slick_carousel__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_slick_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_slick_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_slick_carousel_dist_vue_slick_carousel_css__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_slick_carousel_dist_vue_slick_carousel_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_slick_carousel_dist_vue_slick_carousel_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_slick_carousel_dist_vue_slick_carousel_theme_css__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_slick_carousel_dist_vue_slick_carousel_theme_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_slick_carousel_dist_vue_slick_carousel_theme_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_product__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_productcard__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_productcard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_productcard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_contentTopHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_contentTopHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_contentTopHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_discoverNav__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_discoverNav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_discoverNav__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_userFollowBtn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_userFollowBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_userFollowBtn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helper__ = __webpack_require__(2);
/* global $:true */















var filterArrowDownString = '<i class="material-icons icon icon--right theme--dark">keyboard_arrow_down</i>';

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    isComp: Boolean,
    listLimit: Number
  },
  components: {
    productCard: __WEBPACK_IMPORTED_MODULE_8__components_productcard___default.a,
    contentTopHeader: __WEBPACK_IMPORTED_MODULE_9__components_contentTopHeader___default.a,
    discoverNav: __WEBPACK_IMPORTED_MODULE_10__components_discoverNav___default.a,
    VueSlickCarousel: __WEBPACK_IMPORTED_MODULE_4_vue_slick_carousel___default.a,
    UserFollowBtn: __WEBPACK_IMPORTED_MODULE_11__components_userFollowBtn___default.a
  },

  data: function data() {
    return {
      slickOptions: {
        infinite: false,
        slidesToShow: 6,
        slidesToScroll: 6,
        dots: false,
        cssEase: 'linear',
        arrows: true
        //      autoplay: true,
        //      autoplaySpeed: 6000,

      },
      activeTab: 'recommended',
      seed: '',
      page_index: 1,
      total_pages: 1,
      items_per_page: 1 * 50,
      categories: [],
      selected_category: null,
      products: [],
      feeds: [],
      isPageReady: false,
      tabs: [{ id: 'recommended', title: 'Trending' }],
      mainProduct: null,
      viewAllTrending: false,
      trendingProducts: [],
      buttonHover: false,
      viewAllByCategory: false,
      selectedTab: 'recommended',
      busy: false
    };
  },


  computed: {
    followButtonText: function followButtonText() {
      if (this.mainProduct.merchant.is_following) {
        return this.buttonHover ? 'Unfollow' : 'Following';
      }
      return 'Follow';
    },
    onMobile: function onMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    currentUser: function currentUser() {
      return this.$store.state.auth.user;
    },
    filtered_feeds: function filtered_feeds() {
      return this.feeds;
    }
  },

  watch: {},

  beforeCreate: function beforeCreate() {
    this.$parent.$el.classList.add("loading");
  },
  created: function created() {
    this.$root.$on(__WEBPACK_IMPORTED_MODULE_12__helper__["b" /* MyEvents */].USER_FOLLOW, this.setFollowingStatus);
    this.$store.dispatch('navigator/goNextState', {
      page: 'product',
      tab: ''
    });
    // this.seed = parseInt(Date.now() * Math.random())
    this.seed = Math.random();
    this.loadFeeds(1);

    // set active tab
    if (this.pageName) {
      this.activeTab = this.pageName;
    }

    var paramFilter = this.$route.params.filter || '';
    if (paramFilter) {
      this.activeTab = paramFilter;
      this.onTab(this.activeTab);
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.$root.$off(__WEBPACK_IMPORTED_MODULE_12__helper__["b" /* MyEvents */].USER_FOLLOW, this.setFollowingStatus);
  },


  methods: {
    setFollowingStatus: function setFollowingStatus(userId, isFollowing) {
      if (this.mainProduct.merchant && this.mainProduct.merchant.id === userId) {
        this.mainProduct.merchant.is_following = isFollowing;
      }
    },
    addToCart: function addToCart() {
      var _this = this;

      var params = {
        product_variant_id: this.mainProduct.variants[0].id,
        quantity: 1
      };
      __WEBPACK_IMPORTED_MODULE_2__services_item__["a" /* default */].addToCart(params).then(function (response) {
        if (response.body.errors) {
          _this.$store.dispatch('error/showErrorToast', response.body.errors);
        } else {
          _this.$store.dispatch('error/showSuccessToast', ['Added successfully to Cart.']);
        }
      }).catch(function (e) {
        _this.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    isActiveTab: function isActiveTab(tab) {
      return this.activeTab === tab;
    },
    verifyUser: function verifyUser(selectedProduct) {
      if (this.currentUser == null) {
        this.showRegisterModal = true;
      } else {
        this.mainProduct = selectedProduct;
      }
    },
    productDisplay: function productDisplay(product) {
      if (this.currentUser == null) {
        this.showRegisterModal = true;
      } else {
        this.$router.push({ path: 'product/' + product.id });
      }
    },
    addToCollections: function addToCollections() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_7__services_product__["a" /* default */].addIntoCollection(this.mainProduct.id).then(function (resp) {
        _this2.$store.dispatch("error/showSuccessToast", ["You just added " + _this2.mainProduct.name + " in your collections."]);
      }).catch(function (e) {
        _this2.$store.dispatch("error/showErrorToast", e.body.errors || [e.body]);
      });
    },
    onTab: function onTab(tab) {
      this.activeTab = tab;

      if (this.isComp) {
        this.$router.push({ name: 'ProductIndex', params: { filter: tab } });
      } else {
        this.$router.push({
          path: this.$route.path,
          hash: tab
        });
      }
    },
    filterVideos: function filterVideos(filter) {
      console.log(filter);
    },
    isActiveCategory: function isActiveCategory(category) {
      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(this.selected_category, 'id', 'any') === category.id;
    },
    displayAllProduct: function displayAllProduct(category) {
      this.selected_category = category;
      this.viewAllTrending = true;
      this.viewAllByCategory = true;
    },
    displayAllTrendingProduct: function displayAllTrendingProduct(categoryType) {
      this.trendingProducts = this.products;
      this.viewAllTrending = true;
      this.selected_category = null;
      this.selectedTab = categoryType;
    },
    SelectTab: function SelectTab(tab) {
      this.trendingProducts = this.products;
      this.viewAllTrending = true;
      this.selectedTab = tab.id;
      this.selected_category = null;
    },
    loadFeeds: function loadFeeds(page) {
      var _this3 = this;

      this.busy = true;
      var vm = this;
      if (page === 1) {
        this.isPageReady = false;
      }
      this.$store.dispatch('error/showLoadingActivity', true);
      var genre = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(this.selected_genre, 'id', 'any');
      var category = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(this.selected_category, 'id', 'any');
      var params = {
        genre: genre,
        category: category,
        page: page,
        per_page: this.items_per_page,
        seed: this.seed
      };

      __WEBPACK_IMPORTED_MODULE_3__services_search__["a" /* default */].searchDiscoverPublicUser(params).then(function (response) {
        _this3.$parent.$el.classList.add("loading");
        _this3.$store.dispatch('error/showLoadingActivity', false);
        _this3.products = _this3.products.concat(response.body.products);

        // remove products duplicate
        _this3.products = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqBy(_this3.products, 'id');
        _this3.mainProduct = _this3.products[0];
        _this3.trendingProducts = _this3.products;
        // const categories = _.chain(this.products).map('category').keyBy('id').map((v, k) => {return v}).sortBy('name').value()
        _this3.categories = response.body.categories.map(function (c) {
          return {
            id: c,
            name: c
          };
        });
        // this.categories = [{ id: 'any', name: 'All' }].concat(categories)

        _this3.page_index = response.body.pagination.current_page;
        _this3.total_pages = response.body.pagination.total_pages;
        _this3.isPageReady = true;
        _this3.$parent.$el.classList.remove('loading');
        // if (page === 1) {
        //   Promise.all([
        //     SearchService.searchDiscover(_.extend(params, { page: 2 })),
        //     SearchService.searchDiscover(_.extend(params, { page: 3 })),
        //     SearchService.searchDiscover(_.extend(params, { page: 4 })),
        //   ]).then((values) => {
        //     vm.products = vm.products.concat(
        //       values[0].body.products,
        //       values[1].body.products,
        //       values[2].body.products
        //     )

        //     // this will return a a prop limit if available
        //     vm.products = this.products.slice(0, this.listLimit || this.products.length)

        //     // remove products duplicate
        //     this.products = _.uniqBy(this.products, 'id')

        //     vm.page_index =
        //       values[2].body.pagination.total_pages > 4
        //         ? 4
        //         : values[2].body.pagination.total_pages

        //     vm.isPageReady = true
        //   })
        // }
        _this3.busy = false;
      }).catch(function (e) {
        _this3.$store.dispatch('error/showLoadingActivity', false);
        // this.$store.dispatch('error/showErrorToast', e.body.errors || [e.body])
        console.log('discover error', e);
        _this3.busy = false;
      });
    },
    loadMore: function loadMore() {
      this.loadFeeds(this.page_index + 1);
    },


    loadMoreOnScroll: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.debounce(function (e) {
      this.loadMore();
    }, 500),

    handleScroll: function handleScroll(e) {
      var element = e.target;
      var scrollTop = element.scrollTop;
      var halfScrollHeight = element.scrollHeight / 2;
      var gapHeight = halfScrollHeight + 200;
      if (scrollTop >= halfScrollHeight && scrollTop <= gapHeight) {
        this.loadMoreOnScroll();
      }
    },
    changeSelectedCategory: function changeSelectedCategory(category) {
      this.selected_category = category;
    }
  },

  mounted: function mounted() {
    this.$parent.$el.classList.add("loading");
  }
});

/***/ }),
/* 1095 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_category__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_product__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_me__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_digital_uploader__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_digital_uploader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_digital_uploader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_contentTopHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_contentTopHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_contentTopHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_topbarNotification__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_topbarNotification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_topbarNotification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_settings_components_policy_tab__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_settings_components_policy_tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__views_settings_components_policy_tab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_user__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__BannerUpload__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__BannerUpload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__BannerUpload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_product_tag_svg__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_product_tag_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__assets_product_tag_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_product_drop_gif__ = __webpack_require__(764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_product_drop_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_product_drop_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_dragFileUploader__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_dragFileUploader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_dragFileUploader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_nav_vue__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_nav_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_nav_vue__);



/* global $:true */



// import UserService from '@/services/user'














/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    digitalUploader: __WEBPACK_IMPORTED_MODULE_8__components_digital_uploader___default.a,
    contentTopHeader: __WEBPACK_IMPORTED_MODULE_9__components_contentTopHeader___default.a,
    topbarNotification: __WEBPACK_IMPORTED_MODULE_10__components_topbarNotification___default.a,
    policyTab: __WEBPACK_IMPORTED_MODULE_11__views_settings_components_policy_tab___default.a,
    BannerUpload: __WEBPACK_IMPORTED_MODULE_13__BannerUpload___default.a,
    dragFileUploader: __WEBPACK_IMPORTED_MODULE_16__components_dragFileUploader___default.a,
    uploadNav: __WEBPACK_IMPORTED_MODULE_17__components_nav_vue___default.a
  },

  data: function data() {
    return {
      activeTab: 'product',
      iconImage: __WEBPACK_IMPORTED_MODULE_14__assets_product_tag_svg___default.a,
      bannerImage: __WEBPACK_IMPORTED_MODULE_15__assets_product_drop_gif___default.a,
      tabs: [{ id: 'upload', title: 'Upload', isParent: true, path: 'UploadIndex' }, { id: 'music', title: 'Music', path: 'UploadAlbum' }, { id: 'video', title: 'Video', path: 'VideoUpload' }, { id: 'product', title: 'Product', path: 'AddProduct' }, { id: 'live', title: 'Broadcast Live', path: 'CreateLive' }],
      user: {},
      topBarContent: 'Connect your Stripe account to start accepting payments',
      showPolicyActive: false,
      product_categories: [],
      product_upload_successfully: false,
      destinations: [{
        value: 'United States',
        name: 'United States'
      },
      // {
      //   value: 'EE',
      //   name: "Int'l Flat Rate",
      // },
      {
        value: 'Canada',
        name: 'Canada'
      }, {
        value: 'United Kingdom',
        name: 'United Kingdom'
      }, {
        value: 'Australia',
        name: 'Australia'
      }, {
        value: 'France',
        name: 'France'
      }, {
        value: 'Germany',
        name: 'Germany'
      }, {
        value: 'Japan',
        name: 'Japan'
      }, {
        value: 'All other countries',
        name: 'All other countries'
      }],
      countries: [],
      states: [],
      digital_content_category_ids: [],
      digital_content: {
        file: null
      },
      product: {
        name: '',
        description: '',
        stock_status: 'active',
        show_status: 'show_all',
        single_order: false,
        category: '',
        price: null,
        tax_percent: 0,
        is_vat: false,
        seller_location: '',
        variants: [{
          name: '',
          quantity: '',
          price: ''
        }],
        shipments: [{
          country: 'All other countries',
          shipment_alone_price: '',
          shipment_with_price: ''
        }],
        image1: null,
        image2: null,
        image3: null,
        collaborators: [],
        creator_recoup_cost: 0
      },
      product_variants: [{
        name: '',
        quantity: '',
        price: ''
      }],
      users: [],
      collaborators_confirm_dialog: false,
      isPageReady: false,
      productUrl: null,
      loading: false,
      product_category: null,
      product_status: null,
      confirmationImage: null,
      access_levels: []
    };
  },


  computed: {
    onMobile: function onMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    isDigitalProduct: function isDigitalProduct() {
      return this.digital_content_category_ids.indexOf(this.product.category) > -1;
    },
    currentUser: function currentUser() {
      return this.$store.state.auth.user;
    },
    isAvailableToAddProduct: function isAvailableToAddProduct() {
      var isAvailable = this.product.name && this.product.category && this.product.image1;
      if (this.product.variants.length) {
        for (var index in this.product.variants) {
          var variant = this.product.variants[index];
          isAvailable = isAvailable && variant.name.length && (this.isDigitalProduct || parseFloat(variant.quantity) > 0) && parseFloat(variant.price) >= 0;
        }
        if (this.isDigitalProduct) {
          isAvailable = isAvailable && this.digital_content.file;
        } else {
          var validCountries = this.product.shipments.filter(function (shipment) {
            return shipment.country == "All other countries";
          }) != "";
          if (this.product.shipments.length && validCountries) {
            for (var _index in this.product.shipments) {
              for (var price_index in this.product.variants) {
                var shipment = this.product.shipments[_index];
                if (this.product.variants[price_index].price !== 0) {
                  isAvailable = isAvailable && shipment.country.length && parseFloat(shipment.shipment_alone_price) > 0 && parseFloat(shipment.shipment_with_price) >= 0;
                } else if (this.product.variants[price_index].price === 0) {
                  isAvailable = isAvailable && shipment.country.length && parseFloat(shipment.shipment_alone_price) >= 0 && parseFloat(shipment.shipment_with_price) >= 0;
                } else {
                  isAvailable = false;
                }
              }
            }
          } else {
            isAvailable = false;
          }
        }
      } else {
        isAvailable = false;
      }
      return isAvailable;
    },
    creator_share: function creator_share() {
      return 100 - __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.sumBy(this.product.collaborators, 'user_share');
    },
    profit_share_types: function profit_share_types() {
      var profitShare = [];
      for (var i = 1; i <= 100; i += 1) {
        profitShare.push(i);
      }
      return profitShare;
    }
  },

  created: function created() {
    var _this = this;

    if (this.onMobile) {
      this.$router.push({ name: "UploadIndex" });
    }

    this.$store.dispatch('navigator/goNextState', {
      page: 'sell',
      tab: 'products',
      action: 'add_product'
    });
    for (var i = 10; i <= 100; i += 10) {
      this.profit_share_types.push({
        id: i,
        name: i + '%'
      });
    }
    if (this.$store.state.auth.user && ['artist', 'brand', 'label'].indexOf(this.$store.state.auth.user.user_type) > -1) {
      var params = {
        stripe_connected: true,
        page: 1,
        per_page: 30
      };
      this.isPageReady = false;
      this.$store.dispatch('error/showLoadingActivity', true);
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all([
      // CategoryService.getCategories(),
      // UserService.searchUsers(params)
      __WEBPACK_IMPORTED_MODULE_6__services_me__["a" /* default */].mutualUsers(params), __WEBPACK_IMPORTED_MODULE_4__services_category__["a" /* default */].getCategories()]).then(function (values) {
        _this.product_categories = values[1].body;
        _this.digital_content_category_ids = _this.$store.getters['app/digitalCategoryIds'];
        _this.$store.dispatch('app/setProductCategories', values[1].body);
        _this.users = values[0].body.users;
        _this.isPageReady = true;
        _this.$store.dispatch('error/showLoadingActivity', false);

        __WEBPACK_IMPORTED_MODULE_6__services_me__["a" /* default */].mutualUsers(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, params, { per_page: -1 })).then(function (response) {
          return _this.users = response.body.users;
        });
      }).catch(function (reason) {
        console.log(reason);
        _this.$store.dispatch('error/showLoadingActivity', false);
        _this.$store.dispatch('error/showErrorToast', reason);
      });
    } else {
      this.$router.push({ path: '/' });
    }
  },


  methods: {
    pickedFile: function pickedFile(file) {
      this.product.image1 = file[0];
      var reader = new FileReader();
      reader.addEventListener('load', function (event) {
        // document.getElementById(index).src = event.target.result
        $('#product_image1').css('background-image', 'url(' + event.target.result + ')');
      }, false);
      reader.readAsDataURL(file[0]);
    },

    onCopy: function onCopy(e) {
      this.$store.dispatch("error/showSuccessToast", ["You just copied: " + e.text]);
      // alert('You just copied: ' + e.text)
    },

    onError: function onError(e) {
      this.$store.dispatch("error/showErrorToast", ["Failed to copy link"]);
      // alert('Failed to copy link')
    },

    isActiveTab: function isActiveTab(tab) {
      return this.activeTab === tab;
    },
    onTab: function onTab(tab) {
      if (tab.path) {
        this.$router.push({ name: tab.path });
      }
    },
    updateUser: function updateUser(params) {
      var _this2 = this;

      this.$store.dispatch('error/showLoadingActivity', true);
      __WEBPACK_IMPORTED_MODULE_12__services_user__["a" /* default */].updateUserInfo(this.currentUser.id, params).then(function (response) {
        _this2.$store.dispatch('error/showLoadingActivity', false);
        _this2.$store.dispatch('error/showSuccessToast', ['Saved']);
        AuthService.setUser(response.body);
      }).catch(function (e) {
        var errors = e.body.errors ? __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(e.body.errors, function (msg) {
          return 'Email ' + msg.detail;
        }) : [e.body];
        _this2.$store.dispatch('error/showLoadingActivity', false);
        _this2.$store.dispatch('error/showErrorToast', errors);
      });
    },
    imageChanged: function imageChanged(index, e) {
      debugger;
      if (index === 'product_image1') {
        this.product.image1 = e.target.files[0];
      } else if (index === 'product_image2') {
        this.product.image2 = e.target.files[0];
      } else {
        this.product.image3 = e.target.files[0];
      }
      var reader = new FileReader();
      reader.addEventListener('load', function (event) {
        // document.getElementById(index).src = event.target.result
        $('#' + index).css('background-image', 'url(' + event.target.result + ')');
      }, false);
      reader.readAsDataURL(e.target.files[0]);
    },
    addVariant: function addVariant() {
      this.product.variants.push({
        name: '',
        quantity: '',
        price: ''
      });
    },
    deleteVariant: function deleteVariant(index) {
      if (this.product.variants.length > 1) {
        this.product.variants.splice(index, 1);
      }
    },
    addShipment: function addShipment() {
      this.product.shipments.push({
        country: '',
        shipment_alone_price: '',
        shipment_with_price: ''
      });
    },
    deleteShipment: function deleteShipment(index) {
      if (this.product.shipments.length > 1) {
        this.product.shipments.splice(index, 1);
      }
    },
    onChangeProductCategory: function onChangeProductCategory(category_id) {
      // console.log('onChangeProductCategory', category_id, this.product.category)
      if (!this.isDigitalProduct && this.digital_content_category_ids.indexOf(category_id) > -1) {
        this.product_variants = this.product.variants;
        this.product.variants = [{
          name: 'Zip File',
          quantity: '',
          price: ''
        }];
      } else if (this.isDigitalProduct && this.digital_content_category_ids.indexOf(category_id) === -1) {
        this.product.variants = this.product_variants;
      }
    },
    changeTaxPercent: function changeTaxPercent(locationName) {
      this.product.tax_percent = 0;
      if (this.product.is_vat) {
        var country = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(this.countries, function (c) {
          return c.name === locationName;
        });
        this.product.tax_percent = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(country, 'rate', 0);
      } else {
        var state = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(this.states, function (s) {
          return s.name === locationName;
        });
        this.product.tax_percent = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(state, 'rate', 0);
      }
    },
    resetTaxPercent: function resetTaxPercent(value) {
      this.product.tax_percent = 0;
      this.product.seller_location = '';
    },
    learnMore: function learnMore() {},
    addCollaborator: function addCollaborator() {
      this.product.collaborators.push({
        user_id: '',
        user_share: 5
      });
    },
    deleteCollaborator: function deleteCollaborator(index) {
      this.product.collaborators.splice(index, 1);
    },
    showCollaboratorsConfirmDialog: function showCollaboratorsConfirmDialog() {
      this.collaborators_confirm_dialog = true;
    },
    hideCollaboratorsConfirmDialog: function hideCollaboratorsConfirmDialog() {
      this.collaborators_confirm_dialog = false;
    },
    beforeSaveProduct: function beforeSaveProduct() {
      this.showCollaboratorsConfirmDialog();
    },
    saveProduct: function saveProduct() {
      var _this3 = this;

      this.loading = true;
      this.$store.dispatch('error/showLoadingActivity', true);
      var formData = new FormData();
      formData.append('shop_product[name]', this.product.name);
      formData.append('shop_product[description]', this.product.description);
      formData.append('shop_product[single_order]', this.product.single_order);
      formData.append('shop_product[stock_status]', this.product.stock_status);
      formData.append('shop_product[access_level]', this.product.access_level);
      if (this.product.show_status === 'show_only_stream') {
        formData.append('shop_product[show_status]', this.product.show_status);
      } else {
        formData.append('shop_product[show_status]', 'show_all');
      }
      formData.append('shop_product[category_id]', this.product.category);
      formData.append('shop_product[price]', Math.round(this.product.price * 100));
      var variants = [];
      for (var index in this.product.variants) {
        variants.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.product.variants[index], {
          price: this.product.variants[index].price * 100
        }));
      }
      formData.append('shop_product[variants]', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(variants));
      var shipments = [];
      for (var _index2 in this.product.shipments) {
        var shipment = this.product.shipments[_index2];
        shipments.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, shipment, {
          shipment_alone_price: shipment.shipment_alone_price * 100,
          shipment_with_price: shipment.shipment_with_price * 100
        }));
      }
      formData.append('shop_product[shipments]', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(shipments));
      formData.append('shop_product[cover1]', this.product.image1);
      formData.append('shop_product[cover2]', this.product.image2);
      formData.append('shop_product[cover3]', this.product.image3);
      formData.append('shop_product[collaborators]', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.product.collaborators));
      formData.append('shop_product[creator_recoup_cost]', Math.round(this.product.creator_recoup_cost * 100));

      formData.append('shop_product[tax_percent]', __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.product, 'tax_percent', 0));
      formData.append('shop_product[is_vat]', __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.product, 'is_vat', false));
      formData.append('shop_product[seller_location]', __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.product, 'seller_location', ''));

      if (this.isDigitalProduct) {
        formData.append('shop_product[digital_content]', this.digital_content.file);
        formData.append('shop_product[digital_content_name]', this.digital_content.file.name);
      }

      __WEBPACK_IMPORTED_MODULE_5__services_product__["a" /* default */].addProduct(formData).then(function (response) {
        _this3.loading = false;
        _this3.product_category = response.body.category.name;
        _this3.product_status = response.body.status.name;
        _this3.confirmationImage = response.body.covers[0].cover.url;
        _this3.$store.dispatch('error/showLoadingActivity', false);
        if (_this3.product.collaborators.length > 0) {
          _this3.$store.dispatch('navigator/setParams', {
            product_id: response.body.id
          });
          // this.$router.push({ name: 'ManageIndex', params: {activeInnerFilter: 'products', activeInnerTab: 'pending'  } })
          _this3.$router.push({ path: '/product/' + response.body.id });
        } else {
          // this.$router.push({ path: '/sell#products' })
          _this3.hideCollaboratorsConfirmDialog();
          localStorage.setItem("release_product", response.body.id);
          // this.$router.push({ name: 'ManageIndex', params: {activeInnerFilter: 'products', activeInnerTab: 'pending'  } })
          _this3.$router.push({ path: '/product/' + response.body.id });
          _this3.product_upload_successfully = true;
        }
      }).catch(function (e) {
        _this3.loading = false;
        _this3.$store.dispatch('error/showLoadingActivity', false);
        _this3.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    cancelToSaveProduct: function cancelToSaveProduct() {
      this.$router.push({ path: '/sell#products' });
    },
    deleteProductImage: function deleteProductImage(index) {
      if (index === 'product_image1') {
        this.product.image1 = null;
        $('#product_image1').css('background-image', 'none');
      } else if (index === 'product_image2') {
        this.product.image2 = null;
        $('#product_image2').css('background-image', 'none');
      } else {
        this.product.image3 = null;
        $('#product_image3').css('background-image', 'none');
      }
    }
  },

  mounted: function mounted() {
    var _this4 = this;

    var vm = this;

    $.getJSON('../../static/countries.json', function (json) {
      var countries = json.countries;

      var _loop = function _loop(index) {
        var country = {
          value: countries[index]['name'],
          name: countries[index]['name']
        };
        if (!vm.destinations.find(function (c) {
          return c.value === country.value;
        })) {
          vm.destinations.push(country);
        }
      };

      for (var index in countries) {
        _loop(index);
      }
      vm.countries = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(countries, function (c) {
        return c['rate'] !== false;
      });
    });

    $.getJSON('../../static/states.json', function (data) {
      vm.states = data;
    });

    __WEBPACK_IMPORTED_MODULE_12__services_user__["a" /* default */].getAccessLevels(this.currentUser.id).then(function (response) {
      _this4.access_levels = response.body;
      _this4.product.access_level.push('published');
    }).catch(function (e) {
      _this4.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
    });
  }
});

/***/ }),
/* 1096 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_contentTopHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_contentTopHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_contentTopHeader__);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    name: String,
    tabActivePill: Boolean
  },
  components: {
    contentTopHeader: __WEBPACK_IMPORTED_MODULE_2__components_contentTopHeader___default.a
  },
  data: function data() {
    return {
      activeTab: "",
      tabs: [{
        id: "upload",
        title: "Upload",
        pathName: "UploadIndex"
      }, {
        id: "manage",
        title: "Manage",
        pathName: "ManageIndex"
      }]
    };
  },


  computed: {
    currentUser: function currentUser() {
      return this.$store.state.auth.user;
    }
  },

  methods: {
    isActiveTab: function isActiveTab(tab) {
      return this.name === tab;
    },
    isActiveInnerTab: function isActiveInnerTab(tab) {
      return this.activeInnerTab === tab;
    },
    setTab: function setTab(pathName) {
      this.$router.push({ name: pathName });
    }
  },

  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.activeTab = _this.name;

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 1097 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_product__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_user__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_me__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_digital_uploader__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_digital_uploader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_digital_uploader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_category__ = __webpack_require__(196);



/* global $:true */


// import CategoryService from '@/services/category'
// import ProfileService from '@/services/profile'
// import UserService from '@/services/user'







/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		digitalUploader: __WEBPACK_IMPORTED_MODULE_8__components_digital_uploader___default.a
	},

	data: function data() {
		return {
			product_categories: [],
			destinations: [{
				value: 'United States',
				name: 'United States'
			},
			// {
			//   value: 'EE',
			//   name: "Int'l Flat Rate",
			// },
			{
				value: 'Canada',
				name: 'Canada'
			}, {
				value: 'United Kingdom',
				name: 'United Kingdom'
			}, {
				value: 'Australia',
				name: 'Australia'
			}, {
				value: 'France',
				name: 'France'
			}, {
				value: 'Germany',
				name: 'Germany'
			}, {
				value: 'Japan',
				name: 'Japan'
			}, {
				value: 'All other countries',
				name: 'All other countries'
			}],
			countries: [],
			states: [],
			digital_content_category_ids: [],
			digital_content: {
				file: null
			},
			prod_id: '',
			product_image1: null,
			product_image1_url: null,
			product_image2: null,
			product_image2_url: null,
			product_image3: null,
			product_image3_url: null,
			product: null,
			product_variants: [{
				name: '',
				quantity: '',
				price: ''
			}],
			users: [],
			collaborators_confirm_dialog: false,
			isPageReady: false,
			loading: false,
			access_levels: []
		};
	},


	computed: {
		currentUser: function currentUser() {
			return this.$store.state.auth.user;
		},
		onMobile: function onMobile() {
			return this.$vuetify.breakpoint.smAndDown;
		},
		isDigitalProduct: function isDigitalProduct() {
			return this.digital_content_category_ids.indexOf(this.product.category) > -1;
		},
		isAvailableToUpdateProduct: function isAvailableToUpdateProduct() {
			var isAvailable = this.product.name && this.product.category && this.product_image1_url;
			if (this.product.variants.length) {
				for (var index in this.product.variants) {
					var variant = this.product.variants[index];
					isAvailable = isAvailable && variant.name.length && (this.isDigitalProduct || parseFloat(variant.quantity) >= 0) && parseFloat(variant.price) >= 0;
				}
				if (this.isDigitalProduct) {
					isAvailable = isAvailable && this.digital_content.file;
				} else {
					var validCountries = this.product.shipments.filter(function (shipment) {
						return shipment.country == "All other countries";
					}) != "";
					if (this.product.shipments.length && validCountries) {
						for (var _index in this.product.shipments) {
							for (var price_index in this.product.variants) {
								var shipment = this.product.shipments[_index];
								if (this.product.variants[price_index].price !== 0) {
									isAvailable = isAvailable && shipment.country.length && parseFloat(shipment.shipment_alone_price) > 0 && parseFloat(shipment.shipment_with_price) >= 0;
								} else if (this.product.variants[price_index].price === 0) {
									isAvailable = isAvailable && shipment.country.length && parseFloat(shipment.shipment_alone_price) >= 0 && parseFloat(shipment.shipment_with_price) >= 0;
								} else {
									isAvailable = false;
								}
							}
						}
					} else {
						isAvailable = false;
					}
				}
			} else {
				isAvailable = false;
			}
			return isAvailable;
		},
		isEditable: function isEditable() {
			return ['privated', 'published', 'collaborated'].indexOf(this.product.status) === -1;
		},
		creator_share: function creator_share() {
			return 100 - __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.sumBy(this.product.collaborators, 'user_share');
		},
		profit_share_types: function profit_share_types() {
			var profitShare = [];
			for (var i = 1; i <= 100; i += 1) {
				profitShare.push(i);
			}
			return profitShare;
		},
		productCategoryName: function productCategoryName() {
			var _this = this;

			return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(this.product_categories, function (pc) {
				return pc.id === _this.product.category;
			}), 'name', '');
		}
	},

	created: function created() {
		var _this2 = this;

		if (this.onMobile) {
			this.$router.push({ name: "UploadIndex" });
		}

		this.$store.dispatch('navigator/goNextState', {
			page: 'sell',
			tab: 'products',
			action: 'edit_product'
		});

		if (this.$store.state.auth.user && ['artist', 'brand', 'label'].indexOf(this.$store.state.auth.user.user_type) > -1) {
			this.prod_id = this.$route.params.id;
			// const params = {
			//   filter: 'artist',
			//   page: 1,
			//   per_page: 30,
			// }
			var params = {
				stripe_connected: true,
				page: 1,
				per_page: 30
			};
			this.isPageReady = false;
			this.$store.dispatch('error/showLoadingActivity', true);
			__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all([
			// UserService.searchUsers(params),
			// ProfileService.getItems(
			//   this.$store.state.auth.user.id,
			//   'followings',
			//   params
			// ),
			__WEBPACK_IMPORTED_MODULE_6__services_me__["a" /* default */].mutualUsers(params), __WEBPACK_IMPORTED_MODULE_4__services_product__["a" /* default */].getProduct(this.prod_id), __WEBPACK_IMPORTED_MODULE_9__services_category__["a" /* default */].getCategories()]).then(function (values) {
				_this2.product_categories = values[2].body;
				_this2.digital_content_category_ids = _this2.$store.getters['app/digitalCategoryIds'];

				_this2.users = values[0].body.users;

				_this2.product = values[1].body;
				_this2.product.category = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this2.product, 'category.id', '');
				_this2.product.creator_recoup_cost /= 100;
				_this2.product_image1_url = _this2.product.covers[0].cover.url;
				_this2.product_image2_url = _this2.product.covers[1].cover.url;
				_this2.product_image3_url = _this2.product.covers[2].cover.url;
				_this2.product.price /= 100;
				console.log(_this2.product);
				for (var index in _this2.product.variants) {
					_this2.product.variants[index].price /= 100;
				}
				for (var _index2 in _this2.product.shipments) {
					_this2.product.shipments[_index2].shipment_alone_price /= 100;
					_this2.product.shipments[_index2].shipment_with_price /= 100;
				}

				if (_this2.product.digital_content_url) {
					_this2.digital_content.file = {
						name: _this2.product.digital_content_name
					};
				}

				_this2.isPageReady = true;
				_this2.$store.dispatch('error/showLoadingActivity', false);

				__WEBPACK_IMPORTED_MODULE_6__services_me__["a" /* default */].mutualUsers(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, params, { per_page: -1 })).then(function (response) {
					return _this2.users = response.body.users;
				});
			}).catch(function (reason) {
				console.log(reason);
				_this2.$store.dispatch('error/showLoadingActivity', false);
				_this2.$store.dispatch('error/showErrorToast', reason);
			});
		} else {
			this.$router.push({ path: '/' });
		}
	},


	methods: {
		imageChanged: function imageChanged(index, e) {
			var _this3 = this;

			if (index === 'product_image1') {
				this.product_image1 = e.target.files[0];
			} else if (index === 'product_image2') {
				this.product_image2 = e.target.files[0];
			} else {
				this.product_image3 = e.target.files[0];
			}
			var reader = new FileReader();
			reader.addEventListener('load', function (event) {
				// document.getElementById(index).src = event.target.result
				if (index === 'product_image1') {
					_this3.product_image1_url = event.target.result;
				} else if (index === 'product_image2') {
					_this3.product_image2_url = event.target.result;
				} else {
					_this3.product_image3_url = event.target.result;
				}
			}, false);
			reader.readAsDataURL(e.target.files[0]);
			this.$forceUpdate();
		},
		addVariant: function addVariant() {
			this.product.variants.push({
				name: '',
				quantity: '',
				price: ''
			});
		},
		deleteVariant: function deleteVariant(index) {
			if (this.product.variants.length > 1) {
				this.product.variants.splice(index, 1);
			}
		},
		addShipment: function addShipment() {
			this.product.shipments.push({
				country: '',
				shipment_alone_price: '',
				shipment_with_price: ''
			});
		},
		deleteShipment: function deleteShipment(index) {
			if (this.product.shipments.length > 1) {
				this.product.shipments.splice(index, 1);
			}
		},
		onChangeProductCategory: function onChangeProductCategory(category_id) {
			// console.log('onChangeProductCategory', category_id, this.product.category)
			if (!this.isDigitalProduct && this.digital_content_category_ids.indexOf(category_id) > -1) {
				this.product_variants = this.product.variants;
				this.product.variants = [{
					name: 'Zip File',
					quantity: '',
					price: ''
				}];
			} else if (this.isDigitalProduct && this.digital_content_category_ids.indexOf(category_id) === -1) {
				this.product.variants = this.product_variants;
			}
		},
		changeTaxPercent: function changeTaxPercent(locationName) {
			this.product.tax_percent = 0;
			if (this.product.is_vat) {
				var country = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(this.countries, function (c) {
					return c.name === locationName;
				});
				this.product.tax_percent = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(country, 'rate', 0);
			} else {
				var state = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(this.states, function (s) {
					return s.name === locationName;
				});
				this.product.tax_percent = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(state, 'rate', 0);
			}
		},
		resetTaxPercent: function resetTaxPercent(value) {
			this.product.tax_percent = 0;
			this.product.seller_location = '';
		},
		learnMore: function learnMore() {},
		addCollaborator: function addCollaborator() {
			this.product.collaborators.push({
				user_id: '',
				user_share: 5,
				status: 'pending'
			});
		},
		deleteCollaborator: function deleteCollaborator(index) {
			this.product.collaborators.splice(index, 1);
		},
		showCollaboratorsConfirmDialog: function showCollaboratorsConfirmDialog() {
			this.collaborators_confirm_dialog = true;
		},
		hideCollaboratorsConfirmDialog: function hideCollaboratorsConfirmDialog() {
			this.collaborators_confirm_dialog = false;
		},
		beforeSaveProduct: function beforeSaveProduct() {
			if (this.product.status === 'pending') {
				this.showCollaboratorsConfirmDialog();
			} else {
				this.saveProduct();
			}
		},
		saveProduct: function saveProduct() {
			var _this4 = this;

			var total_collaborators_share = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.sumBy(this.product.collaborators, 'user_share');
			if (total_collaborators_share >= 100) {
				this.$store.dispatch('error/showErrorToast', ['Total share shoud be less than 100']);
				return;
			}
			this.loading = true;
			this.$store.dispatch('error/showLoadingActivity', true);
			var formData = new FormData();
			formData.append('shop_product[name]', this.product.name);
			formData.append('shop_product[description]', this.product.description);
			formData.append('shop_product[stock_status]', this.product.stock_status);
			formData.append('shop_product[access_level]', this.product.access_level);
			if (this.product.show_status === 'show_only_stream') {
				formData.append('shop_product[show_status]', this.product.show_status);
			} else {
				formData.append('shop_product[show_status]', 'show_all');
			}
			// formData.append('shop_product[category_id]', this.product.category)
			formData.append('shop_product[price]', Math.round(this.product.price * 100));
			var variants = [];
			for (var index in this.product.variants) {
				variants.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.product.variants[index], {
					price: this.product.variants[index].price * 100
				}));
			}
			formData.append('shop_product[variants]', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(variants));
			var shipments = [];
			for (var _index3 in this.product.shipments) {
				var shipment = this.product.shipments[_index3];
				shipments.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, shipment, {
					shipment_alone_price: shipment.shipment_alone_price * 100,
					shipment_with_price: shipment.shipment_with_price * 100
				}));
			}
			formData.append('shop_product[shipments]', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(shipments));
			if (this.product_image1) {
				formData.append('shop_product[cover1]', this.product_image1);
			} else {
				if (this.product_image1_url === null) {
					formData.append('shop_product[cover1]', null);
				}
			}
			if (this.product_image2) {
				formData.append('shop_product[cover2]', this.product_image2);
			} else {
				if (this.product_image2_url === null) {
					formData.append('shop_product[cover2]', null);
				}
			}
			if (this.product_image3) {
				formData.append('shop_product[cover3]', this.product_image3);
			} else {
				if (this.product_image3_url === null) {
					formData.append('shop_product[cover3]', null);
				}
			}
			formData.append('shop_product[collaborators]', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.product.collaborators));
			formData.append('shop_product[creator_recoup_cost]', Math.round(this.product.creator_recoup_cost * 100));

			formData.append('shop_product[tax_percent]', __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.product, 'tax_percent', 0));
			formData.append('shop_product[is_vat]', __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.product, 'is_vat', false));
			formData.append('shop_product[seller_location]', __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.product, 'seller_location', ''));

			if (__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.digital_content, 'file.size', 0) > 0) {
				formData.append('shop_product[digital_content]', this.digital_content.file);
				formData.append('shop_product[digital_content_name]', this.digital_content.file.name);
			} else if (__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.digital_content, 'file.name', '') === '') {
				formData.append('shop_product[digital_content]', null);
				formData.append('shop_product[digital_content_name]', null);
			}

			__WEBPACK_IMPORTED_MODULE_4__services_product__["a" /* default */].updateProduct(this.product.id, formData).then(function (response) {
				_this4.loading = false;
				_this4.$store.dispatch('error/showLoadingActivity', false);
				_this4.$router.push({ path: '/manage', query: { tab: "products" } });
			}).catch(function (e) {
				_this4.loading = false;
				_this4.$store.dispatch('error/showLoadingActivity', false);
				_this4.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
			});
		},
		cancelToSaveProduct: function cancelToSaveProduct() {
			this.$router.push({ path: '/sell#products' });
		},
		deleteProductImage: function deleteProductImage(index) {
			if (index === 'product_image1') {
				this.product_image1 = null;
				this.product_image1_url = null;
			} else if (index === 'product_image2') {
				this.product_image2 = null;
				this.product_image2_url = null;
			} else {
				this.product_image3 = null;
				this.product_image3_url = null;
			}
		}
	},

	mounted: function mounted() {
		var _this5 = this;

		var vm = this;

		$.getJSON('../../static/countries.json', function (json) {
			var countries = json.countries;

			var _loop = function _loop(index) {
				var country = {
					value: countries[index]['name'],
					name: countries[index]['name']
				};
				if (!vm.destinations.find(function (c) {
					return c.value === country.value;
				})) {
					vm.destinations.push(country);
				}
			};

			for (var index in countries) {
				_loop(index);
			}
			vm.countries = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(countries, function (c) {
				return c['rate'] !== false;
			});
		});

		$.getJSON('../../static/states.json', function (data) {
			vm.states = data;
		});

		__WEBPACK_IMPORTED_MODULE_5__services_user__["a" /* default */].getAccessLevels(this.currentUser.id).then(function (response) {
			_this5.access_levels = response.body;
		}).catch(function (e) {
			_this5.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
		});
	}
});

/***/ }),
/* 1098 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_order__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_contentTopHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_contentTopHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_contentTopHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_activityproductcard__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_activityproductcard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_activityproductcard__);


// import AuthService from '@/services/auth'





/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		contentTopHeader: __WEBPACK_IMPORTED_MODULE_4__components_contentTopHeader___default.a,
		activityProductCard: __WEBPACK_IMPORTED_MODULE_5__components_activityproductcard___default.a
	},

	data: function data() {
		return {
			active: 'none',
			order_id: null,
			order_detail: null,
			isPageReady: false,
			tabs: [{ id: 'cart', title: 'Cart' }, { id: 'history', title: 'Order History' }],
			order_status: { 'order_pending': 'Pending', 'order_shipped': 'Shipped', 'order_refunded': 'Refunded' }
		};
	},


	computed: {
		currentUser: function currentUser() {
			return this.$store.state.auth.user;
		},
		user: function user() {
			return this.order_detail.customer;
		},
		shippingFullName: function shippingFullName() {
			return [__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(this.order_detail, 'shipping_address.first_name', ''), __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(this.order_detail, 'shipping_address.last_name', '')].join(' ');
		},
		subTotal: function subTotal() {
			var sum = 0;
			for (var index in this.order_detail.items) {
				var item = this.order_detail.items[index];
				if (this.isDigitalProduct(item)) {
					sum += item.price;
				} else {
					sum += item.price * item.quantity;
				}
			}
			return sum;
		},
		shippingTotal: function shippingTotal() {
			var sum = 0;
			for (var index in this.order_detail.items) {
				var item = this.order_detail.items[index];
				if (item.shipping_cost) {
					sum += item.shipping_cost;
				}
			}
			return sum;
		},
		taxTotal: function taxTotal() {
			var sum = 0;
			for (var index in this.order_detail.items) {
				var item = this.order_detail.items[index];
				if (item.tax) {
					sum += item.tax;
				}
			}
			return sum;
		},
		refundAmount: function refundAmount() {
			return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(this.order_detail, 'refund_amount', 0);
		},
		stripeFee: function stripeFee() {
			return __WEBPACK_IMPORTED_MODULE_3__helper__["d" /* Stripe */].calculateFee(this.subTotal + this.shippingTotal + this.taxTotal);
		},
		total: function total() {
			return this.subTotal + this.shippingTotal + this.taxTotal + this.stripeFee - this.refundAmount;
		}
	},

	created: function created() {
		var _this = this;

		// redirect to login when 401 error happens, check it in App.vue
		// if (!this.currentUser) {
		//   AuthService.clearTokenAndUserInfo()
		//   this.$router.push({ path: '/login' })
		//   return
		// }

		this.$store.dispatch('navigator/goNextState', { page: 'sell', tab: '' });
		this.order_id = this.$route.params.slug;
		if (this.order_id) {
			this.isPageReady = false;
			this.$store.dispatch('error/showLoadingActivity', true);
			__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_2__services_order__["a" /* default */].getOrder(this.order_id)]).then(function (values) {
				_this.order_detail = values[0].body;
				_this.isPageReady = true;
				_this.$store.dispatch('error/showLoadingActivity', false);
			}).catch(function (reason) {
				console.log(reason);
				_this.$store.dispatch('error/showLoadingActivity', false);
				// this.$store.dispatch('error/showErrorToast', [reason])
			});
		}
	},


	methods: {
		remainingDaysForShipment: function remainingDaysForShipment() {
			var shipmentDate = new Date(this.order_detail.updated_at);
			var currentDate = new Date();
			var difference = currentDate.getTime() - shipmentDate.getTime();
			var numberOfDays = Math.floor(difference / (1000 * 3600 * 24));
			return numberOfDays > 21 ? 0 : 21 - numberOfDays;
		},
		isDigitalProduct: function isDigitalProduct(item) {
			return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(item, 'product.category.is_digital', false);
		},
		isActiveTab: function isActiveTab(tab) {
			return this.active_tab === tab;
		},
		onTab: function onTab(tab) {
			this.$router.push({
				path: this.$route.path,
				hash: tab,
				query: {
					grid_view: this.grid_show
				}
			});
		}
	},

	mounted: function mounted() {}
});

/***/ }),
/* 1099 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_auth__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_item__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_order__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_product__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_user__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_productitem__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_productitem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_productitem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_profileitem__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_profileitem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_profileitem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_sendmessage__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_sendmessage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_sendmessage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_collaborate_product__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_collaborate_product___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_collaborate_product__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_contentTopHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_contentTopHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_contentTopHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_dashboardnav__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_dashboardnav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_dashboardnav__);

















var filterArrowDownString = '<i class="material-icons icon icon--right theme--dark">keyboard_arrow_down</i>';

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    collaborateProduct: __WEBPACK_IMPORTED_MODULE_12__components_collaborate_product___default.a,
    productItem: __WEBPACK_IMPORTED_MODULE_9__components_productitem___default.a,
    profileItem: __WEBPACK_IMPORTED_MODULE_10__components_profileitem___default.a,
    sendMessage: __WEBPACK_IMPORTED_MODULE_11__components_sendmessage___default.a,
    contentTopHeader: __WEBPACK_IMPORTED_MODULE_13__components_contentTopHeader___default.a,
    dashboardNav: __WEBPACK_IMPORTED_MODULE_14__components_dashboardnav___default.a
  },

  data: function data() {
    return {
      active_tab: 'orders',
      tabs: [
        // { id: 'orders', title: 'Orders' },
        // { id: 'products', title: 'Products' },
        // { id: 'collaborations', title: 'Collaborations' },
        // { id: 'pendings', title: 'Pending collaborations' },
      ],
      filters: [{ id: 'all', name: 'All' }, { id: 'creator_unshipped', name: 'Unshipped' }, { id: 'creator_shipped', name: 'Shipped' }, { id: 'collaborator_unshipped', name: 'Collaborated Unshipped' }, { id: 'collaborator_shipped', name: 'Collaborated Shipped' }, { id: 'refunded', name: 'Refunded' }],
      activeFilter: {},
      exportPeriod: null,
      show_product_finish_modal: false,
      show_ship_confirm_modal: false,
      show_unship_confirm_modal: false,
      show_ship_all_confirm_dialog: false,
      show_help_dialog: false,
      product_delete_confirm_dialog: false,
      showSendMessage: false,
      valid_tracking_form: true,
      shipping_id: null,
      order_detail: null,
      orderHistories: [],
      order_pagination: {
        current_page: 1,
        per_page: 100
      },
      products: [],
      product: {},
      selected_item: {},
      tracking_site: null,
      tracking_number: null,
      page_index: 1,
      total_pages: 1,
      items_per_page: 6 * 5,
      isPageReady: false,
      defaultSortBy: 'DESC',
      sorting: [{ id: 'ASC', name: 'Asc' }, { id: 'DESC', name: 'Desc' }]
    };
  },


  computed: {
    isSidebarMini: function isSidebarMini() {
      return this.$store.state.app.sideBarMini;
    },
    currentUser: function currentUser() {
      return this.$store.state.auth.user;
    },
    user: function user() {
      return this.order_detail.customer;
    },
    published_products: function published_products() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(this.products, function (item) {
        return item.status === 'published';
      });
    },
    pending_products: function pending_products() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(this.products, function (item) {
        return item.status == 'pending';
      });
    },
    collaborated_products: function collaborated_products() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(this.products, function (item) {
        return item.status == 'collaborated';
      });
    },
    activeFilterName: function activeFilterName() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(this.activeFilter, 'name', 'All');
    },
    activeFilterItemStatus: function activeFilterItemStatus() {
      var status = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(this.activeFilter, 'id', '').split('_')[1] || '';
      var item_status = '';
      switch (status) {
        case 'shipped':
          item_status = 'item_shipped';
          break;
        case 'unshipped':
          item_status = 'item_ordered';
          break;
        default:
          item_status = '';
          break;
      }
      return item_status;
    }
  },

  watch: {
    $route: function $route(toPath, fromPath) {
      var tab = toPath.hash.substr(1);
      this.setTab(tab);
    }
  },

  created: function created() {
    var _this = this;

    if (!this.currentUser) {
      __WEBPACK_IMPORTED_MODULE_4__services_auth__["a" /* default */].clearTokenAndUserInfo();
      this.$router.push({ path: '/login' });
      return;
    }

    if (['artist', 'brand', 'label'].indexOf(this.$store.state.auth.user.user_type) == -1) {
      this.$router.push({ path: '/' });
      return;
    }

    // if (this.currentUser.data['sell_page_visited'] !== 1) {
    //   this.openHelpDialog()
    // }

    var tab = this.$route.hash.substr(1);
    this.setTab(tab);

    var lastState = this.$store.getters['navigator/last'];
    if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(lastState, 'params.product_id')) {
      __WEBPACK_IMPORTED_MODULE_7__services_product__["a" /* default */].getProduct(lastState.params.product_id).then(function (response) {
        _this.product = response.body;
        _this.openProductFinishModal();
      });
    }

    this.isPageReady = false;
    this.$store.dispatch('error/showLoadingActivity', true);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_6__services_order__["a" /* default */].getReceivedOrders({
      page: this.order_pagination.current_page,
      per_page: this.order_pagination.per_page,
      sort: this.defaultSortBy
    }), __WEBPACK_IMPORTED_MODULE_7__services_product__["a" /* default */].getProducts()]).then(function (values) {
      _this.orderHistories = values[0].body.orders;
      _this.order_pagination = values[0].body.pagination;
      _this.products = values[1].body;
      _this.isPageReady = true;
      _this.$store.dispatch('error/showLoadingActivity', false);

      _this.filterItems(_this.filters[0]);
    }).catch(function (reason) {
      console.log(reason);
      _this.$store.dispatch('error/showLoadingActivity', false);
      _this.$store.dispatch('error/showErrorToast', reason);
    });
  },


  methods: {
    isActiveTab: function isActiveTab(filter) {
      return this.active_tab == filter;
    },
    loadProducts: function loadProducts() {
      var _this2 = this;

      this.$store.dispatch('error/showLoadingActivity', true);
      __WEBPACK_IMPORTED_MODULE_7__services_product__["a" /* default */].getProducts().then(function (response) {
        _this2.products = response.body;
        _this2.$store.dispatch('error/showLoadingActivity', false);
      });
    },
    loadOrders: function loadOrders() {
      var _this3 = this;

      this.$store.dispatch('error/showLoadingActivity', true);
      __WEBPACK_IMPORTED_MODULE_6__services_order__["a" /* default */].getReceivedOrders({
        page: this.order_pagination.current_page + 1,
        per_page: this.order_pagination.per_page,
        sort: this.defaultSortBy
      }).then(function (response) {
        _this3.orderHistories = _this3.orderHistories.concat(response.body.orders);
        _this3.order_pagination = response.body.pagination;
        _this3.$store.dispatch('error/showLoadingActivity', false);
      });
    },
    addProduct: function addProduct() {
      this.$router.push({ path: '/product/add' });
    },
    onTab: function onTab(tab) {
      this.$router.push({
        path: this.$route.path,
        hash: tab
      });
    },
    setTab: function setTab(tab) {
      if (!tab) {
        tab = 'orders';
      }

      this.active_tab = tab;
      // this.$store.dispatch('navigator/setCurrentState', { page: 'sell', tab: tab })
      this.$store.dispatch('navigator/goNextState', { page: 'sell', tab: tab });
    },
    isDigitalProduct: function isDigitalProduct(item) {
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(item, 'product.category.is_digital', false);
    },
    isCollaborated: function isCollaborated(item) {
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(item.product.collaborators, {
        user_id: this.currentUser.id
      });
    },
    editProduct: function editProduct(product) {
      this.$router.push('/product/edit/' + product.id);
    },
    openHelpDialog: function openHelpDialog() {
      this.show_help_dialog = true;
    },
    closeHelpDialog: function closeHelpDialog() {
      var _this4 = this;

      this.show_help_dialog = false;
      var params = {
        user: {
          sell_page_visited: 1
        }
      };
      __WEBPACK_IMPORTED_MODULE_8__services_user__["a" /* default */].updateUserInfo(this.currentUser.id, params).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_4__services_auth__["a" /* default */].setUser(response.body);
        _this4.$store.dispatch('auth/setUser', response.body);
      });
    },
    openProductFinishModal: function openProductFinishModal() {
      this.show_product_finish_modal = true;
    },
    closeProductFinishModal: function closeProductFinishModal() {
      this.show_product_finish_modal = false;
    },


    // openShipAllConfirmDialog() {
    //   this.show_ship_all_confirm_dialog = true
    // },

    // closeShipAllConfirmDialog() {
    //   this.show_ship_all_confirm_dialog = false
    // },

    // shipAll() {
    //   this.$store.dispatch('error/showLoadingActivity', true)
    //   ItemService.markAllShipped().then(response => {
    //     _.each(this.orderHistories, (order) => {
    //       _.each(order.items, (item) => {
    //         item.status = 'item_shipped'
    //       })
    //     })
    //     const arr = this.orderHistories.slice()
    //     this.orderHistories = arr
    //     this.closeShipAllConfirmDialog()
    //     this.$store.dispatch('error/showLoadingActivity', false)
    //   }).catch(e => {
    //     this.closeShipAllConfirmDialog()
    //     this.$store.dispatch('error/showLoadingActivity', false)
    //   })
    // },

    csvExport: function csvExport() {
      var params = {};
      if (this.exportPeriod && this.exportPeriod.start) {
        params['start_date'] = this.exportPeriod.start + ' 00:00:00';
      }
      if (this.exportPeriod && this.exportPeriod.end) {
        params['end_date'] = this.exportPeriod.end + ' 23:59:59';
      }
      __WEBPACK_IMPORTED_MODULE_6__services_order__["a" /* default */].receivedExport(params).then(function (response) {
        var csvData = 'data:text/csv;charset=utf-8,' + encodeURIComponent(response.body);
        var filename = 'order-items-' + __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYYMMDD') + '.csv';
        __WEBPACK_IMPORTED_MODULE_3__helper__["f" /* Utils */].downloadFile(csvData, filename);
      });
    },
    openShipConfirmModal: function openShipConfirmModal(item) {
      this.selected_item = item;
      this.show_ship_confirm_modal = true;
      this.tracking_site = __WEBPACK_IMPORTED_MODULE_3__helper__["g" /* Storage */].get(__WEBPACK_IMPORTED_MODULE_3__helper__["L" /* MyCookies */].TRACKING_SITE);
    },
    closeShipConfirmModal: function closeShipConfirmModal() {
      this.$refs.valid_tracking_form.reset();
      this.show_ship_confirm_modal = false;
    },
    shipItem: function shipItem() {
      var _this5 = this;

      if (this.$refs.valid_tracking_form.validate()) {
        var itemId = this.selected_item.id;
        var params = {
          tracking_site: this.tracking_site,
          tracking_number: this.tracking_number
        };
        __WEBPACK_IMPORTED_MODULE_5__services_item__["a" /* default */].markShipped(itemId, params).then(function (response) {
          __WEBPACK_IMPORTED_MODULE_3__helper__["g" /* Storage */].set(__WEBPACK_IMPORTED_MODULE_3__helper__["L" /* MyCookies */].TRACKING_SITE, _this5.tracking_site);
          var item = void 0;
          __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(_this5.orderHistories, function (order) {
            item = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(order.items, { id: itemId });
            if (item) {
              return false;
            }
          });
          item.status = 'item_shipped';
          var arr = _this5.orderHistories.slice();
          _this5.orderHistories = arr;
          _this5.closeShipConfirmModal();
        }).catch(function (e) {
          _this5.closeShipConfirmModal();
        });
      }
    },
    openUnshipConfirmModal: function openUnshipConfirmModal(item) {
      this.selected_item = item;
      this.show_unship_confirm_modal = true;
    },
    closeUnshipConfirmModal: function closeUnshipConfirmModal() {
      this.show_unship_confirm_modal = false;
    },
    unshipItem: function unshipItem() {
      var _this6 = this;

      var itemId = this.selected_item.id;
      __WEBPACK_IMPORTED_MODULE_5__services_item__["a" /* default */].markUnshipped(itemId).then(function (response) {
        var item = void 0;
        __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(_this6.orderHistories, function (order) {
          item = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(order.items, { id: itemId });
          if (item) {
            return false;
          }
        });
        item.status = 'item_ordered';
        var arr = _this6.orderHistories.slice();
        _this6.orderHistories = arr;
        _this6.closeUnshipConfirmModal();
      }).catch(function (e) {
        _this6.closeUnshipConfirmModal();
      });
    },
    showMessageDialog: function showMessageDialog(order) {
      this.order_detail = order;
      this.showSendMessage = true;
    },
    dismissMessageModal: function dismissMessageModal() {
      this.showSendMessage = false;
    },
    openProductDeleteConfirmDialog: function openProductDeleteConfirmDialog(product) {
      this.product = product;
      this.product_delete_confirm_dialog = true;
    },
    closeProductDeleteConfirmDialog: function closeProductDeleteConfirmDialog() {
      this.product = {};
      this.product_delete_confirm_dialog = false;
    },
    deleteProduct: function deleteProduct() {
      var _this7 = this;

      __WEBPACK_IMPORTED_MODULE_7__services_product__["a" /* default */].deleteProduct(this.product.id).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.remove(_this7.products, function (item) {
          return item.id == _this7.product.id;
        });
        var arr = _this7.products.slice();
        _this7.products = arr;
        _this7.closeProductDeleteConfirmDialog();
      }).catch(function (e) {
        _this7.closeProductDeleteConfirmDialog();
        _this7.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    releaseProduct: function releaseProduct(product) {
      var _this8 = this;

      __WEBPACK_IMPORTED_MODULE_7__services_product__["a" /* default */].releaseProduct(product.id).then(function (response) {
        _this8.active_tab = 'collaborations';
        _this8.loadProducts();
      });
    },
    notResponded: function notResponded(product) {
      var _this9 = this;

      var collaborator = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(product.collaborators, function (c) {
        return c.user_id == _this9.$store.state.auth.user.id;
      });
      // console.log('notResponded', this.$store.state.auth.user.id, collaborator)
      return collaborator && collaborator.status == 'pending';
    },
    acceptCollaboration: function acceptCollaboration(product) {
      var _this10 = this;

      __WEBPACK_IMPORTED_MODULE_7__services_product__["a" /* default */].acceptCollaboration(product.id).then(function (response) {
        _this10.loadProducts();
      });
    },
    denyCollaboration: function denyCollaboration(product) {
      var _this11 = this;

      __WEBPACK_IMPORTED_MODULE_7__services_product__["a" /* default */].denyCollaboration(product.id).then(function (response) {
        _this11.loadProducts();
      });
    },
    filterItems: function filterItems(filter) {
      var _this12 = this;

      if (this.activeFilter == filter) return;

      $('#item_filter .btn__content').html(filter.name + filterArrowDownString);

      switch (filter.id) {
        case 'any':
          this.activeFilter = null;
          break;
        default:
          this.activeFilter = filter;
      }

      var params = {
        page: this.page_index,
        per_page: this.items_per_page,
        status: filter.id,
        sort: this.defaultSortBy
      };
      this.$store.dispatch('error/showLoadingActivity', true);
      __WEBPACK_IMPORTED_MODULE_6__services_order__["a" /* default */].getReceivedOrders(params).then(function (response) {
        _this12.orderHistories = response.body.orders;
        _this12.$store.dispatch('error/showLoadingActivity', false);
      }).catch(function (e) {
        _this12.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
        _this12.$store.dispatch('error/showLoadingActivity', false);
      });
    },
    sortItems: function sortItems(event) {
      var _this13 = this;

      console.log("sortBy===>", event.target.value);
      var selectedVal = event.target.value;
      if (this.defaultSortBy == selectedVal) return;

      this.defaultSortBy = selectedVal;

      var params = {
        page: this.page_index,
        per_page: this.items_per_page,
        sort: this.defaultSortBy
      };

      if (this.activeFilter !== null) {
        params.status = this.activeFilter.id;
      }
      this.$store.dispatch('error/showLoadingActivity', true);
      __WEBPACK_IMPORTED_MODULE_6__services_order__["a" /* default */].getReceivedOrders(params).then(function (response) {
        _this13.orderHistories = response.body.orders;
        _this13.$store.dispatch('error/showLoadingActivity', false);
      }).catch(function (e) {
        _this13.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
        _this13.$store.dispatch('error/showLoadingActivity', false);
      });
    }
  },

  mounted: function mounted() {}
});

/***/ }),
/* 1100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__subscription_plan__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__subscription_plan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__subscription_plan__);


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    subscriptionPlan: __WEBPACK_IMPORTED_MODULE_0__subscription_plan___default.a
  },
  data: function data() {
    return {
      optionPremium: [{ id: 1, text: "Unlimited streaming" }, { id: 2, text: "No Ads" }, { id: 3, text: "Offline listening" }, { id: 4, text: "Unlimited uploads (for creators)" }],
      optionCreators: [{ id: 1, text: "Unlimited streaming" }, { id: 2, text: "No Ads" }, { id: 3, text: "Offline listening" }, { id: 4, text: "Unlimited uploads (for creators)" }, { id: 5, text: "Analytics (for creators)" }]
    };
  }
});

/***/ }),
/* 1101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_address__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_auth__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_user__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    actionRight: {
      type: Boolean,
      default: false
    },
    editDialog: {
      type: Boolean,
      default: false
    },
    header: {
      type: String,
      default: 'Add or change your default shipping address for all of the physical orders you place'
    },
    singleCol: Boolean,
    hideRequireIcon: Boolean
  },
  data: function data() {
    return {
      countries: __WEBPACK_IMPORTED_MODULE_4__helper__["s" /* Countries */],
      states: __WEBPACK_IMPORTED_MODULE_4__helper__["I" /* States */],
      shipping_address: {
        id: '',
        first_name: '',
        last_name: '',
        street_address: '',
        address_line: '',
        city: '',
        state: '',
        postcode: '',
        country: ''
      },
      isPageReady: false
    };
  },


  computed: {
    isCountryUS: function isCountryUS() {
      return this.shipping_address.country === 'United States';
    },
    strippedAddress: function strippedAddress() {
      var addr = this.shipping_address;
      var stripped = {};
      stripped.lineOne = addr.first_name + ' ' + addr.last_name;
      stripped.lineTwo = addr.address_line;
      stripped.lineThree = addr.city + ' ' + addr.state;
      stripped.lineFour = addr.postcode;
      stripped.lineFive = addr.country;

      return stripped;
      // return Object.values(stripped).join("\r\n")
    }
  },

  created: function created() {
    this.resetShippingAddress();
  },


  methods: {
    resetShippingAddress: function resetShippingAddress() {
      var address = this.$store.state.auth.user.default_address;
      if (address) {
        this.shipping_address.id = address.id;
        this.shipping_address.first_name = address.first_name;
        this.shipping_address.last_name = address.last_name;
        this.shipping_address.street_address = address.street_1;
        this.shipping_address.address_line = address.street_2;
        this.shipping_address.city = address.city;
        this.shipping_address.state = address.state;
        this.shipping_address.postcode = address.postcode;
        this.shipping_address.country = address.country;
      }
    },
    submit: function submit() {
      var _this = this;

      this.$validator.validateAll().then(function (response) {
        if (response === true) {
          _this.saveShippingAddress();
        } else {
          _this.$store.dispatch('error/showErrorToast', _this.errors.items.map(function (item) {
            return item.msg;
          }));
        }
      }).catch(function (e) {
        console.log('validate error', e);
      });
    },
    saveShippingAddress: function saveShippingAddress() {
      var _this2 = this;

      var userId = this.$store.state.auth.user.id;
      var params = {
        shop_address: {
          first_name: this.shipping_address.first_name,
          last_name: this.shipping_address.last_name,
          street_1: this.shipping_address.street_address,
          street_2: this.shipping_address.address_line,
          city: this.shipping_address.city,
          state: this.shipping_address.state,
          country: this.shipping_address.country,
          postcode: this.shipping_address.postcode,
          set_default: 1
        }
      };
      this.$store.dispatch('error/showLoadingActivity', true);
      if (this.shipping_address.id === '') {
        __WEBPACK_IMPORTED_MODULE_1__services_address__["a" /* default */].addAddress(params).then(function (response) {
          _this2.$store.dispatch('error/showLoadingActivity', false);
          _this2.$store.dispatch('error/showSuccessToast', ['Saved']);
          __WEBPACK_IMPORTED_MODULE_3__services_user__["a" /* default */].getUserInfo(userId).then(function (response) {
            return __WEBPACK_IMPORTED_MODULE_2__services_auth__["a" /* default */].setUser(response.body);
          });
        }).catch(function (e) {
          _this2.$store.dispatch('error/showLoadingActivity', false);
          _this2.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_1__services_address__["a" /* default */].updateAddress(this.shipping_address.id, params).then(function (response) {
          _this2.$store.dispatch('error/showLoadingActivity', false);
          _this2.$store.dispatch('error/showSuccessToast', ['Saved']);
          __WEBPACK_IMPORTED_MODULE_3__services_user__["a" /* default */].getUserInfo(userId).then(function (response) {
            return __WEBPACK_IMPORTED_MODULE_2__services_auth__["a" /* default */].setUser(response.body);
          });
        }).catch(function (e) {
          _this2.$store.dispatch('error/showLoadingActivity', false);
          _this2.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
        });
      }
    }
  }
});

/***/ }),
/* 1102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_on_click_outside__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_on_click_outside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_on_click_outside__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_auth__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_genre__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_preset__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_user__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helper__ = __webpack_require__(2);








/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1_vue_on_click_outside__["mixin"]],

  data: function data() {
    return {
      genres: [],
      parent: null,
      parent_index: 0,
      presets: [],
      preset_name: '',
      show_selector_view: true,
      show_load_genre_confirm_dialog: false,
      show_load_genre_dialog: false,
      isPageReady: true
    };
  },


  // created() {
  //   this.isPageReady = false
  //   this.$store.dispatch('error/showLoadingActivity', true)
  //   GenreService.getGenres2().then(response => {
  //     this.genres = response.body
  //     let hiddenGenres = _.keyBy(this.$store.state.auth.user.hidden_genres, 'id')
  //     _.each(this.genres, (genre) => {
  //       // genre.value = !!hiddenGenres[genre.id]
  //       // if (genre.value) {
  //       //   _.each(genre.children, (g) => { g.value = true })
  //       // } else {
  //       //   _.each(genre.children, (g) => { g.value = !!hiddenGenres[g.id] })
  //       // }
  //       _.each(genre.children, (g) => { g.value = !hiddenGenres[g.id] })
  //     })
  //     // it stores only child genres statuses
  //     _.each(this.genres, (genre) => {
  //       if (!_.countBy(genre.children, 'value')['false']) {
  //         genre.value = true
  //       }
  //     })
  //     this.isPageReady = true
  //     this.$store.dispatch('error/showLoadingActivity', false)
  //     this.$forceUpdate()
  //   }).catch(e => {
  //     this.$store.dispatch('error/showLoadingActivity', false)
  //   })
  // },

  created: function created() {
    this.loadGenre();
  },


  methods: {
    loadGenre: function loadGenre() {
      this.genres = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.$store.state.app.genres);
      var hiddenGenres = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.keyBy(this.$store.state.auth.user.hidden_genres, 'id');

      __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(this.genres, function (genre) {
        __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(genre.children, function (g) {
          g.value = !hiddenGenres[g.id];
        });
      });

      // it stores only child genres statuses
      __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(this.genres, function (genre) {
        if (!__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.countBy(genre.children, 'value')['false']) {
          genre.value = true;
        }
      });

      this.$forceUpdate();
    },
    openLoadGenreConfirmDialog: function openLoadGenreConfirmDialog() {
      this.preset_name = '';
      this.show_load_genre_confirm_dialog = true;
    },
    closeLoadGenreConfirmDialog: function closeLoadGenreConfirmDialog() {
      this.show_load_genre_confirm_dialog = false;
      this.openLoadGenreDialog();
    },
    openLoadGenreDialog: function openLoadGenreDialog() {
      var _this = this;

      this.$store.dispatch('error/showLoadingActivity', true);
      __WEBPACK_IMPORTED_MODULE_4__services_preset__["a" /* default */].getPresets().then(function (response) {
        _this.presets = response.body;
        _this.show_load_genre_dialog = true;
        _this.$store.dispatch('error/showLoadingActivity', false);
      });
    },
    closeLoadGenreDialog: function closeLoadGenreDialog() {
      this.show_load_genre_dialog = false;
    },
    savePreset: function savePreset() {
      var _this2 = this;

      this.preset_name = this.preset_name.trim();
      if (this.preset_name == '') {
        this.$store.dispatch('error/showErrorToast', ['Please enter preset name']);
        return;
      }

      this.$store.dispatch('error/showLoadingActivity', true);
      __WEBPACK_IMPORTED_MODULE_4__services_preset__["a" /* default */].createPreset({
        name: this.preset_name
      }).then(function (response) {
        _this2.$store.dispatch('error/showLoadingActivity', false);
        _this2.closeLoadGenreConfirmDialog();
      });
    },
    loadPreset: function loadPreset(presetId) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_4__services_preset__["a" /* default */].loadPreset(presetId).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_2__services_auth__["a" /* default */].setUser(response.body);
        _this3.loadGenre();
        _this3.closeLoadGenreDialog();
      });
    },
    removePreset: function removePreset(presetId) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_4__services_preset__["a" /* default */].deletePreset(presetId).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.remove(_this4.presets, function (preset) {
          return preset.id == presetId;
        });
        var arr = _this4.presets.slice();
        _this4.presets = arr;
      });
    },
    checkParentGenre: function checkParentGenre(parent, value) {
      __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(parent.children, function (g) {
        g.value = !parent.value;
      });
      // this.genres = this.genres.slice()
      if (!(value == null || value == undefined)) {
        parent.value = !parent.value;
      }
      this.$forceUpdate();
    },
    checkChildGenre: function checkChildGenre(parent, child) {
      if (child.value) {
        if (parent.value) {
          parent.value = false;
          // this.genres = this.genres.slice()
        }
      } else {
        if (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.countBy(parent.children, 'value')['false'] == 1) {
          parent.value = true;
          // this.genres = this.genres.slice()
        }
      }
      this.$forceUpdate();
    },
    getSelectedChildrenCount: function getSelectedChildrenCount(parent) {
      var c = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.countBy(parent.children, 'value')['true'];
      return c > 0 ? c : 0;
    },
    selectParent: function selectParent(parent, index) {
      this.show_selector_view = false;
      this.parent = parent;
      this.parent_index = index;
    },
    saveGenreFilters: function saveGenreFilters() {
      var _this5 = this;

      var is_genres_selected = false;
      var genre_ids = [];
      __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(this.genres, function (parent) {
        // _.chain(parent.children).filter((child) => (chid.value)).map('id').value()
        __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(parent.children, function (child) {
          if (!child.value) {
            genre_ids.push(child.id);
          }

          if (child.value && !is_genres_selected) {
            is_genres_selected = true;
          }
        });
      });

      if (!is_genres_selected) {
        this.$store.dispatch('error/showErrorToast', ['Please select at least 1 genre']);
        return;
      }

      var userId = this.$store.state.auth.user.id;
      var params = {
        genre_ids: genre_ids.join(',')
      };
      this.$store.dispatch('error/showLoadingActivity', true);
      __WEBPACK_IMPORTED_MODULE_5__services_user__["a" /* default */].hiddenUserGenres(userId, params).then(function (res) {
        _this5.$store.dispatch('error/showLoadingActivity', false);
        _this5.$store.dispatch('error/showSuccessToast', ['Saved']);
        __WEBPACK_IMPORTED_MODULE_5__services_user__["a" /* default */].getUserInfo(userId).then(function (response) {
          return __WEBPACK_IMPORTED_MODULE_2__services_auth__["a" /* default */].setUser(response.body);
        });
      }).catch(function (e) {
        _this5.$store.dispatch('error/showLoadingActivity', false);
        _this5.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    }
  }
});

/***/ }),
/* 1103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    title: {
      type: String,
      default: ""
    },

    subtitle: {
      type: String,
      default: ""
    },
    price: {
      type: String,
      default: "10"
    },
    optionList: {
      type: Array,
      default: function _default() {
        [];
      }
    }
  }
});

/***/ }),
/* 1104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_auth__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_user__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_paymentmodal__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_paymentmodal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_paymentmodal__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    paymentModal: __WEBPACK_IMPORTED_MODULE_2__components_paymentmodal___default.a
  },

  props: {
    user: {
      type: Object,
      required: true
    },

    textAreaHeight: {
      type: Number,
      required: false
    },

    updateUser: {
      type: Function,
      required: true
    },

    isSaveAllMode: {
      type: Boolean,
      required: false
    }
  },

  data: function data() {
    return {};
  },
  created: function created() {},


  methods: {
    saveAllMode: function saveAllMode() {
      this.saveReturnPolicy();
      this.saveShippingPolicy();
      this.saveSizeChart();
      this.savePrivacyPolicy();
    },
    saveReturnPolicy: function saveReturnPolicy() {
      var params = {
        user: {
          return_policy: this.user.return_policy
        }
      };
      this.updateUser(params);
    },
    saveShippingPolicy: function saveShippingPolicy() {
      var params = {
        user: {
          shipping_policy: this.user.shipping_policy
        }
      };
      this.updateUser(params);
    },
    saveSizeChart: function saveSizeChart() {
      var params = {
        user: {
          size_chart: this.user.size_chart
        }
      };
      this.updateUser(params);
    },
    savePrivacyPolicy: function savePrivacyPolicy() {
      var params = {
        user: {
          privacy_policy: this.user.privacy_policy
        }
      };
      this.updateUser(params);
    }
  }
});

/***/ }),
/* 1105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_auth__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_user__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_paymentmodal__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_paymentmodal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_paymentmodal__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    paymentModal: __WEBPACK_IMPORTED_MODULE_2__components_paymentmodal___default.a
  },

  data: function data() {
    return {
      prices: [100, 500, 1000, 2000, 5000, 10000, 25000, 50000, 100000, 250000, 500000, 1000000, 2500000, 5000000, 10000000, 25000000, 50000000, 100000000],
      repost_price: 100,
      proration: {
        add_amount: 0,
        expire_at: null
      },
      show_repost_price_confirm_modal: false,
      show_payment_modal: false,
      isPageReady: false
    };
  },


  computed: {
    currentUser: function currentUser() {
      return this.$store.state.auth.user;
    },
    repost_prices: function repost_prices() {
      var arr = [];
      for (var i in this.prices) {
        arr.push({
          name: '$' + this.prices[i] / 100 + (this.prices[i] > this.currentUser.max_repost_price ? ' Upgrade' : ''),
          value: this.prices[i]
        });
      }
      return arr;
    }
  },

  created: function created() {
    this.resetRepostPrice();
  },


  methods: {
    resetRepostPrice: function resetRepostPrice() {
      this.repost_price = this.currentUser.repost_price;
    },
    openRepostPriceConfirmModal: function openRepostPriceConfirmModal() {
      var _this = this;

      if (this.repost_price == this.currentUser.repost_price) {
        return;
      }

      var params = {
        new_repost_price: this.repost_price
      };
      this.$store.dispatch('error/showLoadingActivity', true);
      __WEBPACK_IMPORTED_MODULE_1__services_user__["a" /* default */].getRepostPriceProration(this.currentUser.id, params).then(function (response) {
        _this.$store.dispatch('error/showLoadingActivity', false);
        _this.proration = response.body;
        // console.log(this.proration)
        if (_this.proration.add_amount > 0) {
          _this.show_repost_price_confirm_modal = true;
        } else {
          _this.setRepostPrice(null);
        }
      }).catch(function (e) {
        _this.$store.dispatch('error/showLoadingActivity', false);
      });
    },
    closeRepostPriceConfirmModal: function closeRepostPriceConfirmModal() {
      this.show_repost_price_confirm_modal = false;
    },
    openPaymentModal: function openPaymentModal() {
      this.closeRepostPriceConfirmModal();
      if (this.proration.add_amount > 0) {
        this.show_payment_modal = true;
      } else {
        this.setRepostPrice(null);
      }
    },
    closePaymentModal: function closePaymentModal() {
      this.show_payment_modal = false;
    },
    setRepostPrice: function setRepostPrice(token) {
      var _this2 = this;

      var params = {
        repost_price: this.repost_price,
        payment_amount: this.proration.add_amount
        // console.log('setRepostPrice', params)
      };if (token) {
        params['payment_token'] = token.id;
      }
      this.$store.dispatch('error/showLoadingActivity', true);
      __WEBPACK_IMPORTED_MODULE_1__services_user__["a" /* default */].setRepostPrice(this.currentUser.id, params).then(function (response) {
        _this2.$store.dispatch('error/showLoadingActivity', false);
        _this2.$store.dispatch('error/showSuccessToast', ['Saved']);
        __WEBPACK_IMPORTED_MODULE_0__services_auth__["a" /* default */].setUser(response.body);
      }).catch(function (e) {
        _this2.$store.dispatch('error/showLoadingActivity', false);
        _this2.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    learnMore: function learnMore() {
      this.$router.push({
        path: '/terms'
      });
    }
  }
});

/***/ }),
/* 1106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_card__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__package_card__);


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    packageCard: __WEBPACK_IMPORTED_MODULE_0__package_card___default.a
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    subtitle: {
      type: String,
      default: ""
    },
    monthlyPrice: {
      type: String,
      default: "10"
    },
    annualPrice: {
      type: String,
      default: "10"
    },
    optionList: {
      type: Array,
      default: function _default() {
        [];
      }
    }
  },
  data: function data() {
    return {
      tab: "yearly",
      tabList: [{ id: "yearly", title: "Yearly (Save 20%)" }, { id: "monthly", title: "Monthly" }]
    };
  },

  methods: {
    setTab: function setTab(tab) {
      this.tab = tab;
    }
  }
});

/***/ }),
/* 1107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_auth__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_user__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helper__ = __webpack_require__(2);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},

  data: function data() {
    return {
      user: {},
      main_genres: [],
      sub_genres: [],
      year_of_birth_options: [],
      isPageReady: false
    };
  },


  computed: {
    enabledForm: function enabledForm() {
      return this.user.request_status == 'denied';
    },
    reviewerName: function reviewerName() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(this.user.approver, 'display_name', '--');
    },
    country_options: function country_options() {
      return __WEBPACK_IMPORTED_MODULE_5__helper__["s" /* Countries */];
    },
    gender_options: function gender_options() {
      return __WEBPACK_IMPORTED_MODULE_5__helper__["t" /* UserGenderOptions */];
    },
    boolean_options: function boolean_options() {
      return __WEBPACK_IMPORTED_MODULE_5__helper__["u" /* UserBooleanOptions */];
    },
    artist_type_options: function artist_type_options() {
      return __WEBPACK_IMPORTED_MODULE_5__helper__["v" /* UserArtistTypeOptions */];
    },
    released_albums_count_options: function released_albums_count_options() {
      return __WEBPACK_IMPORTED_MODULE_5__helper__["w" /* UserReleasedAlbumsCountOptions */];
    },
    years_since_first_released_options: function years_since_first_released_options() {
      return __WEBPACK_IMPORTED_MODULE_5__helper__["x" /* UserYearsSinceFirstReleasedOptions */];
    },
    annual_income_on_merch_sales_options: function annual_income_on_merch_sales_options() {
      return __WEBPACK_IMPORTED_MODULE_5__helper__["y" /* UserAnnualIncomeOnMerchSalesOptions */];
    },
    annual_performances_count_options: function annual_performances_count_options() {
      return __WEBPACK_IMPORTED_MODULE_5__helper__["z" /* UserAnnualPerformancesCountOptions */];
    },
    signed_status_options: function signed_status_options() {
      return __WEBPACK_IMPORTED_MODULE_5__helper__["A" /* UserSignedStatusOptions */];
    },
    performance_rights_organization_options: function performance_rights_organization_options() {
      return __WEBPACK_IMPORTED_MODULE_5__helper__["B" /* UserPerformanceRightsOrganizationOptions */];
    },
    artists_count_options: function artists_count_options() {
      return __WEBPACK_IMPORTED_MODULE_5__helper__["C" /* UserArtistsCountOptions */];
    },
    standard_brand_type_options: function standard_brand_type_options() {
      return __WEBPACK_IMPORTED_MODULE_5__helper__["D" /* UserStandardBrandTypeOptions */];
    },
    employees_count_options: function employees_count_options() {
      return __WEBPACK_IMPORTED_MODULE_5__helper__["E" /* UserEmployeesCountOptions */];
    },
    years_in_business_options: function years_in_business_options() {
      return __WEBPACK_IMPORTED_MODULE_5__helper__["F" /* UserYearsInBusinessOptions */];
    },
    products_count_options: function products_count_options() {
      return __WEBPACK_IMPORTED_MODULE_5__helper__["G" /* UserProductsCountOptions */];
    },
    annual_income_options: function annual_income_options() {
      return __WEBPACK_IMPORTED_MODULE_5__helper__["H" /* UserAnnualIncomeOptions */];
    }
  },

  created: function created() {
    var _this = this;

    this.isPageReady = false;
    this.$store.dispatch('error/showLoadingActivity', true);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_4__services_user__["a" /* default */].getUserInfo(this.$store.state.auth.user.id)]).then(function (values) {
      _this.user = values[0].body;

      _this.main_genres = _this.$store.state.app.genres;
      _this.sub_genres = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.flatMap(_this.$store.state.app.genres, 'children');

      var current_year = __WEBPACK_IMPORTED_MODULE_2_moment___default()().year();
      for (var i = 1900; i < current_year; i++) {
        _this.year_of_birth_options.push(i);
      }

      _this.isPageReady = true;
      _this.$store.dispatch('error/showLoadingActivity', false);
    }).catch(function (reason) {
      console.log('reason', reason);
      _this.$store.dispatch('error/showLoadingActivity', false);
    });
  },


  methods: {
    submit: function submit() {
      var vm = this;
      this.$validator.validateAll().then(function (response) {
        if (response === true) {
          var params = {
            user: {
              first_name: vm.user.first_name,
              last_name: vm.user.last_name,
              year_of_birth: vm.user.year_of_birth,
              gender: vm.user.gender,
              country: vm.user.country,
              city: vm.user.city,

              genre_id: vm.user.genre_id,
              artist_type: vm.user.artist_type,
              released_albums_count: vm.user.released_albums_count,
              years_since_first_released: vm.user.years_since_first_released,
              will_run_live_video: vm.user.will_run_live_video,
              will_sell_products: vm.user.will_sell_products,
              will_sell_physical_copies: vm.user.will_sell_physical_copies,
              annual_income_on_merch_sales: vm.user.annual_income_on_merch_sales,
              annual_performances_count: vm.user.annual_performances_count,
              signed_status: vm.user.signed_status,
              performance_rights_organization: vm.user.performance_rights_organization,
              ipi_cae_number: vm.user.ipi_cae_number,
              website_1_url: vm.user.website_1_url,
              website_2_url: vm.user.website_2_url,
              history: vm.user.history,

              sub_genre_id: vm.user.sub_genre_id,
              is_business_registered: vm.user.is_business_registered,
              artists_count: vm.user.artists_count,

              standard_brand_type: vm.user.standard_brand_type,
              customized_brand_type: vm.user.customized_brand_type,
              employees_count: vm.user.employees_count,
              years_in_business: vm.user.years_in_business,
              will_sell_music_related_products: vm.user.will_sell_music_related_products,
              products_count: vm.user.products_count,
              annual_income: vm.user.annual_income,

              request_resend: true
            }
          };
          __WEBPACK_IMPORTED_MODULE_4__services_user__["a" /* default */].updateUserInfo(vm.user.id, params).then(function (response) {
            vm.user = response.body;
          }).catch(function (e) {
            vm.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
          });
        } else {
          vm.$store.dispatch('error/showErrorToast', [vm.errors.items[0].msg]);
        }
      }).catch(function (e) {
        console.log('error', e);
      });
    }
  }
});

/***/ }),
/* 1108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_me__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_auth__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_user__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_trackcard__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_trackcard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_trackcard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_profileitem__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_profileitem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_profileitem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_address_tab__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_address_tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_address_tab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_account_download__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_account_download___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_account_download__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_account_subscription__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_account_subscription___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_account_subscription__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_genre_tab__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_genre_tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_genre_tab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_policy_tab__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_policy_tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_policy_tab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_price_tab__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_price_tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_price_tab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_verify_tab__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_verify_tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_verify_tab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_contentTopHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_contentTopHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_contentTopHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_dashboardnav__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_dashboardnav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_dashboardnav__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_user_tag__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_user_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_user_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__services_subscription_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_paymentCard_index__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_paymentCard_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_paymentCard_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__views_UpgradeModal__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__views_UpgradeModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__views_UpgradeModal__);




/* global $: true */
























// import { MyEvents } from '@/helper'
// const ActionCable = require('actioncable')

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    isComp: Boolean
  },
  components: {
    trackCard: __WEBPACK_IMPORTED_MODULE_9__components_trackcard___default.a,
    profileItem: __WEBPACK_IMPORTED_MODULE_10__components_profileitem___default.a,
    addressTab: __WEBPACK_IMPORTED_MODULE_11__components_address_tab___default.a,
    accountDownload: __WEBPACK_IMPORTED_MODULE_12__components_account_download___default.a,
    accountSubscription: __WEBPACK_IMPORTED_MODULE_13__components_account_subscription___default.a,
    genreTab: __WEBPACK_IMPORTED_MODULE_14__components_genre_tab___default.a,
    policyTab: __WEBPACK_IMPORTED_MODULE_15__components_policy_tab___default.a,
    priceTab: __WEBPACK_IMPORTED_MODULE_16__components_price_tab___default.a,
    verifyTab: __WEBPACK_IMPORTED_MODULE_17__components_verify_tab___default.a,
    contentTopHeader: __WEBPACK_IMPORTED_MODULE_18__components_contentTopHeader___default.a,
    dashboardNav: __WEBPACK_IMPORTED_MODULE_19__components_dashboardnav___default.a,
    UserTag: __WEBPACK_IMPORTED_MODULE_20__components_user_tag___default.a,
    PaymentCard: __WEBPACK_IMPORTED_MODULE_23__components_paymentCard_index___default.a,
    UpgradeModal: __WEBPACK_IMPORTED_MODULE_24__views_UpgradeModal___default.a
  },

  data: function data() {
    return {
      socialChannel: "",
      socialUsername: "",
      replaceTopMenu: [{ id: 'settings', title: 'Settings', pathName: 'UserSettings', icon: __webpack_require__(430) }],
      dialog: false,
      tabs: [{ id: 'info', title: 'Profile' }, { id: 'subscription', title: 'Subscriptions' }, { id: 'password', title: 'Password' }, { id: 'bank-details', title: 'Bank details' }],
      active_tab: 'info',
      profile: {
        image: null,
        username: '',
        display_name: '',
        email: '',
        contact_url: '',
        enable_alert: false,
        first_name: '',
        last_name: ''
      },
      password: {
        current_password: '',
        new_password: '',
        confirmed_password: ''
      },
      show_stripe_disconnect_confirm_dialog: false,
      stripeDialog: false,
      stripeEmail: '',
      user: {},
      cable: null,
      notification_subscription: null,
      isPageReady: false,
      plans: { basic: 'Basic', plus: 'Creator', pro: 'Advanced' },
      subscriptionModal: false,
      initPayment: false,
      selectedPlan: {},
      plansUpgradeModal: false,
      plansList: { 'basic': 1, plus: '2', pro: '3' },
      plansName: { 'basic': 'Listener', plus: 'Creator', pro: 'Advance' },
      planChangeText: null,
      showGetVerifiedModal: false,
      remainingDaysModal: false,
      requestStatuses: { accepted: "Accepted", denied: "Rejected", pending: "Pending" },
      loading: false
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21_vuex__["a" /* mapState */])({
    sideBarWidth: function sideBarWidth(state) {
      return state.app.sideBarWidth;
    },
    plansData: function plansData(state) {
      return state.app.plansData;
    }
  }), {
    socialChannels: function socialChannels() {
      return [{
        title: "Instagram",
        id: "instagram"
      }, {
        title: "Tik Tok",
        id: "tiktok"
      }, {
        title: "Facebook",
        id: "facebook"
      }, {
        title: "Twitter",
        id: "twitter"
      }];
    },
    calcSideBarWidth: function calcSideBarWidth() {
      var defaultPageMargin = 48;
      var defaultAppPadding = 16;
      return this.sideBarWidth + defaultPageMargin + defaultAppPadding;
    },
    onMobile: function onMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    currentUser: function currentUser() {
      return this.$store.state.auth.user;
    },
    stripeLink: function stripeLink() {
      return 'https://connect.stripe.com/express/oauth/authorize?response_type=code&client_id=' + "ca_CC74CVRdkHTZqAIPQVJS04XoPwiVB1Kx" + '&scope=read_write&state=' + this.$store.state.auth.secret_code;
    },
    availableTabs: function availableTabs() {
      var tabs = this.tabs.slice();

      if (this.currentUser.user_type === 'listener') {
        tabs = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.filter(tabs, function (t) {
          return t.id !== 'seller-policies';
        });
      }

      if (['artist', 'brand', 'label'].indexOf(this.currentUser.request_role) > -1) {
        tabs = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.concat(tabs, {
          id: 'verify-status',
          title: 'Verification Status'
        });
      }

      return tabs;
    }
  }),

  watch: {
    $route: function $route(toPath, fromPath) {
      var tab = toPath.hash.substr(1);
      this.setTab(tab);
    }
  },

  created: function created() {
    var _this = this;

    if (!this.currentUser) {
      __WEBPACK_IMPORTED_MODULE_6__services_auth__["a" /* default */].clearTokenAndUserInfo();
      this.$router.push({ path: '/login' });
      return;
    }
    this.selectedPlan = this.plans[0];

    this.getUserInfo();
    // this.$store.dispatch('navigator/goNextState', {
    //   page: 'settings',
    //   tab: tab,
    // })

    var tab = this.$route.hash.substr(1) || this.$route.params.tab || 'info';
    this.onTab(tab || tab.id);

    __WEBPACK_IMPORTED_MODULE_5__services_me__["a" /* default */].stripeEmail().then(function (res) {
      return _this.stripeEmail = res.body.email;
    });

    this.$intercom.update({ hide_default_launcher: false });
  },
  beforeDestroy: function beforeDestroy() {
    this.$intercom.update({ hide_default_launcher: true });
  },


  methods: {
    selectedChannel: function selectedChannel(channel) {
      this.socialChannel = channel;
      console.log(this.socialChannel);
    },
    hideModal: function hideModal() {
      this.showGetVerifiedModal = false;
    },
    verifiedSocialAttributes: function verifiedSocialAttributes() {
      var _this2 = this;

      if (this.socialChannel.id == null || this.socialUsername === '') {
        this.$store.dispatch('error/showErrorToast', "Social channel and username cannot be empty");
      } else if (this.selectedPlan == null) {
        this.reRequestForVerification();
      } else {
        var params = { social_provider: this.socialChannel.id, social_user_name: this.socialUsername };
        this.$store.dispatch('error/showLoadingActivity', true);
        __WEBPACK_IMPORTED_MODULE_7__services_user__["a" /* default */].updateUserInfo(this.currentUser.id, params).then(function (response) {
          _this2.$store.dispatch('error/showLoadingActivity', false);
          _this2.$store.dispatch('error/showSuccessToast', ['Social Username and channel saved successfully']);
          __WEBPACK_IMPORTED_MODULE_6__services_auth__["a" /* default */].setUser(response.body);
          _this2.verifyUserType();
        }).catch(function (e) {
          _this2.$store.dispatch('error/showLoadingActivity', false);
          _this2.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
        });
      }
    },
    openPaymentModal: function openPaymentModal(plan) {
      this.initPayment = true;
      this.selectedPlan = plan;
    },
    verifyPlanType: function verifyPlanType(plan) {
      this.selectedPlan = plan;
      if ((this.currentUser.plan == "basic" || this.currentUser.plan == null) && this.selectedPlan.id !== 'basic') {
        if (this.currentUser.trial_end !== null && this.currentUser.trial_start !== null && this.currentUser.creator_verified === false && this.currentUser.plan == null) {
          this.verifyUserType();
        } else {
          this.showGetVerifiedModal = true;
        }
      } else {
        this.verifyUserType();
      }
    },
    verifyUserType: function verifyUserType() {
      var plan = this.selectedPlan;
      var creator_verification = this.currentUser.trial_end !== null && this.currentUser.trial_start !== null && this.currentUser.creator_verified === false && this.currentUser.plan == null;
      if (this.currentUser.stripe_customer_id == null || creator_verification) {
        this.openPaymentModal(plan);
      } else {
        this.planChangeText = this.plansCategory(this.currentUser.plan, this.plansList[plan.id]);
        if (!(this.planChangeText === 'Current Plan' || this.planChangeText === null)) {
          this.plansUpgradeModal = true;
        }
      }
    },
    closePaymentModal: function closePaymentModal() {
      this.initPayment = false;
      this.selectedPlan = {};
    },
    plansDescription: function plansDescription(plan) {
      var trial_end = this.currentUser.trial_end !== null && this.currentUser.trial_start !== null && this.currentUser.plan == null;
      if (this.currentUser.user_type !== 'listener' && this.currentUser.creator_verified === false && trial_end || this.currentUser.user_type === 'listener' && trial_end) {
        return 'Subscribe';
      }
      if (this.currentUser == null || this.currentUser.plan === null) {
        if (plan == 'basic') {
          return 'Start free 30 day trial';
        } else {
          return 'Get Verified';
        }
      } else {
        return this.plansCategory(this.currentUser.plan, this.plansList[plan]);
      }
    },
    plansCategory: function plansCategory(userPlan, planCategory) {
      if (this.plansList[userPlan] == planCategory) {
        return 'Current Plan';
      } else if (planCategory <= this.plansList[userPlan]) {
        return 'Downgrade Plan';
      } else {
        return 'Upgrade Plan';
      }
    },
    subscriptionChange: function subscriptionChange() {
      var _this3 = this;

      this.loading = true;
      this.$store.dispatch("error/showLoadingActivity", true);
      var params = { selectedPlan: this.selectedPlan.id, social_provider: this.socialChannel, social_user_name: this.socialUsername };
      __WEBPACK_IMPORTED_MODULE_22__services_subscription_js__["a" /* default */].subscriptionChange(params).then(function (response) {
        _this3.loading = false;
        _this3.$store.dispatch("error/showLoadingActivity", false);
        _this3.hidePlanChangeModal();
        _this3.$store.dispatch('error/showSuccessToast', [response.body.success_response]);
        setTimeout(function () {
          window.location.href = '/settings';
        }, 2000);
      }).catch(function (e) {
        _this3.loading = false;
        _this3.$store.dispatch("error/showLoadingActivity", false);
        _this3.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    hidePlanChangeModal: function hidePlanChangeModal() {
      this.plansUpgradeModal = false;
      this.planChangeText = null;
    },
    isCurrentPlan: function isCurrentPlan(plan) {
      return plan.id === this.currentUser.plan;
    },
    signOut: function signOut() {
      __WEBPACK_IMPORTED_MODULE_6__services_auth__["a" /* default */].signout();
      this.$router.push({ path: '/' });
      this.$root.$emit(__WEBPACK_IMPORTED_MODULE_8__helper__["b" /* MyEvents */].AUTH_SIGNOUT);
    },
    isActiveTab: function isActiveTab(tab) {
      return this.active_tab === tab;
    },


    // availableTab (tab) {
    //   return tab.id !== 'verify-status' ||
    //     (this.currentUser.user_type == 'listener' && ['artist', 'brand', 'label'].indexOf(this.currentUser.request_role) > -1)
    // },

    onTab: function onTab(tab) {
      if (this.active_tab !== tab) {
        // this.$router.push({
        //   path: this.$route.path,
        //   hash: tab,
        // })

        this.setTab(tab);
      }
    },
    setTab: function setTab(tab) {
      if (!tab) {
        tab = 'info';
      }

      switch (tab) {
        case 'info':
          this.resetProfile();
          break;
        case 'password':
          this.resetPassword();
          break;
        // case 'repost-price':
        //   this.resetRepostPrice()
        //   break
        // case 'shipping-address':
        //   this.resetShippingAddress()
        //   break
        // case 'genre-filter':
        //   this.resetGenres()
        //   break

        default:
          break;
      }

      this.active_tab = tab;
    },
    disableSubscriptionModal: function disableSubscriptionModal() {
      this.subscriptionModal = false;
    },
    enableSubscriptionModal: function enableSubscriptionModal() {
      this.subscriptionModal = true;
    },
    profileImageChanged: function profileImageChanged(e) {
      this.profile.image = e.target.files[0];
      var reader = new FileReader();
      reader.addEventListener('load', function (event) {
        // document.getElementById('profile_image').src = event.target.result 
        // document.getElementById('profile_image').style.backgroundImage = event.target.result 
        $('#profile_image').css('background-image', 'url(' + event.target.result + ')');
      }, false);
      reader.readAsDataURL(this.profile.image);
    },
    remainingDays: function remainingDays() {
      var reRequest = new Date(this.currentUser.re_requested_at);
      var todayDate = new Date();
      var diffTime = Math.abs(todayDate - reRequest);
      var diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      return diffDays;
    },
    getUserInfo: function getUserInfo() {
      var _this4 = this;

      this.$store.dispatch('error/showLoadingActivity', true);
      __WEBPACK_IMPORTED_MODULE_7__services_user__["a" /* default */].getUserInfo(this.currentUser.id).then(function (response) {
        _this4.$store.dispatch('error/showLoadingActivity', false);
        __WEBPACK_IMPORTED_MODULE_6__services_auth__["a" /* default */].setUser(response.body);
        _this4.user = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.cloneDeep(response.body);

        var permitted_keys = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(_this4.profile);
        permitted_keys.forEach(function (k) {
          if (k == "image") {
            _this4.profile[k] = response.body.avatar.url;
          } else if (permitted_keys.includes(k)) {
            _this4.profile[k] = response.body[k];
          }
        });

        // this.resetProfile()
        // this.resetShippingAddress()
        // this.resetGenres()
      }).catch(function (e) {
        _this4.$store.dispatch('error/showLoadingActivity', false);
        _this4.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    verifyReRequestStatus: function verifyReRequestStatus() {
      if (this.currentUser.request_status === 'denied' && this.remainingDays() >= 30) {
        this.showGetVerifiedModal = true;
      } else {
        this.remainingDaysModal = true;
      }
    },
    reRequestForVerification: function reRequestForVerification() {
      var _this5 = this;

      this.$store.dispatch('error/showLoadingActivity', true);
      var params = { social_provider: this.socialChannel, social_user_name: this.socialUsername };

      __WEBPACK_IMPORTED_MODULE_7__services_user__["a" /* default */].creatorReRequest(this.currentUser.id, params).then(function (response) {
        _this5.$store.dispatch('error/showLoadingActivity', false);
        _this5.$store.dispatch('error/showSuccessToast', ['Re Request send Successfully']);
        __WEBPACK_IMPORTED_MODULE_6__services_auth__["a" /* default */].setUser(response.body);
        _this5.showGetVerifiedModal = false;
      }).catch(function (e) {
        _this5.$store.dispatch('error/showLoadingActivity', false);
        _this5.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    cancelAccount: function cancelAccount() {
      var _this6 = this;

      this.dialog = false;
      // const _user = _.cloneDeep(this.currentUser)
      __WEBPACK_IMPORTED_MODULE_7__services_user__["a" /* default */].deleteUser(this.user.id).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_6__services_auth__["a" /* default */].signout();
        _this6.$router.push({ path: '/login' });
        // this.$root.$emit(MyEvents.AUTH_SIGNOUT, _user.stream)
      });
    },
    updateAccount: function updateAccount() {
      var params = new FormData();
      if (this.profile.image) {
        params.append('user[avatar]', this.profile.image);
      }

      params.append('user[first_name]', this.profile.first_name);
      params.append('user[last_name]', this.profile.last_name);
      params.append('user[display_name]', this.profile.display_name);
      params.append('user[email]', this.profile.email);
      params.append('user[contact_url]', this.profile.contact_url);
      params.append('user[enable_alert]', this.profile.enable_alert === true ? 1 : 0);

      this.updateUser(params);
    },
    deactivateSubscription: function deactivateSubscription() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this7.loading = true;
                _this7.$store.dispatch("error/showLoadingActivity", true);

                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_22__services_subscription_js__["a" /* default */].deactivateSubscription().then(function (response) {
                  _this7.$store.dispatch("error/showLoadingActivity", false);
                  _this7.loading = false;
                  var user = _this7.currentUser;
                  user.deactivate_subscription = true;
                  __WEBPACK_IMPORTED_MODULE_6__services_auth__["a" /* default */].setUser(user);
                  _this7.subscriptionModal = false;
                  _this7.$store.dispatch('error/showSuccessToast', [response.body.success_response]);
                }).catch(function (e) {
                  _this7.$store.dispatch("error/showLoadingActivity", false);
                  _this7.loading = false;
                  _this7.$store.dispatch('error/showErrorToast', e.body.errors);
                });

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this7);
      }))();
    },
    resetPassword: function resetPassword() {
      this.password.current_password = '';
      this.password.new_password = '';
      this.password.confirmed_password = '';
    },
    updatePassword: function updatePassword() {
      var _this8 = this;

      this.$store.dispatch('error/showLoadingActivity', true);
      var userId = this.currentUser.id;
      var params = new FormData();
      // console.log(this.password)
      params.append('old_password', this.password.current_password);
      params.append('new_password', this.password.new_password);
      params.append('confirmed_password', this.password.confirmed_password);
      __WEBPACK_IMPORTED_MODULE_7__services_user__["a" /* default */].changePassword(userId, params).then(function (response) {
        _this8.$store.dispatch('error/showLoadingActivity', false);
        _this8.$store.dispatch('error/showSuccessToast', ['Saved']);
      }).catch(function (e) {
        _this8.$store.dispatch('error/showLoadingActivity', false);
        _this8.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    viewStripeAccount: function viewStripeAccount() {},
    openStripeDisconnectConfirmDialog: function openStripeDisconnectConfirmDialog() {
      this.show_stripe_disconnect_confirm_dialog = true;
    },
    closeStripeDisconnectConfirmDialog: function closeStripeDisconnectConfirmDialog() {
      this.show_stripe_disconnect_confirm_dialog = false;
    },
    disconnectAccount: function disconnectAccount() {
      var _this9 = this;

      __WEBPACK_IMPORTED_MODULE_5__services_me__["a" /* default */].disconnectStripe().then(function (response) {
        _this9.$store.dispatch('error/showSuccessToast', ['Stripe Disconnected!']);
        _this9.$store.dispatch('auth/setStripeStatus', false);
      }).catch(function (e) {
        _this9.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
      this.closeStripeDisconnectConfirmDialog();
    },
    unblockUser: function unblockUser(user) {
      var _this10 = this;

      this.$store.dispatch('error/showLoadingActivity', true);
      var userId = user.id;
      __WEBPACK_IMPORTED_MODULE_7__services_user__["a" /* default */].unblockUser(userId).then(function (response) {
        _this10.getUserInfo();
      }).catch(function (e) {
        _this10.$store.dispatch('error/showLoadingActivity', false);
        _this10.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    updateUser: function updateUser(params) {
      var _this11 = this;

      this.$store.dispatch('error/showLoadingActivity', true);
      __WEBPACK_IMPORTED_MODULE_7__services_user__["a" /* default */].updateUserInfo(this.currentUser.id, params).then(function (response) {
        _this11.$store.dispatch('error/showLoadingActivity', false);
        _this11.$store.dispatch('error/showSuccessToast', ['Saved']);
        __WEBPACK_IMPORTED_MODULE_6__services_auth__["a" /* default */].setUser(response.body);
      }).catch(function (e) {
        var errors = e.body.errors ? __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(e.body.errors, function (msg) {
          return 'Email ' + msg.detail;
        }) : [e.body];
        _this11.$store.dispatch('error/showLoadingActivity', false);
        _this11.$store.dispatch('error/showErrorToast', errors);
      });
    },
    resetProfile: function resetProfile() {
      this.profile.image = this.currentUser.avatar.url;
      this.profile.username = this.currentUser.username;
      this.profile.display_name = this.currentUser.display_name;
      this.profile.email = this.currentUser.email;
      this.profile.contact_url = this.currentUser.contact_url;
      this.profile.enable_alert = this.currentUser.enable_alert;
    },
    isSubscriptionAvailable: function isSubscriptionAvailable() {
      var trial_end = new Date(this.currentUser.trial_end);
      if (this.currentUser.user_type == 'listener' && this.currentUser.plan && trial_end > new Date()) {
        return true;
      } else if (this.currentUser.plan && this.currentUser.creator_verified) {
        return true;
      }
      return false;
    }
  },

  mounted: function mounted() {
    var vm = this;
    $.getJSON('../../static/countries.json', function (json) {
      var countries = json.countries;
      vm.countries = [];
      for (var index in countries) {
        var country = {
          iso: countries[index]['iso_2'],
          name: countries[index]['name']
        };
        vm.countries.push(country);
      }
    });
  }
});

/***/ }),
/* 1109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_community_guidelines_tab__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_community_guidelines_tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_community_guidelines_tab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_cookie_policy_tab__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_cookie_policy_tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_cookie_policy_tab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_copyright_policy_tab__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_copyright_policy_tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_copyright_policy_tab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_privacy_choice_tab__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_privacy_choice_tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_privacy_choice_tab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_privacy_policy_tab__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_privacy_policy_tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_privacy_policy_tab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_terms_of_use_tab__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_terms_of_use_tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_terms_of_use_tab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_gdpr_tab__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_gdpr_tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_gdpr_tab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_trademark_policy_tab__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_trademark_policy_tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_trademark_policy_tab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_sample_clearance_tab__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_sample_clearance_tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_sample_clearance_tab__);
/* global $:true */











/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    communityGuidelinesTab: __WEBPACK_IMPORTED_MODULE_0__components_community_guidelines_tab___default.a,
    cookiePolicyTab: __WEBPACK_IMPORTED_MODULE_1__components_cookie_policy_tab___default.a,
    copyrightPolicyTab: __WEBPACK_IMPORTED_MODULE_2__components_copyright_policy_tab___default.a,
    privacyChoiceTab: __WEBPACK_IMPORTED_MODULE_3__components_privacy_choice_tab___default.a,
    privacyPolicyTab: __WEBPACK_IMPORTED_MODULE_4__components_privacy_policy_tab___default.a,
    termsOfUseTab: __WEBPACK_IMPORTED_MODULE_5__components_terms_of_use_tab___default.a,
    gdprTab: __WEBPACK_IMPORTED_MODULE_6__components_gdpr_tab___default.a,
    trademarkPolicyTab: __WEBPACK_IMPORTED_MODULE_7__components_trademark_policy_tab___default.a,
    SampleClearanceTab: __WEBPACK_IMPORTED_MODULE_8__components_sample_clearance_tab___default.a
  },

  data: function data() {
    return {
      tabs: [{ id: 'terms_of_use', title: 'Terms of Service' }, { id: 'community_guidelines', title: 'Community Guidlines' }, { id: 'privacy_policy', title: 'Privacy Policy' }, { id: 'privacy_choice', title: 'Privacy Choices' }, { id: 'copyright_policy', title: 'Copyright Policy (DMCA)' }, { id: 'trademark_policy', title: 'Trademark Policy' }, { id: 'gdpr', title: 'GDPR' }, { id: 'cookie_policy', title: 'Cookie Policy' }, { id: 'sample_clearance', title: 'Sample Clearance License' }],
      currentTab: 'terms_of_use',
      isPageReady: false
    };
  },


  computed: {},

  // watch: {
  //   '$route' (toPath, fromPath) {
  //     console.log('list watch')
  //     console.log(toPath)
  //     console.log(fromPath)
  //   }
  // },

  created: function created() {
    var _this = this;

    var tab = this.$route.hash.substr(1);
    this.currentTab = tab || 'terms_of_use';
    this.$store.dispatch('navigator/goNextState', {
      page: 'terms',
      tab: this.currentTab
    });
    this.onTab(this.currentTab);
    setTimeout(function () {
      _this.checkScreenSize();
      window.addEventListener('resize', _this.checkScreenSize);
    }, 0);
  },

  methods: {
    onTab: function onTab(tab) {
      this.currentTab = tab;
      this.$nextTick(function () {
        $(window).scrollTop(0);
      });
    },
    checkScreenSize: function checkScreenSize() {
      var screenWidth = window.innerWidth;
      if (screenWidth > 968) {
        $(".content").css("padding", "0px 0px 0px 250px");
        $(".main-section").css("margin", "10px 200px 30px");
      } else {
        $(".content").css("padding", "0px");
        $(".main-section").css("margin", "20px");
      }
    }
  },

  mounted: function mounted() {
    $(".sidebar").remove();
  }
});

/***/ }),
/* 1110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_dashboardnav__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_dashboardnav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_dashboardnav__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_tracking__ = __webpack_require__(212);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    dashboardNav: __WEBPACK_IMPORTED_MODULE_2__components_dashboardnav___default.a
  },

  data: function data() {
    return {
      showDownloadModal: false,
      pageReady: false,
      top_creators: []
    };
  },


  methods: {
    getDashboardStats: function getDashboardStats() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_3__services_tracking__["a" /* default */].getDashboardStats().then(function (response) {
                  _this.top_creators = response.body;
                }).catch(function (exception) {
                  console.log(exception);
                });

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },

  created: function created() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this2.getDashboardStats();

            case 2:
              _this2.pageReady = true;

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  }
});

/***/ }),
/* 1111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_contentTopHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_contentTopHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_contentTopHeader__);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    name: String,
    tabActivePill: Boolean
  },
  components: {
    contentTopHeader: __WEBPACK_IMPORTED_MODULE_2__components_contentTopHeader___default.a
  },
  data: function data() {
    return {
      activeTab: "",
      tabs: [{
        id: "upload",
        title: "Upload",
        pathName: "UploadAlbum"
      }, {
        id: "manage",
        title: "Manage",
        pathName: "ManageIndex"
      }]
    };
  },


  computed: {
    currentUser: function currentUser() {
      return this.$store.state.auth.user;
    }
  },

  methods: {
    isActiveTab: function isActiveTab(tab) {
      return this.name === tab;
    },
    isActiveInnerTab: function isActiveInnerTab(tab) {
      return this.activeInnerTab === tab;
    },
    setTab: function setTab(pathName) {
      console.log(this.$route);
      this.$router.push({ name: pathName });
    }
  },

  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.activeTab = _this.name;

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 1112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_topbarNotification__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_topbarNotification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_topbarNotification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_getPaidToShare__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_getPaidToShare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_getPaidToShare__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_user__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_downloadApp_vue__ = __webpack_require__(782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_downloadApp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_downloadApp_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_video__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_nav_vue__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_nav_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_nav_vue__);









/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    topbarNotification: __WEBPACK_IMPORTED_MODULE_2__components_topbarNotification___default.a,
    getPaid: __WEBPACK_IMPORTED_MODULE_3__views_getPaidToShare___default.a,
    DownloadApp: __WEBPACK_IMPORTED_MODULE_5__components_downloadApp_vue___default.a,
    uploadNav: __WEBPACK_IMPORTED_MODULE_7__components_nav_vue___default.a
  },

  data: function data() {
    return {
      topBarContent: "Connect your Stripe account to start accepting payments",
      user: {},
      initAppDownload: false,
      isAppDownloadClicked: false,
      isSpotlightVideoAvailable: false
    };
  },

  computed: {
    isStripeConnected: function isStripeConnected() {
      return this.currentUser.stripe_connected;
    },
    onMobile: function onMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    currentUser: function currentUser() {
      return this.$store.state.auth.user;
    },
    stripeLink: function stripeLink() {
      return "https://connect.stripe.com/express/oauth/authorize?response_type=code&client_id=" + "ca_CC74CVRdkHTZqAIPQVJS04XoPwiVB1Kx" + "&scope=read_write&state=" + this.$store.state.auth.secret_code;
    },
    isStreaming: function isStreaming() {
      return _.get(this.user.stream, "status", "") === "running" && _.get(this.user.stream, "notified", false) && (_.get(this.$store.state.streamPlayer.stream, "user.slug", "") !== this.user.slug || !this.$store.getters["streamPlayer/hasFrame"]);
    }
  },
  methods: {
    broadcastLink: function broadcastLink() {
      if (this.isStreaming) {
        return this.$router.push({ name: "VideoManage" });
      } else {
        return this.$router.push({ name: "CreateLive" });
      }
    },
    setTab: function setTab(pathName) {
      this.$router.push({ name: pathName });
    },
    onTab: function onTab(tab) {
      if (tab.path) {
        this.$router.push({ name: tab.path });
      }
    },
    stripeLink: function stripeLink() {
      return "https://connect.stripe.com/express/oauth/authorize?response_type=code&client_id=" + "ca_CC74CVRdkHTZqAIPQVJS04XoPwiVB1Kx" + "&scope=read_write&state=" + this.$store.state.auth.secret_code;
    },
    getUser: function getUser() {
      var _this = this;

      this.$store.dispatch("error/showLoadingActivity", true);
      __WEBPACK_IMPORTED_MODULE_4__services_user__["a" /* default */].getUserInfo(this.currentUser.username).then(function (response) {
        if (response.body.status !== "active") {
          _this.$store.dispatch("error/showErrorToast", ["User does not exist"]);
          _this.$router.push({ path: "/" });
          return;
        }

        // console.log('profile init')
        _this.user = response.body;
        _this.$store.dispatch("error/showLoadingActivity", false);
      }).catch(function (e) {
        _this.$store.dispatch("error/showLoadingActivity", false);
        _this.$store.dispatch("error/showErrorToast", ["Error fetching user"]);
      });
    },
    isSpotlightAlreadyUploaded: function isSpotlightAlreadyUploaded() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                __WEBPACK_IMPORTED_MODULE_6__services_video__["a" /* default */].spotlightVideoAvailable().then(function (response) {
                  _this2.isSpotlightVideoAvailable = true;
                }).catch(function (e) {
                  _this2.isSpotlightVideoAvailable = false;
                  _this2.$store.dispatch("error/showErrorToast", e.body.errors || [e.body]);
                });

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    }
  },
  watch: {
    initAppDownload: function initAppDownload(val) {
      if (val === false) {
        this.isAppDownloadClicked = true;
      }
    }
  },
  created: function created() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this3.getUser();

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this3);
    }))();
  }
});

/***/ }),
/* 1113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_message__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_auth__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_user__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_album__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_product__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_profileitem__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_profileitem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_profileitem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_activityalbumcard__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_activityalbumcard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_activityalbumcard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_activityproductcard__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_activityproductcard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_activityproductcard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__messages_components_message__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__messages_components_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__messages_components_message__);













var ActionCable = __webpack_require__(52);

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    profileItem: __WEBPACK_IMPORTED_MODULE_7__components_profileitem___default.a,
    activityAlbumCard: __WEBPACK_IMPORTED_MODULE_8__components_activityalbumcard___default.a,
    activityProductCard: __WEBPACK_IMPORTED_MODULE_9__components_activityproductcard___default.a,
    Message: __WEBPACK_IMPORTED_MODULE_10__messages_components_message___default.a
  },

  data: function data() {
    return {
      user: null,
      item: null,
      page_index: 0,
      total_pages: 1,
      items_per_page: 5 * 5,
      conversations: [],
      conversation: {},
      conversation_pagination: {
        count: 0,
        current_page: 0,
        per_page: 50,
        total_count: 0,
        total_pages: 0
      },
      messages: [],
      message: {
        body: ''
      },
      message_pagination: {
        count: 0,
        current_page: 0,
        per_page: 50,
        total_count: 0,
        total_pages: 0
      },
      isPageReady: false,
      cable: null,
      message_subscription: null,
      albums: [],
      products: []
    };
  },


  computed: {
    currentUser: function currentUser() {
      return this.$store.state.auth.user;
    },
    other_name: function other_name() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(this.conversation, 'other.display_name', '');
    },
    toLocalTimeString: function toLocalTimeString() {
      return __WEBPACK_IMPORTED_MODULE_1__helper__["f" /* Utils */].toLocalTimeString;
    },
    current_repost_price: function current_repost_price() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(this.conversation, 'other.repost_price', 0);
    }
  },

  created: function created() {
    var _this = this;

    if (!this.currentUser) {
      __WEBPACK_IMPORTED_MODULE_3__services_auth__["a" /* default */].clearTokenAndUserInfo();
      this.$router.push({ path: '/login' });
      return;
    }

    this.$store.dispatch('navigator/goNextState', {
      page: 'direct_messages',
      tab: ''
    });
    __WEBPACK_IMPORTED_MODULE_4__services_user__["a" /* default */].getUserInfo(this.$route.params.user).then(function (response) {
      _this.user = response.body;
      _this.loadConversations();
    });

    var vm = this;
    // this.timer = setInterval(function(){ vm.refreshMessages() }, 10000)

    this.cable = ActionCable.createConsumer("wss://api.yousound.com/cable" + '?token=' + this.$store.state.auth.token);
    this.message_subscription = this.cable.subscriptions.create({
      channel: 'MessagesChannel'
    }, {
      connected: function connected() {
        console.log('connected to MessagesChannel');
      },
      received: function received(data) {
        console.log('message_subscription');
        var other_id = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(vm.conversation, 'other.id', '');
        // console.log(data, data.sender.id, other_id)
        if (data.sender.id == other_id || data.sender.id == vm.currentUser.id) {
          var messageIndex = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.findIndex(vm.messages, function (message) {
            return message.id == data.id;
          });
          if (messageIndex === -1) {
            vm.messages.push(data);
          } else {
            vm.messages[messageIndex] = data;
            // console.log(messageIndex, vm.messages[messageIndex])
          }
          var arr = vm.messages.slice();
          vm.messages = arr;
          vm.$nextTick(function () {
            $('.message-list-section').scrollTop($('.message-list-section').prop('scrollHeight'));
          });
        }
      },
      disconnected: function disconnected() {
        console.log('disconnected to MessagesChannel :(');
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.message_subscription) {
      this.message_subscription.unsubscribe();
    }
  },


  methods: {
    loadConversations: function loadConversations(loadMore) {
      var _this2 = this;

      this.$store.dispatch('error/showLoadingActivity', true);
      var params = void 0;
      if (loadMore) {
        params = {
          user_id: this.user.slug,
          page: this.conversation_pagination.current_page + 1,
          per_page: this.conversation_pagination.per_page
        };
      } else {
        params = {
          user_id: this.user.slug,
          page: 1,
          per_page: this.conversation_pagination.per_page
        };
        this.messages = [];
      }
      __WEBPACK_IMPORTED_MODULE_2__services_message__["a" /* default */].getConversations(params).then(function (response) {
        _this2.$store.dispatch('error/showLoadingActivity', false);
        _this2.conversations = response.body.conversations;
        if (_this2.conversations.length) {
          _this2.conversation = _this2.conversations[0];

          _this2.loadMessages(_this2.conversation.id, false, true);
        }
      }).catch(function (e) {
        _this2.$store.dispatch('error/showLoadingActivity', false);
        _this2.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    loadMessages: function loadMessages(id, loadMore, scrollMove) {
      var _this3 = this;

      if (scrollMove) {
        this.$store.dispatch('error/showLoadingActivity', true);
      }
      var params = {
        conversation_id: id,
        user_id: this.user.slug
      };
      __WEBPACK_IMPORTED_MODULE_2__services_message__["a" /* default */].getMessages(params).then(function (response) {
        if (loadMore) {
          // this.messages = this.conversation.concat(response.body.messages)
          _this3.messages = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.reverse(response.body.messages).concat(_this3.messages);
        } else {
          _this3.messages = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.reverse(response.body.messages);
          if (scrollMove) {
            _this3.$nextTick(function () {
              // $(".message-list-section").animate({ scrollTop: $(".message-list-section").prop("scrollHeight")}, 1000);
              $('.message-list-section').scrollTop($('.message-list-section').prop('scrollHeight'));
            });
          }
        }
        // this.$forceUpdate()
        _this3.$store.dispatch('error/showLoadingActivity', false);
      }).catch(function (e) {
        _this3.$store.dispatch('error/showLoadingActivity', false);
      });
    },
    refreshMessages: function refreshMessages() {
      if (this.conversation && this.conversation.id !== undefined) {
        this.loadMessages(this.conversation.id, false, false);
      }
    },
    selectedConversation: function selectedConversation(conv) {
      if (this.conversation.id === conv.id) {
        return;
      }

      this.item = null;
      this.conversation = conv;
      this.conversation.last_message.is_read = true;
      this.loadMessages(this.conversation.id, false, true);
    },
    selectItem: function selectItem(item) {
      if (this.item === item) {
        this.item = null;
      } else {
        this.item = item;
      }
    }
  },

  mounted: function mounted() {}
});

/***/ }),
/* 1114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_auth_js__ = __webpack_require__(5);


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},

  data: function data() {
    return {
      verifying_request: {
        main_genre: null,
        releases: null,
        soundcloud_url: null,
        bandcamp_url: null,
        website_url: null,
        description: null
      }
    };
  },


  computed: {},

  created: function created() {
    this.$store.dispatch('navigator/goNextState', { page: 'register', tab: '' });
  },


  methods: {
    submit: function submit() {}
  }
});

/***/ }),
/* 1115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_trackcard__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_trackcard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_trackcard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_video_box__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_video_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_video_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_productcard__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_productcard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_productcard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_slick_carousel__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_slick_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_slick_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_contentTopHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_contentTopHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_contentTopHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_user__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_membership_tier__ = __webpack_require__(644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_stream__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_album__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_product__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helper__ = __webpack_require__(2);

/* global $:true */












/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    trackCard: __WEBPACK_IMPORTED_MODULE_1__components_trackcard___default.a,
    contentTopHeader: __WEBPACK_IMPORTED_MODULE_5__components_contentTopHeader___default.a,
    VideoBox: __WEBPACK_IMPORTED_MODULE_2__components_video_box___default.a,
    VueSlickCarousel: __WEBPACK_IMPORTED_MODULE_4_vue_slick_carousel___default.a,
    productCard: __WEBPACK_IMPORTED_MODULE_3__components_productcard___default.a
  },
  data: function data() {
    return {
      isPageReady: false,
      stripe_publishable_key: "pk_live_fXEdJ0v6E2ROxT8rufDCby12",
      PublicRelationsUsername: __WEBPACK_IMPORTED_MODULE_11__helper__["c" /* PublicRelationsUsername */],
      active_tab: '',
      slide_tab: '',
      show_following: false,
      show_following_scroll: false,
      show_followers: false,
      show_followers_scroll: false,
      darkMode: true,
      slug: '',
      user: {
        display_name: '',
        avatar: {}
      },
      tier: 'all',
      tierList: [],
      albums: [],
      videos: [],
      products: [],
      last_updated: null
    };
  },


  computed: {
    currentUser: function currentUser() {
      return this.$store.state.auth.user;
    },
    onMobile: function onMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    }
  },

  watch: {
    tier: function tier(newTier, oldTier) {
      this.getMembersAlbums();
      this.getMembersStreams();
      this.getMembersProducts();

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.tierList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var t = _step.value;

          if (newTier == 'all') this.last_updated = null;else if (t.value == newTier) this.last_updated = t.updated_at;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  },

  methods: {
    getUserInfo: function getUserInfo() {
      var _this = this;

      var paths = window.location.href.split('/');
      this.slug = paths[paths.length - 1];

      __WEBPACK_IMPORTED_MODULE_6__services_user__["a" /* default */].getUserInfo(this.slug).then(function (response) {
        if (response.body.status !== 'active') {
          _this.$store.dispatch('error/showErrorToast', ['User does not exist']);
          _this.$router.push({ name: 'AlbumIndex' });
          return;
        }

        _this.user = response.body;
        _this.$emit('updateHead');

        _this.getTiersList();
        _this.getMembersAlbums();
        _this.getMembersStreams();
        _this.getMembersProducts();
      }).catch(function (e) {
        _this.$store.dispatch('error/showLoadingActivity', false);
        _this.$store.dispatch('error/showErrorToast', ['User does not exist']);
        _this.$router.push({ path: '/' });
      });
    },
    getTiersList: function getTiersList() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_7__services_membership_tier__["a" /* default */].getTiersList(this.user.id, true).then(function (response) {
        var memberships = _this2.currentUser.memberships.map(function (membership) {
          return membership.membership_tier.month_tier.id;
        });

        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(response.body), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var tier = _step2.value;

            if (memberships.includes(tier.value) || tier.value == 'all' || _this2.currentUser.id == _this2.user.id) _this2.tierList.push(tier);
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }).catch(function (e) {
        _this2.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    getMembersAlbums: function getMembersAlbums() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_9__services_album__["a" /* default */].getMembersAlbums({
        user_id: this.user.id,
        tier: this.tier
      }).then(function (response) {
        _this3.albums = response.body;
      }).catch(function (e) {
        _this3.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    getMembersStreams: function getMembersStreams() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_8__services_stream__["a" /* default */].getMembersStreams({
        user_id: this.user.id,
        tier: this.tier
      }).then(function (response) {
        _this4.videos = response.body;
      }).catch(function (e) {
        _this4.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    getMembersProducts: function getMembersProducts() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_10__services_product__["a" /* default */].getMembersProducts({
        user_id: this.user.id,
        tier: this.tier
      }).then(function (response) {
        _this5.products = response.body;
      }).catch(function (e) {
        _this5.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    modeToggle: function modeToggle() {
      var app_container = $(this.$parent.$parent.$el);
      if (this.darkMode) {
        app_container.find('.app-container').addClass('dark-mode bg-grey');
      } else {
        app_container.find('.app-container').removeClass('dark-mode bg-grey');
      }
    },
    productDisplay: function productDisplay(product) {
      if (this.currentUser == null) {
        this.showRegisterModal = true;
      } else {
        this.$router.push({ path: '/product/' + product.id });
      }
    }
  },

  mounted: function mounted() {
    this.modeToggle();
    this.getUserInfo();
  }
});

/***/ }),
/* 1116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_profile__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_user__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_membership__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_subscription__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_sms__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_albumslidecard__ = __webpack_require__(777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_albumslidecard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_albumslidecard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_slider_Carousel3d__ = __webpack_require__(787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_slider_Carousel3d___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_slider_Carousel3d__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_merchmodal__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_merchmodal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_merchmodal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_sharemodal__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_sharemodal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_sharemodal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_productcard__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_productcard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_productcard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_productslidecard__ = __webpack_require__(784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_productslidecard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_productslidecard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_sendlovemodal__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_sendlovemodal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_sendlovemodal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_sendmessage__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_sendmessage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_sendmessage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_slider_Slide__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_slider_Slide___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_slider_Slide__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_trackcard__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_trackcard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_trackcard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_useritem__ = __webpack_require__(789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_useritem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_useritem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_artistitem__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_artistitem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_artistitem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_contentTopHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_contentTopHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_contentTopHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__services_auth__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__services_stream__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_video_box__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_video_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__components_video_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_userFollowBtn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_userFollowBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__components_userFollowBtn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_vue_slick_carousel__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_vue_slick_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_vue_slick_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_vue_stripe_elements__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_vue_stripe_elements___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_vue_stripe_elements__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__services_membership__ = __webpack_require__(414);




/* global $:true */


































// import streamPlayer from '@/components/stream_player'

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    trackCard: __WEBPACK_IMPORTED_MODULE_22__components_trackcard___default.a,
    albumSlideCard: __WEBPACK_IMPORTED_MODULE_13__components_albumslidecard___default.a,
    productCard: __WEBPACK_IMPORTED_MODULE_17__components_productcard___default.a,
    productSlideCard: __WEBPACK_IMPORTED_MODULE_18__components_productslidecard___default.a,
    merchModal: __WEBPACK_IMPORTED_MODULE_15__components_merchmodal___default.a,
    shareModal: __WEBPACK_IMPORTED_MODULE_16__components_sharemodal___default.a,
    userItem: __WEBPACK_IMPORTED_MODULE_23__components_useritem___default.a,
    artistItem: __WEBPACK_IMPORTED_MODULE_24__components_artistitem___default.a,
    sendMessage: __WEBPACK_IMPORTED_MODULE_20__components_sendmessage___default.a,
    sendLoveModal: __WEBPACK_IMPORTED_MODULE_19__components_sendlovemodal___default.a,
    carousel3d: __WEBPACK_IMPORTED_MODULE_14__components_slider_Carousel3d___default.a,
    slide: __WEBPACK_IMPORTED_MODULE_21__components_slider_Slide___default.a,
    contentTopHeader: __WEBPACK_IMPORTED_MODULE_25__components_contentTopHeader___default.a,
    VideoBox: __WEBPACK_IMPORTED_MODULE_28__components_video_box___default.a,
    UserFollowBtn: __WEBPACK_IMPORTED_MODULE_29__components_userFollowBtn___default.a,
    VueSlickCarousel: __WEBPACK_IMPORTED_MODULE_30_vue_slick_carousel___default.a,
    Card: __WEBPACK_IMPORTED_MODULE_32_vue_stripe_elements__["Card"],
    CardNumber: __WEBPACK_IMPORTED_MODULE_32_vue_stripe_elements__["CardNumber"],
    CardExpiry: __WEBPACK_IMPORTED_MODULE_32_vue_stripe_elements__["CardExpiry"],
    CardCvc: __WEBPACK_IMPORTED_MODULE_32_vue_stripe_elements__["CardCvc"]
    // streamPlayer
  },

  data: function data() {
    return {
      // active_tab: 'songs',
      // slide_tab: 'songs',
      stripe_publishable_key: "pk_live_fXEdJ0v6E2ROxT8rufDCby12",
      stripeOptions: {},
      cardNumber: null,
      cardExpiry: null,
      cardCvc: null,
      PublicRelationsUsername: __WEBPACK_IMPORTED_MODULE_12__helper__["c" /* PublicRelationsUsername */],
      active_tab: '',
      slide_tab: '',
      show_following: false,
      show_following_scroll: false,
      show_followers: false,
      show_followers_scroll: false,
      tabs: [{ id: 'catalog', title: 'Catalog', roles: ['label'], icon: __webpack_require__(647) }, { id: 'artists', title: 'Artists', roles: ['label'] }, { id: 'songs', title: 'Music', icon: __webpack_require__(648) },
      // { id: 'video', title: 'Video', icon: require('../../../static/images/video.svg') },
      // { id: 'merch', title: 'Shop', icon: require('../../../static/images/shop.svg') },
      // { id: 'sms_group', title: 'SMS groups' },
      { id: 'reposted', title: 'Reposted', roles: ['label'], icon: __webpack_require__(771) }, { id: 'downloaded', title: 'Downloaded', roles: ['label'], icon: __webpack_require__(770) }, { id: 'followings', title: 'Following' }, { id: 'followers', title: 'Followers' }],
      slug: null,
      user: {
        display_name: '',
        avatar: {}
      },
      show_block_user_confirm_dialog: false,
      show_invite_confirm_dialog: false,
      showPageMerchModal: false,
      selectedProduct: {},
      showPageShareModal: false,
      showSendMessage: false,
      showShareModal: false,
      showMembershipModal: false,
      showPaymentModal: false,
      showFollowCard: false,
      showSendLoveModal: false,
      show_stream_live_button: false,
      view_stream_clicked: false,
      grid_show: true,
      auto_play: false,
      startIndex: 0,
      page_index: 1,
      total_pages: 0,
      items_per_page: 5 * 10,
      selectedTier: null,
      genres: null,
      genre_index: 0,
      followings_selector: 'followings',
      products: [],
      albums: [],
      users: [],
      buttonHover: false,
      isPageReady: false,
      ownVideos: [],
      smsList: [],
      slickOptions: {
        infinite: false,
        slidesToShow: 5,
        slidesToScroll: 5,
        dots: false,
        cssEase: 'linear',
        arrows: false,
        rows: 1
      },
      allTiers: null,
      monthlyTier: true,
      purchasePrice: null,
      showConfirmPurchaseDialog: false,
      purchaseModal: false,
      stripePriceId: null,
      amount: 0,
      membership_tiers: [],
      membership_id: null,
      darkMode: false,
      show_order_complete_dialog: false,
      stripe_inprogress: false
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapState */])({
    sideBarWidth: function sideBarWidth(state) {
      return state.app.sideBarWidth;
    },
    plansData: function plansData(state) {
      return state.app.plansData;
    }
  }), {
    onMobile: function onMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    currentUser: function currentUser() {
      return this.$store.state.auth.user;
    },
    userLocation: function userLocation() {
      return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.user, 'default_address.city', '--');
    },
    enabledViewDirectMessage: function enabledViewDirectMessage() {
      return this.currentUser.user_type === 'admin' || this.currentUser.user_type === 'moderator' && __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.currentUser, 'enabled_view_direct_message') === true;
    },
    coverImageURL: function coverImageURL() {
      var imageUrl = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.albums, '[' + this.startIndex + '].cover.thumb.url', '');
      if (imageUrl) {
        return imageUrl + '?' + new Date();
      }
      return imageUrl;
    },
    albumDisplayCount: function albumDisplayCount() {
      if (this.albums.length > 7) {
        return 7;
      } else {
        return this.albums.length;
      }
    },
    merchDisplayCount: function merchDisplayCount() {
      if (this.products.length > 7) {
        return 7;
      } else {
        return this.products.length;
      }
    },
    streamViewpurchasePrice: function streamViewpurchasePrice() {
      return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.user, 'stream.view_price', 0);
    },
    followMetaVisible: function followMetaVisible() {
      return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.user, 'username') !== __WEBPACK_IMPORTED_MODULE_12__helper__["c" /* PublicRelationsUsername */] || __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.currentUser, 'user_type') === 'admin';
    },
    followButtonText: function followButtonText() {
      if (this.user.is_following) {
        return this.buttonHover ? 'Unfollow' : 'Following';
      }
      return 'Follow';
    },
    smsCount: function smsCount() {
      return this.smsList.length;
    },
    isUserSignedUp: function isUserSignedUp() {
      return this.currentUser.phone_number;
    },
    userIsFollowing: function userIsFollowing() {
      return this.user.is_following;
    }
  }),

  watch: {
    $route: function $route(toPath, fromPath) {
      var paths = toPath.path.split('/');
      this.slug = paths[1];
      var tab = toPath.hash.substr(1);
      var grid_view = toPath.query.grid_view === undefined ? true : toPath.query.grid_view === 'true' || toPath.query.grid_view === true;
      var auto_play = toPath.query.auto_play === undefined ? false : toPath.query.auto_play === 'true' || toPath.query.auto_play === true;
      this.init(tab, grid_view, auto_play, false);
    },
    monthlyTier: function monthlyTier(oldVal, _newVal) {
      this.membership_tiers = oldVal ? this.allTiers.monthly : this.allTiers.annual;
    },
    showMembershipModal: function showMembershipModal(oldVal, _newVal) {
      this.selectedTier = oldVal ? this.selectedTier : null;
    }
  },

  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var tab, grid_view, auto_play;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              window.addEventListener('scroll', _this.handleScroll);
              _this.slug = _this.$route.params.slug;
              _context.next = 4;
              return _this.ownStream();

            case 4:
              tab = _this.$route.hash.substr(1);
              grid_view = _this.$route.query.grid_view === undefined ? true : _this.$route.query.grid_view === 'true' || _this.$route.query.grid_view === true;
              auto_play = _this.$route.query.auto_play === undefined ? false : _this.$route.query.auto_play === 'true' || _this.$route.query.auto_play === true;

              _this.init(tab, grid_view, auto_play, true);

              _this.$root.$on(__WEBPACK_IMPORTED_MODULE_12__helper__["b" /* MyEvents */].USER_FOLLOW, _this.setFollowingStatus);

              _this.listAllSMS();

            case 10:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    this.$root.$off(__WEBPACK_IMPORTED_MODULE_12__helper__["b" /* MyEvents */].USER_FOLLOW, this.setFollowingStatus);
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapActions */])({
    setPlaylist: 'player/setPlaylist',
    setPlaylistIndex: 'player/setListIndex',
    setPlaying: 'player/setPlayingStatus'
  }), {
    ownStream: function ownStream(tab, page) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var userId, params;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.$store.dispatch('error/showLoadingActivity', true);
                userId = _this2.currentUser.id;
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_8__services_user__["a" /* default */].getUserInfo(_this2.slug).then(function (response) {
                  userId = response.body.id;
                }).catch(function (err) {
                  console.log('error in fetching user info', err);
                });

              case 4:
                params = {
                  genre_id: 0, // default for all videos
                  only_follows: _this2.only_follows,
                  page: 1, // get page 1
                  per_page: 100,
                  user_id: userId
                };

                console.log("========================", userId);
                __WEBPACK_IMPORTED_MODULE_27__services_stream__["a" /* default */].getStreams(params).then(function (response) {
                  console.log(response.body.streams);
                  _this2.ownVideos = response.body.streams.filter(function (str) {
                    return _this2.user.display_name == str.user.display_name;
                  });
                  // this.ownVideos = this.ownVideos.concat(response.body.streams)
                  // this.ownVideos = [ ...this.ownVideos, ...this.ownVideos]
                  _this2.pagination = response.body.pagination;
                  _this2.videoGenres = response.body.genres;
                  _this2.$store.dispatch('error/showLoadingActivity', false);
                }).catch(function () {
                  _this2.$store.dispatch('error/showLoadingActivity', false);
                });

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    loadMore: function loadMore() {
      this.loadData(this.pagination.current_page + 1);
    },
    handleScroll: function handleScroll(event) {
      if (this.show_following) {
        var navProfileCard = document.querySelector('.special-scroll-header');

        var y = window.scrollY;
        if (y >= 75) {
          this.show_following_scroll = true;
          this.show_followers_scroll = true;
        } else {
          this.show_following_scroll = false;
          this.show_followers_scroll = false;
        }
      } else {
        this.show_following_scroll = false;
        this.show_followers_scroll = false;
      }
    },
    isActiveTab: function isActiveTab(tab) {
      return this.active_tab === tab;
    },
    onTab: function onTab(tab) {
      if (tab == "followings") {
        console.log('user', this.currentUser);
        if (this.currentUser.id != this.user.id) {
          this.show_following = true;
        }
      } else if (tab == "followers") {
        console.log('user', this.currentUser);
        if (this.currentUser.id != this.user.id) {
          this.show_followers = true;
        }
      } else {
        this.show_following = false;
        this.show_following_scroll = false;
        this.show_followers = false;
        this.show_followers_scroll = false;
      }
      this.$router.push({
        path: this.$route.path,
        hash: tab
        // query: {
        //   grid_view: this.grid_show
        // }

      });
    },
    setGridView: function setGridView(flag) {
      this.$router.push({
        path: this.$route.path,
        hash: this.active_tab
        // query: {
        //   grid_view: flag
        // }
      });
    },
    isStreaming: function isStreaming() {
      // console.log(_.get(this.$store.state.streamPlayer.user, 'slug', ''), this.user.slug, this.$store.state.streamPlayer.frame_mode)
      return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.user.stream, 'status', '') === 'running' && __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.user.stream, 'notified', false) && (__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.$store.state.streamPlayer.stream, 'user.slug', '') !== this.user.slug || !this.$store.getters['streamPlayer/hasFrame']);
    },
    viewStream: function viewStream() {
      var _this3 = this;

      console.log('viewStream clicked');
      this.view_stream_clicked = true;
      __WEBPACK_IMPORTED_MODULE_8__services_user__["a" /* default */].getUserInfo(this.slug).then(function (response) {
        _this3.user = response.body;
        _this3.view_stream_clicked = false;

        if (_this3.isStreaming()) {
          _this3.$store.dispatch('streamPlayer/setStream', _this3.user.stream);
          _this3.$root.$emit(__WEBPACK_IMPORTED_MODULE_12__helper__["b" /* MyEvents */].STREM_PLAYER_INIT);
        }
      }).catch(function (err) {
        console.log('profle/viewStream', err);
        _this3.view_stream_clicked = false;
      });
    },
    init: function init(tab, grid_view, auto_play, first_visit) {
      var _this4 = this;

      this.show_stream_live_button = false;
      this.showSendMessage = false;
      this.startIndex = 0;
      this.genres = [{
        id: 'any',
        name: 'Any genre',
        slug: 'any'
      }];
      this.total_pages = 0;

      this.$store.dispatch('error/showLoadingActivity', true);
      __WEBPACK_IMPORTED_MODULE_8__services_user__["a" /* default */].getUserInfo(this.slug).then(function (response) {
        if (response.body.status !== 'active') {
          _this4.$store.dispatch('error/showErrorToast', ['User does not exist']);
          _this4.$router.push({ name: 'AlbumIndex' });
          return;
        }

        // console.log('profile init')
        _this4.user = response.body;
        _this4.$emit('updateHead');

        if (_this4.isStreaming()) {
          __WEBPACK_IMPORTED_MODULE_5_vue__["default"].http.get(_this4.user.stream.mp_channel_1_ep_1_url).then(function () {
            _this4.show_stream_live_button = true;
            if (first_visit) {
              // console.log('calling ...', MyEvents.STREM_PLAYER_INIT)
              _this4.$store.dispatch('streamPlayer/setStream', _this4.user.stream);
              _this4.$root.$emit(__WEBPACK_IMPORTED_MODULE_12__helper__["b" /* MyEvents */].STREM_PLAYER_INIT);
            }
          });
          // this.$store.dispatch('streamPlayer/setStream', this.user.stream)
          // this.$root.$emit(MyEvents.STREM_PLAYER_INIT)
        }

        // // put 'merch' tab first for brand
        // if (this.user.user_type === 'brand') {
        //   if (this.tabs[7].id === 'merch') {
        //     this.tabs.unshift(this.tabs.pop())
        //   }
        // } else {
        //   if (this.tabs[7].id !== 'merch') {
        //     this.tabs.push(this.tabs.shift())
        //   }
        // }
        if (_this4.currentUser.id === _this4.user.id) {
          _this4.tabs.filter(function (tab) {
            return tab.id == 'songs';
          })[0].title = 'Releases';
        } else {
          _this4.tabs = _this4.tabs.filter(function (tab) {
            return tab.id !== 'sms_group';
          });
        }
        if (tab) {
          _this4.active_tab = tab;
          _this4.slide_tab = tab;
        } else {
          switch (_this4.user.user_type) {
            case 'artist':
              _this4.active_tab = 'songs';
              _this4.slide_tab = 'songs';

              // this.active_tab = 'followings'
              // this.slide_tab = 'followings'
              break;
            case 'label':
              _this4.active_tab = 'artists';
              _this4.slide_tab = 'artists';
              break;
            case 'brand':
              _this4.active_tab = 'merch';
              _this4.slide_tab = 'merch';
              break;
            default:
              // this.active_tab = 'playlists'
              // this.slide_tab = 'playlists'
              _this4.active_tab = 'reposted';
              _this4.slide_tab = 'reposted';
              break;
          }
        }

        _this4.grid_show = grid_view;
        _this4.auto_play = auto_play;
        _this4.$store.dispatch('player/setGridShow', grid_view);
        if (grid_view) {
          _this4.active_tab = _this4.slide_tab;
          _this4.$store.dispatch('navigator/goNextState', {
            page: 'profile',
            tab: _this4.active_tab
          });
        } else {
          _this4.slide_tab = _this4.active_tab;
          _this4.$store.dispatch('navigator/goNextState', {
            page: 'profile-slider',
            tab: _this4.active_tab
          });
        }

        if (_this4.active_tab !== 'video' && _this4.active_tab !== 'sms_group') {
          // temp implementation because there is no video 'getItems' yet
          _this4.getItems(_this4.active_tab, false);
        }
        _this4.isPageReady = false;
        _this4.$store.dispatch('error/showLoadingActivity', false);

        if (window.location.search == '?membership_tier_modal' && _this4.user.membership_tiers != 0 && _this4.currentUser.id != _this4.user.id) {
          _this4.showMembershipDialog();
        }
      }).catch(function (e) {
        _this4.$store.dispatch('error/showLoadingActivity', false);
        _this4.$store.dispatch('error/showErrorToast', ['User does not exist']);
        _this4.$router.push({ path: '/' });
        // this.$store.dispatch('error/showErrorToast', e.body.errors || [e.body])
        // setTimeout(() => {
        //   this.$router.push({ path: '/album' })
        // }, 5000)
      });
    },
    getItems: function getItems(tab, loadMore) {
      var _this5 = this;

      if (!loadMore) {
        this.albums = [];
        this.products = [];
        this.users = [];
        this.startIndex = 0;
        this.page_index = 1;
      } else {
        this.page_index += 1;
      }

      var params = {
        page: this.page_index,
        per_page: this.items_per_page
      };
      this.$store.dispatch('error/showLoadingActivity', true);
      __WEBPACK_IMPORTED_MODULE_7__services_profile__["a" /* default */].getItems(this.user.id, tab, params).then(function (response) {
        console.log(response.body);
        _this5.$store.dispatch('error/showLoadingActivity', false);
        switch (tab) {
          case 'merch':
            _this5.products = _this5.products.concat(response.body.products);
            break;
          case 'followers':
          case 'followings':
          case 'artists':
            _this5.users = _this5.users.concat(response.body.users);
            break;
          case 'video':
            _this5.users = _this5.users.concat(response.body.users);
            break;
          case 'sms_group':
            break;
          default:
            var albums = [];
            if (tab === 'reposted' || tab === 'downloaded') {
              for (var index in response.body.feeds) {
                if (response.body.feeds[index].assoc_type === 'Album') {
                  albums.push(response.body.feeds[index].assoc);
                }
              }
            } else {
              albums = response.body.albums;
            }
            _this5.fillAlbums(albums);

            if (tab === 'songs' && _this5.auto_play) {
              _this5.auto_play = false;
              _this5.playSong();
            }

            if (!_this5.grid_show) {
              _this5.changeBackground();
            }
            break;
        }

        _this5.page_index = response.body.pagination.current_page;
        _this5.total_pages = response.body.pagination.total_pages;
      }).catch(function (e) {
        console.log(e);
        console.log(e.message);
        _this5.$store.dispatch('error/showLoadingActivity', false);
        _this5.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    fillAlbums: function fillAlbums(albums) {
      var genres = this.genres.slice();
      for (var album_index in albums) {
        var album = albums[album_index];
        genres = genres.concat(album.genres);
        album.genre_ids = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(album.genres, 'id').join(',');
        this.albums.push(album);

        /* focus the album on playing in slider view */
        if (this.$store.state.player.isPlaying && !this.grid_show) {
          var currentItem = this.$store.state.player.list[this.$store.state.player.listIndex];
          if (currentItem.assoc_type) {
            if (currentItem.assoc.id === album.id) {
              this.startIndex = album_index;
            }
          } else {
            if (currentItem.id === album.id) {
              this.startIndex = album_index;
            }
          }
        }
      }
      this.genres = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.uniqBy(genres, 'id');
      // console.log(this.active_tab, albums)
      // console.log(this.albums)
    },
    setFollowingsSelector: function setFollowingsSelector(value, name) {
      if (this.followings_selector !== value) {
        this.followings_selector = value;
        $('#followings_selector .btn__content').html(name + '<i class="material-icons icon icon--right theme--dark">keyboard_arrow_down</i>');
        this.getItems(this.active_tab, false);
      }
    },
    onAfterAlbumSlideChange: function onAfterAlbumSlideChange(index) {
      // if(this.$store.state.player.isPlaying && this.$store.state.player.page === 'profile' && !this.grid_show) {
      //   this.$refs.albumCarousel.goSlide(this.$store.state.player.listIndex)
      // } else {
      //   this.startIndex = index
      // }
      this.startIndex = index;
      this.changeBackground();
    },
    onAfterMerchSlideChange: function onAfterMerchSlideChange(index) {},
    changeBackground: function changeBackground() {
      var canvas = document.getElementById('canvas');
      var cctx = canvas.getContext('2d');
      if (this.coverImageURL) {
        var buff = document.createElement('canvas');
        buff.width = canvas.width;
        buff.height = canvas.height;
        var imageObj = new Image();
        // this will make CORS happy because the server is well configured
        imageObj.crossOrigin = 'anonymous';
        // Easiest is to always host your images on your own server
        // imageObj.src = 'https://dl.dropboxusercontent.com/s/8q8sjnqmmto13h5/lionCMYK.jpg'
        imageObj.src = this.coverImageURL;
        imageObj.onload = function () {
          // canvas.width = imageObj.height
          // canvas.height = imageObj.height
          cctx.drawImage(imageObj, 0, 0);
          window.StackBlur.image(imageObj, canvas, 70, false);
        };
      } else {
        cctx.clearRect(0, 0, canvas.width, canvas.height);
      }
    },
    isAvailableForSlideView: function isAvailableForSlideView(tab) {
      return ['artists', 'followings'].indexOf(tab.id) === -1 && (!tab.roles || tab.roles.indexOf(this.user.user_type) > -1);
    },
    isAvailableForGridView: function isAvailableForGridView(tab) {
      return !tab.roles || tab.roles.indexOf(this.user.user_type) > -1;
    },
    closePageMerchModal: function closePageMerchModal() {
      this.showPageMerchModal = false;
    },
    openPageMerchModal: function openPageMerchModal(product) {
      var _this6 = this;

      // console.log('openPageMerchModal', product)
      this.selectedProduct = product;
      this.$nextTick(function () {
        _this6.showPageMerchModal = true;
      });
    },
    closePageShareModal: function closePageShareModal() {
      this.showPageShareModal = false;
    },
    openPageShareModal: function openPageShareModal() {
      // console.log('openPageShareModal')
      this.showPageMerchModal = false;
      this.showPageShareModal = true;
    },
    showMessageDialog: function showMessageDialog() {
      this.showSendMessage = true;
    },
    dismissMessageModal: function dismissMessageModal() {
      this.showSendMessage = false;
    },
    showLoveDialog: function showLoveDialog() {
      this.showSendLoveModal = true;
    },
    dismissLoveDialog: function dismissLoveDialog() {
      this.showSendLoveModal = false;
    },
    viewDirectMessages: function viewDirectMessages() {
      this.$router.push({ path: '/user/' + this.user.slug + '/messages' });
    },
    goToChat: function goToChat() {
      this.$router.push({ path: '/user/' + this.user.slug + '/chat' });
    },
    flagUser: function flagUser() {
      var emailTo = __WEBPACK_IMPORTED_MODULE_12__helper__["h" /* ViolationsEmail */];
      var emailCC = '';
      var emailSub = '';
      var emailBody = '';
      window.open('mailto:' + emailTo + '?cc=' + emailCC + '&subject=' + emailSub + '&body=' + emailBody, '_blank');
    },
    openBlockUserConfirmDialog: function openBlockUserConfirmDialog() {
      this.show_block_user_confirm_dialog = true;
    },
    closeBlockUserConfirmDialog: function closeBlockUserConfirmDialog() {
      this.show_block_user_confirm_dialog = false;
    },
    blockUser: function blockUser() {
      var _this7 = this;

      __WEBPACK_IMPORTED_MODULE_8__services_user__["a" /* default */].blockUser(this.user.id).then(function (response) {
        _this7.$store.dispatch('error/showSuccessToast', ['You blocked ' + _this7.user.display_name + ', go to settings page to unblock']);
      }).catch(function (e) {
        _this7.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
      this.closeBlockUserConfirmDialog();
    },
    setFollowingStatus: function setFollowingStatus(userId, isFollowing) {
      if (this.user && this.user.id === userId) {
        this.user.is_following = isFollowing;
      }
    },
    openInviteConfirmDialog: function openInviteConfirmDialog() {
      this.show_invite_confirm_dialog = true;
    },
    closeInviteConfirmDialog: function closeInviteConfirmDialog() {
      this.show_invite_confirm_dialog = false;
    },
    inviteUser: function inviteUser() {
      var _this8 = this;

      this.closeInviteConfirmDialog();
      __WEBPACK_IMPORTED_MODULE_8__services_user__["a" /* default */].inviteUser(this.user.id).then(function (response) {
        _this8.user = response.body;
        _this8.$store.dispatch('error/showSuccessToast', ['Invited']);
      });
    },
    playSong: function playSong() {
      if (this.active_tab === 'songs' || this.albums.length) {
        this.setPlaylist(this.albums);
        this.setPlaylistIndex(0);
        this.setPlaying(true);
        this.$root.$emit('play');
      } else {
        this.$router.push({
          path: this.$route.path,
          hash: 'songs',
          query: {
            // grid_view: this.grid_show,
            auto_play: true
          }
        });
      }
    },
    moveSlide: function moveSlide() {
      if (this.$refs.albumCarousel !== undefined) {
        var lastState = this.$store.getters['navigator/last'];
        if (lastState.page === 'profile') {
          this.$refs.albumCarousel.goSlide(this.$store.state.player.listIndex);
        } else {
          var playingIndex = -1;
          for (var index in this.albums) {
            var currentItem = this.albums[index];
            var playingItem = this.$store.state.player.list[this.$store.state.player.listIndex];
            if (playingItem !== undefined) {
              if (playingItem.assoc_type === 'Album') {
                playingItem = playingItem.assoc;
              }
              if (playingItem.id === currentItem.id) {
                playingIndex = index;
                break;
              }
            }
          }
          this.$refs.albumCarousel.goSlide(parseInt(playingIndex));
        }
      }
    },
    signOut: function signOut() {
      __WEBPACK_IMPORTED_MODULE_26__services_auth__["a" /* default */].signout();
      this.$router.push({ path: '/login' });
      this.$root.$emit(__WEBPACK_IMPORTED_MODULE_12__helper__["b" /* MyEvents */].AUTH_SIGNOUT);
    },
    listAllSMS: function listAllSMS() {
      var _this9 = this;

      __WEBPACK_IMPORTED_MODULE_11__services_sms__["a" /* default */].listSMS().then(function (response) {
        _this9.smsList = response.body;
      }).catch(function (e) {
        _this9.$store.dispatch("error/showErrorToast", e.body.errors || [e.body]);
      });
    },
    setMenuAction: function setMenuAction(menu) {
      switch (menu.id) {
        case "profile":
          this.$router.push('/' + this.currentUser.slug);
          break;
        case "signOut":
          this.signOut();
          break;
        default:
          this.$router.push({ name: menu.pathName });
          break;
      }
    },
    showMembershipDialog: function showMembershipDialog() {
      this.getMembershipTiers();
    },
    showPaymentDialog: function showPaymentDialog() {
      this.showPaymentModal = true;
    },
    showFollowCardDialog: function showFollowCardDialog() {
      this.showFollowCard = true;
    },
    dismissMembershipDialog: function dismissMembershipDialog() {
      this.showMembershipModal = false;
    },
    dismissPaymentDialog: function dismissPaymentDialog() {
      this.showPaymentModal = false;
    },
    getMembershipTiers: function getMembershipTiers() {
      var _this10 = this;

      __WEBPACK_IMPORTED_MODULE_8__services_user__["a" /* default */].getMembershipTiers(this.user.id).then(function (response) {
        _this10.allTiers = { monthly: [], annual: [] };
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(response.body.monthly), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var tier = _step.value;

            if (tier.content_present) _this10.allTiers['monthly'].push(tier);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(response.body.annual), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var _tier = _step2.value;

            console.log(_tier);
            if (_tier.content_present) _this10.allTiers['annual'].push(_tier);
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        _this10.membership_tiers = _this10.monthlyTier ? _this10.allTiers.monthly : _this10.allTiers.annual;
        _this10.showMembershipModal = true;
      }).catch(function (e) {
        _this10.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    purchaseMembership: function purchaseMembership(tier) {
      var membership_id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (this.purchaseMembershipBtnTitle(tier) == 'Visit membership area') return this.$router.push({ path: '/members/' + this.user.slug });

      this.selectedTier = tier;
      this.membership_id = membership_id;

      if (this.currentUser.stripe_customer_id == null) {
        this.purchasePrice = this.selectedTier.total_price;
        this.showPaymentDialog();
      } else {
        this.purchasePrice = this.selectedTier.total_price;
        this.openPurchaseModal();
      }
    },
    openPurchaseModal: function openPurchaseModal() {
      this.purchaseModal = true;
    },
    hidePurchaseModal: function hidePurchaseModal() {
      this.purchaseModal = false;
    },
    handlePayment: function handlePayment() {
      var _this11 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_32_vue_stripe_elements__["createToken"])().then(function (data) {
        _this11.storeCard(data.token);
      });
    },
    storeCard: function storeCard(token_response) {
      var _this12 = this;

      __WEBPACK_IMPORTED_MODULE_8__services_user__["a" /* default */].storeCard(this.currentUser.id, { token_response: token_response }).then(function (response) {
        return [_this12.purchase()];
      }).catch(function (e) {
        _this12.$store.dispatch('error/showErrorToast', ["Unable to store payment information"]);
      });
    },
    purchase: function purchase() {
      var _this13 = this;

      if (this.getMembershipId(this.selectedTier)) return this.update();

      this.stripe_inprogress = true;
      __WEBPACK_IMPORTED_MODULE_9__services_membership__["a" /* default */].purchaseMembership({ membership_tier_id: this.selectedTier.id }).then(function (response) {
        _this13.paymentSuccessful = true;
        _this13.purchaseModal = false;
        _this13.showMembershipModal = false;
        _this13.showPaymentModal = false;

        _this13.updateCurrentUserInfo();
        _this13.followUser(response);
        _this13.stripe_inprogress = false;
      }).catch(function (e) {
        _this13.stripe_inprogress = false;
        _this13.$store.dispatch('error/showLoadingActivity', false);
        _this13.$store.dispatch('error/showErrorToast', ["Purchase unsuccessful"]);
      });
    },
    update: function update() {
      var _this14 = this;

      this.stripe_inprogress = true;
      __WEBPACK_IMPORTED_MODULE_9__services_membership__["a" /* default */].updateMembership(this.getMembershipId(this.selectedTier), { membership_tier_id: this.selectedTier.id }).then(function (response) {
        _this14.paymentSuccessful = true;
        _this14.purchaseModal = false;
        _this14.showMembershipModal = false;
        _this14.showPaymentModal = false;

        _this14.$store.dispatch('error/showLoadingActivity', false);
        _this14.$store.dispatch('error/showSuccessToast', ["You have successfully updated this membership."]);

        _this14.updateCurrentUserInfo();
        _this14.$forceUpdate();
        _this14.show_order_complete_dialog = true;
        _this14.stripe_inprogress = false;
      }).catch(function (e) {
        _this14.stripe_inprogress = false;
        _this14.$store.dispatch('error/showLoadingActivity', false);
        _this14.$store.dispatch('error/showErrorToast', ["Purchase unsuccessful"]);
      });
    },
    updateCurrentUserInfo: function updateCurrentUserInfo() {
      var _this15 = this;

      __WEBPACK_IMPORTED_MODULE_8__services_user__["a" /* default */].getUserInfo(this.currentUser.id).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_26__services_auth__["a" /* default */].setUser(response.body);
        _this15.$store.dispatch('auth/setUser', response.body);
      });
    },
    followUser: function followUser() {
      var _this16 = this;

      if (this.user.is_following) {
        this.$store.dispatch('error/showSuccessToast', ['You have successfully purchased the membership']);
        this.$forceUpdate();
        this.show_order_complete_dialog = true;
      } else {
        __WEBPACK_IMPORTED_MODULE_8__services_user__["a" /* default */].followUser(this.user.id, {}).then(function (response) {
          _this16.user.is_following = true;
          _this16.$store.dispatch('error/showLoadingActivity', false);
          _this16.$store.dispatch('error/showSuccessToast', ['You have successfully purchased this membership. You are now following ' + _this16.user.display_name]);

          _this16.$forceUpdate();
          _this16.show_order_complete_dialog = true;
        }).catch(function (e) {
          _this16.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
        });
      }
    },
    purchaseMembershipBtnTitle: function purchaseMembershipBtnTitle(tier) {
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.currentUser.memberships), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var _membership = _step3.value;

          if (_membership.membership_tier_id == tier.id) {
            return 'Visit membership area';
          } else if (tier.membership_tier_id == _membership.membership_tier_id) {
            return 'Switch to Annual';
          } else if (_membership.membership_tier != undefined && tier.id == _membership.membership_tier.membership_tier_id) {
            return 'Switch to Monthly';
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      return 'Purchase';
    },
    getMembershipId: function getMembershipId(tier) {
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.currentUser.memberships), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var _membership2 = _step4.value;

          if (_membership2.membership_tier_id == tier.id) {
            return _membership2.id;
          } else if (tier.membership_tier_id == _membership2.membership_tier_id) {
            if (tier.plan_type == 'monthly') {
              return null;
            } else {
              return _membership2.id;
            }
          } else if (_membership2.membership_tier != undefined && tier.id == _membership2.membership_tier.membership_tier_id) {
            return _membership2.id;
          }
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      return null;
    },
    purchasedPlan: function purchasedPlan(tier) {
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.currentUser.memberships), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var _membership3 = _step5.value;

          if (_membership3.membership_tier_id == tier.id) {
            return true;
          }
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      return false;
    },
    totalPayable: function totalPayable() {
      return this.purchasePrice / 100 + (this.currentUser.plan == null ? parseInt(this.amount) : 0);
    },
    fromNow: function fromNow(date) {
      return __WEBPACK_IMPORTED_MODULE_31_moment___default()(date).fromNow();
    },
    modeToggle: function modeToggle() {
      var app_container = $(this.$parent.$parent.$el);
      if (this.darkMode) {
        app_container.find('.app-container').addClass('dark-mode bg-grey');
      } else {
        app_container.find('.app-container').removeClass('dark-mode bg-grey');
      }
    }
  }),

  mounted: function mounted() {
    this.modeToggle();
    this.$root.$on('index_change', this.moveSlide);
    $(window).resize(function () {
      var height = $('#user_info_page').height() + 230;
      var screen_height = $(window).height();
      if (height > screen_height) {
        height += 50;
      } else {
        height = screen_height;
      }
      var canvas = document.getElementById('canvas');
      if (canvas) {
        $('#canvas').css('cssText', 'height: ' + height + 'px !important;');
      }
      $('#back_image').css('cssText', 'height: ' + height + 'px !important;');
    }).trigger('resize');
  },


  head: {
    title: function title() {
      return {
        inner: __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.user, 'display_name', '')
      };
    }
  }
});

/***/ }),
/* 1117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_me__ = __webpack_require__(28);


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },


  computed: {},

  created: function created() {
    console.log('stripe_connect created', this.$store.state.auth.user);
    this.$store.dispatch('auth/setSecretCode', this.$route.query['state']);
    for (var key in this.$route.query) {
      if (key === 'code') {
        this.connectStripe(this.$route.query[key]);
        break;
      }
    }
  },


  methods: {
    connectStripe: function connectStripe(code) {
      var _this = this;

      var params = {
        code: code
      };
      __WEBPACK_IMPORTED_MODULE_0__services_me__["a" /* default */].connectStripe(params).then(function (response) {
        _this.$store.dispatch('error/showSuccessToast', ['Stripe Conected!']);
        _this.$router.push({ path: '/settings#bank-details' });
      }).catch(function (e) {
        _this.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    }
  }
});

/***/ }),
/* 1118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_contentTopHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_contentTopHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_contentTopHeader__);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    name: String,
    tabActivePill: Boolean
  },
  components: {
    contentTopHeader: __WEBPACK_IMPORTED_MODULE_2__components_contentTopHeader___default.a
  },
  data: function data() {
    return {
      activeTab: "",
      tabs: [{
        id: "upload",
        title: "Upload",
        pathName: "UploadIndex"
      }, {
        id: "manage",
        title: "Manage",
        pathName: "ManageIndex"
      }]
    };
  },


  computed: {
    currentUser: function currentUser() {
      return this.$store.state.auth.user;
    }
  },

  methods: {
    isActiveTab: function isActiveTab(tab) {
      return this.name === tab;
    },
    isActiveInnerTab: function isActiveInnerTab(tab) {
      return this.activeInnerTab === tab;
    },
    setTab: function setTab(pathName) {
      this.$router.push({ name: pathName });
    }
  },

  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.activeTab = _this.name;

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 1119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_auth__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_me__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_payment__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_stream__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_album__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_product__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_user__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_attach__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_attach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_attach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_paymentmodal__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_paymentmodal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_paymentmodal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_digital_uploader__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_digital_uploader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_digital_uploader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_contentTopHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_contentTopHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_contentTopHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_video_estimate__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_video_estimate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__views_video_estimate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_topbarNotification__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_topbarNotification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_topbarNotification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_nav_vue__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_nav_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_nav_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__helper__ = __webpack_require__(2);






// import * as UpChunk from '@mux/upchunk'

















/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Attach: __WEBPACK_IMPORTED_MODULE_13__components_attach___default.a,
    PaymentModal: __WEBPACK_IMPORTED_MODULE_14__components_paymentmodal___default.a,
    DigitalUploader: __WEBPACK_IMPORTED_MODULE_15__components_digital_uploader___default.a,
    contentTopHeader: __WEBPACK_IMPORTED_MODULE_16__components_contentTopHeader___default.a,
    videoEstimate: __WEBPACK_IMPORTED_MODULE_17__views_video_estimate___default.a,
    topbarNotification: __WEBPACK_IMPORTED_MODULE_18__components_topbarNotification___default.a,
    uploadNav: __WEBPACK_IMPORTED_MODULE_19__components_nav_vue___default.a
  },

  data: function data() {
    return {
      topBarContent: 'Connect your Stripe account to start accepting payments',
      activeView: 'initStream',
      active_tab: 'create',
      tabs: [{ id: 'info', title: 'Intro', path: '/info' }, { id: 'create', title: 'Setup' }, { id: 'manage', title: 'Live Stream', disabled: true }],
      albums: [],
      products: [],
      VideoTypes: __WEBPACK_IMPORTED_MODULE_20__helper__["l" /* VideoTypes */],
      video_type: __WEBPACK_IMPORTED_MODULE_20__helper__["l" /* VideoTypes */].LIVE,
      terms: false,
      view_prices: __WEBPACK_IMPORTED_MODULE_20__helper__["j" /* StreamViewPrices */],
      costs: __WEBPACK_IMPORTED_MODULE_20__helper__["m" /* StreamCosts */],
      streamCost: 1000,
      profit_share_types: [],
      // periods: [],
      // period: 3600,
      // genres: [],
      stream: {
        name: '',
        description: '',
        view_price: 0,
        viewers_limit: 1,
        cover: null,
        ml_input_type: 'RTMP_PUSH',
        ml_input_codec: 'AVC',
        ml_input_resolution: 'HD',
        ml_input_maximum_bitrate: 'MAX_10_MBPS',
        collaborators: [],
        account_ids: [],
        creator_recoup_cost: 0
      },
      stream_cover_url: null,
      stream_assoc: {
        type: 'Album',
        value: null
      },
      digital_content: {
        file: null
      },
      show_payment_dialog: false,
      show_stripe_connect_dialog: false,
      show_help_dialog: false,
      show_attach_picker: false,
      show_collaborators_dialog: false,
      users: [],
      friends: [],
      isPageReady: false,
      user: {}
    };
  },


  computed: {
    onMobile: function onMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    hasFree_stream_seconds: function hasFree_stream_seconds() {
      return this.user.free_stream_seconds !== undefined && this.user.free_stream_seconds > 0;
    },
    mergedAttachmentItems: function mergedAttachmentItems() {
      var combined = [].concat(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray___default()(this.albums), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray___default()(this.products));

      return combined;
    },
    viewers_limits: function viewers_limits() {
      var range = [].concat(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray___default()(Array(101).keys()));
      range.shift();
      return range;
    },
    currentUser: function currentUser() {
      return this.$store.state.auth.user;
    },
    isStreaming: function isStreaming() {
      return _.get(this.user.stream, 'status', '') === 'running' && _.get(this.user.stream, 'notified', false) && (_.get(this.$store.state.streamPlayer.stream, 'user.slug', '') !== this.user.slug || !this.$store.getters['streamPlayer/hasFrame']);
    },
    MediaLiveInputTypes: function MediaLiveInputTypes() {
      return __WEBPACK_IMPORTED_MODULE_20__helper__["o" /* MediaLiveInputTypes */];
    },
    MediaLiveInputCodecs: function MediaLiveInputCodecs() {
      return __WEBPACK_IMPORTED_MODULE_20__helper__["p" /* MediaLiveInputCodecs */];
    },
    MediaLiveInputResolutions: function MediaLiveInputResolutions() {
      return __WEBPACK_IMPORTED_MODULE_20__helper__["q" /* MediaLiveInputResolutions */];
    },
    MediaLiveInputMaximumBitrates: function MediaLiveInputMaximumBitrates() {
      return __WEBPACK_IMPORTED_MODULE_20__helper__["r" /* MediaLiveInputMaximumBitrates */];
    },


    // isValidate() {
    //   return !!this.stream_cover_url
    // },

    // streamCost() {
    //   return Math.round((this.period * StreamHourlyPrice) / 3600)
    // },

    profileUrl: function profileUrl() {
      return window.location.origin + '/' + this.currentUser.slug;
    },
    genres: function genres() {
      return this._.filter(this.$store.state.app.genres, function (g) {
        return __WEBPACK_IMPORTED_MODULE_20__helper__["n" /* VideoGenres */].indexOf(g.name) > -1;
      }).map(function (g) {
        return { id: g.id, name: g.name };
      });
    },
    profiles: function profiles() {
      return this.friends.slice();
    },
    stream_view_price: function stream_view_price() {
      return __WEBPACK_IMPORTED_MODULE_20__helper__["a" /* Filter */].formatNumber(this.stream.view_price);
    },
    creator_share: function creator_share() {
      return 100 - this._.sumBy(this.stream.collaborators, 'user_share');
    }
  },

  // watch: {
  //   '$route' (toPath, fromPath) {
  //   }
  // },

  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var i, params, friendsParams;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (_this.onMobile) {
                _this.$router.push({ name: "UploadIndex" });
              }

              _context.next = 3;
              return _this.getUser();

            case 3:
              console.log(2);

              // get attchment array items
              _this.getAttachmentItems();

              // re-navigate user away when user is on live
              console.log(_this.isStreaming);
              if (_this.isStreaming) {
                _this.$router.push({ name: 'VideoManage' });
              } else if (!_this.hasFree_stream_seconds) {
                _this.$router.push({ name: 'CreateLive' });
              }

              _this.$store.dispatch('navigator/goNextState', {
                page: 'broadcast',
                tab: 'create'
              });

              if (!_this.currentUser.stripe_connected) {
                _this.openStripeConnectDialog();
              } else {
                // if (this.currentUser.data['video_page_visited'] !== 1) {
                //   this.openHelpDialog()
                // }

                // this.genres = _.flatMap(this.$store.state.app.genres, 'children')
                // this.genres = this.$store.state.app.genres
                // VideoGenres.forEach((vg) => {
                //   const g = this._.find(this.$store.state.app.genres, { name: vg })
                //   if (g) {
                //     this.genres.push({ id: g.id, name: g.name })
                //   } else {
                //     console.log('VideoGenres', vg)
                //   }
                // })

                for (i = 1; i <= 100; i++) {
                  _this.profit_share_types.push(i);
                }

                params = {
                  stripe_connected: true,
                  page: 1,
                  per_page: 30
                };
                friendsParams = {
                  page: 1,
                  per_page: 30
                };


                _this.isPageReady = false;
                _this.$store.dispatch('error/showLoadingActivity', true);
                __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_7__services_me__["a" /* default */].mutualUsers(params), __WEBPACK_IMPORTED_MODULE_7__services_me__["a" /* default */].mutualUsers(friendsParams)]).then(function (values) {
                  _this.product_categories = _this.$store.state.app.product_categories;
                  _this.digital_content_category_ids = _this.$store.getters['app/digitalCategoryIds'];

                  _this.users = values[0].body.users;
                  _this.friends = values[1].body.users;
                  _this.isPageReady = true;
                  _this.$store.dispatch('error/showLoadingActivity', false);

                  __WEBPACK_IMPORTED_MODULE_7__services_me__["a" /* default */].mutualUsers(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, params, { per_page: -1 })).then(function (response) {
                    _this.users = response.body.users;
                  });

                  __WEBPACK_IMPORTED_MODULE_7__services_me__["a" /* default */].mutualUsers(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, friendsParams, { per_page: -1 })).then(function (response) {
                    _this.friends = response.body.users;
                  });
                }).catch(function (reason) {
                  console.log(reason);
                  _this.$store.dispatch('error/showLoadingActivity', false);
                  _this.$store.dispatch('error/showErrorToast', reason);
                });

                if (_this.currentUser.enabled_live_video_free) {
                  // this.periods.push({
                  //   id: 1,
                  //   name: '1hour / FREE',
                  // })
                } else {
                  // if (this.currentUser.stream_rolled_time > 0) {
                  //   this.periods.push({
                  //     id: this.currentUser.stream_rolled_time,
                  //     name: `${Filter.timeInHours(
                  //       this.currentUser.stream_rolled_time
                  //     )} / Remaining Unpaid Time`,
                  //   })
                  //   this.period = this.currentUser.stream_rolled_time
                  // }

                  // for (let i = 1; i <= 24; i++) {
                  //   this.periods.push({
                  //     id: i * 3600,
                  //     name: `${i}hours / $${(i * StreamHourlyPrice) / 100}`,
                  //   })
                  // }
                  // this.period = 3600

                  if (_this.currentUser.stream_rolled_cost > 0) {
                    _this.costs.unshift({
                      value: 0,
                      name: '$' + __WEBPACK_IMPORTED_MODULE_20__helper__["a" /* Filter */].formatNumber(_this.currentUser.stream_rolled_cost) + ' - Remaining Cost'
                    });
                    _this.streamCost = 0;
                  }
                }
              }

            case 9:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },


  methods: {
    getAttachmentItems: function getAttachmentItems() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_10__services_album__["a" /* default */].getAlbums({
        statuses: 'published, collaborated',
        user_statuses: 'accepted'
      }), __WEBPACK_IMPORTED_MODULE_11__services_product__["a" /* default */].getProducts({
        statuses: 'published, collaborated',
        stock_statuses: 'active',
        user_statuses: 'accepted'
      })]).then(function (values) {
        _this2.albums = values[0].body;
        _this2.products = values[1].body;
      }).catch(function (reason) {
        console.log(reason);
        // this.$store.dispatch('error/showErrorToast', [reason])
      });
    },
    getUser: function getUser() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_12__services_user__["a" /* default */].getUserInfo(_this3.currentUser.username).then(function (response) {
                  if (response.body.status !== 'active') {
                    _this3.$store.dispatch('error/showErrorToast', ['User does not exist']);
                    _this3.$router.push({ path: '/' });
                    return;
                  }

                  // console.log('profile init')
                  _this3.user = response.body;
                  // this.user.free_stream_seconds = 0 // test
                  console.log('user2: ', _this3.user);
                }).catch(function (e) {
                  _this3.$store.dispatch('error/showErrorToast', ['Error fetching user']);
                });

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    gotoNextView: function gotoNextView(view) {
      this.activeView = view;
    },
    onTab: function onTab(tab) {
      if (tab.id === this.active_tab) return;

      this.$router.push({
        path: '/user/' + this.currentUser.slug + '/video' + tab.path
      });
    },
    openHelpDialog: function openHelpDialog() {
      this.show_help_dialog = true;
    },
    closeHelpDialog: function closeHelpDialog() {
      var _this4 = this;

      this.show_help_dialog = false;
      var params = {
        user: {
          video_page_visited: 1
        }
      };
      __WEBPACK_IMPORTED_MODULE_12__services_user__["a" /* default */].updateUserInfo(this.currentUser.id, params).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_6__services_auth__["a" /* default */].setUser(response.body);
        _this4.$store.dispatch('auth/setUser', response.body);
      });
    },
    openStripeConnectDialog: function openStripeConnectDialog() {
      this.show_stripe_connect_dialog = true;
    },
    closeStripeConnectDialog: function closeStripeConnectDialog() {
      this.show_stripe_connect_dialog = false;
      this.$router.push({ path: '/settings#bank-details' });
    },
    openCollaboratorsDialog: function openCollaboratorsDialog() {
      this.show_collaborators_dialog = true;
    },
    closeCollaboratorsDialog: function closeCollaboratorsDialog() {
      this.show_collaborators_dialog = false;
    },
    addCollaborator: function addCollaborator() {
      this.stream.collaborators.push({
        user_id: '',
        user_share: 5
      });
    },
    deleteCollaborator: function deleteCollaborator(index) {
      this.stream.collaborators.splice(index, 1);
    },
    openPaymentDialog: function openPaymentDialog() {
      var _this5 = this;

      this.$validator.validateAll().then(function (response) {
        if (response === true) {
          if (_this5.currentUser.enabled_live_video_free || _this5.streamCost === 0) {
            _this5.submit();
          } else {
            _this5.show_payment_dialog = true;
          }
        } else {
          _this5.$store.dispatch('error/showErrorToast', [_this5.errors.items[0].msg]);
        }
      }).catch(function (e) {
        console.log('error', e);
      });
    },
    closePaymentDialog: function closePaymentDialog() {
      this.show_payment_dialog = false;
    },
    deposit: function deposit(token) {
      var _this6 = this;

      if (token) {
        var params = {
          payment_token: token.id,
          amount: this.streamCost
          // amount: StreamHourlyPrice
        };
        __WEBPACK_IMPORTED_MODULE_8__services_payment__["a" /* default */].makeDeposit(params).then(function () {
          _this6.submit();
        }).catch(function (e) {
          _this6.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
        });
      } else {
        this.submit();
      }
    },
    imageChanged: function imageChanged(e) {
      var _this7 = this;

      if (e.target.files.length > 0) {
        this.stream.cover = e.target.files[0];
        var reader = new FileReader();
        reader.addEventListener('load', function (event) {
          _this7.stream_cover_url = event.target.result;
        }, false);
        reader.readAsDataURL(this.stream.cover);
      } else {
        this.stream.cover = null;
        this.stream_cover_url = null;
      }
    },
    submit: function submit() {
      var _this8 = this;

      this.$validator.validateAll().then(function (response) {
        if (response === true) {
          var formData = new FormData();
          formData.append('stream[name]', _this8.stream.name);
          formData.append('stream[description]', _this8.stream.description);
          formData.append('stream[genre_id]', _this8.stream.genre_id);
          formData.append('stream[view_price]', _this8.stream.view_price);
          formData.append('stream[valid_period]', _this8.period);
          formData.append('stream[cover]', _this8.stream.cover);
          formData.append('stream[viewers_limit]', _this8.stream.viewers_limit);

          if (_this8.digital_content.file) {
            formData.append('stream[digital_content]', _this8.digital_content.file);

            formData.append('stream[digital_content_name]', _this8.digital_content.file.name);
          }

          formData.append('stream[account_ids]', _this8.stream.account_ids.join(','));
          formData.append('stream[collaborators]', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this8.stream.collaborators));
          formData.append('stream[creator_recoup_cost]', Math.round(_this8.stream.creator_recoup_cost * 100));

          if (_this8.stream_assoc.value) {
            formData.append('stream[assoc_type]', _this8.stream_assoc.type);
            formData.append('stream[assoc_id]', _this8.stream_assoc.value.id);
          }

          _this8.$store.dispatch('error/showLoadingActivity', true);
          __WEBPACK_IMPORTED_MODULE_9__services_stream__["a" /* default */].createStream(formData).then(function (response) {
            _this8.$store.dispatch('error/showLoadingActivity', false);
            _this8.$store.dispatch('auth/setStream', response.body);
            _this8.$router.push({
              path: '/user/' + _this8.currentUser.slug + '/video'
            });
          }).catch(function (e) {
            _this8.$store.dispatch('error/showLoadingActivity', false);
            _this8.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
          });
        } else {
          _this8.$store.dispatch('error/showErrorToast', [_this8.errors.items[0].msg]);
        }
      }).catch(function (e) {
        console.log('error', e);
      });
    }
  }
});

/***/ }),
/* 1120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_stream__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},

  data: function data() {
    return {
      deletingInterval: null
    };
  },


  computed: {
    currentUser: function currentUser() {
      return this.$store.state.auth.user;
    }
  },

  created: function created() {
    var vm = this;
    this.$store.dispatch('navigator/goNextState', {
      page: 'broadcast',
      tab: ''
    });
    this.deletingInterval = setInterval(function () {
      vm.getStream();
    }, 10000);
  },
  beforeDestroy: function beforeDestroy() {
    if (this.deletingInterval) {
      clearInterval(this.deletingInterval);
    }
  },


  methods: {
    getStream: function getStream() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__services_stream__["a" /* default */].getStream(this.currentUser.stream.id).then(function (response) {
        if (response.body.status === __WEBPACK_IMPORTED_MODULE_1__helper__["i" /* StreamStatuses */].DELETED || response.body.status === __WEBPACK_IMPORTED_MODULE_1__helper__["i" /* StreamStatuses */].ARCHIVED) {
          _this.resetStream();
        }
      }).catch(function (e) {
        if (e.status === 404) {
          _this.resetStream();
        } else {
          console.log('getStream', e);
        }
      });
    },
    resetStream: function resetStream() {
      if (this.deletingInterval) {
        clearInterval(this.deletingInterval);
        this.$store.dispatch('auth/setStream', null);
        this.$router.push({ path: '/user/' + this.currentUser.slug + '/video' });
      }
    }
  }
});

/***/ }),
/* 1121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_me__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_stream__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      active_tab: 'edit',
      tabs: [{ id: 'info', title: 'Intro', path: '/info' }, { id: 'edit', title: 'Details', path: '/edit' }, { id: 'manage', title: 'Live Stream', path: '' }],
      stream: null,
      view_prices: __WEBPACK_IMPORTED_MODULE_4__helper__["j" /* StreamViewPrices */],
      viewers_limits: __WEBPACK_IMPORTED_MODULE_4__helper__["k" /* StreamViewersLimits */],
      users: [],
      isPageReady: false
    };
  },


  computed: {
    currentUser: function currentUser() {
      return this.$store.state.auth.user;
    },
    currentStream: function currentStream() {
      return this.currentUser.stream;
    },
    stream_cover_url: function stream_cover_url() {
      return this._.get(this.currentStream, 'cover.url', '');
    }
  },

  // watch: {
  //   currentStream(val) {
  //     console.log('currentStream', val)
  //   },
  // },

  created: function created() {
    var _this = this;

    // console.log('video/edit', this.currentStream)

    this.$store.dispatch('navigator/goNextState', {
      page: 'broadcast',
      tab: 'edit'
    });

    this.isPageReady = false;
    this.$store.dispatch('error/showLoadingActivity', true);

    this.cloneStream(this.currentStream);
    console.log(this.currentStream, this.stream);

    var params = {
      stripe_connected: true,
      page: 1,
      per_page: 30
    };
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_2__services_me__["a" /* default */].mutualUsers(params)]).then(function (values) {
      _this.users = values[0].body.users;
      _this.isPageReady = true;
      _this.$store.dispatch('error/showLoadingActivity', false);

      __WEBPACK_IMPORTED_MODULE_2__services_me__["a" /* default */].mutualUsers(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params, { per_page: -1 })).then(function (response) {
        return _this.users = response.body.users;
      });
    }).catch(function (reason) {
      console.log(reason);
      _this.$store.dispatch('error/showLoadingActivity', false);
      _this.$store.dispatch('error/showErrorToast', reason);
    });
  },


  methods: {
    onTab: function onTab(tab) {
      if (tab.id === this.active_tab) return;

      this.$router.push({
        path: '/user/' + this.currentUser.slug + '/video' + tab.path
      });
    },
    cloneStream: function cloneStream(stream) {
      var _this2 = this;

      console.log('cloneStream', stream);
      this.stream = this._.pick(stream, ['id', 'name', 'viewers_limit', 'view_price', 'genre']);
      this.stream['account_ids'] = [];(stream.account_ids || []).forEach(function (id) {
        var account_id = parseInt(id);
        if (account_id !== _this2.currentUser.id) {
          _this2.stream.account_ids.push(account_id);
        }
      });
    },
    submit: function submit() {
      var _this3 = this;

      this.$validator.validateAll().then(function (response) {
        if (response === true) {
          // const formData = new FormData()
          // formData.append('stream[name]', this.stream.name)
          // formData.append('stream[view_price]', this.stream.view_price)
          // formData.append('stream[viwers_limit]', this.stream.viewers_limit)
          // formData.append('stream[genre_id]', this.stream.genre_id)
          // formData.append('stream[cover]', this.stream.cover)

          var params = {
            stream: {
              name: _this3.stream.name,
              view_price: _this3.stream.view_price,
              viewers_limit: _this3.stream.viewers_limit
            }
          };

          _this3.$store.dispatch('error/showLoadingActivity', true);
          // StreamService.createStream(formData)
          __WEBPACK_IMPORTED_MODULE_3__services_stream__["a" /* default */].updateStream(_this3.stream.id, params).then(function (response) {
            _this3.$store.dispatch('error/showLoadingActivity', false);
            _this3.$store.dispatch('auth/setStream', response.body);
            // this.$router.push({
            //   path: `/user/${this.currentUser.slug}/video`,
            // })
          }).catch(function (e) {
            _this3.$store.dispatch('error/showLoadingActivity', false);
            _this3.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
          });
        } else {
          _this3.$store.dispatch('error/showErrorToast', [_this3.errors.items[0].msg]);
        }
      }).catch(function (e) {
        console.log('error', e);
      });
    }
  }
});

/***/ }),
/* 1122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var durationTable = [
// [sec, val, step],
[10, 0, 0], [60, 50, 1.0], [300, 74, 10.0], [600, 84, 30.0], [3600, 134, 60.0], [7200, 146, 300.0], [43200, 186, 900.0]];

var viewersTable = [[0, 0, 0], [5000, 50, 100], [10000, 60, 500], [50000, 100, 1000], [100000, 110, 5000], [1000000, 200, 10000], [10000000, 290, 100000]];

var MaxDuration = durationTable[durationTable.length - 1][0];
var MaxViewers = viewersTable[viewersTable.length - 1][0];

var editTabs = [{ id: 'info', title: 'Intro' }, { id: 'edit', title: 'Details', path: '/edit' }, { id: 'manage', title: 'Live Stream', path: '' }];
var createTabs = [{ id: 'info', title: 'Intro' }, { id: 'create', title: 'Setup', path: '/create' }, { id: 'manage', title: 'Live Stream', path: '', disabled: true }];

var STREAM_PER_VIEWER_MINUTE_PRICE = 0.26;
var ENCODING_PER_MINUTE_PRICE = 14.0;

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      active_tab: 'info',
      duration: 0,
      durationDetail: {
        hour: 0,
        min: 0,
        sec: 0
      },
      durationMirror: 0,
      durationFlag: false,
      viewers: 0,
      viewersMirror: 0,
      viewersFlag: false,
      percentage: '30',
      isPageReady: true
    };
  },


  computed: {
    currentUser: function currentUser() {
      return this.$store.state.auth.user;
    },
    isStreamRunning: function isStreamRunning() {
      return !this._.isNil(this.currentUser.stream);
    },
    totalPrice: function totalPrice() {
      return (ENCODING_PER_MINUTE_PRICE + this.viewers * STREAM_PER_VIEWER_MINUTE_PRICE * parseInt(this.percentage) / 100.0) * this.duration / 60;
    },
    tabs: function tabs() {
      return this.isStreamRunning ? editTabs : createTabs;
    }
  },

  created: function created() {
    this.$store.dispatch('navigator/goNextState', {
      page: 'broadcast',
      tab: 'info'
    });
  },


  methods: {
    gotoNextView: function gotoNextView() {
      this.$emit('gotoNextView', 'initStream');
    },
    onTab: function onTab(tab) {
      if (tab.id === this.active_tab) return;

      this.$router.push({
        path: '/user/' + this.currentUser.slug + '/video' + tab.path
      });
    },
    handleDurationDetailChange: function handleDurationDetailChange(e) {
      var _this = this;

      this.durationFlag = true;
      this.duration2detail(parseInt(this.durationDetail.hour) * 3600 + parseInt(this.durationDetail.min) * 60 + parseInt(this.durationDetail.sec));
      this.durationMirror = this.sec2val(this.duration);
      this.$nextTick(function () {
        _this.durationFlag = false;
      });
    },
    handleDurationMirrorChange: function handleDurationMirrorChange(e) {
      // console.log('handleDruationMirroChange', e, this.durationFlag)
      if (!this.durationFlag) {
        this.duration2detail(this.mirror2sec(this.durationMirror));
      }
    },
    duration2detail: function duration2detail(val) {
      if (val > MaxDuration) {
        val = MaxDuration;
      }
      val = parseInt(val);
      this.duration = val;

      var hour = parseInt(val / 3600);
      val = val - hour * 3600;
      var min = parseInt(val / 60);
      var sec = val - min * 60;
      this.durationDetail = { hour: hour, min: min, sec: sec };
    },
    mirror2sec: function mirror2sec(val) {
      var index = this._.findIndex(durationTable, function (item) {
        return item[1] > val;
      });
      if (index === 0) {
        return 0;
      }
      if (index === -1) {
        return durationTable[durationTable.length - 1][0];
      }
      var preItem = durationTable[index - 1];
      var curItem = durationTable[index];
      return preItem[0] + (val - preItem[1]) * curItem[2];
    },
    sec2val: function sec2val(sec) {
      var index = this._.findIndex(durationTable, function (item) {
        return item[0] > sec;
      });
      if (index === 0) {
        return 0;
      }
      if (index === -1) {
        return durationTable[durationTable.length - 1][1];
      }
      var preItem = durationTable[index - 1];
      var curItem = durationTable[index];
      return preItem[1] + (sec - preItem[0]) / curItem[2];
    },
    handleViewersMirrorChange: function handleViewersMirrorChange() {
      if (!this.viewersFlag) {
        this.viewers = this.mirror2real(this.viewersMirror);
      }
    },
    handleViewersChange: function handleViewersChange() {
      var _this2 = this;

      this.viewersFlag = true;
      this.viewers = parseInt(this.viewers);
      if (this.viewers < 0) {
        this.viewers = 0;
      }
      if (this.viewers > MaxViewers) {
        this.viewers = MaxViewers;
      }
      this.viewersMirror = this.real2mirror(this.viewers);
      this.$nextTick(function () {
        _this2.durationFlag = false;
      });
    },
    mirror2real: function mirror2real(val) {
      var index = this._.findIndex(viewersTable, function (item) {
        return item[1] > val;
      });
      if (index === 0) {
        return 0;
      }
      if (index === -1) {
        return viewersTable[viewersTable.length - 1][0];
      }
      var preItem = viewersTable[index - 1];
      var curItem = viewersTable[index];
      return preItem[0] + (val - preItem[1]) * curItem[2];
    },
    real2mirror: function real2mirror(val) {
      var index = this._.findIndex(viewersTable, function (item) {
        return item[0] > val;
      });
      if (index === 0) {
        return 0;
      }
      if (index === -1) {
        return viewersTable[viewersTable.length - 1][1];
      }
      var preItem = viewersTable[index - 1];
      var curItem = viewersTable[index];
      return preItem[1] + (val - preItem[0]) / curItem[2];
    }
  }
});

/***/ }),
/* 1123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_stream__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_video_box__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_video_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_video_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_contentTopHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_contentTopHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_contentTopHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_discoverNav__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_discoverNav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_discoverNav__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_slick_carousel__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_slick_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_slick_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_slick_carousel_dist_vue_slick_carousel_css__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_slick_carousel_dist_vue_slick_carousel_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_slick_carousel_dist_vue_slick_carousel_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_slick_carousel_dist_vue_slick_carousel_theme_css__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_slick_carousel_dist_vue_slick_carousel_theme_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_slick_carousel_dist_vue_slick_carousel_theme_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__static_styles_video_scss__ = __webpack_require__(757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__static_styles_video_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__static_styles_video_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_LogoutModal__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_LogoutModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__views_LogoutModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_userFollowBtn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_userFollowBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_userFollowBtn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash__);
// import { VideoGenres } from '@/helper'





// import VideoDetailBox from '@/components/video_detail_box'




// import demoVideo from '../../assets/demo-video.mp4'




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    isComp: Boolean,
    listLimit: Number
  },
  components: {
    VideoBox: __WEBPACK_IMPORTED_MODULE_2__components_video_box___default.a,
    contentTopHeader: __WEBPACK_IMPORTED_MODULE_3__components_contentTopHeader___default.a,
    discoverNav: __WEBPACK_IMPORTED_MODULE_4__components_discoverNav___default.a,
    VueSlickCarousel: __WEBPACK_IMPORTED_MODULE_5_vue_slick_carousel___default.a,
    logoutModal: __WEBPACK_IMPORTED_MODULE_9__views_LogoutModal___default.a,
    UserFollowBtn: __WEBPACK_IMPORTED_MODULE_10__components_userFollowBtn___default.a
  },

  data: function data() {
    return {
      slickOptions: {
        infinite: false,
        slidesToShow: 5,
        slidesToScroll: 5,
        dots: false,
        cssEase: 'linear',
        arrows: true,
        rows: 2
      },
      // demoVideo: demoVideo,
      selectedTab: 0,
      activeTab: 0,
      only_follows: false,
      videos: [],
      items_per_page: 1 * 50,
      pagination: {
        current_page: 1,
        total_pages: 0
      },
      videoGenres: [],
      isPageReady: false,
      tabs: [{ id: 'trending', title: 'Trending' }],
      selectedVideo: null,
      viewAllVideos: true,
      show_logout_modal: false,
      show_modalCard1: false,
      show_modalCard2: false,
      show_modalCard3: false,
      show_modalCard4: false,
      bgDemoImg: __webpack_require__(148),
      spotlightVideoSource: null,
      videoLoading: __webpack_require__(147),
      buttonHover: false,
      viewAllIconClick: false,
      selectedVideoCategoryName: 'Trending'
    };
  },


  computed: {
    followButtonText: function followButtonText() {
      if (this.selectedVideo.user.is_following) {
        return this.buttonHover ? 'Unfollow' : 'Following';
      }
      return 'Follow';
    },
    onMobile: function onMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    available_genres: function available_genres() {
      var _this = this;

      var genres = [{ id: 0, name: 'All' }];
      if (this.currentUser != null) {
        this.videoGenres.forEach(function (vg) {
          var g = _this._.find(_this.$store.state.app.genres, { name: vg });
          genres.push({ id: g.id, name: g.name });
        });
      }
      // const genres = this._.filter(this.$store.state.app.genres, (g) => (VideoGenres.indexOf(g.name) > -1))
      // console.log('available_genres', genres)
      return genres;
    },
    selected_genre: function selected_genre() {
      var genre = this._.find(this.available_genres, { id: this.activeTab }) || this._.find(this.available_genres, { id: 0 });
      // console.log('selected_genre', this.available_genres, genre)
      return genre;
    },
    currentUser: function currentUser() {
      return this.$store.state.auth.user;
    },
    beforeDestroy: function beforeDestroy() {
      this.$root.$off(__WEBPACK_IMPORTED_MODULE_0__helper__["b" /* MyEvents */].USER_FOLLOW, this.setFollowingStatus);
    }
  },

  watch: {
    $route: function $route(toPath, fromPath) {
      this.only_follows = toPath.hash.substr(1) === 'follows';
      // console.log('$route', this.only_follows)
      this.setTab(-1);
    },
    selectedVideoCategoryName: function selectedVideoCategoryName(newVal, oldVal) {
      if (newVal != oldVal) this.pagination.current_page = 1;
    }
  },

  methods: {
    setFollowingStatus: function setFollowingStatus(userId, isFollowing) {
      if (this.selectedVideo.user && this.selectedVideo.user.id === userId) {
        this.selectedVideo.user.is_following = isFollowing;
      }
    },
    verifyUser: function verifyUser() {
      var _this2 = this;

      if (this.currentUser) {
        this.$router.push({ name: 'VideoShow', params: { videoId: this.selectedVideo.id } });
      } else {
        __WEBPACK_IMPORTED_MODULE_1__services_stream__["a" /* default */].getSpotlightStream(this.selectedVideo.user.id).then(function (response) {
          console.log("response", response);
          _this2.spotlightVideoSource = response.body.mp_channel_1_ep_1_id;
          if (_this2.currentUser == null) {
            _this2.show_modalCard3 = true;
          } else {
            _this2.show_modalCard4 = true;
          }
        }).catch(function (e) {
          if (_this2.currentUser == null) {
            _this2.show_modalCard1 = true;
          } else {
            _this2.show_modalCard2 = true;
          }
        });
      }
    },
    repostItem: function repostItem() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_1__services_stream__["a" /* default */].repostStream(this.selectedVideo.id).then(function (res) {
        _this3.$store.dispatch('error/showSuccessToast', ['You just added ' + _this3.selectedVideo.name + ' stream in your collection.']);
      }).catch(function (e) {
        _this3.$store.dispatch('error/showErrorToast', e.body.errors || [e.body] || [e.body.error]);
      });
    },
    isActiveTab: function isActiveTab(tab) {
      return this.selectedTab === tab;
    },
    onTab: function onTab(tab) {
      if (this.isComp) {
        this.$router.push({ name: 'VideoIndex', params: { filter: tab } });
      } else {
        this.selectedTab = tab;
        this.filterVideos(tab);
      }
    },
    filterVideos: function filterVideos(filter) {
      console.log(filter);
    },
    changeSelectedVideo: function changeSelectedVideo(video) {
      this.selectedVideo = video;
    },
    displayAllVideos: function displayAllVideos(categoryType) {
      this.selectedVideoCategoryName = categoryType;
      this.viewAllVideos = true;
    },
    back: function back() {
      this.viewAllVideos = false;
      this.loadData(this.activeTab, this.pagination.current_page);
    },
    loadData: function loadData(tab, page) {
      var _this4 = this;

      this.busy = true;
      this.$store.dispatch('error/showLoadingActivity', true);
      var params = {
        genre_id: tab,
        only_follows: this.only_follows,
        page: page,
        per_page: this.items_per_page
      };

      var api_response = this.currentUser != null ? __WEBPACK_IMPORTED_MODULE_1__services_stream__["a" /* default */].getStreams(params) : __WEBPACK_IMPORTED_MODULE_1__services_stream__["a" /* default */].getStreamsPublicUsers(params);
      api_response.then(function (response) {
        _this4.videos = _this4.videos.concat(response.body.streams);

        _this4.selectedVideo = _this4.videos[0];
        _this4.isPageReady = true;
        _this4.$parent.$el.classList.remove('loading');
        // this.videos.filter((v) => )
        // this.videos = [ ...this.videos, ...this.videos]
        console.log(_this4.videos);
        _this4.pagination = response.body.pagination;
        _this4.videoGenres = response.body.genres;
        _this4.$store.dispatch('error/showLoadingActivity', false);
        _this4.busy = false;
      }).catch(function () {
        _this4.$store.dispatch('error/showLoadingActivity', false);
        _this4.busy = false;
      });
    },
    loadMore: function loadMore() {
      this.loadData(this.pagination.current_page + 1);
    },
    setTab: function setTab(tab) {
      if (this.activeTab !== tab) {
        this.activeTab = tab < 0 ? 0 : tab;
        this.videos.length = 0;
        this.pagination.current_page = 0;
        this.loadData(this.activeTab, this.pagination.current_page);
      }
    },


    loadMoreOnScroll: __WEBPACK_IMPORTED_MODULE_11_lodash___default.a.debounce(function (e) {
      this.loadMore();
    }, 500),

    handleScroll: function handleScroll(e) {
      var element = e.target;
      var scrollTop = element.scrollTop;
      var halfScrollHeight = element.scrollHeight / 2;
      var gapHeight = halfScrollHeight + 200;
      if (scrollTop >= halfScrollHeight && scrollTop <= gapHeight) {
        this.loadMoreOnScroll();
      }
    }
  },

  created: function created() {
    this.$root.$on(__WEBPACK_IMPORTED_MODULE_0__helper__["b" /* MyEvents */].USER_FOLLOW, this.setFollowingStatus);

    var paramFilter = this.$route.params.filter || '';

    this.$store.dispatch('navigator/goNextState', { page: 'video', tab: '' });
    this.loadData(this.activeTab, this.pagination.current_page);

    if (paramFilter) {
      this.selectedTab = paramFilter;
      this.onTab(this.selectedTab);
    }
  },
  mounted: function mounted() {
    this.$parent.$el.classList.add("loading");
  }
});

/***/ }),
/* 1124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_contentTopHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_contentTopHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_contentTopHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_paymentmodal__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_paymentmodal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_paymentmodal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BannerUpload__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BannerUpload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__BannerUpload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_broadcast_icon_png__ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_broadcast_icon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_broadcast_icon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_live_drop_gif__ = __webpack_require__(762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_live_drop_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_live_drop_gif__);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    paymentModal: __WEBPACK_IMPORTED_MODULE_2__components_paymentmodal___default.a,
    contentTopHeader: __WEBPACK_IMPORTED_MODULE_1__components_contentTopHeader___default.a,
    BannerUpload: __WEBPACK_IMPORTED_MODULE_3__BannerUpload___default.a
  },

  props: {},

  data: function data() {
    return {
      iconImage: __WEBPACK_IMPORTED_MODULE_4__assets_broadcast_icon_png___default.a,
      bannerImage: __WEBPACK_IMPORTED_MODULE_5__assets_live_drop_gif___default.a,
      hour: 1,
      showPaymentModal: false,
      selected: {
        plan: {},
        hour: null
      },
      plans: [{
        title: 'Basic',
        viewersLimit: 100,
        price: 10,
        benefits: ['100 concurrent viewer limit'],
        id: 'basic',
        selectedHour: 1
      }, {
        title: 'Plus',
        viewersLimit: 500,
        price: 40,
        benefits: ['500 concurrent viewer limit'],
        id: 'plus',
        selectedHour: 1
      }, {
        title: 'Pro',
        viewersLimit: 1000,
        price: 75,
        benefits: ['1,000 concurrent viewer limit'],
        id: 'pro',
        selectedHour: 1
      }, {
        title: 'Custom',
        price: 300,
        benefits: ['1,000 concurrent viewer limit'],
        id: 'custom',
        selectedHour: 10000
      }],
      activeTab: 'live',
      tabs: [{ id: 'upload', title: 'Upload', isParent: true, path: 'UploadIndex' }, { id: 'music', title: 'Music', path: 'UploadAlbum' }, { id: 'video', title: 'Video', path: 'VideoUpload' }, { id: 'product', title: 'Product', path: 'AddProduct' }, { id: 'live', title: 'Broadcast Live', path: 'CreateLive' }],
      learnMoreActive: false
    };
  },


  computed: {
    hasFree_stream_seconds: function hasFree_stream_seconds() {
      return this.currentUser.free_stream_seconds !== undefined && this.currentUser.free_stream_seconds > 0;
    },
    currentUser: function currentUser() {
      var user = this.$store.state.auth.user;
      // user.free_stream_seconds = 0 // test
      return user;
    },
    hours: function hours() {
      var num = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()({ length: 24 }, function (_, i) {
        return { value: i + 1, title: i + 1 + ' hr' };
      });
      num.push({ value: 10000, title: '10K viewers' });
      return num;
    },
    payable: function payable() {
      var payable = this.selected.plan.price * this.selected.plan.selectedHour;
      return payable;
    }
  },

  created: function created() {},


  methods: {
    isActiveTab: function isActiveTab(tab) {
      return this.activeTab === tab;
    },
    onTab: function onTab(tab) {
      if (tab.path) {
        this.$router.push({ name: tab.path });
      }
    },
    getPayable: function getPayable(plan) {
      this.selected.plan = plan;
      this.openPaymentDialog();
    },
    openPaymentDialog: function openPaymentDialog() {
      this.showPaymentModal = true;
    },
    closePaymentDialog: function closePaymentDialog() {
      this.showPaymentModal = false;
    },
    proceedToUpload: function proceedToUpload() {
      this.$router.push({ name: "VideoCreate" });
    }
  },

  mounted: function mounted() {
    console.log(this.user);
  }
});

/***/ }),
/* 1125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_on_click_outside__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_on_click_outside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_on_click_outside__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_auth__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_payment__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_stream__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_user__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_attach__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_attach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_attach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_paymentmodal__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_paymentmodal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_paymentmodal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_contentTopHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_contentTopHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_contentTopHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_user_tag__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_user_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_user_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__helper__ = __webpack_require__(2);









// import MeService from '@/services/me'








var ActionCable = __webpack_require__(52);

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Attach: __WEBPACK_IMPORTED_MODULE_9__components_attach___default.a,
    PaymentModal: __WEBPACK_IMPORTED_MODULE_10__components_paymentmodal___default.a,
    contentTopHeader: __WEBPACK_IMPORTED_MODULE_11__components_contentTopHeader___default.a,
    userTag: __WEBPACK_IMPORTED_MODULE_12__components_user_tag___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_4_vue_on_click_outside__["mixin"]],

  data: function data() {
    return {
      stream_cover_url: '',
      active_tab: 'live',
      tabs: [{ id: 'live', title: 'Live Stream', path: '/create' }],
      // show_deposit_dialog: false,
      show_stream_delete_confirm_dialog: false,
      show_create_failed_dialog: false,
      show_add_more_time_dialog: false,
      show_add_more_time_caution_dialog: false,
      show_payment_dialog: false,
      show_view_stream_button: false,
      stream_assoc: {},
      viewers_limits: __WEBPACK_IMPORTED_MODULE_13__helper__["k" /* StreamViewersLimits */],
      view_prices: __WEBPACK_IMPORTED_MODULE_13__helper__["j" /* StreamViewPrices */],
      costs: __WEBPACK_IMPORTED_MODULE_13__helper__["m" /* StreamCosts */],
      streamCost: 1000,
      viewers_limit: 0,
      searchGuests: null,
      guests: [],
      selected_guests: [],
      // periods: [],
      // period: 3600,
      remainingFirstCheck: {
        time: 300,
        checked: false
      },
      remainingSecondCheck: {
        time: 60,
        checked: false
      },
      creatingInterval: null,
      remainingInterval: null,
      remainingSeconds: 0,
      broadcastSeconds: 0,
      active_viewers: 0,
      total_viewers: 0,
      cable: null,
      stream_subscription: null,
      isPageReady: false,
      edit_stream_details_active: false,
      saveDetailsLoader: false,
      add_account_active: false,
      users: [],
      selectedAccounts: [],
      search_user: '',
      searchUserLoader: true
    };
  },


  computed: {
    stream: function stream() {
      return this.currentUser.stream || {};
    },
    assoc: function assoc() {
      return this.stream_assoc.assoc;
    },
    featuredUsers: function featuredUsers() {
      return this.stream_assoc.accounts || [];
    },
    currentUser: function currentUser() {
      // console.log(this.temp.stream);
      // console.log("i", this.$store.state.auth.user);
      // return this.temp
      return this.$store.state.auth.user;
    },
    isRunning: function isRunning() {
      return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.currentUser, 'stream.status', '') === __WEBPACK_IMPORTED_MODULE_13__helper__["i" /* StreamStatuses */].RUNNING;
      // return false
    },
    streamUrl: function streamUrl() {
      return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.currentUser, 'stream.ml_input_dest_1_url', '');
    },
    streamKey: function streamKey() {
      return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.currentUser, 'stream.ml_input_id', '');
    },
    profileUrl: function profileUrl() {
      return window.location.origin + '/' + this.currentUser.slug;
    },
    remainingTime: function remainingTime() {
      if (this.remainingSecondCheck.checked) {
        return 'a minute';
      } else if (this.remainingFirstCheck.checked) {
        return '5 minutes';
      }
      return 'a couple of minutes';
    },


    // streamCost() {
    //   return Math.round((this.period * StreamHourlyPrice) / 3600)
    // },

    MediaLiveInputTypes: function MediaLiveInputTypes() {
      return __WEBPACK_IMPORTED_MODULE_13__helper__["o" /* MediaLiveInputTypes */];
    },
    MediaLiveInputCodecs: function MediaLiveInputCodecs() {
      return __WEBPACK_IMPORTED_MODULE_13__helper__["p" /* MediaLiveInputCodecs */];
    },
    MediaLiveInputResolutions: function MediaLiveInputResolutions() {
      return __WEBPACK_IMPORTED_MODULE_13__helper__["q" /* MediaLiveInputResolutions */];
    },
    MediaLiveInputMaximumBitrates: function MediaLiveInputMaximumBitrates() {
      return __WEBPACK_IMPORTED_MODULE_13__helper__["r" /* MediaLiveInputMaximumBitrates */];
    }
  },

  watch: {
    search_user: function search_user(val) {
      this.getUsers();
    },
    searchGuests: function searchGuests(val) {
      val && this.querySelections(val);
    }
  },

  created: function created() {
    var _this = this;

    // Redirect away if user is not on live
    if (!this.isRunning) {
      this.$router.push({ name: "VideoCreate" });
    }

    // for (let i = 1; i <= 24; i++) {
    //   this.periods.push({
    //     id: i * 3600,
    //     name: `${i}hours / $${(i * StreamHourlyPrice) / 100}`,
    //   })
    // }

    this.getUsers();

    this.isPageReady = false;
    this.$store.dispatch('error/showLoadingActivity', true);
    __WEBPACK_IMPORTED_MODULE_8__services_user__["a" /* default */].getUserInfo(this.currentUser.id).then(function (response) {
      _this.isPageReady = true;
      _this.$store.dispatch('error/showLoadingActivity', false);

      __WEBPACK_IMPORTED_MODULE_5__services_auth__["a" /* default */].setUser(response.body);
      _this.$store.dispatch('auth/setStream', response.body.stream);
      _this.stream_assoc = {
        type: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(response.body, 'stream.assoc_type', 'Album'),
        value: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(response.body, 'stream.assoc')
      };
      _this.users = response.body.stream.accounts;
      if (_this.stream_assoc.type === '') {
        _this.stream_assoc.type = 'Album';
      }
      // console.log('stream_assoc', this.stream_assoc)

      var stream_status = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(response.body, 'stream.status', '');
      if (stream_status === '') {
        _this.$router.push({
          // path: `/user/${this.currentUser.slug}/video/info`,
          // name: 'VideoCreate',
        });
      } else if (['deleted', 'inactive'].indexOf(stream_status) > -1) {
        _this.$router.push({
          path: '/user/' + _this.currentUser.slug + '/video/delete'
        });
      } else {
        var vm = _this;

        _this.$store.dispatch('navigator/goNextState', {
          page: 'broadcast',
          tab: ''
        });

        // if (!this.isRunning) {
        //   this.creatingInterval = setInterval(function () {
        //     vm.getStream()
        //   }, 10000)
        // }

        _this.remainingSeconds = response.body.stream.remaining_seconds;
        _this.broadcastSeconds = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(response.body, 'stream.broadcast_seconds', 0);
        _this.viewers_limit = _this.currentUser.stream.viewers_limit;
        // this.selected_guests = ['e0e54729-a1d6-4d8c-8a76-6fc207e6c210']
        // this.guests = _.cloneDeep(this.currentUser.stream.guests)
        _this.guests = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(_this.currentUser.stream.guests, function (u) {
          return {
            id: u.id,
            name: u.username
          };
        });
        _this.selected_guests = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(_this.currentUser.stream.guests, 'id');

        if (_this.currentUser.stream.notified) {
          _this.show_view_stream_button = true;

          _this.remainingInterval = setInterval(function () {
            vm.refresh();
          }, 1000);
        }

        _this.stream_subscription = _this.cable.subscriptions.create({
          channel: 'StreamCreatorsChannel',
          stream_id: vm.currentUser.stream.id
        }, {
          connected: function connected() {
            console.log('connected to StreamCreatorsChannel');
          },
          received: function received(data) {
            console.log('stream_subscription');
            console.log(data);
            if (data.notified) {
              console.log('signal comming');
              vm.show_view_stream_button = true;
              if (!_this.remainingInterval) {
                _this.remainingInterval = setInterval(function () {
                  vm.refresh();
                }, 1000);
              }
            }
            if (data.active_viewers_size >= 0) {
              vm.active_viewers = data.active_viewers_size;
            }
            if (data.total_viewers_size >= 0) {
              vm.total_viewers = data.total_viewers_size;
            }
            if (data.remaining_seconds >= 0) {
              _this.remainingSeconds = data.remaining_seconds;
            }
          },
          disconnected: function disconnected() {
            console.log('disconnected to StreamCreatorsChannel :(');
          }
        });
      }
    }).catch(function (e) {
      // console.log(e)
      _this.$store.dispatch('error/showLoadingActivity', false);
    });

    this.cable = ActionCable.createConsumer("wss://api.yousound.com/cable" + '?token=' + this.$store.state.auth.token);
  },
  beforeDestroy: function beforeDestroy() {
    if (this.creatingInterval) {
      clearInterval(this.creatingInterval);
    }

    if (this.remainingInterval) {
      clearInterval(this.remainingInterval);
    }

    if (this.stream_subscription) {
      this.stream_subscription.unsubscribe();
      this.stream_subscription = null;
    }
  },


  methods: {
    removeAccount: function removeAccount(u) {
      this.users = this.stream.accounts.filter(function (user) {
        return user.id !== u.id;
      });

      this.updateUsersList();
    },
    updateUsersList: function updateUsersList() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var users, params;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this2.users.length <= stream.accounts.length)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                users = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(_this2.users), [_this2.selectedAccounts]);
                params = {
                  stream: {
                    accounts: users
                  }
                };

                _this2.searchUserLoader = true;
                _context.next = 7;
                return __WEBPACK_IMPORTED_MODULE_7__services_stream__["a" /* default */].updateStream(_this2.currentUser.stream.id, params).then(function () {
                  _this2.searchUserLoader = false;
                  _this2.users = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(_this2.users), [_this2.selectedAccounts]);
                });

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    getUsers: function getUsers() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var params;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.searchUserLoader = true;

                params = {
                  stripe_connected: true,
                  q: _this3.search_user,
                  per_page: 30,
                  page: 1
                  // Promise.all([MeService.mutualUsers(params)])
                };
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_8__services_user__["a" /* default */].searchUsers(params).then(function (response) {
                  _this3.$store.dispatch('error/showLoadingActivity', false);
                  _this3.users = response.body.users;
                  _this3.searchUserLoader = false;
                }).catch(function (reason) {
                  console.log(reason);
                  _this3.$store.dispatch('error/showLoadingActivity', false);
                  _this3.$store.dispatch('error/showErrorToast', reason);
                  _this3.searchUserLoader = false;
                });

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    saveStreamDetails: function saveStreamDetails() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var params;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                params = {
                  stream: {
                    view_price: _this4.stream.view_price,
                    description: _this4.stream.description,
                    viewers_limit: _this4.stream.viewers_limit,
                    cover: _this4.stream.cover
                  }
                };

                _this4.saveDetailsLoader = true;
                _context3.next = 4;
                return __WEBPACK_IMPORTED_MODULE_7__services_stream__["a" /* default */].updateStream(_this4.currentUser.stream.id, params).then(function () {
                  _this4.edit_stream_details_active = false;
                  _this4.saveDetailsLoader = false;
                });

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    imageChanged: function imageChanged(e) {
      var _this5 = this;

      if (e.target.files.length > 0) {
        this.stream.cover = e.target.files[0];
        var reader = new FileReader();
        reader.addEventListener('load', function (event) {
          _this5.stream.cover = event.target.result;
        }, false);
        reader.readAsDataURL(this.stream.cover);
      } else {
        this.stream.cover = null;
        this.stream_cover_url = null;
      }
    },
    addStreamAttach: function addStreamAttach() {
      this.$refs.streamAttach.openAttachPicker();
    },
    changeStreamAttach: function changeStreamAttach() {
      this.$refs.streamAttach.openAttachPicker();
    },
    removeStreamAttach: function removeStreamAttach() {
      this.$refs.streamAttach.removeAttach();
    },
    onTab: function onTab(tab) {
      if (tab.id === this.active_tab) return;

      // this.$router.push({
      //   path: `/user/${this.currentUser.slug}/video${tab.path}`,
      // })
    },
    querySelections: function querySelections(v) {
      var _this6 = this;

      var params = {
        page: 1,
        per_page: 10
      };
      if (v.length) {
        params['q'] = v;
      }
      __WEBPACK_IMPORTED_MODULE_8__services_user__["a" /* default */].searchUsers(params).then(function (response) {
        _this6.guests = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(response.body.users, function (u) {
          return {
            id: u.id,
            name: u.username
          };
        });
      }).catch(function (e) {
        console.log('querySelections error', e.body.errors || [e.body]);
      });
    },
    saveViewersLimit: function saveViewersLimit(value) {
      if (value === this.viewers_limit) return;

      var params = {
        stream: {
          viewers_limit: value
        }
      };
      __WEBPACK_IMPORTED_MODULE_7__services_stream__["a" /* default */].updateStream(this.currentUser.stream.id, params);
    },
    saveGuests: function saveGuests(values) {
      var params = {
        stream: {
          guests_ids: values.join(',')
        }
      };
      __WEBPACK_IMPORTED_MODULE_7__services_stream__["a" /* default */].updateStream(this.currentUser.stream.id, params);
    },
    saveAttach: function saveAttach() {
      console.log('saveAttach', this.stream_assoc);
      var params = void 0;
      if (this.stream_assoc.value && this.stream_assoc.value.id > 0) {
        params = {
          stream: {
            assoc_type: this.stream_assoc.type,
            assoc_id: this.stream_assoc.value.id
          }
        };
      } else {
        params = {
          stream: {
            assoc_type: '',
            assoc_id: 0
          }
        };
      }
      __WEBPACK_IMPORTED_MODULE_7__services_stream__["a" /* default */].updateStream(this.currentUser.stream.id, params);
    },
    addMoreTime: function addMoreTime() {
      var _this7 = this;

      var params = {
        stream: {
          extend_period: this.period
        }
      };
      __WEBPACK_IMPORTED_MODULE_7__services_stream__["a" /* default */].updateStream(this.currentUser.stream.id, params).then(function (response) {
        _this7.$store.dispatch('auth/setStream', response.body);
        _this7.remainingSeconds = response.body.remaining_seconds;
      }).catch(function (e) {
        console.log('saveViewersLimit', e.body.errors || [e.body]);
      });
    },


    // openDepositDialog() {
    //   if (this.currentUser.enabled_live_video_free || this.currentUser.balance_amount >= StreamHourlyPrice * 80) {
    //     this.$router.push({ path: `/user/${this.currentUser.slug}/video/create` })
    //   } else {
    //     this.show_deposit_dialog = true
    //   }
    // },
    // closeDepositDialog() {
    //   this.show_deposit_dialog = false
    // },

    openStreamDeleteConfirmDialog: function openStreamDeleteConfirmDialog() {
      this.show_stream_delete_confirm_dialog = true;
    },
    closeStreamDeleteConfirmDialog: function closeStreamDeleteConfirmDialog() {
      this.show_stream_delete_confirm_dialog = false;
    },
    openCreateFailedDialog: function openCreateFailedDialog() {
      this.show_create_failed_dialog = true;
    },
    closeCreateFailedDialog: function closeCreateFailedDialog() {
      this.show_create_failed_dialog = false;
      this.$router.push({ path: '/' });
    },
    openAddMoreTimeDialog: function openAddMoreTimeDialog() {
      this.show_add_more_time_dialog = true;
    },
    closeAddMoreTimeDialog: function closeAddMoreTimeDialog() {
      this.show_add_more_time_dialog = false;
    },
    openAddMoreTimeCautionDialog: function openAddMoreTimeCautionDialog() {
      this.show_add_more_time_caution_dialog = true;
    },
    closeAddMoreTimeCautionDialog: function closeAddMoreTimeCautionDialog() {
      this.show_add_more_time_caution_dialog = false;
      this.openAddMoreTimeDialog();
    },
    openPaymentDialog: function openPaymentDialog() {
      this.closeAddMoreTimeDialog();
      this.show_payment_dialog = true;
      // this.addMoreTime()
    },
    closePaymentDialog: function closePaymentDialog() {
      this.show_payment_dialog = false;
    },
    deposit: function deposit(token) {
      if (token) {
        var params = {
          payment_token: token.id,
          amount: this.streamCost
        };
        __WEBPACK_IMPORTED_MODULE_6__services_payment__["a" /* default */].makeDeposit(params);
        // PaymentService.makeDeposit(params)
        //   .then(() => {
        //     this.addMoreTime()
        //   })
        //   .catch((e) => {
        //     this.$store.dispatch(
        //       'error/showErrorToast',
        //       e.body.errors || [e.body]
        //     )
        //   })
      }
    },
    refresh: function refresh() {
      this.remainingSeconds -= 1;
      this.broadcastSeconds += 1;
      if (!this.currentUser.enabled_live_video_free) {
        if (!this.remainingSecondCheck.checked && this.remainingSeconds < this.remainingSecondCheck.time) {
          this.remainingSecondCheck.checked = true;
          this.remainingFirstCheck.checked = true;
          this.openAddMoreTimeCautionDialog();
        } else if (!this.remainingFirstCheck.checked && this.remainingSeconds < this.remainingFirstCheck.time) {
          this.remainingFirstCheck.checked = true;
          this.openAddMoreTimeCautionDialog();
        }

        if (this.remainingSeconds <= 0) {
          if (this.remainingInterval) {
            clearInterval(this.remainingInterval);
          }
          this.$store.dispatch('error/showErrorToast', ['Time is up and live stream is about to stop!!!']);
          this.deleteStream();
        }
      }
      // else {
      //   if (!this.show_view_stream_button) {
      //     Vue.http.get(this.currentUser.stream.mp_channel_1_ep_1_url).then(response => {
      //       this.show_view_stream_button = true
      //       // StreamService.notifyStream(this.currentUser.stream.id)
      //     })
      //   }
      // }
    },
    isStreaming: function isStreaming() {
      // return _.get(this.currentUser.stream, 'status', '') === 'started' &&
      return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.$store.state.streamPlayer.user, 'slug', '') !== this.currentUser.slug || !this.$store.getters['streamPlayer/hasFrame'];
    },
    viewStream: function viewStream() {
      var _this8 = this;

      if (this.isStreaming()) {
        __WEBPACK_IMPORTED_MODULE_8__services_user__["a" /* default */].getUserInfo(this.currentUser.id).then(function (response) {
          __WEBPACK_IMPORTED_MODULE_5__services_auth__["a" /* default */].setUser(response.body);

          _this8.$store.dispatch('streamPlayer/setStream', _this8.currentUser.stream);
          _this8.$root.$emit(__WEBPACK_IMPORTED_MODULE_13__helper__["b" /* MyEvents */].STREM_PLAYER_INIT);
        });
      }
    },
    getStream: function getStream() {
      var _this9 = this;

      var vm = this;
      __WEBPACK_IMPORTED_MODULE_7__services_stream__["a" /* default */].getStream(this.currentUser.stream.id).then(function (response) {
        switch (response.body.status) {
          case __WEBPACK_IMPORTED_MODULE_13__helper__["i" /* StreamStatuses */].RUNNING:
            _this9.$store.dispatch('auth/setStream', response.body);
            if (_this9.creatingInterval) {
              clearInterval(_this9.creatingInterval);
              _this9.remainingSeconds = response.body.remaining_seconds;
              _this9.remainingInterval = setInterval(function () {
                vm.refresh();
              }, 1000);
            }
            break;
          case __WEBPACK_IMPORTED_MODULE_13__helper__["i" /* StreamStatuses */].INACTIVE:
          case __WEBPACK_IMPORTED_MODULE_13__helper__["i" /* StreamStatuses */].ARCHIVED:
          case __WEBPACK_IMPORTED_MODULE_13__helper__["i" /* StreamStatuses */].DELETED:
            if (_this9.creatingInterval) {
              clearInterval(_this9.creatingInterval);
            }
            _this9.openCreateFailedDialog();
            break;
        }
      }).catch(function (e) {
        console.log('getStream Error', e);
        // if (this.creatingInterval) {
        //   clearInterval(this.creatingInterval)
        // }
        // this.openCreateFailedDialog()
      });
    },


    // startStream() {
    //   this.$store.dispatch('error/showLoadingActivity', true)
    //   StreamService.startStream(this.currentUser.stream.id).then(response => {
    //     this.$store.dispatch('error/showLoadingActivity', false)
    //     this.$store.dispatch('auth/setStream', response.body)
    //   }).catch(e => {
    //     this.$store.dispatch('error/showLoadingActivity', false)
    //     this.$store.dispatch('error/showErrorToast', e.body.errors || [e.body])
    //   })
    // },

    // stopStream() {
    //   this.$store.dispatch('error/showLoadingActivity', true)
    //   StreamService.stopStream(this.currentUser.stream.id).then(response => {
    //     this.$store.dispatch('error/showLoadingActivity', false)
    //     this.$store.dispatch('auth/setStream', response.body)
    //   }).catch(e => {
    //     this.$store.dispatch('error/showLoadingActivity', false)
    //     this.$store.dispatch('error/showErrorToast', e.body.errors || [e.body])
    //   })
    // },

    deleteStream: function deleteStream() {
      var _this10 = this;

      this.closeStreamDeleteConfirmDialog();
      this.$store.dispatch('error/showLoadingActivity', true);
      __WEBPACK_IMPORTED_MODULE_7__services_stream__["a" /* default */].deleteStream(this.currentUser.stream.id).then(function (response) {
        // / close the video player if watching own live video
        if (__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this10.$store.state.streamPlayer.stream, 'id') === _this10.currentUser.stream.id) {
          _this10.$root.$emit(__WEBPACK_IMPORTED_MODULE_13__helper__["b" /* MyEvents */].STREM_PLAYER_SHUTDOWN);
        }
        __WEBPACK_IMPORTED_MODULE_5__services_auth__["a" /* default */].setUser(response.body);
        _this10.$store.dispatch('auth/setStream', response.body.stream);
        _this10.$store.dispatch('error/showLoadingActivity', false);
        _this10.$router.push({ path: '/' });
        // this.$router.push({ path: `/user/${this.currentUser.slug}/video/create` })
      }).catch(function (e) {
        _this10.$store.dispatch('error/showLoadingActivity', false);
        _this10.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    }
  }
});

/***/ }),
/* 1126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_user__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_stream__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_comment__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_user_tag__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_user_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_user_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_attach__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_attach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_attach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_chat__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_chat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_chat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_user_box__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_user_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_user_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_video_box__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_video_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_video_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_video_player__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_video_player___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_video_player__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_artistitem__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_artistitem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_artistitem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_paymentmodal__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_paymentmodal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_paymentmodal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_sharemodal__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_sharemodal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_sharemodal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_comments__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_comments___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_comments__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_merchmodal__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_merchmodal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_merchmodal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_sendlovemodal__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_sendlovemodal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_sendlovemodal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__views_mobile_components_mobileComments__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__views_mobile_components_mobileComments___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__views_mobile_components_mobileComments__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_commentInput__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_commentInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_commentInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_userFollowBtn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_userFollowBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_userFollowBtn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__services_collection__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__services_album__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__services_product__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_albumfinishmodal__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_albumfinishmodal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__components_albumfinishmodal__);









// import ProfileService from '@/services/profile'






















var ActionCable = __webpack_require__(52);

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ArtistItem: __WEBPACK_IMPORTED_MODULE_16__components_artistitem___default.a,
    Attach: __WEBPACK_IMPORTED_MODULE_11__components_attach___default.a,
    Chat: __WEBPACK_IMPORTED_MODULE_12__components_chat___default.a,
    PaymentModal: __WEBPACK_IMPORTED_MODULE_17__components_paymentmodal___default.a,
    ShareModal: __WEBPACK_IMPORTED_MODULE_18__components_sharemodal___default.a,
    UserBox: __WEBPACK_IMPORTED_MODULE_13__components_user_box___default.a,
    UserTag: __WEBPACK_IMPORTED_MODULE_10__components_user_tag___default.a,
    VideoBox: __WEBPACK_IMPORTED_MODULE_14__components_video_box___default.a,
    VideoPlayer: __WEBPACK_IMPORTED_MODULE_15__components_video_player___default.a,
    Comments: __WEBPACK_IMPORTED_MODULE_19__components_comments___default.a,
    merchModal: __WEBPACK_IMPORTED_MODULE_20__components_merchmodal___default.a,
    sendLoveModal: __WEBPACK_IMPORTED_MODULE_21__components_sendlovemodal___default.a,
    mobileComments: __WEBPACK_IMPORTED_MODULE_22__views_mobile_components_mobileComments___default.a,
    commentInput: __WEBPACK_IMPORTED_MODULE_23__components_commentInput___default.a,
    UserFollowBtn: __WEBPACK_IMPORTED_MODULE_24__components_userFollowBtn___default.a,
    albumFinishModal: __WEBPACK_IMPORTED_MODULE_29__components_albumfinishmodal___default.a
  },

  data: function data() {
    return {
      activePaneTab: 'info',
      paneTabs: [{
        name: 'Info',
        id: 'info'
      }, {
        name: 'Comments',
        id: 'comments'
      }],
      moment: __WEBPACK_IMPORTED_MODULE_5_moment___default.a,
      showSendLoveModal: false,
      showMoreActive: false,
      showAttachProduct: false,
      selectAttactProduct: 1,
      stream: {},
      stream_assoc: {
        type: 'Album',
        value: null
      },
      comments: [],
      comments_pagination: {},
      accounts: [],
      videos: [],
      buttonHover: false,
      amount: 1000,
      cable: null,
      stream_subscription: null,
      show_featured_dialog: false,
      show_payment_dialog: false,
      show_share_dialog: false,
      isPageReady: false,
      showMerchModal: false,
      mobileHeaderOptions: {},
      isSubscribed: false,
      albums: [],
      products: [],
      mainItem: null,
      showReleaseVideoModal: false,
      releaseVideo: null
    };
  },


  computed: {
    ownItem: function ownItem() {
      return this.currentUser.id === this.user.id;
    },
    onMobile: function onMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    currentUser: function currentUser() {
      return this.$store.state.auth.user;
    },
    user: function user() {
      return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.stream, 'user', {});
    },
    assocType: function assocType() {
      return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.stream, 'assoc_type', '');
    },
    assocImage: function assocImage() {
      // console.log('assocType', this.assocType, this.stream.assoc)
      switch (this.assocType) {
        case 'Album':
          return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.stream.assoc, 'cover.thumb.url', '');
        case 'ShopProduct':
          return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.stream.assoc, 'covers[0].cover.thumb.url', '');
        default:
          return '';
      }
    },
    hasDigitalContent: function hasDigitalContent() {
      return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.stream, 'digital_content_url') !== null;
    },
    showFeaturedSection: function showFeaturedSection() {
      if (this.currentUser.id === this.user.id) {
        return true;
      }

      if (this.stream.assoc || this.accounts.length > 0) {
        return true;
      }

      return false;
    },
    followButtonText: function followButtonText() {
      if (this.user.is_following) {
        return this.buttonHover ? 'Unfollow' : 'Following';
      }
      return 'Follow';
    },
    initShowMore: function initShowMore() {
      return this.stream.description.length >= 138;
    }
  },

  created: function created() {
    var _this = this;

    this.getAttachmentItems();
    this.fetchSubscriptionDetails();
    this.$store.dispatch('navigator/goNextState', {
      page: 'video',
      tab: 'show'
    });

    this.cable = ActionCable.createConsumer("wss://api.yousound.com/cable" + '?token=' + this.$store.state.auth.token);

    this.loadData(this.$route.params.videoId);

    // save header option before altering
    this.mobileHeaderOptions = this.$store.state.appMobile.mobileHeaderOptions;
    console.log('entry :', this.mobileHeaderOptions);

    var releaseVideoId = localStorage.getItem("release_video");
    if (releaseVideoId) {
      __WEBPACK_IMPORTED_MODULE_7__services_stream__["a" /* default */].getStream(releaseVideoId).then(function (response) {
        _this.releaseVideo = response.body;
        if (_this.releaseVideo) {
          _this.showReleaseVideoModal = true;
          localStorage.removeItem("release_video");
        }
      }).catch(function (exception) {
        console.log(exception);
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.unsubscribe();
  },


  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vuex__["c" /* mapActions */])({
    setMobileFooter: 'appMobile/setMobileFooterOptions'
  }), {
    dismissFinishDialog: function dismissFinishDialog() {
      this.showReleaseVideoModal = false;
    },
    showPromoteModal: function showPromoteModal() {},
    reRenderComments: function reRenderComments() {
      var _this2 = this;

      var videoId = this.$route.params.videoId;
      __WEBPACK_IMPORTED_MODULE_8__services_comment__["a" /* default */].getComments({
        commentable_type: 'Stream',
        commentable_id: videoId
      }).then(function (resp) {
        _this2.comments = [];
        _this2.comments = resp.body.comments;
        _this2.comments_pagination = resp.body.pagination;
      }).catch(function (e) {
        console.log(e);
      });
    },
    getAttachmentItems: function getAttachmentItems() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_27__services_album__["a" /* default */].getAlbums({
        statuses: 'published, collaborated',
        user_statuses: 'accepted'
      }), __WEBPACK_IMPORTED_MODULE_28__services_product__["a" /* default */].getProducts({
        statuses: 'published, collaborated',
        stock_statuses: 'active',
        user_statuses: 'accepted'
      })]).then(function (values) {
        _this3.albums = values[0].body;
        _this3.products = values[1].body;
        _this3.mainItem = _this3.albums[0];
      }).catch(function (reason) {
        console.log(reason);
        // this.$store.dispatch('error/showErrorToast', [reason])
      });
    },
    fetchSubscriptionDetails: function fetchSubscriptionDetails() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_6__services_user__["a" /* default */].getSubscriptionDetail(_this4.currentUser.id).then(function (response) {
                  if (response.bodyText === "Subscribed") {
                    _this4.isSubscribed = true;
                  }
                }).catch(function (e) {
                  _this4.$store.dispatch('error/showErrorToast', ["There was an error on fetching user info "]);
                });

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4);
      }))();
    },
    getAssoc: function getAssoc(data) {
      this.stream_assoc = data;
    },
    showLoveDialog: function showLoveDialog() {
      this.showSendLoveModal = true;
    },
    dismissLoveDialog: function dismissLoveDialog() {
      this.showSendLoveModal = false;
    },
    showMerchDialog: function showMerchDialog() {
      this.showMerchModal = true;
    },
    dimissMerchDialog: function dimissMerchDialog() {
      this.showMerchModal = false;
    },
    gotoAssoc: function gotoAssoc() {
      var type = this.stream.assoc_type;
      var id = this.stream.assoc.id;
      var slug = this.stream.assoc.slug || '';

      switch (type) {
        case 'ShopProduct':
          return this.showMerchDialog();
        case 'Album':
          return this.$router.push({ name: 'AlbumDetail', params: { slug: slug } });
        case 'profile':
          return this.$router.push('/' + this.stream.user.slug);
        default:
          return '';
      }
    },
    loadData: function loadData(videoId) {
      var _this5 = this;

      var vm = this;
      this.unsubscribe();
      this.stream_subscription = this.cable.subscriptions.create({
        channel: 'StreamsChannel',
        stream_id: videoId
      }, {
        connected: function connected() {
          console.log('connected to StreamsChannel');
        },
        received: function received(data) {
          console.log('stream_subscription');
          console.log(data);
          if (data.notified) {
            __WEBPACK_IMPORTED_MODULE_7__services_stream__["a" /* default */].getStream(videoId).then(function (res) {
              vm.stream = res.body;
            });
          } else if (data.assoc_type) {
            vm.stream.assoc_type = data.assoc_type;
            vm.stream.assoc = data.assoc;
          }
        },
        disconnected: function disconnected() {
          console.log('disconnected to StreamsChannel :(');
        }
      });

      this.isPageReady = false;
      console.log('loading data...', videoId);
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_7__services_stream__["a" /* default */].getStream(videoId), __WEBPACK_IMPORTED_MODULE_8__services_comment__["a" /* default */].getComments({
        commentable_type: 'Stream',
        commentable_id: videoId
      }), __WEBPACK_IMPORTED_MODULE_7__services_stream__["a" /* default */].getSimilarStreams(videoId, {
        page: 1,
        per_page: 10
      })]).then(function (values) {
        if ([__WEBPACK_IMPORTED_MODULE_9__helper__["i" /* StreamStatuses */].ARCHIVED, __WEBPACK_IMPORTED_MODULE_9__helper__["i" /* StreamStatuses */].RUNNING, __WEBPACK_IMPORTED_MODULE_9__helper__["i" /* StreamStatuses */].UPLOADING].indexOf(values[0].body.status) > -1) {
          _this5.stream = values[0].body;

          console.log(_this5.stream);
          console.log(_this5.stream.assoc);
        } else {
          _this5.$router.push({ path: '/video' });
        }

        _this5.comments = values[1].body.comments;
        _this5.comments_pagination = values[1].body.pagination;

        _this5.videos = values[2].body.streams;

        _this5.isPageReady = true;
      }).catch(function (e) {
        console.log('video/show loadData error', e);
      });
    },
    unsubscribe: function unsubscribe() {
      if (this.stream_subscription) {
        this.stream_subscription.unsubscribe();
        this.stream_subscription = null;
      }
    },
    deleteStream: function deleteStream() {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_7__services_stream__["a" /* default */].deleteStream(this.stream.id).then(function () {
        _this6.$router.push({ path: '/video' });
      }).catch(function (e) {
        _this6.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    updateStream: function updateStream() {
      var _this7 = this;

      var params = void 0;
      if (this.stream_assoc.value && this.stream_assoc.value.id > 0) {
        params = {
          stream: {
            assoc_type: this.stream_assoc.type,
            assoc_id: this.stream_assoc.value.id
          }
        };
      } else {
        params = {
          stream: {
            assoc_type: '',
            assoc_id: 0
          }
        };
      }
      __WEBPACK_IMPORTED_MODULE_7__services_stream__["a" /* default */].updateStream(this.stream.id, params).then(function (res) {
        _this7.stream.assoc = res.body.assoc;
        _this7.closeFeaturedDialog();
      });
    },
    addContent: function addContent() {
      var _this8 = this;

      var hours = document.getElementById("showAttachmentHours").textContent;
      var minutes = document.getElementById("showAttachmentMinutes").textContent;
      var seconds = document.getElementById("showAttachmentSeconds").textContent;
      var totalSeconds = (hours * 3600 + minutes * 60 + seconds).replace(/^0+/, '');
      if (totalSeconds == '' || totalSeconds > this.stream.duration) {
        var errorMsg = totalSeconds == '' ? "Please select a valid duration." : "Selected duration is gereater than your stream duration. Please choose below your duration limit.";
        this.$store.dispatch('error/showErrorToast', [errorMsg]);
      } else {
        var assoc_id = this.mainItem.id;
        var assoc_type = this.mainItem.category ? "ShopProduct" : "Album";
        var params = { stream: { show_attachment_at: totalSeconds, assoc_id: assoc_id, assoc_type: assoc_type } };
        __WEBPACK_IMPORTED_MODULE_7__services_stream__["a" /* default */].updateStream(this.stream.id, params).then(function (res) {
          _this8.$store.dispatch('error/showSuccessToast', ['Your attachment will be listed in ' + _this8.stream.name + ' at chosen time for 5 seconds.']);
          _this8.loadData(_this8.stream.id);
          _this8.showAttachProduct = false;
        });
      }
    },
    openFeaturedDialog: function openFeaturedDialog() {
      if (this.stream.assoc && this.stream.assoc.id > 0) {
        this.stream_assoc = {
          type: this.stream.assoc_type,
          value: this.stream.assoc
        };
      } else {
        this.stream_assoc = {
          type: 'Album',
          value: null
        };
      }

      this.show_featured_dialog = true;
    },
    closeFeaturedDialog: function closeFeaturedDialog() {
      this.show_featured_dialog = false;
    },
    openPaymentDialog: function openPaymentDialog() {
      this.show_payment_dialog = true;
    },
    closePaymentDialog: function closePaymentDialog() {
      this.show_payment_dialog = false;
    },
    openShareDialog: function openShareDialog() {
      this.show_share_dialog = true;
    },
    closeShareDialog: function closeShareDialog() {
      this.show_share_dialog = false;
    },
    payAttachment: function payAttachment(token) {
      var _this9 = this;

      var params = {
        amount: 0
      };

      __WEBPACK_IMPORTED_MODULE_7__services_stream__["a" /* default */].payAttachment(this.stream.id, params).then(function (res) {
        _this9.closePaymentDialog();
      }).catch(function (e) {
        _this9.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    },
    repostItem: function repostItem() {
      var _this10 = this;

      __WEBPACK_IMPORTED_MODULE_7__services_stream__["a" /* default */].repostStream(this.stream.id).then(function (res) {
        _this10.$store.dispatch('error/showSuccessToast', ['You just added ' + _this10.stream.name + ' stream in your collection.']);
      }).catch(function (e) {
        _this10.$store.dispatch('error/showErrorToast', e.body.errors || [e.body] || [e.body.error]);
      });
    }
  }),

  watch: {
    $route: function $route(toPath, fromPath) {
      var videoId = this.$route.params.videoId;
      console.log('vidoe/show watch', videoId);
      this.loadData(videoId);
    },
    showMoreActive: function showMoreActive(val) {
      if (val) {
        document.querySelector('.vid__description').style.height = 'auto';
        console.log(document.querySelector('.vid__description').clientHeight);
      } else {
        document.querySelector('.vid__description').style.height = '20px';
        console.log(document.querySelector('.vid__description').clientHeight);
      }
    },
    activePaneTab: function activePaneTab(val) {
      if (val === 'comments') {
        this.setMobileFooter({ showFooter: false });
      } else {
        this.setMobileFooter({ showFooter: true });
      }
    }
  },
  mounted: function mounted() {
    // console.log('height:', document.querySelector('.vid__description').style.height);
    console.log('Lorem ipsum dolor sit amet consectetur adipisicing elit. Ducimus explicabo itaque quia deleniti earum odio ut facilis, quod possimus. Quia'.length);
  }
});

/***/ }),
/* 1127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mux_upchunk__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mux_upchunk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__mux_upchunk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_auth__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_me__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_payment__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_video__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_stream__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__services_user__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__services_album__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__services_product__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_attach__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_attach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_attach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_paymentmodal__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_paymentmodal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_paymentmodal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_digital_uploader__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_digital_uploader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_digital_uploader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_contentTopHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_contentTopHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_contentTopHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_dragFileUploader__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_dragFileUploader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_dragFileUploader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_topbarNotification__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_topbarNotification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_topbarNotification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__BannerUpload__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__BannerUpload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__BannerUpload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__assets_video_icon_svg__ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__assets_video_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__assets_video_icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__assets_music_drop_gif__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__assets_music_drop_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__assets_music_drop_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_nav_vue__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_nav_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_nav_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__helper__ = __webpack_require__(2);





























/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    BannerUpload: __WEBPACK_IMPORTED_MODULE_22__BannerUpload___default.a,
    Attach: __WEBPACK_IMPORTED_MODULE_16__components_attach___default.a,
    PaymentModal: __WEBPACK_IMPORTED_MODULE_17__components_paymentmodal___default.a,
    DigitalUploader: __WEBPACK_IMPORTED_MODULE_18__components_digital_uploader___default.a,
    contentTopHeader: __WEBPACK_IMPORTED_MODULE_19__components_contentTopHeader___default.a,
    dragFileUploader: __WEBPACK_IMPORTED_MODULE_20__components_dragFileUploader___default.a,
    topbarNotification: __WEBPACK_IMPORTED_MODULE_21__components_topbarNotification___default.a,
    uploadNav: __WEBPACK_IMPORTED_MODULE_25__components_nav_vue___default.a
  },

  data: function data() {
    return {
      loading: false,
      iconImage: __WEBPACK_IMPORTED_MODULE_23__assets_video_icon_svg___default.a,
      bannerImage: __WEBPACK_IMPORTED_MODULE_24__assets_music_drop_gif___default.a,
      topBarContent: 'Connect your Stripe account to start accepting payments',
      activeTab: 'video',
      tabs: [{ id: 'upload', title: 'Upload', isParent: true, path: 'UploadIndex' }, { id: 'music', title: 'Music', path: 'UploadAlbum' }, { id: 'video', title: 'Video', path: 'VideoUpload' }, { id: 'product', title: 'Product', path: 'AddProduct' }, { id: 'live', title: 'Broadcast Live', path: 'CreateLive' }],
      submitLoading: false,
      albums: [],
      products: [],
      VideoTypes: __WEBPACK_IMPORTED_MODULE_26__helper__["l" /* VideoTypes */],
      video_type: __WEBPACK_IMPORTED_MODULE_26__helper__["l" /* VideoTypes */].UPLOADED,
      terms: false,
      view_prices: __WEBPACK_IMPORTED_MODULE_26__helper__["j" /* StreamViewPrices */],
      viewers_limits: __WEBPACK_IMPORTED_MODULE_26__helper__["k" /* StreamViewersLimits */],
      costs: __WEBPACK_IMPORTED_MODULE_26__helper__["m" /* StreamCosts */],
      streamCost: 1000,
      profit_share_types: [],
      duration: 100,
      // periods: [],
      // period: 3600,
      // genres: [],
      video: {},
      stream: {
        name: '',
        description: '',
        view_price: 0,
        viewers_limit: 0,
        cover: null,
        ml_input_type: 'RTMP_PUSH',
        ml_input_codec: 'AVC',
        ml_input_resolution: 'HD',
        ml_input_maximum_bitrate: 'MAX_10_MBPS',
        collaborators: [],
        account_ids: [],
        creator_recoup_cost: 0,
        access_level: ''
      },
      stream_cover_url: null,
      stream_assoc: {
        id: null,
        type: null
      },
      digital_content: {
        file: null
      },
      show_payment_dialog: false,
      show_stripe_connect_dialog: false,
      show_help_dialog: false,
      show_attach_picker: false,
      show_collaborators_dialog: false,
      users: [],
      friends: [],
      isPageReady: false,
      videoFile: null,
      videoUrl: null,
      genre_name: null,
      selectedStream: null,
      access_levels: [],
      videoId: null
    };
  },


  computed: {
    onMobile: function onMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    mergedAttachmentItems: function mergedAttachmentItems() {
      var combined = [].concat(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(this.albums), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(this.products));
      console.log('combined: ', combined);
      return combined;
    },
    videoFileName: function videoFileName() {
      return this.videoFile[0].name || null;
    },
    currentUser: function currentUser() {
      return this.$store.state.auth.user;
    },
    profileUrl: function profileUrl() {
      return window.location.origin + '/' + this.currentUser.slug;
    },
    genres: function genres() {
      return this._.filter(this.$store.state.app.genres, function (g) {
        return __WEBPACK_IMPORTED_MODULE_26__helper__["n" /* VideoGenres */].indexOf(g.name) > -1;
      }).map(function (g) {
        return { id: g.id, name: g.name };
      });
    },
    profiles: function profiles() {
      return this.friends.slice();
    },
    stream_view_price: function stream_view_price() {
      return __WEBPACK_IMPORTED_MODULE_26__helper__["a" /* Filter */].formatNumber(this.stream.view_price);
    },
    creator_share: function creator_share() {
      return 100 - this._.sumBy(this.stream.collaborators, 'user_share');
    }
  },
  created: function created() {
    var _this = this;

    if (this.onMobile) {
      this.$router.push({ name: "UploadIndex" });
    }

    this.$store.dispatch('navigator/goNextState', {
      page: 'broadcast',
      tab: 'create'
    });

    if (!this.currentUser.stripe_connected) {
      this.openStripeConnectDialog();
    } else {
      // if (this.currentUser.data['video_page_visited'] !== 1) {
      //   this.openHelpDialog()
      // }

      // this.genres = _.flatMap(this.$store.state.app.genres, 'children')
      // this.genres = this.$store.state.app.genres
      // VideoGenres.forEach((vg) => {
      //   const g = this._.find(this.$store.state.app.genres, { name: vg })
      //   if (g) {
      //     this.genres.push({ id: g.id, name: g.name })
      //   } else {
      //     console.log('VideoGenres', vg)
      //   }
      // })

      for (var i = 1; i <= 100; i++) {
        this.profit_share_types.push(i);
      }

      var params = {
        stripe_connected: true,
        page: 1,
        per_page: 30
      };

      var friendsParams = {
        page: 1,
        per_page: 30
      };

      this.isPageReady = false;
      this.videoId = this.$route.params.videoId;
      this.$store.dispatch('error/showLoadingActivity', true);
      __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_9__services_me__["a" /* default */].mutualUsers(params), __WEBPACK_IMPORTED_MODULE_9__services_me__["a" /* default */].mutualUsers(friendsParams), this.getAttachmentItems()]).then(function (values) {
        _this.product_categories = _this.$store.state.app.product_categories;
        _this.digital_content_category_ids = _this.$store.getters['app/digitalCategoryIds'];

        _this.users = values[0].body.users;
        _this.friends = values[1].body.users;
        _this.isPageReady = true;
        _this.$store.dispatch('error/showLoadingActivity', false);

        __WEBPACK_IMPORTED_MODULE_9__services_me__["a" /* default */].mutualUsers(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, params, { per_page: -1 })).then(function (response) {
          _this.users = response.body.users;
        });

        __WEBPACK_IMPORTED_MODULE_9__services_me__["a" /* default */].mutualUsers(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, friendsParams, { per_page: -1 })).then(function (response) {
          _this.friends = response.body.users;
        });

        if (_this.videoId) {
          __WEBPACK_IMPORTED_MODULE_12__services_stream__["a" /* default */].getStream(_this.videoId).then(function (response) {
            _this.stream = response.body;
            _this.stream_cover_url = response.body.cover.url;
            _this.period = _this.stream.period;
            _this.duration = _this.stream.duration;
            _this.digital_content.file = _this.stream.digital_content;
            _this.digital_content.name = _this.stream.digital_content_name;
            _this.stream.collaborators = _this.stream.collaborators ? JSON.parse(_this.stream.collaborators) : _this.stream.collaborators;
            _this.stream.creator_recoup_cost = _this.stream.creator_recoup_cost / 100;
            if (_this.stream.assoc) {
              _this.stream_assoc = {
                id: _this.stream.assoc.id,
                type: _this.stream.assoc_type
              };
            }
            var content = _this.stream.assoc_type === 'Album' ? _this.albums : _this.products;
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(content), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var assoc = _step.value;

                if (_this.stream.assoc && assoc['id'] === _this.stream.assoc.id) {
                  _this.selectedStream = assoc;
                }
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }
          }).catch(function (e) {
            console.error(e);
            _this.$store.dispatch('error/showErrorToast', ['Unable to find this video']);
          });
        }
      }).catch(function (reason) {
        console.log(reason);
        _this.$store.dispatch('error/showLoadingActivity', false);
        _this.$store.dispatch('error/showErrorToast', reason);
      });

      if (this.currentUser.enabled_live_video_free) {
        this.periods.push({
          id: 1,
          name: '1hour / FREE'
        });
      } else {
        // if (this.currentUser.stream_rolled_time > 0) {
        //   this.periods.push({
        //     id: this.currentUser.stream_rolled_time,
        //     name: `${Filter.timeInHours(
        //       this.currentUser.stream_rolled_time
        //     )} / Remaining Unpaid Time`,
        //   })
        //   this.period = this.currentUser.stream_rolled_time
        // }

        // for (let i = 1; i <= 24; i++) {
        //   this.periods.push({
        //     id: i * 3600,
        //     name: `${i}hours / $${(i * StreamHourlyPrice) / 100}`,
        //   })
        // }
        // this.period = 3600

        if (this.currentUser.stream_rolled_cost > 0) {
          this.costs.unshift({
            value: 0,
            name: '$' + __WEBPACK_IMPORTED_MODULE_26__helper__["a" /* Filter */].formatNumber(this.currentUser.stream_rolled_cost) + ' - Remaining Cost'
          });
          this.streamCost = 0;
        }
      }
    }
  },


  methods: {
    chooseAssoc: function chooseAssoc(item) {
      this.stream_assoc.id = item.id;
      if (item.album_type === 'album') {
        this.stream_assoc.type = 'Album';
      } else {
        this.stream_assoc.type = 'ShopProduct';
      }
    },
    isActiveTab: function isActiveTab(tab) {
      return this.activeTab === tab;
    },
    onTab: function onTab(tab) {
      if (tab.path) {
        this.$router.push({ name: tab.path });
      }
    },
    getAttachmentItems: function getAttachmentItems() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_14__services_album__["a" /* default */].getAlbums({
        statuses: 'published, collaborated',
        user_statuses: 'accepted'
      }), __WEBPACK_IMPORTED_MODULE_15__services_product__["a" /* default */].getProducts({
        statuses: 'published, collaborated',
        stock_statuses: 'active',
        user_statuses: 'accepted'
      })]).then(function (values) {
        _this2.albums = values[0].body;
        _this2.products = values[1].body;
      }).catch(function (reason) {
        console.log(reason);
        // this.$store.dispatch('error/showErrorToast', [reason])
      });
    },
    pickedFile: function pickedFile(file) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var video;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this3.validateDuration(file);

              case 2:
                video = _context.sent;

                __WEBPACK_IMPORTED_MODULE_13__services_user__["a" /* default */].uploadStreamLimit(_this3.currentUser.id).then(function (response) {
                  if (response.status == 200) {
                    var duration = video.duration / 60;
                    var plan = _this3.currentUser.plan;
                    var video_duration_limit = plan === "pro" ? 180 : 120;

                    if (duration > video_duration_limit) {
                      _this3.videoFile = null;
                      _this3.$store.dispatch('error/showErrorToast', ['You cannot upload file which have more than ' + video_duration_limit + ' minutes duration']);
                    } else {
                      _this3.videoFile = file;
                    }
                  }
                }).catch(function (e) {
                  _this3.videoFile = null;
                  _this3.$store.dispatch('error/showErrorToast', ['Your stream limit has been exceeded.']);
                });

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    validateDuration: function validateDuration(file) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  try {
                    var video = document.createElement('video');
                    video.preload = 'metadata';

                    video.onloadedmetadata = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
                      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                        while (1) {
                          switch (_context2.prev = _context2.next) {
                            case 0:
                              resolve(this);

                            case 1:
                            case 'end':
                              return _context2.stop();
                          }
                        }
                      }, _callee2, this);
                    }));

                    video.onerror = function () {
                      reject("Invalid video. Please select a video file.");
                    };

                    video.src = window.URL.createObjectURL(file[0]);
                  } catch (e) {
                    reject(e);
                  }
                }));

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    openHelpDialog: function openHelpDialog() {
      this.show_help_dialog = true;
    },
    closeHelpDialog: function closeHelpDialog() {
      var _this5 = this;

      this.show_help_dialog = false;
      var params = {
        user: {
          video_page_visited: 1
        }
      };
      __WEBPACK_IMPORTED_MODULE_13__services_user__["a" /* default */].updateUserInfo(this.currentUser.id, params).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_8__services_auth__["a" /* default */].setUser(response.body);
        _this5.$store.dispatch('auth/setUser', response.body);
      });
    },
    openStripeConnectDialog: function openStripeConnectDialog() {
      this.show_stripe_connect_dialog = true;
    },
    closeStripeConnectDialog: function closeStripeConnectDialog() {
      this.show_stripe_connect_dialog = false;
      this.$router.push({ path: '/settings#bank-details' });
    },
    openCollaboratorsDialog: function openCollaboratorsDialog() {
      this.show_collaborators_dialog = true;
    },
    closeCollaboratorsDialog: function closeCollaboratorsDialog() {
      this.show_collaborators_dialog = false;
    },
    addCollaborator: function addCollaborator() {
      this.stream.collaborators.push({
        user_id: '',
        user_share: 5
      });
    },
    deleteCollaborator: function deleteCollaborator(index) {
      this.stream.collaborators.splice(index, 1);
    },
    openPaymentDialog: function openPaymentDialog() {
      var _this6 = this;

      this.$validator.validateAll().then(function (response) {
        if (response === true) {
          if (_this6.currentUser.enabled_live_video_free || _this6.streamCost === 0) {
            _this6.submit();
          } else {
            _this6.show_payment_dialog = true;
          }
        } else {
          _this6.$store.dispatch('error/showErrorToast', [_this6.errors.items[0].msg]);
        }
      }).catch(function (e) {
        console.log('error', e);
      });
    },
    closePaymentDialog: function closePaymentDialog() {
      this.show_payment_dialog = false;
    },
    deposit: function deposit(token) {
      var _this7 = this;

      if (token) {
        var params = {
          payment_token: token.id,
          amount: this.streamCost
          // amount: StreamHourlyPrice
        };
        __WEBPACK_IMPORTED_MODULE_10__services_payment__["a" /* default */].makeDeposit(params).then(function () {
          _this7.submit();
        }).catch(function (e) {
          _this7.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
        });
      } else {
        this.submit();
      }
    },
    imageChanged: function imageChanged(e) {
      var _this8 = this;

      if (e.target.files.length > 0) {
        this.stream.cover = e.target.files[0];
        var reader = new FileReader();
        reader.addEventListener('load', function (event) {
          _this8.stream_cover_url = event.target.result;
        }, false);
        reader.readAsDataURL(this.stream.cover);
      } else {
        this.stream.cover = null;
        this.stream_cover_url = null;
      }
    },


    onCopy: function onCopy(e) {
      this.$store.dispatch("error/showSuccessToast", ["You just copied: " + e.text]);
      // alert('You just copied: ' + e.text)
    },

    onError: function onError(e) {
      this.$store.dispatch("error/showErrorToast", ["Failed to copy link"]);
      // alert('Failed to copy link')
    },

    submit: function submit() {
      var _this9 = this;

      this.$validator.validateAll().then(function (response) {
        if (response === true) {
          _this9.loading = true;
          _this9.submitLoading = true;

          var formData = new FormData();
          formData.append('stream[name]', _this9.stream.name);
          formData.append('stream[description]', _this9.stream.description);
          formData.append('stream[genre_id]', _this9.stream.genre_id);
          formData.append('stream[cover]', _this9.stream.cover);
          formData.append('stream[access_level]', _this9.stream.access_level);
          formData.append('stream[viewers_limit]', _this9.stream.viewers_limit);

          if (_this9.digital_content.file) {
            formData.append('stream[digital_content]', _this9.digital_content.file);

            formData.append('stream[digital_content_name]', _this9.digital_content.file.name);
          }

          formData.append('stream[account_ids]', _this9.stream.account_ids.join(','));
          formData.append('stream[collaborators]', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this9.stream.collaborators));
          if (_this9.stream_assoc.id && _this9.selectedStream) {
            formData.append('stream[assoc_type]', _this9.stream_assoc.type);
            formData.append('stream[assoc_id]', _this9.stream_assoc.id);
          }

          _this9.$store.dispatch('error/showLoadingActivity', true);
          if (_this9.videoId) {
            __WEBPACK_IMPORTED_MODULE_12__services_stream__["a" /* default */].updateStream(_this9.videoId, formData).then(function (response) {
              _this9.$store.dispatch("error/showSuccessToast", ["Video updated successfully!"]);
              _this9.loading = false;
              _this9.$router.push({ path: '/manage', query: { tab: 'videos' } });
            }).catch(function (e) {
              _this9.$store.dispatch("error/showErrorToast", ['Unable to update video']);
              _this9.loading = false;
            });
          } else {
            formData.append('stream[view_price]', _this9.stream.view_price);
            formData.append('stream[valid_period]', _this9.period);
            formData.append('stream[duration]', _this9.duration);
            formData.append('stream[creator_recoup_cost]', Math.round(_this9.stream.creator_recoup_cost * 100));

            __WEBPACK_IMPORTED_MODULE_11__services_video__["a" /* default */].createVideo(formData).then(function (response) {
              _this9.genre_name = response.body.genre.name;
              _this9.video = response.body;

              var upload_url = _this9.video.upload_url;

              var upload = __WEBPACK_IMPORTED_MODULE_7__mux_upchunk__["createUpload"]({
                endpoint: upload_url,
                file: _this9.videoFile[0],
                chunkSize: 5120 // Uploads the file in ~5mb chunks
              });

              upload.on('error', function (err) {
                _this9.loading = false;
                _this9.$store.dispatch('error/showLoadingActivity', false);
                console.error('💥', err.detail);
              });

              upload.on('progress', function (progress) {
                _this9.$store.commit('error/setProgressBarValue', parseInt(progress.detail));
              });

              upload.on('success', function () {
                _this9.loading = false;
                localStorage.setItem("release_video", _this9.video.id);
                _this9.$router.push({ path: '/video/' + _this9.video.id + '/show' });
                _this9.$store.dispatch('error/showLoadingActivity', false);
                console.log("Wrap it up, we're done here. 👋");
                // this.$router.push({ path: `/video/${this.video.id}/show` })
              });
            }).catch(function (e) {
              _this9.loading = false;
              console.log(e);
              console.log(e.message);
              _this9.$store.dispatch('error/showLoadingActivity', false);
              _this9.$store.dispatch('error/showErrorToast', e.message || e.body.errors || [e.body]);

              _this9.submitLoading = false;
            });
          }
        } else {
          _this9.$store.dispatch('error/showErrorToast', [_this9.errors.items[0].msg]);
        }
      }).catch(function (e) {
        console.log('error', e);
      });
    },
    deleteAttachedVideo: function deleteAttachedVideo() {
      var _this10 = this;

      // remove prev. emmited video file
      this.videoFile = null;

      // delete uploaded file form input in child component
      this.$nextTick(function () {
        return _this10.$refs.dragFileUploader.deleteAttachedVideo();
      });
    }
  },

  mounted: function mounted() {
    var _this11 = this;

    __WEBPACK_IMPORTED_MODULE_13__services_user__["a" /* default */].getAccessLevels(this.currentUser.id).then(function (response) {
      _this11.access_levels = response.body;
      _this11.stream.access_level = 'published';
    }).catch(function (e) {
      _this11.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
    });
  }
});

/***/ }),
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1192 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1193 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1194 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1195 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1196 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1197 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1198 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1199 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1200 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1201 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1202 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1203 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1204 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1205 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1206 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1207 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1208 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1209 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1210 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1211 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1212 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1213 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1214 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1215 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1216 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1217 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1218 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1219 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1220 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1221 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1222 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1223 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1224 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1225 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1226 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1227 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1228 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1229 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1230 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1231 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1232 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1233 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1234 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1235 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1236 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1237 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1238 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1239 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1240 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1241 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1242 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1243 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1244 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1245 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1246 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1247 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1248 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1249 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1250 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1251 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1252 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1253 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1254 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1255 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1256 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1257 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1258 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1259 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1260 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1261 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1262 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1263 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1264 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1265 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1266 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1267 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1268 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1269 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1270 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1271 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1272 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1273 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1274 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1275 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1276 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1277 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1278 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1279 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1280 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1281 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1282 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1283 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1284 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1285 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1286 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1287 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1288 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1289 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1290 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1291 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1292 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1293 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1294 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1295 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1296 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1297 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1298 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1299 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1300 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1301 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1302 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1303 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1304 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1305 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1306 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1307 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1308 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1309 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1310 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1311 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1312 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1313 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1314 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1315 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1316 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1317 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1318 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1319 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1320 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1321 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1322 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1323 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1324 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1325 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1326 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1327 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1328 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1329 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1330 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1331 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1332 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1333 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1334 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1335 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1336 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1337 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1338 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1339 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1340 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1341 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1342 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1343 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1344 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1345 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1346 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1347 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1348 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1349 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1350 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1351 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1352 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1353 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1354 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1355 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1356 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1357 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1358 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1359 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1360 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1361 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1362 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1363 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1364 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1365 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1366 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1367 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1368 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1369 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1370 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1371 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1372 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1373 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1374 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1375 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1376 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1377 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1378 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1379 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1380 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1381 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1382 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1383 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1384 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1385 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1386 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1387 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1388 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1389 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1390 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1391 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1392 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1393 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1394 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1395 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1396 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1397 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1398 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1399 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1400 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1401 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1402 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1403 */,
/* 1404 */,
/* 1405 */,
/* 1406 */,
/* 1407 */,
/* 1408 */,
/* 1409 */,
/* 1410 */,
/* 1411 */,
/* 1412 */,
/* 1413 */,
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 466,
	"./af.js": 466,
	"./ar": 473,
	"./ar-dz": 467,
	"./ar-dz.js": 467,
	"./ar-kw": 468,
	"./ar-kw.js": 468,
	"./ar-ly": 469,
	"./ar-ly.js": 469,
	"./ar-ma": 470,
	"./ar-ma.js": 470,
	"./ar-sa": 471,
	"./ar-sa.js": 471,
	"./ar-tn": 472,
	"./ar-tn.js": 472,
	"./ar.js": 473,
	"./az": 474,
	"./az.js": 474,
	"./be": 475,
	"./be.js": 475,
	"./bg": 476,
	"./bg.js": 476,
	"./bm": 477,
	"./bm.js": 477,
	"./bn": 478,
	"./bn.js": 478,
	"./bo": 479,
	"./bo.js": 479,
	"./br": 480,
	"./br.js": 480,
	"./bs": 481,
	"./bs.js": 481,
	"./ca": 482,
	"./ca.js": 482,
	"./cs": 483,
	"./cs.js": 483,
	"./cv": 484,
	"./cv.js": 484,
	"./cy": 485,
	"./cy.js": 485,
	"./da": 486,
	"./da.js": 486,
	"./de": 489,
	"./de-at": 487,
	"./de-at.js": 487,
	"./de-ch": 488,
	"./de-ch.js": 488,
	"./de.js": 489,
	"./dv": 490,
	"./dv.js": 490,
	"./el": 491,
	"./el.js": 491,
	"./en-au": 492,
	"./en-au.js": 492,
	"./en-ca": 493,
	"./en-ca.js": 493,
	"./en-gb": 494,
	"./en-gb.js": 494,
	"./en-ie": 495,
	"./en-ie.js": 495,
	"./en-nz": 496,
	"./en-nz.js": 496,
	"./eo": 497,
	"./eo.js": 497,
	"./es": 500,
	"./es-do": 498,
	"./es-do.js": 498,
	"./es-us": 499,
	"./es-us.js": 499,
	"./es.js": 500,
	"./et": 501,
	"./et.js": 501,
	"./eu": 502,
	"./eu.js": 502,
	"./fa": 503,
	"./fa.js": 503,
	"./fi": 504,
	"./fi.js": 504,
	"./fo": 505,
	"./fo.js": 505,
	"./fr": 508,
	"./fr-ca": 506,
	"./fr-ca.js": 506,
	"./fr-ch": 507,
	"./fr-ch.js": 507,
	"./fr.js": 508,
	"./fy": 509,
	"./fy.js": 509,
	"./gd": 510,
	"./gd.js": 510,
	"./gl": 511,
	"./gl.js": 511,
	"./gom-latn": 512,
	"./gom-latn.js": 512,
	"./gu": 513,
	"./gu.js": 513,
	"./he": 514,
	"./he.js": 514,
	"./hi": 515,
	"./hi.js": 515,
	"./hr": 516,
	"./hr.js": 516,
	"./hu": 517,
	"./hu.js": 517,
	"./hy-am": 518,
	"./hy-am.js": 518,
	"./id": 519,
	"./id.js": 519,
	"./is": 520,
	"./is.js": 520,
	"./it": 521,
	"./it.js": 521,
	"./ja": 522,
	"./ja.js": 522,
	"./jv": 523,
	"./jv.js": 523,
	"./ka": 524,
	"./ka.js": 524,
	"./kk": 525,
	"./kk.js": 525,
	"./km": 526,
	"./km.js": 526,
	"./kn": 527,
	"./kn.js": 527,
	"./ko": 528,
	"./ko.js": 528,
	"./ky": 529,
	"./ky.js": 529,
	"./lb": 530,
	"./lb.js": 530,
	"./lo": 531,
	"./lo.js": 531,
	"./lt": 532,
	"./lt.js": 532,
	"./lv": 533,
	"./lv.js": 533,
	"./me": 534,
	"./me.js": 534,
	"./mi": 535,
	"./mi.js": 535,
	"./mk": 536,
	"./mk.js": 536,
	"./ml": 537,
	"./ml.js": 537,
	"./mr": 538,
	"./mr.js": 538,
	"./ms": 540,
	"./ms-my": 539,
	"./ms-my.js": 539,
	"./ms.js": 540,
	"./mt": 541,
	"./mt.js": 541,
	"./my": 542,
	"./my.js": 542,
	"./nb": 543,
	"./nb.js": 543,
	"./ne": 544,
	"./ne.js": 544,
	"./nl": 546,
	"./nl-be": 545,
	"./nl-be.js": 545,
	"./nl.js": 546,
	"./nn": 547,
	"./nn.js": 547,
	"./pa-in": 548,
	"./pa-in.js": 548,
	"./pl": 549,
	"./pl.js": 549,
	"./pt": 551,
	"./pt-br": 550,
	"./pt-br.js": 550,
	"./pt.js": 551,
	"./ro": 552,
	"./ro.js": 552,
	"./ru": 553,
	"./ru.js": 553,
	"./sd": 554,
	"./sd.js": 554,
	"./se": 555,
	"./se.js": 555,
	"./si": 556,
	"./si.js": 556,
	"./sk": 557,
	"./sk.js": 557,
	"./sl": 558,
	"./sl.js": 558,
	"./sq": 559,
	"./sq.js": 559,
	"./sr": 561,
	"./sr-cyrl": 560,
	"./sr-cyrl.js": 560,
	"./sr.js": 561,
	"./ss": 562,
	"./ss.js": 562,
	"./sv": 563,
	"./sv.js": 563,
	"./sw": 564,
	"./sw.js": 564,
	"./ta": 565,
	"./ta.js": 565,
	"./te": 566,
	"./te.js": 566,
	"./tet": 567,
	"./tet.js": 567,
	"./th": 568,
	"./th.js": 568,
	"./tl-ph": 569,
	"./tl-ph.js": 569,
	"./tlh": 570,
	"./tlh.js": 570,
	"./tr": 571,
	"./tr.js": 571,
	"./tzl": 572,
	"./tzl.js": 572,
	"./tzm": 574,
	"./tzm-latn": 573,
	"./tzm-latn.js": 573,
	"./tzm.js": 574,
	"./uk": 575,
	"./uk.js": 575,
	"./ur": 576,
	"./ur.js": 576,
	"./uz": 578,
	"./uz-latn": 577,
	"./uz-latn.js": 577,
	"./uz.js": 578,
	"./vi": 579,
	"./vi.js": 579,
	"./x-pseudo": 580,
	"./x-pseudo.js": 580,
	"./yo": 581,
	"./yo.js": 581,
	"./zh-cn": 582,
	"./zh-cn.js": 582,
	"./zh-hk": 583,
	"./zh-hk.js": 583,
	"./zh-tw": 584,
	"./zh-tw.js": 584
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1414;

/***/ }),
/* 1415 */,
/* 1416 */,
/* 1417 */,
/* 1418 */,
/* 1419 */,
/* 1420 */,
/* 1421 */,
/* 1422 */,
/* 1423 */,
/* 1424 */,
/* 1425 */,
/* 1426 */,
/* 1427 */,
/* 1428 */,
/* 1429 */,
/* 1430 */,
/* 1431 */,
/* 1432 */,
/* 1433 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/activate1.0b14eeb.svg";

/***/ }),
/* 1434 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/activate2.8478778.svg";

/***/ }),
/* 1435 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/activate3.6e992dd.svg";

/***/ }),
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/activate4.62e87f2.svg";

/***/ }),
/* 1437 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/activate5.51c43c8.svg";

/***/ }),
/* 1438 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/activate6.0767c82.svg";

/***/ }),
/* 1439 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/activate7.ffbe56a.svg";

/***/ }),
/* 1440 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/app-store-black.3921c2d.svg";

/***/ }),
/* 1441 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjYiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAyNiAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIuMTk3ODggNS45NDgwNEwyMi44MDIgNS45NDgwNEMyMy45MDY2IDUuOTQ4MDQgMjQuODAyIDYuODQzNDcgMjQuODAyIDcuOTQ4MDRMMjQuODAyIDEzLjc5MTdDMjQuODAyIDE0Ljg5NjMgMjMuOTA2NiAxNS43OTE3IDIyLjgwMiAxNS43OTE3TDYuMjA4MjkgMTUuNzkxNyIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIyLjA4MTM0IiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik01Ljg0Mzc1IDEuNTcyODhDNC4xMzUyMSAzLjI4MTQyIDMuMTc3MjkgNC4yMzkzMyAxLjQ2ODc1IDUuOTQ3ODhMNS44NDM3NSAxMC4zMjI5IiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjIuMDgxMzQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg=="

/***/ }),
/* 1442 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMiIgaGVpZ2h0PSIyMiIgdmlld0JveD0iMCAwIDIyIDIyIiBmaWxsPSJub25lIj4KICA8ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfNzJfMTAyMikiPgogICAgPHBhdGggZD0iTTIwLjE2NjYgOS4xNjY3Nkg2LjI1ODk4TDEwLjQ2MjggNC45NjI5M0MxMC43OTY4IDQuNjE3MTYgMTAuOTgxNiA0LjE1NDA1IDEwLjk3NzQgMy42NzMzNkMxMC45NzMyIDMuMTkyNjcgMTAuNzgwNCAyLjczMjg0IDEwLjQ0MDUgMi4zOTI5M0MxMC4xMDA2IDIuMDUzMDEgOS42NDA3NCAxLjg2MDIgOS4xNjAwNSAxLjg1NjAzQzguNjc5MzYgMS44NTE4NSA4LjIxNjI1IDIuMDM2NjQgNy44NzA0OCAyLjM3MDZMMC41MzcxNDYgOS43MDM5M0MwLjM2NjQxNCA5Ljg3NDIzIDAuMjMwOTU3IDEwLjA3NjUgMC4xMzg1MzMgMTAuMjk5M0MwLjA0NjEwOTQgMTAuNTIyIC0wLjAwMTQ2NDg0IDEwLjc2MDggLTAuMDAxNDY0ODQgMTEuMDAxOUMtMC4wMDE0NjQ4NCAxMS4yNDMxIDAuMDQ2MTA5NCAxMS40ODE5IDAuMTM4NTMzIDExLjcwNDZDMC4yMzA5NTcgMTEuOTI3MyAwLjM2NjQxNCAxMi4xMjk2IDAuNTM3MTQ2IDEyLjI5OTlMNy44NzA0OCAxOS42MzMzQzguMDQwOTQgMTkuODAzNSA4LjI0MzI1IDE5LjkzODQgOC40NjU4NyAyMC4wMzA1QzguNjg4NDkgMjAuMTIyNSA4LjkyNzA1IDIwLjE2OTggOS4xNjc5NCAyMC4xNjk2QzkuNDA4ODMgMjAuMTY5NCA5LjY0NzMzIDIwLjEyMTggOS44Njk4MiAyMC4wMjk1QzEwLjA5MjMgMTkuOTM3MSAxMC4yOTQ0IDE5LjgwMTkgMTAuNDY0NiAxOS42MzE0QzEwLjYzNDkgMTkuNDYxIDEwLjc2OTggMTkuMjU4NyAxMC44NjE5IDE5LjAzNkMxMC45NTM5IDE4LjgxMzQgMTEuMDAxMiAxOC41NzQ5IDExLjAwMSAxOC4zMzRDMTEuMDAwOCAxOC4wOTMxIDEwLjk1MzIgMTcuODU0NiAxMC44NjA5IDE3LjYzMjFDMTAuNzY4NSAxNy40MDk2IDEwLjYzMzMgMTcuMjA3NSAxMC40NjI4IDE3LjAzNzNMNi4yNTg5OCAxMi44MzM0SDIwLjE2NjZDMjAuNjUyOSAxMi44MzM0IDIxLjExOTIgMTIuNjQwMyAyMS40NjMgMTIuMjk2NUMyMS44MDY4IDExLjk1MjYgMjIgMTEuNDg2MyAyMiAxMS4wMDAxQzIyIDEwLjUxMzkgMjEuODA2OCAxMC4wNDc1IDIxLjQ2MyA5LjcwMzczQzIxLjExOTIgOS4zNTk5MiAyMC42NTI5IDkuMTY2NzYgMjAuMTY2NiA5LjE2Njc2WiIgZmlsbD0iYmxhY2siLz4KICA8L2c+CiAgPGRlZnM+CiAgICA8Y2xpcFBhdGggaWQ9ImNsaXAwXzcyXzEwMjIiPgogICAgICA8cmVjdCB3aWR0aD0iMjIiIGhlaWdodD0iMjIiIGZpbGw9IndoaXRlIi8+CiAgICA8L2NsaXBQYXRoPgogIDwvZGVmcz4KPC9zdmc+"

/***/ }),
/* 1443 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzg5OV8yMjgxKSI+CjxwYXRoIGQ9Ik0xMCAwSDZWNkgwVjEwSDZWMTZIMTBWMTBIMTZWNkgxMFYwWiIgZmlsbD0iYmxhY2siLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF84OTlfMjI4MSI+CjxyZWN0IHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K"

/***/ }),
/* 1444 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcuMiAxMC44QzcuMiAxMC4xMzczIDcuNzM3MjYgOS42IDguNCA5LjZIMTUuNkMxNi4yNjI3IDkuNiAxNi44IDEwLjEzNzMgMTYuOCAxMC44QzE2LjggMTEuNDYyNyAxNi4yNjI3IDEyIDE1LjYgMTJIOC40QzcuNzM3MjYgMTIgNy4yIDExLjQ2MjcgNy4yIDEwLjhaIiBmaWxsPSIjMDkyNDRCIi8+CjxwYXRoIGQ9Ik04LjQgMTQuNEM3LjczNzI2IDE0LjQgNy4yIDE0LjkzNzMgNy4yIDE1LjZDNy4yIDE2LjI2MjcgNy43MzcyNiAxNi44IDguNCAxNi44SDEyQzEyLjY2MjcgMTYuOCAxMy4yIDE2LjI2MjcgMTMuMiAxNS42QzEzLjIgMTQuOTM3MyAxMi42NjI3IDE0LjQgMTIgMTQuNEg4LjRaIiBmaWxsPSIjMDkyNDRCIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMCAxMkMwIDUuMzcyNTggNS4zNzI1OCAwIDEyIDBDMTguNjI3NCAwIDI0IDUuMzcyNTggMjQgMTJDMjQgMTguNjI3NCAxOC42Mjc0IDI0IDEyIDI0SDIuNEMxLjA3NDUyIDI0IDAgMjIuOTI1NSAwIDIxLjZWMTJaTTEyIDIuNEM2LjY5ODA3IDIuNCAyLjQgNi42OTgwNyAyLjQgMTJWMjEuNkgxMkMxNy4zMDE5IDIxLjYgMjEuNiAxNy4zMDE5IDIxLjYgMTJDMjEuNiA2LjY5ODA3IDE3LjMwMTkgMi40IDEyIDIuNFoiIGZpbGw9IiMwOTI0NEIiLz4KPC9zdmc+Cg=="

/***/ }),
/* 1445 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0wIDEyQzAgNS4zNzI1OCA1LjM3MjU4IDAgMTIgMEMxOC42Mjc0IDAgMjQgNS4zNzI1OCAyNCAxMkMyNCAxOC42Mjc0IDE4LjYyNzQgMjQgMTIgMjRIMi40QzEuMDc0NTIgMjQgMCAyMi45MjU1IDAgMjEuNlYxMlpNNy4yIDEwLjhDNy4yIDEwLjEzNzMgNy43MzcyNiA5LjYgOC40IDkuNkgxNS42QzE2LjI2MjcgOS42IDE2LjggMTAuMTM3MyAxNi44IDEwLjhDMTYuOCAxMS40NjI3IDE2LjI2MjcgMTIgMTUuNiAxMkg4LjRDNy43MzcyNiAxMiA3LjIgMTEuNDYyNyA3LjIgMTAuOFpNOC40IDE0LjRDNy43MzcyNiAxNC40IDcuMiAxNC45MzczIDcuMiAxNS42QzcuMiAxNi4yNjI3IDcuNzM3MjYgMTYuOCA4LjQgMTYuOEgxMkMxMi42NjI3IDE2LjggMTMuMiAxNi4yNjI3IDEzLjIgMTUuNkMxMy4yIDE0LjkzNzMgMTIuNjYyNyAxNC40IDEyIDE0LjRIOC40WiIgZmlsbD0iIzA5MjQ0QiIvPgo8L3N2Zz4K"

/***/ }),
/* 1446 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNSAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkuNTY3NzYgNEgxLjA2MzA4QzAuNDI1MjM0IDQgMCA0LjQgMCA1VjE1QzAgMTUuNiAwLjQyNTIzNCAxNiAxLjA2MzA4IDE2SDkuNTY3NzZDMTAuMjA1NiAxNiAxMC42MzA4IDE1LjYgMTAuNjMwOCAxNVY1QzEwLjYzMDggNC40IDEwLjIwNTYgNCA5LjU2Nzc2IDRaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNMTMuODIwMyAwSDMuMTg5NDVWMkgxMi43NTcyVjEzSDE0Ljg4MzRWMUMxNC44ODM0IDAuNCAxNC40NTgxIDAgMTMuODIwMyAwWiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg=="

/***/ }),
/* 1447 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/content.f00363d.svg";

/***/ }),
/* 1448 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQzLjUgMTMuNUM0NC4yOTU2IDEzLjUgNDUuMDU4NyAxMy44MTYxIDQ1LjYyMTMgMTQuMzc4N0M0Ni4xODM5IDE0Ljk0MTMgNDYuNSAxNS43MDQ0IDQ2LjUgMTYuNVYzM0M0Ni41IDMzLjc5NTYgNDYuMTgzOSAzNC41NTg3IDQ1LjYyMTMgMzUuMTIxM0M0NS4wNTg3IDM1LjY4MzkgNDQuMjk1NiAzNiA0My41IDM2SDQwLjVWNDMuNUwzMCAzNkgyMSIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIzIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMzQuNSAzSDQuNUMzLjcwNDM1IDMgMi45NDEyOSAzLjMxNjA3IDIuMzc4NjggMy44Nzg2OEMxLjgxNjA3IDQuNDQxMjkgMS41IDUuMjA0MzUgMS41IDZWMjUuNUMxLjUgMjYuMjk1NiAxLjgxNjA3IDI3LjA1ODcgMi4zNzg2OCAyNy42MjEzQzIuOTQxMjkgMjguMTgzOSAzLjcwNDM1IDI4LjUgNC41IDI4LjVIOVYzOUwyMSAyOC41SDM0LjVDMzUuMjk1NiAyOC41IDM2LjA1ODcgMjguMTgzOSAzNi42MjEzIDI3LjYyMTNDMzcuMTgzOSAyNy4wNTg3IDM3LjUgMjYuMjk1NiAzNy41IDI1LjVWNkMzNy41IDUuMjA0MzUgMzcuMTgzOSA0LjQ0MTI5IDM2LjYyMTMgMy44Nzg2OEMzNi4wNTg3IDMuMzE2MDcgMzUuMjk1NiAzIDM0LjUgM1oiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMyIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg=="

/***/ }),
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/creators.ce283e4.png";

/***/ }),
/* 1450 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1451 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1452 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTUuNzE4MDEgMi43MjcyM1YzLjMyNzIzQzUuMjcwNSAzLjM0ODg3IDQuODM5NTIgMy41MDMwMyA0LjQ3OTgyIDMuNzcwMTRDNC4zMzg2NyAzLjg4MDY0IDQuMjI1MSA0LjAyMjQgNC4xNDgwNSA0LjE4NDI1QzQuMDcxMDEgNC4zNDYxMSA0LjAzMjU5IDQuNTIzNjQgNC4wMzU4MiA0LjcwMjg3QzQuMDI1MjggNS4wMjg1IDQuMTQwMDggNS4zNDU3NiA0LjM1NjU1IDUuNTg5MjNDNC42Njg2NiA1Ljg4ODk3IDUuMDQzNTMgNi4xMTU1NCA1LjQ1NDAxIDYuMjUyNTFMNS43MTYzNyA2LjM1Mzk2VjcuNTY3MDVDNS40MjY5MiA3LjU0NDY1IDUuMTQwNDEgNy40OTM0OSA0Ljg2MTEgNy40MTQzMkM0LjU3OTQ4IDcuMzQxNjUgNC4zMDU1IDcuMjQyMTEgNC4wNDI5MSA3LjExNzA1VjguMTQ5NkM0LjU3MzI2IDguMzcxNjkgNS4xNDI0OSA4LjQ4NjA5IDUuNzE3NDYgOC40ODYxNFY5LjI3MjY5SDYuMjUzMVY4LjQ3MDg3QzYuNzA5NDIgOC40NTIzMyA3LjE0OTEyIDguMjk0NTMgNy41MTMxIDguMDE4NjlDNy42NTk3NCA3Ljg5NzY5IDcuNzc2NTkgNy43NDQ1OSA3Ljg1NDYyIDcuNTcxMjNDNy45MzI2NSA3LjM5Nzg2IDcuOTY5NzcgNy4yMDg4NyA3Ljk2MzEgNy4wMTg4N0M3Ljk2NzA0IDYuODA4NzggNy45MTQyOCA2LjYwMTUxIDcuODEwMzcgNi40MTg4N0M3LjY5MDggNi4yMjcxMyA3LjUyOTA2IDYuMDY1MiA3LjMzNzQ2IDUuOTQ1NDFDNi45OTMzNCA1Ljc0MDE0IDYuNjI5NTIgNS41Njk4MyA2LjI1MTQ2IDUuNDM3MDVWNC4yODA2OUM2LjY4Mjc2IDQuMzE3NjQgNy4xMDU4NSA0LjQyMDQ3IDcuNTA2MDEgNC41ODU2TDcuODczNjQgMy42NzAzMkM3LjM2MTEyIDMuNDQ5NCA2LjgxMTQ5IDMuMzI3MjYgNi4yNTM2NCAzLjMxMDMyVjIuNzI3MjNINS43MTgwMVpNNS43MTgwMSA1LjIxNTZDNS41Nzc5OSA1LjE2MDQ0IDUuNDQ3NzggNS4wODMwOCA1LjMzMjM3IDQuOTg2NTFDNS4yOTMyNiA0Ljk1MDU4IDUuMjYyMzUgNC45MDY2NSA1LjI0MTc0IDQuODU3N0M1LjIyMTEyIDQuODA4NzYgNS4yMTEyOSA0Ljc1NTk1IDUuMjEyOTEgNC43MDI4N0M1LjIxMjkxIDQuNDgxNDIgNS4zODEyOCA0LjM0NTc4IDUuNzE4MDEgNC4yOTU5NlY1LjIxNTZaTTYuMjUzNjQgNi41NjUwNUM2LjM5NjY3IDYuNjI1MTcgNi41MzA5NiA2LjcwNDI0IDYuNjUyOTEgNi44MDAxNEM2LjY5NDY2IDYuODMzMzMgNi43MjgzMyA2Ljg3NTU2IDYuNzUxMzkgNi45MjM2NUM2Ljc3NDQ0IDYuOTcxNzUgNi43ODYyOCA3LjAyNDQ1IDYuNzg2MDEgNy4wNzc3OEM2Ljc4NjAxIDcuMzI1NDEgNi42MDg1NSA3LjQ3OTIzIDYuMjUzNjQgNy41MzkyM1Y2LjU2NTA1WiIgZmlsbD0iYmxhY2siLz4KPGNpcmNsZSBjeD0iNiIgY3k9IjYiIHI9IjUuNSIgc3Ryb2tlPSJibGFjayIvPgo8L3N2Zz4K"

/***/ }),
/* 1453 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNiAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0IDBIMkMxLjQ2OTU3IDAgMC45NjA4NTkgMC4yMTA3MTQgMC41ODU3ODYgMC41ODU3ODZDMC4yMTA3MTQgMC45NjA4NTkgMCAxLjQ2OTU3IDAgMkwwIDIuNEw4IDYuOUwxNiAyLjVWMkMxNiAxLjQ2OTU3IDE1Ljc4OTMgMC45NjA4NTkgMTUuNDE0MiAwLjU4NTc4NkMxNS4wMzkxIDAuMjEwNzE0IDE0LjUzMDQgMCAxNCAwWiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTcuNSA4Ljg5OTk1TDAgNC42OTk5NVYxMkMwIDEyLjUzMDQgMC4yMTA3MTQgMTMuMDM5MSAwLjU4NTc4NiAxMy40MTQyQzAuOTYwODU5IDEzLjc4OTIgMS40Njk1NyAxNCAyIDE0SDE0QzE0LjUzMDQgMTQgMTUuMDM5MSAxMy43ODkyIDE1LjQxNDIgMTMuNDE0MkMxNS43ODkzIDEzLjAzOTEgMTYgMTIuNTMwNCAxNiAxMlY0LjY5OTk1TDguNSA4Ljg5OTk1QzguMzQyNCA4Ljk2OTE5IDguMTcyMTQgOS4wMDQ5NSA4IDkuMDA0OTVDNy44Mjc4NiA5LjAwNDk1IDcuNjU3NiA4Ljk2OTE5IDcuNSA4Ljg5OTk1WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg=="

/***/ }),
/* 1454 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxMCAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMuMDIyOTMgMTZMMyA5SDBWNkgzVjRDMyAxLjMwMDggNC42NzE1MSAwIDcuMDc5MzggMEM4LjIzMjc3IDAgOS4yMjQwNiAwLjA4NTg3IDkuNTEyOTQgMC4xMjQyNVYyLjk0NTA3TDcuODQyOTYgMi45NDU4M0M2LjUzMzQzIDIuOTQ1ODMgNi4yNzk4NyAzLjU2ODEgNi4yNzk4NyA0LjQ4MTI0VjZIMTBMOSA5SDYuMjc5ODZWMTZIMy4wMjI5M1oiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo="

/***/ }),
/* 1455 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgdmlld0JveD0iMCAwIDIwMCAyMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIyMDAiIGhlaWdodD0iMjAwIiByeD0iMTAwIiBmaWxsPSIjRTFFMUUxIi8+CjxyZWN0IHg9IjUiIHk9IjUiIHdpZHRoPSIxOTAiIGhlaWdodD0iMTkwIiByeD0iOTUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS1vcGFjaXR5PSIwLjIiIHN0cm9rZS13aWR0aD0iMTAiLz4KPHJlY3QgeD0iOCIgeT0iOCIgd2lkdGg9IjE4NCIgaGVpZ2h0PSIxODQiIHJ4PSI5MiIgZmlsbD0id2hpdGUiIGZpbGwtb3BhY2l0eT0iMC44Ii8+CjxwYXRoIGQ9Ik0xMDAgMTM1Ljg3NVY5NC44NzUiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iNCIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTg3LjE4NzUgMTA3LjY4OEwxMDAgOTQuODc1TDExMi44MTIgMTA3LjY4OCIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSI0IiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTEwLjI1IDExNy45MzhIMTI1LjYyNUMxMzIuOCAxMTcuMTY5IDEzOC40MzggMTExLjI3NSAxMzguNDM4IDEwMy44NDRDMTM4LjQzOCA5Ni40MTI1IDEzMi44IDkwLjUxODggMTI1LjYyNSA4OS43NUMxMjQuMzQ0IDc2LjkzNzUgMTEzLjMyNSA2Ni42ODc1IDEwMCA2Ni42ODc1Qzg4LjQ2ODggNjYuNjg3NSA3OC43MzEzIDc0LjM3NSA3NS40IDg0Ljg4MTNDNjcuNzEyNSA4Ni4xNjI1IDYxLjU2MjUgOTMuMDgxMiA2MS41NjI1IDEwMS4yODFDNjEuNTYyNSAxMDkuOTk0IDY4LjIyNSAxMTcuMTY5IDc2LjkzNzUgMTE3LjkzOEg4OS43NSIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSI0IiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K"

/***/ }),
/* 1456 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1457 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1458 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1459 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1460 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMjMiIHZpZXdCb3g9IjAgMCAyMiAyMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik05LjQ2NCAwLjQ4NTMzM0MxMC4zMjY4IC0wLjE2MTc3OCAxMS41MTMyIC0wLjE2MTc3OCAxMi4zNzYgMC40ODUzMzNMMjAuODY5MyA2Ljg1NTMzQzIxLjQ4MDQgNy4zMTM2MiAyMS44NCA4LjAzMjg2IDIxLjg0IDguNzk2NjdWMjAuMzIzM0MyMS44NCAyMS42NjM1IDIwLjc1MzUgMjIuNzUgMTkuNDEzMyAyMi43NUgxMy40NjhDMTIuNzMwOSAyMi43NSAxMi4xMzMzIDIyLjE1MjQgMTIuMTMzMyAyMS40MTUzVjE0LjI1NjdDMTIuMTMzMyAxMy41ODY2IDExLjU5MDEgMTMuMDQzMyAxMC45MiAxMy4wNDMzQzEwLjI0OTkgMTMuMDQzMyA5LjcwNjY3IDEzLjU4NjYgOS43MDY2NyAxNC4yNTY3VjIxLjQxNTNDOS43MDY2NyAyMi4xNTI1IDkuMTA5MTEgMjIuNzUgOC4zNzIgMjIuNzVIMi40MjY2N0MxLjA4NjQ2IDIyLjc1IDAgMjEuNjYzNSAwIDIwLjMyMzNWOC43OTY2N0MwIDguMDMyODYgMC4zNTk2MTggNy4zMTM2MiAwLjk3MDY2NyA2Ljg1NTMzTDkuNDY0IDAuNDg1MzMzWk0xMC45MiAyLjQyNjY3TDIuNDI2NjcgOC43OTY2N1YyMC4zMjMzSDcuMjhWMTQuMjU2N0M3LjI4IDEyLjI0NjQgOC45MDk2OCAxMC42MTY3IDEwLjkyIDEwLjYxNjdDMTIuOTMwMyAxMC42MTY3IDE0LjU2IDEyLjI0NjQgMTQuNTYgMTQuMjU2N1YyMC4zMjMzSDE5LjQxMzNWOC43OTY2N0wxMC45MiAyLjQyNjY3WiIgZmlsbD0iIzA5MjQ0QiIvPgo8L3N2Zz4K"

/***/ }),
/* 1461 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMjMiIHZpZXdCb3g9IjAgMCAyMiAyMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyLjM3NiAwLjQ4NTMzM0MxMS41MTMyIC0wLjE2MTc3OCAxMC4zMjY4IC0wLjE2MTc3OCA5LjQ2NCAwLjQ4NTMzM0wwLjk3MDY2NiA2Ljg1NTMzQzAuMzU5NjE4IDcuMzEzNjIgMCA4LjAzMjg2IDAgOC43OTY2N1YyMC4zMjMzQzAgMjEuNjYzNSAxLjA4NjQ2IDIyLjc1IDIuNDI2NjcgMjIuNzVINy4xNTg2N0M3Ljg5NTc4IDIyLjc1IDguNDkzMzMgMjIuMTUyNSA4LjQ5MzMzIDIxLjQxNTNWMTUuNDdDOC40OTMzMyAxNC4xMjk4IDkuNTc5NzkgMTMuMDQzMyAxMC45MiAxMy4wNDMzQzEyLjI2MDIgMTMuMDQzMyAxMy4zNDY3IDE0LjEyOTggMTMuMzQ2NyAxNS40N1YyMS40MTUzQzEzLjM0NjcgMjIuMTUyNCAxMy45NDQyIDIyLjc1IDE0LjY4MTMgMjIuNzVIMTkuNDEzM0MyMC43NTM1IDIyLjc1IDIxLjg0IDIxLjY2MzUgMjEuODQgMjAuMzIzM1Y4Ljc5NjY3QzIxLjg0IDguMDMyODYgMjEuNDgwNCA3LjMxMzYyIDIwLjg2OTMgNi44NTUzM0wxMi4zNzYgMC40ODUzMzNaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K"

/***/ }),
/* 1462 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAABGdBTUEAALGPC/xhBQAAAGxJREFUOBFjYCASHD16dCsIE6mcgYVYhf////ciVi1IHRMpiklRO2owPLRGg4L2QcEIyk2kJn64s3AwGBkZt9Eq8v7jsBNT+MiRI/9BGFMGuwitXDxaViDCezSM4WFBs6Agus4DZVOgc4jOIACVzxnMhRE6EgAAAABJRU5ErkJggg=="

/***/ }),
/* 1463 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1My44OCA3MS4xMyI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiNiOWJhYmQ7fTwvc3R5bGU+PC9kZWZzPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTIyNi4zMS0xNjcuMzZjLTYuMjksNC41Mi0xMyw4LjQ2LTE5LjM1LDEyLjg1LTMuNTMsMi40My03LjE3LDQuODMtMTAuODgsNy0yLjMzLDEuNC00LjUsMy40LTYuODMsNS0xLjc2LDEuMi0zLjg0LDEuOTUtNS4zMSwzLjZhMTIsMTIsMCwwLDEtNC40My4zbC0uMTUtMS4zNGMwLTkuNi4wNy0xOS4yLjA3LTI4LjgsMC0xMy0uMDYtMjYtLjA4LTM5LC42Ni0yLDEuNTYtMi4zNCwzLjIyLTEuNDgsNC42NiwyLjQsOC42NCw1LjgxLDEzLDguNiw2LjE2LDMuOTUsMTIuMzQsOC4xOSwxOC41LDEyLjI3LDMuMTksMi4xMiw2LjQsNC4yMSw5LjY2LDYuMjMsMi43NywxLjcxLDYuMTUsMy4wOCw4LjA5LDUuODIuNTIuNzQsMS40NiwxLjYxLDEuNCwyLjU5cy0xLjI2LDEuODktMS43NCwyLjcxYS4zNS4zNSwwLDAsMS0uMTYuMTguNDUuNDUsMCwwLDEtLjI4LDBjLS42Ny0uMTEtLjQ2LjE5LS44LjQ2UTIyOC4zLTE2OC43OSwyMjYuMzEtMTY3LjM2Wm0tMTEuMjIsMS4yNy41NC0uNGMyLjQ5LTEuODcsNS4wNy00LjMyLDgtNS40NywxLjQxLS41NSwyLjg0LTEuNTYsMS4yMy0zLjE3LTEuMjctMS4yNi0zLjQ2LTIuMTItNC45NC0zLjItMy42OS0yLjY3LTcuNDItNS4yOS0xMS4yMy03Ljc4LTIuNDQtMS42LTUuMDctMy4yMS03LjU4LTQuODNzLTUtMy43LTcuNjctNS4yYy0yLjA1LTEuMTUtMy44OS0yLjY0LTUuODgtMy44OWExMi4xOCwxMi4xOCwwLDAsMC0zLjQyLTEuNTksMy4xNCwzLjE0LDAsMCwwLS4xNS42M3EwLDI2Ljc1LDAsNTMuNWMwLC41Mi0uMjgsMS4zLjQzLDEuNWEyLjYzLDIuNjMsMCwwLDAsMi40NS0uNzNjMy42NC0zLjkzLDguNjEtNi4yLDEzLTkuMDZDMjA1LTE1OS4xMSwyMTAuMTgtMTYyLjQyLDIxNS4wOS0xNjYuMDlaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTc5LjM1IDIwOS42MSkiLz48L3N2Zz4="

/***/ }),
/* 1464 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1465 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1466 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1467 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1468 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/landing-share-paid.197588b.png";

/***/ }),
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/landing-tile1.b23dfeb.png";

/***/ }),
/* 1470 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/landing-tile2.1256502.png";

/***/ }),
/* 1471 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/landing-tile3-min.e70d783.png";

/***/ }),
/* 1472 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/landing-tile4-min.b3f05ec.png";

/***/ }),
/* 1473 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAASCAYAAABSO15qAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEHSURBVHgB7ZI9UoRAEIV7BoINuYEcgZRIPYHrDbzBTgG5tRdAzMx0M9O9AUaY6RE4Aub8+E05VFGsm7DJBvuqHj0z1e/1T6HkH6RpuiZsYAQDWA7DsMvz/G2e680fsix7JLzAEK7cc6iUWsdxLFVVfRw1SJLkgVC4a0PVd4Q1cUUM4A0mP5h8jhp/akCCrS4I6r7vb4uiqO3dGBN6nvdlxyFnMykiejyQFLi2rdF+FFvYM4a7cRx2dHVgIH/LEtfBt8yA6cHb3GARlP3QfqS1jqjy6qpt27Ytp4m+79/RmbHnruvuCQ2jlYrNPyEwsgAYbjXiSBYC7fXJO7gYnIUBP8NelqGBz7/hOVr8EggKJwAAAABJRU5ErkJggg=="

/***/ }),
/* 1474 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0OSIgaGVpZ2h0PSI0NCIgdmlld0JveD0iMCAwIDQ5IDQ0IiBmaWxsPSJub25lIj4KICA8cGF0aCBkPSJNMy40MjAwNCA2LjUwODUxTDI1LjI2NTYgMjQuMDYyNEw0NS41NjA4IDYuNDg5MjYiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KICA8cGF0aCBkPSJNMi4yOTY4OCA4LjkzNzVWMzUuMDYyNUMyLjI5Njg4IDM1Ljk3NDIgMi43MDAxOSAzNi44NDg1IDMuNDE4MTEgMzcuNDkzMkM0LjEzNjAyIDM4LjEzNzggNS4xMDk3MiAzOC41IDYuMTI1IDM4LjVINDIuODc1QzQzLjg5MDMgMzguNSA0NC44NjQgMzguMTM3OCA0NS41ODE5IDM3LjQ5MzJDNDYuMjk5OCAzNi44NDg1IDQ2LjcwMzEgMzUuOTc0MiA0Ni43MDMxIDM1LjA2MjVWOC45Mzc1QzQ2LjcwMzEgOC4wMjU4MiA0Ni4yOTk4IDcuMTUxNDggNDUuNTgxOSA2LjUwNjgyQzQ0Ljg2NCA1Ljg2MjE2IDQzLjg5MDMgNS41IDQyLjg3NSA1LjVINi4xMjVDNS4xMDk3MiA1LjUgNC4xMzYwMiA1Ljg2MjE2IDMuNDE4MTEgNi41MDY4MkMyLjcwMDE5IDcuMTUxNDggMi4yOTY4OCA4LjAyNTgyIDIuMjk2ODggOC45Mzc1WiIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4="

/***/ }),
/* 1475 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9InBheW1lbnRzX2JsYWNrXzI0ZHAgMSIgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzUxXzE2OTgpIj4KPGcgaWQ9Ikdyb3VwIj4KPHBhdGggaWQ9IlZlY3RvciIgZD0iTTE1LjM0NzUgMTEuNjM4MlY1LjQ4MDI4QzE1LjM0NzUgNC42MzM1NyAxNC42NTQ3IDMuOTQwODEgMTMuODA4IDMuOTQwODFIMy4wMzE2NkMyLjE4NDk1IDMuOTQwODEgMS40OTIxOSA0LjYzMzU3IDEuNDkyMTkgNS40ODAyOFYxMS42MzgyQzEuNDkyMTkgMTIuNDg0OSAyLjE4NDk1IDEzLjE3NzcgMy4wMzE2NiAxMy4xNzc3SDEzLjgwOEMxNC42NTQ3IDEzLjE3NzcgMTUuMzQ3NSAxMi40ODQ5IDE1LjM0NzUgMTEuNjM4MlpNMTMuODA4IDExLjYzODJIMy4wMzE2NlY1LjQ4MDI4SDEzLjgwOFYxMS42MzgyWk04LjQxOTgyIDYuMjUwMDJDNy4xNDIwNiA2LjI1MDAyIDYuMTEwNjEgNy4yODE0NyA2LjExMDYxIDguNTU5MjNDNi4xMTA2MSA5LjgzNyA3LjE0MjA2IDEwLjg2ODQgOC40MTk4MiAxMC44Njg0QzkuNjk3NTggMTAuODY4NCAxMC43MjkgOS44MzcgMTAuNzI5IDguNTU5MjNDMTAuNzI5IDcuMjgxNDcgOS42OTc1OCA2LjI1MDAyIDguNDE5ODIgNi4yNTAwMlpNMTguNDI2NCA2LjI1MDAyVjE0LjcxNzFDMTguNDI2NCAxNS41NjM4IDE3LjczMzYgMTYuMjU2NiAxNi44ODY5IDE2LjI1NjZIMy44MDE0QzMuODAxNCAxNS40ODY5IDMuODAxNCAxNS41NjM4IDMuODAxNCAxNC43MTcxSDE2Ljg4NjlWNi4yNTAwMkMxNy43MzM2IDYuMjUwMDIgMTcuNjU2NyA2LjI1MDAyIDE4LjQyNjQgNi4yNTAwMloiIGZpbGw9IndoaXRlIi8+CjwvZz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF81MV8xNjk4Ij4KPHJlY3Qgd2lkdGg9IjE4LjQ3MzciIGhlaWdodD0iMTguNDczNyIgZmlsbD0id2hpdGUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuNzIyNjU2IDAuODYxODkzKSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo="

/***/ }),
/* 1476 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMTkiIHZpZXdCb3g9IjAgMCAyMCAxOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9ImV2ZW50X2F2YWlsYWJsZV9ibGFja18yNGRwIDEiIGNsaXAtcGF0aD0idXJsKCNjbGlwMF81MV8xNzEwKSI+CjxwYXRoIGlkPSJWZWN0b3IiIGQ9Ik0xNS4zNDcgMi43MzY4N0gxNC41NzczVjEuMTk3NEgxMy4wMzc4VjIuNzM2ODdINi44Nzk5M1YxLjE5NzRINS4zNDA0NlYyLjczNjg3SDQuNTcwNzJDMy43MjQwMSAyLjczNjg3IDMuMDMxMjUgMy40Mjk2MyAzLjAzMTI1IDQuMjc2MzRWMTUuMDUyN0MzLjAzMTI1IDE1Ljg5OTQgMy43MjQwMSAxNi41OTIxIDQuNTcwNzIgMTYuNTkyMUgxNS4zNDdDMTYuMTkzNyAxNi41OTIxIDE2Ljg4NjUgMTUuODk5NCAxNi44ODY1IDE1LjA1MjdWNC4yNzYzNEMxNi44ODY1IDMuNDI5NjMgMTYuMTkzNyAyLjczNjg3IDE1LjM0NyAyLjczNjg3Wk0xNS4zNDcgMTUuMDUyN0g0LjU3MDcyVjcuMzU1MjlIMTUuMzQ3VjE1LjA1MjdaTTQuNTcwNzIgNS44MTU4MlY0LjI3NjM0SDE1LjM0N1Y1LjgxNTgySDQuNTcwNzJaTTguODUwNDYgMTMuODY3M0wxMy40MTUgOS4zMDI3MkwxMi41OTkxIDguNDg2OEw4Ljg1MDQ2IDEyLjIzNTRMNy4yMjYzMiAxMC42MTEzTDYuNDEwMzkgMTEuNDI3Mkw4Ljg1MDQ2IDEzLjg2NzNaIiBmaWxsPSJ3aGl0ZSIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzUxXzE3MTAiPgo8cmVjdCB3aWR0aD0iMTguNDczNyIgaGVpZ2h0PSIxOC40NzM3IiBmaWxsPSJ3aGl0ZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC43MjI2NTYgMC40Mjc2ODEpIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg=="

/***/ }),
/* 1477 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMTkiIHZpZXdCb3g9IjAgMCAyMCAxOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9ImRhc2hib2FyZF9ibGFja18yNGRwICgxKSAxIiBjbGlwLXBhdGg9InVybCgjY2xpcDBfNTFfMTY4MikiPgo8cGF0aCBpZD0iVmVjdG9yIiBkPSJNMTUuMzQ3IDMuOTM0MjVWNS40NzM3MkgxMi4yNjgxVjMuOTM0MjVIMTUuMzQ3Wk03LjY0OTY3IDMuOTM0MjVWOC41NTI2N0g0LjU3MDcyVjMuOTM0MjVINy42NDk2N1pNMTUuMzQ3IDEwLjA5MjFWMTQuNzEwNkgxMi4yNjgxVjEwLjA5MjFIMTUuMzQ3Wk03LjY0OTY3IDEzLjE3MTFWMTQuNzEwNkg0LjU3MDcyVjEzLjE3MTFINy42NDk2N1pNMTYuODg2NSAyLjM5NDc4SDEwLjcyODZWNy4wMTMySDE2Ljg4NjVWMi4zOTQ3OFpNOS4xODkxNCAyLjM5NDc4SDMuMDMxMjVWMTAuMDkyMUg5LjE4OTE0VjIuMzk0NzhaTTE2Ljg4NjUgOC41NTI2N0gxMC43Mjg2VjE2LjI1SDE2Ljg4NjVWOC41NTI2N1pNOS4xODkxNCAxMS42MzE2SDMuMDMxMjVWMTYuMjVIOS4xODkxNFYxMS42MzE2WiIgZmlsbD0id2hpdGUiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF81MV8xNjgyIj4KPHJlY3Qgd2lkdGg9IjE4LjQ3MzciIGhlaWdodD0iMTguNDczNyIgZmlsbD0id2hpdGUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuNzIyNjU2IDAuMDg1NTcxMykiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K"

/***/ }),
/* 1478 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1479 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cart.52dbb1b.png";

/***/ }),
/* 1480 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/discoverm.333c56a.png";

/***/ }),
/* 1481 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIxMSIgdmlld0JveD0iMCAwIDIwIDExIiBmaWxsPSJub25lIj4KICA8cGF0aCBkPSJNMSAxLjU1OTg2TDEwIDkuNzQzODRMMTkgMS41NTk4NiIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLW9wYWNpdHk9IjAuNiIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4="

/***/ }),
/* 1482 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDIwIDE4IiBmaWxsPSJub25lIj4KICA8cGF0aCBkPSJNMTcuMzc5MyAzLjEwMzQ1SDE0LjYyNzJMMTIuOTQ1NyAwLjMwMTAzNEMxMi44OTA2IDAuMjA5MjI4IDEyLjgxMjYgMC4xMzMyNTUgMTIuNzE5NCAwLjA4MDUwNDdDMTIuNjI2MiAwLjAyNzc1NDIgMTIuNTIwOSAyLjAzNjk2ZS0wNSAxMi40MTM4IDBINy40NDgyN0M3LjM0MTE3IDIuMDM2OTZlLTA1IDcuMjM1OSAwLjAyNzc1NDIgNy4xNDI2OSAwLjA4MDUwNDdDNy4wNDk0OCAwLjEzMzI1NSA2Ljk3MTUgMC4yMDkyMjggNi45MTYzNCAwLjMwMTAzNEw1LjIzNDkgMy4xMDM0NUgyLjQ4Mjc2QzEuODI0MjkgMy4xMDM0NSAxLjE5Mjc5IDMuMzY1MDIgMC43MjcxODMgMy44MzA2M0MwLjI2MTU3NSA0LjI5NjI0IDAgNC45Mjc3NCAwIDUuNTg2MjFWMTUuNTE3MkMwIDE2LjE3NTcgMC4yNjE1NzUgMTYuODA3MiAwLjcyNzE4MyAxNy4yNzI4QzEuMTkyNzkgMTcuNzM4NCAxLjgyNDI5IDE4IDIuNDgyNzYgMThIMTcuMzc5M0MxOC4wMzc4IDE4IDE4LjY2OTMgMTcuNzM4NCAxOS4xMzQ5IDE3LjI3MjhDMTkuNjAwNSAxNi44MDcyIDE5Ljg2MjEgMTYuMTc1NyAxOS44NjIxIDE1LjUxNzJWNS41ODYyMUMxOS44NjIxIDQuOTI3NzQgMTkuNjAwNSA0LjI5NjI0IDE5LjEzNDkgMy44MzA2M0MxOC42NjkzIDMuMzY1MDIgMTguMDM3OCAzLjEwMzQ1IDE3LjM3OTMgMy4xMDM0NVpNOS45MzEwMyAxNC4yNzU5QzkuMTMzMDkgMTQuMjc1OSA4LjM1MzA2IDE0LjAzOTIgNy42ODk2IDEzLjU5NTlDNy4wMjYxMyAxMy4xNTI2IDYuNTA5MDIgMTIuNTIyNSA2LjIwMzY2IDExLjc4NTNDNS44OTgzIDExLjA0ODEgNS44MTg0IDEwLjIzNjkgNS45NzQwNyA5LjQ1NDI5QzYuMTI5NzQgOC42NzE2OCA2LjUxMzk5IDcuOTUyOCA3LjA3ODIyIDcuMzg4NTdDNy42NDI0NiA2LjgyNDM0IDguMzYxMzMgNi40NDAwOSA5LjE0Mzk0IDYuMjg0NDJDOS45MjY1NiA2LjEyODc1IDEwLjczNzggNi4yMDg2NCAxMS40NzUgNi41MTRDMTIuMjEyMiA2LjgxOTM2IDEyLjg0MjMgNy4zMzY0NyAxMy4yODU2IDcuOTk5OTRDMTMuNzI4OSA4LjY2MzQxIDEzLjk2NTUgOS40NDM0MyAxMy45NjU1IDEwLjI0MTRDMTMuOTY1NSAxMS4zMTE0IDEzLjU0MDUgMTIuMzM3NiAxMi43ODM4IDEzLjA5NDJDMTIuMDI3MiAxMy44NTA4IDExLjAwMSAxNC4yNzU5IDkuOTMxMDMgMTQuMjc1OVoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPg=="

/***/ }),
/* 1483 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkiIGhlaWdodD0iMjMiIHZpZXdCb3g9IjAgMCAxOSAyMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9Ikdyb3VwIj4KPHBhdGggaWQ9IlZlY3RvciIgZD0iTTE1LjU1NyAyMS40OTk5SDIuNjY3MDNDMi40MzA2OCAyMS40OTk5IDIuMTk3MDMgMjEuNDQ5NyAxLjk4MTU3IDIxLjM1MjZDMS43NjYxMSAyMS4yNTU0IDEuNTczNzggMjEuMTEzNSAxLjQxNzM0IDIwLjkzNjRDMS4yNjA5IDIwLjc1OTIgMS4xNDM5NCAyMC41NTA4IDEuMDc0MiAyMC4zMjVDMS4wMDQ0NiAyMC4wOTkxIDAuOTgzNTU2IDE5Ljg2MTEgMS4wMTI4NiAxOS42MjY1TDIuNDQ1MzYgOC4xNjY1NUgxNS43Nzg3TDE3LjIxMTIgMTkuNjI2NUMxNy4yNDA1IDE5Ljg2MTEgMTcuMjE5NiAyMC4wOTkxIDE3LjE0OTkgMjAuMzI1QzE3LjA4MDEgMjAuNTUwOCAxNi45NjMyIDIwLjc1OTIgMTYuODA2NyAyMC45MzY0QzE2LjY1MDMgMjEuMTEzNSAxNi40NTc5IDIxLjI1NTQgMTYuMjQyNSAyMS4zNTI2QzE2LjAyNyAyMS40NDk3IDE1Ljc5MzQgMjEuNDk5OSAxNS41NTcgMjEuNDk5OVoiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMS44IiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBpZD0iVmVjdG9yXzIiIGQ9Ik01Ljc3NzM0IDlWNC44MzMzM0M1Ljc4MDIgMy45NTAxNiA2LjEzMjMxIDMuMTAzOTcgNi43NTY4MSAyLjQ3OTQ3QzcuMzgxMzEgMS44NTQ5NiA4LjIyNzUgMS41MDI4NiA5LjExMDY4IDEuNUM5Ljk5Mzg1IDEuNTAyODYgMTAuODQgMS44NTQ5NiAxMS40NjQ1IDIuNDc5NDdDMTIuMDg5IDMuMTAzOTcgMTIuNDQxMiAzLjk1MDE2IDEyLjQ0NCA0LjgzMzMzVjkiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMS44IiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L2c+Cjwvc3ZnPgo="

/***/ }),
/* 1484 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1485 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2IiBmaWxsPSJub25lIj4KICA8Y2lyY2xlIGN4PSI4IiBjeT0iOCIgcj0iNi41IiBmaWxsPSIjRkYwMDAwIi8+CiAgPGNpcmNsZSBjeD0iOCIgY3k9IjgiIHI9IjYuNSIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIzIi8+CiAgPGNpcmNsZSBjeD0iOCIgY3k9IjgiIHI9IjYuNSIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIzIi8+CiAgPGNpcmNsZSBjeD0iOCIgY3k9IjgiIHI9IjYuNSIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIzIi8+Cjwvc3ZnPg=="

/***/ }),
/* 1486 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjAiIGN5PSIyMCIgcj0iMjAiIGZpbGw9IiMwOTA5MDkiLz4KPHBhdGggZD0iTTI2LjcgMTMuM0MyNi4zIDEyLjkgMjUuNyAxMi45IDI1LjMgMTMuM0wyMCAxOC42TDE0LjcgMTMuM0MxNC4zIDEyLjkgMTMuNyAxMi45IDEzLjMgMTMuM0MxMi45IDEzLjcgMTIuOSAxNC4zIDEzLjMgMTQuN0wxOC42IDIwTDEzLjMgMjUuM0MxMi45IDI1LjcgMTIuOSAyNi4zIDEzLjMgMjYuN0MxMy41IDI2LjkgMTMuNyAyNyAxNCAyN0MxNC4zIDI3IDE0LjUgMjYuOSAxNC43IDI2LjdMMjAgMjEuNEwyNS4zIDI2LjdDMjUuNSAyNi45IDI1LjggMjcgMjYgMjdDMjYuMiAyNyAyNi41IDI2LjkgMjYuNyAyNi43QzI3LjEgMjYuMyAyNy4xIDI1LjcgMjYuNyAyNS4zTDIxLjQgMjBMMjYuNyAxNC43QzI3LjEgMTQuMyAyNy4xIDEzLjcgMjYuNyAxMy4zWiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg=="

/***/ }),
/* 1487 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzNSIgaGVpZ2h0PSIzNSIgdmlld0JveD0iMCAwIDM1IDM1IiBmaWxsPSJub25lIj4KICA8Y2lyY2xlIGN4PSIxNy41IiBjeT0iMTcuNSIgcj0iMTcuNSIgZmlsbD0id2hpdGUiLz4KICA8cGF0aCBkPSJNMTcgMTFWMjUiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KICA8cGF0aCBkPSJNMjQgMThIMTAiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+"

/***/ }),
/* 1488 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxNiAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iOCIgY3k9IjguNSIgcj0iOCIgZmlsbD0iIzY1RDFGRiIvPgo8ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfODBfMjQ3OCkiPgo8cGF0aCBkPSJNOCA1LjM4ODkyVjExLjYxMTEiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMS4zMzMzMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik05Ljc3Nzc4IDkuODMzNUw4IDExLjYxMTMiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMS4zMzMzMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik02LjIyMjY2IDkuODMzNUw4LjAwMDQzIDExLjYxMTMiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMS4zMzMzMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfODBfMjQ3OCI+CjxyZWN0IHdpZHRoPSIxMC42NjY3IiBoZWlnaHQ9IjEwLjY2NjciIGZpbGw9IndoaXRlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyLjY2Njk5IDMuMTY2NzUpIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg=="

/***/ }),
/* 1489 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9ImYtY2hhdCAxIiBjbGlwLXBhdGg9InVybCgjY2xpcDBfMzgyXzM2MDYpIj4KPGcgaWQ9Ikdyb3VwIj4KPHBhdGggaWQ9IlZlY3RvciIgZD0iTTE3LjUwMDIgMS42NjY2N0gyLjUwMDE2QzEuNTc5MzMgMS42NjY2NyAwLjgzMzQ5NiAyLjQxMjUgMC44MzM0OTYgMy4zMzMzNFYxMi41QzAuODMzNDk2IDEzLjQyMDggMS41NzkzMyAxNC4xNjY3IDIuNTAwMTYgMTQuMTY2N0g2LjY2NjgzTDEwLjAwMDIgMTguMzMzM0wxMy4zMzM1IDE0LjE2NjdIMTcuNTAwMkMxOC40MjEgMTQuMTY2NyAxOS4xNjY4IDEzLjQyMDggMTkuMTY2OCAxMi41VjMuMzMzMzRDMTkuMTY2OCAyLjQxMjUgMTguNDIxIDEuNjY2NjcgMTcuNTAwMiAxLjY2NjY3WiIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBpZD0iVmVjdG9yXzIiIGQ9Ik01LjgzMzUgNS44MzMzNEgxNC4xNjY4IiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGlkPSJWZWN0b3JfMyIgZD0iTTUuODMzNSAxMEgxMC44MzM1IiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjwvZz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF8zODJfMzYwNiI+CjxyZWN0IHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K"

/***/ }),
/* 1490 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjMiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMyAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggaWQ9IlZlY3RvciIgZD0iTTExLjIyNzMgMTlDMTEuMjI3MyAxOSAxIDEzLjI3MjcgMSA2LjMxODE5QzEgNS4wODg3NSAxLjQyNTk2IDMuODk3MjkgMi4yMDU0MSAyLjk0NjUyQzIuOTg0ODYgMS45OTU3NSA0LjA2OTY0IDEuMzQ0NCA1LjI3NTIgMS4xMDMyOEM2LjQ4MDc2IDAuODYyMTcyIDcuNzMyNjIgMS4wNDYyIDguODE3NzkgMS42MjQwNEM5LjkwMjk2IDIuMjAxODkgMTAuNzU0NCAzLjEzNzg3IDExLjIyNzMgNC4yNzI3M0MxMS43MDAxIDMuMTM3ODcgMTIuNTUxNiAyLjIwMTg5IDEzLjYzNjggMS42MjQwNEMxNC43MjE5IDEuMDQ2MiAxNS45NzM4IDAuODYyMTcyIDE3LjE3OTMgMS4xMDMyOEMxOC4zODQ5IDEuMzQ0NCAxOS40Njk3IDEuOTk1NzUgMjAuMjQ5MSAyLjk0NjUyQzIxLjAyODYgMy44OTcyOSAyMS40NTQ1IDUuMDg4NzUgMjEuNDU0NSA2LjMxODE5QzIxLjQ1NDUgMTMuMjcyNyAxMS4yMjczIDE5IDExLjIyNzMgMTlaIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo="

/***/ }),
/* 1491 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1492 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1493 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9IkZyYW1lIDEwMDAwMDQzNDIiPgo8cGF0aCBpZD0iVmVjdG9yIiBkPSJNMC4zNjA4MiA4LjkwNzA0TDIuNzAzODMgMTAuNjgxOEwxMC44ODY2IDcuMDQ1TDQuNTQzMTQgMTIuMDQ0N1YxOC4xODA5QzQuNTQzMzMgMTguMzY3MyA0LjYwMDggMTguNTQ5MSA0LjcwNzc2IDE4LjcwMTdDNC44MTQ3MiAxOC44NTQ0IDQuOTY2IDE4Ljk3MDQgNS4xNDExMiAxOS4wMzQyQzUuMzE2MjQgMTkuMDk4IDUuNTA2NzQgMTkuMTA2NSA1LjY4NjgyIDE5LjA1ODRDNS44NjY4OSAxOS4wMTAzIDYuMDI3ODQgMTguOTA4MSA2LjE0Nzg4IDE4Ljc2NTVMOC45OTM2OCAxNS4zODQyTDE0LjkwOCAxOS44MTc0QzE1LjAzMDcgMTkuOTA5NyAxNS4xNzQ3IDE5Ljk2OTQgMTUuMzI2NyAxOS45OTFDMTUuNDc4NiAyMC4wMTI1IDE1LjYzMzYgMTkuOTk1MyAxNS43NzcxIDE5Ljk0MDhDMTUuOTIwNiAxOS44ODY0IDE2LjA0OCAxOS43OTY1IDE2LjE0NzQgMTkuNjc5NUMxNi4yNDY3IDE5LjU2MjYgMTYuMzE0OSAxOS40MjIzIDE2LjM0NTUgMTkuMjcxOUwxOS45ODIzIDEuMDg3OTJDMjAuMDE0NSAwLjkyNzI4OCAyMC4wMDI3IDAuNzYwOTM2IDE5Ljk0ODEgMC42MDY0NTRDMTkuODkzNiAwLjQ1MTk3MiAxOS43OTgzIDAuMzE1MTAxIDE5LjY3MjQgMC4yMTAzMUMxOS41NDY0IDAuMTA1NTE5IDE5LjM5NDUgMC4wMzY3MDM4IDE5LjIzMjcgMC4wMTExMzg0QzE5LjA3MDkgLTAuMDE0NDI3IDE4LjkwNTEgMC4wMDQyMDc5MSAxOC43NTMgMC4wNjUwNzNMMC41NjkwMjYgNy4zMzg2N0MwLjQxOTg1NiA3LjM5ODg2IDAuMjg5MzIyIDcuNDk3NTQgMC4xOTA3NDUgNy42MjQ2NEMwLjA5MjE2NzUgNy43NTE3NSAwLjAyOTA3NTcgNy45MDI3MyAwLjAwNzkwNzYzIDguMDYyMTlDLTAuMDEzMjYwNSA4LjIyMTY0IDAuMDA4MjUyODkgOC4zODM4NiAwLjA3MDI1MjUgOC41MzIyOEMwLjEzMjI1MiA4LjY4MDcxIDAuMjMyNTE4IDguODEwMDMgMC4zNjA4MiA4LjkwNzA0WiIgZmlsbD0id2hpdGUiLz4KPC9nPgo8L3N2Zz4K"

/***/ }),
/* 1494 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjciIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAyNyAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9Ikdyb3VwIDEwMDAwMDQ0MTgiPgo8ZyBpZD0iR3JvdXAgMzY2MjgiPgo8cGF0aCBpZD0iVmVjdG9yIiBkPSJNMTIuODE5MSA4LjQ2OTVMMC45NzQ5NjEgMC4xMTIyMjRDMC43ODQyMDggLTAuMDIyMTM0OCAwLjUzNjcyNyAtMC4wMzY5MjA3IDAuMzMyMjYgMC4wNzM2NTI0QzAuMTI3NzkyIDAuMTg0MjI2IDAgMC40MDQwODYgMCAwLjY0MjU5VjE3LjM1NzFDMCAxNy41OTU2IDAuMTI4NDE2IDE3LjgxNDkgMC4zMzI4ODMgMTcuOTI2MUMwLjQyMzg5NiAxNy45NzU2IDAuNTIzNjM2IDE4IDAuNjIzMzc3IDE4QzAuNzQ2ODA1IDE4IDAuODY5NjEgMTcuOTYyMSAwLjk3NDk2MSAxNy44ODc1TDEyLjgxOTEgOS41MzAyM0MxMi45ODkzIDkuNDEwNjUgMTMuMDkwOSA5LjIxMjAxIDEzLjA5MDkgOC45OTk4NkMxMy4wOTA5IDguNzg3NzEgMTIuOTg5MyA4LjU4OTA3IDEyLjgxOTEgOC40Njk1WiIgZmlsbD0id2hpdGUiLz4KPC9nPgo8ZyBpZD0iR3JvdXAgMzY5MzAiPgo8cGF0aCBpZD0iVmVjdG9yXzIiIGQ9Ik0yNS44MTkxIDguNDY5NUwxMy45NzUgMC4xMTIyMjRDMTMuNzg0MiAtMC4wMjIxMzQ4IDEzLjUzNjcgLTAuMDM2OTIwNyAxMy4zMzIzIDAuMDczNjUyNEMxMy4xMjc4IDAuMTg0MjI2IDEzIDAuNDA0MDg2IDEzIDAuNjQyNTlWMTcuMzU3MUMxMyAxNy41OTU2IDEzLjEyODQgMTcuODE0OSAxMy4zMzI5IDE3LjkyNjFDMTMuNDIzOSAxNy45NzU2IDEzLjUyMzYgMTggMTMuNjIzNCAxOEMxMy43NDY4IDE4IDEzLjg2OTYgMTcuOTYyMSAxMy45NzUgMTcuODg3NUwyNS44MTkxIDkuNTMwMjNDMjUuOTg5MyA5LjQxMDY1IDI2LjA5MDkgOS4yMTIwMSAyNi4wOTA5IDguOTk5ODZDMjYuMDkwOSA4Ljc4NzcxIDI1Ljk4OTMgOC41ODkwNyAyNS44MTkxIDguNDY5NVoiIGZpbGw9IndoaXRlIi8+CjwvZz4KPC9nPgo8L3N2Zz4K"

/***/ }),
/* 1495 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTUiIGhlaWdodD0iNTUiIHZpZXdCb3g9IjAgMCA1NSA1NSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9IkZyYW1lIDMyNzIiPgo8ZyBpZD0iR3JvdXAgMTAwMDAwNDQyMCI+CjxwYXRoIGlkPSJWZWN0b3IiIGQ9Ik0xIDI3LjVDMSAxMi44ODgzIDEyLjg4ODMgMSAyNy41IDFDNDIuMTExNyAxIDU0IDEyLjg4ODMgNTQgMjcuNUM1NCA0Mi4xMTE3IDQyLjExMTcgNTQgMjcuNSA1NEMxMi44ODgzIDU0IDEgNDIuMTExNyAxIDI3LjVaIiBmaWxsPSJ3aGl0ZSIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIyIi8+CjxwYXRoIGlkPSJWZWN0b3JfMiIgZD0iTTIwLjU5NzcgMTcuOTAyMUwzNy40ODc2IDI4LjQ1ODNMMjAuNTk3NyAzOS4wMTQ1VjE3LjkwMjFaIiBmaWxsPSJibGFjayIgc3Ryb2tlPSIjMDYwNjA2Ii8+CjwvZz4KPC9nPgo8L3N2Zz4K"

/***/ }),
/* 1496 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDIiIGhlaWdodD0iNDIiIHZpZXdCb3g9IjAgMCA0MiA0MiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9IkZyYW1lIDMyNzIiPgo8cGF0aCBpZD0iVmVjdG9yIiBkPSJNMSAyMUMxIDkuOTcyNTMgOS45NzI1MyAxIDIxIDFDMzIuMDI3NSAxIDQxIDkuOTcyNTMgNDEgMjFDNDEgMzIuMDI3NSAzMi4wMjc1IDQxIDIxIDQxQzkuOTcyNTQgNDEgMSAzMi4wMjc1IDEgMjFaIiBmaWxsPSJibGFjayIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIyIi8+CjxwYXRoIGlkPSJWZWN0b3JfMiIgZD0iTTMwLjkxNzggMjAuMTYyOEwxNi43MzQ5IDExLjUwNTRDMTYuNDk4NyAxMS4zNTU3IDE2LjIyNTggMTEuMjczOCAxNS45NDYyIDExLjI2ODVDMTUuNjY2NiAxMS4yNjMzIDE1LjM5MDkgMTEuMzM1IDE1LjE0OTIgMTEuNDc1OUMxNC45MDQgMTEuNjEwNCAxNC42OTk1IDExLjgwODYgMTQuNTU3NCAxMi4wNDk1QzE0LjQxNTMgMTIuMjkwNCAxNC4zNDA3IDEyLjU2NTIgMTQuMzQxNiAxMi44NDQ5VjMwLjE3OTVDMTQuMzQwNyAzMC40NTkyIDE0LjQxNTMgMzAuNzM0IDE0LjU1NzQgMzAuOTc0OUMxNC42OTk1IDMxLjIxNTggMTQuOTA0IDMxLjQxNCAxNS4xNDkyIDMxLjU0ODVDMTUuMzkwOSAzMS42ODkzIDE1LjY2NjYgMzEuNzYxIDE1Ljk0NjIgMzEuNzU1OEMxNi4yMjU4IDMxLjc1MDYgMTYuNDk4NyAzMS42Njg3IDE2LjczNDkgMzEuNTE5TDMwLjkxNzggMjIuODYxNUMzMS4xNTAyIDIyLjcyMTMgMzEuMzQyNSAyMi41MjM0IDMxLjQ3NiAyMi4yODdDMzEuNjA5NSAyMi4wNTA2IDMxLjY3OTYgMjEuNzgzNyAzMS42Nzk2IDIxLjUxMjJDMzEuNjc5NiAyMS4yNDA3IDMxLjYwOTUgMjAuOTczOCAzMS40NzYgMjAuNzM3NEMzMS4zNDI1IDIwLjUwMSAzMS4xNTAyIDIwLjMwMzEgMzAuOTE3OCAyMC4xNjI4WiIgZmlsbD0id2hpdGUiLz4KPC9nPgo8L3N2Zz4K"

/***/ }),
/* 1497 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9ImJ1dHRvbi1uZXh0IDEiIGNsaXAtcGF0aD0idXJsKCNjbGlwMF80MzFfMTcwOSkiPgo8ZyBpZD0iR3JvdXAiPgo8cGF0aCBpZD0iVmVjdG9yIiBkPSJNMTQuNSA5LjAwMDI0TDIgMC4yNTAyMzhDMS4xMjUgLTAuMzc0NzYxIDAgMC4yNTAyMzkgMCAxLjI1MDI0VjE4Ljc1MDJDMCAxOS43NTAyIDEuMTI1IDIwLjM3NTIgMiAxOS43NTAyTDE0LjUgMTEuMDAwMkMxNS4xMjUgMTAuNTAwMiAxNS4xMjUgOS41MDAyNCAxNC41IDkuMDAwMjRaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBpZD0iVmVjdG9yXzIiIGQ9Ik0xOC43NSAwQzE4IDAgMTcuNSAwLjUgMTcuNSAxLjI1VjE4Ljc1QzE3LjUgMTkuNSAxOCAyMCAxOC43NSAyMEMxOS41IDIwIDIwIDE5LjUgMjAgMTguNzVWMS4yNUMyMCAwLjUgMTkuNSAwIDE4Ljc1IDBaIiBmaWxsPSJibGFjayIvPgo8L2c+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfNDMxXzE3MDkiPgo8cmVjdCB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIGZpbGw9IndoaXRlIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg=="

/***/ }),
/* 1498 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9ImJ1dHRvbi1uZXh0IDIiIGNsaXAtcGF0aD0idXJsKCNjbGlwMF80MzFfMTcxNykiPgo8ZyBpZD0iR3JvdXAiPgo8cGF0aCBpZD0iVmVjdG9yIiBkPSJNNS41IDEwLjk5OThMMTggMTkuNzQ5OEMxOC44NzUgMjAuMzc0OCAyMCAxOS43NDk4IDIwIDE4Ljc0OThMMjAgMS4yNDk3N0MyMCAwLjI0OTc2NSAxOC44NzUgLTAuMzc1MjM1IDE4IDAuMjQ5NzY1TDUuNSA4Ljk5OTc2QzQuODc1IDkuNDk5NzYgNC44NzUgMTAuNDk5OCA1LjUgMTAuOTk5OFoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGlkPSJWZWN0b3JfMiIgZD0iTTEuMjUgMjBDMiAyMCAyLjUgMTkuNSAyLjUgMTguNzVMMi41IDEuMjVDMi41IDAuNSAyIC00LjM3MTE0ZS0wOCAxLjI1IC0xLjA5Mjc4ZS0wN0MwLjUwMDAwMiAtMS43NDg0NmUtMDcgMS43MDQ3NGUtMDYgMC41IDEuNjM5MThlLTA2IDEuMjVMMS4wOTI3OGUtMDcgMTguNzVDNC4zNzExNGUtMDggMTkuNSAwLjUgMjAgMS4yNSAyMFoiIGZpbGw9ImJsYWNrIi8+CjwvZz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF80MzFfMTcxNyI+CjxyZWN0IHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgZmlsbD0id2hpdGUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIwIDIwKSByb3RhdGUoLTE4MCkiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K"

/***/ }),
/* 1499 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNiAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9Ikdyb3VwIj4KPHBhdGggaWQ9IlZlY3RvciIgZD0iTTE1IDBIMTNDMTIuNDQ3NyAwIDEyIDAuNDQ3NzE1IDEyIDFWMTNDMTIgMTMuNTUyMyAxMi40NDc3IDE0IDEzIDE0SDE1QzE1LjU1MjMgMTQgMTYgMTMuNTUyMyAxNiAxM1YxQzE2IDAuNDQ3NzE1IDE1LjU1MjMgMCAxNSAwWiIgZmlsbD0id2hpdGUiLz4KPHBhdGggaWQ9IlZlY3Rvcl8yIiBkPSJNOSA0SDdDNi40NDc3MiA0IDYgNC40NDc3MiA2IDVWMTNDNiAxMy41NTIzIDYuNDQ3NzIgMTQgNyAxNEg5QzkuNTUyMjggMTQgMTAgMTMuNTUyMyAxMCAxM1Y1QzEwIDQuNDQ3NzIgOS41NTIyOCA0IDkgNFoiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGlkPSJWZWN0b3JfMyIgZD0iTTMgOEgxQzAuNDQ3NzE1IDggMCA4LjQ0NzcyIDAgOVYxM0MwIDEzLjU1MjMgMC40NDc3MTUgMTQgMSAxNEgzQzMuNTUyMjggMTQgNCAxMy41NTIzIDQgMTNWOUM0IDguNDQ3NzIgMy41NTIyOCA4IDMgOFoiIGZpbGw9IndoaXRlIi8+CjwvZz4KPC9zdmc+Cg=="

/***/ }),
/* 1500 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4IiBoZWlnaHQ9IjgiIHZpZXdCb3g9IjAgMCA4IDgiIGZpbGw9Im5vbmUiPgogIDxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNCAwQzMuNDQ3NzIgMCAzIDAuNDQ3NzE1IDMgMVYzSDFDMC40NDc3MTUgMyAwIDMuNDQ3NzIgMCA0QzAgNC41NTIyOCAwLjQ0NzcxNSA1IDEgNUgzVjdDMyA3LjU1MjI4IDMuNDQ3NzIgOCA0IDhDNC41NTIyOCA4IDUgNy41NTIyOCA1IDdWNUg3QzcuNTUyMjggNSA4IDQuNTUyMjggOCA0QzggMy40NDc3MiA3LjU1MjI4IDMgNyAzSDVWMUM1IDAuNDQ3NzE1IDQuNTUyMjggMCA0IDBaIiBmaWxsPSIjMTcxNzE3Ii8+Cjwvc3ZnPg=="

/***/ }),
/* 1501 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjciIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAyNyAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9Ikdyb3VwIDEwMDAwMDQ0MTciPgo8ZyBpZD0iR3JvdXAgMzY2MjkiPgo8cGF0aCBpZD0iVmVjdG9yIiBkPSJNMTMuMjcxNyA5LjUzMDVMMjUuMTE1OSAxNy44ODc4QzI1LjMwNjYgMTguMDIyMSAyNS41NTQxIDE4LjAzNjkgMjUuNzU4NiAxNy45MjYzQzI1Ljk2MyAxNy44MTU4IDI2LjA5MDggMTcuNTk1OSAyNi4wOTA4IDE3LjM1NzRMMjYuMDkwOCAwLjY0Mjg2OEMyNi4wOTA4IDAuNDA0MzY0IDI1Ljk2MjQgMC4xODUxNDYgMjUuNzU3OSAwLjA3MzkzMDdDMjUuNjY2OSAwLjAyNDQyOTMgMjUuNTY3MiAtNC44MDAzMmUtMDggMjUuNDY3NCAtNS43MTQ2N2UtMDhDMjUuMzQ0IC02Ljg0NjE3ZS0wOCAyNS4yMjEyIDAuMDM3OTI5NSAyNS4xMTU5IDAuMTEyNTAxTDEzLjI3MTcgOC40Njk3N0MxMy4xMDE1IDguNTg5MzQgMTIuOTk5OSA4Ljc4Nzk5IDEyLjk5OTkgOS4wMDAxNEMxMi45OTk5IDkuMjEyMjggMTMuMTAxNSA5LjQxMDkzIDEzLjI3MTcgOS41MzA1WiIgZmlsbD0id2hpdGUiLz4KPC9nPgo8ZyBpZD0iR3JvdXAgMzY5MzEiPgo8cGF0aCBpZD0iVmVjdG9yXzIiIGQ9Ik0wLjI3MTcwNiA5LjUzMDVMMTIuMTE1OSAxNy44ODc4QzEyLjMwNjYgMTguMDIyMSAxMi41NTQxIDE4LjAzNjkgMTIuNzU4NiAxNy45MjYzQzEyLjk2MyAxNy44MTU4IDEzLjA5MDggMTcuNTk1OSAxMy4wOTA4IDE3LjM1NzRMMTMuMDkwOCAwLjY0Mjg2OEMxMy4wOTA4IDAuNDA0MzY0IDEyLjk2MjQgMC4xODUxNDYgMTIuNzU3OSAwLjA3MzkzMDdDMTIuNjY2OSAwLjAyNDQyOTMgMTIuNTY3MiAtNC44MDAzMmUtMDggMTIuNDY3NCAtNS43MTQ2N2UtMDhDMTIuMzQ0IC02Ljg0NjE3ZS0wOCAxMi4yMjEyIDAuMDM3OTI5NSAxMi4xMTU5IDAuMTEyNTAxTDAuMjcxNzA2IDguNDY5NzdDMC4xMDE1MjQgOC41ODkzNCAtOC42MDE2NGUtMDUgOC43ODc5OSAtOC42MDM0ZS0wNSA5LjAwMDE0Qy04LjYwNTE3ZS0wNSA5LjIxMjI4IDAuMTAxNTI0IDkuNDEwOTMgMC4yNzE3MDYgOS41MzA1WiIgZmlsbD0id2hpdGUiLz4KPC9nPgo8L2c+Cjwvc3ZnPgo="

/***/ }),
/* 1502 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAyMiAyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9Ikdyb3VwIj4KPHBhdGggaWQ9IlZlY3RvciIgZD0iTTEwLjMzMzUgOS4wMDAwNEwxNC4zMzM1IDUuMDAwMDJMMTAuMzMzNSAxIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGlkPSJWZWN0b3JfMiIgZD0iTTE0LjMzMzQgNUgzLjAwMDAxQzIuNDY5NTcgNSAxLjk2MDg2IDUuMjEwNzEgMS41ODU3OSA1LjU4NTc5QzEuMjEwNzEgNS45NjA4NiAxIDYuNDY5NTcgMSA3LjAwMDAxVjE1QzEgMTUuNTMwNSAxLjIxMDcxIDE2LjAzOTIgMS41ODU3OSAxNi40MTQzQzEuOTYwODYgMTYuNzg5MyAyLjQ2OTU3IDE3LjAwMDEgMy4wMDAwMSAxNy4wMDAxSDMuNjY2NjgiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggaWQ9IlZlY3Rvcl8zIiBkPSJNMTEuNjY3IDEzTDcuNjY2OTkgMTdMMTEuNjY3IDIxIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGlkPSJWZWN0b3JfNCIgZD0iTTcuNjY2OTkgMTcuMDAwMUgxOS4wMDA0QzE5LjUzMDggMTcuMDAwMSAyMC4wMzk1IDE2Ljc4OTMgMjAuNDE0NiAxNi40MTQzQzIwLjc4OTcgMTYuMDM5MiAyMS4wMDA0IDE1LjUzMDUgMjEuMDAwNCAxNVY3LjAwMDAxQzIxLjAwMDQgNi40Njk1NyAyMC43ODk3IDUuOTYwODYgMjAuNDE0NiA1LjU4NTc5QzIwLjAzOTUgNS4yMTA3MSAxOS41MzA4IDUgMTkuMDAwNCA1SDE4LjMzMzciIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9nPgo8L3N2Zz4K"

/***/ }),
/* 1503 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzUiIGhlaWdodD0iMzUiIHZpZXdCb3g9IjAgMCAzNSAzNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTcuNSIgY3k9IjE3LjUiIHI9IjE3IiBmaWxsPSJibGFjayIgc3Ryb2tlPSIjMTgxMzBGIi8+CjxwYXRoIGQ9Ik0yNC43MDY4IDEwLjI5MjZDMjQuNDMzOCAxMC4wMjA2IDI0LjAyNjggOS45Mjc2NCAyMy42NjM4IDEwLjA1ODZMOS42NjM4MSAxNS4wNTg2QzkuMjg2ODEgMTUuMTkyNiA5LjAyNTgxIDE1LjUzOTYgOS4wMDE4MSAxNS45Mzg2QzguOTc3ODEgMTYuMzM4NiA5LjE5MzgxIDE2LjcxMzYgOS41NTI4MSAxNi44OTM2TDE0LjEzODggMTkuMTg1NkwxOS45OTk4IDE0Ljk5OTZMMTUuODEyOCAyMC44NjE2TDE4LjEwNDggMjUuNDQ3NkMxOC4yNzU4IDI1Ljc4NjYgMTguNjIyOCAyNS45OTk2IDE4Ljk5OTggMjUuOTk5NkMxOS4wMjA4IDI1Ljk5OTYgMTkuMDQwOCAyNS45OTg2IDE5LjA2MDggMjUuOTk3NkMxOS40NjA4IDI1Ljk3MzYgMTkuODA3OCAyNS43MTM2IDE5Ljk0MjggMjUuMzM1NkwyNC45NDI4IDExLjMzNTZDMjUuMDcxOCAxMC45NzI2IDI0Ljk3OTggMTAuNTY1NiAyNC43MDY4IDEwLjI5MjZaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K"

/***/ }),
/* 1504 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1505 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4IiBoZWlnaHQ9IjIiIHZpZXdCb3g9IjAgMCA4IDIiIGZpbGw9Im5vbmUiPgogIDxwYXRoIGQ9Ik0xIDJDMC40NDc3MTUgMiAwIDEuNTUyMjggMCAxQzAgMC40NDc3MTUgMC40NDc3MTUgMCAxIDBIN0M3LjU1MjI4IDAgOCAwLjQ0NzcxNSA4IDFDOCAxLjU1MjI4IDcuNTUyMjggMiA3IDJIMVoiIGZpbGw9IiMxNzE3MTciLz4KPC9zdmc+"

/***/ }),
/* 1506 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1507 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1508 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1509 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjMiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAyMyAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9Ikdyb3VwIj4KPHBhdGggaWQ9IlZlY3RvciIgZD0iTTE5LjQgMUgzLjRDMi4wNzQ1MiAxIDEgMi4wNzQ1MiAxIDMuNFYxNC42QzEgMTUuOTI1NSAyLjA3NDUyIDE3IDMuNCAxN0gxOS40QzIwLjcyNTUgMTcgMjEuOCAxNS45MjU1IDIxLjggMTQuNlYzLjRDMjEuOCAyLjA3NDUyIDIwLjcyNTUgMSAxOS40IDFaIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggaWQ9IlZlY3Rvcl8yIiBkPSJNOSA1LjgwMDAyTDE0LjYgOS4wMDAwMkw5IDEyLjJWNS44MDAwMloiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L2c+Cjwvc3ZnPgo="

/***/ }),
/* 1510 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/library_1.44dcfbc.png";

/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/library_2.9c3667e.jpg";

/***/ }),
/* 1512 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/library_4.81f4ac3.jpg";

/***/ }),
/* 1513 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/library_5.c6ce801.png";

/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/library_6.5246382.jpg";

/***/ }),
/* 1515 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/music.c4b05a4.svg";

/***/ }),
/* 1517 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1518 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/notification_1.bc9c6f1.png";

/***/ }),
/* 1519 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/player.33704b5.png";

/***/ }),
/* 1520 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1521 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/spotlight.5a2df18.gif";

/***/ }),
/* 1522 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/spotlight_1.77b8b6c.gif";

/***/ }),
/* 1523 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/spotlight_2.76765d7.gif";

/***/ }),
/* 1524 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/success.b31f18d.gif";

/***/ }),
/* 1525 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1526 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNiIgaGVpZ2h0PSI2IiB2aWV3Qm94PSIwIDAgNiA2IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfNTlfMTQ5NSkiPgo8cGF0aCBkPSJNMCAzQzAgMS4zNDMxNSAxLjM0MzE1IDAgMyAwQzQuNjU2ODUgMCA2IDEuMzQzMTUgNiAzQzYgNC42NTY4NSA0LjY1Njg1IDYgMyA2QzEuMzQzMTUgNiAwIDQuNjU2ODUgMCAzWiIgZmlsbD0iI0ZGMjQyNCIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzU5XzE0OTUiPgo8cGF0aCBkPSJNMCAzQzAgMS4zNDMxNSAxLjM0MzE1IDAgMyAwQzQuNjU2ODUgMCA2IDEuMzQzMTUgNiAzQzYgNC42NTY4NSA0LjY1Njg1IDYgMyA2QzEuMzQzMTUgNiAwIDQuNjU2ODUgMCAzWiIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K"

/***/ }),
/* 1527 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTEiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMSAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEuMDMxMDMgMC4wODkyOTc4QzAuOTI2NDM5IDAuMDMwNzQyMyAwLjgwNzc4NSAtNS43NTY1OGUtMDUgMC42ODcwMTQgOC4wNzcyZS0wOEMwLjU2NjI0MyA1Ljc3Mjc0ZS0wNSAwLjQ0NzYyIDAuMDMwOTcxMSAwLjM0MzA4OSAwLjA4OTYyNjRDMC4yMzg1NTggMC4xNDgyODIgMC4xNTE4MDkgMC4yMzI2MDkgMC4wOTE1Nzg3IDAuMzM0MTE2QzAuMDMxMzQ4MyAwLjQzNTYyMyAtMC4wMDAyMzcyNjggMC41NTA3MjcgMS4zNDE5NGUtMDYgMC42Njc4MzdWMTEuMzMyMkMtMC4wMDAyMzcyNjggMTEuNDQ5MyAwLjAzMTM0ODMgMTEuNTY0NCAwLjA5MTU3ODcgMTEuNjY1OUMwLjE1MTgwOSAxMS43Njc0IDAuMjM4NTU4IDExLjg1MTcgMC4zNDMwODkgMTEuOTEwNEMwLjQ0NzYyIDExLjk2OSAwLjU2NjI0MyAxMS45OTk5IDAuNjg3MDE0IDEyQzAuODA3Nzg1IDEyLjAwMDEgMC45MjY0MzkgMTEuOTY5MyAxLjAzMTAzIDExLjkxMDdMMTAuNjU0IDYuNTc4NTRDMTAuNzU5MSA2LjUyMDIyIDEwLjg0NjUgNi40MzYgMTAuOTA3MiA2LjMzNDRDMTAuOTY4IDYuMjMyODEgMTEgNi4xMTc0NSAxMSA2QzExIDUuODgyNTUgMTAuOTY4IDUuNzY3MTkgMTAuOTA3MiA1LjY2NTZDMTAuODQ2NSA1LjU2NCAxMC43NTkxIDUuNDc5NzggMTAuNjU0IDUuNDIxNDZMMS4wMzEwMyAwLjA4OTI5NzhaIiBmaWxsPSIjRjM1ODQzIi8+Cjwvc3ZnPgo="

/***/ }),
/* 1528 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTEiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxMSAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEuNSAxNEMwLjY3MTU3MiAxNCAwIDEzLjMwMzYgMCAxMi40NDQ0VjEuNTU1NTZDMCAwLjY5NjQ0NiAwLjY3MTU3MiAwIDEuNSAwQzIuMzI4NDMgMCAzIDAuNjk2NDQ2IDMgMS41NTU1NlYxMi40NDQ0QzMgMTMuMzAzNiAyLjMyODQzIDE0IDEuNSAxNFoiIGZpbGw9IiNGMzU4NDMiLz4KPHBhdGggZD0iTTkuNSAxNEM4LjY3MTU3IDE0IDggMTMuMzAzNiA4IDEyLjQ0NDRWMS41NTU1NkM4IDAuNjk2NDQ2IDguNjcxNTcgMCA5LjUgMEMxMC4zMjg0IDAgMTEgMC42OTY0NDYgMTEgMS41NTU1NlYxMi40NDQ0QzExIDEzLjMwMzYgMTAuMzI4NCAxNCA5LjUgMTRaIiBmaWxsPSIjRjM1ODQzIi8+Cjwvc3ZnPgo="

/***/ }),
/* 1529 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1530 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMyA2SDlDNi43OTA4NiA2IDUgNy43OTA4NiA1IDEwVjE4QzUgMjAuMjA5MSA2Ljc5MDg2IDIyIDkgMjJIMTAuNzVMMTIuNSAyMEg5QzcuODk1NDMgMjAgNyAxOS4xMDQ2IDcgMThWMTBDNyA4Ljg5NTQzIDcuODk1NDMgOCA5IDhIMjNDMjQuMTA0NiA4IDI1IDguODk1NDMgMjUgMTBWMThDMjUgMTkuMTA0NiAyNC4xMDQ2IDIwIDIzIDIwSDE5LjVMMjEuMjUgMjJIMjNDMjUuMjA5MSAyMiAyNyAyMC4yMDkxIDI3IDE4VjEwQzI3IDcuNzkwODYgMjUuMjA5MSA2IDIzIDZaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNMTUuMjQ3NCAxOC44NjAxQzE1LjY0NTggMTguNDA0OCAxNi4zNTQyIDE4LjQwNDggMTYuNzUyNiAxOC44NjAxTDIxLjU0ODggMjQuMzQxNUMyMi4xMTQ2IDI0Ljk4ODEgMjEuNjU1NCAyNiAyMC43OTYyIDI2SDExLjIwMzhDMTAuMzQ0NiAyNiA5Ljg4NTQzIDI0Ljk4ODEgMTAuNDUxMiAyNC4zNDE1TDE1LjI0NzQgMTguODYwMVoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo="

/***/ }),
/* 1531 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAGKSURBVHgBnVTbcYMwEJTABdBB6CBOBYYKklQQqCAM8O/88whUEFxB7AqCKwgdhBJoAMgekRkegni8MxpO0rFa9k5wJoHjOIaiKC+ccwNTndYQF23bFghPURQdp+/wCYGuquoHQoOto6zr2kySpJwRgWQLki+EGrsOFVSbQRAUPZFQ8j0hqfA5KX0OnhWeFsYOsT7MgbIHUrahmURJgYTnoXQglxyoCStM7nneE4LPiewMhtrYeyXBtAA1aRzHie/7b4j3w2TyixQ9sjkskBhMVKzzgHMiTUTlRqAKK0jYMjn04QQEB/GcFYPaZIONJSJChWFDeg6/Knik4aW97FCFrUMTzae5rusIo3VZIhGVa0zw6g4eWFDyvkQCFGT2eSWBUIKE/YOCzM6WduHfGcNumiZl6zgpYRjmCPKFhB/0TgZvjiuHleRjZzaqYrO/Co1A1wEmWwh3CzwV1Jpd7mXllksr/gBdg/blpwW6gCT1CpJcXNa+y6XlEPePxj3GpWFLHJKjFQ7C1xF+AX6ovrFOf0i5AAAAAElFTkSuQmCC"

/***/ }),
/* 1532 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkuMSAyMC41MkwxNS42NiAxMy45NkwyMi4xOCAyMC41MkwyMy4yNiAxOS40NEwxNi43IDEyLjg0TDIzLjI2IDYuMjRMMjIuMTggNS4xNkwxNS42NiAxMS43Nkw5LjEgNS4xNkw4LjAyIDYuMjRMMTQuNTggMTIuODRMOC4wMiAxOS40NEw5LjEgMjAuNTJaIiBmaWxsPSJ3aGl0ZSIvPgo8ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfMTI4MF8yMDI4KSI+CjxwYXRoIGQ9Ik0xNiAwQzEyLjgzNTUgMCA5Ljc0MjA3IDAuOTM4Mzg0IDcuMTEwODggMi42OTY0OUM0LjQ3OTcgNC40NTQ1OSAyLjQyODk0IDYuOTUzNDUgMS4yMTc5MyA5Ljg3NzA2QzAuMDA2OTMyNSAxMi44MDA3IC0wLjMwOTkyMSAxNi4wMTc3IDAuMzA3NDQzIDE5LjEyMTRDMC45MjQ4MDYgMjIuMjI1MSAyLjQ0ODY2IDI1LjA3NjEgNC42ODYzIDI3LjMxMzdDNi45MjM5NCAyOS41NTEzIDkuNzc0ODcgMzEuMDc1MiAxMi44Nzg2IDMxLjY5MjZDMTUuOTgyMyAzMi4zMDk5IDE5LjE5OTMgMzEuOTkzMSAyMi4xMjI5IDMwLjc4MjFDMjUuMDQ2NiAyOS41NzExIDI3LjU0NTQgMjcuNTIwMyAyOS4zMDM1IDI0Ljg4OTFDMzEuMDYxNiAyMi4yNTc5IDMyIDE5LjE2NDUgMzIgMTZDMzEuOTg3NiAxMS43NjAzIDMwLjI5NzkgNy42OTc4OSAyNy4zIDQuNjk5OTlDMjQuMzAyMSAxLjcwMjA5IDIwLjIzOTcgMC4wMTIzOTk0IDE2IDBWMFpNMjQuMTIxIDIyTDIyIDI0LjEyMUwxNiAxOC4xMjFMMTAgMjQuMTIxTDcuODc5MDEgMjJMMTMuODc5IDE2TDcuODc5MDEgMTBMMTAgNy44NzlMMTYgMTMuODc5TDIyIDcuODc5TDI0LjEyMSAxMEwxOC4xMjEgMTZMMjQuMTIxIDIyWiIgZmlsbD0iYmxhY2siLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF8xMjgwXzIwMjgiPgo8cmVjdCB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIGZpbGw9IndoaXRlIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg=="

/***/ }),
/* 1533 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1534 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1535 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/streams.8126691.svg";

/***/ }),
/* 1536 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tile-2.d11bb9e.jpeg";

/***/ }),
/* 1537 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tile-3.ffd0c85.jpeg";

/***/ }),
/* 1538 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tile-4.3d67b1d.jpeg";

/***/ }),
/* 1539 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tile-5.33b2a31.jpeg";

/***/ }),
/* 1540 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tile-6.dc93bec.jpeg";

/***/ }),
/* 1541 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tile-7.1e3f335.jpeg";

/***/ }),
/* 1542 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tile-8.caa37be.jpeg";

/***/ }),
/* 1543 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tile-9.a2833d3.jpg";

/***/ }),
/* 1544 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tile1-min.7ff06ac.png";

/***/ }),
/* 1545 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgOCA4IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfMTE4NV8yMDQwKSI+CjxwYXRoIGQ9Ik0xLjMzMzM3IDAuMzMzMjI0TDEuMzMzMzcgNy42NjY1NkMxLjMzMzQgNy43MjcyNyAxLjM1IDcuNzg2ODEgMS4zODEzOSA3LjgzODc4QzEuNDEyNzggNy44OTA3NCAxLjQ1Nzc3IDcuOTMzMTQgMS41MTE0OSA3Ljk2MTQxQzEuNTY1MjEgNy45ODk2OCAxLjYyNTY0IDguMDAyNzQgMS42ODYyNCA3Ljk5OTE4QzEuNzQ2ODUgNy45OTU2MyAxLjgwNTMzIDcuOTc1NTggMS44NTUzNyA3Ljk0MTIyTDcuMTg4NzEgNC4yNzQ1NkM3LjIzMzI2IDQuMjQzOTIgNy4yNjk2OSA0LjIwMjkxIDcuMjk0ODYgNC4xNTUwNkM3LjMyMDAzIDQuMTA3MjEgNy4zMzMxOCA0LjA1Mzk2IDcuMzMzMTggMy45OTk4OUM3LjMzMzE4IDMuOTQ1ODIgNy4zMjAwMyAzLjg5MjU3IDcuMjk0ODYgMy44NDQ3MkM3LjI2OTY5IDMuNzk2ODcgNy4yMzMyNiAzLjc1NTg2IDcuMTg4NzEgMy43MjUyMkwxLjg1NTM3IDAuMDU4NTU4QzEuODA1MzMgMC4wMjQxOTc0IDEuNzQ2ODQgMC4wMDQxNTYzOSAxLjY4NjI0IDAuMDAwNTk4NzMzQzEuNjI1NjQgLTAuMDAyOTU4OTIgMS41NjUyMSAwLjAxMDEwMTggMS41MTE0OSAwLjAzODM3MDZDMS40NTc3NiAwLjA2NjYzOTQgMS40MTI3OCAwLjEwOTA0MyAxLjM4MTM5IDAuMTYxMDA1QzEuMzUgMC4yMTI5NjggMS4zMzM0IDAuMjcyNTE3IDEuMzMzMzcgMC4zMzMyMjRWMC4zMzMyMjRaIiBmaWxsPSJibGFjayIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzExODVfMjA0MCI+CjxyZWN0IHdpZHRoPSI4IiBoZWlnaHQ9IjgiIGZpbGw9IndoaXRlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDgpIHJvdGF0ZSgtOTApIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg=="

/***/ }),
/* 1546 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/turntable.ad845ff.gif";

/***/ }),
/* 1547 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTMiIHZpZXdCb3g9IjAgMCAxNiAxMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2IDEuNUMxNS40IDEuOCAxNC44IDEuOSAxNC4xIDJDMTQuOCAxLjYgMTUuMyAxIDE1LjUgMC4yQzE0LjkgMC42IDE0LjIgMC44IDEzLjQgMUMxMi44IDAuNCAxMS45IDAgMTEgMEM5LjMgMCA3LjggMS41IDcuOCAzLjNDNy44IDMuNiA3LjggMy44IDcuOSA0QzUuMiAzLjkgMi43IDIuNiAxLjEgMC42QzAuOCAxLjEgMC43IDEuNiAwLjcgMi4zQzAuNyAzLjQgMS4zIDQuNCAyLjIgNUMxLjcgNSAxLjIgNC44IDAuNyA0LjZDMC43IDYuMiAxLjggNy41IDMuMyA3LjhDMyA3LjkgMi43IDcuOSAyLjQgNy45QzIuMiA3LjkgMiA3LjkgMS44IDcuOEMyLjIgOS4xIDMuNCAxMC4xIDQuOSAxMC4xQzMuOCAxMSAyLjQgMTEuNSAwLjggMTEuNUMwLjUgMTEuNSAwLjMgMTEuNSAwIDExLjVDMS41IDEyLjQgMy4yIDEzIDUgMTNDMTEgMTMgMTQuMyA4IDE0LjMgMy43QzE0LjMgMy42IDE0LjMgMy40IDE0LjMgMy4zQzE1IDIuOCAxNS42IDIuMiAxNiAxLjVaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K"

/***/ }),
/* 1548 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2NCA2NCIgd2lkdGg9IjY0IiBoZWlnaHQ9IjY0Ij48dGl0bGU+YW50ZW5uYTwvdGl0bGU+PGcgY2xhc3M9Im5jLWljb24td3JhcHBlciIgZmlsbD0iIzAwMDAwMCI+PHBhdGggZD0iTTQ1LjQzNSwzOC40MzVhMSwxLDAsMCwxLS43MDctMS43MDcsMTgsMTgsMCwwLDAsMC0yNS40NTcsMSwxLDAsMCwxLDEuNDE0LTEuNDE0LDIwLDIwLDAsMCwxLDAsMjguMjg1QTEsMSwwLDAsMSw0NS40MzUsMzguNDM1WiIgZGF0YS1jb2xvcj0iY29sb3ItMiIvPjxwYXRoIGQ9Ik0xOC41NjUsMzguNDM1YTEsMSwwLDAsMS0uNzA3LS4yOTMsMjAsMjAsMCwwLDEsMC0yOC4yODUsMSwxLDAsMCwxLDEuNDE0LDEuNDE0LDE4LDE4LDAsMCwwLDAsMjUuNDU3LDEsMSwwLDAsMS0uNzA3LDEuNzA3WiIgZGF0YS1jb2xvcj0iY29sb3ItMiIvPjxwYXRoIGQ9Ik00Miw1OUgzM1YyOS45MWE2LDYsMCwxLDAtMiwwVjU5SDIyYTEsMSwwLDAsMCwwLDJINDJhMSwxLDAsMCwwLDAtMloiIGZpbGw9IiMwMDAwMDAiLz48cGF0aCBkPSJNNTAuMzg1LDQzLjM4NWExLDEsMCwwLDEtLjcwNy0xLjcwNywyNSwyNSwwLDAsMCwwLTM1LjM1NiwxLDEsMCwwLDEsMS40MTQtMS40MTQsMjcsMjcsMCwwLDEsMCwzOC4xODRBMSwxLDAsMCwxLDUwLjM4NSw0My4zODVaIiBkYXRhLWNvbG9yPSJjb2xvci0yIi8+PHBhdGggZD0iTTEzLjYxNSw0My4zODVhMSwxLDAsMCwxLS43MDctLjI5MywyNywyNywwLDAsMSwwLTM4LjE4NCwxLDEsMCwwLDEsMS40MTQsMS40MTQsMjUsMjUsMCwwLDAsMCwzNS4zNTYsMSwxLDAsMCwxLS43MDcsMS43MDdaIiBkYXRhLWNvbG9yPSJjb2xvci0yIi8+PHBhdGggZD0iTTIzLjUxNSwzMy40ODVhLjk5My45OTMsMCwwLDEtLjcwNy0uMjkzLDEzLDEzLDAsMCwxLDAtMTguMzg0LDEsMSwwLDAsMSwxLjQxNCwxLjQxNCwxMSwxMSwwLDAsMCwwLDE1LjU1NiwxLDEsMCwwLDEtLjcwNywxLjcwN1oiIGRhdGEtY29sb3I9ImNvbG9yLTIiLz48cGF0aCBkPSJNNDAuNDg1LDMzLjQ4NWExLDEsMCwwLDEtLjcwNy0xLjcwNywxMSwxMSwwLDAsMCwwLTE1LjU1NiwxLDEsMCwwLDEsMS40MTQtMS40MTQsMTMsMTMsMCwwLDEsMCwxOC4zODRBLjk5My45OTMsMCwwLDEsNDAuNDg1LDMzLjQ4NVoiIGRhdGEtY29sb3I9ImNvbG9yLTIiLz48L2c+PC9zdmc+"

/***/ }),
/* 1549 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1550 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1551 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/upload.211785a.svg";

/***/ }),
/* 1552 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/vector..61baf32.gif";

/***/ }),
/* 1553 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/videos.1944666.svg";

/***/ }),
/* 1554 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1555 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqCAYAAADFw8lbAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAGHSURBVHgB7ZiBTcMwEEV/EAPQDcIEsAFhArpBsgGwCUzQskE3aNmgGzhMQDYwZzWIJKpTX/pNCs2TTnLTk/11uTvbAZRYa9f2eIzYFWIhk2eWR6ZZ+wI6bsFDNZdW6B143GictUJT8Mg0zkmoY538n+AyS5KkCnHURHQOPrw560o3Nh5G2wF8In+LrE9LckCowU8BvYotxYJyKoBUrBDL69+l5Os1tHSiuUAkZO6XkKj2FVPaGL8hHivPmi1Cq95gZLQNvxd5dXO7q2JnzO0Wl+DiNoW0MaZBjWhMJqEDWXz3qe4ffyai7GJq4jpAuud5JTvQCkpiCn30PC/RbvJBnO2r34jdH/AZdKihCpXcK7F7tXRi5ugQKngifmo5+uzOpPvOpdPOxGYSyiZU6Awj0ye0bIxzxCP3rNlCc11egn/JexB7qsfDrssOe0IfIELFGhsPc7TIjuDC8ilC1/9/nx3rCUvw2IaKdGgb/jt4fGictUK34LHROI8plDlXG1dQltOq1lDyBdgjS+NCkRs+AAAAAElFTkSuQmCC"

/***/ }),
/* 1556 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/world.8ec705e.png";

/***/ }),
/* 1557 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iMTMiIHZpZXdCb3g9IjAgMCAxMyAxMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0wLjI0MjM5NiAyLjM2OTA3QzAuNDI5NzQgMS4yODE0NCAxLjI5NDI1IDAuNDgxOTI1IDIuMzg1MzQgMC4zMTU5MDhDMy40MzA3OSAwLjE1NjgzOCA0Ljg2NDk3IDAgNi40NTYgMEM4LjA0NzAyIDAgOS40ODEyMSAwLjE1NjgzOCAxMC41MjY3IDAuMzE1OTA4QzExLjYxNzcgMC40ODE5MjUgMTIuNDgyMyAxLjI4MTQzIDEyLjY2OTYgMi4zNjkwN0MxMi44MDAyIDMuMTI3MSAxMi45MTIgNC4wOTAwNCAxMi45MTIgNS4xNjQ4QzEyLjkxMiA2LjIzOTU2IDEyLjgwMDIgNy4yMDI0OSAxMi42Njk2IDcuOTYwNTJDMTIuNDgyMyA5LjA0ODE2IDExLjYxNzcgOS44NDc2NyAxMC41MjY3IDEwLjAxMzdDOS41NzAyNCAxMC4xNTkyIDguMjg4NDcgMTAuMzAyOSA2Ljg1ODkgMTAuMzI2M0wyLjkxMDgzIDEyLjY1OTJDMi40ODA0NyAxMi45MTM1IDEuOTM2OCAxMi42MDMzIDEuOTM2OCAxMi4xMDM0VjkuOTA2MDVDMS4wNjMwMiA5LjYxNTUgMC40MDMyMTUgOC44OTQxNyAwLjI0MjM5NiA3Ljk2MDUyQzAuMTExODI1IDcuMjAyNDkgMCA2LjIzOTU2IDAgNS4xNjQ4QzAgNC4wOTAwNCAwLjExMTgyNSAzLjEyNzEgMC4yNDIzOTYgMi4zNjkwN1pNMi41ODI0IDMuODczNkMyLjU4MjQgMy41MTcwNCAyLjg3MTQ0IDMuMjI4IDMuMjI4IDMuMjI4SDkuNjg0QzEwLjA0MDYgMy4yMjggMTAuMzI5NiAzLjUxNzA0IDEwLjMyOTYgMy44NzM2QzEwLjMyOTYgNC4yMzAxNSAxMC4wNDA2IDQuNTE5MiA5LjY4NCA0LjUxOTJIMy4yMjhDMi44NzE0NCA0LjUxOTIgMi41ODI0IDQuMjMwMTUgMi41ODI0IDMuODczNlpNMi41ODI0IDYuNDU2QzIuNTgyNCA2LjA5OTQ0IDIuODcxNDQgNS44MTA0IDMuMjI4IDUuODEwNEg1LjgxMDRDNi4xNjY5NSA1LjgxMDQgNi40NTYgNi4wOTk0NCA2LjQ1NiA2LjQ1NkM2LjQ1NiA2LjgxMjU1IDYuMTY2OTUgNy4xMDE2IDUuODEwNCA3LjEwMTZIMy4yMjhDMi44NzE0NCA3LjEwMTYgMi41ODI0IDYuODEyNTUgMi41ODI0IDYuNDU2WiIgZmlsbD0iIzU2NTQ1MiIvPgo8L3N2Zz4K"

/***/ }),
/* 1558 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAAKT2lDQ1BQaG90b3Nob3AgSUNDIHByb2ZpbGUAAHjanVNnVFPpFj333vRCS4iAlEtvUhUIIFJCi4AUkSYqIQkQSoghodkVUcERRUUEG8igiAOOjoCMFVEsDIoK2AfkIaKOg6OIisr74Xuja9a89+bN/rXXPues852zzwfACAyWSDNRNYAMqUIeEeCDx8TG4eQuQIEKJHAAEAizZCFz/SMBAPh+PDwrIsAHvgABeNMLCADATZvAMByH/w/qQplcAYCEAcB0kThLCIAUAEB6jkKmAEBGAYCdmCZTAKAEAGDLY2LjAFAtAGAnf+bTAICd+Jl7AQBblCEVAaCRACATZYhEAGg7AKzPVopFAFgwABRmS8Q5ANgtADBJV2ZIALC3AMDOEAuyAAgMADBRiIUpAAR7AGDIIyN4AISZABRG8lc88SuuEOcqAAB4mbI8uSQ5RYFbCC1xB1dXLh4ozkkXKxQ2YQJhmkAuwnmZGTKBNA/g88wAAKCRFRHgg/P9eM4Ors7ONo62Dl8t6r8G/yJiYuP+5c+rcEAAAOF0ftH+LC+zGoA7BoBt/qIl7gRoXgugdfeLZrIPQLUAoOnaV/Nw+H48PEWhkLnZ2eXk5NhKxEJbYcpXff5nwl/AV/1s+X48/Pf14L7iJIEyXYFHBPjgwsz0TKUcz5IJhGLc5o9H/LcL//wd0yLESWK5WCoU41EScY5EmozzMqUiiUKSKcUl0v9k4t8s+wM+3zUAsGo+AXuRLahdYwP2SycQWHTA4vcAAPK7b8HUKAgDgGiD4c93/+8//UegJQCAZkmScQAAXkQkLlTKsz/HCAAARKCBKrBBG/TBGCzABhzBBdzBC/xgNoRCJMTCQhBCCmSAHHJgKayCQiiGzbAdKmAv1EAdNMBRaIaTcA4uwlW4Dj1wD/phCJ7BKLyBCQRByAgTYSHaiAFiilgjjggXmYX4IcFIBBKLJCDJiBRRIkuRNUgxUopUIFVIHfI9cgI5h1xGupE7yAAygvyGvEcxlIGyUT3UDLVDuag3GoRGogvQZHQxmo8WoJvQcrQaPYw2oefQq2gP2o8+Q8cwwOgYBzPEbDAuxsNCsTgsCZNjy7EirAyrxhqwVqwDu4n1Y8+xdwQSgUXACTYEd0IgYR5BSFhMWE7YSKggHCQ0EdoJNwkDhFHCJyKTqEu0JroR+cQYYjIxh1hILCPWEo8TLxB7iEPENyQSiUMyJ7mQAkmxpFTSEtJG0m5SI+ksqZs0SBojk8naZGuyBzmULCAryIXkneTD5DPkG+Qh8lsKnWJAcaT4U+IoUspqShnlEOU05QZlmDJBVaOaUt2ooVQRNY9aQq2htlKvUYeoEzR1mjnNgxZJS6WtopXTGmgXaPdpr+h0uhHdlR5Ol9BX0svpR+iX6AP0dwwNhhWDx4hnKBmbGAcYZxl3GK+YTKYZ04sZx1QwNzHrmOeZD5lvVVgqtip8FZHKCpVKlSaVGyovVKmqpqreqgtV81XLVI+pXlN9rkZVM1PjqQnUlqtVqp1Q61MbU2epO6iHqmeob1Q/pH5Z/YkGWcNMw09DpFGgsV/jvMYgC2MZs3gsIWsNq4Z1gTXEJrHN2Xx2KruY/R27iz2qqaE5QzNKM1ezUvOUZj8H45hx+Jx0TgnnKKeX836K3hTvKeIpG6Y0TLkxZVxrqpaXllirSKtRq0frvTau7aedpr1Fu1n7gQ5Bx0onXCdHZ4/OBZ3nU9lT3acKpxZNPTr1ri6qa6UbobtEd79up+6Ynr5egJ5Mb6feeb3n+hx9L/1U/W36p/VHDFgGswwkBtsMzhg8xTVxbzwdL8fb8VFDXcNAQ6VhlWGX4YSRudE8o9VGjUYPjGnGXOMk423GbcajJgYmISZLTepN7ppSTbmmKaY7TDtMx83MzaLN1pk1mz0x1zLnm+eb15vft2BaeFostqi2uGVJsuRaplnutrxuhVo5WaVYVVpds0atna0l1rutu6cRp7lOk06rntZnw7Dxtsm2qbcZsOXYBtuutm22fWFnYhdnt8Wuw+6TvZN9un2N/T0HDYfZDqsdWh1+c7RyFDpWOt6azpzuP33F9JbpL2dYzxDP2DPjthPLKcRpnVOb00dnF2e5c4PziIuJS4LLLpc+Lpsbxt3IveRKdPVxXeF60vWdm7Obwu2o26/uNu5p7ofcn8w0nymeWTNz0MPIQ+BR5dE/C5+VMGvfrH5PQ0+BZ7XnIy9jL5FXrdewt6V3qvdh7xc+9j5yn+M+4zw33jLeWV/MN8C3yLfLT8Nvnl+F30N/I/9k/3r/0QCngCUBZwOJgUGBWwL7+Hp8Ib+OPzrbZfay2e1BjKC5QRVBj4KtguXBrSFoyOyQrSH355jOkc5pDoVQfujW0Adh5mGLw34MJ4WHhVeGP45wiFga0TGXNXfR3ENz30T6RJZE3ptnMU85ry1KNSo+qi5qPNo3ujS6P8YuZlnM1VidWElsSxw5LiquNm5svt/87fOH4p3iC+N7F5gvyF1weaHOwvSFpxapLhIsOpZATIhOOJTwQRAqqBaMJfITdyWOCnnCHcJnIi/RNtGI2ENcKh5O8kgqTXqS7JG8NXkkxTOlLOW5hCepkLxMDUzdmzqeFpp2IG0yPTq9MYOSkZBxQqohTZO2Z+pn5mZ2y6xlhbL+xW6Lty8elQfJa7OQrAVZLQq2QqboVFoo1yoHsmdlV2a/zYnKOZarnivN7cyzytuQN5zvn//tEsIS4ZK2pYZLVy0dWOa9rGo5sjxxedsK4xUFK4ZWBqw8uIq2Km3VT6vtV5eufr0mek1rgV7ByoLBtQFr6wtVCuWFfevc1+1dT1gvWd+1YfqGnRs+FYmKrhTbF5cVf9go3HjlG4dvyr+Z3JS0qavEuWTPZtJm6ebeLZ5bDpaql+aXDm4N2dq0Dd9WtO319kXbL5fNKNu7g7ZDuaO/PLi8ZafJzs07P1SkVPRU+lQ27tLdtWHX+G7R7ht7vPY07NXbW7z3/T7JvttVAVVN1WbVZftJ+7P3P66Jqun4lvttXa1ObXHtxwPSA/0HIw6217nU1R3SPVRSj9Yr60cOxx++/p3vdy0NNg1VjZzG4iNwRHnk6fcJ3/ceDTradox7rOEH0x92HWcdL2pCmvKaRptTmvtbYlu6T8w+0dbq3nr8R9sfD5w0PFl5SvNUyWna6YLTk2fyz4ydlZ19fi753GDborZ752PO32oPb++6EHTh0kX/i+c7vDvOXPK4dPKy2+UTV7hXmq86X23qdOo8/pPTT8e7nLuarrlca7nuer21e2b36RueN87d9L158Rb/1tWeOT3dvfN6b/fF9/XfFt1+cif9zsu72Xcn7q28T7xf9EDtQdlD3YfVP1v+3Njv3H9qwHeg89HcR/cGhYPP/pH1jw9DBY+Zj8uGDYbrnjg+OTniP3L96fynQ89kzyaeF/6i/suuFxYvfvjV69fO0ZjRoZfyl5O/bXyl/erA6xmv28bCxh6+yXgzMV70VvvtwXfcdx3vo98PT+R8IH8o/2j5sfVT0Kf7kxmTk/8EA5jz/GMzLdsAAAAgY0hSTQAAeiUAAICDAAD5/wAAgOkAAHUwAADqYAAAOpgAABdvkl/FRgAAAj1JREFUeNrcmrty00AUhr8VcWigIyUhM3mFeIaJ0zIpeQSl4TXySqkp6Gw18BCgdJgK0sQyOhReZ0QixdqLdlf+Z1yudD6fPZfVWSUieNIZ8NVwzRT45uPlmeP6HPgB1BYQ6DW1fkbuZImI2PxyEVmJf630s41tUoZb6xz4DLxiWN0Bl0DRd4EJyByYEVYL4MInyBJ4Qxz9Ao5cg/0YqCJCoN9daVusPHIMfAcUaUiAE6A0BamAA9LSGpiYbK1lghBom5Z9QeaRY6JPzMx3gZxHSLE2mmlbO2PkT4Bi57Novm7zSD4iCLSteZtHVl0ZIWFVwGHTI/kIIdA2502PlMBbxqkSeLcFqSNXcNWo3jYVP8v0yS4FCCztUMCZEo9nXUcIp7YoSwjip2vvkgLEb10X1JhAHhtbO8RHNBDVknG8KEvAE0mAqMZPYkH49kjWAdO2nZTv2uUKUlP9LZ6BGSwm/G+tyYv3HTDBIHxtracwq/WXkBA+Y+R/mMODDwByX92EgNiCTIeAkfvqRr2cfAyU2qdDtPGi/6BQR4OHNh7g1nPhk4BHg9tmjFwzXl3v5ccHgE8j9MaDzXv5gQ42466x6PK5gliwGXelrgWP5otd85GYo7Zdah3F7f2gB+A0VJ9kUMFPbZrGks3Mbp2IJ07omB/u2lqpxIyX8fRWR5Gy2aIPhOl55ILNyOsuULGb0fPWg83BqtDV9EpntSF6pyv9jsIsFdjdDmreEipFpHa4EVTrZ+Qutqh9uXj2bwDUwAMVLslYsAAAAABJRU5ErkJggg=="

/***/ }),
/* 1559 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzUiIGhlaWdodD0iMzUiIHZpZXdCb3g9IjAgMCAzNSAzNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTcuNSIgY3k9IjE3LjUiIHI9IjE3IiBmaWxsPSJ3aGl0ZSIgc3Ryb2tlPSIjQkRCREJEIi8+CjxwYXRoIGQ9Ik0yNC43MDY4IDEwLjI5MjZDMjQuNDMzOCAxMC4wMjA2IDI0LjAyNjggOS45Mjc2NCAyMy42NjM4IDEwLjA1ODZMOS42NjM4MSAxNS4wNTg2QzkuMjg2ODEgMTUuMTkyNiA5LjAyNTgxIDE1LjUzOTYgOS4wMDE4MSAxNS45Mzg2QzguOTc3ODEgMTYuMzM4NiA5LjE5MzgxIDE2LjcxMzYgOS41NTI4MSAxNi44OTM2TDE0LjEzODggMTkuMTg1NkwxOS45OTk4IDE0Ljk5OTZMMTUuODEyOCAyMC44NjE2TDE4LjEwNDggMjUuNDQ3NkMxOC4yNzU4IDI1Ljc4NjYgMTguNjIyOCAyNS45OTk2IDE4Ljk5OTggMjUuOTk5NkMxOS4wMjA4IDI1Ljk5OTYgMTkuMDQwOCAyNS45OTg2IDE5LjA2MDggMjUuOTk3NkMxOS40NjA4IDI1Ljk3MzYgMTkuODA3OCAyNS43MTM2IDE5Ljk0MjggMjUuMzM1NkwyNC45NDI4IDExLjMzNTZDMjUuMDcxOCAxMC45NzI2IDI0Ljk3OTggMTAuNTY1NiAyNC43MDY4IDEwLjI5MjZaIiBmaWxsPSJibGFjayIgZmlsbC1vcGFjaXR5PSIwLjQiLz4KPC9zdmc+Cg=="

/***/ }),
/* 1560 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzUiIGhlaWdodD0iMzUiIHZpZXdCb3g9IjAgMCAzNSAzNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTcuNSIgY3k9IjE3LjUiIHI9IjE3IiBmaWxsPSJibGFjayIgc3Ryb2tlPSIjMTgxMzBGIi8+CjxwYXRoIGQ9Ik0yNC43MDY4IDExLjI5NTNDMjQuNDMzOCAxMS4wMDY1IDI0LjAyNjggMTAuOTA3OCAyMy42NjM4IDExLjA0NjlMOS42NjM4MSAxNi4zNTQ2QzkuMjg2ODEgMTYuNDk2OCA5LjAyNTgxIDE2Ljg2NTIgOS4wMDE4MSAxNy4yODg3QzguOTc3ODEgMTcuNzEzMyA5LjE5MzgxIDE4LjExMTQgOS41NTI4MSAxOC4zMDI1TDE0LjEzODggMjAuNzM1NUwxOS45OTk4IDE2LjI5MTlMMTUuODEyOCAyMi41MTQ3TDE4LjEwNDggMjcuMzgyOUMxOC4yNzU4IDI3Ljc0MjcgMTguNjIyOCAyNy45Njg4IDE4Ljk5OTggMjcuOTY4OEMxOS4wMjA4IDI3Ljk2ODggMTkuMDQwOCAyNy45Njc4IDE5LjA2MDggMjcuOTY2N0MxOS40NjA4IDI3Ljk0MTIgMTkuODA3OCAyNy42NjUyIDE5Ljk0MjggMjcuMjY0TDI0Ljk0MjggMTIuNDAyNEMyNS4wNzE4IDEyLjAxNzEgMjQuOTc5OCAxMS41ODUxIDI0LjcwNjggMTEuMjk1M1oiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo="

/***/ }),
/* 1561 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0Ij48dGl0bGU+bG9nIG91dDwvdGl0bGU+PGcgY2xhc3M9Im5jLWljb24td3JhcHBlciIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjIiIGZpbGw9IiMwMDAwMDAiIHN0cm9rZT0iIzAwMDAwMCI+PGxpbmUgZGF0YS1jYXA9ImJ1dHQiIGRhdGEtY29sb3I9ImNvbG9yLTIiIGZpbGw9Im5vbmUiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgeDE9IjE3IiB5MT0iMTIiIHgyPSIyIiB5Mj0iMTIiLz4gPHBvbHlsaW5lIGRhdGEtY29sb3I9ImNvbG9yLTIiIGZpbGw9Im5vbmUiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgcG9pbnRzPSIgNywxNyAyLDEyIDcsNyAiLz4gPHBvbHlsaW5lIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzAwMDAwMCIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBwb2ludHM9IjEwLDEgMjIsMSAyMiwyMyAxMCwyMyAiLz48L2c+PC9zdmc+"

/***/ }),
/* 1562 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/music-wave.82a5114.gif";

/***/ }),
/* 1563 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/nav_logo_white.f790ddf.png";

/***/ }),
/* 1564 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguOTkxMDEgMC42NjY1MDRDNC4zOTEwMSAwLjY2NjUwNCAwLjY2NjAxNiA0LjM5OTg0IDAuNjY2MDE2IDguOTk5ODRDMC42NjYwMTYgMTMuNTk5OCA0LjM5MTAxIDE3LjMzMzIgOC45OTEwMSAxNy4zMzMyQzEzLjU5OTMgMTcuMzMzMiAxNy4zMzI3IDEzLjU5OTggMTcuMzMyNyA4Ljk5OTg0QzE3LjMzMjcgNC4zOTk4NCAxMy41OTkzIDAuNjY2NTA0IDguOTkxMDEgMC42NjY1MDRaTTEyLjUyNDMgMTMuOTk5OEw4Ljk5OTM1IDExLjg3NDhMNS40NzQzNSAxMy45OTk4TDYuNDA3NjggOS45OTE1TDMuMjk5MzUgNy4yOTk4NEw3LjM5OTM1IDYuOTQ5ODRMOC45OTkzNSAzLjE2NjVMMTAuNTk5MyA2Ljk0MTVMMTQuNjk5MyA3LjI5MTVMMTEuNTkxIDkuOTgzMTdMMTIuNTI0MyAxMy45OTk4WiIgZmlsbD0iI0ZGRTYwMCIvPgo8L3N2Zz4K"

/***/ }),
/* 1565 */,
/* 1566 */,
/* 1567 */,
/* 1568 */,
/* 1569 */,
/* 1570 */,
/* 1571 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1281)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(864),
  /* template */
  __webpack_require__(1722),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5199f490",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1572 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(872),
  /* template */
  __webpack_require__(1707),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1573 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1239)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(875),
  /* template */
  __webpack_require__(1665),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2ca62905",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1574 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1306)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(878),
  /* template */
  __webpack_require__(1757),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-686aad07",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1575 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1294)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(883),
  /* template */
  __webpack_require__(1743),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-60b24daa",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1576 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(893),
  /* template */
  __webpack_require__(1808),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1577 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1039),
  /* template */
  __webpack_require__(1855),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1578 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1197)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(897),
  /* template */
  __webpack_require__(1606),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0c0c89a5",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1579 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1254)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(898),
  /* template */
  __webpack_require__(1686),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3bd0cd06",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1580 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1363)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(899),
  /* template */
  __webpack_require__(1835),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-abbaea20",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1581 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1192)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(900),
  /* template */
  __webpack_require__(1599),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-05432b6d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1582 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1366)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(901),
  /* template */
  __webpack_require__(1838),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b2643954",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1583 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1251)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(902),
  /* template */
  __webpack_require__(1682),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-37754709",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1584 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1340)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1040),
  /* template */
  __webpack_require__(1804),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-831c3aae",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1585 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(908),
  /* template */
  __webpack_require__(1704),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1586 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1249)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(910),
  /* template */
  __webpack_require__(1680),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-36d219e2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1587 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1343)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(911),
  /* template */
  __webpack_require__(1809),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8a9d2c44",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1588 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1393)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(912),
  /* template */
  __webpack_require__(1870),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f3b2682c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1589 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1286)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(914),
  /* template */
  __webpack_require__(1734),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5a716274",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1590 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1224)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(915),
  /* template */
  __webpack_require__(1641),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1eb3d1f5",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1591 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1041),
  /* template */
  __webpack_require__(1852),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1592 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1344)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(929),
  /* template */
  __webpack_require__(1811),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-9139795a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1593 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1202)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(930),
  /* template */
  __webpack_require__(1615),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1594 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1324)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1042),
  /* template */
  __webpack_require__(1781),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-74e901d0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1595 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(932),
  /* template */
  __webpack_require__(1828),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1596 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1043),
  /* template */
  __webpack_require__(1705),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1597 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1386)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(942),
  /* template */
  __webpack_require__(1860),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-eac36f80",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1598 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page no-top-nav no-side-space subscribe-landing"
  }, [_c('div', {
    staticClass: "banner"
  }, [_c('v-container', {
    staticClass: "banner-container"
  }, [_c('div', {
    staticClass: "banner-content"
  }, [_c('h1', {
    staticClass: "_title"
  }, [_vm._v("Join the world’s creators & music lovers.")]), _vm._v(" "), _c('p', {
    staticClass: "_subtitle"
  }, [_vm._v("Start your free 30 day trial")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#plans"
    }
  }, [_c('v-btn', {
    staticClass: "white",
    attrs: {
      "round": ""
    }
  }, [_vm._v("Choose Plan")])], 1)])])], 1), _vm._v(" "), _c('v-container', {
    staticClass: "learnmore-comp"
  }, [_c('learn-more', {
    attrs: {
      "pageMode": "",
      "setOnMobile": "",
      "hideFooter": ""
    }
  })], 1), _vm._v(" "), _c('v-container', {
    staticClass: "plans-container pb-5 mb-5",
    attrs: {
      "id": "plans"
    }
  }, [_c('h1', {
    staticClass: "main-title intro-title"
  }, [_vm._v("Choose Plan")]), _vm._v(" "), _c('hr', {
    staticClass: "light"
  }), _vm._v(" "), _c('div', {
    staticClass: "dflex align-center justify-space-between top-note"
  }, [_c('div', {
    staticClass: "_left"
  }, [_vm._v("Cancel anytime.")]), _vm._v(" "), _c('div', {
    staticClass: "_right"
  }, [_vm._v("* SMS costs $0.01 per text")])]), _vm._v(" "), _c('div', {
    staticClass: "plans"
  }, _vm._l((_vm.plans), function(plan, index) {
    return _c('div', {
      key: index,
      staticClass: "plan",
      class: [("plan_" + index), ("plan_" + (plan.id))]
    }, [_c('div', [_c('h2', {
      staticClass: "plan_title"
    }, [_vm._v(_vm._s(plan.title))]), _vm._v(" "), _c('div', {
      staticClass: "plan_lists"
    }, _vm._l((plan.list), function(item, i) {
      return _c('div', {
        key: i,
        staticClass: "plan_list"
      }, [((typeof item === 'string')) ? _c('div', {
        staticClass: "top_item"
      }, [_c('v-icon', [_vm._v("check")]), _vm._v(" "), _c('div', {
        domProps: {
          "innerHTML": _vm._s(item)
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(item) + "\n\t\t\t\t\t\t\t")])], 1) : _c('div', _vm._l((item), function(innerItem, i) {
        return _c('div', {
          key: i,
          staticClass: "innerItem dflex"
        }, [_c('span', {
          staticClass: "_bullet"
        }, [_vm._v("•")]), _vm._v(" "), _c('span', {
          domProps: {
            "innerHTML": _vm._s(innerItem)
          }
        }, [_vm._v(_vm._s(innerItem))])])
      }))])
    }))]), _vm._v(" "), _c('div', {
      staticClass: "pricing-absolute"
    }, [_c('div', {
      staticClass: "pricing"
    }, [_c('span', {
      staticClass: "currency"
    }, [_vm._v("$")]), _vm._v(" "), _c('span', {
      staticClass: "cost"
    }, [_vm._v(_vm._s(plan.price))]), _vm._v(" "), _c('span', {
      staticClass: "per"
    }, [_vm._v("/month")])]), _vm._v(" "), _c('div', {
      staticClass: "plan_btn_wrapper"
    }, [_c('v-btn', {
      staticClass: "plan_btn py-4",
      attrs: {
        "depressed": "",
        "block": "",
        "round": "",
        "dark": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.verifyUserType(plan)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.plansDescription(plan.id)))])])], 1)])])
  }))]), _vm._v(" "), _c('v-container', {
    staticClass: "faq-container"
  }, [_c('h1', {
    staticClass: "main-title mb-3"
  }, [_vm._v("FAQ")]), _vm._v(" "), _c('hr', {
    staticClass: "light mb-5"
  }), _vm._v(" "), _c('div', {
    staticClass: "faqs"
  }, [_c('div', {
    staticClass: "faq"
  }, [_c('h3', [_vm._v("How can I pay for a subscription?")]), _vm._v(" "), _c('div', [_vm._v("You can pay with accepted credit cards.")])]), _vm._v(" "), _c('div', {
    staticClass: "faq"
  }, [_c('h3', [_vm._v("How does the 30 day trial work?")]), _vm._v(" "), _c('div', [_vm._v("\n\t\t\t\t\tStart a free trial to get full access to all features. Simply add a\n\t\t\t\t\tvalid credit card, your card will be "), _c('br'), _vm._v(" automatically charged 30 days\n\t\t\t\t\tafter your trial starts and you will be charged on a monthly basis.\n\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "faq"
  }, [_c('h3', [_vm._v("How do I change my subscription?")]), _vm._v(" "), _c('div', [_vm._v("\n\t\t\t\t\tGo to "), _c('strong', [_vm._v("Settings")]), _vm._v(" and tap\n\t\t\t\t\t"), _c('strong', [_vm._v("Subscriptions")]), _vm._v(", if on desktop, go to\n\t\t\t\t\t"), _c('strong', [_vm._v("Settings > Accounts")]), _vm._v(", then tap the plan you"), _c('br'), _vm._v(" want &\n\t\t\t\t\tconfirm. If it’s an upgraded plan you will enter a card to start a\n\t\t\t\t\tfree trial, if you already have a"), _c('br'), _vm._v(" premium subscription the upgrade\n\t\t\t\t\tprice difference will be pro-rated and billed on the next cycle.\n\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "faq"
  }, [_c('h3', [_vm._v("How do I cancel my subscription?")]), _vm._v(" "), _c('div', [_vm._v("\n\t\t\t\t\tGo to "), _c('strong', [_vm._v("Settings")]), _vm._v(" and tap\n\t\t\t\t\t"), _c('strong', [_vm._v("Subscriptions")]), _vm._v(", if on desktop, go to\n\t\t\t\t\t"), _c('strong', [_vm._v("Settings > Accounts")]), _vm._v(", then tap Free and"), _c('br'), _vm._v(" confirm.\n\t\t\t\t\tYour account will convert to “Preview Only” on the next payment\n\t\t\t\t\tcycle.\n\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "faq"
  }, [_c('h3', [_vm._v("Can I listen offline?")]), _vm._v(" "), _c('div', [_vm._v("\n\t\t\t\t\tCurrently, no, however you can download songs you love & support\n\t\t\t\t\tcreators directly,"), _c('br'), _vm._v(" they keep 100% of their sales.\n\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "faq"
  }, [_c('h3', [_vm._v("How do creators share my subscription?")]), _vm._v(" "), _c('div', [_vm._v("\n\t\t\t\t\t50% of your monthly subscription is paid directly to the top 10\n\t\t\t\t\tcreators you stream the most that month. If you"), _c('br'), _vm._v(" stream 10 creators,\n\t\t\t\t\t$5 will be split between 10 creators at $0.50 cents, if you only\n\t\t\t\t\tstream one creator the entire"), _c('br'), _vm._v("  month, they will earn the entire $5.\n\t\t\t\t")])])])]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "plans-dialog"
    },
    model: {
      value: (_vm.initPayment),
      callback: function($$v) {
        _vm.initPayment = $$v
      },
      expression: "initPayment"
    }
  }, [_c('payment-card', {
    attrs: {
      "item": _vm.selectedPlan,
      "totalPayable": _vm.totalPayable,
      "closePayment": _vm.closePaymentModal
    }
  })], 1), _vm._v(" "), (_vm.currentUser !== null && _vm.currentUser.plan !== null) ? _c('v-dialog', {
    model: {
      value: (_vm.plansUpgradeModal),
      callback: function($$v) {
        _vm.plansUpgradeModal = $$v
      },
      expression: "plansUpgradeModal"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Plan Changes")]), _vm._v(" "), (_vm.plansName[_vm.currentUser.plan] == 'Listener') ? _c('v-card-text', [_c('p', [_vm._v("Your current plan is "), _c('b', [_vm._v(" " + _vm._s(_vm.plansName[_vm.currentUser.plan]) + " ")]), _vm._v(" and you are trying to "), _c('b', [_vm._v(_vm._s(_vm.planChangeText) + ". ")])]), _vm._v(" "), _c('p', [_vm._v("You will remain listener until admin approve your account. Once you verified, you will be charged according to subscription of current plan and new chosen plan.\n\t\t\t\t\tAre you sure you want to continue?\n\t\t\t\t")])]) : _c('v-card-text', [_c('p', [_vm._v("Your current plan is "), _c('b', [_vm._v(" " + _vm._s(_vm.plansName[_vm.currentUser.plan]) + " ")]), _vm._v(" and you are trying to "), _c('b', [_vm._v(_vm._s(_vm.planChangeText) + ". ")])]), _vm._v(" "), _c('p', [_vm._v("This will have an immediate effect and you will be charged according to subscription of current plan and new chosen plan.\n\t\t\t\t\tAre you sure you want to continue?\n\t\t\t\t")])]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.subscriptionChange(_vm.planChangeText)
      }
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.hidePlanChangeModal()
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1599 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    class: {
      active: _vm.plan.active
    },
    attrs: {
      "xs12": "",
      "md4": "",
      "plan": ""
    }
  }, [_c('div', {
    staticClass: "plan-wrapper"
  }, [_c('h3', {
    staticClass: "mb-3"
  }, [_vm._v(_vm._s(_vm.plan.title))]), _vm._v(" "), _c('div', {
    staticClass: "items"
  }, _vm._l((_vm.plan.list), function(n, i) {
    return _c('div', {
      key: i,
      staticClass: "item dflex align-start mb-3"
    }, [_c('span', {
      staticClass: "dflex"
    }, [_c('svg', {
      attrs: {
        "width": "20",
        "height": "20",
        "viewBox": "0 0 20 20",
        "fill": "none",
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [_c('path', {
      attrs: {
        "d": "M8.57421 14.8225C8.20317 14.8225 7.85174 14.681 7.62655 14.437L4.57886 11.1464C4.48463 11.0447 4.41584 10.9289 4.37642 10.8056C4.33699 10.6822 4.32771 10.5537 4.3491 10.4274C4.37049 10.3011 4.42213 10.1795 4.50107 10.0695C4.58001 9.95953 4.6847 9.86334 4.80916 9.78645C4.93358 9.70924 5.07541 9.65285 5.22655 9.62051C5.37768 9.58817 5.53514 9.58053 5.6899 9.59801C5.84465 9.61549 5.99367 9.65776 6.12839 9.72239C6.26312 9.78702 6.38092 9.87275 6.47503 9.97465L8.48039 12.1382L13.5223 5.52204C13.6896 5.30359 13.956 5.14826 14.2632 5.09011C14.5703 5.03196 14.8932 5.07575 15.1609 5.21186C15.7179 5.49485 15.8894 6.0943 15.5413 6.55015L9.58414 14.3638C9.48245 14.4978 9.34228 14.6095 9.1758 14.6892C9.00931 14.7689 8.82155 14.8141 8.6288 14.8211C8.61004 14.8225 8.59298 14.8225 8.57421 14.8225Z",
        "fill": "black"
      }
    })])]), _vm._v(" "), _c('p', {
      staticClass: "mb-0",
      domProps: {
        "innerHTML": _vm._s(n)
      }
    }, [_vm._v("\n          " + _vm._s(n) + "\n        ")])])
  })), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('h5', {
    staticClass: "mb-5 mt-15"
  }, [_vm._v("$" + _vm._s(_vm.plan.price) + " "), _c('span', [_vm._v("/month")])]), _vm._v(" "), _c('v-btn', {
    staticClass: "plan_btn",
    nativeOn: {
      "click": function($event) {
        _vm.openPaymentDialog(_vm.plan.stripePriceId)
      }
    }
  }, [_vm._v(" Start free trial ")])], 1), _vm._v(" "), (_vm.showCardModal) ? _c('cardModal', {
    attrs: {
      "amount": _vm.plan.price,
      "stripePriceId": _vm.plan.stripePriceId,
      "dismiss": _vm.closePaymentDialog
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1600 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isPageReady) ? _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-tabs', {
    staticClass: "white",
    attrs: {
      "dark": ""
    },
    model: {
      value: (_vm.current_tab),
      callback: function($$v) {
        _vm.current_tab = $$v
      },
      expression: "current_tab"
    }
  }, [_c('v-tabs-bar', {
    staticClass: "transparent pl-4 mt-4"
  }, [_vm._l((_vm.tabs), function(tab) {
    return _c('v-tabs-item', {
      key: tab.id,
      attrs: {
        "href": '#' + tab.id,
        "ripple": ""
      }
    }, [_vm._v(_vm._s(tab.title))])
  }), _vm._v(" "), _c('v-tabs-slider', {
    attrs: {
      "color": "black"
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    staticClass: "user-serach search-input mr-4",
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.search_keyword),
      callback: function($$v) {
        _vm.search_keyword = $$v
      },
      expression: "search_keyword"
    }
  })], 2), _vm._v(" "), _c('v-tabs-items', {
    staticStyle: {
      "border": "none"
    }
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('v-tabs-content', {
      key: tab.id,
      attrs: {
        "id": tab.id
      }
    }, [_c('v-card', {
      attrs: {
        "flat": ""
      }
    }, [(tab.id == 'all') ? _c('v-data-table', {
      staticClass: "user-table",
      attrs: {
        "headers": _vm.attendee_headers,
        "items": _vm.attendees,
        "search": _vm.search_keyword,
        "rows-per-page-items": _vm.per_page_options,
        "disable-initial-sort": ""
      },
      scopedSlots: _vm._u([{
        key: "items",
        fn: function(props) {
          return [_c('td', {
            staticClass: "text-xs-left"
          }, [_vm._v(_vm._s(props.item.full_name))]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_vm._v(_vm._s(props.item.username))]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_vm._v(_vm._s(props.item.email))]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_vm._v(_vm._s(props.item.account_type))]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_vm._v(_vm._s(props.item.referred_by))]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-center"
          }, [(
            ['created', 'expired'].indexOf(props.item.status) > -1
          ) ? [_c('v-btn', {
            attrs: {
              "color": "primary"
            },
            nativeOn: {
              "click": function($event) {
                _vm.inviteAttendee(props.item)
              }
            }
          }, [_vm._v("Invite")])] : (props.item.status === 'invited') ? [_vm._v("\n                  Invited by\n                  " + _vm._s(_vm._.get(props.item, "inviter.username", "--")) + "\n                ")] : [_vm._v("\n                  " + _vm._s(_vm._f("capitalize")(props.item.status)) + "\n                ")]], 2), _vm._v(" "), _c('td', {
            staticClass: "text-xs-right"
          }, [_c('v-menu', {
            staticClass: "more-menu",
            attrs: {
              "offset-y": ""
            }
          }, [_c('v-btn', {
            attrs: {
              "slot": "activator",
              "dark": ""
            },
            slot: "activator"
          }, [_c('v-icon', [_vm._v("settings")])], 1), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
            key: "delete",
            staticClass: "default-menu-item",
            nativeOn: {
              "click": function($event) {
                _vm.openAttendeeDeleteConfirmDialog(props.item)
              }
            }
          }, [_c('v-list-tile-title', [_c('label', [_vm._v("Delete")])])], 1)], 1)], 1)], 1)]
        }
      }, {
        key: "pageText",
        fn: function(ref) {
          var pageStart = ref.pageStart;
          var pageStop = ref.pageStop;

          return [_vm._v("\n              From " + _vm._s(pageStart) + " to " + _vm._s(pageStop) + " out of\n              " + _vm._s(_vm.attendees.length) + "\n            ")]
        }
      }])
    }) : _vm._e()], 1)], 1)
  }))], 1), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.show_attendee_delete_confirm_dialog),
      callback: function($$v) {
        _vm.show_attendee_delete_confirm_dialog = $$v
      },
      expression: "show_attendee_delete_confirm_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Delete an Attendee")]), _vm._v(" "), _c('v-card-text', [_vm._v("If you click OK, the attendee will be permanently . Click OK to\n        delete <"), _c('b', [_vm._v(_vm._s(_vm.attendee.full_name))]), _vm._v("(" + _vm._s(_vm.attendee.email) + ")>, or click Cancel.")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.deleteAttendee(_vm.attendee)
      }
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeAttendeeDeleteConfirmDialog()
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1601 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page manage-page px-5"
  }, [_c('upload-nav', {
    attrs: {
      "name": "manage"
    }
  }), _vm._v(" "), _c('content-top-header', {
    staticClass: "content-top-header-tab"
  }, [_c('template', {
    slot: "topHeader"
  }, [_c('ul', _vm._l((_vm.tabFilterOptions), function(filter) {
    return _c('li', {
      key: filter.id,
      class: {
        'active tab-active': _vm.isActiveFilter(filter.value)
      },
      attrs: {
        "href": ("#" + (filter.value))
      }
    }, [_c('label', {
      staticClass: "innerBold",
      on: {
        "click": function($event) {
          _vm.setActiveInnerFilter(filter.value)
        }
      }
    }, [_vm._v(_vm._s(filter.title))])])
  }))])], 2), _vm._v(" "), (_vm.activeInnerFilter != 'videos') ? _c('content-top-header', {
    staticClass: "manage-tab-content content-top-header-tab"
  }, [_c('template', {
    slot: "topHeader"
  }, [_c('ul', _vm._l((_vm.getInnerMenuTabs(_vm.activeInnerFilter)), function(tab) {
    return _c('li', {
      key: tab.id,
      class: {
        active: _vm.isActiveInnerTab(tab.id)
      },
      attrs: {
        "href": ("#" + (tab.id))
      }
    }, [_c('label', {
      on: {
        "click": function($event) {
          _vm.setInnerTab(tab.id)
        }
      }
    }, [_vm._v(_vm._s(tab.title))])])
  }))])], 2) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.active_tab === 'content'),
      expression: "active_tab === 'content'"
    }],
    class: _vm.activeInnerFilter != 'videos' ? 'mt-180' : 'mt-130'
  }, [_c('manage-album', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeInnerFilter === 'albums'),
      expression: "activeInnerFilter === 'albums'"
    }],
    ref: "manageAlbum",
    attrs: {
      "textBtnToRight": _vm.activeInnerFilter == 'albums' &&
        (_vm.activeInnerTab == 'published' || _vm.activeInnerTab == 'privated')
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1602 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('hr', {
    staticClass: "my-3"
  }), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('v-btn', {
    staticClass: "text-poppins-14 text-white font-weight-700 btn-pay ma-0 full-width my-4"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(597),
      "width": "58",
      "height": "24"
    }
  })]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "text-dmsans-14 font-weight-700 mb-2"
  }, [_vm._v("Credit card")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "text-dmsans-14 font-weight-700 mb-2"
  }, [_vm._v("Country or region")]), _vm._v(" "), _c('div', {
    staticClass: "mb-4 country-region"
  }, [_c('v-select', {
    staticClass: "pt-0 country",
    attrs: {
      "label": "Choose one",
      "single-line": "",
      "hide-details": ""
    }
  }), _vm._v(" "), _vm._m(6)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "text-poppins-18 btn-confirm ma-0 full-width"
  }, [_vm._v("\n    Pay $565.35\n  ")]), _vm._v(" "), _vm._m(7)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "display-flex align-center justify-space-between"
  }, [_c('span', {
    staticClass: "text-dmsans-14 text-grey-2"
  }, [_vm._v("Subtotal")]), _vm._v(" "), _c('span', {
    staticClass: "text-dmsans-15"
  }, [_vm._v("$519.96")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "display-flex align-center justify-space-between my-1"
  }, [_c('span', {
    staticClass: "text-dmsans-14 text-grey-2"
  }, [_vm._v("Stripe Fee")]), _vm._v(" "), _c('span', {
    staticClass: "text-dmsans-15"
  }, [_vm._v("$7.70")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "display-flex align-center justify-space-between"
  }, [_c('span', {
    staticClass: "text-dmsans-14 text-grey-2"
  }, [_vm._v("Tax")]), _vm._v(" "), _c('span', {
    staticClass: "text-dmsans-15"
  }, [_vm._v("$37.69")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "display-flex align-center justify-space-between"
  }, [_c('span', {
    staticClass: "text-dmsans-16"
  }, [_vm._v("Grand Total ")]), _vm._v(" "), _c('span', {
    staticClass: "text-dmsans-16"
  }, [_vm._v("$565.35")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-dmsans-16 text-grey-3 font-weight-400 display-flex align-center full-width mt-2 mb-4"
  }, [_c('hr', {
    staticClass: "flex-grow"
  }), _vm._v(" "), _c('span', {
    staticClass: "mx-2"
  }, [_vm._v("Or pay with card")]), _vm._v(" "), _c('hr', {
    staticClass: "flex-grow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "credit-card mb-5"
  }, [_c('div', {
    staticClass: "display-flex align-center px-3 credit-card__number"
  }, [_c('input', {
    staticClass: "full-width border-none",
    attrs: {
      "type": "text",
      "placeholder": "1234 1234 1234 1234"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "display-flex align-center gap-8"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(320),
      "width": "24",
      "height": "16"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(318),
      "width": "24",
      "height": "16"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(314),
      "width": "24",
      "height": "16"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(316),
      "width": "24",
      "height": "16"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "display-flex align-center full-width"
  }, [_c('input', {
    staticClass: "border-none width-50 credit-card__month px-3 credit-card__month",
    attrs: {
      "type": "text",
      "placeholder": "MM / YY"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "width-50 px-3 display-flex align-center"
  }, [_c('input', {
    staticClass: "border-none full-width",
    attrs: {
      "type": "text",
      "placeholder": "CVC"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(599),
      "width": "24",
      "height": "16"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zip"
  }, [_c('input', {
    staticClass: "full-width border-none px-3",
    attrs: {
      "type": "text",
      "placeholder": "ZIP"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt-5 display-flex justify-center"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1515)
    }
  })])
}]}

/***/ }),
/* 1603 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-section"
  }, [_c('h2', [_vm._v("Copyright Policy")]), _vm._v(" "), _c('p', [_vm._v("\n    YouSound, Inc. (\"Company\") has adopted the following general policy\n    regarding claims of infringement with respect to intellectual property\n    owned or controlled by third parties, in accordance with the Digital\n    Millennium Copyright Act (DMCA).\n  ")]), _vm._v(" "), _c('p', [_vm._v("It is Company's policy to:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("\n      Block access to or remove material that it believes in good faith to be\n      the intellectual property of a third party (e.g., copyrights,\n      trademarks, trade secrets, etc.) that has been illegally copied and\n      distributed by any of our advertisers, affiliates, content providers,\n      members, or users; and\n    ")]), _vm._v(" "), _c('li', [_vm._v("\n      Remove and discontinue service to repeat offenders. A repeat infringer\n      is a user for whom YouSound has received more than two notices of\n      claimed infringement or for which YouSound has had to remove content\n      more than twice. Notwithstanding the preceding sentence, YouSound\n      reserves the right to immediately terminate the account of any user for\n      egregious infringing activities, at YouSound's sole discretion.\n    ")])]), _vm._v(" "), _c('h3', [_vm._v("Procedure for Reporting Copyright Infringement")]), _vm._v(" "), _c('p', [_vm._v("\n    If you believe that material or content residing on or accessible through\n    the Company website or service infringes an intellectual property right\n    that you own or control, please send a notice of claimed infringement to\n    "), _c('a', {
    attrs: {
      "href": "mailto:copyright@yousound.com"
    }
  }, [_vm._v("copyright@yousound.com")]), _vm._v(". Please\n    note that you will be liable for damages, including costs and attorneys'\n    fees, if you materially misrepresent that content or an activity is\n    infringing your copyrights. Your communication must include all of the\n    following items:\n  ")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("\n      A physical or electronic signature of a person authorized to act on\n      behalf of the owner of the work that has been allegedly infringed.\n    ")]), _vm._v(" "), _c('li', [_vm._v("\n      Identification of works or materials being infringed, including the URL\n      on YouSound.com where the material is located.\n    ")]), _vm._v(" "), _c('li', [_vm._v("\n      Identification of the material that is claimed to be infringing,\n      including information regarding the location or time of the infringing\n      materials that the intellectual property owner seeks to have removed,\n      with sufficient detail so that Company is capable of finding and\n      verifying its existence.\n    ")]), _vm._v(" "), _c('li', [_vm._v("\n      Information reasonably sufficient to permit us to contact you, such as\n      an address, telephone number, and, if available, an electronic mail\n      address at which you may be contacted.\n    ")]), _vm._v(" "), _c('li', [_vm._v("\n      If claiming copyright infringement, the statement: \"I swear under\n      penalty of perjury that I am the copyright owner or am authorized to act\n      on behalf of the owner of an exclusive right that is allegedly\n      infringed, and that the information in this notification is accurate. I\n      have a good faith belief that use of the copyrighted materials described\n      above as allegedly infringing is not authorized by the copyright owner,\n      its agent, or the law.\"\n    ")])]), _vm._v(" "), _c('p', [_vm._v("\n    Note that a copy of your legal notice will be forwarded to the party\n    responsible for providing the alleged infringing content. Please do not\n    include any information in your report other than the above items.\n  ")]), _vm._v(" "), _c('h3', [_vm._v("When Infringement Notification is Received by the Designated Agent")]), _vm._v(" "), _c('p', [_vm._v("It is Company's policy to:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Remove or disable access to the infringing material.")]), _vm._v(" "), _c('li', [_vm._v("\n      Notify the content provider, member, or user that it has removed or\n      disabled access to the material.\n    ")]), _vm._v(" "), _c('li', [_vm._v("\n      Terminate the account of repeat offenders, including removing the\n      infringing material from the system, and terminating the content\n      provider's, member's, or user's access to the service.\n    ")])]), _vm._v(" "), _c('h2', [_vm._v("Procedure to Supply a Counter-Notice")]), _vm._v(" "), _c('p', [_vm._v("\n    If the content provider, member, or user believes that the material that\n    was removed or to which access was disabled is either not infringing, or\n    believes that they have the right to post and use such material from the\n    owner of the intellectual property, the owner's agent, or pursuant to the\n    law, they must send a counter-notice containing the following information\n    to the Company at the address listed below:\n  ")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("\n      A physical or electronic signature of the content provider, member, or\n      user.\n    ")]), _vm._v(" "), _c('li', [_vm._v("\n      Identification of the material that has been removed or to which access\n      has been disabled and the location at which the material appeared before\n      it was removed or disabled.\n    ")]), _vm._v(" "), _c('li', [_vm._v("\n      A statement that the content provider, member, or user has a good faith\n      belief that the material was removed or disabled as a result of mistake\n      or misidentification of the material.\n    ")]), _vm._v(" "), _c('li', [_vm._v("\n      The content provider's, member's, or user's name, address, telephone\n      number, and, if available, email address, along with a statement that\n      such person or entity consents to the jurisdiction of the Federal Court\n      for the judicial district in which the content provider's, member's, or\n      user's address is located, or if the address is outside the United\n      States, for any judicial district in which Company is located, and that\n      such person or entity will accept service of process from the person who\n      provided notification of the alleged infringement.\n    ")])]), _vm._v(" "), _c('p', [_vm._v("\n    Company may send a copy of the counter-notice to the original complaining\n    party, informing them that Company may replace the removed material or\n    cease disabling it in 10 business days. Unless the owner files an action\n    seeking a court order against the content provider, member, or user, the\n    removed material may be replaced or access to it restored in 10 to 14\n    business days or more after receipt of the counter-notice, at Company's\n    discretion. Please contact Company to receive notification of claimed\n    infringement at the following address:\n    "), _c('a', {
    attrs: {
      "href": "mailto:copyright@yousound.com"
    }
  }, [_vm._v("copyright@yousound.com")]), _vm._v(".\n  ")])])
}]}

/***/ }),
/* 1604 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page auth-page auth-login-page no-top-nav no-side-space"
  }, [_c('v-container', {
    attrs: {
      "grid-list-item": "",
      "allChildrenCenter": "",
      "auth-card": "",
      "px-0": "",
      "pb-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "auth-card-wrapper": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "auth-card-child": "",
      "left-card": "",
      "sign-in-info": ""
    }
  }, [(!_vm.onMobile) ? _c('div', [_c('img', {
    attrs: {
      "width": "40%",
      "src": "/static/images/nav_logo_primary.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-4 dflex align-center"
  }, [_c('h3', [_vm._v("Login")]), _vm._v(" "), _c('h3', {
    staticClass: "mx-3"
  }, [_vm._v("or")]), _vm._v(" "), _c('h3', [_c('router-link', {
    attrs: {
      "to": "/register"
    }
  }, [_vm._v("Sign Up")])], 1)])]) : _c('div', {
    staticClass: "text-xs-center create-btn-wrapper"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "transparent create-btn black--text",
    staticStyle: {
      "margin": "0 auto"
    },
    attrs: {
      "round": "",
      "depressed": "",
      "to": _vm.onMobile ? '/onboarding' : '/register'
    }
  }, [_vm._v("\n              Sign Up\n            ")])], 1), _vm._v(" "), (!_vm.onMobile) ? _c('v-spacer') : _vm._e(), _vm._v(" "), (!_vm.onMobile) ? _c('div', {
    staticClass: "text-xs-center auth-img-wrapper"
  }, [_c('img', {
    attrs: {
      "width": "70%",
      "src": "/static/images/new_login_img.svg",
      "alt": ""
    }
  })]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md4": "",
      "auth-card-child": "",
      "right-card": "",
      "sign-in-info": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center mt-4"
  }, [_c('h2', [_vm._v("Hello,")]), _vm._v(" "), _c('h2', [_vm._v("welcome back!")])]), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-item": "",
      "px-0": ""
    }
  }, [_c('login-input')], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1605 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "repost-comp repost-music"
  }, [(_vm.showBanner) ? _c('div', {
    staticClass: "repost-banner"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "repost-banner-close",
    on: {
      "click": function($event) {
        _vm.closeBanner()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(80),
      "width": "15px"
    }
  })])]) : _vm._e(), _vm._v(" "), (!_vm.viewAllPlaylist) ? _c('div', {
    staticClass: "playlists"
  }, [_c('div', {
    staticClass: "title dflex align-center _intro"
  }, [_c('div', [_vm._v(_vm._s(_vm.playlistLen()) + " Playlists")]), _vm._v(" "), _c('div', {
    staticClass: "_action",
    on: {
      "click": function($event) {
        _vm.displayAllPlaylists()
      }
    }
  }, [_vm._v("View All")])]), _vm._v(" "), _c('div', {
    staticClass: "dflex playlist-container"
  }, _vm._l((this.playlists.slice(0, 6).reverse()), function(playlist, index) {
    return _c('div', {
      key: index,
      staticClass: "playlist-holder"
    }, [_c('v-btn', {
      staticClass: "absolute",
      attrs: {
        "dark": ""
      },
      on: {
        "click": function($event) {
          _vm.openDeletePlaylistModal(playlist.id)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "right": ""
      }
    }, [_vm._v("more_horiz")])], 1), _vm._v(" "), _c('div', {
      staticClass: "playlist-box",
      on: {
        "click": function($event) {
          _vm.$router.push({
            path: ("/playlist/" + (playlist.id))
          })
        }
      }
    }, [_c('div', {
      staticClass: "playlist-images"
    }, [_c('ul', _vm._l((_vm.playlistImageList(playlist)), function(playlistImage, index) {
      return _c('li', {
        key: index
      }, [_c('img', {
        attrs: {
          "src": playlistImage,
          "width": "30",
          "alt": "playlist icon"
        }
      })])
    }))]), _vm._v(" "), _c('div', {
      staticClass: "playlist-text"
    }, [_vm._v("\n\t\t\t\t\t\t " + _vm._s(playlist.name) + "\n\t\t\t\t\t\t")])])], 1)
  }))]) : _vm._e(), _vm._v(" "), (!_vm.viewAllPlaylist) ? _c('div', {
    staticClass: "music playlist-music"
  }, [_c('div', {
    staticClass: "title _intro text-capitalize"
  }, [_vm._v(_vm._s(_vm.streams.length) + " " + _vm._s(_vm._f("pluralize")("video", _vm.streams.length)))]), _vm._v(" "), _c('div', {
    staticClass: "title dflex align-center justify-space-between _intro"
  }, [_c('div', {
    staticClass: "dflex align-center justify-space-between w-100"
  }, [_c('input', {
    staticClass: "input-track",
    attrs: {
      "type": "text",
      "placeholder": "Search videos"
    }
  }), _vm._v(" "), (_vm.selectVideosMode) ? _c('div', {
    staticClass: "selectAlbumsMode _action"
  }, [_c('v-btn', {
    attrs: {
      "round": "",
      "dark": "",
      "depressed": ""
    },
    on: {
      "click": function($event) {
        _vm.openAddToPlaylist()
      }
    }
  }, [_vm._v(" Add selected to... ")]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        _vm.toggleSelectVideosMode(false)
      }
    }
  }, [_vm._v(" Cancel ")])], 1) : _c('div', [_c('v-btn', {
    staticClass: "dflex align-center _action pointer-cursor font-bold",
    attrs: {
      "round": "",
      "dark": "",
      "depressed": ""
    },
    on: {
      "click": function($event) {
        _vm.toggleSelectVideosMode(true)
      }
    }
  }, [_c('v-icon', [_vm._v("add")]), _vm._v(" "), _c('span', [_vm._v("Select Videos")])], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "list-track-view list-track-view-trackCard list-track-view-video listings"
  }, _vm._l((_vm.tempVideo), function(video, index) {
    return _c('div', {
      key: index,
      staticClass: "list-track-view-item listing cursor-none"
    }, [_c('video-box', {
      attrs: {
        "hoverOverlay": false,
        "getCollections": _vm.getCollections,
        "item": video,
        "showUsername": "",
        "forCollection": "",
        "hideUser": true,
        "sideTabView": true
      }
    }), _vm._v(" "), (_vm.selectVideosMode) ? _c('div', {
      staticClass: "selectMusic"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedVideos),
        expression: "selectedVideos"
      }],
      staticClass: "selectMusic-check",
      attrs: {
        "type": "checkbox",
        "id": ("check-" + index)
      },
      domProps: {
        "value": video,
        "checked": Array.isArray(_vm.selectedVideos) ? _vm._i(_vm.selectedVideos, video) > -1 : (_vm.selectedVideos)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.selectedVideos,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = video,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedVideos = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectedVideos = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedVideos = $$c
          }
        }
      }
    }), _vm._v(" "), (_vm.selectedVideos.includes(video)) ? _c('v-icon', {
      staticClass: "check-icon",
      on: {
        "click": function($event) {
          _vm.removeVideo(video.id)
        }
      }
    }, [_vm._v("\n              check\n            ")]) : _vm._e()], 1) : _vm._e()], 1)
  }))]) : _vm._e(), _vm._v(" "), (_vm.viewAllPlaylist) ? _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-lg": "",
      "px-0": ""
    }
  }, [_c('div', {
    staticClass: "playlists"
  }, [_c('div', {
    staticClass: "title dflex align-center _intro"
  }, [_c('v-btn', {
    staticClass: "back-btn",
    attrs: {
      "ripple": true,
      "fab": "",
      "small": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.back()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ml-5"
  }, [_vm._v(_vm._s(_vm.playlistLen()) + " Playlists")])], 1), _vm._v(" "), _c('div', {
    staticClass: "dflex playlist-container"
  }, _vm._l((this.playlists), function(playlist, index) {
    return _c('div', {
      key: index,
      staticClass: "playlist-holder pr-2",
      on: {
        "click": function($event) {
          _vm.$router.push({
            path: ("/playlist/" + (playlist.id))
          })
        }
      }
    }, [_c('div', {
      staticClass: "playlist-box"
    }, [_c('div', {
      staticClass: "playlist-images"
    }, [_c('ul', _vm._l((_vm.playlistImageList(playlist)), function(playlistImage, index) {
      return _c('li', {
        key: index
      }, [_c('img', {
        attrs: {
          "src": playlistImage,
          "width": "30",
          "alt": "playlist icon"
        }
      })])
    }))]), _vm._v(" "), _c('div', {
      staticClass: "playlist-text"
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(playlist.name) + "\n\t\t\t\t\t\t\t")])])])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.addToPlaylistActive) ? _c('add-to-playlist', {
    attrs: {
      "playlists": this.playlists,
      "addToPlaylist": _vm.addToPlaylistActive,
      "selectedItems": this.selectedVideos,
      "type": "stream"
    },
    on: {
      "closeAddToPlaylist": _vm.closeAddToPlaylist,
      "methodThatForcesUpdate": _vm.methodThatForcesUpdate
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dflex gap-25 align-center justify-space-between"
  }, [_c('div', {
    staticClass: "repost-content"
  }, [_c('div', {
    staticClass: "dflex align-center mb-4"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(308),
      "width": "25"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "repost-head"
  }, [_vm._v("Build your collection")])]), _vm._v(" "), _c('p', {
    staticClass: "repost-text"
  }, [_vm._v("Create playlists or shopping lists for all of the albums, videos & products you discover")])]), _vm._v(" "), _c('div', {
    staticClass: "repost-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(97),
      "width": "100%"
    }
  })])])
}]}

/***/ }),
/* 1606 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    class: {
      bg: _vm.bg
    }
  }, [_c('v-container', {
    staticClass: "inner-container",
    attrs: {
      "fluid": "",
      "px-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    class: [("order-md-" + _vm.order1), 'order-1'],
    attrs: {
      "xs12": "",
      "md6": "",
      "order": _vm.order1
    }
  }, [_c('div', {
    staticClass: "text-container d-block justify-center align-center align-md-start flex-column"
  }, [_c('h3', {
    staticClass: "mb-5"
  }, [_vm._v("\n            " + _vm._s(_vm.title) + " "), _c('br'), _vm._v("\n            " + _vm._s(_vm.title2) + "\n          ")]), _vm._v(" "), _c('ul', {
    staticClass: "ul-list"
  }, _vm._l((_vm.list1), function(list, i) {
    return _c('li', {
      key: i
    }, [_vm._v("\n              " + _vm._s(list) + "\n            ")])
  }))])]), _vm._v(" "), _c('v-flex', {
    class: [("order-md-" + _vm.order2), 'order-2'],
    attrs: {
      "xs12": "",
      "md6": "",
      "order": _vm.order2
    }
  }, [_c('div', {
    staticClass: "img-container d-flex justify-center align-center"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgSrc
    }
  })])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "_pad-first-flex": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    class: [("order-md-" + _vm.order3), 'order-1'],
    attrs: {
      "xs12": "",
      "md6": "",
      "order": _vm.order1
    }
  }, [_c('div', {
    staticClass: "text-container pl-md-15 d-block justify-center align-center align-md-start flex-column"
  }, [_c('h3', {
    staticClass: "mb-5"
  }, [_vm._v("\n            " + _vm._s(_vm.title3) + " "), _c('br'), _vm._v("\n            " + _vm._s(_vm.title4) + "\n          ")]), _vm._v(" "), _c('ul', {
    staticClass: "ul-list"
  }, _vm._l((_vm.list2), function(list, k) {
    return _c('li', {
      key: k
    }, [_vm._v("\n              " + _vm._s(list) + "\n            ")])
  }))])]), _vm._v(" "), _c('v-flex', {
    class: [("order-md-" + _vm.order4), 'order-2'],
    attrs: {
      "xs12": "",
      "md6": "",
      "order": _vm.order2
    }
  }, [_c('div', {
    staticClass: "img-container pr-md-10 d-flex justify-center align-center"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgSrc1
    }
  })])])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1607 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "share-section",
    class: {
      onMobile: _vm.onMobile
    },
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-flex', {
    staticClass: "dismiss-section",
    attrs: {
      "xs12": "",
      "sm12": ""
    },
    on: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-section",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "dflex profile-section",
    attrs: {
      "xs12": ""
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/' + _vm.user.slug
    }
  }, [_c('div', {
    staticClass: "avatar-image",
    style: ({
      'background-image': 'url(' + _vm.user.avatar.thumb.url + ')',
    })
  })]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": '/' + _vm.user.slug
    }
  }, [_c('label', {
    staticClass: "user-name"
  }, [_vm._v(_vm._s(_vm.user.username) + "\n          "), (_vm.user.user_type == 'artist') ? _c('v-icon', {
    staticClass: "user-status",
    class: {
      online: _vm.user.status == 'active'
    }
  }, [_vm._v("fa-check-circle")]) : _vm._e()], 1)]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.user.id != _vm.$store.state.auth.user.id) ? _c('user-follow-btn', {
    attrs: {
      "user": _vm.user,
      "theme": "dark",
      "type": "default"
    },
    on: {
      "afterFollow": _vm.afterFollow
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "item-section",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "item-image",
    style: ({
      'background-image': 'url(' + _vm.itemCover + ')'
    })
  }), _vm._v(" "), _c('p', {
    staticClass: "item-name"
  }, [_vm._v(_vm._s(_vm.item.name))])]), _vm._v(" "), _c('v-flex', {
    staticClass: "share-social-section",
    attrs: {
      "xs12": ""
    }
  }, [_c('social-sharing', {
    attrs: {
      "url": _vm.shareUrl
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', {
            staticClass: "social-section"
          }, [_c('network', {
            attrs: {
              "network": "facebook"
            }
          }, [_c('v-btn', {
            staticClass: "social-share-btn"
          }, [_c('v-icon', [_vm._v("fa-facebook")])], 1)], 1), _vm._v(" "), _c('network', {
            attrs: {
              "network": "twitter"
            }
          }, [_c('v-btn', {
            staticClass: "social-share-btn"
          }, [_c('v-icon', [_vm._v("fa-twitter")])], 1)], 1)], 1)
        
      },
      staticRenderFns: []
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "input-section",
    attrs: {
      "xs12": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shareUrl),
      expression: "shareUrl"
    }],
    staticClass: "form-control clipboard-url",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.shareUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shareUrl = $event.target.value
      }
    }
  }), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.shareUrl),
      expression: "shareUrl",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.onCopy),
      expression: "onCopy",
      arg: "success"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:error",
      value: (_vm.onError),
      expression: "onError",
      arg: "error"
    }],
    staticClass: "clipboard-btn"
  }, [_c('v-icon', [_vm._v("fa-clipboard")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1608 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "player px-4"
  }, [_c('div', {
    staticClass: "display-flex align-center justify-space-between pt-5 pb-4"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(317),
      "width": "27"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'DiscoverMobile'
        })
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(44),
      "width": "100"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(117),
      "width": "27"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'DiscoverMobile'
        })
      }
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "track-list mb-2"
  }, [_c('div', {
    staticClass: "text-Poppins-15 font-weight-600 text-white mb-2"
  }, [_vm._v("\n      Tracklist\n    ")]), _vm._v(" "), _vm._l((_vm.playList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "display-flex align-center gap-15 my-2 track-list__item",
      class: {
        'is-play': item.isPlay
      }
    }, [_c('div', [(item.isPlay) ? _c('img', {
      attrs: {
        "src": __webpack_require__(1499),
        "width": "16"
      }
    }) : _c('span', {
      staticClass: "track-list__item--number"
    }, [_vm._v(" " + _vm._s(index + 1))])]), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "text-poppins-16 font-weight-500 text-white"
    }, [_vm._v("\n          " + _vm._s(item.title) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "text-poppins-14 font-weight-500 text-grey-5"
    }, [_vm._v("\n          " + _vm._s(item.name) + "\n        ")])])])
  })], 2), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "track-list mb-2"
  }, [_c('div', {
    staticClass: "text-Poppins-15 font-weight-600 text-white mb-2"
  }, [_vm._v("Credits")]), _vm._v(" "), _vm._l((2), function(i) {
    return _c('div', {
      key: i,
      staticClass: "display-flex align-center justify-space-between gap-15 my-3"
    }, [_c('div', {
      staticClass: "display-flex align-center gap-15"
    }, [_c('img', {
      staticClass: "rounded",
      attrs: {
        "src": __webpack_require__(30),
        "width": 40,
        "height": 40
      }
    }), _vm._v(" "), _vm._m(5, true)]), _vm._v(" "), _c('div', {
      staticClass: "text-poppins-12 text-black btn-follow font-weight-500 display-flex justify-center align-center"
    }, [_vm._v("\n        FOLLOW\n      ")])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "track-list mb-5"
  }, [_c('div', {
    staticClass: "text-Poppins-15 font-weight-600 text-white mb-2"
  }, [_vm._v("\n      283 comments\n    ")]), _vm._v(" "), _vm._l((2), function(i) {
    return _c('div', {
      key: i,
      staticClass: "display-flex align-center gap-15 my-3"
    }, [_c('img', {
      staticClass: "rounded",
      attrs: {
        "src": __webpack_require__(30),
        "width": 40,
        "height": 40
      }
    }), _vm._v(" "), _vm._m(6, true)])
  }), _vm._v(" "), _c('input', {
    staticClass: "text-poppins-14 text-black mt-5 reply-input",
    attrs: {
      "placeholder": "Add your reply"
    }
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "display-flex align-center justify-center my-4"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1519),
      "width": "329",
      "height": "326"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "display-flex justify-space-between align-start"
  }, [_c('div', [_c('div', {
    staticClass: "mb-1 text-poppins-18 text-white"
  }, [_vm._v("The Origin")]), _vm._v(" "), _c('div', {
    staticClass: "text-dmsans-14 font-weight-500 text-white"
  }, [_vm._v("SALVA")])]), _vm._v(" "), _c('div', {
    staticClass: "display-flex align-center gap-20"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1502),
      "width": "20"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(1490),
      "width": "20"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt-3"
  }, [_c('div', {
    staticClass: "progress-bar"
  }, [_c('span', {
    staticClass: "progress-line"
  }), _vm._v(" "), _c('input', {
    staticClass: "progress",
    attrs: {
      "type": "range",
      "min": "0",
      "max": "100",
      "value": "0",
      "id": "progress"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "duration mt-2 display-flex justify-space-between"
  }, [_c('span', [_vm._v("00:00")]), _vm._v(" "), _c('span', [_vm._v("-3:24")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "display-flex justify-center align-center gap-42 my-5"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1501),
      "width": "26"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(1495),
      "width": "55"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(1494),
      "width": "26"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb-2 relative"
  }, [_c('img', {
    staticClass: "max-full-width username",
    attrs: {
      "src": __webpack_require__(118)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "display-flex justify-space-between align-center pa-3 absolute w-100 top-0"
  }, [_c('div', [_c('div', {
    staticClass: "mb-1 text-poppins-18 text-white"
  }, [_vm._v("SALVA")]), _vm._v(" "), _c('div', {
    staticClass: "text-dmsans-14 font-weight-500 text-white"
  }, [_vm._v("Artist")])]), _vm._v(" "), _c('div', {
    staticClass: "text-poppins-12 text-black btn-follow font-weight-500 display-flex justify-center align-center"
  }, [_vm._v("\n        Follow\n      ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "text-poppins-16 font-weight-500 text-white"
  }, [_vm._v("Teeko")]), _vm._v(" "), _c('div', {
    staticClass: "text-poppins-14 font-weight-500 text-white"
  }, [_vm._v("\n            producer\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "text-poppins-16 font-weight-500 text-white"
  }, [_vm._v("\n          Tame Impala\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "text-poppins-14 text-white"
  }, [_vm._v("this is amazing!")])])
}]}

/***/ }),
/* 1609 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tag user_tag",
    class: {
      'cursor-pointer': _vm.clickUser,
      fitContent: _vm.fitContent
    },
    on: {
      "click": function($event) {
        _vm.clickUser ? _vm.gotoUser() : ''
      }
    }
  }, [(_vm.showAvatar) ? _c('div', {
    staticClass: "tag__image",
    style: (("background-image: url(" + (_vm.user.avatar.url) + ");width: " + _vm.width + "px;height: " + _vm.height + "px; margin-right: " + (_vm.marginRight ? _vm.marginRight : '')))
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "bio-wrapper"
  }, [(!_vm.hideName) ? _c('div', {
    staticClass: "tag__name text-capitalize"
  }, [_vm._v(_vm._s(_vm.user.username))]) : _vm._e(), _vm._v(" "), (_vm.showUserType) ? _c('div', {
    staticClass: "tag__usertype text-capitalize"
  }, [_vm._v(_vm._s(_vm.user.user_type))]) : _vm._e()]), _vm._v(" "), (['artist', 'label', 'brand'].indexOf(_vm.user.user_type) > -1 && !_vm.hideTick) ? _c('v-icon', {
    staticClass: "user-status online"
  }, [_vm._v("fa-check-circle")]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1610 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page manage-page mx-5",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "page-left"
  }, [_c('div', {
    staticClass: "tab-container"
  }, [_c('h2', {
    staticClass: "page-title"
  }, [_vm._v("Manage")]), _vm._v(" "), _c('ul', _vm._l((_vm.tabs), function(tab) {
    return _c('li', {
      key: tab.id,
      class: {
        active: _vm.isActiveTab(tab.id)
      },
      attrs: {
        "href": ("#" + (tab.id))
      }
    }, [_c('label', {
      on: {
        "click": function($event) {
          _vm.onTab(tab.id)
        }
      }
    }, [_vm._v(_vm._s(tab.title))])])
  }))])]), _vm._v(" "), (_vm.currentUser && _vm.isPageReady) ? _c('div', {
    staticClass: "page-content",
    staticStyle: {
      "padding": "unset !important"
    }
  }, [(_vm.active_tab == 'published') ? _c('div', [(!_vm.published_albums || _vm.published_albums.length == 0) ? _c('div', {
    staticClass: "empty-section"
  }, [_c('p', {
    staticClass: "empty-title"
  }, [_vm._v("You have not uploaded any albums yet")]), _vm._v(" "), _c('router-link', {
    staticClass: "empty-discover-btn",
    attrs: {
      "to": "/upload/album"
    }
  }, [_vm._v("Upload")])], 1) : _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-layout', {
    staticClass: "covers-content",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.published_albums), function(album, index) {
    return _c('div', {
      key: index,
      staticClass: "card-container"
    }, [_c('album-card', {
      attrs: {
        "album": album,
        "editButtonAction": _vm.editAlbum,
        "deleteButtonAction": _vm.openAlbumDeleteConfirmDialog,
        "videoOnlyButtonAction": _vm.openVideoOnlyConfirmDialog,
        "privateButtonAction": _vm.openPrivateConfirmDialog
      }
    })], 1)
  }))], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.active_tab == 'privated') ? _c('div', [(!_vm.private_albums || _vm.private_albums.length == 0) ? _c('div', {
    staticClass: "empty-section"
  }, [_c('p', {
    staticClass: "empty-title"
  }, [_vm._v("You have no private albums")])]) : _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-layout', {
    staticClass: "covers-content",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.private_albums), function(album, index) {
    return _c('div', {
      key: index,
      staticClass: "card-container"
    }, [_c('album-card', {
      attrs: {
        "album": album,
        "showPromoteButton": false,
        "editButtonAction": _vm.editAlbum,
        "deleteButtonAction": _vm.openAlbumDeleteConfirmDialog,
        "publishButtonAction": _vm.openPublishConfirmDialog
      }
    })], 1)
  }))], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.active_tab == 'video_only') ? _c('div', [(!_vm.video_only_albums || _vm.video_only_albums.length == 0) ? _c('div', {
    staticClass: "empty-section"
  }, [_c('p', {
    staticClass: "empty-title"
  }, [_vm._v("You have no albums only for live video")])]) : _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-layout', {
    staticClass: "covers-content",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.video_only_albums), function(album, index) {
    return _c('div', {
      key: index,
      staticClass: "card-container"
    }, [_c('album-card', {
      attrs: {
        "album": album,
        "showPromoteButton": false,
        "editButtonAction": _vm.editAlbum,
        "deleteButtonAction": _vm.openAlbumDeleteConfirmDialog,
        "publishButtonAction": _vm.openPublishConfirmDialog
      }
    })], 1)
  }))], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.active_tab == 'collaborated') ? _c('div', [(!_vm.collaborated_albums || _vm.collaborated_albums.length == 0) ? _c('div', {
    staticClass: "empty-section"
  }, [_c('p', {
    staticClass: "empty-title"
  }, [_vm._v("You have no album collaborations")])]) : _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-layout', {
    staticClass: "covers-content",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.collaborated_albums), function(album, index) {
    return _c('div', {
      key: index,
      staticClass: "card-container"
    }, [_c('album-card', {
      attrs: {
        "album": album,
        "editButtonAction": _vm.editAlbum,
        "deleteButtonAction": _vm.openAlbumDeleteConfirmDialog
      }
    })], 1)
  }))], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.active_tab == 'pending') ? _c('div', [(!_vm.pending_albums || _vm.pending_albums.length == 0) ? _c('div', {
    staticClass: "empty-section"
  }, [_c('p', {
    staticClass: "empty-title"
  }, [_vm._v("You have no pending album collaborations")])]) : _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-layout', {
    staticClass: "covers-content",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.pending_albums), function(album, index) {
    return _c('div', {
      key: index,
      staticClass: "card-container"
    }, [(album.user.id == _vm.$store.state.auth.user.id) ? _c('album-card', {
      attrs: {
        "album": album,
        "showPromoteButton": false,
        "editButtonAction": _vm.editAlbum,
        "deleteButtonAction": _vm.openAlbumDeleteConfirmDialog,
        "releaseButtonAction": _vm.releaseAlbum
      }
    }) : (_vm.notResponded(album)) ? _c('album-card', {
      attrs: {
        "album": album,
        "showPromoteButton": false,
        "acceptButtonAction": _vm.acceptAlbum,
        "denyButtonAction": _vm.denyAlbum
      }
    }) : _c('album-card', {
      attrs: {
        "album": album,
        "showPromoteButton": false
      }
    })], 1)
  }))], 1)], 1) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.show_album_finish_modal) ? _c('div', {
    staticClass: "album-finish-section"
  }, [_c('div', {
    staticClass: "dismiss-section",
    on: {
      "click": function($event) {
        _vm.closeAlbumFinishModal()
      }
    }
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "popup-section",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "title-section",
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "title-text"
  }, [_vm._v("This album is pending release,\n          "), _c('router-link', {
    staticClass: "link-text",
    attrs: {
      "to": "/upload/album"
    }
  }, [_vm._v("upload another")])], 1)]), _vm._v(" "), _c('v-flex', {
    staticClass: "promote-album-section",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-flex', {
    staticClass: "header-section",
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "header-text"
  }, [_vm._v("What Next?")])]), _vm._v(" "), _c('div', {
    staticClass: "content-section"
  }, [_c('div', {
    staticClass: "promote-album-image"
  }, [_c('div', {
    staticClass: "promote-image",
    style: ({
      'background-image': 'url(' + _vm.album.cover.url + ')'
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "promote-album-description"
  }, [_c('p', [_vm._v("\n              When you added collaborators accept your collaboration via\n              Direct Message or Manage > Pending Collaborations, you will then\n              be able to release the album.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              Visit Manage > Pending Collaborations to see who accepted and/or\n              denied your collaboration.\n            ")])])])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.show_album_delete_confirm_dialog),
      callback: function($$v) {
        _vm.show_album_delete_confirm_dialog = $$v
      },
      expression: "show_album_delete_confirm_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Delete an Album")]), _vm._v(" "), _c('v-card-text', [_vm._v("If you click OK, your followers won't see the album any more. Click\n        OK to delete <" + _vm._s(_vm.album.name) + ">, or click Cancel.")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.deleteAlbum()
      }
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeAlbumDeleteConfirmDialog()
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.show_publish_confirm_dialog),
      callback: function($$v) {
        _vm.show_publish_confirm_dialog = $$v
      },
      expression: "show_publish_confirm_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Publish an Album")]), _vm._v(" "), _c('v-card-text', [_vm._v("If you click OK, the album will be published. Click OK to publish, or\n        click Cancel.")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.publishAlbum()
      }
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closePublishConfirmDialog()
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.show_private_confirm_dialog),
      callback: function($$v) {
        _vm.show_private_confirm_dialog = $$v
      },
      expression: "show_private_confirm_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Make album private")]), _vm._v(" "), _c('v-card-text', [_vm._v("If you make this album private it will be removed from public feeds\n        and reposts. Click OK to private, or click Cancel.")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.privateAlbum()
      }
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closePrivateConfirmDialog()
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "invite-dialog",
      "width": "440"
    },
    model: {
      value: (_vm.show_video_only_confirm_dialog),
      callback: function($$v) {
        _vm.show_video_only_confirm_dialog = $$v
      },
      expression: "show_video_only_confirm_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("\n        Make an album available only for live\n      ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n        If you click OK, the album will be available only for live\n        video.\n      ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "black",
      "dark": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.videoOnlyAlbum()
      }
    }
  }, [_vm._v("Yes")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1611 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-follow-btn",
    class: [("is_" + _vm.theme)]
  }, [_c('v-btn', {
    staticClass: "follow-btn",
    class: {
      'follow-btn': true,
      follow: !_vm.userIsFollowing,
      following: _vm.userIsFollowing,
      btnBlock: _vm.btnBlock,
      borderRadius: _vm.borderRadius,
    },
    staticStyle: {
      "background-color": "red"
    },
    on: {
      "mouseenter": function($event) {
        _vm.buttonHover = true
      },
      "mouseleave": function($event) {
        _vm.buttonHover = false
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.followUser()
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.followButtonText) + "\n  ")])], 1)
},staticRenderFns: []}

/***/ }),
/* 1612 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page album-stats-page"
  }, [(_vm.isPageReady) ? _c('v-flex', {
    staticClass: "album-section",
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": ""
    }
  }, [_c('h2', {
    staticClass: "page-title"
  }, [_vm._v("Stats")]), _vm._v(" "), _c('div', {
    staticClass: "album-info-section"
  }, [_c('div', {
    staticClass: "album-cover-image",
    style: ({
      'background-image': 'url(' + _vm.album.cover.thumb.url + ')'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "album-detail-section"
  }, [_c('p', {
    staticClass: "album-name"
  }, [_vm._v(_vm._s(_vm.album.name))]), _vm._v(" "), _c('p', {
    staticClass: "user-name"
  }, [_vm._v("\n          By\n          "), _c('router-link', {
    attrs: {
      "to": '/' + _vm.album.user.slug
    }
  }, [_vm._v(_vm._s(_vm.album.user.username))])], 1), _vm._v(" "), _c('p', {
    staticClass: "album-stats"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("formatLargeNumber")(_vm.album.stats.plays_size)))]), _c('label', [_vm._v("Plays")])])])])]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": ""
    }
  }, [_c('div', {
    staticClass: "normal-tab"
  }, [_c('v-tabs', {
    attrs: {
      "black": ""
    },
    model: {
      value: (_vm.currentTab),
      callback: function($$v) {
        _vm.currentTab = $$v
      },
      expression: "currentTab"
    }
  }, [_c('v-tabs-bar', {
    staticClass: "transparent"
  }, [_vm._l((_vm.tabs), function(tab) {
    return _c('v-tabs-item', {
      key: tab.id,
      attrs: {
        "href": ("#" + (tab.id)),
        "ripple": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.onTab(tab.id)
        }
      }
    }, [_vm._v(_vm._s(tab.title))])
  }), _vm._v(" "), _c('v-tabs-slider', {
    attrs: {
      "color": "black"
    }
  })], 2), _vm._v(" "), _c('v-tabs-items', _vm._l((_vm.tabs), function(tab) {
    return _c('v-tabs-content', {
      key: tab.id,
      attrs: {
        "id": tab.id
      }
    }, [_c('v-card', {
      attrs: {
        "flat": ""
      }
    }, _vm._l((_vm.activities), function(activity) {
      return _c('activity-item', {
        key: activity.id,
        attrs: {
          "activityItem": activity
        }
      })
    }))], 1)
  }))], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1613 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uploader"
  }, [_c('input', {
    staticClass: "uploader__file",
    attrs: {
      "type": "file",
      "id": "file_uploader",
      "accept": _vm.accept
    },
    on: {
      "change": function($event) {
        _vm.filesChange($event.target.files)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fileName),
      expression: "fileName"
    }],
    staticClass: "uploader__filename"
  }, [_vm._v("\n    " + _vm._s(_vm.fileName) + "\n  ")]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "uploader__add",
    attrs: {
      "for": "file_uploader"
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fileName),
      expression: "fileName"
    }],
    staticClass: "uploader__remove",
    on: {
      "click": function($event) {
        _vm.deleteFile()
      }
    }
  }, [_vm._v("remove")])]), _vm._v(" "), _c('div', {
    staticClass: "uploader__desc"
  }, [_vm._v(".Zip file only, 25MB max")])])
},staticRenderFns: []}

/***/ }),
/* 1614 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "direct-message-section",
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-flex', {
    staticClass: "dismiss-section",
    attrs: {
      "xs12": "",
      "sm12": ""
    },
    on: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "popup-section",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "content-section",
    class: {
      sm7: _vm.$store.state.auth.user.user_type == 'artist',
      sm12: _vm.$store.state.auth.user.user_type != 'artist',
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "avatar-image",
    style: ({
      'background-image': 'url(' + _vm.receiver.avatar.thumb.url + ')',
    })
  }), _vm._v(" "), _c('p', {
    staticClass: "user-name"
  }, [_vm._v("\n        " + _vm._s(_vm.receiver.username) + "\n        "), (_vm.receiver.user_type == 'artist') ? _c('v-icon', {
    staticClass: "user-status",
    class: {
      online: _vm.receiver.status == 'active'
    }
  }, [_vm._v("fa-check-circle")]) : _vm._e()], 1), _vm._v(" "), (_vm.$store.state.auth.user.user_type == 'artist') ? _c('label', {
    staticClass: "repost-price"
  }, [_vm._v("Repost Price: $" + _vm._s(_vm._f("formatNumber")(_vm.receiver.repost_price)))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "send-message-section relative"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.message),
      expression: "message",
      modifiers: {
        "trim": true
      }
    }],
    ref: "message",
    staticClass: "message-input-area",
    attrs: {
      "maxlength": "500",
      "placeholder": "Write a message..."
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (_vm.showEmojiPicker) ? _c('picker', {
    staticClass: "emoji-picker",
    attrs: {
      "title": "Pick your emoji…",
      "emoji": "point_up"
    },
    on: {
      "click": _vm.addEmoji
    }
  }) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "show-emoji-box-btn",
    class: {
      selected: _vm.showEmojiPicker
    },
    nativeOn: {
      "click": function($event) {
        _vm.showEmojiPicker = !_vm.showEmojiPicker
      }
    }
  }, [_c('v-icon', [_vm._v("tag_faces")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "send-message-btn",
    attrs: {
      "disabled": !_vm.message
    },
    nativeOn: {
      "click": function($event) {
        _vm.checkMessage()
      }
    }
  }, [_vm._v("Send")])], 1)]), _vm._v(" "), (_vm.$store.state.auth.user.user_type == 'artist') ? _c('v-flex', {
    staticClass: "requests-section",
    class: {
      sm5: _vm.$store.state.auth.user.user_type == 'artist',
      sm12: _vm.$store.state.auth.user.user_type != 'artist',
    },
    attrs: {
      "xs12": "",
      "pa-0": ""
    }
  }, [_c('div', {
    staticClass: "header-section"
  }, [_c('p', {
    staticClass: "section-title"
  }, [_vm._v("Request repost")]), _vm._v(" "), _c('div', {
    staticClass: "option-area"
  }, [_c('v-btn', {
    staticClass: "request-option-btn",
    class: {
      selected: _vm.tab == 'album'
    },
    nativeOn: {
      "click": function($event) {
        _vm.onTab('album')
      }
    }
  }, [_vm._v("Album")]), _vm._v(" "), _c('v-btn', {
    staticClass: "request-option-btn",
    class: {
      selected: _vm.tab == 'merch'
    },
    nativeOn: {
      "click": function($event) {
        _vm.onTab('merch')
      }
    }
  }, [_vm._v("Product")])], 1)]), _vm._v(" "), (_vm.tab == 'album') ? _c('div', {
    staticClass: "content-section"
  }, _vm._l((_vm.albums), function(album) {
    return _c('div', {
      key: album.id,
      staticClass: "request-item",
      class: {
        selected: _vm.item == album,
        banned: _vm.InBanned(album)
      },
      on: {
        "click": function($event) {
          _vm.InBanned(album) ? null : _vm.selectItem(album)
        }
      }
    }, [_c('div', {
      staticClass: "avatar-area"
    }, [_c('div', {
      staticClass: "avatar-image",
      style: (("background-image: url(" + (album.cover.thumb.url) + ")"))
    })]), _vm._v(" "), _c('div', {
      staticClass: "detail-area"
    }, [_c('label', {
      staticClass: "item-name"
    }, [_vm._v(_vm._s(album.name))]), _vm._v(" "), _c('label', {
      staticClass: "user-name"
    }, [_vm._v(_vm._s(album.user.username))])])])
  })) : _vm._e(), _vm._v(" "), (_vm.tab == 'merch') ? _c('div', {
    staticClass: "content-section"
  }, _vm._l((_vm.products), function(product) {
    return _c('div', {
      key: product.id,
      staticClass: "request-item",
      class: {
        selected: _vm.item == product,
        banned: _vm.InReposted(product)
      },
      on: {
        "click": function($event) {
          _vm.InReposted(product) ? null : _vm.selectItem(product)
        }
      }
    }, [_c('div', {
      staticClass: "avatar-area"
    }, [_c('div', {
      staticClass: "avatar-image",
      style: (("background-image: url(" + (product.covers[0].cover.thumb.url) + ")"))
    })]), _vm._v(" "), _c('div', {
      staticClass: "detail-area"
    }, [_c('label', {
      staticClass: "item-name"
    }, [_vm._v(_vm._s(product.name))]), _vm._v(" "), _c('label', {
      staticClass: "user-name"
    }, [_vm._v(_vm._s(product.merchant.username))])])])
  })) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.show_repost_payment_modal) ? _c('repost-payment-modal', {
    attrs: {
      "item": _vm.item,
      "itemType": _vm.tab,
      "receiver": _vm.receiver,
      "dismiss": _vm.closeRepostPaymentModal,
      "finish": _vm.sendMessage
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$store.getters['player/isPlaying']) ? _c('div', {
    staticClass: "side-player"
  }, [_c('v-dialog', {
    model: {
      value: (_vm.showListeningMessage),
      callback: function($$v) {
        _vm.showListeningMessage = $$v
      },
      expression: "showListeningMessage"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Still Listening")]), _vm._v(" "), _c('v-card-text', [_vm._v("Are you still Listening?")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.hideListeningMessage($event)
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "side-player-inner"
  }, [_c('div', {
    staticClass: "track-detail-section"
  }, [_c('div', {
    staticClass: "track-cover-container",
    style: ({
      width: _vm.isMini ? '100%' : ''
    })
  }, [_c('router-link', {
    attrs: {
      "to": ("/" + (_vm.item.album_type) + "/" + (_vm.item.slug))
    }
  }, [(_vm.item.album_type == 'playlist') ? [_c('div', {
    staticClass: "track-cover-image",
    class: _vm.item.album_type,
    style: ({
      'background-image': ("url(" + _vm.album1Cover + "), url(" + _vm.album2Cover + "), url(" + _vm.album3Cover + "), url(" + _vm.album4Cover + ")"),
    })
  }, [_c('div', {
    staticStyle: {
      "max-width": "180px",
      "padding-top": "10.5rem",
      "padding-left": "10px"
    }
  }, [_c('label', {
    staticClass: "ellipsisIt cursor-pointer",
    staticStyle: {
      "background-color": "black"
    }
  }, [_vm._v(_vm._s(_vm.track.name))]), _vm._v(" "), _c('div', {
    staticClass: "user-info"
  }, [_c('router-link', {
    staticClass: "user-name cursor-pointer",
    staticStyle: {
      "background-color": "black"
    },
    attrs: {
      "to": '/' + _vm.item.user.slug
    }
  }, [_vm._v(_vm._s(_vm.item.user.username) + "???")])], 1)])])] : [_c('div', {
    staticClass: "track-cover-image",
    style: ({
      'background-image': 'url(' + _vm.item.cover.url + ')'
    })
  })]], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "track-info-container"
  }, [_c('div', {
    staticClass: "track-info"
  }, [_c('div', {
    staticClass: "dflex justify-space-between align-center"
  }, [(!_vm.isMini) ? _c('div', {
    staticClass: "follow-meta"
  }, [_c('div', {
    staticClass: "dflex align-center justify-space-between width100"
  }, [_c('div', {
    staticClass: "actions-section flex-none",
    class: {
      _mini: _vm.isMini
    }
  }, [_c('v-menu', {
    staticClass: "dots-wrapper",
    attrs: {
      "offset-y": "",
      "dark": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "slot": "activator",
      "right": ""
    },
    slot: "activator"
  }, [_vm._v("more_horiz")]), _vm._v(" "), _c('v-list', [_c('v-list-tile', [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "depressed": "",
      "color": "transparent ma-0"
    },
    nativeOn: {
      "click": function($event) {
        _vm.showShareModal = true;
        _vm.modalMode = true;
      }
    },
    slot: "activator"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ic_share.svg",
      "width": "20"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Share")])], 1)], 1), _vm._v(" "), (_vm.stripeConnected) ? _c('v-list-tile', [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "depressed": "",
      "color": "transparent ma-0"
    },
    nativeOn: {
      "click": function($event) {
        _vm.showDownloadModal = true;
        _vm.modalMode = true;
      }
    },
    slot: "activator"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ic_download.svg",
      "width": "20"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Download")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile', [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "depressed": "",
      "color": "transparent ma-0"
    },
    nativeOn: {
      "click": function($event) {
        _vm.repostItem()
      }
    },
    slot: "activator"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ic_repost.svg",
      "width": "20"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Repost")])], 1)], 1)], 1)], 1)], 1)])]) : _vm._e()])])])])]), _vm._v(" "), (!_vm.isMini) ? _c('div', {
    staticClass: "player-section-container",
    class: {
      'd-block': _vm.isLoaded,
      'dflex': !_vm.isLoaded
    }
  }, [(!_vm.isLoaded) ? _c('div', {
    staticClass: "loading flex-none",
    attrs: {
      "id": "loading"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isLoaded) ? _c('div', {
    staticClass: "player-section"
  }, [_c('div', {
    staticClass: "controls-section"
  }, [_c('v-btn', {
    staticClass: "player-control-btn no-Btn-bg _prev",
    attrs: {
      "ripple": false,
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.skip('prev')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ic_rewind.svg",
      "width": "20"
    }
  })]), _vm._v(" "), (!_vm.isPlaying) ? _c('v-btn', {
    staticClass: "player-control-btn play no-Btn-bg _play",
    attrs: {
      "ripple": false,
      "flat": "",
      "id": "play"
    },
    nativeOn: {
      "click": function($event) {
        _vm.$root.$emit(_vm.MyEvents.AUDIO_PLAYER_REPLAY)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ic_play.svg",
      "height": "26"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isPlaying) ? _c('v-btn', {
    staticClass: "player-control-btn pause no-Btn-bg _pause",
    attrs: {
      "ripple": false,
      "flat": "",
      "id": "pause"
    },
    nativeOn: {
      "click": function($event) {
        _vm.pause()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ic_pause.svg",
      "height": "26"
    }
  })]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "player-control-btn no-Btn-bg _next",
    attrs: {
      "ripple": false,
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.skip('next')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ic_skip.svg",
      "width": "20"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "bar-section"
  }, [_c('label', {
    staticClass: "duration-time played",
    attrs: {
      "id": "playedTime"
    }
  }, [_vm._v(_vm._s(_vm.playedTime))]), _vm._v(" "), _c('v-spacer', [_c('v-slider', {
    staticClass: "player-bar",
    attrs: {
      "hide-details": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.seek(_vm.progress)
      }
    },
    model: {
      value: (_vm.progress),
      callback: function($$v) {
        _vm.progress = $$v
      },
      expression: "progress"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "duration-time total",
    attrs: {
      "id": "totalTime"
    }
  }, [_vm._v(_vm._s(_vm.totalTime))])], 1)]) : _vm._e(), _vm._v(" "), (_vm.showReminder) ? _c('div', {
    staticClass: "reminder-section"
  }, [_vm._m(0)]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.modalMode),
      callback: function($$v) {
        _vm.modalMode = $$v
      },
      expression: "modalMode"
    }
  }, [(_vm.showShareModal) ? _c('share-modal', {
    attrs: {
      "item": _vm.item,
      "dismiss": _vm.dismissShareDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showDownloadModal) ? _c('download-modal', {
    attrs: {
      "item": _vm.item,
      "track": _vm.track,
      "dismiss": _vm.dismissDownloadDialog
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "dialog-w_auto dialog-no_shadow"
    },
    model: {
      value: (_vm.show_modalCard1),
      callback: function($$v) {
        _vm.show_modalCard1 = $$v
      },
      expression: "show_modalCard1"
    }
  }, [_c('div', {
    staticClass: "modal-card"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": __webpack_require__(19),
      "width": "135px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-card-img"
  }, [_c('div', {
    staticClass: "modal-card-img-inner",
    style: ({
      'background-image': 'url(' + this.user.avatar.thumb.url + ')',
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center user-box"
  }, [_c('p', [_vm._v("Sign up to experience")]), _vm._v(" "), _c('div', {
    staticClass: "user-div"
  }, [_c('p', {
    staticClass: "user-text"
  }, [_vm._v(" " + _vm._s(this.user.username))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(23),
      "width": "15px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "button-wrapper"
  }, [_c('router-link', {
    attrs: {
      "to": "/signup"
    }
  }, [_c('button', {
    staticClass: "modal-button"
  }, [_vm._v("\n              Create account\n            ")])])], 1)])]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "dialog-w_auto dialog-no_shadow"
    },
    model: {
      value: (_vm.show_modalCard2),
      callback: function($$v) {
        _vm.show_modalCard2 = $$v
      },
      expression: "show_modalCard2"
    }
  }, [_c('div', {
    staticClass: "modal-card"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": __webpack_require__(19),
      "width": "135px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-card-img"
  }, [_c('div', {
    staticClass: "modal-card-img-inner",
    style: (("background-image: url(" + _vm.bgDemoImg + ")"))
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center user-box"
  }, [_c('p', [_vm._v("Sign up to experience")]), _vm._v(" "), _c('div', {
    staticClass: "user-div"
  }, [_c('p', {
    staticClass: "user-text"
  }, [_vm._v(" " + _vm._s(this.user.username))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(23),
      "width": "15px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "text-center font-inter"
  }, [_c('p', [_vm._v("Get full access. "), _c('b', [_vm._v("50%")]), _vm._v(" of your subscription is shared with creators you stream most. See who you support!")])]), _vm._v(" "), _c('div', {
    staticClass: "button-wrapper"
  }, [_c('router-link', {
    attrs: {
      "to": "/settings"
    }
  }, [_c('button', {
    staticClass: "modal-button"
  }, [_vm._v("\n\t\t\t\t\t\t\tStart 30 day free trial\n\t\t\t\t\t\t")])])], 1)])]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "dialog-w_50 dialog-no_shadow"
    },
    model: {
      value: (_vm.show_modalCard3),
      callback: function($$v) {
        _vm.show_modalCard3 = $$v
      },
      expression: "show_modalCard3"
    }
  }, [_c('div', {
    staticClass: "modal-card-main"
  }, [_c('div', {
    staticClass: "modal-card-split"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": __webpack_require__(19),
      "width": "135px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-card-img"
  }, [_c('div', {
    staticClass: "modal-card-img-inner",
    style: ({
      'background-image': 'url(' + this.user.avatar.thumb.url + ')',
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "user-box"
  }, [_c('p', [_vm._v("Sign up to experience")]), _vm._v(" "), _c('div', {
    staticClass: "user-div"
  }, [_c('p', {
    staticClass: "user-text"
  }, [_vm._v(_vm._s(this.user.username))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(23),
      "width": "15px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "button-wrapper"
  }, [_c('router-link', {
    attrs: {
      "to": "/signup"
    }
  }, [_c('button', {
    staticClass: "modal-button"
  }, [_vm._v("\n                Create account\n              ")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-card-title-img",
    style: (("background-image: url(" + _vm.videoLoading + ")"))
  }, [_c('video', {
    attrs: {
      "playsinline": "",
      "autoplay": "",
      "loop": "",
      "id": "bgvid"
    }
  }, [(_vm.spotlightVideoSource) ? _c('source', {
    attrs: {
      "src": ("https://stream.mux.com/" + _vm.spotlightVideoSource + "/low.mp4"),
      "type": "video/mp4"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "volume-button"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(43),
      "width": "17px"
    }
  })])])])]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "dialog-w_50 dialog-no_shadow"
    },
    model: {
      value: (_vm.show_modalCard4),
      callback: function($$v) {
        _vm.show_modalCard4 = $$v
      },
      expression: "show_modalCard4"
    }
  }, [_c('div', {
    staticClass: "modal-card-main"
  }, [_c('div', {
    staticClass: "modal-card-split"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": __webpack_require__(19),
      "width": "135px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-card-img"
  }, [_c('div', {
    staticClass: "modal-card-img-inner",
    style: ({
      'background-image': 'url(' + this.user.avatar.thumb.url + ')',
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "user-box"
  }, [_c('p', [_vm._v("Sign up to experience")]), _vm._v(" "), _c('div', {
    staticClass: "user-div"
  }, [_c('p', {
    staticClass: "user-text"
  }, [_vm._v(_vm._s(this.user.username))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(23),
      "width": "15px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "font-inter"
  }, [_c('p', [_vm._v("Get full access. "), _c('b', [_vm._v("50%")]), _vm._v(" of your subscription is shared with creators you stream most. See who you support!")])]), _vm._v(" "), _c('div', {
    staticClass: "button-wrapper"
  }, [_c('router-link', {
    attrs: {
      "to": "/settings"
    }
  }, [_c('button', {
    staticClass: "modal-button"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tStart 30 day free trial\n\t\t\t\t\t\t\t")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-card-title-img",
    style: (("background-image: url(" + _vm.videoLoading + ")"))
  }, [_c('video', {
    attrs: {
      "playsinline": "",
      "autoplay": "",
      "loop": "",
      "id": "bgvid"
    }
  }, [(_vm.spotlightVideoSource) ? _c('source', {
    attrs: {
      "src": ("https://stream.mux.com/" + _vm.spotlightVideoSource + "/low.mp4"),
      "type": "video/mp4"
    }
  }) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "volume-button"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(43),
      "width": "17px"
    }
  })])])])])], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "media d-flex"
  }, [_c('div', {
    staticClass: "media__image"
  }), _vm._v(" "), _c('div', {
    staticClass: "media__content"
  }, [_c('div', {
    staticClass: "media__title"
  }, [_vm._v("Reminder!")]), _vm._v(" "), _c('div', {
    staticClass: "media__description"
  }, [_vm._v("\n              Support your favorite artists & brands\n            ")])])])
}]}

/***/ }),
/* 1616 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "progress-bar-main",
    on: {
      "click": function($event) {
        _vm.pauseChart = !_vm.pauseChart
      }
    }
  }, [(_vm.pauseChart) ? _c('img', {
    attrs: {
      "src": __webpack_require__(1528),
      "width": "10"
    }
  }) : _c('img', {
    attrs: {
      "src": __webpack_require__(1527),
      "width": "10"
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 1617 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-section"
  }, [_c('h2', [_vm._v("Sample Clearance License")]), _vm._v(" "), _c('p', [_vm._v("YouSound Inc. (“YouSound”) is not a law firm and does not provide legal services or legal advice. Distribution of YouSound Inc. licenses does not create a lawyer-client or other relationship. YouSound Inc. makes its licenses and related information available on an “as-is” basis. YouSound Inc. gives no warranties regarding its licenses, any material licensed under their terms and conditions, or any related information. YouSound Inc. disclaims all liability for damages resulting from their use to the fullest extent possible.")]), _vm._v(" "), _c('h3', [_vm._v("Using YouSound Cleared Samples")]), _vm._v(" "), _c('p', [_vm._v("The YouSound Inc. Sample Clearance License provides a standard set of terms and conditions that creators and other rights holders may use to share original works of authorship and other material subject to copyright and certain other rights specified in the Sample Clearance  below. YouSound Sample Clearance License is a modified version of the Creative Commons Attribution-ShareAlike 4.0 International intended to allow licensors to allow the public to publish their audio content on YouSound.com & any of it’s officially affiliated websites.  YouSound Sample Clearance Licenses are only intended for use on YouSound.com and no other platform, digital or physical.  Licensors only grant YouSound Sample Clearance Licenses to Verified Artists on YouSound.com to upload, distribute, and broadcast on the YouSound.com platform and all of it’s officially connected affiliated sites.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Considerations for licensors")]), _vm._v(":  YouSound Sample Clearance Licenses are intended for use by those authorized to give the public permission to use material in ways otherwise restricted by copyright and certain other rights. Our licenses are irrevocable. Licensors should read and understand the terms and conditions of the license they choose before applying it. Licensors should also secure all rights necessary before applying our licenses so that the public can reuse the material as expected. Licensors should clearly mark any material not subject to the license. This includes other material used under an exception or limitation to copyright:")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Irrevocability")]), _vm._v(": Remember the license may not be revoked.  Once you apply a YouSound Sample Clearance License to your material, anyone who receives it may rely on that license for as long as the material is protected by copyright and similar rights, even if you later stop distributing it.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Type of material")]), _vm._v(": Make sure the material is appropriate for YouSound Sample Clearance Licensing, and are appropriate for all types of content you want to share publicly, except for software and hardware.  YouSound Sample Clearance licenses may be applied to any type of work, including music, videos, text, photographs, and many other types of material.  The only categories of works for which CC does not recommend its licenses are computer software and hardware.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Nature and adequacy of rights")]), _vm._v(": Make sure the material is subject to copyright or similar rights.  YouSound Sample Clearance Licenses are operative only where copyright, sui generis database rights, or other rights closely related to copyright come into play. They should not be applied to material in the public domain.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Clear rights needed to use the material")]), _vm._v(".  If the material includes rights held by others, you must get permission in writing to sublicense those rights under the YouSound Sample Clearance License. If you created the material in the scope of your employment or as a work-for-hire, you may not be the holder of the rights and may need to get permission before applying a YouSound Sample Clearance License.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Considerations for the public")]), _vm._v(": By using one of our YouSound Sample Clearance Licenses, a licensor grants the public permission to use the licensed material for upload, distribution, and broadcasting on YouSound.com and any of it’s officially affiliated websites. If the licensor’s permission is not necessary for any reason–for example, because of any applicable exception or limitation to copyright–then that use is not regulated by the license. Our licenses grant only permissions under copyright and certain other rights that a licensor has authority to grant. Use of the licensed material may still be restricted for other reasons, including because others have copyright or other rights in the material. ")]), _vm._v(" "), _c('h3', [_vm._v("YouSound Sample Clearance License")]), _vm._v(" "), _c('p', [_vm._v("By exercising the Licensed Rights (defined below), You accept and agree to be bound by the terms and conditions of this YouSound Sample Clearance License  (\"Sample Clearance \"). To the extent this Sample Clearance  may be interpreted as a contract, You are granted the Licensed Rights in consideration of Your acceptance of these terms and conditions, and the Licensor grants You such rights in consideration of benefits the Licensor receives from making the Licensed Material available under these terms and conditions.")]), _vm._v(" "), _c('h3', [_vm._v("Section 1 – Definitions.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("a. Adapted Material")]), _vm._v(" means material subject to Copyright and Similar Rights that is derived from or based upon the Licensed Material and in which the Licensed Material is translated, altered, arranged, transformed, or otherwise modified in a manner requiring permission under the Copyright and Similar Rights held by the Licensor. For purposes of this Sample Clearance , where the Licensed Material is a musical work, performance, or sound recording, Adapted Material is always produced where the Licensed Material is synced in timed relation with a moving image. ")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("b. Adapter's License")]), _vm._v(" means the license You apply to Your Copyright and Similar Rights in Your contributions to Adapted Material in accordance with the terms and conditions of this Sample Clearance .")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("c. Copyright and Similar Rights")]), _vm._v(" means copyright and/or similar rights closely related to copyright including, without limitation, performance, broadcast, sound recording, and Sui Generis Database Rights, without regard to how the rights are labeled or categorized. For purposes of this Sample Clearance , the rights specified in Section 2(b)(1)-(2) are not Copyright and Similar Rights.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("d. Effective Technological Measures")]), _vm._v(" means those measures that, in the absence of proper authority, may not be circumvented under laws fulfilling obligations under Article 11 of the WIPO Copyright Treaty adopted on December 20, 1996, and/or similar international agreements.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("e. Exceptions and Limitations")]), _vm._v(" means fair use, fair dealing, and/or any other exception or limitation to Copyright and Similar Rights that applies to Your use of the Licensed Material.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("f. License Elements")]), _vm._v(" means the license attributes listed in the name of a Sample Clearance.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("g. Licensed Material")]), _vm._v(" means the artistic or other material to which the Licensor applied this Sample Clearance .")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("h. Licensed Rights")]), _vm._v(" means the rights granted to You subject to the terms and conditions of this Sample Clearance , which are limited to all Copyright and Similar Rights that apply to Your use of the Licensed Material and that the Licensor has authority to license.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("i. Licensor ")]), _vm._v(" means the individual(s) or entity(ies) granting rights under this Sample Clearance.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("j. Share ")]), _vm._v(" means to provide material to the public by any means or process that requires permission under the Licensed Rights, such as reproduction, public display, public performance, distribution, dissemination, communication, or importation, and to make material available to the public including in ways that members of the public may access the material from a place and at a time individually chosen by them.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("k. Sui Generis Database Rights ")]), _vm._v(" means rights other than copyright resulting from Directive 96/9/EC of the European Parliament and of the Council of 11 March 1996 on the legal protection of databases, as amended and/or succeeded, as well as other essentially equivalent rights anywhere in the world.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("l. You ")]), _vm._v(" means the individual or entity exercising the Licensed Rights under this Sample Clearance . Your has a corresponding meaning..")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('h3', [_vm._v("Section 2 – Scope.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("a. License Grant.")])]), _vm._v(" "), _c('p', [_vm._v("1. Subject to the terms and conditions of this Sample Clearance , the Licensor hereby grants You a worldwide, royalty-free, non-sublicensable, non-exclusive, irrevocable license to exercise the Licensed Rights in the Licensed Material to:")]), _vm._v(" "), _c('li', [_vm._v("A.\treproduce and Share the Licensed Material, in whole or in part exclusively on YouSound.com ; and")]), _vm._v(" "), _c('li', [_vm._v("B.\tproduce, reproduce, and Share Adapted Material exclusively on YouSound.com.")]), _vm._v(" "), _c('li', [_vm._v("C.\tYou must modify the Licensed Material in whole or part, and include it into your own creative work. ")]), _vm._v(" "), _c('li', [_vm._v("D.\tSample Clearance is only valid for modifications of Licensed Material. ")]), _vm._v(" "), _c('li', [_vm._v("E.\tIf Licensed Material has not been modified by Licensee, it can not be uploaded, distributed or broadcasted on YouSound.com and it’s officially affiliated websites. ")]), _vm._v(" "), _c('p', [_vm._v("2. Exceptions and Limitations. For the avoidance of doubt, where Exceptions and Limitations apply to Your use, this Sample Clearance  does not apply, and You do not need to comply with its terms and conditions.")]), _vm._v(" "), _c('p', [_vm._v("3. Term. The term of this Sample Clearance  is specified in Section 6(a).")]), _vm._v(" "), _c('p', [_vm._v("4.\tMedia and formats; technical modifications allowed. The Licensor authorizes You to exercise the Licensed Rights in all media and formats whether now known or hereafter created, and to make technical modifications necessary to do so. The Licensor waives and/or agrees not to assert any right or authority to forbid You from making technical modifications necessary to exercise the Licensed Rights, including technical modifications necessary to circumvent Effective Technological Measures.")]), _vm._v(" "), _c('p', [_vm._v("5. Downstream recipients.")]), _vm._v(" "), _c('li', [_vm._v("A.\tOffer from the Licensor – Licensed Material. Every recipient of the Licensed Material automatically receives an offer from the Licensor to exercise the Licensed Rights under the terms and conditions of this Sample Clearance .")]), _vm._v(" "), _c('li', [_vm._v("B.\tAdditional offer from the Licensor – Adapted Material. Every recipient of Adapted Material from You automatically receives an offer from the Licensor to exercise the Licensed Rights in the Adapted Material under the conditions of the Adapter’s License You apply. ")]), _vm._v(" "), _c('li', [_vm._v("C.\tNo downstream restrictions. You may not offer or impose any additional or different terms or conditions on, or apply any Effective Technological Measures to, the Licensed Material if doing so restricts exercise of the Licensed Rights by any recipient of the Licensed Material.")]), _vm._v(" "), _c('p', [_vm._v("6.  No endorsement. Nothing in this Sample Clearance constitutes or may be construed as permission to assert or imply that You are, or that Your use of the Licensed Material is, connected with, or sponsored, endorsed, or granted official status by, the Licensor or others designated to receive attribution as provided in Section 3(a)(1)(A)(i).")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("b. Other Rights")])]), _vm._v(" "), _c('li', [_vm._v("1.\tMoral rights, such as the right of integrity, are not licensed under this Sample Clearance , nor are publicity, privacy, and/or other similar personality rights; however, to the extent possible, the Licensor waives and/or agrees not to assert any such rights held by the Licensor to the limited extent necessary to allow You to exercise the Licensed Rights, but not otherwise.")]), _vm._v(" "), _c('li', [_vm._v("2. Patent and trademark rights are not licensed under this Sample Clearance. ")]), _vm._v(" "), _c('li', [_vm._v("3.\tTo the extent possible, the Licensor waives any right to collect royalties from You for the exercise of the Licensed Rights, whether directly or through a collecting society under any voluntary or waivable statutory or compulsory licensing scheme. In all other cases the Licensor expressly reserves any right to collect such royalties.")]), _vm._v(" "), _c('h3', [_vm._v("Section 3 – License Conditions.")]), _vm._v(" "), _c('p', [_vm._v("Your exercise of the Licensed Rights is expressly made subject to the following conditions.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("a. Attribution.")])]), _vm._v(" "), _c('li', [_vm._v("1.\tIf You Share the Licensed Material (including in modified form):")]), _vm._v(" "), _c('li', [_vm._v("A.\tYouSound.com retains and publicly displays:")]), _vm._v(" "), _c('li', [_vm._v("i.\tidentification of the creator(s) of the Licensed Material and any others designated to receive attribution on Licensees Album page under the Album Credits section;")]), _vm._v(" "), _c('li', [_vm._v("ii.   a hyperlink to the Licensed Material on YouSound.com;")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("b. ShareAlike")]), _vm._v("  In addition to the conditions in Section 3(a), if You Share Adapted Material You produce, the following conditions also apply. ")]), _vm._v(" "), _c('li', [_vm._v("1. When You upload your Adapted Material you must attach the Licensed Material on the Upload page you use to upload Your Adapted Material.")]), _vm._v(" "), _c('li', [_vm._v("2. You may not offer or impose any additional or different terms or conditions on, or apply any Effective Technological Measures to, Adapted Material that restrict exercise of the rights granted under the Adapter's License You apply.")]), _vm._v(" "), _c('h3', [_vm._v("Section 4 – Sui Generis Database Rights.")]), _vm._v(" "), _c('p', [_vm._v("Where the Licensed Rights include Sui Generis Database Rights that apply to Your use of the Licensed Material:")]), _vm._v(" "), _c('li', [_vm._v("a.\tfor the avoidance of doubt, Section 2(a)(1) grants You the right to extract, reuse, reproduce, and Share all or a substantial portion of the contents of the database;")]), _vm._v(" "), _c('li', [_vm._v("b.\tif You include all or a substantial portion of the database contents in a database in which You have Sui Generis Database Rights, then the database in which You have Sui Generis Database Rights (but not its individual contents) is Adapted Material, including for purposes of Section 3(b); and")]), _vm._v(" "), _c('li', [_vm._v("c.\tYou must comply with the conditions in Section 3(a) if You Share all or a substantial portion of the contents of the database.")]), _vm._v(" "), _c('p', [_vm._v("For the avoidance of doubt, this Section 4 supplements and does not replace Your obligations under this Sample Clearance  where the Licensed Rights include other Copyright and Similar Rights.")]), _vm._v(" "), _c('h3', [_vm._v("Section 5 – Disclaimer of Warranties and Limitation of Liability.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("a.\tUnless otherwise separately undertaken by the Licensor, to the extent possible, the Licensor offers the Licensed Material as-is and as-available, and makes no representations or warranties of any kind concerning the Licensed Material, whether express, implied, statutory, or other. This includes, without limitation, warranties of title, merchantability, fitness for a particular purpose, non-infringement, absence of latent or other defects, accuracy, or the presence or absence of errors, whether or not known or discoverable. Where disclaimers of warranties are not allowed in full or in part, this disclaimer may not apply to You.")]), _c('p')]), _c('li', [_c('strong', [_vm._v("b.\tTo the extent possible, in no event will the Licensor be liable to You on any legal theory (including, without limitation, negligence) or otherwise for any direct, special, indirect, incidental, consequential, punitive, exemplary, or other losses, costs, expenses, or damages arising out of this Sample Clearance  or use of the Licensed Material, even if the Licensor has been advised of the possibility of such losses, costs, expenses, or damages. Where a limitation of liability is not allowed in full or in part, this limitation may not apply to You.")]), _c('p')]), _c('li', [_vm._v("c.\tThe disclaimer of warranties and limitation of liability provided above shall be interpreted in a manner that, to the extent possible, most closely approximates an absolute disclaimer and waiver of all liability.")]), _vm._v(" "), _c('h3', [_vm._v("Section 6 – Term and Termination.")]), _vm._v(" "), _c('li', [_vm._v("a.\tThis Sample Clearance  applies for the term of the Copyright and Similar Rights licensed here. However, if You fail to comply with this Sample Clearance , then Your rights under this Sample Clearance  terminate automatically.")]), _vm._v(" "), _c('li', [_vm._v("b.\tWhere Your right to use the Licensed Material has terminated under Section 6(a), it reinstates:")]), _vm._v(" "), _c('li', [_vm._v("1.\tautomatically as of the date the violation is cured, provided it is cured within 30 days of Your discovery of the violation; or")]), _vm._v(" "), _c('li', [_vm._v("2.\tupon express reinstatement by the Licensor.")]), _vm._v(" "), _c('li', [_vm._v("c.\tFor the avoidance of doubt, this Section 6(b) does not affect any right the Licensor may have to seek remedies for Your violations of this Sample Clearance. ")]), _vm._v(" "), _c('li', [_vm._v("d.\tFor the avoidance of doubt, the Licensor may also offer the Licensed Material under separate terms or conditions or stop distributing the Licensed Material at any time; however, doing so will not terminate this Sample Clearance .")]), _vm._v(" "), _c('li', [_vm._v("e.\tSections 1, 5, 6, 7, and 8 survive termination of this Sample Clearance .")]), _vm._v(" "), _c('h3', [_vm._v("Section 7 – Other Terms and Conditions.")]), _vm._v(" "), _c('li', [_vm._v("a.\tThe Licensor shall not be bound by any additional or different terms or conditions communicated by You unless expressly agreed.")]), _vm._v(" "), _c('li', [_vm._v("b.\tAny arrangements, understandings, or agreements regarding the Licensed Material not stated herein are separate from and independent of the terms and conditions of this Sample Clearance .")]), _vm._v(" "), _c('h3', [_vm._v("Section 8 – Interpretation.")]), _vm._v(" "), _c('li', [_vm._v("a.\tFor the avoidance of doubt, this Sample Clearance  does not, and shall not be interpreted to, reduce, limit, restrict, or impose conditions on any use of the Licensed Material that could lawfully be made without permission under this Sample Clearance. ")]), _vm._v(" "), _c('li', [_vm._v("b.\tTo the extent possible, if any provision of this Sample Clearance  is deemed unenforceable, it shall be automatically reformed to the minimum extent necessary to make it enforceable. If the provision cannot be reformed, it shall be severed from this Sample Clearance  without affecting the enforceability of the remaining terms and conditions.")]), _vm._v(" "), _c('li', [_vm._v("c.\tNo term or condition of this Sample Clearance will be waived and no failure to comply consented to unless expressly agreed to by the Licensor.")]), _vm._v(" "), _c('li', [_vm._v("d.\tNothing in this Sample Clearance  constitutes or may be interpreted as a limitation upon, or waiver of, any privileges and immunities that apply to the Licensor or You, including from the legal processes of any jurisdiction or authority.")]), _vm._v(" "), _c('p', [_vm._v("YouSound Inc. is not a party to it’s Sample Clearances.  Notwithstanding, YouSound Inc. may elect to apply one of its Sample Clearances to material it publishes and in those instances will be considered the “Licensor.” Except for the limited purpose of indicating that material is shared under a YouSound Inc. Sample Clearance  or as otherwise permitted by the YouSound Inc. policies published at YouSound's Terms & Policy pages.  YouSound Inc. does not authorize the use of the trademark “YouSound Inc.” or any other trademark or logo of YouSound Inc. without its prior written consent including, without limitation, in connection with any unauthorized modifications to any of its Sample Clearance s or any other arrangements, understandings, or agreements concerning use of licensed material. For the avoidance of doubt, this paragraph does not form part of the Sample Clearances.")])])
}]}

/***/ }),
/* 1618 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "promote-modal-section",
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-flex', {
    staticClass: "dismiss-section",
    attrs: {
      "xs12": "",
      "sm12": ""
    },
    on: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "popup-section",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "main-section text-left",
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('h2', {
    staticClass: "page-title text-xs-left"
  }, [_vm._v("Promote")]), _vm._v(" "), _c('div', {
    staticClass: "normal-tab"
  }, [_c('v-tabs', {
    attrs: {
      "dark": ""
    },
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, [_c('v-tabs-bar', {
    staticClass: "transparent"
  }, [_c('v-tabs-item', {
    key: "suggested",
    attrs: {
      "href": "#suggested",
      "ripple": ""
    }
  }, [_vm._v("Suggested Reposters")]), _vm._v(" "), _c('v-tabs-item', {
    key: "current",
    attrs: {
      "href": "#current",
      "ripple": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.getCurrentReposters()
      }
    }
  }, [_vm._v("Current Reposters")]), _vm._v(" "), _c('v-tabs-slider', {
    attrs: {
      "color": "black"
    }
  })], 1), _vm._v(" "), (_vm.tab == 'suggested') ? _c('v-layout', {
    staticClass: "search-section",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm2": "",
      "mx-1": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.repost_prices,
      "item-text": "title",
      "item-value": "value",
      "single-line": "",
      "bottom": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.repost_price),
      callback: function($$v) {
        _vm.repost_price = $$v
      },
      expression: "repost_price"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm2": "",
      "mx-1": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.amounts,
      "item-text": "title",
      "item-value": "value",
      "single-line": "",
      "bottom": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.amount),
      callback: function($$v) {
        _vm.amount = $$v
      },
      expression: "amount"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm2": "",
      "mx-1": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.filters,
      "item-text": "title",
      "item-value": "value",
      "label": "Category",
      "single-line": "",
      "bottom": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm2": "",
      "mx-1": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    staticClass: "form-control search-box",
    attrs: {
      "type": "text",
      "placeholder": "Search Username"
    },
    domProps: {
      "value": (_vm.keyword)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.searchUsers()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm2": "",
      "mx-1": ""
    }
  }, [_c('v-btn', {
    staticClass: "search-btn",
    nativeOn: {
      "click": function($event) {
        _vm.searchUsers()
      }
    }
  }, [_vm._v("Search")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-tabs-items', [_c('v-tabs-content', {
    key: "suggested",
    attrs: {
      "id": "suggested"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "header-title",
    attrs: {
      "sm1": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    staticClass: "header-title text-xs-left pl-2",
    attrs: {
      "sm2": ""
    }
  }, [_vm._v("User")]), _vm._v(" "), _c('v-flex', {
    staticClass: "header-title",
    attrs: {
      "sm2": ""
    }
  }, [_vm._v("Followers")]), _vm._v(" "), _c('v-flex', {
    staticClass: "header-title",
    attrs: {
      "sm2": ""
    }
  }, [_vm._v("Price")]), _vm._v(" "), _c('v-flex', {
    staticClass: "header-title text-xs-left px-2",
    attrs: {
      "sm3": ""
    }
  }, [_vm._v("Recent Reposts")]), _vm._v(" "), _c('v-flex', {
    staticClass: "header-title",
    attrs: {
      "sm2": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "user-list-section"
  }, _vm._l((_vm.users), function(user, index) {
    return _c('v-layout', {
      key: index,
      staticClass: "suggested-reposter-item",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "sm1": ""
      }
    }, [_c('div', {
      staticClass: "user-avatar",
      style: (("background-image: url(" + (user.avatar.thumb.url) + ")"))
    })]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "sm2": ""
      }
    }, [_c('p', {
      staticClass: "user-name text-xs-left pl-2"
    }, [_vm._v("\n                        " + _vm._s(user.username) + "\n                      ")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "sm2": ""
      }
    }, [_c('p', {
      staticClass: "user-followers"
    }, [_vm._v(_vm._s(user.followers))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "sm2": ""
      }
    }, [_c('p', {
      staticClass: "repost-price"
    }, [_vm._v("\n                        $" + _vm._s(_vm._f("formatNumber")(user.repost_price)) + "\n                      ")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "sm3": ""
      }
    }, [_c('div', {
      staticClass: "recent-posts text-xs-left px-2"
    }, _vm._l((user.recent_items), function(recent_item, index) {
      return _c('div', {
        key: index,
        staticClass: "recent-post-item"
      }, [(recent_item.assoc_type == 'Album') ? _c('activity-album-card', {
        attrs: {
          "object": recent_item.assoc
        }
      }) : _vm._e(), _vm._v(" "), (recent_item.assoc_type == 'ShopProduct') ? _c('activity-product-card', {
        attrs: {
          "object": recent_item.assoc,
          "price-show": false
        }
      }) : _vm._e()], 1)
    }))]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "sm2": ""
      }
    }, [_c('v-btn', {
      staticClass: "select-btn",
      class: {
        selected: _vm.user_ids.indexOf(user.id) > -1
      },
      nativeOn: {
        "click": function($event) {
          _vm.selectUser(user)
        }
      }
    }, [_vm._v("Select User")])], 1)], 1)
  })), _vm._v(" "), _c('div', {
    staticClass: "total-section"
  }, [_c('v-btn', {
    staticClass: "finish-btn ml-3 mt-1",
    nativeOn: {
      "click": function($event) {
        _vm.saveAndFinish()
      }
    }
  }, [_vm._v("Finish & Pay")]), _vm._v(" "), _c('div', {
    staticClass: "total-potential-section px-3"
  }, [_c('p', {
    staticClass: "title mb-1"
  }, [_vm._v("Total Potential Reach")]), _vm._v(" "), _c('p', {
    staticClass: "value"
  }, [_vm._v("\n                      " + _vm._s(_vm.suggested_values.total_potential_reach) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "cost-section px-3"
  }, [_c('p', {
    staticClass: "title mb-1"
  }, [_vm._v("Cost")]), _vm._v(" "), _c('p', {
    staticClass: "value"
  }, [_vm._v("\n                      $" + _vm._s(_vm._f("formatNumber")(_vm.suggested_values.total_cost)) + "\n                    ")])])], 1)], 1)], 1), _vm._v(" "), _c('v-tabs-content', {
    key: "current",
    attrs: {
      "id": "current"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "header-title",
    attrs: {
      "sm1": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    staticClass: "header-title text-xs-left pl-2",
    attrs: {
      "sm3": ""
    }
  }, [_vm._v("User")]), _vm._v(" "), _c('v-flex', {
    staticClass: "header-title",
    attrs: {
      "sm2": ""
    }
  }, [_vm._v("Followers")]), _vm._v(" "), _c('v-flex', {
    staticClass: "header-title",
    attrs: {
      "sm2": ""
    }
  }, [_vm._v("Price")]), _vm._v(" "), _c('v-flex', {
    staticClass: "header-title text-xs-left px-2",
    attrs: {
      "sm2": ""
    }
  }, [_vm._v("Actual Reach(Plays)")]), _vm._v(" "), _c('v-flex', {
    staticClass: "header-title",
    attrs: {
      "sm2": ""
    }
  }, [_vm._v("Add to favorites")])], 1), _vm._v(" "), _c('div', {
    staticClass: "user-list-section current"
  }, _vm._l((_vm.reposters), function(user, index) {
    return _c('v-layout', {
      key: index,
      staticClass: "suggested-reposter-item",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "sm1": ""
      }
    }, [_c('div', {
      staticClass: "user-avatar",
      style: (("background-image: url(" + (user.avatar.thumb.url) + ")"))
    })]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "sm3": ""
      }
    }, [_c('p', {
      staticClass: "user-name text-xs-left pl-2"
    }, [_vm._v("\n                        " + _vm._s(user.username) + "\n                      ")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "sm2": ""
      }
    }, [_c('p', {
      staticClass: "user-followers"
    }, [_vm._v(_vm._s(user.followers))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "sm2": ""
      }
    }, [_c('p', {
      staticClass: "repost-price"
    }, [_vm._v("\n                        $" + _vm._s(_vm._f("formatNumber")(user.repost_price)) + "\n                      ")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "sm2": ""
      }
    }), _vm._v(" "), _c('v-flex', {
      attrs: {
        "sm2": ""
      }
    }, [(_vm.favorite_ids.indexOf(user.id) > -1) ? _c('v-btn', {
      staticClass: "favorite-btn",
      nativeOn: {
        "click": function($event) {
          _vm.addUserToFavorite(user)
        }
      }
    }, [_c('v-icon', [_vm._v("favorite")])], 1) : _vm._e(), _vm._v(" "), (_vm.favorite_ids.indexOf(user.id) < 0) ? _c('v-btn', {
      staticClass: "favorite-btn",
      nativeOn: {
        "click": function($event) {
          _vm.addUserToFavorite(user)
        }
      }
    }, [_c('v-icon', [_vm._v("favorite_border")])], 1) : _vm._e()], 1)], 1)
  })), _vm._v(" "), _c('div', {
    staticClass: "total-section"
  }, [_c('div', {
    staticClass: "cost-section px-3"
  }, [_c('p', {
    staticClass: "title mb-1"
  }, [_vm._v("Paid")]), _vm._v(" "), _c('p', {
    staticClass: "value"
  }, [_vm._v("\n                      $" + _vm._s(_vm._f("formatNumber")(_vm.current_values.total_paid)) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "total-potential-section px-3"
  }, [_c('p', {
    staticClass: "title mb-1"
  }, [_vm._v("Total Potential Reach")]), _vm._v(" "), _c('p', {
    staticClass: "value"
  }, [_vm._v("\n                      " + _vm._s(_vm.current_values.total_potential_reach) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "cost-section px-3"
  }, [_c('p', {
    staticClass: "title mb-1"
  }, [_vm._v("Total Actual Reach")]), _vm._v(" "), _c('p', {
    staticClass: "value"
  }, [_vm._v("\n                      " + _vm._s(_vm.current_values.total_actual_reach) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "total-potential-section px-3"
  }, [_c('p', {
    staticClass: "title mb-1"
  }, [_vm._v("Score")]), _vm._v(" "), _c('p', {
    staticClass: "value"
  }, [_vm._v("0%")])])])], 1)], 1)], 1)], 1)], 1)])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1619 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "full-height",
    attrs: {
      "xs3": ""
    }
  }, [_c('v-tabs', {
    staticClass: "full-height",
    attrs: {
      "centered": "",
      "grow": ""
    }
  }, [_c('v-tabs-bar', {
    staticClass: "grey lighten-4",
    attrs: {
      "slot": "activators"
    },
    slot: "activators"
  }, [_c('v-tabs-slider', {
    attrs: {
      "color": "black primary"
    }
  }), _vm._v(" "), _c('v-tabs-item', {
    attrs: {
      "href": "#tab-online"
    }
  }, [_c('v-icon', [_vm._v("people")])], 1), _vm._v(" "), (_vm.admin) ? _c('v-tabs-item', {
    staticClass: "black--text",
    attrs: {
      "href": "#tab-settings"
    }
  }, [_c('v-icon', [_vm._v("settings")])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-tabs-content', {
    staticClass: "full-height",
    attrs: {
      "id": "tab-online"
    }
  }, [_c('v-card', {
    staticClass: "full-height",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "full-height"
  }, [_vm._l((_vm.onlineUsers), function(user) {
    return _c('v-flex', {
      key: user.username,
      staticClass: "text-xs-left"
    }, [_c('v-layout', {
      attrs: {
        "row": ""
      }
    }, [_c('div', [_c('img', {
      staticClass: "pic",
      attrs: {
        "src": user.avatar.thumb.url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "bubble online"
    })]), _vm._v(" "), _c('div', {
      staticClass: "msg-name"
    }, [_c('user-modal', {
      attrs: {
        "user": user
      }
    })], 1)])], 1)
  }), _vm._v(" "), _vm._l((_vm.idleUsers), function(user) {
    return _c('v-flex', {
      key: user.username,
      staticClass: "text-xs-left"
    }, [_c('v-layout', {
      attrs: {
        "row": ""
      }
    }, [_c('div', [_c('img', {
      staticClass: "pic",
      attrs: {
        "src": user.avatar.thumb.url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "bubble idle"
    })]), _vm._v(" "), _c('div', {
      staticClass: "msg-name"
    }, [_c('user-modal', {
      attrs: {
        "user": user
      }
    })], 1)])], 1)
  })], 2)], 1)], 1), _vm._v(" "), (_vm.admin) ? _c('v-tabs-content', {
    attrs: {
      "id": "tab-settings"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [(_vm.admin) ? [_c('v-switch', {
    attrs: {
      "label": "Enable links?"
    },
    model: {
      value: (_vm.room.settings.links),
      callback: function($$v) {
        _vm.$set(_vm.room.settings, "links", $$v)
      },
      expression: "room.settings.links"
    }
  }), _vm._v(" "), _c('v-switch', {
    attrs: {
      "label": "Character limit?"
    },
    model: {
      value: (_vm.room.settings.charLimitBool),
      callback: function($$v) {
        _vm.$set(_vm.room.settings, "charLimitBool", $$v)
      },
      expression: "room.settings.charLimitBool"
    }
  }), _vm._v(" "), (_vm.room.settings.charLimitBool) ? _c('v-text-field', {
    attrs: {
      "label": "Limit",
      "placeholder": "# of characters",
      "rules": [_vm.rules.number]
    },
    model: {
      value: (_vm.room.settings.charLimit),
      callback: function($$v) {
        _vm.$set(_vm.room.settings, "charLimit", $$v)
      },
      expression: "room.settings.charLimit"
    }
  }) : _vm._e()] : _vm._e(), _vm._v(" "), void 0], 2)], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1620 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page messages-page"
  }, [(_vm.show_stopPopup) ? _c('div', {
    staticClass: "messages-stop-music-section"
  }, [_c('div', {
    staticClass: "popup-section"
  }, [_c('img', {
    staticClass: "popup-image",
    attrs: {
      "src": "/static/images/earphone.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "popup-title"
  }, [_vm._v("Direct Messages")]), _vm._v(" "), _c('p', {
    staticClass: "popup-text"
  }, [_vm._v("\n        Direct messages is where you can share music + product directly, view\n        repost requests & approve collaborations.\n      ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "gotta-btn",
    nativeOn: {
      "click": function($event) {
        _vm.setVisitedTime()
      }
    }
  }, [_vm._v("Ok. Got it!")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.currentUser) ? _c('v-container', {
    staticClass: "messages-page-content",
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "row": ""
    }
  }, [(!_vm.conversations || _vm.conversations.length == 0) ? _c('v-flex', {
    staticClass: "message-rooms-section empty-section",
    attrs: {
      "xs12": "",
      "pa-0": ""
    }
  }, [_c('p', {
    staticClass: "empty-title"
  }, [_vm._v("No messages")]), _vm._v(" "), _c('p', {
    staticClass: "empty-description"
  }, [_vm._v("Your conversations will appear here.")])]) : [_c('v-flex', {
    staticClass: "conversations",
    attrs: {
      "xs12": "",
      "sm3": "",
      "pa-0": ""
    }
  }, [_c('div', {
    staticClass: "conversations__header"
  }, [_c('div', {
    staticClass: "d-flex justify-space-between align-center"
  }, [_c('div', {
    staticClass: "conversations__count"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1557),
      "alt": "conversation",
      "width": "16"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.conversations.length < 99 ? _vm.conversations.length : "99+") + " conversations")])]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('div', {
    staticClass: "mode-toggle",
    on: {
      "click": _vm.modeToggle
    }
  }, [_c('div', {
    staticClass: "toggle"
  }, [_c('div', {
    attrs: {
      "id": "dark-mode",
      "type": "checkbox"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "conversations__content"
  }, _vm._l((_vm.conversations), function(conv) {
    return _c('div', {
      key: ("conversation-" + (conv.id)),
      staticClass: "message-room-item",
      class: {
        new: conv.last_message && !conv.last_message.is_read,
        selected: conv.id == _vm.conversation.id,
      },
      on: {
        "click": function($event) {
          _vm.selectedConversation(conv)
        }
      }
    }, [_c('div', {
      staticClass: "avatar-area"
    }, [_c('router-link', {
      attrs: {
        "to": ("/" + (conv.other.slug))
      }
    }, [(!conv.other.length) ? _c('div', {
      staticClass: "avatar-image",
      style: ('background-image: url(' +
        conv.other.avatar.thumb.url +
        ');')
    }) : _vm._e()])], 1), _vm._v(" "), _c('div', {
      staticClass: "detail-area"
    }, [_c('div', {
      staticClass: "conversation-info"
    }, [_c('div', {
      staticClass: "user-name"
    }, [_vm._v(_vm._s(conv.other.display_name))]), _vm._v(" "), _c('div', {
      staticClass: "messaged-time"
    }, [_vm._v("\n                    " + _vm._s(_vm.datetimePeriodFormat(new Date(conv.last_message.created_at))) + "\n                  ")])]), _vm._v(" "), _c('div', {
      staticClass: "short-message",
      domProps: {
        "innerHTML": _vm._s(conv.last_message.body.substring(0, 20))
      }
    })])])
  }))]), _vm._v(" "), (_vm.conversation && _vm.conversation.id > 0) ? _c('v-flex', {
    staticClass: "message-content-section",
    attrs: {
      "xs12": "",
      "sm6": "",
      "pa-0": ""
    }
  }, [_c('div', {
    staticClass: "header-section"
  }, [_c('p', {
    staticClass: "user-name"
  }), _c('div', {
    staticClass: "user-avatar-image",
    style: ({
      'background-image': 'url(' + _vm.conversation.other.avatar.thumb.url + ')',
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "user-info"
  }, [_c('h2', [_vm._v(_vm._s(_vm.conversation.other.display_name))]), _vm._v(" "), _c('span', [_vm._v("@" + _vm._s(_vm.conversation.other.username) + " ")]), _vm._v(" • "), _c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v(_vm._s(_vm.conversation.other.user_type))])]), _vm._v(" "), _c('p')]), _vm._v(" "), (_vm.messages && _vm.messages.length > 0) ? _c('div', {
    staticClass: "message-list-section"
  }, _vm._l((_vm.messages), function(message) {
    return _c('message', {
      key: message.id,
      attrs: {
        "message": message,
        "is-own": _vm.conversation.other.id != message.sender.id
      },
      on: {
        "updated": _vm.refreshMessages
      }
    })
  })) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "send-message-section"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.message.body),
      expression: "message.body",
      modifiers: {
        "trim": true
      }
    }],
    ref: "message",
    staticClass: "message-input-box",
    attrs: {
      "type": "text",
      "maxlength": "500",
      "placeholder": "Write a message...",
      "disabled": !(_vm.currentUser.creator_verified),
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.message.body)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.checkMessage()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.message, "body", $event.target.value.trim())
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (_vm.showEmojiPicker) ? _c('picker', {
    directives: [{
      name: "on-click-outside",
      rawName: "v-on-click-outside",
      value: (_vm.hideEmojiDialog),
      expression: "hideEmojiDialog"
    }],
    staticClass: "emoji-picker",
    attrs: {
      "title": "Pick your emoji…",
      "emoji": "point_up"
    },
    on: {
      "click": _vm.addEmoji
    }
  }) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "show-emoji-box-btn",
    class: {
      selected: _vm.showEmojiPicker
    },
    nativeOn: {
      "click": function($event) {
        _vm.showEmojiDialog()
      }
    }
  }, [_c('v-icon', [_vm._v("tag_faces")])], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "flex-column share-message-content",
    attrs: {
      "xs12": "",
      "sm3": "",
      "pa-0": ""
    }
  }, [_c('div', {
    staticClass: "header-section"
  }, [_c('div', {
    staticClass: "search-content-title"
  }, [_vm._v("\n              Share content in conversation\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "search content"
  }, [_c('input', {
    staticClass: "search-content",
    attrs: {
      "type": "text",
      "placeholder": "search"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "search-conversation"
  }, [_c('div', {
    staticClass: "conversation-avatar"
  }, [_c('a', {
    attrs: {
      "href": "/9234ds"
    }
  }, [_c('div', {
    staticClass: "avatar-image",
    staticStyle: {
      "background-image": "url('https://d19mruzykfu6hg.cloudfront.net/uploads/user/avatar/121/thumb_bae70610-6589-40a1-a210-6cec61767a75.png')"
    },
    attrs: {
      "data-v-5be2a303": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "conversation-info"
  }, [_c('div', {
    staticClass: "conversation-info",
    attrs: {
      "data-v-5be2a303": ""
    }
  }, [_c('div', {
    staticClass: "user-name",
    attrs: {
      "data-v-5be2a303": ""
    }
  }, [_vm._v("Bruh Make Beats")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title",
    attrs: {
      "data-v-5be2a303": ""
    }
  }, [_vm._v("ALBUM")])])])])])])])]], 2)], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "messages-repost"
    },
    model: {
      value: (_vm.show_repost_modal),
      callback: function($$v) {
        _vm.show_repost_modal = $$v
      },
      expression: "show_repost_modal"
    }
  }, [_c('v-card', {
    staticClass: "pa-5"
  }, [(
    ['artist', 'brand', 'label'].indexOf(_vm.currentUser.user_type) > -1
  ) ? _c('div', {
    staticClass: "requests",
    attrs: {
      "xs12": "",
      "sm3": "",
      "pa-0": ""
    }
  }, [(_vm.otherStripeConnected) ? [_c('div', {
    staticClass: "requests__header"
  }, [_c('div', {
    staticClass: "requests__actions"
  }, [_c('div', {
    staticClass: "requests__title"
  }, [_vm._v("Repost Request")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [(
    ['artist', 'label'].indexOf(_vm.currentUser.user_type) > -1
  ) ? _c('v-btn', {
    class: {
      'btn--active': _vm.tab == 'album'
    },
    nativeOn: {
      "click": function($event) {
        _vm.onTab('album')
      }
    }
  }, [_vm._v("Album")]) : _vm._e(), _vm._v(" "), (
    ['artist', 'brand', 'label'].indexOf(
      _vm.currentUser.user_type
    ) > -1
  ) ? _c('v-btn', {
    class: {
      'btn--active': _vm.tab == 'merch'
    },
    nativeOn: {
      "click": function($event) {
        _vm.onTab('merch')
      }
    }
  }, [_vm._v("Product")]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "requests__content"
  }, [(_vm.tab == 'album') ? _vm._l((_vm.albums), function(album) {
    return _c('div', {
      key: album.id,
      staticClass: "request-item",
      class: {
        selected: _vm.item == album,
        banned: _vm.InBanned(album),
      },
      on: {
        "click": function($event) {
          _vm.InBanned(album) ? null : _vm.selectItem(album)
        }
      }
    }, [_c('div', {
      staticClass: "avatar-area"
    }, [_c('div', {
      staticClass: "avatar-image",
      style: (("background-image: url(" + (album.cover.thumb.url) + ")"))
    })]), _vm._v(" "), _c('div', {
      staticClass: "detail-area"
    }, [_c('label', {
      staticClass: "item-name"
    }, [_vm._v(_vm._s(album.name))]), _vm._v(" "), _c('label', {
      staticClass: "user-name"
    }, [_vm._v(_vm._s(album.user.username))])])])
  }) : (_vm.tab == 'merch') ? _vm._l((_vm.products), function(product) {
    return _c('div', {
      key: product.id,
      staticClass: "request-item",
      class: {
        selected: _vm.item == product,
        banned: _vm.InReposted(product),
      },
      on: {
        "click": function($event) {
          _vm.InReposted(product) ? null : _vm.selectItem(product)
        }
      }
    }, [_c('div', {
      staticClass: "avatar-area"
    }, [_c('div', {
      staticClass: "avatar-image",
      style: (("background-image: url(" + (product.covers[0].cover.thumb.url) + ")"))
    })]), _vm._v(" "), _c('div', {
      staticClass: "detail-area"
    }, [_c('label', {
      staticClass: "item-name"
    }, [_vm._v(_vm._s(product.name))]), _vm._v(" "), _c('label', {
      staticClass: "user-name"
    }, [_vm._v(_vm._s(product.merchant.username))])])])
  }) : _vm._e()], 2)] : [_c('div', {
    staticClass: "requests__body"
  }, [_c('h5', [_vm._v("Repost Request")]), _vm._v(" "), _c('p', [_vm._v("\n              To promote albums and products"), _c('br'), _vm._v("\n              receiver must first connect to Stripe\n            ")])])]], 2) : _vm._e()])], 1), _vm._v(" "), (_vm.show_repost_payment_modal) ? _c('repost-payment-modal', {
    attrs: {
      "item": _vm.item,
      "itemType": _vm.tab,
      "receiver": _vm.conversation.other,
      "dismiss": _vm.closeRepostPaymentModal,
      "finish": _vm.sendMessage
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_send_love_modal) ? _c('send-love-modal', {
    attrs: {
      "item": _vm.conversation.other,
      "dismiss": _vm.closeSendLoveModal
    }
  }) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.show_block_user_confirm_dialog),
      callback: function($$v) {
        _vm.show_block_user_confirm_dialog = $$v
      },
      expression: "show_block_user_confirm_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Block a User")]), _vm._v(" "), _c('v-card-text', [_vm._v("Are you sure you want to block <" + _vm._s(_vm.otherName) + ">?")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.blockUser()
      }
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeBlockUserConfirmDialog()
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.show_conversation_delete_confirm_dialog),
      callback: function($$v) {
        _vm.show_conversation_delete_confirm_dialog = $$v
      },
      expression: "show_conversation_delete_confirm_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Delete a Conversation")]), _vm._v(" "), _c('v-card-text', [_vm._v("If you click OK, all messages under the conversation will be deleted.\n        Click OK to delete a conversation with <" + _vm._s(_vm.otherName) + ">, or\n        click Cancel.")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.deleteEntireMessage()
      }
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeConversationDeleteConfirmDialog()
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "repost-request-dialog"
    },
    model: {
      value: (_vm.repostRequestActive),
      callback: function($$v) {
        _vm.repostRequestActive = $$v
      },
      expression: "repostRequestActive"
    }
  }, [_c('div', {
    staticClass: "_top dflex aling-center"
  }, [_c('img', {
    staticClass: "mr-3",
    attrs: {
      "src": __webpack_require__(1533),
      "width": "30",
      "alt": "repost dollar icon"
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Repost Requests")])]), _vm._v(" "), _c('hr', {
    staticClass: "light my-3"
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "mb-2"
  }, [_vm._v("\n        Creators can send requests you to share their content.\n      ")]), _vm._v(" "), _c('ul', {
    staticClass: "ml-4"
  }, [_c('li', [_vm._v("Set your repost price in your messages")]), _vm._v(" "), _c('li', [_vm._v("\n          Creators can send you direct messages with their content attached to\n          preview\n        ")]), _vm._v(" "), _c('li', [_vm._v("\n          You have 3 days to accept the request or it’s automatically refunded\n        ")]), _vm._v(" "), _c('li', [_vm._v("\n          If you accept a request the content is reposted to your followers on\n          the home tab\n        ")]), _vm._v(" "), _c('li', [_vm._v("\n          Repost requests remain on feeds for 7 days then is automatically\n          removed.\n        ")])]), _vm._v(" "), _c('hr', {
    staticClass: "light my-3"
  }), _vm._v(" "), _c('h2', {
    staticClass: "mb-3"
  }, [_vm._v("FAQ")]), _vm._v(" "), _c('div', {
    staticClass: "faqs"
  }, [_c('div', {
    staticClass: "faq"
  }, [_c('h3', [_vm._v("How & when do I get paid?")]), _vm._v(" "), _c('div', [_vm._v("\n            You must have a valid Stripe account connected, and accepted\n            requests payout in 2 days.\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "faq"
  }, [_c('h3', [_vm._v("What does ‘Enable SMS text’ mean?")]), _vm._v(" "), _c('div', [_vm._v("\n            SMS enabled means that any repost request you accept will send\n            links to the content to everyone on your SMS list and to your\n            followers on YouSound. The requester will pay for the SMS charges.\n            If you enable SMS you can charge more as SMS texts are more\n            valuable than sharing to the home feed alone.\n          ")])])])])]), _vm._v(" "), (_vm.smsActive) ? _c('SMS', {
    on: {
      "closeSMS": _vm.closeSMS
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1621 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "success display-flex justify-center align-center gap-4 pa-4"
  }, [_c('div', {
    staticClass: "text-white font-32 font-weight-500"
  }, [_vm._v("Success!")]), _vm._v(" "), _c('div', {
    staticClass: "text-white font-22 font-weight-500"
  }, [_vm._v("\n    Welcome to the community\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "text-white font-24 font-weight-500"
  }, [_vm._v("Loud Pack")]), _vm._v(" "), _c('div', [_c('img', {
    attrs: {
      "src": __webpack_require__(1524),
      "width": 400
    }
  })]), _vm._v(" "), _c('v-btn', {
    staticClass: "btn-go mx-0 mt-4 full-width",
    on: {
      "click": function($event) {
        _vm.$router.push('/communitym')
      }
    }
  }, [_vm._v("\n    Go to community\n  ")])], 1)
},staticRenderFns: []}

/***/ }),
/* 1622 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar",
    class: {
      drawerActive: _vm.drawer
    }
  }, [_c('v-toolbar', {
    attrs: {
      "app": "",
      "fixed": "",
      "flat": "",
      "height": "94",
      "color": "white"
    }
  }, [_c('v-container', {
    attrs: {
      "navbar-container": ""
    }
  }, [_c('v-toolbar-items', {
    staticClass: "align-center width100"
  }, [_c('span', {
    staticClass: "toggle-icon",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M1 12H23",
      "stroke": "black",
      "stroke-width": "2",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M1 5H23",
      "stroke": "black",
      "stroke-width": "2",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M1 19H12",
      "stroke": "black",
      "stroke-width": "2",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])]), _vm._v(" "), _c('v-toolbar-title', {
    staticClass: "ml-0 cursor-pointer"
  }, [_c('img', {
    staticClass: "logo ",
    staticStyle: {
      "width": "142px",
      "height": "auto"
    },
    attrs: {
      "src": "/static/images/nav_logo_primary.png"
    },
    on: {
      "click": function($event) {
        _vm.$router.push('/')
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "link-text-wrapper"
  }, _vm._l((_vm.links), function(link) {
    return _c('v-btn', {
      key: link.text,
      staticClass: "nav_text no-Btn-bg",
      attrs: {
        "to": {
          name: link.route
        }
      }
    }, [_vm._v("\n            " + _vm._s(link.text) + "\n          ")])
  })), _vm._v(" "), _c('v-spacer', {}), _vm._v(" "), (!_vm.isAuthenticated) ? _c('v-btn', {
    staticClass: "login_text",
    attrs: {
      "elevation": "0",
      "to": {
        name: 'Login'
      }
    }
  }, [_vm._v("\n          Sign in\n        ")]) : _c('v-btn', {
    staticClass: "login_text",
    attrs: {
      "elevation": "0",
      "to": {
        name: 'AlbumIndex'
      }
    }
  }, [_vm._v("\n          Discover\n        ")])], 1)], 1)], 1), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndDown) ? _c('v-navigation-drawer', {
    staticClass: "landing-sidebar",
    attrs: {
      "app": "",
      "fixed": "",
      "dark": "",
      "disable-resize-watcher": true
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-list-tile', {
    staticClass: "mb-6",
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    staticClass: "mobile-logo",
    staticStyle: {
      "width": "142px",
      "height": "auto"
    },
    attrs: {
      "src": "/static/images/nav_logo_white.png"
    }
  })]), _vm._v(" "), _vm._l((_vm.links), function(link) {
    return _c('v-list-tile', {
      key: link.text,
      attrs: {
        "router": "",
        "to": link.route
      }
    }, [_c('v-list-tile-title', [_vm._v(_vm._s(link.text))])], 1)
  })], 2), _vm._v(" "), (!_vm.isAuthenticated) ? _c('v-btn', {
    staticClass: "login_text_mobile d-sm-flex d-none justify-md-center align-md-center",
    attrs: {
      "elevation": "0",
      "to": {
        name: 'Login'
      }
    }
  }, [_vm._v("\n      Sign in\n    ")]) : _c('v-btn', {
    staticClass: "login_text_mobile d-sm-flex d-none justify-md-center align-md-center",
    attrs: {
      "elevation": "0",
      "to": {
        name: 'AlbumIndex'
      }
    }
  }, [_vm._v("\n      Discover\n    ")])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1623 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_c('v-container', {
    staticClass: "inner-footer",
    attrs: {
      "grid-list-xs": "",
      "px-0": ""
    }
  }, [_c('v-layout', {
    staticClass: "mb-15",
    attrs: {
      "wrap": "",
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md3": ""
    }
  }, [_c('div', {
    staticClass: "logo-container"
  }, [_c('img', {
    staticClass: "footer-logo",
    staticStyle: {
      "width": "130px"
    },
    attrs: {
      "src": "/static/images/nav_logo_primary.png"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "appstore-logo-wrapper mt-6 mx-auto mx-md-0 d-flex d-md-block justify-center",
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "target": "_blank",
      "href": "https://apps.apple.com/us/app/yousound/id1452078262"
    }
  }, [_c('img', {
    staticClass: "appstore-logo",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/store.png"
    }
  })])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md2": ""
    }
  }, [_c('h3', {
    staticClass: "mb-6"
  }, [_vm._v("About")]), _vm._v(" "), _c('v-list', {
    attrs: {
      "flat": ""
    }
  }, _vm._l((_vm.aboutLinks), function(link) {
    return _c('v-list-tile', {
      key: link.text,
      staticClass: "pl-md-0",
      attrs: {
        "router": "",
        "href": link.route,
        "target": link.ext ? '_blank' : ''
      }
    }, [_c('v-list-tile-title', {
      staticClass: "black--text"
    }, [_vm._v(_vm._s(link.text))])], 1)
  }))], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md2": ""
    }
  }, [_c('h3', {
    staticClass: "mb-6"
  }, [_vm._v("Company")]), _vm._v(" "), _c('v-list', {
    attrs: {
      "flat": ""
    }
  }, _vm._l((_vm.companyLinks), function(link) {
    return _c('v-list-tile', {
      key: link.text,
      staticClass: "pl-md-0",
      attrs: {
        "router": "",
        "href": link.route,
        "target": link.ext ? '_blank' : '',
        "color": "dark"
      }
    }, [_c('v-list-tile-title', {
      staticClass: "black--text"
    }, [_vm._v(_vm._s(link.text))])], 1)
  }))], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md5": ""
    }
  }, [_c('h3', {
    staticClass: "mb-6"
  }, [_vm._v("Subscribe our Newsletter")]), _vm._v(" "), _c('form', {
    staticClass: "d-flex align-center",
    attrs: {
      "action": ""
    }
  }, [_c('input', {
    attrs: {
      "type": "email",
      "placeholder": "Your email"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "subscribe_btn"
  }, [_vm._v(" Subscribe")])], 1)])], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "text-center mt-md-15"
  }, [_vm._v("© 2021 YouSound, Inc.")])], 1)
},staticRenderFns: []}

/***/ }),
/* 1624 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "ys-dialog-container",
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-layout', {
    staticClass: "ys-dialog-dismiss",
    attrs: {
      "row": "",
      "wrap": ""
    },
    on: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "ys-dialog ys-album-dialog",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "pr-2": ""
    }
  }, [_c('div', {
    staticClass: "album-cover",
    style: ({
      'background-image': 'url(' + _vm.album.cover.url + ')'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "album-info mt-3"
  }, [_c('v-flex', {
    attrs: {
      "x12": "",
      "mb-3": "",
      "py-2": "",
      "border-top": "",
      "border-bottom": ""
    }
  }, [_c('h4', [_vm._v("Album Stats")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "album-stats"
  }, [_c('div', [_c('label', [_vm._v("Uploaded:")]), _c('span', [_vm._v(_vm._s(_vm._f("formatDate")(_vm.album.created_at)))])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("Plays:")]), _c('span', [_vm._v(_vm._s(_vm._f("formatNumberWithComma")(_vm.album.played)))])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("Reposts:")]), _c('span', [_vm._v(_vm._s(_vm._f("formatNumberWithComma")(_vm.album.reposted)))])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("Downloads:")]), _c('span', [_vm._v(_vm._s(_vm._f("formatNumberWithComma")(_vm.album.donwloaded)))])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("Album only for live video:")]), _vm._v(" "), (_vm.album.is_only_for_live_stream) ? _c('span', {
    staticClass: "red--text"
  }, [_c('b', [_vm._v("Yes")])]) : _c('span', [_vm._v("No")])])]), _vm._v(" "), (_vm.album_product) ? _c('v-flex', {
    attrs: {
      "x12": "",
      "mt-4": "",
      "mb-3": "",
      "py-2": "",
      "border-top": "",
      "border-bottom": ""
    }
  }, [_c('h4', [_vm._v("Product Attachment")])]) : _vm._e(), _vm._v(" "), (_vm.album_product) ? _c('v-flex', [_c('v-card', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-card-media', {
    attrs: {
      "src": _vm.album_product.covers[0].cover.thumb.url,
      "contain": ""
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs7": ""
    }
  }, [_c('div', [_c('div', {
    staticClass: "product-name"
  }, [_vm._v(_vm._s(_vm.album_product.name))]), _vm._v(" "), _c('div', {
    staticClass: "product-price"
  }, [_vm._v("$" + _vm._s(_vm._f("formatNumber")(_vm.album_product.price)))])])])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "x12": "",
      "mt-3": "",
      "mb-3": "",
      "py-2": "",
      "border-top": "",
      "border-bottom": ""
    }
  }, [_c('h4', [_vm._v("Contributors")])]), _vm._v(" "), _c('v-list', {
    attrs: {
      "subheader": "",
      "two-line": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-avatar', {
    staticClass: "mr-2"
  }, [_c('img', {
    attrs: {
      "src": _vm.user.avatar.url
    }
  })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
    domProps: {
      "innerHTML": _vm._s(_vm.user.username)
    }
  }), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Uploader")])], 1)], 1), _vm._v(" "), _vm._l((_vm.album.contributors), function(c, index) {
    return (_vm.album.contributors && _vm.album.contributors.length > 0) ? _c('v-list-tile', {
      key: ("contributor-" + index)
    }, [_c('v-list-tile-avatar', {
      staticClass: "mr-2"
    }, [_c('img', {
      attrs: {
        "src": c.user.avatar.url
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(c.user.username)
      }
    }), _vm._v(" "), _c('v-list-tile-sub-title', {
      domProps: {
        "innerHTML": _vm._s(c.user_role)
      }
    })], 1)], 1) : _vm._e()
  })], 2), _vm._v(" "), (_vm.album.collaborators && _vm.album.collaborators.length > 0) ? _c('v-flex', {
    attrs: {
      "x12": "",
      "mt-3": "",
      "mb-3": "",
      "py-2": "",
      "border-top": "",
      "border-bottom": ""
    }
  }, [_c('h4', [_vm._v("Collaborators")])]) : _vm._e(), _vm._v(" "), _c('v-list', _vm._l((_vm.album.collaborators), function(c, index) {
    return (_vm.album.collaborators && _vm.album.collaborators.length > 0) ? _c('v-list-tile', {
      key: ("collaborator-" + index)
    }, [_c('v-list-tile-avatar', {
      staticClass: "mr-2"
    }, [_c('img', {
      attrs: {
        "src": c.user.avatar.url
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(c.user.username)
      }
    }), _vm._v(" "), _c('v-list-tile-sub-title', {
      domProps: {
        "innerHTML": _vm._s(c.user_role)
      }
    })], 1)], 1) : _vm._e()
  }))], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": "",
      "pl-2": "",
      "border-left": ""
    }
  }, [_c('div', {
    staticClass: "album-action"
  }, [_c('label', {
    staticClass: "album-name"
  }, [_vm._v(_vm._s(_vm.album.name))]), _vm._v(" "), _c('v-menu', {
    staticClass: "more-menu",
    attrs: {
      "offset-y": ""
    }
  }, [_c('v-btn', {
    staticClass: "more-btn",
    attrs: {
      "slot": "activator",
      "dark": ""
    },
    slot: "activator"
  }, [_c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("more_horiz")])], 1), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
    key: "delete_album",
    staticClass: "default-menu-item",
    nativeOn: {
      "click": function($event) {
        _vm.deleteAlbum()
      }
    }
  }, [_c('v-list-tile-title', [_c('label', [_vm._v("Delete Entire Album")])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "table-wrapper"
  }, [_c('table', {
    staticClass: "tracks-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-xs-left"
  }, [_vm._v("Track Title")]), _vm._v(" "), _c('th', {
    staticClass: "text-xs-left"
  }, [_vm._v("Sampled from Yousound")]), _vm._v(" "), _c('th', {
    staticClass: "text-xs-left"
  }, [_vm._v("Played")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.tracks), function(track) {
    return _c('tr', [_c('td', {
      staticClass: "text-xs-left"
    }, [_vm._v(_vm._s(track.name))]), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center"
    }, [(_vm.isSampledTrack(track.id)) ? _c('span', {
      staticClass: "album_credit-btn",
      on: {
        "click": function($event) {
          _vm.show_album_credit_dialog = true
        }
      }
    }, [_vm._v("Yes")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(track.played))]), _vm._v(" "), _c('td', [_c('v-btn', {
      staticClass: "remove-btn",
      attrs: {
        "dark": "",
        "small": "",
        "color": "red"
      },
      nativeOn: {
        "click": function($event) {
          _vm.deleteTrack(track.id)
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1)], 1)])
  }))])])])], 1), _vm._v(" "), _c('v-dialog', {
    staticClass: "album-credits-dialog",
    attrs: {
      "scrollable": "",
      "max-width": "600px"
    },
    model: {
      value: (_vm.show_album_credit_dialog),
      callback: function($$v) {
        _vm.show_album_credit_dialog = $$v
      },
      expression: "show_album_credit_dialog"
    }
  }, [(_vm.show_album_credit_dialog) ? _c('v-card', {
    staticClass: "album-dialog-body"
  }, [_c('v-card-title', [_vm._v("Album Credits")]), _vm._v(" "), _c('v-btn', {
    staticClass: "dialog-close-btn",
    nativeOn: {
      "click": function($event) {
        _vm.show_album_credit_dialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("highlight_off")])], 1), _vm._v(" "), _c('v-card-text', {
    staticStyle: {
      "height": "300px"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('label', {
    staticClass: "album-info-label"
  }, [_vm._v("Album Name: ")]), _vm._v(" "), _c('label', {
    staticClass: "album-info-text"
  }, [_vm._v(_vm._s(_vm.album.name))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('label', {
    staticClass: "album-info-label"
  }, [_vm._v("Release Date: ")]), _vm._v(" "), _c('label', {
    staticClass: "album-info-text"
  }, [_vm._v(_vm._s(_vm._f("formatDate")(_vm.album.released_at)))])]), _vm._v(" "), (_vm.album.location && _vm.album.location != '') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('label', {
    staticClass: "album-info-label"
  }, [_vm._v("Location: ")]), _vm._v(" "), _c('label', {
    staticClass: "album-info-text"
  }, [_vm._v(_vm._s(_vm.album.location))])]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('label', {
    staticClass: "album-info-label"
  }, [_vm._v("Genre: ")]), _vm._v(" "), _c('label', {
    staticClass: "album-info-text"
  }, [_vm._v(_vm._s(_vm.genres))])]), _vm._v(" "), (_vm.album.collaborators && _vm.album.collaborators.length > 0) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('label', {
    staticClass: "album-info-label"
  }, [_vm._v("Collaborators: ")]), _vm._v(" "), _c('label', {
    staticClass: "album-info-text"
  }, [_vm._l((_vm.album.collaborators), function(c) {
    return [_c('div', {
      staticClass: "collaborator-info"
    }, [_c('router-link', {
      staticClass: "user-name",
      attrs: {
        "to": ("/" + (c.user.slug))
      }
    }, [_vm._v(_vm._s(c.user.username))]), _vm._v(" - " + _vm._s(c.user_role))], 1)]
  })], 2)]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('label', {
    staticClass: "album-info-label"
  }, [_vm._v("Contributors: ")]), _vm._v(" "), _c('label', {
    staticClass: "album-info-text"
  }, [_c('div', {
    staticClass: "contributor-info"
  }, [_c('router-link', {
    staticClass: "user-name",
    attrs: {
      "to": ("/" + (_vm.album.user.slug))
    }
  }, [_vm._v(_vm._s(_vm.album.user.username))]), _vm._v(" - Uploader")], 1)]), _vm._v(" "), (_vm.album.contributors && _vm.album.contributors.length > 0) ? _c('label', {
    staticClass: "album-info-text"
  }, [_vm._l((_vm.album.contributors), function(c) {
    return [_c('div', {
      staticClass: "contributor-info"
    }, [_c('router-link', {
      staticClass: "user-name",
      attrs: {
        "to": ("/" + (c.user.slug))
      }
    }, [_vm._v(_vm._s(c.user.username))]), _vm._v(" - " + _vm._s(c.user_role))], 1)]
  })], 2) : _vm._e()]), _vm._v(" "), (_vm.album.samplings && _vm.album.samplings.length > 0) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('label', {
    staticClass: "album-info-label"
  }, [_vm._v("Samples: ")]), _vm._v(" "), (_vm.album.samplings && _vm.album.samplings.length > 0) ? _c('label', {
    staticClass: "album-info-text"
  }, [_vm._l((_vm.album.samplings), function(s) {
    return [_c('div', {
      staticClass: "sampling-info"
    }, [_c('label', [_vm._v(_vm._s(s.sampling_track.name))]), _vm._v(": "), _c('router-link', {
      staticClass: "user-name",
      attrs: {
        "to": ("/" + (s.sample_user.slug))
      }
    }, [_vm._v(_vm._s(s.sample_user.username))]), _vm._v(" "), _c('span', [_vm._v(" - " + _vm._s(s.sample_track.name))])], 1)]
  })], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.album.labels && _vm.album.labels.length > 0) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('label', {
    staticClass: "album-info-label"
  }, [_vm._v("Label: ")]), _vm._v(" "), _c('label', {
    staticClass: "album-info-text"
  }, [_c('router-link', {
    staticClass: "user-name",
    attrs: {
      "to": ("/" + (_vm.album.labels[0].user.slug))
    }
  }, [_vm._v(_vm._s(_vm.album.labels[0].user.username))])], 1)]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('div', {
    staticClass: "album-info-label"
  }, [_vm._v("About the album: ")]), _vm._v(" "), _c('label', {
    staticClass: "album-info-text"
  }, [_vm._v(_vm._s(_vm.album.description))])])], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1625 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page video-page info-page"
  }, [_c('div', {
    staticClass: "d-flex"
  }, [(_vm.isPageReady) ? _c('div', {
    staticClass: "page-content"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "description-container",
    attrs: {
      "xs6": ""
    }
  }, [_c('h4', [_vm._v("How it works")]), _vm._v(" "), _c('p', [_vm._v("\n            Create one of a kind live video experiences designed to maximize\n            sales with exclusive products & downloads for your most engaging\n            customers. Pay as you go. Unused credit rolls over to your next\n            broadcast. All broadcasts include delivery of all resolutions up\n            to HD 1080p.\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n            To learn more visit the\n            "), _c('a', {
    attrs: {
      "href": "//support.yousound.com/en/articles/4490519-live-video-cost",
      "target": "_blank"
    }
  }, [_vm._v("Frequently Asked Questions")])]), _vm._v(" "), (!_vm.isStreamRunning) ? _c('v-btn', {
    staticClass: "mt-4",
    attrs: {
      "round": "",
      "dark": "",
      "color": "blue"
    },
    on: {
      "click": _vm.gotoNextView
    }
  }, [_vm._v("Setup Live Stream")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "estimate-container",
    attrs: {
      "xs6": ""
    }
  }, [_c('h4', [_vm._v("Estimate your cost")]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("Duration of an average live stream")]), _vm._v(" "), _c('v-layout', {
    staticClass: "input"
  }, [_c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('div', {
    staticClass: "duration"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.durationDetail.hour),
      expression: "durationDetail.hour"
    }],
    attrs: {
      "type": "number",
      "min": "0",
      "max": "12",
      "size": "3"
    },
    domProps: {
      "value": (_vm.durationDetail.hour)
    },
    on: {
      "change": _vm.handleDurationDetailChange,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.durationDetail, "hour", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(":")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.durationDetail.min),
      expression: "durationDetail.min"
    }],
    attrs: {
      "type": "number",
      "min": "0",
      "max": "59",
      "size": "3"
    },
    domProps: {
      "value": (_vm.durationDetail.min)
    },
    on: {
      "change": _vm.handleDurationDetailChange,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.durationDetail, "min", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(":")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.durationDetail.sec),
      expression: "durationDetail.sec"
    }],
    attrs: {
      "type": "number",
      "min": "0",
      "max": "59",
      "size": "3"
    },
    domProps: {
      "value": (_vm.durationDetail.sec)
    },
    on: {
      "change": _vm.handleDurationDetailChange,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.durationDetail, "sec", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "duration-helper"
  }, [_c('span', [_vm._v("hours")]), _vm._v(" "), _c('span', [_vm._v("mintues")]), _vm._v(" "), _c('span', [_vm._v("seconds")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs7": "",
      "slider-container": ""
    }
  }, [_c('v-slider', {
    attrs: {
      "min": "0",
      "max": "186",
      "step": "1",
      "hide-details": ""
    },
    on: {
      "input": _vm.handleDurationMirrorChange
    },
    model: {
      value: (_vm.durationMirror),
      callback: function($$v) {
        _vm.durationMirror = $$v
      },
      expression: "durationMirror"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("Live stream view count")]), _vm._v(" "), _c('v-layout', {
    staticClass: "input"
  }, [_c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.viewers),
      expression: "viewers"
    }],
    attrs: {
      "type": "number",
      "min": "0",
      "max": "10000000"
    },
    domProps: {
      "value": (_vm.viewers)
    },
    on: {
      "change": _vm.handleViewersChange,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.viewers = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs7": "",
      "slider-container": ""
    }
  }, [_c('v-slider', {
    attrs: {
      "min": "0",
      "max": "290",
      "step": "1",
      "hide-details": ""
    },
    on: {
      "input": _vm.handleViewersMirrorChange
    },
    model: {
      value: (_vm.viewersMirror),
      callback: function($$v) {
        _vm.viewersMirror = $$v
      },
      expression: "viewersMirror"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("How long does the average viewer watch?")]), _vm._v(" "), _c('div', {
    staticClass: "radio-container"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.percentage),
      expression: "percentage"
    }],
    attrs: {
      "id": "average-30",
      "type": "radio",
      "name": "percentage",
      "value": "30"
    },
    domProps: {
      "checked": _vm._q(_vm.percentage, "30")
    },
    on: {
      "change": function($event) {
        _vm.percentage = "30"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "average-30"
    }
  }, [_vm._v("30% of"), _c('br'), _vm._v("the live stream")])]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.percentage),
      expression: "percentage"
    }],
    attrs: {
      "id": "average-50",
      "type": "radio",
      "name": "percentage",
      "value": "50"
    },
    domProps: {
      "checked": _vm._q(_vm.percentage, "50")
    },
    on: {
      "change": function($event) {
        _vm.percentage = "50"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "average-50"
    }
  }, [_vm._v("50% of"), _c('br'), _vm._v("the live stream")])]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.percentage),
      expression: "percentage"
    }],
    attrs: {
      "id": "average-90",
      "type": "radio",
      "name": "percentage",
      "value": "90"
    },
    domProps: {
      "checked": _vm._q(_vm.percentage, "90")
    },
    on: {
      "change": function($event) {
        _vm.percentage = "90"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "average-90"
    }
  }, [_vm._v("90% of"), _c('br'), _vm._v("the live stream")])]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.percentage),
      expression: "percentage"
    }],
    attrs: {
      "id": "average-100",
      "type": "radio",
      "name": "percentage",
      "value": "100"
    },
    domProps: {
      "checked": _vm._q(_vm.percentage, "100")
    },
    on: {
      "change": function($event) {
        _vm.percentage = "100"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "average-100"
    }
  }, [_vm._v("100% of"), _c('br'), _vm._v("\n                the live stream")])])]), _vm._v(" "), _c('div', {
    staticClass: "total"
  }, [_c('label', [_vm._v("Estimated Total")]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(_vm._f("formatNumber")(_vm.totalPrice)))])])], 1)], 1)], 1) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 1626 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "transition": "slide-up",
      "fullscreen": "",
      "content-class": "mobile-comment-dialog"
    },
    model: {
      value: (_vm.initComment),
      callback: function($$v) {
        _vm.initComment = $$v
      },
      expression: "initComment"
    }
  }, [_c('div', {
    staticClass: "dflex top-wrapper"
  }, [_c('div', {
    staticClass: "centerLogo text-center flex-grow"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(429),
      "width": "120"
    }
  })]), _vm._v(" "), _c('img', {
    staticClass: "cursor-pointer",
    attrs: {
      "src": __webpack_require__(223)
    },
    on: {
      "click": function($event) {
        _vm.closeCommentDialog()
      }
    }
  })]), _vm._v(" "), (_vm.isAssocPassed) ? _c('div', {
    staticClass: "_assoc"
  }, [_vm._t("_assoc")], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "width100 comments-comp",
    class: {
      isAssocPassed: _vm.isAssocPassed
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__content",
    class: {
      'no-comment': !_vm.comments.length
    }
  }, [(!_vm.hideComments && _vm.comments.length) ? _c('chat', {
    attrs: {
      "items": _vm.comments,
      "hideDatedString": "",
      "showShortAge": ""
    }
  }) : _c('div', {
    staticClass: "nocomment-msg"
  }, [_vm._v("\n          Please be respectful when leaving comments & follow our "), _c('router-link', {
    attrs: {
      "to": "#"
    }
  }, [_c('strong', [_vm._v("Community Guidelines")])])], 1)], 1)]), _vm._v(" "), _c('comment-input', {
    attrs: {
      "item": _vm.item,
      "roundInput": _vm.roundInput,
      "noBorder": _vm.noBorder,
      "placeholder": _vm.placeholder,
      "aviHeight": _vm.aviHeight,
      "aviWidht": _vm.aviWidth
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1627 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "trending-comp trending-products"
  }, [(_vm.title) ? _c('div', {
    staticClass: "top-bar"
  }, [_c('h2', {
    staticClass: "bar-title"
  }, [_vm._v(_vm._s(_vm.title))])]) : _vm._e(), _vm._v(" "), _c('item-tab', {
    staticClass: "mb-4",
    attrs: {
      "mode": "grid"
    }
  }, [_c('template', {
    slot: "itemTabs"
  }, _vm._l((_vm.productFeed), function(feed, index) {
    return _c('span', {
      key: index,
      class: ['tab-holder px-0 flex', _vm.classAttr]
    }, [_c('product-card', {
      attrs: {
        "hideOverlay": "",
        "noMeta": "",
        "altMeta": _vm.altMeta,
        "altMetaPrice": "",
        "dataObject": feed,
        "showFullOverlay": _vm.showFullOverlay
      }
    })], 1)
  }))], 2), _vm._v(" "), (!_vm.hideCta) ? _c('div', {
    staticClass: "cta"
  }, [_c('v-btn', {
    staticClass: "cta-btn",
    attrs: {
      "block": "",
      "outline": ""
    }
  }, [_c('strong', [_vm._v("\n        View all products\n      ")])])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1628 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page label-manage-page mx-5",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.currentUser.user_type == 'artist') ? _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "page-left"
  }, [_c('div', {
    staticClass: "tab-container"
  }, [_c('h2', {
    staticClass: "page-title"
  }, [_vm._v("My Labels")]), _vm._v(" "), _c('ul', _vm._l((_vm.artist_tabs), function(tab) {
    return _c('li', {
      key: tab.id,
      class: {
        active: _vm.isActiveTab(tab.id)
      },
      attrs: {
        "href": ("#" + (tab.id))
      }
    }, [_c('label', {
      on: {
        "click": function($event) {
          _vm.onTab(tab.id)
        }
      }
    }, [_vm._v(_vm._s(tab.title))])])
  }))])]), _vm._v(" "), (_vm.currentUser && _vm.isPageReady) ? _c('div', {
    staticClass: "page-content"
  }, [(_vm.navigatorState.tab == 'approved_labels') ? _c('div', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [(!_vm.approved_labels || _vm.approved_labels.length == 0) ? [_c('div', {
    staticClass: "empty-section"
  }, [_c('p', {
    staticClass: "empty-title"
  }, [_vm._v("Empty")]), _vm._v(" "), _c('p', {
    staticClass: "empty-description"
  }, [_vm._v("You have no approved labels")])])] : [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_vm._l((_vm.approved_labels), function(relation, index) {
    return [_c('label-user-item', {
      attrs: {
        "user": relation.host,
        "deleteFunc": _vm.showLabelDeleteConfirmDialog,
        "deleteButtonText": 'remove label'
      }
    })]
  })], 2)]], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.navigatorState.tab == 'approved_albums') ? _c('div', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [(!_vm.approved_albums || _vm.approved_albums.length == 0) ? [_c('div', {
    staticClass: "empty-section"
  }, [_c('p', {
    staticClass: "empty-title"
  }, [_vm._v("Empty")]), _vm._v(" "), _c('p', {
    staticClass: "empty-description"
  }, [_vm._v("You have no approved albums")])])] : [_c('v-layout', {
    staticClass: "covers-content",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.approved_albums), function(user_album, index) {
    return _c('div', {
      key: index,
      staticClass: "card-container"
    }, [_c('label-album-item', {
      attrs: {
        "album": user_album.album,
        "user": user_album.user,
        "type": 'label',
        "deleteButtonFunc": _vm.showAlbumDeleteConfirmDialog,
        "deleteButtonText": "Remove <br>from Record Label",
        "deleteButtonClass": "height text-xs-left"
      }
    })], 1)
  }))]], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.navigatorState.tab == 'pending_labels') ? _c('div', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [(!_vm.pending_labels || _vm.pending_labels.length == 0) ? [_c('div', {
    staticClass: "empty-section"
  }, [_c('p', {
    staticClass: "empty-title"
  }, [_vm._v("Empty")]), _vm._v(" "), _c('p', {
    staticClass: "empty-description"
  }, [_vm._v("You have no pending labels")])])] : [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_vm._l((_vm.pending_labels), function(relation, index) {
    return [_c('label-user-item', {
      attrs: {
        "user": relation.host,
        "acceptFunc": _vm.acceptLabelUserRequest,
        "denyFunc": _vm.denyLabelUserRequest
      }
    })]
  })], 2)]], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.navigatorState.tab == 'pending_albums') ? _c('div', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [(!_vm.pending_albums || _vm.pending_albums.length == 0) ? [_c('div', {
    staticClass: "empty-section"
  }, [_c('p', {
    staticClass: "empty-title"
  }, [_vm._v("Empty")]), _vm._v(" "), _c('p', {
    staticClass: "empty-description"
  }, [_vm._v("You have no pending albums")])])] : [_c('v-layout', {
    staticClass: "covers-content",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.pending_albums), function(user_album, index) {
    return _c('div', {
      key: index,
      staticClass: "card-container"
    }, [_c('label-album-item', {
      attrs: {
        "album": user_album.album,
        "user": user_album.user,
        "type": 'label',
        "showPromoteButton": false,
        "acceptButtonFunc": _vm.acceptLabelAlbumRequest,
        "denyButtonFunc": _vm.denyLabelAlbumRequest
      }
    })], 1)
  }))]], 2)], 1) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.currentUser.user_type == 'label') ? _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "page-left"
  }, [_c('div', {
    staticClass: "tab-container"
  }, [_c('h2', {
    staticClass: "page-title"
  }, [_vm._v("Record Label")]), _vm._v(" "), _c('ul', _vm._l((_vm.label_tabs), function(tab) {
    return _c('li', {
      key: tab.id,
      class: {
        active: _vm.isActiveTab(tab.id)
      },
      attrs: {
        "href": ("#" + (tab.id))
      }
    }, [_c('label', {
      on: {
        "click": function($event) {
          _vm.onTab(tab.id)
        }
      }
    }, [_vm._v(_vm._s(tab.title))])])
  }))])]), _vm._v(" "), (_vm.currentUser && _vm.isPageReady) ? _c('div', {
    staticClass: "page-content"
  }, [(_vm.navigatorState.tab == 'approved_labels') ? _c('div', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "add-product-btn",
    nativeOn: {
      "click": function($event) {
        _vm.showSelectUserDialog()
      }
    }
  }, [_c('v-icon', [_vm._v("add")]), _vm._v("Add Artist\n              ")], 1)], 1), _vm._v(" "), _vm._l((_vm.approved_labels), function(relation, index) {
    return [_c('label-user-item', {
      attrs: {
        "user": relation.client,
        "deleteFunc": _vm.showRosterDeleteConfirmDialog,
        "deleteButtonText": 'remove artist from roster'
      }
    })]
  })], 2)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.navigatorState.tab == 'approved_albums') ? _c('div', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-layout', {
    staticClass: "covers-content",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.approved_albums), function(user_album, index) {
    return _c('div', {
      key: index,
      staticClass: "card-container"
    }, [_c('label-album-item', {
      attrs: {
        "album": user_album.album,
        "user": user_album.user,
        "type": 'label',
        "deleteButtonFunc": _vm.showAlbumDeleteConfirmDialog,
        "deleteButtonText": "Remove <br>from Record Label",
        "deleteButtonClass": "height text-xs-left"
      }
    })], 1)
  }))], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.navigatorState.tab == 'pending_labels') ? _c('div', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_vm._l((_vm.not_approved_labels), function(relation, index) {
    return [_c('label-user-item', {
      attrs: {
        "user": relation.client,
        "status": relation.status,
        "deleteFunc": _vm.showLabelDeleteConfirmDialog
      }
    })]
  })], 2)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.navigatorState.tab == 'pending_albums') ? _c('div', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-layout', {
    staticClass: "covers-content",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.not_approved_albums), function(user_album, index) {
    return _c('div', {
      key: index,
      staticClass: "card-container"
    }, [_c('label-album-item', {
      attrs: {
        "album": user_album.album,
        "user": user_album.user,
        "type": 'label',
        "showPromoteButton": false,
        "deleteButtonFunc": _vm.showAlbumDeleteConfirmDialog,
        "deleteButtonText": "Remove <br>from Record Label",
        "deleteButtonClass": 'height text-xs-left',
        "status": _vm._f("capitalize")(user_album.status)
      }
    })], 1)
  }))], 1)], 1) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.show_select_user_modal) ? _c('select-user-modal', {
    attrs: {
      "title": "Add Artist to Roster",
      "type": "artist",
      "dismiss": _vm.hideSelectUserDialog,
      "selectUser": _vm.sendRequestToAdd
    }
  }) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.label_delete_confirm_dialog),
      callback: function($$v) {
        _vm.label_delete_confirm_dialog = $$v
      },
      expression: "label_delete_confirm_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Delete a Label")]), _vm._v(" "), _c('v-card-text', [_vm._v("If you click OK, you won't see this label any more. Click OK to\n        delete <" + _vm._s(_vm.user.username) + ">, or click Cancel.")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.removeLabel()
      }
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.hideLabelDeleteConfirmDialog()
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.roster_delete_confirm_dialog),
      callback: function($$v) {
        _vm.roster_delete_confirm_dialog = $$v
      },
      expression: "roster_delete_confirm_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Delete a Roster")]), _vm._v(" "), _c('v-card-text', [_vm._v("If you click OK, you won't add roster's album to your label any more.\n        Click OK to delete <" + _vm._s(_vm.user.username) + ">, or click\n        Cancel.")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.removeRoster()
      }
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.hideRosterDeleteConfirmDialog()
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.album_delete_confirm_dialog),
      callback: function($$v) {
        _vm.album_delete_confirm_dialog = $$v
      },
      expression: "album_delete_confirm_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Remove an Album from your Record Label")]), _vm._v(" "), _c('v-card-text', [_vm._v("If you click OK, your followers won't see the album any more. Click\n        OK to remove <" + _vm._s(_vm.album.name) + ">, or click Cancel.")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.removeAlbum()
      }
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.hideAlbumDeleteConfirmDialog()
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.album_status_confirm_dialog),
      callback: function($$v) {
        _vm.album_status_confirm_dialog = $$v
      },
      expression: "album_status_confirm_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.status_dialog_title))]), _vm._v(" "), _c('v-card-text', [_vm._v(_vm._s(_vm.status_dialog_text))]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.updateAlbumStatus()
      }
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.hideAlbumStatusConfirmDialog()
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "my-dialog-2"
    },
    model: {
      value: (_vm.show_help_dialog),
      callback: function($$v) {
        _vm.show_help_dialog = $$v
      },
      expression: "show_help_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('label', [_vm._v("Labels")])]), _vm._v(" "), _c('v-card-text', [_c('div', [_c('h4', [_vm._v("Labels")]), _vm._v(" "), _c('ul', [_c('li', [_c('b', [_vm._v("Invite artists")]), _vm._v(" to your roster.")]), _vm._v(" "), _c('li', [_c('b', [_vm._v("Request albums")]), _vm._v(" to be added to your catalog.")])]), _vm._v(" "), _c('h4', [_vm._v("Artists")]), _vm._v(" "), _c('ul', [_c('li', [_c('b', [_vm._v("Manage")]), _vm._v(" your approved labels & albums.")])])])]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    staticClass: "px-4",
    attrs: {
      "dark": "",
      "round": "",
      "color": "blue"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeHelpDialog()
      }
    }
  }, [_vm._v("Ok, Got it!")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1629 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-section"
  }, [_c('h2', [_vm._v("Community Guidelines")]), _vm._v(" "), _c('p', [_vm._v("\n    Our mission is to provide a safe and ethical social experience, and we\n    require that all users follow our Community Guidelines. YouSound reserves\n    the right to terminate any account for conduct that we consider\n    inappropriate or harmful. First and second infractions will be\n    acknowledged by our staff via email to the account you signed up with. If\n    we deem your content unsuitable and not in compliance with our Community\n    Guidelines, YouSound has the ability to disable your video broadcasting\n    privileges and/or cut live transmission of your video broadcast to viewers\n    while you are streaming.\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    YouSound also has the ability to terminate your account and all of the\n    content within it, including your music, playlists, and products. There is\n    no fixed time for the length of termination for severe violations, and if\n    your account is reinstated, all of your content may be lost. YouSound is\n    an open platform that gives users unparalleled access to broadcast and\n    create revenue while consuming musical content for free. Thus, YouSound\n    has a zero-tolerance policy in moderating our community, and prefers\n    termination over suspension for serious violations. YouSound will not\n    allow anyone who does not comply with Community Guidelines to jeopardize\n    the privileges of the entire community.\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    As stated in our Terms of Service, we also provide these Community\n    Guidelines for every user to follow when using YouSound services. As\n    YouSound grows, we may encounter unforeseen cases that require us to\n    update our Community Guidelines. It is your responsibility as a user to\n    read and periodically check our Community Guidelines to fully understand\n    how to conduct your business and interactions, and ensure they are in\n    compliance with our Community Guidelines.\n  ")]), _vm._v(" "), _c('h3', [_vm._v("Respect The Law")]), _vm._v(" "), _c('p', [_vm._v("\n    We require users to obey their applicable local, regional, national, and\n    international laws while using our services. Behavior or actions\n    showcasing, encouraging, offering, or soliciting illegal activity are\n    strictly prohibited.\n  ")]), _vm._v(" "), _c('h3', [_vm._v("Evasion of Termination")]), _vm._v(" "), _c('p', [_vm._v("\n    Every termination is binding until an official representative of YouSound\n    reinstates your account. Any attempt to avoid our site, community, or chat\n    termination by logging in with other accounts, usernames, or appearing on\n    another user's account will also result in termination of the newly\n    created account, or the user's account you appear on.\n  ")]), _vm._v(" "), _c('h3', [_vm._v("Self-Abuse Conduct")]), _vm._v(" "), _c('p', [_vm._v("\n    Any conduct or activity that may endanger your life or cause you physical\n    harm is strictly prohibited. This includes, but is not limited to: use of\n    illegal drugs, suicide threats, intentional physical trauma, use of\n    weapons on yourself, and excessive alcohol consumption.\n  ")]), _vm._v(" "), _c('h3', [_vm._v("Threats of Violence")]), _vm._v(" "), _c('p', [_vm._v("\n    Acts, confessions, or threats of violence are taken extremely seriously.\n    This includes, but is not limited to:\n  ")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("\n      Attempts or threats to physically injure, hurt, harm, or kill others\n    ")]), _vm._v(" "), _c('li', [_vm._v("\n      Confessions of physically injuring, hurting, harming, or killing others\n    ")]), _vm._v(" "), _c('li', [_vm._v("\n      Use of weapons such as knives or guns to intimidate, injure, or kill\n      others\n    ")]), _vm._v(" "), _c('li', [_vm._v("\n      Attempts or threats to hack, or use other forms of technology to harm\n      others\n    ")])]), _vm._v(" "), _c('h3', [_vm._v("Hate Speech & Harassment")]), _vm._v(" "), _c('p', [_vm._v("\n    Hate speech, conduct, or any content that actively advocates, persuades,\n    or facilitates discrimination, harasses, or violates others with violence\n    based on ethnicity, race, sex, religion, sexual orientation, gender, age,\n    medical condition, disability, or physical characteristics, is strictly\n    prohibited. All hateful speech and conduct violate our Community\n    Guidelines, and all accounts associated with hate speech and conduct will\n    be terminated indefinitely.\n  ")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Tormenting or verbally abusing users to humiliate them")]), _vm._v(" "), _c('li', [_vm._v("Advising someone to hurt themselves")]), _vm._v(" "), _c('li', [_vm._v("Creating user accounts for the sole purpose of harassment")]), _vm._v(" "), _c('li', [_vm._v("Influencing others to harass users")]), _vm._v(" "), _c('li', [_vm._v("\n      Stalking or continually contacting users who do not wish to be contacted\n    ")]), _vm._v(" "), _c('li', [_vm._v("\n      Disclosing someone's personal information without their permission\n    ")]), _vm._v(" "), _c('li', [_vm._v("\n      Recording someone against their will with the intent to harm them\n    ")]), _vm._v(" "), _c('li', [_vm._v("Sharing information or content with the intent to inflict harm")]), _vm._v(" "), _c('li', [_vm._v("Browsing or raiding user profiles with the intent to cause harm")]), _vm._v(" "), _c('li', [_vm._v("Unwanted sexual or lewd advances and inappropriate behavior")]), _vm._v(" "), _c('li', [_vm._v("Sexual assault, rape, molestation, or content that promotes it")]), _vm._v(" "), _c('li', [_vm._v("Content featuring nudity or performing sexual acts")]), _vm._v(" "), _c('li', [_vm._v("\n      Sexual content (sound or visual), shared or threatened to be shared\n      without consent\n    ")]), _vm._v(" "), _c('li', [_vm._v("\n      Uninvited offers, demands, bribes, or extortion for sexual content and\n      services\n    ")]), _vm._v(" "), _c('li', [_vm._v("\n      Sexual services, prostitution, escorts, sexual massages, or recorded\n      sexual activity\n    ")]), _vm._v(" "), _c('li', [_vm._v("\n      Sexual content, nudity, sexual violence, or exploitation of minors, or\n      content that appears to include minors, or involves underage sex\n    ")])]), _vm._v(" "), _c('p', [_vm._v("\n    Harassment of any kind, including the actions stated in this section, is\n    any content or activity that attempts to degrade, intimidate, abuse, or\n    create an unfriendly environment for users, and is strictly prohibited and\n    subject to immediate account termination. YouSound must not be used to\n    encourage hateful speech, harassment, or conduct, whether the victims are\n    on or off YouSound services. Users of YouSound who engage in hateful\n    conduct will be prevented from using our services. In some cases, YouSound\n    may take legal action against users for hate speech or sexual misconduct,\n    including any content that promotes it.\n  ")]), _vm._v(" "), _c('h3', [_vm._v("Disclosure of Private Information")]), _vm._v(" "), _c('p', [_vm._v("\n    Sharing the private information of others is strictly prohibited. Any\n    information that reveals the private and personal information about any\n    individual or user on or off the YouSound service, including information\n    of their private residence, without permission is prohibited. This\n    includes but is not limited to:\n  ")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("\n      Sharing or disclosing personal and identifiable information (real name,\n      location, or photo ID)\n    ")]), _vm._v(" "), _c('li', [_vm._v("\n      Sharing or disclosing protected user profiles or any information from\n      said profiles\n    ")]), _vm._v(" "), _c('li', [_vm._v("\n      Sharing, disclosing, or broadcasting any content that is obtained from\n      filming or streaming in a way that invades another person's or user's\n      privacy and/or takes place on the private property of the person or user\n      without permission\n    ")])]), _vm._v(" "), _c('h3', [_vm._v("Impersonation & Imitation")]), _vm._v(" "), _c('p', [_vm._v("\n    Any content and/or activity on YouSound intended to impersonate, imitate,\n    or otherwise convince other users that you are another individual on\n    YouSound is strictly prohibited. Any attempt to falsify or skew the\n    perception of your real identity with the intention of convincing other\n    users that you are another member on YouSound will result in immediate\n    account termination.\n  ")]), _vm._v(" "), _c('h3', [_vm._v("Malicious Content & Conduct")]), _vm._v(" "), _c('p', [_vm._v("\n    Any conduct, activity, or content that disrupts, distorts, impedes,\n    interrupts, causes harm, or otherwise violates YouSound and its services\n    or another user's experience, on or off any device, is strictly prohibited.\n    These activities include, but are not limited to:\n  ")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("\n      Repeatedly uploading large amounts of unwanted messages, text, or\n      reports\n    ")]), _vm._v(" "), _c('li', [_vm._v("\n      Promotion and distribution of unauthorized and unofficial advertisements\n    ")]), _vm._v(" "), _c('li', [_vm._v("Phishing")]), _vm._v(" "), _c('li', [_vm._v("Fraud of any kind")]), _vm._v(" "), _c('li', [_vm._v("Distribution of viruses and malware")]), _vm._v(" "), _c('li', [_vm._v("\n      Data disinformation (uploading misleading metadata, intentional\n      miscategorization, feigning distress)\n    ")]), _vm._v(" "), _c('li', [_vm._v("\n      Tampering with publicly viewed data (e.g., artificially increasing\n      follower counts)\n    ")]), _vm._v(" "), _c('li', [_vm._v("Selling your personal or Verified User account")])]), _vm._v(" "), _c('h3', [_vm._v("Nudity, Sexual Content, Clothing and Attire")]), _vm._v(" "), _c('p', [_vm._v("\n    Nudity and sexual acts that are explicit, such as pornography or\n    intercourse, are prohibited. Sexual content that threatens and/or\n    encourages sexual violence and/or exploitation is strictly prohibited and\n    may be reported to law enforcement. Child exploitation will be swiftly\n    reported to authorities via the National Center for Missing & Exploited\n    Children. Sexually suggestive content, activity, and video broadcasting\n    are strictly prohibited. When reviewing this type of sexual content or\n    activity, we will consider context based on these factors, including but\n    not limited to:\n  ")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Conduct and commentary")]), _vm._v(" "), _c('li', [_vm._v("\n      Response to content, such as messages from users and broadcasters\n    ")]), _vm._v(" "), _c('li', [_vm._v("\n      Clothing, environment, such as area and location, and music, sounds,\n      props\n    ")]), _vm._v(" "), _c('li', [_vm._v("Camera angles and focus")]), _vm._v(" "), _c('li', [_vm._v("\n      Stream characteristics, such as title, images, and other metadata\n    ")]), _vm._v(" "), _c('li', [_vm._v("Profile and channel content, including profile picture, emojis, etc.")])]), _vm._v(" "), _c('p', [_vm._v("\n    All activity on YouSound is displayed publicly; therefore, we recommend\n    Verified Users wear clothing and attire that is appropriate for the\n    context, intent, or activity of your broadcast. For most streams,\n    including profile imagery, we recommend clothing suitable for public\n    settings. Attire is just one factor we might consider when evaluating\n    reports of potential sexual misconduct. Attire, clothing, or the lack\n    thereof, intended to be sexually suggestive includes underwear, intimate\n    clothing, or exposing or focusing on the male or female genitalia,\n    including but not limited to buttocks or nipples. If you notice any\n    violations regarding Nudity, Sexual content, or Attire, you can contact\n    violations@yousound.com.\n  ")]), _vm._v(" "), _c('h3', [_vm._v("Extreme Violence & Gore")]), _vm._v(" "), _c('p', [_vm._v("\n    Visual or audio content that focuses on extreme violence and/or gore is\n    prohibited.\n  ")]), _vm._v(" "), _c('h3', [_vm._v("Unauthorized Content & Copyrights")]), _vm._v(" "), _c('p', [_vm._v("\n    Uploading or broadcasting any audio or video content that you do not own\n    or do not have the rights to upload or broadcast, or are otherwise not\n    authorized to use, violates our Terms of Service and may make your content\n    eligible for DMCA takedowns by third-party rights holders. We do not\n    tolerate Verified Users uploading, broadcasting, or rebroadcasting\n    unauthorized content, playing other YouSound Verified User's content,\n    broadcasting third-party movies and television shows, rebroadcasting\n    televised or pre-recorded sports games, or uploading and broadcasting any\n    type of audio or visual content from other sites without permission from\n    the copyright owner.\n  ")]), _vm._v(" "), _c('h3', [_vm._v("Respect Intellectual Property Rights")]), _vm._v(" "), _c('p', [_vm._v("\n    When Verified Users upload or broadcast audio or video content on\n    YouSound, they should create original content or content that they are\n    authorized to broadcast from the respective copyright owners. Audio or\n    Video that involves derivative content, duplicates, or performances of\n    another person's or user's copyrighted content may violate their\n    intellectual property and may be eligible for a DMCA takedown by the\n    copyright holder. It's of the utmost importance that Verified Users ensure\n    their content is original and adheres to applicable copyright laws, and\n    fair use to secure the authorization rights needed before sharing audio or\n    video content on YouSound. YouSound keeps track of repeat infringers;\n    multiple copyright violations will result in multiple strikes on your\n    account and lead to termination of your account. This policy applies to\n    music, video, visuals, graphics, and other performance arts on YouSound.\n  ")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("\n      Performance Art: Performances of existing copyrighted content or works\n      require you to have the authorized right to share the content and/or\n      your performance of said work.\n    ")]), _vm._v(" "), _c('li', [_vm._v("\n      Live Music Performance & Creation: Live musical content must be original\n      music. You may live video broadcast a live performance of a \"cover\"\n      song, for example, musical content written by someone else other than\n      yourself, as long as it does not incorporate recorded musical or other\n      audio elements owned by another person or party, such as an instrumental\n      backing track of someone else's recording.\n    ")]), _vm._v(" "), _c('li', [_vm._v("\n      Pre-recorded Audio & Music: Radio-style live video broadcasts that\n      include pre-recorded audio or music, live audio and music performances\n      like covering a copyrighted work, karaoke, lip-syncing, or impersonation\n      of other people are reserved only for Verified Users who have upgraded\n      their account to clear copyrighted content.\n    ")])])])
}]}

/***/ }),
/* 1630 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feature-bar-container"
  }, [_c('div', {
    staticClass: "main-text"
  }, [_vm._v("Feature content")]), _vm._v(" "), _c('div', {
    staticClass: "divider mt-4 mb-5"
  }), _vm._v(" "), _c('div', {
    staticClass: "feature-flex"
  }, [_c('div', {
    staticClass: "w-75"
  }, [_c('div', {
    staticClass: "feature-head mb-3"
  }, [_vm._v("Web description")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-feature"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.webTitle),
      expression: "webTitle"
    }],
    staticClass: "feature-input",
    attrs: {
      "type": "text",
      "placeholder": "",
      "maxlength": "46"
    },
    domProps: {
      "value": (_vm.webTitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.webTitle = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "input-feature mt-3"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.webReview),
      expression: "webReview"
    }],
    staticClass: "feature-input",
    attrs: {
      "type": "text",
      "maxlength": "120"
    },
    domProps: {
      "value": (_vm.webReview)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.webReview = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "feature-head mb-3 mt-5"
  }, [_vm._v("Mobile description")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-feature"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mobileTitle),
      expression: "mobileTitle"
    }],
    staticClass: "feature-input",
    attrs: {
      "type": "text",
      "maxlength": "26"
    },
    domProps: {
      "value": (_vm.mobileTitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mobileTitle = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "input-feature mt-3"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mobileReview),
      expression: "mobileReview"
    }],
    staticClass: "feature-input",
    attrs: {
      "type": "text",
      "maxlength": "60"
    },
    domProps: {
      "value": (_vm.mobileReview)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mobileReview = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "w-25"
  }, [_c('div', {
    staticClass: "feature-head mb-3"
  }, [_vm._v("Content Image")]), _vm._v(" "), _c('div', {
    staticClass: "feature-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.album.cover.url,
      "width": "100%"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "divider mt-4 mb-5"
  }), _vm._v(" "), _c('div', [_c('v-btn', {
    staticClass: "post-content",
    attrs: {
      "loading": _vm.loading
    },
    on: {
      "click": function($event) {
        _vm.saveTitleAndReview()
      }
    }
  }, [_vm._v("\n\t\t \tPost Content\n\t\t")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dflex align-center justify-space-between"
  }, [_c('label', {
    staticClass: "label-title"
  }, [_vm._v("Title for Web")]), _vm._v(" "), _c('label', {
    staticClass: "label-time"
  }, [_vm._v("*46 chars max")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dflex align-center justify-space-between"
  }, [_c('label', {
    staticClass: "label-title"
  }, [_vm._v("Review for web")]), _vm._v(" "), _c('label', {
    staticClass: "label-time"
  }, [_vm._v("*120 chars max")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dflex align-center justify-space-between"
  }, [_c('label', {
    staticClass: "label-title"
  }, [_vm._v("Title for mobile")]), _vm._v(" "), _c('label', {
    staticClass: "label-time"
  }, [_vm._v("*26 chars max")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dflex align-center justify-space-between"
  }, [_c('label', {
    staticClass: "label-title"
  }, [_vm._v("Review for mobile")]), _vm._v(" "), _c('label', {
    staticClass: "label-time"
  }, [_vm._v("*60 chars max")])])
}]}

/***/ }),
/* 1631 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "top-icon-wrapper text-center pb-4"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1474),
      "width": "49",
      "height": "44",
      "alt": "send airplane icon"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "text-sf-pro text-20"
  }, [_vm._v("Sent another confirmation email to")]), _vm._v(" "), _c('div', {
    staticClass: "text-sf-pro email"
  }, [_vm._v(_vm._s(_vm.userEmail))])])])
},staticRenderFns: []}

/***/ }),
/* 1632 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uploaderBox"
  }, [_c('div', {
    staticClass: "uploaderBox__input"
  }, [_c('input', {
    staticClass: "uploaderBox__file",
    attrs: {
      "type": "file",
      "id": "file_uploader",
      "accept": _vm.accept
    },
    on: {
      "change": function($event) {
        _vm.filesChange($event.target.files)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "btn theme--dark blue",
    attrs: {
      "for": "file_uploader"
    }
  }, [_vm._v("Upload")])]), _vm._v(" "), _c('div', {
    staticClass: "uploaderBox__desc"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fileName),
      expression: "fileName"
    }],
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.fileName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fileName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('v-icon', {
    staticClass: "clear-btn",
    on: {
      "click": function($event) {
        _vm.deleteFile()
      }
    }
  }, [_vm._v("clear")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "download-app",
    class: [("download-app_" + _vm.type)]
  }, [(_vm.type === 'type1') ? _c('v-container', {
    class: [("_" + _vm.type)],
    attrs: {
      "grid-list-lg": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": ""
    }
  }, [_c('div', {
    staticClass: "_title"
  }, [_vm._v("\n          Scan QR code.\n          "), _c('br'), _vm._v("\n          Download the app.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "_subtitle"
  }, [_vm._v("\n          Point your camera at the QR code & open the link.\n          "), _c('br'), _vm._v("\n          You will be redirected to the App Store or Google Play store.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "store-badge"
  }, [_c('img', {
    staticClass: "ios-store mr-3",
    attrs: {
      "src": _vm.iosStore,
      "width": "200",
      "alt": "ios app store icon"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "android-store",
    attrs: {
      "src": _vm.androidPlaystore,
      "width": "200",
      "alt": "android app store icon"
    }
  })])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('div', {
    staticClass: "qr-wrapper"
  }, [_c('img', {
    attrs: {
      "src": _vm.renderQR,
      "width": "100%",
      "alt": _vm.altText
    }
  })])])], 1)], 1) : (_vm.type === 'type2') ? _c('v-container', {
    class: [("_" + _vm.type)],
    attrs: {
      "grid-list-lg": ""
    }
  }, [(!_vm.showPlan) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "qrsection-card": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": "",
      "details-card": ""
    }
  }, [_c('div', {
    staticClass: "dflex"
  }, [_c('img', {
    staticClass: "mr-2",
    attrs: {
      "src": __webpack_require__(1466),
      "width": "30",
      "alt": "spotlight icon"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "_title"
  }, [_vm._v("Spotlight video")])]), _vm._v(" "), _c('hr', {
    staticClass: "my-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "_subtitle"
  }, [_vm._v("\n          Download the app to upload a video for your spotlight.\n          "), _c('br'), _vm._v("\n          When potential subscibers preview your content they will see your\n          video.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "_highlight"
  }, [_c('div', {
    staticClass: "intro"
  }, [_vm._v("Things to mention in your video:")]), _vm._v(" "), _c('ul', {
    staticClass: "_highlight-list"
  }, [_c('li', [_vm._v("Who you are")]), _vm._v(" "), _c('li', [_vm._v("The type of content you’re offering")]), _vm._v(" "), _c('li', [_vm._v("\n              Run up your streams! Their subscription is shared with the\n              creators they stream most!\n            ")])])]), _vm._v(" "), _c('hr', {
    staticClass: "mb-5"
  }), _vm._v(" "), _c('div', {
    staticClass: "store-badge"
  }, [_c('div', {
    staticClass: "qr-wrapper"
  }, [_c('img', {
    attrs: {
      "src": _vm.renderQR,
      "width": "130",
      "alt": _vm.altText
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "badges"
  }, [_c('div', {
    staticClass: "_title"
  }, [_vm._v("\n              Scan QR code.\n              "), _c('br'), _vm._v("\n              Download the app.\n            ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', [_c('img', {
    staticClass: "ios-store mr-3",
    attrs: {
      "src": _vm.iosStore,
      "width": "30%",
      "alt": "ios app store icon"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "android-store",
    attrs: {
      "src": _vm.androidPlaystore,
      "width": "30%",
      "alt": "android app store icon"
    }
  })])], 1)])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "featured-card": ""
    }
  }, [_c('div', {
    staticClass: "card-wrapper"
  }, [_c('div', {
    staticClass: "card-image",
    style: (("background-image: url(" + _vm.userImage + ");}"))
  }, [_c('div', {
    staticClass: "featured-artist dflex justify-space-between align-center"
  }, [_c('div', [_c('div', {
    staticClass: "__label"
  }, [_vm._v("Subscribe to support")]), _vm._v(" "), _c('div', {
    staticClass: "artist-name"
  }, [_c('user-tag', {
    attrs: {
      "user": _vm.currentUser
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "volume allChildrenCenter"
  }, [(true) ? _c('v-icon', [_vm._v("volume_up")]) : _c('v-icon', [_vm._v("volume_off")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "card-details"
  }, [_c('img', {
    staticClass: "mb-2",
    attrs: {
      "src": __webpack_require__(49),
      "width": "100",
      "alt": "yousound logo"
    }
  }), _vm._v(" "), _c('div', [_vm._v("\n              Get full access to all creators & their content.\n              "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("50%")]), _vm._v(" of your subscription shared with creators you stream the most.\n            ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("1 month free, then $10/month.")]), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-2 showPlanBtn",
    attrs: {
      "depressed": "",
      "block": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.showPlan = true;
      }
    }
  }, [_vm._v("Start 30 day free trial")])], 1)])])], 1) : _vm._e(), _vm._v(" "), (_vm.showPlan) ? _c('AuthPlan') : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1634 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-container"
  }, [_c('ul', _vm._l((_vm.footers), function(footer, i) {
    return _c('li', {
      key: i,
      on: {
        "click": function($event) {
          _vm.$router.push({
            name: footer.path
          })
        }
      }
    }, [_c('span', {
      staticClass: "footer-wrapper"
    }, [(footer.isNotificationActive) ? _c('img', {
      staticClass: "__count",
      attrs: {
        "src": _vm.notificationIcon,
        "width": "8"
      }
    }) : _vm._e(), _vm._v(" "), (footer.path === _vm.currentRoute) ? _c('img', {
      attrs: {
        "src": footer.activeIcon,
        "width": "23"
      }
    }) : _c('img', {
      attrs: {
        "src": footer.icon,
        "width": "23"
      }
    })])])
  }))])
},staticRenderFns: []}

/***/ }),
/* 1635 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video-page create-page mx-5"
  }, [_c('div', {
    staticClass: "page-content"
  }, [_c('drag-file-uploader', {
    ref: "dragFileUploader",
    attrs: {
      "accept": "mp3/*",
      "type": "file",
      "category": "audio",
      "autoUpload": true
    },
    on: {
      "filePicked": _vm.pickedFile
    }
  })], 1), _vm._v(" "), (_vm.album.tracks.length) ? _c('div', {
    staticClass: "track-list-section"
  }, [_c('h4', {
    staticClass: "track-list-title",
    attrs: {
      "id": "track_list"
    }
  }, [_vm._v("Tracklist")]), _vm._v(" "), _c('draggable', {
    staticClass: "track-items",
    attrs: {
      "handle": ".item-handle"
    },
    model: {
      value: (_vm.album.tracks),
      callback: function($$v) {
        _vm.$set(_vm.album, "tracks", $$v)
      },
      expression: "album.tracks"
    }
  }, [_c('transition-group', _vm._l((_vm.album.tracks), function(file, index) {
    return _c('div', {
      key: index,
      staticClass: "track-item"
    }, [_c('label', {
      staticClass: "item-index pl-3"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('div', {
      staticClass: "item-section"
    }, [_c('img', {
      staticClass: "item-handle",
      attrs: {
        "width": "18",
        "src": "/static/images/t-menu.svg",
        "alt": ""
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (file.file_name),
        expression: "file.file_name"
      }],
      staticClass: "item-name",
      attrs: {
        "type": "text",
        "disabled": file.status != _vm.status.success,
        "placeholder": "Track name"
      },
      domProps: {
        "value": (file.file_name)
      },
      on: {
        "focus": function($event) {
          _vm.onInputFocus(index, $event)
        },
        "blur": function($event) {
          _vm.onInputBlur(index, $event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(file, "file_name", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "d-flex align-center ml-2 pl-2 download-price"
    }, [_c('i', {
      staticClass: "fa fa-usd",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (file.download_price),
        expression: "file.download_price"
      }],
      staticClass: "item-name",
      attrs: {
        "type": "text",
        "disabled": file.status != _vm.status.success,
        "placeholder": "Set download price ($1 - $1000)"
      },
      domProps: {
        "value": (file.download_price)
      },
      on: {
        "focus": function($event) {
          _vm.onInputFocus(index, $event)
        },
        "blur": function($event) {
          _vm.onInputBlur(index, $event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(file, "download_price", $event.target.value)
        }
      }
    })]), _vm._v(" "), (file.status == _vm.status.uploading) ? _c('v-progress-circular', {
      staticClass: "primary--text loading",
      attrs: {
        "indeterminate": "",
        "size": 20
      }
    }) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "action-btns"
    }, [(file.status == _vm.status.success) ? _c('v-icon', {
      staticClass: "done"
    }, [_vm._v("done")]) : _vm._e(), _vm._v(" "), (file.status == _vm.status.failed) ? _c('v-icon', {
      staticClass: "failed"
    }, [_vm._v("error_outline")]) : _vm._e(), _vm._v(" "), (file.status != _vm.status.uploading) ? _c('v-icon', {
      staticClass: "clear-btn",
      on: {
        "click": function($event) {
          _vm.deleteTrack(index)
        }
      }
    }, [_vm._v("clear")]) : _vm._e()], 1)], 1)])
  }))], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "my-dialog-1"
    },
    model: {
      value: (_vm.show_unauthorized_content_dialog),
      callback: function($$v) {
        _vm.show_unauthorized_content_dialog = $$v
      },
      expression: "show_unauthorized_content_dialog"
    }
  }, [_c('v-card', [_c('v-card-text', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Unauthorized audio content")]), _vm._v(" "), _c('div', [_vm._v("\n          The song\n          "), _c('span', {
    staticClass: "blue--text"
  }, [_vm._v(_vm._s(_vm.currentFile.track_title))]), _vm._v(" by\n          "), _c('span', {
    staticClass: "blue--text"
  }, [_vm._v(_vm._s(_vm.currentFile.artist_name))]), _vm._v(" was\n          detected in your upload. Please delete any unauthorized tracks in\n          your album to complete your upload. if you find this message, please\n          contact support.\n        ")])]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "dark": "",
      "color": "grey"
    },
    nativeOn: {
      "click": function($event) {
        _vm.show_unauthorized_content_dialog = false
      }
    }
  }, [_vm._v("Return to upload page")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "dark": "",
      "color": "red"
    },
    nativeOn: {
      "click": function($event) {
        _vm.cancelTrack()
      }
    }
  }, [_vm._v("Cancel Upload")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "my-dialog-1"
    },
    model: {
      value: (_vm.show_duplicate_content_dialog),
      callback: function($$v) {
        _vm.show_duplicate_content_dialog = $$v
      },
      expression: "show_duplicate_content_dialog"
    }
  }, [_c('v-card', [_c('v-card-text', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Duplicate upload")]), _vm._v(" "), _c('div', [_vm._v("\n          The song\n          "), _c('span', {
    staticClass: "blue--text"
  }, [_vm._v(_vm._s(_vm.currentFile.track_title))]), _vm._v(" by\n          "), _c('span', {
    staticClass: "blue--text"
  }, [_vm._v(_vm._s(_vm.currentFile.artist_name))]), _vm._v(" was\n          detected in your upload. Only one copy of a song can exist on\n          YouSound. If you are a collaborator on this song, contact the\n          original uploader and request to add yourself as a collaborator then\n          re-upload the album. Please delete any duplicate tracks in your\n          album to complete your upload.\n        ")])]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "dark": "",
      "color": "grey"
    },
    nativeOn: {
      "click": function($event) {
        _vm.show_duplicate_content_dialog = false
      }
    }
  }, [_vm._v("Return to upload page")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "dark": "",
      "color": "red"
    },
    nativeOn: {
      "click": function($event) {
        _vm.cancelTrack()
      }
    }
  }, [_vm._v("Cancel Upload")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1636 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page browser-page"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "/static/images/nav_logo_primary.png"
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Update Your Browser")]), _vm._v(" "), _c('p', [_vm._v("\n    We only support the latest browsers, and there’s plently to choose from.\n  ")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    staticClass: "chrome",
    attrs: {
      "href": "https://www.google.com/chrome/"
    }
  })]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "firefox",
    attrs: {
      "href": "https://www.mozilla.org/en-US/firefox/"
    }
  })]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "brave",
    attrs: {
      "href": "https://brave.com/download/"
    }
  })]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "opera",
    attrs: {
      "href": "https://www.opera.com/"
    }
  })]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "yandex",
    attrs: {
      "href": "https://browser.yandex.com/"
    }
  })])])])
}]}

/***/ }),
/* 1637 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "attach"
  }, [(!_vm.dataOnlyMode) ? _c('div', {
    staticClass: "attach__content"
  }, [(_vm.stream_assoc.value) ? [(_vm.stream_assoc.type == 'Album') ? _c('attach-card', {
    attrs: {
      "image": _vm._.get(_vm.stream_assoc.value, 'cover.thumb.url', ''),
      "title": _vm.stream_assoc.value.name,
      "subtitle": ((_vm.stream_assoc.value.tracks.length) + " tracks")
    }
  }) : _vm._e(), _vm._v(" "), (_vm.stream_assoc.type == 'ShopProduct') ? _c('attach-card', {
    attrs: {
      "image": _vm._.get(_vm.stream_assoc.value, 'covers[0].cover.thumb.url', ''),
      "title": _vm.stream_assoc.value.name,
      "subtitle": ("$" + (_vm.$options.filters.formatNumber(
          _vm.stream_assoc.value.price
        )))
    }
  }) : _vm._e(), _vm._v(" "), (_vm.stream_assoc.type == 'User') ? _c('attach-card', {
    attrs: {
      "image": _vm._.get(_vm.stream_assoc.value, 'avatar.thumb.url', ''),
      "title": _vm.stream_assoc.value.username,
      "subtitle": ((_vm.stream_assoc.value.followers) + " followers")
    }
  }) : _vm._e()] : [_c('div', {
    staticClass: "attach__image"
  })]], 2) : _vm._e(), _vm._v(" "), (!_vm.hideMetaActions) ? _c('div', {
    staticClass: "attach__footer"
  }, [(_vm.stream_assoc.value) ? [_c('span', {
    staticClass: "attach__cta",
    on: {
      "click": function($event) {
        _vm.openAttachPicker()
      }
    }
  }, [_vm._v("Change")]), _vm._v(" "), (!_vm.dataOnlyMode) ? _c('span', {
    staticClass: "attach__cta danger",
    on: {
      "click": function($event) {
        _vm.removeAttach()
      }
    }
  }, [_vm._v("Remove")]) : _vm._e()] : [_c('span', {
    staticClass: "attach__cta",
    on: {
      "click": function($event) {
        _vm.openAttachPicker()
      }
    }
  }, [_vm._v(_vm._s(_vm.ctaTitle))])]], 2) : _vm._e(), _vm._v(" "), (_vm.show_attach_picker) ? _c('attach-picker', {
    attrs: {
      "dismiss": _vm.closeAttachPicker,
      "title": _vm.attachPickerTitle,
      "customAlbums": _vm.customAlbums,
      "customProducts": _vm.customProducts,
      "fullscreen": _vm.fullscreen
    },
    on: {
      "getSelected": _vm.getSelected
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1638 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'bg-white': _vm.$vuetify.breakpoint.width <= 1280
    }
  }, [(_vm.current !== 7) ? _c('div', {
    staticClass: "text-center pt-5",
    class: {
      mb110: _vm.$vuetify.breakpoint.width > 1280
    }
  }, [(_vm.$vuetify.breakpoint.width > 1280 && _vm.current !== 1) ? _c('v-btn', {
    staticClass: "absolute ma-0 btn-back",
    attrs: {
      "id": "signup-back-button",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.handlePrevStage()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1442),
      "width": "24",
      "alt": "arrow-left"
    }
  })]) : _vm._e(), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(49),
      "width": "150"
    }
  })]), _vm._v(" "), (_vm.$vuetify.breakpoint.width > 1280) ? _c('v-btn', {
    staticClass: "absolute ma-0 btn-close",
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.$router.push("/")
      }
    }
  }, [_c('v-icon', {
    staticClass: "font-size-34"
  }, [_vm._v("close")])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [(_vm.current !== 7) ? _c('div', {
    staticClass: "onboarding auth",
    class: [
      ("onboarding-" + (_vm.currentStage.stage)),
      {
        allowFullPage: _vm.currentStage.allowFullPage,
        onMobile: _vm.onMobile,
        aboveMobile: !_vm.onMobile,
      } ]
  }, [(_vm.current <= 6 && _vm.$vuetify.breakpoint.width > 1280) ? _c('div', {
    staticClass: "auth__title"
  }, [_vm._v("\n        Sign up\n      ")]) : _vm._e(), _vm._v(" "), (!_vm.currentStage.hideStage) ? _c('Stager', {
    attrs: {
      "staging": "onboarding"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.current === 1) ? _c('div', {
    staticClass: "stage-wrapper width-control"
  }, [_c('ChooseAccount')], 1) : (_vm.accountCategory === 'creator') ? _c('div', {
    staticClass: "stage-wrapper"
  }, [_c('div', {
    staticClass: "width-control"
  }, [_c('transition', {
    attrs: {
      "name": "slide-fadeInOnly"
    }
  }, [(_vm.current === 2) ? _c('AccountType', {
    on: {
      "actionPrevStage": _vm.handlePrevStage
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "width-control"
  }, [_c('transition', {
    attrs: {
      "name": "slide-fadeInOnly"
    }
  }, [(_vm.current === 3) ? _c('AccountInfo', {
    on: {
      "actionPrevStage": _vm.handlePrevStage
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "width-control"
  }, [_c('transition', {
    attrs: {
      "name": "slide-fadeInOnly"
    }
  }, [(_vm.current === 4) ? _c('ProfileImage', {
    on: {
      "actionPrevStage": _vm.handlePrevStage
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "width-control"
  }, [_c('transition', {
    attrs: {
      "name": "slide-fadeInOnly"
    }
  }, [(_vm.current === 5) ? _c('AgeLocation', {
    on: {
      "actionPrevStage": _vm.handlePrevStage
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "width-control"
  }, [_c('transition', {
    attrs: {
      "name": "slide-fadeInOnly"
    }
  }, [(_vm.current === 6) ? _c('GetVerified', {
    on: {
      "actionPrevStage": _vm.handlePrevStage
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "width-control _max"
  }, [_c('transition', {
    attrs: {
      "name": "slide-fadeInOnly"
    }
  }, [(_vm.current === 7) ? _c('CheckEmail', {
    on: {
      "actionPrevStage": _vm.handlePrevStage
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "width-control"
  }, [_c('transition', {
    attrs: {
      "name": "slide-fadeInOnly"
    }
  }, [(_vm.current === 8) ? _c('AuthPlan') : _vm._e()], 1)], 1)]) : (_vm.accountCategory === 'listener') ? _c('div', {
    staticClass: "stage-wrapper"
  }, [_c('div', {
    staticClass: "width-control"
  }, [_c('transition', {
    attrs: {
      "name": "slide-fadeInOnly"
    }
  }, [(_vm.current === 2) ? _c('AccountType', {
    on: {
      "actionPrevStage": _vm.handlePrevStage
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "width-control"
  }, [_c('transition', {
    attrs: {
      "name": "slide-fadeInOnly"
    }
  }, [(_vm.current === 3) ? _c('AccountInfo', {
    on: {
      "actionPrevStage": _vm.handlePrevStage
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "width-control"
  }, [_c('transition', {
    attrs: {
      "name": "slide-fadeInOnly"
    }
  }, [(_vm.current === 4) ? _c('ProfileImage', {
    on: {
      "actionPrevStage": _vm.handlePrevStage
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "width-control"
  }, [_c('transition', {
    attrs: {
      "name": "slide-fadeInOnly"
    }
  }, [(_vm.current === 5) ? _c('AgeLocation', {
    on: {
      "actionPrevStage": _vm.handlePrevStage
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "width-control"
  }, [_c('transition', {
    attrs: {
      "name": "slide-fadeInOnly"
    }
  }, [(_vm.current === 6) ? _c('GetVerified', {
    on: {
      "actionPrevStage": _vm.handlePrevStage
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "width-control"
  }, [_c('transition', {
    attrs: {
      "name": "slide-fadeInOnly"
    }
  }, [(_vm.current === 8) ? _c('ConfirmEmail') : _vm._e()], 1)], 1)]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.current === 7) ? _c('CheckEmail', {
    on: {
      "actionPrevStage": _vm.handlePrevStage
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 1639 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard-nav margin-top-header"
  }, [_c('v-toolbar', {
    staticClass: "nav-z-index",
    attrs: {
      "fixed": "",
      "app": "",
      "flat": "",
      "height": "73"
    }
  }, [_c('content-top-header', {
    staticClass: "black-theme"
  }, [_c('template', {
    slot: "topHeader"
  }, [_c('ul', {
    staticClass: "width100"
  }, [_vm._l((_vm.tabs), function(tab) {
    return _c('li', {
      key: tab.id,
      staticClass: "nav-li",
      attrs: {
        "href": ("#" + (tab.id))
      }
    }, [_c('label', {
      staticClass: "nav-label",
      on: {
        "click": function($event) {
          _vm.setTab(tab.pathName)
        }
      }
    }, [(tab.icon) ? _c('img', {
      staticClass: "li-icon",
      attrs: {
        "src": tab.icon,
        "width": "18"
      }
    }) : _vm._e(), _vm._v("\n                      " + _vm._s(tab.title) + "\n                    ")])])
  }), _vm._v(" "), _c('v-spacer')], 2)])], 2)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1640 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "track-card dflex",
    class: {
      playing: _vm.isPlaying
    }
  }, [(!_vm.isEmptyAlbum) ? _c('v-flex', {
    staticClass: "track-info",
    attrs: {
      "xs12": "",
      "pa-0": ""
    },
    on: {
      "mouseenter": function($event) {
        _vm.is_component_hover = true
      },
      "mouseleave": function($event) {
        _vm.is_component_hover = false
      }
    }
  }, [_c('v-flex', {
    staticClass: "track-cover px-0 py-0",
    attrs: {
      "xs12": ""
    }
  }, [(_vm.item.album_type == 'playlist') ? [_c('div', {
    staticClass: "playlist-icon"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/playlist.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "track-image",
    class: _vm.item.album_type,
    style: ({
      'background-image': ("url(" + _vm.album1Cover + "), url(" + _vm.album2Cover + "), url(" + _vm.album3Cover + "), url(" + _vm.album4Cover + ")"),
    })
  })] : [_c('div', {
    staticClass: "track-image",
    style: ({
      'background-image': 'url(' + _vm.item.cover.url + ')'
    })
  })], _vm._v(" "), (_vm.forCollection) ? _c('v-flex', {
    staticClass: "track-actions forCollection",
    attrs: {
      "xs12": ""
    }
  }, [(!_vm.isPlaying || _vm.$store.state.player.isPaused) ? _c('span', {
    staticClass: "collection-counter"
  }, [_vm._v(_vm._s(_vm.objectIndex + 1))]) : _vm._e(), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        _vm.gotoItem()
      }
    }
  }, [_c('v-flex', {
    staticClass: "touch-flex",
    attrs: {
      "xs12": ""
    }
  })], 1), _vm._v(" "), (!_vm.isPlaying || _vm.$store.state.player.isPaused) ? _c('v-btn', {
    staticClass: "play-button",
    class: {
      'play-button-2': _vm.playButton2
    },
    nativeOn: {
      "click": function($event) {
        _vm.playSong()
      }
    }
  }, [_c('v-icon', {
    class: [{
      'play-button-2': _vm.playButton2,
      iconHasWhiteBG: _vm.playButton2IconHasWhiteBG,
      'black--text': _vm.playButton2IconHasWhiteBG,
    } ]
  }, [_vm._v("\n\t\t\t\t\t\t\tplay_arrow\n\t\t\t\t\t\t")])], 1) : _vm._e(), _vm._v(" "), (_vm.isPlaying && !_vm.$store.state.player.isPaused) ? _c('v-btn', {
    staticClass: "play-button",
    nativeOn: {
      "click": function($event) {
        _vm.pauseSong()
      }
    }
  }, [_c('v-icon', {
    class: [{
      'play-button-2': _vm.playButton2,
      iconHasWhiteBG: _vm.playButton2IconHasWhiteBG,
      'black--text': _vm.playButton2IconHasWhiteBG,
    }]
  }, [_vm._v("\n\t\t\t\t\t\t\tpause\n\t\t\t\t\t\t")])], 1) : _vm._e(), _vm._v(" "), (_vm.currentUser && _vm.willMenuRender && !_vm.hideMoreMenu) ? _c('v-menu', {
    staticClass: "track-menu",
    attrs: {
      "offset-y": "",
      "close-on-content-click": false,
      "nudge-width": 100
    },
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.is_menu_hover = true
      }
    },
    slot: "activator"
  }, [_c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("more_horiz")])], 1), _vm._v(" "), _c('v-card', [_c('v-list', [(_vm.currentUser.user_type == 'label') ? _c('v-list-tile', {
    key: "add_to_my_label",
    staticClass: "default-menu-item track-menu-item",
    nativeOn: {
      "click": function($event) {
        _vm.addToMyLabel()
      }
    }
  }, [_c('v-list-tile-title', [_c('label', [_vm._v("Add to my label")])])], 1) : _vm._e(), _vm._v(" "), ( false) ? _c('v-list-tile', {
    key: "add_to_playlist",
    staticClass: "default-menu-item track-menu-item has-sub-menu"
  }, [_c('v-menu', {
    staticClass: "track-menu",
    attrs: {
      "offset-x": ""
    },
    model: {
      value: (_vm.submenu),
      callback: function($$v) {
        _vm.submenu = $$v
      },
      expression: "submenu"
    }
  }, [_c('v-list-tile-title', {
    staticClass: "has-sub-menu",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('label', [_vm._v("Add to Playlist")])]), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
    key: "add_to_playlist",
    staticClass: "default-menu-item track-menu-item",
    nativeOn: {
      "click": function($event) {
        _vm.addToNewPlaylist()
      }
    }
  }, [_c('v-list-tile-title', [_c('label', [_vm._v("New Playlist")])])], 1), _vm._v(" "), _vm._l((_vm.playlists), function(list, list_index) {
    return _c('v-list-tile', {
      key: ("playlist_2_" + list_index),
      staticClass: "default-menu-item track-menu-item",
      nativeOn: {
        "click": function($event) {
          _vm.addToPlaylist(list)
        }
      }
    }, [_c('v-list-tile-title', [_c('label', [_vm._v(_vm._s(list.name))])])], 1)
  })], 2)], 1)], 1) : _vm._e(), _vm._v(" "), (
    ['admin', 'moderator'].indexOf(_vm.currentUser.user_type) >
    -1 && !_vm.item.recommended
  ) ? _c('v-list-tile', {
    key: "recommended",
    staticClass: "default-menu-item track-menu-item",
    on: {
      "click": function($event) {
        (_vm.showFeatureModal = true) && (_vm.menu = false)
      }
    }
  }, [_c('v-list-tile-title', [_c('div', {
    staticClass: "menu-list-item dflex align-center px-2"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(324),
      "width": "16"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "ml-0"
  }, [_vm._v("Feature")])])])], 1) : _vm._e(), _vm._v(" "), (
    ['admin', 'moderator'].indexOf(_vm.currentUser.user_type) >
    -1 && _vm.item.recommended
  ) ? _c('v-list-tile', {
    key: "unrecommended",
    staticClass: "default-menu-item track-menu-item",
    nativeOn: {
      "click": function($event) {
        _vm.unrecommendAlbum()
      }
    }
  }, [_c('v-list-tile-title', [_c('div', {
    staticClass: "menu-list-item dflex align-center px-2"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(324),
      "width": "16"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "ml-0"
  }, [_vm._v("Unfeature")])])])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile', {
    staticClass: "default-menu-item track-menu-item"
  }, [_c('v-list-tile-title', [_c('div', {
    staticClass: "menu-list-item dflex align-center px-2"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(602),
      "width": "16"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "ml-0"
  }, [_vm._v("Edit feature")])])])], 1), _vm._v(" "), _c('v-list-tile', {
    staticClass: "default-menu-item track-menu-item"
  }, [_c('v-list-tile-title', [_c('div', {
    staticClass: "menu-list-item dflex align-center px-2"
  }, [_c('img', {
    staticClass: "filter-invert",
    attrs: {
      "src": __webpack_require__(57),
      "width": "16"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "ml-0"
  }, [_vm._v("Add to collection")])])])], 1), _vm._v(" "), _c('v-list-tile', {
    staticClass: "default-menu-item track-menu-item"
  }, [_c('v-list-tile-title', [_c('div', {
    staticClass: "menu-list-item dflex align-center px-2"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(604),
      "width": "16"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "ml-0"
  }, [_vm._v("Add to playlist")])])])], 1), _vm._v(" "), _c('v-list-tile', {
    key: "share",
    staticClass: "default-menu-item track-menu-item",
    nativeOn: {
      "click": function($event) {
        _vm.showShareDialog()
      }
    }
  }, [_c('v-list-tile-title', [_c('div', {
    staticClass: "menu-list-item dflex align-center px-2"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(222),
      "width": "16"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "ml-0"
  }, [_vm._v("Share")])])])], 1), _vm._v(" "), (_vm.item.user.id != _vm.currentUser.id) ? _c('v-list-tile', {
    key: "hide",
    staticClass: "default-menu-item track-menu-item",
    nativeOn: {
      "click": function($event) {
        _vm.showHideAlbumDialog()
      }
    }
  }, [_c('v-list-tile-title', [_c('div', {
    staticClass: "menu-list-item dflex align-center px-2"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(592),
      "width": "16"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "ml-0"
  }, [_vm._v("Hide")])])])], 1) : _vm._e(), _vm._v(" "), (_vm.item.user.id != _vm.currentUser.id) ? _c('v-list-tile', {
    key: "report",
    staticClass: "default-menu-item track-menu-item",
    nativeOn: {
      "click": function($event) {
        _vm.openReportDialog()
      }
    }
  }, [_c('v-list-tile-title', [_c('div', {
    staticClass: "menu-list-item dflex align-center px-2"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(321),
      "width": "16"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "ml-0"
  }, [_vm._v("Report")])])])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile', {
    key: "remove",
    staticClass: "default-menu-item track-menu-item",
    nativeOn: {
      "click": function($event) {
        _vm.openRemoveFromCollectionModal()
      }
    }
  }, [_c('v-list-tile-title', [_c('div', {
    staticClass: "menu-list-item dflex align-center px-2"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(321),
      "width": "16"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "ml-0"
  }, [_vm._v("Remove")])])])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.hideTrackLength) ? _c('p', {
    staticClass: "track-count"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.item.tracks.length) + " " + _vm._s(_vm.item.tracks.length > 1 ? 'tracks' : 'track') + "\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.showHoverTrackInfo) ? _c('div', {
    staticClass: "track-hover-info"
  }, [_c('div', {
    staticClass: "item-name"
  }, [_vm._v(_vm._s(_vm.item.name))]), _vm._v(" "), _c('div', {
    staticClass: "artist-name"
  }, [_vm._v(_vm._s(_vm.owner.username))])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.forCollection) ? _c('v-flex', {
    staticClass: "track-actions",
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.gotoItem()
      }
    }
  }, [_c('v-flex', {
    staticClass: "touch-flex",
    attrs: {
      "xs12": "",
      "ripple": false
    },
    on: {
      "contextmenu": _vm.showTrackMenu
    }
  })], 1), _vm._v(" "), (!_vm.isPlaying || _vm.$store.state.player.isPaused) ? _c('v-btn', {
    staticClass: "play-button-main",
    class: {
      'play-button-2': _vm.playButton2
    },
    nativeOn: {
      "click": function($event) {
        _vm.playSong()
      }
    }
  }, [_c('v-icon', {
    class: [{
      'play-button-2': _vm.playButton2,
      iconHasWhiteBG: _vm.playButton2IconHasWhiteBG,
      'black--text': _vm.playButton2IconHasWhiteBG,
    }]
  }, [_vm._v("\n\t\t\t\t\t\t\tplay_arrow\n\t\t\t\t\t\t")])], 1) : _vm._e(), _vm._v(" "), (_vm.isPlaying && !_vm.$store.state.player.isPaused) ? _c('v-btn', {
    staticClass: "play-button-main",
    nativeOn: {
      "click": function($event) {
        _vm.pauseSong()
      }
    }
  }, [_c('v-icon', {
    class: [{
      'play-button-2': _vm.playButton2,
      iconHasWhiteBG: _vm.playButton2IconHasWhiteBG,
      'black--text': _vm.playButton2IconHasWhiteBG,
    } ]
  }, [_vm._v("\n\t\t\t\t\t\t\tpause\n\t\t\t\t\t\t")])], 1) : _vm._e(), _vm._v(" "), (_vm.currentUser && _vm.willMenuRender && !_vm.hideMoreMenu) ? _c('v-menu', {
    staticClass: "track-menu",
    attrs: {
      "position-x": _vm.x,
      "position-y": _vm.y,
      "absolute": "",
      "offset-y": "",
      "close-on-content-click": false,
      "nudge-width": 100
    },
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_c('v-card', {
    staticClass: "track-menu-options"
  }, [_c('v-list', [(_vm.currentUser.user_type == 'label') ? _c('v-list-tile', {
    key: "add_to_my_label",
    staticClass: "default-menu-item track-menu-item",
    nativeOn: {
      "click": function($event) {
        _vm.addToMyLabel()
      }
    }
  }, [_c('v-list-tile-title', [_c('label', [_vm._v("Add to my label")])])], 1) : _vm._e(), _vm._v(" "), ( false) ? _c('v-list-tile', {
    key: "add_to_playlist",
    staticClass: "default-menu-item track-menu-item has-sub-menu"
  }, [_c('v-menu', {
    staticClass: "track-menu",
    attrs: {
      "offset-x": ""
    },
    model: {
      value: (_vm.submenu),
      callback: function($$v) {
        _vm.submenu = $$v
      },
      expression: "submenu"
    }
  }, [_c('v-list-tile-title', {
    staticClass: "has-sub-menu",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('label', [_vm._v("Add to Playlist")])]), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
    key: "add_to_playlist",
    staticClass: "default-menu-item track-menu-item",
    nativeOn: {
      "click": function($event) {
        _vm.addToNewPlaylist()
      }
    }
  }, [_c('v-list-tile-title', [_c('label', [_vm._v("New Playlist")])])], 1), _vm._v(" "), _vm._l((_vm.playlists), function(list, list_index) {
    return _c('v-list-tile', {
      key: ("playlist_2_" + list_index),
      staticClass: "default-menu-item track-menu-item",
      nativeOn: {
        "click": function($event) {
          _vm.addToPlaylist(list)
        }
      }
    }, [_c('v-list-tile-title', [_c('label', [_vm._v(_vm._s(list.name))])])], 1)
  })], 2)], 1)], 1) : _vm._e(), _vm._v(" "), (['admin', 'moderator'].indexOf(_vm.currentUser.user_type) > -1) ? _c('v-list-tile', {
    staticClass: "default-menu-item track-menu-item",
    on: {
      "click": function($event) {
        (_vm.showFeatureModal = true) && (_vm.menu = false)
      }
    }
  }, [_c('v-list-tile-title', [_c('div', {
    staticClass: "menu-list-item dflex align-center px-2"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(602),
      "width": "16"
    }
  }), _vm._v(" "), (_vm.item.web_title || _vm.item.web_review || _vm.item.mobile_title || _vm.item.mobile_review) ? _c('label', {
    staticClass: "ml-0"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\tEdit Feature\n\t\t\t\t\t\t\t\t")]) : _c('label', {
    staticClass: "ml-0"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\tFeature\n\t\t\t\t\t\t\t\t")])])])], 1) : _vm._e(), _vm._v(" "), (
    ['admin', 'moderator'].indexOf(_vm.currentUser.user_type) >
    -1 && _vm.item.recommended
  ) ? _c('v-list-tile', {
    key: "unrecommended",
    staticClass: "default-menu-item track-menu-item",
    nativeOn: {
      "click": function($event) {
        _vm.unrecommendAlbum()
      }
    }
  }, [_c('v-list-tile-title', [_c('div', {
    staticClass: "menu-list-item dflex align-center px-2"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(324),
      "width": "16"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "ml-0"
  }, [_vm._v("Unfeature")])])])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile', {
    staticClass: "default-menu-item track-menu-item",
    nativeOn: {
      "click": function($event) {
        _vm.addToCollection(_vm.item)
      }
    }
  }, [_c('v-list-tile-title', [_c('div', {
    staticClass: "menu-list-item dflex align-center px-2"
  }, [_c('img', {
    staticClass: "filter-invert",
    attrs: {
      "src": __webpack_require__(57),
      "width": "16"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "ml-0"
  }, [_vm._v("Add to collection")])])])], 1), _vm._v(" "), _c('v-list-tile', {
    staticClass: "default-menu-item track-menu-item"
  }, [_c('v-list-tile-title', [_c('div', {
    staticClass: "menu-list-item dflex align-center px-2"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(604),
      "width": "16"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "ml-0"
  }, [_vm._v("Add to playlist")])])])], 1), _vm._v(" "), _c('v-list-tile', {
    key: "share",
    staticClass: "default-menu-item track-menu-item",
    nativeOn: {
      "click": function($event) {
        _vm.showShareDialog()
      }
    }
  }, [_c('v-list-tile-title', [_c('div', {
    staticClass: "menu-list-item dflex align-center px-2"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(222),
      "width": "16"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "ml-0"
  }, [_vm._v("Share")])])])], 1), _vm._v(" "), (_vm.item.user.id != _vm.currentUser.id) ? _c('v-list-tile', {
    key: "hide",
    staticClass: "default-menu-item track-menu-item",
    nativeOn: {
      "click": function($event) {
        _vm.showHideAlbumDialog()
      }
    }
  }, [_c('v-list-tile-title', [_c('div', {
    staticClass: "menu-list-item dflex align-center px-2"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(592),
      "width": "16"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "ml-0"
  }, [_vm._v("Hide")])])])], 1) : _vm._e(), _vm._v(" "), (_vm.item.user.id != _vm.currentUser.id) ? _c('v-list-tile', {
    key: "report",
    staticClass: "default-menu-item track-menu-item",
    nativeOn: {
      "click": function($event) {
        _vm.openReportDialog()
      }
    }
  }, [_c('v-list-tile-title', [_c('div', {
    staticClass: "menu-list-item dflex align-center px-2"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(321),
      "width": "16"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "ml-0"
  }, [_vm._v("Report")])])])], 1) : _vm._e()], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.hideTrackLength) ? _c('p', {
    staticClass: "track-count"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.item.tracks.length) + " " + _vm._s(_vm.item.tracks.length > 1 ? 'tracks' : 'track') + "\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.showHoverTrackInfo) ? _c('div', {
    staticClass: "track-hover-info"
  }, [_c('div', {
    staticClass: "item-name"
  }, [_vm._v(_vm._s(_vm.item.name))]), _vm._v(" "), _c('div', {
    staticClass: "artist-name"
  }, [_vm._v(_vm._s(_vm.owner.username))])]) : _vm._e()], 1) : _vm._e()], 2), _vm._v(" "), _c('v-flex', {
    staticClass: "track-detail",
    attrs: {
      "xs12": "",
      "pa-0": ""
    }
  }, [_c('p', {
    staticClass: "track-name"
  }, [_c('router-link', {
    attrs: {
      "to": ("/" + (_vm.item.album_type) + "/" + (_vm.item.slug))
    }
  }, [_vm._v(_vm._s(_vm.forCollection ? _vm.item.track.name : _vm.item.name))])], 1), _vm._v(" "), _c('p', {
    staticClass: "track-user-name"
  }, [(_vm.item.collaborators_count == 0) ? _c('router-link', {
    attrs: {
      "to": '/' + _vm.owner.slug
    }
  }, [_vm._v(_vm._s(_vm.owner.username))]) : (_vm.item.collaborators_count == 1) ? [_c('router-link', {
    attrs: {
      "to": '/' + _vm.owner.slug
    }
  }, [_vm._v(_vm._s(_vm.owner.username))]), _vm._v(", \n\t\t\t\t\t\t"), (_vm.item.collaborators && _vm.item.collaborators[0]) ? _c('router-link', {
    attrs: {
      "to": '/' + _vm.item.collaborators[0].user.slug
    }
  }, [_vm._v(_vm._s(_vm.item.collaborators[0].user.username))]) : _vm._e()] : _c('router-link', {
    attrs: {
      "to": ("/" + (_vm.item.album_type) + "/" + (_vm.item.slug))
    }
  }, [_vm._v(" " + _vm._s(_vm.forCollection ? _vm.item.name + ' • Album Name' : _vm.item.track.name))])], 2)]), _vm._v(" "), _c('v-flex', {
    staticClass: "dflex align-top"
  }, [_c('div', {
    staticClass: "track-time pr-3 font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.totalTime()) + " ")])]), _vm._v(" "), (_vm.forCollection || _vm.playlistId) ? _c('v-menu', {
    staticClass: "track-menu",
    attrs: {
      "offset-y": "",
      "close-on-content-click": false,
      "nudge-width": 100
    }
  }, [_c('v-btn', {
    staticClass: "toolbar-btn",
    attrs: {
      "slot": "activator",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.is_menu_hover = true
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("more_horiz")])], 1), _vm._v(" "), _c('v-card', [_c('v-list', [_c('v-list-tile', {
    key: "remove",
    staticClass: "default-menu-item track-menu-item",
    nativeOn: {
      "click": function($event) {
        _vm.openRemoveFromCollectionModal()
      }
    }
  }, [_c('v-list-tile-title', [_c('div', {
    staticClass: "menu-list-item dflex align-center"
  }, [_c('label', {
    staticClass: "ml-0 black--text"
  }, [_vm._v("Remove")])])])], 1)], 1)], 1)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "feature-modal"
    },
    model: {
      value: (_vm.showFeatureModal),
      callback: function($$v) {
        _vm.showFeatureModal = $$v
      },
      expression: "showFeatureModal"
    }
  }, [_c('featureModal', {
    attrs: {
      "album": _vm.item
    }
  })], 1), _vm._v(" "), (_vm.showDownloadModal) ? _c('download-modal', {
    attrs: {
      "item": _vm.item,
      "dismiss": _vm.dismissDownloadDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showShareModal) ? _c('share-modal', {
    attrs: {
      "item": _vm.item,
      "dismiss": _vm.dismissShareDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_report_dialog) ? _c('v-dialog', {
    attrs: {
      "width": "1000",
      "persistent": ""
    },
    model: {
      value: (_vm.show_report_dialog),
      callback: function($$v) {
        _vm.show_report_dialog = $$v
      },
      expression: "show_report_dialog"
    }
  }, [_c('album-report-dialog', {
    attrs: {
      "album": _vm.item,
      "dismiss": _vm.closeReportDialog
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.hide_dialog) ? _c('v-dialog', {
    attrs: {
      "content-class": "my-dialog-1"
    },
    model: {
      value: (_vm.hide_dialog),
      callback: function($$v) {
        _vm.hide_dialog = $$v
      },
      expression: "hide_dialog"
    }
  }, [_c('v-card', [_c('v-card-media', {
    attrs: {
      "src": _vm.item.cover.url,
      "height": "125px",
      "contain": ""
    }
  }), _vm._v(" "), _c('v-card-text', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("\n\t\t\t\t\t\tAre you sure you want to hide this " + _vm._s(_vm.item.album_type) + "?\n\t\t\t\t\t")]), _vm._v(" "), _c('div', [_vm._v("\n\t\t\t\t\t\tYou won't be able to see it anymore, unless you visit the artists\n\t\t\t\t\t\tprofile or download the song.\n\t\t\t\t\t")])]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "dark": "",
      "color": "grey"
    },
    nativeOn: {
      "click": function($event) {
        _vm.hide_dialog = false
      }
    }
  }, [_vm._v("No, cancel please!")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "dark": "",
      "color": "red"
    },
    nativeOn: {
      "click": function($event) {
        _vm.hideAlbum()
      }
    }
  }, [_vm._v("Yes, hide it!")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.playlist_dialog) ? _c('v-dialog', {
    staticClass: "playlist-dialog",
    attrs: {
      "max-width": "500px"
    },
    model: {
      value: (_vm.playlist_dialog),
      callback: function($$v) {
        _vm.playlist_dialog = $$v
      },
      expression: "playlist_dialog"
    }
  }, [_c('v-card', {
    staticClass: "playlist-dialog-body"
  }, [_c('v-card-title', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('h5', {
    staticClass: "ma-0"
  }, [_vm._v("New Playlist")])]), _vm._v(" "), _c('v-btn', {
    staticClass: "dialog-close-btn",
    nativeOn: {
      "click": function($event) {
        _vm.playlist_dialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("highlight_off")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "create-playlist-section"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "form-group": ""
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Name"), _c('label', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.playlist.name),
      expression: "playlist.name",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.playlist.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.playlist, "name", $event.target.value.trim())
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "form-group": "",
      "text-xs-center": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "dark": "",
      "round": "",
      "color": "blue"
    },
    nativeOn: {
      "click": function($event) {
        _vm.createPlaylist()
      }
    }
  }, [_vm._v("Create Playlist")])], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.forCollection) ? _c('v-dialog', {
    attrs: {
      "content-class": "invite-dialog",
      "width": "440"
    },
    model: {
      value: (_vm.show_remove_from_collection_modal),
      callback: function($$v) {
        _vm.show_remove_from_collection_modal = $$v
      },
      expression: "show_remove_from_collection_modal"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("\n          Remove from Collection\n        ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n          Are you sure you want to remove this music from collection?\n        ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red",
      "dark": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.removeFromCollection()
      }
    }
  }, [_vm._v("\n            Yes\n          ")])], 1)], 1)], 1) : (_vm.playlistId) ? _c('v-dialog', {
    attrs: {
      "content-class": "invite-dialog",
      "width": "440"
    },
    model: {
      value: (_vm.show_remove_from_collection_modal),
      callback: function($$v) {
        _vm.show_remove_from_collection_modal = $$v
      },
      expression: "show_remove_from_collection_modal"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("\n          Remove from Playlist\n        ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n          Are you sure you want to remove this track from playlist?\n        ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "black",
      "dark": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.removeFromPlaylist('track', _vm.item.track.id, _vm.playlistId);
        _vm.show_remove_from_collection_modal = false
      }
    }
  }, [_vm._v("\n            Yes\n          ")])], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1641 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "content-class": "payment-success"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('div', {
    staticClass: "payment-success__wrapper"
  }, [_c('div', {
    staticClass: "py-5 mb-5"
  }, [_c('div', {
    staticClass: "w-100 d-flex justify-center"
  }, [_c('router-link', {
    staticClass: "mw-145",
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(49),
      "width": "145px"
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "w-100 d-flex justify-center"
  }, [_c('div', {
    staticClass: "payment-success__content"
  }, [_c('div', {
    staticClass: "payment-success__title d-flex align-center"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('img', {
    staticClass: "w-100",
    attrs: {
      "src": "/static/images/circle_check.svg"
    }
  })]), _vm._v(" "), _c('div', [_vm._v("Payment successful")])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex payment-success__description"
  }, [_c('div', {
    staticClass: "user"
  }, [_c('div', [_vm._v("Hi, John!")]), _vm._v(" "), _c('div', [_vm._v("You’ve upgraded.")]), _vm._v(" "), (_vm.accountCategory === 'creator') ? _c('div', {
    staticClass: "note"
  }, [_vm._v("\n                Your creator account is pending verification. Please allow up\n                to 72 hours. Your listener subscription is active, download\n                the app & go!\n              ")]) : _c('div', {
    staticClass: "note"
  }, [_vm._v("\n                Your listener subscription is active, download the app & go!\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "minw-315"
  }, [_c('img', {
    staticClass: "w-100",
    attrs: {
      "src": "/static/images/people.svg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-center gap-14 payment-success__icon"
  }, [_c('div', {
    staticClass: "mw-145 cursor-pointer",
    on: {
      "click": function($event) {
        _vm.openQrCode(_vm.qrCodeTypeList.IOS)
      }
    }
  }, [_c('img', {
    staticClass: "w-100",
    attrs: {
      "src": "/static/images/app-store.svg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mw-145 cursor-pointer",
    on: {
      "click": function($event) {
        _vm.openQrCode(_vm.qrCodeTypeList.ANDROID)
      }
    }
  }, [_c('img', {
    staticClass: "w-100",
    attrs: {
      "src": "/static/images/play-store.svg"
    }
  })])])])])])]), _vm._v(" "), _c('QrCode', {
    ref: "qrCode"
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1642 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-section"
  }, [_vm._v("Features")])
},staticRenderFns: []}

/***/ }),
/* 1643 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page no-top-nav account-activation"
  }, [_c('Stager', {
    attrs: {
      "staging": "activation",
      "ownCurrent": _vm.current + 1,
      "ownStages": _vm.stages
    },
    on: {
      "updateCurrent": _vm.updateCurrent
    }
  }), _vm._v(" "), _c('v-carousel', {
    ref: "stageSwipe",
    class: {
      endLeft: _vm.endLeft,
      endRight: _vm.endRight
    },
    attrs: {
      "hide-delimiters": "",
      "hide-controls": "",
      "cycle": false
    },
    model: {
      value: (_vm.current),
      callback: function($$v) {
        _vm.current = $$v
      },
      expression: "current"
    }
  }, _vm._l((_vm.stages), function(stage, i) {
    return _c('v-carousel-item', {
      key: i,
      style: (("background-color: " + (stage.color))),
      attrs: {
        "src": stage.color
      },
      nativeOn: {
        "touchstart": function($event) {
          _vm.touchStart($event)
        },
        "touchend": function($event) {
          _vm.touchEnd($event)
        }
      }
    }, [_c('v-spacer'), _vm._v(" "), _c('img', {
      staticClass: "stage-img",
      class: [("stage-" + (stage.stage))],
      attrs: {
        "src": stage.image,
        "width": "50%",
        "alt": "yousound"
      }
    })], 1)
  }))], 1)
},staticRenderFns: []}

/***/ }),
/* 1644 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('BannerUpload', {
    attrs: {
      "MainHeading": "Broadcast live",
      "MainText": "Broadcast from your browser, run pay-per-view, sell exclusives, limit room capacity & allow up to 40 video participants",
      "Icon": _vm.iconImage,
      "MainImage": _vm.bannerImage
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "page live-page mx-5"
  }, [_c('div', {
    staticClass: "page-content mt-4"
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-lg": "",
      "px-0": "",
      "pb-0": ""
    }
  }, [_c('h2', {
    staticClass: "heading-2"
  }, [_vm._v("Choose")]), _vm._v(" "), _c('div', {
    staticClass: "plans"
  }, _vm._l((_vm.plans), function(plan, i) {
    return _c('div', {
      key: i,
      staticClass: "plan",
      attrs: {
        "sm3": ""
      }
    }, [_c('div', {
      staticClass: "price-title-flex"
    }, [_c('div', {
      staticClass: "upload-tab-img uploadLive"
    }), _vm._v(" "), (plan.id === 'custom') ? _c('h3', [_vm._v("\n              Custom\n            ")]) : _c('h3', [_vm._v("\n              " + _vm._s(plan.viewersLimit) + " viewers\n            ")])]), _vm._v(" "), _c('div', {
      staticClass: "price-highlight mt-4"
    }, [_c('h4', {
      staticClass: "_price"
    }, [_vm._v("$" + _vm._s(plan.price) + " "), _c('span', [_vm._v("/hour")])])]), _vm._v(" "), _c('div', {
      staticClass: "price-highlight-button dflex align-center mt-2"
    }, [_c('v-select', {
      staticClass: "pa-0 hour-selector",
      attrs: {
        "items": _vm.hours,
        "dense": "",
        "item-text": "title",
        "item-value": "value",
        "hide-details": "",
        "outlined": ""
      },
      model: {
        value: (plan.selectedHour),
        callback: function($$v) {
          _vm.$set(plan, "selectedHour", $$v)
        },
        expression: "plan.selectedHour"
      }
    }), _vm._v(" "), _c('v-btn', {
      staticClass: "_button",
      attrs: {
        "outline": ""
      }
    }, [(!_vm.hasFree_stream_seconds) ? _c('span', [_vm._v("Add time")]) : _c('span', [_vm._v("Add time")])])], 1)])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "mt-5"
  }, [_c('h2', {
    staticClass: "heading-3"
  }, [_vm._v("Remaining time")]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-container",
    class: !(_vm.hasFree_stream_seconds) ? "empty" : null
  }, [(!(_vm.hasFree_stream_seconds)) ? _c('div', [_c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Unused time on your events is saved here for later use\n          ")])]) : _c('div', {
    staticClass: "wrapper-info dflex justify-space-between align-center mb-3"
  }, [_c('div', [_c('h3', {
    staticClass: "mr-2"
  }, [_vm._v("Rollover time remainings")]), _vm._v(" "), _c('span', {}, [_vm._v("You have")]), _vm._v(" "), _c('b', {}, [_vm._v(_vm._s(_vm._f("timeInWords")(_vm.currentUser.free_stream_seconds)))]), _vm._v(" "), _c('span', [_vm._v("remaining")])]), _vm._v(" "), _c('div', [_c('v-btn', {
    staticClass: "app-blue-2 px-2",
    style: ([
      !_vm.hasFree_stream_seconds ?
      {
        'background-color': '#c9c3c3 !important',
        color: 'grey !important',
      } :
      {} ]),
    attrs: {
      "disabled": !_vm.hasFree_stream_seconds,
      "depressed": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'VideoCreate'
        })
      }
    }
  }, [_c('b', [_vm._v("Use time")])])], 1)])])])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "learn-more-dialog"
    },
    model: {
      value: (_vm.learnMoreActive),
      callback: function($$v) {
        _vm.learnMoreActive = $$v
      },
      expression: "learnMoreActive"
    }
  }, [_c('div', {
    staticClass: "dflex align-center"
  }, [_c('img', {
    staticClass: "mr-3",
    attrs: {
      "src": __webpack_require__(1548),
      "width": "40",
      "alt": "live signal icon"
    }
  }), _vm._v(" "), _c('h2', [_vm._v("\n          Maximize revenue with\n          "), _c('br'), _vm._v("\n          live broadcasts\n        ")])]), _vm._v(" "), _c('hr', {
    staticClass: "light my-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "mb-3"
  }, [_vm._v("\n        Use these tools to maximize sale conversions with limited audiences.\n        "), _c('br'), _vm._v("\n        There’s an average 16% sales conversation on products sold on YouSound\n        live broadcasts.\n      ")]), _vm._v(" "), _c('ul', {
    staticClass: "_highlight ml-3"
  }, [_c('li', {
    staticClass: "app-bold"
  }, [_vm._v("Sell products (you keep 100%)")]), _vm._v(" "), _c('li', {
    staticClass: "app-bold"
  }, [_vm._v("\n          Sell exclusive “live video only” products (you keep 100%)\n        ")]), _vm._v(" "), _c('li', {
    staticClass: "app-bold"
  }, [_vm._v("\n          Sell pay-per-view access up to $10,000/viewer (you keep 90%)\n        ")]), _vm._v(" "), _c('li', {
    staticClass: "app-bold"
  }, [_vm._v("Limit event capacity")])]), _vm._v(" "), _c('hr', {
    staticClass: "light my-3"
  }), _vm._v(" "), _c('div', [_vm._v("\n        As a creator, you own and operate your brand & cover your costs.\n        "), _c('br'), _vm._v("\n        We do not sell your information & you keep the lion share of profits.\n      ")])]), _vm._v(" "), (_vm.showPaymentModal) ? _c('payment-modal', {
    attrs: {
      "amount": _vm.payable,
      "dismiss": _vm.closePaymentDialog,
      "finish": _vm.proceedToUpload
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1645 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isPageReady) ? _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-tabs', {
    staticClass: "white",
    attrs: {
      "dark": ""
    },
    model: {
      value: (_vm.albums_tab),
      callback: function($$v) {
        _vm.albums_tab = $$v
      },
      expression: "albums_tab"
    }
  }, [_c('content-top-header', {
    staticClass: "content-top-header-tab",
    attrs: {
      "height": 62
    }
  }, [_c('template', {
    slot: "topHeader"
  }, [_c('ul', _vm._l((_vm.albums_tabs), function(tab) {
    return _c('li', {
      key: tab.id,
      class: {
        'active tab-active': tab.id == _vm.albums_tab
      },
      attrs: {
        "href": ("#" + (tab.id))
      },
      on: {
        "click": function($event) {
          _vm.onTab(tab.id)
        }
      }
    }, [_c('label', {
      staticClass: "innerBold"
    }, [_vm._v(_vm._s(tab.title))])])
  }))])], 2), _vm._v(" "), _c('v-tabs-items', {
    staticStyle: {
      "border": "none"
    }
  }, [_c('v-tabs-content', {
    key: "published",
    attrs: {
      "id": "published"
    }
  }, [(_vm.albums_tab == 'published') ? _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-data-table', {
    staticClass: "album-table custom-data-table pt-70 px-4",
    attrs: {
      "headers": _vm.album_headers,
      "items": _vm.published_albums,
      "pagination": _vm.published_pagination,
      "rows-per-page-items": _vm.per_page_options,
      "total-items": _vm.total_published_albums
    },
    on: {
      "update:pagination": function($event) {
        _vm.published_pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('a', {
          attrs: {
            "href": 'album/' + props.item.slug
          }
        }, [_c('td', {
          staticClass: "text-xs-left"
        }, [_c('div', {
          staticClass: "album-cover-image ml-4 display-flex align-center gap-10"
        }, [_c('div', {
          staticClass: "album-cover-image",
          style: ({
            'background-image': 'url(' + props.item.cover.thumb.url + ')',
          })
        }), _vm._v(" "), _c('div', [_c('div', {
          staticClass: "avatar-title"
        }, [_vm._v(_vm._s(props.item.name))])])])])]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.user.username))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v(_vm._s(props.item.played))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v(_vm._s(props.item.downloaded))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v(_vm._s(props.item.reposted))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center"
        }, [(props.item.recommended) ? _c('label', {
          staticClass: "recommended-text"
        }, [_vm._v("Yes")]) : _c('label', {
          staticClass: "unrecommended-text"
        }, [_vm._v("No")])]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_c('v-menu', {
          staticClass: "more-menu",
          attrs: {
            "offset-y": ""
          }
        }, [_c('v-btn', {
          attrs: {
            "slot": "activator",
            "dark": ""
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("settings")])], 1), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
          key: "detail",
          staticClass: "default-menu-item",
          nativeOn: {
            "click": function($event) {
              _vm.openAlbumDetailDialog(props.item)
            }
          }
        }, [_c('v-list-tile-title', [_c('label', [_vm._v("Detail")])])], 1), _vm._v(" "), _c('v-list-tile', {
          key: "delete",
          staticClass: "default-menu-item",
          nativeOn: {
            "click": function($event) {
              _vm.openAlbumDeleteConfirmModal(props.item)
            }
          }
        }, [_c('v-list-tile-title', [_c('label', [_vm._v("Delete")])])], 1), _vm._v(" "), (!props.item.recommended) ? _c('v-list-tile', {
          key: "recommended",
          staticClass: "default-menu-item",
          nativeOn: {
            "click": function($event) {
              _vm.recommendAlbum(props.item)
            }
          }
        }, [_c('v-list-tile-title', [_c('label', [_vm._v("Recommend")])])], 1) : _vm._e(), _vm._v(" "), (props.item.recommended) ? _c('v-list-tile', {
          key: "unrecommended",
          staticClass: "default-menu-item",
          nativeOn: {
            "click": function($event) {
              _vm.unrecommendAlbum(props.item)
            }
          }
        }, [_c('v-list-tile-title', [_c('label', [_vm._v("Unrecommend")])])], 1) : _vm._e()], 1)], 1)], 1)]
      }
    }, {
      key: "pageText",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n              From " + _vm._s(pageStart) + " to " + _vm._s(pageStop) + " out of\n              " + _vm._s(_vm.total_published_albums) + "\n            ")]
      }
    }])
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-tabs-content', {
    key: "privated",
    attrs: {
      "id": "privated"
    }
  }, [(_vm.albums_tab == 'privated') ? _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-data-table', {
    staticClass: "album-table custom-data-table pt-70 px-4",
    attrs: {
      "headers": _vm.album_headers,
      "items": _vm.privated_albums,
      "pagination": _vm.privated_pagination,
      "rows-per-page-items": _vm.per_page_options,
      "total-items": _vm.total_privated_albums
    },
    on: {
      "update:pagination": function($event) {
        _vm.privated_pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('a', {
          attrs: {
            "href": 'album/' + props.item.slug
          }
        }, [_c('td', {
          staticClass: "text-xs-left"
        }, [_c('div', {
          staticClass: "album-cover-image ml-4 display-flex align-center gap-10"
        }, [_c('div', {
          staticClass: "album-cover-image",
          style: ({
            'background-image': 'url(' + props.item.cover.thumb.url + ')',
          })
        }), _vm._v(" "), _c('div', [_c('div', {
          staticClass: "avatar-title"
        }, [_vm._v(_vm._s(props.item.name) + " sdas")])])])])]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.user.username))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v(_vm._s(props.item.played))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v(_vm._s(props.item.downloaded))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v(_vm._s(props.item.reposted))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center"
        }, [(props.item.recommended) ? _c('label', {
          staticClass: "recommended-text"
        }, [_vm._v("Yes")]) : _c('label', {
          staticClass: "unrecommended-text"
        }, [_vm._v("No")])]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_c('v-menu', {
          staticClass: "more-menu",
          attrs: {
            "offset-y": ""
          }
        }, [_c('v-btn', {
          attrs: {
            "slot": "activator",
            "dark": ""
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("settings")])], 1), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
          key: "detail",
          staticClass: "default-menu-item",
          nativeOn: {
            "click": function($event) {
              _vm.openAlbumDetailDialog(props.item)
            }
          }
        }, [_c('v-list-tile-title', [_c('label', [_vm._v("Detail")])])], 1), _vm._v(" "), _c('v-list-tile', {
          key: "delete",
          staticClass: "default-menu-item",
          nativeOn: {
            "click": function($event) {
              _vm.openAlbumDeleteConfirmModal(props.item)
            }
          }
        }, [_c('v-list-tile-title', [_c('label', [_vm._v("Delete")])])], 1), _vm._v(" "), (!props.item.recommended) ? _c('v-list-tile', {
          key: "recommended",
          staticClass: "default-menu-item",
          nativeOn: {
            "click": function($event) {
              _vm.recommendAlbum(props.item)
            }
          }
        }, [_c('v-list-tile-title', [_c('label', [_vm._v("Recommend")])])], 1) : _vm._e(), _vm._v(" "), (props.item.recommended) ? _c('v-list-tile', {
          key: "unrecommended",
          staticClass: "default-menu-item",
          nativeOn: {
            "click": function($event) {
              _vm.unrecommendAlbum(props.item)
            }
          }
        }, [_c('v-list-tile-title', [_c('label', [_vm._v("Unrecommend")])])], 1) : _vm._e()], 1)], 1)], 1)]
      }
    }, {
      key: "pageText",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n              From " + _vm._s(pageStart) + " to " + _vm._s(pageStop) + " out of\n              " + _vm._s(_vm.total_privated_albums) + "\n            ")]
      }
    }])
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-tabs-content', {
    key: "product",
    attrs: {
      "id": "product"
    }
  }, [(_vm.albums_tab == 'product') ? _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-data-table', {
    staticClass: "product-table custom-data-table pt-70 px-4",
    attrs: {
      "headers": _vm.product_headers,
      "items": _vm.products,
      "pagination": _vm.product_pagination,
      "rows-per-page-items": _vm.per_page_options,
      "total-items": _vm.total_products
    },
    on: {
      "update:pagination": function($event) {
        _vm.product_pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('a', {
          attrs: {
            "href": 'album/' + props.item.slug
          }
        }, [_c('td', {
          staticClass: "text-xs-left"
        }, [_c('div', {
          staticClass: "album-cover-image ml-4 display-flex align-center gap-10"
        }, [_c('div', {
          staticClass: "album-cover-image",
          style: ({
            'background-image': 'url(' + props.item.covers[0].cover.thumb.url + ')',
          })
        }), _vm._v(" "), _c('div', [_c('div', {
          staticClass: "avatar-title"
        }, [_vm._v(_vm._s(props.item.name))])])])])]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v("\n                " + _vm._s(props.item.merchant.username) + "\n              ")]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v(_vm._s(props.item.sold))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v("\n                " + _vm._s(_vm._f("formatDate")(props.item.created_at)) + "\n              ")]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v(_vm._s(props.item.reposted))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center"
        }, [(props.item.recommended) ? _c('label', {
          staticClass: "recommended-text"
        }, [_vm._v("Yes")]) : _vm._e(), _vm._v(" "), (!props.item.recommended) ? _c('label', {
          staticClass: "unrecommended-text"
        }, [_vm._v("No")]) : _vm._e()]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_c('v-menu', {
          staticClass: "more-menu",
          attrs: {
            "offset-y": ""
          }
        }, [_c('v-btn', {
          attrs: {
            "slot": "activator",
            "dark": ""
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("settings")])], 1), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
          key: "detail",
          staticClass: "default-menu-item",
          nativeOn: {
            "click": function($event) {
              _vm.openProductDetailDialog(props.item)
            }
          }
        }, [_c('v-list-tile-title', [_c('label', [_vm._v("Detail")])])], 1), _vm._v(" "), _c('v-list-tile', {
          key: "delete",
          staticClass: "default-menu-item",
          nativeOn: {
            "click": function($event) {
              _vm.openProductDeleteConfirmModal(props.item)
            }
          }
        }, [_c('v-list-tile-title', [_c('label', [_vm._v("Delete")])])], 1)], 1)], 1)], 1)]
      }
    }, {
      key: "pageText",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n              From " + _vm._s(pageStart) + " to " + _vm._s(pageStop) + " out of\n              " + _vm._s(_vm.total_products) + "\n            ")]
      }
    }])
  })], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), (_vm.show_album_detail_dialog) ? _c('album-detail-dialog', {
    attrs: {
      "item": _vm.album,
      "dismiss": _vm.closeAlbumDetailDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_product_detail_dialog) ? _c('product-detail-dialog', {
    attrs: {
      "item": _vm.product,
      "dismiss": _vm.closeProductDetailDialog
    }
  }) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "invite-dialog",
      "width": "440"
    },
    model: {
      value: (_vm.show_album_delete_confirm_modal),
      callback: function($$v) {
        _vm.show_album_delete_confirm_modal = $$v
      },
      expression: "show_album_delete_confirm_modal"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("\n        Delete Album\n      ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n        If you click OK, the album will no longer be available to users.\n        Click OK to delete <" + _vm._s(_vm.album.name) + ">\n      ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red",
      "dark": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.deleteAlbum()
      }
    }
  }, [_vm._v("Yes")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "invite-dialog",
      "width": "440"
    },
    model: {
      value: (_vm.show_product_delete_confirm_modal),
      callback: function($$v) {
        _vm.show_product_delete_confirm_modal = $$v
      },
      expression: "show_product_delete_confirm_modal"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("\n        Delete Product\n      ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n        If you click OK, the product will no longer be available to users.\n        Click OK to delete <" + _vm._s(_vm.product.name) + ">\n      ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red",
      "dark": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.deleteProduct()
      }
    }
  }, [_vm._v("Yes")])], 1)], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1646 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page stream-page"
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": ""
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1647 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sms-landing"
  }, [(_vm.isUserSubscribed) ? _c('v-container', {
    attrs: {
      "grid-list-xs": "",
      "fluid": "",
      "pa-0": ""
    }
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "sm3": "",
      "conversation-list": ""
    }
  }, [_c('div', {
    staticClass: "_intro"
  }, [_c('div', {
    staticClass: "_title app-bold"
  }, [_vm._v("Sent SMS")]), _vm._v(" "), _c('div', {
    staticClass: "_subtitle"
  }, [_vm._v("\n            " + _vm._s(_vm.smsCount) + " text " + _vm._s(_vm._f("pluralize")("message", _vm.smsCount)) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "conversation-content"
  }, _vm._l((_vm.smsList), function(message, index) {
    return _c('div', {
      key: index,
      staticClass: "message",
      on: {
        "click": function($event) {
          _vm.openMessage(message.id)
        }
      }
    }, [_c('user-tag', {
      attrs: {
        "user": _vm.currentUser,
        "showAvatar": "",
        "hideTick": "",
        "hideName": "",
        "width": "37.7",
        "height": "37.5",
        "clickUser": false
      }
    }), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "message-recipient"
    }, [_vm._v("teekomusic")]), _vm._v(" "), _c('div', {
      staticClass: "message-trunc"
    }, [_vm._v("\n                " + _vm._s(message.message) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "messaged-time"
    }, [_vm._v("\n                " + _vm._s(_vm._f("toLocalTimeString")(message.created_at)) + "\n              ")])])], 1)
  }))]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm9": "",
      "conversation-card": ""
    }
  }, [_c('div', {
    staticClass: "_intro"
  }, [_vm._v("\n          Send SMS text to "), _c('strong', [_vm._v("2,343 people")]), _vm._v(" on your sms list\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "message-content"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.smsEngagementActive) ? _c('sms-engagement', {
    attrs: {
      "item": _vm.currentMessage
    },
    on: {
      "closeEngagement": _vm.closeEngagement
    }
  }) : _vm._e()], 1)], 1)])], 1)], 1) : _c('v-container', {
    attrs: {
      "grid-list-xs": "",
      "fluid": "",
      "pa-0": "",
      "sms-community": "",
      "not-subscribed": "",
      "allChildrenCenter": ""
    }
  }, [_c('div', {
    staticClass: "text-center _wrapper"
  }, [_c('h1', {
    staticClass: "_intro-text"
  }, [_vm._v("Reach your community through text.")]), _vm._v(" "), _c('img', {
    staticClass: "my-5",
    attrs: {
      "src": __webpack_require__(1534),
      "width": "40%",
      "alt": "sms chat"
    }
  }), _vm._v(" "), _c('div', [_vm._v("\n        You have "), _c('strong', [_vm._v("2,039 people")]), _vm._v(" on your SMS contact list.\n        Subscribe to text them!\n      ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-3 px-3",
    attrs: {
      "depressed": "",
      "round": "",
      "dark": ""
    },
    on: {
      "click": _vm.initSubscribe
    }
  }, [_vm._v("\n        Subscribe\n      ")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1648 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "media",
    class: _vm.type
  }, [_c('div', {
    staticClass: "media__image",
    style: (("background-image: url(" + _vm.image + ")"))
  }), _vm._v(" "), _c('div', {
    staticClass: "media__content"
  }, [_c('div', [_c('div', {
    staticClass: "media__title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "media__description"
  }, [_vm._v(_vm._s(_vm.subtitle))])])])])
},staticRenderFns: []}

/***/ }),
/* 1649 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isPageReady) ? _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-tabs', {
    staticClass: "white",
    attrs: {
      "dark": ""
    },
    model: {
      value: (_vm.active_tab),
      callback: function($$v) {
        _vm.active_tab = $$v
      },
      expression: "active_tab"
    }
  }, [_c('v-tabs-bar', {
    staticClass: "transparent"
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('v-tabs-item', {
      key: tab.id,
      attrs: {
        "href": '#' + tab.id,
        "ripple": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.onTab(tab.id)
        }
      }
    }, [_vm._v(_vm._s(tab.title))])
  })), _vm._v(" "), _c('v-tabs-items', {
    staticStyle: {
      "border": "none"
    }
  }, [_c('v-tabs-content', {
    attrs: {
      "id": "all"
    }
  }, [(_vm.active_tab == 'all') ? _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-data-table', {
    staticClass: "user-table",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.all_transactions,
      "pagination": _vm.all_pagination,
      "rows-per-page-items": _vm.per_page_options,
      "total-items": _vm.total_all_transactions
    },
    on: {
      "update:pagination": function($event) {
        _vm.all_pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-left"
        }, [_c('div', {
          staticClass: "avatar-image",
          style: ({
            'background-image': 'url(' + props.item.sender.avatar.url + ')',
          })
        }), _vm._v("\n                " + _vm._s(props.item.sender.username) + "\n              ")]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_c('div', {
          staticClass: "avatar-image",
          style: ({
            'background-image': 'url(' + props.item.receiver.avatar.url + ')',
          })
        }), _vm._v("\n                " + _vm._s(props.item.receiver.username) + "\n              ")]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v("\n                $" + _vm._s(_vm._f("formatNumber")((props.item.sent_amount + props.item.payment_fee))) + "\n              ")]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v("\n                $" + _vm._s(_vm._f("formatNumber")(props.item.received_amount)) + "\n              ")]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v(_vm._s(props.item.payment_type))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v(_vm._s(props.item.status))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v("\n                " + _vm._s(_vm._f("formatDate")(props.item.created_at)) + "\n              ")])]
      }
    }, {
      key: "pageText",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n              From " + _vm._s(pageStart) + " to " + _vm._s(pageStop) + " out of\n              " + _vm._s(_vm.total_all_transactions) + "\n            ")]
      }
    }])
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-tabs-content', {
    attrs: {
      "id": "refunded"
    }
  }, [(_vm.active_tab == 'refunded') ? _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-data-table', {
    staticClass: "user-table",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.refunded_transactions,
      "pagination": _vm.refunded_pagination,
      "rows-per-page-items": _vm.per_page_options,
      "total-items": _vm.total_refunded_transactions
    },
    on: {
      "update:pagination": function($event) {
        _vm.refunded_pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-left"
        }, [_c('div', {
          staticClass: "avatar-image",
          style: ({
            'background-image': 'url(' + props.item.sender.avatar.url + ')',
          })
        }), _vm._v("\n                " + _vm._s(props.item.sender.username) + "\n              ")]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_c('div', {
          staticClass: "avatar-image",
          style: ({
            'background-image': 'url(' + props.item.receiver.avatar.url + ')',
          })
        }), _vm._v("\n                " + _vm._s(props.item.receiver.username) + "\n              ")]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v(_vm._s(props.item.sent_amount))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v(_vm._s(props.item.received_amount))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v(_vm._s(props.item.payment_type))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v(_vm._s(props.item.status))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v("\n                " + _vm._s(_vm._f("formatDate")(props.item.created_at)) + "\n              ")])]
      }
    }, {
      key: "pageText",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n              From " + _vm._s(pageStart) + " to " + _vm._s(pageStop) + " out of\n              " + _vm._s(_vm.total_refunded_transactions) + "\n            ")]
      }
    }])
  })], 1) : _vm._e()], 1)], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1650 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "artist-card"
  }, [_c('v-flex', {
    staticClass: "item-info",
    attrs: {
      "xs12": "",
      "pa-0": ""
    }
  }, [_c('v-flex', {
    staticClass: "artist-info-section",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "artist-cover",
    style: ({
      'background-image': 'url(' + _vm.artist.avatar.url + ')'
    })
  }), _vm._v(" "), (_vm.canViewProfile) ? _c('v-flex', {
    staticClass: "artist-actions",
    attrs: {
      "xs12": ""
    }
  }, [_c('router-link', {
    attrs: {
      "to": ("/" + (_vm.artist.slug))
    }
  }), _vm._v(" "), (_vm.followButtonVisible) ? _c('div', {
    staticClass: "follow-section"
  }, [_c('user-follow-btn', {
    staticClass: "mt-3",
    attrs: {
      "user": _vm.artist,
      "type": "default"
    },
    on: {
      "afterFollow": _vm.afterFollow
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "artist-name"
  }, [_vm._v("\n        " + _vm._s(_vm.artist.username) + "\n        "), (_vm.artist.user_type !== 'listener') ? _c('v-icon', {
    staticClass: "user-status",
    class: {
      online: _vm.artist.status == 'active'
    }
  }, [_vm._v("fa-check-circle")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "artist-title"
  }, [_vm._v("\n        Artist\n      ")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1651 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    staticClass: "user-item",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.showSendMessage) ? _c('send-message', {
    attrs: {
      "receiver": _vm.userItem,
      "dismiss": _vm.dismissMessageModal
    }
  }) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "user-item-body",
    class: {
      'last-item': _vm.last
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "user-item-section",
    class: {
      sm6: _vm.userItem.recent_reposts,
      'no-reposts': !_vm.userItem.recent_reposts,
    },
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-flex', {
    staticClass: "user-item-section-body",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "user-item-profile-avatar-area"
  }, [_c('router-link', {
    attrs: {
      "to": '/' + _vm.userItem.slug
    }
  }, [_c('div', {
    staticClass: "user-item-profile-avatar",
    style: ({
      'background-image': 'url(' + _vm.userItem.avatar.thumb.url + ')',
    })
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "user-item-content-area"
  }, [_c('div', {
    staticClass: "user-item-content"
  }, [_c('router-link', {
    staticClass: "user-name",
    attrs: {
      "to": '/' + _vm.userItem.slug
    }
  }, [_vm._v(_vm._s(_vm.userItem.username))]), _vm._v(" \n              "), (_vm.userItem.user_type == 'artist') ? _c('v-icon', {
    staticClass: "user-status",
    class: {
      online: _vm.userItem.status == 'active'
    }
  }, [_vm._v("fa-check-circle")]) : _vm._e(), _vm._v(" \n              "), _c('label', {
    staticClass: "follower-count"
  }, [_c('strong', [_vm._v("2.8k")]), _vm._v(" Followers")])], 1), _vm._v(" "), _c('div', {
    staticClass: "actions-section"
  }, [(
    _vm.$store.state.auth.user &&
    _vm.userItem.id != _vm.$store.state.auth.user.id
  ) ? _c('user-follow-btn', {
    attrs: {
      "user": _vm.userItem,
      "theme": "dark",
      "type": "default"
    },
    on: {
      "afterFollow": _vm.afterFollow
    }
  }) : _vm._e(), _vm._v(" "), _c('v-menu', {
    staticClass: "more-menu",
    attrs: {
      "offset-y": ""
    }
  }, [_c('v-btn', {
    staticClass: "more-btn",
    attrs: {
      "slot": "activator",
      "dark": ""
    },
    slot: "activator"
  }, [_c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("more_horiz")])], 1), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
    key: "message"
  }, [_c('v-list-tile-title', {
    staticClass: "default-menu-item",
    nativeOn: {
      "click": function($event) {
        _vm.showMessageDialog()
      }
    }
  }, [_c('label', [_vm._v("Message")])])], 1), _vm._v(" "), _c('v-list-tile', {
    key: "blockuser"
  }, [_c('v-list-tile-title', {
    staticClass: "default-menu-item",
    nativeOn: {
      "click": function($event) {
        _vm.blockUser()
      }
    }
  }, [_c('label', [_vm._v("Block User")])])], 1)], 1)], 1)], 1)])])], 1), _vm._v(" "), (_vm.userItem.recent_reposts) ? _c('v-flex', {
    staticClass: "user-item-recent-posts",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('p', {
    staticClass: "recent-posts-section-title"
  }, [_vm._v("Recent reposts")]), _vm._v(" "), _vm._l((_vm.userItem.recent_reposts), function(repost, index) {
    return _c('div', {
      key: index,
      staticClass: "recent-post-item",
      style: ({
        'background-image': 'url(' + _vm.imageURL(_vm.userItem.assoc) + ')',
      })
    }, [(repost.album_type) ? _c('router-link', {
      attrs: {
        "to": '/album/' + repost.slug
      }
    }) : _vm._e(), _vm._v(" "), (!repost.album_type) ? _c('router-link', {
      attrs: {
        "to": "/"
      }
    }) : _vm._e()], 1)
  })], 2) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1652 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page albums-page mx-5",
    class: {
      isComp: _vm.isComp,
      onMobile: _vm.onMobile
    },
    attrs: {
      "id": "page-content"
    }
  }, [(!_vm.isComp && !_vm.onMobile) ? _c('discover-nav', {
    attrs: {
      "pageName": "music",
      "filterShow": "true",
      "searchShow": this.$store.state.app.sideBarMini
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isPageReady) ? _c('div', {
    staticClass: "page-content"
  }, [(_vm.viewAllTrending) ? _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-lg": "",
      "px-0": "",
      "pt-4": ""
    }
  }, [_c('div', [_c('content-top-header', {
    staticClass: "__inner mt-3",
    attrs: {
      "absolute": ""
    }
  }, [_c('template', {
    slot: "topHeader"
  }, [_c('ul', {
    staticClass: "width100 trending-topbar"
  }, [_c('li', [_c('v-btn', {
    staticClass: "back-btn",
    attrs: {
      "ripple": false,
      "fab": "",
      "small": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.back()
      }
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-li"
  }, [_c('label', {
    class: (_vm.viewAllTrending) ? 'active' : '',
    on: {
      "click": function($event) {
        _vm.displayTrendingTracks()
      }
    }
  }, [_vm._v("Trending")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-li"
  }, [_c('label', {
    on: {
      "click": function($event) {
        _vm.displayNewTracks()
      }
    }
  }, [_vm._v("New")])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('li', [(false) ? _c('v-btn', {
    staticClass: "btn-genre-selector",
    attrs: {
      "dark": "",
      "rounded": ""
    },
    on: {
      "click": function($event) {
        _vm.openGenreSelectorDialog()
      }
    }
  }, [_vm._v("\n                Genres: All\n                ")]) : _vm._e()], 1)], 1)])], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "albums"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.recommendedAlbums), function(feed, index) {
    return _c('v-flex', {
      key: index,
      attrs: {
        "feed-card": "",
        "xs6": "",
        "custom-lg6": "",
        "px-0": ""
      }
    }, [_c('track-card', {
      attrs: {
        "objects": _vm.recommendedAlbums,
        "objectIndex": index,
        "hideButtonAction": _vm.hideAlbum,
        "willMenuRender": ""
      }
    })], 1)
  }))], 1)]) : _vm._e(), _vm._v(" "), ((!_vm.viewAllPopular && !_vm.viewAllTrending)) ? _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-lg": "",
      "px-0": "",
      "pt-4": "",
      "id": "new-album-container"
    }
  }, [(_vm.viewAllNew) ? _c('div', [_c('content-top-header', {
    staticClass: "__inner mt-3",
    attrs: {
      "absolute": ""
    }
  }, [_c('template', {
    slot: "topHeader"
  }, [_c('ul', {
    staticClass: "width100 trending-topbar"
  }, [_c('li', [_c('v-btn', {
    staticClass: "back-btn",
    attrs: {
      "ripple": false,
      "fab": "",
      "small": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.back()
      }
    }
  })], 1), _vm._v(" "), _c('li', [_c('label', {
    on: {
      "click": function($event) {
        _vm.displayTrendingTracks()
      }
    }
  }, [_vm._v("Trending")])]), _vm._v(" "), _c('li', [_c('label', {
    class: (_vm.viewAllNew) ? 'active' : '',
    on: {
      "click": function($event) {
        _vm.displayNewTracks()
      }
    }
  }, [_vm._v("New Release")])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('li', [(false) ? _c('v-btn', {
    staticClass: "btn-genre-selector",
    attrs: {
      "dark": "",
      "rounded": ""
    },
    on: {
      "click": function($event) {
        _vm.openGenreSelectorDialog()
      }
    }
  }, [_vm._v("\n                Genres: All\n                ")]) : _vm._e()], 1)], 1)])], 2)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "albums"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.newAlbums), function(feed, index) {
    return _c('v-flex', {
      key: index,
      attrs: {
        "feed-card": "",
        "sm3": "",
        "custom-lg6": "",
        "px-0": ""
      }
    }, [_c('track-card', {
      attrs: {
        "objects": _vm.newAlbums,
        "objectIndex": index,
        "hideButtonAction": _vm.hideAlbum,
        "willMenuRender": ""
      }
    })], 1)
  }))], 1)]) : _vm._e(), _vm._v(" "), ((!_vm.viewAllNew && !_vm.viewAllTrending)) ? _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-lg": "",
      "px-0": "",
      "pt-4": "",
      "id": "popular-album-container"
    }
  }, [(_vm.viewAllPopular) ? _c('div', [_c('content-top-header', {
    staticClass: "__inner mt-3",
    attrs: {
      "absolute": ""
    }
  }, [_c('template', {
    slot: "topHeader"
  }, [_c('ul', {
    staticClass: "width100 trending-topbar"
  }, [_c('li', [_c('v-btn', {
    staticClass: "back-btn",
    attrs: {
      "ripple": false,
      "fab": "",
      "small": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.back()
      }
    }
  })], 1), _vm._v(" "), _c('li', [_c('label', {
    on: {
      "click": function($event) {
        _vm.displayTrendingTracks()
      }
    }
  }, [_vm._v("Trending")])]), _vm._v(" "), _c('li', [_c('label', {
    on: {
      "click": function($event) {
        _vm.displayNewTracks()
      }
    }
  }, [_vm._v("New")])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('li', [(false) ? _c('v-btn', {
    staticClass: "btn-genre-selector",
    attrs: {
      "dark": "",
      "rounded": ""
    },
    on: {
      "click": function($event) {
        _vm.openGenreSelectorDialog()
      }
    }
  }, [_vm._v("\n                Genres: All\n                ")]) : _vm._e()], 1)], 1)])], 2)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "albums"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.popularAlbums), function(feed, index) {
    return _c('v-flex', {
      key: index,
      attrs: {
        "feed-card": "",
        "sm3": "",
        "custom-lg6": "",
        "px-0": ""
      }
    }, [_c('track-card', {
      attrs: {
        "objects": _vm.popularAlbums,
        "objectIndex": index,
        "hideButtonAction": _vm.hideAlbum,
        "willMenuRender": ""
      }
    })], 1)
  }))], 1)]) : _vm._e()], 1) : _c('div', {
    staticClass: "page-loader"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(166),
      "alt": ""
    }
  })]), _vm._v(" "), (_vm.currentUser) ? _c('v-dialog', {
    attrs: {
      "fullscreen": _vm.onMobile,
      "content-class": [("my-genre-dialog genre-filter ma-0 pa-2 " + (_vm.onMobile ? 'onMobile' : ''))]
    },
    model: {
      value: (_vm.show_genre_selector_dialog),
      callback: function($$v) {
        _vm.show_genre_selector_dialog = $$v
      },
      expression: "show_genre_selector_dialog"
    }
  }, [_c('genre-dialog', {
    attrs: {
      "dismiss": _vm.closeGenreSelectorDialog
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1653 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "playlist px-5"
  }, [_c('content-top-header', {
    staticClass: "mt-3 black-theme"
  }, [_c('template', {
    slot: "topHeader"
  }, [_c('ul', _vm._l((_vm.tabs), function(tab) {
    return _c('li', {
      key: tab.id,
      class: {
        'active tab-active': _vm.isActiveTab(tab.id)
      },
      attrs: {
        "href": ("#" + (tab.id))
      }
    }, [_c('label', {
      staticClass: "innerBold",
      on: {
        "click": function($event) {
          _vm.onTab(tab.id)
        }
      }
    }, [_vm._v(_vm._s(tab.title))])])
  }))])], 2), _vm._v(" "), _c('div', {
    staticClass: "breadcrumb"
  }, [_vm._v("Playlists > " + _vm._s("Playlist"))]), _vm._v(" "), _c('div', {
    staticClass: "meta-summary"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_vm._v(" " + _vm._s(this.playlist.name))]), _vm._v(" "), (this.playlist.playlist_type == 'tracks') ? _c('span', [_vm._v(_vm._s(this.tracks.length) + "\n      " + _vm._s(_vm._f("pluralize")("track", this.tracks.length)))]) : (this.playlist.playlist_type == 'streams') ? _c('span', [_vm._v(_vm._s(this.streams.length) + "\n      " + _vm._s(_vm._f("pluralize")("stream", this.streams.length)))]) : _vm._e(), _vm._v(" "), (this.playlist.playlist_type == 'products') ? _c('span', [_vm._v(_vm._s(this.products.length) + "\n      " + _vm._s(_vm._f("pluralize")("product", this.products.length)))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "mx-1"
  }, [_vm._v("•")])]), _vm._v(" "), (this.playlist.playlist_type == 'tracks') ? _c('div', {
    staticClass: "list-track-view list-track-view-trackCard listings"
  }, _vm._l((this.tracks), function(track, index) {
    return _c('div', {
      key: index,
      staticClass: "list-track-view-item listing"
    }, [_c('track-card', {
      attrs: {
        "objects": _vm.parseAlbum,
        "objectIndex": index,
        "hideMoreMenu": "",
        "playlistId": _vm.playlist.id,
        "removeFromPlaylist": _vm.removeFromPlaylist,
        "hideTrackLength": "",
        "displayDuration": ""
      }
    })], 1)
  })) : (this.playlist.playlist_type == 'streams') ? _c('div', {
    staticClass: "list-track-view list-track-view-trackCard listings"
  }, _vm._l((this.streams), function(video, index) {
    return _c('div', {
      key: index,
      staticClass: "list-track-view-item listing"
    }, [_c('video-box', {
      attrs: {
        "hoverOverlay": false,
        "item": video,
        "showUsername": "",
        "playlistId": _vm.playlist.id,
        "removeFromPlaylist": _vm.removeFromPlaylist,
        "hideUser": false,
        "sideTabView": true
      }
    })], 1)
  })) : (this.playlist.playlist_type == 'products') ? _c('div', {
    staticClass: "list-track-view list-track-view-trackCard listings"
  }, _vm._l((this.products), function(product, index) {
    return _c('div', {
      key: index,
      staticClass: "list-track-view-item listing"
    }, [_c('product-card', {
      attrs: {
        "dataObject": product,
        "sideTabView": "",
        "hideOverlay": false,
        "hideOptionCount": "",
        "playlistId": _vm.playlist.id,
        "removeFromPlaylist": _vm.removeFromPlaylist,
        "altMeta": "",
        "noMeta": "",
        "altMetaPrice": ""
      }
    })], 1)
  })) : _vm._e(), _vm._v(" "), (_vm.share_dialog) ? _c('share-modal', {
    attrs: {
      "item": _vm.sharedAlbum,
      "dismiss": _vm.closeShareTrack
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1654 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "landing-page pa-4"
  }, [_c('div', {
    staticClass: "header-container ma-4"
  }, [_c('div', {
    class: {
      'header-content': _vm.$vuetify.breakpoint.width > 1280
    }
  }, [_c('div', {
    staticClass: "logo-and-menu",
    class: {
      'display-flex justify-center align-center': _vm.$vuetify.breakpoint.width <= 1280,
    }
  }, [_c('div', {
    staticClass: "logo-container",
    on: {
      "click": function($event) {
        _vm.tab = null
      }
    }
  }, [_c('router-link', {
    staticClass: "logo-link",
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/landing-page/ys_logo_primary-black.svg",
      "aspect-ratio": "1",
      "height": "44",
      "width": "144"
    }
  })])], 1), _vm._v(" "), (_vm.$vuetify.breakpoint.width > 1280) ? _c('div', {
    staticClass: "links-container white--text font-space-grotesk font-weight-700 text-18"
  }, [_vm._l((_vm.tabList), function(item, index) {
    return _c('span', {
      key: index,
      staticClass: "menu-item cursor-pointer",
      class: {
        'active-menu': _vm.tab == item.value
      },
      on: {
        "click": function($event) {
          _vm.tab = item.value
        }
      }
    }, [_vm._v("\n              " + _vm._s(item.text) + "\n            ")])
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-item cursor-pointer",
    on: {
      "click": function($event) {
        _vm.navigateTo('/login')
      }
    }
  }, [_vm._v("\n              Signin\n            ")])], 2) : _vm._e()])])]), _vm._v(" "), _c('div', {
    class: {
      'main-content': _vm.$vuetify.breakpoint.width > 1280
    }
  }, [(!_vm.tab) ? _c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-space-around": "",
      "row": "",
      "gap-8": "",
      "main-content-wrapper": ""
    }
  }, [_c('div', {
    staticClass: "blurb-container"
  }, [_c('div', {
    staticClass: "white--text font-space-grotesk font-weight-500",
    class: {
      'text-container': _vm.$vuetify.breakpoint.width > 1280
    }
  }, [_c('span', {
    class: _vm.$vuetify.breakpoint.width <= 1280 ?
      'text-32 text-center display-flex' :
      'text-50'
  }, [_vm._v("\n              Music Streaming\n              "), _c('br'), _vm._v("\n              Evolved\n            ")]), _vm._v(" "), (_vm.$vuetify.breakpoint.width > 1280) ? _c('div', {
    staticClass: "app-icons-container"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "row": "",
      "mt-4": "",
      "pt-4": ""
    }
  }, [_c('div', {
    staticClass: "app-icon-container"
  }, [_c('img', {
    staticClass: "cursor-pointer",
    attrs: {
      "src": "/static/images/landing-page/apple-store.svg",
      "aspect-ratio": "1",
      "height": "80",
      "width": "220"
    },
    on: {
      "click": function($event) {
        _vm.openQrCode(_vm.qrCodeTypeList.IOS)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "app-icon-container"
  }, [_c('img', {
    staticClass: "cursor-pointer",
    attrs: {
      "src": "/static/images/landing-page/google-play.svg",
      "aspect-ratio": "1",
      "height": "80",
      "width": "220"
    },
    on: {
      "click": function($event) {
        _vm.openQrCode(_vm.qrCodeTypeList.ANDROID)
      }
    }
  })])])], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "image-container"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/landing-page/ys-landing-ios.svg",
      "aspect-ratio": "1",
      "height": "677"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.tab == 'go_premium') ? _c('UpgradePlan', {
    staticClass: "py-5",
    attrs: {
      "category-plan": _vm.categoryPlan
    }
  }) : _vm._e(), _vm._v(" "), (_vm.tab == 'revenue_calculator') ? _c('RevenueCalculator', {
    staticClass: "py-5 w-100"
  }) : _vm._e()], 1)]), _vm._v(" "), (_vm.$vuetify.breakpoint.width <= 1280) ? _c('div', {
    class: {
      'bg-white sp-text': _vm.tab == null,
    }
  }, [(_vm.tab == null) ? _c('div', {
    class: [
      'display-flex justify-space-between align-center btn-wrapper',
      {
        'scrolled': _vm.isScrolled
      }
    ]
  }, [_c('button', {
    staticClass: "btn-try-calculator",
    on: {
      "click": _vm.goToCalculator
    }
  }, [_vm._v("\n        Estimator\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn-sign-up",
    on: {
      "click": _vm.redirectToAppStore
    }
  }, [_vm._v("\n        Sign up\n      ")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.width > 1280) ? _c('FooterLandingPage') : _vm._e(), _vm._v(" "), _c('QrCode', {
    ref: "qrCode"
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1655 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb-4",
    class: [("_" + _vm.staging), {
      isDark: _vm.currentStage.isDark
    }]
  }, [(_vm.hideStagerTitle) ? _c('div', {
    staticClass: "auth__subtitle mb-3",
    domProps: {
      "innerHTML": _vm._s(_vm.currentStage.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.current > 1 && _vm.hideStagerBar) ? _c('div', {
    staticClass: "stages"
  }, _vm._l((_vm.stages.slice(1, _vm.stages.length - 2)), function(stage, index) {
    return _c('div', {
      key: index,
      staticClass: "stage dflex",
      class: {
        _current: _vm.current >= stage.stage
      }
    })
  })) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "_meta"
  }, [(_vm.currentStage.subtitle) ? _c('div', {
    staticClass: "_subtitle",
    domProps: {
      "innerHTML": _vm._s(_vm.currentStage.subtitle)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentStage.cta1) ? _c('div', {
    staticClass: "cta cta1"
  }, [_c('v-btn', {
    staticClass: "px-2",
    style: (("background-color: " + (_vm.currentStage.cta1.color))),
    attrs: {
      "depressed": "",
      "round": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.handleCTA(_vm.currentStage.cta1.action)
      }
    }
  }, [_c('strong', [_vm._v("\n          " + _vm._s(_vm.currentStage.cta1.title) + "\n        ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.currentStage.cta2) ? _c('div', {
    staticClass: "cta cta2"
  }, [_c('v-btn', {
    staticClass: "no-Btn-bg transparent",
    attrs: {
      "ripple": false,
      "depressed": "",
      "round": ""
    }
  }, [_c('strong', [_vm._v("\n          " + _vm._s(_vm.currentStage.cta2.title) + "\n        ")])])], 1) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 1656 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ApexChart', {
    attrs: {
      "type": "donut",
      "options": _vm.chartOptions,
      "series": _vm.series
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1657 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page protect-page",
    staticStyle: {
      "padding-top": "0px",
      "min-height": "100%"
    }
  }, [_c('v-layout', {
    attrs: {
      "column": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "sm4": "",
      "pa-3": ""
    }
  }, [_c('div', {
    staticClass: "mt-5"
  }, [_c('img', {
    staticClass: "site-logo",
    attrs: {
      "src": "/static/images/nav_logo_primary.png"
    }
  })]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "width": "50px",
      "margin": "30px auto 30px auto"
    }
  }), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit()
      }
    }
  }, [_c('label', {
    staticClass: "mb-3"
  }, [_vm._v("Please enter the code word to continue...")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.secret_code),
      expression: "secret_code"
    }],
    staticClass: "mt-4 mb-2",
    attrs: {
      "type": "password",
      "autocomplete": "off",
      "placeholder": "Code Word",
      "name": "secret_code"
    },
    domProps: {
      "value": (_vm.secret_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.secret_code = $event.target.value
      }
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "reset-btn",
    attrs: {
      "block": "",
      "round": "",
      "dark": "",
      "color": "blue",
      "type": "submit"
    }
  }, [_vm._v("Go")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1658 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-section"
  }, [_vm._v("Product")])
},staticRenderFns: []}

/***/ }),
/* 1659 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isPageReady) ? _c('v-container', {
    staticClass: "genre",
    attrs: {
      "pa-0": ""
    }
  }, [(_vm.show_selector_view) ? _c('v-layout', {
    staticClass: "pgs_area",
    attrs: {
      "row": "",
      "wrap": "",
      "mt-3": ""
    }
  }, _vm._l((_vm.genres), function(parent, index) {
    return _c('div', {
      staticClass: "pgs-wrapper genre-container"
    }, [_c('div', {
      key: parent.id,
      staticClass: "pgs"
    }, [_c('div', {
      staticClass: "pgs-inner-wrapper genre-block",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.selectParent(parent, index)
        }
      }
    }, [_c('div', {
      staticClass: "pgs-inner"
    }, [_c('div', {
      staticClass: "pgs__title"
    }, [_c('label', [_vm._v(_vm._s(parent.name))])]), _vm._v(" "), _c('div', {
      staticClass: "pgs__content"
    }, [_c('div', {
      staticClass: "upload-info"
    }, [_c('label', [_vm._v(_vm._s(_vm._f("formatNumberWithComma")(parent.users_size)))]), _vm._v(" "), _c('span', [_vm._v("Album Uploaded")])]), _vm._v(" "), (parent.value) ? _c('div', {
      staticClass: "pgs__badge check-o"
    }) : _c('div', {
      staticClass: "pgs__badge check"
    })])])])])])
  })) : _vm._e(), _vm._v(" "), (_vm.show_selector_view) ? _c('div', {
    staticClass: "text-xs-center"
  }, [_c('v-btn', {
    staticClass: "update-btn",
    attrs: {
      "dark": "",
      "color": "blue"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  }, [_vm._v("OK")])], 1) : _vm._e(), _vm._v(" "), (!_vm.show_selector_view) ? _c('div', {
    staticClass: "genre-container"
  }, [_c('div', {
    staticClass: "pgs-wrapper"
  }, [_c('div', {
    key: _vm.parent.id,
    staticClass: "pgs"
  }, [_c('div', {
    staticClass: "pgs-inner-wrapper genre-block"
  }, [_c('div', {
    staticClass: "pgs-inner"
  }, [_c('div', {
    staticClass: "pgs__title"
  }, [_vm._v(_vm._s(_vm.parent.name))]), _vm._v(" "), _c('div', {
    staticClass: "pgs__content"
  }, [(_vm.parent.value) ? _c('div', {
    staticClass: "pgs__badge check-o"
  }) : _c('div', {
    staticClass: "pgs__badge check"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "genre__content"
  }, [_c('v-radio-group', {
    attrs: {
      "mandatory": false
    },
    model: {
      value: (_vm.genre.id),
      callback: function($$v) {
        _vm.$set(_vm.genre, "id", $$v)
      },
      expression: "genre.id"
    }
  }, [_c('v-layout', {
    key: _vm.parent.id,
    attrs: {
      "row": "",
      "wrap": "",
      "ma-0": ""
    }
  }, [(Object.keys(_vm.groupChildrenByRegion(_vm.parent)).length == 1) ? _vm._l((_vm.parent.children), function(child) {
    return _c('v-flex', {
      key: child.id,
      attrs: {
        "xs12": "",
        "sm4": ""
      }
    }, [_c('div', {
      staticClass: "dflex"
    }, [_c('input', {
      attrs: {
        "name": "sub-genres",
        "type": "radio",
        "id": child.id
      },
      domProps: {
        "value": child.id
      },
      on: {
        "change": function($event) {
          _vm.checkChildGenre(_vm.parent, child)
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "ml-2",
      attrs: {
        "for": child.id
      }
    }, [_vm._v(_vm._s(child.name))])])])
  }) : [_vm._l((_vm.groupChildrenByRegion(_vm.parent)), function(values, key) {
    return [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('h5', [_vm._v(_vm._s(key))])]), _vm._v(" "), _vm._l((values), function(child) {
      return _c('v-flex', {
        key: child.id,
        attrs: {
          "xs12": "",
          "sm3": ""
        }
      }, [_c('div', {
        staticClass: "dflex"
      }, [_c('input', {
        attrs: {
          "name": "sub-genres",
          "type": "radio",
          "id": child.id
        },
        domProps: {
          "value": child.id
        },
        on: {
          "change": function($event) {
            _vm.checkChildGenre(_vm.parent, child)
          }
        }
      }), _vm._v(" "), _c('label', {
        staticClass: "ml-2",
        attrs: {
          "for": child.id
        }
      }, [_vm._v(_vm._s(child.name))])])])
    })]
  })], _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center mt-5",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "update-btn",
    attrs: {
      "dark": "",
      "color": "grey"
    },
    nativeOn: {
      "click": function($event) {
        _vm.show_selector_view = true
      }
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('v-btn', {
    staticClass: "update-btn",
    attrs: {
      "dark": "",
      "color": "blue"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  }, [_vm._v("Select Genre & Close")])], 1)], 2)], 1)], 1)]) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1660 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-input theme-black",
    class: {
      isOnMobile: _vm.isOnMobile
    }
  }, [_c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [_c('div', {
    staticClass: "global-search-box",
    class: [("is_" + _vm.theme), {
      isRound: _vm.isRound
    }]
  }, [(!_vm.isOnMobile) ? _c('img', {
    staticClass: "icon",
    attrs: {
      "src": _vm.preIcon,
      "width": "18"
    }
  }) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    staticClass: "search-field",
    class: {
      'isOnMobile-input': _vm.isOnMobile
    },
    attrs: {
      "type": "search",
      "id": "search",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.keyword)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.goToSearch()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value
      }
    }
  })])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1661 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "slider-card"
  }, [_c('v-flex', {
    staticClass: "track-info",
    attrs: {
      "xs12": "",
      "pa-0": ""
    }
  }, [_c('v-flex', {
    staticClass: "track-cover",
    attrs: {
      "xs12": ""
    }
  }, [(_vm.item.album_type == 'playlist') ? _c('div', {
    staticClass: "playlist-icon"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/playlist.png"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "track-image",
    style: ({
      'background-image': 'url(' + _vm.item.cover.url + ')'
    })
  }), _vm._v(" "), _c('v-flex', {
    staticClass: "track-actions",
    class: {
      playing: _vm.isPlaying
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('v-flex', {
    staticClass: "touch-flex",
    attrs: {
      "xs12": ""
    },
    on: {
      "click": function($event) {
        _vm.playSong()
      }
    }
  }), _vm._v(" "), (!_vm.isPlaying || _vm.$store.state.player.isPaused) ? _c('v-btn', {
    staticClass: "play-button",
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.playSong()
      }
    }
  }, [_c('v-icon', [_vm._v("play_arrow")])], 1) : _c('v-btn', {
    staticClass: "play-button",
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.pauseSong()
      }
    }
  }, [_c('v-icon', [_vm._v("pause")])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": ("/" + (_vm.item.album_type) + "/" + (_vm.item.slug))
    }
  }, [_c('p', {
    staticClass: "track-count"
  }, [_vm._v(_vm._s(_vm.item.tracks.length) + " tracks")])])], 1)], 1)], 1), _vm._v(" "), (_vm.showDownloadModal) ? _c('download-modal', {
    attrs: {
      "item": _vm.item,
      "dismiss": _vm.dismissDownloadModal
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1662 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "payment-modal",
    class: {
      paymentSuccessful: _vm.paymentSuccessful,
      paymentFailed: _vm.paymentFailed
    }
  }, [(!_vm.paymentSuccessful && !_vm.paymentFailed) ? _c('transition', {
    attrs: {
      "name": "slide-left"
    }
  }, [_c('div', {
    staticClass: "payment-card"
  }, [_c('div', {
    staticClass: "dflex align-center justify-space-between"
  }, [_c('div', {
    staticClass: "payment-modal-title"
  }, [_vm._v("Payment")]), _vm._v(" "), _c('v-icon', {
    staticClass: "cancel-icon-round",
    on: {
      "click": function($event) {
        _vm.closePayment()
      }
    }
  }, [_vm._v("cancel")])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "section-wrapper"
  }, [_c('div', {
    staticClass: "card-details-wrapper left-child _child"
  }, [_c('package-details', {
    attrs: {
      "item": _vm.item,
      "itemPrice": _vm.itemPrice,
      "itemType": _vm.itemType
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "card-details-wrapper right-child _child"
  }, [_c('card-details', {
    attrs: {
      "hidePayBtn": "",
      "totalPayable": _vm.totalPayable
    }
  }), _vm._v(" "), _c('hr', {
    staticClass: "hr-space"
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "pay_btn",
    attrs: {
      "block": "",
      "round": "",
      "dark": ""
    },
    on: {
      "click": _vm.handlePayment
    }
  }, [_vm._v("\n            Pay $" + _vm._s(_vm.itemPrice) + " /month\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "stripe-credit black--text"
  }, [_c('span', {
    staticClass: "mr-1"
  }, [_vm._v(" Powered By")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(1467),
      "width": "40",
      "alt": "stripe icon"
    }
  })])], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.paymentSuccessful) ? _c('transition', {
    attrs: {
      "name": "slide-left"
    }
  }, [_c('div', {
    staticClass: "payment-success payment-ready"
  }, [_c('div', {
    staticClass: "payment-modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('div', {
    staticClass: "divider my-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "dflex align-center my-4"
  }, [_c('div', {
    staticClass: "success-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(119),
      "width": "100%"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "result-text"
  }, [_c('div', [_vm._v("Thank you")]), _vm._v(" "), _c('div', [_vm._v("Your account is pending")])])]), _vm._v(" "), _c('div', {
    staticClass: "post"
  }, [_vm._v("\n        We sent an email confirmation to: "), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.userEmail))])]), _vm._v(" "), _c('div', {
    staticClass: "divider my-4"
  }), _vm._v(" "), _c('package-details', {
    attrs: {
      "item": _vm.item,
      "itemPrice": _vm.itemPrice,
      "itemType": _vm.itemType,
      "hideTitle": "",
      "altMeta": "",
      "noBorder": ""
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-4 pay_btn py-4",
    attrs: {
      "depressed": "",
      "dark": "",
      "round": "",
      "block": ""
    },
    on: {
      "click": _vm.hideConfirmationPayment
    }
  }, [_vm._v("Go to next step")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.paymentFailed) ? _c('transition', {
    attrs: {
      "name": "slide-left"
    }
  }, [_c('div', {
    staticClass: "payment-success payment-ready"
  }, [_c('div', {
    staticClass: "payment-modal-title"
  }, [_vm._v("Payment Failed")]), _vm._v(" "), _c('div', {
    staticClass: "divider my-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "dflex align-center mb-3"
  }, [_c('v-icon', {
    staticClass: "failed-icon result-icon"
  }, [_vm._v("check_circle")]), _vm._v(" "), _c('div', {
    staticClass: "result-text"
  }, [_c('div', [_vm._v("Oops")]), _vm._v(" "), _c('div', [_vm._v("Your payment was not successful")])])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-4",
    attrs: {
      "depressed": "",
      "dark": "",
      "round": "",
      "block": ""
    },
    on: {
      "click": function($event) {
        _vm.closePayment()
      }
    }
  }, [_vm._v("Close")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.confirmPayment) ? _c('transition', [_c('div', [_c('checkEmail')], 1)]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1663 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page upload-child video-page broadcast-page create-page mx-5 margin-top-header"
  }, [_c('upload-nav', {
    attrs: {
      "name": "upload"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "mt-5 text-poppins-36"
  }, [_vm._v("Broadcast live")]), _vm._v(" "), (_vm.activeView == 'intro') ? _c('videoEstimate', {
    on: {
      "gotoNextView": _vm.gotoNextView
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeView == 'initStream') ? _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "page-content"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.openPaymentDialog()
      }
    }
  }, [_c('div', {
    staticClass: "bg-white rounded-20 pa-4 mt-4"
  }, [_c('h4', {
    staticClass: "info-title"
  }, [_vm._v("Info")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "gap-20": "",
      "broadcast-info": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label max-char-label"
  }, [_c('div', [_c('label', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', {
    staticClass: "__title"
  }, [_vm._v("Title of Event")])])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.stream.name),
      expression: "stream.name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "title",
      "maxlength": "80"
    },
    domProps: {
      "value": (_vm.stream.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.stream, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("\n                  Category\n                ")]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "pt-0",
    attrs: {
      "placeholder": "Select",
      "items": _vm.genres,
      "name": "genre",
      "item-text": "name",
      "item-value": "id",
      "hide-details": ""
    },
    model: {
      value: (_vm.stream.genre_id),
      callback: function($$v) {
        _vm.$set(_vm.stream, "genre_id", $$v)
      },
      expression: "stream.genre_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label max-char-label"
  }, [_c('span', {
    staticClass: "__title"
  }, [_vm._v("Description")])]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.stream.description),
      expression: "stream.description"
    }],
    staticClass: "form-control",
    attrs: {
      "maxlength": "4000"
    },
    domProps: {
      "value": (_vm.stream.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.stream, "description", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("\n                  Live event thumbnail\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "video-thumbnail-container"
  }, [_c('div', {
    staticClass: "video-thumbnail-wrapper"
  }, [(_vm.stream_cover_url) ? _c('div', {
    staticClass: "video-thumbnail",
    style: ({
      'background-image': 'url(' + _vm.stream_cover_url + ')',
    })
  }) : _c('div', {
    staticClass: "video-thumbnail"
  }, [_c('div', {
    staticClass: "cover-wrapper allChildrenCenter"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "file",
      "name": "stream_cover_file",
      "id": "stream_cover_file",
      "accept": ".png, .jpg, .jpeg"
    },
    on: {
      "change": function($event) {
        _vm.imageChanged($event)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "stream_cover_file"
    }
  }, [(_vm.stream_cover_url) ? _c('span', {
    staticClass: "app-blue--text"
  }, [_vm._v("Change")]) : _c('span', {
    staticClass: "texet-xs-center dflex align-center justify-center flex-column"
  }, [_c('img', {
    attrs: {
      "width": "20",
      "src": "/static/images/ic_camera.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("ADD IMAGE")])])])])])]), _vm._v(" "), (_vm.stream_cover_url) ? _c('div', {
    staticClass: "cover-wrapper mt-2"
  }, [_c('label', {
    attrs: {
      "for": "stream_cover_file"
    }
  }, [_c('span', {
    staticClass: "app-blue--text"
  }, [_vm._v("Change")])])]) : _vm._e()])])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "bg-white rounded-20 pa-4 mt-4"
  }, [_vm._m(0), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "gap-20": "",
      "broadcast-info": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Pay per view price\n                  ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "view_price",
      "disabled": ""
    },
    domProps: {
      "value": _vm.stream_view_price
    }
  })])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Capacity")]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "pt-0",
    attrs: {
      "items": _vm.viewers_limits,
      "item-text": "name",
      "item-value": "id"
    },
    model: {
      value: (_vm.stream.viewers_limit),
      callback: function($$v) {
        _vm.$set(_vm.stream, "viewers_limit", $$v)
      },
      expression: "stream.viewers_limit"
    }
  })], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "submit-section mt-4"
  }, [_c('v-btn', {
    staticClass: "release-now-btn white--text",
    attrs: {
      "round": "",
      "type": "submit"
    }
  }, [_vm._v("\n            Release\n          ")])], 1)])])]) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "my-dialog-2"
    },
    model: {
      value: (_vm.show_help_dialog),
      callback: function($$v) {
        _vm.show_help_dialog = $$v
      },
      expression: "show_help_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('v-card-media', {
    attrs: {
      "src": "/static/images/post1.jpg",
      "contain": ""
    }
  }), _vm._v(" "), _c('label', [_vm._v("Live Video")])], 1), _vm._v(" "), _c('v-card-text', [_c('ul', [_c('li', [_vm._v("\n            Attach albums & products to live video to "), _c('br'), _vm._v("let user\n            "), _c('b', [_vm._v("download")]), _vm._v(" or "), _c('b', [_vm._v("add to cart")]), _vm._v(" while viewing.\n          ")]), _vm._v(" "), _c('li', [_vm._v("Make albums & products "), _c('b', [_vm._v("exclusive")]), _vm._v(" on broadcast.")]), _vm._v(" "), _c('li', [_vm._v("\n            Let users view for "), _c('b', [_vm._v("Free")]), _vm._v(" or "), _c('b', [_vm._v("Pay Per View")]), _vm._v("."), _c('br'), _vm._v("Charge\n            up to $10,000 per user.\n          ")]), _vm._v(" "), _c('li', [_c('b', [_vm._v("Limit")]), _vm._v(" the amount of viewers on your broadcast.")]), _vm._v(" "), _c('li', [_vm._v("Add users to your "), _c('b', [_vm._v("Guest List")]), _vm._v(" to watch for free.")])])]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    staticClass: "px-4",
    attrs: {
      "dark": "",
      "round": "",
      "color": "blue"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeHelpDialog()
      }
    }
  }, [_vm._v("Ok, Got it!")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "my-dailog-1",
      "persistent": ""
    },
    model: {
      value: (_vm.show_stripe_connect_dialog),
      callback: function($$v) {
        _vm.show_stripe_connect_dialog = $$v
      },
      expression: "show_stripe_connect_dialog"
    }
  }, [_c('v-card', [_c('v-card-text', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Stripe Connect")]), _vm._v(" "), _c('div', [_vm._v("You have to connect stripe in setting page.")])]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "px-4",
    attrs: {
      "dark": "",
      "round": "",
      "color": "blue"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeStripeConnectDialog()
      }
    }
  }, [_vm._v("Ok, Got it!")]), _vm._v(" "), _c('v-spacer')], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "stream-collaborators-dialog",
      "persistent": ""
    },
    model: {
      value: (_vm.show_collaborators_dialog),
      callback: function($$v) {
        _vm.show_collaborators_dialog = $$v
      },
      expression: "show_collaborators_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("\n          Collaborators Pay Per View Split\n        ")])]), _vm._v(" "), _c('v-card-text', [_c('div', [_c('div', [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "pt-0",
    attrs: {
      "items": _vm.view_prices,
      "item-text": "name",
      "item-value": "id"
    },
    model: {
      value: (_vm.stream.view_price),
      callback: function($$v) {
        _vm.$set(_vm.stream, "view_price", $$v)
      },
      expression: "stream.view_price"
    }
  })], 1), _vm._v(" "), (_vm.stream.view_price > 0 && _vm.stream.collaborators.length < 3) ? _c('div', [_c('v-btn', {
    staticClass: "add-option-btn ma-0",
    nativeOn: {
      "click": function($event) {
        _vm.addCollaborator()
      }
    }
  }, [_c('v-icon', [_vm._v("add")]), _vm._v(" Add another collaborator\n            ")], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.stream.collaborators && _vm.stream.collaborators.length > 0) ? _c('v-layout', {
    attrs: {
      "row": "",
      "creator-wrapper": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Creator"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('label', {
    staticClass: "creator-name"
  }, [_vm._v(_vm._s(_vm.currentUser.username))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm3": ""
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Profit Share"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('label', {
    staticClass: "creator-share"
  }, [_vm._v(_vm._s(_vm.creator_share))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm3": ""
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Recoup Cost")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.stream.creator_recoup_cost),
      expression: "stream.creator_recoup_cost"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.stream.creator_recoup_cost)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.stream, "creator_recoup_cost", $event.target.value)
      }
    }
  })])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.stream.collaborators), function(collaborator, index) {
    return _c('v-layout', {
      key: index,
      attrs: {
        "row": "",
        "collaborator-wrapper": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "sm6": ""
      }
    }, [_c('label', {
      staticClass: "control-label"
    }, [_vm._v("Collaborators"), _c('span', {
      staticClass: "required"
    }, [_vm._v("*")])]), _vm._v(" "), _c('v-select', {
      staticClass: "pt-0",
      attrs: {
        "items": _vm.users,
        "item-text": "username",
        "item-value": "id",
        "chips": "",
        "autocomplete": "",
        "no-data-text": "No collaborator available",
        "clearable": ""
      },
      scopedSlots: _vm._u([{
        key: "selection",
        fn: function(data) {
          return [_c('v-chip', {
            key: JSON.stringify(data.item),
            staticClass: "chip--select-multi",
            attrs: {
              "selected": data.selected
            },
            on: {
              "input": function($event) {
                data.parent.selectItem(data.item)
              }
            }
          }, [_c('v-avatar', [_c('img', {
            attrs: {
              "src": data.item.avatar.thumb.url
            }
          })]), _vm._v("\n                    " + _vm._s(data.item.username) + "\n                  ")], 1)]
        }
      }, {
        key: "item",
        fn: function(data) {
          return [(typeof data.item !== 'object') ? [_c('v-list-tile-content', {
            domProps: {
              "textContent": _vm._s(data.item)
            }
          })] : [_c('v-list-tile-avatar', [_c('img', {
            attrs: {
              "src": data.item.avatar.thumb.url
            }
          })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
            domProps: {
              "innerHTML": _vm._s(data.item.username)
            }
          })], 1)]]
        }
      }]),
      model: {
        value: (collaborator.user_id),
        callback: function($$v) {
          _vm.$set(collaborator, "user_id", $$v)
        },
        expression: "collaborator.user_id"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm6": ""
      }
    }, [_c('label', {
      staticClass: "control-label"
    }, [_vm._v("Profit Share"), _c('span', {
      staticClass: "required"
    }, [_vm._v("*")])]), _vm._v(" "), _c('v-select', {
      staticClass: "pt-0",
      attrs: {
        "items": _vm.profit_share_types,
        "item-text": "name",
        "item-value": "id",
        "autocomplete": ""
      },
      model: {
        value: (collaborator.user_share),
        callback: function($$v) {
          _vm.$set(collaborator, "user_share", $$v)
        },
        expression: "collaborator.user_share"
      }
    })], 1), _vm._v(" "), _c('v-icon', {
      staticClass: "clear-btn",
      on: {
        "click": function($event) {
          _vm.deleteCollaborator(index)
        }
      }
    }, [_vm._v("clear")])], 1)
  })], 2)]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "px-4",
    attrs: {
      "dark": "",
      "round": "",
      "color": "blue"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeCollaboratorsDialog()
      }
    }
  }, [_vm._v("OK")]), _vm._v(" "), _c('v-spacer')], 1)], 1)], 1), _vm._v(" "), (_vm.show_payment_dialog) ? _c('payment-modal', {
    attrs: {
      "amount": _vm.streamCost,
      "dismiss": _vm.closePaymentDialog,
      "finish": _vm.deposit
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', {
    staticClass: "info-title"
  }, [_vm._v("Options")])])
}]}

/***/ }),
/* 1664 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page video-page create-page mx-5"
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "page-left"
  }, [_c('div', {
    staticClass: "tab-container"
  }, [_c('h2', {
    staticClass: "page-title"
  }, [_vm._v("Broadcast")]), _vm._v(" "), _c('ul', {
    staticClass: "pr-3"
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('li', {
      key: tab.id,
      class: {
        active: tab.id === _vm.active_tab
      }
    }, [_c('label', {
      on: {
        "click": function($event) {
          _vm.onTab(tab)
        }
      }
    }, [_vm._v(_vm._s(tab.title))])])
  }))])]), _vm._v(" "), (_vm.isPageReady) ? _c('div', {
    staticClass: "page-content"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit()
      }
    }
  }, [_c('h3', {
    staticClass: "mt-3 mb-4"
  }, [_vm._v("Broadcast Details")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-5",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm5": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Title of Event")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.stream.name),
      expression: "stream.name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "title"
    },
    domProps: {
      "value": (_vm.stream.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.stream, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Pay Per View?")]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "pt-0",
    attrs: {
      "items": _vm.view_prices,
      "item-text": "name",
      "item-value": "id"
    },
    model: {
      value: (_vm.stream.view_price),
      callback: function($$v) {
        _vm.$set(_vm.stream, "view_price", $$v)
      },
      expression: "stream.view_price"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Event Capacity")]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "pt-0",
    attrs: {
      "items": _vm.viewers_limits,
      "item-text": "name",
      "item-value": "id"
    },
    model: {
      value: (_vm.stream.viewers_limit),
      callback: function($$v) {
        _vm.$set(_vm.stream, "viewers_limit", $$v)
      },
      expression: "stream.viewers_limit"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Genre")]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.stream.genre.name))])]), _vm._v(" "), _c('div', {
    staticClass: "text-center mt-5"
  }, [_c('v-btn', {
    staticClass: "px-5",
    attrs: {
      "round": "",
      "dark": "",
      "color": "blue",
      "type": "submit"
    }
  }, [_vm._v("Update Channel")])], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm7": "",
      "pl-5": ""
    }
  }, [_c('div', [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Thumbnail")]), _vm._v(" "), _c('div', {
    staticClass: "video-thumbnail-wrapper"
  }, [(_vm.stream_cover_url) ? _c('div', {
    staticClass: "video-thumbnail",
    style: ({
      'background-image': 'url(' + _vm.stream_cover_url + ')',
    })
  }) : _vm._e()])]), _vm._v(" "), (_vm.stream.account_ids.length > 0) ? _c('div', {
    staticClass: "form-group mt-2"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Feature profiles")]), _vm._v(" "), _c('v-select', {
    staticClass: "pt-0",
    attrs: {
      "items": _vm.users,
      "multiple": "",
      "item-text": "name",
      "item-value": "id",
      "placeholder": "Type name to search",
      "chips": "",
      "autocomplete": "",
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(data) {
        return [_c('v-chip', {
          key: JSON.stringify(data.item),
          attrs: {
            "selected": data.selected
          },
          on: {
            "input": function($event) {
              data.parent.selectItem(data.item)
            }
          }
        }, [_c('v-avatar', [_c('img', {
          attrs: {
            "src": data.item.avatar.url
          }
        })]), _vm._v("\n                    " + _vm._s(data.item.username) + "\n                  ")], 1)]
      }
    }, {
      key: "item",
      fn: function(data) {
        return [(typeof data.item !== 'object') ? [_c('v-list-tile-content', {
          domProps: {
            "textContent": _vm._s(data.item)
          }
        })] : [_c('v-list-tile-avatar', [_c('img', {
          attrs: {
            "src": data.item.avatar.url
          }
        })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
          domProps: {
            "innerHTML": _vm._s(data.item.username)
          }
        })], 1)]]
      }
    }]),
    model: {
      value: (_vm.stream.account_ids),
      callback: function($$v) {
        _vm.$set(_vm.stream, "account_ids", $$v)
      },
      expression: "stream.account_ids"
    }
  })], 1) : _vm._e()])], 1)], 1)]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 1665 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-loader",
    style: ({
      'background-color': _vm.bgColor
    })
  }, [(_vm.loaderType === 'fullBG') ? _c('div', {
    staticClass: "_fullBG"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.loaderType === 'linear') ? _c('div', {
    staticClass: "_linear"
  }, [_c('v-progress-linear', {
    staticClass: "primary--text app-loader_linear",
    attrs: {
      "value": _vm.loadValue,
      "height": "2"
    }
  })], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loader-def center"
  }, [_c('span')])
}]}

/***/ }),
/* 1666 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "album-track-item relative",
    class: {
      selected: _vm.buttonHover ||
        (_vm.isPlaying && _vm.trackIndex == _vm.$store.state.player.trackIndex) ||
        (!_vm.isPlaying && _vm.trackIndex == 0),
    },
    on: {
      "click": function($event) {
        _vm.selectTrack()
      },
      "mouseenter": function($event) {
        _vm.buttonHover = true
      },
      "mouseleave": function($event) {
        _vm.buttonHover = false
      }
    }
  }, [(
     false
  ) ? _c('v-btn', {
    staticClass: "action-btn"
  }, [(_vm.trackIndex == _vm.$store.state.player.trackIndex && _vm.isPlaying) ? _c('v-icon', [_vm._v("pause")]) : (_vm.buttonHover || (_vm.trackIndex == 0 && !_vm.isPlaying)) ? _c('v-icon', [_vm._v("play_arrow")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "track-name"
  }, [(_vm.showIndexPlayIcon && (_vm.trackIndex == _vm.$store.state.player.trackIndex && _vm.isPlaying)) ? _c('img', {
    staticClass: "track-showIndexPlayIcon",
    attrs: {
      "width": "15",
      "src": "/static/images/graph-bar.svg"
    }
  }) : _c('span', {
    staticClass: "track-index"
  }, [_vm._v(_vm._s(_vm.trackIndex + 1) + ". ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.track.name))]), _vm._v(" "), (_vm.album.album_type == 'playlist') ? _c('router-link', {
    staticClass: "track-user-name",
    attrs: {
      "to": ("/" + (_vm.track.user.slug))
    }
  }, [_vm._v("\n      - " + _vm._s(_vm.track.user.username))]) : _vm._e()], 1), _vm._v(" "), (!_vm.hideMoreBtn) ? _c('div', {
    staticClass: "right-section",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [(
    _vm.buttonHover &&
    !(_vm.trackIndex == _vm.$store.state.player.trackIndex && _vm.isPlaying)
  ) ? _c('v-icon', {
    attrs: {
      "color": "grey"
    }
  }, [_vm._v("play_arrow")]) : _vm._e(), _vm._v(" "), (!_vm.showIndexPlayIcon && _vm.selectedTrackIsPlaying) ? _c('v-icon', {
    attrs: {
      "color": "grey"
    }
  }, [_vm._v("pause")]) : _vm._e(), _vm._v(" "), _c('v-menu', {
    staticClass: "track-more-action",
    attrs: {
      "offset-y": "",
      "close-on-content-click": false
    },
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_c('v-btn', {
    staticClass: "more-btn",
    attrs: {
      "slot": "activator",
      "dark": ""
    },
    slot: "activator"
  }, [_c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("more_horiz")])], 1), _vm._v(" "), _c('v-list', [(
    _vm.album.album_type == 'playlist' &&
    _vm.currentUser &&
    _vm.album.user.id == _vm.currentUser.id
  ) ? _c('v-list-tile', {
    key: "remove_track",
    nativeOn: {
      "click": function($event) {
        _vm.removeItem()
      }
    }
  }, [_c('v-list-tile-title', {
    staticClass: "default-menu-item"
  }, [_c('label', [_vm._v("Remove Track")])])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile', {
    key: "share",
    staticClass: "default-menu-item track-menu-item",
    nativeOn: {
      "click": function($event) {
        _vm.showShareDialog()
      }
    }
  }, [_c('v-list-tile-title', [_c('label', [_vm._v("Share")])])], 1), _vm._v(" "), ( false) ? _c('v-list-tile', {
    key: "add_to_playlist",
    staticClass: "default-menu-item track-menu-item has-sub-menu"
  }, [_c('v-menu', {
    staticClass: "track-menu",
    attrs: {
      "offset-x": ""
    },
    model: {
      value: (_vm.submenu),
      callback: function($$v) {
        _vm.submenu = $$v
      },
      expression: "submenu"
    }
  }, [_c('v-list-tile-title', {
    staticClass: "has-sub-menu",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('img', {
    staticClass: "track-status-icon",
    attrs: {
      "src": "/static/images/ic_add_to.png"
    }
  }), _vm._v(" "), _c('label', [_vm._v("Add to Playlist")])]), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
    key: "add_to_playlist",
    staticClass: "default-menu-item track-menu-item",
    nativeOn: {
      "click": function($event) {
        _vm.addToNewPlaylist()
      }
    }
  }, [_c('v-dialog', {
    staticClass: "playlist-dialog",
    attrs: {
      "max-width": "500px"
    },
    model: {
      value: (_vm.playlist_dialog),
      callback: function($$v) {
        _vm.playlist_dialog = $$v
      },
      expression: "playlist_dialog"
    }
  }, [_c('v-list-tile-title', {
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('img', {
    staticClass: "track-status-icon",
    attrs: {
      "src": "/static/images/ic_add_to.png"
    }
  }), _vm._v(" "), _c('label', [_vm._v("New Playlist")])]), _vm._v(" "), _c('v-card', {
    staticClass: "playlist-dialog-body"
  }, [_c('v-card-title', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('h5', {
    staticClass: "ma-0"
  }, [_vm._v("New Playlist")])]), _vm._v(" "), _c('v-btn', {
    staticClass: "dialog-close-btn",
    nativeOn: {
      "click": function($event) {
        _vm.playlist_dialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("highlight_off")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "create-playlist-section"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "form-group": ""
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Name"), _c('label', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.playlist.name),
      expression: "playlist.name",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.playlist.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.playlist, "name", $event.target.value.trim())
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "form-group": "",
      "text-xs-center": ""
    }
  }, [_c('v-btn', {
    staticClass: "create-playlist-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.createPlaylist()
      }
    }
  }, [_vm._v("Create Playlist")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _vm._l((_vm.playlists), function(list, list_index) {
    return _c('v-list-tile', {
      key: ("playlist_1_" + list_index),
      staticClass: "default-menu-item track-menu-item",
      nativeOn: {
        "click": function($event) {
          _vm.addToPlaylist(list)
        }
      }
    }, [_c('v-list-tile-title', [_c('img', {
      staticClass: "track-status-icon",
      attrs: {
        "src": "/static/images/ic_download.png"
      }
    }), _vm._v(" "), _c('label', [_vm._v(_vm._s(list.name))])])], 1)
  })], 2)], 1)], 1) : _vm._e()], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showStats) ? _c('div', {
    staticClass: "track-actions"
  }, [_c('v-btn', {
    staticClass: "action-btn"
  }, [_c('v-icon', [_vm._v("play_arrow")]), _vm._v(_vm._s(_vm.track.played))], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.share_dialog) ? _c('share-modal', {
    attrs: {
      "item": _vm.album,
      "dismiss": _vm.dismissShareDialog
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1667 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_c('v-container', {
    staticClass: "px-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('div', {
    staticClass: "dflex footer-sitemap white--text"
  }, [_c('div', {
    staticClass: "sitemap-link pa-3"
  }, [_c('router-link', {
    attrs: {
      "to": "#"
    }
  }, [_vm._v(" Help center ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "sitemap-link pa-3"
  }, [_c('router-link', {
    attrs: {
      "to": "#"
    }
  }, [_vm._v(" Terms & Privacy ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "sitemap-link pa-3"
  }, [_c('router-link', {
    attrs: {
      "to": "#"
    }
  }, [_vm._v(" Report a bug ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "dflex justify-space-between copyright-footer"
  }, [_c('p', {
    staticClass: "pa-3"
  }, [_vm._v("©YouSound, Inc..")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1668 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logout-modal"
  }, [_c('div', {
    staticClass: "logout-flex"
  }, [_c('div', {
    staticClass: "logout-content"
  }, [_c('h2', {
    staticClass: "logout-heading"
  }, [_vm._v("\n                Join the world's creators & music lovers.\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "btns-wrapper mt-4"
  }, [_c('v-btn', {
    staticClass: "signup",
    attrs: {
      "round": "",
      "to": "/signup"
    }
  }, [_vm._v("Signup")]), _vm._v(" "), _c('v-btn', {
    staticClass: "login ml-3",
    attrs: {
      "round": "",
      "to": "/login"
    }
  }, [_vm._v("Login")])], 1)]), _vm._v(" "), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logout-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(221),
      "width": "100%"
    }
  })])
}]}

/***/ }),
/* 1669 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box__footer"
  }, [_c('div', {
    staticClass: "box__title"
  }, [_c('user-tag', {
    attrs: {
      "user": _vm.user
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box__content"
  }, [_c('div', {
    staticClass: "box__image"
  })])
}]}

/***/ }),
/* 1670 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "account_download"
  }, [_c('div', {
    staticClass: "account_download__title"
  }, [_vm._v("PURCHASED DOWNLOADS")]), _vm._v(" "), _vm._l((3), function(i) {
    return _c('div', {
      key: i,
      staticClass: "bg-white rounded-10px account_download__item",
      class: _vm.$vuetify.breakpoint.width <= 650 ? 'wrap' : ''
    }, [_vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "d-flex align-center mr-3 wrap",
      class: _vm.$vuetify.breakpoint.width <= 1280 ? 'gap-18' : 'gap-36'
    }, [_c('div', {
      staticClass: "cursor-pointer text-poppins-15"
    }, [_vm._v("Download")]), _vm._v(" "), _c('div', {
      staticClass: "text-poppins-13"
    }, [_vm._v("3 remaining")])])])
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex gap-14"
  }, [_c('div', {
    staticClass: "account_download__image"
  }, [_c('img')]), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-column"
  }, [_c('div', {
    staticClass: "text-poppins-15 font-weight-600"
  }, [_vm._v("\n          I Thought We Were Having Fun\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "text-poppins-15 text-grey-1"
  }, [_vm._v("RUCKAZOID, Tri Nohbi")])])])
}]}

/***/ }),
/* 1671 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "subscription-plan bg-white"
  }, [_c('div', {
    staticClass: "d-flex justify-center align-center tab-group"
  }, _vm._l((_vm.tabList), function(item, i) {
    return _c('div', {
      key: i,
      staticClass: "tab-text width-50 cursor-pointer text-center",
      class: {
        'active-tab': item.id == _vm.tab
      },
      on: {
        "click": function($event) {
          _vm.setTab(item.id)
        }
      }
    }, [_vm._v("\n      " + _vm._s(item.title) + "\n    ")])
  })), _vm._v(" "), _c('div', {
    class: _vm.$vuetify.breakpoint.width > 650 ? '' : 'px-8'
  }, [(_vm.tab == 'yearly') ? _c('package-card', {
    attrs: {
      "title": _vm.title,
      "subtitle": _vm.subtitle,
      "price": _vm.monthlyPrice,
      "option-list": _vm.optionList
    }
  }) : _vm._e(), _vm._v(" "), (_vm.tab == 'monthly') ? _c('package-card', {
    attrs: {
      "title": _vm.title,
      "subtitle": _vm.subtitle,
      "price": _vm.annualPrice,
      "option-list": _vm.optionList
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 1672 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "content-class": "qr-code"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('div', {
    staticClass: "qr-code__wrapper"
  }, [_c('div', {
    staticClass: "qr-code__title py-5"
  }, [_c('div', {
    staticClass: "w-100 d-flex justify-center"
  }, [_c('router-link', {
    staticClass: "mw-145",
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(19),
      "width": "145px"
    }
  })])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "absolute ma-0 color-white btn-close",
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_c('v-icon', {
    staticClass: "font-size-34"
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "qr-code__content"
  }, [_c('div', {
    staticClass: "qr-code__content--title"
  }, [_vm._v("\n        " + _vm._s(_vm.typeQR === _vm.qrCodeTypeList.IOS ?
    "Download iOS app" :
    "Download Android app") + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "qr-code__content--img"
  }, [(_vm.typeQR === _vm.qrCodeTypeList.IOS) ? _c('img', {
    attrs: {
      "src": __webpack_require__(323),
      "width": "307"
    }
  }) : _c('img', {
    attrs: {
      "src": __webpack_require__(322),
      "width": "307"
    }
  })])])])])
},staticRenderFns: []}

/***/ }),
/* 1673 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-section"
  }, [_vm._m(0), _vm._v(" "), _c('div', [(_vm.isPageReady) ? _c('v-container', {
    staticClass: "content-section genre",
    attrs: {
      "grid-list-lg": "",
      "pa-0": ""
    }
  }, [(_vm.show_selector_view) ? _c('v-layout', {
    staticClass: "pgs_area",
    attrs: {
      "row": "",
      "wrap": "",
      "ma-0": ""
    }
  }, [_vm._l((_vm.genres), function(parent, index) {
    return _c('div', {
      staticClass: "pgs-wrapper"
    }, [_c('div', {
      key: parent.id,
      staticClass: "pgs"
    }, [_c('div', {
      staticClass: "pgs-inner-wrapper",
      class: ("bg-color-" + index),
      on: {
        "click": function($event) {
          _vm.checkParentGenre(parent, !parent.value)
        }
      }
    }, [_c('div', {
      staticClass: "pgs-inner"
    }, [_c('div', {
      staticClass: "pgs__title"
    }, [_c('label', [_vm._v(_vm._s(parent.name))])]), _vm._v(" "), _c('div', {
      staticClass: "pgs__description"
    }, [_c('span', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.selectParent(parent, index)
        }
      }
    }, [_vm._v("+" + _vm._s(_vm.getSelectedChildrenCount(parent)) + " Subgenres")])]), _vm._v(" "), _c('div', {
      staticClass: "pgs__content"
    }, [_c('div', {
      staticClass: "upload-info"
    }, [_c('label', [_vm._v(_vm._s(_vm._f("formatNumberWithComma")(parent.users_size)))]), _vm._v(" "), _c('span', [_vm._v("Album Uploaded")])]), _vm._v(" "), (parent.value) ? _c('div', {
      staticClass: "pgs__badge check-o"
    }) : _c('div', {
      staticClass: "pgs__badge check"
    })])])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "actions-wrapper"
  }, [_c('v-btn', {
    attrs: {
      "dark": "",
      "round": "",
      "color": "blue"
    },
    nativeOn: {
      "click": function($event) {
        _vm.saveGenreFilters()
      }
    }
  }, [_vm._v("Save")])], 1)], 2) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.show_selector_view) ? _c('div', {
    staticClass: "content-section genre"
  }, [_c('div', {
    staticClass: "genre-container"
  }, [_c('div', {
    staticClass: "genre__header"
  }, [_c('div', {
    staticClass: "pgs-wrapper"
  }, [_c('div', {
    key: _vm.parent.id,
    staticClass: "pgs"
  }, [_c('div', {
    staticClass: "pgs-inner-wrapper",
    class: ("bg-color-" + _vm.parent_index)
  }, [_c('div', {
    staticClass: "pgs-inner"
  }, [_c('div', {
    staticClass: "pgs__title"
  }, [_vm._v(_vm._s(_vm.parent.name))]), _vm._v(" "), _c('div', {
    staticClass: "pgs__description"
  }, [_vm._v("\n                    +" + _vm._s(_vm.getSelectedChildrenCount(_vm.parent)) + " Subgenres\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "pgs__content"
  }, [(_vm.parent.value) ? _c('div', {
    staticClass: "pgs__badge check-o"
  }) : _c('div', {
    staticClass: "pgs__badge check"
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "genre__content"
  }, [_c('v-layout', {
    key: _vm.parent.id,
    attrs: {
      "row": "",
      "wrap": "",
      "ma-0": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('p', {
    staticClass: "regular-checkbox settings parent-genre"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.parent.value),
      expression: "parent.value"
    }],
    attrs: {
      "id": _vm.parent.id,
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.parent.value) ? _vm._i(_vm.parent.value, null) > -1 : (_vm.parent.value)
    },
    on: {
      "click": function($event) {
        _vm.checkParentGenre(_vm.parent)
      },
      "change": function($event) {
        var $$a = _vm.parent.value,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.parent.value = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.parent.value = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.parent, "value", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": _vm.parent.id
    }
  }, [_vm._v("Select All")])])]), _vm._v(" "), _vm._l((_vm.parent.children), function(child) {
    return _c('v-flex', {
      key: child.id,
      attrs: {
        "xs12": "",
        "sm3": ""
      }
    }, [_c('p', {
      staticClass: "regular-checkbox settings"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (child.value),
        expression: "child.value"
      }],
      attrs: {
        "id": child.id,
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(child.value) ? _vm._i(child.value, null) > -1 : (child.value)
      },
      on: {
        "click": function($event) {
          _vm.checkChildGenre(_vm.parent, child)
        },
        "change": function($event) {
          var $$a = child.value,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (child.value = $$a.concat([$$v]))
            } else {
              $$i > -1 && (child.value = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.$set(child, "value", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": child.id
      }
    }, [_vm._v(_vm._s(child.name))]), _vm._v(" "), _c('span', [_vm._v("(" + _vm._s(child.users_size) + ")")])])])
  })], 2)], 1)]), _vm._v(" "), _c('v-btn', {
    staticClass: "update-btn",
    attrs: {
      "dark": "",
      "color": "blue"
    },
    nativeOn: {
      "click": function($event) {
        _vm.show_selector_view = true
      }
    }
  }, [_vm._v("OK")])], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "my-dialog-1"
    },
    model: {
      value: (_vm.show_load_genre_confirm_dialog),
      callback: function($$v) {
        _vm.show_load_genre_confirm_dialog = $$v
      },
      expression: "show_load_genre_confirm_dialog"
    }
  }, [_c('v-card', [_c('v-card-text', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Save current genre setting?")]), _vm._v(" "), _c('div', [_vm._v("You can save current genre setting and load it later")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "pt-3": ""
    }
  }, [_c('v-flex', {
    staticClass: "d-flex",
    attrs: {
      "xs2": ""
    }
  }, [_c('label', {
    staticClass: "text-xs-left"
  }, [_vm._v("Name")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "d-flex",
    attrs: {
      "xs10": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.preset_name),
      expression: "preset_name"
    }],
    staticClass: "py-1 px-2",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.preset_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.preset_name = $event.target.value
      }
    }
  })])], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "dark": "",
      "color": "green"
    },
    nativeOn: {
      "click": function($event) {
        _vm.savePreset()
      }
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "dark": "",
      "color": "grey"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeLoadGenreConfirmDialog()
      }
    }
  }, [_vm._v("No")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    directives: [{
      name: "on-click-outside",
      rawName: "v-on-click-outside",
      value: (_vm.closeLoadGenreDialog),
      expression: "closeLoadGenreDialog"
    }],
    attrs: {
      "content-class": "my-dialog-1"
    },
    model: {
      value: (_vm.show_load_genre_dialog),
      callback: function($$v) {
        _vm.show_load_genre_dialog = $$v
      },
      expression: "show_load_genre_dialog"
    }
  }, [_c('v-card', [_c('v-card-text', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Load Genre")]), _vm._v(" "), _c('v-list', [_vm._l((_vm.presets), function(preset, index) {
    return [_c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(preset.name))])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('div', [_c('v-btn', {
      staticClass: "mr-2",
      attrs: {
        "icon": "",
        "small": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.removePreset(preset.id)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "red"
      }
    }, [_vm._v("fa-trash")])], 1), _vm._v(" "), _c('v-btn', {
      attrs: {
        "icon": "",
        "small": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.loadPreset(preset.id)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "blue"
      }
    }, [_vm._v("fa-download")])], 1)], 1)])], 1), _vm._v(" "), (index + 1 < _vm.presets.length) ? _c('v-divider', {
      key: preset.id
    }) : _vm._e()]
  })], 2)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "dark": "",
      "color": "grey"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeLoadGenreDialog()
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "description-section genre"
  }, [_c('label', [_vm._v("Tailor your experience by removing music genres you don't like.")]), _vm._v(" "), _c('label', [_vm._v("You will no longer see the selected genres unless you visit a specific\n      profile, or unhide the genre.")])])
}]}

/***/ }),
/* 1674 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "blurb-and-subscription-container w-100",
    class: _vm.$vuetify.breakpoint.width <= 1280 ? '' : 'py-5'
  }, [_c('div', {
    staticClass: "blurb-and-subscription"
  }, [_c('div', {
    staticClass: "display-flex align-center justify-space-between gap-8",
    class: _vm.$vuetify.breakpoint.width <= 1280 ? 'flex-column' : ''
  }, [_c('div', {
    staticClass: "blurb-container"
  }, [_c('div', {
    staticClass: "font-space-grotesk font-weight-500",
    class: _vm.$vuetify.breakpoint.width <= 1280 ? 'text-32 text-center display-flex white--text font-weight-700' : 'text-50 white--text'
  }, [(_vm.$vuetify.breakpoint.width > 1280) ? _c('span', [_vm._v("Streaming Revenue"), _c('br'), _vm._v("Estimator")]) : _c('span', [_vm._v("Estimate Streaming Revenue")])])]), _vm._v(" "), _c('div', {
    staticClass: "subscription-container"
  }, [_c('div', {
    staticClass: "subscription-plan",
    class: {
      'bg-white': _vm.$vuetify.breakpoint.width > 1280
    }
  }, [_c('div', {
    staticClass: "text-center overflow-hidden font-space-grotesk"
  }, [_c('div', {
    staticClass: "pa-7"
  }, [_c('div', {
    staticClass: "title-money"
  }, [_vm._v(_vm._s(_vm.formattedListenerCount))]), _vm._v(" "), _c('div', {
    staticClass: "font-weight-bold title-money-note text-14 pt-2"
  }, [_vm._v("\n                  Monthly listeners\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "slider-component"
  }, [_c('div', {
    staticClass: "slide-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.range),
      expression: "formData.range"
    }],
    ref: "input",
    staticClass: "slider",
    attrs: {
      "type": "range",
      "min": 0,
      "max": _vm.increments.length - 1
    },
    domProps: {
      "value": (_vm.formData.range)
    },
    on: {
      "input": _vm.updateRangePrice,
      "__r": function($event) {
        _vm.$set(_vm.formData, "range", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "revenue-output-box"
  }, [_c('div', {
    staticClass: "result-price"
  }, [_vm._v(_vm._s(_vm.youSoundRevenue))]), _vm._v(" "), _c('div', {
    staticClass: "result-price-text"
  }, [_vm._v("YOUSOUND")])]), _vm._v(" "), _c('div', {
    staticClass: "revenue-output-box"
  }, [_c('div', {
    staticClass: "result-price"
  }, [_vm._v(_vm._s(_vm.dspRevenue))]), _vm._v(" "), _c('div', {
    staticClass: "result-price-text"
  }, [_vm._v("OTHER MUSIC PLATFORMS")])])])])])])])]), _vm._v(" "), (_vm.$vuetify.breakpoint.width <= 1280) ? _c('div', {
    staticClass: "btn-wrapper"
  }, [_c('button', {
    staticClass: "btn-sign-up",
    on: {
      "click": _vm.redirectToAppStore
    }
  }, [_vm._v("\n      Sign up\n    ")])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1675 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-section"
  }, [_c('h2', [_vm._v("Privacy Choices")]), _vm._v(" "), _c('p', [_vm._v("\n    YouSound takes your privacy seriously, so we provide you with a variety of\n    choices regarding how we use the information we collect about you, and how\n    you can manage your online privacy when you use the YouSound Services.\n    Here’s how you can exercise those choices.\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    If you want more information or have questions, contact us at\n    privacy@yousound.com.\n  ")]), _vm._v(" "), _c('table', {
    staticStyle: {
      "font-family": "'Open Sans', sans-serif",
      "font-size": "16px",
      "border-collapse": "collapse"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "border": "1px solid #d7d7d7",
      "padding": "16px"
    }
  }, [_c('strong', [_vm._v("If you want to:")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "1px solid #d7d7d7",
      "padding": "16px"
    }
  }, [_c('strong', [_vm._v("Do this:")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border": "1px solid #d7d7d7",
      "padding": "16px"
    }
  }, [_vm._v("\n          Update your user profile information and preferences\n        ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "1px solid #d7d7d7",
      "padding": "16px"
    }
  }, [_vm._v("\n          Go to “Settings”, then click \"Update Profile\""), _c('br')])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border": "1px solid #d7d7d7",
      "padding": "16px"
    }
  }, [_vm._v("\n          Disable or deactivate your YouSound user account\n        ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "1px solid #d7d7d7",
      "padding": "16px"
    }
  }, [_vm._v("\n          Go to “Settings”, then click \"Disable Account\""), _c('br')])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border": "1px solid #d7d7d7",
      "padding": "16px"
    }
  }, [_vm._v("\n          Close your account and delete your profile information. Note: If you\n          close your account, YouSound may retain other information about you\n          for the activities described in our Terms, or as permitted or\n          required by applicable law.\n        ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "1px solid #d7d7d7",
      "padding": "16px"
    }
  }, [_vm._v("\n          Go to “Settings”, then click \"Cancel My Account\""), _c('br')])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border": "1px solid #d7d7d7",
      "padding": "16px"
    }
  }, [_vm._v("\n          (Verified Artists) Download your songs\n        ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "1px solid #d7d7d7",
      "padding": "16px"
    }
  }, [_vm._v("\n          Log into your account, play your own songs, and use the download\n          button on the footer player to download your songs\n        ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border": "1px solid #d7d7d7",
      "padding": "16px"
    }
  }, [_vm._v("\n          To disable activity sharing with friends, you must close your\n          account\n        ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "1px solid #d7d7d7",
      "padding": "16px"
    }
  }, [_vm._v("\n          Go to “Settings”, then click \"Cancel My Account\""), _c('br')])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border": "1px solid #d7d7d7",
      "padding": "16px"
    }
  }, [_vm._v("\n          De-link your account from your other accounts and services (such as\n          Stripe.com) and opt out of sharing between the YouSound Services and\n          Stripe.\n        ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "1px solid #d7d7d7",
      "padding": "16px"
    }
  }, [_vm._v("\n          Go to “Settings”, then click \"Bank Details\" and click \"Disconnect\n          Stripe\""), _c('br')])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border": "1px solid #d7d7d7",
      "padding": "16px"
    }
  }, [_vm._v("\n          Opt out of non-transactional email or push notifications\n        ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "1px solid #d7d7d7",
      "padding": "16px"
    }
  }, [_vm._v("\n          Use the “unsubscribe” link included in each email\n        ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border": "1px solid #d7d7d7",
      "padding": "16px"
    }
  }, [_vm._v("\n          Opt out of marketing emails from YouSound\n        ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "1px solid #d7d7d7",
      "padding": "16px"
    }
  }, [_vm._v("\n          Use the “unsubscribe” link included in each email\n        ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border": "1px solid #d7d7d7",
      "padding": "16px"
    }
  }, [_vm._v("\n          Opt out of Google Analytics in connection with your use of the\n          YouSound Services\n        ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "1px solid #d7d7d7",
      "padding": "16px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://tools.google.com/dlpage/gaoptout"
    }
  }, [_vm._v("Click here")])])])])]), _vm._v(" "), _c('h3', [_vm._v("EEA DATA SUBJECT RIGHTS")]), _vm._v(" "), _c('p', [_vm._v("\n    Residents of the European Economic Area (“EEA”) can exercise certain data\n    subject rights available to them under applicable data protection laws.\n    Where such rights apply, we will comply with requests to exercise these\n    rights in accordance with applicable law. Please note, however, that we\n    are not legally required to accommodate such requests under all\n    circumstances, which may include if we need to keep processing your\n    information for our legitimate interests or to comply with a legal\n    obligation.\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    We may request you provide us with information necessary to confirm your\n    identity (such as your IP address, date of birth, transaction IDs, and\n    email address) before responding to your request."), _c('br'), _c('br')]), _vm._v(" "), _c('table', {
    staticStyle: {
      "font-family": "'Open Sans', sans-serif",
      "font-size": "16px",
      "border-collapse": "collapse"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticStyle: {
      "border": "1px solid #d7d7d7",
      "padding": "16px",
      "font-size": "18px",
      "text-align": "left"
    }
  }, [_vm._v("\n          If you want to:\n        ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "border": "1px solid #d7d7d7",
      "padding": "16px",
      "font-size": "18px",
      "text-align": "left"
    }
  }, [_vm._v("\n          Do this:\n        ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border": "1px solid #d7d7d7",
      "padding": "16px"
    }
  }, [_vm._v("\n          Obtain access to or a copy of certain personal information we hold\n          about you.\n        ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "1px solid #d7d7d7",
      "padding": "16px"
    }
  }, [_vm._v("\n          If you want to see your account information, login, then go to the\n          “Settings” page, then click \"View All of Your User Submitted Data\"\n        ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border": "1px solid #d7d7d7",
      "padding": "16px"
    }
  }, [_vm._v("\n          Update personal information which is out of date or incorrect\n        ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "1px solid #d7d7d7",
      "padding": "16px"
    }
  }, [_vm._v("\n          To update your account or profile information, login, then go to the\n          “Settings” page, and update out-of-date or incorrect information.\n        ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border": "1px solid #d7d7d7",
      "padding": "16px"
    }
  }, [_vm._v("\n          Delete certain personal information which we are holding about you\n        ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "1px solid #d7d7d7",
      "padding": "16px"
    }
  }, [_vm._v("\n          Go to “Settings”, then click \"Cancel My Account\". Your\n          information is permanently deleted within 7 days. View our Terms\n          clause \"Personal Information\" to see the specifics."), _c('br')])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border": "1px solid #d7d7d7",
      "padding": "16px"
    }
  }, [_vm._v("\n          Restrict the way that we process and disclose specific personal\n          information about you.\n        ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "1px solid #d7d7d7",
      "padding": "16px"
    }
  }, [_vm._v("\n          Go to “Settings”, then click \"Cancel My Account\"."), _c('br')])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border": "1px solid #d7d7d7",
      "padding": "16px"
    }
  }, [_vm._v("\n          Transfer your personal information to a third-party provider of\n          services\n        ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "1px solid #d7d7d7",
      "padding": "16px"
    }
  }, [_vm._v("\n          To allow users to send and accept payments, we use Stripe. To remove\n          Stripe from your account, go to “Settings”, then click \"Bank\n          Details\" and click \"Disconnect Stripe\".\n        ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border": "1px solid #d7d7d7",
      "padding": "16px"
    }
  }, [_vm._v("\n          Object to the processing of your personal information\n        ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "1px solid #d7d7d7",
      "padding": "16px"
    }
  }, [_vm._v("\n          Go to “Settings”, then click \"Cancel My Account\"."), _c('br')])])])])])
}]}

/***/ }),
/* 1676 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "display-flex justify-space-between align-center mb-3"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'YouMobile'
        })
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1481),
      "width": "20",
      "height": "20"
    }
  })])]), _vm._v(" "), _vm._l((3), function(i) {
    return _c('div', {
      key: i
    }, [_vm._m(1, true), _vm._v(" "), _vm._m(2, true), _vm._v(" "), _c('hr', {
      staticClass: "my-3"
    })])
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "text-poppins-14 text-white font-weight-700 btn-checkout ma-0",
    on: {
      "click": function($event) {
        _vm.$router.push('checkoutm')
      }
    }
  }, [_vm._v("\n    CHECKOUT\n  ")])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "display-flex gap-8 align-center"
  }, [_c('div', {
    staticClass: "cart__title"
  }, [_vm._v("Cart")]), _vm._v(" "), _c('div', {
    staticClass: "cart__count text-center"
  }, [_vm._v("4")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "display-flex gap-15"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1479),
      "width": "96",
      "height": "96"
    }
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "text-capitalize text-dmsans-14"
  }, [_vm._v("\n          The Slow Rush with exclusive featuring the thing\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "text-dmsans-14 text-grey-1 font-weight-700 my-1"
  }, [_vm._v("\n          Tame Impala\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "text-inter-12"
  }, [_vm._v("Other")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "display-flex justify-space-between align-center mt-2"
  }, [_c('div', {
    staticClass: "display-flex align-center gap-15"
  }, [_c('div', {
    staticClass: "display-flex align-center cart__item__count"
  }, [_c('span', [_c('img', {
    attrs: {
      "src": __webpack_require__(1505),
      "width": "8",
      "height": "8"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("1")]), _vm._v(" "), _c('span', [_c('img', {
    attrs: {
      "src": __webpack_require__(1500),
      "width": "8",
      "height": "8"
    }
  })])]), _vm._v(" "), _c('div', [_vm._v("$129.99")])]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1506),
      "width": "32",
      "height": "30"
    }
  })])])
}]}

/***/ }),
/* 1677 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "my-overlay",
    on: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: {
      fullscreen: _vm.fullscreen,
      onMobile: _vm.onMobile
    }
  }, [_c('h4', {
    staticClass: "modal__title"
  }, [(_vm.fullscreen && !_vm.altFullscreenHeader) ? _c('span', {
    staticClass: "dismisser",
    on: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  }, [_c('v-icon', [_vm._v("arrow_back_ios")])], 1) : _vm._e(), _vm._v(" "), (_vm.fullscreen && _vm.altFullscreenHeader) ? _c('div', {
    staticClass: "pa-2 dflex align-center justify-space-between width100"
  }, [_c('div', {
    staticClass: "flex-grow text-center"
  }, [_c('img', {
    attrs: {
      "height": "24",
      "src": __webpack_require__(49)
    }
  })]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(164),
      "width": "18"
    },
    on: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.title) ? _c('span', {
    staticClass: "flex-grow text-center"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal__header"
  }, [_c('v-btn', {
    class: {
      selected: _vm.active_tab == 'Album'
    },
    nativeOn: {
      "click": function($event) {
        _vm.onTab('Album')
      }
    }
  }, [_vm._v("Album")]), _vm._v(" "), _c('v-btn', {
    class: {
      selected: _vm.active_tab == 'ShopProduct'
    },
    nativeOn: {
      "click": function($event) {
        _vm.onTab('ShopProduct')
      }
    }
  }, [_vm._v("Product")]), _vm._v(" "), (_vm.showVideo) ? _c('v-btn', {
    class: {
      selected: _vm.active_tab == 'Video'
    },
    nativeOn: {
      "click": function($event) {
        _vm.onTab('Video')
      }
    }
  }, [_vm._v("\n          Video\n        ")]) : _vm._e()], 1), _vm._v(" "), (_vm.active_tab == 'Album') ? _c('div', {
    staticClass: "modal__content"
  }, _vm._l((_vm.albums), function(album, index) {
    return _c('div', {
      key: index,
      staticClass: "media",
      class: {
        selected: _vm.attachId == album.id
      },
      on: {
        "click": function($event) {
          _vm.selectItem('Album', album)
        }
      }
    }, [_c('div', {
      staticClass: "media__header"
    }, [_c('div', {
      staticClass: "media__image",
      style: (("background-image: url(" + (album.cover.thumb.url) + ")"))
    })]), _vm._v(" "), _c('div', {
      staticClass: "media__content"
    }, [_c('label', {
      staticClass: "media__title"
    }, [_vm._v(_vm._s(album.name))]), _vm._v(" "), _c('label', {
      staticClass: "media__subtitle"
    }, [_vm._v(_vm._s(album.user.username))])])])
  })) : _vm._e(), _vm._v(" "), (_vm.active_tab == 'ShopProduct') ? _c('div', {
    staticClass: "modal__content"
  }, _vm._l((_vm.products), function(product, index) {
    return _c('div', {
      key: index,
      staticClass: "media",
      class: {
        selected: _vm.attachId == product.id
      },
      on: {
        "click": function($event) {
          _vm.selectItem('ShopProduct', product)
        }
      }
    }, [_c('div', {
      staticClass: "media__header"
    }, [_c('div', {
      staticClass: "media__image",
      style: (("background-image: url(" + (product.covers[0].cover.thumb.url) + ")"))
    })]), _vm._v(" "), _c('div', {
      staticClass: "media__content"
    }, [_c('label', {
      staticClass: "media__title"
    }, [_vm._v(_vm._s(product.name))]), _vm._v(" "), _c('label', {
      staticClass: "media__subtitle"
    }, [_vm._v(_vm._s(product.merchant.username))])])])
  })) : _vm._e(), _vm._v(" "), (_vm.showVideo && _vm.active_tab == 'Video') ? _c('div', {
    staticClass: "modal__content"
  }, _vm._l((_vm.videos), function(video, index) {
    return _c('div', {
      key: index,
      staticClass: "media",
      class: {
        selected: _vm.attachId == video.id
      },
      on: {
        "click": function($event) {
          _vm.selectItem('Video', video)
        }
      }
    }, [_c('div', {
      staticClass: "media__header"
    }, [_c('div', {
      staticClass: "media__image _vid",
      style: (("background-image: url(" + (video.cover.thumb.url) + ")"))
    })]), _vm._v(" "), _c('div', {
      staticClass: "media__content"
    }, [_c('label', {
      staticClass: "media__title"
    }, [_vm._v(_vm._s(video.name))]), _vm._v(" "), _c('label', {
      staticClass: "media__subtitle"
    }, [_vm._v(_vm._s(video.user.username))])])])
  })) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 1678 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-grey"
  }, [_c('div', {
    staticClass: "pa-4 display-flex justify-end"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1486),
      "width": "40",
      "height": "40"
    },
    on: {
      "click": function($event) {
        _vm.$emit('previousStep')
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bg-white pa-4 payment"
  }, [_c('div', {
    staticClass: "font-24 font-weight-600 text-black"
  }, [_vm._v("Loud Pack")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "text-poppins-14 font-weight-600 text-black my-4"
  }, [_vm._v("\n      You have of multiple memberships for this user. You can keep or cancel\n      other memberships.\n    ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('v-btn', {
    staticClass: "text-poppins-14 text-white font-weight-700 btn-pay ma-0 full-width my-4",
    on: {
      "click": function($event) {
        _vm.$emit('nexStep')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(597),
      "width": "58",
      "height": "24"
    }
  })]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "text-dmsans-14 font-weight-700 mb-2"
  }, [_vm._v("Credit card")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "text-dmsans-14 font-weight-700 mb-2"
  }, [_vm._v("Country or region")]), _vm._v(" "), _c('div', {
    staticClass: "mb-4 country-region"
  }, [_c('v-select', {
    staticClass: "pt-0 country",
    attrs: {
      "label": "Choose one",
      "single-line": "",
      "hide-details": ""
    }
  }), _vm._v(" "), _vm._m(6)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "text-poppins-18 btn-confirm ma-0 text-white full-width",
    on: {
      "click": function($event) {
        _vm.$emit('nexStep')
      }
    }
  }, [_vm._v("\n      Pay\n    ")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "font-20 font-weight-600 text-black"
  }, [_vm._v("20$/")]), _vm._v(" "), _c('span', {
    staticClass: "text-poppins-14 font-weight-600 text-black"
  }, [_vm._v("month")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "display-flex justify-space-between mb-2"
  }, [_c('span', {
    staticClass: "text-poppins-16 font-weight-600 text-black"
  }, [_vm._v(" Gold")]), _vm._v(" "), _c('label', {
    staticClass: "switch"
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "slider round"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "display-flex justify-space-between mb-2"
  }, [_c('span', {
    staticClass: "text-poppins-16 font-weight-600 text-black"
  }, [_vm._v("\n        Platinum")]), _vm._v(" "), _c('label', {
    staticClass: "switch"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "slider round"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "display-flex justify-space-between mb-2"
  }, [_c('span', {
    staticClass: "text-poppins-16 font-weight-600 text-black"
  }, [_vm._v("\n        Sample packs\n      ")]), _vm._v(" "), _c('label', {
    staticClass: "switch"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "slider round"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-dmsans-16 text-grey-3 font-weight-400 display-flex align-center full-width mt-2 mb-4"
  }, [_c('hr', {
    staticClass: "flex-grow"
  }), _vm._v(" "), _c('span', {
    staticClass: "mx-2"
  }, [_vm._v("Or pay with card")]), _vm._v(" "), _c('hr', {
    staticClass: "flex-grow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "credit-card mb-5"
  }, [_c('div', {
    staticClass: "display-flex align-center px-3 credit-card__number"
  }, [_c('input', {
    staticClass: "full-width border-none",
    attrs: {
      "type": "text",
      "placeholder": "1234 1234 1234 1234"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "display-flex align-center gap-8"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(320),
      "width": "24",
      "height": "16"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(318),
      "width": "24",
      "height": "16"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(314),
      "width": "24",
      "height": "16"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(316),
      "width": "24",
      "height": "16"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "display-flex align-center full-width"
  }, [_c('input', {
    staticClass: "border-none width-50 credit-card__month px-3 credit-card__month",
    attrs: {
      "type": "text",
      "placeholder": "MM / YY"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "width-50 px-3 display-flex align-center"
  }, [_c('input', {
    staticClass: "border-none full-width",
    attrs: {
      "type": "text",
      "placeholder": "CVC"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(599),
      "width": "24",
      "height": "16"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zip"
  }, [_c('input', {
    staticClass: "full-width border-none px-3",
    attrs: {
      "type": "text",
      "placeholder": "ZIP"
    }
  })])
}]}

/***/ }),
/* 1679 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "carousel-3d-container",
    style: ({
      height: this.slideHeight + 'px'
    })
  }, [_c('div', {
    staticClass: "carousel-3d-slider",
    style: ({
      width: this.slideWidth + 'px',
      height: this.slideHeight + 'px',
    })
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.controlsVisible) ? _c('controls', {
    attrs: {
      "next-html": _vm.controlsNextHtml,
      "prev-html": _vm.controlsPrevHtml,
      "width": _vm.controlsWidth,
      "height": _vm.controlsHeight
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1680 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mobile-player",
    class: {
      'no-album': !_vm.item
    }
  }, [_c('canvas', {
    staticClass: "player-background",
    attrs: {
      "id": "canvas"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "_top dflex align-center justify-space-between"
  }, [_vm._m(0), _vm._v(" "), _c('v-icon', {
    staticClass: "min-player",
    on: {
      "click": function($event) {
        _vm.minModal()
      }
    }
  }, [_vm._v(" expand_more ")])], 1), _vm._v(" "), (_vm.item) ? _c('div', {
    staticClass: "album-track-details"
  }, [_c('div', {
    staticClass: "album-cover",
    style: ({
      'background-image': 'url(' + _vm.albumCover + ')'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "track-info"
  }, [_c('div', {
    staticClass: "track-name"
  }, [_vm._v(_vm._s(_vm.item.name))]), _vm._v(" "), _c('div', {
    staticClass: "track-artist"
  }, [_vm._v(_vm._s(_vm.item.user.username))])]), _vm._v(" "), (_vm.isLoaded) ? _c('div', {
    staticClass: "loading flex-none",
    attrs: {
      "id": "loading"
    }
  }) : _c('div', {
    staticClass: "controls-section"
  }, [_c('div', {
    staticClass: "bar-section"
  }, [_c('v-spacer', [_c('v-slider', {
    staticClass: "player-bar pa-0",
    attrs: {
      "hide-details": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.seek(_vm.progress)
      }
    },
    model: {
      value: (_vm.progress),
      callback: function($$v) {
        _vm.progress = $$v
      },
      expression: "progress"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "duration-time total",
    attrs: {
      "id": "totalTime"
    }
  }, [_vm._v(_vm._s(_vm.totalTime))])], 1), _vm._v(" "), _c('div', {
    staticClass: "action-btns"
  }, [_c('v-btn', {
    staticClass: "player-control-btn no-Btn-bg",
    attrs: {
      "ripple": false,
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.skip('prev')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ic_rewind.svg",
      "width": "20"
    }
  })]), _vm._v(" "), (!_vm.isPlaying) ? _c('v-btn', {
    staticClass: "player-control-btn play no-Btn-bg",
    attrs: {
      "ripple": false,
      "flat": "",
      "id": "play"
    },
    nativeOn: {
      "click": function($event) {
        _vm.$root.$emit(_vm.MyEvents.AUDIO_PLAYER_REPLAY)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ic_play.svg",
      "height": "26"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isPlaying) ? _c('v-btn', {
    staticClass: "player-control-btn pause no-Btn-bg",
    attrs: {
      "ripple": false,
      "flat": "",
      "id": "pause"
    },
    nativeOn: {
      "click": function($event) {
        _vm.pause()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ic_pause.svg",
      "height": "26"
    }
  })]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "player-control-btn no-Btn-bg",
    attrs: {
      "ripple": false,
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.skip('next')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ic_skip.svg",
      "width": "20"
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "player-options text-center"
  }, [_c('v-icon', {
    on: {
      "click": function($event) {
        _vm.optionModalActive = true
      }
    }
  }, [_vm._v("more_horiz")]), _vm._v(" "), (_vm.optionModalActive) ? _c('transition', {
    attrs: {
      "name": "slide-up",
      "leave-active-class": "slide-fade"
    }
  }, [_c('div', [_c('div', {
    staticClass: "decoy",
    on: {
      "click": function($event) {
        _vm.optionModalActive = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "option-modal"
  }, [_c('div', {
    staticClass: "follow-user"
  }, [_c('user-tag', {
    attrs: {
      "user": _vm.user,
      "showAvatar": "",
      "showUserType": "",
      "width": "35",
      "height": "35"
    }
  }), _vm._v(" "), (_vm.currentUser && _vm.item.user.id != _vm.currentUser.id) ? _c('user-follow-btn', {
    attrs: {
      "user": _vm.item,
      "theme": "dark",
      "type": "player"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "action-wrapper"
  }, [_c('div', {
    staticClass: "_action _border_right _border_bottom",
    on: {
      "click": function($event) {
        _vm.openShareModal()
      }
    }
  }, [_c('img', {
    staticClass: "_action-icon mr-1",
    attrs: {
      "src": "/static/images/ic_share_fill.svg",
      "width": "20"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "_action-title"
  }, [_vm._v("Share")])]), _vm._v(" "), _c('div', {
    staticClass: "_action _border_bottom",
    on: {
      "click": function($event) {
        _vm.repostItem()
      }
    }
  }, [_c('img', {
    staticClass: "_action-icon mr-1",
    attrs: {
      "slot": "activator",
      "src": "/static/images/ic_repost.svg",
      "width": "20"
    },
    slot: "activator"
  }), _vm._v(" "), _c('div', {
    staticClass: "_action-title"
  }, [_vm._v("Repost")])]), _vm._v(" "), _c('div', {
    staticClass: "_action _border_right",
    on: {
      "click": function($event) {
        _vm.showAlbumCredit()
      }
    }
  }, [_c('img', {
    staticClass: "_action-icon mr-1",
    attrs: {
      "src": "/static/images/ic_users_fill.svg",
      "width": "20"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "_action-title"
  }, [_vm._v("Credits")])]), _vm._v(" "), _c('div', {
    staticClass: "_action",
    on: {
      "click": function($event) {
        _vm.showComments()
      }
    }
  }, [_c('img', {
    staticClass: "_action-icon mr-1",
    attrs: {
      "src": "/static/images/ic_comment.svg",
      "width": "20"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "_action-title"
  }, [_vm._v("Comment")])])])])])]) : _vm._e()], 1), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.modalMode),
      callback: function($$v) {
        _vm.modalMode = $$v
      },
      expression: "modalMode"
    }
  }, [(_vm.showShareModal) ? _c('share-modal', {
    attrs: {
      "item": _vm.item,
      "dismiss": _vm.dismissShareDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showDownloadModal) ? _c('download-modal', {
    attrs: {
      "item": _vm.item,
      "track": _vm.track,
      "dismiss": _vm.dismissDownloadDialog
    }
  }) : _vm._e()], 1)], 1) : _c('div', {
    staticClass: "no-album-info"
  }, [_vm._v("\n    No music to play\n  ")]), _vm._v(" "), _c('mobile-comments', {
    ref: "mobileComments",
    attrs: {
      "item": _vm.item,
      "comments": _vm.comments
    }
  }), _vm._v(" "), (_vm.item) ? _c('div', {
    staticClass: "credits-dialog-wrapper"
  }, [_c('v-dialog', {
    staticClass: "album-credits-dialog",
    attrs: {
      "scrollable": "",
      "max-width": "600px"
    },
    model: {
      value: (_vm.showCredit),
      callback: function($$v) {
        _vm.showCredit = $$v
      },
      expression: "showCredit"
    }
  }, [_c('v-card', {
    staticClass: "album-dialog-body"
  }, [_c('v-card-title', [_vm._v("Album Credits")]), _vm._v(" "), _c('v-btn', {
    staticClass: "dialog-close-btn",
    on: {
      "click": function($event) {
        _vm.showCredit = false
      }
    }
  }, [_c('v-icon', [_vm._v("highlight_off")])], 1), _vm._v(" "), _c('v-card-text', {
    staticStyle: {
      "height": "300px"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('label', {
    staticClass: "album-info-label"
  }, [_vm._v("Album Name: ")]), _vm._v(" "), _c('label', {
    staticClass: "album-info-text"
  }, [_vm._v(_vm._s(_vm.item.name))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('label', {
    staticClass: "album-info-label"
  }, [_vm._v("Release Date: ")]), _vm._v(" "), _c('label', {
    staticClass: "album-info-text"
  }, [_vm._v(_vm._s(_vm._f("formatDate")(_vm.item.released_at)))])]), _vm._v(" "), (_vm.item.location && _vm.item.location != '') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('label', {
    staticClass: "album-info-label"
  }, [_vm._v("Location: ")]), _vm._v(" "), _c('label', {
    staticClass: "album-info-text"
  }, [_vm._v(_vm._s(_vm.item.location))])]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('label', {
    staticClass: "album-info-label"
  }, [_vm._v("Genre: ")]), _vm._v(" "), _c('label', {
    staticClass: "album-info-text"
  }, [_vm._v(_vm._s(_vm.genres))])]), _vm._v(" "), (_vm.item.collaborators && _vm.item.collaborators.length > 0) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('label', {
    staticClass: "album-info-label"
  }, [_vm._v("Collaborators: ")]), _vm._v(" "), _c('label', {
    staticClass: "album-info-text"
  }, [_vm._l((_vm.item.collaborators), function(c) {
    return [_c('div', {
      key: ("collaborator-" + (c.id)),
      staticClass: "collaborator-info"
    }, [_c('router-link', {
      staticClass: "user-name",
      attrs: {
        "to": ("/" + (c.user.slug))
      }
    }, [_vm._v(_vm._s(c.user.username))]), _vm._v(" "), _c('span', [_vm._v(" - " + _vm._s(c.user_role))])], 1)]
  })], 2)]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('label', {
    staticClass: "album-info-label"
  }, [_vm._v("Contributors: ")]), _vm._v(" "), _c('label', {
    staticClass: "album-info-text"
  }, [_c('div', {
    staticClass: "contributor-info"
  }, [_c('router-link', {
    staticClass: "user-name",
    attrs: {
      "to": ("/" + (_vm.item.user.slug))
    }
  }, [_vm._v(_vm._s(_vm.item.user.username))]), _vm._v(" "), _c('span', [_vm._v(" - Uploader")])], 1)]), _vm._v(" "), (_vm.item.contributors && _vm.item.contributors.length > 0) ? _c('label', {
    staticClass: "album-info-text"
  }, [_vm._l((_vm.item.contributors), function(c) {
    return [_c('div', {
      key: ("contributor-" + (c.id)),
      staticClass: "contributor-info"
    }, [_c('router-link', {
      staticClass: "user-name",
      attrs: {
        "to": ("/" + (c.user.slug))
      }
    }, [_vm._v(_vm._s(c.user.username))]), _vm._v(" "), _c('span', [_vm._v(" - " + _vm._s(c.user_role))])], 1)]
  })], 2) : _vm._e()]), _vm._v(" "), (_vm.item.samplings && _vm.item.samplings.length > 0) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('label', {
    staticClass: "album-info-label"
  }, [_vm._v("Samples: ")]), _vm._v(" "), (_vm.item.samplings && _vm.item.samplings.length > 0) ? _c('label', {
    staticClass: "album-info-text"
  }, [_vm._l((_vm.item.samplings), function(s) {
    return [_c('div', {
      key: ("sampling-" + (s.id)),
      staticClass: "sampling-info"
    }, [_c('label', [_vm._v(_vm._s(s.sampling_track.name))]), _vm._v(": "), _c('router-link', {
      staticClass: "user-name",
      attrs: {
        "to": ("/" + (s.sample_user.slug))
      }
    }, [_vm._v(_vm._s(s.sample_user.username))]), _vm._v(" "), _c('span', [_vm._v(" - " + _vm._s(s.sample_track.name))])], 1)]
  })], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.item.labels && _vm.item.labels.length > 0) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('label', {
    staticClass: "album-info-label"
  }, [_vm._v("Label: ")]), _vm._v(" "), _c('label', {
    staticClass: "album-info-text"
  }, [_c('router-link', {
    staticClass: "user-name",
    attrs: {
      "to": ("/" + (_vm.item.labels[0].user.slug))
    }
  }, [_vm._v(_vm._s(_vm.item.labels[0].user.username))])], 1)]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('div', {
    staticClass: "album-info-label"
  }, [_vm._v("About the album:")]), _vm._v(" "), _c('label', {
    staticClass: "album-info-text"
  }, [_vm._v(_vm._s(_vm.item.description))])])], 1)], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo-wrapper"
  }, [_c('img', {
    staticClass: "_logo",
    attrs: {
      "src": __webpack_require__(429),
      "width": "130"
    }
  })])
}]}

/***/ }),
/* 1681 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-input auth-input-page"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center mt-4"
  }), _vm._v(" "), _c('form', {
    class: {
      'mt-2': _vm.onMobile
    },
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit()
      }
    }
  }, [_c('div', {
    staticClass: "form-group _email text-xs-center",
    class: {
      'has-error': _vm.errors.has('email')
    }
  }, [_c('label', {
    staticClass: "auth-label-input d-flex"
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    staticClass: "email",
    class: {
      input: true,
      'text-danger': _vm.errors.has('email')
    },
    attrs: {
      "name": "email",
      "type": "email",
      "placeholder": " ",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.has('email')) ? _c('p', {
    staticClass: "text-danger text-xs-left mb-0",
    class: {
      'mb-2': _vm.onMobile
    }
  }, [_vm._v("\n        " + _vm._s(_vm.errors.first("email")) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group _password text-xs-center my-1"
  }, [_c('label', {
    staticClass: "auth-label-input d-flex"
  }, [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "password",
    attrs: {
      "type": "password",
      "placeholder": " ",
      "autocomplete": "new-password"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center mt-4",
    class: {
      'mt-0': _vm.onMobile
    }
  }, [_c('v-btn', {
    staticClass: "auth-button login-btn-text",
    class: _vm.checkUserEmpty ? 'auth-bg-disabled' : 'auth-bg-active',
    attrs: {
      "depressed": "",
      "block": "",
      "round": "",
      "dark": "",
      "type": "submit",
      "loading": _vm.loading
    }
  }, [_vm._v("\n        Login\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "forgot-password mb-4 mt-5"
  }, [_c('span', {
    staticClass: "forgot-password-text cursor-pointer",
    on: {
      "click": function($event) {
        !_vm.showForgotPassword ? _vm.$route.push('/forgot') : _vm.showForgotPassword()
      }
    }
  }, [_vm._v("\n          Forgot password\n        ")])])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo-container"
  }, [_c('img', {
    staticClass: "logo-img",
    attrs: {
      "src": "/static/images/nav_logo_primary.png",
      "aspect-ratio": "1",
      "width": "174"
    }
  })])
}]}

/***/ }),
/* 1682 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [
    [_c('div', {
      staticClass: "my-overlay",
      on: {
        "click": function($event) {
          _vm.dismiss()
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "box"
    }, [_vm._m(0), _vm._v(" "), _c('div', {
      staticClass: "credit-card-inputs"
    }, [_c('card-number', {
      ref: "cardNumber",
      staticClass: "stripe-element card-number payment-card",
      class: {
        complete: _vm.complete
      },
      attrs: {
        "stripe": _vm.stripePubkey,
        "options": _vm.options
      },
      on: {
        "change": function($event) {
          _vm.number = $event.complete
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "card-box-bottom"
    }, [_c('card-expiry', {
      ref: "cardExpiry",
      staticClass: "stripe-element card-expiry payment-card",
      class: {
        complete: _vm.complete
      },
      attrs: {
        "stripe": _vm.stripePubkey,
        "options": _vm.options
      },
      on: {
        "change": function($event) {
          _vm.expiry = $event.complete
        }
      }
    }), _vm._v(" "), _c('card-cvc', {
      ref: "cardCvc",
      staticClass: "stripe-element card-cvc payment-card",
      class: {
        complete: _vm.complete
      },
      attrs: {
        "stripe": _vm.stripePubkey,
        "options": _vm.options
      },
      on: {
        "change": function($event) {
          _vm.cvc = $event.complete
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "divider"
    }), _vm._v(" "), _c('v-btn', {
      staticClass: "btn-cta",
      attrs: {
        "disabled": !_vm.complete
      },
      on: {
        "click": function($event) {
          _vm.paymentMethod()
        }
      }
    }, [_vm._v("Pay $" + _vm._s((_vm.finalAmount)))])], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "box__footer"
    })])]
  ], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box__header"
  }, [_c('div', {
    staticClass: "box__icon"
  }), _vm._v(" "), _c('h4', [_vm._v("You're almost done.")]), _vm._v(" "), _c('p', [_vm._v("Fill the card detail to complete your subscription.")])])
}]}

/***/ }),
/* 1683 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "product-card",
    class: {
      'side-tab-view': _vm.sideTabView,
      'px-0': _vm.onMobile
    }
  }, [_c('v-flex', {
    staticClass: "product-info",
    attrs: {
      "pa-0": ""
    },
    on: {
      "mouseenter": function($event) {
        _vm.is_component_hover = true
      },
      "mouseleave": function($event) {
        _vm.is_component_hover = false
      }
    }
  }, [_c('v-flex', {
    staticClass: "product-cover",
    class: {
      'px-0': _vm.onMobile
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "product-price"
  }, [_vm._v("$" + _vm._s(_vm._f("formatNumber")(_vm.item.price)))]), _vm._v(" "), _c('div', {
    staticClass: "product-image",
    style: ({
      'background-image': 'url(' + _vm.item.covers[0].cover.url + ')',
    })
  }, [_c('div', {
    staticClass: "full-overlay"
  }, [_c('div', {
    staticClass: "hover-info"
  }, [_c('div', {
    staticClass: "item-name"
  }, [_vm._v(_vm._s(_vm.item.name))]), _vm._v(" "), _c('div', {
    staticClass: "artist-name"
  }, [_vm._v(_vm._s(_vm.item.merchant.username))])]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 dflex justify-space-between align-center w-100"
  }, [(!_vm.hidePriceOverlay) ? _c('div', {
    staticClass: "items-price"
  }, [_vm._v("$" + _vm._s(_vm._f("formatNumber")(_vm.item.price)))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "item-plus"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(57),
      "width": "15px"
    }
  })])])])]), _vm._v(" "), (_vm.currentUser && !_vm.hideOverlay) ? _c('v-flex', {
    staticClass: "product-actions",
    attrs: {
      "xs12": "",
      "relative": ""
    },
    on: {
      "click": function($event) {
        _vm.currentUser !== null ? _vm.$router.push({
          name: 'SingleProduct',
          params: {
            id: _vm.item.id
          }
        }) : _vm.spotlightVideo()
      }
    }
  }, [(!_vm.hidePriceOverlay) ? _c('div', {
    staticClass: "product-label"
  }, [_vm._v("$" + _vm._s(_vm._f("formatNumber")(_vm.item.price)))]) : _vm._e(), _vm._v(" "), (!_vm.hideMoreOptions) ? _c('span', [(_vm.willMenuRender) ? _c('v-menu', {
    staticClass: "product-menu",
    attrs: {
      "offset-y": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.is_menu_hover = true
      }
    },
    slot: "activator"
  }, [_c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("more_horiz")])], 1), _vm._v(" "), _c('v-list', [(_vm.item.merchant.id != _vm.currentUser.id) ? _c('v-list-tile', {
    staticClass: "default-menu-item track-menu-item",
    nativeOn: {
      "click": function($event) {
        _vm.openHideDialog()
      }
    }
  }, [_c('v-list-tile-title', [_c('label', [_vm._v("Hide")])])], 1) : _vm._e()], 1)], 1) : _vm._e()], 1) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    on: {
      "click": function($event) {
        _vm.currentUser !== null ? _vm.$router.push({
          name: 'SingleProduct',
          params: {
            id: _vm.item.id
          }
        }) : _vm.spotlightVideo()
      }
    }
  }, [(!_vm.noMeta) ? _c('v-flex', {
    staticClass: "product-detail"
  }, [_c('p', {
    staticClass: "product-name cursor-pointer"
  }, [_vm._v("\n          " + _vm._s(_vm.item.name) + "\n        ")]), _vm._v(" "), _c('user-tag', {
    staticClass: "tag",
    attrs: {
      "user": _vm.item.merchant
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.altMeta) ? _c('div', {
    staticClass: "mt-2 box__footer alt-meta"
  }, [_c('div', {
    staticClass: "alt-meta-name"
  }, [_vm._v(_vm._s(_vm.item.name))]), _vm._v(" "), _c('div', {
    staticClass: "alt-meta-user"
  }, [_c('b', {
    staticClass: "text-capitalize"
  }, [_vm._v(_vm._s(_vm.item.merchant.username))])]), _vm._v(" "), (_vm.altMetaPrice) ? _c('div', {
    staticClass: "alt-meta-price"
  }, [_c('b', {
    staticClass: "text-capitalize"
  }, [_vm._v("$" + _vm._s(_vm._f("formatNumber")(_vm.item.price)))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.forCollection || _vm.playlistId) ? _c('v-menu', {
    staticClass: "track-menu",
    attrs: {
      "offset-y": "",
      "close-on-content-click": false,
      "nudge-width": 100
    }
  }, [_c('v-btn', {
    staticClass: "toolbar-btn",
    attrs: {
      "slot": "activator",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.is_menu_hover = true
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("more_horiz")])], 1), _vm._v(" "), _c('v-card', [_c('v-list', [_c('v-list-tile', {
    key: "remove",
    staticClass: "default-menu-item track-menu-item",
    nativeOn: {
      "click": function($event) {
        _vm.openRemoveFromCollectionModal()
      }
    }
  }, [_c('v-list-tile-title', [_c('div', {
    staticClass: "menu-list-item dflex align-center"
  }, [_c('label', {
    staticClass: "ml-0 black--text"
  }, [_vm._v("Remove")])])])], 1)], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.showMerchModal) ? _c('merch-modal', {
    attrs: {
      "item": _vm.item,
      "dismiss": _vm.closeMerchDialog,
      "shareProduct": _vm.openShareDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showShareModal) ? _c('share-modal', {
    attrs: {
      "item": _vm.item,
      "dismiss": _vm.closeShareDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_hide_dialog) ? _c('v-dialog', {
    attrs: {
      "content-class": "my-dialog-1"
    },
    model: {
      value: (_vm.show_hide_dialog),
      callback: function($$v) {
        _vm.show_hide_dialog = $$v
      },
      expression: "show_hide_dialog"
    }
  }, [_c('v-card', [_c('v-card-media', {
    attrs: {
      "src": _vm.item.covers[0].cover.url,
      "height": "125px",
      "contain": ""
    }
  }), _vm._v(" "), _c('v-card-text', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("\n          Are you sure you want to hide this product?\n        ")]), _vm._v(" "), _c('div', [_vm._v("\n          You won't be able to see it anymore, unless you visit the artists\n          profile or download the song.\n        ")])]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "dark": "",
      "color": "grey"
    },
    nativeOn: {
      "click": function($event) {
        _vm.show_hide_dialog = false
      }
    }
  }, [_vm._v("No, cancel please!")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "dark": "",
      "color": "red"
    },
    nativeOn: {
      "click": function($event) {
        _vm.hideProduct()
      }
    }
  }, [_vm._v("Yes, hide it!")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "logout-modal"
    },
    model: {
      value: (_vm.show_logout_modal),
      callback: function($$v) {
        _vm.show_logout_modal = $$v
      },
      expression: "show_logout_modal"
    }
  }, [_c('logoutModal')], 1), _vm._v(" "), (_vm.forCollection) ? _c('v-dialog', {
    attrs: {
      "content-class": "invite-dialog",
      "width": "440"
    },
    model: {
      value: (_vm.show_remove_from_collection_modal),
      callback: function($$v) {
        _vm.show_remove_from_collection_modal = $$v
      },
      expression: "show_remove_from_collection_modal"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("\n        Remove from Collection\n      ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n        Are you sure you want to remove this product from collection?\n      ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red",
      "dark": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.removeFromCollection()
      }
    }
  }, [_vm._v("Yes")])], 1)], 1)], 1) : (_vm.playlistId) ? _c('v-dialog', {
    attrs: {
      "content-class": "invite-dialog",
      "width": "440"
    },
    model: {
      value: (_vm.show_remove_from_collection_modal),
      callback: function($$v) {
        _vm.show_remove_from_collection_modal = $$v
      },
      expression: "show_remove_from_collection_modal"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("\n        Remove from Playlist\n      ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n        Are you sure you want to remove this product from playlist?\n      ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "black",
      "dark": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.removeFromPlaylist('shop_product', _vm.item.id, _vm.playlistId);
        _vm.show_remove_from_collection_modal = false
      }
    }
  }, [_vm._v("\n          Yes\n        ")])], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1684 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-section"
  }, [_vm._v("Opportunity")])
},staticRenderFns: []}

/***/ }),
/* 1685 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "blurb-and-subscription-container w-100 py-5"
  }, [_c('div', {
    staticClass: "blurb-and-subscription"
  }, [_c('div', {
    staticClass: "display-flex align-center justify-space-between gap-8"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "subscription-container"
  }, [_c('div', {
    staticClass: "subscription-plan bg-white"
  }, [_c('div', {
    staticClass: "d-flex justify-center align-center tab-group"
  }, _vm._l((_vm.tabList), function(item, i) {
    return _c('div', {
      key: i,
      staticClass: "tab-text width-50 cursor-pointer text-center",
      class: {
        'active-tab': item.id == _vm.tab
      },
      on: {
        "click": function($event) {
          _vm.setTab(item.id)
        }
      }
    }, [_vm._v("\n                " + _vm._s(item.title) + "\n              ")])
  })), _vm._v(" "), (_vm.categoryPlan == 'creator') ? _c('div', {
    staticClass: "font-space-grotesk"
  }, [_c('div', {
    staticClass: "text-31 font-weight-700 mb-1"
  }, [_vm._v("\n                " + _vm._s(_vm.creators.title) + "\n                "), _c('span', {
    staticClass: "price-text"
  }, [_vm._v(_vm._s(_vm.tab === "yearly" ? "$10/mo" : "$12/mo"))])]), _vm._v(" "), _c('div', {
    staticClass: "text-grey-purple-1 text-16 font-weight-500 mb-4"
  }, [_vm._v("\n                " + _vm._s(_vm.creators.subtitle) + "\n              ")]), _vm._v(" "), _vm._l((_vm.creators.option), function(item, i) {
    return _c('div', {
      key: i,
      staticClass: "d-flex align-center justify-start gap-10 pb-2"
    }, [_vm._m(1, true), _vm._v(" "), _c('span', {
      staticClass: "font-poppins text-14 font-weight-500"
    }, [_vm._v("\n                  " + _vm._s(item) + "\n                ")])])
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "package-card-btn font-weight-700 mt-3",
    attrs: {
      "block": "",
      "text": ""
    },
    on: {
      "click": _vm.handleGetStarted
    }
  }, [_vm._v("\n                Get Started\n              ")])], 2) : _c('div', {
    staticClass: "font-space-grotesk"
  }, [_c('div', {
    staticClass: "text-31 font-weight-700 mb-1"
  }, [_vm._v("\n                " + _vm._s(_vm.premium.title) + "\n                "), _c('span', {
    staticClass: "price-text"
  }, [_vm._v(_vm._s(_vm.tab === "yearly" ? "$100/mo" : "$12/mo"))])]), _vm._v(" "), _c('div', {
    staticClass: "text-grey-purple-1 text-16 font-weight-500 mb-4"
  }, [_vm._v("\n                " + _vm._s(_vm.premium.subtitle) + "\n              ")]), _vm._v(" "), _vm._l((_vm.premium.option), function(item, i) {
    return _c('div', {
      key: i,
      staticClass: "d-flex align-center justify-start gap-10 pb-2"
    }, [_vm._m(2, true), _vm._v(" "), _c('span', {
      staticClass: "font-poppins text-14 font-weight-500"
    }, [_vm._v("\n                  " + _vm._s(item) + "\n                ")])])
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "package-card-btn font-weight-700 mt-3",
    attrs: {
      "block": "",
      "text": ""
    },
    on: {
      "click": _vm.handleGetStarted
    }
  }, [_vm._v("\n                Coming soon\n              ")])], 2)])])])])]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "bg-grey-white upgrade-plan-dialog",
      "fullscreen": ""
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.closeDialog($event)
      }
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('div', {
    staticClass: "d-flex justify-center align-center full-height"
  }, [_c('div', {
    staticClass: "display-flex justify-center align-start gap-14 subscription-div",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "upgrade-plan-dialog"
  }, [_c('div', {
    staticClass: "display-flex justify-center align-center logo-container"
  }, [_c('img', {
    staticClass: "logo-img",
    attrs: {
      "src": __webpack_require__(44),
      "aspect-ratio": "1",
      "height": "24",
      "width": "124"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "subscription-plan upgrade-plan-dialog__content"
  }, [_c('div', {
    staticClass: "d-flex justify-center align-center tab-group"
  }, _vm._l((_vm.tabList), function(item, i) {
    return _c('div', {
      key: i,
      staticClass: "tab-text width-50 cursor-pointer text-center",
      class: {
        'active-tab': item.id == _vm.tab
      },
      on: {
        "click": function($event) {
          _vm.setTab(item.id)
        }
      }
    }, [_vm._v("\n                " + _vm._s(item.title) + "\n              ")])
  })), _vm._v(" "), _c('div', {
    staticClass: "credit-card bg-white mb-4"
  }, [_c('div', {
    staticClass: "font-inter text-20 font-weight-700"
  }, [_vm._v("PREMIUM")]), _vm._v(" "), _c('div', {
    staticClass: "font-inter text-16 font-weight-500"
  }, [_vm._v("\n                All access for everyone.\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "display-flex align-center font-space-grotesk"
  }, [_c('span', {
    staticClass: "text-36 font-weight-700"
  }, [_vm._v("\n                  $" + _vm._s(_vm.tab === "yearly" ? 100 : 12) + "\n                ")]), _vm._v(" "), _c('span', {
    staticClass: "text-14 font-weight-500 text-grey-3 mt-2"
  }, [_vm._v("\n                  /year\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "credit-card"
  }, [_c('div', {
    staticClass: "text-dmsans-14 mb-3"
  }, [(_vm.tab === 'yearly') ? [_vm._v("\n                  Your card will be charged $100 each year starting today.\n                ")] : [_vm._v("\n                  Your card will be charged $12 each month starting today.\n                ")]], 2), _vm._v(" "), _c('hr', {
    staticClass: "divider mb-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "display-flex align-center justify-space-between mb-3"
  }, [_c('div', {
    staticClass: "text-dmsans-14 font-weight-700 mb-2"
  }, [_vm._v("\n                  Credit card\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "display-flex align-center gap-8"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(320),
      "width": "24",
      "height": "16"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(318),
      "width": "24",
      "height": "16"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(314),
      "width": "24",
      "height": "16"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(316),
      "width": "24",
      "height": "16"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "credit-card__input bg-white"
  }, [_c('div', {
    staticClass: "display-flex align-center px-3 credit-card__number"
  }, [_c('div', {
    staticClass: "StripeElement",
    attrs: {
      "id": "card-element"
    }
  })])]), _vm._v(" "), _c('v-btn', {
    staticClass: "text-poppins text-18 font-weight-600 white--text w-100 bg-blue-1 btn-pay",
    on: {
      "click": _vm.purchase
    }
  }, [_vm._v("\n                Purchase\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "font-dm-sans text-center"
  }, [_c('span', {
    staticClass: "text-16"
  }, [_vm._v(" Powered by ")]), _vm._v(" "), _c('span', {
    staticClass: "text-20 font-weight-700"
  }, [_vm._v("stripe")])])], 1)])]), _vm._v(" "), _c('v-icon', {
    staticClass: "material-icons icon icon-close cursor-pointer icon--x-large",
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("\n          close\n        ")])], 1)])]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "bg-grey-white upgrade-plan-dialog",
      "fullscreen": ""
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.closeSuccessDialog($event)
      }
    },
    model: {
      value: (_vm.successDialog),
      callback: function($$v) {
        _vm.successDialog = $$v
      },
      expression: "successDialog"
    }
  }, [_c('v-icon', {
    staticClass: "material-icons icon icon-close cursor-pointer icon--x-large",
    on: {
      "click": _vm.closeSuccessDialog
    }
  }, [_vm._v("\n      close\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "bg-grey-white h-100 w-100 display-flex justify-center align-center"
  }, [_c('div', {
    staticClass: "success-dialog-content"
  }, [_c('div', {
    staticClass: "bg-white success__content mt-5 font-poppins display-flex flex-column align-center justify-center"
  }, [_c('img', {
    staticClass: "mb-5 text-center w-100 logo-img",
    attrs: {
      "src": __webpack_require__(44),
      "aspect-ratio": "1",
      "height": "24",
      "width": "124"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "user-img",
    attrs: {
      "src": "/static/images/user.png",
      "aspect-ratio": "1",
      "height": "150",
      "width": "150"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "thank-you-text text-24 font-weight-700"
  }, [_vm._v("Thank you,")]), _vm._v(" "), _c('div', {
    staticClass: "thank-you-text text-24 font-weight-700 display-flex align-center"
  }, [(_vm.currentUser) ? _c('span', [_vm._v(_vm._s(_vm.currentUser.first_name))]) : _vm._e(), _vm._v(" "), _c('img', {
    staticClass: "check-icon",
    attrs: {
      "src": "/static/images/ic_circle_check.svg",
      "aspect-ratio": "1",
      "height": "15",
      "width": "15"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "my-3 text-16 font-weight-500"
  }, [_vm._v("\n            Your subscription is active!\n          ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "btn-dashboard white--text font-weight-700 text-14 mt-3",
    on: {
      "click": _vm.goToDashboard
    }
  }, [_vm._v("\n            Go to dashboard\n          ")])], 1)])])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "blurb-container"
  }, [_c('div', {
    staticClass: "white--text font-space-grotesk font-weight-500 text-50"
  }, [_vm._v("\n            Go Ad-Free\n            "), _c('br'), _vm._v("\n            Empower Artists\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "max-w-18px d-flex justify-center"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(309),
      "aspect-ratio": "1",
      "height": "18",
      "width": "18"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "max-w-18px d-flex justify-center"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(309),
      "aspect-ratio": "1",
      "height": "18",
      "width": "18"
    }
  })])
}]}

/***/ }),
/* 1686 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "timeline-section"
  }, [_c('div', {
    staticClass: "inner-timeline"
  }, [_c('h3', {
    staticClass: "section-title"
  }, [_vm._v("YouSound Partner Program Timeline")]), _vm._v(" "), _c('div', {
    staticClass: "timeline"
  }, [_c('div', {
    staticClass: "outer"
  }, _vm._l((_vm.timelines), function(timeline, i) {
    return _c('div', {
      key: i,
      staticClass: "card"
    }, [_c('div', {
      staticClass: "timeline-content"
    }, [_c('h3', {
      staticClass: "title"
    }, [_vm._v(_vm._s(timeline.date))]), _vm._v(" "), _c('p', {
      staticClass: "subtitle"
    }, [_vm._v(_vm._s(timeline.title))]), _vm._v(" "), _vm._l((timeline.text), function(content, n) {
      return _c('p', {
        key: n,
        staticClass: "content"
      }, [_vm._v("\n              " + _vm._s(content) + "\n            ")])
    })], 2)])
  }))])])])
},staticRenderFns: []}

/***/ }),
/* 1687 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page terms-page",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('div', {
    staticClass: "content-page"
  }, [_c('v-navigation-drawer', {
    attrs: {
      "permanent": "",
      "fixed": "",
      "height": "100vh"
    }
  }, [_c('div', {
    staticClass: "page-title"
  }), _vm._v(" "), _c('v-list', _vm._l((_vm.tabs), function(t) {
    return _c('v-list-tile', {
      key: t.id,
      class: {
        active: t.id == _vm.active_tab
      },
      attrs: {
        "href": ("#" + (t.id))
      },
      nativeOn: {
        "click": function($event) {
          _vm.onTab(t.id)
        }
      }
    }, [_c('v-list-tile-title', [_vm._v(_vm._s(t.title))])], 1)
  }))], 1), _vm._v(" "), (_vm.active_tab == 'team') ? _c('team-tab') : (_vm.active_tab == 'product') ? _c('product-tab') : (_vm.active_tab == 'timeline') ? _c('timeline-tab') : (_vm.active_tab == 'success') ? _c('success-tab') : (_vm.active_tab == 'opportunity') ? _c('opportunity-tab') : (_vm.active_tab == 'features') ? _c('features-tab') : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 1688 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "learn-more",
    class: {
      onMobile: _vm.onMobile
    }
  }, [(!_vm.onMobile) ? _c('content-top-header', {
    attrs: {
      "absolute": ""
    }
  }, [_c('template', {
    slot: "topHeader"
  }, [_c('ul', {
    staticClass: "pr-3"
  }, [_c('li', [_c('h2', [_vm._v("Learn More")])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _vm._l((_vm.tabs), function(tab) {
    return _c('li', {
      key: tab.id,
      staticClass: "nav-li",
      class: [{
          'active tab-active': _vm.isActiveTab(tab.id)
        },
        ("nav-" + (tab.id)) ],
      attrs: {
        "href": ("#" + (tab.id))
      }
    }, [_c('label', {
      staticClass: "nav-label",
      on: {
        "click": function($event) {
          _vm.onTab(tab.id)
        }
      }
    }, [(tab.icon) ? _c('img', {
      staticClass: "li-icon",
      attrs: {
        "src": tab.icon,
        "width": "18"
      }
    }) : _vm._e(), _vm._v("\n              " + _vm._s(tab.title) + "\n            ")])])
  })], 2)])], 2) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.activeTab === 'listener') ? _c('div', {
    staticClass: "learn-more-body _listener",
    class: {
      onMobile: _vm.onMobile
    }
  }, [_c('v-container', {
    staticClass: "mt-5 pt-5",
    attrs: {
      "fluid": "",
      "grid-list-lg": ""
    }
  }, [_c('v-layout', {
    class: {
      '': _vm.onMobile
    },
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "justify-space-between": "",
      "my-6": "",
      "layer-layout": ""
    }
  }, [_c('v-flex', {
    staticClass: "content-space-left",
    attrs: {
      "xs12": "",
      "sm6": "",
      "context-layer": ""
    }
  }, [_c('div', {
    staticClass: "tile-context"
  }, [_c('h1', {
    staticClass: "_title"
  }, [_vm._v("Listen, watch &"), _c('br'), _vm._v(" shop")]), _vm._v(" "), _c('div', {
    staticClass: "_subtitle"
  }, [_vm._v("\n                  Stream albums, videos & live events. "), _c('br'), _vm._v("\n                  Shop artists & brands, creators keep "), _c('br'), _vm._v("\n                  100%. Build collections, playlists & "), _c('br'), _vm._v("\n                  shopping lists.\n                ")])])]), _vm._v(" "), _c('v-flex', {
    class: [_vm.pageMode ? 'sm6' : 'sm6'],
    attrs: {
      "xs12": "",
      "tiles-layer": ""
    }
  }, [_c('div', {
    staticClass: "fullwidht-right"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1469),
      "width": "100%"
    }
  })])])], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-lg": ""
    }
  }, [_c('v-layout', {
    class: {
      'flex-wrap-reverse': _vm.onMobile
    },
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "justify-space-between": "",
      "my-6": "",
      "layer-layout": ""
    }
  }, [_c('v-flex', {
    class: [_vm.pageMode ? 'sm6' : 'sm5'],
    attrs: {
      "xs12": "",
      "tiles-layer": ""
    }
  }, [_c('div', {
    staticClass: "single-tile-3 fullwidht-left"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1470),
      "width": "90%"
    }
  })])]), _vm._v(" "), _c('v-flex', {
    staticClass: "content-space-right pattern-bg-right",
    class: [_vm.pageMode ? 'sm6' : 'sm6'],
    attrs: {
      "xs12": "",
      "context-layer": ""
    }
  }, [_c('div', {
    staticClass: "tile-context"
  }, [_c('h1', {
    staticClass: "_title"
  }, [_vm._v("Organic music "), _c('br'), _vm._v(" discovery")]), _vm._v(" "), _c('div', {
    staticClass: "_subtitle"
  }, [_vm._v("\n                  YouSound’s algorithm is chronological "), _c('br'), _vm._v("\n                  allowing everything to be discovered. "), _c('br'), _vm._v("\n                  Each creator is verified to ensure high "), _c('br'), _vm._v("\n                  quality content & less saturation.\n                ")])])])], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-lg": ""
    }
  }, [_c('v-layout', {
    class: {
      '': _vm.onMobile
    },
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "justify-space-between": "",
      "my-6": "",
      "layer-layout": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "context-layer": ""
    }
  }, [_c('div', {
    staticClass: "tile-context text-left"
  }, [_c('h1', {
    staticClass: "_title"
  }, [_vm._v("Streaming payouts"), _c('br'), _vm._v(" reinvented")]), _vm._v(" "), _c('div', {
    staticClass: "_subtitle"
  }, [_vm._v("\n                  Subscribers share up to 50% of their "), _c('br'), _vm._v("\n                  payment to the top 10 creators they stream "), _c('br'), _vm._v("\n                  each month & can see exactly where their "), _c('br'), _vm._v("\n                  money goes.\n                ")])])]), _vm._v(" "), _c('v-flex', {
    class: [_vm.pageMode ? 'sm6' : 'sm6'],
    attrs: {
      "xs12": "",
      "tiles-layer": ""
    }
  }, [_c('div', [_c('img', {
    attrs: {
      "src": __webpack_require__(1471),
      "width": "100%"
    }
  })])])], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-lg": ""
    }
  }, [_c('v-layout', {
    class: {
      'flex-wrap-reverse': _vm.onMobile
    },
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "justify-space-between": "",
      "my-6": "",
      "layer-layout": ""
    }
  }, [_c('v-flex', {
    class: [_vm.pageMode ? 'sm6' : 'sm5'],
    attrs: {
      "xs12": "",
      "tiles-layer": ""
    }
  }, [_c('div', {
    staticClass: "single-tile-3"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1472),
      "width": "90%"
    }
  })])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pattern-bg-right",
    class: [_vm.pageMode ? 'sm6' : 'sm6'],
    attrs: {
      "xs12": "",
      "context-layer": ""
    }
  }, [_c('div', {
    staticClass: "tile-context"
  }, [_c('h1', {
    staticClass: "_title"
  }, [_vm._v("Join & build "), _c('br'), _vm._v(" memberships")]), _vm._v(" "), _c('div', {
    staticClass: "_subtitle"
  }, [_vm._v("\n                  Support your favorite creators by joining "), _c('br'), _vm._v("\n                  their memberships & gaining access to "), _c('br'), _vm._v("\n                  exclusive content & discussion forums.\n                ")])])])], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-lg": ""
    }
  }, [_c('v-layout', {
    class: {
      '': _vm.onMobile
    },
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "justify-space-between": "",
      "my-6": "",
      "layer-layout": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "context-layer": ""
    }
  }, [_c('div', {
    staticClass: "tile-context"
  }, [_c('h1', {
    staticClass: "_title"
  }, [_vm._v("Share "), _c('br'), _vm._v(" & get paid")]), _vm._v(" "), _c('div', {
    staticClass: "_subtitle"
  }, [_vm._v("\n                  Earn $2/month for a year from each "), _c('br'), _vm._v("\n                  person that subscribes through your "), _c('br'), _vm._v("\n                  shared albums, videos, products & "), _c('br'), _vm._v("\n                  playlists.\n                ")])])]), _vm._v(" "), _c('v-flex', {
    class: [_vm.pageMode ? 'sm6' : 'sm6'],
    attrs: {
      "xs12": "",
      "tiles-layer": ""
    }
  }, [_c('div', [_c('img', {
    attrs: {
      "src": __webpack_require__(1468),
      "width": "100%"
    }
  })])])], 1)], 1)], 1) : _vm._e()]), _vm._v(" "), (!_vm.hideFooter) ? _c('hr', {
    staticClass: "light mt-5 mb-3"
  }) : _vm._e(), _vm._v(" "), (!_vm.hideFooter) ? _c('div', {
    staticClass: "learn-more-footer"
  }, [_c('h2', {
    staticClass: "_title"
  }, [_vm._v("\n        Join the community.\n        "), _c('br'), _vm._v("\n        Download the app.\n      ")]), _vm._v(" "), (_vm.onMobile) ? _c('app-footer', {
    attrs: {
      "hideDownload": ""
    }
  }) : _vm._e()], 1) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 1689 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "select-user-section",
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-flex', {
    staticClass: "dismiss-section",
    attrs: {
      "xs12": "",
      "sm12": ""
    },
    on: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "popup-section",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "title-section",
    attrs: {
      "xs12": ""
    }
  }, [_c('h2', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('v-flex', {
    staticClass: "search-section",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "search-box"
  }, [_c('div', {
    staticClass: "search-container"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('svg', {
    attrs: {
      "width": "20px",
      "height": "20px",
      "viewBox": "0 0 28 28",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("Group 22")]), _vm._v(" "), _c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Design",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "searchIcon",
      "transform": "translate(-732.000000, -61.000000)",
      "stroke": "#FFFFFF",
      "stroke-width": "1.5999999"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group-29",
      "transform": "translate(710.000000, 50.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group-22",
      "transform": "translate(23.000000, 12.000000)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "Oval-2",
      "cx": "11.375",
      "cy": "11.375",
      "r": "11.375"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M19.5,19.5 L25.59375,25.59375",
      "id": "Line",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])])])])])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    staticClass: "search-field",
    attrs: {
      "type": "search",
      "id": "search",
      "placeholder": "Search"
    },
    domProps: {
      "value": (_vm.keyword)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.loadUsers()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value
      }
    }
  })])])])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "list-section",
    attrs: {
      "xs12": ""
    }
  }, _vm._l((_vm.filtered_users), function(user, index) {
    return _c('v-flex', {
      key: index,
      staticClass: "user-item",
      attrs: {
        "xs12": ""
      },
      on: {
        "click": function($event) {
          if ($event.target !== $event.currentTarget) { return null; }
          _vm.onSelectUser(user)
        }
      }
    }, [_c('router-link', {
      attrs: {
        "to": '/' + user.slug
      }
    }, [_c('div', {
      staticClass: "avatar-image",
      style: ({
        'background-image': 'url(' + user.avatar.thumb.url + ')',
      })
    })]), _vm._v(" "), _c('label', {
      staticClass: "user-name",
      on: {
        "click": function($event) {
          _vm.onSelectUser(user)
        }
      }
    }, [_vm._v("\n          " + _vm._s(user.username) + "\n          "), (user.user_type == 'artist') ? _c('v-icon', {
      staticClass: "user-status",
      class: {
        online: user.status == 'active'
      }
    }, [_vm._v("fa-check-circle")]) : _vm._e()], 1)], 1)
  }))], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1690 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mobile-header header-container"
  }, [(!_vm.isModalComp) ? _c('div', {
    staticClass: "header-wrapper dflex justify-space-between align-center width100",
    class: {
      'no-modalComp': !_vm.isModalComp
    }
  }, [_c('div', {
    staticClass: "_inner-wrapper _left"
  }, [(_vm.showGoBack) ? _c('v-icon', {
    staticClass: "go-back mr-3",
    attrs: {
      "color": "black"
    },
    on: {
      "click": function($event) {
        _vm.goBack()
      }
    }
  }, [_vm._v("\n        arrow_back_ios\n      ")]) : _vm._e(), _vm._v(" "), (_vm.isAuthenticated) ? _c('img', {
    attrs: {
      "src": _vm.leftAltIcon
    },
    on: {
      "click": _vm.openSearchModal
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "_inner-wrapper _center"
  }, [_c('img', {
    attrs: {
      "src": _vm.centerImg
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: _vm.isAuthenticated ? 'AlbumIndex' : 'Home'
        })
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_inner-wrapper _right"
  }, [(_vm.showRightAltIcon) ? _c('span', {
    on: {
      "click": function($event) {
        _vm.openMusicPlayer()
      }
    }
  }, [(_vm.isPlaying) ? _c('img', {
    staticClass: "right-alt-icon mt-1",
    attrs: {
      "src": __webpack_require__(1562),
      "width": "25"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isPlaying) ? _c('img', {
    staticClass: "right-alt-icon",
    attrs: {
      "src": _vm.rightAltIcon,
      "width": "30"
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.hideUser && _vm.isAuthenticated && !_vm.onProfilePage) ? _c('user-tag', {
    class: {
      'ml-3': _vm.showRightAltIcon
    },
    attrs: {
      "user": _vm.currentUser,
      "hideTick": "",
      "showAvatar": "",
      "hideName": "",
      "width": _vm.avatarWidth,
      "height": _vm.avatarHeight
    }
  }) : _vm._e()], 1)]) : _c('div', {
    staticClass: "header-wrapper dflex justify-space-between align-center width100",
    class: {
      isModalComp: _vm.isModalComp
    }
  }, [_c('div', {
    staticClass: "_inner-wrapper _left"
  }, [(_vm.showModalCompLeftIcon) ? _c('img', {
    attrs: {
      "src": _vm.leftAltIcon
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "_inner-wrapper _center ml-0"
  }, [_c('img', {
    attrs: {
      "src": _vm.appLogo
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: _vm.isAuthenticated ? 'AlbumIndex' : 'Home'
        })
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_inner-wrapper _right"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(223),
      "width": "18"
    },
    on: {
      "click": function($event) {
        _vm.goBack()
      }
    }
  })])]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "content-class": "search-dialog",
      "background-color": "red",
      "transition": "slide-up"
    },
    model: {
      value: (_vm.searchModalActive),
      callback: function($$v) {
        _vm.searchModalActive = $$v
      },
      expression: "searchModalActive"
    }
  }, [_c('search', {
    ref: "searchRef",
    on: {
      "closeSearchModal": _vm.closeSearchModal
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1691 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "album-card"
  }, [(_vm.isShowPromoteModal) ? _c('promote-modal', {
    attrs: {
      "item": _vm.album,
      "dismiss": _vm.dismissPromoteDialog,
      "success": _vm.saveAndFinish
    }
  }) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "album-info",
    attrs: {
      "xs12": "",
      "pa-0": ""
    }
  }, [_c('v-flex', {
    staticClass: "album-cover",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "album-image",
    style: ({
      'background-image': 'url(' + _vm.album.cover.url + ')'
    })
  }), _vm._v(" "), _c('v-flex', {
    staticClass: "album-actions",
    attrs: {
      "xs12": ""
    }
  }, [_c('router-link', {
    attrs: {
      "to": ("/" + (_vm.album.album_type) + "/" + (_vm.album.slug))
    }
  }, [_c('v-flex', {
    staticClass: "touch-flex",
    attrs: {
      "xs12": ""
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "full-height",
    attrs: {
      "xs12": "",
      "pt-2": ""
    }
  }, [(_vm.acceptButtonFunc) ? [_c('div', {
    staticClass: "label-user-avatar",
    style: (("background-image: url(" + (_vm.user.avatar.url) + ")"))
  }), _vm._v(" "), _c('div', {
    staticClass: "label-username"
  }, [_vm._v(_vm._s(_vm.user.username))]), _vm._v(" "), _c('div', {
    staticClass: "label-description"
  }, [_vm._v("\n              wants to add this album to their catalog\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "label-actions-section"
  }, [_c('v-btn', {
    staticClass: "action-btn accept",
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.acceptButtonFunc(_vm.album, _vm.user)
      }
    }
  }, [_vm._v("Accept")]), _vm._v(" "), _c('v-btn', {
    staticClass: "action-btn deny",
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.denyButtonFunc(_vm.album, _vm.user)
      }
    }
  }, [_vm._v("Deny")])], 1)] : [(_vm.status && _vm.status != '') ? _c('v-btn', {
    staticClass: "action-btn",
    attrs: {
      "dark": ""
    }
  }, [_vm._v(_vm._s(_vm.status))]) : _vm._e(), _vm._v(" "), (_vm.deleteButtonFunc) ? _c('v-btn', {
    staticClass: "action-btn",
    class: _vm.deleteButtonClass,
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.deleteButtonFunc(_vm.album, _vm.user)
      }
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.deleteButtonText)
    }
  })]) : _vm._e()]], 2), _vm._v(" "), (!_vm.acceptButtonFunc && _vm.album.tracks) ? _c('p', {
    staticClass: "album-count"
  }, [_vm._v("\n          " + _vm._s(_vm.album.tracks) + " tracks\n        ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "album-detail",
    attrs: {
      "xs12": "",
      "pa-0": ""
    }
  }, [_c('p', {
    staticClass: "album-name"
  }, [_vm._v(_vm._s(_vm.album.name))]), _vm._v(" "), _c('p', {
    staticClass: "album-posted-date"
  }, [_vm._v("2 months")])])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1692 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box",
    class: {
      'side-tab-view': _vm.sideTabView,
      onMobile: _vm.onMobile
    }
  }, [_c('div', {
    staticClass: "box__content",
    class: {
      'cursor-pointer': !_vm.hoverOverlay
    },
    on: {
      "click": function($event) {
        !_vm.hoverOverlay && _vm.currentUser != null ? _vm.$router.push(("/video/" + (_vm.item.id) + "/show")) : _vm.fetchSpotlightVideo()
      }
    }
  }, [(_vm.durationTag && !_vm.coverOnly) ? _c('span', {
    staticClass: "duration__tag"
  }, [_vm._v(_vm._s(_vm.durationTag))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box__image",
    class: {
      coverRadius: _vm.coverRadius
    },
    style: (("background-image: url(" + (_vm._.get(_vm.item, 'cover.url')) + ")"))
  }, [(_vm.showFullOverlay) ? _c('div', {
    staticClass: "full-overlay"
  }, [_c('v-icon', {
    staticClass: "full-overlay_icon icon play-button-2 iconHasWhiteBG black--text"
  }, [_vm._v("play_arrow")]), _vm._v(" "), _c('div', {
    staticClass: "hover-info"
  }, [_c('div', {
    staticClass: "item-name"
  }, [_vm._v(_vm._s(_vm.item.name))]), _vm._v(" "), _c('div', {
    staticClass: "artist-name"
  }, [_vm._v(_vm._s(_vm.item.user.username))])])], 1) : _vm._e()]), _vm._v(" "), (_vm.isLive) ? _c('div', {
    staticClass: "box__caption"
  }, [_vm._v("Live")]) : _vm._e(), _vm._v(" "), (_vm.hoverOverlay) ? _c('div', {
    staticClass: "box__overlay"
  }, [_c('v-btn', {
    staticClass: "box__cta",
    attrs: {
      "block": "",
      "dark": "",
      "to": ("/video/" + (_vm.item.id) + "/show")
    }
  }, [_vm._v("Watch Now")])], 1) : _vm._e()]), _vm._v(" "), (!_vm.coverOnly) ? _c('div', {
    staticClass: "box__footer dflex align-start",
    class: {
      'px-2': _vm.onMobile
    }
  }, [(!_vm.hideUser) ? _c('user-tag', {
    attrs: {
      "showAvatar": "",
      "hideName": "",
      "hideTick": "",
      "width": "40",
      "height": "40",
      "user": _vm.item.user
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box_subtitle-wrapper",
    class: {
      'dgrid': _vm.sideTabView
    }
  }, [_c('div', {
    staticClass: "box__subtitle"
  }, [(_vm.item.accounts.length > 0) ? _c('span', {
    staticClass: "box__acc-wrapper"
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "stream_name"
  }, [_vm._v(_vm._s(_vm.item.name))]), _vm._v(" "), (_vm.showUsername) ? _c('div', {
    staticClass: "user_name"
  }, [_c('b', {
    staticClass: "text-capitalize"
  }, [_vm._v(_vm._s(_vm.item.user.username))])]) : _vm._e()]), _vm._v(" "), (!_vm.noMeta) ? _c('div', {
    staticClass: "box__title"
  }, [_c('div', {
    staticClass: "box__author"
  }), _vm._v(" "), _c('div', {
    staticClass: "box__views__duration_wrapper dflex align-center"
  }, [(_vm.showViews) ? _c('span', {
    staticClass: "box__views mr-2"
  }, [_vm._v("0 views")]) : _vm._e(), _vm._v(" "), (!_vm.hideFreeTag && _vm.isVideoFree && !_vm.sideTabView) ? _c('span', {
    staticClass: "user-name"
  }, [_vm._v("\n            " + _vm._s(_vm.item.user.username) + "\n          ")]) : _vm._e()])]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.altMeta) ? _c('div', {
    staticClass: "mt-2 box__footer alt-meta",
    class: {
      'px-2': _vm.onMobile
    }
  }, [_c('div', {
    staticClass: "alt-meta-name"
  }, [_vm._v(_vm._s(_vm.item.name))]), _vm._v(" "), _c('div', {
    staticClass: "alt-meta-user"
  }, [_c('b', {
    staticClass: "text-capitalize"
  }, [_vm._v(_vm._s(_vm.item.user.username))])])]) : _vm._e(), _vm._v(" "), (_vm.forCollection || _vm.playlistId) ? _c('v-menu', {
    staticClass: "track-menu",
    attrs: {
      "offset-y": "",
      "close-on-content-click": false,
      "nudge-width": 100
    }
  }, [_c('v-btn', {
    staticClass: "toolbar-btn",
    attrs: {
      "slot": "activator",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.is_menu_hover = true
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("more_horiz")])], 1), _vm._v(" "), _c('v-card', [_c('v-list', [_c('v-list-tile', {
    key: "remove",
    staticClass: "default-menu-item track-menu-item",
    nativeOn: {
      "click": function($event) {
        _vm.openRemoveFromCollectionModal()
      }
    }
  }, [_c('v-list-tile-title', [_c('div', {
    staticClass: "menu-list-item dflex align-center"
  }, [_c('label', {
    staticClass: "ml-0 black--text"
  }, [_vm._v("Remove")])])])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "dialog-w_auto dialog-no_shadow"
    },
    model: {
      value: (_vm.show_modalCard1),
      callback: function($$v) {
        _vm.show_modalCard1 = $$v
      },
      expression: "show_modalCard1"
    }
  }, [_c('div', {
    staticClass: "modal-card"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": __webpack_require__(19),
      "width": "135px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-card-img"
  }, [_c('div', {
    staticClass: "modal-card-img-inner",
    style: ({
      'background-image': 'url(' + _vm.item.user.avatar.thumb.url + ')',
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center user-box"
  }, [_c('p', [_vm._v("Sign up to experience")]), _vm._v(" "), _c('div', {
    staticClass: "user-div"
  }, [_c('p', {
    staticClass: "user-text"
  }, [_vm._v(" " + _vm._s(_vm.item.user.username))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(23),
      "width": "15px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "button-wrapper"
  }, [_c('router-link', {
    attrs: {
      "to": "/signup"
    }
  }, [_c('button', {
    staticClass: "modal-button"
  }, [_vm._v("\n            Create account\n          ")])])], 1)])]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "dialog-w_auto dialog-no_shadow"
    },
    model: {
      value: (_vm.show_modalCard2),
      callback: function($$v) {
        _vm.show_modalCard2 = $$v
      },
      expression: "show_modalCard2"
    }
  }, [_c('div', {
    staticClass: "modal-card"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": __webpack_require__(19),
      "width": "135px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-card-img"
  }, [_c('div', {
    staticClass: "modal-card-img-inner",
    style: ({
      'background-image': 'url(' + _vm.item.user.avatar.thumb.url + ')',
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center user-box"
  }, [_c('p', [_vm._v("Sign up to experience")]), _vm._v(" "), _c('div', {
    staticClass: "user-div"
  }, [_c('p', {
    staticClass: "user-text"
  }, [_vm._v(" " + _vm._s(_vm.item.user.username))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(23),
      "width": "15px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "text-center font-inter"
  }, [_c('p', [_vm._v("Get full access. "), _c('b', [_vm._v("50%")]), _vm._v(" of your subscription is shared with creators you stream most. See who you support!")])]), _vm._v(" "), _c('div', {
    staticClass: "button-wrapper"
  }, [_c('router-link', {
    attrs: {
      "to": "/settings"
    }
  }, [_c('button', {
    staticClass: "modal-button"
  }, [_vm._v("\n            Start 30 day free trial\n          ")])])], 1)])]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "dialog-w_50 dialog-no_shadow"
    },
    model: {
      value: (_vm.show_modalCard3),
      callback: function($$v) {
        _vm.show_modalCard3 = $$v
      },
      expression: "show_modalCard3"
    }
  }, [_c('div', {
    staticClass: "modal-card-main"
  }, [_c('div', {
    staticClass: "modal-card-split"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": __webpack_require__(19),
      "width": "135px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-card-img"
  }, [_c('div', {
    staticClass: "modal-card-img-inner",
    style: ({
      'background-image': 'url(' + _vm.item.user.avatar.thumb.url + ')',
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "user-box"
  }, [_c('p', [_vm._v("Sign up to experience")]), _vm._v(" "), _c('div', {
    staticClass: "user-div"
  }, [_c('p', {
    staticClass: "user-text"
  }, [_vm._v(_vm._s(_vm.item.user.username))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(23),
      "width": "15px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "button-wrapper"
  }, [_c('router-link', {
    attrs: {
      "to": "/signup"
    }
  }, [_c('button', {
    staticClass: "modal-button"
  }, [_vm._v("\n              Create account\n            ")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-card-title-img",
    style: (("background-image: url(" + _vm.videoLoading + ")"))
  }, [_c('video', {
    attrs: {
      "playsinline": "",
      "autoplay": "",
      "loop": "",
      "id": "bgvid"
    }
  }, [(_vm.spotlightVideoSource) ? _c('source', {
    attrs: {
      "src": ("https://stream.mux.com/" + _vm.spotlightVideoSource + "/low.mp4"),
      "type": "video/mp4"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "volume-button"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(43),
      "width": "17px"
    }
  })])])])]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "dialog-w_50 dialog-no_shadow"
    },
    model: {
      value: (_vm.show_modalCard4),
      callback: function($$v) {
        _vm.show_modalCard4 = $$v
      },
      expression: "show_modalCard4"
    }
  }, [_c('div', {
    staticClass: "modal-card-main"
  }, [_c('div', {
    staticClass: "modal-card-split"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": __webpack_require__(19),
      "width": "135px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-card-img"
  }, [_c('div', {
    staticClass: "modal-card-img-inner",
    style: ({
      'background-image': 'url(' + _vm.item.user.avatar.thumb.url + ')',
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "user-box"
  }, [_c('p', [_vm._v("Sign up to experience")]), _vm._v(" "), _c('div', {
    staticClass: "user-div"
  }, [_c('p', {
    staticClass: "user-text"
  }, [_vm._v(_vm._s(_vm.item.user.username))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(23),
      "width": "15px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "font-inter"
  }, [_c('p', [_vm._v("Get full access. "), _c('b', [_vm._v("50%")]), _vm._v(" of your subscription is shared with creators you stream most. See who you support!")])]), _vm._v(" "), _c('div', {
    staticClass: "button-wrapper"
  }, [_c('router-link', {
    attrs: {
      "to": "/settings"
    }
  }, [_c('button', {
    staticClass: "modal-button"
  }, [_vm._v("\n              Start 30 day free trial\n            ")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-card-title-img",
    style: (("background-image: url(" + _vm.videoLoading + ")"))
  }, [_c('video', {
    attrs: {
      "playsinline": "",
      "autoplay": "",
      "loop": "",
      "id": "bgvid"
    }
  }, [(_vm.spotlightVideoSource) ? _c('source', {
    attrs: {
      "src": ("https://stream.mux.com/" + _vm.spotlightVideoSource + "/low.mp4"),
      "type": "video/mp4"
    }
  }) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "volume-button"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(43),
      "width": "17px"
    }
  })])])])]), _vm._v(" "), (_vm.forCollection) ? _c('v-dialog', {
    attrs: {
      "content-class": "invite-dialog",
      "width": "440"
    },
    model: {
      value: (_vm.show_remove_from_collection_modal),
      callback: function($$v) {
        _vm.show_remove_from_collection_modal = $$v
      },
      expression: "show_remove_from_collection_modal"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("\n        Remove from Collection\n      ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n        Are you sure you want to remove video from collection?\n      ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red",
      "dark": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.removeFromCollection()
      }
    }
  }, [_vm._v("Yes")])], 1)], 1)], 1) : (_vm.playlistId) ? _c('v-dialog', {
    attrs: {
      "content-class": "invite-dialog",
      "width": "440"
    },
    model: {
      value: (_vm.show_remove_from_collection_modal),
      callback: function($$v) {
        _vm.show_remove_from_collection_modal = $$v
      },
      expression: "show_remove_from_collection_modal"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("\n        Remove from Playlist\n      ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n        Are you sure you want to remove this video from playlist?\n      ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "black",
      "dark": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.removeFromPlaylist('stream', _vm.item.id, _vm.playlistId);
        _vm.show_remove_from_collection_modal = false
      }
    }
  }, [_vm._v("\n          Yes\n        ")])], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1693 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "scroll",
      rawName: "v-scroll",
      value: (_vm.handleScroll),
      expression: "handleScroll"
    }]
  }, [_c('div', {
    staticClass: "page profile-grid-page mx-5",
    class: {
      onMobile: _vm.onMobile
    }
  }, [(
    !(
      _vm.currentUser &&
      _vm.user.id != _vm.currentUser.id &&
      _vm.user.username != _vm.PublicRelationsUsername
    )
  ) ? _c('content-top-header', {
    staticClass: "border-bottom-x",
    attrs: {
      "height": "auto"
    }
  }, [_c('template', {
    slot: "topHeader"
  }, [_c('ul', {
    staticClass: "user-top-wrapper"
  }, [(_vm.user) ? _c('li', {
    staticClass: "user-profile-section"
  }, [_c('div', {
    staticClass: "user-profile-image-section",
    class: {
      live: _vm.show_stream_live_button
    },
    on: {
      "click": function($event) {
        _vm.show_stream_live_button &&
          !_vm.view_stream_clicked &&
          _vm.viewStream()
      }
    }
  }, [_c('div', {
    staticClass: "user-profile-image-own",
    style: ({
      'background-image': 'url(' + _vm.user.avatar.url + ')',
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "user-info-section"
  }, [_c('div', {
    staticClass: "user-name-section"
  }, [_c('label', {
    staticClass: "display-name-own"
  }, [_vm._v("\n                  " + _vm._s(_vm.user.username) + "\n                  "), (
    ['artist', 'label', 'brand'].indexOf(_vm.user.user_type) >
    -1
  ) ? _c('v-icon', {
    staticClass: "user-status online"
  }, [_vm._v("fa-check-circle")]) : _vm._e()], 1)]), _vm._v(" "), (_vm.followMetaVisible && !_vm.onMobile) ? _c('div', {
    staticClass: "user-status-section mt-0"
  }, [_c('div', {
    staticClass: "follower-count stat-count",
    on: {
      "click": function($event) {
        _vm.onTab('followers')
      }
    }
  }, [_c('strong', {
    staticClass: "_count"
  }, [_vm._v(_vm._s(_vm._f("formatLargeNumber")(_vm.user.followers)))]), _vm._v("\n                  Followers\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "follower-count stat-count",
    on: {
      "click": function($event) {
        _vm.onTab('followings')
      }
    }
  }, [_c('strong', {
    staticClass: "_count"
  }, [_vm._v(_vm._s(_vm.user.followings))]), _vm._v("\n                  Following\n                ")]), _vm._v(" "), (_vm.user.user_type === 'listener' && _vm.user.inviter) ? [_c('div', {
    staticClass: "vertical-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "user-inviter-name"
  }, [_vm._v("\n                    Invited by\n                    "), _c('router-link', {
    attrs: {
      "to": ("/" + (_vm.user.inviter.slug))
    }
  }, [_vm._v(_vm._s(_vm.user.inviter.username))])], 1)] : _vm._e()], 2) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('li', {
    staticClass: "user-action-section"
  }, [_c('v-btn', {
    staticClass: "play-btn",
    nativeOn: {
      "click": function($event) {
        _vm.playSong()
      }
    }
  }, [_c('v-icon', [_vm._v("play_arrow")]), _vm._v(" "), _c('span', [_vm._v("Play")])], 1)], 1), _vm._v(" "), (
    _vm.currentUser &&
    _vm.user.id != _vm.currentUser.id &&
    _vm.user.username != _vm.PublicRelationsUsername
  ) ? [_c('li', [_c('user-follow-btn', {
    attrs: {
      "user": _vm.user,
      "theme": "dark",
      "type": "default",
      "borderRadius": ""
    }
  })], 1), _vm._v(" "), _c('li', [_c('img', {
    staticClass: "message-btn mt-2",
    staticStyle: {
      "opacity": "0.8"
    },
    attrs: {
      "src": __webpack_require__(595),
      "alt": "mail icon",
      "width": "25"
    },
    on: {
      "click": function($event) {
        _vm.showMessageDialog()
      }
    }
  })]), _vm._v(" "), (
    _vm.currentUser &&
    _vm.currentUser.creator_verified &&
    _vm.user.stripe_connected &&
    _vm.user.creator_verified &&
    _vm.user.id != _vm.currentUser.id
  ) ? _c('li', [_c('img', {
    staticClass: "donate-btn mt-2",
    staticStyle: {
      "opacity": "0.8"
    },
    attrs: {
      "src": __webpack_require__(610),
      "alt": "circled dollar icon",
      "width": "25"
    },
    on: {
      "click": function($event) {
        _vm.showLoveDialog()
      }
    }
  })]) : _vm._e()] : _vm._e(), _vm._v(" "), _c('li', [(
    _vm.currentUser &&
    _vm.user.id != _vm.currentUser.id &&
    _vm.user.username != _vm.PublicRelationsUsername
  ) ? _c('v-menu', {
    staticClass: "more-menu",
    attrs: {
      "offset-y": ""
    }
  }, [_c('v-btn', {
    staticClass: "more-btn",
    attrs: {
      "slot": "activator",
      "dark": ""
    },
    slot: "activator"
  }, [_c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("more_horiz")])], 1), _vm._v(" "), _c('v-list', [(_vm.enabledViewDirectMessage) ? _c('v-list-tile', {
    key: "view_direct_messages",
    on: {
      "click": function($event) {
        _vm.viewDirectMessages()
      }
    }
  }, [_c('v-list-tile-title', {
    staticClass: "default-menu-item"
  }, [_c('label', [_vm._v("View Direct Messages")])])], 1) : _vm._e(), _vm._v(" "), (
    _vm.currentUser &&
    _vm.currentUser.creator_verified &&
    _vm.user.id != _vm.currentUser.id &&
    _vm.user.stripe_connected &&
    _vm.user.creator_verified
  ) ? _c('v-list-tile', {
    key: "send_love",
    on: {
      "click": function($event) {
        _vm.showLoveDialog()
      }
    }
  }, [_c('v-list-tile-title', {
    staticClass: "default-menu-item"
  }, [_c('label', [_vm._v("Donate")])])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        _vm.flagUser()
      }
    }
  }, [_c('v-list-tile-title', {
    staticClass: "default-menu-item"
  }, [_c('label', [_vm._v("Flag")])])], 1)], 1)], 1) : _vm._e()], 1)], 2)])], 2) : _vm._e(), _vm._v(" "), (
    _vm.currentUser &&
    _vm.user.id != _vm.currentUser.id &&
    _vm.user.username != _vm.PublicRelationsUsername &&
    !_vm.show_following_scroll
  ) ? _c('content-top-header', {
    attrs: {
      "height": "auto"
    }
  }, [_c('template', {
    slot: "topHeader"
  }, [_c('ul', {
    staticClass: "user-top-wrapper"
  }, [(_vm.user) ? _c('li', {
    staticClass: "user-profile-section"
  }, [_c('div', {
    staticClass: "user-profile-image-section",
    class: {
      live: _vm.show_stream_live_button
    },
    on: {
      "click": function($event) {
        _vm.show_stream_live_button &&
          !_vm.view_stream_clicked &&
          _vm.viewStream()
      }
    }
  }, [_c('div', {
    staticClass: "user-profile-image",
    style: ({
      'background-image': 'url(' + _vm.user.avatar.url + ')',
    })
  }), _vm._v(" "), (_vm.followMetaVisible && _vm.onMobile) ? _c('div', {
    staticClass: "user-status-section mt-2"
  }, [_c('label', {
    staticClass: "follower-count",
    on: {
      "click": function($event) {
        _vm.onTab('followers')
      }
    }
  }, [_c('strong', {
    staticClass: "_count"
  }, [_vm._v(_vm._s(_vm._f("formatLargeNumber")(_vm.user.followers)))]), _vm._v(" "), _c('div', {
    staticClass: "_label"
  }, [_vm._v("Followers")])]), _vm._v(" "), _c('label', {
    staticClass: "vertical-divider"
  }), _vm._v(" "), _c('label', {
    staticClass: "follower-count",
    on: {
      "click": function($event) {
        _vm.onTab('followings')
      }
    }
  }, [_c('strong', {
    staticClass: "_count"
  }, [_vm._v(_vm._s(_vm._f("formatLargeNumber")(_vm.user.followings)))]), _vm._v(" "), _c('div', {
    staticClass: "_label"
  }, [_vm._v("Following")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "live-btn"
  }, [_vm._v("Live")])]), _vm._v(" "), _c('div', {
    staticClass: "user-info-section"
  }, [_c('div', {
    staticClass: "user-name-section"
  }, [_c('span', {
    staticClass: "user-role"
  }, [_vm._v(_vm._s(_vm.user.user_type))]), _vm._v(" "), _c('div', {
    staticClass: "display-name"
  }, [_vm._v("\n                  " + _vm._s(_vm.user.username) + "\n                  "), (
    ['artist', 'label', 'brand'].indexOf(_vm.user.user_type) >
    -1
  ) ? _c('v-icon', {
    staticClass: "user-status online"
  }, [_vm._v("fa-check-circle")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "user-following-section"
  }, [_c('div', {
    staticClass: "dflex align-center"
  }, [(
    _vm.currentUser &&
    _vm.user.id != _vm.currentUser.id &&
    _vm.user.username != _vm.PublicRelationsUsername
  ) ? [_c('div', [_c('user-follow-btn', {
    attrs: {
      "user": _vm.user,
      "theme": "blue",
      "type": "default",
      "borderRadius": ""
    }
  })], 1), _vm._v(" "), _c('div', [(_vm.user.membership_tiers) ? _c('v-btn', {
    staticClass: "member-btn",
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.showMembershipDialog()
      }
    }
  }, [_c('v-icon', [_vm._v("lock")]), _vm._v("\n                        Members\n                      ")], 1) : _vm._e()], 1)] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ml-2"
  }, [(
    _vm.currentUser &&
    _vm.user.id != _vm.currentUser.id &&
    _vm.user.username != _vm.PublicRelationsUsername
  ) ? _c('v-menu', {
    staticClass: "more-menu",
    attrs: {
      "offset-y": ""
    }
  }, [_c('v-btn', {
    staticClass: "more-btn",
    attrs: {
      "slot": "activator",
      "dark": ""
    },
    slot: "activator"
  }, [_c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("more_horiz")])], 1), _vm._v(" "), _c('v-list', [(_vm.enabledViewDirectMessage) ? _c('v-list-tile', {
    key: "view_direct_messages",
    on: {
      "click": function($event) {
        _vm.viewDirectMessages()
      }
    }
  }, [_c('v-list-tile-title', {
    staticClass: "default-menu-item"
  }, [_c('label', [_vm._v("View Direct Messages")])])], 1) : _vm._e(), _vm._v(" "), (
    _vm.currentUser &&
    _vm.currentUser.creator_verified &&
    _vm.user.id != _vm.currentUser.id &&
    _vm.user.stripe_connected &&
    _vm.user.creator_verified
  ) ? _c('v-list-tile', {
    key: "send_love",
    on: {
      "click": function($event) {
        _vm.showLoveDialog()
      }
    }
  }, [_c('v-list-tile-title', {
    staticClass: "default-menu-item"
  }, [_c('label', [_vm._v("Donate")])])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-title', {
    staticClass: "default-menu-item"
  }, [_c('div', {
    staticClass: "dlfex align-center menu-list-div px-2"
  }, [_c('img', {
    staticClass: "mr-2",
    attrs: {
      "src": __webpack_require__(596),
      "width": "12"
    }
  }), _vm._v(" "), _c('label', [_vm._v("Message")])])])], 1), _vm._v(" "), _c('v-list-tile'), _vm._v(" "), _c('v-list-tile', {
    key: "block",
    on: {
      "click": function($event) {
        _vm.openBlockUserConfirmDialog()
      }
    }
  }, [_c('v-list-tile-title', {
    staticClass: "default-menu-item"
  }, [_c('div', {
    staticClass: "dlfex align-center menu-list-div px-2"
  }, [_c('img', {
    staticClass: "mr-2",
    attrs: {
      "src": __webpack_require__(609),
      "width": "12"
    }
  }), _vm._v(" "), _c('label', [_vm._v("Block")])])])], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        _vm.flagUser()
      }
    }
  }, [_c('v-list-tile-title', {
    staticClass: "default-menu-item"
  }, [_c('div', {
    staticClass: "dlfex align-center menu-list-div px-2",
    on: {
      "click": function($event) {
        _vm.flagUser()
      }
    }
  }, [_c('img', {
    staticClass: "mr-2",
    attrs: {
      "src": __webpack_require__(605),
      "width": "12"
    }
  }), _vm._v(" "), _c('label', [_vm._v("Report")])])])], 1)], 1)], 1) : _vm._e()], 1)], 2), _vm._v(" "), (_vm.followMetaVisible && !_vm.onMobile) ? _c('div', {
    staticClass: "user-status-section"
  }, [_c('label', {
    staticClass: "follower-count stat-count",
    on: {
      "click": function($event) {
        _vm.onTab('followers')
      }
    }
  }, [_c('strong', {
    staticClass: "_count"
  }, [_vm._v(_vm._s(_vm._f("formatLargeNumber")(_vm.user.followers)))]), _vm._v("\n                    Followers")]), _vm._v(" "), _c('label', {
    staticClass: "follower-count stat-count",
    on: {
      "click": function($event) {
        _vm.onTab('followings')
      }
    }
  }, [_c('strong', {
    staticClass: "_count"
  }, [_vm._v(_vm._s(_vm.user.followings))]), _vm._v("\n                    Following")]), _vm._v(" "), (_vm.user.user_type === 'listener' && _vm.user.inviter) ? [_c('label', {
    staticClass: "vertical-divider"
  }), _vm._v(" "), _c('label', {
    staticClass: "user-inviter-name"
  }, [_vm._v("\n                      Invited by\n                      "), _c('router-link', {
    attrs: {
      "to": ("/" + (_vm.user.inviter.slug))
    }
  }, [_vm._v(_vm._s(_vm.user.inviter.username))])], 1)] : _vm._e()], 2) : _vm._e()])])]) : _vm._e()])])], 2) : _vm._e(), _vm._v(" "), (
    _vm.currentUser &&
    _vm.user.id != _vm.currentUser.id &&
    _vm.user.username != _vm.PublicRelationsUsername &&
    _vm.show_following_scroll
  ) ? _c('content-top-header', {
    staticClass: "special-scroll-header",
    attrs: {
      "height": "auto"
    }
  }, [_c('template', {
    slot: "topHeader"
  }, [_c('ul', {
    staticClass: "user-top-wrapper align-center"
  }, [(_vm.user) ? _c('li', [_c('div', {
    staticClass: "dflex align-center"
  }, [_c('div', {
    staticClass: "user-profile-section my-0"
  }, [_c('div', {
    staticClass: "user-profile-image-section mr-3",
    class: {
      live: _vm.show_stream_live_button
    },
    on: {
      "click": function($event) {
        _vm.show_stream_live_button &&
          !_vm.view_stream_clicked &&
          _vm.viewStream()
      }
    }
  }, [_c('div', {
    staticClass: "user-profile-image small-img",
    style: ({
      'background-image': 'url(' + _vm.user.avatar.url + ')',
    })
  }), _vm._v(" "), (_vm.followMetaVisible && _vm.onMobile) ? _c('div', {
    staticClass: "user-status-section mt-2"
  }, [_c('label', {
    staticClass: "follower-count",
    on: {
      "click": function($event) {
        _vm.onTab('followers')
      }
    }
  }, [_c('strong', {
    staticClass: "_count"
  }, [_vm._v(_vm._s(_vm._f("formatLargeNumber")(_vm.user.followers)))]), _vm._v(" "), _c('div', {
    staticClass: "_label"
  }, [_vm._v("Followers")])]), _vm._v(" "), _c('label', {
    staticClass: "vertical-divider"
  }), _vm._v(" "), _c('label', {
    staticClass: "follower-count",
    on: {
      "click": function($event) {
        _vm.onTab('followings')
      }
    }
  }, [_c('strong', {
    staticClass: "_count"
  }, [_vm._v(_vm._s(_vm._f("formatLargeNumber")(_vm.user.followings)))]), _vm._v(" "), _c('div', {
    staticClass: "_label"
  }, [_vm._v("Following")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "live-btn"
  }, [_vm._v("Live")])]), _vm._v(" "), _c('div', {
    staticClass: "user-info-section"
  }, [_c('div', {
    staticClass: "user-name-section small-text"
  }, [_c('div', {
    staticClass: "display-name "
  }, [_vm._v("\n                      " + _vm._s(_vm.user.username) + "\n                      "), (
    ['artist', 'label', 'brand'].indexOf(_vm.user.user_type) >
    -1
  ) ? _c('v-icon', {
    staticClass: "user-status online"
  }, [_vm._v("fa-check-circle")]) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "ml-4"
  }, [_c('ul', {
    staticClass: "width100"
  }, [_vm._l((_vm.tabs), function(tab) {
    return [(_vm.isAvailableForGridView(tab)) ? _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (['followings', 'followers'].indexOf(tab.id) == -1),
        expression: "['followings', 'followers'].indexOf(tab.id) == -1"
      }],
      key: tab.id,
      staticClass: "nav-li",
      class: [{
          'active tab-active': _vm.isActiveTab(tab.id)
        },
        ("nav-" + (tab.id)) ],
      attrs: {
        "href": ("#" + (tab.id))
      }
    }, [_c('label', {
      staticClass: "nav-label",
      on: {
        "click": function($event) {
          _vm.onTab(tab.id)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(tab.title) + "\n                      ")])]) : _vm._e()]
  })], 2)])])]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "dflex align-center"
  }, [(_vm.followMetaVisible && !_vm.onMobile) ? _c('div', {
    staticClass: "user-status-section"
  }, [_c('label', {
    staticClass: "follower-count stat-count",
    on: {
      "click": function($event) {
        _vm.onTab('followers')
      }
    }
  }, [_c('strong', {
    staticClass: "_count"
  }, [_vm._v(_vm._s(_vm._f("formatLargeNumber")(_vm.user.followers)))]), _vm._v("\n                Followers")]), _vm._v(" "), _c('label', {
    staticClass: "follower-count stat-count",
    on: {
      "click": function($event) {
        _vm.onTab('followings')
      }
    }
  }, [_c('strong', {
    staticClass: "_count"
  }, [_vm._v(_vm._s(_vm.user.followings))]), _vm._v("\n                Following")]), _vm._v(" "), _c('label', {
    staticClass: "follower-count stat-count"
  }, [_c('strong', {
    staticClass: "_count"
  }, [_vm._v(_vm._s(_vm._f("formatLargeNumber")(_vm.smsCount)))]), _vm._v("\n                SMS\n              ")]), _vm._v(" "), (_vm.user.user_type === 'listener' && _vm.user.inviter) ? [_c('label', {
    staticClass: "vertical-divider"
  }), _vm._v(" "), _c('label', {
    staticClass: "user-inviter-name"
  }, [_vm._v("\n                  Invited by\n                  "), _c('router-link', {
    attrs: {
      "to": ("/" + (_vm.user.inviter.slug))
    }
  }, [_vm._v(_vm._s(_vm.user.inviter.username))])], 1)] : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mb-2 ml-5"
  }, [_c('div', {
    staticClass: "dflex align-center mt-2"
  }, [(
    _vm.currentUser &&
    _vm.user.id != _vm.currentUser.id &&
    _vm.user.username != _vm.PublicRelationsUsername
  ) ? [_c('div', [_c('user-follow-btn', {
    attrs: {
      "user": _vm.user,
      "theme": "blue",
      "type": "default",
      "borderRadius": ""
    }
  })], 1), _vm._v(" "), (
    _vm.currentUser &&
    _vm.currentUser.creator_verified &&
    _vm.user.stripe_connected &&
    _vm.user.creator_verified &&
    _vm.user.id != _vm.currentUser.id
  ) ? _c('div', [_c('img', {
    staticClass: "donate-btn mt-2",
    staticStyle: {
      "opacity": "0.8"
    },
    attrs: {
      "src": __webpack_require__(610),
      "alt": "circled dollar icon",
      "width": "25"
    },
    on: {
      "click": function($event) {
        _vm.showLoveDialog()
      }
    }
  })]) : _vm._e()] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ml-2"
  }, [(
    _vm.currentUser &&
    _vm.user.id != _vm.currentUser.id &&
    _vm.user.username != _vm.PublicRelationsUsername
  ) ? _c('v-menu', {
    staticClass: "more-menu",
    attrs: {
      "offset-y": ""
    }
  }, [_c('v-btn', {
    staticClass: "more-btn",
    attrs: {
      "slot": "activator",
      "dark": ""
    },
    slot: "activator"
  }, [_c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("more_horiz")])], 1), _vm._v(" "), _c('v-list', [(_vm.enabledViewDirectMessage) ? _c('v-list-tile', {
    key: "view_direct_messages",
    on: {
      "click": function($event) {
        _vm.viewDirectMessages()
      }
    }
  }, [_c('v-list-tile-title', {
    staticClass: "default-menu-item"
  }, [_c('label', [_vm._v("View Direct Messages")])])], 1) : _vm._e(), _vm._v(" "), (
    _vm.currentUser &&
    _vm.currentUser.creator_verified &&
    _vm.user.id != _vm.currentUser.id &&
    _vm.user.stripe_connected &&
    _vm.user.creator_verified
  ) ? _c('v-list-tile', {
    key: "send_love",
    on: {
      "click": function($event) {
        _vm.showLoveDialog()
      }
    }
  }, [_c('v-list-tile-title', {
    staticClass: "default-menu-item"
  }, [_c('label', [_vm._v("Donate")])])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-title', {
    staticClass: "default-menu-item"
  }, [_c('div', {
    staticClass: "dlfex align-center menu-list-div px-2"
  }, [_c('img', {
    staticClass: "mr-2",
    attrs: {
      "src": __webpack_require__(596),
      "width": "12"
    }
  }), _vm._v(" "), _c('label', [_vm._v("Message")])])])], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-title', {
    staticClass: "default-menu-item"
  }, [_c('div', {
    staticClass: "dlfex align-center menu-list-div px-2"
  }, [_c('img', {
    staticClass: "mr-2",
    attrs: {
      "src": __webpack_require__(1452),
      "width": "12"
    }
  }), _vm._v(" "), _c('label', [_vm._v("Donate")])])])], 1), _vm._v(" "), _c('v-list-tile', {
    key: "block",
    on: {
      "click": function($event) {
        _vm.openBlockUserConfirmDialog()
      }
    }
  }, [_c('v-list-tile-title', {
    staticClass: "default-menu-item"
  }, [_c('div', {
    staticClass: "dlfex align-center menu-list-div px-2"
  }, [_c('img', {
    staticClass: "mr-2",
    attrs: {
      "src": __webpack_require__(609),
      "width": "12"
    }
  }), _vm._v(" "), _c('label', [_vm._v("Block")])])])], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        _vm.flagUser()
      }
    }
  }, [_c('v-list-tile-title', {
    staticClass: "default-menu-item"
  }, [_c('div', {
    staticClass: "dlfex align-center menu-list-div px-2",
    on: {
      "click": function($event) {
        _vm.flagUser()
      }
    }
  }, [_c('img', {
    staticClass: "mr-2",
    attrs: {
      "src": __webpack_require__(605),
      "width": "12"
    }
  }), _vm._v(" "), _c('label', [_vm._v("Report")])])])], 1)], 1)], 1) : _vm._e()], 1)], 2)])])], 1)])], 2) : _vm._e(), _vm._v(" "), (_vm.show_following) ? _c('div', {
    staticClass: "followers-header"
  }, [_c('div', {
    staticClass: "followers-title"
  }, [_vm._v("Followers")])]) : _vm._e(), _vm._v(" "), (!_vm.show_following) ? _c('content-top-header', {
    attrs: {
      "absolute": ""
    }
  }, [_c('template', {
    slot: "topHeader"
  }, [_c('ul', {
    staticClass: "width100"
  }, [_vm._l((_vm.tabs), function(tab) {
    return [(_vm.isAvailableForGridView(tab)) ? _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (['followings', 'followers'].indexOf(tab.id) == -1),
        expression: "['followings', 'followers'].indexOf(tab.id) == -1"
      }],
      key: tab.id,
      staticClass: "nav-li",
      class: [{
          'active tab-active': _vm.isActiveTab(tab.id)
        },
        ("nav-" + (tab.id)) ],
      attrs: {
        "href": ("#" + (tab.id))
      }
    }, [_c('label', {
      staticClass: "nav-label",
      on: {
        "click": function($event) {
          _vm.onTab(tab.id)
        }
      }
    }, [_vm._v("\n                " + _vm._s(tab.title) + "\n              ")])]) : _vm._e()]
  })], 2)])], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [(_vm.active_tab == 'followings' || _vm.active_tab == 'followers') ? _c('div', [(!_vm.users || _vm.users.length == 0) ? _c('div', {
    staticClass: "empty-section"
  }, [_c('p', {
    staticClass: "empty-title"
  }, [_vm._v("Profile is Empty")]), _vm._v(" "), _c('p', {
    staticClass: "empty-description"
  }, [_vm._v("It’s a little lonely in here...")]), _vm._v(" "), (_vm.currentUser && _vm.user.id == _vm.currentUser.id) ? _c('router-link', {
    staticClass: "empty-discover-btn",
    attrs: {
      "to": "/album"
    }
  }, [_vm._v("Discover")]) : _vm._e()], 1) : _c('v-layout', {
    staticClass: "covers-content",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.users), function(user, index) {
    return _c('v-flex', {
      key: index,
      staticClass: "card-container",
      attrs: {
        "xs12": "",
        "sm2": ""
      }
    }, [_c('artist-item', {
      key: index,
      attrs: {
        "artist": user
      }
    })], 1)
  })), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.page_index < _vm.total_pages),
      expression: "page_index < total_pages"
    }],
    staticClass: "loadmore-btn",
    nativeOn: {
      "click": function($event) {
        _vm.getItems(_vm.active_tab, true)
      }
    }
  }, [_vm._v("Load More")])], 1) : (_vm.active_tab == 'artists') ? _c('div', [(!_vm.users || _vm.users.length == 0) ? [(_vm.currentUser && _vm.currentUser.id == _vm.user.id) ? [_vm._m(0)] : [_vm._m(1)]] : _c('v-layout', {
    staticClass: "covers-content",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.users), function(user, index) {
    return _c('v-flex', {
      key: index,
      staticClass: "card-container min-240",
      attrs: {
        "xs12": "",
        "sm2": ""
      }
    }, [_c('artist-item', {
      key: index,
      attrs: {
        "artist": user
      }
    })], 1)
  })), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.page_index < _vm.total_pages),
      expression: "page_index < total_pages"
    }],
    staticClass: "loadmore-btn",
    nativeOn: {
      "click": function($event) {
        _vm.getItems(_vm.active_tab, true)
      }
    }
  }, [_vm._v("Load More")])], 2) : (_vm.active_tab == 'merch') ? _c('div', [(!_vm.products || _vm.products.length == 0) ? [(_vm.currentUser && _vm.currentUser.id == _vm.user.id) ? [(_vm.currentUser.creator_verified) ? _c('div', {
    staticClass: "empty-section"
  }, [_c('p', {
    staticClass: "empty-title"
  }, [_vm._v("Empty")]), _vm._v(" "), _c('p', {
    staticClass: "empty-description"
  }, [_vm._v("\n                You have not uploaded any products\n              ")]), _vm._v(" "), _c('router-link', {
    staticClass: "empty-discover-btn",
    attrs: {
      "to": "/product/add"
    }
  }, [_vm._v("Upload")])], 1) : _vm._e()] : [_vm._m(2)]] : _c('v-layout', {
    staticClass: "covers-content",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.products), function(product, index) {
    return _c('v-flex', {
      key: index,
      staticClass: "card-container",
      attrs: {
        "xs12": "",
        "sm4": ""
      }
    }, [_c('product-card', {
      attrs: {
        "dataObject": product,
        "hideOverlay": ""
      }
    })], 1)
  })), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.page_index < _vm.total_pages),
      expression: "page_index < total_pages"
    }],
    staticClass: "loadmore-btn",
    nativeOn: {
      "click": function($event) {
        _vm.getItems(_vm.active_tab, true)
      }
    }
  }, [_vm._v("Load More")])], 2) : (_vm.active_tab === 'sms_group' && _vm.user.id == _vm.currentUser.id) ? _c('div', [_c('div', {
    staticClass: "sms-group pa-2"
  }, [_c('div', {
    staticClass: "dflex align-center justify-space-between"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "sms-btn-group mr-4"
  }, [_c('v-btn', {
    staticClass: "join-btn",
    attrs: {
      "round": ""
    }
  }, [_vm._v("Join SMS")]), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-2 joined-btn",
    attrs: {
      "round": ""
    }
  }, [_vm._v("Joined SMS")])], 1)])])]) : (_vm.active_tab == 'video') ? _c('div', {
    staticClass: "profile-videos mt-3"
  }, [_vm._m(4), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((3), function(video) {
    return _c('v-flex', {
      key: video,
      staticClass: "pr-3",
      attrs: {
        "xs4": ""
      }
    }, [_c('video-box', {
      attrs: {
        "hoverOverlay": false,
        "item": _vm.ownVideos[video]
      }
    })], 1)
  })), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.ownVideos), function(video) {
    return _c('v-flex', {
      key: video.name,
      staticClass: "card-container",
      attrs: {
        "xs3": ""
      }
    }, [_c('video-box', {
      attrs: {
        "hoverOverlay": false,
        "item": video
      }
    })], 1)
  }))], 1) : _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": "",
      "px-0": ""
    }
  }, [(!_vm.albums || _vm.albums.length == 0) ? [(_vm.active_tab == 'songs') ? [(_vm.currentUser && _vm.currentUser.id == _vm.user.id) ? [(_vm.currentUser.creator_verified) ? _c('div', {
    staticClass: "empty-section"
  }, [_c('p', {
    staticClass: "empty-title"
  }, [_vm._v("Empty")]), _vm._v(" "), _c('p', {
    staticClass: "empty-description"
  }, [_vm._v("You have no uploaded albums")]), _vm._v(" "), _c('router-link', {
    staticClass: "empty-discover-btn",
    attrs: {
      "to": "/upload/album"
    }
  }, [_vm._v("Upload")])], 1) : _vm._e()] : [_c('div', {
    staticClass: "empty-section"
  }, [_c('p', {
    staticClass: "empty-title"
  }, [_vm._v("Empty")]), _vm._v(" "), _c('p', {
    staticClass: "empty-description"
  }, [_vm._v("\n                  This user has no uploaded albums\n                ")])])]] : (_vm.active_tab == 'downloaded') ? [(_vm.currentUser && _vm.currentUser.id == _vm.user.id) ? [_c('div', {
    staticClass: "empty-section"
  }, [_c('p', {
    staticClass: "empty-title"
  }, [_vm._v("Empty")]), _vm._v(" "), _c('p', {
    staticClass: "empty-description"
  }, [_vm._v("You have no downloaded albums")]), _vm._v(" "), _c('router-link', {
    staticClass: "empty-discover-btn",
    attrs: {
      "to": "/album"
    }
  }, [_vm._v("Discover")])], 1)] : [_c('div', {
    staticClass: "empty-section"
  }, [_c('p', {
    staticClass: "empty-title"
  }, [_vm._v("Empty")]), _vm._v(" "), _c('p', {
    staticClass: "empty-description"
  }, [_vm._v("\n                  This user has not downloaded any albums\n                ")])])]] : (_vm.active_tab == 'reposted') ? [(_vm.currentUser && _vm.currentUser.id == _vm.user.id) ? [_c('div', {
    staticClass: "empty-section"
  }, [_c('p', {
    staticClass: "empty-title"
  }, [_vm._v("Empty")]), _vm._v(" "), _c('p', {
    staticClass: "empty-description"
  }, [_vm._v("You have no reposts")]), _vm._v(" "), _c('router-link', {
    staticClass: "empty-discover-btn",
    attrs: {
      "to": "/album"
    }
  }, [_vm._v("Discover")])], 1)] : [_c('div', {
    staticClass: "empty-section"
  }, [_c('p', {
    staticClass: "empty-title"
  }, [_vm._v("Empty")]), _vm._v(" "), _c('p', {
    staticClass: "empty-description"
  }, [_vm._v("This user has no reposts")])])]] : (_vm.active_tab == 'catalog') ? [(_vm.currentUser && _vm.currentUser.id == _vm.user.id) ? [_c('div', {
    staticClass: "empty-section"
  }, [_c('p', {
    staticClass: "empty-title"
  }, [_vm._v("Empty")]), _vm._v(" "), _c('p', {
    staticClass: "empty-description"
  }, [_vm._v("You have no catalog")])])] : [_c('div', {
    staticClass: "empty-section"
  }, [_c('p', {
    staticClass: "empty-title"
  }, [_vm._v("Empty")]), _vm._v(" "), _c('p', {
    staticClass: "empty-description"
  }, [_vm._v("This user has no catalog")])])]] : _vm._e()] : _c('div', {
    staticClass: "profile-track"
  }, [_c('div', {
    staticClass: "_body list-track-container list-track-view list-track-view-trackCard list-popular-tracks"
  }, [_c('div', {
    staticClass: "dflex justify-space-between align-center mt-3 mb-3"
  }, [_c('div', {
    staticClass: "text-big"
  }, [_vm._v("Popular")])]), _vm._v(" "), _vm._l((_vm.albums.slice(0, 5)), function(track, index) {
    return _c('div', {
      key: index,
      staticClass: "list-track-view-item px-5"
    }, [_c('track-card', {
      attrs: {
        "objects": _vm.albums,
        "objectIndex": index,
        "hideMoreMenu": "",
        "hideTrackLength": "",
        "displayDuration": ""
      }
    })], 1)
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "dflex justify-space-between align-center mt-5 mb-3"
  }, [_c('div', {
    staticClass: "text-big"
  }, [_vm._v("Albums")])]), _vm._v(" "), _c('v-layout', {
    staticClass: "covers-content",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.albums.filter(function (t) { return t.collaborators_count == 0; }).slice(0, 6)), function(feed, index) {
    return _c('v-flex', {
      key: index,
      staticClass: "custom-lg6",
      attrs: {
        "xs6": ""
      }
    }, [_c('track-card', {
      attrs: {
        "objects": _vm.albums.filter(function (t) { return t.collaborators_count == 0; }).slice(0, 6),
        "objectIndex": index
      }
    })], 1)
  })), _vm._v(" "), _c('div', {
    staticClass: "dflex justify-space-between align-center mt-5 mb-3"
  }, [_c('div', {
    staticClass: "text-big"
  }, [_vm._v("Appears on")])]), _vm._v(" "), _c('v-layout', {
    staticClass: "covers-content",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.albums.filter(function (t) { return t.collaborators_count > 0; })), function(feed, index) {
    return _c('v-flex', {
      key: index,
      staticClass: "custom-lg6",
      attrs: {
        "xs6": ""
      }
    }, [_c('track-card', {
      attrs: {
        "objects": _vm.albums.filter(function (t) { return t.collaborators_count > 0; }),
        "objectIndex": index
      }
    })], 1)
  }))], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.page_index < _vm.total_pages),
      expression: "page_index < total_pages"
    }],
    staticClass: "loadmore-btn",
    nativeOn: {
      "click": function($event) {
        _vm.getItems(_vm.active_tab, true)
      }
    }
  }, [_vm._v("Load More")])], 2)], 1)], 1), _vm._v(" "), (_vm.showSendMessage) ? _c('send-message', {
    attrs: {
      "receiver": _vm.user,
      "dismiss": _vm.dismissMessageModal
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showSendLoveModal) ? _c('send-love-modal', {
    attrs: {
      "item": _vm.user,
      "dismiss": _vm.dismissLoveDialog
    }
  }) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "invite-dialog",
      "width": "440"
    },
    model: {
      value: (_vm.show_block_user_confirm_dialog),
      callback: function($$v) {
        _vm.show_block_user_confirm_dialog = $$v
      },
      expression: "show_block_user_confirm_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Block a User")]), _vm._v(" "), _c('v-card-text', [_vm._v("Are you sure you want to block this?")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "dark": "",
      "block": "",
      "color": "black"
    },
    nativeOn: {
      "click": function($event) {
        _vm.blockUser()
      }
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "dark": "",
      "block": "",
      "color": "black"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeBlockUserConfirmDialog()
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "invite-dialog",
      "width": "440"
    },
    model: {
      value: (_vm.show_invite_confirm_dialog),
      callback: function($$v) {
        _vm.show_invite_confirm_dialog = $$v
      },
      expression: "show_invite_confirm_dialog"
    }
  }, [_c('v-card', [_c('v-card-media', {
    attrs: {
      "src": _vm.user.avatar.url,
      "height": "125px",
      "contain": ""
    }
  }), _vm._v(" "), _c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("\n        Do you want to invite this user?\n      ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n        This user's account is pending verification. Only verified users can\n        invite pending accounts. Inviting this user will expedite their\n        verification process\n      ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red",
      "dark": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeInviteConfirmDialog()
      }
    }
  }, [_vm._v("No, cancel!")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green",
      "dark": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.inviteUser()
      }
    }
  }, [_vm._v("Yes, Invite!")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": ["membership-dialog"]
    },
    model: {
      value: (_vm.showMembershipModal),
      callback: function($$v) {
        _vm.showMembershipModal = $$v
      },
      expression: "showMembershipModal"
    }
  }, [_c('div', {
    staticClass: "membership-bg-img",
    style: ({
      'background-image': 'url(' + _vm.user.avatar.url + ')'
    })
  }, [_c('div', [_c('h2', {
    staticClass: "memership-title"
  }, [_vm._v(_vm._s(_vm.user.display_name) + " "), _c('img', {
    attrs: {
      "src": __webpack_require__(1558),
      "width": "14px"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "memership-subtitle"
  }, [_vm._v("Membership")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.monthlyTier = !_vm.monthlyTier
      }
    }
  }, [_vm._v("\n          Switch to " + _vm._s(_vm.monthlyTier ? 'yearly' : 'monthly') + " plan\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex plan-slides"
  }, _vm._l((_vm.membership_tiers), function(tier) {
    return _c('div', [_c('div', {
      staticClass: "member-plan"
    }, [_c('div', {
      staticClass: "plan-title"
    }, [_c('div', {
      staticClass: "plan-main-title"
    }, [_c('h3', [_vm._v(_vm._s(tier.plan_name))]), _vm._v(" "), _c('img', {
      attrs: {
        "src": __webpack_require__(1564)
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "plan-price"
    }, [_c('strong', [_vm._v("$" + _vm._s(parseFloat(tier.price)))]), _vm._v("/" + _vm._s(_vm.monthlyTier ? 'month' : 'year') + "\n                ")]), _vm._v(" "), (_vm.purchasedPlan(tier)) ? _c('span', {
      staticClass: "plan-status"
    }, [_vm._v("\n                  current plan\n                ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "plan-description"
    }, [_c('span', {}, [_vm._v("\n                  " + _vm._s(_vm.fromNow(tier.updated_at)) + "\n                ")]), _vm._v("\n                " + _vm._s(tier.description) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "plan-button-section"
    }, [_c('v-btn', {
      staticClass: "btn member-button",
      on: {
        "click": function($event) {
          _vm.purchaseMembership(tier, _vm.getMembershipId(tier))
        }
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.purchaseMembershipBtnTitle(tier)) + "\n                ")])], 1)])])
  }))])])]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": ["membership-payment-dialog"]
    },
    model: {
      value: (_vm.showPaymentModal),
      callback: function($$v) {
        _vm.showPaymentModal = $$v
      },
      expression: "showPaymentModal"
    }
  }, [_c('v-card', {
    staticClass: "w-100"
  }, [_c('v-card-title', {
    staticClass: "dflex justify-space-between"
  }, [_c('h2', {
    staticClass: "px-3"
  }, [_vm._v("Payment")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "fab": "",
      "dark": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.showPaymentModal = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-flex', {
    staticClass: "px-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "mb-1"
  }, [_c('div', {
    staticClass: "title mb-2"
  }, [_vm._v("Purchase")])]), _vm._v(" "), _c('div', {
    staticClass: "membership-purchase-section"
  }, [_c('div', {
    staticClass: "header-title"
  }, [_vm._v("\n                Membership purchase\n                "), _c('span', {
    staticClass: "membership-price"
  }, [_vm._v("\n                  $" + _vm._s((this.selectedTier ? (this.selectedTier.price) : null)) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "membership-purchase-section-body"
  }, [_vm._v("\n              Your card will be charged every month starting from today\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 mb-1"
  }, [_c('div', {
    staticClass: "title mb-2"
  }, [_vm._v("Credit card")])]), _vm._v(" "), _c('div', {
    staticClass: "payment-stripe-section"
  }, [_c('div', {
    staticClass: "stripe-section-body"
  }, [_c('div', {
    staticClass: "lock"
  }, [_c('card-number', {
    ref: "cardNumber",
    staticClass: "stripe-element card-number payment-card",
    attrs: {
      "stripe": _vm.stripe_publishable_key,
      "options": _vm.stripeOptions
    },
    on: {
      "change": function($event) {
        _vm.number = $event.complete
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "icon-image"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(426),
      "alt": "",
      "width": "130"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom-details"
  }, [_c('div', [_c('card-expiry', {
    ref: "cardExpiry",
    staticClass: "stripe-element card-expiry payment-card",
    attrs: {
      "stripe": _vm.stripe_publishable_key,
      "options": _vm.stripeOptions
    },
    on: {
      "change": function($event) {
        _vm.expiry = $event.complete
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "question-mark"
  }, [_c('card-cvc', {
    ref: "cardCvc",
    staticClass: "stripe-element card-cvc payment-card",
    attrs: {
      "stripe": _vm.stripe_publishable_key,
      "options": _vm.stripeOptions
    },
    on: {
      "change": function($event) {
        _vm.cvc = $event.complete
      }
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "payment-stripe-section-button"
  }, [_c('div', {
    staticClass: "btn-holder"
  }, [_c('v-btn', {
    staticClass: "checkout-btn",
    on: {
      "click": _vm.handlePayment
    }
  }, [_vm._v("Pay $" + _vm._s(_vm.totalPayable()))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "powered-by text-center"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(427),
      "width": "100",
      "alt": ""
    }
  })])])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "invite-dialog",
      "width": "440"
    },
    model: {
      value: (_vm.purchaseModal),
      callback: function($$v) {
        _vm.purchaseModal = $$v
      },
      expression: "purchaseModal"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("\n        Purchase Membership\n      ")]), _vm._v(" "), (_vm.selectedTier) ? _c('v-card-text', [_vm._v("\n        Are you sure you want to purchase "), _c('b', [_vm._v(_vm._s(_vm.selectedTier.plan_name))]), _vm._v("?\n        This process might take a while. Please don't refresh page in this time.\n        "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "my-2"
  }, [_c('div', {
    staticClass: "d-flex row my-2"
  }, [_c('div', {
    staticClass: "col-10 text-left"
  }, [_vm._v("Membership Price")]), _c('div', {
    staticClass: "col-1 text-right"
  }, [_c('b', [_vm._v("$" + _vm._s(_vm.selectedTier.price))])])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex row my-2"
  }, [_c('div', {
    staticClass: "col-10 text-left"
  }, [_vm._v("Stripe Fee")]), _c('div', {
    staticClass: "col-1 text-right"
  }, [_c('b', [_vm._v("$" + _vm._s(_vm.selectedTier.stripe_fee / 100))])])])]), _vm._v(" "), _c('hr'), _vm._v("\n        By clicking "), _c('b', [_vm._v("Yes")]), _vm._v(" you agree to be charged "), _c('b', [_vm._v("$" + _vm._s(_vm.selectedTier.total_price / 100))]), _vm._v(" every " + _vm._s(_vm.selectedTier.plan_type) + ".\n      ")]) : _vm._e(), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "green",
      "dark": "",
      "block": "",
      "disabled": _vm.stripe_inprogress
    },
    nativeOn: {
      "click": function($event) {
        _vm.purchase()
      }
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "black",
      "dark": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.hidePurchaseModal()
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "my-dialog-1"
    },
    model: {
      value: (_vm.show_order_complete_dialog),
      callback: function($$v) {
        _vm.show_order_complete_dialog = $$v
      },
      expression: "show_order_complete_dialog"
    }
  }, [_c('div', {
    staticClass: "payment-success payment-ready"
  }, [_c('div', {
    staticClass: "dflex align-center my-4"
  }, [_c('div', {
    staticClass: "success-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(119),
      "width": "100%"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "result-text"
  }, [_c('div', {
    staticClass: "big"
  }, [_vm._v("Thank you!")]), _vm._v(" "), _c('div', [_vm._v("Your order was successful")])])]), _vm._v(" "), _c('div', {
    staticClass: "post"
  }, [_vm._v("\n        We sent an email confirmation to: "), _c('br'), _vm._v(" "), _c('strong', [_vm._v(" " + _vm._s(_vm.currentUser.email) + " ")])]), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-5 pay_btn",
    attrs: {
      "depressed": "",
      "round": "",
      "block": ""
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          path: ("/members/" + (_vm.user.slug))
        })
      }
    }
  }, [_vm._v("View members area")])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "empty-section"
  }, [_c('p', {
    staticClass: "empty-title"
  }, [_vm._v("Empty")]), _vm._v(" "), _c('p', {
    staticClass: "empty-description"
  }, [_vm._v("You have not added any user")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "empty-section"
  }, [_c('p', {
    staticClass: "empty-title"
  }, [_vm._v("Empty")]), _vm._v(" "), _c('p', {
    staticClass: "empty-description"
  }, [_vm._v("\n                This user has not added any user\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "empty-section"
  }, [_c('p', {
    staticClass: "empty-title"
  }, [_vm._v("Empty")]), _vm._v(" "), _c('p', {
    staticClass: "empty-description"
  }, [_vm._v("This user has no products")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sms-info"
  }, [_c('div', {
    staticClass: "dflex align-center"
  }, [_c('div', {
    staticClass: "sms-img"
  }), _vm._v(" "), _c('div', {
    staticClass: "ml-2"
  }, [_c('div', {
    staticClass: "sms-name dflex align-center"
  }, [_vm._v("\n                  Tribe Nohbi\n                  "), _c('img', {
    staticClass: "ml-1",
    attrs: {
      "src": __webpack_require__(119),
      "width": "10"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "user-type"
  }, [_vm._v("\n                  Artist\n                ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dflex justify-space-between align-center"
  }, [_c('div', {
    staticClass: "text-big mb-2"
  }, [_vm._v("Popular")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dflex justify-space-between align-center margin-top-x"
  }, [_c('div', {
    staticClass: "text-big mb-2"
  }, [_vm._v("Videos")])])
}]}

/***/ }),
/* 1694 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "d-flex justify-center"
  }, [_c('div', {
    staticClass: "community"
  }, [_c('div', {
    staticClass: "community__title mb-5"
  }, [_vm._v("Communities")]), _vm._v(" "), _c('div', {
    staticClass: "community__subtitle my-3"
  }, [_vm._v("Your profile")]), _vm._v(" "), _c('div', {
    staticClass: "community__item",
    on: {
      "click": function($event) {
        _vm.$router.push('/username/m')
      }
    }
  }, [_c('img', {
    staticClass: "community__item--image",
    attrs: {
      "src": __webpack_require__(165)
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "community__subtitle mb-3 mt-4"
  }, [_vm._v("Subscribed")]), _vm._v(" "), _c('div', {
    staticClass: "community__item mb-2",
    on: {
      "click": function($event) {
        _vm.$router.push('/username/m')
      }
    }
  }, [_c('img', {
    staticClass: "community__item--image",
    attrs: {
      "src": __webpack_require__(165)
    }
  }), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "community__item",
    on: {
      "click": function($event) {
        _vm.$router.push('/username/m')
      }
    }
  }, [_c('img', {
    staticClass: "community__item--image",
    attrs: {
      "src": __webpack_require__(165)
    }
  }), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "community__subtitle mt-4 mb-3"
  }, [_vm._v("Following")]), _vm._v(" "), _c('div', {
    staticClass: "community__item mb-5 pb-5",
    on: {
      "click": function($event) {
        _vm.$router.push('/username/m')
      }
    }
  }, [_c('img', {
    staticClass: "community__item--image",
    attrs: {
      "src": __webpack_require__(165)
    }
  }), _vm._v(" "), _vm._m(3)])])]), _vm._v(" "), _c('Footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "community__item__content d-flex justify-space-between"
  }, [_c('span', {
    staticClass: "text-left"
  }, [_vm._v("You")]), _vm._v(" "), _c('span', {
    staticClass: "text-right"
  }, [_vm._v("Platinum • 1m")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "community__item__content d-flex justify-space-between"
  }, [_c('span', {
    staticClass: "text-left"
  }, [_vm._v("SALVA")]), _vm._v(" "), _c('span', {
    staticClass: "text-right"
  }, [_vm._v("Platinum • 1m")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "community__item__content d-flex justify-space-between"
  }, [_c('span', {
    staticClass: "text-left"
  }, [_vm._v("Tri Nohbi")]), _vm._v(" "), _c('span', {
    staticClass: "text-right"
  }, [_vm._v("Acapella packs • 1w")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "community__item__content d-flex justify-space-between"
  }, [_c('span', {
    staticClass: "text-left"
  }, [_vm._v("You")]), _vm._v(" "), _c('span', {
    staticClass: "text-right"
  }, [_vm._v("Platinum • 1m")])])
}]}

/***/ }),
/* 1695 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "activity-product-card"
  }, [_c('v-flex', {
    staticClass: "product-info",
    attrs: {
      "xs12": "",
      "pa-0": ""
    }
  }, [_c('v-flex', {
    staticClass: "product-cover",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "product-image",
    style: ({
      'background-image': 'url(' + _vm.item.covers[0].cover.thumb.url + ')'
    })
  }), _vm._v(" "), (_vm.priceShow) ? _c('v-flex', {
    staticClass: "product-actions",
    attrs: {
      "xs12": "",
      "relative": ""
    }
  }, [_c('v-flex', {
    staticClass: "touch-flex",
    attrs: {
      "xs12": ""
    },
    on: {
      "click": function($event) {
        _vm.showMerchModal = true
      }
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.showMerchModal) ? _c('merch-modal', {
    attrs: {
      "item": _vm.item,
      "dismiss": _vm.dimissMerchModal
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1696 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page video-page delete-page"
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": ""
    }
  }, [_c('h2', {
    staticClass: "page-title"
  }, [_vm._v("Live Video")]), _vm._v(" "), _c('div', {
    staticClass: "divider mt-3"
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": "",
      "text-xs-center": ""
    }
  }, [_c('h4', [_vm._v("Your channel is being deleted...")]), _vm._v(" "), _c('p', {
    staticClass: "mt-2"
  }, [_vm._v("\n      This process can take up to 5 minutes. When this process is completed,\n      you can create a new channel"), _c('br'), _vm._v("\n      This page should automatically refresh.\n    ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "px-3 mt-3",
    attrs: {
      "round": "",
      "dark": "",
      "color": "blue"
    },
    nativeOn: {
      "click": function($event) {
        _vm.getStream()
      }
    }
  }, [_vm._v("Refresh")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1697 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "auth-page auth-register-page"
  }, [(_vm.isPageReady && !_vm.show_register_success_dialog) ? _c('div', {
    staticClass: "text-xs-center"
  }, [(_vm.inviter.username) ? _c('div', {
    staticClass: "inviter"
  }, [_vm._v("\n      You've been invited by"), _c('br'), _vm._v(" "), _c('user-tag', {
    attrs: {
      "user": _vm.inviter
    }
  }), _c('br'), _vm._v("\n      to get verified\n    ")], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isPageReady && !_vm.show_register_success_dialog) ? _c('form', {
    staticClass: "auth-form register-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit()
      }
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-item": "",
      "px-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('div', {
    staticClass: "avatar-area"
  }, [_c('span', {
    staticClass: "avatar-img"
  }, [_c('img', {
    ref: "avatar",
    staticClass: "avatar",
    attrs: {
      "src": "/static/images/user-new.svg",
      "id": "avatar"
    }
  })]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "avatar-upload"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "avatar_file",
    staticClass: "avatar-file",
    attrs: {
      "type": "file",
      "name": "avatar_file",
      "id": "avatar_file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.imageChanged($event)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "avatar_file"
    }
  }, [_vm._v("Choose image")])])])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "account_type",
    attrs: {
      "items": _vm.UserTypeOptions,
      "item-value": "value",
      "item-text": "text",
      "name": "account_type",
      "placeholder": "Choose account type",
      "hide-details": ""
    },
    model: {
      value: (_vm.user.request_role),
      callback: function($$v) {
        _vm.$set(_vm.user, "request_role", $$v)
      },
      expression: "user.request_role"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": "",
      "relative": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.username),
      expression: "user.username"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        min: 3,
        max: 20,
        regex: /^[A-Za-z0-9_.]+$/,
      }),
      expression: "{\n              required: true,\n              min: 3,\n              max: 20,\n              regex: /^[A-Za-z0-9_.]+$/,\n            }"
    }],
    staticClass: "username",
    attrs: {
      "type": "text",
      "name": "username",
      "placeholder": "@username"
    },
    domProps: {
      "value": (_vm.user.username)
    },
    on: {
      "blur": _vm.onBlur,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "username", $event.target.value)
      }
    }
  }), _vm._v(" "), (!_vm.is_username_available) ? _c('label', {
    staticClass: "error--text"
  }, [_vm._v("already taken")]) : _vm._e()]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.display_name),
      expression: "user.display_name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:20'),
      expression: "'required|max:20'"
    }],
    staticClass: "displayname",
    attrs: {
      "type": "text",
      "name": "name",
      "autocomplete": "off",
      "placeholder": "Name"
    },
    domProps: {
      "value": (_vm.user.display_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "display_name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.city),
      expression: "user.city"
    }],
    staticClass: "displayname",
    attrs: {
      "type": "text",
      "name": "city",
      "placeholder": "City"
    },
    domProps: {
      "value": (_vm.user.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "city", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('country-select', {
    staticClass: "country",
    attrs: {
      "country": _vm.country,
      "topCountry": "US"
    },
    model: {
      value: (_vm.user.country),
      callback: function($$v) {
        _vm.$set(_vm.user, "country", $$v)
      },
      expression: "user.country"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    staticClass: "country",
    attrs: {
      "items": _vm.age_group,
      "label": "Age Group",
      "persistent-hint": "",
      "return-object": "",
      "single-line": "",
      "name": "social_provider"
    },
    model: {
      value: (_vm.user.age_group),
      callback: function($$v) {
        _vm.$set(_vm.user, "age_group", $$v)
      },
      expression: "user.age_group"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    staticClass: "country",
    attrs: {
      "items": _vm.social_platform,
      "label": "Social Platform",
      "persistent-hint": "",
      "return-object": "",
      "single-line": "",
      "name": "social_provider"
    },
    model: {
      value: (_vm.user.social_provider),
      callback: function($$v) {
        _vm.$set(_vm.user, "social_provider", $$v)
      },
      expression: "user.social_provider"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.social_user_name),
      expression: "user.social_user_name"
    }],
    staticClass: "displayname",
    attrs: {
      "type": "text",
      "name": "social_user_name",
      "autocomplete": "off",
      "placeholder": "Social Platform Username"
    },
    domProps: {
      "value": (_vm.user.social_user_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "social_user_name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    staticClass: "email",
    attrs: {
      "type": "email",
      "name": "email",
      "placeholder": "Email",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:5|max:16'),
      expression: "'required|min:5|max:16'"
    }],
    staticClass: "password",
    attrs: {
      "type": "password",
      "name": "password",
      "placeholder": "Password",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.social_url),
      expression: "user.social_url"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "displayname",
    attrs: {
      "type": "text",
      "name": "social_media",
      "autocomplete": "off",
      "placeholder": "Social Media URL"
    },
    domProps: {
      "value": (_vm.user.social_url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "social_url", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('div', {
    staticClass: "dflex justify-space-between align-center mt-2"
  }, [_c('p', {
    staticClass: "regular-checkbox ma-0"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.terms),
      expression: "terms"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "id": "terms",
      "type": "checkbox",
      "name": "terms"
    },
    domProps: {
      "checked": Array.isArray(_vm.terms) ? _vm._i(_vm.terms, null) > -1 : (_vm.terms)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.terms,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.terms = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.terms = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.terms = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "terms-text",
    attrs: {
      "for": "terms"
    }
  }, [_c('span', [_vm._v("Accept Terms")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "forgot-password terms-text",
    attrs: {
      "to": "/terms"
    }
  }, [_vm._v("\n              Terms & Conditions\n            ")])], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": "",
      "mt-3": ""
    }
  }, [_c('v-btn', {
    staticClass: "create-account-button",
    attrs: {
      "block": "",
      "round": "",
      "dark": "",
      "type": "submit"
    }
  }, [_vm._v("Create account")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "content-class": "register-success-dialog"
    },
    model: {
      value: (_vm.show_register_success_dialog),
      callback: function($$v) {
        _vm.show_register_success_dialog = $$v
      },
      expression: "show_register_success_dialog"
    }
  }, [_c('v-layout', {
    staticClass: "page auth-page register-success-page",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "transition": "slide-x-reverse-transition"
    }
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "/static/images/nav_logo_primary.png"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    staticClass: "overview-section"
  }, [_c('h5', [_vm._v("Success!")]), _vm._v(" "), _c('p', [_vm._v("Please check your email to confirm your account.")])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('div', {
    staticClass: "info-section"
  }, [_c('p', [_vm._v("\n              Please allow at least 48 hours for staff to verify your account.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              While your account is being activated you can download the iOS\n              app & browse as a listener.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              Use the web/desktop version to upload albums & products,\n              download songs & broadcast live!\n            ")])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('div', {
    staticClass: "download-section"
  }, [_c('div', [_c('a', {
    attrs: {
      "href": "//apps.apple.com/us/app/id1452078262",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/img_download_ios.svg",
      "height": "64"
    }
  })])]), _vm._v(" "), _c('div', [_c('img', {
    staticClass: "qr-code",
    attrs: {
      "src": "/static/images/ios-app-link-qr.svg"
    }
  })]), _vm._v(" "), _c('div', [_c('label', [_vm._v("Android coming soon.")])])])], 1)])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1698 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "activity-item"
  }, [_c('div', {
    staticClass: "activity-item-body"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "activity-item-section",
    class: {
      md5: _vm.activityItem.sender.recent_reposts,
      'no-reposts': !_vm.activityItem.sender.recent_reposts,
    },
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('div', {
    staticClass: "activity-item-section-body"
  }, [_c('v-flex', {
    staticClass: "activity-item-content-area",
    attrs: {
      "xs10": ""
    }
  }, [_c('profile-item', {
    attrs: {
      "user": _vm.activityItem.sender,
      "className": 'activity-item-profile-avatar-area'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "activity-item-content"
  }, [_c('div', {
    class: {
      'd-block': _vm.onMobile,
      'dflex align-center': !_vm.onMobile,
    }
  }, [_c('user-tag', {
    staticClass: "user-name",
    attrs: {
      "user": _vm.activityItem.sender
    }
  }), _vm._v(" "), (!_vm.onMobile) ? _c('span', {
    staticClass: "mx-2"
  }, [_vm._v("●")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "activity-time"
  }, [_vm._v(_vm._s(_vm._f("formatDateFromNow")(_vm.toLocalTimeString(_vm.activityItem.updated_at))))])], 1), _vm._v(" "), _c('label', {
    staticClass: "description-text align-center"
  }, [(_vm.activityIcon) ? _c('v-icon', {
    staticClass: "activityIcon mr-2"
  }, [_vm._v("\n                  " + _vm._s(_vm.activityIcon) + "\n                ")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("capitalize")(_vm.activityItem.message)))])], 1)])], 1), _vm._v(" "), (_vm.activityItem.action_type == 'comment' || _vm.activityItem.assoc) ? _c('v-flex', {
    staticClass: "details",
    attrs: {
      "xs2": ""
    }
  }, [(_vm.activityItem.assoc) ? [(_vm.activityItem.assoc_type == 'Comment') ? [(_vm.activityItem.assoc.commentable_type == 'ShopProduct') ? _c('div', {
    staticClass: "actioned-item",
    style: ({
      'background-image': 'url(' +
        _vm.activityItem.assoc.commentable.covers[0].cover.thumb
        .url +
        ')',
    })
  }) : (_vm.activityItem.assoc.commentable_type == 'Album') ? _c('div', {
    staticClass: "actioned-item",
    style: ({
      'background-image': 'url(' +
        _vm.activityItem.assoc.commentable.cover.thumb.url +
        ')',
    })
  }) : (_vm.activityItem.assoc.commentable_type == 'Post') ? _c('div', {
    staticClass: "actioned-item",
    style: ({
      'background-image': 'url(' +
        _vm.activityItem.assoc.commentable.cover.thumb.url +
        ')',
    })
  }) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.activityItem.assoc_type == 'Post') ? _c('div', {
    staticClass: "actioned-item",
    style: ({
      'background-image': 'url(' + _vm.activityItem.assoc.cover.thumb.url + ')',
    })
  }) : _vm._e(), _vm._v(" "), (_vm.activityItem.assoc_type == 'ShopProduct') ? _c('div', {
    staticClass: "actioned-item"
  }, [_c('activity-product-card', {
    attrs: {
      "object": _vm.activityItem.assoc
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.activityItem.assoc_type == 'Album') ? _c('div', {
    staticClass: "actioned-item"
  }, [_c('activity-album-card', {
    attrs: {
      "object": _vm.activityItem.assoc
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.activityItem.assoc_type == 'Video') ? _c('div', {
    staticClass: "actioned-item __video"
  }, [_c('video-box', {
    attrs: {
      "hoverOverlay": false,
      "coverOnly": "",
      "item": _vm.testVid
    }
  })], 1) : _vm._e()] : _vm._e()], 2) : _vm._e()], 1)])], 1)], 1), _vm._v(" "), (_vm.showMerchModal && _vm.activityItem.assoc_type === 'ShopProduct') ? _c('merch-modal', {
    attrs: {
      "item": _vm.activityItem.assoc,
      "dismiss": _vm.dimissMerchModal
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1699 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    class: {
      //'primary': $store.getters['navigator/isPrimaryTheme'],
      //gray: $store.getters['navigator/isGrayTheme'],
      normal: _vm.$store.getters['navigator/isNormalTheme'],
      'app-audio': _vm.$store.state.player.isPlaying,
      'app-video': _vm.$store.getters['streamPlayer/hasFrame'],
      'app-header': _vm.$store.getters['navigator/hasHeader'],
      'app-footer': _vm.$store.getters['navigator/hasFooter'],
    },
    attrs: {
      "id": "app",
      "standalone": ""
    }
  }, [(_vm.showSidebar && !this.authPage && !this.welcomePage && !this.QRPage && !this.noSidebar) ? _c('sidebar') : _vm._e(), _vm._v(" "), _c('v-content', {
    class: {
      'bg-light': _vm.bgLight,
      'bg-grey': _vm.bgGrey,
      'bg-dark': _vm.bgDark,
      'bg-black': _vm.bgBlack,
      'bg-natural-grey': _vm.bgNaturalGrey
    }
  }, [(!_vm.onMobile && _vm.isAuthenticated) ? _c('span', [_c('app-loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadValue !== 100),
      expression: "loadValue !== 100"
    }],
    ref: "appLoader",
    on: {
      "getLoadUpdate": _vm.getLoadUpdate
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-container', {
    staticClass: "app-container",
    class: {
      'onMobile-container': _vm.onMobile,
      'onMobile-container-fullwidth': _vm.noSideSpace,
      'no-padding': _vm.noPadding,
      'no-margin': _vm.noMargin,
      'not-authenticated': !_vm.isAuthenticated,
      wrapFullHeight: _vm.wrapFullHeight
    },
    attrs: {
      "fluid": ""
    }
  }, [_c('router-view')], 1)], 1), _vm._v(" "), (_vm.currentUser) ? _c('stream-player', {
    ref: "streamPlayer"
  }) : _vm._e(), _vm._v(" "), (_vm.$store.state.auth.firstVisit) ? _c('earn-money-sticker') : _vm._e(), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "multi-line": "",
      "top": "",
      "timeout": _vm.$store.state.error.timeout,
      "color": _vm.$store.state.error.color
    },
    model: {
      value: (_vm.showError),
      callback: function($$v) {
        _vm.showError = $$v
      },
      expression: "showError"
    }
  }, [_c('label', {
    staticStyle: {
      "font-weight": "700"
    }
  }, [_vm._v(_vm._s(_vm.$store.state.error.errors[0]))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.$store.dispatch('error/hideToast')
      }
    }
  }, [_c('v-icon', [_vm._v("clear")])], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "500px"
    },
    model: {
      value: (_vm.show_login_dialog),
      callback: function($$v) {
        _vm.show_login_dialog = $$v
      },
      expression: "show_login_dialog"
    }
  }, [_c('login-dialog', {
    attrs: {
      "dismiss": _vm.closeLoginDialog
    }
  })], 1), _vm._v(" "), (_vm.onMobile) ? _c('v-dialog', {
    attrs: {
      "transition": "slide-up",
      "content-class": "no-border-radius",
      "fullscreen": ""
    },
    model: {
      value: (_vm.mobilePlayerActive),
      callback: function($$v) {
        _vm.mobilePlayerActive = $$v
      },
      expression: "mobilePlayerActive"
    }
  }, [_c('mobile-player', {
    attrs: {
      "isPlayerOpened": _vm.mobilePlayerActive
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.globalSMSactive) ? _c('SMS', {
    on: {
      "closeSMS": _vm.closeSMS
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1700 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "media"
  }, [(_vm.imageLink) ? _c('router-link', {
    attrs: {
      "to": _vm.imageLink
    }
  }, [_c('div', {
    staticClass: "media__image",
    class: {
      round: _vm.imageRounded
    },
    style: (("background-image: url(" + _vm.image + ")"))
  })]) : _c('div', {
    staticClass: "media__image",
    class: {
      round: _vm.imageRounded
    },
    style: (("background-image: url(" + _vm.image + ")"))
  }), _vm._v(" "), _c('div', {
    staticClass: "media__content"
  }, [_c('div', [(_vm.titleLink) ? _c('router-link', {
    attrs: {
      "to": _vm.titleLink
    }
  }, [_c('div', {
    staticClass: "media__title"
  }, [_vm._v("\n          " + _vm._s(_vm.title) + "\n          "), (_vm.meta.verified) ? _c('v-icon', [_vm._v("fa-check-circle")]) : _vm._e()], 1)]) : _c('div', {
    staticClass: "media__title"
  }, [_vm._v("\n        " + _vm._s(_vm.title) + "\n        "), (_vm.meta.verified) ? _c('v-icon', [_vm._v("fa-check-circle")]) : _vm._e()], 1), _vm._v(" "), (_vm.subtitle) ? _c('div', {
    staticClass: "media__subtitle"
  }, [_vm._v(_vm._s(_vm.subtitle))]) : _vm._e(), _vm._v(" "), (_vm.description) ? _c('div', {
    staticClass: "media__description"
  }, [_vm._v("\n        " + _vm._s(_vm.description) + "\n      ")]) : _vm._e()], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1701 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "activity-album-card"
  }, [_c('v-flex', {
    staticClass: "track-info",
    attrs: {
      "xs12": "",
      "pa-0": ""
    }
  }, [_c('v-flex', {
    staticClass: "track-cover",
    attrs: {
      "xs12": ""
    }
  }, [(_vm.item.album_type == 'playlist') ? _c('div', {
    staticClass: "track-image",
    class: _vm.item.album_type,
    style: ({
      'background-image': ("url(" + _vm.album1Cover + "), url(" + _vm.album2Cover + "), url(" + _vm.album3Cover + "), url(" + _vm.album4Cover + ")"),
    })
  }) : _c('div', {
    staticClass: "track-image",
    style: ({
      'background-image': 'url(' + _vm.item.cover.url + ')'
    })
  }), _vm._v(" "), _c('v-flex', {
    staticClass: "track-actions",
    class: {
      playing: _vm.isPlaying
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('v-flex', {
    staticClass: "touch-flex",
    attrs: {
      "xs12": ""
    },
    on: {
      "click": function($event) {
        _vm.goToAlbum()
      }
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1702 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "content-class": "addToPlaylist-dialog"
    },
    model: {
      value: (_vm.getAddToPlaylist),
      callback: function($$v) {
        _vm.getAddToPlaylist = $$v
      },
      expression: "getAddToPlaylist"
    }
  }, [_c('v-icon', {
    staticClass: "icon-close",
    on: {
      "click": function($event) {
        _vm.closeAddToPlaylist()
      }
    }
  }, [_vm._v("close")]), _vm._v(" "), (!_vm.newPlaylistActive && !_vm.playlistAddedSuccess) ? _c('div', {
    staticClass: "addToPlaylist"
  }, [_c('div', {
    staticClass: "text-center _top"
  }, [_c('span', [_vm._v("Add To Playlist")])]), _vm._v(" "), _c('div', {
    staticClass: "mb-3 app-bold"
  }, [_vm._v("All to Playlists")]), _vm._v(" "), _c('div', {
    staticClass: "mb-2 _playlist add_new",
    on: {
      "click": function($event) {
        _vm.newPlaylist()
      }
    }
  }, [_c('trackcardsimple', {
    attrs: {
      "item": {},
      "cover": __webpack_require__(1462),
      "title": "New Playlist",
      "coverRadius": ""
    }
  })], 1), _vm._v(" "), _vm._l((this.playlists), function(playlist, index) {
    return ((_vm.selectedItems.length > 0)) ? _c('div', {
      key: index,
      staticClass: "mb-2 _playlist",
      on: {
        "click": function($event) {
          _vm.addToExistingPlaylist(playlist)
        }
      }
    }, [_c('trackcardsimple', {
      attrs: {
        "item": {},
        "cover": __webpack_require__(603),
        "title": playlist.name,
        "id": playlist.id,
        "coverRadius": ""
      }
    })], 1) : _vm._e()
  })], 2) : _vm._e(), _vm._v(" "), (_vm.newPlaylistActive) ? _c('div', {
    staticClass: "newPlaylist"
  }, [_c('div', {
    staticClass: "text-center _top",
    on: {
      "click": function($event) {
        _vm.createNewPlaylist()
      }
    }
  }, [_c('span', [_vm._v("New Playlist")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPlaylistTitle),
      expression: "newPlaylistTitle"
    }],
    attrs: {
      "type": "text",
      "name": "newPlaylist",
      "id": "newPlaylist",
      "placeholder": "Name your playlist"
    },
    domProps: {
      "value": (_vm.newPlaylistTitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPlaylistTitle = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dflex justify-space-between align-center"
  }, [_c('div', {
    staticClass: "app-bold my-3"
  }, [_vm._v("Playlist is public")]), _vm._v(" "), _c('v-switch', {
    staticClass: "flex-none widthfit",
    attrs: {
      "color": "green",
      "hide-details": ""
    },
    model: {
      value: (_vm.isNewPlaylistPublic),
      callback: function($$v) {
        _vm.isNewPlaylistPublic = $$v
      },
      expression: "isNewPlaylistPublic"
    }
  })], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('v-btn', {
    staticClass: "py-4",
    attrs: {
      "round": "",
      "dark": "",
      "block": ""
    },
    on: {
      "click": function($event) {
        _vm.addNewPlaylist()
      }
    }
  }, [_vm._v("\n      Save Playlist\n    ")])], 1) : _vm._e(), _vm._v(" "), (_vm.playlistAddedSuccess) ? _c('div', {
    staticClass: "text-center playlistAddedSuccess"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(603),
      "width": "50",
      "alt": "playlist icon"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "intro-text"
  }, [_vm._v("Added to Playlist")]), _vm._v(" "), _c('div', {
    staticClass: "body-text"
  }, [_vm._v("\n      " + _vm._s(_vm.selectedItems.length) + " " + _vm._s(_vm._f("pluralize")(_vm.type, _vm.selectedItems.length)) + " added to \"" + _vm._s(_vm.newPlaylistTitle) + "\"\n    ")])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1703 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex justify-space-between align-center footer"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1491),
      "width": "20",
      "height": "20"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'CommunityMobile'
        })
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(319),
      "width": "20",
      "height": "20"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'DiscoverMobile'
        })
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(1507),
      "width": "20",
      "height": "20"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'SpotlightMobile'
        })
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(1484),
      "width": "20",
      "height": "20"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'NotificationMobile'
        })
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(601),
      "width": "20",
      "height": "20"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'YouMobile'
        })
      }
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 1704 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page auth-page auth-login-page",
    staticStyle: {
      "background-color": "black"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "text-xs-center"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "/static/images/nav_logo_primary.png"
    }
  }), _vm._v(" "), _c('h4', [_vm._v("Sign in")])]), _vm._v(" "), _c('v-btn', {
    staticClass: "dialog-close-btn",
    nativeOn: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  }, [_c('v-icon', [_vm._v("highlight_off")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit()
      }
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('email')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    staticClass: "email",
    class: {
      input: true,
      'text-danger': _vm.errors.has('email')
    },
    attrs: {
      "name": "email",
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.has('email')) ? _c('p', {
    staticClass: "text-danger text-xs-left"
  }, [_vm._v("\n              " + _vm._s(_vm.errors.first('email')) + "\n            ")]) : _vm._e()])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "password",
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm6": "",
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "regular-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.remember),
      expression: "remember"
    }],
    attrs: {
      "id": "remember",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.remember) ? _vm._i(_vm.remember, null) > -1 : (_vm.remember)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.remember,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.remember = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.remember = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.remember = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "remember"
    }
  }, [_vm._v("Remember me")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm6": "",
      "xs12": "",
      "text-xs-right": "",
      "text-sm-right": ""
    }
  }, [_c('a', {
    staticClass: "forgot-password",
    on: {
      "click": function($event) {
        _vm.choosePage('forgot')
      }
    }
  }, [_vm._v("Forgot password")])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('v-btn', {
    staticClass: "login-button",
    attrs: {
      "block": "",
      "round": "",
      "dark": "",
      "type": "submit"
    }
  }, [_vm._v("Sign in")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('v-layout', {
    staticClass: "or-divider",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('hr', {
    staticClass: "divider"
  })]), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('p', {
    staticClass: "or"
  }, [_vm._v("OR")])]), _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('hr', {
    staticClass: "divider"
  })])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('a', {
    staticClass: "create-account mb-4",
    on: {
      "click": function($event) {
        _vm.choosePage('register')
      }
    }
  }, [_vm._v("Create an account")])])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1705 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "myVideoPlayer",
    staticClass: "stream-player-wrapper"
  }, [_c('video', {
    ref: "myVideo",
    staticClass: "video-js vjs-default-skin vjs-fluid",
    attrs: {
      "id": "my_video",
      "controls": ""
    }
  }), _vm._v(" "), (_vm.user) ? _c('div', {
    ref: "myOverlay",
    staticClass: "my_overlay"
  }, [_c('v-layout', {
    staticClass: "my-header",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": ""
    }
  }, [_c('v-toolbar', {
    staticClass: "header"
  }, [_c('v-toolbar-title', {
    on: {
      "click": function($event) {
        _vm.choosePage('album')
      }
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.choosePage('album')
      }
    },
    slot: "activator"
  }, [_c('img', {
    staticStyle: {
      "margin-top": "3px"
    },
    attrs: {
      "src": "/static/images/ic_music_active.svg",
      "width": "20"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Album")])], 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.choosePage('product')
      }
    },
    slot: "activator"
  }, [_c('img', {
    staticStyle: {
      "margin-top": "-2px"
    },
    attrs: {
      "src": "/static/images/ic_tag_active.svg",
      "width": "18"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Product")])], 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.choosePage('video')
      }
    },
    slot: "activator"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ic_video_active.svg",
      "width": "20"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Video")])], 1), _vm._v(" "), _c('v-badge', {
    attrs: {
      "color": "red"
    }
  }, [(_vm.$store.state.activity.badge.stream > 0) ? _c('span', {
    attrs: {
      "slot": "badge"
    },
    slot: "badge"
  }, [_vm._v(_vm._s(_vm.$store.state.activity.badge.stream))]) : _vm._e(), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.choosePage('feed')
      }
    },
    slot: "activator"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ic_home_active.svg",
      "width": "20"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Feed")])], 1)], 1), _vm._v(" "), _c('v-badge', {
    attrs: {
      "color": "red"
    }
  }, [(_vm.$store.state.activity.badge.activity > 0) ? _c('span', {
    attrs: {
      "slot": "badge"
    },
    slot: "badge"
  }, [_vm._v(_vm._s(_vm.$store.state.activity.badge.activity))]) : _vm._e(), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.choosePage('activity')
      }
    },
    slot: "activator"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ic_alarm_active.svg",
      "width": "18"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Activity")])], 1)], 1), _vm._v(" "), _c('v-badge', {
    attrs: {
      "color": "red"
    }
  }, [(_vm.$store.state.activity.badge.message > 0) ? _c('span', {
    attrs: {
      "slot": "badge"
    },
    slot: "badge"
  }, [_vm._v(_vm._s(_vm.$store.state.activity.badge.message))]) : _vm._e(), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.choosePage('messages')
      }
    },
    slot: "activator"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ic_message_active.svg",
      "width": "20"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Messages")])], 1)], 1), _vm._v(" "), _c('v-badge', {
    attrs: {
      "color": "red"
    }
  }, [(_vm.$store.state.activity.badge.cart > 0) ? _c('span', {
    attrs: {
      "slot": "badge"
    },
    slot: "badge"
  }, [_vm._v(_vm._s(_vm.$store.state.activity.badge.cart))]) : _vm._e(), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.choosePage('cart')
      }
    },
    slot: "activator"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ic_cart_active.svg",
      "width": "20"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Cart")])], 1)], 1), _vm._v(" "), _c('v-badge', {
    attrs: {
      "color": "red"
    }
  }, [(_vm.$store.state.activity.badge.sell > 0) ? _c('span', {
    attrs: {
      "slot": "badge"
    },
    slot: "badge"
  }, [_vm._v(_vm._s(_vm.$store.state.activity.badge.sell))]) : _vm._e(), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [(
    _vm.$store.state.auth.user && ['artist', 'brand', 'label'].indexOf(
      _vm.$store.state.auth.user.user_type
    ) > -1
  ) ? _c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.choosePage('sell')
      }
    },
    slot: "activator"
  }, [_c('img', {
    staticStyle: {
      "margin-top": "2px"
    },
    attrs: {
      "src": "/static/images/ic_delivery_active.svg",
      "width": "20"
    }
  })]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("Sell")])], 1)], 1), _vm._v(" "), (_vm.$store.state.auth.user) ? _c('v-menu', {
    staticClass: "profile-menu",
    attrs: {
      "offset-y": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.player.fullscreen()
      }
    },
    slot: "activator"
  }, [_c('div', {
    staticClass: "profile-image",
    style: ({
      'background-image': 'url(' + _vm.currentUser.avatar.thumb.url + ')',
    })
  })])], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), (_vm.user.id == _vm.currentUser.id) ? _c('div', {
    staticClass: "stream-sector"
  }, [_c('div', {
    staticClass: "stream-sector__header"
  }, [_c('div', {
    staticClass: "stream-sector__header__left"
  }, [_c('div', {
    staticClass: "avatar",
    style: ({
      'background-image': 'url(' + _vm.user.avatar.thumb.url + ')',
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.user.username))])]), _vm._v(" "), _c('div', {
    staticClass: "stream-sector__header__right"
  }, [_c('div', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm._f("timeInHours")(_vm.time)))])])]), _vm._v(" "), _c('div', {
    staticClass: "separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "stream-sector__content"
  }, [_c('div', {
    staticClass: "stream-sector__content__left"
  }, [_c('div', {
    staticClass: "user-info"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.stream.stats.views_size))]), _c('span', [_vm._v("views")])]), _vm._v(" "), (_vm.stream.assoc_type === 'Album') ? _c('label', [_c('strong', [_vm._v(_vm._s(_vm.stream.stats.downloads_size))]), _c('span', [_vm._v("downloaded")])]) : _vm._e(), _vm._v(" "), _c('label', [_c('strong', [_vm._v(_vm._s(_vm.stream.stats.followed_size))]), _c('span', [_vm._v("followed")])])])]), _vm._v(" "), _c('div', {
    staticClass: "stream-sector__content__right"
  }, [(_vm.showAttachButton) ? [_c('v-btn', {
    staticClass: "display-btn",
    attrs: {
      "dark": "",
      "color": "blue"
    },
    nativeOn: {
      "click": function($event) {
        _vm.openAlbumMerchPopup()
      }
    }
  }, [_vm._v("Display Merch / Album")])] : [_c('div', {
    staticClass: "media d-flex"
  }, [(_vm.stream && _vm.stream.assoc_type == 'Album') ? [_c('div', {
    staticClass: "media__image",
    style: (("background-image: url(" + (_vm.stream.assoc.cover.thumb.url) + ")"))
  }), _vm._v(" "), _c('div', {
    staticClass: "media__content"
  }, [_c('div', {
    staticClass: "media__title"
  }, [_vm._v(_vm._s(_vm.stream.assoc.name))]), _vm._v(" "), _c('div', {
    staticClass: "media__description"
  }, [_vm._v("\n                    " + _vm._s(_vm.stream.assoc.tracks.length) + " tracks\n                  ")])])] : (_vm.stream && _vm.stream.assoc_type == 'ShopProduct') ? [_c('div', {
    staticClass: "media__image",
    style: (("background-image: url(" + (_vm.stream.assoc.covers[0].cover.thumb.url) + ")"))
  }), _vm._v(" "), _c('div', {
    staticClass: "media__content"
  }, [_c('div', {
    staticClass: "media__title"
  }, [_vm._v(_vm._s(_vm.stream.assoc.name))]), _vm._v(" "), _c('div', {
    staticClass: "media__description"
  }, [_vm._v("\n                    $" + _vm._s(_vm._f("formatNumber")(_vm.stream.assoc.price)) + "\n                  ")])])] : (_vm.stream && _vm.stream.assoc_type == 'User') ? [_c('div', {
    staticClass: "media__image round",
    style: (("background-image: url(" + (_vm.stream.assoc.avatar.thumb.url) + ")"))
  }), _vm._v(" "), _c('div', {
    staticClass: "media__content"
  }, [_c('div', {
    staticClass: "media__title"
  }, [_vm._v("\n                    " + _vm._s(_vm.stream.assoc.username) + "\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "media__description"
  }, [_vm._v("\n                    " + _vm._s(_vm.stream.assoc.followers) + " followers\n                  ")])])] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "media__action--hover"
  }, [_c('v-btn', {
    staticClass: "display-btn",
    attrs: {
      "dark": "",
      "color": "blue"
    },
    nativeOn: {
      "click": function($event) {
        _vm.openAlbumMerchPopup()
      }
    }
  }, [_c('v-icon', [_vm._v("link")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "remove-btn",
    attrs: {
      "dark": "",
      "color": "red"
    },
    nativeOn: {
      "click": function($event) {
        _vm.removeItem()
      }
    }
  }, [_c('v-icon', [_vm._v("delete")])], 1)], 1)], 2)]], 2)])]) : _c('div', {
    staticClass: "stream-sector"
  }, [_c('div', {
    staticClass: "stream-sector__header"
  }, [_c('div', {
    staticClass: "stream-sector__header__left"
  }, [_c('div', {
    staticClass: "avatar",
    style: ({
      'background-image': 'url(' + _vm.user.avatar.thumb.url + ')',
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "user-info"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.user.username))]), _vm._v(" "), _c('div', [_c('user-follow-btn', {
    attrs: {
      "user": _vm.user,
      "theme": "dark",
      "type": "default",
      "followParam": {
        page_track: ("Stream: " + (_vm.stream.id))
      }
    }
  }), _vm._v(" "), (_vm.stream.is_reposted) ? _c('v-btn', {
    staticClass: "ml-1 px-2",
    attrs: {
      "round": "",
      "dark": "",
      "small": "",
      "color": "green"
    }
  }, [_vm._v("Reposted")]) : _c('v-btn', {
    staticClass: "ml-1 px-2",
    attrs: {
      "round": "",
      "dark": "",
      "small": "",
      "color": "blue"
    },
    nativeOn: {
      "click": function($event) {
        _vm.repostStream()
      }
    }
  }, [_vm._v("Repost Stream")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "stream-sector__header__right"
  })]), _vm._v(" "), _c('div', {
    staticClass: "separator"
  }), _vm._v(" "), (_vm.stream && _vm.stream.assoc_type == 'Album') ? _c('div', {
    staticClass: "stream-sector__content"
  }, [_c('div', {
    staticClass: "stream-sector__content__left"
  }, [_c('div', {
    staticClass: "media__image",
    style: (("background-image: url(" + (_vm.stream.assoc.cover.thumb.url) + ")"))
  }), _vm._v(" "), _c('div', {
    staticClass: "media__content"
  }, [_c('div', {
    staticClass: "media__title"
  }, [_vm._v(_vm._s(_vm.stream.assoc.name))]), _vm._v(" "), _c('div', {
    staticClass: "media__description"
  }, [_vm._v("\n              " + _vm._s(_vm.stream.assoc.tracks.length) + " tracks\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "stream-sector__content__right"
  }, [_c('v-btn', {
    attrs: {
      "dark": "",
      "color": "blue"
    },
    nativeOn: {
      "click": function($event) {
        _vm.downloadAlbum()
      }
    }
  }, [_vm._v("Download")])], 1)]) : (_vm.stream && _vm.stream.assoc_type == 'ShopProduct') ? _c('div', {
    staticClass: "stream-sector__content"
  }, [_c('div', {
    staticClass: "stream-sector__content__left"
  }, [_c('div', {
    staticClass: "media__image",
    style: (("background-image: url(" + (_vm.stream.assoc.covers[0].cover.thumb.url) + ")"))
  }, [_c('div', {
    staticClass: "media__image--hover",
    on: {
      "click": function($event) {
        _vm.removeProductFromCart()
      }
    }
  }, [_c('v-icon', [_vm._v("delete")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "media__content"
  }, [_c('div', {
    staticClass: "media__title"
  }, [_vm._v(_vm._s(_vm.stream.assoc.name))]), _vm._v(" "), _c('div', {
    staticClass: "media__description"
  }, [_vm._v("\n              $" + _vm._s(_vm._f("formatNumber")(_vm.stream.assoc.price)) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "stream-sector__content__right"
  }, [(_vm.isInCart) ? _c('v-btn', {
    attrs: {
      "dark": "",
      "color": "green"
    }
  }, [_vm._v("Added to Cart")]) : _c('v-btn', {
    attrs: {
      "dark": "",
      "color": "blue"
    },
    nativeOn: {
      "click": function($event) {
        _vm.openMerchModal()
      }
    }
  }, [_vm._v("Add to Cart")])], 1)]) : (_vm.stream && _vm.stream.assoc_type == 'User') ? _c('div', {
    staticClass: "stream-sector__content"
  }, [_c('div', {
    staticClass: "stream-sector__content__left"
  }, [_c('div', {
    staticClass: "media__image round",
    style: (("background-image: url(" + (_vm.stream.assoc.avatar.thumb.url) + ")"))
  }), _vm._v(" "), _c('div', {
    staticClass: "media__content"
  }, [_c('div', {
    staticClass: "media__title"
  }, [_vm._v(_vm._s(_vm.stream.assoc.username))]), _vm._v(" "), _c('div', {
    staticClass: "media__description"
  }, [_vm._v("\n              " + _vm._s(_vm.stream.assoc.followers) + " followers\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "stream-sector__content__right"
  }, [_c('v-btn', {
    attrs: {
      "dark": "",
      "color": "blue"
    },
    nativeOn: {
      "click": function($event) {
        _vm.visitProfile()
      }
    }
  }, [_vm._v("Visit")])], 1)]) : _vm._e()]), _vm._v(" "), (_vm.show_album_merch_popup) ? _c('div', {
    staticClass: "album-merch-popup requests"
  }, [_c('div', {
    staticClass: "dismiss-section",
    on: {
      "click": function($event) {
        _vm.closeAlbumMerchPopup()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-section"
  }, [_c('div', {
    staticClass: "requests-section"
  }, [_c('div', {
    staticClass: "header-section"
  }, [_c('p', {
    staticClass: "section-title"
  }, [_vm._v("Attach content to live video")]), _vm._v(" "), _c('div', {
    staticClass: "option-area"
  }, [_c('v-btn', {
    staticClass: "request-option-btn",
    class: {
      selected: _vm.request_tab == 'Album'
    },
    nativeOn: {
      "click": function($event) {
        _vm.onRequestTab('Album')
      }
    }
  }, [_vm._v("Album")]), _vm._v(" "), _c('v-btn', {
    staticClass: "request-option-btn",
    class: {
      selected: _vm.request_tab == 'ShopProduct'
    },
    nativeOn: {
      "click": function($event) {
        _vm.onRequestTab('ShopProduct')
      }
    }
  }, [_vm._v("Product")])], 1)]), _vm._v(" "), (_vm.request_tab == 'Album') ? _c('div', {
    staticClass: "content-section"
  }, _vm._l((_vm.albums), function(album) {
    return _c('div', {
      key: album.id,
      staticClass: "request-item",
      class: {
        selected: _vm.assoc.id == album.id
      },
      on: {
        "click": function($event) {
          _vm.selectItem('Album', album)
        }
      }
    }, [_c('div', {
      staticClass: "avatar-area"
    }, [_c('div', {
      staticClass: "avatar-image",
      style: (("background-image: url(" + (album.cover.thumb.url) + ")"))
    })]), _vm._v(" "), _c('div', {
      staticClass: "detail-area"
    }, [_c('label', {
      staticClass: "item-name"
    }, [_vm._v(_vm._s(album.name))]), _vm._v(" "), _c('label', {
      staticClass: "user-name"
    }, [_vm._v(_vm._s(album.user.username))])])])
  })) : _vm._e(), _vm._v(" "), (_vm.request_tab == 'ShopProduct') ? _c('div', {
    staticClass: "content-section"
  }, _vm._l((_vm.products), function(product) {
    return _c('div', {
      key: product.id,
      staticClass: "request-item",
      class: {
        selected: _vm.assoc.id == product.id
      },
      on: {
        "click": function($event) {
          _vm.selectItem('ShopProduct', product)
        }
      }
    }, [_c('div', {
      staticClass: "avatar-area"
    }, [_c('div', {
      staticClass: "avatar-image",
      style: (("background-image: url(" + (product.covers[0].cover.thumb.url) + ")"))
    })]), _vm._v(" "), _c('div', {
      staticClass: "detail-area"
    }, [_c('label', {
      staticClass: "item-name"
    }, [_vm._v(_vm._s(product.name))]), _vm._v(" "), _c('label', {
      staticClass: "user-name"
    }, [_vm._v(_vm._s(product.merchant.username))])])])
  })) : _vm._e()])])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('i', {
    ref: "closeButton",
    staticClass: "fa fa-close close-btn",
    on: {
      "click": function($event) {
        _vm.closePlayer()
      }
    }
  }), _vm._v(" "), (_vm.user) ? [_c('v-dialog', {
    attrs: {
      "content-class": "stream-view-confirm-dialog"
    },
    model: {
      value: (_vm.show_streaming_confirm_dialog),
      callback: function($$v) {
        _vm.show_streaming_confirm_dialog = $$v
      },
      expression: "show_streaming_confirm_dialog"
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__caption"
  }, [_vm._v("Live")]), _vm._v(" "), _c('div', {
    staticClass: "box__content"
  }, [_c('div', {
    staticClass: "box__title"
  }, [_vm._v(_vm._s(_vm.stream.name))]), _vm._v(" "), _c('div', {
    staticClass: "box__subtitle"
  }, [_vm._v("\n            " + _vm._s(_vm._.get(_vm.stream, "user.username")) + "\n            "), _c('v-icon', [_vm._v("fa-check-circle")])], 1), _vm._v(" "), _c('label', {
    staticClass: "stream-genre"
  }, [_vm._v(_vm._s(_vm._.get(_vm.stream, "genre.name")))])]), _vm._v(" "), _c('div', {
    staticClass: "box__header"
  }, [_c('label', [_vm._v(_vm._s(_vm._f("formatDateFromNow")(_vm.stream.started_at)))])]), _vm._v(" "), _c('div', {
    staticClass: "box__image",
    style: (("background-image: url(" + (_vm._.get(_vm.stream, 'cover.url')) + ")"))
  }), _vm._v(" "), _c('div', {
    staticClass: "box__footer"
  }, [(_vm.can_view) ? _c('v-btn', {
    class: {
      'theme--dark': _vm.enabledPlaying
    },
    attrs: {
      "block": "",
      "disabled": !_vm.enabledPlaying
    },
    on: {
      "click": _vm.onClick
    }
  }, [_vm._v("Watch" + _vm._s(_vm.latencyTime))]) : (_vm.exceed_capacity) ? _c('div', [_vm._v("\n            Sorry,"), _c('br'), _vm._v("\n            Broadcast is at capacity\n          ")]) : _c('v-btn', {
    attrs: {
      "dark": "",
      "block": ""
    },
    on: {
      "click": _vm.openPaymentDialog
    }
  }, [_vm._v("Pay $" + _vm._s(_vm._f("formatNumber")(_vm.stream.view_price)))])], 1)])]), _vm._v(" "), (_vm.show_merch_modal) ? _c('merch-modal', {
    attrs: {
      "item": _vm.product,
      "dismiss": _vm.closeMerchModal
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_share_dialog) ? _c('share-modal', {
    attrs: {
      "item": _vm.album,
      "dismiss": _vm.closeShareDialog
    }
  }) : _vm._e()] : _vm._e(), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.show_payment_dialog),
      callback: function($$v) {
        _vm.show_payment_dialog = $$v
      },
      expression: "show_payment_dialog"
    }
  }, [(_vm.show_payment_dialog) ? _c('payment-modal', {
    attrs: {
      "receivers": [_vm.stream.user],
      "amount": _vm.stream.view_price,
      "dismiss": _vm.closePaymentDialog,
      "finish": _vm.payViewStream
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.show_stream_delete_confirm_dialog),
      callback: function($$v) {
        _vm.show_stream_delete_confirm_dialog = $$v
      },
      expression: "show_stream_delete_confirm_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Delete a Stream")]), _vm._v(" "), _c('v-card-text', [_vm._v("If you click OK, the stream will no longer be available. Click OK to\n        delete, or click Cancel.")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "red--text darken-1",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.archiveStream()
      }
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeStreamDeleteConfirmDialog()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-spacer')], 1)], 1)], 1)], 2)
},staticRenderFns: []}

/***/ }),
/* 1706 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-page",
    class: {
      'bg-white': _vm.$vuetify.breakpoint.width <= 1280
    },
    staticStyle: {
      "background-color": "black"
    }
  }, [_c('v-container', {
    staticClass: "no-top-nav no-side-space",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('div', {
    staticClass: "login-outer"
  }, [_c('div', {
    class: {
      'login-view': _vm.$vuetify.breakpoint.width > 1280
    }
  }, [(_vm.$vuetify.breakpoint.width > 1280) ? _c('v-btn', {
    staticClass: "absolute ma-0 btn-close",
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.$router.push("/")
      }
    }
  }, [_c('v-icon', {
    staticClass: "font-size-34",
    staticStyle: {
      "background-color": "black"
    }
  }, [_vm._v("close")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "auth"
  }, [(true) ? _c('div', {
    staticClass: "d-flex flex-column",
    staticStyle: {
      "align-items": "center",
      "height": "330px",
      "min-width": "300px",
      "gap": "5px"
    }
  }, [_c('div', [_c('img', {
    staticClass: "logo",
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "src": "/static/images/nav_logo_primary.png"
    }
  })]), _vm._v(" "), _c('strong', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("Create new password")]), _vm._v(" "), _c('form', {
    staticStyle: {
      "width": "100%",
      "display": "flex",
      "flex-direction": "column",
      "justify-content": "center",
      "align-items": "center",
      "align-content": "center",
      "gap": "10px"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit()
      }
    }
  }, [_c('div', {
    staticClass: "d-flex flex-column",
    class: {
      'has-error': _vm.errors.has('password')
    },
    staticStyle: {
      "width": "100%"
    }
  }, [_c('label', {
    attrs: {
      "for": "confirm_password"
    }
  }, [_vm._v("New password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:5|max:16'),
      expression: "'required|min:5|max:16'"
    }],
    class: {
      input: true,
      'text-danger': _vm.errors.has('password'),
    },
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "name": "password",
      "type": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('password')) ? _c('p', {
    staticClass: "text-danger text-xs-left"
  }, [_vm._v("\n                  " + _vm._s(_vm.errors.first("password")) + "\n                ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-column",
    class: {
      'has-error': _vm.errors.has('confirm_password')
    },
    staticStyle: {
      "width": "100%"
    }
  }, [_c('label', {
    attrs: {
      "for": "confirm_password"
    }
  }, [_vm._v("Confirm password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirm_password),
      expression: "confirm_password"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|confirmed:password'),
      expression: "'required|confirmed:password'"
    }],
    class: {
      input: true,
      'text-danger': _vm.errors.has('confirm_password'),
    },
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "name": "confirm_password",
      "type": "password"
    },
    domProps: {
      "value": (_vm.confirm_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirm_password = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('confirm_password')) ? _c('p', {
    staticClass: "text-danger text-xs-left"
  }, [_vm._v("\n                  " + _vm._s(_vm.errors.first("confirm_password")) + "\n                ")]) : _vm._e()]), _vm._v(" "), _c('v-btn', {
    staticClass: "reset-btn",
    attrs: {
      "block": "",
      "round": "",
      "dark": "",
      "type": "submit"
    }
  }, [_vm._v("Reset")])], 1)]) : _vm._e()])], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1707 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    staticClass: "ys-dialog ys-album-report-dialog",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "left-pane",
    attrs: {
      "xs5": "",
      "px-3": "",
      "py-4": ""
    }
  }, [_c('h3', [_vm._v("Report Content")]), _vm._v(" "), _c('v-radio-group', {
    attrs: {
      "mandatory": false
    },
    model: {
      value: (_vm.active_violation),
      callback: function($$v) {
        _vm.active_violation = $$v
      },
      expression: "active_violation"
    }
  }, _vm._l((_vm.violations), function(v) {
    return _c('v-radio', {
      key: v.value,
      attrs: {
        "label": v.label,
        "value": v.value
      },
      on: {
        "change": function($event) {
          _vm.reason = ''
        }
      }
    })
  })), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('p', [_vm._v("\n      Yousound reviews all reports to verify if users are in violation of our\n      "), _c('b', [_vm._v("Terms of Service")]), _vm._v(". Accounts falsely reporting content may have\n      their accounts terminated.\n    ")])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "right-pane",
    attrs: {
      "xs7": ""
    }
  }, [(_vm.active_violation != 'infringe') ? _c('div', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_c('v-flex', {
    attrs: {
      "x12": "",
      "pa-3": ""
    }
  }, [_c('h3', [_vm._v("Specify the violation")]), _vm._v(" "), _c('p', [_vm._v("\n            Yousound reviews all reports to verify if users are in violation\n            of our "), _c('b', [_vm._v("Terms of Service")]), _vm._v("."), _c('br'), _vm._v("Accounts falsely reporting\n            content may have their accounts terminated.\n          ")]), _vm._v(" "), (_vm.violation.options.length) ? _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.violation.options,
      "data-vv-name": "reason",
      "error-messages": _vm.errors.collect('reason'),
      "label": "Choose one",
      "single-line": ""
    },
    model: {
      value: (_vm.reason),
      callback: function($$v) {
        _vm.reason = $$v
      },
      expression: "reason"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:500'),
      expression: "'required|max:500'"
    }],
    staticClass: "mt-3",
    attrs: {
      "label": "Provide additional details",
      "data-vv-name": "description",
      "error-messages": _vm.errors.collect('description'),
      "counter": 500,
      "max": "500",
      "full-width": "",
      "multi-line": "",
      "single-line": ""
    },
    model: {
      value: (_vm.description),
      callback: function($$v) {
        _vm.description = $$v
      },
      expression: "description"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "right-pane__footer"
  }, [_c('v-flex', {
    attrs: {
      "px-2": ""
    }
  }, [_c('v-divider')], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  }, [_vm._v("CANCEL")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "type": "submit",
      "flat": ""
    }
  }, [_vm._v("NEXT")])], 1)], 1)]) : _c('div', [_c('v-flex', {
    attrs: {
      "x12": "",
      "pa-3": ""
    }
  }, [_c('h3', [_vm._v("Specify the violation")]), _vm._v(" "), _c('p', [_vm._v("\n          Yousound reviews all reports to verify if users are in violation of\n          our "), _c('b', [_vm._v("Terms of Service")]), _vm._v("."), _c('br'), _vm._v("Accounts falsely reporting content\n          may have their accounts terminated.\n        ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-3 px-3",
    attrs: {
      "dark": "",
      "round": "",
      "color": "blue"
    }
  }, [_vm._v("File Copyright Claim")])], 1)], 1)]), _vm._v(" "), (_vm.show_confirm_view) ? _c('div', {
    staticClass: "confirm-view"
  }, [_c('h3', [_vm._v("Your Report Has Been Filed")]), _vm._v(" "), _c('div', [_c('label', [_vm._v("Issue:")]), _c('span', [_vm._v(_vm._s(_vm.violation.label))])]), _vm._v(" "), _c('p', [_vm._v("\n      If we find this content to be in violation of our\n      "), _c('b', [_vm._v("Term of Services")]), _vm._v(", we will remove it.\n    ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "px-4",
    attrs: {
      "dark": "",
      "round": "",
      "color": "blue"
    },
    on: {
      "click": function($event) {
        _vm.closeConfirmView()
      }
    }
  }, [_vm._v("Close")])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1708 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.currentUser.creator_verified) ? _c('div', {
    staticClass: "upload-page mx-5",
    class: {
      page: !_vm.onMobile
    }
  }, [_c('upload-nav', {
    attrs: {
      "name": "upload"
    }
  }), _vm._v(" "), _c('div', [_vm._m(0), _vm._v(" "), _c('v-container', {
    staticClass: "margin-top-header",
    attrs: {
      "fluid": "",
      "grid-list-lg": "",
      "px-0": "",
      "mb-4": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "upload-tab-container",
    attrs: {
      "sm12": "",
      "md6": "",
      "lg4": ""
    }
  }, [_c('div', {
    staticClass: "upload-tab-wrapper",
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'UploadAlbum'
        })
      }
    }
  }, [_c('div', {
    staticClass: "upload-tab-img uploadMusic"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-left my-4"
  }, [_c('h3', [_vm._v("Audio")]), _vm._v(" "), _c('div', {
    staticClass: "upload-tab-description"
  }, [_vm._v("\n                Upload audio files & assigned collaborators & splits\n              ")])])])]), _vm._v(" "), _c('v-flex', {
    staticClass: "upload-tab-container",
    attrs: {
      "sm12": "",
      "md6": "",
      "lg4": ""
    }
  }, [_c('div', {
    staticClass: "upload-tab-wrapper",
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'AddProduct'
        })
      }
    }
  }, [_c('div', {
    staticClass: "upload-tab-img uploadProduct"
  }), _vm._v(" "), _c('div', {
    staticClass: " text-left my-4"
  }, [_c('h3', [_vm._v("Digital product")]), _vm._v(" "), _c('div', {
    staticClass: "upload-tab-description"
  }, [_vm._v("\n                Upload zip files, set splits & recoup cost\n              ")])])])]), _vm._v(" "), _c('v-flex', {
    staticClass: "upload-tab-container",
    attrs: {
      "sm12": "",
      "md6": "",
      "lg4": ""
    }
  }, [_c('div', {
    staticClass: "upload-tab-wrapper",
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'VideoCreate'
        })
      }
    }
  }, [_c('div', {
    staticClass: "upload-tab-img uploadLive"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-left my-4"
  }, [_c('h3', [_vm._v("Broadcast")]), _vm._v(" "), _c('div', {
    staticClass: "upload-tab-description"
  }, [_vm._v("\n                Stream live video to your audience\n              ")])])])])], 1)], 1)], 1)], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "mt-5"
  }, [_c('div', {
    staticClass: "upload-title"
  }, [_vm._v("\n        Upload\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "upload-subtitle"
  }, [_vm._v("Add content directly to YouSound for instant worldwide distribution")])])
}]}

/***/ }),
/* 1709 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "text-poppins-16 my-2 pt-2"
  }, [_vm._v("New Releases")]), _vm._v(" "), _c('div', {
    staticClass: "horizontal-scroll"
  }, _vm._l((5), function(i) {
    return _c('div', {
      key: i,
      staticClass: "horizontal-scroll__item mr-2 mb-2"
    }, [_vm._m(1, true), _vm._v(" "), _c('div', {
      staticClass: "font-15 font-weight-500 text-white"
    }, [_vm._v("Amazing")]), _vm._v(" "), _c('div', {
      staticClass: "text-grey-4 font-15 font-weight-500"
    }, [_vm._v("Nighttime")])])
  })), _vm._v(" "), _c('div', {
    staticClass: "text-poppins-16 my-2"
  }, [_vm._v("Playlists")]), _vm._v(" "), _c('div', {
    staticClass: "horizontal-scroll"
  }, _vm._l((5), function(i) {
    return _c('div', {
      key: i,
      staticClass: "horizontal-scroll__item mr-2 mb-2"
    }, [_vm._m(2, true), _vm._v(" "), _c('div', {
      staticClass: "font-15 font-weight-500 text-white"
    }, [_vm._v("Rap Jams")])])
  })), _vm._v(" "), _c('div', {
    staticClass: "text-poppins-16 font-weight-700 my-2"
  }, [_vm._v("YOUR ALBUMS")]), _vm._v(" "), _c('div', {
    staticClass: "horizontal-scroll"
  }, _vm._l((5), function(i) {
    return _c('div', {
      key: i,
      staticClass: "horizontal-scroll__item mr-2 mb-2"
    }, [_vm._m(3, true), _vm._v(" "), _c('div', {
      staticClass: "font-15 font-weight-500 text-white"
    }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
      staticClass: "text-grey-4 font-15 font-weight-500"
    }, [_vm._v("Artist name")])])
  })), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._l((5), function(i) {
    return _c('div', {
      key: i,
      staticClass: "my-4 display-flex align-center gap-8"
    }, [_vm._m(5, true), _vm._v(" "), _vm._m(6, true)])
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "display-flex justify-space-between align-center mb-3"
  }, [_c('div', {
    staticClass: "display-flex gap-8 align-center"
  }, [_c('div', {
    staticClass: "library__title"
  }, [_vm._v("Library")])]), _vm._v(" "), _c('div', {
    staticClass: "library__select font-weight-500"
  }, [_vm._v("Create")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": __webpack_require__(1510),
      "width": "151",
      "height": "151"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": __webpack_require__(1511),
      "width": "151",
      "height": "151"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": __webpack_require__(600),
      "width": "151",
      "height": "151"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "my-4 display-flex justify-space-between align-center"
  }, [_c('div', {
    staticClass: "text-poppins-16 text-white"
  }, [_vm._v("Tracks (1,239)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": __webpack_require__(1512),
      "width": "48",
      "height": "48"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "text-poppins-16 text-white"
  }, [_vm._v("Never gonna give you up")]), _vm._v(" "), _c('div', {
    staticClass: "display-flex align-center gap-4"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1488),
      "width": "16",
      "height": "16"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-poppins-14 font-weight-500 text-grey-5"
  }, [_vm._v("\n          Rick Astley\n        ")])])])
}]}

/***/ }),
/* 1710 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "activity-product-card"
  }, [_c('v-flex', {
    staticClass: "product-info",
    attrs: {
      "xs12": "",
      "pa-0": ""
    }
  }, [_c('v-flex', {
    staticClass: "product-cover",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "product-image",
    style: ({
      'background-image': 'url(' + (_vm.object ? _vm.object.avatar.url : '') + ')',
    })
  }), _vm._v(" "), _c('v-flex', {
    staticClass: "product-actions",
    attrs: {
      "xs12": "",
      "relative": ""
    }
  }, [_c('v-flex', {
    staticClass: "touch-flex",
    attrs: {
      "xs12": ""
    },
    on: {
      "click": function($event) {
        _vm.choosePage( true ? _vm.object.slug : '')
      }
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1711 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "QR-page"
  }, [_c('img', {
    staticClass: "ys-logo",
    attrs: {
      "src": "/static/images/landing-page/ys_logo_primary-black.svg"
    }
  }), _vm._v(" "), (this.default && !this.ios && !this.android) ? _c('div', {
    staticClass: "title"
  }, [_vm._v("Download the app "), _c('br'), _vm._v(" to create your account")]) : _vm._e(), _vm._v(" "), (this.default && !this.ios && !this.android) ? _c('div', {
    staticClass: "options"
  }, [_c('div', {
    staticClass: "app-icon-container"
  }, [_c('img', {
    staticClass: "cursor-pointer",
    attrs: {
      "src": "/static/images/landing-page/apple-store.svg",
      "aspect-ratio": "1",
      "height": "54",
      "width": "187"
    },
    on: {
      "click": function($event) {
        _vm.showQR('ios')
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "app-icon-container"
  }, [_c('img', {
    staticClass: "cursor-pointer",
    attrs: {
      "src": "/static/images/landing-page/google-play.svg",
      "aspect-ratio": "1",
      "height": "54",
      "width": "187"
    },
    on: {
      "click": function($event) {
        _vm.showQR('android')
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (this.ios || this.android) ? _c('div', {
    staticClass: "options"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n      " + _vm._s(this.ios ?
    "Download iOS app" :
    "Download Android app") + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "qr-code__content--img",
    staticStyle: {
      "margin-top": "20%"
    }
  }, [(this.ios) ? _c('img', {
    attrs: {
      "src": __webpack_require__(323),
      "width": "307"
    }
  }) : _vm._e(), _vm._v(" "), (this.android) ? _c('img', {
    attrs: {
      "src": __webpack_require__(322),
      "width": "307"
    }
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (this.ios || this.android) ? _c('center', {
    on: {
      "click": _vm.reset
    }
  }, [_vm._v(" Go back ")]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1712 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.product && _vm.currentUser.creator_verified) ? _c('div', {
    staticClass: "page upload-child sell-page product-page mx-5 margin-top-header"
  }, [_c('div', {
    staticClass: "page-content"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": ""
    }
  }, [_c('h2', {
    staticClass: "my-2 album-info-title"
  }, [_vm._v("Info")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "content-section": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm7": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "product-section": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "form-group": ""
    }
  }, [_c('label', {
    staticClass: "control-label max-char-label"
  }, [_c('span', {
    staticClass: "__title"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\tProduct Name\n\t\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.name),
      expression: "product.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.product.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "form-group": ""
    }
  }, [_c('label', {
    staticClass: "control-label max-char-label"
  }, [_c('span', {
    staticClass: "__title"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\tCategory\n\t\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('v-select', {
    staticClass: "pt-0",
    attrs: {
      "placeholder": "Select",
      "items": _vm.product_categories,
      "item-text": "name",
      "item-value": "id",
      "no-data-text": "No destination available",
      "autocomplete": ""
    },
    on: {
      "change": _vm.onChangeProductCategory
    },
    model: {
      value: (_vm.product.category),
      callback: function($$v) {
        _vm.$set(_vm.product, "category", $$v)
      },
      expression: "product.category"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "form-group": ""
    }
  }, [_c('label', {
    staticClass: "control-label max-char-label"
  }, [_c('span', {
    staticClass: "__title"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("\n                          Access Level\n                        ")])]), _vm._v(" "), _c('v-select', {
    staticClass: "pt-0",
    attrs: {
      "placeholder": "Select",
      "items": _vm.access_levels,
      "item-text": "title",
      "item-value": "id",
      "no-data-text": "No destination available",
      "autocomplete": ""
    },
    model: {
      value: (_vm.product.access_level),
      callback: function($$v) {
        _vm.$set(_vm.product, "access_level", $$v)
      },
      expression: "product.access_level"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "form-group": ""
    }
  }, [_c('label', {
    staticClass: "control-label max-char-label"
  }, [_c('span', {
    staticClass: "__title"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\tDescription\n\t\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.description),
      expression: "product.description"
    }],
    staticClass: "product-description form-control non-resizable",
    attrs: {
      "maxlength": "2000"
    },
    domProps: {
      "value": (_vm.product.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "mt-4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "value": "single_order",
      "label": "Only a single product allowed per user"
    },
    model: {
      value: (_vm.product.single_order),
      callback: function($$v) {
        _vm.$set(_vm.product, "single_order", $$v)
      },
      expression: "product.single_order"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticClass: "black--text"
  }, [_vm._v("Check box if you want to limit this product to only one per user")])])], 2)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm5": "",
      "pl-4": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "product-section": ""
    }
  }, [_c('label', {
    staticClass: "control-label max-char-label"
  }, [_c('span', {
    staticClass: "__title"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tProduct Images\n\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('v-container', {
    attrs: {
      "grid-list-lg": "",
      "px-0": "",
      "pt-0": "",
      "mt-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('div', {
    staticClass: "product-image-section"
  }, [(_vm.product_image1_url) ? _c('div', {
    staticClass: "product-image",
    style: (("background-image:url(" + _vm.product_image1_url + ")")),
    attrs: {
      "id": "product_image1"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.product_image1_url) ? _c('div', {
    staticClass: "product-image-upload-section"
  }, [_c('input', {
    staticClass: "add-product-image-file",
    attrs: {
      "type": "file",
      "name": "product_image_file",
      "id": "product_image_file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.imageChanged('product_image1', $event)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "product_image_file"
    }
  }, [_c('v-icon', {
    staticClass: "camera"
  }, [_vm._v("photo_camera")]), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tUpload\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "product-image-change-section"
  }, [_c('input', {
    staticClass: "change-product-image-file",
    attrs: {
      "type": "file",
      "name": "product_image_file",
      "id": "product_image_file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.imageChanged('product_image1', $event)
      }
    }
  }), _vm._v(" "), (_vm.product_image1_url) ? _c('label', {
    attrs: {
      "for": "product_image_file"
    }
  }, [_vm._v("Change")]) : _vm._e(), (_vm.product_image1_url) ? _c('label', {
    staticClass: "text-btn",
    on: {
      "click": function($event) {
        _vm.deleteProductImage('product_image1')
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t/ Delete")]) : _vm._e()])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('div', {
    staticClass: "product-image-section"
  }, [(_vm.product_image2_url) ? _c('div', {
    staticClass: "product-image",
    style: (("background-image:url(" + _vm.product_image2_url + ")")),
    attrs: {
      "id": "product_image2"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.product_image2_url) ? _c('div', {
    staticClass: "product-image-upload-section"
  }, [_c('input', {
    staticClass: "add-product-image-file",
    attrs: {
      "type": "file",
      "name": "product_image_file2",
      "id": "product_image_file2",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.imageChanged('product_image2', $event)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "product_image_file2"
    }
  }, [_c('v-icon', {
    staticClass: "camera"
  }, [_vm._v("photo_camera")]), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tUpload\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "product-image-change-section"
  }, [_c('input', {
    staticClass: "change-product-image-file",
    attrs: {
      "type": "file",
      "name": "product_image_file2",
      "id": "product_image_file2",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.imageChanged('product_image2', $event)
      }
    }
  }), _vm._v(" "), (_vm.product_image2_url) ? _c('label', {
    attrs: {
      "for": "product_image_file2"
    }
  }, [_vm._v("Change")]) : _vm._e(), (_vm.product_image2_url) ? _c('label', {
    staticClass: "text-btn",
    on: {
      "click": function($event) {
        _vm.deleteProductImage('product_image2')
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t/ Delete")]) : _vm._e()])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('div', {
    staticClass: "product-image-section"
  }, [(_vm.product_image3_url) ? _c('div', {
    staticClass: "product-image",
    style: (("background-image:url(" + _vm.product_image3_url + ")")),
    attrs: {
      "id": "product_image3"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.product_image3_url) ? _c('div', {
    staticClass: "product-image-upload-section"
  }, [_c('input', {
    staticClass: "add-product-image-file",
    attrs: {
      "type": "file",
      "name": "product_image_file3",
      "id": "product_image_file3",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.imageChanged('product_image3', $event)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "product_image_file3"
    }
  }, [_c('v-icon', {
    staticClass: "camera"
  }, [_vm._v("photo_camera")]), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tUpload\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "product-image-change-section"
  }, [_c('input', {
    staticClass: "change-product-image-file",
    attrs: {
      "type": "file",
      "name": "product_image_file3",
      "id": "product_image_file3",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.imageChanged('product_image3', $event)
      }
    }
  }), _vm._v(" "), (_vm.product_image3_url) ? _c('label', {
    attrs: {
      "for": "product_image_file3"
    }
  }, [_vm._v("Change")]) : _vm._e(), (_vm.product_image3_url) ? _c('label', {
    staticClass: "text-btn",
    on: {
      "click": function($event) {
        _vm.deleteProductImage('product_image3')
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t/ Delete")]) : _vm._e()])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "price-option-section": ""
    }
  }, [_c('h2', {
    staticClass: "album-info-title"
  }, [_vm._v("Products (" + _vm._s(_vm.product.variants.length) + ")")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm7": "",
      "mt-4": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "product-section": ""
    }
  }, _vm._l((_vm.product.variants), function(variant, index) {
    return _c('v-layout', {
      key: index,
      attrs: {
        "row": "",
        "product-option-content": "",
        "form-group": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "sm4": ""
      }
    }, [_c('label', {
      staticClass: "control-label"
    }, [_c('label', {
      staticClass: "required"
    }, [_vm._v("*")]), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\tOption Name\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
      staticClass: "dflex align-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (variant.name),
        expression: "variant.name"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "disabled": _vm.isDigitalProduct,
        "placeholder": "Large - Black"
      },
      domProps: {
        "value": (variant.name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(variant, "name", $event.target.value)
        }
      }
    })])]), _vm._v(" "), (!_vm.isDigitalProduct) ? _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm4": ""
      }
    }, [_c('label', {
      staticClass: "control-label"
    }, [_c('label', {
      staticClass: "required"
    }, [_vm._v("*")]), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t# In Stock\n\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (variant.quantity),
        expression: "variant.quantity"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "99"
      },
      domProps: {
        "value": (variant.quantity)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(variant, "quantity", $event.target.value)
        }
      }
    })]) : _vm._e(), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm4": ""
      }
    }, [_c('label', {
      staticClass: "control-label"
    }, [_c('label', {
      staticClass: "required"
    }, [_vm._v("*")]), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tPrice\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "dflex gap-10 align-center"
    }, [_c('span', {
      staticClass: "dflex align-center"
    }, [_c('vue-numeric', {
      staticClass: "form-control primary-input",
      attrs: {
        "currency": "$",
        "currency-symbol-position": "prefix",
        "separator": ",",
        "precision": 2,
        "min": 0
      },
      model: {
        value: (variant.price),
        callback: function($$v) {
          _vm.$set(variant, "price", $$v)
        },
        expression: "variant.price"
      }
    }), _vm._v(" "), _c('v-icon', {
      staticClass: "clear-btn",
      on: {
        "click": function($event) {
          _vm.deleteVariant(index)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tclear\n\t\t\t\t\t\t\t\t\t\t\t\t\t")])], 1), _vm._v(" "), (!_vm.isDigitalProduct) ? _c('v-btn', {
      staticClass: "add-option-btn",
      nativeOn: {
        "click": function($event) {
          _vm.addVariant()
        }
      }
    }, [_c('v-icon', [_vm._v("add")])], 1) : _vm._e()], 1)])], 1)
  }))], 1), _vm._v(" "), (!_vm.isDigitalProduct) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "pa-0": "",
      "mt-5": ""
    }
  }, [_c('h2', {
    staticClass: "album-info-title"
  }, [_vm._v("Tax")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": "",
      "product-section": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "mt-2": "",
      "product-section": "",
      "mt-4": ""
    }
  }, [_c('v-checkbox', {
    on: {
      "change": _vm.resetTaxPercent
    },
    model: {
      value: (_vm.product.is_vat),
      callback: function($$v) {
        _vm.$set(_vm.product, "is_vat", $$v)
      },
      expression: "product.is_vat"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("Sellers outside of US check box for VAT/GST")])])], 2)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "mt-3": ""
    }
  }, [(_vm.product.is_vat) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Sellers Country")]), _vm._v(" "), _c('v-select', {
    staticClass: "pt-0",
    attrs: {
      "items": _vm.countries,
      "item-text": "name",
      "item-value": "name",
      "autocomplete": ""
    },
    on: {
      "change": _vm.changeTaxPercent
    },
    model: {
      value: (_vm.product.seller_location),
      callback: function($$v) {
        _vm.$set(_vm.product, "seller_location", $$v)
      },
      expression: "product.seller_location"
    }
  })], 1) : _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Sellers State")]), _vm._v(" "), _c('v-select', {
    staticClass: "pt-0",
    attrs: {
      "placeholder": "CA",
      "items": _vm.states,
      "item-text": "name",
      "item-value": "name",
      "autocomplete": ""
    },
    on: {
      "change": _vm.changeTaxPercent
    },
    model: {
      value: (_vm.product.seller_location),
      callback: function($$v) {
        _vm.$set(_vm.product, "seller_location", $$v)
      },
      expression: "product.seller_location"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [(_vm.product.is_vat) ? _c('label', {
    staticClass: "control-label"
  }, [_vm._v("Tax")]) : _c('label', {
    staticClass: "control-label"
  }, [_vm._v("State Tax")]), _vm._v(" "), _c('vue-numeric', {
    staticClass: "form-control primary-input",
    attrs: {
      "currency": "%",
      "placeholder": "8.5%",
      "currency-symbol-position": "suffix",
      "separator": ",",
      "precision": 3,
      "min": 0,
      "max": 100
    },
    model: {
      value: (_vm.product.tax_percent),
      callback: function($$v) {
        _vm.$set(_vm.product, "tax_percent", $$v)
      },
      expression: "product.tax_percent"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "price-option-section": "",
      "form-group": "",
      "mt-5": ""
    }
  }, [_c('h2', {
    staticClass: "album-info-title"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tShipping & Handling \n\t\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": ""
    }
  }, [_c('span', {
    staticClass: "text-muted mt-4"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\tPlease select "), _c('strong', [_vm._v("All other countries")]), _vm._v(" in destination to proceed.\n\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _vm._l((_vm.product.shipments), function(shipment, index) {
    return _c('v-layout', {
      key: index,
      attrs: {
        "row": "",
        "mt-3": "",
        "product-option-content": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "sm5": "",
        "pr-2": ""
      }
    }, [_c('label', {
      staticClass: "control-label"
    }, [_vm._v("Destination")]), _vm._v(" "), _c('span', {
      staticClass: "dflex align-center"
    }, [_c('v-select', {
      staticClass: "pt-0",
      attrs: {
        "items": _vm.destinations,
        "item-text": "name",
        "item-value": "value",
        "autocomplete": ""
      },
      model: {
        value: (shipment.country),
        callback: function($$v) {
          _vm.$set(shipment, "country", $$v)
        },
        expression: "shipment.country"
      }
    })], 1)]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm4": "",
        "pr-2": ""
      }
    }, [_c('label', {
      staticClass: "control-label"
    }, [_vm._v("Shipped Alone")]), _vm._v(" "), _c('vue-numeric', {
      staticClass: "form-control primary-input",
      attrs: {
        "currency": "$",
        "currency-symbol-position": "prefix",
        "separator": ",",
        "precision": 2,
        "min": 0
      },
      model: {
        value: (shipment.shipment_alone_price),
        callback: function($$v) {
          _vm.$set(shipment, "shipment_alone_price", $$v)
        },
        expression: "shipment.shipment_alone_price"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm4": ""
      }
    }, [_c('label', {
      staticClass: "control-label"
    }, [_vm._v("With others")]), _vm._v(" "), _c('div', {
      staticClass: "dflex align-center gap-10"
    }, [_c('span', {
      staticClass: "dflex align-center"
    }, [_c('vue-numeric', {
      staticClass: "form-control primary-input",
      attrs: {
        "currency": "$",
        "currency-symbol-position": "prefix",
        "separator": ",",
        "precision": 2,
        "min": 0
      },
      model: {
        value: (shipment.shipment_with_price),
        callback: function($$v) {
          _vm.$set(shipment, "shipment_with_price", $$v)
        },
        expression: "shipment.shipment_with_price"
      }
    }), _vm._v(" "), _c('v-icon', {
      staticClass: "clear-btn",
      on: {
        "click": function($event) {
          _vm.deleteShipment(index)
        }
      }
    }, [_vm._v("clear")])], 1), _vm._v(" "), _c('v-btn', {
      staticClass: "add-option-btn"
    }, [_c('v-icon', [_vm._v("add")])], 1)], 1)])], 1)
  })], 2)], 1) : _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm7": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "section-title": ""
    }
  }, [_c('h4', [_vm._v("Digital Product Upload")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "product-section": ""
    }
  }, [_c('h4', {
    staticClass: "option-title"
  }, [_vm._v(".Zip file only, 2GB max upload")]), _vm._v(" "), _c('digital-uploader', {
    attrs: {
      "digitalContent": _vm.digital_content
    }
  })], 1)], 1), _vm._v(" "), (['pending', 'collaborated'].indexOf(_vm.product.status) != -1) ? _c('v-flex', {
    staticClass: "collaborator-section",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h4', {
    staticClass: "option-title"
  }, [_vm._v("Collaborators")])]), _vm._v(" "), (
    _vm.product.status == 'pending' && _vm.product.collaborators.length < 3
  ) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "add-option-btn ma-0",
    nativeOn: {
      "click": function($event) {
        _vm.addCollaborator()
      }
    }
  }, [_c('v-icon', [_vm._v("add")]), _vm._v(" Add another collaborator\n\t\t\t\t\t\t\t\t\t\t")], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "pa-0": ""
    }
  }, [(_vm.product.collaborators && _vm.product.collaborators.length > 0) ? _c('v-layout', {
    attrs: {
      "row": "",
      "creator-wrapper": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Creator"), _c('label', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('label', {
    staticClass: "creator-name"
  }, [_vm._v(_vm._s(_vm.$store.state.auth.user.username))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm3": ""
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Profit Share"), _c('label', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('label', {
    staticClass: "creator-share"
  }, [_vm._v(_vm._s(_vm.creator_share))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm3": ""
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Recoup Cost")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.creator_recoup_cost),
      expression: "product.creator_recoup_cost"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": _vm.product.status != 'pending'
    },
    domProps: {
      "value": (_vm.product.creator_recoup_cost)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product, "creator_recoup_cost", $event.target.value)
      }
    }
  })])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.product.collaborators), function(collaborator, index) {
    return _c('v-layout', {
      key: index,
      attrs: {
        "row": "",
        "product-option-content": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "sm6": ""
      }
    }, [_c('label', {
      staticClass: "control-label"
    }, [_vm._v("Collaborators"), _c('label', {
      staticClass: "required"
    }, [_vm._v("*")])]), _vm._v(" "), _c('v-select', {
      staticClass: "pt-0",
      attrs: {
        "items": _vm.users,
        "item-text": "username",
        "item-value": "id",
        "chips": "",
        "no-data-text": "No collaborator available",
        "disabled": _vm.product.status != 'pending',
        "autocomplete": ""
      },
      scopedSlots: _vm._u([{
        key: "selection",
        fn: function(data) {
          return [_c('v-chip', {
            key: JSON.stringify(data.item),
            staticClass: "chip--select-multi",
            attrs: {
              "selected": data.selected
            },
            on: {
              "input": function($event) {
                data.parent.selectItem(data.item)
              }
            }
          }, [_c('v-avatar', [_c('img', {
            attrs: {
              "src": data.item.avatar.thumb.url
            }
          })]), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(data.item.username) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")], 1)]
        }
      }, {
        key: "item",
        fn: function(data) {
          return [(typeof data.item !== 'object') ? [_c('v-list-tile-content', {
            domProps: {
              "textContent": _vm._s(data.item)
            }
          })] : [_c('v-list-tile-avatar', [_c('img', {
            attrs: {
              "src": data.item.avatar.thumb.url
            }
          })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
            domProps: {
              "innerHTML": _vm._s(data.item.username)
            }
          })], 1)]]
        }
      }]),
      model: {
        value: (collaborator.user_id),
        callback: function($$v) {
          _vm.$set(collaborator, "user_id", $$v)
        },
        expression: "collaborator.user_id"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm6": ""
      }
    }, [_c('label', {
      staticClass: "control-label"
    }, [_vm._v("Profit Share"), _c('label', {
      staticClass: "required"
    }, [_vm._v("*")])]), _vm._v(" "), _c('v-select', {
      staticClass: "pt-0",
      attrs: {
        "items": _vm.profit_share_types,
        "item-text": "name",
        "item-value": "id",
        "disabled": _vm.product.status != 'pending',
        "autocomplete": ""
      },
      model: {
        value: (collaborator.user_share),
        callback: function($$v) {
          _vm.$set(collaborator, "user_share", $$v)
        },
        expression: "collaborator.user_share"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm3": ""
      }
    }, [_c('label', {
      staticClass: "control-label"
    }, [_vm._v("Status")]), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(collaborator.status) + "\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), (_vm.product.status == 'pending') ? _c('v-icon', {
      staticClass: "clear-btn",
      on: {
        "click": function($event) {
          _vm.deleteCollaborator(index)
        }
      }
    }, [_vm._v("clear")]) : _vm._e()], 1)
  })], 2)], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "product-save-btn",
    attrs: {
      "disabled": !_vm.isAvailableToUpdateProduct,
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        _vm.beforeSaveProduct()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('a', {
    staticClass: "cancel-button",
    on: {
      "click": function($event) {
        _vm.cancelToSaveProduct()
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1713 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "analytics_modal"
  }, [_c('div', {
    staticClass: "modal_body"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal_content"
  }, [_c('h2', {
    staticClass: "modal_content_title"
  }, [_vm._v("\n\t\t\t\tTrack 60+ metrics, including:\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "modal_points-div"
  }, [_c('ul', {
    staticClass: "_points"
  }, [_vm._l((this.proBenefits), function(item) {
    return _c('li', {
      staticClass: "_point"
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(item) + "\n\t\t\t\t\t")])
  }), _vm._v(" "), _c('li', {
    staticClass: "_point"
  }, [_vm._v("Content Performance")])], 2)]), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.currentUser.request_status !== 'denied') ? _c('div', [_c('v-btn', {
    staticClass: "py-4 button-wrapper",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "round": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.planUpgrade()
      }
    }
  }, [_vm._v("\n\t\t\t\t\tUpgrade\n\t\t\t\t")])], 1) : _vm._e()])]), _vm._v(" "), (_vm.showGetVerifiedModal) ? _c('div', [_c('div', {
    staticClass: "verified-main"
  }, [_c('div', {
    staticClass: "modal-inner"
  }, [_c('div', {
    staticClass: "text-center _title"
  }, [_vm._v("Get verified")]), _vm._v(" "), _c('div', {
    staticClass: "margin-vertical"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "_lable"
  }, [_vm._v("Social channel")]), _vm._v(" "), _c('v-menu', {
    staticClass: "social-type-menu",
    attrs: {
      "content-class": "s-menu__content"
    }
  }, [_c('v-select', {
    staticClass: "social-types-selector py-0",
    class: {
      '_filled': _vm.socialChannel
    },
    attrs: {
      "slot": "activator",
      "placeholder": _vm.socialChannel ? _vm.socialChannel.title : 'Choose',
      "single-line": "",
      "hide-details": ""
    },
    slot: "activator"
  }), _vm._v(" "), _vm._l((_vm.socialChannels), function(channel, i) {
    return _c('div', {
      key: i,
      staticClass: "channel-info",
      class: [((channel.id) + "-menu")],
      on: {
        "click": function($event) {
          _vm.selectedChannel(channel)
        }
      }
    }, [_c('div', {
      staticClass: "_title"
    }, [_vm._v(_vm._s(channel.title))]), _vm._v(" "), _c('div', {
      staticClass: "_tags"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(channel.tags) + "\n\t\t\t\t\t\t\t\t")])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "_lable"
  }, [_vm._v("Social Username")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.socialUsername),
      expression: "socialUsername"
    }],
    staticClass: "_socialHandle width100",
    attrs: {
      "placeholder": "Username",
      "type": "text"
    },
    domProps: {
      "value": (_vm.socialUsername)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.socialUsername = $event.target.value
      }
    }
  })], 1)]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-3 px-3",
    attrs: {
      "round": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.verifiedSocialAttributes()
      }
    }
  }, [_vm._v("Get Verified")]), _vm._v(" "), _c('div', {
    staticClass: "close-button",
    on: {
      "click": function($event) {
        _vm.hideModal()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(80),
      "width": "11"
    }
  })])], 1)])]) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "plans-dialog"
    },
    model: {
      value: (_vm.initPayment),
      callback: function($$v) {
        _vm.initPayment = $$v
      },
      expression: "initPayment"
    }
  }, [_c('payment-card', {
    attrs: {
      "item": _vm.selectedPlan,
      "totalPayable": _vm.totalPayable,
      "closePayment": _vm.closePaymentModal
    }
  })], 1), _vm._v(" "), (_vm.currentUser !== null) ? _c('v-dialog', {
    model: {
      value: (_vm.plansUpgradeModal),
      callback: function($$v) {
        _vm.plansUpgradeModal = $$v
      },
      expression: "plansUpgradeModal"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Plan Changes")]), _vm._v(" "), (_vm.plansName[_vm.currentUser.plan] == 'Listener' || _vm.currentUser.plan == null) ? _c('v-card-text', [_c('p', [_vm._v("Your current plan is "), _c('b', [_vm._v(" " + _vm._s(_vm.currentUser.plan == null ? "Free Plan" : _vm.plansName[_vm.currentUser.plan]) + " ")]), _vm._v(" and you are trying to upgrade it to "), _c('b', [_vm._v(" Advanced Plan. ")])]), _vm._v(" "), _c('p', [_vm._v("You will remain in your current plan until admin approve your account. Once you verified, you will be charged\n\t\t\t\t\taccording to subscription of current plan and new chosen plan.\n\t\t\t\t\tAre you sure you want to continue?\n\t\t\t\t")])]) : _c('v-card-text', [_c('p', [_vm._v("Your current plan is "), _c('b', [_vm._v(" " + _vm._s(_vm.plansName[_vm.currentUser.plan]) + " ")]), _vm._v(" and you are trying to upgrade it to "), _c('b', [_vm._v(" Advanced Plan. ")])]), _vm._v(" "), _c('p', [_vm._v("This will have an immediate effect and you will be charged according to subscription of current\n\t\t\t\t\tplan and new chosen plan.\n\t\t\t\t\tAre you sure you want to continue?\n\t\t\t\t")])]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.verifyUserType()
      }
    }
  }, [_vm._v("Ok\n\t\t\t\t")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.hidePlanChangeModal()
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal_insight"
  }, [_c('div', [_c('h2', {
    staticClass: "modal_main_title mb-1"
  }, [_vm._v("Unlock analytics insights")]), _vm._v(" "), _c('p', {
    staticClass: "modal_text"
  }, [_vm._v("Get in-depth metrics for all of your content & maximize your growth.")])]), _vm._v(" "), _c('div', {
    staticClass: "modal_graphic mt-3"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1552),
      "width": "100%"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal_pricing"
  }, [_c('p', {
    staticClass: "_price"
  }, [_c('span', {
    staticClass: "currency"
  }, [_vm._v("$")]), _vm._v("100"), _c('span', {
    staticClass: "_time"
  }, [_vm._v(" /month")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footnote"
  }, [_vm._v("\n\t\t\t\t\tIf we need to contact you we will send a direct message from "), _c('strong', [_vm._v("@yousoundapp")])])
}]}

/***/ }),
/* 1714 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('content-top-header', {
    staticClass: "black-theme"
  }, [_c('template', {
    slot: "topHeader"
  }, [_c('ul', _vm._l((_vm.tabs), function(tab) {
    return _c('li', {
      key: tab.id,
      staticClass: "nav-li",
      class: [{
        active: _vm.isActiveTab(tab.id)
      }, ("nav-" + (tab.id))],
      attrs: {
        "href": ("#" + (tab.id))
      }
    }, [_c('label', {
      staticClass: "nav-label",
      on: {
        "click": function($event) {
          _vm.onTab(tab.id)
        }
      }
    }, [_vm._v("\n            " + _vm._s(tab.title) + "\n          ")])])
  }))])], 2), _vm._v(" "), _c('div', {
    staticClass: "page-content margin-top-header"
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    staticClass: "min-100",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "px-4 pt-4",
    attrs: {
      "xs12": "",
      "sm7": "",
      "order-section": ""
    }
  }, [_c('div', {
    staticClass: "mb-4 main-heading"
  }, [_vm._v("Order #: "), _c('b', [_vm._v(_vm._s(_vm.order_detail.id))])]), _vm._v(" "), _c('div', {
    staticClass: "order-container"
  }, _vm._l((_vm.order_detail.items), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "order-item"
    }, [_c('div', {
      staticClass: "order-content-section pa-0",
      attrs: {
        "sm12": ""
      }
    }, [_c('div', {
      staticClass: "product-cover-image"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'SingleProduct',
          params: {
            id: item.product.id
          }
        }
      }
    }, [_c('activity-product-card', {
      attrs: {
        "object": item.product,
        "price-show": false
      }
    })], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "product-content"
    }, [_c('div', {
      staticClass: "product-content-row"
    }, [_c('div', {
      staticClass: "product-name"
    }, [_c('router-link', {
      attrs: {
        "to": "#"
      }
    }, [_c('span', {
      staticClass: "black--text"
    }, [_vm._v("\n                          " + _vm._s(item.product.name) + " | " + _vm._s(item.product_variant.name) + "\n                        ")])])], 1), _vm._v(" "), _c('div', {
      staticClass: "product-content-row justify-space-between pt-0"
    }, [_c('div', [_c('router-link', {
      staticClass: "user-name",
      attrs: {
        "to": ("/" + (item.product.merchant.slug))
      }
    }, [_vm._v("\n                          " + _vm._s(item.product.merchant.username) + "\n                        ")])], 1)]), _vm._v(" "), _c('label', {
      staticClass: "product-price"
    }, [_vm._v("\n                      Quantity: "), _c('b', [_vm._v(_vm._s(item.quantity))])])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
      staticClass: "product-action-row justify-space-between"
    }, [_c('label', {
      staticClass: "product-price"
    }, [_vm._v("\n                    $" + _vm._s(_vm._f("formatNumber")(item.price)) + "\n                  ")])])], 1)])])
  })), _vm._v(" "), _c('div', {
    staticClass: "orders-status-section"
  }, [_c('div', {
    staticClass: "status-row"
  }, [_c('label', {
    staticClass: "status-title"
  }, [_vm._v("Subtotal")]), _vm._v(" "), _c('label', {
    staticClass: "status-title value"
  }, [_vm._v("$" + _vm._s(_vm._f("formatNumber")(_vm.subTotal)))])]), _vm._v(" "), _c('div', {
    staticClass: "status-row"
  }, [_c('label', {
    staticClass: "status-title"
  }, [_vm._v("Shipping")]), _vm._v(" "), _c('label', {
    staticClass: "status-title value"
  }, [_vm._v("\n                  $" + _vm._s(_vm._f("formatNumber")(_vm.shippingTotal)) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "status-row"
  }, [_c('label', {
    staticClass: "status-title"
  }, [_vm._v("Sales Tax")]), _vm._v(" "), _c('label', {
    staticClass: "status-title value"
  }, [_vm._v("$" + _vm._s(_vm._f("formatNumber")(_vm.taxTotal)))])]), _vm._v(" "), _c('div', {
    staticClass: "status-row"
  }, [_c('label', {
    staticClass: "status-title"
  }, [_vm._v("Stripe Fee")]), _vm._v(" "), _c('label', {
    staticClass: "status-title value"
  }, [_vm._v("$" + _vm._s(_vm._f("formatNumber")(_vm.stripeFee)))])]), _vm._v(" "), _c('div', {
    staticClass: "total-row"
  }, [_c('label', {
    staticClass: "status-title"
  }, [_vm._v("Total")]), _vm._v(" "), _c('label', {
    staticClass: "status-title value"
  }, [_c('span', [_vm._v("USD")]), _vm._v("$" + _vm._s(_vm._f("formatNumber")(_vm.total)))])])])]), _vm._v(" "), _c('v-flex', {
    staticClass: "orders-section-container px-5 pt-4",
    attrs: {
      "xs12": "",
      "sm5": ""
    }
  }, [_c('div', {
    staticClass: "mb-3"
  }, [_c('div', {
    staticClass: "title mb-2"
  }, [_vm._v("Shipment status")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("Sellers have 21 days to ship your items")])]), _vm._v(" "), _c('div', {
    staticClass: "pendingDiv"
  }, [_c('div', {
    staticClass: "bold"
  }, [_vm._v("\n                " + _vm._s(this.order_status[_vm.order_detail.status]) + "\n              ")]), _vm._v(" "), (_vm.order_detail.status == 'order_pending') ? _c('div', [_vm._v(_vm._s(_vm.remainingDaysForShipment()) + " days left to ship or you will receive an automatic refund")]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.order_detail.items), function(item) {
    return _c('div', {
      staticClass: "trackDiv mt-3"
    }, [_c('div', {
      staticClass: "mb-2"
    }, [_c('span', {
      staticClass: "bold"
    }, [_vm._v("\n                    Shipped\n                  ")]), _vm._v("\n                  with "), _c('span', {
      staticClass: "bold"
    }, [_vm._v("\n                    " + _vm._s(item.tracking_site) + "\n                  ")])]), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "bold"
    }, [_vm._v("\n                  Tracking:\n                ")]), _vm._v(" " + _vm._s(item.tracking_number) + "\n              ")]), _vm._v(" "), _c('div', [_c('v-btn', {
      staticClass: "green-btn mt-2"
    }, [_vm._v("Track order")])], 1)])
  })], 2)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1715 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-section"
  }, [_c('h2', [_vm._v("Cookie Policy")]), _vm._v(" "), _c('h3', [_vm._v("What Are Cookies?")]), _vm._v(" "), _c('p', [_vm._v("\n    Cookies are small text files that are stored on your device (computer, smartphone, or other internet-enabled device) when you visit a website. They are widely used to make websites work, or work more efficiently, as well as to provide information to the owners of the site. This page describes the information they collect, how we use it, and why we sometimes need to store these cookies. We will also explain how you can prevent these cookies from being stored; however, doing so may downgrade or 'break' certain elements of the site’s functionality. For more general information on cookies, you can refer to the Wikipedia article on\n    "), _c('a', {
    attrs: {
      "href": "https://en.wikipedia.org/wiki/HTTP_cookie",
      "target": "_blank"
    }
  }, [_vm._v("HTTP Cookies")]), _vm._v(".\n  ")]), _vm._v(" "), _c('h3', [_vm._v("How We Use Cookies")]), _vm._v(" "), _c('p', [_vm._v("\n    We use cookies for various purposes detailed below. Unfortunately, in most cases, there are no industry-standard options for disabling cookies without completely disabling the functionality and features they add to this site. It is recommended that you keep all cookies enabled if you are not sure whether you need them or not, as they may be used to provide a service that you use.\n  ")]), _vm._v(" "), _c('h3', [_vm._v("Disabling Cookies")]), _vm._v(" "), _c('p', [_vm._v("\n    You can prevent the setting of cookies by adjusting the settings on your browser (see your browser Help for how to do this). Be aware that disabling cookies will affect the functionality of this and many other websites that you visit. Disabling cookies will usually result in also disabling certain functionality and features of this site. Therefore, it is recommended that you do not disable cookies.\n  ")]), _vm._v(" "), _c('h3', [_vm._v("The Cookies We Set")]), _vm._v(" "), _c('ul', [_c('li', [_c('strong', [_vm._v("Account related cookies")]), _vm._v(": If you create an account with us, we will use cookies for the management of the signup process and general administration. These cookies will usually be deleted when you log out; however, in some cases, they may remain afterward to remember your site preferences when logged out.\n    ")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Login related cookies")]), _vm._v(": We use cookies when you are logged in so that we can remember this fact. This prevents you from having to log in every single time you visit a new page. These cookies are typically removed or cleared when you log out to ensure that you can only access restricted features and areas when logged in.\n    ")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Email newsletters related cookies")]), _vm._v(": This site offers newsletter or email subscription services, and cookies may be used to remember if you are already registered and whether to show certain notifications which might only be valid to subscribed/unsubscribed users.\n    ")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Orders processing related cookies")]), _vm._v(": This site offers e-commerce or payment facilities, and some cookies are essential to ensure that your order is remembered between pages so that we can process it properly.\n    ")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Forms related cookies")]), _vm._v(": When you submit data through a form such as those found on contact pages or comment forms, cookies may be set to remember your user details for future correspondence.\n    ")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Site preferences cookies")]), _vm._v(": In order to provide you with a great experience on this site, we provide the functionality to set your preferences for how this site runs when you use it. To remember your preferences, we need to set cookies so that this information can be called whenever you interact with a page affected by your preferences.\n    ")])]), _vm._v(" "), _c('h3', [_vm._v("Third Party Cookies")]), _vm._v(" "), _c('p', [_vm._v("\n    In some special cases, we also use cookies provided by trusted third parties. The following section details which third-party cookies you might encounter through this site.\n  ")]), _vm._v(" "), _c('ul', [_c('li', [_c('strong', [_vm._v("Google Analytics")]), _vm._v(": This site uses Google Analytics, one of the most widespread and trusted analytics solutions on the web, to help us understand how you use the site and ways that we can improve your experience. These cookies may track things such as how long you spend on the site and the pages that you visit so we can continue to produce engaging content. For more information on Google Analytics cookies, see the official\n      "), _c('a', {
    attrs: {
      "href": "https://policies.google.com/technologies/cookies",
      "target": "_blank"
    }
  }, [_vm._v("Google Analytics page")]), _vm._v(".\n    ")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Testing new features")]), _vm._v(": From time to time, we test new features and make subtle changes to the way that the site is delivered. When we are still testing new features, these cookies may be used to ensure that you receive a consistent experience while on the site while ensuring we understand which optimizations our users appreciate the most.\n    ")])]), _vm._v(" "), _c('h3', [_vm._v("More Information")]), _vm._v(" "), _c('p', [_vm._v("\n    Hopefully, this has clarified things for you. As mentioned earlier, if there is something that you are not sure whether you need or not, it is usually safer to leave cookies enabled in case it interacts with one of the features you use on our site.\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    However, if you are still looking for more information, then you can contact us through one of our preferred contact methods:\n  ")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Email: "), _c('a', {
    attrs: {
      "href": "mailto:support@yousound.com"
    }
  }, [_vm._v("support@yousound.com")])])])])
}]}

/***/ }),
/* 1716 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video-holder-box",
    style: ({
      'pointer-events': _vm.currentUser.free_trial_time <= 0 && !this.isSubscribed ? 'none' : ''
    })
  }, [_c('discover-nav', {
    class: _vm.show_nav ? 'navVisible' : 'navHide',
    attrs: {
      "pageName": "video",
      "disabled": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "invisible-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "video-container-main",
    on: {
      "mouseenter": function($event) {
        _vm.show_video_overlay = true;
        _vm.show_nav = true
      },
      "mouseleave": function($event) {
        _vm.hideOverlay();
        _vm.show_nav = false
      }
    }
  }, [_c('video', {
    ref: "myVideoPlayer",
    staticClass: "video-js vjs-default-skin vjs-fluid",
    class: {
      onMobile: _vm.onMobile
    },
    attrs: {
      "id": "myVideoPlayer",
      "playsinline": _vm.onMobile,
      "disabled": true,
      "control": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "video-overlay",
    class: _vm.show_video_overlay ? 'visibleOverlay' : 'hideOverlay'
  }, [_c('div', {
    staticClass: "vo-content"
  }, [_c('h2', {
    staticClass: "vo-heading"
  }, [_vm._v("' " + _vm._s(_vm.video.name) + " '")]), _vm._v(" "), _c('div', {
    staticClass: "vo-following-main"
  }, [_c('div', {
    staticClass: "dflex align-center gap-10"
  }, [_c('div', {
    staticClass: "profile-img",
    style: ({
      'background-image': 'url(' + _vm.video.user.avatar.url + ')',
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "profile-text"
  }, [_vm._v(_vm._s(_vm.video.user.username))])]), _vm._v(" "), _c('div', {
    staticClass: "following-btns"
  }, [(_vm.video.user.id !== _vm.currentUser.id) ? _c('user-follow-btn', {
    attrs: {
      "user": _vm.video.user,
      "type": "default",
      "borderRadius": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "icon-button",
    on: {
      "click": function($event) {
        _vm.addToCollection()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(57),
      "width": "18"
    }
  })]), _vm._v(" "), _c('v-btn', {
    staticClass: "icon-button",
    on: {
      "click": function($event) {
        _vm.openShareModal()
      }
    }
  }, [_c('img', {
    staticClass: "invert",
    attrs: {
      "src": __webpack_require__(222),
      "width": "18"
    }
  })]), _vm._v(" "), _c('v-btn', {
    staticClass: "icon-button"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(761),
      "width": "18"
    }
  })])], 1)])]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.assoc.assoc_type !== null && _vm.displayListingProduct) ? _c('div', {
    staticClass: "ad-d-bar"
  }, [_c('img', {
    attrs: {
      "src": _vm.assoc.itemPic,
      "width": "100%"
    }
  })]) : _vm._e()]), _vm._v(" "), (_vm.displayListingProduct && _vm.assoc.assoc_type !== null) ? _c('div', {
    staticClass: "ad-show"
  }, [_c('div', {
    staticClass: "ad-show-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.assoc.itemPic,
      "width": "100%"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ad-show-content"
  }, [_c('div', {
    staticClass: "dflex align-center gap-10"
  }, [_c('div', {
    staticClass: "profile-img",
    style: ({
      'background-image': 'url(' + _vm.assoc.userImageUrl + ')',
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "profile-text"
  }, [_vm._v(_vm._s(_vm.assoc.username))])]), _vm._v(" "), _c('div', {
    staticClass: "ad-info my-3"
  }, [_c('div', {
    staticClass: "category"
  }, [_vm._v(_vm._s(_vm.assoc.category))]), _vm._v(" "), _c('div', {
    staticClass: "name my-1"
  }, [_vm._v(_vm._s(_vm.assoc.name))]), _vm._v(" "), (_vm.assoc.assoc_type === 'ShopProduct') ? _c('div', {
    staticClass: "price"
  }, [_vm._v("$" + _vm._s(_vm.assoc.price))]) : _vm._e()]), _vm._v(" "), (_vm.assoc.assoc_type === 'ShopProduct') ? _c('div', {
    staticClass: "ad-option ad-d-btn mt-2"
  }, [_c('v-select', {
    attrs: {
      "items": _vm.options(),
      "item-text": "name",
      "item-value": "id",
      "placeholder": "Option"
    },
    model: {
      value: (_vm.option),
      callback: function($$v) {
        _vm.option = $$v
      },
      expression: "option"
    }
  }), _vm._v(" "), (_vm.assoc.assoc_type === 'ShopProduct') ? _c('v-btn', {
    staticClass: "ad-btn",
    attrs: {
      "block": ""
    },
    on: {
      "click": function($event) {
        _vm.assoc.stock > 0 ? _vm.addToCart() : ''
      }
    }
  }, [(_vm.assoc.stock > 0) ? _c('span', [_vm._v("Add to cart")]) : _c('span', [_vm._v("Out of Stock")])]) : _vm._e()], 1) : _c('div', [_c('v-btn', {
    staticClass: "ad-btn",
    attrs: {
      "block": ""
    },
    on: {
      "click": function($event) {
        _vm.playSong()
      }
    }
  }, [_c('span', [_vm._v("Play Song")])])], 1)]), _vm._v(" "), _c('div')]) : _vm._e()]), _vm._v(" "), (_vm.currentUser && _vm.currentUser.creator_verified && _vm.video.user.stripe_connected && _vm.video.user.creator_verified && _vm.video.user.id !== _vm.currentUser.id) ? _c('li', [(_vm.showSendLoveModal) ? _c('send-love-modal', {
    attrs: {
      "item": _vm.video.user,
      "dismiss": _vm.dismissLoveDialog
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('li', [(_vm.showShareModal) ? _c('share-modal', {
    attrs: {
      "item": _vm.video,
      "type": "Stream",
      "dismiss": _vm.dismissShareDialog
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.showListeningMessage),
      callback: function($$v) {
        _vm.showListeningMessage = $$v
      },
      expression: "showListeningMessage"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Still Listening")]), _vm._v(" "), _c('v-card-text', [_vm._v("Are you still Listening?")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.hideListeningMessage($event)
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), (this.user) ? _c('div', [_c('v-dialog', {
    attrs: {
      "content-class": "dialog-w_auto dialog-no_shadow"
    },
    model: {
      value: (_vm.show_modalCard1),
      callback: function($$v) {
        _vm.show_modalCard1 = $$v
      },
      expression: "show_modalCard1"
    }
  }, [_c('div', {
    staticClass: "modal-card"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": __webpack_require__(19),
      "width": "135px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-card-img"
  }, [_c('div', {
    staticClass: "modal-card-img-inner",
    style: ({
      'background-image': 'url(' + this.user.avatar.thumb.url + ')',
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center user-box"
  }, [_c('p', [_vm._v("Sign up to experience")]), _vm._v(" "), _c('div', {
    staticClass: "user-div"
  }, [_c('p', {
    staticClass: "user-text"
  }, [_vm._v(" " + _vm._s(this.user.username))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(23),
      "width": "15px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "button-wrapper"
  }, [_c('router-link', {
    attrs: {
      "to": "/signup"
    }
  }, [_c('button', {
    staticClass: "modal-button"
  }, [_vm._v("\n\t\t\t\t\t\t\tCreate account\n\t\t\t\t\t\t")])])], 1)])]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "dialog-w_auto dialog-no_shadow"
    },
    model: {
      value: (_vm.show_modalCard2),
      callback: function($$v) {
        _vm.show_modalCard2 = $$v
      },
      expression: "show_modalCard2"
    }
  }, [_c('div', {
    staticClass: "modal-card"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": __webpack_require__(19),
      "width": "135px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-card-img"
  }, [_c('div', {
    staticClass: "modal-card-img-inner",
    style: ({
      'background-image': 'url(' + this.user.avatar.thumb.url + ')',
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center user-box"
  }, [_c('p', [_vm._v("Sign up to experience")]), _vm._v(" "), _c('div', {
    staticClass: "user-div"
  }, [_c('p', {
    staticClass: "user-text"
  }, [_vm._v(" " + _vm._s(this.user.username))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(23),
      "width": "15px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "text-center font-inter"
  }, [_c('p', [_vm._v("Get full access. "), _c('b', [_vm._v("50%")]), _vm._v(" of your subscription is shared with creators you stream most. See who you support!")])]), _vm._v(" "), _c('div', {
    staticClass: "button-wrapper"
  }, [_c('router-link', {
    attrs: {
      "to": "/settings"
    }
  }, [_c('button', {
    staticClass: "modal-button"
  }, [_vm._v("\n\t\t\t\t\t\t\tStart 30 day free trial\n\t\t\t\t\t\t")])])], 1)])]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "dialog-w_50 dialog-no_shadow"
    },
    model: {
      value: (_vm.show_modalCard3),
      callback: function($$v) {
        _vm.show_modalCard3 = $$v
      },
      expression: "show_modalCard3"
    }
  }, [_c('div', {
    staticClass: "modal-card-main"
  }, [_c('div', {
    staticClass: "modal-card-split"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": __webpack_require__(19),
      "width": "135px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-card-img"
  }, [_c('div', {
    staticClass: "modal-card-img-inner",
    style: ({
      'background-image': 'url(' + this.user.avatar.thumb.url + ')',
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "user-box"
  }, [_c('p', [_vm._v("Sign up to experience")]), _vm._v(" "), _c('div', {
    staticClass: "user-div"
  }, [_c('p', {
    staticClass: "user-text"
  }, [_vm._v(_vm._s(this.user.username))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(23),
      "width": "15px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "button-wrapper"
  }, [_c('router-link', {
    attrs: {
      "to": "/signup"
    }
  }, [_c('button', {
    staticClass: "modal-button"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tCreate account\n\t\t\t\t\t\t\t")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-card-title-img",
    style: (("background-image: url(" + _vm.videoLoading + ")"))
  }, [_c('video', {
    attrs: {
      "playsinline": "",
      "autoplay": "",
      "loop": "",
      "id": "bgvid"
    }
  }, [(_vm.spotlightVideoSource) ? _c('source', {
    attrs: {
      "src": ("https://stream.mux.com/" + _vm.spotlightVideoSource + "/low.mp4"),
      "type": "video/mp4"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "volume-button"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(43),
      "width": "17px"
    }
  })])])])]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "dialog-w_50 dialog-no_shadow"
    },
    model: {
      value: (_vm.show_modalCard4),
      callback: function($$v) {
        _vm.show_modalCard4 = $$v
      },
      expression: "show_modalCard4"
    }
  }, [_c('div', {
    staticClass: "modal-card-main"
  }, [_c('div', {
    staticClass: "modal-card-split"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": __webpack_require__(19),
      "width": "135px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-card-img"
  }, [_c('div', {
    staticClass: "modal-card-img-inner",
    style: ({
      'background-image': 'url(' + this.user.avatar.thumb.url + ')',
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "user-box"
  }, [_c('p', [_vm._v("Sign up to experience")]), _vm._v(" "), _c('div', {
    staticClass: "user-div"
  }, [_c('p', {
    staticClass: "user-text"
  }, [_vm._v(_vm._s(this.user.username))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(23),
      "width": "15px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "font-inter"
  }, [_c('p', [_vm._v("Get full access. "), _c('b', [_vm._v("50%")]), _vm._v(" of your subscription is shared with creators you stream most. See who you support!")])]), _vm._v(" "), _c('div', {
    staticClass: "button-wrapper"
  }, [_c('router-link', {
    attrs: {
      "to": "/settings"
    }
  }, [_c('button', {
    staticClass: "modal-button"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tStart 30 day free trial\n\t\t\t\t\t\t\t")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-card-title-img",
    style: (("background-image: url(" + _vm.videoLoading + ")"))
  }, [_c('video', {
    attrs: {
      "playsinline": "",
      "autoplay": "",
      "loop": "",
      "id": "bgvid"
    }
  }, [(_vm.spotlightVideoSource) ? _c('source', {
    attrs: {
      "src": ("https://stream.mux.com/" + _vm.spotlightVideoSource + "/low.mp4"),
      "type": "video/mp4"
    }
  }) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "volume-button"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(43),
      "width": "17px"
    }
  })])])])])], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "project-icon"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1530),
      "width": "25"
    }
  })])
}]}

/***/ }),
/* 1717 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spotlight relative"
  }, [_c('div', {
    directives: [{
      name: "touch",
      rawName: "v-touch",
      value: ({
        up: function () { return _vm.swipe(true); },
        down: function () { return _vm.swipe(false); },
      }),
      expression: "{\n      up: () => swipe(true),\n      down: () => swipe(false),\n    }"
    }],
    staticClass: "spotlight__image"
  }, [(_vm.currentIndex == 0) ? _c('img', {
    attrs: {
      "src": __webpack_require__(1521)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentIndex == 1) ? _c('img', {
    attrs: {
      "src": __webpack_require__(1522)
    }
  }) : _c('img', {
    attrs: {
      "src": __webpack_require__(1523)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "spotlight__content full-width absolute"
  }, [_c('div', {
    staticClass: "display-flex justify-space-between align-center"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(44),
      "width": "100"
    },
    on: {
      "click": function($event) {
        _vm.$router.push('/')
      }
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "spotlight__action display-flex flex-column align-center"
  }, [_c('div', {
    staticClass: "display-flex flex-column justify-center mb-3",
    on: {
      "click": function($event) {
        _vm.isSend = true
      }
    }
  }, [_c('img', {
    staticClass: "mb-1",
    attrs: {
      "src": __webpack_require__(1493),
      "width": "19",
      "height": "19"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-poppins-14 text-white"
  }, [_vm._v("23")])]), _vm._v(" "), _c('div', {
    staticClass: "display-flex flex-column justify-center mb-3",
    on: {
      "click": function($event) {
        _vm.isComment = true
      }
    }
  }, [_c('img', {
    staticClass: "mb-1",
    attrs: {
      "src": __webpack_require__(1489),
      "width": "20",
      "height": "20"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-poppins-14 text-white"
  }, [_vm._v("1.2k")])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('Footer')], 1), _vm._v(" "), _c('v-bottom-sheet', {
    attrs: {
      "hide-overlay": ""
    },
    model: {
      value: (_vm.isComment),
      callback: function($$v) {
        _vm.isComment = $$v
      },
      expression: "isComment"
    }
  }, [_c('v-list', {
    staticClass: "px-4"
  }, [_c('v-subheader', {
    staticClass: "text-inter-14 font-weight-600 mb-3 justify-center"
  }, [_vm._v("\n        Comments\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "display-flex gap-10 mb-5 pb-5"
  }, [_c('img', {
    staticClass: "rounded",
    attrs: {
      "src": __webpack_require__(30),
      "width": 44,
      "height": 44
    }
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "text-inter-14"
  }, [_c('span', {
    staticClass: "font-weight-600"
  }, [_vm._v(" superman10 ")]), _vm._v(" "), _c('span', {
    staticClass: "font-weight-500 text-grey-3"
  }, [_vm._v("12s")])]), _vm._v(" "), _c('div', {
    staticClass: "text-inter-14 font-weight-500"
  }, [_vm._v("\n            I really want to do those things a thing when we we see a thing to\n            do a thing when really really see the thing!\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "display-flex align-center gap-10 my-5 pt-5"
  }, [_c('img', {
    staticClass: "rounded",
    attrs: {
      "src": __webpack_require__(30),
      "width": 44,
      "height": 44
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "input-comment full-width pa-2",
    attrs: {
      "type": "text",
      "placeholder": "Say something!"
    }
  })])], 1)], 1), _vm._v(" "), _c('v-bottom-sheet', {
    attrs: {
      "hide-overlay": ""
    },
    model: {
      value: (_vm.isSend),
      callback: function($$v) {
        _vm.isSend = $$v
      },
      expression: "isSend"
    }
  }, [_c('v-list', {
    staticClass: "px-4"
  }, [_c('div', {
    staticClass: "display-flex align-center input-search px-2 my-4"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(319),
      "width": "20",
      "height": "20"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "full-width px-2 input-search__input",
    attrs: {
      "type": "text",
      "placeholder": "Search people"
    }
  })]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((4), function(i) {
    return _c('v-flex', {
      key: i,
      attrs: {
        "d-flex": "",
        "xs4": "",
        "mb-3": ""
      }
    }, [_c('div', {
      staticClass: "display-flex flex-column align-center justify-center gap-4"
    }, [_c('img', {
      staticClass: "rounded",
      attrs: {
        "src": __webpack_require__(30),
        "width": 44,
        "height": 44
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "text-inter-14 font-weight-500"
    }, [_vm._v("TREV")])])])
  })), _vm._v(" "), _c('div', {
    staticClass: "input-send"
  }, [_c('input', {
    staticClass: "full-width px-2 input-send__input",
    attrs: {
      "type": "text",
      "placeholder": "Write a message..."
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "input-send__btn text-inter-12 text-white"
  }, [_vm._v("\n          Send seperately\n        ")])], 1)], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "camera"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1482),
      "width": "19",
      "height": "19"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "display-flex flex-column justify-center mb-3"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(317),
      "width": "24",
      "height": "24"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "display-flex flex-column justify-center"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1516),
      "width": "34",
      "height": "34"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "display-flex justify-space-between align-center spotlight__user"
  }, [_c('div', {
    staticClass: "display-flex align-center gap-8"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(601),
      "width": "60",
      "height": "60"
    }
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "display-flex gap-4 align-center"
  }, [_c('span', {
    staticClass: "text-poppins-18 text-white"
  }, [_vm._v(" Salva ")]), _vm._v(" "), _c('img', {
    staticClass: "max-full-width",
    attrs: {
      "src": __webpack_require__(315)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-poppins-15 text-white"
  }, [_vm._v("12,392 views")])])]), _vm._v(" "), _c('div', {
    staticClass: "btn-follow display-flex justify-center align-center"
  }, [_c('div', {
    staticClass: "text-poppins-13 text-black font-weight-600"
  }, [_vm._v("Follow")])])])
}]}

/***/ }),
/* 1718 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "send-love-section",
    class: {
      transparent: _vm.showPaymentModal
    },
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [(!_vm.showPaymentModal) ? _c('v-flex', {
    staticClass: "dismiss-section",
    attrs: {
      "xs12": "",
      "sm12": ""
    },
    on: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.showPaymentModal) ? _c('v-layout', {
    staticClass: "popup-section",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('div', {
    staticClass: "top-section"
  }, [_c('p', {
    staticClass: "title-label"
  }, [_vm._v("Send payment to")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "profile-section",
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "user-name"
  }, [_vm._v(_vm._s(_vm.item.username) + "\n        "), (_vm.item.user_type == 'artist') ? _c('v-icon', {
    staticClass: "user-status",
    class: {
      online: _vm.item.status == 'active'
    }
  }, [_vm._v("fa-check-circle")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "avatar-image",
    style: ({
      'background-image': 'url(' + _vm.item.avatar.thumb.url + ')'
    })
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "input-section",
    attrs: {
      "xs12": ""
    }
  }, [_c('vue-numeric', {
    staticClass: "donate-amount",
    attrs: {
      "currency": "$",
      "separator": ",",
      "min": 1
    },
    model: {
      value: (_vm.donate_amount),
      callback: function($$v) {
        _vm.donate_amount = $$v
      },
      expression: "donate_amount"
    }
  }), _vm._v(" "), _c('v-select', {
    staticClass: "pt-4",
    attrs: {
      "items": _vm.descriptions,
      "hide-details": ""
    },
    model: {
      value: (_vm.description),
      callback: function($$v) {
        _vm.description = $$v
      },
      expression: "description"
    }
  }), _vm._v(" "), (_vm.description === 'Add Video Credit') ? _c('p', [_vm._v("\n        Adding video credit gives this user more time to broadcast live video\n      ")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "download-btn",
    nativeOn: {
      "click": function($event) {
        _vm.showPaymentDialog()
      }
    }
  }, [_vm._v("\n        Go to checkout\n      ")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showPaymentModal) ? _c('payment-modal', {
    attrs: {
      "receivers": [_vm.item],
      "amount": _vm.donate_amount_by_cent,
      "dismiss": _vm.hidePaymentDialog,
      "finish": _vm.sendLove
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1719 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page chat-page"
  }, [_c('v-snackbar', {
    attrs: {
      "timeout": 0,
      "bottom": true,
      "right": true,
      "multi-line": false,
      "vertical": false
    },
    model: {
      value: (_vm.disconnected),
      callback: function($$v) {
        _vm.disconnected = $$v
      },
      expression: "disconnected"
    }
  }, [_vm._v("\n    Connecting...\n  ")]), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": 'error',
      "timeout": 5000
    },
    model: {
      value: (_vm.isMessageErr),
      callback: function($$v) {
        _vm.isMessageErr = $$v
      },
      expression: "isMessageErr"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.messageError) + "\n  ")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.show_requestPopup) ? _c('v-flex', {
    staticClass: "chat-popup requests",
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('div', {
    staticClass: "dismiss-section",
    on: {
      "click": function($event) {
        _vm.show_requestPopup = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-section"
  }, [_c('div', {
    staticClass: "requests-section"
  }, [_c('div', {
    staticClass: "header-section"
  }, [_c('p', {
    staticClass: "section-title"
  }, [_vm._v("Attach content to chat")]), _vm._v(" "), _c('div', {
    staticClass: "option-area"
  }, [_c('v-btn', {
    staticClass: "request-option-btn",
    class: {
      selected: _vm.request_tab == 'album'
    },
    nativeOn: {
      "click": function($event) {
        _vm.onRequestTab('album')
      }
    }
  }, [_vm._v("Album")]), _vm._v(" "), _c('v-btn', {
    staticClass: "request-option-btn",
    class: {
      selected: _vm.request_tab == 'merch'
    },
    nativeOn: {
      "click": function($event) {
        _vm.onRequestTab('merch')
      }
    }
  }, [_vm._v("Product")]), _vm._v(" "), _c('v-btn', {
    staticClass: "request-option-btn",
    class: {
      selected: _vm.request_tab == 'users'
    },
    nativeOn: {
      "click": function($event) {
        _vm.onRequestTab('users')
      }
    }
  }, [_vm._v("User")])], 1)]), _vm._v(" "), (_vm.request_tab == 'album') ? _c('div', {
    staticClass: "content-section"
  }, _vm._l((_vm.albums), function(album, index) {
    return _c('div', {
      key: index,
      staticClass: "request-item",
      class: {
        selected: _vm.item_index == index
      },
      on: {
        "click": function($event) {
          _vm.selectItemIndex(index)
        }
      }
    }, [_c('div', {
      staticClass: "avatar-area"
    }, [_c('div', {
      staticClass: "avatar-image",
      style: (("background-image: url(" + (album.cover.thumb.url) + ")"))
    })]), _vm._v(" "), _c('div', {
      staticClass: "detail-area"
    }, [_c('label', {
      staticClass: "item-name"
    }, [_vm._v(_vm._s(album.name))]), _vm._v(" "), _c('label', {
      staticClass: "user-name"
    }, [_vm._v(_vm._s(album.user.username))])])])
  })) : _vm._e(), _vm._v(" "), (_vm.request_tab == 'merch') ? _c('div', {
    staticClass: "content-section"
  }, _vm._l((_vm.products), function(product, index) {
    return _c('div', {
      key: index,
      staticClass: "request-item",
      class: {
        selected: _vm.item_index == index
      },
      on: {
        "click": function($event) {
          _vm.selectItemIndex(index)
        }
      }
    }, [_c('div', {
      staticClass: "avatar-area"
    }, [_c('div', {
      staticClass: "avatar-image",
      style: (("background-image: url(" + (product.covers[0].cover.thumb.url) + ")"))
    })]), _vm._v(" "), _c('div', {
      staticClass: "detail-area"
    }, [_c('label', {
      staticClass: "item-name"
    }, [_vm._v(_vm._s(product.name))]), _vm._v(" "), _c('label', {
      staticClass: "user-name"
    }, [_vm._v(_vm._s(product.merchant.username))])])])
  })) : _vm._e(), _vm._v(" "), (_vm.request_tab == 'users') ? _c('div', {
    staticClass: "content-section"
  }, [_c('v-flex', {
    staticClass: "title-section",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-flex', {
    staticClass: "search-section",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "search-box"
  }, [_c('div', {
    staticClass: "search-container"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ic_search.svg",
      "width": "20"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userSearchKeyword),
      expression: "userSearchKeyword"
    }],
    staticClass: "search-field",
    attrs: {
      "type": "search",
      "id": "search",
      "placeholder": "Search"
    },
    domProps: {
      "value": (_vm.userSearchKeyword)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.loadUsers()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userSearchKeyword = $event.target.value
      }
    }
  })])])])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "list-section",
    attrs: {
      "xs12": ""
    }
  }, _vm._l((_vm.users), function(user, index) {
    return _c('v-flex', {
      key: index,
      staticClass: "user-item",
      attrs: {
        "xs12": ""
      },
      on: {
        "click": function($event) {
          if ($event.target !== $event.currentTarget) { return null; }
          _vm.onSelectUser(user)
        }
      }
    }, [_c('div', {
      staticClass: "avatar-image",
      style: ({
        'background-image': 'url(' + user.avatar.thumb.url + ')',
      }),
      on: {
        "click": function($event) {
          _vm.onSelectUser(user)
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "user-name",
      on: {
        "click": function($event) {
          _vm.onSelectUser(user)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(user.username) + "\n                  "), (user.user_type == 'artist') ? _c('v-icon', {
      staticClass: "user-status",
      class: {
        online: user.status == 'active'
      }
    }, [_vm._v("fa-check-circle")]) : _vm._e()], 1)])
  }))], 1) : _vm._e()])])]) : _vm._e()], 1), _vm._v(" "), (_vm.user) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": ""
    }
  }, [_c('h2', {
    staticClass: "page-title"
  }, [_vm._v(_vm._s(_vm.user.username))]), _vm._v(" "), _c('label', {
    staticClass: "chat-room"
  }, [_vm._v("CHAT ROOM (" + _vm._s(_vm.room.online.length) + ")")]), _vm._v(" "), (_vm.show_stream_live_button) ? _c('v-btn', {
    staticClass: "live-btn px-1",
    attrs: {
      "outline": "",
      "round": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.viewStream()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-circle"
  }), _vm._v(" "), _c('span', {
    staticClass: "live"
  }, [_vm._v("Live")])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.user) ? _c('v-flex', {
    staticClass: "chat-page-content",
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "chat-content-section",
    attrs: {
      "xs12": "",
      "sm9": "",
      "pa-0": ""
    }
  }, [_c('div', {
    directives: [{
      name: "chat-scroll",
      rawName: "v-chat-scroll",
      value: ({
        always: false,
        smooth: false
      }),
      expression: "{ always: false, smooth: false }"
    }],
    staticClass: "chat-list-section",
    attrs: {
      "id": "msg-container"
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "600",
      "margin-left": "8px",
      "font-size": "16px",
      "padding-bottom": "5px"
    }
  }, [_c('P', [_vm._v("\n              Start chatting! Chat conversations are deleted permanently every\n              24 hours. Be respectful.\n            ")])], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "inset": _vm.inset
    }
  }), _vm._v(" "), _c('center', [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.disconnected) ? _c('v-progress-circular', {
    staticClass: "progress-circular",
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _vm._l((_vm.reverseMessages), function(message) {
    return _c('div', {
      key: message.id,
      staticClass: "chat-item other"
    }, [_c('div', {
      staticClass: "user-avatar-image",
      style: ('background-color: gray; background-image: url(' +
        (message.fromUser ?
          message.fromUser.avatar.url :
          new String()) +
        ');')
    }), _vm._v(" "), _c('div', {
      staticClass: "chat-section"
    }, [_c('div', {
      staticClass: "info-section"
    }, [_c('router-link', {
      staticClass: "item-user",
      attrs: {
        "to": '/' + message.from
      }
    }, [_vm._v(_vm._s(message.fromUser ? message.fromUser.username : message.from))]), _vm._v(" "), _c('label', {
      staticClass: "messaged-time"
    }, [_vm._v(_vm._s(_vm.moment(message.time).calendar()))])], 1), _vm._v(" "), _c('div', {
      staticClass: "chat-content text"
    }, [(!_vm.isAttachmentLink(message.text)) ? _c('label', {
      staticClass: "text-message"
    }, [_vm._v(_vm._s(message.text))]) : _vm._e(), _vm._v(" "), (_vm.isAlbumLink(message.text) && _vm.albumLinks[message.text]) ? _c('div', {
      staticClass: "album-embed-wrapper"
    }, [_c('activity-album-card', {
      staticClass: "chat-album-embed",
      attrs: {
        "object": _vm.albumLinks[message.text]
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "info-section"
    }, [_c('router-link', {
      attrs: {
        "to": '/album/' + _vm.albumLinks[message.text].slug
      }
    }, [_c('label', {
      staticClass: "item-title"
    }, [_vm._v(_vm._s(_vm.albumLinks[message.text].name))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('router-link', {
      staticClass: "item-user",
      attrs: {
        "to": '/' + _vm.albumLinks[message.text].user.slug
      }
    }, [_vm._v(_vm._s(_vm.albumLinks[message.text].user.username))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isMerchLink(message.text) && _vm.merchLinks[message.text]) ? _c('div', {
      staticClass: "album-embed-wrapper"
    }, [_c('activity-product-card', {
      staticClass: "chat-album-embed",
      attrs: {
        "object": _vm.merchLinks[message.text]
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "info-section"
    }, [_c('label', {
      staticClass: "item-title"
    }, [_vm._v(_vm._s(_vm.merchLinks[message.text].name))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('router-link', {
      staticClass: "item-user",
      attrs: {
        "to": '/' + _vm.merchLinks[message.text].merchant.slug
      }
    }, [_vm._v(_vm._s(_vm.merchLinks[message.text].merchant.username))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isUserLink(message.text) && _vm.userLinks[message.text]) ? _c('div', {
      staticClass: "album-embed-wrapper"
    }, [_c('activity-user-card', {
      staticClass: "chat-album-embed",
      attrs: {
        "object": _vm.userLinks[message.text]
      }
    }), _vm._v(" "), (!!_vm.userLinks[message.text]) ? _c('div', {
      staticClass: "info-section"
    }, [_c('label', {
      staticClass: "item-title"
    }, [_vm._v(_vm._s(_vm.userLinks[message.text].username))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('router-link', {
      staticClass: "item-user",
      attrs: {
        "to": '/' + _vm.userLinks[message.text].slug
      }
    }, [_vm._v(_vm._s(_vm._f("formatLargeNumber")(_vm.userLinks[message.text].followers)) + "\n                      followers")])], 1) : _vm._e()], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "clear"
    })])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "send-chat-section"
  }, [(_vm.connected) ? _c('v-btn', {
    staticClass: "show-attachment-box-btn",
    class: {
      selected: _vm.show_broadcastPopup
    },
    nativeOn: {
      "click": function($event) {
        _vm.show_requestPopup = true
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ic_attach_add.svg",
      "width": "36"
    }
  })]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    ref: "chat",
    staticClass: "chat-input-box",
    attrs: {
      "type": "text",
      "placeholder": "Write a message...",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.sendMessage(_vm.message)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.showEmojiPicker) ? _c('picker', {
    staticClass: "emoji-picker",
    attrs: {
      "title": "Pick your emoji…",
      "emoji": "point_up"
    },
    on: {
      "click": _vm.addEmoji
    }
  }) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "show-emoji-box-btn",
    class: {
      selected: _vm.showEmojiPicker
    },
    nativeOn: {
      "click": function($event) {
        _vm.showEmojiPicker = !_vm.showEmojiPicker
      }
    }
  }, [_c('v-icon', [_vm._v("tag_faces")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "send-chat-btn",
    nativeOn: {
      "click": function($event) {
        _vm.sendMessage(_vm.message)
      }
    }
  }, [_vm._v("Send")])], 1)]), _vm._v(" "), _c('v-flex', {
    staticClass: "requests-section",
    attrs: {
      "xs12": "",
      "sm3": "",
      "pa-0": ""
    }
  }, [(_vm.meberList) ? _c('div', {
    staticClass: "content-section"
  }, [_c('center', [(_vm.disconnected) ? _c('v-progress-circular', {
    staticClass: "progress-circular",
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.connected) ? _c('div', {
    staticClass: "member-group"
  }, [_vm._v("MODERATOR")]) : _vm._e(), _vm._v(" "), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, _vm._l((_vm.adminUsers), function(adminUser) {
    return _c('div', {
      key: ("admin-" + (adminUser.username)),
      staticClass: "member-item"
    }, [_c('div', {
      staticClass: "avatar-area"
    }, [_c('div', {
      staticClass: "avatar-image",
      style: ('background-image: url(' + adminUser.avatar.url + ');')
    }), _vm._v(" "), _c('div', {
      staticClass: "memeber-status",
      class: _vm.room.online.indexOf(adminUser.slug) > -1 ?
        'online' :
        _vm.room.idle.indexOf(adminUser.slug) > -1 ?
        'idle' :
        'offline'
    })]), _vm._v(" "), _c('div', {
      staticClass: "detail-area"
    }, [_c('router-link', {
      staticClass: "user-name",
      attrs: {
        "to": '/' + adminUser.slug
      }
    }, [_vm._v(_vm._s(adminUser.username))])], 1)])
  })), _vm._v(" "), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.onlineUsers.length) ? _c('div', {
    key: 'onlineHeader',
    staticClass: "member-group mt-3"
  }, [_vm._v("\n              ONLINE: " + _vm._s(_vm.room.online.length) + "\n            ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.onlineUsers), function(onlineUser) {
    return (_vm.onlineUsers.length) ? _c('div', {
      key: ("online-" + (onlineUser.username)),
      staticClass: "member-item"
    }, [_c('div', {
      staticClass: "avatar-area"
    }, [_c('div', {
      staticClass: "avatar-image",
      style: ('background-image: url(' + onlineUser.avatar.url + ');')
    }), _vm._v(" "), _c('div', {
      staticClass: "memeber-status online"
    })]), _vm._v(" "), _c('div', {
      staticClass: "detail-area"
    }, [(onlineUser) ? _c('router-link', {
      staticClass: "user-name",
      attrs: {
        "to": '/' + onlineUser.slug
      }
    }, [_vm._v(_vm._s(onlineUser.username))]) : _vm._e()], 1)]) : _vm._e()
  }), _vm._v(" "), (_vm.idleUsers.length) ? _c('div', {
    key: 'idleHeader',
    staticClass: "member-group mt-3"
  }, [_vm._v("\n              IDLE: " + _vm._s(_vm.room.idle.length) + "\n            ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.idleUsers), function(idleUser) {
    return (_vm.idleUsers.length) ? _c('div', {
      key: ("idle-" + (idleUser.username)),
      staticClass: "member-item"
    }, [_c('div', {
      staticClass: "avatar-area"
    }, [_c('div', {
      staticClass: "avatar-image",
      style: ('background-image: url(' + idleUser.avatar.url + ');')
    }), _vm._v(" "), _c('div', {
      staticClass: "memeber-status idle"
    })]), _vm._v(" "), _c('div', {
      staticClass: "detail-area"
    }, [(idleUser) ? _c('router-link', {
      staticClass: "user-name",
      attrs: {
        "to": '/' + idleUser.slug
      }
    }, [_vm._v(_vm._s(idleUser.username))]) : _vm._e()], 1)]) : _vm._e()
  })], 2), _vm._v(" "), (_vm.admin) ? _c('v-menu', {
    staticClass: "settings-menu",
    attrs: {
      "down": "",
      "offset-y": "",
      "nudge-top": -5,
      "close-on-content-click": false
    }
  }, [_c('v-btn', {
    staticClass: "settings-btn",
    attrs: {
      "slot": "activator",
      "round": ""
    },
    slot: "activator"
  }, [_c('v-icon', {
    attrs: {
      "dark": "",
      "right": ""
    }
  }, [_vm._v("more_horiz")])], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-tile', {
    staticClass: "settings-list-tile"
  }, [_c('v-list-tile-content', {
    staticClass: "default-menu-item"
  }, [_c('v-list-tile-title', [_vm._v("Allow users to attach content")]), _vm._v(" "), _c('v-switch', {
    staticClass: "pl-3",
    attrs: {
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        _vm.updateSettings()
      }
    },
    model: {
      value: (_vm.room.settings.attachments),
      callback: function($$v) {
        _vm.$set(_vm.room.settings, "attachments", $$v)
      },
      expression: "room.settings.attachments"
    }
  })], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-tile', {
    staticClass: "settings-list-tile"
  }, [_c('v-list-tile-content', {
    staticClass: "default-menu-item"
  }, [_c('v-list-tile-title', [_vm._v("Allow users to send links")]), _vm._v(" "), _c('v-switch', {
    staticClass: "pl-3",
    attrs: {
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        _vm.updateSettings()
      }
    },
    model: {
      value: (_vm.room.settings.links),
      callback: function($$v) {
        _vm.$set(_vm.room.settings, "links", $$v)
      },
      expression: "room.settings.links"
    }
  })], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-tile', {
    staticClass: "settings-list-tile"
  }, [_c('v-list-tile-content', {
    staticClass: "default-menu-item"
  }, [_c('v-list-tile-title', [_vm._v("Enable a character limit")]), _vm._v(" "), _c('v-switch', {
    staticClass: "pl-3",
    attrs: {
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        _vm.updateSettings()
      }
    },
    model: {
      value: (_vm.room.settings.charLimitBool),
      callback: function($$v) {
        _vm.$set(_vm.room.settings, "charLimitBool", $$v)
      },
      expression: "room.settings.charLimitBool"
    }
  })], 1)], 1)], 1)], 1) : _vm._e()], 1) : _vm._e()])], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1720 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide-up"
    }
  }, [_c('div', {
    staticClass: "sms-engagement"
  }, [_c('div', {
    staticClass: "_top"
  }, [_c('div', {
    staticClass: "_title"
  }, [_c('div', [_vm._v("SMS")]), _vm._v(" "), _c('div', [_vm._v("Conversation")])]), _vm._v(" "), _c('v-icon', {
    staticClass: "close-icon",
    on: {
      "click": _vm.closeEngagement
    }
  }, [_vm._v("\n        keyboard_arrow_down\n      ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "message"
  }, [_c('div', {
    staticClass: "message-wrapper"
  }, [_c('user-tag', {
    attrs: {
      "user": _vm.currentUser,
      "showAvatar": "",
      "hideTick": "",
      "hideName": "",
      "width": "43",
      "height": "43"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "message-content"
  }, [_vm._v("Hello, test message")])], 1), _vm._v(" "), (_vm.attachment) ? _c('div', {
    staticClass: "attachment"
  }, [_c('v-icon', {
    staticClass: "attach-icon"
  }, [_vm._v("attachment")]), _vm._v(" "), _c('trackcardsimple', {
    attrs: {
      "item": _vm.attachment,
      "cover": '',
      "title": _vm.attachment.title,
      "subtitle": _vm.attachment.title,
      "coverRadius": "",
      "isVideo": _vm.attachType === 'Video'
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "_summary"
  }, [_c('div', {
    staticClass: "_detail"
  }, [_vm._v("\n          Delivered to\n          "), _c('strong', {
    staticClass: "recipientsLen"
  }, [_vm._v(_vm._s(_vm.recipientsLen) + " contacts via "), _c('strong', [_vm._v("SMS")])])]), _vm._v(" "), _c('div', {
    staticClass: "_time"
  }, [_vm._v(_vm._s(_vm._f("getTime")(new Date(Date.now()))))])])]), _vm._v(" "), _c('directory', {
    staticClass: "pt-0",
    attrs: {
      "customDirectory": [],
      "isComp": "",
      "height": 70,
      "separator": ""
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1721 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page sell-page mx-5",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('content-top-header', {
    staticClass: "black-theme"
  }, [_c('template', {
    slot: "topHeader"
  }, [_c('ul', {
    staticClass: "pr-3"
  }, [_c('li', {
    staticClass: "nav-li"
  }, [_c('label', {
    staticClass: "nav-label"
  }, [_vm._v("\n                Sales\n              ")])])])])], 2), _vm._v(" "), _c('content-top-header', {
    staticClass: "content-top-header-tab",
    attrs: {
      "height": 62
    }
  }, [_c('template', {
    slot: "topHeader"
  }, [_c('ul', [_c('li', {
    staticClass: "sell-header"
  }, [_vm._v("\n              " + _vm._s(_vm.orderHistories.length) + " sales\n            ")])])])], 2), _vm._v(" "), (_vm.currentUser && _vm.isPageReady) ? _c('div', {
    staticClass: "page-content mt-150"
  }, [(_vm.active_tab == 'orders') ? [(!_vm.orderHistories || _vm.orderHistories.length == 0) ? _c('div', {
    staticClass: "empty-section"
  }, [_c('p', {
    staticClass: "empty-title"
  }, [_vm._v("You have no sales")])]) : _c('div', {
    staticClass: "relative",
    attrs: {
      "flat": ""
    }
  }, [_vm._l((_vm.orderHistories), function(order, index) {
    return _c('div', {
      key: index,
      staticClass: "order-item"
    }, [(_vm.currentUser.id == order.merchant.id) ? [_c('div', {
      staticClass: "profile-section"
    }, [_c('v-layout', {
      attrs: {
        "row": ""
      }
    }, [_c('div', {
      staticClass: "profile-content-section relative w-100"
    }, [_c('div', {
      staticClass: "dflex justify-space-between align-center w-100"
    }, [_c('div', {
      staticClass: "dflex align-center"
    }, [_c('div', {
      staticClass: "profile-avatar mr-3"
    }, [_c('profile-item', {
      attrs: {
        "user": order.customer,
        "className": 'order-item-profile-avatar'
      }
    })], 1), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "profile-content"
    }, [_c('a', {
      staticClass: "user-name",
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(order.customer.username))]), _vm._v(" "), _c('label', {
      staticClass: "order-detail-text"
    }, [_vm._v("\n                          Purchased\n                          "), _c('b', [_vm._v(" \n                            " + _vm._s(_vm._f("formatDate")(order.created_at)) + "\n                          ")])])])])]), _vm._v(" "), _c('div', [_c('v-menu', {
      staticClass: "menu-content-x",
      attrs: {
        "left": "",
        "offset-y": "",
        "nudge-top": 35,
        "nudge-left": 45
      }
    }, [_c('v-btn', {
      attrs: {
        "slot": "activator",
        "round": ""
      },
      slot: "activator"
    }, [_c('v-icon', {
      attrs: {
        "dark": "",
        "right": ""
      }
    }, [_vm._v("more_horiz")])], 1), _vm._v(" "), _c('v-list', {
      staticClass: "list-class"
    }, [_c('v-list-tile', [_c('v-list-tile-content', [_c('router-link', {
      staticClass: "order-detail-btn",
      attrs: {
        "to": "`/sell/order/"
      }
    }, [_vm._v("Order Details")]), _vm._v(" "), _c('a', {
      staticClass: "message-buyer-btn"
    }, [_vm._v("Message Buyer")])], 1)], 1)], 1)], 1)], 1)])])])], 1), _vm._v(" "), _vm._l((order.items), function(item) {
      return _c('div', {
        key: item.id,
        staticClass: "order-section"
      }, [_c('v-container', {
        staticClass: "pa-0 mt-3",
        attrs: {
          "fluid": _vm.isSidebarMini,
          "grid-list-xl": "",
          "fill-height": ""
        }
      }, [(
        _vm.activeFilterItemStatus == '' ||
        item.status == _vm.activeFilterItemStatus
      ) ? _c('v-layout', {
        attrs: {
          "row": ""
        }
      }, [_c('v-flex', {
        staticClass: "px-0",
        attrs: {
          "xs8": ""
        }
      }, [_c('div', {
        staticClass: "order-content-section"
      }, [_c('div', {
        staticClass: "order-content-container"
      }, [_c('div', {
        staticClass: "product-cover-image",
        style: (("background-image: url(" + (item.product.covers[0].cover.thumb.url) + ")"))
      }), _vm._v(" "), _c('div', {
        staticClass: "product-content"
      }, [_c('div', {
        staticClass: "product-content-row"
      }, [_c('div', {
        staticClass: "product-name"
      }, [_vm._v("\n                                " + _vm._s(item.product.name) + " |\n                                " + _vm._s(item.product_variant.name) + "\n                              ")])]), _vm._v(" "), _c('div', {
        staticClass: "product-content-row pt-1"
      }, [_c('div', {
        staticClass: "product-price"
      }, [_vm._v("\n                                $" + _vm._s(_vm._f("formatNumber")(item.price)) + "\n                              ")])])])]), _vm._v(" "), _c('v-spacer')], 1)]), _vm._v(" "), _c('v-flex', {
        staticClass: "px-0",
        attrs: {
          "xs4": ""
        }
      }, [(_vm.isDigitalProduct(item)) ? _c('div', {
        staticClass: "order-status-section text-xs-center digital"
      }, [_c('p', {
        staticClass: "order-status-text"
      }, [_vm._v("\n                          " + _vm._s(item.product.digital_content_name) + "\n                        ")])]) : (item.status == 'item_ordered') ? _c('div', {
        staticClass: "order-status-section text-xs-center"
      }, [_c('p', {
        staticClass: "order-status-text"
      }, [_vm._v("Ship by 9/21/2022")]), _vm._v(" "), _c('v-btn', {
        staticClass: "order-status-btn ship",
        nativeOn: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.openShipConfirmModal(item)
          }
        }
      }, [_vm._v("Ship")])], 1) : (item.status == 'item_shipped') ? _c('div', {
        staticClass: "order-status-section text-xs-center"
      }, [_c('p', {
        staticClass: "order-status-text"
      }, [_vm._v("Shipped")]), _vm._v(" "), _c('v-btn', {
        staticClass: "order-status-btn shipped",
        nativeOn: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.openUnshipConfirmModal(item)
          }
        }
      }, [_vm._v("Unship")])], 1) : (item.status == 'item_refunded') ? _c('div', {
        staticClass: "order-status-section text-xs-center"
      }, [_c('p', {
        staticClass: "order-status-text"
      }, [_vm._v("Refunded")])]) : _vm._e()])], 1) : _vm._e()], 1)], 1)
    })] : [_c('div', {
      staticClass: "profile-section"
    }, [_c('v-layout', {
      attrs: {
        "row": ""
      }
    }, [_c('div', {
      staticClass: "profile-content-section relative w-100"
    }, [_c('div', {
      staticClass: "dflex justify-space-between align-center w-100"
    }, [_c('div', {
      staticClass: "dflex align-center"
    }, [_c('div', {
      staticClass: "profile-avatar mr-3"
    }, [_c('profile-item', {
      attrs: {
        "user": order.customer,
        "className": 'order-item-profile-avatar'
      }
    })], 1), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "profile-content"
    }, [_c('a', {
      staticClass: "user-name",
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(order.customer.username))]), _vm._v(" "), _c('label', {
      staticClass: "order-detail-text"
    }, [_vm._v("\n                          Purchased\n                          ")]), _vm._v(" "), _c('label', {
      staticClass: "order-date"
    }, [_c('b', [_vm._v(_vm._s(_vm._f("formatDate")(order.created_at)))])])])])])])])])], 1), _vm._v(" "), _vm._l((order.items), function(item) {
      return _c('div', {
        key: item.id,
        staticClass: "order-section"
      }, [(
        _vm.activeFilterItemStatus == '' ||
        item.status == _vm.activeFilterItemStatus
      ) ? _c('div', {
        staticClass: "order-section__item"
      }, [_c('div', {
        staticClass: "order-content-section relative"
      }, [_c('div', {
        staticClass: "product-cover-image",
        style: (("background-image: url(" + (item.product.covers[0].cover.thumb.url) + ")"))
      }), _vm._v(" "), _c('div', {
        staticClass: "product-content"
      }, [_c('v-flex', {
        staticClass: "product-content-row",
        attrs: {
          "sm12": ""
        }
      }, [_c('label', {
        staticClass: "product-name"
      }, [_vm._v(_vm._s(item.product.name))])]), _vm._v(" "), _c('v-flex', {
        staticClass: "product-content-row",
        attrs: {
          "sm12": "",
          "pt-1": ""
        }
      }, [_c('label', {
        staticClass: "product-price"
      }, [_vm._v("$" + _vm._s(_vm._f("formatNumber")(item.price)))])])], 1)])]) : _vm._e()])
    })]], 2)
  }), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center"
  }, [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (
        _vm.order_pagination.current_page < _vm.order_pagination.total_pages
      ),
      expression: "\n                order_pagination.current_page < order_pagination.total_pages\n              "
    }],
    staticClass: "loadmore-btn",
    nativeOn: {
      "click": function($event) {
        _vm.loadOrders()
      }
    }
  }, [_vm._v("Load More")])], 1)], 2)] : _vm._e(), _vm._v(" "), (_vm.active_tab == 'products') ? [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(
    ['artist', 'brand', 'label'].indexOf(_vm.currentUser.user_type) !=
    -1
  ) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-right": ""
    }
  }, [(_vm.currentUser.stripe_connected) ? _c('v-btn', {
    staticClass: "add-product-btn",
    nativeOn: {
      "click": function($event) {
        _vm.addProduct()
      }
    }
  }, [_c('v-icon', [_vm._v("add")]), _vm._v("Add Product\n              ")], 1) : _c('v-btn', {
    staticClass: "add-product-btn",
    attrs: {
      "to": "/settings#bank-details"
    }
  }, [_vm._v("\n                Connect Stripe to Add Products\n              ")])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.published_products), function(product, index) {
    return _c('product-item', {
      key: index,
      attrs: {
        "index": index,
        "product": product,
        "deleteItem": _vm.openProductDeleteConfirmDialog
      }
    })
  })], 2)], 1)] : _vm._e(), _vm._v(" "), (_vm.active_tab == 'collaborations') ? [(!_vm.collaborated_products || _vm.collaborated_products.length == 0) ? _c('div', {
    staticClass: "empty-section"
  }, [_c('p', {
    staticClass: "empty-title"
  }, [_vm._v("You have no product collaborations")])]) : _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-layout', {
    staticClass: "covers-content",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.collaborated_products), function(product) {
    return _c('div', {
      key: product.id,
      staticClass: "card-container"
    }, [_c('collaborate-product', {
      attrs: {
        "product": product,
        "editButtonAction": _vm.editProduct,
        "deleteButtonAction": _vm.openProductDeleteConfirmDialog
      }
    })], 1)
  }))], 1)] : _vm._e(), _vm._v(" "), (_vm.active_tab == 'pendings') ? [(!_vm.pending_products || _vm.pending_products.length == 0) ? _c('div', {
    staticClass: "empty-section"
  }, [_c('p', {
    staticClass: "empty-title"
  }, [_vm._v("\n            You have no pending product collaborations\n          ")])]) : _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-layout', {
    staticClass: "covers-content",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.pending_products), function(product) {
    return _c('div', {
      key: product.id,
      staticClass: "card-container"
    }, [(product.merchant.id == _vm.currentUser.id) ? _c('collaborate-product', {
      attrs: {
        "product": product,
        "showPromoteButton": false,
        "editButtonAction": _vm.editProduct,
        "deleteButtonAction": _vm.openProductDeleteConfirmDialog,
        "releaseButtonAction": _vm.releaseProduct
      }
    }) : (_vm.notResponded(product)) ? _c('collaborate-product', {
      attrs: {
        "product": product,
        "showPromoteButton": false,
        "acceptButtonAction": _vm.acceptCollaboration,
        "denyButtonAction": _vm.denyCollaboration
      }
    }) : _c('collaborate-product', {
      attrs: {
        "product": product,
        "showPromoteButton": false
      }
    })], 1)
  }))], 1)] : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.showSendMessage) ? _c('send-message', {
    attrs: {
      "receiver": _vm.user,
      "dismiss": _vm.dismissMessageModal
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_product_finish_modal) ? _c('div', {
    staticClass: "product-finish-section"
  }, [_c('v-flex', {
    staticClass: "dismiss-section",
    attrs: {
      "xs12": "",
      "sm12": ""
    },
    on: {
      "click": function($event) {
        _vm.closeProductFinishModal()
      }
    }
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "popup-section",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "title-section",
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "title-text"
  }, [_vm._v("This product is pending release,\n            "), _c('router-link', {
    staticClass: "link-text",
    attrs: {
      "to": "/product/add"
    }
  }, [_vm._v("upload another")])], 1)]), _vm._v(" "), _c('v-flex', {
    staticClass: "promote-product-section",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-flex', {
    staticClass: "header-section",
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "header-text"
  }, [_vm._v("What Next?")])]), _vm._v(" "), _c('div', {
    staticClass: "content-section"
  }, [_c('div', {
    staticClass: "promote-product-image"
  }, [_c('div', {
    staticClass: "promote-image",
    style: ({
      'background-image': 'url(' + _vm.product.covers[0].cover.url + ')',
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "promote-product-description"
  }, [_c('p', [_vm._v("\n                When you added collaborators accept your collaboration via\n                Direct Message or Sell > Pending Collaborations, you will then\n                be able to release the product.\n              ")]), _vm._v(" "), _c('p', [_vm._v("\n                Visit Sell > Pending Collaborations to see who accepted and/or\n                denied your collaboration.\n              ")])])])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.product_delete_confirm_dialog),
      callback: function($$v) {
        _vm.product_delete_confirm_dialog = $$v
      },
      expression: "product_delete_confirm_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Delete a Product")]), _vm._v(" "), _c('v-card-text', [_vm._v("If you click OK, the product will no longer be available to users.\n          Click OK to delete <" + _vm._s(_vm.product.name) + ">, or click\n          Cancel.")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.deleteProduct()
      }
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeProductDeleteConfirmDialog()
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": ""
    },
    model: {
      value: (_vm.show_ship_confirm_modal),
      callback: function($$v) {
        _vm.show_ship_confirm_modal = $$v
      },
      expression: "show_ship_confirm_modal"
    }
  }, [_c('v-form', {
    ref: "valid_tracking_form",
    attrs: {
      "lazy-valiation": ""
    },
    model: {
      value: (_vm.valid_tracking_form),
      callback: function($$v) {
        _vm.valid_tracking_form = $$v
      },
      expression: "valid_tracking_form"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Ship Product")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n            Enter shipping carrier website & tracking number"), _c('br'), _vm._v("\n            Buyer will see the tracking number in their "), _c('b', [_vm._v("Order History")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "www.fedex.com",
      "rules": [function (v) { return !!v || 'Carrier website is required'; }],
      "required": "",
      "single-line": ""
    },
    model: {
      value: (_vm.tracking_site),
      callback: function($$v) {
        _vm.tracking_site = $$v
      },
      expression: "tracking_site"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Enter tracking number",
      "rules": [function (v) { return !!v || 'Tracking number is required'; }],
      "required": "",
      "single-line": ""
    },
    model: {
      value: (_vm.tracking_number),
      callback: function($$v) {
        _vm.tracking_number = $$v
      },
      expression: "tracking_number"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.shipItem()
      }
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeShipConfirmModal()
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": ""
    },
    model: {
      value: (_vm.show_unship_confirm_modal),
      callback: function($$v) {
        _vm.show_unship_confirm_modal = $$v
      },
      expression: "show_unship_confirm_modal"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Unship Product")]), _vm._v(" "), _c('v-card-text', [_vm._v("If you click OK, the buyer will see the item has not been shipped.\n          Click OK to mark the itme as unshipped, or click Cancel.")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.unshipItem()
      }
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeUnshipConfirmModal()
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "my-dialog-2"
    },
    model: {
      value: (_vm.show_help_dialog),
      callback: function($$v) {
        _vm.show_help_dialog = $$v
      },
      expression: "show_help_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('label', [_vm._v("Sellers")])]), _vm._v(" "), _c('v-card-text', [_c('ul', [_c('li', [_vm._v("Sell "), _c('b', [_vm._v("physical")]), _vm._v(" & "), _c('b', [_vm._v("digital")]), _vm._v(" products.")]), _vm._v(" "), _c('li', [_c('b', [_vm._v("Collaborate")]), _vm._v(" on products with artists, brands & labels.\n            ")]), _vm._v(" "), _c('li', [_c('b', [_vm._v("Set splits & recoup costs")]), _vm._v(", confirm through direct message.\n            ")]), _vm._v(" "), _c('li', [_vm._v("\n              Automatically "), _c('b', [_vm._v("split payments")]), _vm._v(" for collaborative products.\n            ")]), _vm._v(" "), _c('li', [_vm._v("Keep"), _c('b', [_vm._v(" 90%")]), _vm._v(" of sales.")])])]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    staticClass: "px-4",
    attrs: {
      "dark": "",
      "round": "",
      "color": "blue"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeHelpDialog()
      }
    }
  }, [_vm._v("Ok, Got it!")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1722 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-swipe"
  }, [_c('div', {
    ref: "swipeEle",
    staticClass: "swipe-item swipe-wrapper",
    class: {
      slideRight: _vm.slideRight,
      slideLeft: _vm.slideLeft
    },
    on: {
      "mouseup": _vm.initEvent
    }
  }, [_vm._t("leftComponent")], 2), _vm._v(" "), _c('div', {
    staticClass: "swipe-item side-tab",
    class: {
      slideRight: _vm.slideRight
    }
  }, [_vm._t("rightComponent")], 2)])
},staticRenderFns: []}

/***/ }),
/* 1723 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-section"
  }, [_c('h2', [_vm._v("General Data Protection Regulation")]), _vm._v(" "), _c('div', {
    staticClass: "article-body content-body wikistyle markdown-format"
  }, [_c('div', {
    staticClass: "intro"
  }), _vm._v(" "), _c('h3', [_vm._v("1. Definitions")]), _vm._v(" "), _c('p', [_vm._v("\n      (a) “Data Protection Legislation” means European Directives 95/46/EC and\n      2002/58/EC, and any legislation and/or regulation implementing or made\n      pursuant to them, or which amends or replaces any of them (including the\n      General Data Protection Regulation, Regulation (EU) 2016/679);\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      (b) “Data Processor”, “Data Subject”, “Processor”, “Processing”,\n      “Subprocessor”, and “Supervisory Authority” shall be interpreted in\n      accordance with applicable Data Protection Legislation;\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      (c) “Personal Data” means any information relating to an identifiable or\n      identified Data Subject who visits or engages in transactions through\n      your store (a “Customer”), which YouSound Processes as a Data Processor\n      in the course of providing you with the Services. Personal Data does not\n      include information that YouSound processes in the context of services\n      that it provides directly to a consumer;\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      (d) All other capitalized terms shall have the same definitions as in\n      the Agreement.\n    ")]), _vm._v(" "), _c('h3', [_vm._v("2. Data Protection")]), _vm._v(" "), _c('ul', [_c('li', [_c('strong', [_vm._v("2.1.")]), _vm._v(" Where a Data Subject is located in the European Economic Area, that\n        Data Subject’s Personal Data will be processed by YouSound, Inc. As part\n        of providing the Services, this Personal Data may be transferred to\n        other regions, including to Canada and the European Union. Such\n        transfers will be completed in compliance with relevant Data Protection\n        Legislation.\n      ")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("2.2.")]), _vm._v(" When YouSound Processes Personal Data in the course of providing\n        the Services, YouSound will:\n      ")]), _vm._v(" "), _c('ul', [_c('li', [_c('strong', [_vm._v("2.2.1.")]), _vm._v(" Process the Personal Data as a Data Processor, only for the\n          purpose of providing the Services in accordance with documented\n          instructions from you (provided that such instructions align\n          with the functionalities of the Services), and as may subsequently be\n          agreed by you. If YouSound is required by law to Process the Personal\n          Data for any other purpose, YouSound will provide you with prior notice\n          of this requirement, unless prohibited by law.\n        ")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("2.2.2.")]), _vm._v(" Notify you if, in YouSound’s opinion, your instructions for the\n          processing of Personal Data infringe applicable Data Protection\n          Legislation.\n        ")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("2.2.3.")]), _vm._v(" Notify you promptly, to the extent permitted by law, upon\n          receiving an inquiry or complaint from a Data Subject or Supervisory\n          Authority relating to YouSound’s Processing of the Personal Data.\n        ")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("2.2.4.")]), _vm._v(" Implement and maintain appropriate technical and organizational\n          measures to protect the Personal Data against unauthorized or unlawful\n          processing, accidental loss, destruction, damage, theft, alteration,\n          or disclosure. These measures shall be appropriate to the risk and to\n          the nature of the Personal Data to be protected.\n        ")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("2.2.5.")]), _vm._v(" Provide you, upon request, with up-to-date attestations, reports,\n          or extracts thereof where available from a source charged with auditing\n          YouSound’s data protection practices (e.g., external auditors, internal\n          audit, data protection auditors), or suitable certifications, to enable\n          you to assess compliance with the terms of this Addendum.\n        ")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("2.2.6.")]), _vm._v(" Notify you promptly upon becoming aware of and confirming any\n          accidental, unauthorized, or unlawful processing of, disclosure of, or\n          access to the Personal Data.\n        ")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("2.2.7.")]), _vm._v(" Ensure that its personnel who access the Personal Data are\n          subject to confidentiality obligations that restrict their ability to\n          disclose the Customer Personal Data.\n        ")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("2.2.8.")]), _vm._v(" Upon termination of the Agreement, YouSound will promptly\n          initiate its purge process to delete or anonymize the Personal Data. If\n          you request a copy of such Personal Data within 60 days of termination,\n          YouSound will provide you with a copy of such Personal Data.\n        ")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("2.3.")]), _vm._v(" In the course of providing the Services, you acknowledge and agree\n        that YouSound may use Subprocessors to Process the Personal Data.\n        YouSound’s use of any specific Subprocessor to process the Personal Data\n        must comply with Data Protection Legislation and must be governed by a\n        contract between YouSound and the Subprocessor.\n      ")])]), _vm._v(" "), _c('h3', [_vm._v("3. Miscellaneous")]), _vm._v(" "), _c('ul', [_c('li', [_c('strong', [_vm._v("3.1.")]), _vm._v(" In the event of any conflict or inconsistency between the provisions\n        of the Agreement and this Addendum, the provisions of this Addendum\n        shall prevail. For avoidance of doubt and to the extent allowed by\n        applicable law, any and all liability under this Addendum, including\n        limitations thereof, will be governed by the relevant provisions of the\n        Agreement. You acknowledge and agree that YouSound may amend this\n        Addendum from time to time by posting the relevant amended and restated\n        Addendum on YouSound’s Terms & Policy page on its website, and such\n        amendments to the Addendum are effective as of the date of posting. Your\n        continued use of the Services after the amended Addendum is posted to\n        YouSound’s website constitutes your agreement to, and acceptance of, the\n        amended Addendum. If you do not agree to any changes to the Addendum, do\n        not continue to use the Service.\n      ")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("3.2.")]), _vm._v(" Except as specifically modified and amended in this Addendum, all of\n        the terms, provisions, and requirements contained in the Agreement shall\n        remain in full force and effect and govern this Addendum. If any\n        provision of the Addendum is held illegal or unenforceable in a judicial\n        proceeding, such provision shall be severed and shall be inoperative,\n        and the remainder of this Addendum shall remain operative and binding on\n        the parties.\n      ")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("3.3.")]), _vm._v(" The terms of this Addendum shall be governed by and interpreted in\n        accordance with the laws of the Province of Ontario and the laws of\n        Canada applicable therein, without regard to principles of conflicts of\n        laws. The parties irrevocably and unconditionally submit to the\n        exclusive jurisdiction of the courts of the Province of Ontario with\n        respect to any dispute or claim arising out of or in connection with\n        this Addendum.\n      ")])])])])
}]}

/***/ }),
/* 1724 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('content-top-header', {
    staticClass: "black-theme"
  }, [_c('template', {
    slot: "topHeader"
  }, [_c('ul', {
    staticClass: "pr-3"
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('li', {
      key: tab.id,
      staticClass: "nav-li",
      class: [{
        'active': _vm.name === tab.id,
        'tab-active': _vm.tabActivePill
      }, ("nav-" + (tab.id))],
      attrs: {
        "href": ("#" + (tab.id))
      }
    }, [_c('label', {
      staticClass: "nav-label",
      on: {
        "click": function($event) {
          _vm.setTab(tab.pathName)
        }
      }
    }, [_vm._v("\n            " + _vm._s(tab.title) + "\n          ")])])
  }))])], 2)
},staticRenderFns: []}

/***/ }),
/* 1725 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "repost-comp repost-music"
  }, [(_vm.showBanner) ? _c('div', {
    staticClass: "repost-banner"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "repost-banner-close",
    on: {
      "click": function($event) {
        _vm.closeBanner()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(80),
      "width": "15px"
    }
  })])]) : _vm._e(), _vm._v(" "), (!_vm.viewAllPlaylist) ? _c('div', {
    staticClass: "playlists"
  }, [_c('div', {
    staticClass: "title dflex align-center _intro"
  }, [_c('div', [_vm._v(_vm._s(_vm.playlistLen()) + " Playlists")]), _vm._v(" "), _c('div', {
    staticClass: "_action",
    on: {
      "click": function($event) {
        _vm.displayAllPlaylists()
      }
    }
  }, [_vm._v("View All")])]), _vm._v(" "), _c('div', {
    staticClass: "dflex playlist-container"
  }, _vm._l((this.playlists.slice(0, 6).reverse()), function(playlist, index) {
    return _c('div', {
      key: index,
      staticClass: "playlist-holder pr-2"
    }, [_c('v-btn', {
      staticClass: "absolute",
      attrs: {
        "dark": ""
      },
      on: {
        "click": function($event) {
          _vm.openDeletePlaylistModal(playlist.id)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "right": ""
      }
    }, [_vm._v("more_horiz")])], 1), _vm._v(" "), _c('div', {
      staticClass: "playlist-box",
      on: {
        "click": function($event) {
          _vm.$router.push({
            path: ("/playlist/" + (playlist.id))
          })
        }
      }
    }, [_c('div', {
      staticClass: "playlist-images"
    }, [_c('ul', _vm._l((_vm.playlistImageList(playlist)), function(playlistImage, index) {
      return _c('li', {
        key: index
      }, [_c('img', {
        attrs: {
          "src": playlistImage,
          "width": "30",
          "alt": "playlist icon"
        }
      })])
    }))]), _vm._v(" "), _c('div', {
      staticClass: "playlist-text"
    }, [_vm._v("\n\t\t\t\t\t\t " + _vm._s(playlist.name) + "\n\t\t\t\t\t\t")])])], 1)
  }))]) : _vm._e(), _vm._v(" "), (!_vm.viewAllPlaylist) ? _c('div', {
    staticClass: "music playlist-music"
  }, [_c('div', {
    staticClass: "title _intro"
  }, [_vm._v(_vm._s(this.tracks.length) + " Tracks")]), _vm._v(" "), _c('div', {
    staticClass: "title dflex align-center justify-space-between _intro"
  }, [_c('div', {
    staticClass: "dflex align-center justify-space-between w-100"
  }, [_c('input', {
    staticClass: "input-track mr-auto",
    attrs: {
      "type": "text",
      "placeholder": "Search tracks"
    }
  }), _vm._v(" "), (_vm.selectAlbumsMode) ? _c('div', {
    staticClass: "selectAlbumsMode _action"
  }, [_c('v-btn', {
    attrs: {
      "round": "",
      "dark": "",
      "depressed": ""
    },
    on: {
      "click": function($event) {
        _vm.openAddToPlaylist()
      }
    }
  }, [_vm._v(" Add selected to... ")]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        _vm.toggleSelectAlbumsMode(false)
      }
    }
  }, [_vm._v(" Cancel ")])], 1) : _c('div', [_c('v-btn', {
    staticClass: "dflex align-center _action pointer-cursor font-bold",
    attrs: {
      "round": "",
      "dark": "",
      "depressed": ""
    },
    on: {
      "click": function($event) {
        _vm.toggleSelectAlbumsMode(true)
      }
    }
  }, [_c('v-icon', [_vm._v("add")]), _vm._v(" "), _c('span', [_vm._v("Select tracks")])], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "_body list-track-view list-track-view-trackCard"
  }, _vm._l((this.tracks), function(track, index) {
    return _c('div', {
      key: index,
      staticClass: "list-track-view-item"
    }, [_c('track-card', {
      attrs: {
        "objects": _vm.tempAlbum,
        "objectIndex": index,
        "getCollections": _vm.getCollections,
        "hideMoreMenu": "",
        "hideTrackLength": "",
        "forCollection": "",
        "meatBall": !_vm.selectAlbumsMode,
        "displayDuration": ""
      }
    }), _vm._v(" "), (_vm.selectAlbumsMode) ? _c('div', {
      staticClass: "selectMusic"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedAlbums),
        expression: "selectedAlbums"
      }],
      staticClass: "selectMusic-check",
      attrs: {
        "type": "checkbox",
        "id": ("check-" + index)
      },
      domProps: {
        "value": track,
        "checked": Array.isArray(_vm.selectedAlbums) ? _vm._i(_vm.selectedAlbums, track) > -1 : (_vm.selectedAlbums)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.selectedAlbums,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = track,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedAlbums = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectedAlbums = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedAlbums = $$c
          }
        }
      }
    }), _vm._v(" "), (_vm.selectedAlbums.includes(track)) ? _c('v-icon', {
      staticClass: "check-icon",
      on: {
        "click": function($event) {
          _vm.removeAlbum(track)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\tcheck\n\t\t\t\t\t\t")]) : _vm._e()], 1) : _vm._e()], 1)
  }))]) : _vm._e(), _vm._v(" "), (_vm.viewAllPlaylist) ? _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-lg": "",
      "px-0": "",
      "py-0": ""
    }
  }, [_c('div', {
    staticClass: "playlists"
  }, [_c('div', {
    staticClass: "title dflex align-center _intro"
  }, [_c('v-btn', {
    staticClass: "back-btn",
    attrs: {
      "ripple": true,
      "fab": "",
      "small": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.back()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ml-4"
  }, [_vm._v(_vm._s(_vm.playlistLen()) + " Playlists")])], 1), _vm._v(" "), _c('div', {
    staticClass: "dflex playlist-container"
  }, _vm._l((this.playlists), function(playlist, index) {
    return _c('div', {
      key: index,
      staticClass: "playlist-holder pr-2",
      on: {
        "click": function($event) {
          _vm.$router.push({
            path: ("/playlist/" + (playlist.id))
          })
        }
      }
    }, [_c('div', {
      staticClass: "playlist-box"
    }, [_c('div', {
      staticClass: "playlist-images"
    }, [_c('ul', _vm._l((_vm.playlistImageList(playlist)), function(playlistImage, index) {
      return _c('li', {
        key: index
      }, [_c('img', {
        attrs: {
          "src": playlistImage,
          "width": "30",
          "alt": "playlist icon"
        }
      })])
    }))]), _vm._v(" "), _c('div', {
      staticClass: "playlist-text"
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(playlist.name) + "\n\t\t\t\t\t\t\t")])])])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.addToPlaylistActive) ? _c('add-to-playlist', {
    attrs: {
      "playlists": this.playlists,
      "addToPlaylist": _vm.addToPlaylistActive,
      "selectedItems": _vm.selectedAlbums,
      "type": "track"
    },
    on: {
      "closeAddToPlaylist": _vm.closeAddToPlaylist,
      "methodThatForcesUpdate": _vm.methodThatForcesUpdate
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dflex gap-25 align-center justify-space-between"
  }, [_c('div', {
    staticClass: "repost-content"
  }, [_c('div', {
    staticClass: "dflex align-center mb-4"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(308),
      "width": "25"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "repost-head"
  }, [_vm._v("Build your collection")])]), _vm._v(" "), _c('p', {
    staticClass: "repost-text"
  }, [_vm._v("Create playlists or shopping lists for all of the albums, videos & products you discover")])]), _vm._v(" "), _c('div', {
    staticClass: "repost-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(97),
      "width": "100%"
    }
  })])])
}]}

/***/ }),
/* 1726 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('content-top-header', {
    staticClass: "black-theme"
  }, [_c('template', {
    slot: "topHeader"
  }, [_c('ul', {
    staticClass: "pr-3"
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('li', {
      key: tab.id,
      staticClass: "nav-li",
      class: [{
        'active': _vm.name === tab.id,
        'tab-active': _vm.tabActivePill
      }, ("nav-" + (tab.id))],
      attrs: {
        "href": ("#" + (tab.id))
      }
    }, [_c('label', {
      staticClass: "nav-label",
      on: {
        "click": function($event) {
          _vm.setTab(tab.pathName)
        }
      }
    }, [_vm._v("\n            " + _vm._s(tab.title) + "\n          ")])])
  }))])], 2)
},staticRenderFns: []}

/***/ }),
/* 1727 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "items"
  }, [(!_vm.onMobile) ? _c('div', [_vm._l((_vm.items), function(item) {
    return [_c('div', {
      key: item.id,
      staticClass: "item"
    }, [_c('div', {
      staticClass: "item__header"
    }, [_c('router-link', {
      attrs: {
        "to": ("/" + (item.user.slug))
      }
    }, [_c('div', {
      staticClass: "item__image",
      style: (("background-image: url(" + (item.user.avatar.url) + ")"))
    })])], 1), _vm._v(" "), _c('div', {
      staticClass: "item__content"
    }, [_c('div', {
      staticClass: "item__title"
    }, [_c('router-link', {
      attrs: {
        "to": ("/" + (item.user.slug))
      }
    }, [_vm._v("\n              " + _vm._s(_vm._f("capitalize")(item.user.username)) + "\n            ")]), _vm._v(" "), (!_vm.hideDatedString) ? _c('span', [_vm._v(_vm._s(_vm.toLocalTimeString(item.created_at)))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "item__description",
      domProps: {
        "innerHTML": _vm._s(item.body)
      }
    })]), _vm._v(" "), (_vm.showShortAge) ? _c('div', {
      staticClass: "item__age"
    }, [_vm._v(_vm._s(_vm._f("formatDateFromNowShort")(item.created_at)))]) : _vm._e()])]
  })], 2) : _c('div', [_vm._l((_vm.items), function(item) {
    return [_c('item-swipe', {
      key: item.id
    }, [_c('template', {
      slot: "leftComponent"
    }, [_c('div', {
      key: item.id,
      staticClass: "item"
    }, [_c('div', {
      staticClass: "item__header"
    }, [_c('user-tag', {
      attrs: {
        "user": item.user,
        "width": "42",
        "height": "42",
        "hideName": "",
        "hideTick": "",
        "showAvatar": ""
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "item__content"
    }, [_c('div', {
      staticClass: "item__title"
    }, [_c('div', {
      staticClass: "created_by"
    }, [_vm._v("\n                    " + _vm._s(_vm._f("capitalize")(item.user.username)) + "\n                  ")]), _vm._v(" "), (!_vm.hideDatedString) ? _c('span', {
      staticClass: "created_at"
    }, [_vm._v(_vm._s(_vm.toLocalTimeString(item.created_at)))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "item__description",
      domProps: {
        "innerHTML": _vm._s(item.body)
      }
    })]), _vm._v(" "), (_vm.showShortAge) ? _c('div', {
      staticClass: "item__age"
    }, [_vm._v(_vm._s(_vm._f("formatDateFromNowShort")(item.created_at)))]) : _vm._e()])]), _vm._v(" "), _c('template', {
      slot: "rightComponent"
    }, [_c('v-btn', {
      staticStyle: {
        "background": "#FF6565"
      },
      attrs: {
        "depressed": ""
      },
      on: {
        "click": function($event) {
          _vm.deleteComment()
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "white"
      }
    }, [_vm._v("delete")])], 1)], 1)], 2)]
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 1728 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "repost-payment-modal"
  }, [_c('div', {
    staticClass: "dismiss-section",
    on: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  }), _vm._v(" "), (!_vm.show_error_dialog) ? _c('v-layout', {
    staticClass: "popup-section",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "modal__header",
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('p', [_vm._v("\n        You are requesting a repost from\n        "), _c('span', [_vm._v(_vm._s(_vm.receiver.username))])])]), _vm._v(" "), _c('v-flex', {
    staticClass: "modal__content",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "repost-item"
  }, [_c('div', {
    staticClass: "repost-item-image",
    style: ({
      'background-image': 'url(' + _vm.itemCover + ')'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "repost-item-title"
  }, [_vm._v(_vm._s(_vm.itemTitle))]), _vm._v(" "), _c('div', {
    staticClass: "repost-item-owner"
  }, [_vm._v(_vm._s(_vm.itemOwner))])]), _vm._v(" "), _c('div', {
    staticClass: "payment"
  }, [_c('p', [_vm._v("\n          This user charge\n          "), _c('strong', [_vm._v("$" + _vm._s(_vm._f("formatNumber")(_vm.receiver.repost_price)))]), _vm._v(" for\n          repost requests.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          You card isn't charged unless this user choose to repost your\n          content. Users can accept, deny, or repost for free. If the user\n          doesn't respond in 1 day, the request is automatically denied\n        ")]), _vm._v(" "), _c('v-flex', {
    staticClass: "payment-section",
    attrs: {
      "xs12": ""
    }
  }, [_c('card', {
    staticClass: "stripe-card pa-2",
    class: {
      complete: _vm.complete
    },
    attrs: {
      "stripe": _vm.stripe_publishable_key,
      "options": _vm.stripeOptions
    },
    on: {
      "change": function($event) {
        _vm.complete = $event.complete
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fee-section pl-2 pr-2"
  }, [_c('label', {
    staticClass: "fee-amount"
  }, [_vm._v("fee: $" + _vm._s(_vm._f("formatNumber")(_vm.fee)))])])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "action-section",
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('v-btn', {
    staticClass: "pay-btn",
    attrs: {
      "disabled": _vm.sent_payment || !_vm.complete
    },
    nativeOn: {
      "click": function($event) {
        _vm.sendPayment()
      }
    }
  }, [_vm._v("Pay: $" + _vm._s(_vm._f("formatNumber")((_vm.amount + _vm.fee))))])], 1)], 1)]), _vm._v(" "), _c('v-flex', {
    staticClass: "modal__footer",
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('p', [_vm._v("All transaction powered by "), _c('span', [_vm._v("Stripe.com")])])])], 1) : _c('v-dialog', {
    attrs: {
      "content-class": "my-dialog-1",
      "persistent": ""
    },
    model: {
      value: (_vm.show_error_dialog),
      callback: function($$v) {
        _vm.show_error_dialog = $$v
      },
      expression: "show_error_dialog"
    }
  }, [_c('v-card', [_c('v-card-media', {
    attrs: {
      "src": _vm._.get(_vm.receiver, 'avatar.thumb.url'),
      "height": "125px",
      "contain": ""
    }
  }), _vm._v(" "), _c('v-card-text', {
    staticClass: "mt-2"
  }, [_c('div', {
    staticClass: "headline"
  }, [_vm._v("You cannot send the payment")]), _vm._v(" "), _c('div', [_vm._v("\n          " + _vm._s(_vm._.get(_vm.receiver, "display_name", "Receiver")) + " did not connect to\n          stripe yet.\n        ")])]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "dark": "",
      "color": "blue"
    },
    nativeOn: {
      "click": function($event) {
        _vm.show_error_dialog = false;
        _vm.dismiss();
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1729 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sms",
    class: {
      onMobile: _vm.onMobile
    },
    style: ([_vm.sizeSMS])
  }, [_c('div', {
    staticClass: "closedecoy",
    on: {
      "click": _vm.outsideClick
    }
  }), _vm._v(" "), (_vm.isUserSignedUp && !_vm.isUserSubscribed) ? _c('div', {
    staticClass: "subscribe-view"
  }, [(!_vm.showCardPanel) ? _c('div', {
    staticClass: "intro"
  }, [_vm._m(0), _vm._v(" "), _c('img', {
    staticClass: "cursor-pointer",
    attrs: {
      "src": __webpack_require__(164),
      "width": "16"
    },
    on: {
      "click": _vm.closeSMS
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.showCardPanel) ? _c('hr') : _vm._e(), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": "",
      "px-0": "",
      "grid-list-lg": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "start-trial": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('h2', {
    staticClass: "_title"
  }, [_vm._v("\n            Start "), _c('br'), _vm._v("\n            Free Trial\n          ")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("30 days")]), _vm._v(" "), _c('li', [_vm._v("Cancel anytime")])])]), _vm._v(" "), (!_vm.showCardPanel) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "pro-plan": ""
    }
  }, [_c('h3', {
    staticClass: "_title"
  }, [_vm._v("Pro")]), _vm._v(" "), _c('div', {
    staticClass: "_subtitle"
  }, [_vm._v("For professional creators & curators")]), _vm._v(" "), _c('span', {
    staticClass: "plan-list"
  }, [_c('v-icon', {
    staticClass: "_check"
  }, [_vm._v("check")]), _vm._v(" "), _c('div', [_vm._v("Ad-free + unlimited uploads")])], 1), _vm._v(" "), _c('span', {
    staticClass: "plan-list"
  }, [_c('v-icon', {
    staticClass: "_check"
  }, [_vm._v("check")]), _vm._v(" "), _c('div', [_vm._v("Keep 100% sales & donations")])], 1), _vm._v(" "), _c('span', {
    staticClass: "plan-list"
  }, [_c('v-icon', {
    staticClass: "_check"
  }, [_vm._v("check")]), _vm._v(" "), _c('div', [_vm._v("SMS texting*")])], 1), _vm._v(" "), _c('span', {
    staticClass: "plan-list"
  }, [_c('v-icon', {
    staticClass: "_check"
  }, [_vm._v("check")]), _vm._v(" "), _c('div', [_vm._v("Get paid to share")])], 1), _vm._v(" "), _c('div', {
    staticClass: "pricing"
  }, [_c('div', {
    staticClass: "_wrapper"
  }, [_c('span', {
    staticClass: "currency"
  }, [_vm._v("$")]), _vm._v(" "), _c('span', {
    staticClass: "cost"
  }, [_vm._v("30")]), _vm._v(" "), _c('span', {
    staticClass: "duration"
  }, [_vm._v("/month")])]), _vm._v(" "), _c('v-btn', {
    staticClass: "trial-btn",
    on: {
      "click": function($event) {
        _vm.showCard()
      }
    }
  }, [_vm._v("Free Trial")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.showCardPanel) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "card-panel": ""
    }
  }, [_c('img', {
    staticClass: "_logo",
    attrs: {
      "src": __webpack_require__(44),
      "width": "80"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "_subtitle mb-3"
  }, [_vm._v("Pro Subscription")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('card', {
    staticClass: "stripe-card",
    class: {
      complete: _vm.complete
    },
    attrs: {
      "stripe": _vm.stripePubkey,
      "options": _vm.options
    },
    on: {
      "change": function($event) {
        _vm.complete = $event.complete
      }
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "addCard-btn",
    attrs: {
      "depressed": "",
      "disabled": false,
      "loading": _vm.addCardLoading
    },
    on: {
      "click": function($event) {
        _vm.paymentMethod()
      }
    }
  }, [_vm._v("\n            Add card to file\n          ")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), (!_vm.showCardPanel) ? _c('div', {
    staticClass: "footnote"
  }, [_vm._v("\n      * SMS costs $0.01 per text\n    ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.isUserSignedUp) ? _c('div', {
    staticClass: "creator-signup"
  }, [(!_vm.signUpDone) ? _c('div', {
    staticClass: "join-creator",
    class: {
      digitEntered: _vm.digitEntered
    }
  }, [(_vm.digitEntered) ? _c('div', {
    staticClass: "_title"
  }, [_vm._v("Confirm Your Number")]) : _c('div', {
    staticClass: "_title"
  }, [_vm._v("Join this creator community")]), _vm._v(" "), _c('div', {
    staticClass: "_user"
  }, [_c('user-tag', {
    attrs: {
      "user": _vm.currentUser,
      "showAvatar": "",
      "hideTick": "",
      "hideName": "",
      "fitContent": "",
      "height": "140",
      "width": "140",
      "clickUser": false
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('user-tag', {
    attrs: {
      "user": _vm.currentUser,
      "fitContent": "",
      "showUserType": "",
      "clickUser": false
    }
  })], 1), _vm._v(" "), (_vm.digitEntered) ? _c('div', {
    staticClass: "message"
  }, [_vm._v("\n        You will receive text to this number. This number will also be used\n        when you sign up to other SMS communities\n      ")]) : _c('div', {
    staticClass: "message"
  }, [_vm._v("\n        Enter your phone number to let creator send you text messages from\n        this app. Phone numbers are never shared.\n      ")]), _vm._v(" "), (!_vm.digitEntered) ? _c('div', {
    staticClass: "_tel"
  }, [_c('br'), _vm._v(" "), _c('img', {
    staticClass: "flag",
    attrs: {
      "src": __webpack_require__(634),
      "width": "18"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "digit"
  }, [_vm._v("+ 0 1 (")]), _vm._v(" "), _vm._l((_vm.digitsLen), function(input, idx) {
    return _c('span', {
      key: idx
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (_vm.telDigits[idx]),
        expression: "telDigits[idx]",
        modifiers: {
          "number": true
        }
      }],
      ref: ("input" + idx),
      refInFor: true,
      staticClass: "digit _num",
      attrs: {
        "type": "text",
        "name": "",
        "id": ("input-" + idx),
        "pattern": "([0-9])",
        "maxlength": "1"
      },
      domProps: {
        "value": (_vm.telDigits[idx])
      },
      on: {
        "keydown": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "delete", [8, 46], $event.key)) { return null; }
          _vm.delDigit($event, idx)
        },
        "keyup": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
          _vm.submitTel($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.telDigits, idx, _vm._n($event.target.value))
        },
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    }), _vm._v(" "), (idx === 2) ? _c('span', {
      staticClass: "digit"
    }, [_vm._v(")")]) : _vm._e(), _vm._v(" "), (idx === 6) ? _c('span', {
      staticClass: "digit"
    }, [_vm._v("-")]) : _vm._e()])
  })], 2) : _c('div', {
    staticClass: "_tel-entered"
  }, [_vm._v(_vm._s(_vm.telFormatted))]), _vm._v(" "), (_vm.digitEntered) ? _c('v-btn', {
    staticClass: "width100",
    attrs: {
      "round": "",
      "dark": "",
      "depressed": ""
    },
    on: {
      "click": function($event) {
        _vm.updatePhoneNo()
      }
    }
  }, [_vm._v("\n        Confirm\n      ")]) : _vm._e(), _vm._v(" "), (_vm.digitEntered) ? _c('h3', {
    staticClass: "cursor-pointer",
    on: {
      "click": function($event) {
        _vm.digitEntered = false
      }
    }
  }, [_vm._v("\n        Update my number\n      ")]) : _vm._e(), _vm._v(" "), (!_vm.digitEntered) ? _c('h3', {
    staticClass: "cursor-pointer",
    on: {
      "click": _vm.closeSMS
    }
  }, [_vm._v("\n        No thanks, I’ll just follow\n      ")]) : _vm._e()], 1) : (_vm.signUpDone) ? _c('div', {
    staticClass: "signup-done"
  }, [_c('img', {
    staticClass: "flag",
    attrs: {
      "src": __webpack_require__(1448),
      "width": "22",
      "alt": "conversation icon"
    }
  }), _vm._v(" "), _c('div', [_vm._v("You’ve been added to this SMS list")]), _vm._v(" "), _c('v-btn', {
    staticClass: "done-btn",
    attrs: {
      "depressed": "",
      "round": ""
    },
    on: {
      "click": function($event) {
        _vm.closeSMS()
      }
    }
  }, [_vm._v("Close")])], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (
    !_vm.confirmSendSMS && !_vm.sendSuccess && _vm.isUserSignedUp && _vm.isUserSubscribed
  ) ? _c('div', {
    staticClass: "post-sms"
  }, [(!_vm.confirmSendSMS) ? _c('div', {
    staticClass: "post-sms-card"
  }, [_c('div', {
    staticClass: "post-sms-wrapper"
  }, [(!_vm.onMobile) ? _c('div', {
    staticClass: "_top"
  }, [_c('h2', {
    staticClass: "_title"
  }, [_vm._v("Send SMS")]), _vm._v(" "), _c('div', {
    staticClass: "_title"
  }, [_vm._v("\n            to "), _c('strong', [_vm._v(_vm._s(_vm._f("formatNumberWithComma")(45678)))]), _vm._v(" SMS\n            contacts\n          ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "post-sms-submit",
    class: {
      onMobile: _vm.onMobile
    }
  }, [_c('div', {
    staticClass: "cursor-pointer",
    on: {
      "click": _vm.closeSMS
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('div', {
    staticClass: "dflex align-center"
  }, [_c('div', {
    staticClass: "char-count mr-2"
  }, [_c('span', {
    class: {
      'red--text': _vm.charCount == _vm.smsMaxChar
    }
  }, [_vm._v(_vm._s(_vm.charCount))]), _vm._v("\n              /\n              "), _c('span', [_vm._v(_vm._s(_vm.smsMaxChar))])]), _vm._v(" "), _c('v-btn', {
    staticClass: "post-sms-btn ma-0",
    attrs: {
      "round": "",
      "depressed": "",
      "dark": ""
    },
    on: {
      "click": _vm.confirmSend
    }
  }, [_c('span', [_vm._v("Send")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "post-sms-action"
  }, [_c('div', {
    staticClass: "sms-layer sms-input"
  }, [_c('user-tag', {
    attrs: {
      "showAvatar": "",
      "hideName": "",
      "hideTick": "",
      "user": _vm.currentUser,
      "width": "30",
      "height": "30"
    }
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.textMessage),
      expression: "textMessage",
      modifiers: {
        "trim": true
      }
    }],
    ref: "sms",
    staticClass: "sms-input-area",
    attrs: {
      "maxlength": _vm.smsMaxChar,
      "placeholder": "Enter message..."
    },
    domProps: {
      "value": (_vm.textMessage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.textMessage = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })], 1), _vm._v(" "), (!_vm.onMobile) ? _c('div', {
    staticClass: "char-count"
  }, [_c('span', {
    class: {
      'red--text': _vm.charCount == _vm.smsMaxChar
    }
  }, [_vm._v(_vm._s(_vm.charCount))]), _vm._v("\n          /\n          "), _c('span', [_vm._v(_vm._s(_vm.smsMaxChar))])]) : _vm._e()]), _vm._v(" "), _c('attach-slide', {
    staticClass: "mb-0",
    on: {
      "getAttachment": _vm.getSelected
    }
  }), _vm._v(" "), (!_vm.onMobile) ? _c('div', {
    staticClass: "post-sms-submit"
  }, [_c('div', {
    staticClass: "cursor-pointer",
    on: {
      "click": _vm.closeSMS
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    staticClass: "post-sms-btn ma-0",
    attrs: {
      "round": "",
      "depressed": "",
      "dark": ""
    },
    on: {
      "click": _vm.confirmSend
    }
  }, [_c('span', [_vm._v("Send")])])], 1) : _vm._e()], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.confirmSendSMS) ? _c('div', {
    staticClass: "confirm-sms"
  }, [_c('img', {
    staticClass: "cursor-pointer close-icon",
    attrs: {
      "src": __webpack_require__(164),
      "width": "16"
    },
    on: {
      "click": _vm.closeSMS
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "_title"
  }, [_vm._v("Confirm SMS text")]), _vm._v(" "), _c('img', {
    staticClass: "my-4",
    attrs: {
      "src": __webpack_require__(1525),
      "width": "35"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "_message"
  }, [_vm._v("\n      This SMS text will be sent to:\n      "), _c('strong', [_vm._v(_vm._s(_vm._f("formatNumberWithComma")(2450)) + " people")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n\n      The credit card connected to this account will be charged $0.01 per\n      text:\n\n      "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h2', [_vm._v("$24.50")])]), _vm._v(" "), _c('v-btn', {
    staticClass: "width100 mt-3",
    attrs: {
      "dark": "",
      "round": ""
    },
    on: {
      "click": _vm.sendSMS
    }
  }, [_vm._v("Ok, send SMS")])], 1) : _vm._e(), _vm._v(" "), (_vm.onMobile && _vm.sendSuccess) ? _c('div', {
    staticClass: "sms-success"
  }, [_c('img', {
    staticClass: "m2-4",
    attrs: {
      "src": __webpack_require__(310),
      "width": "60"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "_title"
  }, [_vm._v("Success")]), _vm._v(" "), _c('div', {
    staticClass: "_message"
  }, [_vm._v("\n      SMS text sent to: "), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm._f("formatNumberWithComma")(2450)) + " people")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-btn', {
    staticClass: "width100 mt-3",
    attrs: {
      "dark": "",
      "depressed": "",
      "round": ""
    },
    on: {
      "click": _vm.openEngagement
    }
  }, [_vm._v("\n      View Engagement\n    ")])], 1) : _vm._e(), _vm._v(" "), (_vm.smsEngagementActive) ? _c('sms-engagement', {
    on: {
      "closeEngagement": _vm.closeEngagement
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n        You have "), _c('strong', [_vm._v("2,500")]), _vm._v(" people on your SMS contact list!\n        "), _c('br'), _vm._v("\n        Subscribe to a "), _c('strong', [_vm._v("Pro Plan")]), _vm._v(" to text your content to them\n        directly.\n      ")])
}]}

/***/ }),
/* 1730 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-section"
  }, [_c('h2', [_vm._v("Community Guidelines")]), _vm._v(" "), _c('p', [_vm._v("\n    At YouSound, our mission is to provide a safe & ethical social music\n    experience powered by our Verified Artists, and we require that all users\n    participate with our Community Guidelines. YouSound reserves the right to\n    terminate any account for any conduct that we consider inappropriate or\n    harmful. First & second infractions will be acknowledged by our staff in\n    the form of an email to the account you signed up with. Your access to the\n    site could be terminated. If we deem your content is unsuitable and not\n    corresponding to our Community Guidelines, YouSound has the ability to\n    disable your video broadcasting privileges and/or cut live transmission of\n    your video broadcast to viewers while you are streaming.\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    YouSound also has the ability to terminate your account and all of the\n    content within it, including your music, playlists, and products. There is\n    no fixed time for the length of termination for severe violations, and if\n    your account is re-instated, all of your content may be lost. YouSound is\n    an open platform that gives users unparalleled access to broadcast and\n    create revenue while consuming musical content for free. Thus, YouSound\n    has a zero tolerance policy to moderating our community, and avoids\n    suspending accounts and opts for termination. YouSound will not allow\n    anyone not complying with Community Guidelines the ability to jeopardize\n    the privileges for the entire community.\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    As stated in our Terms of Service, we also provide these Community\n    Guidelines for every user to follow when using YouSound services. As\n    YouSound grows, we may encounter unforeseen cases that may require us to\n    update our Community Guidelines. It is your responsibility as a user to\n    read and periodically check our Community Guidelines to full understand\n    how to conduct your business and interactions, and make sure they are in\n    compliance of our Community Guidelines.\n  ")]), _vm._v(" "), _c('h3', [_vm._v("Respect The Law")]), _vm._v(" "), _c('p', [_vm._v("\n    We require users to obey their applicable local, regional, national, and\n    international laws while using our services. Behavior or actions\n    showcasing, encouraging, offering, or soliciting illegal activity is fully\n    prohibited.\n  ")]), _vm._v(" "), _c('h3', [_vm._v("Evasion of Termination")]), _vm._v(" "), _c('p', [_vm._v("\n    Every termination is binding until an official representative of YouSound\n    reinstates your account. Any attempt to avoid our site, community, or chat\n    termination by logging on with other accounts, usernames, or appearance on\n    another user's account will also result in termination of the newly\n    created account, or the user's account you appear on.\n  ")]), _vm._v(" "), _c('h3', [_vm._v("Self-Abuse Conduct")]), _vm._v(" "), _c('p', [_vm._v("\n    Any and all conduct or activity that may endanger your life or cause you\n    to do yourself physical harm is strictly prohibited. This includes, but is\n    not limited to: use of illegal drugs, suicide threats, intentional\n    physical trauma, use of weapons on yourself, and excessive alcohol\n    consumption.\n  ")]), _vm._v(" "), _c('h3', [_vm._v("Threats of Violence")]), _vm._v(" "), _c('p', [_vm._v("\n    Acts, confessions, or threats of violence are taken extremely seriously.\n    This includes, but is not limited to:\n  ")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("\n      Attempts or threats to physically injure, hurt, harm or kill others\n    ")]), _vm._v(" "), _c('li', [_vm._v("\n      Confessions of physically injuring, hurting, harming or killing others\n    ")]), _vm._v(" "), _c('li', [_vm._v("\n      Use of weapons such as knifes or guns to intimidate, injure or kill\n      others\n    ")]), _vm._v(" "), _c('li', [_vm._v("\n      Attempts or threats to hack, or use other forms of technology to harm\n      others.\n    ")])]), _vm._v(" "), _c('h3', [_vm._v("Hate Speech & Harassment")]), _vm._v(" "), _c('p', [_vm._v("\n    Hate speech activity, conduct, or any content that actively advocates,\n    persuades, or facilitates discrimination, harasses, or violates others\n    with violence based on ethnicity, race, sex, religion, sexual orientation,\n    gender, age, medical condition, disability, physical characteristics, is\n    strictly prohibited. All hateful speech and conduct is in violation of our\n    Community Guidelines, and all accounts associated with hate speech and\n    conduct will be swiftly terminated indefinitely.\n  ")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Tormenting or verbally abusing users to humiliate somebody")]), _vm._v(" "), _c('li', [_vm._v("Advising somebody to hurt themselves")]), _vm._v(" "), _c('li', [_vm._v("Creating user accounts for the sole use of harassment")]), _vm._v(" "), _c('li', [_vm._v("Influencing others to harass users")]), _vm._v(" "), _c('li', [_vm._v("\n      Stalking or continually contacting users who don't want to be contacted\n    ")]), _vm._v(" "), _c('li', [_vm._v("\n      Disclosing someone's personal information without their permission\n    ")]), _vm._v(" "), _c('li', [_vm._v("\n      Recording somebody against their will with the purpose to hurt them\n    ")]), _vm._v(" "), _c('li', [_vm._v("Sharing information or content with the purpose to inflict harm")]), _vm._v(" "), _c('li', [_vm._v("Browsing or raiding user profiles with the intent to cause harm")]), _vm._v(" "), _c('li', [_vm._v("Unwanted sexual or lewd advances and inappropriate behavior")]), _vm._v(" "), _c('li', [_vm._v("Sexual assault, rape, molestation, or content that promotes it")]), _vm._v(" "), _c('li', [_vm._v("Content with nude persons or performing sexual acts")]), _vm._v(" "), _c('li', [_vm._v("\n      Sexual content (sound or visual), shared or threatened to share without\n      consent\n    ")]), _vm._v(" "), _c('li', [_vm._v("\n      Uninvited offers, demands, bribes, or extortion for sexual content and\n      services\n    ")]), _vm._v(" "), _c('li', [_vm._v("\n      Sexual services, prostitution, escorts, sexual massages, recorded sexual\n      activity\n    ")]), _vm._v(" "), _c('li', [_vm._v("\n      Sexual content, nudity, sexual violence or exploitation of minors, or\n      seems to include minors, or content that underage sex.\n    ")])]), _vm._v(" "), _c('p', [_vm._v("\n    Harassment of any kind, including the guidelines stated in this section,\n    is any content or activity that attempts to degrade, intimidate, abuse, or\n    create an unfriendly environment for users, and is strictly prohibited and\n    is subject to immediate account termination. YouSound is not allowed to be\n    used to encourage hateful speech, harassment, or conduct, whether the\n    victims of such abuse are on or off YouSound services. Users of YouSound\n    that engagement in hateful conduct will be prevented from using our\n    services. In some cases, YouSound may take legal action against users for\n    hate speech or sexual misconduct, including any content that promotes it.\n  ")]), _vm._v(" "), _c('h3', [_vm._v("Disclosure of Private Information")]), _vm._v(" "), _c('p', [_vm._v("\n    Sharing the private information of others is strictly prohibited. Any\n    information that reveals the private and personal information about any\n    individual or user on or off the YouSound service, including information\n    of their private residence, without permission if prohibited. This\n    includes but is not limited to:\n  ")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("\n      Sharing or disclosing of personal and identifiable information (real\n      name, location, or photo ID)\n    ")]), _vm._v(" "), _c('li', [_vm._v("\n      Sharing or disclosing protected user profiles or any information from\n      said profiles\n    ")]), _vm._v(" "), _c('li', [_vm._v("\n      Sharing, disclosing, or broadcasting any content that is obtained from\n      filming or streaming in a way that invades another's person or users\n      privacy and/or takes place on the private property of the person or user\n      without permission\n    ")])]), _vm._v(" "), _c('h3', [_vm._v("Impersonation & Imitation")]), _vm._v(" "), _c('p', [_vm._v("\n    All use content and/or activity on YouSound meant to impersonate, imitate,\n    or otherwise convince other users that you are another individual on\n    YouSound is strictly prohibited. Any and all attempts to falsify or skew\n    the perception of your real identity with the intention to convince other\n    users that you are another member on YouSound will have their account\n    immediately terminated indefinitely.\n  ")]), _vm._v(" "), _c('h3', [_vm._v("Malicious Content & Conduct")]), _vm._v(" "), _c('p', [_vm._v("\n    Any conduct, activity, or content that disrupts, distorts, impedes,\n    interrupts, causes harms, or otherwise violates YouSound and it's services\n    or another user's experience, on or off any device is strictly prohibited.\n    These activity include, but are not limited to:\n  ")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("\n      Repetitively uploading large amounts of unwanted messages, text, or\n      reports\n    ")]), _vm._v(" "), _c('li', [_vm._v("\n      Promotion and distribution of unauthorized and unofficial advertisements\n    ")]), _vm._v(" "), _c('li', [_vm._v("Phishing")]), _vm._v(" "), _c('li', [_vm._v("Fraud of any kind")]), _vm._v(" "), _c('li', [_vm._v("Distribution of viruses and malware")]), _vm._v(" "), _c('li', [_vm._v("\n      Data disinformation (uploading misleading metadata, intentional\n      miscategorization, feigning distress)\n    ")]), _vm._v(" "), _c('li', [_vm._v("\n      Tampering with publicly viewed data (ie: artificially increasing\n      follower counts)\n    ")]), _vm._v(" "), _c('li', [_vm._v("Selling your personal or Verified User account")])]), _vm._v(" "), _c('h3', [_vm._v("Nudity, Sexual Content, Clothing and Attire")]), _vm._v(" "), _c('p', [_vm._v("\n    Nudity and sexual acts that are explicit like like pornography or\n    intercourse are prohibited. Sexual content that threaten and/or encourage\n    sexual content or any type of sexual violence and/or exploitation are\n    strictly prohibited and may be reported to law enforcement. Child\n    exploitation will swiftly be reported to authorities via the National\n    Center for Missing & Exploited Children. Sexually suggestive content,\n    activity, and video broadcasting is strictly prohibited. When reviewing\n    this type of sexual content or activity, we will consider the context on\n    these factors, but not limited to:\n  ")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Conduct and commentary")]), _vm._v(" "), _c('li', [_vm._v("\n      Response to content, for example, messages from users and broadcasters\n    ")]), _vm._v(" "), _c('li', [_vm._v("\n      Clothing, environment, for example, area and location and music, sounds,\n      props\n    ")]), _vm._v(" "), _c('li', [_vm._v("Camera angles and focus")]), _vm._v(" "), _c('li', [_vm._v("\n      Stream characteristics, for example, title, images, and other metadata\n    ")]), _vm._v(" "), _c('li', [_vm._v("Profile and channel content like profile picture, emojis, etc.")])]), _vm._v(" "), _c('p', [_vm._v("\n    All activity on YouSound is displayed in public, therefore we recommend\n    Verified Users wear clothing and attire that is appropriate for the\n    context, intent, or activity of your broadcast. For most streams,\n    including profile imagery, we recommend clothing for public settings.\n    Attire is just one thing we might consider when evaluating reports of\n    potential sexual misconduct. Attire, clothing, or the lack of clothing,\n    intended to be sexually suggestive includes underwear, intimate clothing,\n    or exposing or focusing on the male or female genitalia, including but not\n    limited to, buttocks or nipples. If you notice any violations regarding\n    Nudity Sexual content or Attire, you can contact violations@yousound.com\n  ")]), _vm._v(" "), _c('h3', [_vm._v("Extreme Violence & Gore")]), _vm._v(" "), _c('p', [_vm._v("\n    Visual or audio content that focuses on extreme violence and/or gore and\n    is prohibited.\n  ")]), _vm._v(" "), _c('h3', [_vm._v("Unauthorized Content & Copyrights")]), _vm._v(" "), _c('p', [_vm._v("\n    Uploading or broadcasting any audio or video content that you do not own\n    or do not have the rights to upload or broadcast, or are otherwise not\n    authorized to use, violates our Terms of Service and may make your content\n    eligible for DMCA takedowns by third-party rights holders. We absolutely\n    do not tolerate Verified Users uploading, broadcasting, or rebroadcasting\n    unauthorized content, playing other YouSound Verified User's content,\n    broadcasting third-party movies and television shows, rebroadcasting\n    televised or pre-recorded sports games, or uploading and broadcasting of\n    any type of audio or visual content from other sites without permission\n    from the copyright owner.\n  ")]), _vm._v(" "), _c('h3', [_vm._v("Respect Intellectual Property Rights")]), _vm._v(" "), _c('p', [_vm._v("\n    When Verified Users upload or broadcast audio or video content on\n    YouSound, users should create original content or content that you are\n    authorized to broadcast from the respective copyright owners. Audio or\n    Video that involves derivative content, duplicates, or performances of\n    another person or users copyrighted content may violate their intellectual\n    property and may be eligible for a DMCA takedown by the copyright holder.\n    It's of the utmost importance that Verified Users make sure their content\n    is original, and adheres to applicable copyright laws, and fair use to\n    secure the authorization rights needed before sharing audio or video\n    content on YouSound. YouSound keeps track of repeat infringers, multiple\n    copyright violations will result in multiple strikes on your account and\n    lead to termination of your account. This policy applies to music, video,\n    visuals, graphics, and other performance arts on YouSound.\n  ")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("\n      Performance Art: Performances of existing copyrighted content or works\n      require you to have the authorized right to share the content and/or\n      your performance of said work.\n    ")]), _vm._v(" "), _c('li', [_vm._v("\n      Live Music Performance & Creation: Live musical content must be original\n      music. You may live video broadcast a live performance of a \"cover\"\n      song, for example, musical content written by someone else other than\n      yourself, as long as it does not incorporate recorded musical or other\n      audio elements owned by another person or party, for example, and\n      instrumental backing track of someone else's recording.\n    ")]), _vm._v(" "), _c('li', [_vm._v("\n      Pre-recorded Audio & Music: Radio-style live video broadcasts that\n      includes pre-recorded audio or music, live audio and music performances\n      like covering a copyrighted work, karaoke, lip-syncing, or impersonation\n      other people is reserved only for Verified Users who have upgraded their\n      account to clear copyrighted content.\n    ")])])])
}]}

/***/ }),
/* 1731 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ApexChart', {
    attrs: {
      "type": "line",
      "options": _vm.chartOptions,
      "series": _vm.series
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1732 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "product-slide-card"
  }, [_c('v-flex', {
    staticClass: "product-info",
    attrs: {
      "xs12": "",
      "pa-0": ""
    }
  }, [(false) ? _c('v-flex', {
    staticClass: "product-user",
    attrs: {
      "xs12": "",
      "pa-0": ""
    }
  }, [_c('profile-item', {
    attrs: {
      "user": _vm.publisher,
      "className": 'product-user-avatar'
    }
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": '/' + _vm.publisher.slug
    }
  }, [_c('p', {
    staticClass: "product-user-name"
  }, [_vm._v(_vm._s(_vm.publisher.username))])]), _vm._v(" "), _c('div', {
    staticClass: "product-posted-at"
  }, [_c('img', {
    staticClass: "product-status-icon",
    attrs: {
      "src": "/static/images/ic_repeat.png"
    }
  }), _c('label', [_vm._v("reposted 10min ago")])])], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "product-cover",
    attrs: {
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "product-price"
  }, [_vm._v("$" + _vm._s(_vm._f("formatNumber")(_vm.item.price)))]), _vm._v(" "), _c('div', {
    staticClass: "product-image",
    style: ({
      'background-image': 'url(' + _vm.item.covers[0].cover.url + ')'
    })
  }), _vm._v(" "), _c('v-flex', {
    staticClass: "product-actions",
    attrs: {
      "xs12": "",
      "relative": ""
    }
  }, [_c('v-flex', {
    staticClass: "touch-flex",
    attrs: {
      "xs12": ""
    }
  }), _vm._v(" "), (_vm.showButtonAction) ? _c('v-btn', {
    staticClass: "action-btn",
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.showButtonAction(_vm.item)
      }
    }
  }, [_vm._v("View Detail")]) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1733 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chat-room"
  }, [_c('div', {
    staticClass: "display-flex align-center justify-space-between pt-5 pb-4 px-4"
  }, [_c('div', {
    staticClass: "text-poppins-18 text-white"
  }, [_vm._v("Chat rooms")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(117),
      "width": "27"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'CommunityMobile'
        })
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "horizontal-scroll px-4"
  }, _vm._l((10), function(i) {
    return _c('div', {
      key: i,
      staticClass: "horizontal-scroll__item mr-2 mb-2"
    }, [_vm._m(0, true)])
  })), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "bg-white chat-room__comment relative"
  }, [_vm._m(2), _vm._v(" "), _vm._l((2), function(i) {
    return _c('div', {
      key: i,
      staticClass: "display-flex gap-15 my-3 px-4"
    }, [_c('img', {
      staticClass: "rounded",
      attrs: {
        "src": __webpack_require__(30),
        "width": 44,
        "height": 44
      }
    }), _vm._v(" "), _vm._m(3, true)])
  }), _vm._v(" "), _c('div', {
    staticClass: "display-flex align-center gap-10 chat-room__comment--input"
  }, [_c('img', {
    staticClass: "rounded",
    attrs: {
      "src": __webpack_require__(1487),
      "width": 35,
      "height": 35
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "input-comment full-width pa-2",
    attrs: {
      "type": "text",
      "placeholder": "Say something!"
    }
  })])], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": __webpack_require__(118),
      "width": "50",
      "height": "50"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "px-4"
  }, [_c('iframe', {
    attrs: {
      "width": "100%",
      "height": "315",
      "src": "https://www.youtube.com/embed/2Te4Dhhy0-U?si=UlNm6BTTXkBUGi7E",
      "title": "YouTube video player",
      "frameborder": "0",
      "allow": "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
      "allowfullscreen": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "display-flex algin-center justify-space-between mb-2 pa-4"
  }, [_c('span', {
    staticClass: "text-poppins-16 font-weight-500 text-black"
  }, [_vm._v("\n        Salva’s room\n      ")]), _vm._v(" "), _c('span', {
    staticClass: "text-poppins-13 font-weight-500 text-black"
  }, [_vm._v("\n        36 watching\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "message"
  }, [_c('div', [_c('span', {
    staticClass: "text-inter-14 text-white font-weight-500"
  }, [_vm._v("\n            Joey •\n          ")]), _vm._v(" "), _c('span', {
    staticClass: "text-inter-14 text-white"
  }, [_vm._v("1m")])]), _vm._v(" "), _c('div', {
    staticClass: "text-inter-14 text-white"
  }, [_vm._v("I’m down! Any ideas??")])])
}]}

/***/ }),
/* 1734 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "payment-package"
  }, [(!_vm.hideTitle) ? _c('div', {
    staticClass: "package-title"
  }, [_vm._v(_vm._s(_vm.itemType))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "package-details",
    class: {
      noBorder: _vm.noBorder
    }
  }, [_c('div', {
    staticClass: "_summary dflex justify-space-between mb-3",
    class: {
      altMeta: _vm.altMeta
    }
  }, [_c('div', {
    staticClass: "package-subtitle"
  }, [_vm._v("\n        " + _vm._s(_vm.item.title) + " " + _vm._s(_vm.subtitleAppend) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "package-pricing mt-2"
  }, [_c('span', {
    staticClass: "currency"
  }, [_vm._v("$")]), _vm._v(" "), _c('span', {
    staticClass: "cost"
  }, [_vm._v(_vm._s(_vm.itemPrice) + "/month")])])]), _vm._v(" "), _c('div', {
    staticClass: "payment-note dflex"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("schedule")]), _vm._v(" "), _c('div', {
    staticClass: "__note"
  }, [_vm._v("\n        Your card will be charged each month starting on\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("formatSlashedDate")(_vm.currentDate)))])])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1735 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-section address-section"
  }, [_c('div', {
    staticClass: "description-section"
  }, [_c('p', {
    staticClass: "header"
  }, [_vm._v("\n      " + _vm._s(_vm.header) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "content-section",
    class: {
      actionRight: _vm.actionRight
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit()
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "shipping-address-section": "",
      "ma-0": ""
    }
  }, [_c('v-flex', {
    class: {
      sm6: !_vm.singleCol
    },
    attrs: {
      "xs12": "",
      "form-group": "",
      "first-name": ""
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("First Name"), (!_vm.hideRequireIcon) ? _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipping_address.first_name),
      expression: "shipping_address.first_name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "first_name"
    },
    domProps: {
      "value": (_vm.shipping_address.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.shipping_address, "first_name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    class: {
      sm6: !_vm.singleCol
    },
    attrs: {
      "xs12": "",
      "form-group": "",
      "last-name": ""
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Last Name"), (!_vm.hideRequireIcon) ? _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipping_address.last_name),
      expression: "shipping_address.last_name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "last_name"
    },
    domProps: {
      "value": (_vm.shipping_address.last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.shipping_address, "last_name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    class: {
      sm6: !_vm.singleCol
    },
    attrs: {
      "xs12": "",
      "form-group": "",
      "street": ""
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Street Address"), (!_vm.hideRequireIcon) ? _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipping_address.street_address),
      expression: "shipping_address.street_address"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "street"
    },
    domProps: {
      "value": (_vm.shipping_address.street_address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.shipping_address, "street_address", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    class: {
      sm6: !_vm.singleCol
    },
    attrs: {
      "xs12": "",
      "form-group": "",
      "apartment": ""
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Apt., Floor, Unit etc. (Optional)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipping_address.address_line),
      expression: "shipping_address.address_line"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "address_2"
    },
    domProps: {
      "value": (_vm.shipping_address.address_line)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.shipping_address, "address_line", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    class: {
      sm6: !_vm.singleCol
    },
    attrs: {
      "xs12": "",
      "form-group": "",
      "d-flex": "",
      "justify-space-between": "",
      "city": ""
    }
  }, [_c('div', {
    staticClass: "shipping-address-city-section"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("City / Region"), (!_vm.hideRequireIcon) ? _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipping_address.city),
      expression: "shipping_address.city"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "city"
    },
    domProps: {
      "value": (_vm.shipping_address.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.shipping_address, "city", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.isCountryUS) ? _c('div', {
    staticClass: "shipping-address-state-section"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("State"), (!_vm.hideRequireIcon) ? _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "shipping-address-state"
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "pt-0",
    attrs: {
      "items": _vm.states,
      "name": "state",
      "item-text": "value",
      "item-value": "value",
      "single-line": "",
      "autocomplete": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.shipping_address.state),
      callback: function($$v) {
        _vm.$set(_vm.shipping_address, "state", $$v)
      },
      expression: "shipping_address.state"
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), _c('v-flex', {
    class: {
      sm6: !_vm.singleCol
    },
    attrs: {
      "xs12": "",
      "form-group": "",
      "zipcode": ""
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Zipcode"), (!_vm.hideRequireIcon) ? _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipping_address.postcode),
      expression: "shipping_address.postcode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "zipcode"
    },
    domProps: {
      "value": (_vm.shipping_address.postcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.shipping_address, "postcode", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    class: {
      sm6: !_vm.singleCol
    },
    attrs: {
      "xs12": "",
      "form-group": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    class: {
      sm6: !_vm.singleCol
    },
    attrs: {
      "xs12": "",
      "form-group": "",
      "country": ""
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Country"), (!_vm.hideRequireIcon) ? _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "pt-0",
    attrs: {
      "items": _vm.countries,
      "name": "country",
      "item-text": "name",
      "item-value": "name",
      "single-line": "",
      "autocomplete": ""
    },
    model: {
      value: (_vm.shipping_address.country),
      callback: function($$v) {
        _vm.$set(_vm.shipping_address, "country", $$v)
      },
      expression: "shipping_address.country"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    class: {
      sm6: !_vm.singleCol
    },
    attrs: {
      "xs12": "",
      "form-group": "",
      "save-btn": ""
    }
  }, [_c('v-btn', {
    staticClass: "update-btn",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1736 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page activity-page px-5"
  }, [(_vm.isPageReady && !_vm.isComp) ? _c('content-top-header', [_c('template', {
    slot: "topHeader"
  }, [_c('ul', [_c('li', {
    staticClass: "active"
  }, [_c('label', [_vm._v("Activity")])])])])], 2) : _vm._e(), _vm._v(" "), (_vm.currentUser && _vm.isPageReady) ? _c('div', {
    staticClass: "page-content"
  }, [(!_vm.activities || _vm.activities.length == 0) ? _c('div', {
    staticClass: "empty-section"
  }, [_c('p', {
    staticClass: "empty-title"
  }, [_vm._v("No Activity")]), _vm._v(" "), _c('p', {
    staticClass: "empty-description"
  }, [_vm._v("\n        This is where you'll see who followed, commented, and other\n        activity.\n      ")]), _vm._v(" "), _c('router-link', {
    staticClass: "empty-discover-btn",
    attrs: {
      "to": "/album"
    }
  }, [_vm._v("Discover")])], 1) : _c('div', {
    staticClass: "activity-item-wrapper"
  }, [_c('div', {
    staticClass: "activity-item-parent"
  }, [(
    ['artist', 'brand', 'label'].indexOf(_vm.currentUser.user_type) > -1
  ) ? _c('div', {
    staticClass: "invite-header"
  }, [_c('div', {
    staticClass: "dflex align-center"
  }, [_c('div', {
    staticClass: "round-avatar __logo",
    style: ({
      'background-image': 'url(' + _vm.youLogo + ')'
    }),
    attrs: {
      "width": "30"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "__text"
  }, [_vm._v("Invite your friends!")])]), _vm._v(" "), _c('v-btn', {
    staticClass: "btn-pill",
    attrs: {
      "depressed": ""
    },
    on: {
      "click": function($event) {
        _vm.show_invite_dialog = true
      }
    }
  }, [_vm._v("Invite")])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.activities.slice(0, 100)), function(activity, index) {
    return _c('activity-item', {
      key: index,
      attrs: {
        "activityItem": activity
      }
    })
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "suggested-users"
  }, [_c('h2', {
    staticClass: "mb-3"
  }, [_vm._v("Suggested people to follow")]), _vm._v(" "), _vm._l((5), function(user, index) {
    return _c('div', {
      key: index,
      staticClass: "suggested-user"
    }, [_c('div', {
      staticClass: "dflex justify-space-between align-center"
    }, [_c('user-tag', {
      attrs: {
        "user": _vm.currentUser,
        "showAvatar": "",
        "width": "70",
        "height": "70",
        "marginRight": "20"
      }
    }), _vm._v(" "), _c('v-btn', {
      staticClass: "follow-btn",
      attrs: {
        "depressed": "",
        "round": "",
        "dark": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.followUser(user)
        }
      }
    }, [_vm._v("\n              Follow\n            ")])], 1)])
  })], 2)])]) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "invite-dialog",
      "width": "440"
    },
    model: {
      value: (_vm.show_invite_dialog),
      callback: function($$v) {
        _vm.show_invite_dialog = $$v
      },
      expression: "show_invite_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Invite Artist/Brand")]), _vm._v(" "), _c('v-card-text', [_vm._v("Link expires in 72 hours and can only be used once")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "dark": "",
      "block": "",
      "color": "black"
    },
    nativeOn: {
      "click": function($event) {
        _vm.createInvitation()
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-3"
  }, [_vm._v("fa-link")]), _vm._v(" Copy Link")], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.link_copied),
      expression: "link_copied"
    }],
    staticClass: "link-copied"
  }, [_vm._v("link has been copied")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1737 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-grey-white"
  }, [_c('div', {
    staticClass: "mt-70 px-5"
  }, [_c('div', {
    staticClass: "font-poppins font-weight-600 mb-4"
  }, [_vm._v("FEATURE")]), _vm._v(" "), _c('div', {
    staticClass: "display-flex justify-space-between align-center bg-white pa-3 rounded-10px mb-3"
  }, [_c('div', {
    staticClass: "font-weight-600 font-poppins text-16 w-100"
  }, [_vm._v("\n        Disable Sign Ups\n      ")]), _vm._v(" "), _c('v-switch', {
    staticClass: "allow-attach-switch shorten mx-3",
    attrs: {
      "color": "black",
      "hide-details": "",
      "input-value": _vm.settings.disable_sign_up
    },
    on: {
      "change": function($event) {
        _vm.updateSetting('disable_sign_up')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "display-flex justify-space-between align-center bg-white pa-3 rounded-10px mb-3"
  }, [_c('div', {
    staticClass: "font-weight-600 font-poppins text-16 w-100"
  }, [_vm._v("\n        Disable Login\n      ")]), _vm._v(" "), _c('v-switch', {
    staticClass: "allow-attach-switch shorten mx-3",
    attrs: {
      "color": "black",
      "hide-details": ""
    },
    model: {
      value: (_vm.settings.login),
      callback: function($$v) {
        _vm.$set(_vm.settings, "login", $$v)
      },
      expression: "settings.login"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "display-flex justify-space-between align-center bg-white pa-3 rounded-10px mb-3"
  }, [_c('div', {
    staticClass: "font-weight-600 font-poppins text-16 w-100"
  }, [_vm._v("\n        Disable Verification\n      ")]), _vm._v(" "), _c('v-switch', {
    staticClass: "allow-attach-switch shorten mx-3",
    attrs: {
      "color": "black",
      "hide-details": "",
      "input-value": _vm.settings.disable_verification
    },
    on: {
      "change": function($event) {
        _vm.updateSetting('disable_verification')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "display-flex justify-space-between align-center bg-white pa-3 rounded-10px mb-3"
  }, [_c('div', {
    staticClass: "font-weight-600 font-poppins text-16 w-100"
  }, [_vm._v("\n        Disable Live Video\n      ")]), _vm._v(" "), _c('v-switch', {
    staticClass: "allow-attach-switch shorten mx-3",
    attrs: {
      "color": "black",
      "hide-details": "",
      "input-value": _vm.settings.disable_live_video
    },
    on: {
      "change": function($event) {
        _vm.updateSetting('disable_live_video')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "display-flex justify-space-between align-center bg-white pa-3 rounded-10px mb-3"
  }, [_c('div', {
    staticClass: "font-weight-600 font-poppins text-16 w-100"
  }, [_vm._v("\n        Disable Uploads\n      ")]), _vm._v(" "), _c('v-switch', {
    staticClass: "allow-attach-switch shorten mx-3",
    attrs: {
      "color": "black",
      "hide-details": ""
    },
    model: {
      value: (_vm.settings.uploads),
      callback: function($$v) {
        _vm.$set(_vm.settings, "uploads", $$v)
      },
      expression: "settings.uploads"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "display-flex justify-space-between align-center bg-white pa-3 rounded-10px mb-3"
  }, [_c('div', {
    staticClass: "font-weight-600 font-poppins text-16 w-100"
  }, [_vm._v("\n        Disable Product Uploads\n      ")]), _vm._v(" "), _c('v-switch', {
    staticClass: "allow-attach-switch shorten mx-3",
    attrs: {
      "color": "black",
      "hide-details": ""
    },
    model: {
      value: (_vm.settings.merch_uploads),
      callback: function($$v) {
        _vm.$set(_vm.settings, "merch_uploads", $$v)
      },
      expression: "settings.merch_uploads"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "display-flex justify-space-between align-center bg-white pa-3 rounded-10px mb-3"
  }, [_c('div', {
    staticClass: "font-weight-600 font-poppins text-16 w-100"
  }, [_vm._v("\n        Disable Site For Maintenance\n      ")]), _vm._v(" "), _c('v-switch', {
    staticClass: "allow-attach-switch shorten mx-3",
    attrs: {
      "color": "black",
      "hide-details": ""
    },
    model: {
      value: (_vm.settings.maintenance),
      callback: function($$v) {
        _vm.$set(_vm.settings, "maintenance", $$v)
      },
      expression: "settings.maintenance"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "bg-white pa-3 rounded-10px"
  }, [_c('div', {
    staticClass: "font-weight-600 font-poppins text-16 w-100"
  }, [_vm._v("\n        Send All Users Direct Message\n      ")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    staticClass: "w-100 message font-poppins rounded-10px pa-2",
    attrs: {
      "placeholder": "Write a message to all users"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "bg-blue-1 text-white rounded-20",
    nativeOn: {
      "click": function($event) {
        _vm.sendGlobalMessage()
      }
    }
  }, [_vm._v("\n        Send\n      ")])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1738 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "comments-comp"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__content"
  }, [_c('div', {
    staticClass: "box__initComment"
  }, [_c('div', {
    staticClass: "ci"
  }, [_c('div', {
    staticClass: "ci__header"
  }, [_c('router-link', {
    attrs: {
      "to": ("/" + (_vm.currentUser.slug))
    }
  }, [_c('div', {
    staticClass: "ci__image",
    class: {
      roundAvatar: _vm.roundAvatar
    },
    style: (("background-image: url(" + (_vm.currentUser.avatar.url) + "); height: " + _vm.aviHeight + "px; width: " + _vm.aviWidth + "px;"))
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "ci__content"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.commentText),
      expression: "commentText",
      modifiers: {
        "trim": true
      }
    }],
    class: {
      roundInput: _vm.roundInput
    },
    attrs: {
      "type": "text",
      "placeholder": "Leave a comment..."
    },
    domProps: {
      "value": (_vm.commentText)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.addComment()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.commentText = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), (!_vm.hideCommentCount) ? _c('div', {
    staticClass: "comment__count"
  }, [_vm._v(_vm._s(_vm.comments.length) + " " + _vm._s(_vm._f("pluralize")("comment", _vm.comments.length)))]) : _vm._e(), _vm._v(" "), (!_vm.hideComments) ? _c('chat', {
    attrs: {
      "items": _vm.comments
    }
  }) : _vm._e()], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1739 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "trending-comp trending-videos"
  }, [(_vm.title) ? _c('div', {
    staticClass: "top-bar"
  }, [_c('h2', {
    staticClass: "bar-title"
  }, [_vm._v(_vm._s(_vm.title))])]) : _vm._e(), _vm._v(" "), _c('item-tab', {
    staticClass: "mb-3",
    attrs: {
      "mode": "grid",
      "minHeight": "180"
    }
  }, [_c('template', {
    slot: "itemTabs"
  }, _vm._l((_vm.videoFeed), function(feed, index) {
    return _c('span', {
      key: index,
      class: ['tab-holder px-0 flex', _vm.classAttr]
    }, [_c('video-box', {
      attrs: {
        "hoverOverlay": false,
        "item": feed,
        "hideUser": "",
        "hideFreeTag": "",
        "showFullOverlay": _vm.showFullOverlay,
        "coverOnly": _vm.coverOnly,
        "coverRadius": _vm.coverRadius
      }
    })], 1)
  }))], 2), _vm._v(" "), (!_vm.hideCta) ? _c('div', {
    staticClass: "cta"
  }, [_c('v-btn', {
    staticClass: "cta-btn",
    attrs: {
      "block": "",
      "outline": ""
    }
  }, [_c('strong', [_vm._v(" View all videos ")])])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1740 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "display-flex justify-space-between align-center mb-4"
  }, [_c('div', {
    staticClass: "display-flex align-center gap-8"
  }, [_c('img', {
    staticClass: "rounded",
    attrs: {
      "src": __webpack_require__(30),
      "width": 30,
      "height": 30
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-poppins-16 text-black font-weight-500"
  }, [_vm._v("SALVA")])]), _vm._v(" "), _c('div', {
    staticClass: "text-inter-15 btn-cancel font-weight-400",
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'NotificationMobile'
        })
      }
    }
  }, [_vm._v("\n      Cancel\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "display-flex gap-8 mb-3"
  }, [_c('img', {
    staticClass: "rounded",
    attrs: {
      "src": __webpack_require__(30),
      "width": 30,
      "height": 30
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "display-flex align-center gap-15 full-width message__input"
  }, [_c('input', {
    staticClass: "full-width px-3",
    attrs: {
      "type": "text"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "rounded",
    attrs: {
      "src": __webpack_require__(1503),
      "width": 35,
      "height": 35
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "message__from pa-3"
  }, [_c('div', {
    staticClass: "text-poppins-14 font-weight-500 text-black"
  }, [_vm._v("Origami")]), _vm._v(" "), _c('div', {
    staticClass: "text-inter-14 text-gray-dark my-1"
  }, [_vm._v("\n        I’m down! Any ideas??\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "text-right text-poppins-12"
  }, [_vm._v("11:35 AM")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "display-flex justify-end"
  }, [_c('div', {
    staticClass: "message__to pa-3"
  }, [_c('div', {
    staticClass: "text-poppins-14 font-weight-500 text-white"
  }, [_vm._v("\n        I can do 10 pair of them..\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "text-right text-poppins-12 text-white"
  }, [_vm._v("1d")])])])
}]}

/***/ }),
/* 1741 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sample-license-dialog px-5 pt-5 pb-3"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "my-dialog__footer"
  }, [_c('v-btn', {
    attrs: {
      "color": "blue",
      "dark": "",
      "round": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  }, [_vm._v("Ok")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "my-dialog__header"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/nav_logo_primary.png"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "ml-3"
  }, [_vm._v("Sample Clearance License")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "my-dialog__content"
  }, [_c('div', {
    staticClass: "my-dialog__content__section border-bottom py-4"
  }, [_c('p', [_vm._v("\n        YouSound Sample Clearance License allows Verified Artists to give\n        other Verified Artists permission to sample or mix music submitted to\n        YouSound by copyright owners for executive broadcast on YouSound. Any\n        song that is sampled is credited in Album Credits, which gives\n        listeners one click discovery of album collaborator & contributor\n        profiles.\n        "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n        Read the license here\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "my-dialog__content__section pt-4"
  }, [_c('h4', {
    staticClass: "mb-3"
  }, [_vm._v("You can:")]), _vm._v(" "), _c('h6', [_vm._v("Legally sample / mix cleared songs and upload them to YouSound")]), _vm._v(" "), _c('h6', [_vm._v("Promote artists you sample by crediting artists")])]), _vm._v(" "), _c('div', {
    staticClass: "my-dialog__content__section border-bottom py-4"
  }, [_c('h4', {
    staticClass: "mb-3"
  }, [_vm._v("You cannot:")]), _vm._v(" "), _c('h6', [_vm._v("\n        Sample content from YouSound and distribute sampled content outside of\n        YouSound\n      ")]), _vm._v(" "), _c('h6', [_vm._v("\n        Sample content from YouSound and sell physical copies of sampled\n        content\n      ")])])])
}]}

/***/ }),
/* 1742 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "welcome-page"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [_c('div', {
    staticClass: "username"
  }, [_vm._v("Hey, " + _vm._s(this.username) + "!")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('button', {
    staticClass: "invite-button",
    on: {
      "click": function($event) {
        _vm.copyLink()
      }
    }
  }, [_vm._v("Invite your friends")]), _vm._v(" "), _c('router-link', {
    staticClass: "home-link",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("\n      Back home\n    ")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "yousound"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "/static/images/nav_logo_primary.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "avatar"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/welcome-avatar.svg",
      "alt": "avatar"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "message"
  }, [_vm._v("\n      YouSound will be launching soon. "), _c('br'), _vm._v("\n      In the meantime, you can invite friends to join the fun.\n    ")])
}]}

/***/ }),
/* 1743 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "position": "relative",
      "display": "inline-block",
      "width": "auto",
      "margin": "0",
      "padding": "0"
    }
  }, [_c('div', {
    staticClass: "modal-trigger"
  }, [_vm._v("\n    " + _vm._s(_vm.user.username) + "\n    "), _c('div', {
    staticClass: "user-modal",
    style: ('top: ' + _vm.y + 'px; left: ' + _vm.x + 'px;')
  }, [_vm._v("\n      ,\n      "), _c('v-layout', {
    staticClass: "text-xs-right",
    attrs: {
      "row": ""
    }
  }, [_vm._v(", "), _c('img', {
    staticClass: "pic-big",
    attrs: {
      "src": _vm.user.image
    }
  }), _vm._v(",\n        "), _c('div', {
    staticClass: "user-modal-header"
  }, [_vm._v("\n          ,\n          "), _c('div', {
    staticClass: "user-modal-name"
  }, [_vm._v(_vm._s(_vm.user.username))]), _vm._v("\n          ,\n          "), _c('div', {
    staticClass: "user-modal-detail"
  }, [_c('b', [_vm._v("2.8k")]), _vm._v(" Followers")]), _vm._v("\n          ,\n        ")]), _vm._v("\n        , ")]), _vm._v(",\n      "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_vm._v(", "), _c('button', {
    staticClass: "user-modal-btn"
  }, [_vm._v("Follow")]), _vm._v(",\n        "), _c('button', {
    staticClass: "user-modal-btn"
  }, [_vm._v("Message")]), _vm._v(", ")]), _vm._v(",\n    ")], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1744 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "join-section"
  }, [_c('v-container', {
    attrs: {
      "grid-list-xs": "",
      "px-0": ""
    }
  }, [_c('v-layout', {
    staticClass: "justify-center",
    attrs: {
      "wrap": "",
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "d-flex justify-center align-center flex-column"
  }, [_c('p', {
    staticClass: "text-center mb-5"
  }, [_vm._v("\n            Join the community. "), _c('br'), _vm._v("\n            It’s all for you.\n          ")]), _vm._v(" "), (!_vm.isAuthenticated) ? _c('v-btn', {
    staticClass: "signup_btn",
    attrs: {
      "to": "/login"
    }
  }, [_vm._v(" Sign In ")]) : _c('v-btn', {
    staticClass: "signup_btn",
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'AlbumIndex'
        })
      }
    }
  }, [_vm._v("Discover ")])], 1)])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1745 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page auth-page no-top-nav social-verify-page"
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "px-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "justify-center": "",
      "flex-column": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm5": "",
      "md8": ""
    }
  }, [(_vm.token == 'being') ? [_c('div', [_c('div', {
    staticClass: "page-header"
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "/static/images/nav_logo_primary.png"
    }
  }), _vm._v(" "), _c('br')]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('h4', [_vm._v("Check your email & confirm your account")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('p', [_vm._v("\n                  If you don't see the email in your main inbox"), _c('br'), _vm._v("check your\n                  other folders like 'promotions'\n                ")]), _vm._v(" "), (_vm.user_type != 0) ? _c('div', {
    staticClass: "__artistBrand-note"
  }, [_c('h5', [_vm._v("After you confirm your artist / brand account:")]), _vm._v(" "), _c('ul', {
    staticClass: "allChildrenCenter flex-column"
  }, [_c('li', [_vm._v("\n                      Please allow at least 72 hours for staff to verify your account\n                    ")]), _vm._v(" "), _c('li', [_vm._v("\n                      If your account hasn’t been verified within 72 hours send us a DM on Instagram to "), _c('a', {
    attrs: {
      "href": "https://instagram.com/yousoundapp",
      "target": "_blank"
    }
  }, [_vm._v("@yousoundapp")]), _vm._v(" from the social media URL you signed up with\n                    ")])])]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "px-3 mt-4",
    attrs: {
      "round": "",
      "dark": "",
      "depressed": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.sendConfirmEmail($event)
      }
    }
  }, [_vm._v("\n                  Resend email\n                ")])], 1)], 1)])] : [_c('div', {
    staticClass: "d-flex flex-column",
    staticStyle: {
      "align-items": "center",
      "height": "100vh"
    }
  }, [_c('div', [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "/static/images/nav_logo_primary.png"
    }
  })]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "d-flex flex-column",
    staticStyle: {
      "gap": "20px",
      "align-items": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "110px"
    },
    attrs: {
      "src": "/static/images/lined_check.svg"
    }
  }), _vm._v(" "), _c('div', [_c('center', {
    staticStyle: {
      "font-weight": "800",
      "font-size": "30px"
    }
  }, [_vm._v("\n                    Email confirmed!\n                  ")]), _vm._v(" "), _c('center', {
    staticStyle: {
      "font-weight": "500",
      "font-size": "24px"
    }
  }, [_vm._v("Your account has been activated")])], 1)])]), _vm._v(" "), _c('div', [(_vm.isPageReady) ? _c('v-btn', {
    staticClass: "px-3 mt-4 login-button",
    attrs: {
      "round": "",
      "dark": "",
      "depressed": "",
      "to": "/login"
    }
  }, [_vm._v("\n                Login to web app\n              ")]) : _vm._e()], 1)])]], 2), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": ""
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1746 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "display-flex justify-space-between align-center"
  }, [_c('span', {
    staticClass: "title font-weight-600"
  }, [_vm._v("Discover")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(319),
      "width": 20,
      "height": 20
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "horizontal-scroll mt-3"
  }, _vm._l((_vm.categoryList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "discover__category horizontal-scroll__item display-flex justify-center align-center mr-2 px-4",
      class: {
        'bg-black text-white': item.active
      }
    }, [_vm._v("\n      " + _vm._s(item.text) + "\n    ")])
  })), _vm._v(" "), _c('div', {
    staticClass: "discover__play"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "display-flex align-center gap-8 discover__play__content",
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'PlayerMobile'
        })
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1496),
      "width": 42,
      "height": 42
    }
  }), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "discover__play-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "discover__play-2"
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-poppins-15 my-5 text-center"
  }, [_vm._v("\n    Swipe left for more, swipe right to save\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }), _vm._v(" "), _c('Footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "discover__type display-flex gap-8 align-center full-width my-3"
  }, [_c('div', {
    staticClass: "discover__type__item bg-black text-white display-flex justify-center align-center"
  }, [_vm._v("\n      Trending\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "discover__type__item display-flex justify-center align-center"
  }, [_vm._v("\n      New\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "discover__type__item display-flex justify-center align-center"
  }, [_vm._v("\n      Popular\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "relative"
  }, [_c('div', {
    staticClass: "discover__play__image"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1480),
      "width": "100%",
      "height": "100%"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "absolute discover__play__btn display-flex align-center justify-space-between"
  }, [_c('div', {
    staticClass: "discover__play__btn--previous display-flex align-center justify-center"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1498),
      "width": "20px",
      "height": "20px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "discover__play__btn--next display-flex align-center justify-center"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1497),
      "width": "20px",
      "height": "20px"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "text-poppins-18 text-black font-weight-500"
  }, [_vm._v("\n          Wonder Where We Land\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "text-poppins-16 text-gray font-weight-500"
  }, [_vm._v("Sbtkrt")])])
}]}

/***/ }),
/* 1747 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-section"
  }, [_c('h2', [_vm._v("Privacy Policy")]), _vm._v(" "), _c('div', {
    staticClass: "article-body content-body wikistyle markdown-format"
  }, [_c('div', {
    staticClass: "intro"
  }), _vm._v(" "), _c('p', [_vm._v("\n      Effective Date: September 1st, 2024 YouSound, Inc. (“YouSound”) knows that you\n      care about how your Personal Data is used and shared, and we take your\n      privacy seriously. Please read the following to learn more about our\n      privacy policy. "), _c('br'), _c('br'), _vm._v("This Privacy Policy describes how we\n      collect, use, share, and safeguard your Personal Data when you access\n      the www.yousound.com website and domain name, mobile applications, and\n      any other linked pages, features, content, or application services\n      offered from time to time by YouSound in connection therewith\n      (collectively, the \"Service\"), or otherwise interact with us. This\n      policy does not apply to the practices of companies that\n      "), _c('br'), _c('br'), _vm._v("“Personal Data” means any data related to an identified or\n      identifiable individual. By accessing or using the Service, you\n      acknowledge that you accept the practices and policies outlined in this\n      Privacy Policy.\n    ")]), _vm._v(" "), _c('h3', [_vm._v("What Personal Data Does YouSound Collect?")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("User information,")]), _vm._v(" such as the name, username, password,\n      email address, photograph or other likeness, settings, associations with\n      Verified Users and customers, purchase history, and any other\n      information you provide in connection with your user account.\n    ")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("User financial information,")]), _vm._v(" such as your credit or\n      debit card number, bank account number, and billing and shipping\n      address. This information is collected and processed by our payment\n      processor, as necessary to complete your purchase. We do not receive\n      your credit card information directly, but we may receive information\n      about the transaction, such as the date and time it occurred. This\n      information may or may not be associated with an existing user on the\n      website.\n    ")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("User information,")]), _vm._v(" such as user-provided biography,\n      location, and tags.\n    ")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Financial information,")]), _vm._v(" such as Stripe account(s) and\n      payouts.\n    ")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Buyer & Seller information,")]), _vm._v(" such as the user-provided\n      name, email address, country of residence, zip/postal code, picture,\n      location, and biography.\n    ")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Emails and messages,")]), _vm._v(" including receipts, newsletters,\n      and support contact. This information consists of the emails we send to\n      individuals, and the messages that users may send to one another.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      In addition to the above, we may automatically collect the following\n      types of information:\n    ")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Website activity information,")]), _vm._v(" such as application logs,\n      data files, information collected by cookies, IP address, browser\n      information, and metrics generated in the normal operation of a website.\n      “Application logs” are text files in which are recorded most of the\n      activities on a website, including page visits, payments, and usage.\n      Website activity information is sometimes associated with an IP address\n      or other Personal Data. Third parties may also collect information about\n      your website activity over time and on other websites or mobile\n      applications.\n    ")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Information collected via cookies.")]), _vm._v(" Cookies are\n      alphanumeric identifiers that we transfer to your computer’s hard drive\n      through your browser to enable our systems to recognize your browser and\n      tell us how and when pages in our site are visited and by how many\n      people. YouSound cookies do not collect Personal Data, and we do not\n      combine the general information collected through cookies with other\n      Personal Data to tell us who you are or what your screen name or email\n      address is. Most browsers have an option for turning off the cookie\n      feature, which will prevent your browser from accepting new cookies, as\n      well as (depending on the sophistication of your browser software)\n      allowing you to decide on acceptance of each new cookie in a variety of\n      ways. We strongly recommend that you leave the cookies activated,\n      however, because cookies enable you to take advantage of some of\n      YouSound’s most attractive features. If you choose to disable cookies or\n      similar technologies, some parts of our Service may not work properly.\n    ")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("We use Google Analytics")]), _vm._v(" to collect and process\n      analytical data about users of YouSound’s website. Google Analytics\n      tracks your interaction with the Site and stores information about IP\n      address, operating system, web browser, pages visited, information about\n      demographics of our website users, the device used, and where the visit\n      originated. You can learn about Google’s practices by going\n      to https://www.google.com/policies/privacy/partners/, and opt out of\n      them by downloading the Google Analytics opt-out browser add-on,\n      available at https://tools.google.com/dlpage/gaoptout.\n    ")]), _vm._v(" "), _c('li', [_vm._v("\n      We may use software tools such as JavaScript to collect page interaction\n      information such as clicks, drags, and hover-overs, response times,\n      errors, and length of visits to certain pages.\n    ")]), _vm._v(" "), _c('h3', [_vm._v("For Which Purposes Will YouSound Use Your Personal Data?")]), _vm._v(" "), _c('p', [_vm._v("\n      The Personal Data collected by YouSound is used for the following\n      purposes:\n    ")]), _vm._v(" "), _c('li', [_vm._v("\n      To allow you to use the Service, to set up a user account and profile\n      that can be used to interact with other users, and to allow users to\n      identify each other by displaying Personal Data to other users and\n      visitors of the Service;\n    ")]), _vm._v(" "), _c('li', [_vm._v("\n      To provide, administer, and communicate with you about products,\n      services, offers, programs, and promotions of YouSound and its partners\n      (including surveys and any other marketing activities). If required\n      under applicable law, we will only send you promotional communications\n      with your consent;\n    ")]), _vm._v(" "), _c('li', [_vm._v("\n      To operate, evaluate and improve our business, including developing new\n      products and services; managing our communications; determining the\n      effectiveness of, and optimizing the content you see; analyzing our\n      products, services, website, mobile application, and any other digital\n      assets; facilitating the functionality of our website, mobile\n      application, and any other digital assets;\n    ")]), _vm._v(" "), _c('li', [_vm._v("\n      To process sales and purchases, to transfer money, and to provide the\n      expected receipts, statistics, and reports to the band and its\n      customers;\n    ")]), _vm._v(" "), _c('li', [_vm._v("\n      To perform accounting, auditing, billing, reconciliation, and collection\n      activities;\n    ")]), _vm._v(" "), _c('li', [_vm._v("To respond to your inquiries;")]), _vm._v(" "), _c('li', [_vm._v("\n      To perform data analyses and data aggregation (including anonymization\n      of Personal Data);\n    ")]), _vm._v(" "), _c('li', [_vm._v("\n      In connection with prospective service engagements, partnerships or\n      vendor relationships;\n    ")]), _vm._v(" "), _c('li', [_vm._v("\n      To comply with law enforcement requests and other legal obligations;\n    ")]), _vm._v(" "), _c('li', [_vm._v("To apply and enforce our Terms of Use and other agreements;")]), _vm._v(" "), _c('li', [_vm._v("\n      To protect the rights, property, or safety of YouSound, our employees,\n      our users, or others, including by taking measures to prevent fraud and\n      reduce credit risk;\n    ")]), _vm._v(" "), _c('li', [_vm._v("To comply with industry standards and our policies.")]), _vm._v(" "), _c('p', [_vm._v("\n      We also may use the information in other ways for which we provide\n      specific notice at the time of collection.\n    ")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Email Communications:")]), _vm._v(" We may receive a confirmation\n      when you open an email from YouSound. YouSound uses this confirmation to\n      help us make emails more interesting and helpful and improve our\n      service. If you do not want to receive email from us, please contact us\n      as specified in the “How To Contact Us” section below.\n    ")]), _vm._v(" "), _c('h3', [_vm._v("When Does YouSound Collect Personal Data Relating To You?")]), _vm._v(" "), _c('p', [_vm._v("We may collect and use Personal Data relating to you when:")]), _vm._v(" "), _c('li', [_vm._v("You have consented to the use of your Personal Data;")]), _vm._v(" "), _c('li', [_vm._v("\n      We need your Personal Data to provide you with services and products\n      requested by you, or to respond to your inquiries;\n    ")]), _vm._v(" "), _c('li', [_vm._v("We have a legal obligation to use your Personal Data;")]), _vm._v(" "), _c('li', [_vm._v("\n      We have a legitimate interest in using your Personal Data. This includes\n      our legitimate interests to ensure and improve the safety, security and\n      performance of our products and services.\n    ")]), _vm._v(" "), _c('h3', [_vm._v("How Does YouSound Receive Personal Data About You?")]), _vm._v(" "), _c('p', [_vm._v("We may receive Personal Data relating to you from:")]), _vm._v(" "), _c('li', [_vm._v("You directly when you provide us with information about you;")]), _vm._v(" "), _c('li', [_vm._v("Your use of YouSound’s Service;")]), _vm._v(" "), _c('li', [_vm._v("Third parties that provide us with information about you.")]), _vm._v(" "), _c('h3', [_vm._v("How Long Does YouSound Keep Your Personal Data?")]), _vm._v(" "), _c('p', [_vm._v("\n      YouSound stores Personal Data only for as long as it is necessary for\n      the fulfillment of the purpose for which it was collected, unless\n      otherwise required or authorized by applicable law. We take measures to\n      destroy or permanently de-identify Personal Data if required by law or\n      if the Personal Data is no longer required for the purpose for which we\n      collected it.\n    ")]), _vm._v(" "), _c('h3', [_vm._v("How Will YouSound Share the Personal Data It Receives?")]), _vm._v(" "), _c('p', [_vm._v("\n      Personal Data about our customers is an integral part of our business.\n      We neither rent nor sell your Personal Data to anyone. We share your\n      Personal Data only as described below.\n    ")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Members of our Group:")]), _vm._v(" We may share your Personal Data\n      with any members of our group, which includes our affiliates, employees,\n      subsidiaries and branch offices, to which it is reasonably necessary or\n      desirable for us to disclose your data in order to carry out the\n      above-mentioned data processing purposes.\n    ")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Affiliated Businesses We Do Not Control:")]), _vm._v(" We are\n      affiliated with a variety of businesses and work closely with them. In\n      certain situations, these businesses sell items to you through\n      YouSound's Service. In other situations, YouSound provides services, or\n      sells products jointly with affiliated businesses. You can easily\n      recognize when an affiliated business is associated with your\n      transaction, and we will share your Personal Data that is related to\n      such transactions with that affiliated business.\n    ")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Agents:")]), _vm._v(" We employ other companies and people to perform\n      tasks on our behalf and need to share your information with them to\n      provide products or services to you. Examples may include sending postal\n      mail and email, analyzing data, providing marketing assistance,\n      providing search results and links (including paid listings and links),\n      processing credit card payments, and providing customer service. Unless\n      we tell you differently, YouSound’s agents do not have any right to use\n      Personal Data we share with them beyond what is necessary to assist us.\n      You hereby consent to our sharing of Personal Data for the above\n      purposes.\n    ")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Verified Users:")]), _vm._v(" When you use certain functionality or\n      services, we may provide certain Personal Data to Verified Users, such\n      as your email address, country of residence and zip/postal code\n      (\"Customer Information\"), and you can opt-in to be added to the relevant\n      band’s mailing list. Verified Users are only authorized by us to use the\n      Customer Information to send email to you and may not share, rent, or\n      sell the information with others for any other purpose.\n    ")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("User profiles:")]), _vm._v(" User profile information including\n      users’ name, email address, purchase history and other information you\n      enter (“User Submissions”) may be displayed to other users in certain\n      cases to facilitate user interaction within the Service. Email addresses\n      are used to add new User Submissions to user profiles and to communicate\n      through User Submissions. Users’ email addresses will not be directly\n      revealed to other users by us, except, when the user is “connected” to\n      another user via a shared group membership, or an invitation, or if the\n      user has chosen to include their email address in their User Profile.\n      You may designate certain User Submissions, including individual items\n      in your purchase history, as private, in which case they will not be\n      displayed to other users.\n    ")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Aggregate information:")]), _vm._v(" We may provide aggregate\n      information to our partners about how our customers, collectively, use\n      our site. We share this type of statistical data so that our partners\n      also understand how often people use their services and our Service, so\n      that they, too, may provide you with an optimal online experience.\n      YouSound never discloses aggregate information to a partner in a manner\n      that would identify you personally.\n    ")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Communication in response to User Submissions:")]), _vm._v(" As part\n      of the Service and Services, you will receive from Company email and\n      other communication relating to your User Submissions. You acknowledge\n      and agree that by posting such User Submissions, Company may send you\n      email and other communication that it determines in its sole discretion\n      relate to your User Submissions.\n    ")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Business Transfers:")]), _vm._v(" In these types of transactions,\n      customer information is typically one of the business assets that is\n      transferred. Moreover, if YouSound, or substantially all of its assets\n      were acquired, or in the unlikely event that YouSound goes out of\n      business or enters bankruptcy, customer information would be one of the\n      assets that is transferred or acquired by a third party. You acknowledge\n      that such transfers may occur, and that any acquirer of YouSound may\n      continue to use your Personal Data as set forth in this policy.\n    ")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Compliance with the Law, Protection of YouSound and Others:")]), _vm._v("\n      We may access, preserve, and disclose collected information, if we\n      believe doing so is required or appropriate to: comply with law\n      enforcement requests and legal process, such as a court order or\n      subpoena; enforce or apply our conditions of use and other agreements;\n      or protect the rights, property, or safety of YouSound, our employees,\n      our users, or others. This includes exchanging information with other\n      companies and organizations for fraud protection and credit risk\n      reduction.\n    ")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("With Your Consent:")]), _vm._v(" Except as set forth above, you will\n      be notified when your Personal Data may be shared with third parties,\n      and will be able to prevent the sharing of this information.\n    ")]), _vm._v(" "), _c('h3', [_vm._v("Is Personal Data About You Secure?")]), _vm._v(" "), _c('p', [_vm._v("\n      YouSound endeavors to protect user information to ensure that your\n      Personal Data is kept private. We use physical, managerial, and\n      technical security measures to protect your Personal Data against\n      accidental or unlawful destruction, loss, alteration, unauthorized\n      disclosure or access. In particular, we take steps to ensure that our\n      employees and service providers who have access to your Personal Data\n      only process it upon our instructions, unless otherwise required by law.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      However, no measures are 100% secure and unauthorized entry or use,\n      hardware or software failure, and other factors, may compromise the\n      security of your Personal Data. To protect the security of your data,\n      you need to select and protect your password appropriately and limit\n      access to your computer and browser by signing off after you have\n      finished accessing your account.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      The Service may contain links to other sites. YouSound is not\n      responsible for the privacy policies and/or practices on other sites.\n      When linking to another site you should read the privacy policy stated\n      on that site. This Privacy Policy only governs information collected by\n      YouSound.\n    ")]), _vm._v(" "), _c('h3', [_vm._v("What Choices And Rights Do You Have Regarding Your Personal Data?")]), _vm._v(" "), _c('p', [_vm._v("\n      You have certain rights regarding the Personal Data we maintain about\n      you. We also offer you certain choices about what Personal Data we\n      collect from you, how we use that information, and how we communicate\n      with you.\n    ")]), _vm._v(" "), _c('li', [_vm._v("\n      Sometimes you may be required by law or by contract to provide us with\n      your Personal Data to be able to use our products or services. In other\n      cases, you may provide us with your personal data voluntarily. The\n      particular reasons for using your Personal Data, whether you are\n      required to provide your Personal Data, and the possible consequences of\n      not providing your Personal Data will be indicated at the time the\n      information is collected.\n    ")]), _vm._v(" "), _c('li', [_vm._v("\n      You may designate certain User Submissions as private so that they are\n      not shared with other users. Not all User Submissions may be designated\n      as private.\n    ")]), _vm._v(" "), _c('li', [_vm._v("\n      You can add or update certain information on pages, such as your\n      username and password, your email address, and your user profile\n      information.\n    ")]), _vm._v(" "), _c('li', [_vm._v("\n      Where required by law, we obtain your prior opt-in consent at the time\n      of collection for certain processing of Personal Data, such as for\n      direct marketing purposes. If we rely on consent for the processing of\n      your Personal Data, you have the right to withdraw your consent at any\n      time and, when you do so, this will not affect the lawfulness of the\n      processing before your consent withdrawal.\n    ")]), _vm._v(" "), _c('li', [_vm._v("\n      You can opt out of the collection and use of certain information, which\n      we collect about you by automated means, when you visit our website.\n      Your browser may tell you how to be notified and opt out of receiving\n      certain types of cookies and similar technologies. Please note, however,\n      that without cookies you may not be able to use all of the features of\n      our website.\n    ")]), _vm._v(" "), _c('li', [_vm._v("\n      You can at any time tell us not to send you marketing communications by\n      email by clicking on the unsubscribe link within the marketing emails\n      you receive from us or by contacting us as specified in the “How To\n      Contact Us” section below. Please note that if you do not want to\n      receive legal notices from us, such as this Privacy Policy, those legal\n      notices will still govern your use of the YouSound Service, and you are\n      responsible for reviewing such legal notices for changes.\n    ")]), _vm._v(" "), _c('li', [_vm._v("\n      To the extent provided by applicable law, you may withdraw any consent\n      you previously provided to us, or object at any time on legitimate\n      grounds, to the processing of your Personal Data. We will apply your\n      preferences going forward. In some circumstances, withdrawing your\n      consent to the use or disclosure of your Personal Data will mean that\n      you cannot take advantage of some YouSound features.\n    ")]), _vm._v(" "), _c('li', [_vm._v("\n      Subject to applicable law, you may have the right to: obtain\n      confirmation that we hold Personal Data about you, request access to and\n      receive information about the Personal Data we maintain about you,\n      receive copies of the Personal Data we maintain about you, exercise your\n      right to data portability, update and correct inaccuracies in your\n      Personal Data, object to or restrict the processing of your Personal\n      Data, and have the information blocked, anonymized or deleted, as\n      appropriate. These rights may be limited in some circumstances by local\n      law requirements. You may also have the right to lodge a complaint with\n      your local data protection authority.\n    ")]), _vm._v(" "), _c('li', [_vm._v("\n      Under California’s “Shine the Light” law, California residents who\n      provide Personal Data in obtaining products or services for personal,\n      family, or household use are entitled to request and obtain from us once\n      a calendar year information about the customer information we shared, if\n      any, with other businesses for their own direct marketing uses. If\n      applicable, this information would include the categories of customer\n      information shared, the names and email addresses of those businesses\n      with which we shared customer information for the immediately prior\n      calendar year (e.g., requests made in 2018 will receive information\n      regarding 2017 sharing activities), and descriptions of the likely types\n      of marketing the third parties would send. Please be aware that not all\n      information sharing is covered by the “Shine the Light” requirements and\n      only information on covered sharing will be included in our response.\n    ")]), _vm._v(" "), _c('li', [_vm._v("\n      If we fall short of your expectations in processing your Personal Data\n      or you wish to make a complaint about our privacy practices, please tell\n      us because it gives us an opportunity to fix the problem. You may\n      contact us by using the contact details provided in the “How To Contact\n      Us” section below. To assist us in responding to your request, please\n      give full details of the issue. We attempt to review and respond to all\n      complaints within a reasonable time.\n    ")]), _vm._v(" "), _c('li', [_vm._v("\n      If you provide us with any Personal Data relating to another individual,\n      you should make sure that the sharing with us and our further use as\n      described to you from time to time is in line with applicable laws, so\n      for example you should duly inform that individual on the processing of\n      her/his Personal Data and obtain her/his consent, as may be necessary\n      under applicable laws.\n    ")]), _vm._v(" "), _c('li', [_vm._v("\n      To exercise your rights and choices as described above, please contact\n      us as specified in the “How To Contact Us” section below.\n    ")]), _vm._v(" "), _c('h3', [_vm._v("Does YouSound Collect Children's Data?")]), _vm._v(" "), _c('p', [_vm._v("\n      We do not knowingly collect, maintain, or use Personal Data from\n      children under 13 years of age, and no part of the Service is directed\n      to children under the age of 13. If you learn that your child has\n      provided us with Personal Data without your consent, you may alert us by\n      using the contact details provided in the “How To Contact Us” section\n      below. If we learn that we have collected any Personal Data from\n      children under 13, we will promptly take steps to delete such\n      information and terminate the child’s account.\n    ")]), _vm._v(" "), _c('h3', [_vm._v("Does YouSound Transfer Your Personal Data Abroad?")]), _vm._v(" "), _c('p', [_vm._v("\n      To offer our services, we may transfer your Personal Data to recipients\n      in countries other than the country in which the data were originally\n      collected, including to the United States. The laws in those countries\n      may not offer the same level of data protection as the country in which\n      the data initially were provided. When we transfer your Personal Data to\n      recipients in other countries, we will protect the data as described in\n      this Privacy Policy.\n    ")]), _vm._v(" "), _c('h3', [_vm._v("Changes To This Privacy Policy.")]), _vm._v(" "), _c('p', [_vm._v("\n      YouSound may amend this Privacy Policy from time to time. Use of\n      information we collect now is subject to the Privacy Policy in effect at\n      the time such information is used. If we make changes in the way we use\n      Personal Data, we will notify you by posting an announcement on our\n      Service or sending you an email. Users are bound by any changes to the\n      Privacy Policy when they use the Service after such changes have been\n      first posted.\n    ")]), _vm._v(" "), _c('h3', [_vm._v("How To Contact Us.")]), _vm._v(" "), _c('p', [_vm._v("\n      If you have any questions or concerns regarding the privacy of your\n      Personal Data by YouSound, or if you would like to exercise your rights\n      to your Personal Data, please send a detailed message\n      to support@youSound.com. Please specify the subject of your request on\n      the subject line and in the body of your message (e.g. “Request for\n      access to my personal data”, “Request for California Privacy\n      Information” etc.). We will provide the requested information and make\n      every effort to resolve your concerns.\n    ")])])])
}]}

/***/ }),
/* 1748 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-xs": "",
      "px-0": "",
      "banner": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "text-container pt-md-15 justify-center align-md-start align-center flex-column"
  }, [_c('h3', {
    staticClass: "mb-5"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('v-btn', {
    staticClass: "discover_btn",
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'Login'
        })
      }
    }
  }, [_vm._v("Discover ")])], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "img-container d-flex justify-center align-center"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgSrc
    }
  })])])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1749 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "product-item",
    attrs: {
      "xs12": ""
    }
  }, [(_vm.isShowPromoteModal) ? _c('promote-modal', {
    attrs: {
      "item": _vm.album,
      "dismiss": _vm.dismissPromoteDialog,
      "success": _vm.saveAndFinish
    }
  }) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm12": "",
      "product-content-section": "",
      "pa-0": "",
      "relative": ""
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/album/' + _vm.album.slug
    }
  }, [_c('div', {
    staticClass: "product-image",
    style: ({
      'background-image': 'url(' + _vm.album.cover.url + ')'
    })
  })]), _vm._v(" "), _c('v-layout', {
    staticClass: "product-content",
    attrs: {
      "wrap": "",
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "product-content-row",
    attrs: {
      "xs12": "",
      "sm6": "",
      "pr-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "justify-space-around": "",
      "column": "",
      "fill-height": ""
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.album.name))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.album.user.display_name))])])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "product-content-row d-flex align-center justify-end gap-15",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [(_vm.album.collaborators_count === 0) ? [(_vm.videoOnlyButtonAction) ? _c('v-btn', {
    staticClass: "text-btn",
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.videoOnlyButtonAction(_vm.album)
      }
    }
  }, [_vm._v("Make Live Video Only")]) : _vm._e(), _vm._v(" "), (_vm.updateAccessLevelAction) ? _c('v-select', {
    staticClass: "pt-0 access-level",
    attrs: {
      "items": _vm.access_levels,
      "item-text": "title",
      "item-value": "id",
      "placeholder": "Select access level",
      "hide-details": "",
      "single-line": ""
    },
    on: {
      "change": function($event) {
        _vm.toggle_album_access_level_dialog = true
      }
    },
    model: {
      value: (_vm.album.access_level),
      callback: function($$v) {
        _vm.$set(_vm.album, "access_level", $$v)
      },
      expression: "album.access_level"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editButtonAction) ? _c('v-btn', {
    staticClass: "text-btn text-poppins-15",
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.editProduct()
      }
    }
  }, [_vm._v("\n            Edit\n          ")]) : _vm._e(), _vm._v(" "), (_vm.deleteButtonAction) ? _c('v-btn', {
    staticClass: "text-btn text-poppins-15",
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.show_album_delete_confirm_dialog = true
      }
    }
  }, [_vm._v("\n            Delete\n          ")]) : _vm._e()] : [_c('div', {
    staticClass: "w-100"
  }), _vm._v(" "), (_vm.album.status == 'pending') ? _c('span', {
    staticClass: "collaboration-status"
  }, [(
    _vm.album.user.id === this.$store.state.auth.user.id &&
    _vm.usersCountByStatus.accepted === _vm.album.collaborators_count
  ) ? [_c('span', {
    staticClass: "approve-wrapper"
  }, [_c('v-btn', {
    staticClass: "text-btn release text-poppins-15",
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.releaseButtonAction(_vm.album)
      }
    }
  }, [_vm._v("\n                  Release Now\n                ")])], 1)] : _c('span', {
    staticClass: "status-overview"
  }, [(_vm.usersCountByStatus.accepted > 0) ? _c('span', [_c('span', {
    staticClass: "accepted-title"
  }, [_vm._v("Accepted")]), _vm._v(" "), _vm._l((_vm.usersByStatus.accepted), function(c, i) {
    return _c('span', {
      key: i
    }, [_vm._v("\n                  " + _vm._s(c.user.username) + "\n                ")])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.usersCountByStatus.denied > 0) ? _c('span', [_c('span', {
    staticClass: "denied-title"
  }, [_vm._v("Denied")]), _vm._v(" "), _vm._l((_vm.usersByStatus.denied), function(c, i) {
    return _c('span', {
      key: i
    }, [_vm._v("\n                  " + _vm._s(c.user.username) + "\n                ")])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.usersCountByStatus.pending > 0) ? _c('span', [_c('span', {
    staticClass: "pending-title"
  }, [_vm._v("Waiting for approval")]), _vm._v(" "), _vm._l((_vm.usersByStatus.pending), function(c, i) {
    return _c('span', {
      key: i
    }, [_vm._v("\n                  " + _vm._s(c.user.username) + "\n                ")])
  })], 2) : _vm._e()]), _vm._v(" "), (
    _vm.acceptButtonAction &&
    !_vm.usersByStatus.denied &&
    !_vm.usersByStatus.accepted
  ) ? _c('span', {
    staticClass: "collaboration-actions"
  }, [_c('v-btn', {
    staticClass: "text-btn deny text-poppins-15",
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.denyButtonAction(_vm.album)
      }
    }
  }, [_vm._v("\n                Deny\n              ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "text-btn accept text-poppins-15",
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.acceptButtonAction(_vm.album)
      }
    }
  }, [_vm._v("\n                Accept\n              ")])], 1) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (
    _vm.editButtonAction &&
    this.$store.state.auth.user.id === _vm.album.user.id
  ) ? _c('v-btn', {
    staticClass: "action-btn",
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.editButtonAction(_vm.album)
      }
    }
  }, [_vm._v("Edit")]) : _vm._e(), _vm._v(" "), (
    _vm.deleteButtonAction &&
    this.$store.state.auth.user.id === _vm.album.user.id
  ) ? _c('v-btn', {
    staticClass: "text-btn text-poppins-15",
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.deleteButtonAction(_vm.album)
      }
    }
  }, [_vm._v("Delete")]) : _vm._e()]], 2)], 1)], 1), _vm._v(" "), (_vm.album.status == 'collaborated' || _vm.album.status == 'pending') ? _c('div', {
    staticClass: "divider"
  }) : _vm._e(), _vm._v(" "), (_vm.album.status == 'collaborated' || _vm.album.status == 'pending') ? _c('v-flex', {
    attrs: {
      "sm12": "",
      "collaborator-content-section": ""
    }
  }, [_c('div', [_c('div', {
    staticClass: "text-poppins-14"
  }, [_vm._v("\n        Collaborators (" + _vm._s(_vm.usersByStatus.accepted.length) + ")\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "collaborator-content"
  }, [_vm._l((_vm.usersByStatus.accepted), function(c, i) {
    return _c('div', {
      key: i,
      staticClass: "collaborator-content__item"
    }, [_c('img', {
      staticClass: "collaborator-content__item--img",
      attrs: {
        "src": c.user.avatar.url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "collaborator-content__item__user"
    }, [_c('span', {
      staticClass: "username"
    }, [_vm._v("\n              " + _vm._s(c.user.username) + "\n              "), (_vm.$store.state.auth.user.username === c.user.username) ? _c('span', [_vm._v("\n                (owner)\n              ")]) : _vm._e()]), _vm._v(" "), _c('span', {
      staticClass: "user-type"
    }, [_vm._v(_vm._s(c.user.user_type))])])])
  }), _vm._v(" "), (_vm.album.status == 'pending' && _vm.usersByStatus.denied > 0) ? _c('v-btn', {
    staticClass: "action-btn release",
    attrs: {
      "depressed": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.releaseButtonAction(_vm.product)
      }
    }
  }, [_vm._v("\n          Release Now\n        ")]) : _vm._e()], 2)])]) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "invite-dialog",
      "width": "440"
    },
    model: {
      value: (_vm.toggle_album_access_level_dialog),
      callback: function($$v) {
        _vm.toggle_album_access_level_dialog = $$v
      },
      expression: "toggle_album_access_level_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v(" Update Access Level ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n        Are you sure you want to update the access level?\n      ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "black",
      "dark": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.updateAccessLevel()
      }
    }
  }, [_vm._v("Yes")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "invite-dialog",
      "width": "440"
    },
    model: {
      value: (_vm.show_video_only_confirm_dialog),
      callback: function($$v) {
        _vm.show_video_only_confirm_dialog = $$v
      },
      expression: "show_video_only_confirm_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("\n        Make an album available only for live\n      ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n        If you click OK, the album will be available only for live video.\n      ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "black",
      "dark": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.videoOnlyAlbum()
      }
    }
  }, [_vm._v("Yes")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "invite-dialog",
      "width": "440"
    },
    model: {
      value: (_vm.show_album_delete_confirm_dialog),
      callback: function($$v) {
        _vm.show_album_delete_confirm_dialog = $$v
      },
      expression: "show_album_delete_confirm_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v(" Delete Album ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n        If you click OK, your followers won't see the album any more. Click OK\n        to delete <" + _vm._s(_vm.album.name) + ">\n      ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red",
      "dark": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.deleteAlbum()
      }
    }
  }, [_vm._v("Yes")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1750 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isPageReady) ? _c('v-card', {
    staticClass: "bg-grey-white",
    attrs: {
      "flat": ""
    }
  }, [_c('div', {
    staticClass: "display-flex justify-space-between bg-grey-white-4 align-center pa-4"
  }, [_c('v-select', {
    staticClass: "normal-input ml-4",
    attrs: {
      "items": _vm.genre_categories,
      "item-text": "name",
      "item-value": "id",
      "hide-details": ""
    },
    model: {
      value: (_vm.genre_category),
      callback: function($$v) {
        _vm.genre_category = $$v
      },
      expression: "genre_category"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "genre-add display-flex justify-center gap-4 align-center"
  }, [_c('v-icon', {
    staticClass: "genre-add__icon"
  }, [_vm._v("add")]), _vm._v(" "), _c('span', {
    staticClass: "text-white font-poppins text-14"
  }, [_vm._v("Add new subgenre")])], 1)], 1), _vm._v(" "), _c('table', {
    staticClass: "w-100 custom-table px-4"
  }, [_c('tbody', {
    staticClass: "custom-table__tbody"
  }, _vm._l((_vm.filtered_genres), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "pl-3 font-poppins text-16 font-weight-600"
    }, [_vm._v("\n          " + _vm._s(item.name) + "\n        ")]), _vm._v(" "), _c('td')])
  }))])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1751 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-page",
    class: {
      'bg-white': _vm.$vuetify.breakpoint.width <= 1280
    },
    staticStyle: {
      "background-color": "black"
    }
  }, [_c('v-container', {
    staticClass: "no-top-nav no-side-space",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('div', {
    staticClass: "login-outer"
  }, [_c('div', {
    class: {
      'login-view': _vm.$vuetify.breakpoint.width > 1280
    }
  }, [(_vm.$vuetify.breakpoint.width > 1280) ? _c('v-btn', {
    staticClass: "absolute ma-0 btn-close",
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.$router.push("/")
      }
    }
  }, [_c('v-icon', {
    staticClass: "font-size-34",
    staticStyle: {
      "background-color": "black"
    }
  }, [_vm._v("close")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "auth"
  }, [(_vm.loginAuth === 'login') ? _c('div', [_c('login-input', {
    attrs: {
      "showForgotPassword": _vm.showForgotPassword
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.loginAuth === 'forgotPassword') ? _c('div', {
    staticClass: "forgot-password-input"
  }, [_c('div', {
    staticClass: "intro-text text-xs-center"
  }, [_c('h2', [_vm._v("Forgot Password")])]), _vm._v(" "), _c('forgot-password-input', {
    attrs: {
      "showLogin": _vm.showLogin
    }
  })], 1) : _vm._e()])], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1752 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isPageReady) ? _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-tabs', {
    staticClass: "white",
    attrs: {
      "dark": ""
    },
    model: {
      value: (_vm.active_tab),
      callback: function($$v) {
        _vm.active_tab = $$v
      },
      expression: "active_tab"
    }
  }, [_c('content-top-header', {
    staticClass: "content-top-header-tab",
    attrs: {
      "height": 62
    }
  }, [_c('template', {
    slot: "topHeader"
  }, [_c('ul', _vm._l((_vm.signups_tabs), function(tab) {
    return _c('li', {
      key: tab.id,
      class: {
        'active tab-active': tab.id == _vm.active_tab
      },
      attrs: {
        "href": ("#" + (tab.id))
      },
      on: {
        "click": function($event) {
          _vm.onTab(tab.id)
        }
      }
    }, [_c('label', {
      staticClass: "innerBold"
    }, [_vm._v(_vm._s(tab.title))])])
  }))])], 2), _vm._v(" "), _c('v-tabs-items', {
    staticStyle: {
      "border": "none"
    }
  }, _vm._l((_vm.signups_tabs), function(tab) {
    return _c('v-tabs-content', {
      key: tab.id,
      attrs: {
        "id": tab.id
      }
    }, [_c('v-card', {
      attrs: {
        "flat": ""
      }
    }, [(_vm.active_tab == 'waiting') ? _c('v-data-table', {
      staticClass: "user-table custom-data-table pt-70 px-4",
      attrs: {
        "headers": _vm.headers,
        "items": _vm.signups,
        "pagination": _vm.pagination,
        "rows-per-page-items": _vm.per_page_options,
        "total-items": _vm.total_signups
      },
      on: {
        "update:pagination": function($event) {
          _vm.pagination = $event
        }
      },
      scopedSlots: _vm._u([{
        key: "items",
        fn: function(props) {
          return [_c('td', {
            staticClass: "text-xs-left"
          }, [_c('div', {
            staticClass: "avatar-image-wrapper ml-4 display-flex align-center gap-10"
          }, [_c('div', {
            staticClass: "avatar-image",
            style: ({
              'background-image': 'url(' + props.item.avatar.url + ')',
            })
          }), _vm._v(" "), _c('div', [_c('div', {
            staticClass: "avatar-title"
          }, [_vm._v(_vm._s(props.item.username))]), _vm._v(" "), _c('div', {
            staticClass: "avatar-title text-back-80"
          }, [_vm._v("\n                      @" + _vm._s(props.item.slug) + "\n                    ")])])])]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_vm._v("\n                " + _vm._s(_vm._f("capitalize")(props.item.request_role)) + "\n              ")]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_vm._v("\n                " + _vm._s(_vm._.get(props.item, "genre.name", "")) + "\n              ")]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_vm._v("\n                " + _vm._s(_vm._f("formatDate")(props.item.created_at)) + "\n              ")]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [(props.item.inviter) ? _c('router-link', {
            attrs: {
              "to": ("/" + (props.item.inviter.slug))
            }
          }, [_vm._v(_vm._s(props.item.inviter.username))]) : _vm._e()], 1), _vm._v(" "), _c('td', {
            staticClass: "text-xs-right"
          }, [_c('v-menu', {
            attrs: {
              "offset-y": ""
            }
          }, [_c('v-btn', {
            attrs: {
              "slot": "activator"
            },
            slot: "activator"
          }, [_c('v-icon', [_vm._v("more_horiz")])], 1), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
            staticClass: "pb-2"
          }, [_c('div', {
            staticClass: "cursor-pointer display-flex justify-center algin-center gap-8",
            on: {
              "click": function($event) {
                _vm.openApproveModal(props.item)
              }
            }
          }, [_c('v-icon', {
            staticClass: "icon-error",
            attrs: {
              "color": "black"
            }
          }, [_vm._v("\n                          error\n                        ")]), _vm._v(" "), _c('span', {
            staticClass: "text-poppins-15"
          }, [_vm._v(" View info ")])], 1)]), _vm._v(" "), _c('v-list-tile', {
            staticClass: "display-flex justify-center algin-center gap-8"
          }, [_c('div', {
            staticClass: "cursor-pointer display-flex justify-center algin-center gap-8",
            on: {
              "click": function($event) {
                _vm.openApproveModal(props.item)
              }
            }
          }, [_c('v-icon', {
            staticClass: "icon-error",
            attrs: {
              "color": "red"
            }
          }, [_vm._v("error")]), _vm._v(" "), _c('span', {
            staticClass: "text-poppins-15"
          }, [_vm._v(" Flag user ")])], 1)])], 1)], 1)], 1)]
        }
      }, {
        key: "pageText",
        fn: function(ref) {
          var pageStart = ref.pageStart;
          var pageStop = ref.pageStop;

          return [_vm._v("\n              From " + _vm._s(pageStart) + " to " + _vm._s(pageStop) + " out of\n              " + _vm._s(_vm.total_signups) + "\n            ")]
        }
      }])
    }) : _vm._e(), _vm._v(" "), (_vm.active_tab == 'co-signed') ? _c('v-data-table', {
      staticClass: "user-table custom-data-table pt-70 px-4",
      attrs: {
        "headers": _vm.headers,
        "items": _vm.signups,
        "pagination": _vm.pagination,
        "rows-per-page-items": _vm.per_page_options,
        "total-items": _vm.total_signups
      },
      on: {
        "update:pagination": function($event) {
          _vm.pagination = $event
        }
      },
      scopedSlots: _vm._u([{
        key: "items",
        fn: function(props) {
          return [_c('td', {
            staticClass: "text-xs-left"
          }, [_c('div', {
            staticClass: "avatar-image-wrapper ml-4 display-flex align-center gap-10"
          }, [_c('div', {
            staticClass: "avatar-image",
            style: ({
              'background-image': 'url(' + props.item.avatar.url + ')',
            })
          }), _vm._v(" "), _c('div', [_c('div', {
            staticClass: "avatar-title"
          }, [_vm._v(_vm._s(props.item.username))]), _vm._v(" "), _c('div', {
            staticClass: "avatar-title text-back-80"
          }, [_vm._v("\n                      @" + _vm._s(props.item.slug) + "\n                    ")])])])]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_vm._v("\n                " + _vm._s(_vm._f("capitalize")(props.item.request_role)) + "\n              ")]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_vm._v("\n                " + _vm._s(_vm._.get(props.item, "genre.name", "")) + "\n              ")]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-center"
          }, [_vm._v("\n                " + _vm._s(_vm._f("formatDate")(props.item.created_at)) + "\n              ")]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_c('label', {
            class: {
              'status-accepted': props.item.status == 'Accepted',
              'status-expired': props.item.status == 'Expired',
              'status-pending': props.item.status == 'Pending',
            }
          }, [_vm._v(_vm._s(props.item.status))])]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [(props.item.inviter) ? _c('router-link', {
            attrs: {
              "to": ("/" + (props.item.inviter.slug))
            }
          }, [_vm._v(_vm._s(props.item.inviter.username))]) : _vm._e()], 1), _vm._v(" "), _c('td', {
            staticClass: "text-xs-right"
          }, [_c('v-menu', {
            attrs: {
              "offset-y": ""
            }
          }, [_c('v-btn', {
            attrs: {
              "slot": "activator"
            },
            slot: "activator"
          }, [_c('v-icon', [_vm._v("more_horiz")])], 1), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
            staticClass: "pb-2"
          }, [_c('div', {
            staticClass: "cursor-pointer display-flex justify-center algin-center gap-8",
            on: {
              "click": function($event) {
                _vm.openApproveModal(props.item)
              }
            }
          }, [_c('v-icon', {
            staticClass: "icon-error",
            attrs: {
              "color": "black"
            }
          }, [_vm._v("\n                          error\n                        ")]), _vm._v(" "), _c('span', {
            staticClass: "text-poppins-15"
          }, [_vm._v(" View info ")])], 1)]), _vm._v(" "), _c('v-list-tile', {
            staticClass: "display-flex justify-center algin-center gap-8"
          }, [_c('div', {
            staticClass: "cursor-pointer display-flex justify-center algin-center gap-8",
            on: {
              "click": function($event) {
                _vm.denyButtonAction()
              }
            }
          }, [_c('v-icon', {
            staticClass: "icon-error",
            attrs: {
              "color": "red"
            }
          }, [_vm._v("error")]), _vm._v(" "), _c('span', {
            staticClass: "text-poppins-15"
          }, [_vm._v(" Flag user ")])], 1)])], 1)], 1)], 1)]
        }
      }, {
        key: "pageText",
        fn: function(ref) {
          var pageStart = ref.pageStart;
          var pageStop = ref.pageStop;

          return [_vm._v("\n              From " + _vm._s(pageStart) + " to " + _vm._s(pageStop) + " out of\n              " + _vm._s(_vm.total_signups) + "\n            ")]
        }
      }])
    }) : _vm._e(), _vm._v(" "), (_vm.active_tab == 'approved' || _vm.active_tab == 'denied') ? _c('v-data-table', {
      staticClass: "user-table custom-data-table pt-70 px-4",
      attrs: {
        "headers": _vm.headers,
        "items": _vm.signups,
        "pagination": _vm.pagination,
        "rows-per-page-items": _vm.per_page_options,
        "total-items": _vm.total_signups
      },
      scopedSlots: _vm._u([{
        key: "items",
        fn: function(props) {
          return [_c('td', {
            staticClass: "text-xs-left"
          }, [_c('div', {
            staticClass: "avatar-image-wrapper ml-4 display-flex align-center gap-10"
          }, [_c('div', {
            staticClass: "avatar-image",
            style: ({
              'background-image': 'url(' + props.item.avatar.url + ')',
            })
          }), _vm._v(" "), _c('div', [_c('div', {
            staticClass: "avatar-title"
          }, [_vm._v(_vm._s(props.item.username))]), _vm._v(" "), _c('div', {
            staticClass: "avatar-title text-back-80"
          }, [_vm._v("\n                      @" + _vm._s(props.item.slug) + "\n                    ")])])])]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_vm._v("\n                " + _vm._s(_vm._f("capitalize")(props.item.request_role)) + "\n              ")]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-center"
          }, [_vm._v("\n                " + _vm._s(_vm._f("formatDate")(props.item.created_at)) + "\n              ")]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-center"
          }, [_vm._v("\n                " + _vm._s(_vm._f("formatDate")(props.item.approved_at)) + "\n              ")]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_vm._v("\n                " + _vm._s(props.item.approver ? props.item.approver.username : "") + "\n              ")]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_c('v-btn', {
            staticClass: "signups-btn",
            attrs: {
              "color": "primary"
            },
            nativeOn: {
              "click": function($event) {
                _vm.openApproveModal(props.item)
              }
            }
          }, [_vm._v("Click to view")])], 1)]
        }
      }, {
        key: "pageText",
        fn: function(ref) {
          var pageStart = ref.pageStart;
          var pageStop = ref.pageStop;

          return [_vm._v("\n              From " + _vm._s(pageStart) + " to " + _vm._s(pageStop) + " out of\n              " + _vm._s(_vm.total_signups) + "\n            ")]
        }
      }])
    }) : _vm._e()], 1)], 1)
  }))], 1), _vm._v(" "), (_vm.show_approve_modal) ? _c('signup-approve-modal', {
    attrs: {
      "item": _vm.user,
      "dismiss": _vm.closeApproveModal,
      "approveButtonAction": _vm.approveUser,
      "denyButtonAction": _vm.denyUser,
      "activeTab": _vm.active_tab,
      "loading": _vm.loading
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_deny_modal) ? _c('signup-deny-modal', {
    attrs: {
      "item": _vm.user,
      "dismiss": _vm.closeDenyModal,
      "submission": _vm.viewSubmission,
      "loading": _vm.loading
    }
  }) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1753 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.category) ? _c('div', [_c('div', {
    staticClass: "uploaderBox",
    attrs: {
      "id": "uploaderBox"
    }
  }, [_c('div', {
    staticClass: "uploaderBox__input"
  }, [_c('input', {
    staticClass: "uploaderBox__file",
    attrs: {
      "type": "file",
      "id": "file",
      "name": _vm.uploadFieldName,
      "accept": _vm.accept,
      "multiple": ""
    },
    on: {
      "change": function($event) {
        _vm.filesChange($event.target.files)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "allChildrenCenter flex-column"
  }, [_c('label', {
    attrs: {
      "for": "file"
    }
  }, [(_vm.category == 'audio') ? _c('img', {
    staticClass: "uploaderBox_image",
    attrs: {
      "src": __webpack_require__(1549)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.category == 'video') ? _c('img', {
    staticClass: "uploaderBox_image",
    attrs: {
      "src": __webpack_require__(1550)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.category == 'product') ? _c('img', {
    staticClass: "uploaderBox_image",
    attrs: {
      "src": "/static/images/upload.png"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "uploaderBox__desc"
  }, [(_vm.category == 'audio') ? _c('div', [_c('b', {
    staticClass: "uploaderBox__dragndrop"
  }, [_vm._v("\n                  Drag and drop audio files\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.category == 'video') ? _c('div', [(_vm.category == 'video') ? _c('b', {
    staticClass: "uploaderBox__dragndrop"
  }, [_vm._v("\n                  Drag and drop video files\n                ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.category == 'product') ? _c('div', [(_vm.category == 'product') ? _c('b', {
    staticClass: "uploaderBox__dragndrop"
  }, [_vm._v("\n                  Drag and drop product files\n                ")]) : _vm._e()]) : _vm._e()])])])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1754 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page terms-page",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [(_vm.$vuetify.breakpoint.width >= 968) ? _c('div', {
    staticClass: "page-left",
    staticStyle: {
      "width": "unset"
    }
  }, [_c('div', {
    staticClass: "tab-container"
  }, [_c('v-navigation-drawer', {
    attrs: {
      "permanent": "",
      "fixed": "",
      "height": "100vh"
    }
  }, [_c('div', {
    staticClass: "page-title"
  }), _vm._v(" "), _c('v-list', _vm._l((_vm.tabs), function(t) {
    return _c('v-list-tile', {
      key: t.id,
      class: {
        active: t.id == _vm.currentTab
      },
      staticStyle: {
        "line-height": "3"
      },
      attrs: {
        "href": ("#" + (t.id))
      },
      nativeOn: {
        "click": function($event) {
          _vm.onTab(t.id)
        }
      }
    }, [_c('v-list-tile-title', [_vm._v(_vm._s(t.title) + " ")])], 1)
  }))], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [(_vm.$vuetify.breakpoint.width < 968) ? _c('div', [_c('div', {
    staticClass: "page-title"
  }), _vm._v(" "), _c('v-list', _vm._l((_vm.tabs), function(t) {
    return _c('v-list-tile', {
      key: t.id,
      class: {
        active: t.id == _vm.currentTab
      },
      staticStyle: {
        "line-height": "3"
      },
      attrs: {
        "href": ("#" + (t.id))
      },
      nativeOn: {
        "click": function($event) {
          _vm.onTab(t.id)
        }
      }
    }, [_c('v-list-tile-title', [_vm._v(_vm._s(t.title) + " ")])], 1)
  }))], 1) : _vm._e(), _vm._v(" "), (_vm.currentTab == 'terms_of_use') ? _c('terms-of-use-tab') : (_vm.currentTab == 'community_guidelines') ? _c('community-guidelines-tab') : (_vm.currentTab == 'privacy_policy') ? _c('privacy-policy-tab') : (_vm.currentTab == 'privacy_choice') ? _c('privacy-choice-tab') : (_vm.currentTab == 'copyright_policy') ? _c('copyright-policy-tab') : (_vm.currentTab == 'trademark_policy') ? _c('trademark-policy-tab') : (_vm.currentTab == 'gdpr') ? _c('gdpr-tab') : (_vm.currentTab == 'cookie_policy') ? _c('cookie-policy-tab') : (_vm.currentTab == 'sample_clearance') ? _c('sample-clearance-tab') : _vm._e()], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1755 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.onMobile) ? _c('div', [(!_vm.videoUploaded) ? _c('div', [_c('BannerUpload', {
    attrs: {
      "MainHeading": "Spotlight video",
      "MainText": "Upload a 15 second video clip to attract new followers when new potential subscribers preview your content",
      "Icon": _vm.iconImage,
      "MainImage": _vm.bannerImage
    }
  }), _vm._v(" "), _c('drag-file-uploader', {
    ref: "dragFileUploader",
    attrs: {
      "accept": "video/*",
      "type": "file",
      "category": "video",
      "autoUpload": true
    },
    on: {
      "filePicked": _vm.pickedFile
    }
  })], 1) : _c('div', [_c('div', {
    staticClass: "spotlight-header dflex align-center justify-space-between"
  }, [_c('div', {
    staticClass: "replace",
    on: {
      "click": function($event) {
        _vm.replaceVideo()
      }
    }
  }, [_vm._v("\n\t\t\t\t< Replace video\n\t\t\t")]), _vm._v(" "), _c('div', [_c('v-btn', {
    staticClass: "head-button",
    attrs: {
      "loading": _vm.loading
    },
    on: {
      "click": function($event) {
        _vm.submit()
      }
    }
  }, [_vm._v("\n\t\t\t\t\tSave video\n\t\t\t\t")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "main-flex"
  }, [_c('div', {
    staticClass: "w-75"
  }, [_c('h2', {
    staticClass: "heading"
  }, [_vm._v("Web Preview")]), _vm._v(" "), _c('div', {
    staticClass: "web-container"
  }, [_c('div', {
    staticClass: "web-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "_user-icon mb-4"
  }, [_c('div', {
    staticClass: "user-icon-inner",
    style: ({
      'background-image': 'url(' + _vm.currentUser.avatar.url + ')'
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "_info mb-4"
  }, [_c('p', [_vm._v("Subscribe to support")]), _vm._v(" "), _c('div', {
    staticClass: "dflex align-center"
  }, [_c('p', {
    staticClass: "font-bold mr-1"
  }, [_vm._v(" " + _vm._s(_vm.currentUser.username))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(310),
      "width": "12"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_text mb-4"
  }, [_vm._v("\n\t\t\t\t\t\t\tGet full access to all creators and their content. 50% of your subscription shared with creators that viewed the most.\n\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "_button"
  }, [_c('v-btn', {
    staticClass: "button-web",
    attrs: {
      "rounded": ""
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tSubscribe\n\t\t\t\t\t\t\t")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "web-video"
  }, [_c('div', {
    staticClass: "modal-card-title-img"
  }, [_c('video', {
    attrs: {
      "playsinline": "",
      "autoplay": "",
      "loop": "",
      "id": "bgvid"
    }
  }, [_c('source', {
    attrs: {
      "src": this.video.src,
      "type": this.videoFile[0].type
    }
  })]), _vm._v(" "), _vm._m(1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "w-25"
  }, [_c('h2', {
    staticClass: "heading"
  }, [_vm._v("Mobile Preview")]), _vm._v(" "), _c('div', {
    staticClass: "mob-container"
  }, [_c('div', {
    staticClass: "mob-video"
  }, [_c('div', {
    staticClass: "modal-card-title-img"
  }, [_c('video', {
    staticClass: "min-height",
    attrs: {
      "playsinline": "",
      "autoplay": "",
      "muted": "",
      "loop": "",
      "id": "bgvid"
    },
    domProps: {
      "muted": true
    }
  }, [_c('source', {
    attrs: {
      "src": this.video.src,
      "type": this.videoFile[0].type
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "mob-content"
  }, [_c('div', {
    staticClass: "_info"
  }, [_c('p', [_vm._v("Subscribe to support")]), _vm._v(" "), _c('div', {
    staticClass: "dflex align-center"
  }, [_c('p', {
    staticClass: "font-bold mr-1"
  }, [_vm._v(" " + _vm._s(_vm.currentUser.username))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(310),
      "width": "12"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_content"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "_text mb-3"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tGet full access to all creators and their content. 50% of your subscription shared with creators that viewed the most.\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "_button"
  }, [_c('v-btn', {
    staticClass: "button-mob"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\tStart 30 day free trial\n\t\t\t\t\t\t\t\t")])], 1)])])])])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile-image-section"
  }, [_c('div', {
    staticClass: "profile-image"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1563),
      "width": "140"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "volume-button"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(43),
      "width": "17px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_logo mb-3"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(44),
      "width": "70"
    }
  })])
}]}

/***/ }),
/* 1756 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "trending-comp trending-music"
  }, [(_vm.title) ? _c('div', {
    staticClass: "top-bar"
  }, [_c('h2', {
    staticClass: "bar-title"
  }, [_vm._v(_vm._s(_vm.title))])]) : _vm._e(), _vm._v(" "), _c('item-tab', {
    attrs: {
      "mode": "grid"
    }
  }, [_c('template', {
    slot: "itemTabs"
  }, _vm._l((_vm.musicFeed), function(feed, index) {
    return _c('span', {
      key: index,
      class: ['tab-holder px-0 flex', _vm.classAttr]
    }, [_c('track-card', {
      staticClass: "pa-0",
      attrs: {
        "objects": _vm.musicFeed,
        "objectIndex": index,
        "hideMoreMenu": "",
        "hideTrackLength": _vm.hideTrackLength,
        "noAction": _vm.noAction,
        "noMeta": _vm.noMeta,
        "playButton2": _vm.playButton2,
        "playButton2IconHasWhiteBG": _vm.playButton2IconHasWhiteBG
      }
    })], 1)
  }))], 2), _vm._v(" "), (!_vm.hideCta) ? _c('div', {
    staticClass: "cta"
  }, [_c('v-btn', {
    staticClass: "cta-btn",
    attrs: {
      "block": "",
      "outline": ""
    }
  }, [_c('strong', [_vm._v(" View all music ")])])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1757 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "autocomplete"
  }, [(_vm.options.length && _vm.showPanel) ? _c('div', {
    staticClass: "options"
  }, _vm._l((_vm.options), function(option, index) {
    return _c('div', {
      key: index,
      staticClass: "option",
      on: {
        "click": function($event) {
          _vm.selectOption(option)
        }
      }
    }, [_vm._v("\n      " + _vm._s(_vm.itemName ? option[_vm.itemName] : option) + "\n    ")])
  })) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1758 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isPageReady) ? _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('content-top-header', {
    staticClass: "content-top-header-tab",
    attrs: {
      "height": 62
    }
  }, [_c('template', {
    slot: "topHeader"
  }, [_c('ul', [_vm._l((_vm.users_tabs), function(tab) {
    return _c('li', {
      key: tab.id,
      class: {
        'active tab-active': tab.id == _vm.active_tab
      },
      attrs: {
        "href": ("#" + (tab.id))
      },
      on: {
        "click": function($event) {
          _vm.onTab(tab.id)
        }
      }
    }, [_c('label', {
      staticClass: "innerBold"
    }, [_vm._v(_vm._s(tab.title))])])
  }), _vm._v(" "), _c('li', {
    staticStyle: {
      "width": "100%",
      "text-align": "right"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search_value),
      expression: "search_value"
    }],
    staticStyle: {
      "padding": "10px"
    },
    attrs: {
      "type": "text",
      "placeholder": "search users"
    },
    domProps: {
      "value": (_vm.search_value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search_value = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn",
    staticStyle: {
      "background": "black",
      "color": "white"
    },
    on: {
      "click": _vm.loadUsers
    }
  }, [_vm._v("Search")])])], 2)])], 2), _vm._v(" "), _c('v-card', {
    staticClass: "bg-natural-grey pt-70 px-4",
    attrs: {
      "flat": ""
    }
  }, [_c('v-data-table', {
    staticClass: "user-table custom-data-table table-footer",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.users,
      "pagination": _vm.pagination,
      "rows-per-page-items": _vm.per_page_options,
      "total-items": _vm.total_users
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-left"
        }, [_c('div', {
          staticClass: "ml-2 avatar-image-wrapper"
        }, [_c('div', {
          staticClass: "avatar-image",
          style: ({
            'background-image': 'url(' + props.item.avatar.url + ')',
          })
        }), _vm._v(" "), _c('div', {
          staticClass: "avatar-title"
        }, [_vm._v(_vm._s(props.item.username))])])]), _vm._v(" "), (_vm.active_tab == 'moderator') ? _c('td', {
          staticClass: "text-xs-left"
        }, [_c('v-switch', {
          staticClass: "setting-cell-switch",
          attrs: {
            "label": "",
            "hide-details": ""
          },
          on: {
            "change": function($event) {
              _vm.toggleViewDirectMessages(props.item)
            }
          },
          model: {
            value: (props.item.enabled_view_direct_messages),
            callback: function($$v) {
              _vm.$set(props.item, "enabled_view_direct_messages", $$v)
            },
            expression: "props.item.enabled_view_direct_messages"
          }
        })], 1) : _vm._e(), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_c('v-switch', {
          staticClass: "setting-cell-switch",
          attrs: {
            "label": "",
            "hide-details": ""
          },
          on: {
            "change": function($event) {
              _vm.toggleLiveVideo(props.item)
            }
          },
          model: {
            value: (props.item.enabled_live_video),
            callback: function($$v) {
              _vm.$set(props.item, "enabled_live_video", $$v)
            },
            expression: "props.item.enabled_live_video"
          }
        })], 1), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_c('v-switch', {
          staticClass: "setting-cell-switch",
          attrs: {
            "label": "",
            "hide-details": ""
          },
          on: {
            "change": function($event) {
              _vm.toggleLiveVideoFree(props.item)
            }
          },
          model: {
            value: (props.item.enabled_live_video_free),
            callback: function($$v) {
              _vm.$set(props.item, "enabled_live_video_free", $$v)
            },
            expression: "props.item.enabled_live_video_free"
          }
        })], 1), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_c('v-switch', {
          staticClass: "setting-cell-switch",
          attrs: {
            "label": "",
            "hide-details": ""
          },
          on: {
            "change": function($event) {
              _vm.toggleSignInAuthorized(props.item)
            }
          },
          model: {
            value: (props.item.sign_in_authorized),
            callback: function($$v) {
              _vm.$set(props.item, "sign_in_authorized", $$v)
            },
            expression: "props.item.sign_in_authorized"
          }
        })], 1), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.email))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [(props.item.social_provider != null) ? _c('a', {
          attrs: {
            "href": ("https://" + (props.item.social_provider) + ".com/" + ((props.item.social_user_id == null ? props.item.social_user_name: props.item.social_user_id))),
            "target": "_blank"
          }
        }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(("https://" + (props.item.social_provider) + ".com/" + ((props.item.social_user_id == null ? props.item.social_user_name: props.item.social_user_id)))) + "\n\t\t\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(_vm._f("formatDate")(props.item.created_at)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [(props.item.approver) ? _c('router-link', {
          attrs: {
            "to": ("/" + (props.item.approver.slug))
          }
        }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(props.item.approver.username) + "\n\t\t\t\t\t\t")]) : _vm._e()], 1), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.status))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_c('v-menu', {
          staticClass: "more-menu",
          attrs: {
            "offset-y": ""
          }
        }, [_c('v-btn', {
          attrs: {
            "slot": "activator",
            "dark": ""
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("settings")])], 1), _vm._v(" "), _c('v-list', [(props.item.status == 'inactive') ? _c('v-list-tile', {
          staticClass: "default-menu-item",
          nativeOn: {
            "click": function($event) {
              _vm.sendConfirmEmail(props.item)
            }
          }
        }, [_c('v-list-tile-title', [_c('label', [_vm._v("Resend confirm email")])])], 1) : _vm._e(), _vm._v(" "), (
          ['suspended', 'pending'].indexOf(props.item.status) !== -1
        ) ? _c('v-list-tile', {
          key: "activate",
          staticClass: "default-menu-item",
          nativeOn: {
            "click": function($event) {
              _vm.activateAccount(props.item)
            }
          }
        }, [_c('v-list-tile-title', [_c('label', [_vm._v("Activate account")])])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile', {
          staticClass: "default-menu-item",
          nativeOn: {
            "click": function($event) {
              _vm.openUserDeleteConfirmDialog(props.item)
            }
          }
        }, [_c('v-list-tile-title', [_c('label', [_vm._v("Remove account")])])], 1), _vm._v(" "), (
          props.item.status == 'active' && ['listener', 'moderator'].indexOf(props.item.user_type) > -1
        ) ? _c('v-list-tile', {
          staticClass: "default-menu-item",
          nativeOn: {
            "click": function($event) {
              _vm.updateUserRole(props.item, 'artist')
            }
          }
        }, [_c('v-list-tile-title', [_c('label', [_vm._v("Convert to artist")])])], 1) : _vm._e(), _vm._v(" "), (
          props.item.status == 'active' && ['listener', 'moderator'].indexOf(props.item.user_type) > -1
        ) ? _c('v-list-tile', {
          staticClass: "default-menu-item",
          nativeOn: {
            "click": function($event) {
              _vm.updateUserRole(props.item, 'brand')
            }
          }
        }, [_c('v-list-tile-title', [_c('label', [_vm._v("Convert to brand")])])], 1) : _vm._e(), _vm._v(" "), (
          props.item.status == 'active' && ['artist', 'brand', 'moderator'].indexOf(
            props.item.user_type
          ) > -1
        ) ? _c('v-list-tile', {
          staticClass: "default-menu-item",
          nativeOn: {
            "click": function($event) {
              _vm.updateUserRole(props.item, 'listener')
            }
          }
        }, [_c('v-list-tile-title', [_c('label', [_vm._v("Convert to listener")])])], 1) : _vm._e(), _vm._v(" "), (
          props.item.status == 'active' && ['listener', 'artist'].indexOf(props.item.user_type) > -1
        ) ? _c('v-list-tile', {
          staticClass: "default-menu-item",
          nativeOn: {
            "click": function($event) {
              _vm.updateUserRole(props.item, 'moderator')
            }
          }
        }, [_c('v-list-tile-title', [_c('label', [_vm._v("Convert to moderator")])])], 1) : _vm._e(), _vm._v(" "), (props.item.stripe_connected) ? _c('v-list-tile', {
          staticClass: "default-menu-item",
          nativeOn: {
            "click": function($event) {
              _vm.openDisconnectStripeConfirmDialog(props.item)
            }
          }
        }, [_c('v-list-tile-title', [_c('label', [_vm._v("Disconnect Stripe")])])], 1) : _vm._e()], 1)], 1)], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.show_stream_delete_confirm_dialog),
      callback: function($$v) {
        _vm.show_stream_delete_confirm_dialog = $$v
      },
      expression: "show_stream_delete_confirm_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Delete a Stream")]), _vm._v(" "), _c('v-card-text', [_vm._v("If you click OK, the stream will no longer be available. Click OK to\n\t\t\t\t\tdelete, or click Cancel.")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "red--text darken-1",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.archiveStream()
      }
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeStreamDeleteConfirmDialog()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-spacer')], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.show_free_stream_toggle_confirm_dialog),
      callback: function($$v) {
        _vm.show_free_stream_toggle_confirm_dialog = $$v
      },
      expression: "show_free_stream_toggle_confirm_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Stream Running")]), _vm._v(" "), _c('v-card-text', [_vm._v("Stream is running for now. Please stop the stream before toggle free\n\t\t\t\t\tstream option")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "red--text darken-1",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeFreeStreamToggleConfirmDialog()
      }
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('v-spacer')], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.show_disconnect_stripe_confirm_dialog),
      callback: function($$v) {
        _vm.show_disconnect_stripe_confirm_dialog = $$v
      },
      expression: "show_disconnect_stripe_confirm_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Disconnect Stripe")]), _vm._v(" "), _c('v-card-text', [_vm._v("Are you going to disconnect this user from Yousound\n\t\t\t\t\tmarketplace?")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "red--text darken-1",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.disconnectStripe()
      }
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeDisconnectStripeConfirmDialog()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-spacer')], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "my-dialog-1"
    },
    model: {
      value: (_vm.show_user_delete_confirm_dialog),
      callback: function($$v) {
        _vm.show_user_delete_confirm_dialog = $$v
      },
      expression: "show_user_delete_confirm_dialog"
    }
  }, [_c('v-card', [_c('v-card-media', {
    attrs: {
      "src": _vm._.get(_vm.user, 'avatar.thumb.url'),
      "height": "125px",
      "contain": ""
    }
  }), _vm._v(" "), _c('v-card-text', {
    staticClass: "mt-2"
  }, [_c('div', [_vm._v("\n\t\t\t\t\t\tDo you really want to delete\n\t\t\t\t\t\t"), _c('b', [_vm._v(_vm._s(_vm._.get(_vm.user, "display_name", "User")))]), _vm._v("?\n\t\t\t\t\t")])]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "dark": "",
      "color": "red"
    },
    on: {
      "click": function($event) {
        _vm.removeAccount(_vm.user)
      }
    }
  }, [_vm._v("Confirm")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "dark": "",
      "color": "grey"
    },
    on: {
      "click": function($event) {
        _vm.closeUserDeleteConfirmDialog()
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1759 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    staticClass: "page auth-page auth-twitter-page",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": "",
      "md6": "",
      "offset-md3": "",
      "lg8": "",
      "offset-lg2": "",
      "xl8": "",
      "offset-xl2": "",
      "transition": "slide-x-reverse-transition"
    }
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "/static/images/nav_logo_primary.png"
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('h4', [_c('span', [_vm._v(_vm._s(_vm.user.request_role))]), _vm._v(" Verification")])])], 1), _vm._v(" "), (_vm.isPageReady) ? _c('div', {
    staticClass: "page-content"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit()
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h5', [_vm._v("Personal Info")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.first_name),
      expression: "user.first_name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "name": "first_name",
      "autocomplete": "off",
      "placeholder": "First Name"
    },
    domProps: {
      "value": (_vm.user.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "first_name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.last_name),
      expression: "user.last_name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "name": "last_name",
      "autocomplete": "off",
      "placeholder": "Last Name"
    },
    domProps: {
      "value": (_vm.user.last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "last_name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.year_of_birth_options,
      "name": "year_of_birth",
      "placeholder": "Year of Birth",
      "autocomplete": ""
    },
    model: {
      value: (_vm.user.year_of_birth),
      callback: function($$v) {
        _vm.$set(_vm.user, "year_of_birth", $$v)
      },
      expression: "user.year_of_birth"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.gender_options,
      "item-value": "value",
      "item-text": "text",
      "name": "gender",
      "placeholder": "Sex"
    },
    model: {
      value: (_vm.user.gender),
      callback: function($$v) {
        _vm.$set(_vm.user, "gender", $$v)
      },
      expression: "user.gender"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.country_options,
      "name": "country",
      "placeholder": "Country",
      "autocomplete": ""
    },
    model: {
      value: (_vm.user.country),
      callback: function($$v) {
        _vm.$set(_vm.user, "country", $$v)
      },
      expression: "user.country"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.city),
      expression: "user.city"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "name": "city",
      "autocomplete": "off",
      "placeholder": "City"
    },
    domProps: {
      "value": (_vm.user.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "city", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.user.request_role == 'artist') ? [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h5', {
    staticClass: "pt-3"
  }, [_c('span', [_vm._v("Artist")]), _vm._v(" Info")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.main_genres,
      "item-value": "id",
      "item-text": "name",
      "name": "main_genre",
      "placeholder": "What is your main Genre?",
      "autocomplete": ""
    },
    model: {
      value: (_vm.user.genre_id),
      callback: function($$v) {
        _vm.$set(_vm.user, "genre_id", $$v)
      },
      expression: "user.genre_id"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.artist_type_options,
      "name": "artist_type",
      "placeholder": "What type of artist are you?"
    },
    model: {
      value: (_vm.user.artist_type),
      callback: function($$v) {
        _vm.$set(_vm.user, "artist_type", $$v)
      },
      expression: "user.artist_type"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.released_albums_count_options,
      "item-value": "id",
      "item-text": "name",
      "name": "released_albums_count",
      "placeholder": "How many albums have you released?"
    },
    model: {
      value: (_vm.user.released_albums_count),
      callback: function($$v) {
        _vm.$set(_vm.user, "released_albums_count", $$v)
      },
      expression: "user.released_albums_count"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.years_since_first_released_options,
      "item-value": "id",
      "item-text": "name",
      "name": "years_since_first_released",
      "placeholder": "How many years since your first release?"
    },
    model: {
      value: (_vm.user.years_since_first_released),
      callback: function($$v) {
        _vm.$set(_vm.user, "years_since_first_released", $$v)
      },
      expression: "user.years_since_first_released"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.boolean_options,
      "item-value": "id",
      "item-text": "name",
      "name": "will_run_live_video",
      "placeholder": "Do you plan to run live video on YouSound?"
    },
    model: {
      value: (_vm.user.will_run_live_video),
      callback: function($$v) {
        _vm.$set(_vm.user, "will_run_live_video", $$v)
      },
      expression: "user.will_run_live_video"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.boolean_options,
      "item-value": "id",
      "item-text": "name",
      "name": "will_sell_products",
      "placeholder": "Do you sell products?"
    },
    model: {
      value: (_vm.user.will_sell_products),
      callback: function($$v) {
        _vm.$set(_vm.user, "will_sell_products", $$v)
      },
      expression: "user.will_sell_products"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.annual_income_on_merch_sales_options,
      "item-value": "id",
      "item-text": "name",
      "name": "annual_income_on_merch_sales",
      "placeholder": "Annual income on product sales"
    },
    model: {
      value: (_vm.user.annual_income_on_merch_sales),
      callback: function($$v) {
        _vm.$set(_vm.user, "annual_income_on_merch_sales", $$v)
      },
      expression: "user.annual_income_on_merch_sales"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.annual_performances_count_options,
      "item-value": "id",
      "item-text": "name",
      "name": "annual_performances_count",
      "placeholder": "How many show do you perform annually?"
    },
    model: {
      value: (_vm.user.annual_performances_count),
      callback: function($$v) {
        _vm.$set(_vm.user, "annual_performances_count", $$v)
      },
      expression: "user.annual_performances_count"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.signed_status_options,
      "item-value": "id",
      "item-text": "name",
      "name": "signed_status",
      "placeholder": "Are you currently signed?"
    },
    model: {
      value: (_vm.user.signed_status),
      callback: function($$v) {
        _vm.$set(_vm.user, "signed_status", $$v)
      },
      expression: "user.signed_status"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.performance_rights_organization_options,
      "item-value": "id",
      "item-text": "name",
      "name": "performance_rights_organization",
      "placeholder": "Performance Rights Organization (Writers)",
      "autocomplete": ""
    },
    model: {
      value: (_vm.user.performance_rights_organization),
      callback: function($$v) {
        _vm.$set(_vm.user, "performance_rights_organization", $$v)
      },
      expression: "user.performance_rights_organization"
    }
  })], 1)] : (_vm.user.request_role == 'label') ? [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h5', {
    staticClass: "pt-3"
  }, [_c('span', [_vm._v("Label")]), _vm._v(" Info")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.main_genres,
      "item-value": "id",
      "item-text": "name",
      "name": "main_genre",
      "placeholder": "What is your main Genre?",
      "autocomplete": ""
    },
    model: {
      value: (_vm.user.genre_id),
      callback: function($$v) {
        _vm.$set(_vm.user, "genre_id", $$v)
      },
      expression: "user.genre_id"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.sub_genres,
      "item-value": "id",
      "item-text": "name",
      "name": "sub_genre",
      "placeholder": "What sub genre do you release most?",
      "autocomplete": ""
    },
    model: {
      value: (_vm.user.sub_genre_id),
      callback: function($$v) {
        _vm.$set(_vm.user, "sub_genre_id", $$v)
      },
      expression: "user.sub_genre_id"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.released_albums_count_options,
      "item-value": "id",
      "item-text": "name",
      "name": "released_albums_count",
      "placeholder": "How many albums have you released?"
    },
    model: {
      value: (_vm.user.released_albums_count),
      callback: function($$v) {
        _vm.$set(_vm.user, "released_albums_count", $$v)
      },
      expression: "user.released_albums_count"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.years_since_first_released_options,
      "item-value": "id",
      "item-text": "name",
      "name": "years_since_first_released",
      "placeholder": "How many years since your first release?"
    },
    model: {
      value: (_vm.user.years_since_first_released),
      callback: function($$v) {
        _vm.$set(_vm.user, "years_since_first_released", $$v)
      },
      expression: "user.years_since_first_released"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.boolean_options,
      "item-value": "id",
      "item-text": "name",
      "name": "will_run_live_video",
      "placeholder": "Do you plan to run live video on YouSound?"
    },
    model: {
      value: (_vm.user.will_run_live_video),
      callback: function($$v) {
        _vm.$set(_vm.user, "will_run_live_video", $$v)
      },
      expression: "user.will_run_live_video"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.boolean_options,
      "item-value": "id",
      "item-text": "name",
      "name": "will_sell_products",
      "placeholder": "Do you sell products?"
    },
    model: {
      value: (_vm.user.will_sell_products),
      callback: function($$v) {
        _vm.$set(_vm.user, "will_sell_products", $$v)
      },
      expression: "user.will_sell_products"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.annual_income_on_merch_sales_options,
      "item-value": "id",
      "item-text": "name",
      "name": "annual_income_on_merch_sales",
      "placeholder": "Annual income on product sales"
    },
    model: {
      value: (_vm.user.annual_income_on_merch_sales),
      callback: function($$v) {
        _vm.$set(_vm.user, "annual_income_on_merch_sales", $$v)
      },
      expression: "user.annual_income_on_merch_sales"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.boolean_options,
      "item-value": "id",
      "item-text": "name",
      "name": "is_business_registered",
      "placeholder": "Is your business registered?"
    },
    model: {
      value: (_vm.user.is_business_registered),
      callback: function($$v) {
        _vm.$set(_vm.user, "is_business_registered", $$v)
      },
      expression: "user.is_business_registered"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric'),
      expression: "'required|numeric'"
    }],
    attrs: {
      "items": _vm.artists_count_options,
      "item-value": "id",
      "item-text": "name",
      "name": "artists_count",
      "placeholder": "How many artists are currently on your roster?"
    },
    model: {
      value: (_vm.user.artists_count),
      callback: function($$v) {
        _vm.$set(_vm.user, "artists_count", $$v)
      },
      expression: "user.artists_count"
    }
  })], 1)] : (_vm.user.request_role == 'brand') ? [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h5', {
    staticClass: "pt-3"
  }, [_c('span', [_vm._v("Brand")]), _vm._v(" Info")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.standard_brand_type_options,
      "name": "standard_brand_type",
      "placeholder": "What type of Brand?"
    },
    model: {
      value: (_vm.user.standard_brand_type),
      callback: function($$v) {
        _vm.$set(_vm.user, "standard_brand_type", $$v)
      },
      expression: "user.standard_brand_type"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.customized_brand_type),
      expression: "user.customized_brand_type"
    }],
    attrs: {
      "type": "text",
      "name": "customized_brand_type",
      "autocomplete": "off",
      "placeholder": "If your Brand type isn't listed what kind of brand are you?"
    },
    domProps: {
      "value": (_vm.user.customized_brand_type)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "customized_brand_type", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.employees_count_options,
      "item-value": "id",
      "item-text": "name",
      "name": "employees_count",
      "placeholder": "How many employees do you have?"
    },
    model: {
      value: (_vm.user.employees_count),
      callback: function($$v) {
        _vm.$set(_vm.user, "employees_count", $$v)
      },
      expression: "user.employees_count"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.years_in_business_options,
      "item-value": "id",
      "item-text": "name",
      "name": "years_in_business",
      "placeholder": "How many years in business?"
    },
    model: {
      value: (_vm.user.years_in_business),
      callback: function($$v) {
        _vm.$set(_vm.user, "years_in_business", $$v)
      },
      expression: "user.years_in_business"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.boolean_options,
      "item-value": "id",
      "item-text": "name",
      "name": "will_sell_music_related_products",
      "placeholder": "Do you sell music related products or services?"
    },
    model: {
      value: (_vm.user.will_sell_music_related_products),
      callback: function($$v) {
        _vm.$set(_vm.user, "will_sell_music_related_products", $$v)
      },
      expression: "user.will_sell_music_related_products"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.boolean_options,
      "item-value": "id",
      "item-text": "name",
      "name": "will_run_live_video",
      "placeholder": "Do you plan to run live video on YouSound?"
    },
    model: {
      value: (_vm.user.will_run_live_video),
      callback: function($$v) {
        _vm.$set(_vm.user, "will_run_live_video", $$v)
      },
      expression: "user.will_run_live_video"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.boolean_options,
      "item-value": "id",
      "item-text": "name",
      "name": "will_sell_products",
      "placeholder": "Do you sell products?"
    },
    model: {
      value: (_vm.user.will_sell_products),
      callback: function($$v) {
        _vm.$set(_vm.user, "will_sell_products", $$v)
      },
      expression: "user.will_sell_products"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.products_count_options,
      "item-value": "id",
      "item-text": "name",
      "name": "products_count",
      "placeholder": "How many products / SKUs do you have?"
    },
    model: {
      value: (_vm.user.products_count),
      callback: function($$v) {
        _vm.$set(_vm.user, "products_count", $$v)
      },
      expression: "user.products_count"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.annual_income_options,
      "item-value": "id",
      "item-text": "name",
      "name": "annual_income",
      "placeholder": "Annual income"
    },
    model: {
      value: (_vm.user.annual_income),
      callback: function($$v) {
        _vm.$set(_vm.user, "annual_income", $$v)
      },
      expression: "user.annual_income"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.boolean_options,
      "item-value": "id",
      "item-text": "name",
      "name": "is_business_registered",
      "placeholder": "Is your business registered?"
    },
    model: {
      value: (_vm.user.is_business_registered),
      callback: function($$v) {
        _vm.$set(_vm.user, "is_business_registered", $$v)
      },
      expression: "user.is_business_registered"
    }
  })], 1)] : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.website_1_url),
      expression: "user.website_1_url"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:1023|url'),
      expression: "'required|max:1023|url'"
    }],
    attrs: {
      "type": "text",
      "name": "website_1_url",
      "autocomplete": "off",
      "placeholder": "Website URL"
    },
    domProps: {
      "value": (_vm.user.website_1_url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "website_1_url", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.website_2_url),
      expression: "user.website_2_url"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:1023|url'),
      expression: "'max:1023|url'"
    }],
    attrs: {
      "type": "text",
      "name": "website_2_url",
      "autocomplete": "off",
      "placeholder": "Website URL"
    },
    domProps: {
      "value": (_vm.user.website_2_url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "website_2_url", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.history),
      expression: "user.history"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:1023'),
      expression: "'required|max:1023'"
    }],
    attrs: {
      "name": "history",
      "placeholder": "What artists and/or labels have you previously worked with?"
    },
    domProps: {
      "value": (_vm.user.history)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "history", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('p', [_vm._v("\n              All of the information you share with us is secure, never sold & used to verify users."), _c('br'), _vm._v("\n              You agree to our terms of services by signing up.\n              "), _c('router-link', {
    staticClass: "forgot-password",
    attrs: {
      "to": "/terms",
      "target": "_blank"
    }
  }, [_vm._v("View our terms.")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "reset-btn",
    attrs: {
      "block": "",
      "round": "",
      "dark": "",
      "type": "submit"
    }
  }, [_vm._v("Next")])], 1)], 2)], 1)]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 1760 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-section"
  }, [_vm._v("Success")])
},staticRenderFns: []}

/***/ }),
/* 1761 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video-page index-page"
  }, [(!_vm.isComp && !_vm.onMobile) ? _c('discover-nav', {
    attrs: {
      "pageName": "video",
      "searchShow": this.$store.state.app.sideBarMini
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isPageReady) ? _c('div', {
    staticClass: "page",
    class: {
      isComp: _vm.isComp
    }
  }, [_c('div', {
    staticClass: "page-content"
  }, [(_vm.viewAllVideos) ? _c('v-container', {
    staticClass: "px-0"
  }, [_c('div', {
    staticClass: "mx-5"
  }, [_c('div', {
    staticClass: "dflex justify-space-between align-center"
  }, [_c('content-top-header', {
    staticClass: "__inner mt-3",
    attrs: {
      "absolute": ""
    }
  }, [_c('template', {
    slot: "topHeader"
  }, [_c('ul', {
    staticClass: "width100 trending-topbar"
  }, [_vm._l((_vm.tabs), function(tab, index) {
    return _c('li', {
      key: index
    }, [_c('label', {
      class: (tab.title === _vm.selectedVideoCategoryName) ? 'active' : '',
      on: {
        "click": function($event) {
          _vm.displayAllVideos(tab.title)
        }
      }
    }, [_vm._v(_vm._s(tab.title))])])
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('li', [_c('v-btn', {
    staticClass: "btn-genre-selector",
    attrs: {
      "dark": "",
      "rounded": ""
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tCategories: All\n\t\t\t\t\t\t\t\t")])], 1)], 2)])], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "video-trending-page",
    on: {
      "scroll": _vm.handleScroll
    }
  }, [(!_vm.hideOtherVideos) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "id": "new-video-album-container"
    }
  }, _vm._l((_vm.videos), function(video) {
    return _c('v-flex', {
      key: video.name,
      staticClass: "video-container",
      class: [!_vm.isComp ? 'video-container top-3 xs12 sm3 mb-5 custom-lg5' : 'pl-0 xs4', {
        side_fullwidth: _vm.onMobile
      }]
    }, [_c('video-box', {
      staticClass: "_sliced-top",
      attrs: {
        "hoverOverlay": false,
        "item": video
      }
    })], 1)
  })) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticClass: "text-xs-center"
  }, [(_vm.isPageReady) ? _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pagination.current_page < _vm.pagination.total_pages),
      expression: "pagination.current_page < pagination.total_pages"
    }],
    staticClass: "loadmore-btn",
    nativeOn: {
      "click": function($event) {
        _vm.loadMore()
      }
    }
  }, [_vm._v("Load More")]) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "dialog-w_auto dialog-no_shadow"
    },
    model: {
      value: (_vm.show_modalCard1),
      callback: function($$v) {
        _vm.show_modalCard1 = $$v
      },
      expression: "show_modalCard1"
    }
  }, [_c('div', {
    staticClass: "modal-card"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": __webpack_require__(19),
      "width": "135px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-card-img"
  }, [_c('div', {
    staticClass: "modal-card-img-inner",
    style: ({
      'background-image': 'url(' + this.selectedVideo.user.avatar.thumb.url + ')',
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center user-box"
  }, [_c('p', [_vm._v("Sign up to experience")]), _vm._v(" "), _c('div', {
    staticClass: "user-div"
  }, [_c('p', {
    staticClass: "user-text"
  }, [_vm._v(" " + _vm._s(this.selectedVideo.user.username))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(23),
      "width": "15px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "button-wrapper"
  }, [_c('router-link', {
    attrs: {
      "to": "/signup"
    }
  }, [_c('button', {
    staticClass: "modal-button"
  }, [_vm._v("\n\t\t\t\t\t\t\tCreate account\n\t\t\t\t\t\t")])])], 1)])]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "dialog-w_auto dialog-no_shadow"
    },
    model: {
      value: (_vm.show_modalCard2),
      callback: function($$v) {
        _vm.show_modalCard2 = $$v
      },
      expression: "show_modalCard2"
    }
  }, [_c('div', {
    staticClass: "modal-card"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": __webpack_require__(19),
      "width": "135px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-card-img"
  }, [_c('div', {
    staticClass: "modal-card-img-inner",
    style: (("background-image: url(" + _vm.bgDemoImg + ")"))
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center user-box"
  }, [_c('p', [_vm._v("Sign up to experience")]), _vm._v(" "), _c('div', {
    staticClass: "user-div"
  }, [_c('p', {
    staticClass: "user-text"
  }, [_vm._v(" " + _vm._s(this.selectedVideo.user.username))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(23),
      "width": "15px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "text-center font-inter"
  }, [_c('p', [_vm._v("Get full access. "), _c('b', [_vm._v("50%")]), _vm._v(" of your subscription is shared with creators you stream most. See who you support!")])]), _vm._v(" "), _c('div', {
    staticClass: "button-wrapper"
  }, [_c('router-link', {
    attrs: {
      "to": "/settings"
    }
  }, [_c('button', {
    staticClass: "modal-button"
  }, [_vm._v("\n\t\t\t\t\t\t\tStart 30 day free trial\n\t\t\t\t\t\t")])])], 1)])]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "dialog-w_50 dialog-no_shadow"
    },
    model: {
      value: (_vm.show_modalCard3),
      callback: function($$v) {
        _vm.show_modalCard3 = $$v
      },
      expression: "show_modalCard3"
    }
  }, [_c('div', {
    staticClass: "modal-card-main"
  }, [_c('div', {
    staticClass: "modal-card-split"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": __webpack_require__(19),
      "width": "135px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-card-img"
  }, [_c('div', {
    staticClass: "modal-card-img-inner",
    style: ({
      'background-image': 'url(' + this.selectedVideo.user.avatar.thumb.url + ')',
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "user-box"
  }, [_c('p', [_vm._v("Sign up to experience")]), _vm._v(" "), _c('div', {
    staticClass: "user-div"
  }, [_c('p', {
    staticClass: "user-text"
  }, [_vm._v(_vm._s(this.selectedVideo.user.username))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(23),
      "width": "15px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "button-wrapper"
  }, [_c('router-link', {
    attrs: {
      "to": "/signup"
    }
  }, [_c('button', {
    staticClass: "modal-button"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tCreate account\n\t\t\t\t\t\t\t")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-card-title-img",
    style: (("background-image: url(" + _vm.videoLoading + ")"))
  }, [_c('video', {
    attrs: {
      "playsinline": "",
      "autoplay": "",
      "loop": "",
      "id": "bgvid"
    }
  }, [(_vm.spotlightVideoSource) ? _c('source', {
    attrs: {
      "src": ("https://stream.mux.com/" + _vm.spotlightVideoSource + "/low.mp4"),
      "type": "video/mp4"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "volume-button"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(43),
      "width": "17px"
    }
  })])])])]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "dialog-w_50 dialog-no_shadow"
    },
    model: {
      value: (_vm.show_modalCard4),
      callback: function($$v) {
        _vm.show_modalCard4 = $$v
      },
      expression: "show_modalCard4"
    }
  }, [_c('div', {
    staticClass: "modal-card-main"
  }, [_c('div', {
    staticClass: "modal-card-split"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": __webpack_require__(19),
      "width": "135px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-card-img"
  }, [_c('div', {
    staticClass: "modal-card-img-inner",
    style: ({
      'background-image': 'url(' + this.selectedVideo.user.avatar.thumb.url + ')',
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "user-box"
  }, [_c('p', [_vm._v("Sign up to experience")]), _vm._v(" "), _c('div', {
    staticClass: "user-div"
  }, [_c('p', {
    staticClass: "user-text"
  }, [_vm._v(_vm._s(this.selectedVideo.user.username))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(23),
      "width": "15px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "font-inter"
  }, [_c('p', [_vm._v("Get full access. "), _c('b', [_vm._v("50%")]), _vm._v(" of your subscription is shared with creators you stream most. See who you support!")])]), _vm._v(" "), _c('div', {
    staticClass: "button-wrapper"
  }, [_c('router-link', {
    attrs: {
      "to": "/settings"
    }
  }, [_c('button', {
    staticClass: "modal-button"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tStart 30 day free trial\n\t\t\t\t\t\t\t")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-card-title-img",
    style: (("background-image: url(" + _vm.videoLoading + ")"))
  }, [_c('video', {
    attrs: {
      "playsinline": "",
      "autoplay": "",
      "loop": "",
      "id": "bgvid"
    }
  }, [(_vm.spotlightVideoSource) ? _c('source', {
    attrs: {
      "src": ("https://stream.mux.com/" + _vm.spotlightVideoSource + "/low.mp4"),
      "type": "video/mp4"
    }
  }) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "volume-button"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(43),
      "width": "17px"
    }
  })])])])])], 1) : _c('div', {
    staticClass: "page-loader"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(166),
      "alt": ""
    }
  })])], 1)
},staticRenderFns: []}

/***/ }),
/* 1762 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-section"
  }, [_c('h2', [_vm._v("Trademark Policy")]), _vm._v(" "), _c('p', [_vm._v("\n    Using a trademark without the trademark owner’s permission on the YouSound\n    Services in a manner that may mislead or confuse others about your\n    identity or brand affiliation may violate YouSound’s Trademark Policy.\n  ")]), _vm._v(" "), _c('h3', [_vm._v("How To Report a Violation")]), _vm._v(" "), _c('p', [_vm._v("\n    If you believe there is a trademark violation, you should identify the\n    allegedly infringing work and provide the legal basis for your claim,\n    including the registration and/or application numbers for your trademark.\n    Please send a report to\n    "), _c('a', {
    attrs: {
      "href": "mailto:trademark@yousound.com"
    }
  }, [_vm._v("trademark@yousound.com")]), _vm._v(" that\n    includes the following information:\n  ")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Your contact information (name, email, address, telephone number, website).")]), _vm._v(" "), _c('li', [_vm._v("\n      Confirm whether you are the trademark owner or an agent authorized to\n      act on behalf of the trademark owner.\n    ")]), _vm._v(" "), _c('li', [_vm._v("Identify the trademark.")]), _vm._v(" "), _c('li', [_vm._v("\n      Provide the Registration No. or Application No. associated with your\n      trademark (if applicable).\n    ")]), _vm._v(" "), _c('li', [_vm._v("Specify where the trademark is registered (such as with the USPTO).")]), _vm._v(" "), _c('li', [_vm._v("\n      Describe the goods or services in connection with which you use your\n      trademark.\n    ")]), _vm._v(" "), _c('li', [_vm._v("Describe where you use your trademark.")]), _vm._v(" "), _c('li', [_vm._v("\n      Identify the location of the infringing activity on YouSound (e.g.,\n      provide a link) and describe how it violates your trademark rights.\n    ")])]), _vm._v(" "), _c('p', [_vm._v("\n    Note: YouSound will only investigate reports submitted by a trademark\n    owner or authorized agent.\n  ")]), _vm._v(" "), _c('h3', [_vm._v("How Does YouSound Process Trademark Reports?")]), _vm._v(" "), _c('p', [_vm._v("Upon receipt of a report, YouSound will:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Review the report to ensure that it is complete.")]), _vm._v(" "), _c('li', [_vm._v("\n      Determine if there is a violation of our trademark policy. If action is\n      taken based on a report, we will provide the impacted account holder\n      with your name and the information included in your report so they can\n      respond to the claim.\n    ")]), _vm._v(" "), _c('li', [_vm._v("\n      In certain cases, we may also give the impacted account holder an\n      opportunity to comply with our policies or file an appeal.\n    ")]), _vm._v(" "), _c('li', [_vm._v("\n      Any appeal must include an explanation of their side of the situation,\n      along with any relevant materials for us to review. A successful appeal\n      may result in the restoration of the content or account.\n    ")]), _vm._v(" "), _c('li', [_vm._v("\n      Remember, YouSound has the discretion to make and implement reasonable\n      determinations regarding trademarks used on the YouSound Services.\n    ")]), _vm._v(" "), _c('li', [_vm._v("\n      However, YouSound cannot serve as the arbiter of disputes among third\n      parties. Any further dispute between you and the impacted account holder\n      should be resolved directly between you.\n    ")]), _vm._v(" "), _c('li', [_vm._v("\n      Please note that YouSound may, at its discretion, share a copy of your\n      notice with third parties, including for publication.\n    ")])]), _vm._v(" "), _c('h3', [_vm._v("Don’t Impersonate Others")]), _vm._v(" "), _c('p', [_vm._v("\n    You cannot pretend to be any other person or company. Avoid actions that\n    would cause confusion between you, your community, and a person or\n    company. See our\n    "), _c('a', {
    attrs: {
      "href": "/community-guidelines"
    }
  }, [_vm._v("Community Guidelines")]), _vm._v(" for more\n    information.\n  ")]), _vm._v(" "), _c('h3', [_vm._v("What is Not a Violation of This Policy?")]), _vm._v(" "), _c('p', [_vm._v("\n    A reference to another’s trademark is not an automatic violation. It is\n    permissible for an account holder to use a trademark in a manner that is\n    outside the scope of the trademark owner’s rights. You can use someone’s\n    trademark to refer to their goods or services—just not in a way that\n    confuses other users about whose trademark it is. In legal terms,\n    nominative and other fair uses of trademarks do not violate this policy.\n    However, an account holder that uses a trademark must clearly distinguish\n    itself from the trademark owner.\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    YouSound allows account holders to create parody, commentary, and fan\n    accounts, provided the accounts meet the following requirements:\n  ")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("\n      Include a description on the channel or community page that clarifies\n      that the group or account holder is not affiliated with the trademark\n      owner by using terms such as “parody,” “fan,” “commentary,” “subscribers\n      of,” etc.\n    ")]), _vm._v(" "), _c('li', [_vm._v("\n      Account or community names should not be the exact trademark without\n      additional distinguishing words such as “fan,” “subscriber,”\n      “commentary,” or “players.”\n    ")])])])
}]}

/***/ }),
/* 1763 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('upload-nav', {
    attrs: {
      "name": "upload"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "px-5 pt-5 mt-5 text-poppins-36"
  }, [_vm._v("Upload video")]), _vm._v(" "), (this.currentUser.creator_verified) ? _c('div', {
    staticClass: "page upload-child video-page create-page mx-5"
  }, [(!_vm.currentUser.stripe_connected) ? _c('topbarNotification', {
    attrs: {
      "content": _vm.topBarContent,
      "ctaTitle": "Connect",
      "cta": {
        name: 'ManageIndex',
        params: {
          tab: 'payment'
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "page-content"
  }, [_c('drag-file-uploader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.videoId),
      expression: "!videoId"
    }],
    ref: "dragFileUploader",
    attrs: {
      "accept": "video/*",
      "type": "file",
      "category": "video",
      "autoUpload": true
    },
    on: {
      "filePicked": _vm.pickedFile
    }
  }), _vm._v(" "), (_vm.videoFile || (_vm.videoId && _vm.stream)) ? _c('form', {
    staticClass: "video-info-section mt-4",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit()
      }
    }
  }, [(!_vm.videoId) ? _c('v-layout', {
    staticClass: "video-wrapper",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm5": ""
    }
  }, [_c('div', {
    staticClass: "mb-4 dflex align-center mt-4"
  }, [_c('span', {
    staticClass: "app-bold mr-3 _filename"
  }, [_vm._v(_vm._s(_vm.videoFileName))]), _vm._v(" "), _c('span', {
    staticClass: "red--text app-bold cursor-pointer",
    on: {
      "click": _vm.deleteAttachedVideo
    }
  }, [_vm._v("\n                  delete\n                ")])])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "video-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "dflex gap-15"
  }, [_c('v-flex', {
    attrs: {
      "sm8": ""
    }
  }, [_c('div', {
    staticClass: "dflex gap-15"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label max-char-label"
  }, [_c('span', {
    staticClass: "__title"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("\n                        Video Title\n                      ")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.stream.name),
      expression: "stream.name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control py-0 my-0",
    attrs: {
      "type": "text",
      "name": "title",
      "maxlength": "80"
    },
    domProps: {
      "value": (_vm.stream.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.stream, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), (!_vm.videoId) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label max-char-label"
  }, [_c('span', {
    staticClass: "__title"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("\n                        Category\n                      ")])]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "py-0 my-0",
    attrs: {
      "items": _vm.genres,
      "name": "genre",
      "item-text": "name",
      "item-value": "id"
    },
    model: {
      value: (_vm.stream.genre_id),
      callback: function($$v) {
        _vm.$set(_vm.stream, "genre_id", $$v)
      },
      expression: "stream.genre_id"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label max-char-label"
  }, [_c('span', {
    staticClass: "__title"
  }, [_vm._v(" Description ")])]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.stream.description),
      expression: "stream.description"
    }],
    staticClass: "form-control",
    attrs: {
      "maxlength": "4000"
    },
    domProps: {
      "value": (_vm.stream.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.stream, "description", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (!_vm.videoId) ? _c('v-flex', {
    attrs: {
      "sm4": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_c('span', [_vm._v("Custom video thumbnail")])]), _vm._v(" "), _c('div', {
    staticClass: "video-thumbnail-container"
  }, [_c('div', {
    staticClass: "video-thumbnail-wrapper"
  }, [(_vm.stream_cover_url) ? _c('div', {
    staticClass: "video-thumbnail",
    style: ({
      'background-image': 'url(' + _vm.stream_cover_url + ')',
    })
  }) : _c('div', {
    staticClass: "video-thumbnail"
  }, [_c('div', {
    staticClass: "cover-wrapper allChildrenCenter"
  }, [_c('label', {
    staticClass: "cursor-pointer",
    attrs: {
      "for": "stream_cover_file"
    }
  }, [_c('span', {
    staticClass: "texet-xs-center dflex align-center justify-center flex-column"
  }, [_c('img', {
    attrs: {
      "width": "25",
      "src": "/static/images/ic_camera.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "mt-1"
  }, [_c('b', [_vm._v("upload")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "cover-wrapper"
  }, [_vm._v("\n                      " + _vm._s(_vm.stream_cover_url ? "YES" : "") + "\n                      "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "file",
      "name": "stream_cover_file",
      "id": "stream_cover_file",
      "accept": ".png, .jpg, .jpeg"
    },
    on: {
      "change": function($event) {
        _vm.imageChanged($event)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "stream_cover_file"
    }
  }, [(_vm.stream_cover_url) ? _c('span', {
    staticClass: "app-blue--text"
  }, [_vm._v("Change")]) : _vm._e()])])])])]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "video-wrapper"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "dflex gap-20 mt-4 pb-4 align-end album-info-option"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(2), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "py-0 my-0",
    attrs: {
      "items": _vm.access_levels,
      "name": "genre",
      "item-text": "title",
      "item-value": "id"
    },
    model: {
      value: (_vm.stream.access_level),
      callback: function($$v) {
        _vm.$set(_vm.stream, "access_level", $$v)
      },
      expression: "stream.access_level"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Attach Product/Album")]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('v-select', {
    staticClass: "pt-0",
    attrs: {
      "items": _vm.mergedAttachmentItems,
      "item-text": "name",
      "item-value": "id",
      "placeholder": "Type name to search your products & albums",
      "chips": "",
      "autocomplete": "",
      "clearable": ""
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(data) {
        return [(typeof data.item !== 'object') ? [_c('v-list-tile-content', {
          domProps: {
            "textContent": _vm._s(data.item)
          }
        })] : [_c('div', {
          staticClass: "dflex width100 align-centermy-3",
          on: {
            "click": function($event) {
              _vm.chooseAssoc(data.item)
            }
          }
        }, [_c('v-list-tile-avatar', [(data.item.album_type) ? _c('img', {
          attrs: {
            "src": data.item.cover.url
          }
        }) : _c('img', {
          attrs: {
            "src": data.item.covers[0].cover.url
          }
        })]), _vm._v(" "), _c('v-list-tile-content', {
          staticClass: "py-3"
        }, [_c('v-list-tile-title', {
          domProps: {
            "innerHTML": _vm._s(data.item.name)
          }
        })], 1)], 1)]]
      }
    }]),
    model: {
      value: (_vm.selectedStream),
      callback: function($$v) {
        _vm.selectedStream = $$v
      },
      expression: "selectedStream"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "submit-section pt-4"
  }, [_c('v-btn', {
    staticClass: "release-now-btn white--text mb-5",
    staticStyle: {
      "background-color": "#394dff !important"
    },
    attrs: {
      "round": "",
      "flat": "",
      "loading": _vm.loading,
      "type": "submit",
      "disabled": _vm.submitLoading
    }
  }, [_vm._v("\n              " + _vm._s(_vm.videoId ? "Update" : "Release") + "\n            ")])], 1)], 1) : _vm._e()], 1)]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "my-dialog-2"
    },
    model: {
      value: (_vm.show_help_dialog),
      callback: function($$v) {
        _vm.show_help_dialog = $$v
      },
      expression: "show_help_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('v-card-media', {
    attrs: {
      "src": "/static/images/post1.jpg",
      "contain": ""
    }
  }), _vm._v(" "), _c('label', [_vm._v("Live Video")])], 1), _vm._v(" "), _c('v-card-text', [_c('ul', [_c('li', [_vm._v("\n              Attach albums & products to live video to "), _c('br'), _vm._v("let user\n              "), _c('b', [_vm._v("download")]), _vm._v(" or "), _c('b', [_vm._v("add to cart")]), _vm._v(" while viewing.\n            ")]), _vm._v(" "), _c('li', [_vm._v("Make albums & products "), _c('b', [_vm._v("exclusive")]), _vm._v(" on broadcast.")]), _vm._v(" "), _c('li', [_vm._v("\n              Let users view for "), _c('b', [_vm._v("Free")]), _vm._v(" or\n              "), _c('b', [_vm._v("Pay Per View")]), _vm._v("."), _c('br'), _vm._v("Charge up to $10,000 per user.\n            ")]), _vm._v(" "), _c('li', [_c('b', [_vm._v("Limit")]), _vm._v(" the amount of viewers on your broadcast.")]), _vm._v(" "), _c('li', [_vm._v("Add users to your "), _c('b', [_vm._v("Guest List")]), _vm._v(" to watch for free.")])])]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    staticClass: "px-4",
    attrs: {
      "dark": "",
      "round": "",
      "color": "blue"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeHelpDialog()
      }
    }
  }, [_vm._v("Ok, Got it!")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "my-dailog-1",
      "persistent": ""
    },
    model: {
      value: (_vm.show_stripe_connect_dialog),
      callback: function($$v) {
        _vm.show_stripe_connect_dialog = $$v
      },
      expression: "show_stripe_connect_dialog"
    }
  }, [_c('v-card', [_c('v-card-text', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Stripe Connect")]), _vm._v(" "), _c('div', [_vm._v("You have to connect stripe in setting page.")])]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "px-4",
    attrs: {
      "dark": "",
      "round": "",
      "color": "blue"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeStripeConnectDialog()
      }
    }
  }, [_vm._v("Ok, Got it!")]), _vm._v(" "), _c('v-spacer')], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "stream-collaborators-dialog",
      "persistent": ""
    },
    model: {
      value: (_vm.show_collaborators_dialog),
      callback: function($$v) {
        _vm.show_collaborators_dialog = $$v
      },
      expression: "show_collaborators_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("\n            Collaborators Pay Per View Split\n          ")])]), _vm._v(" "), _c('v-card-text', [_c('div', [_c('div', [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "pt-0",
    attrs: {
      "items": _vm.view_prices,
      "item-text": "name",
      "item-value": "id"
    },
    model: {
      value: (_vm.stream.view_price),
      callback: function($$v) {
        _vm.$set(_vm.stream, "view_price", $$v)
      },
      expression: "stream.view_price"
    }
  })], 1), _vm._v(" "), (_vm.stream.view_price > 0 && _vm.stream.collaborators.length < 3) ? _c('div', [_c('v-btn', {
    staticClass: "add-option-btn ma-0",
    nativeOn: {
      "click": function($event) {
        _vm.addCollaborator()
      }
    }
  }, [_c('v-icon', [_vm._v("add")]), _vm._v(" Add another collaborator\n              ")], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.stream.collaborators && _vm.stream.collaborators.length > 0) ? _c('v-layout', {
    attrs: {
      "row": "",
      "creator-wrapper": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Creator"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('label', {
    staticClass: "creator-name"
  }, [_vm._v(_vm._s(_vm.currentUser.username))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm3": ""
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Profit Share"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('label', {
    staticClass: "creator-share"
  }, [_vm._v(_vm._s(_vm.creator_share))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm3": ""
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Recoup Cost")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.stream.creator_recoup_cost),
      expression: "stream.creator_recoup_cost"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.stream.creator_recoup_cost)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.stream, "creator_recoup_cost", $event.target.value)
      }
    }
  })])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.stream.collaborators), function(collaborator, index) {
    return _c('v-layout', {
      key: index,
      attrs: {
        "row": "",
        "collaborator-wrapper": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "sm6": ""
      }
    }, [_c('label', {
      staticClass: "control-label"
    }, [_vm._v("Collaborators"), _c('span', {
      staticClass: "required"
    }, [_vm._v("*")])]), _vm._v(" "), _c('v-select', {
      staticClass: "pt-0",
      attrs: {
        "items": _vm.users,
        "item-text": "username",
        "item-value": "id",
        "chips": "",
        "autocomplete": "",
        "no-data-text": "No collaborator available",
        "clearable": ""
      },
      scopedSlots: _vm._u([{
        key: "selection",
        fn: function(data) {
          return [_c('v-chip', {
            key: JSON.stringify(data.item),
            staticClass: "chip--select-multi",
            attrs: {
              "selected": data.selected
            },
            on: {
              "input": function($event) {
                data.parent.selectItem(data.item)
              }
            }
          }, [_c('v-avatar', [_c('img', {
            attrs: {
              "src": data.item.avatar.thumb.url
            }
          })]), _vm._v("\n                      " + _vm._s(data.item.username) + "\n                    ")], 1)]
        }
      }, {
        key: "item",
        fn: function(data) {
          return [(typeof data.item !== 'object') ? [_c('v-list-tile-content', {
            domProps: {
              "textContent": _vm._s(data.item)
            }
          })] : [_c('v-list-tile-avatar', [_c('img', {
            attrs: {
              "src": data.item.avatar.thumb.url
            }
          })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
            domProps: {
              "innerHTML": _vm._s(data.item.username)
            }
          })], 1)]]
        }
      }]),
      model: {
        value: (collaborator.user_id),
        callback: function($$v) {
          _vm.$set(collaborator, "user_id", $$v)
        },
        expression: "collaborator.user_id"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm6": ""
      }
    }, [_c('label', {
      staticClass: "control-label"
    }, [_vm._v("Profit Share"), _c('span', {
      staticClass: "required"
    }, [_vm._v("*")])]), _vm._v(" "), _c('v-select', {
      staticClass: "pt-0",
      attrs: {
        "items": _vm.profit_share_types,
        "item-text": "name",
        "item-value": "id",
        "autocomplete": ""
      },
      model: {
        value: (collaborator.user_share),
        callback: function($$v) {
          _vm.$set(collaborator, "user_share", $$v)
        },
        expression: "collaborator.user_share"
      }
    })], 1), _vm._v(" "), _c('v-icon', {
      staticClass: "clear-btn",
      on: {
        "click": function($event) {
          _vm.deleteCollaborator(index)
        }
      }
    }, [_vm._v("clear")])], 1)
  })], 2)]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "px-4",
    attrs: {
      "dark": "",
      "round": "",
      "color": "blue"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeCollaboratorsDialog()
      }
    }
  }, [_vm._v("OK")]), _vm._v(" "), _c('v-spacer')], 1)], 1)], 1), _vm._v(" "), (_vm.show_payment_dialog) ? _c('payment-modal', {
    attrs: {
      "amount": _vm.streamCost,
      "dismiss": _vm.closePaymentDialog,
      "finish": _vm.deposit
    }
  }) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt-5 pt-4"
  }, [_c('h4', {
    staticClass: "album-info-title"
  }, [_vm._v("Info")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt-5 pt-4"
  }, [_c('h4', {
    staticClass: "album-info-title"
  }, [_vm._v("Options")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "control-label max-char-label"
  }, [_c('span', {
    staticClass: "__title"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("\n                    Content Acceess\n                  ")])])
}]}

/***/ }),
/* 1764 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page video-page manage-page mx-5"
  }, [(_vm.isPageReady) ? _c('content-top-header', [_c('template', {
    slot: "topHeader"
  }, [_c('ul', {
    staticClass: "width100"
  }, [_vm._l((_vm.tabs), function(tab) {
    return _c('li', {
      key: tab.id,
      class: {
        active: tab.id == _vm.active_tab
      },
      attrs: {
        "href": ("#" + (tab.id))
      }
    }, [_c('label', {
      on: {
        "click": function($event) {
          _vm.onTab(tab.id)
        }
      }
    }, [_vm._v(_vm._s(tab.title))])])
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('li', {
    staticClass: "mr-0"
  }, [_c('v-btn', {
    staticClass: "cancel-btn",
    attrs: {
      "depressed": "",
      "color": "theme--dark red"
    },
    nativeOn: {
      "click": function($event) {
        _vm.openStreamDeleteConfirmDialog()
      }
    }
  }, [_vm._v("Stop")])], 1), _vm._v(" "), _c('li', {
    staticClass: "mr-0"
  }, [(_vm.show_view_stream_button) ? _c('v-btn', {
    staticClass: "view-btn",
    attrs: {
      "depressed": "",
      "dark": "",
      "color": "green"
    },
    nativeOn: {
      "click": function($event) {
        _vm.viewStream()
      }
    }
  }, [_vm._v("Watch / Chat")]) : _c('v-btn', {
    staticClass: "px-4 view-btn",
    attrs: {
      "depressed": "",
      "color": "grey lighten-2"
    }
  }, [_vm._v("Connecting...")])], 1), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-right": "-23px"
    }
  }, [_c('v-btn', {
    staticClass: "view-btn",
    attrs: {
      "depressed": "",
      "dark": "",
      "color": "blue"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.openAddMoreTimeDialog()
      }
    }
  }, [_vm._v("Add Time")])], 1)], 2)])], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [(_vm.isPageReady) ? _c('div', {
    staticClass: "page-content"
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-lg": "",
      "px-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    staticClass: "app-bold mb-2"
  }, [_vm._v("Setup Live Broadcast")]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-info stream-info"
  }, [_c('div', {
    staticClass: "divide"
  }, [_vm._v("\n                Add the "), _c('b', [_vm._v("URL")]), _vm._v(" and "), _c('b', [_vm._v("Stream Key")]), _vm._v(" to your video\n                broadcast Software’s "), _c('b', [_vm._v("Stream Settings")])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("URL: " + _vm._s(_vm.streamUrl)), _c('v-btn', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.streamUrl),
      expression: "streamUrl",
      arg: "copy"
    }],
    staticClass: "clipboard-btn"
  }, [_c('v-icon', [_vm._v("fa-clipboard")])], 1)], 1)]), _vm._v(" "), _c('div', [_c('label', [_vm._v("\n                  Stream Key: " + _vm._s(_vm.streamKey) + "\n                  "), _c('v-btn', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.streamKey),
      expression: "streamKey",
      arg: "copy"
    }],
    staticClass: "clipboard-btn"
  }, [_c('v-icon', [_vm._v("fa-clipboard")])], 1)], 1)])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm6": ""
    }
  }, [_c('div', {
    staticClass: "app-bold mb-2"
  }, [_vm._v("Analytics")]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-info time-info"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "custom-lg5"
  }, [_c('label', [_vm._v("Broadcast time")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("timeInHours")(_vm.broadcastSeconds)))])]), _vm._v(" "), _c('v-flex', {
    staticClass: "custom-lg5"
  }, [_c('label', [_vm._v("Watching now")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.active_viewers))])]), _vm._v(" "), _c('v-flex', {
    staticClass: "custom-lg5"
  }, [_c('label', [_vm._v("Total viewers")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.total_viewers))])]), _vm._v(" "), _c('v-flex', {
    staticClass: "custom-lg5"
  }, [_c('label', [_vm._v("Repost")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(0))])]), _vm._v(" "), _c('v-flex', {
    staticClass: "custom-lg5"
  }, [_c('label', [_vm._v("Shares")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(0))])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('v-flex', {
    staticClass: "custom-lg5"
  }, [_c('label', [_vm._v("Donations")]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(0))])]), _vm._v(" "), _c('v-flex', {
    staticClass: "custom-lg5"
  }, [_c('label', [_vm._v("PPV Sales")]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(0))])]), _vm._v(" "), _c('v-flex', {
    staticClass: "custom-lg5"
  }, [_c('label', [_vm._v("Follows")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(0))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('label', [_vm._v("Attachment Views")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(0))])])], 1)], 1)])], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-xs": "",
      "px-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "mt-3": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm12": ""
    }
  }, [_c('div', {
    staticClass: "app-bold mb-2"
  }, [_vm._v("Broadcast Info")]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-info detail-info pa-3 mr-3"
  }, [_c('div', {
    staticClass: "detail-info-top"
  }, [_c('div', {
    staticClass: "mr-3"
  }, [_c('b', [_vm._v("Details")])]), _vm._v(" "), _c('div', {
    staticClass: "cursor-pointer",
    on: {
      "click": function($event) {
        _vm.editStreamDetailsActive = true
      }
    }
  }, [_vm._v("Edit")])]), _vm._v(" "), (_vm.stream) ? _c('div', {
    staticClass: "stream-details"
  }, [_c('div', {
    staticClass: "stream-bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "stream-info"
  }, [_c('h3', [_vm._v(_vm._s(_vm.stream.name))]), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [(_vm.stream.genre) ? _c('div', {
    staticClass: "mr-3"
  }, [_c('span', {
    staticClass: "meta-title"
  }, [_vm._v("Genre:")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.stream.genre.name))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mr-3"
  }, [_c('span', {
    staticClass: "meta-title"
  }, [_vm._v("Cost:")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.stream.view_price))])]), _vm._v(" "), _c('div', {
    staticClass: "mr-3"
  }, [_c('span', {
    staticClass: "meta-title"
  }, [_vm._v("Capacity:")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.stream.viewers_limit))])])]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.stream.description))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "divide"
  }), _vm._v(" "), _c('div', {
    staticClass: "feature-info"
  }, [_c('div', {
    staticClass: "feature-info-top"
  }, [_c('div', {
    staticClass: "mr-3"
  }, [_c('b', [_vm._v("Feature Profiles")])]), _vm._v(" "), _c('div', {
    staticClass: "cursor-pointer",
    on: {
      "click": function($event) {
        _vm.add_account_active = true
      }
    }
  }, [_vm._v("Add Profile")])]), _vm._v(" "), _c('div', {
    staticClass: "featured-users"
  }, [(_vm.featuredUsers) ? _c('div', _vm._l((_vm.featuredUsers), function(u, i) {
    return _c('v-chip', {
      key: i
    }, [_c('span', {
      staticClass: "remove-acc",
      on: {
        "click": function($event) {
          _vm.removeAccount(u)
        }
      }
    }, [_c('v-icon', {
      staticClass: "mr-1",
      attrs: {
        "color": "white"
      }
    }, [_vm._v("close")]), _vm._v(" "), _c('span', [_vm._v("Remove")])], 1), _vm._v(" "), _c('user-tag', {
      staticClass: "tag",
      attrs: {
        "showAvatar": "",
        "clickUser": false,
        "user": u
      }
    })], 1)
  })) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "divide"
  }), _vm._v(" "), _c('div', {
    staticClass: "attachment-details"
  }, [_c('div', {
    staticClass: "attachment-info-top"
  }, [_c('div', {
    staticClass: "mr-3"
  }, [_c('b', [_vm._v("Attachment")])]), _vm._v(" "), (_vm.assoc) ? _c('div', {
    staticClass: "cursor-pointer mr-3",
    on: {
      "click": _vm.changeStreamAttach
    }
  }, [_vm._v("Change")]) : _vm._e(), _vm._v(" "), (_vm.assoc) ? _c('div', {
    staticClass: "cursor-pointer red--text",
    on: {
      "click": _vm.removeStreamAttach
    }
  }, [_vm._v("Remove")]) : _vm._e(), _vm._v(" "), (!_vm.assoc) ? _c('div', {
    staticClass: "cursor-pointer",
    on: {
      "click": _vm.addStreamAttach
    }
  }, [_vm._v("Add")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "dflex"
  }, [_c('attach', {
    ref: "streamAttach",
    staticClass: "mr-3",
    attrs: {
      "hideMetaActions": ""
    },
    on: {
      "input": function($event) {
        _vm.saveAttach()
      }
    },
    model: {
      value: (_vm.stream_assoc),
      callback: function($$v) {
        _vm.stream_assoc = $$v
      },
      expression: "stream_assoc"
    }
  }), _vm._v(" "), (_vm.stream) ? _c('div', {
    staticClass: "attachment-info"
  }, [_c('h3', [_vm._v(_vm._s(_vm.stream_assoc.name))]), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "mr-3"
  }, [(_vm.stream.assoc_type === 'Album') ? _c('span', {
    staticClass: "meta-title"
  }, [_vm._v("\n                        " + _vm._s(_vm.stream_assoc.tracks.length) + " " + _vm._s(("" + (_vm.stream_assoc.tracks.length > 1 ? 'Tracks' : 'Track'))) + "\n                      ")]) : _vm._e()])])]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "divide"
  }), _vm._v(" "), _c('div', {
    staticClass: "share-social-info"
  }, [_c('div', {
    staticClass: "share-social-info-top"
  }, [_c('div', {
    staticClass: "mr-3"
  }, [_c('b', [_vm._v("Share")])])]), _vm._v(" "), _c('div', {
    staticClass: "dflex"
  }, [_c('social-sharing', {
    attrs: {
      "title": ((_vm.currentUser.username) + " is Broadcasting Live!"),
      "url": _vm.profileUrl
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', {
            staticClass: "share-social-section"
          }, [_c('network', {
            attrs: {
              "network": "facebook"
            }
          }, [_c('v-btn', {
            staticClass: "social-share-btn",
            attrs: {
              "depressed": ""
            }
          }, [_c('v-icon', [_vm._v("fa-facebook")])], 1)], 1), _vm._v(" "), _c('network', {
            attrs: {
              "network": "twitter"
            }
          }, [_c('v-btn', {
            staticClass: "social-share-btn"
          }, [_c('v-icon', [_vm._v("fa-twitter")])], 1)], 1)], 1)
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-section"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profileUrl),
      expression: "profileUrl"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.profileUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profileUrl = $event.target.value
      }
    }
  }), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.profileUrl),
      expression: "profileUrl",
      arg: "copy"
    }],
    staticClass: "clipboard-btn"
  }, [_c('v-icon', [_vm._v("fa-clipboard")])], 1)], 1)], 1)])])])])], 1)], 1), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.show_stream_delete_confirm_dialog),
      callback: function($$v) {
        _vm.show_stream_delete_confirm_dialog = $$v
      },
      expression: "show_stream_delete_confirm_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Delete a Stream")]), _vm._v(" "), _c('v-card-text', [_vm._v("If you click OK, the stream will no longer be available. Click OK\n            to delete, or click Cancel.")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "red--text darken-1",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.deleteStream()
      }
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeStreamDeleteConfirmDialog()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-spacer')], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.show_create_failed_dialog),
      callback: function($$v) {
        _vm.show_create_failed_dialog = $$v
      },
      expression: "show_create_failed_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Failed in Creating a Stream")]), _vm._v(" "), _c('v-card-text', [_vm._v("Channel failed to start, you have not been charged. Please try\n            again.")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "red--text darken-1",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeCreateFailedDialog()
      }
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('v-spacer')], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    directives: [{
      name: "on-click-outside",
      rawName: "v-on-click-outside",
      value: (_vm.closeAddMoreTimeDialog),
      expression: "closeAddMoreTimeDialog"
    }],
    attrs: {
      "content-class": "add-more-time-dialog"
    },
    model: {
      value: (_vm.show_add_more_time_dialog),
      callback: function($$v) {
        _vm.show_add_more_time_dialog = $$v
      },
      expression: "show_add_more_time_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Add more time to your broadcast")]), _vm._v(" "), _c('v-card-text', [_c('v-select', {
    staticClass: "pt-0",
    attrs: {
      "items": _vm.costs,
      "item-text": "name",
      "item-value": "value"
    },
    model: {
      value: (_vm.streamCost),
      callback: function($$v) {
        _vm.streamCost = $$v
      },
      expression: "streamCost"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "dark": "",
      "round": "",
      "color": "blue"
    },
    nativeOn: {
      "click": function($event) {
        _vm.openPaymentDialog()
      }
    }
  }, [_vm._v("Add More Time")]), _vm._v(" "), _c('v-spacer')], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "add-more-time-caution-dialog"
    },
    model: {
      value: (_vm.show_add_more_time_caution_dialog),
      callback: function($$v) {
        _vm.show_add_more_time_caution_dialog = $$v
      },
      expression: "show_add_more_time_caution_dialog"
    }
  }, [_c('v-card', {
    staticClass: "pa-4"
  }, [_c('v-card-text', [_vm._v("\n            You have about"), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.remainingTime))]), _c('br'), _vm._v("\n            remaining before your broadcast ends."), _c('br'), _vm._v("\n            Add more time to continue broadcasting.\n          ")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "px-4",
    attrs: {
      "dark": "",
      "round": "",
      "color": "blue"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeAddMoreTimeCautionDialog()
      }
    }
  }, [_vm._v("\n              Close")]), _vm._v(" "), _c('v-spacer')], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "edit-stream-details-dialog"
    },
    model: {
      value: (_vm.edit_stream_details_active),
      callback: function($$v) {
        _vm.edit_stream_details_active = $$v
      },
      expression: "edit_stream_details_active"
    }
  }, [_c('v-card', {
    staticClass: "pa-4"
  }, [_c('v-card-text', [_c('v-container', {
    attrs: {
      "grid-list-lg": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Pay Per View?")]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "pt-0",
    attrs: {
      "items": _vm.view_prices,
      "item-text": "name",
      "item-value": "id"
    },
    model: {
      value: (_vm.stream.view_price),
      callback: function($$v) {
        _vm.$set(_vm.stream, "view_price", $$v)
      },
      expression: "stream.view_price"
    }
  })], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Event Capacity")]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "pt-0",
    attrs: {
      "items": _vm.viewers_limits,
      "item-text": "name",
      "item-value": "id"
    },
    model: {
      value: (_vm.stream.viewers_limit),
      callback: function($$v) {
        _vm.$set(_vm.stream, "viewers_limit", $$v)
      },
      expression: "stream.viewers_limit"
    }
  })], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Description"), _c('span', {
    staticClass: "ml-1 meta-annotate"
  }, [_vm._v("160 char max")])]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.stream.description),
      expression: "stream.description"
    }],
    staticClass: "form-control",
    attrs: {
      "maxlength": "160"
    },
    domProps: {
      "value": (_vm.stream.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.stream, "description", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Thumbnail")]), _vm._v(" "), _c('div', {
    staticClass: "video-thumbnail-container"
  }, [_c('div', {
    staticClass: "video-thumbnail-wrapper"
  }, [(_vm.stream_cover_url) ? _c('div', {
    staticClass: "video-thumbnail",
    style: ({
      'background-image': 'url(' + _vm.stream.cover.thumb.url || _vm.stream.cover + ')',
    })
  }) : _c('div', {
    staticClass: "video-thumbnail"
  })]), _vm._v(" "), _c('div', {
    staticClass: "cover-wrapper"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "file",
      "name": "stream_cover_file",
      "id": "stream_cover_file",
      "accept": ".png, .jpg, .jpeg"
    },
    on: {
      "change": function($event) {
        _vm.imageChanged($event)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "stream_cover_file"
    }
  }, [_vm._v("Upload")]), _vm._v(" "), _c('span', {
    staticClass: "meta-annotate"
  }, [_vm._v("*PNG, JPG, GIF")])])])])])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('div', {
    staticClass: "text-center width100"
  }, [_c('v-btn', {
    staticClass: "px-4",
    attrs: {
      "dark": "",
      "round": "",
      "color": "blue",
      "loading": _vm.saveDetailsLoader
    },
    nativeOn: {
      "click": function($event) {
        _vm.saveStreamDetails()
      }
    }
  }, [_vm._v("Save")])], 1)])], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "add-users-dialog"
    },
    model: {
      value: (_vm.add_account_active),
      callback: function($$v) {
        _vm.add_account_active = $$v
      },
      expression: "add_account_active"
    }
  }, [_c('v-card', {
    staticClass: "pa-4"
  }, [_c('v-card-text', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search_user),
      expression: "search_user"
    }],
    staticClass: "width100 mb-3 pa-2",
    attrs: {
      "type": "text",
      "placeholder": "Search User"
    },
    domProps: {
      "value": (_vm.search_user)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search_user = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "search_user-results featured-users"
  }, _vm._l((_vm.users), function(u, i) {
    return _c('v-chip', {
      key: i
    }, [_c('span', {
      staticClass: "add-acc __acc",
      on: {
        "click": function($event) {
          _vm.addAccount(u)
        }
      }
    }, [_c('v-icon', {
      staticClass: "mr-1",
      attrs: {
        "color": "white"
      }
    }, [_vm._v("add")])], 1), _vm._v(" "), _c('user-tag', {
      staticClass: "tag",
      attrs: {
        "showAvatar": "",
        "clickUser": false,
        "user": u
      }
    })], 1)
  })), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('v-btn', {
    staticClass: "px-4 mt-3",
    attrs: {
      "dark": "",
      "round": "",
      "color": "blue",
      "loading": _vm.searchUserLoader
    },
    nativeOn: {
      "click": function($event) {
        _vm.updateUsersList()
      }
    }
  }, [_vm._v("Add")])], 1)])], 1)], 1), _vm._v(" "), (_vm.show_payment_dialog) ? _c('payment-modal', {
    attrs: {
      "amount": _vm.streamCost,
      "dismiss": _vm.closePaymentDialog,
      "finish": _vm.deposit
    }
  }) : _vm._e()], 1) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 1765 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$vuetify.breakpoint.width <= 768) ? _c('div', {
    staticClass: "QR-page"
  }, [_c('img', {
    staticClass: "ys-logo",
    attrs: {
      "src": "/static/images/landing-page/ys_logo_primary-black.svg"
    }
  }), _vm._v(" "), (this.default && !this.ios && !this.android) ? _c('div', {
    staticClass: "title"
  }, [_vm._v("Download the app "), _c('br'), _vm._v(" to create your account")]) : _vm._e(), _vm._v(" "), (this.default && !this.ios && !this.android) ? _c('div', {
    staticClass: "options"
  }, [_c('div', {
    staticClass: "app-icon-container"
  }, [_c('img', {
    staticClass: "cursor-pointer",
    attrs: {
      "src": "/static/images/landing-page/apple-store.svg",
      "aspect-ratio": "1",
      "height": "84",
      "width": "187"
    },
    on: {
      "click": function($event) {
        _vm.showQR('ios')
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "app-icon-container"
  }, [_c('img', {
    staticClass: "cursor-pointer",
    attrs: {
      "src": "/static/images/landing-page/google-play.svg",
      "aspect-ratio": "1",
      "height": "84",
      "width": "187"
    },
    on: {
      "click": function($event) {
        _vm.showQR('android')
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (this.ios || this.android) ? _c('div', {
    staticClass: "options"
  }, [_c('div', {
    staticClass: "title",
    domProps: {
      "innerHTML": _vm._s(this.ios ? 'Download iOS App' : 'Download Android App')
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "qr-code__content--img",
    staticStyle: {
      "margin-top": "20%",
      "text-align": "center"
    }
  }, [(this.ios) ? _c('img', {
    attrs: {
      "src": __webpack_require__(323),
      "width": "307"
    }
  }) : _vm._e(), _vm._v(" "), (this.android) ? _c('img', {
    attrs: {
      "src": __webpack_require__(322),
      "width": "307"
    }
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (this.ios || this.android) ? _c('center', {
    on: {
      "click": _vm.reset
    }
  }, [_vm._v(" Go back ")]) : _vm._e()], 1) : _c('div', [_c('v-container', {
    staticClass: "no-top-nav no-side-space"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "full-authTabs-wrapper": "",
      "justify-center": "",
      "row": ""
    }
  }, [_c('v-flex', {
    class: {
      onMobileStrict: _vm.onMobileStrict
    },
    attrs: {
      "xs12": ""
    }
  }, [(_vm.activeView === 'signUpView') ? _c('div', {
    staticClass: "signup-view"
  }, [_c('Onboarding')], 1) : _vm._e()])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1766 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-footer', {
    staticClass: "my-footer"
  }, [_c('a', {
    attrs: {
      "href": "//support.yousound.com",
      "target": "_blank"
    }
  }, [_vm._v("Support")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/terms"
    }
  }, [_vm._v("Terms")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "#"
    }
  }, [_vm._v("Privacy")]), _vm._v(" "), (!_vm.hideDownload) ? _c('router-link', {
    attrs: {
      "to": "#"
    }
  }, [_vm._v("Download App")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "copyright"
  }, [_vm._v("© " + _vm._s(new Date().getFullYear()) + " YouSound, Inc.")])], 1)
},staticRenderFns: []}

/***/ }),
/* 1767 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page attendee-page attendee-add-page",
    staticStyle: {
      "padding-top": "0px",
      "min-height": "100%"
    }
  }, [_c('v-layout', {
    attrs: {
      "column": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "sm4": "",
      "pa-0": ""
    }
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('img', {
    staticClass: "site-logo",
    attrs: {
      "src": "/static/images/nav_logo_white.png"
    }
  })]), _vm._v(" "), _c('form', {
    staticClass: "mx-2 pa-3",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit()
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attendee.full_name),
      expression: "attendee.full_name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:255'),
      expression: "'required|max:255'"
    }],
    staticClass: "my-2",
    attrs: {
      "type": "text",
      "placeholder": "Full Name",
      "name": "full_name"
    },
    domProps: {
      "value": (_vm.attendee.full_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.attendee, "full_name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attendee.username),
      expression: "attendee.username"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:255'),
      expression: "'required|max:255'"
    }],
    staticClass: "my-2",
    attrs: {
      "type": "text",
      "placeholder": "Artist / Brand / Label Name",
      "name": "display_name"
    },
    domProps: {
      "value": (_vm.attendee.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.attendee, "username", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attendee.email),
      expression: "attendee.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    staticClass: "my-2",
    attrs: {
      "type": "email",
      "placeholder": "Email",
      "name": "email"
    },
    domProps: {
      "value": (_vm.attendee.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.attendee, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "my-2",
    attrs: {
      "items": _vm.account_types,
      "item-text": "name",
      "item-value": "id",
      "name": "account_type",
      "label": "- Select Account Type -",
      "single-line": "",
      "bottom": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.attendee.account_type),
      callback: function($$v) {
        _vm.$set(_vm.attendee, "account_type", $$v)
      },
      expression: "attendee.account_type"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attendee.referred_by),
      expression: "attendee.referred_by"
    }],
    staticClass: "my-2",
    attrs: {
      "type": "text",
      "placeholder": "Referred By",
      "name": "referred_by"
    },
    domProps: {
      "value": (_vm.attendee.referred_by)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.attendee, "referred_by", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-0 mt-2",
    attrs: {
      "dark": "",
      "round": "",
      "color": "blue",
      "type": "submit"
    }
  }, [_vm._v("Reserve My Account")])], 1)])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "content-class": "attendee-confirm-dialog"
    },
    model: {
      value: (_vm.show_attendee_confirm_dialog),
      callback: function($$v) {
        _vm.show_attendee_confirm_dialog = $$v
      },
      expression: "show_attendee_confirm_dialog"
    }
  }, [_c('v-layout', {
    attrs: {
      "column": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "sm4": "",
      "pa-3": ""
    }
  }, [_c('div', {
    staticClass: "mt-5"
  }, [_c('img', {
    staticClass: "site-logo",
    attrs: {
      "src": "/static/images/nav_logo_primary.png"
    }
  })]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "width": "50px",
      "margin": "30px auto 50px auto"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('img', {
    staticClass: "page-logo",
    attrs: {
      "src": "/static/images/ic_verified.png"
    }
  })]), _vm._v(" "), _c('h3', [_vm._v("We’re launching soon!")]), _vm._v(" "), _c('p', [_vm._v("\n          You will receive an e-mail with a sign up"), _c('br'), _vm._v("\n          link to your pre-verifed account.\n        ")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1768 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('upload-nav', {
    attrs: {
      "name": "upload"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "px-5 pt-5 mt-5 text-poppins-36"
  }, [_vm._v("Upload product")]), _vm._v(" "), (!_vm.product.image1) ? _c('div', [_c('div', {
    staticClass: "page-content mx-5"
  }, [_c('drag-file-uploader', {
    ref: "dragFileUploader",
    attrs: {
      "accept": "image/*",
      "type": "image",
      "category": "product",
      "autoUpload": true
    },
    on: {
      "filePicked": _vm.pickedFile
    }
  })], 1)]) : _c('div', [(_vm.currentUser.creator_verified) ? _c('div', {
    staticClass: "page upload-child sell-page product-page mx-5"
  }, [(!_vm.currentUser.stripe_connected) ? _c('topbarNotification', {
    attrs: {
      "content": _vm.topBarContent,
      "ctaTitle": "Connect",
      "cta": {
        name: 'ManageIndex',
        params: {
          tab: 'payment'
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.isPageReady) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "content-section": "",
      "mt-4": "",
      "bg-white": "",
      "rounded-20": "",
      "pa-4": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h2', {
    staticClass: "my-2 album-info-title"
  }, [_vm._v("Info")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md12": "",
      "lg7": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "product-section": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "form-group": ""
    }
  }, [_c('label', {
    staticClass: "control-label max-char-label"
  }, [_c('span', {
    staticClass: "__title"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("\n                          Product Name\n                        ")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.name),
      expression: "product.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.product.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "form-group": ""
    }
  }, [_c('label', {
    staticClass: "control-label max-char-label"
  }, [_c('span', {
    staticClass: "__title"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("\n                          Category\n                        ")])]), _vm._v(" "), _c('v-select', {
    staticClass: "pt-0",
    attrs: {
      "placeholder": "Select",
      "items": _vm.product_categories,
      "item-text": "name",
      "item-value": "id",
      "no-data-text": "No destination available",
      "autocomplete": ""
    },
    on: {
      "change": _vm.onChangeProductCategory
    },
    model: {
      value: (_vm.product.category),
      callback: function($$v) {
        _vm.$set(_vm.product, "category", $$v)
      },
      expression: "product.category"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "form-group": ""
    }
  }, [_c('label', {
    staticClass: "control-label max-char-label"
  }, [_c('span', {
    staticClass: "__title"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("\n                          Description\n                        ")])]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.description),
      expression: "product.description"
    }],
    staticClass: "product-description form-control non-resizable",
    attrs: {
      "maxlength": "2000"
    },
    domProps: {
      "value": (_vm.product.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product, "description", $event.target.value)
      }
    }
  })])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md12": "",
      "lg5": "",
      "pl-4": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "product-section": ""
    }
  }, [_c('label', {
    staticClass: "control-label max-char-label"
  }, [_c('span', {
    staticClass: "__title"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("\n                        Product Images\n                      ")])]), _vm._v(" "), _c('v-container', {
    attrs: {
      "grid-list-lg": "",
      "px-0": "",
      "pt-0": "",
      "mt-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('div', {
    staticClass: "product-image-section"
  }, [(_vm.product.image1) ? _c('div', {
    staticClass: "product-image",
    attrs: {
      "id": "product_image1"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.product.image1) ? _c('div', {
    staticClass: "product-image-upload-section"
  }, [_c('input', {
    staticClass: "add-product-image-file",
    attrs: {
      "type": "file",
      "name": "product_image_file",
      "id": "product_image_file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.imageChanged('product_image1', $event)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "product_image_file"
    }
  }, [_c('v-icon', {
    staticClass: "camera"
  }, [_vm._v("photo_camera")]), _vm._v("\n                                Upload\n                              ")], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "product-image-change-section"
  }, [_c('input', {
    staticClass: "change-product-image-file",
    attrs: {
      "type": "file",
      "name": "product_image_file",
      "id": "product_image_file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.imageChanged('product_image1', $event)
      }
    }
  }), _vm._v(" "), (_vm.product.image1) ? _c('label', {
    attrs: {
      "for": "product_image_file"
    }
  }, [_vm._v("\n                              Change\n                            ")]) : _vm._e(), _vm._v(" "), (_vm.product.image1) ? _c('label', {
    staticClass: "text-btn",
    on: {
      "click": function($event) {
        _vm.deleteProductImage('product_image1')
      }
    }
  }, [_vm._v("\n                              / Delete\n                            ")]) : _vm._e()])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('div', {
    staticClass: "product-image-section"
  }, [(_vm.product.image2) ? _c('div', {
    staticClass: "product-image",
    attrs: {
      "id": "product_image2"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.product.image2) ? _c('div', {
    staticClass: "product-image-upload-section"
  }, [_c('input', {
    staticClass: "add-product-image-file",
    attrs: {
      "type": "file",
      "name": "product_image_file2",
      "id": "product_image_file2",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.imageChanged('product_image2', $event)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "product_image_file2"
    }
  }, [_c('v-icon', {
    staticClass: "camera"
  }, [_vm._v("photo_camera")]), _vm._v("\n                                Upload\n                              ")], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "product-image-change-section"
  }, [_c('input', {
    staticClass: "change-product-image-file",
    attrs: {
      "type": "file",
      "name": "product_image_file2",
      "id": "product_image_file2",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.imageChanged('product_image2', $event)
      }
    }
  }), _vm._v(" "), (_vm.product.image2) ? _c('label', {
    attrs: {
      "for": "product_image_file2"
    }
  }, [_vm._v("\n                              Change\n                            ")]) : _vm._e(), _vm._v(" "), (_vm.product.image2) ? _c('label', {
    staticClass: "text-btn",
    on: {
      "click": function($event) {
        _vm.deleteProductImage('product_image2')
      }
    }
  }, [_vm._v("\n                              / Delete\n                            ")]) : _vm._e()])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('div', {
    staticClass: "product-image-section"
  }, [(_vm.product.image3) ? _c('div', {
    staticClass: "product-image",
    attrs: {
      "id": "product_image3"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.product.image3) ? _c('div', {
    staticClass: "product-image-upload-section"
  }, [_c('input', {
    staticClass: "add-product-image-file",
    attrs: {
      "type": "file",
      "name": "product_image_file3",
      "id": "product_image_file3",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.imageChanged('product_image3', $event)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "product_image_file3"
    }
  }, [_c('v-icon', {
    staticClass: "camera"
  }, [_vm._v("photo_camera")]), _vm._v("\n                                Upload\n                              ")], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "product-image-change-section"
  }, [_c('input', {
    staticClass: "change-product-image-file",
    attrs: {
      "type": "file",
      "name": "product_image_file3",
      "id": "product_image_file3",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.imageChanged('product_image3', $event)
      }
    }
  }), _vm._v(" "), (_vm.product.image3) ? _c('label', {
    attrs: {
      "for": "product_image_file3"
    }
  }, [_vm._v("\n                              Change\n                            ")]) : _vm._e(), _vm._v(" "), (_vm.product.image3) ? _c('label', {
    staticClass: "text-btn",
    on: {
      "click": function($event) {
        _vm.deleteProductImage('product_image3')
      }
    }
  }, [_vm._v("\n                              / Delete\n                            ")]) : _vm._e()])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('div', {
    staticClass: "product-image-section"
  }, [(_vm.product.image4) ? _c('div', {
    staticClass: "product-image",
    attrs: {
      "id": "product_image3"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.product.image4) ? _c('div', {
    staticClass: "product-image-upload-section"
  }, [_c('input', {
    staticClass: "add-product-image-file",
    attrs: {
      "type": "file",
      "name": "product_image_file4",
      "id": "product_image_file3",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.imageChanged('product_image4', $event)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "product_image_file3"
    }
  }, [_c('v-icon', {
    staticClass: "camera"
  }, [_vm._v("photo_camera")]), _vm._v("\n                                Upload\n                              ")], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "product-image-change-section"
  }, [_c('input', {
    staticClass: "change-product-image-file",
    attrs: {
      "type": "file",
      "name": "product_image_file3",
      "id": "product_image_file3",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.imageChanged('product_image3', $event)
      }
    }
  }), _vm._v(" "), (_vm.product.image4) ? _c('label', {
    attrs: {
      "for": "product_image_file3"
    }
  }, [_vm._v("\n                              Change\n                            ")]) : _vm._e(), _vm._v(" "), (_vm.product.image4) ? _c('label', {
    staticClass: "text-btn",
    on: {
      "click": function($event) {
        _vm.deleteProductImage('product_image4')
      }
    }
  }, [_vm._v("\n                              / Delete\n                            ")]) : _vm._e()])])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "content-section": "",
      "mt-4": "",
      "bg-white": "",
      "rounded-20": "",
      "pa-4": ""
    }
  }, [(!_vm.isDigitalProduct) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "pa-0": ""
    }
  }, [_c('h2', {
    staticClass: "album-info-title"
  }, [_vm._v("Tax")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "product-section": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "mt-2": "",
      "product-section": "",
      "mt-4": ""
    }
  }, [_c('v-checkbox', {
    on: {
      "change": _vm.resetTaxPercent
    },
    model: {
      value: (_vm.product.is_vat),
      callback: function($$v) {
        _vm.$set(_vm.product, "is_vat", $$v)
      },
      expression: "product.is_vat"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("\n                            Sellers outside of US check box for VAT/GST\n                          ")])])], 2)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "mt-3": ""
    }
  }, [(_vm.product.is_vat) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md4": "",
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Sellers Country")]), _vm._v(" "), _c('v-select', {
    staticClass: "pt-0",
    attrs: {
      "items": _vm.countries,
      "item-text": "name",
      "item-value": "name",
      "autocomplete": ""
    },
    on: {
      "change": _vm.changeTaxPercent
    },
    model: {
      value: (_vm.product.seller_location),
      callback: function($$v) {
        _vm.$set(_vm.product, "seller_location", $$v)
      },
      expression: "product.seller_location"
    }
  })], 1) : _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md4": "",
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Sellers State")]), _vm._v(" "), _c('v-select', {
    staticClass: "pt-0",
    attrs: {
      "placeholder": "CA",
      "items": _vm.states,
      "item-text": "name",
      "item-value": "name",
      "autocomplete": ""
    },
    on: {
      "change": _vm.changeTaxPercent
    },
    model: {
      value: (_vm.product.seller_location),
      callback: function($$v) {
        _vm.$set(_vm.product, "seller_location", $$v)
      },
      expression: "product.seller_location"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md4": "",
      "lg3": ""
    }
  }, [(_vm.product.is_vat) ? _c('label', {
    staticClass: "control-label"
  }, [_vm._v("\n                          Tax\n                        ")]) : _c('label', {
    staticClass: "control-label"
  }, [_vm._v("State Tax")]), _vm._v(" "), _c('vue-numeric', {
    staticClass: "form-control primary-input",
    attrs: {
      "currency": "%",
      "placeholder": "8.5%",
      "currency-symbol-position": "suffix",
      "separator": ",",
      "precision": 3,
      "min": 0,
      "max": 100
    },
    model: {
      value: (_vm.product.tax_percent),
      callback: function($$v) {
        _vm.$set(_vm.product, "tax_percent", $$v)
      },
      expression: "product.tax_percent"
    }
  })], 1)], 1)], 1)], 1) : _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm7": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "section-title": ""
    }
  }, [_c('h4', [_vm._v("Digital Product Upload")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "product-section": ""
    }
  }, [_c('h4', {
    staticClass: "option-title"
  }, [_vm._v(".Zip file only, 2GB max upload")]), _vm._v(" "), _c('digital-uploader', {
    attrs: {
      "digitalContent": _vm.digital_content
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "content-section": "",
      "mt-4": "",
      "bg-white": "",
      "rounded-20": "",
      "pa-4": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "pa-0": ""
    }
  }, [_c('h2', {
    staticClass: "album-info-title"
  }, [_vm._v("Collaborators")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "collaborator-section first-child",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h2', {
    staticClass: "album-info-title-x mt-3"
  }, [_c('span', {
    staticClass: "my-2 mr-2"
  }, [_vm._v("\n                        Collaborators (" + _vm._s(_vm.product.collaborators.length) + ")\n                      ")]), _vm._v(" "), (_vm.product.collaborators.length < 3) ? _c('v-btn', {
    staticClass: "add-option-btn",
    nativeOn: {
      "click": function($event) {
        _vm.addCollaborator()
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1) : _vm._e()], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "pa-0": ""
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-lg": "",
      "px-0": "",
      "py-0": ""
    }
  }, [(
    _vm.product.collaborators &&
    _vm.product.collaborators.length > 0
  ) ? _c('v-layout', {
    attrs: {
      "row": "",
      "creator-wrapper": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md4": "",
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Owner")]), _vm._v(" "), _c('label', {
    staticClass: "creator-name"
  }, [_vm._v(_vm._s(_vm.$store.state.auth.user.username))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md4": "",
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Profit split")]), _vm._v(" "), _c('label', {
    staticClass: "creator-share"
  }, [_vm._v(_vm._s(_vm.creator_share))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md4": "",
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Recoup amount")]), _vm._v(" "), _c('span', {
    staticClass: "dflex align-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.creator_recoup_cost),
      expression: "product.creator_recoup_cost"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.product.creator_recoup_cost)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product, "creator_recoup_cost", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('v-icon', {
    staticClass: "clear-btn",
    on: {
      "click": function($event) {
        _vm.deleteCollaborator(_vm.index)
      }
    }
  }, [_vm._v("clear")])], 1)])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.product.collaborators), function(collaborator, index) {
    return _c('v-layout', {
      key: index,
      attrs: {
        "row": "",
        "collaborator-wrapper": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "sm12": "",
        "md4": "",
        "lg3": ""
      }
    }, [_c('label', {
      staticClass: "control-label"
    }, [_vm._v("Collaborators")]), _vm._v(" "), _c('v-select', {
      staticClass: "pt-0",
      attrs: {
        "items": _vm.users,
        "item-text": "username",
        "item-value": "id",
        "chips": "",
        "autocomplete": "",
        "no-data-text": "No collaborator available",
        "clearable": ""
      },
      scopedSlots: _vm._u([{
        key: "selection",
        fn: function(data) {
          return [_c('v-chip', {
            key: JSON.stringify(data.item),
            staticClass: "chip--select-multi",
            attrs: {
              "selected": data.selected
            },
            on: {
              "input": function($event) {
                data.parent.selectItem(data.item)
              }
            }
          }, [_c('v-avatar', [_c('img', {
            attrs: {
              "src": data.item.avatar.thumb.url
            }
          })]), _vm._v("\n                                " + _vm._s(data.item.username) + "\n                              ")], 1)]
        }
      }, {
        key: "item",
        fn: function(data) {
          return [(typeof data.item !== 'object') ? [_c('v-list-tile-content', {
            domProps: {
              "textContent": _vm._s(data.item)
            }
          })] : [_c('v-list-tile-avatar', [_c('img', {
            attrs: {
              "src": data.item.avatar.thumb.url
            }
          })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
            domProps: {
              "innerHTML": _vm._s(data.item.username)
            }
          })], 1)]]
        }
      }]),
      model: {
        value: (collaborator.user_id),
        callback: function($$v) {
          _vm.$set(collaborator, "user_id", $$v)
        },
        expression: "collaborator.user_id"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm12": "",
        "md4": "",
        "lg3": ""
      }
    }, [_c('label', {
      staticClass: "control-label"
    }, [_vm._v("Profit split")]), _vm._v(" "), _c('v-select', {
      staticClass: "pt-0",
      attrs: {
        "items": _vm.profit_share_types,
        "item-text": "name",
        "item-value": "id",
        "autocomplete": ""
      },
      model: {
        value: (collaborator.user_share),
        callback: function($$v) {
          _vm.$set(collaborator, "user_share", $$v)
        },
        expression: "collaborator.user_share"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm12": "",
        "md4": "",
        "lg3": ""
      }
    }, [_c('label', {
      staticClass: "control-label"
    }, [_vm._v("Recoup amount")]), _vm._v(" "), _c('span', {
      staticClass: "dflex align-center"
    }, [_c('input', {
      staticClass: "form-control",
      attrs: {
        "type": "text"
      }
    }), _vm._v(" "), _c('v-icon', {
      staticClass: "clear-btn mb-15"
    }, [_vm._v("\n                                clear\n                              ")])], 1)])], 1)
  })], 2)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "content-section": "",
      "mt-4": "",
      "bg-white": "",
      "rounded-20": "",
      "pa-4": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "pa-0": ""
    }
  }, [_c('h2', {
    staticClass: "album-info-title mb-0"
  }, [_vm._v("Options")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md12": "",
      "lg6": "",
      "form-group": ""
    }
  }, [_c('label', {
    staticClass: "control-label max-char-label"
  }, [_c('span', {
    staticClass: "__title"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("\n                        Available to..\n                      ")])]), _vm._v(" "), _c('v-select', {
    staticClass: "pt-0",
    attrs: {
      "placeholder": "Select",
      "items": _vm.access_levels,
      "item-text": "title",
      "item-value": "id",
      "no-data-text": "No destination available",
      "autocomplete": "",
      "chips": "",
      "multiple": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(data) {
        return [_c('div', {
          staticClass: "custom-multi-select"
        }, [_c('span', [_vm._v(_vm._s(data.item.title))]), _vm._v(" "), _c('v-icon', {
          staticClass: "icon-close text-white"
        }, [_vm._v("\n                            close\n                          ")])], 1)]
      }
    }]),
    model: {
      value: (_vm.product.access_level),
      callback: function($$v) {
        _vm.$set(_vm.product, "access_level", $$v)
      },
      expression: "product.access_level"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "submit-section": "",
      "mt-5": ""
    }
  }, [_c('v-btn', {
    staticClass: "product-save-btn",
    class: {
      'app-blue': _vm.isAvailableToAddProduct,
      'cursor-pointer': !_vm.isAvailableToAddProduct,
    },
    attrs: {
      "disabled": !_vm.isAvailableToAddProduct
    },
    nativeOn: {
      "click": function($event) {
        _vm.beforeSaveProduct()
      }
    }
  }, [_vm._v("Release")])], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "invite-dialog",
      "width": "440"
    },
    model: {
      value: (_vm.collaborators_confirm_dialog),
      callback: function($$v) {
        _vm.collaborators_confirm_dialog = $$v
      },
      expression: "collaborators_confirm_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("\n              Confirm Collaborators\n            ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n              Make sure to add any collaborators to your product, once it's\n              uploaded you won't be able to add collaborators.\n            ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "green",
      "dark": "",
      "block": "",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        _vm.saveProduct()
      }
    }
  }, [_vm._v("OK")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "black",
      "dark": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.hideCollaboratorsConfirmDialog()
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)], 1) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 1769 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page settings-page mx-5 relative",
    class: {
      onMobile: _vm.onMobile
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('content-top-header', {
    staticClass: "black-theme"
  }, [_c('template', {
    slot: "topHeader"
  }, [_c('ul', {
    staticClass: "pr-3"
  }, [_c('li', {
    staticClass: "nav-li"
  }, [_c('label', {
    staticClass: "nav-label"
  }, [_vm._v("Account")])])])])], 2), _vm._v(" "), _c('content-top-header', {
    staticClass: "content-top-header-tab",
    attrs: {
      "height": 62
    }
  }, [_c('template', {
    slot: "topHeader"
  }, [_c('ul', _vm._l((_vm.availableTabs), function(tab) {
    return _c('li', {
      key: tab.id,
      class: {
        'active tab-active': _vm.isActiveTab(tab.id)
      },
      attrs: {
        "href": ("#" + (tab.id))
      }
    }, [_c('label', {
      on: {
        "click": function($event) {
          _vm.onTab(tab.id)
        }
      }
    }, [_vm._v(_vm._s(tab.title))])])
  }))])], 2), _vm._v(" "), (_vm.currentUser !== null && _vm.currentUser.plan !== null) ? _c('v-dialog', {
    attrs: {
      "content-class": "invite-dialog",
      "width": "440"
    },
    model: {
      value: (_vm.plansUpgradeModal),
      callback: function($$v) {
        _vm.plansUpgradeModal = $$v
      },
      expression: "plansUpgradeModal"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Plan Changes")]), _vm._v(" "), (_vm.plansName[_vm.currentUser.plan] == 'Listener') ? _c('v-card-text', [_vm._v("\n          Your current plan is "), _c('b', [_vm._v(" " + _vm._s(_vm.plansName[_vm.currentUser.plan]) + " ")]), _vm._v(" and you are trying to "), _c('b', [_vm._v(_vm._s(_vm.planChangeText) + ".\n          ")]), _vm._v("\n          You will remain listener until admin approve your account. Once you verified, you will be charged according to\n          subscription of current plan and new chosen plan.\n          Are you sure you want to continue?\n\n        ")]) : _c('v-card-text', [_vm._v("\n          Your current plan is "), _c('b', [_vm._v(" " + _vm._s(_vm.plansName[_vm.currentUser.plan]) + " ")]), _vm._v(" and you are trying to "), _c('b', [_vm._v(_vm._s(_vm.planChangeText) + ".\n          ")]), _vm._v("\n          This will have an immediate effect and you will be charged according to subscription of current plan and new\n          chosen plan.\n          Are you sure you want to continue?\n        ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "block": "",
      "dark": "",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        _vm.subscriptionChange(_vm.planChangeText)
      }
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "block": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.hidePlanChangeModal()
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.currentUser) ? _c('div', {
    staticClass: "page-content mt-130"
  }, [(_vm.active_tab == 'info') ? _c('div', {
    staticClass: "main-section"
  }, [_c('div', {
    staticClass: "content-section"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "ma-0": "",
      "profile-section": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "pa-0": ""
    }
  }, [_c('div', {
    staticClass: "dflex align-center justify-space-between mb-4"
  }, [_c('div', {
    staticClass: "avatar-section"
  }, [_c('h2', {
    staticClass: "mb-3 account-title"
  }, [_vm._v("Profile info")]), _vm._v(" "), _c('div', {
    staticClass: "__wrapper dflex align-center"
  }, [_c('div', {
    staticClass: "profile-image-section"
  }, [(_vm.profile.image) ? _c('div', {
    staticClass: "profile-image",
    style: ({
      'background-image': 'url(' + _vm.profile.image + ')',
    }),
    attrs: {
      "id": "profile_image"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.profile.image) ? _c('div', {
    staticClass: "profile-image-upload-section"
  }, [_c('input', {
    staticClass: "add-profile-image-file",
    attrs: {
      "type": "file",
      "name": "profile_image_file",
      "id": "profile_image_file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.profileImageChanged($event)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "profile_image_file"
    }
  }, [_c('v-icon', {
    staticClass: "camera"
  }, [_vm._v("photo_camera")]), _vm._v("Add\n                        ")], 1)]) : _vm._e(), _vm._v(" "), (_vm.profile.image) ? _c('div', {
    staticClass: "profile-image-change-section"
  }, [_c('input', {
    staticClass: "change-profile-image-file",
    attrs: {
      "type": "file",
      "name": "profile_image_file",
      "id": "profile_image_file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.profileImageChanged($event)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "profile_image_file"
    }
  }, [_c('v-icon', {
    staticClass: "camera"
  }, [_vm._v("photo_camera")]), _vm._v("Update\n                        ")], 1)]) : _vm._e()]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "username"
  }, [_vm._v(_vm._s(_vm.profile.username))]), _vm._v(" "), _c('div', {
    staticClass: "display-name"
  }, [_vm._v(_vm._s(_vm.profile.display_name))]), _vm._v(" "), _c('label', {
    staticClass: "link--text profile_image_file",
    attrs: {
      "for": "profile_image_file"
    }
  }, [_vm._v("Change avatar")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group user-names"
  }, [_c('div', {
    staticClass: "dflex justify-space-between align-center _wrapper"
  }, [_c('div', {
    staticClass: "first-name"
  }, [_c('label', {
    staticClass: "control-label account-label-input"
  }, [_vm._v("First Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.first_name),
      expression: "profile.first_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.profile.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "first_name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "last-name"
  }, [_c('label', {
    staticClass: "control-label account-label-input"
  }, [_vm._v("Last Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.last_name),
      expression: "profile.last_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.profile.last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "last_name", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label account-label-input"
  }, [_vm._v("\n                  Email\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('email')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.email),
      expression: "profile.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    staticClass: "form-control",
    class: {
      input: true,
      'text-danger': _vm.errors.has('email')
    },
    attrs: {
      "name": "email",
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.profile.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.has('email')) ? _c('p', {
    staticClass: "text-danger text-xs-left"
  }, [_vm._v("\n                    " + _vm._s(_vm.errors.first("email")) + "\n                  ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label account-label-input"
  }, [_vm._v(" City ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label account-label-input"
  }, [_vm._v("\n                  Country\n                ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label account-label-input"
  }, [_vm._v("\n                  Age group\n                ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label account-label-input"
  }, [_vm._v("SOCIAL MEDIA")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('v-menu', {
    staticClass: "social-type-menu",
    attrs: {
      "bottom": "",
      "left": "",
      "offset-y": "",
      "nudge-top": -5,
      "nudge-left": 0,
      "content-class": "social-menu__content"
    }
  }, [_c('v-select', {
    staticClass: "social-types-selector py-0",
    class: {
      _filled: _vm.socialChannel
    },
    attrs: {
      "slot": "activator",
      "placeholder": _vm.socialChannel ? _vm.socialChannel.title : 'Select',
      "single-line": "",
      "hide-details": ""
    },
    slot: "activator"
  }), _vm._v(" "), _vm._l((_vm.socialChannels), function(channel, i) {
    return _c('div', {
      key: i,
      staticClass: "channel-info",
      class: [((channel.id) + "-menu")],
      on: {
        "click": function($event) {
          _vm.selectedChannel(channel)
        }
      }
    }, [_c('div', {
      staticClass: "_title"
    }, [_vm._v(_vm._s(channel.title))]), _vm._v(" "), _c('div', {
      staticClass: "_tags"
    }, [_vm._v("\n                        " + _vm._s(channel.tags) + "\n                      ")])])
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group mt-4"
  }, [_c('v-btn', {
    staticClass: "update-btn account-btn-save",
    nativeOn: {
      "click": function($event) {
        _vm.updateAccount()
      }
    }
  }, [_c('span', [_vm._v("Save")])])], 1)])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "invite-dialog",
      "width": "440"
    },
    model: {
      value: (_vm.subscriptionModal),
      callback: function($$v) {
        _vm.subscriptionModal = $$v
      },
      expression: "subscriptionModal"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("\n                Deactivate Subscription\n              ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                Are you sure you want to deactivate subscription?\n                This process might take a while. Please don't refresh page in this time.\n              ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red",
      "dark": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.deactivateSubscription()
      }
    }
  }, [_vm._v("Confirm")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "grey",
      "dark": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.disableSubscriptionModal()
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)], 1)]) : (_vm.active_tab == 'password') ? _c('div', {
    staticClass: "main-section"
  }, [_c('div', {
    staticClass: "account-password"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "ma-0": "",
      "password-section": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "account-password__title account-title"
  }, [_vm._v("\n                Reset your password\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label account-label-input"
  }, [_vm._v("\n                  Current Password\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('password')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password.current_password),
      expression: "password.current_password"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: {
      input: true,
      'text-danger': _vm.errors.has('password'),
    },
    attrs: {
      "name": "password",
      "type": "password"
    },
    domProps: {
      "value": (_vm.password.current_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.password, "current_password", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.has('password')) ? _c('p', {
    staticClass: "text-danger text-xs-left"
  }, [_vm._v("\n                    " + _vm._s(_vm.errors.first("password")) + "\n                  ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label account-label-input"
  }, [_vm._v("\n                  New Password\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('new_password')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password.new_password),
      expression: "password.new_password"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: {
      input: true,
      'text-danger': _vm.errors.has('new_password'),
    },
    attrs: {
      "name": "new_password",
      "type": "password"
    },
    domProps: {
      "value": (_vm.password.new_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.password, "new_password", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.has('new_password')) ? _c('p', {
    staticClass: "text-danger text-xs-left"
  }, [_vm._v("\n                    " + _vm._s(_vm.errors.first("new_password")) + "\n                  ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label account-label-input"
  }, [_vm._v("\n                  Confirm New Password\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('confirmed_password')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password.confirmed_password),
      expression: "password.confirmed_password"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: {
      input: true,
      'text-danger': _vm.errors.has('confirmed_password'),
    },
    attrs: {
      "name": "confirmed_password",
      "type": "password"
    },
    domProps: {
      "value": (_vm.password.confirmed_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.password, "confirmed_password", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.has('confirmed_password')) ? _c('p', {
    staticClass: "text-danger text-xs-left"
  }, [_vm._v("\n                    " + _vm._s(_vm.errors.first("confirmed_password")) + "\n                  ")]) : _vm._e()])]), _vm._v(" "), _c('v-btn', {
    staticClass: "update-btn account-btn-save",
    nativeOn: {
      "click": function($event) {
        _vm.updatePassword()
      }
    }
  }, [_vm._v("\n                Save\n              ")])], 1)], 1)], 1)]) : (_vm.active_tab == 'bank-details') ? _c('div', {
    staticClass: "main-section upload-page"
  }, [_c('div', {
    staticClass: "content-section"
  }, [(_vm.currentUser.creator_verified || _vm.currentUser.user_type == 'admin') ? _c('v-flex', {
    attrs: {
      "sm12": "",
      "md6": "",
      "lg4": "",
      "bank-details-section": "",
      "pa-0": ""
    }
  }, [_c('div', {
    staticClass: "bank-details-section__title"
  }, [_vm._v("Connect payments")]), _vm._v(" "), (!_vm.currentUser.stripe_connected) ? _c('div', {
    staticClass: "mb-4"
  }, [_c('div', {
    staticClass: "stripe-status-identifier dflex align-center justify-space-between"
  }, [_c('div', {
    staticClass: "dflex align-center"
  }, [_c('img', {
    staticClass: "stripe-img",
    attrs: {
      "src": __webpack_require__(607),
      "width": "100"
    }
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "status"
  }, [_vm._v("Connect Stripe account")])])]), _vm._v(" "), _c('div', [_c('router-link', {
    attrs: {
      "href": _vm.stripeLink
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.stripeLink
    }
  }, [_c('v-icon', {
    staticClass: "cursor-pointer stripeLink-icon stripeLink-icon-add"
  }, [_vm._v("\n                      add\n                    ")])], 1)], 1)])]) : _c('div', [_c('div', {
    staticClass: "stripe-status-identifier stripe-status-identifier-connected dflex justify-space-between align-center"
  }, [_c('div', {
    staticClass: "dflex align-center"
  }, [_c('img', {
    staticClass: "stripe-img",
    attrs: {
      "src": __webpack_require__(607),
      "width": "100"
    }
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "status-title"
  }, [_vm._v("Stripe")]), _vm._v(" "), _c('div', {
    staticClass: "status"
  }, [_vm._v("Connected")])])]), _vm._v(" "), _c('div', [_c('v-icon', {
    staticClass: "cursor-pointer stripeLink-icon stripeLink-icon-remove",
    on: {
      "click": function($event) {
        _vm.openStripeDisconnectConfirmDialog()
      }
    }
  }, [_vm._v("\n                    remove\n                  ")])], 1)]), _vm._v(" "), (_vm.currentUser.stripe_connected) ? _c('v-btn', {
    staticClass: "update-btn",
    attrs: {
      "href": _vm.currentUser.stripe_express_dashboard_link,
      "target": "_blank"
    }
  }, [_vm._v("\n                View Stripe Dashboard\n              ")]) : _vm._e()], 1)]) : _c('v-flex', {
    attrs: {
      "sm12": "",
      "md6": "",
      "lg4": "",
      "bank-details-section": "",
      "pa-0": ""
    }
  }, [_c('div', {
    staticClass: "bank-details-section__title"
  }, [_vm._v("You're not verified yet!")])])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "invite-dialog",
      "width": "440"
    },
    model: {
      value: (_vm.show_stripe_disconnect_confirm_dialog),
      callback: function($$v) {
        _vm.show_stripe_disconnect_confirm_dialog = $$v
      },
      expression: "show_stripe_disconnect_confirm_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("\n              Do you really want to disconnect stripe?\n            ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n              Your products will be deleted permanetly when you disconnect to\n              stripe.\n            ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red",
      "dark": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.disconnectAccount()
      }
    }
  }, [_vm._v("Confirm")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "grey",
      "dark": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeStripeDisconnectConfirmDialog()
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)], 1) : (_vm.active_tab == 'subscription') ? _c('account-subscription') : (_vm.active_tab == 'download') ? _c('account-download') : (_vm.active_tab == 'repost-price') ? _c('price-tab') : (_vm.active_tab == 'shipping-address') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('address-tab', {
    attrs: {
      "actionRight": "",
      "singleCol": "",
      "hideRequireIcon": "",
      "header": "Update your shipping address"
    }
  })], 1) : (_vm.active_tab == 'blocked') ? _c('div', {
    staticClass: "main-section"
  }, [_c('div', {
    staticClass: "content-section"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "bocked-user-section": "",
      "ma-0": ""
    }
  }, _vm._l((_vm.currentUser.blocked_users), function(blockedUser, index) {
    return _c('v-flex', {
      key: index,
      attrs: {
        "xs12": "",
        "sm4": "",
        "form-group": ""
      }
    }, [_c('div', {
      staticClass: "blocked-users"
    }, [_c('user-tag', {
      attrs: {
        "user": blockedUser,
        "showAvatar": "",
        "clickUser": "",
        "showUserType": "",
        "width": "50",
        "height": "50"
      }
    }), _vm._v(" "), _c('v-btn', {
      staticClass: "unblock-btn",
      attrs: {
        "outline": "",
        "round": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.unblockUser(blockedUser)
        }
      }
    }, [_vm._v("\n                  Unblock\n                ")])], 1)])
  }))], 1)]) : (_vm.active_tab == 'seller-policies') ? _c('policy-tab', {
    attrs: {
      "user": _vm.user,
      "updateUser": _vm.updateUser
    }
  }) : (_vm.active_tab == 'verify-status') ? _c('div', {
    staticClass: "main-section"
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": "",
      "verify-section": ""
    }
  }, [(_vm.currentUser.approver && _vm.currentUser.approver.display_name) ? _c('div', {
    staticClass: "verify-wrapper verified"
  }, [_c('div', {
    staticClass: "app-bold verify-status"
  }, [_vm._v("\n              " + _vm._s(this.requestStatuses[_vm.currentUser.request_status]) + "\n            ")]), _vm._v(" "), (_vm.currentUser.request_status !== 'pending') ? _c('div', {
    staticClass: "verified-by"
  }, [_vm._v("by " + _vm._s(_vm.currentUser.approver.display_name))]) : _c('div', [_c('span', [_vm._v("-")])])]) : _c('div', {
    staticClass: "verify-wrapper pending"
  }, [_c('div', {
    staticClass: "app-bold verify-status"
  }, [_vm._v("Pending")]), _vm._v(" "), _c('div', {
    staticClass: "verified-by"
  }, [_vm._v("-")])]), _vm._v(" "), ((_vm.currentUser.request_status === 'pending')) ? _c('div', [_c('span', [_vm._v(" You have already requested for account approval.")])]) : ((_vm.currentUser.request_status === 'denied')) ? _c('div', [_c('v-btn', {
    attrs: {
      "round": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.verifyReRequestStatus()
      }
    }
  }, [_vm._v("\n              Re request for verification\n            ")])], 1) : _vm._e()])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.showGetVerifiedModal) ? _c('div', [_c('div', {
    staticClass: "verified-main"
  }, [_c('div', {
    staticClass: "modal-inner"
  }, [_c('div', {
    staticClass: "text-center _title"
  }, [_vm._v("Get verified")]), _vm._v(" "), _c('div', {
    staticClass: "margin-vertical"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "_lable"
  }, [_vm._v("Social channel")]), _vm._v(" "), _c('v-menu', {
    staticClass: "social-type-menu",
    attrs: {
      "content-class": "s-menu__content"
    }
  }, [_c('v-select', {
    staticClass: "social-types-selector py-0",
    class: {
      '_filled': _vm.socialChannel
    },
    attrs: {
      "slot": "activator",
      "placeholder": _vm.socialChannel ? _vm.socialChannel.title : 'Choose',
      "single-line": "",
      "hide-details": ""
    },
    slot: "activator"
  }), _vm._v(" "), _vm._l((_vm.socialChannels), function(channel, i) {
    return _c('div', {
      key: i,
      staticClass: "channel-info",
      class: [((channel.id) + "-menu")],
      on: {
        "click": function($event) {
          _vm.selectedChannel(channel)
        }
      }
    }, [_c('div', {
      staticClass: "_title"
    }, [_vm._v(_vm._s(channel.title))]), _vm._v(" "), _c('div', {
      staticClass: "_tags"
    }, [_vm._v("\n                    " + _vm._s(channel.tags) + "\n                  ")])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "_lable"
  }, [_vm._v("Social Username")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.socialUsername),
      expression: "socialUsername"
    }],
    staticClass: "_socialHandle width100",
    attrs: {
      "placeholder": "Username",
      "type": "text"
    },
    domProps: {
      "value": (_vm.socialUsername)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.socialUsername = $event.target.value
      }
    }
  })], 1)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-3 px-3",
    attrs: {
      "round": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.verifiedSocialAttributes()
      }
    }
  }, [_vm._v("Get Verified")]), _vm._v(" "), _c('div', {
    staticClass: "close-button",
    on: {
      "click": function($event) {
        _vm.hideModal()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(80),
      "width": "11"
    }
  })])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.remainingDaysModal) ? _c('div', [_c('UpgradeModal', {
    attrs: {
      "daysRemaining": 30 - _vm.remainingDays()
    },
    on: {
      "remainingDaysModal": function($event) {
        _vm.remainingDaysModal = $event
      }
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footnote"
  }, [_vm._v("\n            If we need to contact you we will send a direct message from "), _c('strong', [_vm._v("@yousoundapp")])])
}]}

/***/ }),
/* 1770 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "auth-page auth-register-page"
  }, [_c('form', {
    staticClass: "auth-form register-form",
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit()
      }
    }
  }, [_c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "autocomplete": "off",
      "name": "hidden",
      "type": "text"
    }
  }), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-item": "",
      "px-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('div', {
    staticClass: "avatar-area"
  }, [_c('span', {
    staticClass: "avatar-img"
  }, [_c('img', {
    ref: "avatar",
    staticClass: "avatar",
    attrs: {
      "src": "/static/images/user-new.svg",
      "id": "avatar"
    }
  })]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "avatar-upload"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "avatar_file",
    staticClass: "avatar-file",
    attrs: {
      "type": "file",
      "name": "avatar_file",
      "id": "avatar_file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.imageChanged($event)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "avatar_file"
    }
  }, [_vm._v("Choose image")])])])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": "",
      "relative": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.username),
      expression: "user.username"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        min: 3,
        max: 20,
        regex: /^[A-Za-z0-9_.]+$/,
      }),
      expression: "{\n              required: true,\n              min: 3,\n              max: 20,\n              regex: /^[A-Za-z0-9_.]+$/,\n            }"
    }],
    staticClass: "username",
    attrs: {
      "type": "text",
      "name": "username",
      "placeholder": "@username"
    },
    domProps: {
      "value": (_vm.user.username)
    },
    on: {
      "blur": _vm.onBlur,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "username", $event.target.value)
      }
    }
  }), _vm._v(" "), (!_vm.is_username_available) ? _c('label', {
    staticClass: "error--text"
  }, [_vm._v("already taken")]) : _vm._e()]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.display_name),
      expression: "user.display_name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:20'),
      expression: "'required|max:20'"
    }],
    staticClass: "displayname",
    attrs: {
      "type": "text",
      "name": "name",
      "autocomplete": "off",
      "placeholder": "Name"
    },
    domProps: {
      "value": (_vm.user.display_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "display_name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.city),
      expression: "user.city"
    }],
    attrs: {
      "type": "text",
      "name": "city",
      "placeholder": "City"
    },
    domProps: {
      "value": (_vm.user.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "city", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('country-select', {
    staticClass: "country",
    attrs: {
      "name": "country",
      "country": _vm.country,
      "topCountry": "US"
    },
    model: {
      value: (_vm.user.country),
      callback: function($$v) {
        _vm.$set(_vm.user, "country", $$v)
      },
      expression: "user.country"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    staticClass: "country",
    attrs: {
      "items": _vm.age_group,
      "label": "Age Group",
      "persistent-hint": "",
      "return-object": "",
      "single-line": "",
      "name": "social_provider"
    },
    model: {
      value: (_vm.user.age_group),
      callback: function($$v) {
        _vm.$set(_vm.user, "age_group", $$v)
      },
      expression: "user.age_group"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    staticClass: "country",
    attrs: {
      "items": _vm.social_platform,
      "label": "Social Platform",
      "persistent-hint": "",
      "return-object": "",
      "single-line": "",
      "name": "social_provider"
    },
    model: {
      value: (_vm.user.social_provider),
      callback: function($$v) {
        _vm.$set(_vm.user, "social_provider", $$v)
      },
      expression: "user.social_provider"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.social_user_name),
      expression: "user.social_user_name"
    }],
    staticClass: "displayname",
    attrs: {
      "type": "text",
      "name": "social_user_name",
      "autocomplete": "off",
      "placeholder": "Social Platform Username"
    },
    domProps: {
      "value": (_vm.user.social_user_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "social_user_name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    staticClass: "email",
    attrs: {
      "type": "email",
      "name": "email",
      "autocomplete": "new-password",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:5|max:16'),
      expression: "'required|min:5|max:16'"
    }],
    staticClass: "password",
    attrs: {
      "type": "password",
      "name": "password",
      "autocomplete": "new-password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('div', {
    staticClass: "dflex justify-space-between align-center mt-2"
  }, [_c('p', {
    staticClass: "regular-checkbox ma-0"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.terms),
      expression: "terms"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "id": "terms",
      "type": "checkbox",
      "name": "terms"
    },
    domProps: {
      "checked": Array.isArray(_vm.terms) ? _vm._i(_vm.terms, null) > -1 : (_vm.terms)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.terms,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.terms = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.terms = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.terms = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "terms"
    }
  }, [_c('span', {
    staticClass: "terms-text"
  }, [_vm._v("Accept Terms")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "terms-text",
    attrs: {
      "to": "/terms"
    }
  }, [_vm._v("\n              Terms & Conditions\n            ")])], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": "",
      "mt-3": ""
    }
  }, [_c('v-btn', {
    staticClass: "create-account-button",
    attrs: {
      "block": "",
      "round": "",
      "dark": "",
      "type": "submit"
    }
  }, [_vm._v("\n            Create account\n          ")])], 1)], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1771 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page auth-page auth-tab no-top-nav no-side-space"
  }, [_c('v-container', {
    attrs: {
      "grid-list-item": "",
      "auth-card": "",
      "allChildrenCenter": "",
      "px-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "auth-card-wrapper": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [(!_vm.onMobile) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "auth-card-child": "",
      "left-card": "",
      "sign-in-info": ""
    }
  }, [(!_vm.onMobile) ? _c('div', [_c('img', {
    attrs: {
      "width": "40%",
      "src": "/static/images/nav_logo_primary.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-4 dflex align-center"
  }, [_c('h3', [_vm._v("Sign up")]), _vm._v(" "), _c('h3', {
    staticClass: "mx-3"
  }, [_vm._v("or")]), _vm._v(" "), _c('h3', [_c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Login")])], 1)])]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center auth-img-wrapper"
  }, [(_vm.activeTab == 'everyone') ? _c('img', {
    attrs: {
      "width": "70%",
      "src": "/static/images/new_signup_img.svg",
      "alt": ""
    }
  }) : _c('img', {
    attrs: {
      "width": "70%",
      "src": "/static/images/new_signup_img2.svg",
      "alt": ""
    }
  })])], 1) : _vm._e(), _vm._v(" "), (!_vm.register_success) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "lg4": "",
      "auth-card-child": "",
      "right-card": "",
      "sign-in-info": ""
    }
  }, [(_vm.onMobile) ? _c('h2', {
    staticClass: "text-xs-center mb-4"
  }, [_vm._v("Sign Up")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "switch-btn-wrapper __collapsed",
    class: {
      'justify-center': _vm.onMobile
    }
  }, [_c('v-btn', {
    staticClass: "ml-0 switch-btn transparent text-btn px-3",
    class: [_vm.activeTab == 'everyone' ? 'black--text border-dark' : 'grey--text'],
    attrs: {
      "depressed": "",
      "round": _vm.activeTab == 'everyone'
    },
    on: {
      "click": function($event) {
        _vm.activeTab = 'everyone'
      }
    }
  }, [_vm._v("\n            Listener\n          ")]), _vm._v(" "), (!_vm.onMobile) ? _c('v-spacer') : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-0 switch-btn transparent text-btn px-3",
    class: [_vm.activeTab == 'artistBrand' ? 'black--text border-dark' : 'grey--text'],
    attrs: {
      "depressed": "",
      "round": _vm.activeTab == 'artistBrand'
    },
    on: {
      "click": function($event) {
        _vm.activeTab = 'artistBrand'
      }
    }
  }, [_vm._v("\n            Artist / Brand\n          ")])], 1), _vm._v(" "), (_vm.activeTab == 'everyone') ? _c('div', {
    staticClass: "everyone_tab"
  }, [_c('ListenerRegister')], 1) : _vm._e(), _vm._v(" "), (_vm.activeTab == 'artistBrand') ? _c('div', {
    staticClass: "artistBrand_tab"
  }, [_c('InviteRegister', {
    on: {
      "invite-mode": _vm.setInviteMode
    }
  })], 1) : _vm._e()]) : _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "auth-card-child": "",
      "right-card": "",
      "sign-in-info": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center"
  }, [_c('b', [_vm._v("Check your email for confirmation")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-btn', {
    staticClass: "app-blue white--text",
    attrs: {
      "round": "",
      "depressed": ""
    }
  }, [_vm._v("Open email")])], 1)])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1772 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-section"
  }, [_vm._v("Timeline")])
},staticRenderFns: []}

/***/ }),
/* 1773 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('content-top-header', {
    staticClass: "black-theme"
  }, [_c('template', {
    slot: "topHeader"
  }, [_c('ul', {
    staticClass: "pr-3"
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('li', {
      key: tab.id,
      staticClass: "nav-li",
      class: [{
        'active': _vm.name === tab.id,
        'tab-active': _vm.tabActivePill
      }, ("nav-" + (tab.id))],
      attrs: {
        "href": ("#" + (tab.id))
      }
    }, [_c('label', {
      staticClass: "nav-label",
      on: {
        "click": function($event) {
          _vm.setTab(tab.pathName)
        }
      }
    }, [_vm._v("\n            " + _vm._s(tab.title) + "\n          ")])])
  }))])], 2)
},staticRenderFns: []}

/***/ }),
/* 1774 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "landing-page pa-4"
  }, [_c('div', {
    staticClass: "header-container ma-4"
  }, [_c('div', {
    staticClass: "header-content"
  }, [_c('div', {
    staticClass: "logo-and-menu"
  }, [_c('div', {
    staticClass: "logo-container"
  }, [_c('img', {
    staticClass: "cursor-pointer",
    attrs: {
      "src": "/static/images/landing-page/ys_logo_primary-black.svg",
      "aspect-ratio": "1",
      "height": "24",
      "width": "124"
    },
    on: {
      "click": function($event) {
        _vm.navigateTo('/')
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "links-container white--text font-space-grotesk font-weight-700 text-18"
  }, [_c('span', {
    staticClass: "menu-item cursor-pointer",
    class: {
      'active-menu': _vm.isUpgrade
    },
    on: {
      "click": function($event) {
        _vm.isUpgrade = true
      }
    }
  }, [_vm._v("\n              Upgrade\n            ")]), _vm._v(" "), _c('span', {
    staticClass: "menu-item cursor-pointer",
    on: {
      "click": function($event) {
        _vm.navigateTo('/for-creators')
      }
    }
  }, [_vm._v("\n              Creators\n            ")]), _vm._v(" "), _c('span', {
    staticClass: "menu-item cursor-pointer",
    on: {
      "click": function($event) {
        _vm.navigateTo('/login')
      }
    }
  }, [_vm._v("\n              Signin\n            ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "main-content"
  }, [(!_vm.isUpgrade) ? _c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-space-around": "",
      "row": "",
      "gap-8": ""
    }
  }, [_c('div', {
    staticClass: "blurb-container"
  }, [_c('div', {
    staticClass: "text-container white--text font-space-grotesk font-weight-500"
  }, [_c('span', {
    staticClass: "text-50"
  }, [_vm._v("\n              Music Streaming "), _c('br'), _vm._v("\n              Reinvented.\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "app-icons-container"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "row": "",
      "mt-4": "",
      "pt-4": ""
    }
  }, [_c('div', {
    staticClass: "app-icon-container"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/landing-page/apple-store.svg",
      "aspect-ratio": "1",
      "height": "54",
      "width": "187"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "app-icon-container"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/landing-page/google-play.svg",
      "aspect-ratio": "1",
      "height": "54",
      "width": "187"
    }
  })])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "image-container"
  }, [_c('div', {
    staticClass: "image-wrapper"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/landing-page/ys-landing-ios.png",
      "aspect-ratio": "1",
      "height": "805",
      "width": "452"
    }
  })])])]) : _c('UpgradePlan', {
    staticClass: "pa-5",
    attrs: {
      "category-plan": _vm.categoryPlan
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "fqa bg-grey-white"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": "",
      "column": ""
    }
  }, [_c('div', {
    staticClass: "text-40 font-space-grotesk font-weight-500 fqa__title w-100 pb-4 mb-3 text-center"
  }, [_vm._v("\n        FAQ\n      ")]), _vm._v(" "), (_vm.categoryPlan == 'creator') ? _c('div', _vm._l((_vm.creatorFaqs), function(faq, index) {
    return _c('div', {
      key: index,
      staticClass: "bg-white fqa__wrapper w-100 font-dm-sans mb-4"
    }, [_c('div', {
      class: [
        'text-22 font-weight-700 text-grey-purple cursor-pointer',
        faq.open ? 'mb-4' : 'mb-2'
      ],
      on: {
        "click": function($event) {
          _vm.toggleFaq(index, 'creator')
        }
      }
    }, [_vm._v("\n            " + _vm._s(faq.question) + "\n          ")]), _vm._v(" "), (faq.open) ? _c('div', {
      staticClass: "text-18 font-weight-500"
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(faq.answer)
      }
    })]) : _vm._e()])
  })) : _c('div', _vm._l((_vm.generalFaqs), function(faq, index) {
    return _c('div', {
      key: index,
      staticClass: "bg-white fqa__wrapper w-100 font-dm-sans mb-4"
    }, [_c('div', {
      class: [
        'text-22 font-weight-700 text-grey-purple cursor-pointer',
        faq.open ? 'mb-4' : 'mb-2'
      ],
      on: {
        "click": function($event) {
          _vm.toggleFaq(index, 'general')
        }
      }
    }, [_vm._v("\n            " + _vm._s(faq.question) + "\n          ")]), _vm._v(" "), (faq.open) ? _c('div', {
      staticClass: "text-18 font-weight-500"
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(faq.answer)
      }
    })]) : _vm._e()])
  }))])], 1), _vm._v(" "), _c('FooterLandingPage')], 1)
},staticRenderFns: []}

/***/ }),
/* 1775 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "display-flex justify-space-between align-center"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(598),
      "width": "9",
      "height": "18"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'YouMobile'
        })
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(44),
      "width": "100"
    }
  }), _vm._v(" "), _c('div')]), _vm._v(" "), _c('div', {
    staticClass: "text-dmsans-14 text-white d-flex justify-center align-center font-weight-500 my-4 error full-width"
  }, [_vm._v("\n    Checkout error\n  ")]), _vm._v(" "), _c('Card', {
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'ConfirmationMobile'
        })
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1776 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    staticClass: "page verify-page",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": ""
    }
  }, [(true) ? _c('div', {
    staticClass: "verifying-page"
  }, [_c('v-flex', {
    staticClass: "logo-section",
    attrs: {
      "xs12": ""
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "/static/images/logo.png"
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "content-section",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "left-section",
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('div', {
    staticClass: "body-section"
  }, [_c('h4', [_vm._v("Thank you for signing up with YouSound!")]), _vm._v(" "), _c('p', [_vm._v("\n                We’ve built powerful tools that allow you to maximize your\n                reach and generate revenue from your music.\n              ")]), _vm._v(" "), _c('p', [_vm._v("\n                Before artists can upload any content, we verify each artist\n                to ensure that the tools we offer are used responsibly. Each\n                artist is verified by individuals that specialize in the genre\n                you list your music under.\n              ")]), _vm._v(" "), _c('p', [_vm._v("\n                Please complete the questionnaire, and allow 3 days for a\n                response.\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "divider-section"
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "right-section",
    attrs: {
      "xs12": "",
      "sm8": ""
    }
  }, [_c('div', {
    staticClass: "header-section"
  }, [_c('h4', [_vm._v("Tell us about your music")])]), _vm._v(" "), _c('div', {
    staticClass: "body-section"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "pb-2": ""
    }
  }, [_c('v-flex', {
    staticClass: "input-text-section",
    attrs: {
      "xs12": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "What is your main Genre?",
      "single-line": "",
      "bottom": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.verifying_request.main_genre),
      callback: function($$v) {
        _vm.$set(_vm.verifying_request, "main_genre", $$v)
      },
      expression: "verifying_request.main_genre"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.verifying_request.releases),
      expression: "verifying_request.releases"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "How many releases do you have?"
    },
    domProps: {
      "value": (_vm.verifying_request.releases)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.verifying_request, "releases", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.verifying_request.soundcloud_url),
      expression: "verifying_request.soundcloud_url"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Soundcloud URL"
    },
    domProps: {
      "value": (_vm.verifying_request.soundcloud_url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.verifying_request, "soundcloud_url", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.verifying_request.bandcamp_url),
      expression: "verifying_request.bandcamp_url"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Bandcamp URL"
    },
    domProps: {
      "value": (_vm.verifying_request.bandcamp_url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.verifying_request, "bandcamp_url", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.verifying_request.website_url),
      expression: "verifying_request.website_url"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Website URL"
    },
    domProps: {
      "value": (_vm.verifying_request.website_url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.verifying_request, "website_url", $event.target.value)
      }
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-area-section",
    attrs: {
      "xs12": "",
      "sm7": ""
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.verifying_request.description),
      expression: "verifying_request.description"
    }],
    staticClass: "verifying-description form-control non-resizable",
    attrs: {
      "placeholder": "What artists and/or labels have you previously worked with?"
    },
    domProps: {
      "value": (_vm.verifying_request.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.verifying_request, "description", $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "action-section",
    attrs: {
      "row": ""
    }
  }, [_c('v-btn', {
    staticClass: "submit-btn"
  }, [_vm._v("Submit Your Application")])], 1)], 1)])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticClass: "verified-page"
  }, [_c('v-flex', {
    staticClass: "logo-section",
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "/static/images/logo.png"
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('h4', {
    staticClass: "verified-title"
  }, [_vm._v("Your application has been received!")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('label', {
    staticClass: "verified-text"
  }, [_vm._v("You are currently registered as a listener.")]), _vm._v(" "), _c('label', {
    staticClass: "verified-text"
  }, [_vm._v("While your account is being verified, you can discover new music\n          and follow users.")]), _vm._v(" "), _c('label', {
    staticClass: "verified-text"
  }, [_vm._v("If your account is approved, your activity will be transfered to\n          your Artist account.")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('v-btn', {
    staticClass: "awesome-btn"
  }, [_vm._v("Awesome, show me the music!")])], 1)], 1) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 1777 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "main-section",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticClass: "content-section",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "return-policy-section": "",
      "ma-0": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Return Policy")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.return_policy),
      expression: "user.return_policy"
    }],
    staticClass: "policy-area",
    style: ({
      height: _vm.textAreaHeight
    }),
    attrs: {
      "placeholder": "Write a return policy...",
      "rows": "5"
    },
    domProps: {
      "value": (_vm.user.return_policy)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "return_policy", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(!_vm.isSaveAllMode) ? _c('v-btn', {
    staticClass: "update-btn",
    nativeOn: {
      "click": function($event) {
        _vm.saveReturnPolicy()
      }
    }
  }, [_vm._v("Save")]) : _vm._e()], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "return-policy-section": "",
      "ma-0": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Shipping Policy")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.shipping_policy),
      expression: "user.shipping_policy"
    }],
    staticClass: "policy-area",
    style: ({
      height: _vm.textAreaHeight
    }),
    attrs: {
      "placeholder": "Write a shipping policy...",
      "rows": "5"
    },
    domProps: {
      "value": (_vm.user.shipping_policy)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "shipping_policy", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(!_vm.isSaveAllMode) ? _c('v-btn', {
    staticClass: "update-btn",
    nativeOn: {
      "click": function($event) {
        _vm.saveShippingPolicy()
      }
    }
  }, [_vm._v("Save")]) : _vm._e()], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "return-policy-section": "",
      "ma-0": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Size Chart")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.size_chart),
      expression: "user.size_chart"
    }],
    staticClass: "policy-area",
    style: ({
      height: _vm.textAreaHeight
    }),
    attrs: {
      "placeholder": "Write a size chart...",
      "rows": "5"
    },
    domProps: {
      "value": (_vm.user.size_chart)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "size_chart", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(!_vm.isSaveAllMode) ? _c('v-btn', {
    staticClass: "update-btn",
    nativeOn: {
      "click": function($event) {
        _vm.saveSizeChart()
      }
    }
  }, [_vm._v("Save")]) : _vm._e()], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "return-policy-section": "",
      "ma-0": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Privacy Policy")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.privacy_policy),
      expression: "user.privacy_policy"
    }],
    staticClass: "policy-area",
    style: ({
      height: _vm.textAreaHeight
    }),
    attrs: {
      "placeholder": "Write a privacy policy...",
      "rows": "5"
    },
    domProps: {
      "value": (_vm.user.privacy_policy)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "privacy_policy", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(!_vm.isSaveAllMode) ? _c('v-btn', {
    staticClass: "update-btn",
    nativeOn: {
      "click": function($event) {
        _vm.savePrivacyPolicy()
      }
    }
  }, [_vm._v("Save")]) : _vm._e()], 1)])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1778 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isPageReady) ? _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "content-class": "invite-dialog",
      "width": "440"
    },
    model: {
      value: (_vm.show_verification_modal),
      callback: function($$v) {
        _vm.show_verification_modal = $$v
      },
      expression: "show_verification_modal"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("\n        Free Account Credits\n      ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n        Are you sure you want to make these changes?\n      ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red",
      "dark": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.proceedFreeAccountCredit()
      }
    }
  }, [_vm._v("Yes")])], 1)], 1)], 1), _vm._v(" "), _c('content-top-header', {
    staticClass: "content-top-header-tab",
    attrs: {
      "height": 62
    }
  }, [_c('template', {
    slot: "topHeader"
  }, [_c('ul', _vm._l((_vm.subscriptions_tabs), function(tab) {
    return _c('li', {
      key: tab.id,
      class: {
        'active tab-active': tab.id == _vm.active_tab
      },
      attrs: {
        "href": ("#" + (tab.id))
      },
      on: {
        "click": function($event) {
          _vm.activeTab(tab)
        }
      }
    }, [_c('label', {
      staticClass: "innerBold"
    }, [_vm._v("\n            " + _vm._s(tab.title) + "\n          ")])])
  }))])], 2), _vm._v(" "), _c('v-tabs', {
    staticClass: "bg-natural-grey pt-70 px-4",
    attrs: {
      "dark": ""
    },
    model: {
      value: (_vm.active_tab),
      callback: function($$v) {
        _vm.active_tab = $$v
      },
      expression: "active_tab"
    }
  }, [_c('v-tabs-items', {
    staticStyle: {
      "border": "none"
    }
  }, _vm._l((_vm.subscriptions_tabs), function(tab) {
    return _c('v-tabs-content', {
      key: tab.id,
      attrs: {
        "id": tab.id
      }
    }, [_c('v-card', {
      attrs: {
        "flat": ""
      }
    }, [(_vm.active_tab != 'free_credit') ? _c('v-data-table', {
      staticClass: "user-table-x custom-data-table",
      attrs: {
        "headers": _vm.headers,
        "items": _vm.subscriptions,
        "search": _vm.search,
        "pagination": _vm.pagination,
        "rows-per-page-items": _vm.per_page_options,
        "total-items": _vm.total_subscriptions.length
      },
      on: {
        "update:pagination": function($event) {
          _vm.pagination = $event
        }
      },
      scopedSlots: _vm._u([{
        key: "items",
        fn: function(props) {
          return [_c('td', {
            staticClass: "text-xs-left"
          }, [_c('div', {
            staticClass: "avatar-image-wrapper ml-4 display-flex align-center gap-10"
          }, [_c('div', {
            staticClass: "avatar-image subscriptions-image",
            style: ({
              'background-image': 'url(' + props.item.avatar.url + ')',
            })
          }), _vm._v(" "), _c('div', [_c('div', {
            staticClass: "avatar-title"
          }, [_vm._v(_vm._s(props.item.username))]), _vm._v(" "), _c('div', {
            staticClass: "avatar-title text-back-80"
          }, [_vm._v("@" + _vm._s(props.item.slug))])])])]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-center"
          }, [_vm._v("\n                " + _vm._s(_vm._f("capitalize")(props.item.user_type)) + "\n              ")]), _vm._v(" "), (_vm.active_tab == 'cancelled' || _vm.active_tab === 'trial_drop_off') ? _c('td', {
            staticClass: "text-xs-center"
          }, [_vm._v("\n                " + _vm._s(props.item.initial_signup_type) + "\n              ")]) : _vm._e(), _vm._v(" "), _c('td', {
            staticClass: "text-xs-center"
          }, [_vm._v("\n                " + _vm._s(props.item.first_name) + " " + _vm._s(props.item.last_name) + "\n              ")]), _vm._v(" "), (_vm.active_tab != 'cancelled' && _vm.active_tab != 'trial' && _vm.active_tab != 'trial_drop_off') ? _c('td', {
            staticClass: "text-xs-center"
          }, [_vm._v("\n                " + _vm._s(_vm._f("formatDate")(props.item.trial_start)) + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.active_tab != 'cancelled' && _vm.active_tab != 'trial' && _vm.active_tab != 'trial_drop_off') ? _c('td', {
            staticClass: "text-xs-center"
          }, [_vm._v("\n                " + _vm._s(props.item.plan) + "\n              ")]) : _vm._e(), _vm._v(" "), _c('td', {
            staticClass: "text-xs-center"
          }, [_vm._v("\n                " + _vm._s(props.item.email) + "\n              ")]), _vm._v(" "), (_vm.active_tab != 'cancelled' && _vm.active_tab != 'trial_drop_off') ? _c('td', {
            staticClass: "text-xs-center"
          }, [_vm._v("\n                " + _vm._s(_vm.getNumberOfMonths(props.item.created_at)) + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.active_tab == 'trial' && _vm.active_tab != 'trial_drop_off') ? _c('td', {
            staticClass: "text-xs-center"
          }, [_vm._v("\n                " + _vm._s(Math.floor(props.item.free_trial_time / 60) + ' mins') + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.active_tab != 'artists') ? _c('td', {
            staticClass: "text-xs-center"
          }, [_vm._v("\n                " + _vm._s(_vm._f("formatDate")(props.item.trial_end)) + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.active_tab == 'artists') ? _c('td', {
            staticClass: "text-xs-center width-200"
          }, [_c('div', {
            staticClass: "dflex align-center"
          }, [_c('v-select', {
            staticClass: "month-dd",
            attrs: {
              "attach": "",
              "items": _vm.choose_month
            },
            on: {
              "change": function($event) {
                _vm.selectMonth($event, props.item.id)
              }
            }
          }), _vm._v(" "), _c('div', {
            staticClass: "plus-icon-u ml-2"
          }, [_c('img', {
            attrs: {
              "src": __webpack_require__(57),
              "width": "12px"
            },
            on: {
              "click": function($event) {
                _vm.increaseMonth(props.item.id)
              }
            }
          })])], 1)]) : _vm._e(), _vm._v(" "), (_vm.active_tab == 'artists') ? _c('td', {
            staticClass: "text-xs-center"
          }, [_c('v-btn', {
            staticClass: "signups-btn",
            attrs: {
              "color": "primary"
            },
            nativeOn: {
              "click": function($event) {
                _vm.openVerificationModal(props.item)
              }
            }
          }, [_vm._v("Verify User")])], 1) : _vm._e()]
        }
      }, {
        key: "pageText",
        fn: function(ref) {
          var pageStart = ref.pageStart;
          var pageStop = ref.pageStop;

          return [_vm._v("\n              From " + _vm._s(pageStart) + " to " + _vm._s(pageStop) + " out of\n              " + _vm._s(_vm.total_subscriptions) + "\n            ")]
        }
      }])
    }) : _vm._e(), _vm._v(" "), (_vm.active_tab == 'free_credit') ? _c('v-data-table', {
      staticClass: "user-table-x text-xs-left custom-data-table",
      attrs: {
        "headers": _vm.headers,
        "items": _vm.subscriptions,
        "pagination": _vm.pagination,
        "rows-per-page-items": _vm.per_page_options,
        "total-items": _vm.total_subscriptions.length,
        "search": _vm.search
      },
      on: {
        "update:pagination": function($event) {
          _vm.pagination = $event
        }
      },
      scopedSlots: _vm._u([{
        key: "items",
        fn: function(props) {
          return [_c('td', {
            staticClass: "text-xs-left"
          }, [_c('div', {
            staticClass: "avatar-image-wrapper ml-4 display-flex align-center gap-10"
          }, [_c('div', {
            staticClass: "avatar-image subscriptions-image",
            style: ({
              'background-image': 'url(' + props.item.avatar.url + ')',
            })
          }), _vm._v(" "), _c('div', [_c('div', {
            staticClass: "avatar-title"
          }, [_vm._v(_vm._s(props.item.username))]), _vm._v(" "), _c('div', {
            staticClass: "avatar-title text-back-80"
          }, [_vm._v("@" + _vm._s(props.item.slug))])])])]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-center"
          }, [_vm._v("\n                " + _vm._s(_vm._f("capitalize")(props.item.user_type)) + "\n              ")]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-center"
          }, [_vm._v("\n                " + _vm._s(props.item.first_name) + " " + _vm._s(props.item.last_name) + "\n              ")]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-center"
          }, [_vm._v("\n                " + _vm._s(_vm._f("formatDate")(props.item.created_at)) + "\n                ")]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-center"
          }, [_vm._v("\n                " + _vm._s(props.item.plan) + "\n              ")]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-center"
          }, [_vm._v("\n                " + _vm._s(Math.round(Math.abs((new Date(props.item.trial_end) - new Date()) / 86400000))) + " " + _vm._s(props.item.trial_end ? 'days' : '') + "\n              ")]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-center"
          }, [_vm._v("\n                " + _vm._s(props.item.email) + "\n              ")]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-center"
          }, [_vm._v("\n                " + _vm._s(_vm.getNumberOfMonths(props.item.created_at)) + "\n              ")]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-center width-200"
          }, [_c('div', {
            staticClass: "dflex align-center"
          }, [_c('v-select', {
            staticClass: "month-dd",
            attrs: {
              "attach": "",
              "items": _vm.choose_month
            },
            on: {
              "change": function($event) {
                _vm.selectMonth($event, props.item.id)
              }
            }
          }), _vm._v(" "), _c('div', {
            staticClass: "plus-icon-u ml-2"
          }, [_c('img', {
            attrs: {
              "src": __webpack_require__(57),
              "width": "12px"
            },
            on: {
              "click": function($event) {
                _vm.increaseMonth(props.item.id)
              }
            }
          })])], 1)]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-center"
          }, [_c('v-btn', {
            staticClass: "signups-btn",
            attrs: {
              "color": "primary"
            },
            nativeOn: {
              "click": function($event) {
                _vm.openVerificationModal(props.item)
              }
            }
          }, [_vm._v("Verify User")])], 1)]
        }
      }, {
        key: "pageText",
        fn: function(ref) {
          var pageStart = ref.pageStart;
          var pageStop = ref.pageStop;

          return [_vm._v("\n              From " + _vm._s(pageStart) + " to " + _vm._s(pageStop) + " out of\n              " + _vm._s(_vm.total_subscriptions) + "\n            ")]
        }
      }])
    }) : _vm._e()], 1)], 1)
  }))], 1)], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1779 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isPageReady) ? _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-tabs', {
    staticClass: "white",
    attrs: {
      "dark": ""
    },
    model: {
      value: (_vm.active_tab),
      callback: function($$v) {
        _vm.active_tab = $$v
      },
      expression: "active_tab"
    }
  }, [_c('v-tabs-bar', {
    staticClass: "transparent pl-4 mt-4"
  }, [_vm._l((_vm.tabs), function(tab) {
    return _c('v-tabs-item', {
      key: tab.id,
      attrs: {
        "href": '#' + tab.id,
        "ripple": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.onTab(tab.id)
        }
      }
    }, [_vm._v(_vm._s(tab.title))])
  }), _vm._v(" "), _c('v-tabs-slider', {
    attrs: {
      "color": "black"
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    staticClass: "search-input mr-4",
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.onKeyEnter($event)
      }
    },
    model: {
      value: (_vm.search_value),
      callback: function($$v) {
        _vm.search_value = $$v
      },
      expression: "search_value"
    }
  })], 2), _vm._v(" "), _c('v-tabs-items', {
    staticStyle: {
      "border": "none"
    }
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('v-tabs-content', {
      key: tab.id,
      attrs: {
        "id": tab.id
      }
    }, [_c('v-card', {
      attrs: {
        "flat": ""
      }
    }, [_c('v-data-table', {
      staticClass: "user-table",
      attrs: {
        "headers": _vm.headers,
        "items": _vm.items,
        "pagination": _vm.pagination,
        "rows-per-page-items": _vm.per_page_options,
        "total-items": _vm.total_items
      },
      on: {
        "update:pagination": function($event) {
          _vm.pagination = $event
        }
      },
      scopedSlots: _vm._u([{
        key: "items",
        fn: function(props) {
          return [_c('td', {
            staticClass: "text-xs-left"
          }, [_c('div', {
            staticClass: "avatar-image-wrapper"
          }, [_c('div', {
            staticClass: "avatar-image",
            style: ({
              'background-image': 'url(' + props.item.user.avatar.url + ')',
            })
          }), _vm._v(" "), _c('div', {
            staticClass: "avatar-title"
          }, [_vm._v("\n                    " + _vm._s(props.item.user.username) + "\n                  ")])])]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_vm._v("\n                " + _vm._s(props.item.name) + "\n              ")]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_vm._v("\n                " + _vm._s(_vm._f("formatDate")(props.item.created_at)) + "\n              ")]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_vm._v("\n                " + _vm._s(_vm._f("timeInHours")(props.item.broadcast_time)) + "\n              ")]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_vm._v("\n                " + _vm._s(props.item.total_viewers) + "\n              ")]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_vm._v("\n                " + _vm._s(_vm._.get(props.item, 'genre.name', '')) + "\n              ")]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [(props.item.view_price > 0) ? [_vm._v("\n                  $" + _vm._s(_vm._f("formatNumber")(props.item.view_price)) + "\n                ")] : [_vm._v(" Free ")]], 2), _vm._v(" "), _c('td', {
            staticClass: "text-xs-right"
          }, [(props.item.status === _vm.StreamStatuses.RUNNING) ? _c('v-btn', {
            staticClass: "stop-stream-btn",
            attrs: {
              "fab": "",
              "dark": "",
              "color": "pink"
            },
            on: {
              "click": function($event) {
                _vm.openStreamStopConfirmDialog(props.item)
              }
            }
          }, [_c('v-icon', [_vm._v("stop")])], 1) : _vm._e(), _vm._v(" "), (props.item.status === _vm.StreamStatuses.ARCHIVED) ? _c('v-btn', {
            staticClass: "stop-stream-btn",
            attrs: {
              "fab": "",
              "dark": "",
              "color": "gray"
            },
            on: {
              "click": function($event) {
                _vm.openStreamStopConfirmDialog(props.item)
              }
            }
          }, [_c('v-icon', [_vm._v("videocam")])], 1) : _vm._e()], 1)]
        }
      }, {
        key: "pageText",
        fn: function(ref) {
          var pageStart = ref.pageStart;
          var pageStop = ref.pageStop;

          return [_vm._v("\n              From " + _vm._s(pageStart) + " to " + _vm._s(pageStop) + " out of\n              " + _vm._s(_vm.total_items) + "\n            ")]
        }
      }])
    })], 1)], 1)
  }))], 1), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.show_stream_stop_confirm_dialog),
      callback: function($$v) {
        _vm.show_stream_stop_confirm_dialog = $$v
      },
      expression: "show_stream_stop_confirm_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Stop a Stream")]), _vm._v(" "), _c('v-card-text', [_vm._v("If you click OK, the stream will no longer be available. Click OK to\n        stop, or click Cancel.")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "red--text darken-1",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.deleteStream()
      }
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeStreamStopConfirmDialog()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-spacer')], 1)], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1780 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-section repost-price"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content-section"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "repost-price-select"
  }, [_c('v-select', {
    attrs: {
      "items": _vm.repost_prices,
      "item-text": "name",
      "item-value": "value",
      "label": "Price",
      "content-class": "GLOBAL-repost-price-select",
      "single-line": "",
      "auto": "",
      "dirty": "",
      "text-field": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.repost_price),
      callback: function($$v) {
        _vm.repost_price = $$v
      },
      expression: "repost_price"
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "update-btn",
    nativeOn: {
      "click": function($event) {
        _vm.openRepostPriceConfirmModal()
      }
    }
  }, [_vm._v("Set")])], 1), _vm._v(" "), _c('div', {
    staticClass: "repost-price-info-box pa-3 mt-2"
  }, [_c('div', [_vm._v("\n        You've upgraded to\n        "), _c('b', [_vm._v("$" + _vm._s(_vm._f("formatNumber")(_vm.currentUser.max_repost_price)))])]), _vm._v(" "), _c('div', [_vm._v("\n        Upgraded until\n        "), _c('b', [_vm._v(_vm._s(_vm._f("formatDate")(_vm.currentUser.repost_price_end_at)))])])])]), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.show_repost_price_confirm_modal),
      callback: function($$v) {
        _vm.show_repost_price_confirm_modal = $$v
      },
      expression: "show_repost_price_confirm_modal"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Upgrade Repost Price")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n        In order to upgrade your Repost Price you need to pay an annual fee\n        equal to the price you want to upgrade to."), _c('br'), _vm._v(" "), (_vm.proration.add_amount > 0) ? [_vm._v("You have to pay additional $" + _vm._s(_vm._f("formatNumber")(_vm.proration.add_amount)))] : _vm._e()], 2), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.openPaymentModal()
      }
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeRepostPriceConfirmModal()
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), (_vm.show_payment_modal) ? _c('payment-modal', {
    attrs: {
      "amount": _vm.proration.add_amount,
      "dismiss": _vm.closePaymentModal,
      "finish": _vm.setRepostPrice
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "description-section"
  }, [_c('h3', [_vm._v("Earn money by sharing content")]), _vm._v(" "), _c('p', {
    staticClass: "mt-2"
  }, [_vm._v("\n      Every user can accept $1 and earns 50% of the revenue split."), _c('br'), _vm._v("\n      Upgrade your price to keep 90% of each repost request.\n    ")]), _vm._v(" "), _c('ul', {
    staticClass: "mt-3"
  }, [_c('li', [_vm._v("\n        To increase your repost price, you must pay an annual amount equal to\n        the price you want to set"), _c('br'), _vm._v("\n        Example: To charge $20 per repost, you must pay $20 per year\n      ")]), _vm._v(" "), _c('li', [_vm._v("\n        If you want to increase your price multiple times within an year, your\n        cost is prorated\n      ")]), _vm._v(" "), _c('li', [_vm._v("\n        If you upgrade your price, you can downgrade your price at any time\n      ")])])])
}]}

/***/ }),
/* 1781 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "dblclick": function($event) {
        _vm.mini = !_vm.mini
      }
    }
  }, [(_vm.showNotification) ? _c('div', {
    staticClass: "notifcation-wrapper"
  }, [_c('div', {
    staticClass: "notification-overlay",
    on: {
      "click": function($event) {
        _vm.showNotification = false
      }
    }
  }), _vm._v(" "), _c('notifcationDrawer', {
    attrs: {
      "leftPos": _vm.mini ? 100 : 300
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "sidebar",
    attrs: {
      "permanent": "",
      "app": "",
      "fixed": "",
      "dark": "",
      "mini-variant": _vm.mini,
      "mobile-break-point": "",
      "width": _vm.sideBarWidth
    }
  }, [_c('div', [_c('div', {
    staticClass: "sidebar-decoy"
  }), _vm._v(" "), _c('div', {
    staticClass: "tabs-auth-wrapper"
  }, [_c('div', {
    staticClass: "dflex justify-space-between align-center mb-3"
  }, [_c('router-link', {
    staticClass: "sidebar-logo",
    attrs: {
      "to": {
        name: this.$store.state.auth.user &&
          this.$store.state.auth.user.request_role !== 'listener' ?
          'UploadAlbum' :
          'UserSettings',
      }
    }
  }, [(_vm.mini) ? _c('img', {
    staticClass: "_mini",
    attrs: {
      "src": "/static/images/nav_logo_white_mini.png"
    }
  }) : _c('img', {
    attrs: {
      "src": "/static/images/nav_logo_white.png"
    }
  })])], 1), _vm._v(" "), (
    _vm.currentUser &&
    _vm.currentUser.stream !== null &&
    _vm.$store.state.streamPlayer == 'active'
  ) ? _c('div', {
    staticClass: "live-notice",
    class: {
      'pl-0': _vm.mini
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'VideoManage'
        })
      }
    }
  }, [(!_vm.mini) ? _c('b', {
    staticClass: "__text"
  }, [_vm._v("View live broadcast")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "icon_wrapper",
    class: {
      dflex: _vm.mini
    }
  }, [_c('v-icon', [_vm._v("circle")]), _vm._v(" "), _c('span', {
    staticClass: "icon_text"
  }, [_vm._v("LIVE")])], 1)]) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "logout-modal"
    },
    model: {
      value: (_vm.show_logout_modal),
      callback: function($$v) {
        _vm.show_logout_modal = $$v
      },
      expression: "show_logout_modal"
    }
  }, [_c('logoutModal')], 1), _vm._v(" "), (_vm.isAuthenticated) ? _c('div', {
    staticClass: "d-flex gap-10 align-center profile-user"
  }, [_c('div', {
    staticClass: "profile-user__avatar"
  }, [_c('img', {
    attrs: {
      "src": _vm.currentUser.avatar.thumb.url
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-column gap-4"
  }, [_c('div', {
    staticClass: "profile-user__username"
  }, [_vm._v(_vm._s(_vm.currentUser.username))]), _vm._v(" "), _c('a', {
    staticClass: "profile-user__type",
    on: {
      "click": _vm.signOut
    }
  }, [_vm._v("Sign Out")])])]) : _vm._e(), _vm._v(" "), (_vm.isAuthenticated) ? _vm._l((_vm.tabs), function(parent, i) {
    return _c('v-list', {
      key: i,
      staticClass: "py-1 px-0"
    }, [_c('h4', [(parent.name) ? _c('h3', {
      staticClass: "px-3 subheader"
    }, [_vm._v("\n                " + _vm._s(parent.name) + "\n              ")]) : _vm._e()]), _vm._v(" "), _c('div', [(_vm.mini) ? _c('v-list-tile', {
      staticClass: "dflex justify-center align-center"
    }) : _vm._e(), _vm._v(" "), _vm._l((parent.items), function(subMenu, ii) {
      return (
        subMenu.id != 'search' || (subMenu.id === 'search' && _vm.mini)
      ) ? _c('v-list-tile', {
        key: ii,
        staticClass: "side-tab",
        class: [
          _vm.customActiveTab(subMenu) ? 'activeTab' : '',
          {
            'd-none': subMenu.allowedUser &&
              !subMenu.allowedUser.includes(_vm.currentUser.user_type),
          } ],
        attrs: {
          "active-class": subMenu.path ? 'activeTab' : '',
          "to": subMenu.id != 'search' && subMenu.directPath ?
            ("/" + (subMenu.path)) :
            {
              name: subMenu.path
            }
        },
        on: {
          "click": function($event) {
            subMenu.id === 'search' ? _vm.toggleSearch() : null
          }
        }
      }, [_c('v-list-tile-avatar', [(subMenu.id === 'you') ? _c('div', {
        staticClass: "profile-image",
        style: ({
          'background-image': 'url(' + _vm.currentUser.avatar.thumb.url + ')',
        })
      }) : _c('span', [(subMenu.icon.length > 50) ? _c('img', {
        staticClass: "icon _icon_img",
        class: [("icon_" + (subMenu.id))],
        attrs: {
          "src": subMenu.icon
        }
      }) : _c('v-icon', {
        staticClass: "__icon"
      }, [_vm._v("\n                      " + _vm._s(subMenu.icon) + "\n                    ")])], 1)]), _vm._v(" "), (!_vm.mini) ? _c('v-list-tile-title', {
        staticClass: "d-flex justify-space-between align-center"
      }, [(!_vm.mini) ? _c('span', {
        staticClass: "__title"
      }, [_vm._v("\n                    " + _vm._s(subMenu.title) + "\n                  ")]) : (
        subMenu.id === 'notifications' && _vm.badge.message > 0
      ) ? _c('span', {
        staticClass: "dot_notifications",
        class: {
          'mr-0 ml-1': _vm.mini
        }
      }, [_c('v-icon', {
        attrs: {
          "size": "1"
        }
      }, [_vm._v("circle")])], 1) : (subMenu.id === 'sales' && _vm.badge.sell > 0) ? _c('span', {
        staticClass: "dot_notifications",
        class: {
          'mr-0 ml-1': _vm.mini
        }
      }, [_c('v-icon', {
        attrs: {
          "size": "1"
        }
      }, [_vm._v("circle")])], 1) : (subMenu.id === 'cart' && _vm.badge.cart > 0) ? _c('span', {
        staticClass: "dot_notifications",
        class: {
          'mr-0 ml-1': _vm.mini
        }
      }, [_c('v-icon', {
        attrs: {
          "size": "1"
        }
      }, [_vm._v("circle")])], 1) : _vm._e()]) : _vm._e()], 1) : _vm._e()
    })], 2)])
  }) : _vm._l((_vm.tabs), function(parent, i) {
    return _c('v-list', {
      key: i,
      staticClass: "py-1 px-0"
    }, [_c('h4', [(parent.name) ? _c('h3', {
      staticClass: "px-3 subheader"
    }, [_vm._v("\n                " + _vm._s(parent.name) + "\n              ")]) : _vm._e()]), _vm._v(" "), _c('div', _vm._l((parent.items), function(subMenu, ii) {
      return (
        subMenu.id != 'search' || (subMenu.id == 'search' && _vm.mini)
      ) ? _c('v-list-tile', {
        key: ii,
        staticClass: "side-tab",
        class: [
          _vm.customActiveTab(subMenu) ? 'activeTab ${{subMenu}}' : '',
          {
            'd-none': subMenu.allowedUser &&
              _vm.currentUser &&
              !subMenu.allowedUser.includes(_vm.currentUser.user_type),
          } ],
        attrs: {
          "active-class": subMenu.path ? 'activeTab' : '',
          "to": subMenu.directPath ?
            ("/" + (subMenu.path)) :
            {
              name: subMenu.path
            }
        },
        on: {
          "click": function($event) {
            _vm.verifyUser(subMenu)
          }
        }
      }, [_c('v-list-tile-avatar', [(subMenu.id === 'you') ? _c('div', {
        staticClass: "profile-image"
      }) : _c('span', [(subMenu.icon.length > 50) ? _c('img', {
        staticClass: "icon _icon_img",
        class: [("icon_" + (subMenu.id))],
        attrs: {
          "src": subMenu.icon
        }
      }) : _c('v-icon', {
        staticClass: "__icon"
      }, [_vm._v("\n                      " + _vm._s(subMenu.icon) + "\n                    ")])], 1)]), _vm._v(" "), (!_vm.mini) ? _c('v-list-tile-title', {
        staticClass: "d-flex justify-space-between align-center"
      }, [(!_vm.mini) ? _c('span', {
        staticClass: "__title"
      }, [_vm._v("\n                    " + _vm._s(subMenu.title) + "\n                  ")]) : _vm._e(), _vm._v(" "), (subMenu.id === 'notifications' && _vm.badge.message > 0) ? _c('span', {
        staticClass: "dot_notifications",
        class: {
          'mr-0 ml-1': _vm.mini
        }
      }, [_c('v-icon', {
        attrs: {
          "size": "1"
        }
      }, [_vm._v("circle")])], 1) : (subMenu.id === 'sales' && _vm.badge.sell > 0) ? _c('span', {
        staticClass: "dot_notifications",
        class: {
          'mr-0 ml-1': _vm.mini
        }
      }, [_c('v-icon', {
        attrs: {
          "size": "1"
        }
      }, [_vm._v("circle")])], 1) : (subMenu.id === 'cart' && _vm.badge.cart > 0) ? _c('span', {
        staticClass: "dot_notifications",
        class: {
          'mr-0 ml-1': _vm.mini
        }
      }, [_c('v-icon', {
        attrs: {
          "size": "1"
        }
      }, [_vm._v("circle")])], 1) : _vm._e()]) : _vm._e()], 1) : _vm._e()
    }))])
  })], 2)]), _vm._v(" "), _c('div', [(!_vm.mini) ? _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$store.getters['player/isPlaying']),
      expression: "!$store.getters['player/isPlaying']"
    }],
    staticClass: "mx-2 d-flex flex-column align-center gap-14"
  }, [_c('img', {
    staticClass: "cursor-pointer",
    attrs: {
      "src": __webpack_require__(1440),
      "max-height": "59",
      "max-width": "220"
    },
    on: {
      "click": function($event) {
        _vm.openQrCode(_vm.qrCodeTypeList.IOS)
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "cursor-pointer",
    attrs: {
      "src": __webpack_require__(1457),
      "max-height": "59",
      "max-width": "220"
    },
    on: {
      "click": function($event) {
        _vm.openQrCode(_vm.qrCodeTypeList.ANDROID)
      }
    }
  })]), _vm._v(" "), (!_vm.onMobile) ? _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [_c('side-audio-player', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$store.getters['navigator/hasAudioPlayer']),
      expression: "$store.getters['navigator/hasAudioPlayer']"
    }],
    ref: "audioPlayer",
    attrs: {
      "isMini": _vm.mini
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.mini) ? _c('div', {
    staticClass: "thumbnail-mini-song"
  }, [_c('img', {
    attrs: {
      "src": this.$store.state.player.currentTrackPlaying &&
        this.$store.state.player.currentTrackPlaying.album &&
        this.$store.state.player.currentTrackPlaying.album.cover.url,
      "width": "100%"
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.mini) ? _c('div', {
    staticClass: "side-lang-outer my-5 mx-3"
  }) : _vm._e(), _vm._v(" "), (_vm.mini) ? _c('div', {
    staticClass: "toggle-sidebar _bottom"
  }, [_c('img', {
    staticClass: "cursor-pointer",
    class: {
      inversed: !_vm.mini
    },
    attrs: {
      "src": "/static/images/slide-right.svg"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.mini = !_vm.mini
      }
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('QrCode', {
    ref: "qrCode"
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1782 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('app-card', {
    attrs: {
      "image": _vm.userImage,
      "imageLink": ("/" + (_vm.user.username)),
      "title": _vm.userName,
      "titleLink": ("/" + (_vm.user.username)),
      "description": _vm.userType,
      "meta": _vm.userMeta
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1783 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.loading) ? [_c('div', {
    staticClass: "my-overlay",
    on: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  }), _vm._v(" "), (!_vm.show_error_dialog) ? _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__header"
  }, [_c('h4', [_vm._v("Payment")]), _vm._v(" "), _c('div', {
    staticClass: "close-icon",
    on: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1532),
      "width": "32"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "divider my-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "mb-2 heading"
  }, [_vm._v("Purchase")]), _vm._v(" "), _c('div', {
    staticClass: "con_container"
  }, [_c('div', {
    staticClass: "dflex justify-space-between align-center"
  }, [_c('div', {
    staticClass: "heading"
  }, [_vm._v("Product purchase")]), _vm._v(" "), _c('div', {
    staticClass: "heading"
  }, [_vm._v("$" + _vm._s(_vm._f("formatNumber")((_vm.amount + _vm.fee))))])]), _vm._v(" "), _c('div', {
    staticClass: "divider my-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "subheading"
  }, [_vm._v("\n         Sellers have 21 days to ship your items or your order is automatically refunded.\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "mb-2 mt-3 heading"
  }, [_vm._v("Credit card")]), _vm._v(" "), _c('div', {
    staticClass: "card-inputs"
  }, [_c('card-number', {
    ref: "cardNumber",
    staticClass: "stripe-element card-number payment-card",
    class: {
      complete: _vm.complete
    },
    attrs: {
      "stripe": _vm.stripe_publishable_key,
      "options": _vm.stripeOptions
    },
    on: {
      "change": function($event) {
        _vm.number = $event.complete
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "card-box-bottom"
  }, [_c('card-expiry', {
    ref: "cardExpiry",
    staticClass: "stripe-element card-expiry payment-card",
    class: {
      complete: _vm.complete
    },
    attrs: {
      "stripe": _vm.stripe_publishable_key,
      "options": _vm.stripeOptions
    },
    on: {
      "change": function($event) {
        _vm.expiry = $event.complete
      }
    }
  }), _vm._v(" "), _c('card-cvc', {
    ref: "cardCvc",
    staticClass: "stripe-element card-cvc payment-card",
    class: {
      complete: _vm.complete
    },
    attrs: {
      "stripe": _vm.stripe_publishable_key,
      "options": _vm.stripeOptions
    },
    on: {
      "change": function($event) {
        _vm.cvc = $event.complete
      }
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "btn-cta",
    nativeOn: {
      "click": function($event) {
        _vm.sendPayment()
      }
    }
  }, [_vm._v("\n          Pay $" + _vm._s(_vm._f("formatNumber")((_vm.amount + _vm.fee))) + "\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "box__content"
  }), _vm._v(" "), _c('div', {
    staticClass: "divider my-4"
  }), _vm._v(" "), _vm._m(0)]) : _c('v-dialog', {
    attrs: {
      "content-class": "invite-dialog",
      "width": "440"
    },
    model: {
      value: (_vm.show_error_dialog),
      callback: function($$v) {
        _vm.show_error_dialog = $$v
      },
      expression: "show_error_dialog"
    }
  }, [_c('v-card', [(_vm.receiverAvatar) ? _c('v-card-media', {
    attrs: {
      "src": _vm.receiverAvatar,
      "height": "125px",
      "contain": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("\n        You cannot send the payment\n      ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n        " + _vm._s(_vm.receiverName) + " did not connect to stripe yet\n      ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "black",
      "dark": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1)] : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box__footer"
  }, [_c('div', {
    staticClass: "stripe-info"
  }, [_c('label', [_vm._v("Powered by")]), _vm._v(" "), _c('span', [_vm._v("stripe")])])])
}]}

/***/ }),
/* 1784 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "relative mb-5"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "absolute display-flex align-center justify-space-between profile__header"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(317),
      "width": "27"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'PlanMobile'
        })
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(117),
      "width": "27"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'CommunityMobile'
        })
      }
    }
  })]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "display-flex align-center full-width my-3 px-4"
  }, [_c('v-btn', {
    staticClass: "profile__btn",
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'PlanMobile'
        })
      }
    }
  }, [_vm._v("\n      Follow\n    ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "profile__btn",
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'ChatRoomMobile'
        })
      }
    }
  }, [_vm._v("\n      Chat live!\n    ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "horizontal-scroll my-4 px-4"
  }, _vm._l((_vm.categoryList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "profile__category horizontal-scroll__item display-flex justify-center align-center mr-2 px-4",
      class: {
        'bg-white text-black': item.active
      }
    }, [_vm._v("\n      " + _vm._s(item.text) + "\n    ")])
  })), _vm._v(" "), _c('div', {
    staticClass: "text-poppins-16 font-weight-700 mt-2 px-4"
  }, [_vm._v("Albums")]), _vm._v(" "), _c('div', {
    staticClass: "horizontal-scroll px-4"
  }, _vm._l((5), function(i) {
    return _c('div', {
      key: i,
      staticClass: "horizontal-scroll__item mr-2 mb-2"
    }, [_vm._m(2, true), _vm._v(" "), _c('div', {
      staticClass: "font-15 font-weight-500 text-white"
    }, [_vm._v("Album")]), _vm._v(" "), _c('div', {
      staticClass: "text-grey-4 font-15 font-weight-500"
    }, [_vm._v("Artist name")])])
  })), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "horizontal-scroll px-4"
  }, _vm._l((5), function(i) {
    return _c('div', {
      key: i,
      staticClass: "horizontal-scroll__item mr-2 mb-2"
    }, [_vm._m(4, true), _vm._v(" "), _c('div', {
      staticClass: "font-15 font-weight-500 text-white"
    }, [_vm._v("Album")]), _vm._v(" "), _c('div', {
      staticClass: "text-grey-4 font-15 font-weight-500"
    }, [_vm._v("Artist name")])])
  })), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "horizontal-scroll px-4"
  }, _vm._l((5), function(i) {
    return _c('div', {
      key: i,
      staticClass: "horizontal-scroll__item mr-2 mb-2"
    }, [_vm._m(6, true), _vm._v(" "), _c('div', {
      staticClass: "font-15 font-weight-500 text-white"
    }, [_vm._v("Album")]), _vm._v(" "), _c('div', {
      staticClass: "text-grey-4 font-15 font-weight-500"
    }, [_vm._v("Artist name")])])
  }))])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticClass: "max-full-width",
    attrs: {
      "src": __webpack_require__(118)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "absolute profile__username"
  }, [_c('img', {
    staticClass: "max-full-width",
    attrs: {
      "src": __webpack_require__(1520)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "profile__username__name"
  }, [_c('span', [_vm._v(" Salva ")]), _vm._v(" "), _c('img', {
    staticClass: "max-full-width",
    attrs: {
      "src": __webpack_require__(315)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "profile__username__type"
  }, [_vm._v("@salva • 423.2k Followers")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": __webpack_require__(600),
      "width": "151",
      "height": "151"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "display-flex justify-space-between align-center mt-2 px-4"
  }, [_c('div', {
    staticClass: "text-poppins-16 font-weight-700"
  }, [_vm._v("Products")]), _vm._v(" "), _c('div', {
    staticClass: "see-all font-weight-500"
  }, [_vm._v("See All")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": __webpack_require__(1513),
      "width": "151",
      "height": "151"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "display-flex justify-space-between align-center mt-2 px-4"
  }, [_c('div', {
    staticClass: "text-poppins-16 font-weight-700"
  }, [_vm._v("Playlists")]), _vm._v(" "), _c('div', {
    staticClass: "see-all font-weight-500"
  }, [_vm._v("See All")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": __webpack_require__(1514),
      "width": "151",
      "height": "151"
    }
  })])
}]}

/***/ }),
/* 1785 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "bg-grey-white": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-select', {
    staticClass: "normal-input ml-4 select-dashboard",
    attrs: {
      "items": _vm.globalstats_categories,
      "autocomplete": ""
    },
    model: {
      value: (_vm.globalstats_category),
      callback: function($$v) {
        _vm.globalstats_category = $$v
      },
      expression: "globalstats_category"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "d-flex": "",
      "xs12": "",
      "sm6": "",
      "md3": ""
    }
  }, [_c('DashboardItem', {
    staticClass: "bg-white ma-2 pa-4 dashboard__item",
    attrs: {
      "title": "Users",
      "number": _vm.statsList.total_users
    }
  }, [_c('div', {
    staticClass: "my-4"
  }, [_c('DonutChart')], 1)])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "d-flex": "",
      "xs12": "",
      "sm6": "",
      "md3": ""
    }
  }, [_c('DashboardItem', {
    staticClass: "bg-white ma-2 pa-4 dashboard__item",
    attrs: {
      "title": "Subscribers",
      "number": '0'
    }
  }, [_c('div', {
    staticClass: "my-4"
  }, [_c('DonutChart')], 1)])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "d-flex": "",
      "xs12": "",
      "sm6": "",
      "md2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "d-flex": "",
      "xs12": ""
    }
  }, [_c('DashboardItem', {
    staticClass: "bg-white ma-2 pa-4 dashboard__item",
    attrs: {
      "title": "Artist signups",
      "number": _vm.statsList.signup_artist_users
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "d-flex": "",
      "xs12": ""
    }
  }, [_c('DashboardItem', {
    staticClass: "bg-white ma-2 pa-4 dashboard__item",
    attrs: {
      "title": "Total Uploads",
      "number": _vm.statsList.total_tracks
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "d-flex": "",
      "xs12": "",
      "sm6": "",
      "md2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "d-flex": "",
      "xs12": ""
    }
  }, [_c('DashboardItem', {
    staticClass: "bg-white ma-2 pa-4 dashboard__item",
    attrs: {
      "title": "Listener signups",
      "number": _vm.statsList.signup_listener_users
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "d-flex": "",
      "xs12": ""
    }
  }, [_c('DashboardItem', {
    staticClass: "bg-white ma-2 pa-4 dashboard__item",
    attrs: {
      "title": "Total Plays",
      "number": '' + _vm.statsList.played_albums
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "d-flex": "",
      "xs12": "",
      "sm6": "",
      "md2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "d-flex": "",
      "xs12": ""
    }
  }, [_c('DashboardItem', {
    staticClass: "bg-white ma-2 pa-4 dashboard__item",
    attrs: {
      "title": "Playlists created",
      "number": '' + _vm.statsList.created_playlists
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "bg-grey-white": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "d-flex": "",
      "xs12": "",
      "sm12": "",
      "md6": ""
    }
  }, [_c('DashboardItem', {
    staticClass: "bg-white ma-2 pa-4 dashboard__item chart-line",
    attrs: {
      "title": "Total Subscription Revenue",
      "number": _vm.statsList.donations_revenue
    }
  }, [_c('div', {
    staticClass: "my-4"
  }, [_c('LineChart')], 1)])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "d-flex": "",
      "xs12": "",
      "sm12": "",
      "md6": ""
    }
  }, [_c('DashboardItem', {
    staticClass: "bg-white ma-2 pa-4 dashboard__item chart-line",
    attrs: {
      "title": "Total Product sales",
      "number": _vm.statsList.sold_products
    }
  }, [_c('div', {
    staticClass: "my-4"
  }, [_c('LineChart')], 1)])], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "bg-grey-white": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "d-flex": "",
      "xs12": "",
      "sm12": "",
      "md6": ""
    }
  }, [_c('DashboardItem', {
    staticClass: "bg-white ma-2 pa-4 dashboard__item chart-line",
    attrs: {
      "title": "Top streamed artists"
    }
  }, [_c('div', {
    staticClass: "my-4"
  }, _vm._l((_vm.statsList.top_5_played_genres), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "display-flex align-center justify-space-between font-inter text-14 my-3"
    }, [_c('span', {
      staticClass: "font-weight-500 text-grey-black-2"
    }, [_vm._v("\n              " + _vm._s(item.name) + "\n            ")]), _vm._v(" "), _c('span', {
      staticClass: "font-weight-600"
    }, [_vm._v(_vm._s(item.users_size) + " plays")])])
  }))])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "d-flex": "",
      "xs12": "",
      "sm12": "",
      "md6": ""
    }
  }, [_c('DashboardItem', {
    staticClass: "bg-white ma-2 pa-4 dashboard__item chart-line",
    attrs: {
      "title": "Most streamed spotlight videos"
    }
  }, [_c('div', {
    staticClass: "my-4"
  }, _vm._l((_vm.statsList.top_5_downloaded_genres), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "display-flex align-center justify-space-between font-inter text-14 my-3"
    }, [_c('span', {
      staticClass: "font-weight-500 text-grey-black-2"
    }, [_vm._v("\n              " + _vm._s(item.name) + "\n            ")]), _vm._v(" "), _c('span', {
      staticClass: "font-weight-600"
    }, [_vm._v(_vm._s(item.users_size) + " plays")])])
  }))])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1786 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "discover-nav"
  }, [_c('content-top-header', {
    staticClass: "black-theme"
  }, [_c('template', {
    staticClass: "justify-content-start",
    slot: "topHeader"
  }, [_c('div', {
    staticClass: "dflex align-center"
  }, [_c('ul', {
    staticClass: "pr-3"
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('li', {
      key: tab.id,
      staticClass: "nav-li",
      class: [{
        active: _vm.isActiveTab(tab.id)
      }, ("nav-" + (tab.id))],
      attrs: {
        "href": ("#" + (tab.id))
      }
    }, [_c('label', {
      staticClass: "nav-label",
      on: {
        "click": function($event) {
          _vm.onTab(tab.id)
        }
      }
    }, [_vm._v("\n              " + _vm._s(tab.title) + " ")])])
  }))])])], 2), _vm._v(" "), (_vm.currentUser) ? _c('v-dialog', {
    attrs: {
      "fullscreen": _vm.onMobile,
      "content-class": [("my-genre-dialog ma-0 pa-2 " + (_vm.onMobile ? 'onMobile' : ''))]
    },
    model: {
      value: (_vm.show_genre_selector_dialog),
      callback: function($$v) {
        _vm.show_genre_selector_dialog = $$v
      },
      expression: "show_genre_selector_dialog"
    }
  }, [_c('genre-dialog', {
    attrs: {
      "dismiss": _vm.closeGenreSelectorDialog
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1787 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page partners-page mx-5"
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs5": "",
      "layer-flex": "",
      "flex-text": ""
    }
  }, [_c('h1', [_vm._v("YouSound "), _c('br'), _vm._v("Partners")]), _vm._v(" "), _c('span', [_c('v-btn', {
    staticClass: "black white--text mt-4"
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("south")]), _vm._v(" "), _c('span', [_vm._v("Learn More")])], 1)], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": "",
      "layer-flex": "",
      "flex-img": ""
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": "/static/images/up_partnerbg.svg"
    }
  })])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": "",
      "layer-flex": "",
      "flex-img": ""
    }
  }, [_c('img', {
    attrs: {
      "width": "80%",
      "src": "/static/images/up_growthbg.svg"
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": "",
      "layer-flex": "",
      "flex-text": ""
    }
  }, [_c('h2', [_vm._v("Get Paid")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Share ad & subscription revenue")]), _vm._v(" "), _c('li', [_vm._v("User-centric payouts")])])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "section-faq"
  }, [_c('div', {
    staticClass: "__intro-title"
  }, [_vm._v("FAQ")]), _vm._v(" "), _c('accordion', {
    attrs: {
      "accordions": _vm.accordions,
      "leftIcon": "add"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1788 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isPageReady) ? _c('div', {
    staticClass: "main-section"
  }, [_c('v-flex', {
    staticClass: "verification-section",
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('div', {
    staticClass: "profile-section border-bottom mx-3 pb-3"
  }, [_c('div', {
    staticClass: "profile-image",
    style: ({
      'background-image': 'url(' + _vm.user.avatar.url + ')'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "user-info-section"
  }, [_c('div', {
    staticClass: "info-section"
  }, [_c('label', {
    staticClass: "user-name"
  }, [_vm._v(_vm._s(_vm.user.username))]), _vm._v(" "), _c('label', {
    staticClass: "denied-status",
    class: _vm.user.request_status
  }, [_vm._v(_vm._s(_vm.user.request_status))])])])]), _vm._v(" "), (['accepted', 'denied'].indexOf(_vm.user.request_status) > -1) ? _c('div', {
    staticClass: "link-section border-bottom mx-3 py-2"
  }, [_c('label', [_vm._v("Verified By: ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.reviewerName))]), _vm._v(" "), _c('label', {
    staticClass: "pl-4"
  }, [_vm._v("Date Verified: ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("formatDate")(_vm.user.approved_at)))])]) : _vm._e(), _vm._v(" "), (_vm.user.request_status == 'denied') ? _c('v-layout', {
    staticClass: "about-section border-bottom mx-3 pt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('label', [_vm._v("Reasons For Denial")]), _vm._v(" "), _c('p', {
    staticClass: "link-title"
  }, [_vm._v(_vm._s(_vm.user.denial_reason))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('label', [_vm._v("Denial Description")]), _vm._v(" "), _c('p', {
    staticClass: "link-title"
  }, [_vm._v(_vm._s(_vm.user.denial_description))])])], 1) : _vm._e(), _vm._v(" "), (_vm.user.request_status != 'accepted') ? _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit()
      }
    }
  }, [_c('div', {
    staticClass: "info-section mx-3"
  }, [_c('v-layout', {
    staticClass: "border-bottom",
    attrs: {
      "row": "",
      "wrap": "",
      "pb-3": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.first_name),
      expression: "user.first_name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "disabled": !_vm.enabledForm,
      "type": "text",
      "name": "first_name",
      "autocomplete": "off",
      "placeholder": "First Name"
    },
    domProps: {
      "value": (_vm.user.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "first_name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.last_name),
      expression: "user.last_name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "disabled": !_vm.enabledForm,
      "type": "text",
      "name": "last_name",
      "autocomplete": "off",
      "placeholder": "Last Name"
    },
    domProps: {
      "value": (_vm.user.last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "last_name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.year_of_birth_options,
      "disabled": !_vm.enabledForm,
      "name": "year_of_birth",
      "placeholder": "Year of Birth",
      "autocomplete": ""
    },
    model: {
      value: (_vm.user.year_of_birth),
      callback: function($$v) {
        _vm.$set(_vm.user, "year_of_birth", $$v)
      },
      expression: "user.year_of_birth"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.gender_options,
      "disabled": !_vm.enabledForm,
      "name": "gender",
      "placeholder": "Sex"
    },
    model: {
      value: (_vm.user.gender),
      callback: function($$v) {
        _vm.$set(_vm.user, "gender", $$v)
      },
      expression: "user.gender"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.country_options,
      "disabled": !_vm.enabledForm,
      "name": "country",
      "placeholder": "Country",
      "autocomplete": ""
    },
    model: {
      value: (_vm.user.country),
      callback: function($$v) {
        _vm.$set(_vm.user, "country", $$v)
      },
      expression: "user.country"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.city),
      expression: "user.city"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "disabled": !_vm.enabledForm,
      "type": "text",
      "name": "city",
      "autocomplete": "off",
      "placeholder": "City"
    },
    domProps: {
      "value": (_vm.user.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "city", $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "border-bottom",
    attrs: {
      "row": "",
      "wrap": "",
      "pb-3": ""
    }
  }, [(_vm.user.request_role == 'artist') ? [_c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.main_genres,
      "item-value": "id",
      "item-text": "name",
      "disabled": !_vm.enabledForm,
      "name": "main_genre",
      "placeholder": "What is your main Genre?",
      "autocomplete": ""
    },
    model: {
      value: (_vm.user.genre_id),
      callback: function($$v) {
        _vm.$set(_vm.user, "genre_id", $$v)
      },
      expression: "user.genre_id"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.artist_type_options,
      "disabled": !_vm.enabledForm,
      "name": "artist_type",
      "placeholder": "What type of artist are you?"
    },
    model: {
      value: (_vm.user.artist_type),
      callback: function($$v) {
        _vm.$set(_vm.user, "artist_type", $$v)
      },
      expression: "user.artist_type"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.released_albums_count_options,
      "item-value": "id",
      "item-text": "name",
      "disabled": !_vm.enabledForm,
      "name": "released_albums_count",
      "placeholder": "How many albums have you released?"
    },
    model: {
      value: (_vm.user.released_albums_count),
      callback: function($$v) {
        _vm.$set(_vm.user, "released_albums_count", $$v)
      },
      expression: "user.released_albums_count"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.years_since_first_released_options,
      "item-value": "id",
      "item-text": "name",
      "disabled": !_vm.enabledForm,
      "name": "years_since_first_released",
      "placeholder": "How many years since your first release?"
    },
    model: {
      value: (_vm.user.years_since_first_released),
      callback: function($$v) {
        _vm.$set(_vm.user, "years_since_first_released", $$v)
      },
      expression: "user.years_since_first_released"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.boolean_options,
      "item-value": "id",
      "item-text": "name",
      "disabled": !_vm.enabledForm,
      "name": "will_run_live_video",
      "placeholder": "Do you plan to run live video on YouSound?"
    },
    model: {
      value: (_vm.user.will_run_live_video),
      callback: function($$v) {
        _vm.$set(_vm.user, "will_run_live_video", $$v)
      },
      expression: "user.will_run_live_video"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.boolean_options,
      "item-value": "id",
      "item-text": "name",
      "disabled": !_vm.enabledForm,
      "name": "will_sell_products",
      "placeholder": "Do you sell products?"
    },
    model: {
      value: (_vm.user.will_sell_products),
      callback: function($$v) {
        _vm.$set(_vm.user, "will_sell_products", $$v)
      },
      expression: "user.will_sell_products"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.boolean_options,
      "item-value": "id",
      "item-text": "name",
      "disabled": !_vm.enabledForm,
      "name": "will_sell_physical_copies",
      "placeholder": "Do you sell physical copies of your music?"
    },
    model: {
      value: (_vm.user.will_sell_physical_copies),
      callback: function($$v) {
        _vm.$set(_vm.user, "will_sell_physical_copies", $$v)
      },
      expression: "user.will_sell_physical_copies"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.annual_income_on_merch_sales_options,
      "item-value": "id",
      "item-text": "name",
      "disabled": !_vm.enabledForm,
      "name": "annual_income_on_merch_sales",
      "placeholder": "Annual income on product sales"
    },
    model: {
      value: (_vm.user.annual_income_on_merch_sales),
      callback: function($$v) {
        _vm.$set(_vm.user, "annual_income_on_merch_sales", $$v)
      },
      expression: "user.annual_income_on_merch_sales"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.annual_performances_count_options,
      "item-value": "id",
      "item-text": "name",
      "disabled": !_vm.enabledForm,
      "name": "annual_performances_count",
      "placeholder": "How many show do you perform annually?"
    },
    model: {
      value: (_vm.user.annual_performances_count),
      callback: function($$v) {
        _vm.$set(_vm.user, "annual_performances_count", $$v)
      },
      expression: "user.annual_performances_count"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.signed_status_options,
      "item-value": "id",
      "item-text": "name",
      "disabled": !_vm.enabledForm,
      "name": "signed_status",
      "placeholder": "Are you currently signed?"
    },
    model: {
      value: (_vm.user.signed_status),
      callback: function($$v) {
        _vm.$set(_vm.user, "signed_status", $$v)
      },
      expression: "user.signed_status"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.performance_rights_organization_options,
      "item-value": "id",
      "item-text": "name",
      "disabled": !_vm.enabledForm,
      "name": "performance_rights_organization",
      "placeholder": "Performance Rights Organization (Writers)",
      "autocomplete": ""
    },
    model: {
      value: (_vm.user.performance_rights_organization),
      callback: function($$v) {
        _vm.$set(_vm.user, "performance_rights_organization", $$v)
      },
      expression: "user.performance_rights_organization"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.ipi_cae_number),
      expression: "user.ipi_cae_number"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "disabled": !_vm.enabledForm,
      "type": "text",
      "name": "ipi_cae_number",
      "autocomplete": "off",
      "placeholder": "IPI/CAE number"
    },
    domProps: {
      "value": (_vm.user.ipi_cae_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "ipi_cae_number", $event.target.value)
      }
    }
  })])] : (_vm.user.request_role == 'label') ? [_c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.main_genres,
      "item-value": "id",
      "item-text": "name",
      "disabled": !_vm.enabledForm,
      "name": "main_genre",
      "placeholder": "What is your main Genre?",
      "autocomplete": ""
    },
    model: {
      value: (_vm.user.genre_id),
      callback: function($$v) {
        _vm.$set(_vm.user, "genre_id", $$v)
      },
      expression: "user.genre_id"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.sub_genres,
      "item-value": "id",
      "item-text": "name",
      "disabled": !_vm.enabledForm,
      "name": "sub_genre",
      "placeholder": "What sub genre do you release most?",
      "autocomplete": ""
    },
    model: {
      value: (_vm.user.sub_genre_id),
      callback: function($$v) {
        _vm.$set(_vm.user, "sub_genre_id", $$v)
      },
      expression: "user.sub_genre_id"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.released_albums_count_options,
      "item-value": "id",
      "item-text": "name",
      "disabled": !_vm.enabledForm,
      "name": "released_albums_count",
      "placeholder": "How many albums have you released?"
    },
    model: {
      value: (_vm.user.released_albums_count),
      callback: function($$v) {
        _vm.$set(_vm.user, "released_albums_count", $$v)
      },
      expression: "user.released_albums_count"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.years_since_first_released_options,
      "item-value": "id",
      "item-text": "name",
      "disabled": !_vm.enabledForm,
      "name": "years_since_first_released",
      "placeholder": "How many years since your first release?"
    },
    model: {
      value: (_vm.user.years_since_first_released),
      callback: function($$v) {
        _vm.$set(_vm.user, "years_since_first_released", $$v)
      },
      expression: "user.years_since_first_released"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.boolean_options,
      "item-value": "id",
      "item-text": "name",
      "disabled": !_vm.enabledForm,
      "name": "will_run_live_video",
      "placeholder": "Do you plan to run live video on YouSound?"
    },
    model: {
      value: (_vm.user.will_run_live_video),
      callback: function($$v) {
        _vm.$set(_vm.user, "will_run_live_video", $$v)
      },
      expression: "user.will_run_live_video"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.boolean_options,
      "item-value": "id",
      "item-text": "name",
      "disabled": !_vm.enabledForm,
      "name": "will_sell_products",
      "placeholder": "Do you sell products?"
    },
    model: {
      value: (_vm.user.will_sell_products),
      callback: function($$v) {
        _vm.$set(_vm.user, "will_sell_products", $$v)
      },
      expression: "user.will_sell_products"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.boolean_options,
      "item-value": "id",
      "item-text": "name",
      "disabled": !_vm.enabledForm,
      "name": "will_sell_physical_copies",
      "placeholder": "Do you sell physical copies of your music?"
    },
    model: {
      value: (_vm.user.will_sell_physical_copies),
      callback: function($$v) {
        _vm.$set(_vm.user, "will_sell_physical_copies", $$v)
      },
      expression: "user.will_sell_physical_copies"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.annual_income_on_merch_sales_options,
      "item-value": "id",
      "item-text": "name",
      "disabled": !_vm.enabledForm,
      "name": "annual_income_on_merch_sales",
      "placeholder": "Annual income on product sales"
    },
    model: {
      value: (_vm.user.annual_income_on_merch_sales),
      callback: function($$v) {
        _vm.$set(_vm.user, "annual_income_on_merch_sales", $$v)
      },
      expression: "user.annual_income_on_merch_sales"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.boolean_options,
      "item-value": "id",
      "item-text": "name",
      "disabled": !_vm.enabledForm,
      "name": "is_business_registered",
      "placeholder": "Is your business registered?"
    },
    model: {
      value: (_vm.user.is_business_registered),
      callback: function($$v) {
        _vm.$set(_vm.user, "is_business_registered", $$v)
      },
      expression: "user.is_business_registered"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric'),
      expression: "'required|numeric'"
    }],
    attrs: {
      "items": _vm.artists_count_options,
      "item-value": "id",
      "item-text": "name",
      "disabled": !_vm.enabledForm,
      "name": "artists_count",
      "placeholder": "How many artists are currently on your roster?"
    },
    model: {
      value: (_vm.user.artists_count),
      callback: function($$v) {
        _vm.$set(_vm.user, "artists_count", $$v)
      },
      expression: "user.artists_count"
    }
  })], 1)] : (_vm.user.request_role == 'brand') ? [_c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.standard_brand_type_options,
      "disabled": !_vm.enabledForm,
      "name": "standard_brand_type",
      "placeholder": "What type of Brand?"
    },
    model: {
      value: (_vm.user.standard_brand_type),
      callback: function($$v) {
        _vm.$set(_vm.user, "standard_brand_type", $$v)
      },
      expression: "user.standard_brand_type"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.customized_brand_type),
      expression: "user.customized_brand_type"
    }],
    attrs: {
      "disabled": !_vm.enabledForm,
      "type": "text",
      "name": "customized_brand_type",
      "autocomplete": "off",
      "placeholder": "If brand type not listed, what type are you?"
    },
    domProps: {
      "value": (_vm.user.customized_brand_type)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "customized_brand_type", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.employees_count_options,
      "item-value": "id",
      "item-text": "name",
      "disabled": !_vm.enabledForm,
      "name": "employees_count",
      "placeholder": "How many employees do you have?"
    },
    model: {
      value: (_vm.user.employees_count),
      callback: function($$v) {
        _vm.$set(_vm.user, "employees_count", $$v)
      },
      expression: "user.employees_count"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.years_in_business_options,
      "item-value": "id",
      "item-text": "name",
      "disabled": !_vm.enabledForm,
      "name": "years_in_business",
      "placeholder": "How many years in business?"
    },
    model: {
      value: (_vm.user.years_in_business),
      callback: function($$v) {
        _vm.$set(_vm.user, "years_in_business", $$v)
      },
      expression: "user.years_in_business"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.boolean_options,
      "item-value": "id",
      "item-text": "name",
      "disabled": !_vm.enabledForm,
      "name": "will_sell_music_related_products",
      "placeholder": "Do you sell music related products or services?"
    },
    model: {
      value: (_vm.user.will_sell_music_related_products),
      callback: function($$v) {
        _vm.$set(_vm.user, "will_sell_music_related_products", $$v)
      },
      expression: "user.will_sell_music_related_products"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.boolean_options,
      "item-value": "id",
      "item-text": "name",
      "disabled": !_vm.enabledForm,
      "name": "will_run_live_video",
      "placeholder": "Do you plan to run live video on YouSound?"
    },
    model: {
      value: (_vm.user.will_run_live_video),
      callback: function($$v) {
        _vm.$set(_vm.user, "will_run_live_video", $$v)
      },
      expression: "user.will_run_live_video"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.boolean_options,
      "item-value": "id",
      "item-text": "name",
      "disabled": !_vm.enabledForm,
      "name": "will_sell_products",
      "placeholder": "Do you sell products?"
    },
    model: {
      value: (_vm.user.will_sell_products),
      callback: function($$v) {
        _vm.$set(_vm.user, "will_sell_products", $$v)
      },
      expression: "user.will_sell_products"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.products_count_options,
      "item-value": "id",
      "item-text": "name",
      "disabled": !_vm.enabledForm,
      "name": "products_count",
      "placeholder": "How many products / SKUs do you have?"
    },
    model: {
      value: (_vm.user.products_count),
      callback: function($$v) {
        _vm.$set(_vm.user, "products_count", $$v)
      },
      expression: "user.products_count"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.annual_income_options,
      "item-value": "id",
      "item-text": "name",
      "disabled": !_vm.enabledForm,
      "name": "annual_income",
      "placeholder": "Annual income"
    },
    model: {
      value: (_vm.user.annual_income),
      callback: function($$v) {
        _vm.$set(_vm.user, "annual_income", $$v)
      },
      expression: "user.annual_income"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.boolean_options,
      "item-value": "id",
      "item-text": "name",
      "disabled": !_vm.enabledForm,
      "name": "is_business_registered",
      "placeholder": "Is your business registered?"
    },
    model: {
      value: (_vm.user.is_business_registered),
      callback: function($$v) {
        _vm.$set(_vm.user, "is_business_registered", $$v)
      },
      expression: "user.is_business_registered"
    }
  })], 1)] : _vm._e()], 2), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "pb-3": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.website_1_url),
      expression: "user.website_1_url"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:1023|url'),
      expression: "'required|max:1023|url'"
    }],
    attrs: {
      "disabled": !_vm.enabledForm,
      "type": "text",
      "name": "website_1_url",
      "autocomplete": "off",
      "placeholder": "Website URL"
    },
    domProps: {
      "value": (_vm.user.website_1_url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "website_1_url", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.website_2_url),
      expression: "user.website_2_url"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:1023|url'),
      expression: "'max:1023|url'"
    }],
    attrs: {
      "disabled": !_vm.enabledForm,
      "type": "text",
      "name": "website_2_url",
      "autocomplete": "off",
      "placeholder": "Website URL"
    },
    domProps: {
      "value": (_vm.user.website_2_url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "website_2_url", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.history),
      expression: "user.history"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:1023'),
      expression: "'required|max:1023'"
    }],
    attrs: {
      "disabled": !_vm.enabledForm,
      "name": "history",
      "placeholder": "What artists and/or labels have you previously worked with?"
    },
    domProps: {
      "value": (_vm.user.history)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "history", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.enabledForm) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-btn', {
    staticClass: "reset-btn",
    attrs: {
      "round": "",
      "dark": "",
      "type": "submit"
    }
  }, [_vm._v("Save and Resend")])], 1) : _vm._e()], 1)], 1)]) : _vm._e()], 1)], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1789 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile-item-section",
    class: _vm.className
  }, [(_vm.showSendMessage) ? _c('send-message', {
    attrs: {
      "receiver": _vm.user,
      "dismiss": _vm.dismissMessageModal
    }
  }) : _vm._e(), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": '/' + _vm.user.slug
    }
  }, [_c('div', {
    staticClass: "activity-item-profile-avatar",
    style: ({
      'background-image': 'url(' + _vm.user.avatar.thumb.url + ')'
    })
  })]), _vm._v(" "), ( false) ? _c('div', {
    staticClass: "activity-item-profile-cover"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "profile-cover"
  }, [_c('div', {
    staticClass: "profile-cover-body"
  }, [_c('div', {
    staticClass: "profile-cover-avatar"
  }, [_c('router-link', {
    attrs: {
      "to": '/' + _vm.user.slug
    }
  }, [_c('div', {
    staticClass: "activity-item-profile-avatar",
    style: ({
      'background-image': 'url(' + _vm.user.avatar.thumb.url + ')',
    })
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "profile-cover-content"
  }, [_c('router-link', {
    staticClass: "user-name",
    attrs: {
      "to": '/' + _vm.user.slug
    }
  }, [_vm._v(_vm._s(_vm.user.username))]), _vm._v(" \n          "), (_vm.user.user_type == 'artist') ? _c('v-icon', {
    staticClass: "user-status",
    class: {
      online: _vm.user.status == 'active'
    }
  }, [_vm._v("fa-check-circle")]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "user-followers"
  }, [_c('b', [_vm._v(_vm._s(_vm.user.followers))]), _vm._v(" Followers")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "profile-cover-action-buttons"
  }, [(_vm.user.id != _vm.$store.state.auth.user.id) ? _c('user-follow-btn', {
    attrs: {
      "user": _vm.user,
      "theme": "dark",
      "type": "default"
    },
    on: {
      "afterFollow": _vm.afterFollow
    }
  }) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "text-button",
    nativeOn: {
      "click": function($event) {
        _vm.showMessageDialog()
      }
    }
  }, [_vm._v("Message")]), _vm._v(" "), _c('v-menu', {
    staticClass: "more-menu",
    attrs: {
      "offset-y": ""
    }
  }, [_c('v-btn', {
    staticClass: "image-button",
    attrs: {
      "slot": "activator",
      "dark": ""
    },
    slot: "activator"
  }, [_c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("more_horiz")])], 1), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
    key: "repost"
  }, [_c('v-list-tile-title', {
    staticClass: "default-menu-item",
    nativeOn: {
      "click": function($event) {
        _vm.blockUser()
      }
    }
  }, [_c('label', [_vm._v("Block User")])])], 1)], 1)], 1)], 1)])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile-cover-arrow"
  }, [_c('div')])
}]}

/***/ }),
/* 1790 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide-up"
    }
  }, [_c('div', {
    staticClass: "directory",
    class: {
      isComp: _vm.isComp,
      separator: _vm.separator
    },
    style: (("height: " + _vm.height + "%;"))
  }, [(!_vm.isComp) ? _c('div', {
    staticClass: "_top"
  }, [_c('div', {
    staticClass: "_title"
  }, [_c('div', [_vm._v("SMS contact list")]), _vm._v(" "), _c('div', {
    staticClass: "_len"
  }, [_vm._v(_vm._s(_vm.directoryLen) + " people")])]), _vm._v(" "), _c('v-icon', {
    staticClass: "close-icon",
    on: {
      "click": _vm.closeDirectory
    }
  }, [_vm._v("\n        keyboard_arrow_down\n      ")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "_listing"
  }, _vm._l((_vm.directoryLen), function(contact, i) {
    return _c('div', {
      key: i,
      staticClass: "each-contact"
    }, [_c('trackcardsimple', {
      attrs: {
        "item": {},
        "cover": '',
        "title": ("Name " + (i + 1)),
        "subtitle": 'Artist',
        "width": "40",
        "height": "40",
        "round": ""
      }
    })], 1)
  }))])])
},staticRenderFns: []}

/***/ }),
/* 1791 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "display-flex justify-space-between align-center mb-5"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(598),
      "width": "9",
      "height": "18"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'YouMobile'
        })
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(44),
      "width": "100"
    }
  }), _vm._v(" "), _c('div')]), _vm._v(" "), _c('Card')], 1)
},staticRenderFns: []}

/***/ }),
/* 1792 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "approve-section",
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-layout', {
    staticClass: "dismiss-section",
    attrs: {
      "row": "",
      "wrap": ""
    },
    on: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "popup-section",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "profile-section",
    attrs: {
      "xs12": "",
      "sm12": "",
      "mx-3": "",
      "py-3": ""
    }
  }, [_c('div', {
    staticClass: "profile-image",
    style: ({
      'background-image': 'url(' + _vm.item.avatar.url + ')'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "info-section"
  }, [_c('div', {
    staticClass: "user-name"
  }, [_vm._v(_vm._s(_vm.item.username))]), _vm._v(" "), _c('div', {
    staticClass: "user-slug"
  }, [_vm._v("@" + _vm._s(_vm.item.slug))]), _vm._v(" "), _c('div', {
    staticClass: "status"
  }, [_vm._v(_vm._s(_vm.item.status))])]), _vm._v(" "), _c('div', {
    staticClass: "mt-5 mb-3 info-user"
  }, [_c('div', {
    staticClass: "font-weight-700"
  }, [_vm._v("EMAIL")]), _vm._v(" "), _c('div', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm.item.email))])]), _vm._v(" "), _c('div', {
    staticClass: "mb-3 info-user"
  }, [_c('div', {
    staticClass: "font-weight-700"
  }, [_vm._v("LOCATION")]), _vm._v(" "), _c('div', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm.userFullAddress))])]), _vm._v(" "), _c('div', {
    staticClass: "mb-3 info-user"
  }, [_c('div', {
    staticClass: "font-weight-700"
  }, [_vm._v("AGE GROUP")]), _vm._v(" "), _c('div', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm.item.gender))])]), _vm._v(" "), _c('div', {
    staticClass: "mb-3 info-user"
  }, [_c('div', {
    staticClass: "font-weight-700"
  }, [_vm._v("SOCIAL PROFILE")]), _vm._v(" "), (
    (_vm.item.social_user_name || _vm.item.social_user_id) &&
    _vm.item.social_provider &&
    _vm.item.social_provider.toLowerCase() === 'instagram'
  ) ? _c('div', {
    staticClass: "font-weight-500"
  }, [_c('span', [_vm._v("Instagram - ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": ("https://instagram.com/" + (_vm.item.social_user_name == null
                ? _vm.item.social_user_id
                : _vm.item.social_user_name)),
      "target": "_blank"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.item.social_user_name == null ?
    _vm.item.social_user_id :
    _vm.item.social_user_name) + "\n          ")])]) : _vm._e(), _vm._v(" "), (
    (_vm.item.social_user_name || _vm.item.social_user_id) &&
    _vm.item.social_provider &&
    (_vm.item.social_provider.toLowerCase() === 'tiktok' ||
      _vm.item.social_provider.toLowerCase() === 'tik tok')
  ) ? _c('div', {
    staticClass: "font-weight-500"
  }, [_c('span', [_vm._v("TikTok - ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": ("https://tiktok.com/" + (_vm.item.social_user_name == null
                ? _vm.item.social_user_id
                : _vm.item.social_user_name)),
      "target": "_blank"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.item.social_user_name == null ?
    _vm.item.social_user_id :
    _vm.item.social_user_name) + "\n          ")])]) : _vm._e(), _vm._v(" "), (
    (_vm.item.social_user_name || _vm.item.social_user_id) &&
    _vm.item.social_provider &&
    _vm.item.social_provider.toLowerCase() === 'facebook'
  ) ? _c('div', {
    staticClass: "font-weight-500"
  }, [_c('span', [_vm._v("Facebook - ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": ("https://facebook.com/" + (_vm.item.social_user_name == null
                ? _vm.item.social_user_id
                : _vm.item.social_user_name)),
      "target": "_blank"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.item.social_user_name == null ?
    _vm.item.social_user_id :
    _vm.item.social_user_name) + "\n          ")])]) : _vm._e(), _vm._v(" "), (
    (_vm.item.social_user_name || _vm.item.social_user_id) &&
    _vm.item.social_provider &&
    _vm.item.social_provider.toLowerCase() === 'twitter'
  ) ? _c('div', {
    staticClass: "font-weight-500"
  }, [_c('span', [_vm._v("Twitter - ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": ("https://twitter.com/" + (_vm.item.social_user_name == null
                ? _vm.item.social_user_id
                : _vm.item.social_user_name)),
      "target": "_blank"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.item.social_user_name == null ?
    _vm.item.social_user_id :
    _vm.item.social_user_name) + "\n          ")])]) : _vm._e()]), _vm._v(" "), (_vm.activeTab == 'waiting') ? _c('div', {
    staticClass: "action-section"
  }, [_c('v-btn', {
    staticClass: "approve-btn",
    attrs: {
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        _vm.approveButtonAction(_vm.item)
      }
    }
  }, [_vm._v("Approve")]), _vm._v(" "), _c('v-btn', {
    staticClass: "deny-btn",
    attrs: {
      "color": "error ma-0"
    },
    nativeOn: {
      "click": function($event) {
        _vm.denyButtonAction()
      }
    }
  }, [_vm._v("Deny")])], 1) : _vm._e()])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1793 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    staticClass: "page messages-page",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.$store.state.auth.user) ? _c('v-flex', {
    staticClass: "messages-page-content",
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [(!_vm.conversations || _vm.conversations.length == 0) ? _c('v-flex', {
    staticClass: "message-rooms-section empty-section",
    attrs: {
      "xs12": "",
      "pa-0": ""
    }
  }, [_c('p', {
    staticClass: "empty-title"
  }, [_vm._v("No messages")]), _vm._v(" "), _c('p', {
    staticClass: "empty-description"
  }, [_vm._v("Conversations will appear here.")])]) : [_c('v-flex', {
    staticClass: "conversations",
    attrs: {
      "xs12": "",
      "sm3": "",
      "pa-0": ""
    }
  }, [_c('div', {
    staticClass: "conversations__header"
  }, [_c('div', {
    staticClass: "conversations__title"
  }, [_vm._v("Inbox")]), _vm._v(" "), _c('div', {
    staticClass: "conversations__count"
  }, [_vm._v("\n              " + _vm._s(_vm.conversations.length) + " messages\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "conversations__content"
  }, _vm._l((_vm.conversations), function(conv) {
    return _c('div', {
      key: ("conversation-" + (conv.id)),
      staticClass: "message-room-item",
      class: {
        new: conv.last_message && !conv.last_message.is_read,
        selected: conv.id == _vm.conversation.id,
      },
      on: {
        "click": function($event) {
          _vm.selectedConversation(conv)
        }
      }
    }, [_c('div', {
      staticClass: "avatar-area"
    }, [_c('router-link', {
      attrs: {
        "to": ("/" + (conv.other.slug))
      }
    }, [(!conv.other.length) ? _c('div', {
      staticClass: "avatar-image",
      style: ('background-image: url(' +
        conv.other.avatar.thumb.url +
        ');')
    }) : _vm._e()])], 1), _vm._v(" "), _c('div', {
      staticClass: "detail-area"
    }, [_c('label', {
      staticClass: "user-name"
    }, [_vm._v(_vm._s(conv.other.username))]), _vm._v(" "), _c('label', {
      staticClass: "short-message"
    }, [_vm._v(_vm._s(conv.last_message.body))])]), _vm._v(" "), _c('label', {
      staticClass: "messaged-time"
    }, [_vm._v(_vm._s(_vm.toLocalTimeString(conv.last_message.created_at)))])])
  }))]), _vm._v(" "), (_vm.conversation && _vm.conversation.id > 0) ? _c('v-flex', {
    staticClass: "message-content-section",
    class: {
      sm6: _vm.currentUser.user_type === 'artist',
      sm9: _vm.currentUser.user_type !== 'artist',
    },
    attrs: {
      "xs12": "",
      "pa-0": ""
    }
  }, [_c('div', {
    staticClass: "header-section"
  }, [_c('p', {
    staticClass: "user-name"
  }, [_vm._v("\n              " + _vm._s(_vm.conversation.other.username) + "\n              "), (_vm.conversation.other.user_type == 'artist') ? _c('v-icon', {
    staticClass: "user-status",
    class: {
      online: _vm.conversation.other.status == 'active'
    }
  }, [_vm._v("fa-check-circle")]) : _vm._e()], 1), _vm._v(" "), _c('p', {
    staticClass: "messaged-time"
  }, [_vm._v("\n              Repost Price: $" + _vm._s(_vm._f("formatNumber")(_vm.conversation.other.repost_price)) + "\n            ")])]), _vm._v(" "), (_vm.messages && _vm.messages.length > 0) ? _c('div', {
    staticClass: "message-list-section"
  }, _vm._l((_vm.messages), function(message) {
    return _c('message', {
      key: message.id,
      attrs: {
        "message": message,
        "is-own": _vm.conversation.other.id != message.sender.id
      },
      on: {
        "updated": _vm.refreshMessages
      }
    })
  })) : _vm._e()]) : _vm._e()]], 2)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1794 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "ys-dialog-container",
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-layout', {
    staticClass: "ys-dialog-dismiss",
    attrs: {
      "row": "",
      "wrap": ""
    },
    on: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "ys-dialog",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs7": "",
      "pr-2": ""
    }
  }, [_c('div', {
    staticClass: "user-avatar",
    style: ({
      'background-image': 'url(' + _vm.user.avatar.url + ')'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "user-name"
  }, [_c('label', [_vm._v(_vm._s(_vm.user.username))]), _vm._v(" "), (['artist', 'label', 'brand'].indexOf(_vm.user.user_type) > -1) ? _c('v-icon', {
    staticClass: "user-status online"
  }, [_vm._v("fa-check-circle")]) : _vm._e()], 1), _vm._v(" "), _c('h3', [_vm._v("Open Case / File complaint")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "ticket_reason_dropdown",
    attrs: {
      "items": _vm.ticket_reasons,
      "name": "ticket_reason",
      "disabled": _vm.hasTicket,
      "placeholder": "Select reason for opening case...",
      "autocomplete": ""
    },
    model: {
      value: (_vm.ticket.reason),
      callback: function($$v) {
        _vm.$set(_vm.ticket, "reason", $$v)
      },
      expression: "ticket.reason"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "mt-2": ""
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ticket.description),
      expression: "ticket.description"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:1023'),
      expression: "'required|max:1023'"
    }],
    staticClass: "mt-2",
    attrs: {
      "name": "ticket_description",
      "placeholder": "Write a message...",
      "disabled": _vm.hasTicket
    },
    domProps: {
      "value": (_vm.ticket.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.ticket, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), (!_vm.hasTicket) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-right": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "dark": "",
      "small": "",
      "round": "",
      "color": "green",
      "disabled": !_vm.canSend
    },
    nativeOn: {
      "click": function($event) {
        _vm.sendTicket()
      }
    }
  }, [_vm._v("Send")])], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-5": "",
      "pt-3": "",
      "text-xs-center": ""
    }
  }, [_c('p', {
    staticClass: "ma-0"
  }, [_vm._v("\n          Any disputes regarding refunds & returns can only be resolved between sellers and buyers.\n          If we discover a seller has a trend of violations, we may close their account.\n          "), _c('br'), _c('br')])])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": "",
      "px-3": "",
      "border-left": ""
    }
  }, [_c('div', {
    staticClass: "product-cover",
    style: ({
      'background-image': 'url(' + _vm.product.covers[0].cover.url + ')'
    })
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "x12": "",
      "mt-4": "",
      "mb-3": "",
      "py-2": "",
      "border-top": "",
      "border-bottom": ""
    }
  }, [_c('h4', [_vm._v("Product Info")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "x12": "",
      "product-name": ""
    }
  }, [_vm._v("\n        " + _vm._s(_vm.product.name) + "\n      ")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1795 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "auth-input-page"
  }, [(_vm.$store.state.app.onboarding.accountCategory !== 'listener') ? _c('label', {
    staticClass: "auth-label-input"
  }, [_vm._v("\n    Account type\n  ")]) : _vm._e(), _vm._v(" "), (_vm.$store.state.app.onboarding.accountCategory !== 'listener') ? _c('v-menu', {
    staticClass: "account-type-menu pb-1",
    attrs: {
      "bottom": "",
      "left": "",
      "offset-y": "",
      "nudge-top": -5,
      "nudge-left": 0,
      "content-class": "account-menu__content"
    }
  }, [_c('v-select', {
    staticClass: "pa-0",
    class: {
      'acc-selected _filled': _vm.accountType
    },
    attrs: {
      "slot": "activator",
      "placeholder": _vm.accountType ? _vm.accountType.title : 'Select',
      "single-line": "",
      "hide-details": ""
    },
    slot: "activator"
  }), _vm._v(" "), _vm._l((_vm.accountTypes), function(type, i) {
    return _c('div', {
      key: i,
      staticClass: "account-info",
      class: [((type.id) + "-menu")],
      on: {
        "click": function($event) {
          _vm.selectedAccount(type)
        }
      }
    }, [_c('div', {
      staticClass: "_title",
      staticStyle: {
        "font-size": "16px",
        "font-weight": "600"
      }
    }, [_vm._v("\n        " + _vm._s(type.title) + "\n      ")]), _vm._v(" "), _c('div', {
      staticClass: "_tags"
    }, [_vm._v("\n        " + _vm._s(type.tags) + "\n      ")])])
  })], 2) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "auth-label-input"
  }, [_vm._v("Username")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "pb-2",
    attrs: {
      "type": "text",
      "placeholder": "Type username",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    class: {
      'display-flex align-center gap-8 justify-space-between': _vm.$vuetify.breakpoint.width <= 1280,
    }
  }, [(_vm.$vuetify.breakpoint.width <= 1280) ? _c('v-btn', {
    staticClass: "back-button",
    on: {
      "click": function($event) {
        _vm.$emit('actionPrevStage')
      }
    }
  }, [_vm._v("\n      Back\n    ")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "auth-button",
    class: {
      _disabled: !_vm.validated('skipToast'),
      'auth-bg-disabled': _vm.checkDataEmpty,
      'auth-bg-active': !_vm.checkDataEmpty,
    },
    on: {
      "click": function($event) {
        _vm.handleNextStage()
      }
    }
  }, [_vm._v("\n      Next\n    ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1796 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page admin-page"
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('div', {
    staticClass: "admin-tab mt-4"
  }, [_c('v-tabs', {
    attrs: {
      "dark": "",
      "center-active": ""
    }
  }, [_c('content-top-header', {
    staticClass: "black-theme for-tabs"
  }, [_c('template', {
    slot: "topHeader"
  }, [_c('v-tabs-bar', {
    staticClass: "tab_bar",
    attrs: {
      "dark": ""
    }
  }, [_c('div', {
    staticClass: "active-icon"
  }, [_vm._v("Admin >\n              ")]), _vm._v(" "), _vm._l((_vm.tabs), function(tab) {
    return (_vm.availableTab(tab)) ? _c('v-tabs-item', {
      key: tab.id,
      attrs: {
        "href": '#' + tab.id,
        "ripple": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.onTab(tab.id)
        }
      }
    }, [_vm._v(_vm._s(tab.title))]) : _vm._e()
  })], 2)], 1)], 2), _vm._v(" "), _c('v-tabs-items', [_c('v-tabs-content', {
    key: "users",
    attrs: {
      "id": "users"
    }
  }, [(_vm.$store.state.navigator.current.tab == 'users') ? _c('user-tab') : _vm._e()], 1), _vm._v(" "), _c('v-tabs-content', {
    key: "albums",
    attrs: {
      "id": "albums"
    }
  }, [(_vm.$store.state.navigator.current.tab == 'albums') ? _c('album-tab') : _vm._e()], 1), _vm._v(" "), _c('v-tabs-content', {
    key: "signups",
    attrs: {
      "id": "signups"
    }
  }, [(_vm.$store.state.navigator.current.tab == 'signups') ? _c('signup-tab') : _vm._e()], 1), _vm._v(" "), _c('v-tabs-content', {
    key: "subscriptions",
    attrs: {
      "id": "subscriptions"
    }
  }, [(_vm.$store.state.navigator.current.tab == 'subscriptions') ? _c('subscription-tab') : _vm._e()], 1), _vm._v(" "), _c('v-tabs-content', {
    attrs: {
      "id": "payments"
    }
  }, [(_vm.$store.state.navigator.current.tab == 'payments') ? _c('payment-tab') : _vm._e()], 1), _vm._v(" "), _c('v-tabs-content', {
    key: "genres",
    attrs: {
      "id": "genres"
    }
  }, [(_vm.$store.state.navigator.current.tab == 'genres') ? _c('genre-tab') : _vm._e()], 1), _vm._v(" "), _c('v-tabs-content', {
    key: "settings",
    attrs: {
      "id": "settings"
    }
  }, [(_vm.$store.state.navigator.current.tab == 'settings') ? _c('setting-tab') : _vm._e()], 1), _vm._v(" "), _c('v-tabs-content', {
    key: "globalstats",
    attrs: {
      "id": "globalstats"
    }
  }, [(_vm.$store.state.navigator.current.tab == 'globalstats') ? _c('globalstats-tab') : _vm._e()], 1), _vm._v(" "), _c('v-tabs-content', {
    key: "attendees",
    attrs: {
      "id": "attendees"
    }
  }, [(_vm.$store.state.navigator.current.tab == 'attendees') ? _c('attendee-tab') : _vm._e()], 1), _vm._v(" "), _c('v-tabs-content', {
    key: "streams",
    attrs: {
      "id": "streams"
    }
  }, [(_vm.$store.state.navigator.current.tab == 'streams') ? _c('stream-tab') : _vm._e()], 1)], 1)], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1797 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "product-item",
    attrs: {
      "xs12": ""
    }
  }, [(_vm.showPromoteMessage) ? _c('promote-modal', {
    attrs: {
      "item": _vm.product,
      "dismiss": _vm.dismissPromoteModal,
      "success": _vm.saveAndFinish
    }
  }) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm12": "",
      "product-content-section": "",
      "pa-0": "",
      "relative": ""
    }
  }, [_c('div', {
    staticClass: "product-image",
    style: ({
      'background-image': 'url(' + _vm.product.covers[0].cover.thumb.url + ')',
    })
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "product-content",
    attrs: {
      "wrap": "",
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "product-content-row d-flex flex-column gap-4",
    attrs: {
      "xs12": "",
      "sm6": "",
      "pr-0": ""
    }
  }, [_c('label', {
    staticClass: "text-poppins-15"
  }, [_vm._v(_vm._s(_vm.product.name))]), _vm._v(" "), _c('div', [(_vm.status && _vm.status != '') ? _c('label', {
    staticClass: "product-category-text"
  }, [_vm._v("\n              " + _vm._s(_vm.status) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "product-category-text"
  }, [_vm._v("\n              Category: " + _vm._s(_vm.product.category ? _vm.product.category.name : "") + "\n            ")]), _vm._v(" "), _c('label', {
    staticClass: "product-count product-sold-count"
  }, [_vm._v("\n              Sold: " + _vm._s(_vm.product.sold) + "\n            ")]), _vm._v(" "), (_vm.product.stock_status == 'active') ? _c('label', {
    staticClass: "product-count product-status"
  }, [_vm._v("\n              " + _vm._s(_vm.product.stock_status) + "\n              "), _c('v-icon', {
    class: _vm.product.stock_status
  }, [_vm._v("done")])], 1) : _c('label', {
    staticClass: "product-count product-status"
  }, [_vm._v("\n              " + _vm._s(_vm.product.stock_status) + "\n              "), _c('v-icon', {
    class: _vm.product.stock_status
  }, [_vm._v("done")])], 1)])]), _vm._v(" "), _c('v-flex', {
    staticClass: "product-content-row d-flex align-center justify-end gap-15",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [(_vm.$store.state.auth.user.id == _vm.product.merchant.id) ? [_c('v-select', {
    staticClass: "pt-0 access-level",
    attrs: {
      "items": _vm.access_levels,
      "item-text": "title",
      "item-value": "id",
      "placeholder": "Select access level",
      "hide-details": "",
      "single-line": ""
    },
    on: {
      "change": function($event) {
        _vm.toggle_product_access_level_dialog = true
      }
    },
    model: {
      value: (_vm.access_level),
      callback: function($$v) {
        _vm.access_level = $$v
      },
      expression: "access_level"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "text-btn text-poppins-15",
    nativeOn: {
      "click": function($event) {
        _vm.editProduct()
      }
    }
  }, [_vm._v("Edit")]), _vm._v(" "), _c('v-btn', {
    staticClass: "text-btn text-poppins-15",
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.deleteItem(_vm.product)
      }
    }
  }, [_vm._v("Delete")])] : [(_vm.denyItem) ? _c('v-btn', {
    staticClass: "text-btn text-poppins-15",
    nativeOn: {
      "click": function($event) {
        _vm.denyItem(_vm.product)
      }
    }
  }, [_vm._v("Deny")]) : _vm._e(), _vm._v(" "), (_vm.denyItem) ? _c('label', {
    staticClass: "btn-divider"
  }) : _vm._e(), _vm._v(" "), (_vm.acceptItem) ? _c('v-btn', {
    staticClass: "text-btn text-poppins-15",
    nativeOn: {
      "click": function($event) {
        _vm.acceptItem(_vm.product)
      }
    }
  }, [_vm._v("Accept")]) : _vm._e(), _vm._v(" "), (_vm.acceptItem) ? _c('label', {
    staticClass: "btn-divider"
  }) : _vm._e()]], 2)], 1)], 1), _vm._v(" "), (_vm.album.status == 'collaborated' || _vm.album.status == 'pending') ? _c('div', {
    staticClass: "divider"
  }) : _vm._e(), _vm._v(" "), (_vm.product.collaborators.length > 0) ? _c('v-flex', {
    attrs: {
      "sm12": "",
      "collaborator-content-section": ""
    }
  }, [_c('div', [_c('div', {
    staticClass: "text-poppins-14"
  }, [_vm._v("Collaborators (" + _vm._s(_vm.product.collaborators.length) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "collaborator-content"
  }, [_vm._l((_vm.product.collaborators), function(collaborator, i) {
    return _c('div', {
      key: i,
      staticClass: "collaborator-content__item"
    }, [_c('img', {
      staticClass: "collaborator-content__item--img",
      attrs: {
        "src": collaborator.user.avatar.url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "collaborator-content__item__user"
    }, [_c('span', {
      staticClass: "username "
    }, [_vm._v("\n              " + _vm._s(collaborator.user.username) + "\n              "), (
      _vm.$store.state.auth.user.username === collaborator.user.username
    ) ? _c('span', [_vm._v("\n                (owner)\n              ")]) : _vm._e()]), _vm._v(" "), _c('span', {
      staticClass: "user-type"
    }, [_vm._v(_vm._s(collaborator.user.user_type))])])])
  }), _vm._v(" "), (_vm.product.status == 'pending') ? _c('div', [(_vm.currentUserOwnsProduct && _vm.allCollaboratedAccepted) ? _c('v-btn', {
    staticClass: "action-btn release",
    attrs: {
      "depressed": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.releaseButtonAction(_vm.product)
      }
    }
  }, [_c('span', {
    staticClass: "white--text"
  }, [_vm._v("Release Now")])]) : _vm._e(), _vm._v(" "), (_vm.currentUserOwnsProduct && !_vm.allCollaboratedAccepted) ? _c('v-btn', {
    staticClass: "action-btn pending",
    attrs: {
      "depressed": "",
      "disabled": ""
    }
  }, [_c('span', [_vm._v("Pending")])]) : _vm._e(), _vm._v(" "), (_vm.isUserCollaborator) ? _c('div', {
    staticClass: "dflex collaborator-action"
  }, [_c('v-btn', {
    staticClass: "text-btn",
    attrs: {
      "disabled": _vm.allCollaboratedAccepted
    },
    nativeOn: {
      "click": function($event) {
        _vm.acceptCollaboration(_vm.product)
      }
    }
  }, [_vm._v("\n                Accept\n              ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "text-btn",
    attrs: {
      "disabled": _vm.allCollaboratedAccepted
    },
    nativeOn: {
      "click": function($event) {
        _vm.denyCollaboration(_vm.product)
      }
    }
  }, [_vm._v("\n                Deny\n              ")])], 1) : _vm._e()], 1) : _vm._e()], 2)])]) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "invite-dialog",
      "width": "440"
    },
    model: {
      value: (_vm.toggle_product_access_level_dialog),
      callback: function($$v) {
        _vm.toggle_product_access_level_dialog = $$v
      },
      expression: "toggle_product_access_level_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("\n        Update Access Level\n      ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n        Are you sure you want to update the access level?\n      ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "black",
      "dark": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.updateAccessLevel()
      }
    }
  }, [_vm._v("Yes")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1798 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-menu"
  }, [_c('v-toolbar', {
    staticClass: "tab-container",
    class: {
      __absolute: _vm.absolute
    },
    attrs: {
      "app": "",
      "fixed": !_vm.absolute,
      "flat": _vm.absolute,
      "height": _vm.height
    }
  }, [_vm._t("topHeader")], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 1799 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page main-section"
  }, [_c('h2', [_vm._v("Terms of Service")]), _vm._v(" "), _c('div', {
    staticClass: "article-body content-body wikistyle markdown-format"
  }, [_c('div', {
    staticClass: "intro"
  }), _vm._v(" "), _c('p', [_vm._v("Effective date: Jan 1, 2020")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Please read these Terms of Use (\"Agreement\" or \"Terms of Use\")\n        carefully before using the services offered by YouSound, Inc.\n        (\"Company,\" “we,” “us,” or “our”). This agreement sets forth the\n        legally binding terms and conditions for you (\"You\" “your,” “User,”\n        \"Listener,\" \"Customer,\" \"Buyer,\" \"Seller,\" \"Verified Artist,\"\n        \"Verified Brand,\" or \"Verified User”) use of the Website at\n        https://www.yousound.com (the \"Site\") and the service owned and\n        operated by company, including any mobile software applications\n        offered or published by Company (collectively with the Site, the\n        \"Service\"). By using the Site or Service in any manner, including but\n        not limited to visiting or browsing the Site, you agree to be bound by\n        these Terms of Use. These Terms of Use apply to all users of the Site\n        or Service, including users who are also contributors of content,\n        information, and other materials or services on the Site. ")]), _c('br')]), _vm._v(" "), _c('h3', [_c('a', {
    staticClass: "anchor",
    attrs: {
      "id": "summary",
      "href": "#summary",
      "aria-hidden": "true"
    }
  }, [_c('span', {
    staticClass: "link",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v("Summary\n    ")]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("Section")]), _vm._v(" "), _c('th', [_vm._v("What can you find there?")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('a', {
    attrs: {
      "href": "#1-introduction"
    }
  }, [_vm._v("Acceptance of Terms.")])]), _vm._v(" "), _c('td', [_vm._v("Your acceptance of all the YouSound.com Terms of Service.")])]), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
    attrs: {
      "href": "#3-modification"
    }
  }, [_vm._v("Modification of Terms of Use.")])]), _vm._v(" "), _c('td', [_vm._v("YouSound's right to modify it's Terms of Use at any time.")])]), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
    attrs: {
      "href": "#4-rules-and-conduct"
    }
  }, [_vm._v("Rules and Conduct")])]), _vm._v(" "), _c('td', [_vm._v("\n            All of the rules and conduct every user must abide by when using\n            YouSound.com\n          ")])]), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
    attrs: {
      "href": "#5-personal-information"
    }
  }, [_vm._v("Personal Information")])]), _vm._v(" "), _c('td', [_vm._v("\n            How the personal information you submit to YouSound.com is\n            handled.\n          ")])]), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
    attrs: {
      "href": "#6-verified-users-usages-of-personal-user-information"
    }
  }, [_vm._v("Verified Users Usage of Personal User Information")])]), _vm._v(" "), _c('td', [_vm._v("\n            How the personal information you submit to Verified Users on\n            YouSound.com is handled.\n          ")])]), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
    attrs: {
      "href": "#7-registration"
    }
  }, [_vm._v("Registration")])]), _vm._v(" "), _c('td', [_vm._v("How YouSound handles user registration & sign ups.")])]), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
    attrs: {
      "href": "#8-fees-and-payments-defined"
    }
  }, [_vm._v("Fees and Payments Defined")])]), _vm._v(" "), _c('td', [_vm._v("\n            How we define the terms \"Fees\" & \"Payments\" on YouSound.com.\n          ")])]), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
    attrs: {
      "href": "#9-fees-and-payments"
    }
  }, [_vm._v("Fees and Payments")])]), _vm._v(" "), _c('td', [_vm._v("\n            All the methods of payments and fees available on YouSound.com.\n          ")])]), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
    attrs: {
      "href": "#14-additional-fees"
    }
  }, [_vm._v("Additional Fees")])]), _vm._v(" "), _c('td', [_vm._v("\n            How YouSound reserves the right to change it's pricing or\n            surcharges.\n          ")])]), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
    attrs: {
      "href": "#15-linking-to-third-party-sites"
    }
  }, [_vm._v("Linking to Third Party Sites")])]), _vm._v(" "), _c('td', [_vm._v("How YouSound deals with Third Party Linking.")])]), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
    attrs: {
      "href": "#16-content-and-license"
    }
  }, [_vm._v("Content and License")])]), _vm._v(" "), _c('td', [_vm._v("How content is licensed to broadcast on YouSound.com")])]), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
    attrs: {
      "href": "#17-verified-users-respect-of-ip"
    }
  }, [_vm._v("Verified Users & Intellectual Property Rights")])]), _vm._v(" "), _c('td', [_vm._v("\n            How Verified Users are responsible for respecting Intellectual\n            Property.\n          ")])]), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
    attrs: {
      "href": "#18-ip"
    }
  }, [_vm._v("Intellectual Property Rights")])]), _vm._v(" "), _c('td', [_vm._v("How YouSound deals with Intellectual Property Rights.")])]), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
    attrs: {
      "href": "#19-dmca-notice-takedown"
    }
  }, [_vm._v("DMCA Notice and Takedown Procedure")])]), _vm._v(" "), _c('td', [_vm._v("How YouSound handles DMCA Notices.")])]), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
    attrs: {
      "href": "#20-user-of-devices-and-services"
    }
  }, [_vm._v("Use of Devices and Services")])]), _vm._v(" "), _c('td', [_vm._v("\n            How users are responsible for any fees incurred from their devices\n            while accessing YouSound.com\n          ")])]), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
    attrs: {
      "href": "#21-license"
    }
  }, [_vm._v("License")])]), _vm._v(" "), _c('td', [_vm._v("\n            How YouSound and all of it's Intellectual Property is owned soley\n            by YouSound.com\n          ")])]), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
    attrs: {
      "href": "#22-user-content"
    }
  }, [_vm._v("User Content")])]), _vm._v(" "), _c('td', [_vm._v("\n            How YouSound handles the uploading & submission of user content.\n          ")])]), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
    attrs: {
      "href": "#23-promotions"
    }
  }, [_vm._v("Promotions")])]), _vm._v(" "), _c('td', [_vm._v("How YouSound deals with user promotions & giveaways.")])]), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
    attrs: {
      "href": "#24-endorsements-testimonials"
    }
  }, [_vm._v("Endorsements and Testimonials")])]), _vm._v(" "), _c('td', [_vm._v("\n            How Verified Users must comply with FTC guidelines when endorsing\n            products or services.\n          ")])]), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
    attrs: {
      "href": "#25-prohibited-conduct"
    }
  }, [_vm._v("Prohibited Conduct")])]), _vm._v(" "), _c('td', [_vm._v("\n            All of the prohibited conduct that all users must avoid in order\n            to use YouSound.\n          ")])]), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
    attrs: {
      "href": "#26-third-party-content"
    }
  }, [_vm._v("Third Party Content")])]), _vm._v(" "), _c('td', [_vm._v("How YouSound handles Third Party Content.")])]), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
    attrs: {
      "href": "#27-idea-submission"
    }
  }, [_vm._v("Idea Submission")])]), _vm._v(" "), _c('td', [_vm._v("How idea submissions are handled on YouSound.com.")])]), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
    attrs: {
      "href": "#28-termination"
    }
  }, [_vm._v("Termination")])]), _vm._v(" "), _c('td', [_vm._v("How your access to YouSound can be terminated.")])]), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
    attrs: {
      "href": "#29-warranty-disclaimer"
    }
  }, [_vm._v("Warranty Disclaimer")])]), _vm._v(" "), _c('td', [_vm._v("How YouSound provides it's service as is.")])]), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
    attrs: {
      "href": "#30-indemnification"
    }
  }, [_vm._v("Indemnification")])]), _vm._v(" "), _c('td', [_vm._v("How YouSound cannot be held accountable for your actions.")])]), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
    attrs: {
      "href": "#31-limitation-of-liability"
    }
  }, [_vm._v("Limitation of Liability")])]), _vm._v(" "), _c('td', [_vm._v("How users are responsible for resolving their own disputes.")])]), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
    attrs: {
      "href": "#32-international-non-california-user"
    }
  }, [_vm._v("International and Non-California Use")])]), _vm._v(" "), _c('td', [_vm._v("\n            How if users access YouSound outside of California, they do so on\n            their own initiative.\n          ")])]), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
    attrs: {
      "href": "#33-dispute-resolution"
    }
  }, [_vm._v("Dispute Resolution")])]), _vm._v(" "), _c('td', [_vm._v("How YouSound handles dispute resolutions.")])]), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
    attrs: {
      "href": "#34-integration-and-severability"
    }
  }, [_vm._v("Integration and Severability")])]), _vm._v(" "), _c('td', [_vm._v("How YouSound terms are between the user & YouSound.")])]), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
    attrs: {
      "href": "#35-miscellaneous"
    }
  }, [_vm._v("Miscellaneous")])]), _vm._v(" "), _c('td', [_vm._v("\n            How YouSound shall not be liable to perform it's obligations\n            outside of it's reasonable control.\n          ")])]), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
    attrs: {
      "href": "#36-contact"
    }
  }, [_vm._v("Contact")])]), _vm._v(" "), _c('td', [_vm._v("E-mail address to contact YouSound regarding these terms.")])])])]), _vm._v(" "), _c('h3', [_c('a', {
    staticClass: "anchor",
    attrs: {
      "id": "1-introduction",
      "href": "#1-introduction",
      "aria-hidden": "true"
    }
  }, [_c('span', {
    staticClass: "link",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v("Acceptance of Terms.\n    ")]), _vm._v(" "), _c('ol', [_c('p', [_vm._v("\n        The Service is offered subject to acceptance without modification of\n        all of the terms and conditions contained herein (the “Terms of Use”),\n        which Terms of Use also incorporate the Privacy Policy, Copyright\n        Policy and all other operating rules, policies and procedures that may\n        be published from time to time on the Site by Company on it's Terms\n        and Policy pages, each of which is incorporated by reference into\n        these Terms of Use and each of which may be updated by Company from\n        time to time without prior notice to you. In addition, some services\n        offered through the Service may be subject to additional terms and\n        conditions promoted by Company from time to time; your use of such\n        services is subject to those additional terms and conditions, which\n        are incorporated into these Terms of Use by this reference."), _c('br'), _c('br'), _vm._v("\n        If you are using or opening an “Artist Account” or “Brand Account”\n        (Artist Accounts, Brand Accounts collectively known as, “Verified\n        Users”) on behalf of a company, entity or organization (each an\n        “Artist Entity” “Brand Entity” “Label Entity”), then you represent and\n        warrant that you: (i) are an authorized representative of that Artist\n        Entity, Brand Entity, Label Entity, and warrant that you have the\n        authority to bind such Artist Entity, Brand Entity, Label Entity to\n        these Terms of Use and (ii) agree to be bound by these Terms of Use on\n        behalf of such Artist Entity, Brand Entity, Label Entity. The Service\n        is available only to individuals who are at least 13 years old. You\n        represent and warrant that if you are an individual, then you are of\n        legal age to form a binding contract, and that all registration\n        information you submit is accurate and truthful. Company may, in its\n        sole discretion, refuse to offer the Service to any person or entity\n        and change its eligibility criteria at any time. This provision is\n        void where prohibited by law and the right to access the Service is\n        revoked in such jurisdictions.\n      ")])]), _vm._v(" "), _c('h3', [_c('a', {
    staticClass: "anchor",
    attrs: {
      "id": "3-modification",
      "href": "#3-modification",
      "aria-hidden": "true"
    }
  }, [_c('span', {
    staticClass: "link",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v("Modification of Terms of Use.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      Company reserves the right, at its sole discretion, to modify or replace\n      any of the terms in these Terms of Use, or change, suspend, or\n      discontinue the Service (including without limitation, the availability\n      of any feature, database, or content) at any time by posting a notice on\n      the Site or by sending you an e-mail. Company may also impose limits on\n      certain features and services or restrict your access to parts or all of\n      the Service without notice or liability. It is your responsibility to\n      check these Terms of Use periodically for changes. Your continued use of\n      the Service following the posting of any changes to these Terms of Use\n      constitutes acceptance of those changes. Notwithstanding the preceding\n      sentences of this section, no modifications to these Terms of Use will\n      apply to any dispute between you and Company that arose prior to the\n      date of such modification.\n    ")]), _vm._v(" "), _c('h3', [_c('a', {
    staticClass: "anchor",
    attrs: {
      "id": "4-rules-and-conduct",
      "href": "#4-rules-and-conduct",
      "aria-hidden": "true"
    }
  }, [_c('span', {
    staticClass: "link",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v("Rules and Conduct.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      As a condition of use, you promise not to use the Service for any\n      purpose that is prohibited by these Terms of Use. The Service\n      (including, without limitation, any Content) is provided only for your\n      own personal, non-commercial use (except with respect to Artist Entity,\n      Brand Entity and Label Entity (each, an “Artist” “Brand” “Label”)\n      selling Services, Music, Merchandise or other Content as authorized\n      through the Service. You are responsible for all of your activity in\n      connection with the Service. For purposes of these Terms of Use, the\n      term “Content” includes, without limitation, any User Submissions,\n      videos, audio clips, written forum comments, information, data, text,\n      photographs, software, scripts, graphics, and interactive features\n      generated, provided, or otherwise made accessible by Company or its\n      partners on or through the Service."), _c('br'), _vm._v("\n      By way of example, and not as a limitation, you shall not (and shall not\n      permit any third party to) either (a) take any action or (b) upload,\n      download, post, submit or otherwise distribute or facilitate\n      distribution of any content on or through the Service, including without\n      limitation any User Submission, that:\n    ")]), _vm._v(" "), _c('ul', [_c('li', [_c('strong', [_vm._v("infringes any patent, trademark, trade secret, copyright, right of\n          publicity or other right of any other person or entity or violates\n          any law or contractual duty;")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("you know is false, misleading, untruthful or inaccurate;")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("is unlawful, threatening, abusive, harassing, defamatory, libelous,\n          deceptive, fraudulent, invasive of another's privacy, tortious,\n          obscene, offensive;")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("constitutes unauthorized or unsolicited advertising, junk or bulk\n          e-mail (\"spamming\");")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("involves commercial activities and/or sales without Company's prior\n          written consent such as contests, sweepstakes, barter, advertising,\n          or pyramid schemes;")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("exploits people in a sexual or violent manner;")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("contains software viruses or any other computer codes, files, or\n          programs that are designed or intended to disrupt, damage, limit or\n          interfere with the proper function of any software, hardware, or\n          telecommunications equipment or to damage or obtain unauthorized\n          access to any system, data, password or other information of Company\n          or any third party; or")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("impersonates any person or entity, including any employee or\n          representative of Company.")])])]), _vm._v(" "), _c('p', [_vm._v("\n      Additionally, you shall not: (i) take any action that imposes or may\n      impose (as determined by Company in its sole discretion) an unreasonable\n      or disproportionately large load on Company’s (or its third party\n      providers’) infrastructure; (ii) interfere or attempt to interfere with\n      the proper working of the Service or any activities conducted on the\n      Service; (iii) bypass any measures Company may use to prevent or\n      restrict access to the Service (or other accounts, computer systems or\n      networks connected to the Service); (iv) run any form of auto-responder\n      or “spam” on the Service; or (v) use manual or automated software,\n      devices, or other processes to “crawl” or “spider” any page of the\n      Site."), _c('br'), _c('br'), _vm._v("\n      You shall not (directly or indirectly): (i) decipher, decompile,\n      disassemble, reverse engineer or otherwise attempt to derive any source\n      code or underlying ideas or algorithms of any part of the Service,\n      except to the limited extent applicable laws specifically prohibit such\n      restriction, (ii) modify, translate, or otherwise create derivative\n      works of any part of the Service, or (iii) copy, rent, lease,\n      distribute, or otherwise transfer any of the rights that you receive\n      hereunder. You shall abide by all applicable local, state, national and\n      international laws and regulations."), _c('br'), _c('br'), _vm._v("\n      Company does not guarantee that any Content or User Submissions (as\n      defined below) will be made available on the Site or through the\n      Service. Company has no obligation to monitor the Site, Service,\n      Content, or User Submissions. However, Company reserves the right to (i)\n      remove, edit or modify any Content in its sole discretion, including\n      without limitation any User Submissions, from the Site or Service at any\n      time, without notice to you and for any reason (including, but not\n      limited to, upon receipt of claims or allegations from third parties or\n      authorities relating to such Content or if Company is concerned that you\n      may have violated these Terms of Use), or for no reason at all and (ii)\n      to remove or block any User Submissions from the Service."), _c('br'), _c('br'), _vm._v("\n      Company reserves the right to investigate and take appropriate legal\n      action against anyone who, in Company's sole discretion, violates this\n      provision, including, without limitation, terminating your account\n      and/or reporting such activity or Content to law enforcement\n      authorities.\n    ")]), _vm._v(" "), _c('h3', [_c('a', {
    staticClass: "anchor",
    attrs: {
      "id": "5-personal-information",
      "href": "#5-personal-information",
      "aria-hidden": "true"
    }
  }, [_c('span', {
    staticClass: "link",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v("Personal Information.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      As a condition to using certain features of the Service (including,\n      without limitation, the free download feature, or making a purchase from\n      Company or an Artist Entity, Brand Entity, Label Entity), you may be\n      required to provide certain personal information to Company or relevant\n      Artist Entity, Brand Entity, Label Entity, such as your e-mail address,\n      country of residence and zip/postal code (\"User Information\")."), _c('br'), _c('br'), _vm._v("\n      You may register with the Company as a Listener and create a user\n      account (“Listener Account”), which will allow you to access features of\n      the Service that are available through Listeners Accounts, a Listeners\n      profile page that along with information that you choose to share about\n      yourself, and the ability to follow other Listeners or Artist Accounts,\n      Brand Accounts, Label Accounts . Following an Artist Account, Brand\n      Account, or Label Account, purchasing any content or services of\n      Verified Users, gives Verified Users access to your email address while\n      logged in to your Listener Account. Any information you provide for your\n      profile page will be available to other users of the Service by default,\n      subject to our Privacy Policy."), _c('br'), _c('br'), _vm._v("\n      As a condition to each such Verified User’s right to receive such User\n      Information, Company requires each Verified User to agree to the terms\n      set forth in the next section of this Agreement. However, you\n      acknowledge that Company has no control over the use of the User\n      Information by the Verified Users, and you further acknowledge and agree\n      that YouSound shall not be responsible or liable, directly or\n      indirectly, for any damage or loss caused or alleged to be caused by or\n      in connection with the Verified User’s use of such User Information.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      When any user manually deletes their accounts, their personal\n      information is deleted from our servers instantly, and information from\n      deleted accounts by any other user is no longer accessible. All deleted\n      account information backed up is deleted indefinitely within 7 days.\n    ")]), _vm._v(" "), _c('h3', [_c('a', {
    staticClass: "anchor",
    attrs: {
      "id": "6-verified-users-usages-of-personal-user-information",
      "href": "#6-verified-users-usages-of-personal-user-information",
      "aria-hidden": "true"
    }
  }, [_c('span', {
    staticClass: "link",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v("Verified Users Usages of Personal User Information.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      In connection with certain features of the Service, including by\n      requiring that Listeners provide you with their e-mail addresses and\n      other personal information in order to ship products any user orders\n      through the Site, you may collect certain types of User Information. As\n      a condition to receiving such User Information, you acknowledge and\n      agree that you will not disclose, rent, or sell any User Information to\n      any third party, and you will use the User Information only to ship\n      products Users purchase through the Site, and provide Users with general\n      information and news about the Verified User, such as upcoming shows,\n      new Music or other Content delivered in connection with your Verified\n      User account. You further agree that any e-mail or other communication\n      sent to the Verified User will comply with e-mail marketing laws and\n      include a mechanism by which the recipient can unsubscribe from the\n      mailing list, along with clear instructions on how to do so (i.e. a\n      functioning \"opt-out\" mechanism). You will promptly implement a\n      recipient’s request to opt-out of receiving e-mails from you and will\n      not send any further e-mails to such opting-out recipient.\n    ")]), _vm._v(" "), _c('h3', [_c('a', {
    staticClass: "anchor",
    attrs: {
      "id": "7-registration",
      "href": "#7-registration",
      "aria-hidden": "true"
    }
  }, [_c('span', {
    staticClass: "link",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v("Registration.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      You may browse the Site and view Content without registering, but as a\n      condition to using certain aspects of the Service, you may be required\n      to register with Company and select a password and screen name (“User\n      ID”). You shall provide Company with accurate, complete, and updated\n      registration information. Failure to do so shall constitute a breach of\n      these Terms of Use, which may result in immediate termination of your\n      Company account. You shall not (i) select or use as a User ID or domain\n      a name of another person with the intent to impersonate that person;\n      (ii) use as a User ID or domain a name subject to any rights of a person\n      other than you without appropriate authorization; or (iii) use as a User\n      ID or domain a name that is otherwise offensive, vulgar or obscene.\n      Company reserves the right to refuse registration of, or cancel a User\n      ID and domain in its sole discretion. You are solely responsible for\n      activity that occurs on your account and shall be responsible for\n      maintaining the confidentiality of your Company password. You shall\n      never use another user’s account without such other user’s express\n      permission. You will immediately notify Company in writing of any\n      unauthorized use of your account, or other account related security\n      breach of which you are aware.\n    ")]), _vm._v(" "), _c('h3', [_c('a', {
    staticClass: "anchor",
    attrs: {
      "id": "8-fees-and-payments-defined",
      "href": "#8-fees-and-payments-defined",
      "aria-hidden": "true"
    }
  }, [_c('span', {
    staticClass: "link",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v("Fees and Payments Defined.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      YouSound facilitates payments for purchases of products and services,\n      including physical merchandise (“Merchandise”). Each such purchase is a\n      “Transaction,” each Transaction involving Digital Content is a “Digital\n      Transaction”, such as Repost Requests, Donations, Services. Each\n      Transaction involving Merchandise is a “Merchandise Transaction.”\n      Transactions may be made using Stripe.com\n    ")]), _vm._v(" "), _c('h3', [_c('a', {
    staticClass: "anchor",
    attrs: {
      "id": "9-fees-and-payments",
      "href": "#9-fees-and-payments",
      "aria-hidden": "true"
    }
  }, [_c('span', {
    staticClass: "link",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v("Fees and Payments.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      You may purchase products and/or services from a Verified User through\n      the Site, including, without limitation, purchases of Merchandise. All\n      inquiries regarding Merchandise Transactions will be directed to the\n      relevant Verified User. Company is not responsible for refunds for\n      Merchandise, except as provided in this Agreement.\n    ")]), _vm._v(" "), _c('h4', [_vm._v("All Sales Are Final.")]), _vm._v(" "), _c('p', [_vm._v("\n      All sales of Digital Content are final (except where prohibited by law),\n      unless otherwise determined by YouSound. If you do not receive the\n      Digital Content or Physical product or otherwise have an issue with the\n      content delivered, please contact the seller first. If you still haven't\n      or can't receive your downloaded file due to a technical issue on the\n      YouSound service, contact YouSound at support@yousound.com with your\n      report and proof of payment, and we will resolve your issue. At\n      YouSound’s sole discretion, you may be credited or refunded for the\n      Digital Content. However, you understand and agree that YouSound is a\n      platform that Verified Users use to sell their products and services,\n      and the relevant Verified User(s) is/are solely responsible for such\n      content being delivered to you. In the case where a Verified User\n      refuses to refund a sale that YouSound has deemed refundable, YouSound\n      will connect both seller and buyer to resolve their dispute. YouSound\n      cannot force any sell to refund. YouSound does track all orders to\n      ensure sellers are actively fulfilling their orders. Sellers are able to\n      refund buyers through the Payments section of YouSound, refunds can only\n      be given by sellers discretion, YouSound cannot force a refund. YouSound\n      does track all orders processed, and keeps track of every case opened\n      for any product sold. If YouSound finds a trend in fraudulent activity,\n      we will delete all products, and deleted the sellers account. Refunds\n      should be pursued via your payment processes and/or financial services\n      used to render such payments. If a fraudulent charge back is made to a\n      seller, we will delete the buyers account.\n    ")]), _vm._v(" "), _c('h4', [_vm._v("Tax.")]), _vm._v(" "), _c('p', [_vm._v("\n      Your total price for Digital & Physical Content will include the price\n      of the product plus any applicable sales tax; such as sales tax based on\n      your location and the sales tax rate in effect at the time you purchase\n      the product. When Verified Users upload a product to site, Company only\n      allows Verified Users to add the product price and shipping price.\n      Company does not automatically add taxes to the sale. Verified Users are\n      responsible for including the tax in the products or services they sell,\n      and are responsible for taking the required percentage of tax from their\n      sales to pay the required tax in their Country, State, or Region.\n    ")]), _vm._v(" "), _c('h4', [_vm._v("Product Availability.")]), _vm._v(" "), _c('p', [_vm._v("\n      Transactions cannot be guaranteed to be available to you perpetually.\n      For example, if we receive a notification of claimed infringement from a\n      copyright owner or its agent with respect to specific Content, then U.S.\n      law may require us to remove that Content from the Service and not make\n      it available for future sale and we may also have to deny continued\n      access to anyone who previously purchased such Content. This means that\n      you may lose access to purchased Content previously available to you\n      through the Service. If we are required by law to deny access through\n      the Service to previously purchased Content, including by removing\n      access to Content from a user’s personal collection through any mobile\n      application, then Company and Verified Users will not provide the user\n      who purchased that Content with a refund, except as required by\n      applicable law. Users bear all risk from the denial of access to any\n      Content purchased through the Service. Because there is a possibility\n      that we may be required to deny you access to previously purchased\n      Content, we encourage you to promptly download any Content you purchase\n      through the Site to your own devices so that you will retain control and\n      possession of such Content even if we are required to remove the Content\n      from the Service. You warrant that if you enter into a Transaction, then\n      you shall be able to make full and immediate payment for the requested\n      products or services.\n    ")]), _vm._v(" "), _c('h4', [_vm._v("Seller Pricing & Fees")]), _vm._v(" "), _c('p', [_vm._v("\n      Verified Users will set the prices for their products and services that\n      are charged through Transactions (the “Prices”) through the Site, and\n      you may change the Prices at your sole discretion. Company shall be\n      entitled to a share of the revenue you receive from Transactions (the\n      “Revenue Share”), which shall be calculated on your gross revenue from\n      Transactions, not including any Transactions for which you or we provide\n      a refund. You shall be solely responsible and liable for, and Company\n      shall have no responsibility or liability for, any Stripe fees (except\n      for fees charged on Company’s Stripe account), credit card transaction\n      fees (together, “Fees”), bad debts (such as credit card returns or\n      fraud), disputed payments, and refunds, except as provided in this\n      Agreement. YouSound may withhold any taxes, duties, charges or levies on\n      payments by YouSound to you pursuant to this Agreement as may be\n      required by applicable law, rule or regulation. YouSound shall remit any\n      such withheld taxes, duties, charges or levies to the appropriate tax\n      authority, if required.\n    ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("\n      Physical & Digital Products, Repost Requests, Donations & Services.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      For Merchandise Transactions, payments received from users for\n      Merchandise shall be directed to Verified Users, minus 10% of the\n      product price, excluding shipping costs. For Digital Content, Donations\n      & Services (accessed through the “Send Love” button on users profiles),\n      payments received from users shall be directed to payment recipients,\n      minus 10% of the product or service price. For Repost Request (accessed\n      through Direct Messages), payments received from users shall be directed\n      to payment recipients, minus 50% of the price of $1.00 USD (one dollar),\n      and minus 10% of any price above $1.00 USD (one dollar) which is\n      directed to the Company.\n    ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Repost Price Upgrade.")]), _vm._v(" "), _c('p', [_vm._v("\n      To increase the amount any user wants to charge for Repost Requests\n      (“Repost Price Upgrade”), Users are required to pay annual fee equal to\n      the amount they want to charge. For example, if a user wants to charge\n      Verified Users $20 to repost Verified User’s content (Albums and/or\n      Merchandise), user must pay Company $20.00 annually. The maximum repost\n      price upgrade is $1,000,000 USD (one million dollars). The maximum\n      upgrade annual fee is $100,000 USD which is charged to users and paid to\n      Company for any upgrade prices that start at $100,000 USD (one hundred\n      thousand dollars), $250,000 USD (two hundred and fifty thousand\n      dollars), $500,000 USD (five hundred thousand dollars), and $1,000,000\n      USD (one million dollars). 100% of payments received for Repost Price\n      Upgrades shall be directed to Company.\n    ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Live Video Streaming Cost & Fees.")]), _vm._v(" "), _c('p', [_vm._v("\n      For Live Video Streaming, Verified Users pay $10.00 USD (ten dollars)\n      per hour to Live Video Stream to users. Verified Users can choose to\n      charge up to $10,000 USD (ten thousand dollars) per user ('Pay Per\n      View') to view their Live Video Stream, payments received from users\n      shall be directed to Verified User, minus 10% of the 'Pay Per View'\n      price which 10% is directed to Company.\n    ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n      Company retains the right, but does not have the obligation, to\n      immediately halt the offering or sale of any goods or services, prevent\n      or restrict access to the Site or the Services or take any other action\n      in case of technical problems, objectionable material, inaccurate\n      listings, or actions otherwise prohibited by the procedures and\n      guidelines contained on the Site, or for any other reason in the sole\n      and absolute discretion of Company, and to correct any inaccurate\n      listing or technical problems on the Site. Company may immediately halt\n      the offering or sale of any goods or services upon receipt of\n      notifications of claimed infringement, upon acquiring knowledge of\n      actual infringement, or becoming aware of facts or circumstances from\n      which infringing material is apparent with respect to any goods or\n      services.\n    ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n      Unless there is an outstanding Revenue Share owed to Company in which\n      case such payments may be directed to Company. YouSound may retain funds\n      otherwise payable to you if YouSound is required or chooses to provide a\n      refund on your behalf.\n    ")]), _vm._v(" "), _c('h3', [_c('a', {
    staticClass: "anchor",
    attrs: {
      "id": "14-additional-fees",
      "href": "#14-additional-fees",
      "aria-hidden": "true"
    }
  }, [_c('span', {
    staticClass: "link",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v("Additional Fees.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      In addition to the fees set forth above, Company reserves the right to\n      change its price list and to institute new charges at any time, upon ten\n      (10) days prior notice to you, which may be sent by e-mail or posted on\n      the Site. Use of the Service by you following such notification\n      constitutes your acceptance of any new or increased charges.\n    ")]), _vm._v(" "), _c('h3', [_c('a', {
    staticClass: "anchor",
    attrs: {
      "id": "15-linking-to-third-party-sites",
      "href": "#15-linking-to-third-party-sites",
      "aria-hidden": "true"
    }
  }, [_c('span', {
    staticClass: "link",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v("Linking to Third Party Sites.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      The Service may permit you to link to other websites or resources on the\n      Internet, and other websites or resources may contain links to the Site.\n      When you access third party websites, you do so at your own risk. These\n      other websites are not under Company's control, and you acknowledge that\n      Company is not responsible or liable for the content, functions,\n      accuracy, legality, appropriateness or any other aspect of such websites\n      or resources. The inclusion of any such link does not imply endorsement\n      by Company or any association with its operators. You further\n      acknowledge and agree that Company shall not be responsible or liable,\n      directly or indirectly, for any damage or loss caused or alleged to be\n      caused by or in connection with the use of or reliance on any such\n      Content, goods or services available on or through any such website or\n      resource.\n    ")]), _vm._v(" "), _c('h3', [_c('a', {
    staticClass: "anchor",
    attrs: {
      "id": "16-content-and-license",
      "href": "#16-content-and-license",
      "aria-hidden": "true"
    }
  }, [_c('span', {
    staticClass: "link",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v("Content and License.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      You agree that the Service contains Content specifically provided by\n      Company or its partners and that such Content is protected by\n      copyrights, trademarks, service marks, patents, trade secrets or other\n      proprietary rights and laws. You shall abide by and maintain all\n      copyright notices, information, and restrictions contained in any\n      Content accessed through the Service. Company grants each user of the\n      Site and/or Service a worldwide, non-exclusive, non-sublicensable and\n      non-transferable license to use, modify and reproduce the Content,\n      solely for personal, non-commercial use. Use, reproduction,\n      modification, distribution or storage of any Content for other than\n      personal, non-commercial use is expressly prohibited without prior\n      written permission from Company, or from the copyright holder identified\n      in such Content's copyright notice. You shall not sell, license, rent,\n      or otherwise use or exploit any Content for commercial use or in any way\n      that violates any third party right.\n    ")]), _vm._v(" "), _c('h3', [_c('a', {
    staticClass: "anchor",
    attrs: {
      "id": "17-verified-users-respect-of-ip",
      "href": "#17-verified-users-respect-of-ip",
      "aria-hidden": "true"
    }
  }, [_c('span', {
    staticClass: "link",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v("Verified Users & Intellectual Property Rights.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      The Service provides Verified Artists with the ability to upload Digital\n      Content owned or controlled by such Verified Artists to the Site,\n      including but not limited to sound recordings (“Sound Recordings”),\n      videos synchronized with Sound Recordings and other audiovisual works\n      (collectively, “Music Videos”), and the musical works embodied within\n      Sound Recordings and Music Videos (“Musical Works” and, collectively\n      with Sound Recordings and Music Videos, the Verified Artist’s “Music”).\n      Company will not have any ownership rights in any elements of a Verified\n      Artist’s Music, however, Company needs the following license to perform\n      the Service. Each Verified Artist uploading Music to the Service grants\n      Company and its authorized sublicensees and distributors, if any, the\n      worldwide, non-exclusive, royalty-free, right and license to:\n    ")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("(i) reproduce, distribute, publicly perform (including on a\n        through-to-the-audience basis and by means of a digital audio\n        transmission), publicly display, create derivate works of, communicate\n        to the public, synchronize and otherwise exploit (collectively,\n        “Exploit”) (1) the Verified Artist’s Music and perform the Service on\n        the Verified Artist’s behalf (e.g., reproduce, transcode, copy and\n        store the Verified Artist’s Music on computer servers owned and/or\n        operated by or on behalf of Company or its authorized sublicensees and\n        distributors, and publicly perform, transmit, synchronize, stream,\n        distribute, and playback the Verified Artist’s Music) using any\n        technologies or methodologies now known or hereafter developed, and\n        (2) Exploit all associated copyrightable works or metadata, including,\n        without limitation, song lyrics and musical notations, album cover\n        artwork, photographs, graphics, and descriptive text (“Artworks”) in\n        connection with the Service);")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("(ii) allow users of the Service to receive public performances and\n        public displays of the Verified Artist’s Music and Artworks and to\n        reproduce the Verified Artist’s Music and Artworks on any and all\n        devices owned or controlled by the user for non-commercial purposes\n        and receive performances and displays of same; and")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("(iii) reproduce, use, and publish, and to permit others to reproduce,\n        use and publish, the name(s), trademarks, likenesses, and personal and\n        biographical materials of the Verified Artist, in connection with the\n        provision of the Service.")])]), _vm._v(" "), _c('p', [_vm._v("\n      To enable company to exploit your content, music, products, graphics,\n      and any user uploaded and submitted content, pursuant to the above\n      provisions, you hereby grant to Company the worldwide, non-exclusive,\n      royalty-free, sublicensable, and transferable right to use, distribute,\n      reproduce, copy, and display your trademarks, service marks, slogans,\n      logos or similar proprietary rights (collectively, the “Trademarks”)\n      solely in connection with the Service or in the marketing, promotion or\n      advertising of the service, including in all forms of marketing,\n      promotion, and advertising materials now known or hereafter created.\n    ")]), _vm._v(" "), _c('p', [_vm._v("By uploading any content the Site:")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Verified Users represent and warrant, and can demonstrate to\n        Company’s full satisfaction upon request, that (i) you own or\n        otherwise control all rights to your Music and Artworks (or that such\n        Music and Artworks are in the public domain or have otherwise been\n        directly licensed to the Verified User in writing with a grant of\n        rights sufficient to permit the Verified User to enter into this\n        Agreement and to grant all of the rights with respect to the Verified\n        User's Music or Artworks as set forth in this Agreement (hereinafter\n        “Direct Licensed”); (ii) you have full authority to act on behalf of\n        any and all owners of any right, title or interest in and to any Music\n        you upload to the Service and to the Artworks; (iii) you have\n        permission to use the name and likeness of each identifiable\n        individual person whose name or likeness is contained or used within\n        the Music and/or Artworks, and to use such individual’s identifying or\n        personal information (to the extent such information is used or\n        contained in the Music and/or Artworks) as contemplated by these Terms\n        of Use, and (iv) you are authorized to grant all of the aforementioned\n        rights to the Music and/or Artworks to Company and all users of the\n        Service.")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("you represent and warrant that the use or other exploitation of your\n        Music and/or Artworks by Company and its authorized sublicensees and\n        distributors and/or by users of the Site as contemplated by this\n        Agreement will not infringe or violate the rights of any third party,\n        including, without limitation, any privacy rights, publicity rights,\n        copyrights, contract rights, or any other intellectual property or\n        proprietary rights.")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("you represent and warrant that, to the extent you are the songwriter\n        of any or all of the Musical Works embodied in your Sound Recordings\n        or Music Videos, whether in whole or in part (e.g., as a co-writer),\n        you have the full right, power, and authority to grant the rights set\n        forth in this Agreement notwithstanding the provisions of any\n        agreement you may have entered into with any performing rights\n        organization (“PRO”), whether based in the United States (e.g., ASCAP,\n        BMI or SESAC) or elsewhere, or any music publisher, and that you are\n        solely responsible for taking all steps necessary to inform such PRO\n        or music publisher of your grant of a royalty free license to Company\n        for the public performances and communications to the public of your\n        Musical Works, and that no fees or payments of any kind whatsoever\n        shall be due to any PRO or music publisher for the public performance\n        or communication to the public of your Musical Works.")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("you represent and warrant that no fees of any kind shall be due any\n        third party, including, but not limited to, any union, guild,\n        non-featured vocalist or musician, engineer or producer, for the use\n        or re-use of your Music as authorized under this Agreement.")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("If any agreement you have entered into with any third party,\n        including, but not limited to a PRO, music publisher, union or guild,\n        whether by law or contract, prohibits you from granting company the\n        right and license set forth in this Agreement and making the\n        representations and warranties set forth in the four paragraphs\n        immediately above, then you are prohibited from uploading your music\n        to the Service and shall be responsible for indemnifying and holding\n        company harmless from and against any and all claims arising from the\n        exploitation of your music on the Service, including all court costs\n        and legal fees.")])]), _vm._v(" "), _c('h3', [_c('a', {
    staticClass: "anchor",
    attrs: {
      "id": "18-ip",
      "href": "#18-ip",
      "aria-hidden": "true"
    }
  }, [_c('span', {
    staticClass: "link",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v("Intellectual Property Rights.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      The Service provides Verified Users with the ability to add, create,\n      upload, submit, distribute or post (“Submitting” or “Submission”)\n      content, videos (including Music Videos), audio clips (including Music),\n      written forum comments, data, text, photographs, software, scripts,\n      graphics, or other information to the Site (collectively, the “User\n      Submissions”). By Submitting User Submissions on the Site or otherwise\n      through the Service, you:\n    ")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("acknowledge that by Submitting any User Submission to the Site, you\n        are publishing that User Submission, and that you may be identified\n        publicly by your User ID in association with any such User\n        Submission;")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("by Submitting any User Submissions through the Site or the Service,\n        you hereby grant Company a worldwide, non-exclusive, perpetual,\n        irrevocable, royalty-free, fully paid, sublicensable and transferable\n        license to use, edit, modify, reproduce, distribute, prepare\n        derivative works of, publicly display, publicly perform (including on\n        a through-to-the-audience basis and by means of a digital audio\n        transmission), communicate to the public, synchronize and otherwise\n        fully exploit the User Submissions in connection with the Site, the\n        Service and Company’s (and its successors and assigns’) business,\n        including without limitation for promoting and redistributing part or\n        all of the Site (and derivative works thereof) or the Service in any\n        media formats and through any media channels (including, without\n        limitation, third party websites), whether now known or hereafter\n        developed. You also hereby do and shall grant each user of the Site\n        and/or the Service a non-exclusive license to access your User\n        Submissions through the Site and the Service, and to use, edit,\n        modify, reproduce (on any and all devices owned or controlled by the\n        user), distribute, prepare derivative works of, display and perform\n        such User Submissions solely for personal, non-commercial use. For\n        clarity, the foregoing license grant to Company does not affect your\n        other ownership or license rights in your User Submission(s),\n        including the right to grant additional licenses to the material in\n        your User Submission(s), unless otherwise agreed in writing;")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("represent and warrant, and can demonstrate to Company’s full\n        satisfaction upon request that you (i) own or otherwise control all\n        rights to all content in your User Submissions, or that the content in\n        such User Submissions is in the public domain or Direct Licensed, (ii)\n        you have full authority to act on behalf of any and all owners of any\n        right, title or interest in and to any content in your User\n        Submissions to use such content as contemplated by these Terms of Use\n        and to grant the license rights set forth above, (iii) you have the\n        permission to use the name and likeness of each identifiable\n        individual person and to use such individual’s identifying or personal\n        information as contemplated by these Terms of Use; and (iv) you are\n        authorized to grant all of the aforementioned rights to the User\n        Submissions to Company and all users of the Service;")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("you agree to pay all royalties and other amounts owed to any person\n        or entity, including any PROs, due to your Submission of any User\n        Submissions to the Service;")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("that the use or other exploitation of such User Submissions by\n        Company and use or other exploitation by users of the Site and Service\n        as contemplated by this Agreement will not infringe or violate the\n        rights of any third party, including without limitation any privacy\n        rights, publicity rights, copyrights, contract rights, or any other\n        intellectual property or proprietary rights; and")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("understand that Company shall have the right to delete, edit, modify,\n        reformat, excerpt, or translate any materials, content or information\n        submitted by you; and that all information publicly posted or\n        privately transmitted through the Site is the sole responsibility of\n        the person from which such content originated and that Company will\n        not be liable for any errors or omissions in any content; and that\n        Company cannot guarantee the identity of any other users with whom you\n        may interact in the course of using the Service.")])]), _vm._v(" "), _c('p', [_vm._v("\n      Company does not endorse and has no control over any User Submission.\n      Company cannot guarantee the authenticity of any data which users may\n      provide about themselves. You acknowledge that all Content accessed by\n      you using the Service is at your own risk and you will be solely\n      responsible for any damage or loss to any party resulting therefrom.\n    ")]), _vm._v(" "), _c('h3', [_c('a', {
    staticClass: "anchor",
    attrs: {
      "id": "19-dmca-notice-takedown",
      "href": "#19-dmca-notice-takedown",
      "aria-hidden": "true"
    }
  }, [_c('span', {
    staticClass: "link",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v("DMCA Notice and Takedown Procedure.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      YouSound supports the protection of intellectual property and asks all\n      YouSound users to do the same. It’s our policy to respond to all notices\n      of alleged copyright infringement. If someone believes that one of our\n      Verified Users is infringing their intellectual property rights, they\n      can send a DMCA Notice to YouSound’s designated agent using our form.\n      Upon receiving a DMCA Notice, we may remove or disable access to the\n      Materials claimed to be a copyright infringement. Once provided with a\n      notice of takedown, the Verified User can reply with a counter\n      notification using our form if they object to the complaint. The\n      original complainant has 14 business days after we receive a counter\n      notification to seek a court order restraining the merchant from\n      engaging in the infringing activity, otherwise we restore the material.\n      For more information, see our DMCA Copyright Policy.\n    ")]), _vm._v(" "), _c('h3', [_c('a', {
    staticClass: "anchor",
    attrs: {
      "id": "20-user-of-devices-and-services",
      "href": "#20-user-of-devices-and-services",
      "aria-hidden": "true"
    }
  }, [_c('span', {
    staticClass: "link",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v("Use of Devices and Services.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      Access to the YouSound Services may require the use of your personal\n      computer or mobile device, as well as communications with or use of\n      space on such devices. You are responsible for any Internet connection\n      or mobile fees and charges that you incur when accessing the YouSound\n      Services.\n    ")]), _vm._v(" "), _c('h3', [_c('a', {
    staticClass: "anchor",
    attrs: {
      "id": "21-license",
      "href": "#21-license",
      "aria-hidden": "true"
    }
  }, [_c('span', {
    staticClass: "link",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v("License.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      The YouSound Services are owned and operated by YouSound. Unless\n      otherwise indicated, all content, information, and other materials on\n      the YouSound Services (excluding User Content), including, without\n      limitation, YouSound's trademarks and logos, the visual interfaces,\n      graphics, design, compilation, information, software, computer code\n      (including source code or object code), services, text, pictures,\n      information, data, sound files, other files and the selection and\n      arrangement thereof (collectively, the “Materials”) are protected by\n      relevant intellectual property and proprietary rights and laws. All\n      Materials contained on the YouSound Services are the property of\n      YouSound or its subsidiaries or affiliated companies and/or third-party\n      licensors. Unless otherwise expressly stated in writing by YouSound, by\n      agreeing to these Terms of Service you are granted a limited,\n      non-sublicensable license (i.e. a personal and limited right) to access\n      and use the YouSound Services for your personal use or internal business\n      use only.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      YouSound reserves all rights not expressly granted in these Terms of\n      Service. This license is subject to these Terms of Service and does not\n      permit you to engage in any of the following: (a) resale or commercial\n      use of the YouSound Services or the Materials; (b) distribution, public\n      performance or public display of any Materials; (c) modifying or\n      otherwise making any derivative uses of the YouSound Services or the\n      Materials, or any portion of them; (d) use of any data mining, robots or\n      similar data gathering or extraction methods; (e) downloading (except\n      page caching) of any portion of the YouSound Services, the Materials, or\n      any information contained in them, except as expressly permitted on the\n      YouSound Services; or (f) any use of the YouSound Services or the\n      Materials except for their intended purposes. Any use of the YouSound\n      Services or the Materials except as specifically authorized in these\n      Terms of Service, without the prior written permission of YouSound, is\n      strictly prohibited and may violate intellectual property rights or\n      other laws. Unless explicitly stated in these Terms of Service, nothing\n      in them shall be interpreted as conferring any license to intellectual\n      property rights, whether by estoppel, implication or other legal\n      principles. YouSound can terminate this license at any time, without\n      notice.\n    ")]), _vm._v(" "), _c('h3', [_c('a', {
    staticClass: "anchor",
    attrs: {
      "id": "22-user-content",
      "href": "#22-user-content",
      "aria-hidden": "true"
    }
  }, [_c('span', {
    staticClass: "link",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v("User Content.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      YouSound allows users to distribute streaming live and pre-recorded\n      audio-visual works, to use services, such as chat, bulletin boards,\n      forum postings, wiki contributions, voice interactive services, and to\n      participate in other activities in which you may create, post, transmit,\n      perform, or store content, messages, text, sound, images, applications,\n      code or other data or materials on the YouSound Services (“User\n      Content”).\n    ")]), _vm._v(" "), _c('h4', [_vm._v("Licenses to YouSound.")]), _vm._v(" "), _c('li', [_vm._v("\n      (i) Unless otherwise agreed to in a written agreement between you and\n      YouSound that was signed by an authorized representative of YouSound, if\n      you submit, transmit, display, perform, post or store User Content using\n      the YouSound Services, you grant YouSound and its sublicensees an\n      unrestricted, worldwide, perpetual, irrevocable, fully sub-licenseable,\n      nonexclusive, and royalty-free right to (a) use, reproduce, modify,\n      adapt, publish, translate, create derivative works from, distribute,\n      perform and display such User Content (including without limitation for\n      promoting and redistributing part or all of the YouSound Services (and\n      derivative works thereof)) in any form, format, media or media channels\n      now known or later developed or discovered; and (b) use the name,\n      identity, likeness and voice (or other biographical information) that\n      you submit in connection with such User Content.\n    ")]), _vm._v(" "), _c('li', [_vm._v("\n      (ii) With respect to streaming live and pre-recorded audio-visual works,\n      the rights granted by you hereunder terminate once you delete such User\n      Content from the YouSound Services, or generally by closing your\n      account, except (a) to the extent you shared it with others as part of\n      the YouSound Services and others copied or stored portions of the User\n      Content (e.g., made a Clip); (b) YouSound used it for promotional\n      purposes; and (c) for the reasonable time it takes to remove from backup\n      and other systems.\n    ")]), _vm._v(" "), _c('h4', [_vm._v("User Content Representations and Warranties")]), _vm._v(" "), _c('p', [_vm._v("\n      You are solely responsible for your User Content and the consequences of\n      posting or publishing it. By uploading and publishing your User Content,\n      you represent, and warrant that:\n    ")]), _vm._v(" "), _c('li', [_vm._v("\n      (1) you are the creator and owner of the User Content or otherwise have\n      sufficient rights and authority to grant the rights granted herein;\n    ")]), _vm._v(" "), _c('li', [_vm._v("\n      (2) your User Content does not and will not (a) infringe, violate, or\n      misappropriate any third-party right, including any copyright,\n      trademark, patent, trade secret, moral right, privacy right, right of\n      publicity, or any other intellectual property or proprietary right or\n      (b) defame any other person;\n    ")]), _vm._v(" "), _c('li', [_vm._v("\n      (3) your User Content does not contain any viruses, adware, spyware,\n      worms, or other harmful or malicious code; and (4) unless you have\n      received prior written authorization, your User Content specifically\n      does not contain any pre-release or non-public beta software or content\n      or any confidential information of YouSound or third parties. YouSound\n      reserves all rights and remedies against any users who breach these\n      representations and warranties.\n    ")]), _vm._v(" "), _c('h4', [_vm._v("Content is Uploaded at Your Own Risk")]), _vm._v(" "), _c('p', [_vm._v("\n      YouSound uses reasonable security measures in order to attempt to\n      protect User Content against unauthorized copying and distribution.\n      However, YouSound does not guarantee and is not liable for any\n      unauthorized copying, use or distribution of User Content. You hereby\n      release and forever waive any claims you may have against YouSound for\n      any such unauthorized copying or usage of the User Content, under any\n      theory. THE SECURITY MEASURES TO PROTECT CREATOR CONTENT USED BY\n      YouSound HEREIN ARE PROVIDED AND USED \"AS-IS\" AND WITH NO WARRANTIES OR\n      ASSURANCES THAT SUCH SECURITY MEASURES WILL WITHSTAND ATTEMPTS TO EVADE\n      SECURITY MECHANISMS OR THAT THERE WILL BE NO CRACKS, DISABLEMENTS OR\n      OTHER CIRCUMVENTION OF SUCH SECURITY MEASURES.\n    ")]), _vm._v(" "), _c('h3', [_c('a', {
    staticClass: "anchor",
    attrs: {
      "id": "23-promotions",
      "href": "#23-promotions",
      "aria-hidden": "true"
    }
  }, [_c('span', {
    staticClass: "link",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v("Promotions.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      Users may promote, administer, or conduct a promotion (a contest or\n      sweepstakes) on, through or utilizing the YouSound Services (a\n      “Promotion”). If you choose to promote, administer or conduct a\n      Promotion, you must adhere to the following rules: (i) You may carry out\n      Promotions to the extent permitted by applicable law and you are solely\n      responsible for ensuring that any Promotions comply with any and all\n      applicable laws, obligations, and restrictions. (ii) You will be solely\n      responsible for all aspects of and expenses related to your Promotion,\n      including, without limitation, the execution, administration, and\n      operation of the Promotion; drafting and posting any official rules;\n      selecting winners; issuing prizes; and obtaining all necessary\n      third-party permissions and approvals, including, without limitation,\n      filing any and all necessary registrations and bonds. YouSound has the\n      right to remove your Promotion from the YouSound Services for any\n      reason. (iii) YouSound is not responsible for and does not endorse or\n      support any such Promotions. You may not indicate that YouSound is a\n      sponsor or co-sponsor of the Promotion. (iv) All Verified Users should\n      display or read out the following when a Promotion is on their\n      channel: \"This is a promotion by [Your Name]. YouSound does not sponsor\n      or endorse [Your Name]’s promotion and is not responsible for this\n      promotion\".\n    ")]), _vm._v(" "), _c('h3', [_c('a', {
    staticClass: "anchor",
    attrs: {
      "id": "24-endorsements-testimonials",
      "href": "#24-endorsements-testimonials",
      "aria-hidden": "true"
    }
  }, [_c('span', {
    staticClass: "link",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v("Endorsements and Testimonials.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      You agree that your User Content will comply with the FTC's Guidelines\n      Concerning the Use of Testimonials and Endorsements in Advertising , the\n      FTC’s .com Disclosures Guide , the FTC’s Native Advertising Guidelines ,\n      and any other guidelines issued by the FTC from time to time (\"FTC\n      Guidelines”). For example, if you have been paid or provided with free\n      products in exchange for discussing or promoting a product or service\n      through the YouSound Services, or if you are an employee of a company\n      and you decide to discuss or promote that company's products or services\n      through the YouSound Services, you agree to comply with the FTC\n      Guidelines' requirements for disclosing such relationships. You, and not\n      YouSound, are solely responsible for any endorsements or testimonials\n      you make regarding any product or service through the YouSound Services.\n    ")]), _vm._v(" "), _c('h3', [_c('a', {
    staticClass: "anchor",
    attrs: {
      "id": "25-prohibited-conduct",
      "href": "#25-prohibited-conduct",
      "aria-hidden": "true"
    }
  }, [_c('span', {
    staticClass: "link",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v("Prohibited Conduct.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      BY USING THE YouSound SERVICES, YOU AGREE NOT TO violate any law,\n      contract, intellectual property or other third-party right or commit a\n      tort, and that you are solely responsible for your conduct while on the\n      YouSound Services. You agree that you will comply with these Terms of\n      Service and YouSound’s Community Guidelines and will not:\n    ")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("create, upload, transmit, distribute, or store any content that is\n        inaccurate, unlawful, infringing, defamatory, obscene, pornographic,\n        invasive of privacy or publicity rights, harassing, threatening,\n        abusive, inflammatory, or otherwise objectionable;")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("impersonate any person or entity, falsely claim an affiliation with\n        any person or entity, or access the YouSound Services accounts of\n        others without permission, forge another person’s digital signature,\n        misrepresent the source, identity, or content of information\n        transmitted via the YouSound Services, or perform any other similar\n        fraudulent activity;")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("make unsolicited offers, advertisements, proposals, or send junk mail\n        or spam to users of the YouSound Services, including, without\n        limitation, unsolicited advertising, promotional materials, or other\n        solicitation material, bulk mailing of commercial advertising, chain\n        mail, informational announcements, charity requests, petitions for\n        signatures, or any of the preceding things related to promotional\n        giveaways (such as raffles and contests), and other similar\n        activities;")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("harvest or collect the email addresses or other contact information\n        of other users from the YouSound Services;")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("defame, harass, abuse, threaten or defraud users of the YouSound\n        Services, or collect, or attempt to collect, personal information\n        about users or third parties without their consent;")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("remove, circumvent, disable, damage or otherwise interfere with\n        security-related features of the YouSound Services or User Content,\n        features that prevent or restrict use or copying of any content\n        accessible through the YouSound Services, features that enforce\n        limitations on the use of the YouSound Services or User Content, or\n        delete the copyright or other proprietary rights notices on the\n        YouSound Services or User Content;")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("reverse engineer, decompile, disassemble or otherwise attempt to\n        discover the source code of the YouSound Services or any part thereof,\n        except and only to the extent that this activity is expressly\n        permitted by the law of your country of residence;")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("modify, adapt, translate or create derivative works based upon the\n        YouSound Services or any part thereof, except and only to the extent\n        that such activity is expressly permitted by applicable law\n        notwithstanding this limitation;")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("interfere with or damage operation of the YouSound Services or any\n        user's enjoyment of them, by any means, including uploading or\n        otherwise disseminating viruses, adware, spyware, worms, or other\n        malicious code;")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("relay email from a third party's mail servers without the permission\n        of that third party;")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("access any website, server, software application, or other computer\n        resource owned, used and/or licensed by YouSound, including but not\n        limited to the YouSound Services, by means of any robot, spider,\n        scraper, crawler or other automated means for any purpose, or bypass\n        any measures YouSound may use to prevent or restrict access to any\n        website, server, software application, or other computer resource\n        owned, used and/or licensed YouSound, including but not limited to the\n        YouSound Services;")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("manipulate identifiers in order to disguise the origin of any User\n        Content transmitted through the YouSound Services;")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("interfere with or disrupt the YouSound Services or servers or\n        networks connected to the YouSound Services, or disobey any\n        requirements, procedures, policies or regulations of networks\n        connected to the YouSound Services; use the YouSound Services in any\n        manner that could interfere with, disrupt, negatively affect or\n        inhibit other users from fully enjoying the YouSound Services, or that\n        could damage, disable, overburden or impair the functioning of the\n        YouSound Services in any manner;")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("use or attempt to use another user's account without authorization\n        from that user and YouSound;")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("attempt to circumvent any content filtering techniques we employ, or\n        attempt to access any service or area of the YouSound Services that\n        you are not authorized to access;")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("attempt to indicate in any manner that you have a relationship with\n        us or that we have endorsed you or any products or services for any\n        purpose; and")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("use the YouSound Services for any illegal purpose, or in violation of\n        any local, state, national, or international law or regulation,\n        including, without limitation, laws governing intellectual property\n        and other proprietary rights, data protection and privacy.")])]), _vm._v(" "), _c('p', [_vm._v("\n      YouSound takes no responsibility and assumes no liability for any User\n      Content or for any loss or damage resulting therefrom, nor is YouSound\n      liable for any mistakes, defamation, slander, libel, omissions,\n      falsehoods, obscenity, pornography or profanity you may encounter when\n      using the YouSound Services. Your use of the YouSound Services is at\n      your own risk. In addition, these rules do not create any private right\n      of action on the part of any third party or any reasonable expectation\n      that the YouSound Services will not contain any content that is\n      prohibited by such rules.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      YouSound is not liable for any statements or representations included in\n      User Content. YouSound does not endorse any User Content, opinion,\n      recommendation, or advice expressed therein, and YouSound expressly\n      disclaims any and all liability in connection with User Content.\n      Although YouSound has no obligation to screen, edit, or monitor any of\n      the User Content, YouSound reserves the right, and has absolute\n      discretion, to remove, screen or edit any User Content posted or stored\n      on the YouSound Services at any time and for any reason without notice,\n      and you are solely responsible for creating backup copies of and\n      replacing any User Content you post or store on the YouSound Services at\n      your sole cost and expense. Any use of the YouSound Services in\n      violation of the foregoing violates these Terms of Service and may\n      result in, among other things, termination or suspension of your rights\n      to use the YouSound Services.\n    ")]), _vm._v(" "), _c('h4', [_vm._v("Trademarks")]), _vm._v(" "), _c('p', [_vm._v("\n      YouSound, the YouSound logos, and any other product or service name,\n      logo, or slogan used by YouSound, and the look and feel of the YouSound\n      Services, including all page headers, custom graphics, button icons and\n      scripts, are trademarks or trade dress of YouSound, and may not be used\n      in whole or in part in connection with any product or service that is\n      not YouSound’s, in any manner that is likely to cause confusion among\n      customers, or in any manner that disparages or discredits YouSound,\n      without our prior written permission. Any use of these trademarks must\n      be in accordance with any guidelines that YouSound may provide you from\n      time to time. All other trademarks referenced in the YouSound Services\n      are the property of their respective owners. Reference on the YouSound\n      Services to any products, services, processes or other information, by\n      trade name, trademark, manufacturer, supplier, or otherwise does not\n      constitute or imply endorsement, sponsorship, or recommendation thereof\n      by us or any other affiliation.\n    ")]), _vm._v(" "), _c('h3', [_c('a', {
    staticClass: "anchor",
    attrs: {
      "id": "26-third-party-content",
      "href": "#26-third-party-content",
      "aria-hidden": "true"
    }
  }, [_c('span', {
    staticClass: "link",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v("Third Party Content.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      In addition to the User Content, YouSound may provide other third party\n      content on the YouSound Services (collectively the “Third-Party\n      Content”). YouSound does not control or endorse any Third-Party Content\n      and makes no representation or warranties of any kind regarding the\n      Third-Party Content, including without limitation regarding its accuracy\n      or completeness. Please be aware that we do not create Third Party\n      Content, update, or monitor it. Therefore we are not responsible for any\n      Third Party Content on the YouSound Services.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      You are responsible for deciding if you want to access or use third\n      party websites or applications that link from the YouSound Services\n      (“Reference Sites”). YouSound does not control or endorse any such\n      Reference Sites or the information, materials, products, or services\n      contained on or accessible through Reference Sites, and makes no\n      representations or warranties of any kind regarding the Reference Sites.\n      In addition, your correspondence or business dealings with, or\n      participation in promotions of, advertisers found on or through the\n      YouSound Services are solely between you and such advertiser. Access and\n      use of Reference Sites, including the information, materials, products,\n      and services on or available through Reference Sites is solely at your\n      own risk.\n    ")]), _vm._v(" "), _c('h3', [_c('a', {
    staticClass: "anchor",
    attrs: {
      "id": "27-idea-submission",
      "href": "#27-idea-submission",
      "aria-hidden": "true"
    }
  }, [_c('span', {
    staticClass: "link",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v("Idea Submission.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      By submitting ideas, suggestions, documents, and/or proposals\n      (“Submissions”) to YouSound or its employees, you acknowledge and agree\n      that YouSound shall be entitled to use or disclose such Submissions for\n      any purpose in any way without providing compensation or credit to you.\n    ")]), _vm._v(" "), _c('h3', [_c('a', {
    staticClass: "anchor",
    attrs: {
      "id": "28-termination",
      "href": "#28-termination",
      "aria-hidden": "true"
    }
  }, [_c('span', {
    staticClass: "link",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v("Termination.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      Company may terminate your access to all or any part of the Service at\n      any time, with or without cause, with or without notice, effective\n      immediately, which may result in the forfeiture and destruction of all\n      information associated with your membership, including, without\n      limitation, any access to any Music you may have purchased through the\n      Service. If you wish to terminate your account, then you may do so by\n      following the instructions on the Site. Any fees paid hereunder are\n      non-refundable, except as provided in this Agreement. All provisions of\n      these Terms of Use which by their nature should survive termination\n      shall survive termination, including, without limitation, ownership\n      provisions, warranty disclaimers, indemnity and limitations of\n      liability.\n    ")]), _vm._v(" "), _c('h3', [_c('a', {
    staticClass: "anchor",
    attrs: {
      "id": "29-warranty-disclaimer",
      "href": "#29-warranty-disclaimer",
      "aria-hidden": "true"
    }
  }, [_c('span', {
    staticClass: "link",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v("Warranty Disclaimer.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      Company has no special relationship with or fiduciary duty to you. You\n      acknowledge that Company has no control over, and no duty to take any\n      action regarding: which users gains access to the Site; what Content you\n      access via the Site; what effects the Content may have on you; how you\n      may interpret or use the Content; or what actions you may take as a\n      result of having been exposed to the Content. You release Company from\n      all liability for you having acquired or not acquired Content through\n      the Site. The Site may contain, or direct you to websites containing,\n      information that some people may find offensive or inappropriate.\n      Company makes no representations concerning any Content contained in or\n      accessed through the Site, and Company will not be responsible or liable\n      for the accuracy, copyright compliance, legality or decency of material\n      contained in or accessed through the Site or the Service.\n    ")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The Service is provided \"as is\" and \"as available” and is without\n        warranty of any kind, express or implied, including, but not limited\n        to, the implied warranties of title, non-infringement, merchantability\n        and fitness for a particular purpose, and any warranties implied by\n        any course of performance or usage of trade, all of which are\n        expressly disclaimed. Company, and its directors, employees, agents,\n        suppliers, partners and content providers do not warrant that: (a) the\n        service will be secure or available at any particular time or\n        location; (b) any defects or errors will be corrected; (c) any content\n        or software available at or through the service is free of viruses or\n        other harmful components; or (d) the results of using the service will\n        meet your requirements. Your use of the service is solely at your own\n        risk. Some states do not allow limitations on how long an implied\n        warranty lasts, so the above limitations may not apply to you.")])]), _vm._v(" "), _c('p', [_vm._v("\n      Electronic Communications Privacy Act Notice (18 U.S.C. §§ 2701-2711):\n      Company makes no guaranty of confidentiality or privacy of any\n      communication or information transmitted on the Site or any website\n      linked to the Site. Company will not be liable for the privacy of e-mail\n      addresses, registration and identification information, disk space,\n      communications, confidential or trade-secret information, or any other\n      Content stored on Company’s equipment, transmitted over networks\n      accessed by the Site, or otherwise connected with your use of the\n      Service.\n    ")]), _vm._v(" "), _c('h3', [_c('a', {
    staticClass: "anchor",
    attrs: {
      "id": "30-indemnification",
      "href": "#30-indemnification",
      "aria-hidden": "true"
    }
  }, [_c('span', {
    staticClass: "link",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v("Indemnification.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      You shall defend, indemnify, and hold harmless Company and its\n      affiliates, authorized sublicensees and distributors, and each of their\n      employees, contractors, directors, suppliers and representatives, from\n      any and all liabilities, claims, and expenses, including reasonable\n      attorneys' fees and court costs, that arise from or relate to your use\n      or misuse of, or access to, the Site, Service, Content or otherwise from\n      your User Submissions, violation of these Terms of Use, or infringement\n      by you, or any third party using the your account, of any intellectual\n      property or other right of any person or entity, and for breach of any\n      of your representations and warranties in these Terms of Use. For the\n      avoidance of doubt, you hereby agree to defend, indemnify, and hold\n      harmless Company from any and all claims by a third party owning,\n      controlling or claiming any right in or to your Music, including claims\n      for performance royalties, synchronization royalties, mechanical\n      royalties, and use or re-use fees. Company reserves the right to assume\n      the exclusive defense and control of any matter otherwise subject to\n      indemnification by you, in which event you will assist and cooperate\n      with Company in asserting any available defenses at your sole expense.\n    ")]), _vm._v(" "), _c('h3', [_c('a', {
    staticClass: "anchor",
    attrs: {
      "id": "31-limitation-of-liability",
      "href": "#31-limitation-of-liability",
      "aria-hidden": "true"
    }
  }, [_c('span', {
    staticClass: "link",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v("Limitation of Liability.\n    ")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("In no event shall Company, nor its directors, employees, agents,\n        partners, suppliers or content providers, be liable under contract,\n        tort, strict liability, negligence or any other legal or equitable\n        theory with respect to the Service (i) for any lost profits, data\n        loss, cost of procurement of substitute goods or services, or special,\n        indirect, incidental, punitive, or consequential damages of any kind\n        whatsoever, substitute goods or services (however arising), (ii) for\n        any bugs, viruses, trojan horses, or the like (regardless of the\n        source of origination), or (iii) for any direct damages in excess of\n        (in the aggregate) one-hundred U.S. dollars ($100.00). Some states do\n        not allow the exclusion or limitation of incidental or consequential\n        damages, so the above limitations and exclusions may not apply to you.\n      ")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Because Company is not the buyer or seller in any Merchandise\n        Transaction, if a dispute arises between one or more participants in a\n        Merchandise Transaction, then you release Company (and its affiliates,\n        agents and employees) from claims, demands and damages (actual and\n        consequential) of every kind and nature, known and unknown, suspected\n        and unsuspected, disclosed and undisclosed, arising out of or in any\n        way connected with such disputes. If you are a California resident,\n        then you waive California civil code §1542, which says: \"a general\n        release does not extend to claims which the creditor does not know or\n        suspect to exist in his favor at the time of executing the release,\n        which if known by him must have materially affected his settlement\n        with the debtor.\" You, being aware of said code section, hereby\n        expressly waive any rights you may have thereunder, as well as under\n        any other statutes or common law principles of similar effect. You\n        acknowledge and agree that this waiver is an essential and material\n        term of this Agreement, and that without such waiver, this Agreement\n        would not have been entered into by Company.")])]), _vm._v(" "), _c('p', [_vm._v("\n      Because Company is not the buyer or seller in any actual Merchandise\n      Transaction between Verified Users and Listeners and is not the agent of\n      either for any purpose, Company does not have the duty to resolve and\n      will not be involved in resolving any disputes between participants\n      related to or arising out of any such Merchandise Transaction. Artists\n      are individually responsible for compliance with all consumer rights\n      laws applicable to their Merchandise Transactions, including EU Consumer\n      Rights Laws.\n    ")]), _vm._v(" "), _c('h3', [_c('a', {
    staticClass: "anchor",
    attrs: {
      "id": "32-international-non-california-user",
      "href": "#32-international-non-california-user",
      "aria-hidden": "true"
    }
  }, [_c('span', {
    staticClass: "link",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v("International/Non-California Use.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      Company makes no representation that the Content is appropriate or\n      available for use in locations outside of California, and accessing the\n      Service is prohibited from territories where such Content is illegal. If\n      you access the Service from other locations, you do so at your own\n      initiative and are responsible for compliance with local laws.\n    ")]), _vm._v(" "), _c('h3', [_c('a', {
    staticClass: "anchor",
    attrs: {
      "id": "33-dispute-resolution",
      "href": "#33-dispute-resolution",
      "aria-hidden": "true"
    }
  }, [_c('span', {
    staticClass: "link",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v("Dispute Resolution.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      A printed version of these Terms of Use and of any notice given in\n      electronic form shall be admissible in judicial or administrative\n      proceedings based upon or relating to these Terms of Use to the same\n      extent and subject to the same conditions as other business documents\n      and records originally generated and maintained in printed form. You and\n      Company agree that any cause of action arising out of or related to the\n      Service must commence within one (1) year after the cause of action\n      arose; otherwise, such cause of action is permanently barred. These\n      Terms of Use shall be governed by and construed in accordance with the\n      laws of the State of California, excluding its conflicts of law rules,\n      and the United States of America. Any dispute arising from or relating\n      to the subject matter of this Agreement shall be finally settled by\n      arbitration in San Francisco County, California, using the English\n      language in accordance with the Arbitration Rules and Procedures of\n      Judicial Arbitration and Mediation Services, Inc. (\"JAMS\") then in\n      effect, by one commercial arbitrator with substantial experience in\n      resolving intellectual property and commercial contract disputes, who\n      shall be selected from the appropriate list of JAMS arbitrators in\n      accordance with the Arbitration Rules and Procedures of JAMS. The\n      prevailing party in the arbitration shall be entitled to receive\n      reimbursement of its reasonable expenses (including reasonable\n      attorneys' fees, expert witness fees and all other expenses) incurred in\n      connection therewith. Judgment upon the award so rendered may be entered\n      in a court having jurisdiction or application may be made to such court\n      for judicial acceptance of any award and an order of enforcement, as the\n      case may be. Notwithstanding the foregoing, each party shall have the\n      right to institute an action in a court of proper jurisdiction for\n      injunctive or other equitable relief pending a final decision by the\n      arbitrator. For all purposes of this Agreement, the parties consent to\n      exclusive jurisdiction and venue in the United States Federal Courts or\n      state courts located in the Northern District of California. Use of the\n      Service is not authorized in any jurisdiction that does not give effect\n      to all provisions of these Terms of Use, including without limitation,\n      this section.\n    ")]), _vm._v(" "), _c('h3', [_c('a', {
    staticClass: "anchor",
    attrs: {
      "id": "34-integration-and-severability",
      "href": "#34-integration-and-severability",
      "aria-hidden": "true"
    }
  }, [_c('span', {
    staticClass: "link",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v("Integration and Severability.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      These Terms of Use are the entire agreement between you and Company with\n      respect to the Service and use of the Site, and supersede all prior or\n      contemporaneous communications and proposals (whether oral, written or\n      electronic) between you and Company with respect to the Site. If any\n      provision of these Terms of Use is found to be unenforceable or invalid,\n      that provision will be limited or eliminated to the minimum extent\n      necessary so that these Terms of Use will otherwise remain in full force\n      and effect and enforceable. The failure of either party to exercise in\n      any respect any right provided for herein shall not be deemed a waiver\n      of any further rights hereunder.\n    ")]), _vm._v(" "), _c('h3', [_c('a', {
    staticClass: "anchor",
    attrs: {
      "id": "35-miscellaneous",
      "href": "#35-miscellaneous",
      "aria-hidden": "true"
    }
  }, [_c('span', {
    staticClass: "link",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v("Miscellaneous.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      Company shall not be liable for any failure to perform its obligations\n      hereunder where such failure results from any cause beyond Company’s\n      reasonable control, including, without limitation, mechanical,\n      electronic or communications failure or degradation (including\n      \"line-noise\" interference). These Terms of Use are personal to you, and\n      are not assignable, transferable or sublicensable by you except with\n      Company's prior written consent. Company may assign, transfer or\n      delegate any of its rights and obligations hereunder without consent. No\n      agency, partnership, joint venture, or employment relationship is\n      created as a result of these Terms of Use and neither party has any\n      authority of any kind to bind the other in any respect. In any action or\n      proceeding to enforce rights under these Terms of Use, the prevailing\n      party will be entitled to recover costs and attorneys' fees. All notices\n      under these Terms of Use will be in writing and will be deemed to have\n      been duly given when received, if personally delivered or sent by\n      certified or registered mail, return receipt requested; when receipt is\n      electronically confirmed, if transmitted by facsimile or e-mail; or the\n      day after it is sent, if sent for next day delivery by recognized\n      overnight delivery service. The captions and headings in this Agreement\n      are intended only for convenience, and will in no event be construed to\n      define, limit or describe the scope or intent of this Agreement, or of\n      any provision of this Agreement, nor in any way affect the\n      interpretation of this Agreement.\n    ")]), _vm._v(" "), _c('h3', [_c('a', {
    staticClass: "anchor",
    attrs: {
      "id": "36-contact",
      "href": "#36-contact",
      "aria-hidden": "true"
    }
  }, [_c('span', {
    staticClass: "link",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v("Contact.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      You may contact company at the following address: support@yousound.com.\n    ")])])])
}]}

/***/ }),
/* 1800 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Header'), _vm._v(" "), _c('CRow', {
    attrs: {
      "title": 'Creators Get Paid By',
      "title2": 'You Play.',
      "ctaText": 'Choose a plan',
      "ctaAction": '#plans',
      "imgSrc": _vm.img,
      "order1": 2,
      "order2": 1,
      "fullWidth": true
    }
  }), _vm._v(" "), _c('CRow', {
    attrs: {
      "title": 'Track creators you support',
      "title2": 'on your dashboard',
      "imgSrc": _vm.img1,
      "order1": 1,
      "order2": 2
    }
  }), _vm._v(" "), _c('CRow', {
    attrs: {
      "title": ' Make money',
      "title2": 'sharing content',
      "imgSrc": _vm.img2,
      "order1": 2,
      "order2": 1
    }
  }), _vm._v(" "), _c('plans'), _vm._v(" "), _c('Footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 1801 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Header'), _vm._v(" "), _c('Banner', {
    attrs: {
      "title": 'The best place for artists & brands.',
      "imgSrc": _vm.bannerImg
    }
  }), _vm._v(" "), _c('common-section', {
    attrs: {
      "title": 'Upload Music ',
      "title2": '& Share ',
      "title3": 'Upload Videos',
      "title4": '& Share',
      "imgSrc": _vm.img,
      "order1": 1,
      "order2": 2,
      "imgSrc1": _vm.img1,
      "order3": 2,
      "order4": 1,
      "bg": true,
      "list1": _vm.musicList,
      "list2": _vm.videoList
    }
  }), _vm._v(" "), _c('common-section', {
    attrs: {
      "title": 'Sell Your',
      "title2": 'Products',
      "title3": 'Multiple',
      "title4": 'Revenue Streams',
      "imgSrc": _vm.img2,
      "order1": 1,
      "order2": 2,
      "imgSrc1": _vm.img3,
      "order3": 2,
      "order4": 1,
      "bg": false,
      "list1": _vm.productList,
      "list2": _vm.streamsList
    }
  }), _vm._v(" "), _c('common-section', {
    attrs: {
      "title": 'Measure & Grow',
      "title2": 'Your Audience',
      "title3": 'Become a Partner',
      "title4": '& Earn More',
      "imgSrc": _vm.img4,
      "order1": 1,
      "order2": 2,
      "imgSrc1": _vm.img5,
      "order3": 2,
      "order4": 1,
      "bg": false,
      "list1": _vm.growList,
      "list2": _vm.partnerList
    }
  }), _vm._v(" "), _c('time-line'), _vm._v(" "), _c('join'), _vm._v(" "), _c('Footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 1802 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": "",
      "py-0": ""
    },
    on: {
      "touchstart": _vm.touchStart,
      "touchend": _vm.touchEnd
    }
  }, [(_vm.onMobileStrict) ? _c('div', {
    staticClass: "mobile-top _logo"
  }, [_c('div', {
    staticClass: "logo-img-wrapper",
    class: {
      'allChildrenCenter': _vm.activeView == 'landingView'
    }
  }, [_c('img', {
    staticClass: "cursor-pointer logo-img",
    attrs: {
      "src": __webpack_require__(49),
      "width": "130",
      "alt": "Yousound Logo"
    },
    on: {
      "click": function($event) {
        _vm.activeView = 'landingView'
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "switch-tab",
    class: {
      'landingView': _vm.activeView == 'landingView',
      'learnMoreView': _vm.activeView == 'learnMoreView'
    }
  }, [_c('span', {
    staticClass: "_icon",
    class: {
      _filled: _vm.activeView === 'landingView'
    },
    on: {
      "click": function($event) {
        _vm.activeView = 'landingView'
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "_icon",
    class: {
      _filled: _vm.activeView === 'learnMoreView'
    },
    on: {
      "click": function($event) {
        _vm.activeView = 'learnMoreView'
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "align-center": "",
      "full-authTabs-wrapper": "",
      "justify-center": "",
      "row": ""
    }
  }, [(_vm.activeView != 'loginView' && _vm.activeView != 'signUpView') ? _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.onMobileStrict || (_vm.onMobileStrict && _vm.activeView === 'landingView')),
      expression: "!onMobileStrict || (onMobileStrict && activeView === 'landingView')"
    }],
    class: {
      onMobileStrict: _vm.onMobileStrict
    },
    attrs: {
      "flex-column": "",
      "xs12": "",
      "sm6": "",
      "allChildrenCenter": "",
      "full-authTabs-twin": "",
      "full-authTabs-left": "",
      "text-center": ""
    }
  }, [(!_vm.onMobileStrict) ? _c('div', {
    staticClass: "_logo"
  }, [_c('img', {
    staticClass: "cursor-pointer logo-img",
    attrs: {
      "src": __webpack_require__(49),
      "width": "130",
      "alt": "Yousound Logo"
    },
    on: {
      "click": function($event) {
        _vm.activeView = 'landingView'
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "_banner"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(221),
      "width": "70%",
      "alt": "artist with sound machine"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "intro-title mt-5"
  }, [_vm._v("The best place for "), (_vm.onMobileStrict) ? _c('br') : _vm._e(), _vm._v(" music lovers.")]), _vm._v(" "), (_vm.showAuthCTA && !_vm.onMobileStrict) ? _c('div', {
    staticClass: "dflex auth-btns mt-3"
  }, [(_vm.showSignupBtn) ? _c('v-btn', {
    attrs: {
      "ripple": false,
      "depressed": "",
      "dark": "",
      "round": ""
    },
    on: {
      "click": function($event) {
        _vm.activeView = 'signUpView'
      }
    }
  }, [_vm._v("\n          Signup\n        ")]) : _vm._e(), _vm._v(" "), (_vm.showLoginBtn) ? _c('v-btn', {
    attrs: {
      "ripple": false,
      "depressed": "",
      "round": "",
      "outline": ""
    },
    on: {
      "click": _vm.showLogin
    }
  }, [_vm._v("\n          Login\n        ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.showAuthCTA) ? _c('h2', {
    staticClass: "learn-more",
    on: {
      "click": _vm.handleLearnMore
    }
  }, [_vm._v("\n        Learn More\n      ")]) : _vm._e(), _vm._v(" "), (_vm.onMobileStrict) ? _c('div', {
    staticClass: "app-download"
  }, [_c('img', {
    staticClass: "ios-store mr-3",
    attrs: {
      "src": _vm.iosStore,
      "width": "40%",
      "alt": "ios app store icon"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "android-store",
    attrs: {
      "src": _vm.androidPlaystore,
      "width": "40%",
      "alt": "android app store icon"
    }
  })]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (!_vm.onMobileStrict) ? _c('app-footer') : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.onMobileStrict || (_vm.onMobileStrict && _vm.activeView === 'learnMoreView')),
      expression: "!onMobileStrict || (onMobileStrict && activeView === 'learnMoreView')"
    }],
    class: {
      auth__view: _vm.toDisplayGrid,
      onMobileStrict: _vm.onMobileStrict
    },
    attrs: {
      "xs12": "",
      "sm6": "",
      "full-authTabs-twin": "",
      "full-authTabs-right": ""
    }
  }, [(_vm.activeView === 'landingView') ? _c('div', {
    staticClass: "landing-view"
  }, [_c('div', {
    staticClass: "trending-top dflex align-center justify-space-between"
  }, [_c('h2', {
    staticClass: "trending-title"
  }, [_vm._v("Trending")]), _vm._v(" "), _c('content-top-header', {
    attrs: {
      "absolute": ""
    }
  }, [_c('template', {
    slot: "topHeader"
  }, [_c('ul', {
    staticClass: "pr-3"
  }, [_vm._l((_vm.tabs), function(tab) {
    return _c('li', {
      key: tab.id,
      staticClass: "nav-li",
      class: [{
          'active tab-active': _vm.isActiveTab(tab.id)
        },
        ("nav-" + (tab.id)) ],
      attrs: {
        "href": ("#" + (tab.id))
      }
    }, [_c('label', {
      staticClass: "nav-label",
      on: {
        "click": function($event) {
          _vm.onTab(tab.id)
        }
      }
    }, [(tab.icon) ? _c('img', {
      staticClass: "li-icon",
      attrs: {
        "src": tab.icon,
        "width": "18"
      }
    }) : _vm._e(), _vm._v("\n                    " + _vm._s(tab.title) + "\n                  ")])])
  }), _vm._v(" "), _c('v-spacer')], 2)])], 2)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-left"
    }
  }, [(_vm.activeTab === 'music') ? _c('trending-music', {
    attrs: {
      "listLimit": 20,
      "classAttr": "xs3 px-1 mb-1",
      "hideTrackLength": "",
      "noMeta": "",
      "hideCta": "",
      "showHoverTrackInfo": "",
      "title": "",
      "playButton2": "",
      "playButton2IconHasWhiteBG": ""
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-left"
    }
  }, [(_vm.activeTab === 'videos') ? _c('trending-video', {
    attrs: {
      "listLimit": 20,
      "classAttr": "xs4 px-1",
      "title": "",
      "coverOnly": "",
      "showFullOverlay": "",
      "hoverOverlay": "",
      "hideCta": "",
      "coverRadius": ""
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-left"
    }
  }, [(_vm.activeTab === 'merch') ? _c('trending-product', {
    attrs: {
      "listLimit": 20,
      "classAttr": "xs3 px-1 mb-1",
      "altMeta": false,
      "hideCta": "",
      "title": "",
      "showFullOverlay": ""
    }
  }) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.activeView === 'signUpView') ? _c('div', {
    staticClass: "signup-view"
  }, [_c('div', {
    staticClass: "sign-up_logo",
    on: {
      "click": function($event) {
        _vm.activeView = 'landingView'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(49),
      "width": "150"
    }
  })]), _vm._v(" "), _c('Onboarding')], 1) : _vm._e(), _vm._v(" "), (_vm.activeView === 'loginView') ? _c('div', {
    staticClass: "login-view"
  }, [_c('div', {
    staticClass: "sign-up_logo",
    on: {
      "click": function($event) {
        _vm.activeView = 'landingView'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(49),
      "width": "150"
    }
  })]), _vm._v(" "), (_vm.loginAuth === 'login') ? _c('div', {
    staticClass: "login-input"
  }, [_c('div', {
    staticClass: "intro-text text-xs-center my-4"
  }, [_c('h2', [_vm._v("Hello,")]), _vm._v(" "), _c('h2', [_vm._v("welcome back!")])]), _vm._v(" "), _c('login-input', {
    attrs: {
      "showForgotPassword": _vm.showForgotPassword
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.loginAuth === 'forgotPassword') ? _c('div', {
    staticClass: "forgot-password-input"
  }, [_c('div', {
    staticClass: "intro-text text-xs-center"
  }, [_c('h2', [_vm._v("Forgot Password")])]), _vm._v(" "), _c('forgot-password-input', {
    attrs: {
      "showLogin": _vm.showLogin
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.activeView === 'learnMoreView') ? _c('div', {
    staticClass: "learn-more-view",
    style: ({
      'width': _vm.onMobileStrict ? '97%' : null
    })
  }, [_c('learn-more')], 1) : _vm._e()])], 1), _vm._v(" "), _c('Footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 1803 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "my-download-dialog",
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-flex', {
    staticClass: "dismiss-section",
    attrs: {
      "xs12": "",
      "sm12": ""
    },
    on: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "top-section",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('p', {
    staticClass: "title-label"
  }, [_vm._v("Support artists with your contribution")]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v("\n      When you download this album, it's reposted to your followers.\n    ")])]), _vm._v(" "), _c('v-layout', {
    staticClass: "popup-section",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "profile-section",
    attrs: {
      "xs12": ""
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/' + _vm.trackUser.slug
    }
  }, [_c('div', {
    staticClass: "avatar-image",
    style: ({
      'background-image': 'url(' + _vm.trackUser.avatar.thumb.url + ')',
    })
  })]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": '/' + _vm.trackUser.slug
    }
  }, [_c('label', {
    staticClass: "user-name"
  }, [_vm._v("\n          " + _vm._s(_vm.trackUser.username) + "\n          "), (_vm.trackUser.user_type == 'artist') ? _c('v-icon', {
    staticClass: "user-status",
    class: {
      online: _vm.trackUser.status == 'active'
    }
  }, [_vm._v("fa-check-circle")]) : _vm._e()], 1)]), _vm._v(" "), _c('user-follow-btn', {
    attrs: {
      "user": _vm.trackUser,
      "theme": "dark",
      "type": "default"
    },
    on: {
      "afterFollow": _vm.afterFollow
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "item-section",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "item-image",
    style: ({
      'background-image': 'url(' + _vm.coverUrl + ')'
    })
  }), _vm._v(" "), (_vm.track) ? _c('p', {
    staticClass: "item-name"
  }, [_vm._v(_vm._s(_vm.track.name))]) : _c('p', {
    staticClass: "item-name"
  }, [_vm._v(_vm._s(_vm.item.name))])]), _vm._v(" "), (_vm.trackUser.stripe_connected) ? [_c('v-flex', {
    staticClass: "donate-section",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "donate-amount-btn",
    nativeOn: {
      "click": function($event) {
        _vm.donateAmount(5)
      }
    }
  }, [_vm._v("$5")]), _vm._v(" "), _c('v-btn', {
    staticClass: "donate-amount-btn",
    nativeOn: {
      "click": function($event) {
        _vm.donateAmount(10)
      }
    }
  }, [_vm._v("$10")]), _vm._v(" "), _c('v-btn', {
    staticClass: "donate-amount-btn",
    nativeOn: {
      "click": function($event) {
        _vm.donateAmount(20)
      }
    }
  }, [_vm._v("$20")]), _vm._v(" "), _c('v-btn', {
    staticClass: "donate-amount-btn",
    nativeOn: {
      "click": function($event) {
        _vm.donateAmount(50)
      }
    }
  }, [_vm._v("$50")])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "input-section",
    attrs: {
      "xs12": ""
    }
  }, [_c('vue-numeric', {
    staticClass: "donate-amount form-control",
    attrs: {
      "currency": "$",
      "currency-symbol-position": "prefix",
      "separator": ",",
      "precision": 2,
      "min": 1
    },
    model: {
      value: (_vm.donate_amount),
      callback: function($$v) {
        _vm.donate_amount = $$v
      },
      expression: "donate_amount"
    }
  })], 1)] : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "input-section",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "download-btn mt-0",
    nativeOn: {
      "click": function($event) {
        _vm.showPaymentDialog()
      }
    }
  }, [_c('img', {
    staticClass: "pa-2",
    attrs: {
      "src": "/static/images/ic_download_white.png"
    }
  }), _vm._v("Download\n      ")])], 1)], 2), _vm._v(" "), (_vm.showPaymentModal) ? _c('payment-modal', {
    attrs: {
      "receivers": [_vm.trackUser],
      "amount": _vm.donate_amount_by_cent,
      "dismiss": _vm.hidePaymentDialog,
      "finish": _vm.sendLove
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1804 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "genre",
    attrs: {
      "pa-0": ""
    }
  }, [_c('div', {
    staticClass: "dflex justify-space-between align-center"
  }, [_c('div', {}, [_c('h2', {
    staticClass: "_title"
  }, [_vm._v("Choose Language")]), _vm._v(" "), _c('v-btn', {
    staticClass: "update-btn",
    attrs: {
      "round": ""
    }
  }, [_vm._v("\n                Save\n            ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "dflex align-center"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1556)
    }
  })])]), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-lg": "",
      "px-0": "",
      "pt-0": ""
    }
  }, [_c('v-layout', {
    staticClass: "pgs_area",
    attrs: {
      "row": "",
      "wrap": "",
      "mt-4": ""
    }
  }, [_c('v-flex', {
    staticClass: "pgs-wrapper",
    attrs: {
      "xs12": "",
      "sm2": ""
    }
  }, [_c('div', {
    staticClass: "pgs"
  }, [_c('div', {
    staticClass: "pgs-inner-wrapper selected"
  }, [_c('div', {
    staticClass: "pgs-inner"
  }, [_c('div', {
    staticClass: "dflex align-center justify-space-between"
  }, [_c('div', {
    staticClass: "pgs__title mb-0"
  }, [_c('div', {
    staticClass: "dflex align-center"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(608),
      "width": "20"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "ml-2 flag-label"
  }, [_vm._v("English")])])]), _vm._v(" "), _c('div', {
    staticClass: "highlight-circle"
  })])])])])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pgs-wrapper",
    attrs: {
      "xs12": "",
      "sm2": ""
    }
  }, [_c('div', {
    staticClass: "pgs"
  }, [_c('div', {
    staticClass: "pgs-inner-wrapper"
  }, [_c('div', {
    staticClass: "pgs-inner"
  }, [_c('div', {
    staticClass: "dflex align-center justify-space-between"
  }, [_c('div', {
    staticClass: "pgs__title mb-0"
  }, [_c('div', {
    staticClass: "dflex align-center"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(608),
      "width": "20"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "ml-2 flag-label"
  }, [_vm._v("English")])])]), _vm._v(" "), _c('div', {
    staticClass: "highlight-circle"
  })])])])])])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1805 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-tab-wrapper",
    class: {
      isSwipe: _vm.isSwipe,
      'isGrid container fluid grid-list-lg px-0 pt-0': _vm.isGrid
    },
    style: (("min-height: " + _vm.minHeight + "px;"))
  }, [_c('div', {
    staticClass: "item-tabs",
    class: {
      'layout row wrap': _vm.isGrid
    }
  }, [_vm._t("itemTabs")], 2)])
},staticRenderFns: []}

/***/ }),
/* 1806 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "roster-user-item",
    attrs: {
      "x12": "",
      "sm12": ""
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/' + _vm.user.slug
    }
  }, [_c('div', {
    staticClass: "user-avatar",
    style: ({
      'background-image': 'url(' + _vm.user.avatar.thumb.url + ')'
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "user-name"
  }, [_vm._v(_vm._s(_vm.user.username))]), _vm._v(" "), (_vm.deleteFunc) ? _c('v-btn', {
    staticClass: "text-btn error px-2",
    nativeOn: {
      "click": function($event) {
        _vm.deleteFunc(_vm.user)
      }
    }
  }, [_vm._v(_vm._s(_vm.deleteText))]) : _vm._e(), _vm._v(" "), (_vm.status !== '') ? _c('label', {
    staticClass: "btn-divider"
  }) : _vm._e(), _vm._v(" "), (_vm.status !== '') ? _c('v-btn', {
    staticClass: "text-btn black px-2",
    class: {
      error: _vm.status == 'denied'
    }
  }, [_vm._v(_vm._s(_vm.status))]) : _vm._e(), _vm._v(" "), (_vm.denyFunc) ? _c('v-btn', {
    staticClass: "text-btn error px-2",
    nativeOn: {
      "click": function($event) {
        _vm.denyFunc(_vm.user)
      }
    }
  }, [_vm._v("Deny")]) : _vm._e(), _vm._v(" "), (_vm.acceptFunc) ? _c('label', {
    staticClass: "btn-divider"
  }) : _vm._e(), _vm._v(" "), (_vm.acceptFunc) ? _c('v-btn', {
    staticClass: "text-btn px-2",
    nativeOn: {
      "click": function($event) {
        _vm.acceptFunc(_vm.user)
      }
    }
  }, [_vm._v("Accept")]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1807 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "track-card-simple"
  }, [_c('div', {
    staticClass: "cover",
    class: {
      noCover: _vm.noCover,
      round: _vm.round,
      coverRadius: _vm.coverRadius
    },
    style: (("background-image: url(" + _vm.cover + "); height: " + _vm.height + "px; width: " + (_vm.isVideo ? _vm.videoWidth : _vm.width) + "px"))
  }), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [_c('div', {
    staticClass: "_title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "_subtitle"
  }, [_vm._v(_vm._s(_vm.subtitle))])])])
},staticRenderFns: []}

/***/ }),
/* 1808 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'earn-money-sticker': !_vm.$store.state.player.isPlaying,
      'earn-money-sticker--play': _vm.$store.state.player.isPlaying,
    }
  }, [_c('h3', [_vm._v("Every user can earn money.")]), _vm._v(" "), _c('p', [_vm._v("Setup your account now!")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "round": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.learnMore()
      }
    }
  }, [_vm._v("Learn more")])], 1)
},staticRenderFns: []}

/***/ }),
/* 1809 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notification-wrapper",
    class: _vm.notify_container_Class,
    style: ({
      left: _vm.leftPos + 'px'
    })
  }, [(!_vm.inviteShow) ? _c('div', {
    staticClass: "notify-head"
  }, [_vm._v("Notifications")]) : _c('div', {
    staticClass: "dflex align-center justify-space-between"
  }, [_c('div', {
    staticClass: "notify-head"
  }, [_vm._v("Invite")]), _vm._v(" "), _c('div', {
    staticClass: "cursor-pointer",
    on: {
      "click": function($event) {
        _vm.toggleNotify()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(164),
      "width": "16"
    }
  })])]), _vm._v(" "), (!_vm.inviteShow) ? _c('div', {
    staticClass: "notify-body"
  }, [_c('div', {
    staticClass: "notify-invite"
  }, [_c('h2', {
    staticClass: "invite-head"
  }, [_vm._v("Invite 10 creators, get 3 months free!")]), _vm._v(" "), _c('v-btn', {
    staticClass: "purple-btn",
    on: {
      "click": function($event) {
        _vm.toggleNotify()
      }
    }
  }, [_vm._v("\n                Invite\n            ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "notify-main"
  }, [_c('div', {
    staticClass: "notify-main-card"
  }, [_c('div', {
    staticClass: "notify-content"
  }, [_c('div', {
    staticClass: "user-image",
    style: ({
      backgroundImage: 'url(' + _vm.demoPerson + ')'
    })
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "notify-main-card"
  }, [_c('div', {
    staticClass: "notify-content"
  }, [_c('div', {
    staticClass: "user-image",
    style: ({
      backgroundImage: 'url(' + _vm.demoPerson + ')'
    })
  }), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "notify-main-card"
  }, [_c('div', {
    staticClass: "notify-content"
  }, [_c('div', {
    staticClass: "user-image",
    style: ({
      backgroundImage: 'url(' + _vm.demoPerson + ')'
    })
  }), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('div', {
    staticClass: "notify-main-card"
  }, [_c('div', {
    staticClass: "notify-content"
  }, [_c('div', {
    staticClass: "user-image",
    style: ({
      backgroundImage: 'url(' + _vm.demoPerson + ')'
    })
  }), _vm._v(" "), _vm._m(6)]), _vm._v(" "), _vm._m(7)]), _vm._v(" "), _c('div', {
    staticClass: "notify-main-card"
  }, [_c('div', {
    staticClass: "notify-content"
  }, [_c('div', {
    staticClass: "user-image",
    style: ({
      backgroundImage: 'url(' + _vm.demoPerson + ')'
    })
  }), _vm._v(" "), _vm._m(8)]), _vm._v(" "), _vm._m(9)]), _vm._v(" "), _c('div', {
    staticClass: "notify-main-card"
  }, [_c('div', {
    staticClass: "notify-content"
  }, [_c('div', {
    staticClass: "user-image",
    style: ({
      backgroundImage: 'url(' + _vm.demoPerson + ')'
    })
  }), _vm._v(" "), _vm._m(10)]), _vm._v(" "), _vm._m(11)]), _vm._v(" "), _c('div', {
    staticClass: "notify-main-card"
  }, [_c('div', {
    staticClass: "notify-content"
  }, [_c('div', {
    staticClass: "user-image",
    style: ({
      backgroundImage: 'url(' + _vm.demoPerson + ')'
    })
  }), _vm._v(" "), _vm._m(12)]), _vm._v(" "), _vm._m(13)]), _vm._v(" "), _c('div', {
    staticClass: "notify-main-card"
  }, [_c('div', {
    staticClass: "notify-content"
  }, [_c('div', {
    staticClass: "user-image",
    style: ({
      backgroundImage: 'url(' + _vm.demoPerson + ')'
    })
  }), _vm._v(" "), _vm._m(14)]), _vm._v(" "), _vm._m(15)]), _vm._v(" "), _c('div', {
    staticClass: "notify-main-card"
  }, [_c('div', {
    staticClass: "notify-content"
  }, [_c('div', {
    staticClass: "user-image",
    style: ({
      backgroundImage: 'url(' + _vm.demoPerson + ')'
    })
  }), _vm._v(" "), _vm._m(16)]), _vm._v(" "), _vm._m(17)])])]) : _c('div', {
    staticClass: "invite-body"
  }, [_c('div', {
    staticClass: "invite-upper"
  }, [_vm._m(18), _vm._v(" "), _vm._m(19), _vm._v(" "), _c('div', [_c('v-btn', {
    staticClass: "purple-btn"
  }, [_vm._v("\n                    Copy link\n                ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center text-muted"
  }, [_vm._v("\n                Link expires in 72 hours & can only be used once\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "invite-lower"
  }, [_vm._m(20), _vm._v(" "), _c('div', {
    staticClass: "invite-wrapper"
  }, [_c('div', {
    staticClass: "invite-div"
  }, [_c('div', {
    staticClass: "invite-content"
  }, [_c('div', {
    staticClass: "image",
    style: ({
      backgroundImage: 'url(' + _vm.demoPerson + ')'
    })
  }), _vm._v(" "), _vm._m(21)]), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [_vm._v("\n                        2min ago\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "invite-div"
  }, [_c('div', {
    staticClass: "invite-content"
  }, [_c('div', {
    staticClass: "image",
    style: ({
      backgroundImage: 'url(' + _vm.demoPerson + ')'
    })
  }), _vm._v(" "), _vm._m(22)]), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [_vm._v("\n                        2min ago\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "invite-div"
  }, [_c('div', {
    staticClass: "invite-content"
  }, [_c('div', {
    staticClass: "image",
    style: ({
      backgroundImage: 'url(' + _vm.demoPerson + ')'
    })
  }), _vm._v(" "), _vm._m(23)]), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [_vm._v("\n                        2min ago\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "invite-div"
  }, [_c('div', {
    staticClass: "invite-content"
  }, [_c('div', {
    staticClass: "image",
    style: ({
      backgroundImage: 'url(' + _vm.demoPerson + ')'
    })
  }), _vm._v(" "), _vm._m(24)]), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [_vm._v("\n                        2min ago\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "invite-div"
  }, [_c('div', {
    staticClass: "invite-content"
  }, [_c('div', {
    staticClass: "image",
    style: ({
      backgroundImage: 'url(' + _vm.demoPerson + ')'
    })
  }), _vm._v(" "), _vm._m(25)]), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [_vm._v("\n                        2min ago\n                    ")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-data mt-1"
  }, [_c('div', {
    staticClass: "data-content"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("Theo James")]), _vm._v(" reposted your album "), _c('span', {
    staticClass: "text-light"
  }, [_vm._v("sa assad")])]), _vm._v(" "), _c('div', {
    staticClass: "date mt-1"
  }, [_vm._v("\n                            4m ago\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notify-image"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(42),
      "height": "48"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-data mt-1"
  }, [_c('div', {
    staticClass: "data-content"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("Theo James")]), _vm._v(" reposted your album "), _c('span', {
    staticClass: "text-light"
  }, [_vm._v("sa assad")])]), _vm._v(" "), _c('div', {
    staticClass: "date mt-1"
  }, [_vm._v("\n                            4m ago\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notify-image"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(42),
      "height": "48"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-data mt-1"
  }, [_c('div', {
    staticClass: "data-content"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("Theo James")]), _vm._v(" reposted your album "), _c('span', {
    staticClass: "text-light"
  }, [_vm._v("sa assad")])]), _vm._v(" "), _c('div', {
    staticClass: "date mt-1"
  }, [_vm._v("\n                            4m ago\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notify-image"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(42),
      "height": "48"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-data mt-1"
  }, [_c('div', {
    staticClass: "data-content"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("Theo James")]), _vm._v(" reposted your album "), _c('span', {
    staticClass: "text-light"
  }, [_vm._v("sa assad")])]), _vm._v(" "), _c('div', {
    staticClass: "date mt-1"
  }, [_vm._v("\n                            4m ago\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notify-image"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(42),
      "height": "48"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-data mt-1"
  }, [_c('div', {
    staticClass: "data-content"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("Theo James")]), _vm._v(" reposted your album "), _c('span', {
    staticClass: "text-light"
  }, [_vm._v("sa assad")])]), _vm._v(" "), _c('div', {
    staticClass: "date mt-1"
  }, [_vm._v("\n                            4m ago\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notify-image"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(42),
      "height": "48"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-data mt-1"
  }, [_c('div', {
    staticClass: "data-content"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("Theo James")]), _vm._v(" reposted your album "), _c('span', {
    staticClass: "text-light"
  }, [_vm._v("sa assad")])]), _vm._v(" "), _c('div', {
    staticClass: "date mt-1"
  }, [_vm._v("\n                            4m ago\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notify-image"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(42),
      "height": "48"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-data mt-1"
  }, [_c('div', {
    staticClass: "data-content"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("Theo James")]), _vm._v(" reposted your album "), _c('span', {
    staticClass: "text-light"
  }, [_vm._v("sa assad")])]), _vm._v(" "), _c('div', {
    staticClass: "date mt-1"
  }, [_vm._v("\n                            4m ago\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notify-image"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(42),
      "height": "48"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-data mt-1"
  }, [_c('div', {
    staticClass: "data-content"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("Theo James")]), _vm._v(" reposted your album "), _c('span', {
    staticClass: "text-light"
  }, [_vm._v("sa assad")])]), _vm._v(" "), _c('div', {
    staticClass: "date mt-1"
  }, [_vm._v("\n                            4m ago\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notify-image"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(42),
      "height": "48"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-data mt-1"
  }, [_c('div', {
    staticClass: "data-content"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("Theo James")]), _vm._v(" reposted your album "), _c('span', {
    staticClass: "text-light"
  }, [_vm._v("s a assada assada assada assada assada assada assada assada assada assada assada assada assada assada assada assada assada assada assada assada assada assada assada assada assada assad")])]), _vm._v(" "), _c('div', {
    staticClass: "date mt-1"
  }, [_vm._v("\n                            4m ago\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notify-image"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(42),
      "height": "48"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(606),
      "width": "32"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "invite-head"
  }, [_vm._v("\n                    Invite 10 creators, get 3 months free!\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "invite-sub-head"
  }, [_vm._v("\n                    *Creators invited must subscribe to be eligible\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-normal"
  }, [_vm._v("You have "), _c('span', [_vm._v("4")]), _vm._v(" more signups tp go!")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("Theo Hames")]), _vm._v(" subscribed\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("Theo Hames")]), _vm._v(" subscribed\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("Theo Hames")]), _vm._v(" subscribed\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("Theo Hames")]), _vm._v(" subscribed\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("Theo Hames")]), _vm._v(" subscribed\n                        ")])
}]}

/***/ }),
/* 1810 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "carousel-3d-slide",
    class: {
      current: _vm.isCurrent
    },
    style: (_vm.slideStyle),
    on: {
      "click": function($event) {
        _vm.goTo()
      }
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 1811 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "side-player-placeholder"
  }, [_c('div', {
    staticClass: "side-player-placeholder__wrapper"
  }, [_c('div', {
    staticClass: "player_text"
  }, [_vm._v("Hear What's Trending")]), _vm._v(" "), _c('v-btn', {
    staticClass: "cta__wrapper cursor-pointer cta__text",
    attrs: {
      "round": "",
      "dark": "",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        _vm.loadFeeds('discover', 1)
      }
    }
  }, [_c('img', {
    staticStyle: {
      "margin-right": "5px"
    },
    attrs: {
      "src": __webpack_require__(1545),
      "width": "15"
    }
  }), _vm._v("\n          Surprise me\n        ")])], 1), _vm._v(" "), (_vm.isPlaying) ? _c('div', {
    staticClass: "side-player-placeholder__action"
  }, [_c('img', {
    staticClass: "_previous",
    attrs: {
      "src": __webpack_require__(1464),
      "alt": "previous button"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_play",
    attrs: {
      "src": __webpack_require__(1463),
      "alt": "play button"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_skip",
    attrs: {
      "src": __webpack_require__(1465),
      "alt": "skip button"
    }
  })]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1812 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isPageReady) ? _c('div', {
    staticClass: "page video-page show-page",
    class: {
      'no-top-nav': !_vm.onMobile,
      onMobile: _vm.onMobile
    }
  }, [_c('div', {
    staticClass: "page-content margin-top-header"
  }, [_c('v-container', {
    class: {
      'grid-list-md px-4': !_vm.onMobile
    },
    attrs: {
      "fluid": "",
      "px-0": ""
    }
  }, [_c('div', {
    staticClass: "vid_col mb-4"
  }, [_c('video-player', {
    attrs: {
      "src": _vm.stream.mp_channel_1_ep_1_url
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(!_vm.onMobile) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": "",
      "comment-wrapper": ""
    }
  }, [_c('div', [(_vm.onMobile) ? _c('div', {
    staticClass: "pane-tabs-onMobile"
  }, _vm._l((_vm.paneTabs), function(tab, index) {
    return _c('div', {
      key: index,
      staticClass: "pane-tab",
      class: {
        active: _vm.activePaneTab == tab.id
      },
      on: {
        "click": function($event) {
          _vm.activePaneTab = tab.id
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(tab.name) + " "), (tab.id == 'comments') ? _c('span', [_vm._v("(" + _vm._s(_vm._f("formatLargeNumber")(_vm.comments.length)) + ")")]) : _vm._e()])
  })) : _vm._e(), _vm._v(" "), (_vm.activePaneTab == 'info') ? _c('div', [_c('div', {
    staticClass: "content-section"
  }, [_c('div', {
    staticClass: "meta__content",
    class: {
      'px-4': _vm.onMobile
    }
  }, [(_vm.onMobile) ? _c('user-tag', {
    staticClass: "tag",
    attrs: {
      "showAvatar": "",
      "hideName": "",
      "hideTick": "",
      "clickUser": "",
      "width": "40",
      "height": "40",
      "user": _vm.stream.user
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.onMobile) ? _c('div', {
    staticClass: "meta__title"
  }, [_vm._v(_vm._s(_vm.stream.name))]) : _vm._e(), _vm._v(" "), (_vm.onMobile) ? _c('div', {
    staticClass: "dflex flex-column"
  }, [_c('div', {
    staticClass: "meta__name"
  }, [_vm._v(_vm._s(_vm.stream.name.split('- ')[1] || _vm.stream.name))]), _vm._v(" "), _c('div', {
    staticClass: "meta__title text-capitalize"
  }, [_vm._v(_vm._s(_vm.stream.user.username))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "show-more"
  }, [_c('div', {
    staticClass: "vid__description"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.stream.description) + "\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), (_vm.initShowMore) ? _c('span', {
    staticClass: "app-grey--text cursor-pointer showMoreActive",
    on: {
      "click": function($event) {
        _vm.showMoreActive = !_vm.showMoreActive
      }
    }
  }, [(!_vm.showMoreActive) ? _c('b', {
    staticClass: "show-more-less show-more"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\tSHOW MORE\n\t\t\t\t\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.showMoreActive) ? _c('b', {
    staticClass: "show-more-less show-less"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\tSHOW LESS\n\t\t\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "divider my-4"
  }), _vm._v(" "), (_vm.stream.user.id === _vm.currentUser.id) ? _c('div', {
    staticClass: "attachment-block",
    on: {
      "click": function($event) {
        (_vm.showAttachProduct = true)
      }
    }
  }, [_c('div', [_c('img', {
    attrs: {
      "src": __webpack_require__(1443),
      "width": "16"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_content"
  }, [_vm._v("Attach content to video")])]) : _vm._e(), _vm._v(" "), (_vm.onMobile) ? _c('div', {
    staticClass: "meta__cta follow"
  }, [(_vm.currentUser && _vm.stream.user.id != _vm.currentUser.id) ? _c('user-follow-btn', {
    attrs: {
      "user": _vm.stream.user,
      "theme": "dark",
      "type": "player"
    }
  }) : _vm._e()], 1) : _vm._e()], 1)])]) : _vm._e()]), _vm._v(" "), _c('comments', {
    attrs: {
      "item": _vm.stream,
      "comments": _vm.comments,
      "roundAvatar": ""
    },
    on: {
      "reRenderComments": _vm.reRenderComments
    }
  })], 1) : _c('v-flex', {
    staticClass: "px-4",
    attrs: {
      "xs12": "",
      "comment-wrapper": ""
    }
  }, [_c('chat', {
    attrs: {
      "items": _vm.comments,
      "hideDatedString": "",
      "showShortAge": ""
    }
  }), _vm._v(" "), _c('comment-input', {
    attrs: {
      "item": _vm.stream,
      "roundInput": "",
      "noBorder": "",
      "placeholder": "Add your reply"
    }
  })], 1), _vm._v(" "), (_vm.activePaneTab == 'info') ? _c('v-flex', {
    staticClass: "related_col",
    class: {
      'pl-4': !_vm.onMobile
    },
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('div', {
    staticClass: "videos-section"
  }, [_c('h4', {
    staticClass: "__title",
    class: {
      'px-2': _vm.onMobile
    }
  }, [_vm._v("Related Videos")]), _vm._v(" "), _c('div', {
    staticClass: "section__content"
  }, _vm._l((_vm.videos), function(video) {
    return _c('div', {
      key: video.name,
      class: {
        side_fullwidth: _vm.onMobile
      }
    }, [_c('video-box', {
      attrs: {
        "hoverOverlay": false,
        "item": video,
        "showUsername": "",
        "hideUser": !_vm.onMobile ? true : false,
        "sideTabView": !_vm.onMobile ? true : false
      }
    })], 1)
  }))])]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "product-attach-dialog"
    },
    model: {
      value: (_vm.showAttachProduct),
      callback: function($$v) {
        _vm.showAttachProduct = $$v
      },
      expression: "showAttachProduct"
    }
  }, [_c('div', {
    staticClass: "product-attach-flex"
  }, [_c('div', {
    staticClass: "w-60"
  }, [_c('div', {
    staticClass: "content-head"
  }, [_vm._v("SELECT CONTENT")]), _vm._v(" "), _c('div', {
    staticClass: "content-options"
  }, [_c('div', {
    staticClass: "_title",
    class: (_vm.selectAttactProduct == 1) ? "active" : null,
    on: {
      "click": function($event) {
        (_vm.selectAttactProduct = 1)
      }
    }
  }, [_vm._v("Music")]), _vm._v(" "), _c('div', {
    staticClass: "_title",
    class: (_vm.selectAttactProduct == 2) ? "active" : null,
    on: {
      "click": function($event) {
        (_vm.selectAttactProduct = 2)
      }
    }
  }, [_vm._v("Products")])]), _vm._v(" "), _c('div', {
    staticClass: "tabs-main"
  }, [((_vm.selectAttactProduct == 1)) ? _c('div', {
    staticClass: "tabs-container"
  }, _vm._l((_vm.albums), function(album, index) {
    return _c('div', {
      staticClass: "tabs-div",
      class: {
        'active': _vm.mainItem.id === album.id
      },
      on: {
        "click": function($event) {
          _vm.mainItem = album
        }
      }
    }, [_c('div', {
      staticClass: "_image"
    }, [_c('img', {
      attrs: {
        "src": album.cover.url,
        "width": "50"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "_text"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(album.name))]), _vm._v(" "), _c('div', {
      staticClass: "sub mt-1"
    }, [_vm._v(_vm._s(album.user.username))])])])
  })) : _vm._e(), _vm._v(" "), ((_vm.selectAttactProduct == 2)) ? _c('div', {
    staticClass: "tabs-container"
  }, _vm._l((_vm.products), function(product, index) {
    return _c('div', {
      staticClass: "tabs-div",
      class: {
        'active': _vm.mainItem.id === product.id
      },
      on: {
        "click": function($event) {
          _vm.mainItem = product
        }
      }
    }, [_c('div', {
      staticClass: "_image"
    }, [_c('img', {
      attrs: {
        "src": product.covers[0].cover.url,
        "width": "50"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "_text"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(product.name))]), _vm._v(" "), _c('div', {
      staticClass: "sub mt-1"
    }, [_vm._v(_vm._s(product.merchant.username))])])])
  })) : _vm._e()])]), _vm._v(" "), (_vm.mainItem) ? _c('div', {
    staticClass: "w-40 cursor-pointer"
  }, [_c('div', {
    staticClass: "profile_image"
  }, [_c('img', {
    attrs: {
      "src": _vm.mainItem.category ? _vm.mainItem.covers[0].cover.url : _vm.mainItem.cover.url,
      "width": "100%"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "profile_info my-3"
  }, [(_vm.mainItem.category) ? _c('div', {
    staticClass: "image",
    style: ({
      'background-image': 'url(' + _vm.mainItem.merchant.avatar.url + ')'
    })
  }) : _c('div', {
    staticClass: "image",
    style: ({
      'background-image': 'url(' + _vm.mainItem.user.avatar.url + ')'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.mainItem.category ? _vm.mainItem.merchant.username : _vm.mainItem.user.username))])]), _vm._v(" "), _c('div', {
    staticClass: "product-info "
  }, [(_vm.mainItem.category) ? _c('div', {
    staticClass: "category"
  }, [_vm._v(_vm._s(_vm.mainItem.category.name))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.mainItem.name))]), _vm._v(" "), (_vm.mainItem.price) ? _c('div', {
    staticClass: "price mt-1"
  }, [_vm._v("$" + _vm._s(_vm.mainItem.price))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "time-info mb-4 mt-3"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("SHOW ATTACHMENT AT:")]), _vm._v(" "), _c('div', {
    staticClass: "timer-outer mt-2"
  }, [_c('div', {
    staticClass: "time-flex"
  }, [_c('div', [_c('span', {
    attrs: {
      "contenteditable": "",
      "id": "showAttachmentHours"
    }
  }, [_vm._v("00")]), _vm._v("hr\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', [_vm._v("\n\t\t\t\t\t\t\t\t:\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', [_c('span', {
    attrs: {
      "contenteditable": "",
      "id": "showAttachmentMinutes"
    }
  }, [_vm._v("00")]), _vm._v("min\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', [_vm._v("\n\t\t\t\t\t\t\t\t:\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', [_c('span', {
    attrs: {
      "contenteditable": "",
      "id": "showAttachmentSeconds"
    }
  }, [_vm._v("00")]), _vm._v("sec\n\t\t\t\t\t\t\t")])])])]), _vm._v(" "), _c('div', {
    staticClass: "button-case"
  }, [_c('v-btn', {
    staticClass: "button-blue ma-0",
    attrs: {
      "blue": "",
      "rounded": ""
    },
    on: {
      "click": function($event) {
        _vm.addContent()
      }
    }
  }, [_vm._v("Add content")])], 1)]) : _vm._e()])]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "featured-content-dialog"
    },
    model: {
      value: (_vm.show_featured_dialog),
      callback: function($$v) {
        _vm.show_featured_dialog = $$v
      },
      expression: "show_featured_dialog"
    }
  }, [_c('v-card', [_c('v-card-text', [_c('div', {
    staticClass: "headline mb-2"
  }, [_vm._v("Add albmus & products to your video")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('div', {
    staticClass: "mt-3 pa-3",
    staticStyle: {
      "text-align": "left",
      "background-color": "#f8f8f8",
      "border": "1px solid #eee",
      "border-radius": "5px"
    }
  }, [_c('attach', {
    ref: "assocAttach",
    attrs: {
      "dataOnlyMode": ""
    },
    on: {
      "getAssoc": _vm.getAssoc
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "px-4",
    attrs: {
      "dark": "",
      "round": "",
      "color": "blue"
    },
    nativeOn: {
      "click": function($event) {
        _vm.updateStream()
      }
    }
  }, [_vm._v("Update")]), _vm._v(" "), _c('v-btn', {
    staticClass: "px-4",
    attrs: {
      "dark": "",
      "round": "",
      "color": "grey"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeFeaturedDialog()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-spacer')], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.show_payment_dialog),
      callback: function($$v) {
        _vm.show_payment_dialog = $$v
      },
      expression: "show_payment_dialog"
    }
  }, [(_vm.show_payment_dialog) ? _c('payment-modal', {
    attrs: {
      "receivers": [_vm.stream.user],
      "amount": _vm.amount,
      "dismiss": _vm.closePaymentDialog,
      "finish": _vm.payAttachment
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.showSendLoveModal) ? _c('send-love-modal', {
    attrs: {
      "item": _vm.user,
      "dismiss": _vm.dismissLoveDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_share_dialog) ? _c('share-modal', {
    attrs: {
      "item": _vm.stream,
      "type": "Stream",
      "dismiss": _vm.closeShareDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showMerchModal) ? _c('merch-modal', {
    attrs: {
      "item": _vm.stream.assoc,
      "dismiss": _vm.dimissMerchDialog
    }
  }) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    staticStyle: {
      "margin-top": "3%"
    },
    attrs: {
      "content-class": ["finish-modal upload-finish-dialog"]
    },
    model: {
      value: (_vm.showReleaseVideoModal),
      callback: function($$v) {
        _vm.showReleaseVideoModal = $$v
      },
      expression: "showReleaseVideoModal"
    }
  }, [(_vm.showReleaseVideoModal) ? _c('album-finish-modal', {
    attrs: {
      "item": _vm.releaseVideo,
      "type": "stream",
      "promote": _vm.showPromoteModal,
      "dismiss": _vm.dismissFinishDialog
    }
  }) : _vm._e()], 1)], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1813 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('content-top-header', {
    staticClass: "black-theme"
  }, [_c('template', {
    slot: "topHeader"
  }, [_c('ul', {
    staticClass: "pr-3"
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('li', {
      key: tab.id,
      staticClass: "nav-li",
      class: [{
        'active': _vm.name === tab.id,
        'tab-active': _vm.tabActivePill
      }, ("nav-" + (tab.id))],
      attrs: {
        "href": ("#" + (tab.id))
      }
    }, [_c('label', {
      staticClass: "nav-label",
      on: {
        "click": function($event) {
          _vm.setTab(tab.pathName)
        }
      }
    }, [_vm._v("\n            " + _vm._s(tab.title) + "\n          ")])])
  }))])], 2)
},staticRenderFns: []}

/***/ }),
/* 1814 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex flex-column",
    staticStyle: {
      "align-items": "center",
      "height": "100vh",
      "margin-top": "5%"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "d-flex flex-column",
    staticStyle: {
      "gap": "20px",
      "align-items": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "110px"
    },
    attrs: {
      "src": "/static/images/lined_check.svg"
    }
  }), _vm._v(" "), _c('div', [_c('center', {
    staticStyle: {
      "font-weight": "800",
      "font-size": "30px"
    }
  }, [_vm._v("\n          Check Your Email\n        ")]), _vm._v(" "), _c('center', {
    staticStyle: {
      "font-weight": "500",
      "font-size": "24px"
    }
  }, [_vm._v("\n          Your account has been created!\n        ")])], 1)])]), _vm._v(" "), _c('div', [_c('v-btn', {
    staticClass: "px-3 mt-4 login-button",
    staticStyle: {
      "width": "300px",
      "padding": "15px 5px",
      "border-radius": "25px",
      "color": "white",
      "font-size": "18px",
      "height": "50px"
    },
    attrs: {
      "round": "",
      "dark": "",
      "depressed": ""
    },
    on: {
      "click": _vm.sendConfirmEmail
    }
  }, [_vm._v("\n      Resend email\n    ")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticClass: "logo",
    staticStyle: {
      "width": "169px"
    },
    attrs: {
      "src": "/static/images/nav_logo_primary.png"
    }
  })])
}]}

/***/ }),
/* 1815 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "page dashboard-page side-space"
  }, [_c('dashboard-nav', {
    attrs: {
      "name": "dashboard"
    }
  }), _vm._v(" "), _c('content-top-header', {
    staticClass: "content-top-header-tab",
    attrs: {
      "height": 62
    }
  }, [_c('template', {
    slot: "topHeader"
  }, [_c('ul', _vm._l((_vm.tabs), function(tab) {
    return _c('li', {
      key: tab.id,
      class: {
        'active tab-active': _vm.isActiveTab(tab.id)
      },
      attrs: {
        "href": ("#" + (tab.id))
      }
    }, [_c('label', {
      staticClass: "innerBold",
      on: {
        "click": function($event) {
          _vm.setTopMenu(tab.id)
        }
      }
    }, [_vm._v(_vm._s(tab.title))])])
  }))])], 2), _vm._v(" "), _c('div', {
    staticClass: "relative mt-70"
  }, [_c('div', {
    staticClass: "chart-parent"
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-lg": "",
      "px-0": ""
    }
  }, [_c('div', {
    staticClass: "dashboard-title mb-1"
  }, [_vm._v(_vm._s(_vm.activeTab === 'topCreators' ? 'Top Creators' : 'Overview'))]), _vm._v(" "), (_vm.activeTab !== 'topCreators') ? _c('v-layout', {
    staticClass: "inner-tab-actions",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.getInnerTab()), function(action, i) {
    return _c('v-flex', {
      key: i,
      staticClass: "inner-tab-action",
      class: [{
        'inner-tab-active': _vm.isActiveInnerTab(action.id)
      }, action.size == 'custom' ? 'custom-lg5' : action.size ? ("sm" + (action.size)) : ''],
      attrs: {
        "xs12": ""
      },
      on: {
        "click": function($event) {
          _vm.setChartDetails(action)
        }
      }
    }, [_c('div', {
      staticClass: "action_content"
    }, [_c('div', {
      staticClass: "action_title"
    }, [_vm._v(_vm._s(action.title))]), _vm._v(" "), _c('div', {
      staticClass: "action_value"
    }, [(typeof action.value == 'number') ? _c('span', [_vm._v(_vm._s(_vm._f("formatNumberWithComma")(action.value)))]) : _c('span', [_vm._v(_vm._s(action.value))])])])])
  })) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.activeTab === 'topCreators') ? _c('div', {
    staticClass: "col-summary-section"
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-lg": "",
      "px-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, _vm._l((_vm.getDataTables()[0].data), function(creator, i) {
    return _c('v-flex', {
      key: i,
      staticClass: "top-creator-item",
      attrs: {
        "xs12": ""
      }
    }, [_c('div', {
      staticClass: "top-creator-frame"
    }, [_c('div', {
      staticClass: "top-creator-avatar"
    }, [_c('img', {
      attrs: {
        "src": creator.avatar,
        "alt": "creator avatar"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "top-creator-details"
    }, [_c('div', {
      staticClass: "top-creator-name"
    }, [_vm._v(_vm._s(creator.name))]), _vm._v(" "), _c('div', {
      staticClass: "top-creator-plays"
    }, [_vm._v(_vm._s(creator.plays))])]), _vm._v(" "), _c('div', {
      staticClass: "top-creator-earnings"
    }, [_vm._v(_vm._s(creator.earnings))])])])
  }))], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getSummaryTabs()) ? _c('div', {
    staticClass: "col-summary-section"
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-lg": "",
      "px-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, _vm._l((_vm.getSummaryTabs()), function(col, i) {
    return _c('v-flex', {
      key: i,
      attrs: {
        "sm12": "",
        "lg4": "",
        "custom-lg3plus": "",
        "col-summary": ""
      }
    }, [_c('div', {
      staticClass: "col-summary-frame"
    }, [_c('div', {
      staticClass: "col-summary-frame-header"
    }, [_c('h4', [_vm._v(_vm._s(col.header))])]), _vm._v(" "), (col.type == 'pie') ? _c('div', {
      staticClass: "col-summary-frame-body chart-body"
    }, [_c('div', {
      staticClass: "pie-chart",
      attrs: {
        "id": "chart"
      }
    }, [_c('chart', {
      attrs: {
        "type": "donut",
        "height": "500",
        "options": _vm.pieChartOptions,
        "series": _vm.pieSeries
      }
    })], 1)]) : _c('div', {
      staticClass: "col-summary-frame-body"
    }, _vm._l((7), function(item, i) {
      return _c('div', {
        key: i,
        staticClass: "col-listing",
        class: [col.avatarType == 'square' ? '__square' : col.avatarType == 'round' ? '__round' : col.avatarType == 'rectangle' ? '__rectangle' : '']
      }, [_c('div', {
        staticClass: "_title"
      }, [_vm._v(_vm._s(i + 1))]), _vm._v(" "), _c('div', {
        staticClass: "_thumbnail"
      }), _vm._v(" "), _c('div', {
        staticClass: "d-flex flex-column"
      }, [_c('div', {
        staticClass: "_title"
      }, [_vm._v("First Last")]), _vm._v(" "), _c('div', {
        staticClass: "_subtitle"
      }, [_vm._v("RUCKAZOID, Tri Nohbi")])])])
    }))])])
  }))], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getStatsList()) ? _c('v-container', {
    attrs: {
      "px-0": "",
      "mw-100": ""
    }
  }, [_c('div', {
    staticClass: "tracks-title mt-2"
  }, [_c('h2', [_vm._v(_vm._s(_vm.getStatsList().title))])]), _vm._v(" "), _vm._l((_vm.getStatsList().items), function(item, i) {
    return _c('div', {
      key: i,
      staticClass: "tracks-user-title"
    }, [_c('div', {
      staticClass: "tracks-user-title__item"
    }, [_c('div', {
      staticClass: "item-image"
    }, [(_vm.getStatsList().items_type == 'musics') ? _c('img', {
      attrs: {
        "src": item.album.cover.url
      }
    }) : (_vm.getStatsList().items_type == 'products') ? _c('img', {
      attrs: {
        "src": item.cover.url
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "d-flex flex-column gap-4"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "subtitle"
    }, [_vm._v(_vm._s(item.user.display_name))])])]), _vm._v(" "), _c('div', {
      staticClass: "tracks-info"
    }, [_c('div', {
      staticClass: "tracks-info-right"
    }, [_c('v-layout', {
      staticClass: "inner-tab-actions",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, _vm._l((_vm.totalTrackList), function(item, i) {
      return _c('v-flex', {
        key: i,
        staticClass: "inner-tab-action",
        class: i > 3 ? 'sm4' : 'sm3',
        attrs: {
          "xs12": ""
        }
      }, [_c('div', {
        staticClass: "action_content track-item"
      }, [_c('div', {
        staticClass: "action_title"
      }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
        staticClass: "action_value"
      }, [_c('span', [_vm._v(_vm._s(item.content))])])])])
    }))], 1)])])
  })], 2) : _vm._e()], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1816 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('upload-nav', {
    attrs: {
      "name": "upload"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "px-5 pt-5 mt-5 text-poppins-36"
  }, [_vm._v("Edit album")]), _vm._v(" "), (this.currentUser.creator_verified) ? _c('div', {
    staticClass: "page upload-child upload-album-page mt-9"
  }, [(_vm.isPageReady) ? _c('div', [_c('div', [_c('track-uploader', {
    attrs: {
      "accept": ".mp3",
      "autoUpload": true,
      "album": _vm.album
    }
  })], 1), _vm._v(" "), (_vm.album.tracks.length) ? _c('div', {
    attrs: {
      "id": "album_info_section"
    }
  }, [_c('div', {
    staticClass: "album-info-section mx-5"
  }, [_vm._m(0), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-lg": "",
      "px-0": "",
      "album-section": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "album-content-section": "",
      "album-content-info": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm12": "",
      "md8": ""
    }
  }, [_c('div', {
    staticClass: "dflex d-row"
  }, [_c('div', {
    staticClass: "w-100"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("\n                      Album Title\n                    ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.album.name),
      expression: "album.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.album.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.album, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "dflex gap-15 upload-album-item"
  }, [_c('div', {
    staticClass: "w-25"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("\n                      Genre\n                    ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.$store.getters['genreSelector/genre'].name
    },
    on: {
      "click": _vm.openGenreSelectorDialog
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "w-15"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(" BPM ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.album.bpm),
      expression: "album.bpm"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "'1-999'"
    },
    domProps: {
      "value": (_vm.album.bpm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.album, "bpm", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "upload-album-key w-25 dflex gap-15"
  }, [_c('div', {
    staticClass: "w-100"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(" KEY ")]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-nail"
  }, [_c('div', {
    staticClass: "dropdown-head",
    on: {
      "click": function($event) {
        _vm.majorDropdown = true
      }
    }
  }, [(_vm.majorValue == 'major') ? _c('div', [_vm._v("Major")]) : (_vm.majorValue == 'minor') ? _c('div', [_vm._v("Minor")]) : _c('div', {
    staticClass: "text-dull"
  }, [_vm._v("Select")])]), _vm._v(" "), (_vm.majorDropdown) ? _c('div', [_c('div', {
    staticClass: "dropdown-overlay",
    on: {
      "click": function($event) {
        _vm.majorDropdown = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dropdown-body"
  }, [_c('div', {
    staticClass: "inline-block",
    on: {
      "click": function($event) {
        _vm.majorValue = 'major';
        _vm.majorDropdown = false;
        _vm.keyDropdown = true;
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "id": "major",
      "name": "key",
      "value": "major"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "major"
    }
  }, [_vm._v("Major")])]), _vm._v(" "), _c('div', {
    staticClass: "inline-block",
    on: {
      "click": function($event) {
        _vm.majorValue = 'minor';
        _vm.majorDropdown = false;
        _vm.keyDropdown = true;
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "id": "minor",
      "name": "key",
      "value": "minor"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "minor"
    }
  }, [_vm._v("Minor")])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "w-100"
  }, [_c('label', {
    staticClass: "control-label show-none"
  }, [_vm._v(" KEY ")]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-nail"
  }, [_c('div', {
    staticClass: "dropdown-head"
  }, [(_vm.keyValue == 'none') ? _c('div', {
    staticClass: "text-dull"
  }, [_vm._v("\n                            -\n                          ")]) : _c('div', [_vm._v("\n                            " + _vm._s(_vm.keyValue) + "\n                          ")])]), _vm._v(" "), (_vm.keyDropdown) ? _c('div', [_c('div', {
    staticClass: "dropdown-body"
  }, _vm._l((_vm.keyOptions), function(index) {
    return _c('div', {
      staticClass: "cursor-pointer key-value",
      on: {
        "click": function($event) {
          _vm.setKeyValue(index);
          _vm.keyDropdown = false;
        }
      }
    }, [_vm._v("\n                              " + _vm._s(index) + "\n                            ")])
  }))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "w-30"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Location this album represents")]), _vm._v(" "), _c('v-select', {
    staticClass: "pt-0",
    attrs: {
      "items": _vm.locations,
      "item-text": "name",
      "item-value": "name",
      "placeholder": "Type name to search",
      "single-line": "",
      "autocomplete": ""
    },
    model: {
      value: (_vm.album.location),
      callback: function($$v) {
        _vm.$set(_vm.album, "location", $$v)
      },
      expression: "album.location"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "dflex gap-15 upload-album-item"
  }, [_c('div', {
    staticClass: "w-25"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("\n                      Released Date\n                    ")]), _vm._v(" "), _c('v-menu', {
    staticClass: "released-at-picker",
    attrs: {
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-right": 40,
      "max-width": "290px",
      "min-width": "290px",
      "lazy": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.album.released_at),
      callback: function($$v) {
        _vm.$set(_vm.album, "released_at", $$v)
      },
      expression: "album.released_at"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": "",
      "actions": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var save = ref.save;
        var cancel = ref.cancel;

        return [_c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
          attrs: {
            "flat": "",
            "color": "primary"
          },
          on: {
            "click": cancel
          }
        }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
          attrs: {
            "flat": "",
            "color": "primary"
          },
          on: {
            "click": save
          }
        }, [_vm._v("OK")])], 1)]
      }
    }]),
    model: {
      value: (_vm.album.released_at),
      callback: function($$v) {
        _vm.$set(_vm.album, "released_at", $$v)
      },
      expression: "album.released_at"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "w-75"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("\n                      Album includes\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "album-content-wrapper font-lable-check"
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Acapella",
      "hide-details": ""
    },
    model: {
      value: (_vm.album.is_content_acapella),
      callback: function($$v) {
        _vm.$set(_vm.album, "is_content_acapella", $$v)
      },
      expression: "album.is_content_acapella"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Inst",
      "hide-details": ""
    },
    model: {
      value: (_vm.album.is_content_instrumental),
      callback: function($$v) {
        _vm.$set(_vm.album, "is_content_instrumental", $$v)
      },
      expression: "album.is_content_instrumental"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Stems",
      "hide-details": ""
    },
    model: {
      value: (_vm.album.is_content_stems),
      callback: function($$v) {
        _vm.$set(_vm.album, "is_content_stems", $$v)
      },
      expression: "album.is_content_stems"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Remix",
      "hide-details": ""
    },
    model: {
      value: (_vm.album.is_content_remix),
      callback: function($$v) {
        _vm.$set(_vm.album, "is_content_remix", $$v)
      },
      expression: "album.is_content_remix"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "DJ Mix",
      "hide-details": ""
    },
    model: {
      value: (_vm.album.is_content_dj_mix),
      callback: function($$v) {
        _vm.$set(_vm.album, "is_content_dj_mix", $$v)
      },
      expression: "album.is_content_dj_mix"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "dflex"
  }, [_c('div', {
    staticClass: "w-100"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.album.description),
      expression: "album.description"
    }],
    staticClass: "album-description form-control non-resizable",
    domProps: {
      "value": (_vm.album.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.album, "description", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm12": "",
      "md4": ""
    }
  }, [_c('div', {
    staticClass: "album-image-section pb-2"
  }, [_c('div', {
    staticClass: "image-section"
  }, [(_vm.album_image_url) ? _c('div', {
    staticClass: "album-image",
    style: (("background-image: url(" + _vm.album_image_url + ")")),
    attrs: {
      "id": "album_image"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.album_image_url) ? _c('div', {
    staticClass: "album-image-upload-section"
  }, [_c('input', {
    staticClass: "add-album-image-file",
    attrs: {
      "type": "file",
      "name": "album_image_file",
      "id": "album_image_file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.imageChanged($event)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "album_image_file"
    }
  }, [_c('v-icon', {
    staticClass: "camera mt-0"
  }, [_vm._v("photo_camera")]), _vm._v("upload\n                      ")], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "image-change-section"
  }, [_c('input', {
    staticClass: "change-album-image-file",
    attrs: {
      "type": "file",
      "name": "album_image_file",
      "id": "album_image_file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.imageChanged($event)
      }
    }
  }), _vm._v(" "), (_vm.album_image_url) ? _c('label', {
    attrs: {
      "for": "album_image_file"
    }
  }, [_vm._v("Change")]) : _vm._e()])])])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "album-info-section mx-5 pb-0"
  }, [_vm._m(1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-lg": "",
      "px-0": "",
      "album-section": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "album-content-section": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "form-group": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label max-char-label"
  }, [_c('span', {
    staticClass: "__title"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("\n                      Available to..\n                    ")])]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "py-0 my-0",
    attrs: {
      "items": _vm.access_levels,
      "name": "access_level",
      "item-text": "title",
      "item-value": "id",
      "chips": "",
      "multiple": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(data) {
        return [_c('div', {
          staticClass: "custom-multi-select"
        }, [_c('span', [_vm._v(_vm._s(data.item.title))]), _vm._v(" "), _c('v-icon', {
          staticClass: "icon-close text-white"
        }, [_vm._v("\n                          close\n                        ")])], 1)]
      }
    }]),
    model: {
      value: (_vm.album.access_level),
      callback: function($$v) {
        _vm.$set(_vm.album, "access_level", $$v)
      },
      expression: "album.access_level"
    }
  })], 1)])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "album-info-section mx-5"
  }, [_vm._m(2), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-lg": "",
      "px-0": "",
      "album-section": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "album-content-section": ""
    }
  }, [_c('v-flex', {
    staticClass: "additional-info-section",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "pa-0": ""
    }
  }, [_c('v-flex', {
    staticClass: "my-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "dflex": "",
      "align-center": "",
      "pa-0": "",
      "my-0": ""
    }
  }, [_c('h4', {
    staticClass: "album-info-title-x mb-0 mr-2"
  }, [_vm._v("\n                          Collaborators (" + _vm._s(_vm.collaborators.length) + ")\n                        ")]), _vm._v(" "), (_vm.collaborators.length < 3) ? _c('v-btn', {
    staticClass: "add-option-btn ma-0",
    nativeOn: {
      "click": function($event) {
        _vm.addCollaborator($event)
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "pa-0": ""
    }
  }, _vm._l((_vm.collaborators), function(collaborator, index) {
    return _c('div', {
      key: index,
      staticClass: "upload-album-collaborator mb-3"
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "option-content": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "display-flex": "",
        "justify-start": "",
        "align-center": "",
        "gap-15": "",
        "mb-2": ""
      }
    }, [_c('div', {
      staticClass: "w-100"
    }, [_c('label', {
      staticClass: "control-label mb-0"
    }, [_vm._v("Track")]), _vm._v(" "), _c('span', {
      staticClass: "dflex align-center"
    }, [_c('input', {
      staticClass: "form-control",
      attrs: {
        "type": "text"
      }
    })])])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm6": "",
        "md3": ""
      }
    }, [_c('label', {
      staticClass: "control-label"
    }, [_vm._v("Owner")]), _vm._v(" "), _c('v-select', {
      staticClass: "pt-0",
      attrs: {
        "item-text": "owner",
        "item-value": "id",
        "placeholder": "Type name to search",
        "chips": "",
        "no-data-text": "No artist found",
        "autocomplete": ""
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm6": "",
        "md3": ""
      }
    }, [_c('label', {
      staticClass: "control-label"
    }, [_vm._v("Role")]), _vm._v(" "), _c('span', {
      staticClass: "dflex align-center"
    }, [_c('v-select', {
      staticClass: "pt-0",
      attrs: {
        "item-text": "name",
        "item-value": "name",
        "placeholder": "Select",
        "autocomplete": ""
      }
    })], 1)]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm6": "",
        "md3": ""
      }
    }, [_c('label', {
      staticClass: "control-label"
    }, [_vm._v("Profit split")]), _vm._v(" "), _c('span', {
      staticClass: "dflex align-center"
    }, [_c('input', {
      staticClass: "form-control",
      attrs: {
        "type": "text"
      }
    })])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm6": "",
        "md3": ""
      }
    }, [_c('label', {
      staticClass: "control-label"
    }, [_vm._v("Recoup amount")]), _vm._v(" "), _c('span', {
      staticClass: "dflex align-center"
    }, [_c('input', {
      staticClass: "form-control",
      attrs: {
        "type": "text"
      }
    })])])], 1), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "option-content": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "sm6": "",
        "md3": ""
      }
    }, [_c('label', {
      staticClass: "control-label"
    }, [_vm._v("Collaborator")]), _vm._v(" "), _c('v-select', {
      staticClass: "pt-0",
      attrs: {
        "items": _vm.potential_collaborators,
        "item-text": "username",
        "item-value": "id",
        "placeholder": "Type name to search",
        "chips": "",
        "no-data-text": "No artist found",
        "autocomplete": ""
      },
      scopedSlots: _vm._u([{
        key: "selection",
        fn: function(data) {
          return [_c('v-chip', {
            key: JSON.stringify(data.item),
            staticClass: "chip--select-multi",
            attrs: {
              "selected": data.selected
            },
            on: {
              "input": function($event) {
                data.parent.selectItem(data.item)
              }
            }
          }, [_c('v-avatar', [_c('img', {
            attrs: {
              "src": data.item.avatar.thumb.url
            }
          })]), _vm._v("\n                                " + _vm._s(data.item.username) + "\n                              ")], 1)]
        }
      }, {
        key: "item",
        fn: function(data) {
          return [(typeof data.item !== 'object') ? [_c('v-list-tile-content', {
            domProps: {
              "textContent": _vm._s(data.item)
            }
          })] : [_c('v-list-tile-avatar', [_c('img', {
            attrs: {
              "src": data.item.avatar.thumb.url
            }
          })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
            domProps: {
              "innerHTML": _vm._s(data.item.username)
            }
          })], 1)]]
        }
      }]),
      model: {
        value: (collaborator.user_id),
        callback: function($$v) {
          _vm.$set(collaborator, "user_id", $$v)
        },
        expression: "collaborator.user_id"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm6": "",
        "md3": ""
      }
    }, [_c('label', {
      staticClass: "control-label"
    }, [_vm._v("Role")]), _vm._v(" "), _c('span', {
      staticClass: "dflex align-center"
    }, [_c('v-select', {
      staticClass: "pt-0",
      attrs: {
        "items": _vm.role_types,
        "item-text": "name",
        "item-value": "name",
        "placeholder": "Select",
        "autocomplete": ""
      },
      model: {
        value: (collaborator.user_role),
        callback: function($$v) {
          _vm.$set(collaborator, "user_role", $$v)
        },
        expression: "collaborator.user_role"
      }
    })], 1)]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm6": "",
        "md3": ""
      }
    }, [_c('label', {
      staticClass: "control-label"
    }, [_vm._v("Profit split")]), _vm._v(" "), _c('span', {
      staticClass: "dflex align-center"
    }, [_c('input', {
      staticClass: "form-control",
      attrs: {
        "type": "text"
      }
    })])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm6": "",
        "md3": ""
      }
    }, [_c('label', {
      staticClass: "control-label"
    }, [_vm._v("Recoup amount")]), _vm._v(" "), _c('span', {
      staticClass: "dflex align-center"
    }, [_c('input', {
      staticClass: "form-control",
      attrs: {
        "type": "text"
      }
    }), _vm._v(" "), _c('v-icon', {
      staticClass: "clear-btn mb-15",
      on: {
        "click": function($event) {
          _vm.deleteCollaborator(index)
        }
      }
    }, [_vm._v("\n                              clear\n                            ")])], 1)])], 1)], 1)
  }))], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "additional-info-section",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "pa-0": ""
    }
  }, [_c('v-flex', {
    staticClass: "my-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "dflex": "",
      "align-center": "",
      "pa-0": "",
      "my-0": ""
    }
  }, [_c('h4', {
    staticClass: "album-info-title-x mb-0 mr-2"
  }, [_vm._v("\n                          Album Credits (" + _vm._s(_vm.contributors.length) + ")\n                        ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "add-option-btn ma-0",
    nativeOn: {
      "click": function($event) {
        _vm.addContributor($event)
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "pa-0": ""
    }
  }, _vm._l((_vm.contributors), function(contributor, index) {
    return _c('v-layout', {
      key: index,
      attrs: {
        "row": "",
        "option-content": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md6": "",
        "lg3": ""
      }
    }, [_c('label', {
      staticClass: "control-label"
    }, [_vm._v(" Contributor ")]), _vm._v(" "), _c('v-select', {
      staticClass: "pt-0",
      attrs: {
        "items": _vm.potential_contributors,
        "item-text": "username",
        "item-value": "id",
        "placeholder": "Type name to search",
        "chips": "",
        "no-data-text": "No user found",
        "autocomplete": "",
        "clearable": ""
      },
      scopedSlots: _vm._u([{
        key: "selection",
        fn: function(data) {
          return [_c('v-chip', {
            key: JSON.stringify(data.item),
            staticClass: "chip--select-multi",
            attrs: {
              "selected": data.selected
            },
            on: {
              "input": function($event) {
                data.parent.selectItem(data.item)
              }
            }
          }, [_c('v-avatar', [_c('img', {
            attrs: {
              "src": data.item.avatar.thumb.url
            }
          })]), _vm._v("\n                              " + _vm._s(data.item.username) + "\n                            ")], 1)]
        }
      }, {
        key: "item",
        fn: function(data) {
          return [(typeof data.item !== 'object') ? [_c('v-list-tile-content', {
            domProps: {
              "textContent": _vm._s(data.item)
            }
          })] : [_c('v-list-tile-avatar', [_c('img', {
            attrs: {
              "src": data.item.avatar.thumb.url
            }
          })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
            domProps: {
              "innerHTML": _vm._s(data.item.username)
            }
          })], 1)]]
        }
      }]),
      model: {
        value: (contributor.user_id),
        callback: function($$v) {
          _vm.$set(contributor, "user_id", $$v)
        },
        expression: "contributor.user_id"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "md6": "",
        "lg3": ""
      }
    }, [_c('label', {
      staticClass: "control-label"
    }, [_vm._v(" Role ")]), _vm._v(" "), _c('span', {
      staticClass: "dflex align-center"
    }, [_c('v-select', {
      staticClass: "pt-0",
      attrs: {
        "items": _vm.role_types,
        "item-text": "name",
        "item-value": "name",
        "placeholder": "Type name to search",
        "autocomplete": ""
      },
      model: {
        value: (contributor.user_role),
        callback: function($$v) {
          _vm.$set(contributor, "user_role", $$v)
        },
        expression: "contributor.user_role"
      }
    }), _vm._v(" "), _c('v-icon', {
      staticClass: "clear-btn mb-4",
      on: {
        "click": function($event) {
          _vm.deleteContributor(index)
        }
      }
    }, [_vm._v("\n                            clear\n                          ")])], 1)])], 1)
  }))], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mx-5",
    attrs: {
      "xs12": "",
      "album-action-section": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm-6": "",
      "text-xs-left": "",
      "mb-5": ""
    }
  }, [_c('v-btn', {
    staticClass: "release-now-btn white--text",
    attrs: {
      "flat": "",
      "loading": _vm.loading,
      "disabled": _vm.slug ? !_vm.isAvailableToEditAlbum : !_vm.isAvailableToUploadAlbum
    },
    nativeOn: {
      "click": function($event) {
        _vm.releaseNow($event)
      }
    }
  }, [_vm._v("\n                Save Changes\n              ")]), _vm._v(" "), (false) ? _c('v-btn', {
    staticClass: "save-for-later-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.saveForLater($event)
      }
    }
  }, [_vm._v("\n                Save for later\n              ")]) : _vm._e()], 1)], 1)], 1)], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "my-dialog-1 large"
    },
    model: {
      value: (_vm.show_sample_clearance_license_modal),
      callback: function($$v) {
        _vm.show_sample_clearance_license_modal = $$v
      },
      expression: "show_sample_clearance_license_modal"
    }
  }, [_c('sample-license-dialog', {
    attrs: {
      "dismiss": _vm.closeSampleClearanceLicenseModal
    }
  })], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "my-genre-dialog ma-0 pa-2"
    },
    model: {
      value: (_vm.show_genre_selector_dialog),
      callback: function($$v) {
        _vm.show_genre_selector_dialog = $$v
      },
      expression: "show_genre_selector_dialog"
    }
  }, [_c('genre-single-selector', {
    attrs: {
      "dismiss": _vm.closeGenreSelectorDialog
    }
  })], 1)], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', {
    staticClass: "album-info-title mt-2"
  }, [_vm._v("Info")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', {
    staticClass: "album-info-title"
  }, [_vm._v("Options")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', {
    staticClass: "album-info-title"
  }, [_vm._v("Collaborators")])])
}]}

/***/ }),
/* 1817 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-100 font-inter"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "text-14 font-weight-500 text-grey-black-2"
  }, [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")]), _vm._v(" "), (_vm.number) ? _c('div', {
    staticClass: "text-24 font-weight-600"
  }, [_vm._v(_vm._s(_vm.number))]) : _vm._e()]), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 1818 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "account-subscription"
  }, [_c('div', {
    staticClass: "account-subscription__text mb-4"
  }, [_vm._v("Current Plan")]), _vm._v(" "), _c('div', {
    staticClass: "current-plan d-flex",
    class: _vm.$vuetify.breakpoint.width > 650 ? '' : 'flex-wrap gap-10'
  }, [_vm._m(0), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex flex-column gap-4"
  }, [_c('div', {
    staticClass: "plan-name"
  }, [_vm._v("PREMIUM")]), _vm._v(" "), _c('div', {
    staticClass: "note text-black"
  }, [_vm._v("(Monthly)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex flex-column align-end gap-4"
  }, [_c('div', [_c('span', {
    staticClass: "account-subscription__text"
  }, [_vm._v("$12")]), _vm._v(" "), _c('span', {
    staticClass: "note text-black"
  }, [_vm._v("/month")])]), _vm._v(" "), _c('div', {
    staticClass: "note font-weight-500"
  }, [_vm._v("Cancel")])])
}]}

/***/ }),
/* 1819 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "merch-section",
    attrs: {
      "xs12": "",
      "sm12": "",
      "id": "carousel-view"
    }
  }, [_c('v-layout', {
    staticClass: "dismiss-section",
    attrs: {
      "row": "",
      "wrap": ""
    },
    on: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "popup-section",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(!_vm.showPolicySection) ? _c('v-flex', {
    staticClass: "image-section",
    attrs: {
      "xs12": "",
      "sm7": ""
    }
  }, [(_vm.covers.length > 1) ? _c('v-carousel', {
    staticClass: "product-carousel"
  }, _vm._l((_vm.covers), function(cover, index) {
    return _c('v-carousel-item', {
      key: index,
      attrs: {
        "src": cover.cover.large.url,
        "transition": "fade",
        "reverseTransition": "fade"
      },
      on: {
        "onmouseout": function($event) {
          _vm.zoomOut()
        }
      }
    })
  })) : _vm._e(), _vm._v(" "), (_vm.covers.length == 1) ? _c('div', {
    staticClass: "product-cover-image",
    style: ({
      'background-image': 'url(' + _vm.covers[0].cover.url + ')',
      'background-repeat': 'no-repeat',
      'background-size': 'contain',
    })
  }) : _vm._e(), _vm._v(" "), (!_vm.covers.length) ? _c('div', {
    staticClass: "product-cover-image"
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.showPolicySection) ? _c('v-flex', {
    staticClass: "info-section",
    attrs: {
      "xs12": "",
      "sm5": ""
    }
  }, [_c('v-flex', {
    staticClass: "profile-section",
    attrs: {
      "xs12": ""
    }
  }, [_c('profile-item', {
    attrs: {
      "user": _vm.item.merchant,
      "className": 'avatar-image'
    }
  }), _vm._v(" "), (_vm.item.collaborators_count == 0) ? _c('div', {
    staticClass: "profile-content"
  }, [_c('router-link', {
    staticClass: "user-name",
    attrs: {
      "to": ("/" + (_vm.item.merchant.slug))
    }
  }, [_vm._v(_vm._s(_vm.item.merchant.username))])], 1) : _c('div', {
    staticClass: "profile-content"
  }, [_c('div', {
    staticClass: "profile-title"
  }, [_vm._v("Multiple Collaborators")]), _vm._v(" "), _c('router-link', {
    staticClass: "user-name",
    attrs: {
      "to": ("/" + (_vm.item.merchant.slug))
    }
  }, [_vm._v(_vm._s(_vm.item.merchant.username))]), _vm._v(" "), _vm._l((_vm.item.collaborators), function(c) {
    return [_vm._v("\n            , "), _c('router-link', {
      staticClass: "user-name",
      attrs: {
        "to": ("/" + (c.user.slug))
      }
    }, [_vm._v(_vm._s(c.user.username))])]
  })], 2)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "item-section",
    attrs: {
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "item-name"
  }, [_vm._v(_vm._s(_vm.item.name))]), _vm._v(" "), _c('p', {
    staticClass: "item-price"
  }, [_vm._v("$" + _vm._s(_vm._f("formatNumber")(_vm.price)))]), _vm._v(" "), _c('p', {
    staticClass: "item-description"
  }, [_vm._v(_vm._s(_vm.item.description))])])], 1) : _vm._e(), _vm._v(" "), (_vm.showPolicySection) ? _c('v-flex', {
    staticClass: "policy-section",
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-tabs', {
    attrs: {
      "fixed": "",
      "centered": ""
    }
  }, [_c('v-tabs-bar', {
    attrs: {
      "dark": ""
    }
  }, [_c('v-tabs-slider', {
    staticClass: "yellow"
  }), _vm._v(" "), _c('v-tabs-item', {
    key: "size_chart",
    attrs: {
      "href": "#size_chart"
    }
  }, [_vm._v("Size Chart")]), _vm._v(" "), _c('v-tabs-item', {
    key: "shipping_policy",
    attrs: {
      "href": "#shipping_policy"
    }
  }, [_vm._v("Shipping Policy")]), _vm._v(" "), _c('v-tabs-item', {
    key: "return_policy",
    attrs: {
      "href": "#return_policy"
    }
  }, [_vm._v("Return Policy")]), _vm._v(" "), _c('v-tabs-item', {
    key: "privacy_policy",
    attrs: {
      "href": "#privacy_policy"
    }
  }, [_vm._v("Privacy Policy")])], 1), _vm._v(" "), _c('v-tabs-items', [_c('v-tabs-content', {
    key: "size_chart",
    attrs: {
      "id": "size_chart"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_vm._v(_vm._s(_vm.item.merchant.size_chart))])], 1)], 1), _vm._v(" "), _c('v-tabs-content', {
    key: "shipping_policy",
    attrs: {
      "id": "shipping_policy"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_vm._v(_vm._s(_vm.item.merchant.shipping_policy))])], 1)], 1), _vm._v(" "), _c('v-tabs-content', {
    key: "return_policy",
    attrs: {
      "id": "return_policy"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_vm._v(_vm._s(_vm.item.merchant.return_policy))])], 1)], 1), _vm._v(" "), _c('v-tabs-content', {
    key: "prviacy_policy",
    attrs: {
      "id": "privacy_policy"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_vm._v(_vm._s(_vm.item.merchant.privacy_policy))])], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "actions-section",
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('a', {
    staticClass: "action-btn right-border",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.togglePolicy()
      }
    }
  }, [_vm._v(_vm._s(_vm.policyButtonText))]), _vm._v(" "), _c('a', {
    staticClass: "action-btn right-border",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.repostProduct()
      }
    }
  }, [_c('svg', {
    staticStyle: {
      "padding-top": "3px"
    },
    attrs: {
      "width": "24px",
      "height": "20px",
      "viewBox": "0 0 24 20",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Design",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "23---Merch-Modal",
      "transform": "translate(-818.000000, -773.000000)",
      "fill": "#3A92FF"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group-4",
      "transform": "translate(460.000000, 240.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group-6",
      "transform": "translate(177.000000, 529.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M203.353452,13.450486 C203.842994,13.420565 204.283792,13.7701682 204.323209,14.2639522 C204.332359,14.3817114 204.530322,17.1267443 202.64096,19.1604973 C201.389831,20.5064173 199.561882,21.1561054 197.207789,21.1561054 L186.388782,21.1561054 L186.388782,23.5503101 C186.388782,23.723362 186.19645,23.8813659 186.039135,23.9560809 C185.97737,23.9860019 185.818648,24 185.752308,24 C185.650775,24 185.549945,23.9657046 185.467769,23.8999134 L181.643996,20.8232999 C181.538064,20.7380863 181.476123,20.6098284 181.476123,20.4736966 C181.476123,20.3373899 181.538064,20.209132 181.643996,20.1239184 L185.467769,17.0473049 C185.603088,16.9393444 185.882876,16.9155475 186.039135,16.9911374 C186.19645,17.0658524 186.388782,17.2240313 186.388782,17.3970831 L186.388782,19.581316 L197.207789,19.581316 C199.02958,19.581316 200.406525,19.0126421 201.301144,18.0576198 C202.654685,16.6124881 202.520422,14.4555516 202.519015,14.4343794 C202.483645,13.9398955 202.85652,13.4874061 203.353452,13.450486 Z M181.979719,14.5451396 C181.490354,14.5748856 181.049379,14.2275571 181.010139,13.7337731 C181.000812,13.6160139 180.802849,10.8543582 182.692212,8.82043027 C183.94334,7.47451028 185.77129,6.80802443 188.125382,6.80802443 L198.934183,6.80802443 L198.934183,4.44968985 C198.934183,4.276638 199.131619,4.11845916 199.288933,4.04391913 C199.350698,4.01399813 199.5147,4 199.580863,4 C199.682573,4 199.783226,4.03412044 199.865403,4.10008661 L203.689176,7.17670012 C203.795284,7.26191372 203.857048,7.39017156 203.857048,7.52630336 C203.857048,7.66243515 203.795284,7.79069299 203.689176,7.87608157 L199.865403,10.9525201 C199.73026,11.0606556 199.445369,11.0844525 199.288933,11.0088626 C199.131619,10.9341476 198.934183,10.7759687 198.934183,10.6029169 L198.934183,8.3828138 L188.125382,8.3828138 C186.303591,8.3828138 184.926646,8.96951033 184.032204,9.92435762 C182.678662,11.3696643 182.812925,13.5355246 182.814157,13.5565218 C182.849526,14.0511807 182.476651,14.5082195 181.979719,14.5451396 Z",
      "id": "ic_repeat"
    }
  })])])])])]), _vm._v("\n        Repost this product\n      ")]), _vm._v(" "), _c('a', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.shareProduct()
      }
    }
  }, [_c('svg', {
    staticStyle: {
      "padding-top": "3px"
    },
    attrs: {
      "width": "15px",
      "height": "20px",
      "viewBox": "0 0 19 24",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Design",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "23---Merch-Modal",
      "transform": "translate(-1090.000000, -771.000000)",
      "fill-rule": "nonzero",
      "fill": "#3A92FF"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group-4",
      "transform": "translate(460.000000, 240.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group-6",
      "transform": "translate(177.000000, 529.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group-23",
      "transform": "translate(453.000000, 2.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8.00415315,3.25693396 L1.70710678,9.55398033 C1.31658249,9.94450462 0.683417511,9.94450462 0.292893219,9.55398033 C-0.0976310729,9.16345604 -0.0976310729,8.53029106 0.292893219,8.13976677 L8.13976677,0.292893219 C8.53029106,-0.0976310729 9.16345604,-0.0976310729 9.55398033,0.292893219 L17.7919553,8.53086817 C18.1824796,8.92139246 18.1824796,9.55455744 17.7919553,9.94508173 C17.401431,10.335606 16.768266,10.335606 16.3777417,9.94508173 L10.0097727,3.57711275 L10.2200725,16.1756106 C10.2086891,19.7571806 12.3351533,21.4625058 17.0734141,21.4692941 C17.6256983,21.4700854 18.0727716,21.9184416 18.0719804,22.4707258 C18.0711892,23.02301 17.6228329,23.4700833 17.0705488,23.4692921 C11.3129674,23.4610434 8.20482908,20.9684614 8.22021711,16.1891374 L8.00415315,3.25693396 Z",
      "id": "Combined-Shape"
    }
  })])])])])])]), _vm._v("\n        Share this product\n      ")])])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1820 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "d-flex w-100 choose"
  }, [_c('v-btn', {
    staticClass: "auth-default-btn ma-0",
    class: {
      active: _vm.accountCategory == 'listener'
    },
    on: {
      "click": function($event) {
        _vm.chooseAccount('listener')
      }
    }
  }, [_vm._v("\n      Listener\n    ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "auth-default-btn ma-0",
    class: {
      active: _vm.accountCategory == 'creator'
    },
    on: {
      "click": function($event) {
        _vm.chooseAccount('creator')
      }
    }
  }, [_vm._v("\n      Creator\n    ")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "auth-button",
    class: {
      'auth-bg-disabled': _vm.checkDataEmpty,
      'auth-bg-active': !_vm.checkDataEmpty,
    },
    on: {
      "click": function($event) {
        _vm.handleNextStage()
      }
    }
  }, [_vm._v("\n    Next\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "login mt-5"
  }, [_vm._v("Already have an account?")]), _vm._v(" "), _c('router-link', {
    staticClass: "d-flex justify-center mt-4",
    attrs: {
      "to": "/login"
    }
  }, [_c('v-btn', {
    staticClass: "auth-default-btn max-w145"
  }, [_vm._v(" Login ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1821 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page partners-page mx-5 mt-5 pt-5"
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-lg": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs5": "",
      "layer-flex": "",
      "flex-text": ""
    }
  }, [_c('h2', {
    staticClass: "mb-2"
  }, [_vm._v("Get paid to share.")]), _vm._v(" "), _c('div', {
    staticClass: "b-body-text"
  }, [_vm._v("\n                With Repost Request verified artists & brands can pay you to share their albums, videos & products to your followers.\n              ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('ul', [_c('li', [_c('b', [_vm._v("Basic plan:")]), _vm._v(" charge up to "), _c('b', [_vm._v("$100")]), _vm._v(" per repost\n                ")]), _vm._v(" "), _c('li', [_c('b', [_vm._v("Pro plan:")]), _vm._v(" charge up to "), _c('b', [_vm._v("10k")]), _vm._v(" per repost\n                ")]), _vm._v(" "), _c('li', [_c('b', [_vm._v("Plus plan:")]), _vm._v(" charge up to "), _c('b', [_vm._v("100k")]), _vm._v(" per repost\n                ")])]), _vm._v(" "), _c('span', [_c('v-btn', {
    staticClass: "white--text mt-4 app-blue",
    attrs: {
      "depressed": "",
      "round": "",
      "to": '/adfree#plans'
    }
  }, [_c('b', [_vm._v("Choose Plan")])])], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": "",
      "layer-flex": "",
      "flex-img": ""
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": "/static/images/re_sharebg.svg"
    }
  })])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1822 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page auth-page auth-twitter-confirm-page"
  }, [_c('v-card', {
    attrs: {
      "mt-5": ""
    }
  }, [_c('v-card-media', {
    attrs: {
      "contain": "",
      "src": "/static/images/ic_twitter.png",
      "height": "50px"
    }
  }), _vm._v(" "), _c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Connect to Twitter")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n      To complete verification, you must login to your Artist, Brand, or\n      Label"), _c('br'), _vm._v("\n      Twitter account once time & verify your identity.\n    ")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "round": "",
      "dark": "",
      "color": "blue",
      "px-4": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.submit()
      }
    }
  }, [_vm._v("Login to Twitter")]), _vm._v(" "), _c('v-spacer')], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1823 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "comment_input",
    class: {
      noBorder: _vm.noBorder
    }
  }, [_c('user-tag', {
    staticClass: "commenter",
    attrs: {
      "user": _vm.currentUser,
      "showAvatar": "",
      "hideTick": "",
      "hideName": "",
      "width": "42",
      "height": "42"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.commentText),
      expression: "commentText",
      modifiers: {
        "trim": true
      }
    }],
    class: {
      roundInput: _vm.roundInput
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.commentText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.commentText = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (_vm.commentText.length) ? _c('img', {
    staticClass: "ml-3 addComment-cta",
    attrs: {
      "src": __webpack_require__(1560)
    },
    on: {
      "click": function($event) {
        _vm.addComment()
      }
    }
  }) : _c('img', {
    staticClass: "ml-3 addComment-cta",
    attrs: {
      "src": __webpack_require__(1559)
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1824 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('dashboard-nav', {
    attrs: {
      "name": "top-creators"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "page-content px-5"
  }, [_vm._m(0), _vm._v(" "), (_vm.pageReady) ? _c('div', {
    staticClass: "table-margin"
  }, [_c('table', {
    staticClass: "text-xs-left"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "my-2"
  }), _vm._v(" "), _vm._l((_vm.top_creators), function(creator, index) {
    return _c('tr', {
      key: index,
      staticClass: "tbl-row"
    }, [_c('td', [_c('div', {
      staticClass: "dflex align-center my-2"
    }, [_c('div', {
      staticClass: "tbl-num"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('div', {
      staticClass: "tbl-img mx-3",
      style: ({
        'background-image': ("url(" + (creator.avatar_url) + ")"),
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "tbl-content"
    }, [_c('div', {
      staticClass: "tbl-title"
    }, [_vm._v(_vm._s(creator.display_name))]), _vm._v(" "), _c('div', {
      staticClass: "tbl-subtitle"
    }, [_vm._v("@" + _vm._s(creator.user) + "  •  " + _vm._s(creator.user_type))])])])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "number-text ml-4"
    }, [_vm._v(_vm._s(creator.playedViewed))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "number-text ml-3"
    }, [_vm._v("$" + _vm._s(creator.subscriptionShare))])]), _vm._v(" "), _c('td')])
  })], 2)]) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dflex align-center"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1459),
      "width": "20",
      "height": "20"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "main-heading ml-2"
  }, [_vm._v("These creators will share your subscription this month")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "border-bottom"
  }, [_c('th', {
    staticClass: "w-30"
  }, [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Total plays")]), _vm._v(" "), _c('th', [_vm._v("Earning")]), _vm._v(" "), _c('th', {
    staticClass: "w-30"
  })])
}]}

/***/ }),
/* 1825 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "onboarding_comp auth-input-page"
  }, [_c('div', {
    staticClass: "auth-input-page__group"
  }, [_c('label', {
    staticClass: "auth-label-input"
  }, [_vm._v("Full Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fullName),
      expression: "fullName"
    }],
    class: {
      _filled: _vm.fullName
    },
    attrs: {
      "type": "text",
      "placeholder": "Your full name"
    },
    domProps: {
      "value": (_vm.fullName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fullName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "auth-input-page__group my-1"
  }, [_c('label', {
    staticClass: "auth-label-input"
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    class: {
      _filled: _vm.email
    },
    attrs: {
      "type": "email",
      "placeholder": "Your email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "auth-input-page__group"
  }, [_c('label', {
    staticClass: "auth-label-input"
  }, [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "Your password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    class: {
      'display-flex align-center gap-8 justify-space-between': _vm.$vuetify.breakpoint.width <= 1280,
    }
  }, [(_vm.$vuetify.breakpoint.width <= 1280) ? _c('v-btn', {
    staticClass: "back-button",
    on: {
      "click": function($event) {
        _vm.$emit('actionPrevStage')
      }
    }
  }, [_vm._v("\n      Back\n    ")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "auth-button",
    class: {
      _disabled: !_vm.validated('skipToast'),
      'auth-bg-disabled': _vm.checkDataEmpty,
      'auth-bg-active': !_vm.checkDataEmpty,
    },
    on: {
      "click": function($event) {
        _vm.handleNextStage()
      }
    }
  }, [_vm._v("\n      Next\n    ")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1826 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "attach-wrapper"
  }, [(Object.keys(_vm.assoc).length) ? _c('div', {
    staticClass: "attach-layer attach-layer-selected"
  }, [_c('div', {
    staticClass: "attach-info ii"
  }, [_c('div', {
    staticClass: "__cover",
    style: ({
      'background-image': 'url(' + _vm.attachCover + ')'
    })
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('v-icon', {
    staticClass: "attach-cancel cursor-pointer",
    on: {
      "click": function($event) {
        _vm.removeAttach()
      }
    }
  }, [_vm._v("\n      add\n    ")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "thought-attachment"
  }, [_c('div', {
    staticClass: "thought-attachment-previews"
  }, [_c('div', {
    staticClass: "_preview add-attachment dflex align-center justify-center",
    on: {
      "click": function($event) {
        _vm.show_attach_picker = true
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1), _vm._v(" "), _vm._l((_vm.truncAttachment), function(attachment, index) {
    return _c('div', {
      key: index,
      staticClass: "_preview mb-1",
      class: [_vm.getCustomClass(attachment)],
      style: ({
        'background-image': 'url(' + _vm.getBGUrl(attachment) + ')'
      }),
      on: {
        "click": function($event) {
          _vm.selectAttachment({
            type: _vm.getAssocType(attachment),
            value: attachment,
          })
        }
      }
    })
  })], 2)]), _vm._v(" "), (_vm.show_attach_picker) ? _c('attach-picker', {
    attrs: {
      "dismiss": _vm.closeAttachPicker,
      "title": "Add Attachment",
      "customAlbums": _vm.albums,
      "customProducts": _vm.products,
      "fullscreen": ""
    },
    on: {
      "getSelected": _vm.selectAttachment
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "__details"
  }, [_c('div', {
    staticClass: "_title"
  }), _vm._v(" "), _c('div', {
    staticClass: "_info"
  })])
}]}

/***/ }),
/* 1827 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page payments-page",
    class: {
      'mx-5': !_vm.isComp
    }
  }, [_c('content-top-header', {
    staticClass: "black-theme"
  }, [_c('template', {
    slot: "topHeader"
  }, [_c('ul', {
    staticClass: "pr-3"
  }, [_c('li', {
    staticClass: "nav-li"
  }, [_c('label', {
    staticClass: "nav-label"
  }, [_vm._v("\n              Payments\n            ")])])])])], 2), _vm._v(" "), _c('content-top-header', {
    staticClass: "content-top-header-tab",
    attrs: {
      "height": 62
    }
  }, [_c('template', {
    slot: "topHeader"
  }, [_c('ul', _vm._l((_vm.tabs), function(tab) {
    return _c('li', {
      key: tab.id,
      class: {
        'active tab-active': _vm.isActiveTab(tab.id)
      },
      attrs: {
        "href": ("#" + (tab.id))
      }
    }, [_c('label', {
      on: {
        "click": function($event) {
          _vm.setTab(tab.id)
        }
      }
    }, [_vm._v(_vm._s(tab.title))])])
  }))])], 2), _vm._v(" "), (_vm.currentUser) ? _c('div', {
    staticClass: "page-content mt-130 payment"
  }, [(_vm.total_pages === 0) ? [(_vm.active_tab == 'received') ? _c('div', {
    staticClass: "empty-section"
  }, [_c('p', {
    staticClass: "empty-title"
  }, [_vm._v("You have not received any payments")]), _vm._v(" "), (!_vm.currentUser.stripe_connected && (_vm.currentUser.creator_verified || _vm.currentUser.user_type == 'admin')) ? _c('div', [_c('p', {
    staticClass: "empty-description"
  }, [_vm._v("\n            To start accepting payments connect to Stripe.com\n          ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "stripe-connect-btn",
    attrs: {
      "to": "/settings/#bank-details",
      "dark": "",
      "round": ""
    }
  }, [_vm._v("Connect Stripe")])], 1) : _vm._e()]) : (_vm.active_tab == 'sent') ? _c('div', {
    staticClass: "empty-section"
  }, [_c('p', {
    staticClass: "empty-title"
  }, [_vm._v("You have not sent any payments")])]) : _vm._e()] : _c('table', {
    staticClass: "payment-table custom-table"
  }, [_c('thead', {
    staticClass: "custom-table__thread"
  }, [_c('tr', [_c('th', {
    staticClass: "text-xs-left",
    attrs: {
      "width": "25%"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.active_tab == 'received' ? 'Sender' : 'Receiver') + "\n          ")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("Sent")]), _vm._v(" "), (_vm.active_tab === 'received') ? _c('th', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("Received")]) : _vm._e(), _vm._v(" "), _c('th', {
    attrs: {
      "width": "25%"
    }
  }, [_vm._v("Type")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("Date")])])]), _vm._v(" "), _c('tbody', {
    staticClass: "custom-table__tbody"
  }, _vm._l((_vm.histories), function(history, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "user"
    }, [(_vm.active_tab == 'received') ? _c('user-card', {
      attrs: {
        "user": history.sender
      }
    }) : (_vm.active_tab == 'sent') ? _c('user-card', {
      attrs: {
        "user": history.receiver
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center"
    }, [_vm._v("\n            $" + _vm._s(_vm._f("formatNumber")((history.sent_amount + history.payment_fee))) + "\n          ")]), _vm._v(" "), (_vm.active_tab === 'received') ? _c('td', {
      staticClass: "text-xs-center"
    }, [_vm._v("\n            $" + _vm._s(_vm._f("formatNumber")(history.received_amount)) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center",
      staticStyle: {
        "text-transform": "capitalize"
      }
    }, [(history.payment_type == 'buy') ? [(history.sent_amount == history.refund_amount) ? [_vm._v("\n                Full Refund\n              ")] : (history.refund_amount > 0) ? [_vm._v("\n                Partial Refund\n              ")] : [_vm._v("\n                Purchase\n              ")]] : (
      history.payment_type == 'refund' && history.order_id
    ) ? [_vm._v("\n              Refund\n            ")] : (history.payment_type == 'collaborate') ? [_vm._v("\n              Collaborate\n            ")] : [_vm._v("\n              " + _vm._s(history.description ||
      _vm.PaymentTypes[history.payment_type] ||
      history.payment_type) + "\n            ")]], 2), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center",
      class: {
        'error--text': history.status == 'pending'
      }
    }, [_vm._v("\n            " + _vm._s(_vm._f("capitalize")(history.status)) + "\n          ")]), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center"
    }, [_vm._v("\n            " + _vm._s(_vm._f("formatDate")(history.created_at)) + "\n          ")])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center"
  }, [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.page_index < _vm.total_pages),
      expression: "page_index < total_pages"
    }],
    staticClass: "loadmore-btn",
    nativeOn: {
      "click": function($event) {
        _vm.loadMore()
      }
    }
  }, [_vm._v("Load More")])], 1)], 2) : _vm._e(), _vm._v(" "), (_vm.send_message_dialog) ? _c('send-message', {
    attrs: {
      "receiver": _vm.messaging_user,
      "dismiss": _vm.hideSendMessageDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_product_modal) ? _c('product-modal', {
    attrs: {
      "item": _vm.payment.assoc,
      "dismiss": _vm.closeProductModal,
      "shareProduct": _vm.shareProduct
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_share_modal) ? _c('share-modal', {
    attrs: {
      "item": _vm.payment.assoc,
      "dismiss": _vm.closeShareModal
    }
  }) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    staticClass: "my-dialog-1",
    model: {
      value: (_vm.show_withdraw_confirm_modal),
      callback: function($$v) {
        _vm.show_withdraw_confirm_modal = $$v
      },
      expression: "show_withdraw_confirm_modal"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Withdraw Confirmation")]), _vm._v(" "), _c('v-card-text', [_vm._v("Are you sure you want to withdraw $" + _vm._s(_vm._f("formatNumber")(_vm.withdrawAmount)) + "?")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.withdrawMoney()
      }
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeWithdrawConfirmModal()
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "500px"
    },
    model: {
      value: (_vm.show_withdraw_dialog),
      callback: function($$v) {
        _vm.show_withdraw_dialog = $$v
      },
      expression: "show_withdraw_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('h2', [_vm._v("Transfer Money")])]), _vm._v(" "), _c('v-card-text', {
    staticClass: "withdraw-dialog"
  }, [_c('label', [_vm._v("Available")]), _vm._v(" "), _c('label', {
    staticClass: "available-money-amount"
  }, [_vm._v("$" + _vm._s(_vm._f("formatNumber")(_vm.currentUser.available_amount)))]), _vm._v(" "), _c('label', [_vm._v("out of ")]), _vm._v(" "), _c('label', [_vm._v("$" + _vm._s(_vm._f("formatNumber")(_vm.currentUser.balance_amount)))]), _vm._v(" "), _c('v-radio-group', {
    attrs: {
      "mandatory": true
    },
    model: {
      value: (_vm.withdraw_option),
      callback: function($$v) {
        _vm.withdraw_option = $$v
      },
      expression: "withdraw_option"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "All",
      "value": "all"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Partial",
      "value": "partial"
    }
  }), _vm._v(" "), _c('vue-numeric', {
    staticClass: "withdraw-amount pl-2 pr-2 pt-1 pb-1 ma-1 ml-4",
    attrs: {
      "currency": "$",
      "separator": ",",
      "precision": 2,
      "min": 1,
      "disabled": _vm.withdraw_option == 'all'
    },
    model: {
      value: (_vm.withdraw_amount),
      callback: function($$v) {
        _vm.withdraw_amount = $$v
      },
      expression: "withdraw_amount"
    }
  }), _vm._v(" "), (_vm.currentUser.balance_amount < _vm.withdraw_amount) ? _c('label', {
    staticClass: "pl-4 pr-2 error-text"
  }, [_vm._v("Amount should be less than Avaialble Balance.")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pa-3"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": _vm.disableWithdrawButton
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.openWithdrawConfirmModal()
      }
    }
  }, [_vm._v("Withdraw")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.closeWithdrawModal()
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _vm._v(" "), (_vm.show_refund_confirm_dialog) ? _c('v-dialog', {
    staticClass: "my-dialog-1",
    model: {
      value: (_vm.show_refund_confirm_dialog),
      callback: function($$v) {
        _vm.show_refund_confirm_dialog = $$v
      },
      expression: "show_refund_confirm_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Refund Confirmation")]), _vm._v(" "), _c('v-card-text', [_vm._v("Are you sure you want to refund $" + _vm._s(_vm._f("formatNumber")(_vm.refund_amount)) + "?")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "red--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.refundMoney()
      }
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeRefundConfirmDialog()
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.show_refund_dialog) ? _c('order-refund-dialog', {
    attrs: {
      "value": _vm.payment
    },
    on: {
      "input": _vm.continueRefund,
      "close": _vm.closeRefundDialog
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1828 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "carousel-3d-controls"
  }, [_c('a', {
    staticClass: "prev",
    class: {
      disabled: !_vm.parent.isPrevPossible
    },
    style: (("width: " + _vm.width + "px; height: " + _vm.height + "px; line-height: " + _vm.height + "px;")),
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.parent.goPrev()
      }
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.prevHtml)
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "next",
    class: {
      disabled: !_vm.parent.isNextPossible
    },
    style: (("width: " + _vm.width + "px; height: " + _vm.height + "px; line-height: " + _vm.height + "px;")),
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.parent.goNext()
      }
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.nextHtml)
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 1829 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "video-card"
  }, [_c('v-flex', {
    staticClass: "video-info",
    attrs: {
      "xs12": "",
      "pa-0": ""
    }
  }, [_c('v-flex', {
    staticClass: "video-cover",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "video-image",
    style: ({
      'background-image': 'url(' + _vm.item.cover.url + ')'
    })
  }), _vm._v(" "), (_vm.$store.state.auth.user) ? _c('v-flex', {
    staticClass: "video-actions",
    attrs: {
      "xs12": "",
      "relative": ""
    },
    on: {
      "click": function($event) {
        _vm.viewStream()
      }
    }
  }, [_c('v-btn', {
    staticClass: "green px-2 live-video-btn",
    attrs: {
      "dark": "",
      "round": ""
    }
  }, [_c('v-icon', [_vm._v("videocam")]), _vm._v(" "), (_vm.item.view_price > 0) ? _c('span', [_vm._v("$" + _vm._s(_vm._f("formatNumber")(_vm.item.view_price)))]) : _vm._e()], 1), _vm._v(" "), _c('p', [_vm._v("Broadcast started"), _c('br'), _vm._v(_vm._s(_vm._f("formatDateFromNow")(_vm.item.started_at)))])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "video-detail",
    attrs: {
      "xs12": "",
      "pa-0": ""
    }
  }, [_c('p', {
    staticClass: "video-name"
  }, [_c('span'), _vm._v("Broadcasting Live Now")]), _vm._v(" "), _c('p', {
    staticClass: "video-user-name"
  }, [_c('router-link', {
    attrs: {
      "to": '/' + _vm.owner.slug
    }
  }, [_vm._v(_vm._s(_vm.owner.username))])], 1)])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1830 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "product-card"
  }, [_c('v-flex', {
    staticClass: "product-info"
  }, [_c('v-flex', {
    staticClass: "product-cover",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "product-image",
    style: ({
      'background-image': 'url(' + _vm.product.covers[0].cover.url + ')'
    })
  }), _vm._v(" "), _c('v-flex', {
    staticClass: "product-actions",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-flex', {
    staticClass: "touch-flex",
    attrs: {
      "xs12": ""
    }
  }), _vm._v(" "), (this.$store.state.auth.user.id === _vm.product.merchant.id && _vm.editButtonAction) ? _c('v-flex', {
    staticClass: "touch-flex",
    attrs: {
      "xs12": ""
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.editButtonAction(_vm.product)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "pt-2": ""
    }
  }, [(_vm.product.collaborators_count === 0) ? [(_vm.deleteButtonAction) ? _c('v-btn', {
    staticClass: "action-btn",
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.deleteButtonAction(_vm.product)
      }
    }
  }, [_vm._v("Delete")]) : _vm._e(), _vm._v(" "), (_vm.updateButtonAction) ? _c('v-btn', {
    staticClass: "action-btn",
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.updateButtonAction(_vm.product)
      }
    }
  }, [_vm._v(_vm._s(_vm.updateButtonText))]) : _vm._e()] : [(_vm.product.status == 'pending') ? _c('div', {
    staticClass: "collaboration-status"
  }, [(_vm.product.merchant.id === this.$store.state.auth.user.id && _vm.usersCountByStatus.accepted === _vm.product.collaborators_count) ? [_c('div', {
    staticClass: "approve-wrapper"
  }, [_c('div', {
    staticClass: "approved-text"
  }, [_vm._v("This product has been "), _c('br'), _c('span', [_vm._v("APPROVED")])]), _vm._v(" "), _c('v-btn', {
    staticClass: "action-btn release",
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.releaseButtonAction(_vm.product)
      }
    }
  }, [_vm._v("Release Now")])], 1)] : _c('div', {
    staticClass: "status-overview"
  }, [(_vm.usersCountByStatus.accepted > 0) ? _c('div', [_c('div', {
    staticClass: "accepted-title"
  }, [_vm._v("Accepted")]), _vm._v(" "), _vm._l((_vm.usersByStatus.accepted), function(c) {
    return _c('div', [_vm._v(_vm._s(c.user.username))])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.usersCountByStatus.denied > 0) ? _c('div', [_c('div', {
    staticClass: "denied-title"
  }, [_vm._v("Denied")]), _vm._v(" "), _vm._l((_vm.usersByStatus.denied), function(c) {
    return _c('div', [_vm._v(_vm._s(c.user.username))])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.usersCountByStatus.pending > 0) ? _c('div', [_c('div', {
    staticClass: "pending-title"
  }, [_vm._v("Waiting for approval")]), _vm._v(" "), _vm._l((_vm.usersByStatus.pending), function(c) {
    return _c('div', [_vm._v(_vm._s(c.user.username))])
  })], 2) : _vm._e()]), _vm._v(" "), (_vm.acceptButtonAction) ? _c('div', {
    staticClass: "collaboration-actions"
  }, [_c('v-btn', {
    staticClass: "action-btn accept",
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.acceptButtonAction(_vm.product)
      }
    }
  }, [_vm._v("Accept")]), _vm._v(" "), _c('v-btn', {
    staticClass: "action-btn deny",
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.denyButtonAction(_vm.product)
      }
    }
  }, [_vm._v("Deny")])], 1) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.deleteButtonAction && this.$store.state.auth.user.id === _vm.product.merchant.id) ? _c('v-btn', {
    staticClass: "action-btn",
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.deleteButtonAction(_vm.product)
      }
    }
  }, [_vm._v("Delete")]) : _vm._e(), _vm._v(" "), (_vm.product.status == 'collaborated') ? _c('div', {
    staticClass: "collaboration-status"
  }, [_c('div', {
    staticClass: "status-overview"
  }, [_c('div', [_c('div', {
    staticClass: "accepted-title"
  }, [_vm._v("Collaborators")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.product.merchant.username) + " (owner) - " + _vm._s(_vm.ownerShare) + "%")]), _vm._v(" "), _vm._l((_vm.usersByStatus.accepted), function(c) {
    return _c('div', [_vm._v(_vm._s(c.user.username) + " - " + _vm._s(c.user_share) + "%")])
  })], 2)])]) : _vm._e()]], 2), _vm._v(" "), _c('p', {
    staticClass: "product-count"
  }, [_vm._v(_vm._s(_vm.product.stock) + " in stock")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "product-detail"
  }, [_c('p', {
    staticClass: "product-name"
  }, [_vm._v(_vm._s(_vm.product.name))]), _vm._v(" "), _c('p', {
    staticClass: "product-user-name"
  }, [_vm._v(_vm._s(_vm.product.merchant.username))])])], 1), _vm._v(" "), (_vm.isShowPromoteModal) ? _c('promote-modal', {
    attrs: {
      "item": _vm.product,
      "dismiss": _vm.dismissPromoteDialog,
      "success": _vm.saveAndFinish
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1831 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "header"
  }, [_vm._v("Notifications")]), _vm._v(" "), _c('div', {
    staticClass: "mt-4 title"
  }, [_vm._v("Chats")]), _vm._v(" "), _c('div', {
    staticClass: "horizontal-scroll"
  }, _vm._l((5), function(i) {
    return _c('div', {
      key: i,
      staticClass: "horizontal-scroll__item relative pr-2 pb-2",
      on: {
        "click": function($event) {
          _vm.$router.push({
            name: 'ChatRoomMobile'
          })
        }
      }
    }, [_c('img', {
      staticClass: "absolute circle-red",
      attrs: {
        "src": __webpack_require__(1485),
        "width": "16",
        "height": "16"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "horizontal-scroll__item__image"
    }, [_c('img', {
      attrs: {
        "src": __webpack_require__(1517),
        "width": 156,
        "height": 60
      }
    })])])
  })), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "horizontal-scroll"
  }, _vm._l((5), function(i) {
    return _c('div', {
      key: i,
      staticClass: "horizontal-scroll__item inbox mr-2 mb-2"
    }, [_c('div', {
      staticClass: "display-flex gap-8 align-center"
    }, [_c('img', {
      staticClass: "rounded",
      attrs: {
        "src": __webpack_require__(1518),
        "width": 50,
        "height": 50
      }
    }), _vm._v(" "), _vm._m(1, true)]), _vm._v(" "), _c('div', {
      staticClass: "text-inter-14 my-3"
    }, [_vm._v("\n        Yo bro, love your new album, are you down to come through for a\n        session w..\n      ")]), _vm._v(" "), _c('v-btn', {
      staticClass: "text-inter-14 text-white inbox__btn",
      on: {
        "click": function($event) {
          _vm.$router.push({
            name: 'MessagesMobile'
          })
        }
      }
    }, [_vm._v("Reply")])], 1)
  })), _vm._v(" "), _c('div', {
    staticClass: "title mt-4"
  }, [_vm._v("Activity")]), _vm._v(" "), _vm._l((5), function(i) {
    return _c('div', {
      key: i
    }, [_c('div', {
      staticClass: "display-flex gap-8 align-center py-3"
    }, [_c('img', {
      staticClass: "rounded",
      attrs: {
        "src": __webpack_require__(30),
        "width": 50,
        "height": 50
      }
    }), _vm._v(" "), _vm._m(2, true)]), _vm._v(" "), _vm._m(3, true)])
  }), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }), _vm._v(" "), _c('Footer')], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "display-flex justify-space-between align-center mt-3"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Inbox")]), _vm._v(" "), _c('div', {
    staticClass: "see-all font-weight-500"
  }, [_vm._v("See All")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "text-inter-15"
  }, [_vm._v("Andrew Parker")]), _vm._v(" "), _c('div', {
    staticClass: "text-inter-13"
  }, [_c('span', [_vm._v("@andrewparker")]), _vm._v(" "), _c('span', {
    staticClass: "text-black"
  }, [_vm._v("• 24m")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "display-flex justify-space-between algin-center full-width"
  }, [_c('div', {
    staticClass: "text-inter-14 text-grey-6"
  }, [_c('span', {
    staticClass: "font-weight-600"
  }, [_vm._v("@patrick")]), _vm._v(" "), _c('span', {
    staticClass: "font-weight-400"
  }, [_vm._v("followed you")])]), _vm._v(" "), _c('div', {
    staticClass: "text-inter-12 font-weight-400 text-grey-7"
  }, [_vm._v("8h")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "display-flex justify-end"
  }, [_c('hr', {
    staticClass: "line"
  })])
}]}

/***/ }),
/* 1832 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "accordion mt-3"
  }, [_c('div', {
    staticClass: "tabs"
  }, _vm._l((_vm.accordions), function(slide, i) {
    return _c('div', {
      key: i,
      staticClass: "tab",
      style: (i != 0 ? 'margin-top: -1px' : '')
    }, [_c('input', {
      attrs: {
        "type": "checkbox",
        "id": ("chck" + i)
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "tab-label",
      attrs: {
        "for": ("chck" + i)
      }
    }, [(_vm.leftIcon) ? _c('v-icon', {
      staticClass: "_icon_before",
      attrs: {
        "color": "black"
      }
    }, [_vm._v(_vm._s(_vm.leftIcon))]) : _vm._e(), _vm._v("\n        " + _vm._s(slide.title) + "\n      "), (_vm.rightIcon) ? _c('v-icon', {
      staticClass: "_icon_after",
      attrs: {
        "color": "black"
      }
    }, [_vm._v(_vm._s(_vm.rightIcon))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "tab-content",
      domProps: {
        "innerHTML": _vm._s(slide.content)
      }
    })])
  }))])
},staticRenderFns: []}

/***/ }),
/* 1833 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "onboarding_comp profile-image"
  }, [_c('label', {
    attrs: {
      "for": "profileImage"
    }
  }, [_c('div', {
    staticClass: "profile-image-holder",
    style: (("background-image: url(" + (_vm.profileImage ? _vm.profileImage : _vm.pickerImg) + ")"))
  })]), _vm._v(" "), _c('input', {
    staticClass: "profile-image-picker",
    attrs: {
      "type": "file",
      "name": "profile_image",
      "id": "profileImage",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.imageChanged($event)
      }
    }
  }), _vm._v(" "), _c('div', {
    class: {
      'display-flex align-center gap-8 justify-space-between': _vm.$vuetify.breakpoint.width <= 1280,
    }
  }, [(_vm.$vuetify.breakpoint.width <= 1280) ? _c('v-btn', {
    staticClass: "back-button",
    on: {
      "click": function($event) {
        _vm.$emit('actionPrevStage')
      }
    }
  }, [_vm._v("\n      Back\n    ")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "auth-button",
    class: {
      _disabled: !_vm.validated('skipToast'),
      'auth-bg-disabled': _vm.checkDataEmpty,
      'auth-bg-active': !_vm.checkDataEmpty,
    },
    on: {
      "click": function($event) {
        _vm.handleNextStage()
      }
    }
  }, [_vm._v("\n      Next\n    ")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1834 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-landing-page"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-space-between": "",
      "row": "",
      "fill-height": "",
      "gap-20": "",
      "py-4": ""
    }
  }, [_c('div', [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-start": "",
      "row": "",
      "gap-20": ""
    }
  }, [_c('div', {
    staticClass: "black--text text-16 font-weight-500"
  }, [_vm._v("Join Newsletter")]), _vm._v(" "), _c('div', {
    staticClass: "input-email bg-white"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "mx-4 font-poppins text-16 font-weight-500",
    attrs: {
      "placeholder": "Enter your email address"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "tex-16 font-poppins font-weight-600",
    attrs: {
      "color": "black",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.storeEmail()
      }
    }
  }, [_vm._v("\n            Send!\n          ")])], 1)])], 1), _vm._v(" "), _c('div', [_c('v-layout', {
    attrs: {
      "align-center": "",
      "row": "",
      "gap-20": ""
    }
  }, [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/@yousoundapp"
    }
  }, [_c('div', [_c('img', {
    attrs: {
      "src": "/static/images/landing-page/youtube.svg",
      "aspect-ratio": "1",
      "height": "32",
      "width": "32"
    }
  })])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.instagram.com/yousoundapp/"
    }
  }, [_c('div', [_c('img', {
    attrs: {
      "src": "/static/images/landing-page/instagram.svg",
      "aspect-ratio": "1",
      "height": "32",
      "width": "32"
    }
  })])])])], 1)]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-space-between": "",
      "row": "",
      "fill-height": "",
      "gap-20": "",
      "py-4": ""
    }
  }, [_c('div', [_c('a', {
    staticClass: "text-grey-black-2 text-14",
    attrs: {
      "href": "/terms#privacy_policy",
      "target": "_blank"
    }
  }, [_vm._v("\n        Privacy Policy\n      ")]), _vm._v(" "), _c('a', {
    staticClass: "text-grey-black-2 text-14 ml-3",
    attrs: {
      "href": "/terms",
      "target": "_blank"
    }
  }, [_vm._v("\n        Terms of Use\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "text-grey-black-1 text-12 font-weight-500"
  }, [_vm._v("© 2024 YouSound, Inc.")])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1835 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner"
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "text-container d-flex justify-center align-center flex-column"
  }, [_c('h3', {
    staticClass: "mb-md-15 mb-8"
  }, [_vm._v("\n          " + _vm._s(_vm.title) + "\n          "), _c('br'), _vm._v("\n          " + _vm._s(_vm.title2) + "\n          "), _c('br'), _vm._v("\n          " + _vm._s(_vm.title3) + "\n        ")]), _vm._v(" "), _c('a', {
    staticClass: "mt-4 plan_btn",
    attrs: {
      "href": "#plans"
    }
  }, [_vm._v(" Choose a plan ")])])])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1836 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page cart-page margin-top-header",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('content-top-header', {
    staticClass: "black-theme"
  }, [_c('template', {
    slot: "topHeader"
  }, [_c('ul', _vm._l((_vm.tabs), function(tab) {
    return _c('li', {
      key: tab.id,
      staticClass: "nav-li",
      class: [{
        active: _vm.isActiveTab(tab.id)
      }, ("nav-" + (tab.id))],
      attrs: {
        "href": ("#" + (tab.id))
      }
    }, [_c('label', {
      staticClass: "nav-label",
      on: {
        "click": function($event) {
          _vm.onTab(tab.id)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(tab.title) + "\n\t\t\t\t\t")])])
  }))])], 2), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [(_vm.currentUser && _vm.isPageReady) ? _c('div', {
    staticClass: "page-content"
  }, [(_vm.active_tab == 'cart') ? [(!_vm.cartItems || _vm.cartItems.length == 0) ? _c('div', {
    staticClass: "empty-section"
  }, [_c('p', {
    staticClass: "empty-title"
  }, [_vm._v("Your Cart is Empty")]), _vm._v(" "), _c('p', {
    staticClass: "empty-description"
  }, [_vm._v("Looking for something new?")]), _vm._v(" "), _c('router-link', {
    staticClass: "empty-discover-btn",
    attrs: {
      "to": "/product"
    }
  }, [_vm._v("Discover")])], 1) : _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    staticClass: "min-100",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "px-4 pt-4",
    attrs: {
      "xs12": "",
      "sm7": "",
      "order-section": ""
    }
  }, [_c('div', {
    staticClass: "mb-4 main-heading"
  }, [_vm._v(_vm._s(_vm.cartItems.length) + " items in cart")]), _vm._v(" "), _c('div', {
    staticClass: "order-container"
  }, _vm._l((_vm.cartItems), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "order-item"
    }, [_c('div', {
      staticClass: "order-content-section pa-0",
      attrs: {
        "sm12": ""
      }
    }, [_c('div', {
      staticClass: "product-cover-image"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'SingleProduct',
          params: {
            id: item.product.id
          }
        }
      }
    }, [_c('activity-product-card', {
      attrs: {
        "object": item.product,
        "price-show": false
      }
    })], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "product-content"
    }, [_c('div', {
      staticClass: "product-content-row"
    }, [_c('div', {
      staticClass: "product-name"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'SingleProduct',
          params: {
            id: item.product.id
          }
        }
      }
    }, [_c('span', {
      staticClass: "black--text"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(item.product.name) + " |\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(item.product_variant.name) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])])], 1), _vm._v(" "), _c('div', {
      staticClass: "product-content-row justify-space-between pt-0"
    }, [_c('div', [_c('router-link', {
      staticClass: "user-name",
      attrs: {
        "to": ("/" + (item.product.merchant.slug))
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(item.product.merchant.username) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])], 1)]), _vm._v(" "), (!_vm.isDigitalProduct(item)) ? _c('div', [_c('v-btn', {
      staticClass: "product-count-adjust-btn",
      class: {
        active: item.quantity > 1
      },
      attrs: {
        "disabled": item.quantity <= 1
      },
      nativeOn: {
        "click": function($event) {
          _vm.removeQuantity(item)
        }
      }
    }, [_c('v-icon', [_vm._v("remove")])], 1), _vm._v(" "), _c('label', {
      staticClass: "product-count"
    }, [_vm._v(_vm._s(item.quantity))]), _vm._v(" "), _c('v-btn', {
      staticClass: "product-count-adjust-btn active",
      nativeOn: {
        "click": function($event) {
          _vm.addQuantity(item)
        }
      }
    }, [_c('v-icon', [_vm._v("add")])], 1)], 1) : _vm._e()]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
      staticClass: "product-action-row justify-space-between"
    }, [_c('label', {
      staticClass: "product-price"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t$" + _vm._s(_vm._f("formatNumber")(item.price)) + "\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('a', {
      staticClass: "message-buyer-btn",
      on: {
        "click": function($event) {
          if ($event.target !== $event.currentTarget) { return null; }
          _vm.removeCartItem(item)
        }
      }
    }, [_vm._v("Remove")])])], 1)])])
  })), _vm._v(" "), _c('div', {
    staticClass: "orders-status-section"
  }, [_c('div', {
    staticClass: "status-row"
  }, [_c('label', {
    staticClass: "status-title"
  }, [_vm._v("Subtotal")]), _vm._v(" "), _c('label', {
    staticClass: "status-title value"
  }, [_vm._v("$" + _vm._s(_vm._f("formatNumber")(_vm.cartCost.subtotal_cost)))])]), _vm._v(" "), _c('div', {
    staticClass: "status-row"
  }, [_c('label', {
    staticClass: "status-title"
  }, [_vm._v("Shipping")]), _vm._v(" "), _c('label', {
    staticClass: "status-title value"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t$" + _vm._s(_vm._f("formatNumber")(_vm.cartCost.shipping_cost)) + "\n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "status-row"
  }, [_c('label', {
    staticClass: "status-title"
  }, [_vm._v("Sales Tax")]), _vm._v(" "), _c('label', {
    staticClass: "status-title value"
  }, [_vm._v("$" + _vm._s(_vm._f("formatNumber")(_vm.cartCost.tax_cost)))])]), _vm._v(" "), _c('div', {
    staticClass: "status-row"
  }, [_c('label', {
    staticClass: "status-title"
  }, [_vm._v("Stripe Fee")]), _vm._v(" "), _c('label', {
    staticClass: "status-title value"
  }, [_vm._v("$" + _vm._s(_vm._f("formatNumber")(_vm.cartCost.fee_cost)))])]), _vm._v(" "), _c('div', {
    staticClass: "total-row"
  }, [_c('label', {
    staticClass: "status-title"
  }, [_vm._v("Total")]), _vm._v(" "), _c('label', {
    staticClass: "status-title value"
  }, [_c('span', [_vm._v("USD")]), _vm._v(" $" + _vm._s(_vm._f("formatNumber")((_vm.cartCost.total_cost + _vm.cartCost.fee_cost))))])])])]), _vm._v(" "), _c('v-flex', {
    staticClass: "orders-section-container px-5 pt-4",
    attrs: {
      "xs12": "",
      "sm5": ""
    }
  }, [_c('div', {
    staticClass: "mb-3"
  }, [_c('div', {
    staticClass: "title mb-2"
  }, [_vm._v("Shipping")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("All transactions are secure and encrypted.")])]), _vm._v(" "), _c('div', {
    staticClass: "shipping-address-section"
  }, [_c('div', {
    staticClass: "\n\t\t\t\t\t\t\t\t\t\t\td-flex\n\t\t\t\t\t\t\t\t\t\t\tjustify-space-between\n\t\t\t\t\t\t\t\t\t\t\tshipping-action-header\n\t\t\t\t\t\t\t\t\t\t\talign-center\n\t\t\t\t\t\t\t\t\t\t"
  }, [_c('div', {
    staticClass: "stripped-shipping-address"
  }, _vm._l((_vm.strippedAddress), function(line, i) {
    return _c('div', {
      key: i
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(line) + "\n\t\t\t\t\t\t\t\t\t\t")])
  })), _vm._v(" "), _c('div', {
    staticClass: "header-title app-bold flex-none cursor-pointer shipped-btn",
    on: {
      "click": function($event) {
        _vm.editDialog = true
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tEdit\n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "edit-address-dialog"
    },
    model: {
      value: (_vm.editDialog),
      callback: function($$v) {
        _vm.editDialog = $$v
      },
      expression: "editDialog"
    }
  }, [_c('address-tab')], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mb-3"
  }, [_c('div', {
    staticClass: "title mb-2"
  }, [_vm._v("Payment")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("All transactions are secure and encrypted.")])]), _vm._v(" "), _c('div', {
    staticClass: "payment-stripe-section"
  }, [_c('div', {
    staticClass: "header-title"
  }, [_c('h3', [_vm._v("Credit card")]), _vm._v(" "), _c('div', {
    staticClass: "icon-image"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(426),
      "alt": "",
      "width": "130"
    }
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\tand more...\n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "stripe-section-body"
  }, [_c('div', {
    staticClass: "lock"
  }, [_c('card-number', {
    ref: "cardNumber",
    staticClass: "stripe-element card-number payment-card",
    class: {
      complete: _vm.complete
    },
    attrs: {
      "stripe": _vm.stripe_publishable_key,
      "options": _vm.stripeOptions
    },
    on: {
      "change": function($event) {
        _vm.number = $event.complete
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(1473),
      "alt": "",
      "width": "30"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom-details"
  }, [_c('div', [_c('card-expiry', {
    ref: "cardExpiry",
    staticClass: "stripe-element card-expiry payment-card",
    class: {
      complete: _vm.complete
    },
    attrs: {
      "stripe": _vm.stripe_publishable_key,
      "options": _vm.stripeOptions
    },
    on: {
      "change": function($event) {
        _vm.expiry = $event.complete
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "question-mark"
  }, [_c('card-cvc', {
    ref: "cardCvc",
    staticClass: "stripe-element card-cvc payment-card",
    class: {
      complete: _vm.complete
    },
    attrs: {
      "stripe": _vm.stripe_publishable_key,
      "options": _vm.stripeOptions
    },
    on: {
      "change": function($event) {
        _vm.cvc = $event.complete
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(1531),
      "alt": "",
      "width": "40"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-3"
  }, [_c('div', {
    staticClass: "title mb-2"
  }, [_vm._v("Remember me")])]), _vm._v(" "), _c('div', {
    staticClass: "payment-stripe-section"
  }, [_c('div', {
    staticClass: "regular-checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "c-checkbox"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "c-checkbox"
    }
  }, [_vm._v("Save my information for faster checkout")])])]), _vm._v(" "), _c('div', {
    staticClass: "payment-stripe-section-button"
  }, [_c('div', {
    staticClass: "btn-holder"
  }, [_c('v-btn', {
    staticClass: "checkout-btn",
    attrs: {
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        _vm.submit()
      }
    }
  }, [_vm._v("Pay $" + _vm._s(_vm._f("formatNumber")((_vm.cartCost.total_cost + _vm.cartCost.fee_cost))))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "powered-by text-center"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(427),
      "width": "100",
      "alt": ""
    }
  })])])], 1)], 1)], 1)] : _vm._e(), _vm._v(" "), (_vm.active_tab == 'history') ? [(!_vm.orderHistories || _vm.orderHistories.length == 0) ? _c('div', {
    staticClass: "empty-section"
  }, [_c('p', {
    staticClass: "empty-title"
  }, [_vm._v("New Orders")]), _vm._v(" "), _c('p', {
    staticClass: "empty-description"
  }, [_vm._v("You have no orders yet.")])]) : _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, _vm._l((_vm.orderHistories), function(order, index) {
    return _c('v-flex', {
      key: index,
      staticClass: "order-history-item px-5",
      attrs: {
        "xs12": ""
      }
    }, [_c('div', {
      staticClass: "profile-section"
    }, [_c('v-layout', {
      attrs: {
        "row": ""
      }
    }, [_c('div', {
      staticClass: "profile-content-section relative"
    }, [_c('div', {
      staticClass: "dflex align-center"
    }, [_c('div', {
      staticClass: "profile-avatar"
    }, [_c('profile-item', {
      attrs: {
        "user": _vm.currentUser,
        "className": 'order-item-profile-avatar'
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "profile-content"
    }, [_c('a', {
      staticClass: "user-name",
      attrs: {
        "href": "#"
      }
    }, [_c('b', [_vm._v("You")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
      staticClass: "order-detail-text"
    }, [_vm._v("purchased "), _c('b', [_vm._v(" $" + _vm._s(_vm._f("formatNumber")(order.amount)))]), _vm._v(" on "), _c('b', [_vm._v(" " + _vm._s(_vm._f("formatDate")(order.created_at)))])])])]), _vm._v(" "), _c('div', {
      staticClass: "profile-actions"
    }, [_c('div', [(_vm.isMenuAvailable(order)) ? _c('v-menu', {
      staticClass: "menu-content-x",
      attrs: {
        "down": "",
        "offset-y": "",
        "nudge-top": -5
      }
    }, [_c('v-btn', {
      attrs: {
        "slot": "activator",
        "round": ""
      },
      slot: "activator"
    }, [_c('v-icon', {
      attrs: {
        "dark": "",
        "right": ""
      }
    }, [_vm._v("more_horiz")])], 1), _vm._v(" "), _c('v-list', {
      staticClass: "list-class"
    }, [_c('v-list-tile', {
      nativeOn: {
        "click": function($event) {
          _vm.openTicketDialog(order, _vm.item)
        }
      }
    }, [_c('v-list-tile-content', [_c('router-link', {
      staticClass: "order-detail-btn",
      attrs: {
        "to": ("/sell/order/" + (order.id))
      }
    }, [_vm._v("Order Details")]), _vm._v(" "), _c('a', {
      staticClass: "message-buyer-btn",
      on: {
        "click": function($event) {
          _vm.showMessageDialog(order)
        }
      }
    }, [_vm._v("Message Buyer")])], 1)], 1), _vm._v(" "), (_vm.isAddressEnabled(order)) ? _c('v-list-tile', {
      nativeOn: {
        "click": function($event) {
          _vm.openAddressConfimDialog(order)
        }
      }
    }, [_c('v-list-tile-content', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tRemove my personal info\n\t\t\t\t\t\t\t\t\t\t\t\t\t")])], 1) : _vm._e()], 1)], 1) : _vm._e()], 1)])])])], 1), _vm._v(" "), _vm._l((order.items), function(item, index) {
      return _c('div', {
        key: index,
        staticClass: "order-section"
      }, [_c('v-layout', {
        staticClass: "border-x",
        attrs: {
          "row": ""
        }
      }, [_c('div', {
        staticClass: "order-content-section relative dflex align-center"
      }, [_c('div', {
        staticClass: "product-cover-image",
        style: (("background-image: url(" + (item.product.covers[0].cover.thumb.url) + ")"))
      }), _vm._v(" "), _c('div', {
        staticClass: "product-content"
      }, [_c('div', {
        staticClass: "product-content-row"
      }, [_c('div', {
        staticClass: "product-name"
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(item.product.name) + " |\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(item.product_variant.name) + "\n\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
        staticClass: "product-content-row max-width justify-space-between"
      }, [_c('div', {
        staticClass: "product-price"
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t$" + _vm._s(_vm._f("formatNumber")(item.product_variant.price)) + "\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), (!_vm.isDigitalProduct(item)) ? _c('div', {
        staticClass: "product-count"
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tQuantity: "), _c('b', [_vm._v(_vm._s(item.quantity))])]) : _vm._e()])])]), _vm._v(" "), (_vm.isDigitalProduct(item)) ? _c('div', {
        staticClass: "order-status-section digital"
      }, [_c('div', {
        staticClass: "text-xs-center"
      }, [_c('label', [_vm._v(_vm._s(_vm._f("truncateInMiddle")(item.product.digital_content_name, 20)))]), _vm._v(" "), _c('span', {
        staticClass: "product-link",
        on: {
          "click": function($event) {
            _vm.download(item)
          }
        }
      }, [_vm._v("Download")])])]) : _c('div', {
        staticClass: "order-status-section pending",
        class: {
          pending: item.status == 'item_ordered',
          'pending shipped': item.status == 'item_shipped',
        },
        on: {
          "click": function($event) {
            item.status !== 'item_ordered' &&
              _vm.openTrackingInfoDialog(item)
          }
        }
      }, [_c('div', [_c('li', [_vm._v(_vm._s(_vm.order_status[item.status]))]), _vm._v(" "), (item.status === 'item_ordered') ? _c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tMust ship by "), _c('b', [_vm._v(_vm._s(_vm.getItemDay(item)) + ".")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm._f("formatDate")(_vm.getItemDate(item))))]), _vm._v(" or this order is automatically refunded\n\t\t\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (item.status === 'item_shipped') ? _c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tYour item has shipped\n\t\t\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (item.status == 'item_refunded') ? _c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tYour item has refunded\n\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "dflex align-center justify-space-between"
      }, [_c('div', {
        staticClass: "bold"
      }, [_vm._v("Download")]), _vm._v(" "), _c('v-btn', {
        staticClass: "hollow-btn"
      }, [_vm._v("sample.zip")])], 1)])])], 1)
    })], 2)
  }))] : _vm._e(), _vm._v(" "), (_vm.active_tab == 'cart') ? _c('v-dialog', {
    attrs: {
      "content-class": "my-dialog-1"
    },
    model: {
      value: (_vm.show_order_complete_dialog),
      callback: function($$v) {
        _vm.show_order_complete_dialog = $$v
      },
      expression: "show_order_complete_dialog"
    }
  }, [_c('div', {
    staticClass: "payment-success payment-ready"
  }, [_c('div', {
    staticClass: "dflex align-center my-4"
  }, [_c('div', {
    staticClass: "success-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(119),
      "width": "100%"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "result-text"
  }, [_c('div', {
    staticClass: "big"
  }, [_vm._v("Thank you!")]), _vm._v(" "), _c('div', [_vm._v("Your order was successful")])])]), _vm._v(" "), _c('div', {
    staticClass: "post"
  }, [_vm._v("\n\t\t\t\t\t\tWe sent an email confirmation to: "), _c('br'), _vm._v(" "), _c('strong', [_vm._v(" " + _vm._s(_vm.currentUser.email) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "second-head mt-4"
  }, [_vm._v("\n\t\t\t\t\t\tBuyer protection\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "divider mt-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "post mt-2"
  }, [_vm._v("\n\t\t\t\t\t\tSellers have "), _c('b', [_vm._v("21 days")]), _vm._v(" to ship your items or your order is automatically refunded.\n\t\t\t\t\t")]), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-5 pay_btn",
    attrs: {
      "depressed": "",
      "round": "",
      "block": ""
    },
    on: {
      "click": function($event) {
        _vm.orderDetails()
      }
    }
  }, [_vm._v("View order details")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.showPaymentModal) ? _c('payment-modal', {
    attrs: {
      "receivers": _vm.merchants,
      "amount": _vm.cartCost.total_cost,
      "dismiss": _vm.closePaymentDialog,
      "finish": _vm.orderItems
    }
  }) : _vm._e()], 2) : _vm._e()]), _vm._v(" "), (_vm.showSendMessage) ? _c('send-message', {
    attrs: {
      "receiver": _vm.user,
      "dismiss": _vm.dismissMessageModal
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_ticket_dialog) ? _c('ticket-new-dialog', {
    attrs: {
      "item": _vm.active_item,
      "dismiss": _vm.closeTicketDialog
    }
  }) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "tracking-info-dialog"
    },
    model: {
      value: (_vm.show_tracking_info_dialog),
      callback: function($$v) {
        _vm.show_tracking_info_dialog = $$v
      },
      expression: "show_tracking_info_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Your item has shipped")]), _vm._v(" "), _c('v-card-text', [(_vm.active_item && _vm.active_item.product) ? _c('div', {
    staticClass: "product"
  }, [_c('div', {
    staticClass: "product-cover",
    style: (("background-image: url(" + (_vm.active_item.product.covers[0].cover.thumb.url) + ")"))
  }), _vm._v(" "), _c('div', {
    staticClass: "product-info"
  }, [_c('div', {
    staticClass: "product-name"
  }, [_vm._v(_vm._s(_vm.active_item.product.name))]), _vm._v(" "), _c('div', {
    staticClass: "product-owner"
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.active_item.product.merchant.username) + "\n\t\t\t\t\t\t")])])]) : _vm._e(), _vm._v(" "), _c('div', [_c('label', [_vm._v("Carrier: ")]), _c('span', {
    staticClass: "red--text"
  }, [_c('b', [_vm._v(_vm._s(_vm.active_item.tracking_site))])])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("Tracking number: ")]), _c('span', [_vm._v(_vm._s(_vm.active_item.tracking_number))])])])], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "my-dialog-1"
    },
    model: {
      value: (_vm.show_address_confirm_dialog),
      callback: function($$v) {
        _vm.show_address_confirm_dialog = $$v
      },
      expression: "show_address_confirm_dialog"
    }
  }, [_c('v-card', [_c('v-card-text', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Remove your shipping address?")]), _vm._v(" "), _c('div', [_vm._v("\n\t\t\t\t\tThis will remove your shipping address from this user, and user\n\t\t\t\t\tmight not be able to ship your items\n\t\t\t\t")])]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "dark": "",
      "color": "green"
    },
    nativeOn: {
      "click": function($event) {
        _vm.removeMyAddress()
      }
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "dark": "",
      "color": "grey"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeAddressConfimDialog()
      }
    }
  }, [_vm._v("No")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1837 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page auth-page auth-forgot-page no-top-nav no-side-space"
  }, [_c('v-container', {
    attrs: {
      "grid-list-item": "",
      "allChildrenCenter": "",
      "auth-card": "",
      "px-0": ""
    }
  }, [(!_vm.resetSuccess) ? _c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "justify-center": ""
    }
  }, [(!_vm.onMobile) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "auth-card-child": "",
      "left-card": ""
    }
  }, [_c('div', [_c('img', {
    attrs: {
      "width": "40%",
      "src": "/static/images/nav_logo_primary.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-4"
  }, [_c('h3', [_vm._v("Forgot password")])])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "forgot-quest"
  }, [_c('img', {
    attrs: {
      "width": "70%",
      "src": "/static/images/forgot-quest.svg",
      "alt": ""
    }
  })])], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "lg4": "",
      "auth-card-child": "",
      "allChildrenCenter": "",
      "right-card": "",
      "sign-in-info": ""
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "pt-0": "",
      "flex-none": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center"
  }, [_c('h2', [_vm._v("Forgot password")])]), _vm._v(" "), _c('forgot-password-input')], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.resetSuccess) ? _c('div', {
    staticClass: "reset-successful-layout"
  }, [_c('h2', [_vm._v("Check your email")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "_content"
  }, [_c('img', {
    attrs: {
      "width": "40",
      "src": __webpack_require__(606),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "_message"
  }, [_vm._v("\n          Instructions to reset your password were sent to\n          "), _c('strong', [_vm._v(_vm._s(this.email))])])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "to-login-btn",
    attrs: {
      "block": "",
      "round": "",
      "dark": "",
      "height": "40"
    },
    on: {
      "click": function($event) {
        _vm.toLogin()
      }
    }
  }, [_vm._v("\n        Login\n      ")])], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1838 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "plans-section",
    attrs: {
      "id": "plans"
    }
  }, [_c('div', {
    staticClass: "plans-inner"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Choose a plan")]), _vm._v(" "), _c('h2', {
    staticClass: "text-xs-center mt-3"
  }, [_vm._v("Start your 30 day free trial")]), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": "",
      "px-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "justify-space-between": "",
      "mt-4": ""
    }
  }, _vm._l((_vm.plansData), function(plan, n) {
    return _c('plan', {
      key: n,
      attrs: {
        "plan": plan,
        "id": plan.id
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center"
  }, [_vm._v("\n    * Upload features only for verified artist accounts\n    ")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1839 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isPageReady) ? _c('v-container', {
    staticClass: "genre",
    class: {
      onMobile: _vm.onMobile
    },
    attrs: {
      "pa-0": ""
    }
  }, [_c('div', {
    staticClass: "dflex justify-space-between align-center"
  }, [_c('div', {}, [(_vm.show_selector_view) ? _c('h3', {
    staticClass: "_title"
  }, [_vm._v("Genre filters")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "_subtitle d-block justify-space-between",
    class: {
      'dflex': !_vm.onMobile
    }
  }, [_c('div', [(!_vm.show_selector_view) ? _c('v-btn', {
    staticClass: "back-to-genre",
    attrs: {
      "fab": "",
      "round": ""
    },
    nativeOn: {
      "click": function($event) {
        (_vm.show_selector_view = true)
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.show_selector_view) ? _c('span', {
    staticClass: "back-label"
  }, [_vm._v("Back to Genres")]) : _vm._e()], 1), _vm._v(" "), (_vm.show_selector_view) ? _c('p', [_vm._v("\n              Genres you select will appear on Discover\n\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.onMobile) ? _c('p', [_vm._v("\n              Tap and hold to select subgenres\n\t\t\t\t\t\t")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "dflex align-top align-center"
  }, [(_vm.show_selector_view) ? _c('div', {
    staticClass: "input-genre-group"
  }, [_c('input', {
    staticClass: "input-genre",
    attrs: {
      "id": "filter-select",
      "type": "text",
      "placeholder": "Search genres"
    },
    on: {
      "keyup": function($event) {
        _vm.filterRecords()
      },
      "focus": function($event) {
        (_vm.inputDropdown = true)
      }
    }
  }), _vm._v(" "), (_vm.inputDropdown) ? _c('div', [_c('div', {
    staticClass: "genre-dropdown-overlay",
    on: {
      "click": function($event) {
        (_vm.inputDropdown = false)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "genre-dropdown",
    attrs: {
      "id": "genre-dropdown"
    }
  }, [_c('div', {
    staticClass: "genre-container"
  }, _vm._l((_vm.genres), function(parent) {
    return _c('div', {
      key: parent.id
    }, [_c('div', _vm._b({
      staticClass: "genre-block"
    }, 'div', _vm.child in parent.children, false), [(_vm.subGenresName.includes(_vm.child.name.toLowerCase())) ? _c('div', [_c('input', {
      staticClass: "check-box",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.selectedSubgenresIds.includes(_vm.child.id)
      },
      on: {
        "click": function($event) {
          _vm.selectSubGenre(_vm.child, parent)
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "text",
      attrs: {
        "for": "check"
      }
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.child.name) + "\n\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "subtitle"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(parent.name) + "\n\t\t\t\t\t\t\t\t\t\t\t\t")])])]) : _vm._e()])])
  })), _vm._v(" "), _c('div', {
    staticClass: "btn-dropdown"
  }, [_c('v-btn', {
    staticClass: "btn-purple",
    on: {
      "click": function($event) {
        (_vm.inputDropdown = false)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\tSelect\n\t\t\t\t\t\t\t\t")])], 1)])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.onMobile && _vm.show_selector_view) ? _c('v-btn', {
    staticClass: "update-btn",
    attrs: {
      "round": "",
      "dark": "",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        _vm.saveGenreFilters()
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\tSave\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (!_vm.show_selector_view) ? _c('v-btn', {
    staticClass: "update-btn",
    attrs: {
      "round": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        (_vm.show_selector_view = true)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\tSave\n\t\t\t\t\t")]) : _vm._e()], 1), _vm._v(" "), (_vm.onMobile) ? _c('img', {
    attrs: {
      "src": __webpack_require__(223),
      "width": "18"
    },
    on: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-lg": "",
      "px-0": "",
      "pt-0": ""
    }
  }, [(_vm.show_selector_view) ? _c('v-layout', {
    staticClass: "pgs_area",
    attrs: {
      "row": "",
      "wrap": "",
      "mt-4": ""
    }
  }, _vm._l((_vm.genres), function(parent, index) {
    return _c('v-flex', {
      key: index,
      staticClass: "pgs-wrapper",
      attrs: {
        "xs12": "",
        "sm2": ""
      }
    }, [_c('div', {
      key: parent.id,
      staticClass: "pgs"
    }, [_c('div', {
      class: [_vm.selectedMainGenresIds.includes(parent.id) ? 'pgs-inner-wrapper selected' : 'pgs-inner-wrapper'],
      on: {
        "click": function($event) {
          _vm.selectParentGenre(parent)
        }
      }
    }, [_c('div', {
      staticClass: "pgs-inner"
    }, [_c('div', {
      staticClass: "pgs__title"
    }, [_c('label', [_vm._v(_vm._s(parent.name))])]), _vm._v(" "), _c('div', {
      staticClass: "dflex align-center justify-space-between"
    }, [_c('div', {
      staticClass: "pgs__description"
    }, [_c('span', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.selectParent(parent, index)
        }
      }
    }, [_vm._v(_vm._s(_vm.getSelectedChildrenCount(parent)) + " Subgenres")])]), _vm._v(" "), _c('div', {
      staticClass: "highlight-circle"
    })]), _vm._v(" "), _c('div', {
      staticClass: "pgs__content"
    }, [_c('div', {
      staticClass: "upload-info"
    }, [_c('label', [_vm._v(_vm._s(_vm._f("formatNumberWithComma")(parent.users_size)))]), _vm._v(" "), _c('span', [_vm._v("Albums")])]), _vm._v(" "), (parent.value) ? _c('div', {
      staticClass: "pgs__badge check-o"
    }) : _c('div', {
      staticClass: "pgs__badge check"
    })])]), _vm._v(" "), (_vm.onMobile && parent.value) ? _c('div', {
      staticClass: "_selected"
    }, [_vm._v("\n                Selected\n              ")]) : _vm._e()])])])
  })) : _vm._e(), _vm._v(" "), (_vm.onMobile) ? _c('div', {
    staticClass: "_save-section"
  }, [_c('v-btn', {
    staticClass: "update-btn",
    attrs: {
      "round": "",
      "dark": "",
      "color": "black",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        _vm.saveGenreFilters()
      }
    }
  }, [_vm._v("\n          Save\n        ")])], 1) : _vm._e()], 1), _vm._v(" "), (!_vm.show_selector_view) ? _c('div', {
    staticClass: "genre-container"
  }, [_c('div', {
    staticClass: "pgs-wrapperx"
  }, [_c('div', {
    key: _vm.parent.id,
    staticClass: "pgx"
  }, [_c('div', {
    staticClass: "pgs-inner-wrapper-x"
  }, [_c('div', {
    staticClass: "pgs-inner-x"
  }, [_c('div', {
    staticClass: "pgs__title"
  }, [_vm._v(_vm._s(_vm.parent.name))]), _vm._v(" "), _c('div', {
    staticClass: "pgs__description"
  }, [_vm._v("\n                " + _vm._s(_vm.getSelectedChildrenCount(_vm.parent)) + " of " + _vm._s(_vm.groupChildrenByRegion(_vm.parent)[("" + (_vm.parent.name))].length) + " Subgenres selected\n              ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "genre__content"
  }, [_c('v-layout', {
    key: _vm.parent.id,
    attrs: {
      "row": "",
      "wrap": "",
      "ma-0": ""
    }
  }, [(Object.keys(_vm.groupChildrenByRegion(_vm.parent)).length == 1) ? _vm._l((_vm.parent.children), function(child) {
    return _c('v-flex', {
      key: child.id,
      staticClass: "pgs-wrapper sub-genre-filter",
      attrs: {
        "xs12": "",
        "sm2": ""
      }
    }, [_c('div', {
      staticClass: "settings child-genre mx-auto",
      class: [!_vm.selectedSubgenresIds.includes(child.id) ? 'selected' : '']
    }, [_c('input', {
      staticClass: "d-none",
      attrs: {
        "id": child.id,
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.selectedSubgenresIds.includes(child.id)
      },
      on: {
        "click": function($event) {
          _vm.checkChildGenre(_vm.parent, child)
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": child.id
      }
    }, [_vm._v(_vm._s(child.name))])])])
  }) : [_vm._l((_vm.groupChildrenByRegion(_vm.parent)), function(values, key) {
    return [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('h5', [_vm._v(_vm._s(key))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm12": ""
      }
    }, [_c('p', {
      staticClass: "regular-checkbox settings parent-genre"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.region[((_vm.parent.id) + "-" + key)]),
        expression: "region[`${parent.id}-${key}`]"
      }],
      attrs: {
        "id": ((_vm.parent.id) + "-" + key),
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(_vm.region[((_vm.parent.id) + "-" + key)]) ? _vm._i(_vm.region[((_vm.parent.id) + "-" + key)], null) > -1 : (_vm.region[((_vm.parent.id) + "-" + key)])
      },
      on: {
        "click": function($event) {
          _vm.checkRegionGenre(_vm.parent, key)
        },
        "change": function($event) {
          var $$a = _vm.region[((_vm.parent.id) + "-" + key)],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.region[((_vm.parent.id) + "-" + key)] = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.region[((_vm.parent.id) + "-" + key)] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.$set(_vm.region, ((_vm.parent.id) + "-" + key), $$c)
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": ((_vm.parent.id) + "-" + key)
      }
    }, [_vm._v("Select All")])])]), _vm._v(" "), _vm._l((values), function(child) {
      return _c('v-flex', {
        key: child.id,
        attrs: {
          "xs12": "",
          "sm3": ""
        }
      }, [_c('p', {
        staticClass: "regular-checkbox settings child-genre"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (child.value),
          expression: "child.value"
        }],
        attrs: {
          "id": child.id,
          "type": "checkbox"
        },
        domProps: {
          "checked": Array.isArray(child.value) ? _vm._i(child.value, null) > -1 : (child.value)
        },
        on: {
          "click": function($event) {
            _vm.checkChildGenre(_vm.parent, child)
          },
          "change": function($event) {
            var $$a = child.value,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (child.value = $$a.concat([$$v]))
              } else {
                $$i > -1 && (child.value = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.$set(child, "value", $$c)
            }
          }
        }
      }), _vm._v(" "), _c('label', {
        attrs: {
          "for": child.id
        }
      }, [_vm._v(_vm._s(child.name))])])])
    })]
  })]], 2)], 1)]) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1840 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "album-card"
  }, [_c('v-flex', {
    staticClass: "album-info",
    attrs: {
      "xs12": "",
      "pa-0": ""
    }
  }, [_c('v-flex', {
    staticClass: "album-cover",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "album-image",
    style: ({
      'background-image': 'url(' + _vm.album.cover.url + ')'
    })
  }), _vm._v(" "), _c('v-flex', {
    staticClass: "album-actions",
    attrs: {
      "xs12": ""
    }
  }, [_c('router-link', {
    attrs: {
      "to": ("/" + (_vm.album.album_type) + "/" + (_vm.album.slug))
    }
  }, [_c('v-flex', {
    staticClass: "touch-flex",
    attrs: {
      "xs12": ""
    }
  })], 1), _vm._v(" "), (
    this.$store.state.auth.user.id === _vm.album.user.id &&
    _vm.editButtonAction
  ) ? _c('v-flex', {
    staticClass: "touch-flex",
    attrs: {
      "xs12": ""
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.editButtonAction(_vm.album)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "pt-2": ""
    }
  }, [(_vm.album.collaborators_count === 0) ? [(_vm.deleteButtonAction) ? _c('v-btn', {
    staticClass: "action-btn",
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.deleteButtonAction(_vm.album)
      }
    }
  }, [_vm._v("Delete")]) : _vm._e(), _vm._v(" "), (_vm.publishButtonAction) ? _c('v-btn', {
    staticClass: "action-btn",
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.publishButtonAction(_vm.album)
      }
    }
  }, [_vm._v("Make Public")]) : _vm._e(), _vm._v(" "), (_vm.videoOnlyButtonAction) ? _c('v-btn', {
    staticClass: "action-btn",
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.videoOnlyButtonAction(_vm.album)
      }
    }
  }, [_vm._v("Make Live Video Only")]) : _vm._e(), _vm._v(" "), (_vm.privateButtonAction) ? _c('v-btn', {
    staticClass: "action-btn",
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.privateButtonAction(_vm.album)
      }
    }
  }, [_vm._v("Make Private")]) : _vm._e()] : [(_vm.album.status == 'pending') ? _c('div', {
    staticClass: "collaboration-status"
  }, [(
    _vm.album.user.id === this.$store.state.auth.user.id &&
    _vm.usersCountByStatus.accepted === _vm.album.collaborators_count
  ) ? [_c('div', {
    staticClass: "approve-wrapper"
  }, [_c('div', {
    staticClass: "approved-text"
  }, [_vm._v("\n                    This album has been "), _c('br'), _c('span', [_vm._v("APPROVED")])]), _vm._v(" "), _c('v-btn', {
    staticClass: "action-btn release",
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.releaseButtonAction(_vm.album)
      }
    }
  }, [_vm._v("Release Now")])], 1)] : _c('div', {
    staticClass: "status-overview"
  }, [(_vm.usersCountByStatus.accepted > 0) ? _c('div', [_c('div', {
    staticClass: "accepted-title"
  }, [_vm._v("Accepted")]), _vm._v(" "), _vm._l((_vm.usersByStatus.accepted), function(c) {
    return _c('div', [_vm._v("\n                    " + _vm._s(c.user.username) + "\n                  ")])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.usersCountByStatus.denied > 0) ? _c('div', [_c('div', {
    staticClass: "denied-title"
  }, [_vm._v("Denied")]), _vm._v(" "), _vm._l((_vm.usersByStatus.denied), function(c) {
    return _c('div', [_vm._v("\n                    " + _vm._s(c.user.username) + "\n                  ")])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.usersCountByStatus.pending > 0) ? _c('div', [_c('div', {
    staticClass: "pending-title"
  }, [_vm._v("Waiting for approval")]), _vm._v(" "), _vm._l((_vm.usersByStatus.pending), function(c) {
    return _c('div', [_vm._v("\n                    " + _vm._s(c.user.username) + "\n                  ")])
  })], 2) : _vm._e()]), _vm._v(" "), (_vm.acceptButtonAction) ? _c('div', {
    staticClass: "collaboration-actions"
  }, [_c('v-btn', {
    staticClass: "action-btn accept",
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.acceptButtonAction(_vm.album)
      }
    }
  }, [_vm._v("Accept")]), _vm._v(" "), _c('v-btn', {
    staticClass: "action-btn deny",
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.denyButtonAction(_vm.album)
      }
    }
  }, [_vm._v("Deny")])], 1) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (
    _vm.deleteButtonAction &&
    this.$store.state.auth.user.id === _vm.album.user.id
  ) ? _c('v-btn', {
    staticClass: "action-btn",
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.deleteButtonAction(_vm.album)
      }
    }
  }, [_vm._v("Delete")]) : _vm._e(), _vm._v(" "), (_vm.album.status == 'collaborated') ? _c('div', {
    staticClass: "collaboration-status"
  }, [_c('div', {
    staticClass: "status-overview"
  }, [_c('div', [_c('div', {
    staticClass: "accepted-title"
  }, [_vm._v("Collaborators")]), _vm._v(" "), _vm._l((_vm.usersByStatus.accepted), function(c) {
    return _c('div', [_vm._v("\n                    " + _vm._s(c.user.username) + "\n                  ")])
  })], 2)])]) : _vm._e()]], 2), _vm._v(" "), _c('p', {
    staticClass: "album-count"
  }, [_vm._v(_vm._s(_vm.album.tracks.length) + " tracks")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "album-detail",
    attrs: {
      "xs12": "",
      "pa-0": ""
    }
  }, [_c('router-link', {
    attrs: {
      "to": ("/" + (_vm.album.album_type) + "/" + (_vm.album.slug))
    }
  }, [_c('p', {
    staticClass: "album-name"
  }, [_vm._v(_vm._s(_vm.album.name))])]), _vm._v(" "), _c('p', {
    staticClass: "album-posted-date"
  }, [_vm._v("\n        " + _vm._s(_vm._f("formatDateFromNow")(_vm.album.created_at)) + "\n      ")])], 1)], 1), _vm._v(" "), (_vm.isShowPromoteModal) ? _c('promote-modal', {
    attrs: {
      "item": _vm.album,
      "dismiss": _vm.dismissPromoteDialog,
      "success": _vm.saveAndFinish
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1841 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page chart-page mx-5"
  }, [(!_vm.isComp && !_vm.onMobile) ? _c('discover-nav', {
    attrs: {
      "pageName": "chart",
      "searchShow": this.$store.state.app.sideBarMini
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    staticClass: "chart_flex"
  }, [_c('div', {
    staticClass: "w-70"
  }, [_c('h2', {
    staticClass: "heading-charts"
  }, [_vm._v("\n                    YOUSOUND CHARTS\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "charts_container"
  }, [_c('div', {
    staticClass: "chart_div"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "chart_icon"
  }, [_c('div', {
    staticClass: "_progress"
  }, [_c('RadialProgress')], 1), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "chart_div"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "chart_icon"
  }, [_c('div', {
    staticClass: "_progress"
  }, [_c('RadialProgress')], 1), _vm._v(" "), _vm._m(3)])])])]), _vm._v(" "), _c('div', {
    staticClass: "w-30"
  }, [_c('h2', {
    staticClass: "heading-charts"
  }, [_vm._v("\n                    NOW PLAYING\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "playbox_container"
  }, [_vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "divider my-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "product-actions"
  }, [_c('v-btn', {
    staticClass: "follow-btn",
    attrs: {
      "blue": ""
    }
  }, [_vm._v("\n                            Follow\n                        ")]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "top": ""
    }
  }, [_c('span', {
    staticClass: "__actions pl-0",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('img', {
    staticClass: "cursor-pointer mt-2 filter-invert",
    attrs: {
      "src": __webpack_require__(57),
      "width": "20"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Add to wishlist")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "top": ""
    }
  }, [_c('span', {
    staticClass: "__actions pl-0",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('img', {
    staticClass: "cursor-pointer mt-2",
    attrs: {
      "src": "/static/images/ic_share.svg",
      "width": "20"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Share")])])], 1)])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chart_content"
  }, [_c('div', {
    staticClass: "chart_number"
  }, [_vm._v("1")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "chart_name"
  }, [_vm._v("\n                                    Talk\n                                ")]), _vm._v(" "), _c('div', {
    staticClass: "chart_sub"
  }, [_vm._v("\n                                    Tribe Nohbi\n                                ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_image"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(313),
      "width": "80",
      "height": "80"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chart_content"
  }, [_c('div', {
    staticClass: "chart_number"
  }, [_vm._v("2")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "chart_name"
  }, [_vm._v("\n                                    Talk\n                                ")]), _vm._v(" "), _c('div', {
    staticClass: "chart_sub"
  }, [_vm._v("\n                                    Tribe Nohbi\n                                ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_image"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(313),
      "width": "80",
      "height": "80"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "playbox_image"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(313),
      "width": "100%"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "playbox_content mt-1"
  }, [_c('div', [_c('div', {
    staticClass: "play-head"
  }, [_vm._v("Talk")]), _vm._v(" "), _c('div', {
    staticClass: "play-sub"
  }, [_vm._v("Tribe Nohbi")])]), _vm._v(" "), _c('div', {
    staticClass: "play-number"
  }, [_vm._v("\n                            #2\n                        ")])])
}]}

/***/ }),
/* 1842 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    staticClass: "page album-detail-page",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('canvas', {
    staticClass: "background-image",
    attrs: {
      "id": "canvas"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "background-overlay",
    attrs: {
      "id": "back_image"
    }
  }), _vm._v(" "), (_vm.playlist) ? _c('v-flex', {
    staticClass: "album-pages",
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": ""
    }
  }, [_c('div', {
    staticClass: "album-info-page",
    attrs: {
      "id": "album_info_page"
    }
  }, [_c('div', {
    staticClass: "album-image-section"
  }, [_c('div', {
    staticClass: "album-image playlist",
    style: ({
      'background-image': ("url(" + _vm.album1Cover + "), url(" + _vm.album2Cover + "), url(" + _vm.album3Cover + "), url(" + _vm.album4Cover + ")"),
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "album-hover-section"
  }, [_c('div', {
    staticClass: "play-button-section"
  }, [(!_vm.isPlaying || _vm.$store.state.player.isPaused) ? _c('v-btn', {
    staticClass: "play-button",
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.playSong()
      }
    }
  }, [_c('v-icon', {
    staticClass: "play"
  }, [_vm._v("play_arrow")])], 1) : _vm._e(), _vm._v(" "), (_vm.isPlaying && !_vm.$store.state.player.isPaused) ? _c('v-btn', {
    staticClass: "play-button",
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.pauseSong()
      }
    }
  }, [_c('v-icon', {
    staticClass: "pause"
  }, [_vm._v("pause")])], 1) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "action-section"
  })]), _vm._v(" "), _c('div', {
    staticClass: "album-detail-section"
  }, [_c('div', {
    staticClass: "album-info-section"
  }, [_c('label', {
    staticClass: "album-title"
  }, [_vm._v(_vm._s(_vm.playlist.album_type))]), _vm._v(" "), _c('h4', {
    staticClass: "album-name"
  }, [_vm._v(_vm._s(_vm.playlist.name))]), _vm._v(" "), _c('div', {
    staticClass: "py-2"
  }, [(_vm.currentUser.id == _vm.playlist.user.id) ? _c('v-dialog', {
    staticClass: "album-credits-dialog",
    attrs: {
      "scrollable": "",
      "max-width": "600px"
    },
    model: {
      value: (_vm.playlist_dialog),
      callback: function($$v) {
        _vm.playlist_dialog = $$v
      },
      expression: "playlist_dialog"
    }
  }, [_c('v-btn', {
    staticClass: "text-btn",
    attrs: {
      "slot": "activator",
      "color": "primary",
      "dark": ""
    },
    slot: "activator"
  }, [_vm._v("Edit playlist")]), _vm._v(" "), _c('v-card', {
    staticClass: "album-dialog-body"
  }, [_c('v-card-title', [_vm._v("Edit Playlist")]), _vm._v(" "), _c('v-btn', {
    staticClass: "dialog-close-btn",
    nativeOn: {
      "click": function($event) {
        _vm.playlist_dialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("highlight_off")])], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "create-playlist-section"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "form-group": ""
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Name"), _c('label', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.playlist.name),
      expression: "playlist.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.playlist.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.playlist, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "form-group": "",
      "text-xs-center": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "dark": "",
      "round": "",
      "color": "blue"
    },
    nativeOn: {
      "click": function($event) {
        _vm.updatePlaylist()
      }
    }
  }, [_vm._v("Update Playlist")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "dark": "",
      "round": "",
      "color": "red"
    },
    nativeOn: {
      "click": function($event) {
        _vm.deletePlaylist()
      }
    }
  }, [_vm._v("Delete Playlist")])], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('p', {
    staticClass: "album-detail"
  }, [_vm._v("\n            by\n            "), _c('router-link', {
    staticClass: "album-detail",
    attrs: {
      "to": '/' + _vm.playlist.user.slug
    }
  }, [_vm._v(_vm._s(_vm.playlist.user.username))]), _vm._v("\n            • 2017 – " + _vm._s(_vm.playlist.tracks.length) + " Songs, 40:22\n          ")], 1)]), _vm._v(" "), (_vm.currentUser.id != _vm.playlist.user.id) ? _c('div', {
    staticClass: "album-tracks-section"
  }, _vm._l((_vm.playlist.tracks), function(track, index) {
    return _c('album-track-item', {
      key: index,
      attrs: {
        "album": _vm.playlist,
        "trackIndex": index
      }
    })
  })) : _c('div', {
    staticClass: "album-tracks-section"
  }, [_c('draggable', {
    staticClass: "track-items",
    on: {
      "end": _vm.onEnd
    },
    model: {
      value: (_vm.playlist.tracks),
      callback: function($$v) {
        _vm.$set(_vm.playlist, "tracks", $$v)
      },
      expression: "playlist.tracks"
    }
  }, [_c('transition-group', _vm._l((_vm.playlist.tracks), function(track, index) {
    return _c('album-track-item', {
      key: index,
      attrs: {
        "album": _vm.playlist,
        "trackIndex": index,
        "removeTrack": _vm.removeTrack,
        "showStats": true
      }
    })
  }))], 1)], 1)])]), _vm._v(" "), ( false) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": "",
      "album-comment-page": ""
    }
  }, [_c('h4', {
    staticClass: "comment-title"
  }, [_vm._v("Talk to " + _vm._s(_vm.playlist.user.username))]), _vm._v(" "), _c('label', {
    staticClass: "description"
  }, [_vm._v("Comments are only seen by the artist and people you @mention, unless\n        artist makes your comment public.")]), _vm._v(" "), _c('div', {
    staticClass: "comments-section"
  }, [_c('div', {
    staticClass: "tab-section"
  }, [_c('div', {
    staticClass: "comment-tab"
  }, [_c('label', {
    staticClass: "comment-count"
  }, [_vm._v(_vm._s(_vm.commentsCount) + " Comments")])])]), _vm._v(" "), _c('div', {
    staticClass: "content-section"
  }, [_c('div', {
    staticClass: "add-comment-section"
  }, [_c('img', {
    staticClass: "profile-image",
    attrs: {
      "src": _vm.currentUser.avatar.thumb.url
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.commentString),
      expression: "commentString"
    }],
    ref: "comment",
    staticClass: "comment-input",
    attrs: {
      "type": "text",
      "name": "comment_input",
      "placeholder": "Spark a conversation..."
    },
    domProps: {
      "value": (_vm.commentString)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.addComments()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.commentString = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.showEmojiPicker) ? _c('picker', {
    staticClass: "emoji-picker",
    attrs: {
      "title": "Pick your emoji…",
      "emoji": "point_up"
    },
    on: {
      "click": _vm.addEmoji
    }
  }) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "show-emoji-box-btn",
    class: {
      selected: _vm.showEmojiPicker
    },
    nativeOn: {
      "click": function($event) {
        _vm.showEmojiPicker = !_vm.showEmojiPicker
      }
    }
  }, [_c('v-icon', [_vm._v("tag_faces")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "comment-items"
  }, [_vm._l((_vm.comments), function(comment, index) {
    return _c('div', {
      key: index,
      staticClass: "comment-item"
    }, [_c('div', {
      staticClass: "comment-parent-item"
    }, [_c('profile-item', {
      attrs: {
        "user": comment.user,
        "className": 'comment-user-avatar'
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "comment-content relative"
    }, [_c('router-link', {
      attrs: {
        "to": '/' + comment.user.slug
      }
    }, [_c('label', {
      staticClass: "user-name"
    }, [_vm._v(_vm._s(comment.user.username) + "\n                      "), (comment.user.user_type == 'artist') ? _c('v-icon', {
      staticClass: "user-status online"
    }, [_vm._v("fa-check-circle")]) : _vm._e()], 1)]), _vm._v(" "), _c('p', {
      staticClass: "commnet-text",
      domProps: {
        "innerHTML": _vm._s(_vm.convertedHTML(comment.body))
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "right-section"
    }, [_c('v-menu', {
      staticClass: "comment-more-action",
      attrs: {
        "offset-y": ""
      }
    }, [_c('v-btn', {
      staticClass: "more-btn",
      attrs: {
        "slot": "activator",
        "dark": ""
      },
      slot: "activator"
    }, [_c('v-icon', {
      attrs: {
        "right": ""
      }
    }, [_vm._v("more_horiz")])], 1), _vm._v(" "), _c('v-list', [(
      _vm.currentUser.id == _vm.playlist.user.id &&
      comment.status == 'privated'
    ) ? _c('v-list-tile', {
      key: "public",
      nativeOn: {
        "click": function($event) {
          _vm.makePublicComment(comment)
        }
      }
    }, [_c('v-list-tile-title', {
      staticClass: "default-menu-item"
    }, [_c('i', {
      staticClass: "fa fa-eye"
    }), _vm._v(" "), _c('label', [_vm._v("Make Public")])])], 1) : _vm._e(), _vm._v(" "), (
      _vm.currentUser.id == _vm.playlist.user.id &&
      comment.status == 'published'
    ) ? _c('v-list-tile', {
      key: "private",
      nativeOn: {
        "click": function($event) {
          _vm.makePrivateComment(comment)
        }
      }
    }, [_c('v-list-tile-title', {
      staticClass: "default-menu-item"
    }, [_c('i', {
      staticClass: "fa fa-eye-slash"
    }), _vm._v(" "), _c('label', [_vm._v("Make Private")])])], 1) : _vm._e(), _vm._v(" "), (
      _vm.currentUser.id == _vm.playlist.user.id &&
      _vm.currentUser.id != comment.user.id
    ) ? _c('v-list-tile', {
      key: "block",
      nativeOn: {
        "click": function($event) {
          _vm.blockUser(comment)
        }
      }
    }, [_c('v-list-tile-title', {
      staticClass: "default-menu-item"
    }, [_c('img', {
      staticClass: "track-status-icon",
      attrs: {
        "src": "/static/images/ic_comment_flag.png"
      }
    }), _vm._v(" "), _c('label', [_vm._v("Block User")])])], 1) : _vm._e(), _vm._v(" "), (
      _vm.currentUser.id == _vm.playlist.user.id ||
      _vm.currentUser.id == comment.user.id
    ) ? _c('v-list-tile', {
      key: "delete",
      nativeOn: {
        "click": function($event) {
          _vm.deleteComment(comment)
        }
      }
    }, [_c('v-list-tile-title', {
      staticClass: "default-menu-item"
    }, [_c('img', {
      staticClass: "track-status-icon",
      attrs: {
        "src": "/static/images/ic_comment_delete.png"
      }
    }), _vm._v(" "), _c('label', [_vm._v("Delete Comment")])])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('label', {
      staticClass: "comment-time"
    }, [_vm._v("Now")])], 1)], 1)])
  }), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center"
  }, [(_vm.hasMoreComments) ? _c('v-btn', {
    staticClass: "loadmore-btn",
    nativeOn: {
      "click": function($event) {
        _vm.loadMoreComments()
      }
    }
  }, [_vm._v("More Comments")]) : _vm._e()], 1)], 2)])])]) : _vm._e(), _vm._v(" "), (_vm.currentUser) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": "",
      "album-recent-page": ""
    }
  }, [_c('h4', {
    staticClass: "recent-title"
  }, [_vm._v("\n        " + _vm._s(_vm.playlist.user.username) + "'s recent reposts\n      ")]), _vm._v(" "), _c('v-layout', {
    staticClass: "recent-content",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.playlist.user.recent_items), function(feed, index) {
    return (
      ['Album', 'ShopProduct', 'Stream'].indexOf(feed.assoc_type) > -1
    ) ? _c('div', {
      key: feed.id,
      staticClass: "card-container"
    }, [(feed.assoc_type == 'Album') ? _c('track-card', {
      attrs: {
        "objects": _vm.playlist.user.recent_items,
        "objectIndex": index
      }
    }) : _vm._e(), _vm._v(" "), (feed.assoc_type == 'ShopProduct') ? _c('product-card', {
      attrs: {
        "dataObject": feed
      }
    }) : _vm._e(), _vm._v(" "), (feed.assoc_type == 'Stream') ? _c('video-card', {
      attrs: {
        "dataObject": feed
      }
    }) : _vm._e()], 1) : _vm._e()
  }))], 1) : _vm._e(), _vm._v(" "), (_vm.showDownloadModal) ? _c('download-modal', {
    attrs: {
      "item": _vm.playlist,
      "dismiss": _vm.dismissDownloadModal
    }
  }) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1843 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "plan px-4"
  }, [_c('div', {
    staticClass: "display-flex align-center justify-space-between pt-5 pb-4"
  }, [_vm._m(0), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(117),
      "width": "27"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'CommunityMobile'
        })
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "title font-weight-500 text-white my-4"
  }, [_vm._v("Choose plan")]), _vm._v(" "), _c('div', {
    staticClass: "horizontal-scroll mb-5"
  }, _vm._l((4), function(i) {
    return _c('div', {
      key: i,
      staticClass: "horizontal-scroll__item mr-2 mb-2 plan__item"
    }, [_c('div', {
      staticClass: "font-24 font-weight-500 text-white"
    }, [_vm._v("Loud Pack")]), _vm._v(" "), _vm._m(1, true), _vm._v(" "), _c('div', {
      staticClass: "text-poppins-14 text-white my-3"
    }, [_vm._v("\n        Exclusive drops from all my homies!\n      ")]), _vm._v(" "), _c('div', {
      staticClass: "text-poppins-4 text-white mb-2"
    }, [_vm._v("\n        Plan features 4 creators\n      ")]), _vm._v(" "), _vm._l((3), function(i) {
      return _c('div', {
        key: 3,
        staticClass: "display-flex align-center gap-8 plan__item__user"
      }, [_c('img', {
        attrs: {
          "src": __webpack_require__(30),
          "width": "44"
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "text-poppins-15 text-white"
      }, [_vm._v("@salva")])])
    }), _vm._v(" "), _c('v-btn', {
      staticClass: "btn-detail mx-0 text-white font-weight-500 full-width bg-black",
      on: {
        "click": function($event) {
          _vm.$router.push({
            name: 'PlanDetailMobile'
          })
        }
      }
    }, [_vm._v("\n        Details\n      ")])], 2)
  }))])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "display-flex align-center gap-8"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(30),
      "width": "60"
    }
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "text-poppins-16 text-white"
  }, [_vm._v("SALVA")]), _vm._v(" "), _c('div', {
    staticClass: "text-poppins-12"
  }, [_vm._v("ARTIST")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "font-20 font-weight-500 text-white"
  }, [_vm._v("20$/")]), _vm._v(" "), _c('span', {
    staticClass: "text-poppins-14 text-white"
  }, [_vm._v("month")])])
}]}

/***/ }),
/* 1844 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.currentUser.stripe_connected) ? _c('v-toolbar', {
    attrs: {
      "fixed": "",
      "app": "",
      "flat": "",
      "color": "white"
    }
  }, [_c('div', {
    staticClass: "top-bar"
  }, [_c('div', {
    staticClass: "top-bar-notification"
  }, [(_vm.content) ? _c('span', {
    staticClass: "top-bar__content"
  }, [_vm._v(_vm._s(_vm.content))]) : _vm._e(), _vm._v(" "), (_vm.cta) ? _c('v-btn', {
    staticClass: "top-bar__cta",
    attrs: {
      "to": _vm.cta,
      "outline": "",
      "dark": ""
    }
  }, [_vm._v(_vm._s(_vm.ctaTitle))]) : _vm._e()], 1)])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1845 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "repost-banner"
  }, [_c('div', {
    staticClass: "dflex gap-25 align-center justify-space-between"
  }, [_c('div', {
    staticClass: "repost-content"
  }, [_c('div', {
    staticClass: "dflex align-center mb-4"
  }, [_c('img', {
    attrs: {
      "src": _vm.Icon,
      "width": "25",
      "height": "25"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "repost-head"
  }, [_vm._v(_vm._s(_vm.MainHeading) + " ")])]), _vm._v(" "), _c('p', {
    staticClass: "repost-text"
  }, [_vm._v(_vm._s(_vm.MainText))])]), _vm._v(" "), _c('div', {
    staticClass: "repost-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.MainImage,
      "width": "100%"
    }
  })])]), _vm._v(" "), _c('router-link', {
    staticClass: "repost-banner-back",
    attrs: {
      "to": "/upload"
    }
  }, [_vm._v("\n            < Back\n        ")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1846 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page cart-page cart-checkout-page mx-5 margin-top-header"
  }, [_c('content-top-header', [_c('template', {
    slot: "topHeader"
  }, [_c('ul', {
    staticClass: "mx-0"
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('li', {
      key: tab.id,
      staticClass: "nav-li",
      class: [{
        active: _vm.isActiveTab(tab.id)
      }, ("nav-" + (tab.id))],
      attrs: {
        "href": ("#" + (tab.id))
      }
    }, [_c('label', {
      staticClass: "nav-label",
      on: {
        "click": function($event) {
          _vm.onTab(tab.id)
        }
      }
    }, [(tab.icon) ? _c('img', {
      staticClass: "li-icon",
      attrs: {
        "src": tab.icon,
        "width": "18"
      }
    }) : _vm._e(), _vm._v("\n            " + _vm._s(tab.title) + "\n          ")])])
  }))])], 2), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": "",
      "px-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm9": "",
      "order-section": ""
    }
  }, _vm._l((_vm.cartItems), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "order-item"
    }, [_c('div', {
      staticClass: "order-content-section pa-0",
      attrs: {
        "sm12": ""
      }
    }, [_c('div', {
      staticClass: "product-cover-image"
    }, [_c('activity-product-card', {
      attrs: {
        "object": item.product,
        "price-show": false
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "product-content"
    }, [_c('div', {
      staticClass: "product-content-row"
    }, [_c('div', {
      staticClass: "product-name"
    }, [_vm._v("\n                    " + _vm._s(item.product.name) + " |\n                    " + _vm._s(item.product_variant.name) + "\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "product-content-row justify-space-between pt-2"
    }, [_c('div', [_vm._v("\n                      By\n                      "), _c('router-link', {
      staticClass: "user-name",
      attrs: {
        "to": ("/" + (item.product.merchant.slug)),
        "href": "#"
      }
    }, [_vm._v(_vm._s(item.product.merchant.username))])], 1)]), _vm._v(" "), _c('label', {
      staticClass: "product-price"
    }, [_vm._v("\n                    $" + _vm._s(_vm._f("formatNumber")(item.price)) + "\n                  ")])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
      staticClass: "product-action-row justify-space-between"
    }, [_c('div', {
      staticClass: "product-status",
      class: _vm.productStatusStyle(item)
    }, [_vm._v("\n                    " + _vm._s(_vm.productStatusText(item)) + "\n                  ")]), _vm._v(" "), (!_vm.isDigitalProduct(item)) ? _c('div', [_c('v-btn', {
      staticClass: "product-count-adjust-btn active",
      nativeOn: {
        "click": function($event) {
          _vm.addQuantity(item)
        }
      }
    }, [_c('v-icon', [_vm._v("add")])], 1), _vm._v(" "), _c('label', {
      staticClass: "product-count"
    }, [_vm._v(_vm._s(item.quantity))]), _vm._v(" "), _c('v-btn', {
      staticClass: "product-count-adjust-btn",
      class: {
        active: item.quantity > 1
      },
      attrs: {
        "disabled": item.quantity <= 1
      },
      nativeOn: {
        "click": function($event) {
          _vm.removeQuantity(item)
        }
      }
    }, [_c('v-icon', [_vm._v("remove")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('a', {
      staticClass: "message-buyer-btn",
      on: {
        "click": function($event) {
          if ($event.target !== $event.currentTarget) { return null; }
          _vm.removeCartItem(item)
        }
      }
    }, [_vm._v("Remove")])])], 1)])])
  })), _vm._v(" "), _c('v-flex', {
    staticClass: "orders-section-container",
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, [_c('div', {
    staticClass: "shipping-address-section"
  }, [_c('div', {
    staticClass: "\n                d-flex\n                justify-space-between\n                shipping-action-header\n              "
  }, [_c('div', {
    staticClass: "header-title app-bold flex-none"
  }, [_vm._v("\n                Default Shipping Address\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "stripped-shipping-address"
  }, _vm._l((_vm.strippedAddress), function(line, i) {
    return _c('div', {
      key: i
    }, [_vm._v("\n                " + _vm._s(line) + "\n              ")])
  })), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "edit-address-dialog"
    },
    model: {
      value: (_vm.editDialog),
      callback: function($$v) {
        _vm.editDialog = $$v
      },
      expression: "editDialog"
    }
  }, [_c('address-tab')], 1)], 1), _vm._v(" "), _c('router-link', {
    staticClass: "update-shipping-address",
    attrs: {
      "to": "/settings#shipping-address"
    }
  }, [_c('v-icon', {
    staticClass: "settings-icon"
  }, [_vm._v("settings")]), _vm._v("\n            Update Shipping Address\n          ")], 1), _vm._v(" "), _c('div', {
    staticClass: "orders-status-section"
  }, [_c('div', {
    staticClass: "status-row"
  }, [_c('label', {
    staticClass: "status-title"
  }, [_vm._v("Subtotal")]), _vm._v(" "), _c('label', {
    staticClass: "status-title value"
  }, [_vm._v("\n                $" + _vm._s(_vm._f("formatNumber")(_vm.cartCost.subtotal_cost)) + "\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "status-row"
  }, [_c('label', {
    staticClass: "status-title"
  }, [_vm._v("Shipping")]), _vm._v(" "), _c('label', {
    staticClass: "status-title value"
  }, [_vm._v("\n                $" + _vm._s(_vm._f("formatNumber")(_vm.cartCost.shipping_cost)) + "\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "status-row"
  }, [_c('label', {
    staticClass: "status-title"
  }, [_vm._v("Sales Tax")]), _vm._v(" "), _c('label', {
    staticClass: "status-title value"
  }, [_vm._v("$" + _vm._s(_vm._f("formatNumber")(_vm.cartCost.tax_cost)))])]), _vm._v(" "), _c('div', {
    staticClass: "status-row"
  }, [_c('label', {
    staticClass: "status-title"
  }, [_vm._v("Stripe Fee")]), _vm._v(" "), _c('label', {
    staticClass: "status-title value"
  }, [_vm._v("$" + _vm._s(_vm._f("formatNumber")(_vm.cartCost.fee_cost)))])]), _vm._v(" "), _c('div', {
    staticClass: "total-row"
  }, [_c('label', {
    staticClass: "status-title"
  }, [_vm._v("Total")]), _vm._v(" "), _c('label', {
    staticClass: "status-title value"
  }, [_vm._v("$" + _vm._s(_vm._f("formatNumber")((_vm.cartCost.total_cost + _vm.cartCost.fee_cost))))])]), _vm._v(" "), _c('div', {
    staticClass: "action-row"
  }, [_c('v-btn', {
    staticClass: "place-order-btn",
    attrs: {
      "disabled": !_vm.canOrder
    },
    nativeOn: {
      "click": function($event) {
        _vm.openPaymentDialog()
      }
    }
  }, [_vm._v("Place Order")])], 1)])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "edit-address-dialog"
    },
    model: {
      value: (_vm.editDialog),
      callback: function($$v) {
        _vm.editDialog = $$v
      },
      expression: "editDialog"
    }
  }, [_c('address-tab')], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "my-dialog-1"
    },
    model: {
      value: (_vm.show_order_complete_dialog),
      callback: function($$v) {
        _vm.show_order_complete_dialog = $$v
      },
      expression: "show_order_complete_dialog"
    }
  }, [_c('div', {
    staticClass: "payment-success payment-ready"
  }, [_c('div', {
    staticClass: "dflex align-center my-4"
  }, [_c('div', {
    staticClass: "success-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(119),
      "width": "100%"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "result-text"
  }, [_c('div', {
    staticClass: "big"
  }, [_vm._v("Thank you!")]), _vm._v(" "), _c('div', [_vm._v("Your order was successful")])])]), _vm._v(" "), _c('div', {
    staticClass: "post"
  }, [_vm._v("\n        We sent an email confirmation to: "), _c('br'), _vm._v(" "), _c('strong', [_vm._v(" email@email.com ")])]), _vm._v(" "), _c('div', {
    staticClass: "second-head mt-4"
  }, [_vm._v("\n        Buyer protection\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "divider mt-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "post mt-2"
  }, [_vm._v("\n        Sellers have "), _c('b', [_vm._v("21 days")]), _vm._v(" to ship your items or your order is automatically refunded.\n      ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-5 pay_btn",
    attrs: {
      "depressed": "",
      "round": "",
      "block": ""
    }
  }, [_vm._v("View order details")])], 1)]), _vm._v(" "), (_vm.showPaymentModal) ? _c('payment-modal', {
    attrs: {
      "receivers": _vm.merchants,
      "amount": _vm.cartCost.total_cost,
      "dismiss": _vm.closePaymentDialog,
      "finish": _vm.orderItems
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1847 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mobile-search",
    class: {
      searchDone: _vm.searchDone,
      searchSuccessful: _vm.searchSuccessful,
      searchFailed: _vm.searchFailed
    }
  }, [(!_vm.searchDone) ? _c('span', [_c('div', {
    staticClass: "top-section"
  }, [_c('h1', {
    staticClass: "_title"
  }, [_vm._v("Search")]), _vm._v(" "), _c('v-icon', {
    on: {
      "click": _vm.closeSearchModal
    }
  }, [_vm._v("keyboard_arrow_down")])], 1), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.searchDone) ? _c('span', [_c('div', {
    staticClass: "_top dflex top-section"
  }, [_c('img', {
    staticClass: "_left-icon",
    attrs: {
      "src": __webpack_require__(766),
      "width": "24"
    },
    on: {
      "click": _vm.resetSearch
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "logo-wrapper"
  }, [_c('img', {
    staticClass: "_logo",
    attrs: {
      "src": __webpack_require__(44),
      "width": "130"
    }
  })]), _vm._v(" "), _c('v-icon', {
    staticClass: "min-icon",
    on: {
      "click": function($event) {
        _vm.closeSearchModal()
      }
    }
  }, [_vm._v("\n        keyboard_arrow_down\n      ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "subsection"
  }, [(_vm.searchSuccessful) ? _c('div', {
    staticClass: "result-for"
  }, [_vm._v("Search result for:")]) : _vm._e(), _vm._v(" "), (_vm.searchFailed) ? _c('div', {
    staticClass: "result-for"
  }, [_vm._v("No search result for:")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "keyword"
  }, [_vm._v(_vm._s(_vm.searchQuery))])])]) : _vm._e(), _vm._v(" "), (_vm.searchSuccessful) ? _c('div', {
    staticClass: "results"
  }, [_c('div', {
    staticClass: "_label"
  }, [_c('div', {
    staticClass: "label-title"
  }, [_vm._v("People")]), _vm._v(" "), _c('div', {
    staticClass: "label-count"
  }, [_vm._v(_vm._s(_vm.usersResults.length) + " results")])]), _vm._v(" "), _c('div', {
    staticClass: "each_result user-results"
  }, _vm._l((_vm.usersResults), function(result, index) {
    return _c('div', {
      key: index,
      staticClass: "search-result user-result"
    }, [_c('user-tag', {
      attrs: {
        "user": result,
        "width": "40",
        "height": "40",
        "showAvatar": "",
        "showUserType": ""
      }
    }), _vm._v(" "), _c('user-follow-btn', {
      attrs: {
        "user": result,
        "theme": "dark"
      }
    })], 1)
  })), _vm._v(" "), _c('div', {
    staticClass: "each_result album-results"
  }, [_c('div', {
    staticClass: "_label"
  }, [_c('div', {
    staticClass: "label-title"
  }, [_vm._v("Music")]), _vm._v(" "), _c('div', {
    staticClass: "label-count"
  }, [_vm._v(_vm._s(_vm.albumResults.length) + " results")])]), _vm._v(" "), _vm._l((_vm.albumResults), function(result, index) {
    return _c('div', {
      key: index,
      staticClass: "search-result album-result"
    }, [_c('trackcardsimple', {
      attrs: {
        "item": result,
        "cover": result.cover.thumb.url,
        "title": result.name,
        "subtitle": result.user.username
      }
    })], 1)
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "each_result video-results"
  }, [_c('div', {
    staticClass: "_label"
  }, [_c('div', {
    staticClass: "label-title"
  }, [_vm._v("Videos")]), _vm._v(" "), _c('div', {
    staticClass: "label-count"
  }, [_vm._v(_vm._s(_vm.videoResults.length) + " results")])]), _vm._v(" "), _vm._l((_vm.videoResults), function(result, index) {
    return _c('div', {
      key: index,
      staticClass: "search-result video-result"
    }, [_c('video-box', {
      attrs: {
        "hoverOverlay": "",
        "item": result,
        "sideTabView": "",
        "hideUser": "",
        "noMeta": "",
        "showUsername": ""
      }
    })], 1)
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "each_result product-results"
  }, [_c('div', {
    staticClass: "_label"
  }, [_c('div', {
    staticClass: "label-title"
  }, [_vm._v("Products")]), _vm._v(" "), _c('div', {
    staticClass: "label-count"
  }, [_vm._v(_vm._s(_vm.productResults.length) + " results")])]), _vm._v(" "), _vm._l((_vm.productResults), function(result, index) {
    return _c('div', {
      key: index,
      staticClass: "search-result product-result"
    }, [_c('product-card', {
      attrs: {
        "dataObject": result,
        "sideTabView": "",
        "noMeta": "",
        "altMeta": ""
      }
    })], 1)
  })], 2)]) : _vm._e(), _vm._v(" "), (!_vm.searchDone) ? _c('div', {
    staticClass: "body-section"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    attrs: {
      "type": "search",
      "id": "searchModalInput",
      "placeholder": "Start typing..",
      "disabled": _vm.isSearchLoading
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.initSearch()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "search-loader transparent",
    attrs: {
      "ripple": false,
      "depressed": "",
      "disabled": "",
      "loading": _vm.isSearchLoading
    }
  })], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "subsection"
  }, [_c('div', {
    staticClass: "_subtitle"
  }, [_vm._v("Music, videos, products & people")])])
}]}

/***/ }),
/* 1848 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "remain-main"
  }, [_c('div', {
    staticClass: "modal-inner"
  }, [_c('div', {
    staticClass: "text-center _title"
  }, [_vm._v("Get verified")]), _vm._v(" "), _c('hr', {
    staticClass: "margin-vertical"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "modal-days"
  }, [_vm._v("\n\t\t\t " + _vm._s(_vm.daysRemaining) + " Days\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "close-button",
    on: {
      "click": function($event) {
        _vm.hideModal()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(80),
      "width": "11"
    }
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-flex mt-4"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1555),
      "width": "32"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "margin-vertical text-center"
  }, [_c('p', {
    staticClass: "mb-1"
  }, [_vm._v("Your account was reviewed & denied.")]), _vm._v(" "), _c('p', [_vm._v("You can re-apply in:")])])
}]}

/***/ }),
/* 1849 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "merch-section single-product-page",
    attrs: {
      "xs12": "",
      "sm12": "",
      "id": "carousel-view"
    }
  }, [_c('v-layout', {
    staticClass: "dismiss-section",
    attrs: {
      "row": "",
      "wrap": ""
    },
    on: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-section pl-4",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-container', {
    staticClass: "ml-0",
    attrs: {
      "grid-list-lg": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-start": ""
    }
  }, [_c('v-flex', {
    staticClass: "wrapFlex product-covers",
    attrs: {
      "xs12": "",
      "sm7": ""
    }
  }, [_c('div', {
    staticClass: "product-container"
  }, [_c('div', {
    staticClass: "product-side-thumbnails"
  }, _vm._l((_vm.covers), function(img, i) {
    return _c('div', {
      key: i,
      staticClass: "product-thumbnail",
      class: img === _vm.selectedCover ? 'selected' : '',
      on: {
        "click": function($event) {
          _vm.changeFeaturedImage(img)
        }
      }
    }, [_c('div', {
      staticClass: "product-covers",
      style: ({
        'background-image': ("url(" + img + ")"),
      })
    })])
  })), _vm._v(" "), _c('div', {
    staticClass: "product-cover-selected"
  }, [_c('div', {
    staticClass: "__selected",
    style: ({
      'background-image': ("url(" + _vm.selectedCover + ")"),
    })
  })])])]), _vm._v(" "), (_vm.item) ? _c('v-flex', {
    staticClass: "product-details",
    attrs: {
      "xs12": "",
      "sm5": ""
    }
  }, [_c('div', {
    staticClass: "product-section px-5"
  }, [_c('div', {
    staticClass: "product-category"
  }, [_vm._v(_vm._s(_vm.productCategoryName))]), _vm._v(" "), _c('div', {
    staticClass: "product-name"
  }, [_vm._v(_vm._s(_vm.item.name))]), _vm._v(" "), _c('div', {
    staticClass: "product-merchant"
  }, [_c('user-tag', {
    staticClass: "tag",
    attrs: {
      "showAvatar": "",
      "user": _vm.item.merchant
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "product-price"
  }, [_vm._v("$" + _vm._s(_vm._f("formatNumber")(_vm.item.price * 100)))]), _vm._v(" "), _c('div', {
    staticClass: "product-actions"
  }, [_c('v-tooltip', {
    attrs: {
      "top": ""
    }
  }, [_c('span', {
    staticClass: "__actions pl-0",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('img', {
    staticClass: "cursor-pointer mt-3",
    attrs: {
      "src": "/static/images/ic_share.svg",
      "width": "20"
    },
    on: {
      "click": function($event) {
        _vm.share_dialog = true
      }
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Share")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "top": ""
    }
  }, [_c('span', {
    staticClass: "__actions",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('img', {
    staticClass: "cursor-pointer mt-3",
    attrs: {
      "src": "/static/images/ic_repost.svg",
      "width": "20"
    },
    on: {
      "click": _vm.repostProduct
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Repost")])]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('router-link', {
    staticClass: "black--text",
    attrs: {
      "to": {
        name: 'SingleProduct',
        params: {
          id: _vm.item.id
        }
      }
    }
  }, [_c('b', [_vm._v("View product page")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "product-description"
  }, [_vm._v("\n              " + _vm._s(_vm.item.description) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "product-options"
  }, [_c('div', {
    staticClass: "__title"
  }, [_vm._v("Select Option")]), _vm._v(" "), _c('v-select', {
    staticClass: "large",
    attrs: {
      "items": _vm.options,
      "item-text": "name",
      "placeholder": "Select option",
      "item-value": "id",
      "single-line": "",
      "bottom": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.option),
      callback: function($$v) {
        _vm.option = $$v
      },
      expression: "option"
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "product-addTobag",
    attrs: {
      "round": "",
      "block": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.item.stock > 0 ? _vm.addToCart() : ''
      }
    }
  }, [(_vm.item.stock > -1) ? _c('span', [_vm._v("Add to Bag")]) : _c('span', [_vm._v("Out of Stock")])])], 1)]) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1850 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "404 not-found text-center"
  }, [_c('h2', {
    staticClass: "_title"
  }, [_vm._v("404")]), _vm._v(" "), _c('h3', {
    staticClass: "_subtitle"
  }, [_vm._v("No page found")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(1546),
      "width": "40%",
      "alt": "turntable vinyle gif"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "back-action"
  }, [_c('img', {
    staticClass: "mr-2",
    attrs: {
      "src": __webpack_require__(1441),
      "width": "28",
      "alt": "arrow back"
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "black--text",
    attrs: {
      "to": "/dashboard"
    }
  }, [_vm._v("Back To Yousound")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1851 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "message space",
    class: _vm.isOwn ? 'self' : 'other'
  }, [_c('div', {
    staticClass: "messaged-time"
  }, [_vm._v(_vm._s(_vm.toLocalDateString(_vm.message.created_at)))]), _vm._v(" "), (_vm.message.attachment) ? [_c('div', {
    staticClass: "message-section"
  }, [_c('router-link', {
    attrs: {
      "to": ("/" + (_vm.message.sender.slug))
    }
  }, [_c('div', {
    staticClass: "user-avatar-image",
    style: ({
      'background-image': 'url(' + _vm.message.sender.avatar.thumb.url + ')',
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "messaged-time"
  }, [_vm._v("\n        " + _vm._s(_vm.timePeriodFormat(new Date(_vm.message.created_at))) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "message-content text"
  }, [_c('label', {
    staticClass: "text-message",
    domProps: {
      "innerHTML": _vm._s(_vm.message.body)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "message-section"
  }, [_c('router-link', {
    attrs: {
      "to": ("/" + (_vm.message.sender.slug))
    }
  }, [_c('div', {
    staticClass: "user-avatar-image",
    style: ({
      'background-image': 'url(' + _vm.message.sender.avatar.thumb.url + ')',
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "messaged-time"
  }, [_vm._v("\n        " + _vm._s(_vm.timePeriodFormat(new Date(_vm.message.created_at))) + "\n      ")]), _vm._v(" "), (_vm.message.attachment.attachment_type == 'repost') ? [_c('div', {
    staticClass: "message-content text request no-top-corner"
  }, [_c('div', [_c('div', {
    staticClass: "repost-status-section"
  }, [(
    _vm.message.sender.id == _vm.currentUser.id &&
    _vm.message.attachment.status == 'pending'
  ) ? _c('v-icon', {
    staticClass: "icon-close",
    on: {
      "click": function($event) {
        _vm.removeRepostRequest(_vm.message)
      }
    }
  }, [_vm._v("close")]) : _vm._e(), _vm._v(" "), (
    _vm.message.sender.id == _vm.currentUser.id ||
    _vm.message.attachment.status != 'pending'
  ) ? _c('div', [_c('label', {
    staticClass: "status-title"
  }, [_vm._v("Repost request: ")]), _vm._v(" "), _c('span', {
    class: _vm.message.attachment.status
  }, [_vm._v(_vm._s(_vm.message.attachment.status))])]) : _c('div', [_c('label', {
    staticClass: "status-title"
  }, [_vm._v("Repost request: ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "btn--accept",
    nativeOn: {
      "click": function($event) {
        _vm.acceptRepostRequest(_vm.message)
      }
    }
  }, [_vm._v("Accept")]), _vm._v(" "), _c('v-btn', {
    staticClass: "btn--deny",
    nativeOn: {
      "click": function($event) {
        _vm.denyRepostRequest(_vm.message)
      }
    }
  }, [_vm._v("Deny")]), _vm._v(" "), _c('v-btn', {
    staticClass: "btn--free",
    nativeOn: {
      "click": function($event) {
        _vm.acceptRepostRequestOnFree(_vm.message)
      }
    }
  }, [_vm._v("Repost free")])], 1)], 1), _vm._v(" "), (_vm.message.attachment.attachable_type == 'Album') ? _c('div', {
    staticClass: "content-section"
  }, [_c('div', {
    staticClass: "repost-item-image"
  }, [_c('activity-album-card', {
    attrs: {
      "object": _vm.message.attachment.assoc
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "info-section"
  }, [_c('label', {
    staticClass: "item-title"
  }, [_vm._v(_vm._s(_vm.message.attachment.assoc.name))]), _vm._v(" "), _c('a', {
    staticClass: "item-user"
  }, [_vm._v(_vm._s(_vm.message.sender.username))])])]) : (_vm.message.attachment.attachable_type == 'ShopProduct') ? _c('div', {
    staticClass: "content-section"
  }, [_c('div', {
    staticClass: "repost-item-image"
  }, [_c('activity-product-card', {
    attrs: {
      "object": _vm.message.attachment.assoc,
      "price-show": false
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "info-section"
  }, [_c('label', {
    staticClass: "item-title"
  }, [_vm._v(_vm._s(_vm.message.attachment.assoc.name))]), _vm._v(" "), _c('a', {
    staticClass: "item-user"
  }, [_vm._v(_vm._s(_vm.message.sender.username))])])]) : _vm._e()])])] : (_vm.message.attachment.attachment_type == 'collaboration') ? [_c('div', {
    staticClass: "message-content text request no-top-corner"
  }, [_c('div', [_c('div', {
    staticClass: "content-section"
  }, [(_vm.message.attachment.attachable_type == 'Album') ? [_c('div', {
    staticClass: "repost-item-image"
  }, [_c('activity-album-card', {
    attrs: {
      "object": _vm.message.attachment.assoc
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "info-section"
  }, [_c('label', {
    staticClass: "item-title"
  }, [_vm._v(_vm._s(_vm.message.attachment.assoc.name))]), _vm._v(" "), _c('a', {
    staticClass: "item-user"
  }, [_vm._v(_vm._s(_vm.message.sender.username))])]), _vm._v(" "), (_vm.message.attachment.assoc.collaborators.length > 0) ? _c('div', {
    staticClass: "artist-list"
  }, _vm._l((_vm.message.attachment.assoc.collaborators), function(c) {
    return _c('div', {
      key: c.id,
      staticClass: "artist"
    }, [_c('span', [_vm._v(_vm._s(c.user.username))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(c.user_role))])])
  })) : _vm._e()] : (
    _vm.message.attachment.attachable_type == 'ShopProduct'
  ) ? [_c('div', {
    staticClass: "repost-item-image"
  }, [_c('activity-product-card', {
    attrs: {
      "object": _vm.message.attachment.assoc,
      "price-show": false
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "info-section"
  }, [_c('label', {
    staticClass: "item-title"
  }, [_vm._v(_vm._s(_vm.message.attachment.assoc.name))]), _vm._v(" "), _c('a', {
    staticClass: "item-user"
  }, [_vm._v(_vm._s(_vm.message.sender.username))])]), _vm._v(" "), (_vm.message.attachment.assoc.collaborators.length > 0) ? _c('div', {
    staticClass: "artist-list"
  }, [_c('div', {
    staticClass: "artist"
  }, [_c('span', [_vm._v(_vm._s(_vm.message.attachment.assoc.merchant.username) + "( Owner\n                      )")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.message.attachment.assoc.creator_share) + " %")])]), _vm._v(" "), _c('div', {
    staticClass: "artist"
  }, [_c('span', [_vm._v("Recoup Cost")]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(_vm._f("formatNumber")(_vm.message.attachment.assoc.creator_recoup_cost)))])]), _vm._v(" "), _vm._l((_vm.message.attachment.assoc.collaborators), function(c) {
    return _c('div', {
      key: c.id,
      staticClass: "artist"
    }, [_c('span', [_vm._v(_vm._s(c.user.username))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(c.user_share) + " %")])])
  })], 2) : _vm._e()] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "repost-status-section label"
  }, [(
    _vm.message.sender.id == _vm.currentUser.id ||
    _vm.message.attachment.status != 'pending'
  ) ? _c('div', [(_vm.message.attachment.attachable_type == 'Album') ? _c('v-btn', {
    attrs: {
      "to": "/albums#pending"
    }
  }, [_vm._v("View & Release")]) : (
    _vm.message.attachment.attachable_type == 'ShopProduct'
  ) ? _c('v-btn', {
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'ManageIndex',
          params: {
            activeInnerFilter: 'products',
            activeInnerTab: 'pending'
          }
        })
      }
    }
  }, [_vm._v("View & Release")]) : _vm._e()], 1) : _c('div', [(_vm.message.attachment.attachable_type == 'Album') ? _c('v-btn', {
    attrs: {
      "to": "/albums#pending"
    }
  }, [_vm._v("View Pending Collaboration")]) : (
    _vm.message.attachment.attachable_type == 'ShopProduct'
  ) ? _c('v-btn', {
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'ManageIndex',
          params: {
            activeInnerFilter: 'products',
            activeInnerTab: 'pending'
          }
        })
      }
    }
  }, [_vm._v("View Pending Collaboration")]) : _vm._e()], 1)])], 2)])])] : (_vm.message.attachment.attachment_type == 'label_user') ? [_c('div', {
    staticClass: "message-content text request no-top-corner"
  }, [_c('div', [_c('div', {
    staticClass: "content-section"
  }, [_c('div', {
    staticClass: "label-message-section"
  }, [_c('div', {
    staticClass: "label-message"
  }, [_vm._v(_vm._s(_vm.message.body))])]), _vm._v(" "), (_vm.message.attachment.attachable_type == 'User') ? [_c('div', {
    staticClass: "repost-item-image avatar",
    style: ({
      'background-image': 'url(' +
        _vm.message.attachment.assoc.avatar.thumb.url +
        ')',
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "info-section"
  }, [_c('label', {
    staticClass: "item-title"
  }, [_vm._v(_vm._s(_vm.message.attachment.assoc.username))])])] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "repost-status-section label"
  }, [(
    _vm.message.sender.id == _vm.currentUser.id ||
    _vm.message.attachment.status != 'pending'
  ) ? _c('div', [_c('span', {
    class: _vm.message.attachment.status
  }, [_vm._v(_vm._s(_vm.message.attachment.status))])]) : _c('div', [_c('v-btn', {
    staticClass: "btn--accept",
    nativeOn: {
      "click": function($event) {
        _vm.acceptLabelUser(_vm.message)
      }
    }
  }, [_vm._v("Accept")]), _vm._v(" "), _c('v-btn', {
    staticClass: "btn--deny",
    nativeOn: {
      "click": function($event) {
        _vm.denyLabelUser(_vm.message)
      }
    }
  }, [_vm._v("Deny")])], 1)])], 2)]), _vm._v(" "), (false) ? _c('label', {
    staticClass: "text-message"
  }) : _vm._e()])] : (_vm.message.attachment.attachment_type == 'label_album') ? [_c('div', {
    staticClass: "message-content text request no-top-corner"
  }, [_c('div', [_c('div', {
    staticClass: "content-section"
  }, [_c('div', {
    staticClass: "label-message-section"
  }, [_c('div', {
    staticClass: "label-message"
  }, [_vm._v(_vm._s(_vm.message.body))])]), _vm._v(" "), (_vm.message.attachment.attachable_type == 'Album') ? [_c('div', {
    staticClass: "repost-item-image avatar",
    style: ({
      'background-image': 'url(' + _vm.message.attachment.assoc.cover.url + ')',
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "info-section"
  }, [_c('label', {
    staticClass: "item-title"
  }, [_vm._v(_vm._s(_vm.message.attachment.assoc.name))])])] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "repost-status-section label"
  }, [(
    _vm.message.sender.id == _vm.currentUser.id ||
    _vm.message.attachment.status != 'pending'
  ) ? _c('div', [_c('span', {
    class: _vm.message.attachment.status
  }, [_vm._v(_vm._s(_vm.message.attachment.status))])]) : _c('div', [_c('v-btn', {
    staticClass: "btn--accept",
    nativeOn: {
      "click": function($event) {
        _vm.acceptLabelAlbum(_vm.message)
      }
    }
  }, [_vm._v("Accept")]), _vm._v(" "), _c('v-btn', {
    staticClass: "btn--deny",
    nativeOn: {
      "click": function($event) {
        _vm.denyLabelAlbum(_vm.message)
      }
    }
  }, [_vm._v("Deny")])], 1)])], 2)])])] : (_vm.message.attachment.attachment_type == 'sample_album') ? [_c('div', {
    staticClass: "message-content text request no-top-corner"
  }, [_c('div', [(_vm.message.attachment.attachable_type == 'Album') ? _c('div', {
    staticClass: "content-section"
  }, [_c('div', {
    staticClass: "repost-item-image"
  }, [_c('activity-album-card', {
    attrs: {
      "object": _vm.message.attachment.assoc
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "info-section"
  }, [_c('label', {
    staticClass: "item-title"
  }, [_vm._v(_vm._s(_vm.message.attachment.assoc.name))]), _vm._v(" "), _c('a', {
    staticClass: "item-user"
  }, [_vm._v(_vm._s(_vm.message.sender.username))])])]) : _vm._e()])])] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })], 2)] : [_c('div', {
    staticClass: "message-section"
  }, [_c('router-link', {
    attrs: {
      "to": ("/" + (_vm.message.sender.slug))
    }
  }, [_c('div', {
    staticClass: "user-avatar-image",
    style: ({
      'background-image': 'url(' + _vm.message.sender.avatar.thumb.url + ')',
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "messaged-time"
  }, [_vm._v("\n        " + _vm._s(_vm.timePeriodFormat(new Date(_vm.message.created_at))) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "message-content text"
  }, [_c('label', {
    staticClass: "text-message",
    domProps: {
      "innerHTML": _vm._s(_vm.message.body)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })], 1)]], 2)
},staticRenderFns: []}

/***/ }),
/* 1852 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$store.getters['player/isPlaying']) ? _c('v-layout', {
    staticClass: "bottom-player",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "track-detail-section",
    attrs: {
      "xs12": "",
      "sm4": "",
      "md4": ""
    }
  }, [_c('div', {
    staticClass: "track-cover-container"
  }, [_c('router-link', {
    attrs: {
      "to": ("/" + (_vm.item.album_type) + "/" + (_vm.item.slug))
    }
  }, [(_vm.item.album_type == 'playlist') ? [_c('div', {
    staticClass: "track-cover-image",
    class: _vm.item.album_type,
    style: ({
      'background-image': ("url(" + _vm.album1Cover + "), url(" + _vm.album2Cover + "), url(" + _vm.album3Cover + "), url(" + _vm.album4Cover + ")"),
    })
  })] : [_c('div', {
    staticClass: "track-cover-image",
    style: ({
      'background-image': 'url(' + _vm.item.cover.url + ')'
    })
  })]], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "track-info-container"
  }, [_c('div', [_c('div', {
    staticClass: "track-info"
  }, [_c('label', {
    staticClass: "track-index",
    attrs: {
      "id": "trackIndex"
    }
  }, [_vm._v(_vm._s(_vm.trackIndex))]), _vm._v(" "), _c('label', {
    staticClass: "track-name",
    attrs: {
      "id": "trackName"
    }
  }, [_vm._v(_vm._s(_vm.track.name))])]), _vm._v(" "), _c('div', {
    staticClass: "user-info"
  }, [(_vm.item.collaborators_count > 0) ? [_c('router-link', {
    staticClass: "user-name",
    attrs: {
      "to": '/' + _vm.item.user.slug
    }
  }, [_vm._v(_vm._s(_vm.item.user.username))]), _vm._v(" "), _vm._l((_vm.item.collaborators), function(c) {
    return [_c('span', {
      key: ("span-" + (c.user.id))
    }, [_vm._v(", ")]), _vm._v(" "), _c('router-link', {
      key: ("link-" + (c.user.id)),
      staticClass: "user-name",
      attrs: {
        "to": ("/" + (c.user.slug))
      }
    }, [_vm._v(_vm._s(c.user.username))])]
  })] : (_vm.item.album_type == 'album') ? [_c('router-link', {
    staticClass: "user-name",
    attrs: {
      "to": '/' + _vm.item.user.slug
    }
  }, [_vm._v(_vm._s(_vm.item.user.username))]), _vm._v(" "), (_vm.currentUser && _vm.item.user.id != _vm.currentUser.id) ? _c('user-follow-btn', {
    attrs: {
      "user": _vm.item,
      "theme": "dark",
      "type": "player"
    }
  }) : _vm._e()] : [_c('router-link', {
    staticClass: "user-name",
    attrs: {
      "to": '/' + _vm.track.user.slug
    }
  }, [_vm._v(_vm._s(_vm.track.user.username))]), _vm._v(" "), (_vm.currentUser && _vm.track.user.id != _vm.currentUser.id) ? _c('user-follow-btn', {
    attrs: {
      "user": _vm.track,
      "theme": "dark",
      "type": "player"
    }
  }) : _vm._e()]], 2)])])]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "xs12": "",
      "sm4": "",
      "md4": ""
    }
  }, [(!_vm.isLoaded) ? _c('div', {
    staticClass: "loading",
    attrs: {
      "id": "loading"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isLoaded) ? _c('div', {
    staticClass: "player-section"
  }, [_c('div', {
    staticClass: "controls-section"
  }, [_c('div', {
    staticClass: "volume-container"
  }, [_c('div', {
    staticClass: "volume"
  }, [_c('v-slider', {
    staticClass: "volume-ranger",
    attrs: {
      "thumb-label": "",
      "hide-details": ""
    },
    on: {
      "input": _vm.updateVolume
    },
    model: {
      value: (_vm.volume),
      callback: function($$v) {
        _vm.volume = $$v
      },
      expression: "volume"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/images/ic_sound.svg",
      "width": "20"
    }
  })], 1)]), _vm._v(" "), _c('v-btn', {
    staticClass: "player-control-btn",
    nativeOn: {
      "click": function($event) {
        _vm.skip('prev')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ic_rewind.svg",
      "width": "20"
    }
  })]), _vm._v(" "), (!_vm.isPlaying) ? _c('v-btn', {
    staticClass: "player-control-btn play",
    attrs: {
      "id": "play"
    },
    nativeOn: {
      "click": function($event) {
        _vm.$root.$emit(_vm.MyEvents.AUDIO_PLAYER_REPLAY)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ic_play.svg",
      "height": "26"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isPlaying) ? _c('v-btn', {
    staticClass: "player-control-btn pause",
    attrs: {
      "id": "pause"
    },
    nativeOn: {
      "click": function($event) {
        _vm.pause()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ic_pause.svg",
      "height": "26"
    }
  })]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "player-control-btn",
    nativeOn: {
      "click": function($event) {
        _vm.skip('next')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ic_skip.svg",
      "width": "20"
    }
  })]), _vm._v(" "), _c('v-btn', {
    staticClass: "player-control-btn",
    class: {
      selected: _vm.isRepeated
    },
    nativeOn: {
      "click": function($event) {
        _vm.setRepeated()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ic_refresh.svg",
      "width": "18"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "bar-section"
  }, [_c('label', {
    staticClass: "duration-time played",
    attrs: {
      "id": "playedTime"
    }
  }, [_vm._v(_vm._s(_vm.playedTime))]), _vm._v(" "), _c('v-spacer', [_c('v-slider', {
    staticClass: "player-bar",
    attrs: {
      "hide-details": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.seek(_vm.progress)
      }
    },
    model: {
      value: (_vm.progress),
      callback: function($$v) {
        _vm.progress = $$v
      },
      expression: "progress"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "duration-time total",
    attrs: {
      "id": "totalTime"
    }
  }, [_vm._v(_vm._s(_vm.totalTime))])], 1)]) : _vm._e(), _vm._v(" "), (_vm.showReminder) ? _c('div', {
    staticClass: "reminder-section"
  }, [_c('div', {
    staticClass: "media d-flex"
  }, [_c('div', {
    staticClass: "media__image"
  }), _vm._v(" "), _c('div', {
    staticClass: "media__content"
  }, [_c('div', {
    staticClass: "media__title"
  }, [_vm._v("Reminder!")]), _vm._v(" "), _c('div', {
    staticClass: "media__description"
  }, [_vm._v("\n            Support your favorite artists & brands\n          ")])])])]) : _vm._e()]), _vm._v(" "), _c('v-flex', {
    staticClass: "actions-section",
    attrs: {
      "xs12": "",
      "sm4": "",
      "md4": "",
      "text-xs-right": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "top": ""
    }
  }, [_c('v-btn', {
    staticClass: "action-btn",
    attrs: {
      "slot": "activator"
    },
    nativeOn: {
      "click": function($event) {
        _vm.showShareModal = true
      }
    },
    slot: "activator"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ic_share.svg",
      "width": "20"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Share")])], 1), _vm._v(" "), (_vm.stripeConnected) ? _c('v-tooltip', {
    attrs: {
      "top": ""
    }
  }, [_c('v-btn', {
    staticClass: "action-btn",
    attrs: {
      "slot": "activator"
    },
    nativeOn: {
      "click": function($event) {
        _vm.showDownloadModal = true
      }
    },
    slot: "activator"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ic_download.svg",
      "width": "20"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Download")])], 1) : _vm._e(), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "top": ""
    }
  }, [_c('v-btn', {
    staticClass: "action-btn",
    attrs: {
      "slot": "activator"
    },
    nativeOn: {
      "click": function($event) {
        _vm.repostItem()
      }
    },
    slot: "activator"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ic_repost.svg",
      "width": "20"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Repost")])], 1), _vm._v(" "), (_vm.showDownloadModal) ? _c('download-modal', {
    attrs: {
      "item": _vm.item,
      "track": _vm.track,
      "dismiss": _vm.dismissDownloadDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showShareModal) ? _c('share-modal', {
    attrs: {
      "item": _vm.item,
      "dismiss": _vm.dismissShareDialog
    }
  }) : _vm._e()], 1)], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1853 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mobile-auth-confirm-page"
  }, [_c('mobile-header', {
    attrs: {
      "theme": "light",
      "show-menu": false
    }
  }), _vm._v(" "), (!_vm.loading) ? [(true) ? _c('div', {
    staticClass: "d-flex flex-column",
    staticStyle: {
      "align-items": "center",
      "height": "90vh"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "d-flex flex-column",
    staticStyle: {
      "gap": "20px",
      "align-items": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "110px"
    },
    attrs: {
      "src": "/static/images/lined_check.svg"
    }
  }), _vm._v(" "), _c('div', [_c('center', {
    staticStyle: {
      "font-weight": "800",
      "font-size": "24px"
    }
  }, [_vm._v("\n              Email confirmed!\n            ")]), _vm._v(" "), _c('center', {
    staticStyle: {
      "font-weight": "500",
      "font-size": "20px"
    }
  }, [_vm._v("Your account has been activated")])], 1)])]), _vm._v(" "), _vm._m(1)]) : _c('div', {
    staticClass: "section"
  }, [_c('h3', [_vm._v("Check your email")])])] : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticClass: "logo",
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "src": "/static/images/nav_logo_primary.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-bottom": "-130px"
    }
  }, [_c('button', {
    staticStyle: {
      "background-color": "black",
      "width": "300px",
      "padding": "15px 5px",
      "border-radius": "25px",
      "color": "white",
      "font-size": "18px"
    }
  }, [_c('a', {
    staticStyle: {
      "all": "unset"
    },
    attrs: {
      "href": "ys://login"
    }
  }, [_vm._v("Open App")])])])
}]}

/***/ }),
/* 1854 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "my-overlay"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal"
  }, [_c('h4', {
    staticClass: "modal__title"
  }, [_vm._v("Refund Shopping Items")]), _vm._v(" "), _c('div', {
    staticClass: "modal__header"
  }, [(_vm.items_available) ? _c('v-btn', {
    attrs: {
      "dark": "",
      "color": "red"
    },
    on: {
      "click": function($event) {
        _vm.toggleRefundAll(true)
      }
    }
  }, [_vm._v("Refund All")]) : _c('label', [_vm._v("No items available to refund")])], 1), _vm._v(" "), _c('div', {
    staticClass: "modal__content"
  }, _vm._l((_vm.payment.order.items), function(item, index) {
    return _c('shop-item', {
      key: item.id,
      attrs: {
        "value": _vm.payment.order.items[index]
      },
      on: {
        "input": _vm.changeOrderItem
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "modal__footer"
  }, [(_vm.items_selected) ? _c('v-btn', {
    attrs: {
      "dark": "",
      "color": "blue"
    },
    on: {
      "click": function($event) {
        _vm.$emit('input', _vm.payment)
      }
    }
  }, [_vm._v("Continue")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "dark": "",
      "color": "grey"
    },
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_vm._v("Cancel")])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1855 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    staticClass: "my-header",
    class: {
      fixed: _vm.$store.getters['navigator/isHeaderFixed']
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.currentUser) ? _c('v-flex', {
    attrs: {
      "mx-5": ""
    }
  }, [_c('v-toolbar', {
    staticClass: "header"
  }, [_c('router-link', {
    attrs: {
      "to": "/album"
    }
  }, [_c('v-toolbar-title')], 1), _vm._v(" "), (['video'].indexOf(_vm.currentPage) > -1) ? _c('v-btn', {
    staticClass: "btn-live",
    attrs: {
      "to": "/video#follows"
    }
  }, [_vm._v("Live")]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    class: {
      active: _vm.currentPage === 'album'
    },
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.choosePage('album')
      }
    },
    slot: "activator"
  }, [_c('img', {
    staticClass: "active",
    staticStyle: {
      "margin-top": "3px"
    },
    attrs: {
      "src": "/static/images/ic_music_active.svg",
      "width": "20"
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "margin-top": "3px"
    },
    attrs: {
      "src": "/static/images/ic_music.svg",
      "width": "20"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Album")])], 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    class: {
      active: _vm.currentPage === 'product'
    },
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.choosePage('product')
      }
    },
    slot: "activator"
  }, [_c('img', {
    staticClass: "active",
    staticStyle: {
      "margin-top": "-2px"
    },
    attrs: {
      "src": "/static/images/ic_tag_active.svg",
      "width": "18"
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "margin-top": "-2px"
    },
    attrs: {
      "src": "/static/images/ic_tag.svg",
      "width": "18"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Shop")])], 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    class: {
      active: ['video'].indexOf(_vm.currentPage) > -1
    },
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.choosePage('video')
      }
    },
    slot: "activator"
  }, [_c('img', {
    staticClass: "active",
    attrs: {
      "src": "/static/images/ic_video_active.svg",
      "width": "20"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/images/ic_video.svg",
      "width": "20"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Video")])], 1), _vm._v(" "), _c('v-badge', {
    attrs: {
      "color": "red"
    }
  }, [(_vm.$store.state.activity.badge.stream > 0) ? _c('span', {
    attrs: {
      "slot": "badge"
    },
    slot: "badge"
  }, [_vm._v(_vm._s(_vm.$store.state.activity.badge.stream))]) : _vm._e(), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    class: {
      active: _vm.currentPage === 'feed'
    },
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.choosePage('feed')
      }
    },
    slot: "activator"
  }, [_c('img', {
    staticClass: "active",
    attrs: {
      "src": "/static/images/ic_home_active.svg",
      "width": "20"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/images/ic_home.svg",
      "width": "20"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Feed")])], 1)], 1), _vm._v(" "), _c('v-badge', {
    attrs: {
      "color": "red"
    }
  }, [(_vm.$store.state.activity.badge.activity > 0) ? _c('span', {
    attrs: {
      "slot": "badge"
    },
    slot: "badge"
  }, [_vm._v(_vm._s(_vm.$store.state.activity.badge.activity))]) : _vm._e(), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    class: {
      active: _vm.currentPage === 'activity'
    },
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.choosePage('activity')
      }
    },
    slot: "activator"
  }, [_c('img', {
    staticClass: "active",
    attrs: {
      "src": "/static/images/ic_alarm_active.svg",
      "width": "18"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/images/ic_alarm.svg",
      "width": "18"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Activity")])], 1)], 1), _vm._v(" "), _c('v-badge', {
    attrs: {
      "color": "red"
    }
  }, [(_vm.$store.state.activity.badge.message > 0) ? _c('span', {
    attrs: {
      "slot": "badge"
    },
    slot: "badge"
  }, [_vm._v(_vm._s(_vm.$store.state.activity.badge.message))]) : _vm._e(), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    class: {
      active: _vm.currentPage === 'messages'
    },
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.choosePage('messages')
      }
    },
    slot: "activator"
  }, [_c('img', {
    staticClass: "active",
    attrs: {
      "src": "/static/images/ic_message_active.svg",
      "width": "20"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/images/ic_message.svg",
      "width": "20"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Messages")])], 1)], 1), _vm._v(" "), _c('v-badge', {
    attrs: {
      "color": "red"
    }
  }, [(_vm.$store.state.activity.badge.cart > 0) ? _c('span', {
    attrs: {
      "slot": "badge"
    },
    slot: "badge"
  }, [_vm._v(_vm._s(_vm.$store.state.activity.badge.cart))]) : _vm._e(), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    class: {
      active: _vm.currentPage === 'cart'
    },
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.choosePage('cart')
      }
    },
    slot: "activator"
  }, [_c('img', {
    staticClass: "active",
    attrs: {
      "src": "/static/images/ic_cart_active.svg",
      "width": "20"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/images/ic_cart.svg",
      "width": "20"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Cart")])], 1)], 1), _vm._v(" "), (
    _vm.currentUser && ['artist', 'brand', 'label'].indexOf(_vm.currentUser.user_type) > -1
  ) ? _c('v-badge', {
    attrs: {
      "color": "red"
    }
  }, [(_vm.$store.state.activity.badge.sell > 0) ? _c('span', {
    attrs: {
      "slot": "badge"
    },
    slot: "badge"
  }, [_vm._v(_vm._s(_vm.$store.state.activity.badge.sell))]) : _vm._e(), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    class: {
      active: _vm.currentPage === 'sell'
    },
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.choosePage('sell')
      }
    },
    slot: "activator"
  }, [_c('img', {
    staticClass: "active",
    staticStyle: {
      "margin-top": "2px"
    },
    attrs: {
      "src": "/static/images/ic_delivery_active.svg",
      "width": "20"
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "margin-top": "2px"
    },
    attrs: {
      "src": "/static/images/ic_delivery.svg",
      "width": "20"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Sell")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.currentUser) ? _c('v-menu', {
    staticClass: "profile-menu",
    attrs: {
      "bottom": "",
      "left": "",
      "offset-y": "",
      "nudge-top": -5,
      "nudge-left": 0,
      "content-class": "profile-menu__content"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    slot: "activator"
  }, [(_vm.currentUser) ? _c('div', {
    staticClass: "profile-image",
    style: ({
      'background-image': 'url(' + _vm.currentUser.avatar.thumb.url + ')',
    })
  }) : _vm._e()]), _vm._v(" "), _c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-tile', {
    staticClass: "profile",
    attrs: {
      "avatar": "",
      "to": '/' + _vm.currentUser.slug
    }
  }, [_c('v-list-tile-avatar', [_c('img', {
    attrs: {
      "src": _vm.currentUser.avatar.url
    }
  })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                " + _vm._s(_vm.currentUser.username) + "\n                "), (
    ['artist', 'label', 'brand'].indexOf(
      _vm.currentUser.user_type
    ) > -1
  ) ? _c('v-icon', {
    staticClass: "user-status online"
  }, [_vm._v("fa-check-circle")]) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("View Profile")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (
    !_vm.$store.getters['app/disabledLiveVideo'] &&
    _vm.currentUser.enabled_live_video && ['artist', 'brand', 'label'].indexOf(_vm.currentUser.user_type) > -1
  ) ? _c('v-list-tile', {
    attrs: {
      "to": ("/user/" + (_vm.currentUser.slug) + "/video")
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Live Video")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Broadcast a live stream")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.currentUser.user_type == 'artist' || _vm.currentUser.user_type == 'brand') ? _c('v-list-tile', {
    attrs: {
      "to": "/upload/album"
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Upload")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Upload an album")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.currentUser.user_type == 'artist') ? _c('v-list-tile', {
    key: "manage",
    attrs: {
      "to": "/albums"
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Manage")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Edit your albums")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile', {
    key: "settings",
    attrs: {
      "to": "/settings"
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Settings")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Edit profile, password, bank info")])], 1)], 1), _vm._v(" "), (
    ['listener', 'artist', 'label'].indexOf(_vm.currentUser.user_type) >
    -1
  ) ? _c('v-list-tile', {
    key: "payments",
    attrs: {
      "to": "/payments"
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Payments")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("View transactions, refunds")])], 1)], 1) : _vm._e(), _vm._v(" "), (['admin', 'moderator'].indexOf(_vm.currentUser.user_type) > -1) ? _c('v-list-tile', {
    key: "admin",
    attrs: {
      "to": "/admin"
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Admin")])], 1)], 1) : _vm._e(), _vm._v(" "), (
    ['artist', 'brand', 'label'].indexOf(_vm.currentUser.user_type) > -1
  ) ? _c('v-list-tile', {
    key: "invite",
    on: {
      "click": function($event) {
        _vm.openInviteDialog()
      }
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Invite artist/brand")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Invite your team")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile', {
    key: "support",
    on: {
      "click": _vm.goSupport
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Support")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Help docs")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    key: "signout",
    on: {
      "click": _vm.signOut
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Sign Out")])], 1)], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "search-box"
  }, [_c('div', {
    staticClass: "search-container"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('svg', {
    attrs: {
      "width": "20px",
      "height": "20px",
      "viewBox": "0 0 28 28",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("Group 22")]), _vm._v(" "), _c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Design",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "searchIcon",
      "transform": "translate(-732.000000, -61.000000)",
      "stroke": "#FFFFFF",
      "stroke-width": "1.5999999"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group-29",
      "transform": "translate(710.000000, 50.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group-22",
      "transform": "translate(23.000000, 12.000000)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "Oval-2",
      "cx": "11.375",
      "cy": "11.375",
      "r": "11.375"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M19.5,19.5 L25.59375,25.59375",
      "id": "Line",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])])])])])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    staticClass: "search-field",
    attrs: {
      "type": "search",
      "id": "search",
      "placeholder": "Search artist, song or keyword"
    },
    domProps: {
      "value": (_vm.keyword)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.goToSearch()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value
      }
    }
  })])])], 1) : _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": ""
    }
  }, [_c('v-toolbar', {
    staticClass: "header"
  }, [_c('router-link', {
    attrs: {
      "to": "/album"
    }
  }, [_c('v-toolbar-title')], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "my-0",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.choosePage('login')
      }
    }
  }, [_vm._v("Login")]), _vm._v(" "), _c('v-btn', {
    staticClass: "my-0",
    attrs: {
      "dark": "",
      "round": "",
      "color": "green"
    },
    nativeOn: {
      "click": function($event) {
        _vm.choosePage('register')
      }
    }
  }, [_vm._v("Sign Up")])], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "invite-dialog",
      "width": "440"
    },
    model: {
      value: (_vm.show_invite_dialog),
      callback: function($$v) {
        _vm.show_invite_dialog = $$v
      },
      expression: "show_invite_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Invite Artist/Brand")]), _vm._v(" "), _c('v-card-text', [_vm._v("Link expires in 72 hours and can only be used once")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "dark": "",
      "block": "",
      "color": "black"
    },
    nativeOn: {
      "click": function($event) {
        _vm.createInvitation()
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-3"
  }, [_vm._v("fa-link")]), _vm._v(" Copy Link")], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.link_copied),
      expression: "link_copied"
    }],
    staticClass: "link-copied"
  }, [_vm._v("link has been copied")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1856 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    class: {
      fullWidth: _vm.fullWidth
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-xs": "",
      "px-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "row": ""
    }
  }, [_c('v-flex', {
    class: [("order-md-" + _vm.order1), 'order-1'],
    attrs: {
      "xs12": "",
      "md6": "",
      "order": _vm.order1
    }
  }, [_c('div', {
    staticClass: "text-container dflex justify-center align-center flex-column"
  }, [_c('h3', {
    staticClass: "mb-5"
  }, [_vm._v("\n            " + _vm._s(_vm.title) + " "), _c('br'), _vm._v("\n            " + _vm._s(_vm.title2) + "\n\n            "), (_vm.ctaText) ? _c('span', [_c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "cta_btn",
    attrs: {
      "href": _vm.ctaAction
    }
  }, [_vm._v(_vm._s(_vm.ctaText))])]) : _vm._e()])])]), _vm._v(" "), _c('v-flex', {
    class: [("order-md-" + _vm.order2), 'order-2'],
    attrs: {
      "xs12": "",
      "md6": "",
      "order": _vm.order2
    }
  }, [_c('div', {
    staticClass: "img-container dflex justify-center align-center cover-x-space"
  }, [_c('img', {
    class: {
      fullWidth: _vm.fullWidth,
      bigImage: _vm.bigImage,
      moneyImage: _vm.moneyImage,
    },
    attrs: {
      "src": _vm.imgSrc
    }
  })])])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1857 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page notification-page margin-top-header",
    class: {
      'mx-5': _vm.activeTab == 'activity'
    }
  }, [_c('content-top-header', [_c('template', {
    slot: "topHeader"
  }, [_c('ul', _vm._l((_vm.tabs), function(tab) {
    return _c('li', {
      key: tab.id,
      staticClass: "nav-li",
      class: [{
        'active tab-active': _vm.isActiveTab(tab.id)
      }, ("nav-" + (tab.id))],
      attrs: {
        "href": ("#" + (tab.id))
      }
    }, [(!_vm.onMobile) ? _c('label', {
      staticClass: "nav-label __tabs",
      class: [tab.id],
      on: {
        "click": function($event) {
          _vm.setTab(tab.id)
        }
      }
    }, [_c('span', {
      staticClass: "__tab dflex align-center"
    }, [(tab.icon) ? _c('img', {
      staticClass: "li-icon",
      attrs: {
        "src": tab.icon,
        "width": "18"
      }
    }) : _vm._e(), _vm._v("\n              " + _vm._s(tab.title) + "\n            ")]), _vm._v(" "), (!_vm.isActiveTab(tab.id) && tab.badge > 0) ? _c('span', {
      staticClass: "dot_notifications"
    }, [_c('v-icon', {
      attrs: {
        "size": "1"
      }
    }, [_vm._v("circle")])], 1) : _vm._e()]) : (_vm.onMobile && tab.title != 'SMS') ? _c('label', {
      staticClass: "nav-label __tabs",
      class: [tab.id],
      on: {
        "click": function($event) {
          _vm.setTab(tab.id)
        }
      }
    }, [_c('span', {
      staticClass: "__tab dflex align-center"
    }, [(tab.icon) ? _c('img', {
      staticClass: "li-icon",
      attrs: {
        "src": tab.icon,
        "width": "18"
      }
    }) : _vm._e(), _vm._v("\n              " + _vm._s(tab.title) + "\n            ")]), _vm._v(" "), (!_vm.isActiveTab(tab.id) && tab.badge > 0) ? _c('span', {
      staticClass: "dot_notifications"
    }, [_c('v-icon', {
      attrs: {
        "size": "1"
      }
    }, [_vm._v("circle")])], 1) : _vm._e()]) : _vm._e()])
  }))])], 2), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [(_vm.activeTab === 'activity') ? _c('Activity', {
    attrs: {
      "isComp": ""
    }
  }) : (_vm.activeTab === 'messages') ? _c('Messages', {
    staticClass: "mt-1"
  }) : (_vm.activeTab === 'sms') ? _c('SMS', {
    staticClass: "mt-1"
  }) : (_vm.activeTab === 'paidToShare') ? _c('getPaidToShare') : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1858 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _vm._l((_vm.itemList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "you__menu display-flex justify-space-between align-center my-3",
      on: {
        "click": function () { return item.handle(); }
      }
    }, [_c('div', {
      staticClass: "relative you__menu__icon"
    }, [(item.number > 0) ? _c('div', {
      staticClass: "absolute you__menu__icon--number display-flex justify-center align-center text-dmsans-12"
    }, [_vm._v("\n        " + _vm._s(item.number) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('img', {
      attrs: {
        "src": item.icon
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "you__menu--title"
    }, [_vm._v(_vm._s(item.text))]), _vm._v(" "), _c('div', {
      staticClass: "w-22"
    })])
  }), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }), _vm._v(" "), _c('Footer')], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "relative mb-5"
  }, [_c('div', [_c('img', {
    staticClass: "max-full-width",
    attrs: {
      "src": __webpack_require__(118)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "absolute you__username"
  }, [_c('div', {
    staticClass: "you__username__name"
  }, [_c('span', [_vm._v(" Salva ")]), _vm._v(" "), _c('img', {
    staticClass: "max-full-width",
    attrs: {
      "src": __webpack_require__(315)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "you__username__type"
  }, [_vm._v("ACCOUNT")])])])
}]}

/***/ }),
/* 1859 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "auth-input-page"
  }, [_c('payment-success', {
    ref: "paymentSuccess",
    attrs: {
      "account-category": _vm.accountCategory
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1860 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__header"
  }, [_c('div', {
    staticClass: "box__caption"
  }, [_vm._v("Live")]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm._f("formatDateFromNow")(_vm.item.started_at)))])]), _vm._v(" "), _c('div', {
    staticClass: "box__content"
  }, [_c('div', {
    staticClass: "box__title"
  }, [_vm._v(_vm._s(_vm._.get(_vm.item, "user.username")))]), _vm._v(" "), _c('div', {
    staticClass: "box__subtitle"
  }, [_vm._v(_vm._s(_vm.item.name))]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm._.get(_vm.item, "genre.name")))])]), _vm._v(" "), (_vm.item.view_price > 0) ? _c('div', {
    staticClass: "box__footer"
  }, [_c('v-btn', {
    attrs: {
      "dark": "",
      "block": "",
      "to": ("/" + (_vm._.get(_vm.item, 'user.slug')))
    }
  }, [_vm._v("Watch")])], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1861 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "repost-comp repost-music"
  }, [(_vm.showBanner) ? _c('div', {
    staticClass: "repost-banner"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "repost-banner-close",
    on: {
      "click": function($event) {
        _vm.closeBanner()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(80),
      "width": "15px"
    }
  })])]) : _vm._e(), _vm._v(" "), (!_vm.viewAllPlaylist) ? _c('div', {
    staticClass: "playlists"
  }, [_c('div', {
    staticClass: "title dflex align-center _intro"
  }, [_c('div', [_vm._v(_vm._s(_vm.playlistLen()) + " Playlists")]), _vm._v(" "), _c('div', {
    staticClass: "_action",
    on: {
      "click": function($event) {
        _vm.displayAllPlaylists()
      }
    }
  }, [_vm._v("View All")])]), _vm._v(" "), _c('div', {
    staticClass: "dflex playlist-container"
  }, _vm._l((this.playlists.slice(0, 6).reverse()), function(playlist, index) {
    return _c('div', {
      key: index,
      staticClass: "playlist-holder"
    }, [_c('v-btn', {
      staticClass: "absolute",
      attrs: {
        "dark": ""
      },
      on: {
        "click": function($event) {
          _vm.openDeletePlaylistModal(playlist.id)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "right": ""
      }
    }, [_vm._v("more_horiz")])], 1), _vm._v(" "), _c('div', {
      staticClass: "playlist-box",
      on: {
        "click": function($event) {
          _vm.$router.push({
            path: ("/playlist/" + (playlist.id))
          })
        }
      }
    }, [_c('div', {
      staticClass: "playlist-images"
    }, [_c('ul', _vm._l((_vm.playlistImageList(playlist)), function(playlistImage, index) {
      return _c('li', {
        key: index
      }, [_c('img', {
        attrs: {
          "src": playlistImage,
          "width": "30",
          "alt": "playlist icon"
        }
      })])
    }))]), _vm._v(" "), _c('div', {
      staticClass: "playlist-text"
    }, [_vm._v("\n              " + _vm._s(playlist.name) + "\n            ")])])], 1)
  }))]) : _vm._e(), _vm._v(" "), (!_vm.viewAllPlaylist) ? _c('div', {
    staticClass: "music playlist-music"
  }, [_c('div', {
    staticClass: "title _intro text-capitalize"
  }, [_vm._v(" " + _vm._s(_vm.products.length) + " " + _vm._s(_vm._f("pluralize")("product", _vm.products.length)) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "title dflex align-center justify-space-between _intro"
  }, [_c('div', {
    staticClass: "dflex align-center justify-space-between w-100"
  }, [_c('input', {
    staticClass: "input-track",
    attrs: {
      "type": "text",
      "placeholder": "Search Products"
    }
  }), _vm._v(" "), (_vm.selectProductsMode) ? _c('div', {
    staticClass: "selectAlbumsMode _action"
  }, [_c('v-btn', {
    attrs: {
      "round": "",
      "dark": "",
      "depressed": ""
    },
    on: {
      "click": function($event) {
        _vm.openAddToPlaylist()
      }
    }
  }, [_vm._v(" Add selected to... ")]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        _vm.toggleSelectProductsMode(false)
      }
    }
  }, [_vm._v(" Cancel ")])], 1) : _c('div', [_c('v-btn', {
    staticClass: "dflex align-center _action pointer-cursor font-bold",
    attrs: {
      "round": "",
      "dark": "",
      "depressed": ""
    },
    on: {
      "click": function($event) {
        _vm.toggleSelectProductsMode(true)
      }
    }
  }, [_c('v-icon', [_vm._v("add")]), _vm._v(" "), _c('span', [_vm._v("Select Products")])], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "list-track-view list-track-view-trackCard list-track-view-video listings"
  }, _vm._l((_vm.tempProduct), function(product, index) {
    return _c('div', {
      key: index,
      staticClass: "list-track-view-item listing cursor-none"
    }, [_c('product-card', {
      attrs: {
        "dataObject": product,
        "sideTabView": "",
        "forCollection": "",
        "getCollections": _vm.getCollections,
        "hideOverlay": false,
        "hideOptionCount": "",
        "hideMoreOptions": "",
        "hidePriceOverlay": "",
        "altMeta": "",
        "noMeta": "",
        "altMetaPrice": ""
      }
    }), _vm._v(" "), (_vm.selectProductsMode) ? _c('div', {
      staticClass: "selectMusic"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedProducts),
        expression: "selectedProducts"
      }],
      staticClass: "selectMusic-check",
      attrs: {
        "type": "checkbox",
        "id": ("check-" + index)
      },
      domProps: {
        "value": product,
        "checked": Array.isArray(_vm.selectedProducts) ? _vm._i(_vm.selectedProducts, product) > -1 : (_vm.selectedProducts)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.selectedProducts,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = product,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedProducts = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectedProducts = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedProducts = $$c
          }
        }
      }
    }), _vm._v(" "), (_vm.selectedProducts.includes(product)) ? _c('v-icon', {
      staticClass: "check-icon",
      on: {
        "click": function($event) {
          _vm.removeProduct(product.id)
        }
      }
    }, [_vm._v("\n              check\n            ")]) : _vm._e()], 1) : _vm._e()], 1)
  }))]) : _vm._e(), _vm._v(" "), (_vm.viewAllPlaylist) ? _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-lg": "",
      "px-0": "",
      "py-0": ""
    }
  }, [_c('div', {
    staticClass: "playlists"
  }, [_c('div', {
    staticClass: "title dflex align-center _intro"
  }, [_c('v-btn', {
    staticClass: "back-btn",
    attrs: {
      "ripple": true,
      "fab": "",
      "small": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.back()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ml-4"
  }, [_vm._v(_vm._s(_vm.playlistLen()) + " Playlists")])], 1), _vm._v(" "), _c('div', {
    staticClass: "dflex playlist-container"
  }, _vm._l((this.playlists), function(playlist, index) {
    return _c('div', {
      key: index,
      staticClass: "playlist-holder pr-2",
      on: {
        "click": function($event) {
          _vm.$router.push({
            path: ("/playlist/" + (playlist.id))
          })
        }
      }
    }, [_c('div', {
      staticClass: "playlist-box"
    }, [_c('div', {
      staticClass: "playlist-images"
    }, [_c('ul', _vm._l((_vm.playlistImageList(playlist)), function(playlistImage, index) {
      return _c('li', {
        key: index
      }, [_c('img', {
        attrs: {
          "src": playlistImage,
          "width": "30",
          "alt": "playlist icon"
        }
      })])
    }))]), _vm._v(" "), _c('div', {
      staticClass: "playlist-text"
    }, [_vm._v("\n                " + _vm._s(playlist.name) + "\n              ")])])])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.addToPlaylistActive) ? _c('add-to-playlist', {
    attrs: {
      "playlists": this.playlists,
      "addToPlaylist": _vm.addToPlaylistActive,
      "selectedItems": this.selectedProducts,
      "type": "product"
    },
    on: {
      "closeAddToPlaylist": _vm.closeAddToPlaylist,
      "methodThatForcesUpdate": _vm.methodThatForcesUpdate
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dflex gap-25 align-center justify-space-between"
  }, [_c('div', {
    staticClass: "repost-content"
  }, [_c('div', {
    staticClass: "dflex align-center mb-4"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(308),
      "width": "25"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "repost-head"
  }, [_vm._v("Build your collection")])]), _vm._v(" "), _c('p', {
    staticClass: "repost-text"
  }, [_vm._v("Create playlists or shopping lists for all of the albums, videos & products you discover\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "repost-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(97),
      "width": "100%"
    }
  })])])
}]}

/***/ }),
/* 1862 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "package-card",
    class: _vm.$vuetify.breakpoint.width > 650 ? '' : 'w-100'
  }, [_c('div', [_c('div', {
    staticClass: "title pb-1"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "subtitle pb-4"
  }, [_vm._v(_vm._s(_vm.subtitle))]), _vm._v(" "), _c('div', {
    staticClass: "pb-5"
  }, [_c('span', {
    staticClass: "price"
  }, [_vm._v("$" + _vm._s(_vm.price))]), _vm._v(" "), _c('span', {
    staticClass: "date"
  }, [_vm._v("/month")])]), _vm._v(" "), _vm._l((_vm.optionList), function(item, i) {
    return _c('div', {
      key: i,
      staticClass: "d-flex align-center gap-10 pb-2"
    }, [_vm._m(0, true), _vm._v(" "), _c('span', {
      staticClass: "content"
    }, [_vm._v(_vm._s(item.text))])])
  })], 2), _vm._v(" "), _c('div', [_c('v-btn', {
    staticClass: "package-card-btn",
    attrs: {
      "block": "",
      "text": ""
    }
  }, [_vm._v(" Select ")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "package-card__img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(309)
    }
  })])
}]}

/***/ }),
/* 1863 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "ys-dialog-container",
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-layout', {
    staticClass: "ys-dialog-dismiss",
    attrs: {
      "row": "",
      "wrap": ""
    },
    on: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "ys-dialog ys-product-dialog",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "pr-2": ""
    }
  }, [_c('div', {
    staticClass: "product-cover",
    style: ({
      'background-image': 'url(' + _vm.product.covers[0].cover.url + ')'
    })
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "x12": "",
      "mt-4": "",
      "mb-3": "",
      "py-2": "",
      "border-top": "",
      "border-bottom": ""
    }
  }, [_c('h4', [_vm._v("Product Info")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "x12": "",
      "product-name": ""
    }
  }, [_vm._v("\n        " + _vm._s(_vm.product.name) + "\n      ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "x12": ""
    }
  }, [_c('label', [_vm._v("Product id: "), _c('span', [_vm._v(_vm._s(_vm.product.id))])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "x12": ""
    }
  }, [_c('label', [_vm._v("Upload Date: "), _c('span', [_vm._v(_vm._s(_vm._f("formatDate")(_vm.product.created_at)))])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "x12": ""
    }
  }, [_c('label', [_vm._v("Current Price: "), _c('span', [_vm._v("$" + _vm._s(_vm._f("formatNumber")(_vm.product.price)))])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "x12": "",
      "mt-4": "",
      "mb-3": "",
      "py-2": "",
      "border-top": "",
      "border-bottom": ""
    }
  }, [_c('h4', [_vm._v("Total Sales")])]), _vm._v(" "), _c('v-list', {
    attrs: {
      "subheader": "",
      "two-line": ""
    }
  }, [_c('v-list-tile', {
    key: _vm.user.slug
  }, [_c('v-list-tile-avatar', {
    staticClass: "mr-2"
  }, [_c('img', {
    attrs: {
      "src": _vm.user.avatar.url
    }
  })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
    domProps: {
      "innerHTML": _vm._s(_vm.user.username)
    }
  }), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Uploader")])], 1)], 1), _vm._v(" "), _vm._l((_vm.product.contributors), function(c) {
    return (_vm.product.collaborators && _vm.product.collaborators.length > 0) ? _c('v-list-tile', {
      key: c.user.slug
    }, [_c('v-list-tile-avatar', {
      staticClass: "mr-2"
    }, [_c('img', {
      attrs: {
        "src": c.user.avatar.url
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(c.user.username)
      }
    }), _vm._v(" "), _c('v-list-tile-sub-title', {
      domProps: {
        "innerHTML": _vm._s(c.user_role)
      }
    })], 1)], 1) : _vm._e()
  })], 2)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": "",
      "border-left": ""
    }
  }, [_c('v-tabs', {
    staticClass: "white",
    attrs: {
      "dark": ""
    },
    model: {
      value: (_vm.active_tab),
      callback: function($$v) {
        _vm.active_tab = $$v
      },
      expression: "active_tab"
    }
  }, [_c('v-tabs-bar', {
    staticClass: "transparent pl-4 mb-3"
  }, [_vm._l((_vm.tabs), function(tab) {
    return _c('v-tabs-item', {
      key: tab.id,
      attrs: {
        "href": ("#" + (tab.id)),
        "ripple": ""
      }
    }, [_vm._v(_vm._s(tab.title))])
  }), _vm._v(" "), _c('v-tabs-slider', {
    attrs: {
      "color": "black"
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    staticClass: "user-serach search-input mr-4",
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.searchValue),
      callback: function($$v) {
        _vm.searchValue = $$v
      },
      expression: "searchValue"
    }
  })], 2), _vm._v(" "), _c('v-tabs-items', {
    staticStyle: {
      "border": "none"
    }
  }, [_c('v-tabs-content', {
    key: "items",
    attrs: {
      "id": "items"
    }
  }, [_c('v-data-table', {
    staticClass: "table-wrapper",
    attrs: {
      "headers": _vm.items_headers,
      "items": _vm.items,
      "pagination": _vm.items_pagination,
      "rows-per-page-items": _vm.per_page_options,
      "total-items": _vm.total_items
    },
    on: {
      "update:pagination": function($event) {
        _vm.items_pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-left"
        }, [_c('div', {
          staticClass: "avatar-image-wrapper"
        }, [_c('div', {
          staticClass: "avatar-image",
          style: ({
            'background-image': 'url(' + props.item.order.customer.avatar.url + ')'
          })
        }), _vm._v(" "), _c('div', {
          staticClass: "avatar-title"
        }, [_vm._v(_vm._s(props.item.order.customer.username))])])]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(_vm._f("formatDate")(props.item.order.created_at)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v("$" + _vm._s(_vm._f("formatNumber")(props.item.price)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v(_vm._s(props.item.quantity))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v("$" + _vm._s(_vm._f("formatNumber")(props.item.shipping_cost)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v("$" + _vm._s(_vm._f("formatNumber")(props.item.tax_cost)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(_vm.fullAddress(props.item.order.shipping_address)))])]
      }
    }])
  })], 1), _vm._v(" "), _c('v-tabs-content', {
    key: "open_tickets",
    attrs: {
      "id": "open_tickets"
    }
  }, [_c('v-data-table', {
    staticClass: "table-wrapper",
    attrs: {
      "headers": _vm.open_tickets_headers,
      "items": _vm.open_tickets,
      "pagination": _vm.open_tickets_pagination,
      "rows-per-page-items": _vm.per_page_options,
      "total-items": _vm.total_open_tickets
    },
    on: {
      "update:pagination": function($event) {
        _vm.open_tickets_pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-left"
        }, [_c('div', {
          staticClass: "avatar-image-wrapper"
        }, [_c('div', {
          staticClass: "avatar-image",
          style: ({
            'background-image': 'url(' + props.item.open_user.avatar.url + ')'
          })
        }), _vm._v(" "), _c('div', {
          staticClass: "avatar-title"
        }, [_vm._v(_vm._s(props.item.open_user.username))])])]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v(_vm._s(_vm._f("formatDate")(props.item.created_at)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v(_vm._s(props.item.reason))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v(_vm._s(props.item.description))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center"
        }, [_c('v-menu', {
          attrs: {
            "down": "",
            "offset-y": ""
          }
        }, [_c('v-btn', {
          attrs: {
            "slot": "activator",
            "round": ""
          },
          slot: "activator"
        }, [_c('v-icon', {
          attrs: {
            "dark": "",
            "right": ""
          }
        }, [_vm._v("more_horiz")])], 1), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
          staticClass: "default-menu-item",
          nativeOn: {
            "click": function($event) {
              _vm.closeTicket(props.item)
            }
          }
        }, [_c('v-list-tile-title', [_c('label', [_vm._v("Close")])])], 1)], 1)], 1)], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('v-tabs-content', {
    key: "closed_tickets",
    attrs: {
      "id": "closed_tickets"
    }
  }, [_c('v-data-table', {
    staticClass: "table-wrapper",
    attrs: {
      "headers": _vm.closed_tickets_headers,
      "items": _vm.closed_tickets,
      "pagination": _vm.closed_tickets_pagination,
      "rows-per-page-items": _vm.per_page_options,
      "total-items": _vm.total_closed_tickets
    },
    on: {
      "update:pagination": function($event) {
        _vm.closed_tickets_pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-left"
        }, [_c('div', {
          staticClass: "avatar-image-wrapper"
        }, [_c('div', {
          staticClass: "avatar-image",
          style: ({
            'background-image': 'url(' + props.item.open_user.avatar.url + ')'
          })
        }), _vm._v(" "), _c('div', {
          staticClass: "avatar-title"
        }, [_vm._v(_vm._s(props.item.open_user.username))])])]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v(_vm._s(_vm._f("formatDate")(props.item.created_at)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v(_vm._s(_vm._f("formatDate")(props.item.closed_at)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v(_vm._s(props.item.reason))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v(_vm._s(props.item.description))])]
      }
    }])
  })], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1864 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page auth-page twitter-verify-page text-xs-center"
  }, [_vm._m(0), _vm._v(" "), (_vm.isLoading) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('v-progress-circular', {
    staticClass: "primary--text part-loading-activity",
    attrs: {
      "indeterminate": "",
      "size": 50
    }
  })], 1) : _c('h4', [_vm._v("Your account is being verified.")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-xs-center"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "/static/images/nav_logo_primary.png"
    }
  })])
}]}

/***/ }),
/* 1865 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page profile-grid-page members-page mx-5 text-black",
    staticStyle: {
      "color": "black !important"
    }
  }, [_c('content-top-header', {
    attrs: {
      "height": "auto"
    }
  }, [_c('template', {
    slot: "topHeader"
  }, [_c('ul', {
    staticClass: "user-top-wrapper"
  }, [_c('li', {
    staticClass: "user-profile-section"
  }, [_c('div', {
    staticClass: "user-profile-image-section"
  }, [_c('div', {
    staticClass: "user-profile-image",
    style: ({
      'background-image': ("url(" + (_vm.user.avatar.url) + ")"),
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "user-info-section"
  }, [_c('div', {
    staticClass: "user-name-section"
  }, [_c('span', {
    staticClass: "user-role"
  }, [_vm._v(_vm._s(_vm.user.user_type))]), _vm._v(" "), _c('div', {
    staticClass: "display-name"
  }, [_vm._v("\n                  " + _vm._s(_vm.user.username) + "\n                  "), _c('v-icon', {
    staticClass: "user-status online"
  }, [_vm._v("fa-check-circle")])], 1), _vm._v(" "), _c('div', {
    staticClass: "display-name-bottom"
  }, [_vm._v("\n                  MEMBERS SECTIONS "), (_vm.last_updated) ? _c('span', {
    staticClass: "user-role"
  }, [_vm._v("Last Updated: " + _vm._s(_vm.last_updated))]) : _vm._e()])])])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "d-flex align-items-center option-toolbar"
  }, [_c('v-select', {
    staticClass: "large",
    attrs: {
      "items": _vm.tierList,
      "item-text": "name",
      "placeholder": "Select option",
      "item-value": "value",
      "single-line": "",
      "bottom": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.tier),
      callback: function($$v) {
        _vm.tier = $$v
      },
      expression: "tier"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "close-btn"
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "variant": "text",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          path: ("/" + (_vm.user.slug))
        })
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1)])], 1)])], 2), _vm._v(" "), _c('div', {
    staticClass: "members-track profile-track mt-5"
  }, [(_vm.albums.length) ? _c('div', {
    staticClass: "_body list-track-container list-track-view list-track-view-trackCard"
  }, [_vm._m(0), _vm._v(" "), _c('v-container', {
    staticStyle: {
      "margin-left": "-10px"
    },
    attrs: {
      "fluid": "",
      "grid-list-md": "",
      "pl-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "id": "trending-product-container"
    }
  }, _vm._l((_vm.albums), function(feed, index) {
    return _c('v-flex', {
      key: index,
      staticClass: "product-list",
      attrs: {
        "xs6": "",
        "sm4": "",
        "lg3": ""
      }
    }, [_c('track-card', {
      attrs: {
        "objects": _vm.albums,
        "objectIndex": index,
        "willMenuRender": ""
      }
    })], 1)
  }))], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.videos.length) ? _c('div', {
    staticClass: "dflex justify-space-between align-center mt-5 mb-3"
  }, [_c('div', {
    staticClass: "text-big"
  }, [_vm._v("EXCLUSIVE VIDEOS")])]) : _vm._e(), _vm._v(" "), (_vm.videos.length) ? _c('div', {
    staticClass: "mt-4"
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": "",
      "pl-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "id": "trending-product-container"
    }
  }, _vm._l((_vm.videos), function(video) {
    return _c('v-flex', {
      key: video.id,
      staticClass: "video-list",
      attrs: {
        "xs6": "",
        "sm4": "",
        "lg3": ""
      }
    }, [_c('video-box', {
      attrs: {
        "hoverOverlay": false,
        "item": video
      }
    })], 1)
  }))], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.products.length) ? _c('div', {
    staticClass: "dflex justify-space-between align-center mt-5 mb-3"
  }, [_c('div', {
    staticClass: "text-big"
  }, [_vm._v("EXCLUSIVE PRODUCTS")])]) : _vm._e(), _vm._v(" "), (_vm.products.length) ? _c('div', {
    staticClass: "mt-4"
  }, [_c('v-container', {
    staticStyle: {
      "margin-left": "-10px"
    },
    attrs: {
      "fluid": "",
      "grid-list-md": "",
      "pl-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "id": "trending-product-container"
    }
  }, _vm._l((_vm.products), function(product, index) {
    return _c('v-flex', {
      key: index,
      staticClass: "product-list",
      attrs: {
        "xs6": "",
        "sm4": "",
        "lg3": ""
      }
    }, [_c('product-card', {
      attrs: {
        "hideOverlay": "",
        "noMeta": _vm.onMobile,
        "altMeta": _vm.onMobile,
        "altMetaPrice": _vm.onMobile,
        "dataObject": product
      },
      nativeOn: {
        "click": function($event) {
          _vm.productDisplay(product)
        }
      }
    })], 1)
  }))], 1)], 1) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dflex justify-space-between align-center mt-3 mb-3"
  }, [_c('div', {
    staticClass: "text-big"
  }, [_vm._v("EXCLUSIVE MUSIC")])])
}]}

/***/ }),
/* 1866 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "forgot-password-input auth-login-page"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit()
      }
    }
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('email')
    }
  }, [(_vm.onMobile) ? _c('div', {
    staticClass: "form-icon"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(595),
      "alt": "main icon"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: " my-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    staticClass: "email",
    class: {
      input: true,
      'text-danger': _vm.errors.has('email'),
    },
    attrs: {
      "name": "email",
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('email')) ? _c('p', {
    staticClass: "text-danger text-xs-left"
  }, [_vm._v("\n        " + _vm._s(_vm.errors.first("email")) + "\n      ")]) : _vm._e()])]), _vm._v(" "), _c('v-btn', {
    staticClass: "reset-btn py-3",
    attrs: {
      "block": "",
      "round": "",
      "dark": "",
      "type": "submit",
      "loading": _vm.loading
    }
  }, [_vm._v("\n      Reset Password\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "\n        text-xs-center\n        mt-3\n        dflex\n        align-center\n        justify-center\n      "
  }, [_c('span', {
    staticClass: "terms-text mr-2 cursor-pointer app-bold",
    on: {
      "click": function($event) {
        !_vm.showLogin ? _vm.$route.push('/login') : _vm.showLogin()
      }
    }
  }, [_vm._v("\n        Back to login\n      ")])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1867 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page manage-album-page",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [(_vm.currentUser && _vm.isPageReady) ? _c('div', {
    staticClass: "page-content"
  }, [_c('div', _vm._l((_vm.setAlbumFilter()), function(album, index) {
    return _c('album-list', {
      key: index,
      attrs: {
        "index": index,
        "album": album,
        "showPromoteButton": false,
        "editButtonAction": _vm.editAlbum,
        "deleteButtonAction": _vm.openAlbumDeleteConfirmDialog,
        "updateAccessLevelAction": _vm.closeAccessLevelConfirmDialog,
        "acceptButtonAction": _vm.acceptAlbum,
        "denyButtonAction": _vm.denyAlbum,
        "releaseButtonAction": _vm.releaseAlbum,
        "textBtnToRight": _vm.textBtnToRight
      },
      on: {
        "reRenderManageAlbum": _vm.reRenderManageAlbum
      }
    })
  })), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.show_access_level_confirm_dialog),
      callback: function($$v) {
        _vm.show_access_level_confirm_dialog = $$v
      },
      expression: "show_access_level_confirm_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Update Access Level")]), _vm._v(" "), _c('v-card-text', [_vm._v("If you make this album private it will be removed from public feeds\n            and reposts. Click OK to update access level, or click Cancel.")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.privateAlbum()
      }
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeAccessLevelConfirmDialog()
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "invite-dialog",
      "width": "440"
    },
    model: {
      value: (_vm.show_video_only_confirm_dialog),
      callback: function($$v) {
        _vm.show_video_only_confirm_dialog = $$v
      },
      expression: "show_video_only_confirm_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("\n            Make an album available only for live\n          ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n            If you click OK, the album will be available only for live\n            video.\n          ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "black",
      "dark": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.videoOnlyAlbum()
      }
    }
  }, [_vm._v("Yes")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.show_album_delete_confirm_dialog),
      callback: function($$v) {
        _vm.show_album_delete_confirm_dialog = $$v
      },
      expression: "show_album_delete_confirm_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Delete an Album")]), _vm._v(" "), _c('v-card-text', [_vm._v("If you click OK, your followers won't see the album any more. Click\n            OK to delete <" + _vm._s(_vm.album.name) + ">, or click Cancel.")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.deleteAlbum()
      }
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeAlbumDeleteConfirmDialog()
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": ["upload-finish-dialog"]
    },
    model: {
      value: (_vm.showReleaseAlbumModal),
      callback: function($$v) {
        _vm.showReleaseAlbumModal = $$v
      },
      expression: "showReleaseAlbumModal"
    }
  }, [(_vm.showReleaseAlbumModal) ? _c('album-finish-modal', {
    attrs: {
      "item": _vm.releaseAlbum,
      "type": "album",
      "promote": _vm.showPromoteModal,
      "dismiss": _vm.dismissFinishDialog
    }
  }) : _vm._e()], 1)], 1) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 1868 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.step == 1) ? _c('PlanDetail', {
    on: {
      "nexStep": _vm.nexStep
    }
  }) : (_vm.step == 2) ? _c('Payment', {
    on: {
      "nexStep": _vm.nexStep,
      "previousStep": _vm.previousStep
    }
  }) : _c('Success')], 1)
},staticRenderFns: []}

/***/ }),
/* 1869 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "plan"
  }, [_c('div', {
    staticClass: "display-flex align-center justify-space-between pt-5 pb-4 px-4"
  }, [_c('div', {
    staticClass: "text-poppins-18 text-white"
  }, [_vm._v("Plan details")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(117),
      "width": "27"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'CommunityMobile'
        })
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "plan__detail"
  }, [_c('div', {
    staticClass: "font-24 font-weight-500 text-white"
  }, [_vm._v("Loud Pack")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "text-poppins-14 text-white my-3"
  }, [_vm._v("\n      This plan features 4 creators\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "horizontal-scroll"
  }, _vm._l((5), function(i) {
    return _c('div', {
      key: i,
      staticClass: "horizontal-scroll__item plan__user mr-2 mb-2"
    }, [_vm._m(1, true), _vm._v(" "), _c('div', {
      staticClass: "text-poppins-14 text-white"
    }, [_vm._v("@salva")]), _vm._v(" "), _c('div', {
      staticClass: "text-poppins-12 text-grey-4"
    }, [_vm._v("ARTIST")])])
  })), _vm._v(" "), _c('div', {
    staticClass: "my-3 mt-4 text-poppins-14 text-white"
  }, [_vm._v("\n      Exclusive drops from all my homies!\n    ")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('v-btn', {
    staticClass: "btn-detail mx-0 text-white font-weight-500 full-width bg-black",
    on: {
      "click": function($event) {
        _vm.$emit('nexStep')
      }
    }
  }, [_vm._v("\n      Choose plan\n    ")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "font-20 font-weight-500 text-white"
  }, [_vm._v("20$/")]), _vm._v(" "), _c('span', {
    staticClass: "text-poppins-14 text-white"
  }, [_vm._v("month")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb-2"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(118),
      "width": "112",
      "height": "112"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "text-poppins-14 text-white mx-20"
  }, [_c('li', [_vm._v("10 exclusive tracks from 4 of the world famous electronic crews")]), _vm._v(" "), _c('li', [_vm._v("Stems for all tracks")]), _vm._v(" "), _c('li', [_vm._v("Vocal FXs")]), _vm._v(" "), _c('li', [_vm._v("VST presets for each track")])])
}]}

/***/ }),
/* 1870 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-details"
  }, [_c('div', {
    staticClass: "card-title"
  }, [_vm._v("Credit Card")]), _vm._v(" "), _c('div', {
    staticClass: "card-inputs"
  }, [_c('card-number', {
    ref: "cardNumber",
    staticClass: "stripe-element card-number payment-card",
    class: {
      complete: _vm.complete
    },
    attrs: {
      "stripe": _vm.stripePubkey,
      "options": _vm.options
    },
    on: {
      "change": function($event) {
        _vm.number = $event.complete
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "card-box-bottom"
  }, [_c('card-expiry', {
    ref: "cardExpiry",
    staticClass: "stripe-element card-expiry payment-card",
    class: {
      complete: _vm.complete
    },
    attrs: {
      "stripe": _vm.stripePubkey,
      "options": _vm.options
    },
    on: {
      "change": function($event) {
        _vm.expiry = $event.complete
      }
    }
  }), _vm._v(" "), _c('card-cvc', {
    ref: "cardCvc",
    staticClass: "stripe-element card-cvc payment-card",
    class: {
      complete: _vm.complete
    },
    attrs: {
      "stripe": _vm.stripePubkey,
      "options": _vm.options
    },
    on: {
      "change": function($event) {
        _vm.cvc = $event.complete
      }
    }
  })], 1), _vm._v(" "), (!_vm.hidePayBtn) ? _c('div', {
    staticClass: "pay-btn-wrapper"
  }, [_c('v-btn', {
    staticClass: "btn-cta",
    attrs: {
      "disabled": !_vm.complete
    },
    on: {
      "click": function($event) {
        _vm.paymentMethod()
      }
    }
  }, [_vm._v("\n        Pay $" + _vm._s(_vm.totalPayable) + "\n      ")])], 1) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 1871 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "support-body"
  }, [_c('div', {
    staticClass: "support-container"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/nav_logo_primary.png",
      "alt": "YouSound Logo"
    }
  })]), _vm._v(" "), _c('h1', [_vm._v("YouSound Support")]), _vm._v(" "), _c('div', {
    staticClass: "contact"
  }, [_vm._v("\n      If you have questions please reach out to us at:\n      "), _c('br'), _c('a', {
    attrs: {
      "href": "mailto:support@yousound.com"
    }
  }, [_vm._v("support@yousound.com")])]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_vm._v("\n      We’re currently in an early release phase, so responses may take a bit\n      longer than usual. Stay tuned as we expand our support team soon!\n    ")])])])
}]}

/***/ }),
/* 1872 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "collaborators-success-dialog"
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_c('div', {
    staticClass: "dflex gap-15 pt-0",
    staticStyle: {
      "padding-top": "10px"
    }
  }, [(this.type === 'album') ? _c('div', {
    staticClass: "headline-text"
  }, [_vm._v("\n          Your album was released! "), _c('a', {
    staticStyle: {
      "text-decoration": "underline !important"
    },
    attrs: {
      "href": "/upload/album"
    }
  }, [_vm._v("Upload another")]), _vm._v(" or go to "), _c('router-link', {
    staticStyle: {
      "text-decoration": "underline !important"
    },
    attrs: {
      "to": "/upload"
    }
  }, [_vm._v("upload page")])], 1) : (this.type === 'stream') ? _c('div', {
    staticClass: "headline-text"
  }, [_vm._v("\n          Your video was released! "), _c('a', {
    staticStyle: {
      "text-decoration": "underline !important"
    },
    attrs: {
      "href": "/upload/video"
    }
  }, [_vm._v("Upload another")]), _vm._v(" or go to "), _c('router-link', {
    staticStyle: {
      "text-decoration": "underline !important"
    },
    attrs: {
      "to": "/upload"
    }
  }, [_vm._v("upload page")])], 1) : (this.type === 'product') ? _c('div', {
    staticClass: "headline-text"
  }, [_vm._v("\n          Your product was released! "), _c('a', {
    staticStyle: {
      "text-decoration": "underline !important"
    },
    attrs: {
      "href": "/upload/product/add"
    }
  }, [_vm._v("Upload another")]), _vm._v(" or go to "), _c('router-link', {
    staticStyle: {
      "text-decoration": "underline !important"
    },
    attrs: {
      "to": "/upload"
    }
  }, [_vm._v("upload page")])], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "dflex gap-15 align-center"
  }, [_c('div', {
    staticClass: "dflex w-30 border-round"
  }, [(_vm.type == 'stream' || _vm.type == 'album') ? _c('img', {
    attrs: {
      "src": _vm.item.cover.url,
      "width": "100%"
    }
  }) : _c('img', {
    attrs: {
      "src": _vm.item.covers[0].cover.url,
      "width": "100%"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "w-70"
  }, [_c('div', [_c('h3', {
    staticClass: "main-head"
  }, [_vm._v(_vm._s(_vm.item.name))]), _vm._v(" "), _c('p', {
    staticClass: "second-head"
  }, [_vm._v(_vm._s(_vm.type == 'product' ? _vm.item.merchant.username : _vm.item.user.username))]), _vm._v(" "), (_vm.type === 'album') ? _c('p', {
    staticClass: "light-text"
  }, [_vm._v(_vm._s(_vm.item.tracks.length) + " tracks")]) : _vm._e(), _vm._v(" "), (_vm.type !== 'product') ? _c('p', {
    staticClass: "light-text"
  }, [_vm._v(_vm._s(_vm.type === 'album' ? _vm.item.genres[0] && _vm.item.genres[0].name : _vm.item.genre.name))]) : _vm._e(), _vm._v(" "), (_vm.type == 'product') ? _c('p', {
    staticClass: "light-text"
  }, [_vm._v(_vm._s(_vm.item.category.name))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "dflex align-center gap-10"
  }, [_c('div', {
    staticClass: "dflex align-center gap-20"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1453),
      "width": "16"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1454),
      "width": "10"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1547),
      "width": "17"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "url-bar"
  }, [_c('p', {
    staticClass: "mx-0 my-0"
  }, [_vm._v(_vm._s(_vm.albumURL))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.albumURL),
      expression: "albumURL",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.onCopy),
      expression: "onCopy",
      arg: "success"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:error",
      value: (_vm.onError),
      expression: "onError",
      arg: "error"
    }],
    staticClass: "clipboard-btn"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1446),
      "width": "16"
    }
  })])])])])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1873 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.pageReady) ? _c('div', {
    staticClass: "page collection-page mx-5 margin-top-header"
  }, [_c('content-top-header', {
    staticClass: "mt-3 black-theme"
  }, [_c('template', {
    slot: "topHeader"
  }, [_c('ul', [_c('li', {
    staticClass: "active"
  }, [_c('label', {
    staticClass: "innerBold"
  }, [_vm._v("\n\t\t\t\t\t\t\tCollection >\n\t\t\t\t\t\t")])]), _vm._v(" "), _vm._l((_vm.tabs), function(tab) {
    return _c('li', {
      key: tab.id,
      class: {
        'active ': _vm.isActiveTab(tab.id)
      },
      attrs: {
        "href": ("#" + (tab.id))
      }
    }, [_c('label', {
      staticClass: "innerBold",
      on: {
        "click": function($event) {
          _vm.onTab(tab.id)
        }
      }
    }, [_vm._v(_vm._s(tab.title))])])
  })], 2)])], 2), _vm._v(" "), _c('repost-music', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab === 'music'),
      expression: "activeTab === 'music'"
    }],
    attrs: {
      "tracks": this.tracks,
      "getCollections": _vm.getCollections,
      "playlists": this.playlist_data.playlists.filter(function (c) { return c.playlist_type == 'tracks'; }),
      "openDeletePlaylistModal": _vm.openDeletePlaylistModal
    },
    on: {
      "methodThatForcesUpdate": _vm.methodThatForcesUpdate
    }
  }), _vm._v(" "), _c('repost-videos', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab === 'videos'),
      expression: "activeTab === 'videos'"
    }],
    attrs: {
      "streams": _vm.streams,
      "getCollections": _vm.getCollections,
      "playlists": this.playlist_data.playlists.filter(function (c) { return c.playlist_type == 'streams'; }),
      "openDeletePlaylistModal": _vm.openDeletePlaylistModal
    },
    on: {
      "methodThatForcesUpdate": _vm.methodThatForcesUpdate
    }
  }), _vm._v(" "), _c('repost-products', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab === 'products'),
      expression: "activeTab === 'products'"
    }],
    attrs: {
      "products": _vm.products,
      "getCollections": _vm.getCollections,
      "playlists": this.playlist_data.playlists.filter(function (c) { return c.playlist_type == 'products'; }),
      "openDeletePlaylistModal": _vm.openDeletePlaylistModal
    },
    on: {
      "methodThatForcesUpdate": _vm.methodThatForcesUpdate
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "invite-dialog",
      "width": "440"
    },
    model: {
      value: (_vm.show_delete_playlist_modal),
      callback: function($$v) {
        _vm.show_delete_playlist_modal = $$v
      },
      expression: "show_delete_playlist_modal"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("\n          Delete Playlist\n        ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n          Are you sure you want to delete this track from playlist?\n        ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red",
      "dark": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.deletePlaylist()
      }
    }
  }, [_vm._v("Yes")])], 1)], 1)], 1)], 1) : _c('div', {
    staticClass: "page-loader"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(166),
      "alt": ""
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 1874 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "approve-section",
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-layout', {
    staticClass: "dismiss-section",
    attrs: {
      "row": "",
      "wrap": ""
    },
    on: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "popup-section",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "profile-section",
    attrs: {
      "xs12": "",
      "sm12": "",
      "mx-3": "",
      "py-3": ""
    }
  }, [_c('div', {
    staticClass: "profile-image",
    style: ({
      'background-image': 'url(' + _vm.item.avatar.url + ')'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "info-section"
  }, [_c('div', {
    staticClass: "user-name"
  }, [_vm._v(_vm._s(_vm.item.username))]), _vm._v(" "), _c('div', {
    staticClass: "user-slug"
  }, [_vm._v("@" + _vm._s(_vm.item.slug))]), _vm._v(" "), _c('div', {
    staticClass: "status"
  }, [_vm._v(_vm._s(_vm.item.status))])]), _vm._v(" "), _c('div', {
    staticClass: "mt-5 mb-3 info-user"
  }, [_c('div', {
    staticClass: "font-weight-700"
  }, [_vm._v("EMAIL")]), _vm._v(" "), _c('div', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm.item.email))])]), _vm._v(" "), _c('div', {
    staticClass: "mb-3 info-user"
  }, [_c('div', {
    staticClass: "font-weight-700"
  }, [_vm._v("LOCATION")]), _vm._v(" "), _c('div', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm.userFullAddress))])]), _vm._v(" "), _c('div', {
    staticClass: "mb-3 info-user"
  }, [_c('div', {
    staticClass: "font-weight-700"
  }, [_vm._v("AGE GROUP")]), _vm._v(" "), _c('div', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm.item.gender))])]), _vm._v(" "), _c('div', {
    staticClass: "mb-3 info-user"
  }, [_c('div', {
    staticClass: "font-weight-700"
  }, [_vm._v("SOCIAL PROFILE")]), _vm._v(" "), (
    (_vm.item.social_user_name || _vm.item.social_user_id) &&
    _vm.item.social_provider.toLowerCase() === 'instagram'
  ) ? _c('div', {
    staticClass: "font-weight-500"
  }, [_c('span', [_vm._v("Instagram - ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": ("https://instagram.com/" + (_vm.item.social_user_name == null
                ? _vm.item.social_user_id
                : _vm.item.social_user_name)),
      "target": "_blank"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.item.social_user_name == null ?
    _vm.item.social_user_id :
    _vm.item.social_user_name) + "\n          ")])]) : _vm._e(), _vm._v(" "), (
    (_vm.item.social_user_name || _vm.item.social_user_id) &&
    (_vm.item.social_provider.toLowerCase() === 'tiktok' ||
      _vm.item.social_provider.toLowerCase() === 'tik tok')
  ) ? _c('div', {
    staticClass: "font-weight-500"
  }, [_c('span', [_vm._v("TikTok - ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": ("https://tiktok.com/" + (_vm.item.social_user_name == null
                ? _vm.item.social_user_id
                : _vm.item.social_user_name)),
      "target": "_blank"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.item.social_user_name == null ?
    _vm.item.social_user_id :
    _vm.item.social_user_name) + "\n          ")])]) : _vm._e(), _vm._v(" "), (
    (_vm.item.social_user_name || _vm.item.social_user_id) &&
    _vm.item.social_provider.toLowerCase() === 'facebook'
  ) ? _c('div', {
    staticClass: "font-weight-500"
  }, [_c('span', [_vm._v("Facebook - ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": ("https://facebook.com/" + (_vm.item.social_user_name == null
                ? _vm.item.social_user_id
                : _vm.item.social_user_name)),
      "target": "_blank"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.item.social_user_name == null ?
    _vm.item.social_user_id :
    _vm.item.social_user_name) + "\n          ")])]) : _vm._e(), _vm._v(" "), (
    (_vm.item.social_user_name || _vm.item.social_user_id) &&
    _vm.item.social_provider.toLowerCase() === 'twitter'
  ) ? _c('div', {
    staticClass: "font-weight-500"
  }, [_c('span', [_vm._v("Twitter - ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": ("https://twitter.com/" + (_vm.item.social_user_name == null
                ? _vm.item.social_user_id
                : _vm.item.social_user_name)),
      "target": "_blank"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.item.social_user_name == null ?
    _vm.item.social_user_id :
    _vm.item.social_user_name) + "\n          ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "flagged mb-5"
  }, [_vm._v("Flagged")]), _vm._v(" "), _c('div', {
    staticClass: "reason-flag"
  }, [_c('div', {
    staticClass: "reason-flag__title"
  }, [_vm._v("Reason for flag?")]), _vm._v(" "), _c('v-select', {
    staticClass: "normal-input pt-2",
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "items": _vm.denial_reasons,
      "autocomplete": ""
    },
    model: {
      value: (_vm.item.denial_reason),
      callback: function($$v) {
        _vm.$set(_vm.item, "denial_reason", $$v)
      },
      expression: "item.denial_reason"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "action-section"
  }, [_c('v-btn', {
    staticClass: "deny-btn",
    attrs: {
      "color": "black",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        _vm.submission(_vm.item)
      }
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('v-btn', {
    staticClass: "deny-btn",
    attrs: {
      "color": "black",
      "outline": ""
    }
  }, [_vm._v("Cancel")])], 1)])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1875 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page discover-page product-index-page mx-5",
    class: {
      isComp: _vm.isComp
    }
  }, [(!_vm.isComp && !_vm.onMobile) ? _c('discover-nav', {
    attrs: {
      "pageName": "merch",
      "searchShow": this.$store.state.app.sideBarMini
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isPageReady) ? _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "global-header-viewall"
  }, [_c('v-container', {
    staticStyle: {
      "margin-left": "-10px"
    },
    attrs: {
      "fluid": "",
      "grid-list-md": "",
      "pl-0": ""
    }
  }, [_c('content-top-header', {
    staticClass: "__inner mt-3",
    attrs: {
      "absolute": ""
    }
  }, [_c('template', {
    slot: "topHeader"
  }, [_c('ul', {
    staticClass: "width100 trending-topbar"
  }, [_vm._l((_vm.tabs), function(tab, index) {
    return _c('li', {
      key: index
    }, [_c('label', {
      staticClass: "black--text",
      class: (tab.id === _vm.selectedTab) ? 'active' : '',
      on: {
        "click": function($event) {
          _vm.SelectTab(tab)
        }
      }
    }, [_vm._v(_vm._s(tab.title))])])
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('li', {
    staticClass: "category-filter"
  }, [_c('div', [_c('v-select', {
    attrs: {
      "v-model": _vm.selected_category,
      "items": _vm.categories,
      "value": _vm.selected_category,
      "item-text": "name",
      "item-value": "id",
      "placeholder": "Category: All",
      "clearable": "",
      "solo": "",
      "return-object": ""
    },
    on: {
      "input": _vm.changeSelectedCategory
    }
  })], 1)]), _vm._v(" "), _c('li', {
    staticClass: "price-filter"
  }, [_c('div', [(false) ? _c('v-select', {
    attrs: {
      "items": [{
        id: '5-10',
        name: '$5-$10'
      }],
      "item-text": "name",
      "item-value": "id",
      "placeholder": "Price: Any",
      "clearable": "",
      "solo": ""
    }
  }) : _vm._e()], 1)])], 2)])], 2), _vm._v(" "), _c('div', {
    staticClass: "products",
    on: {
      "scroll": _vm.handleScroll
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.selected_category == null ? _vm.products : _vm.products.filter(function (product) { return product.category.name === _vm.selected_category.name; })), function(product) {
    return _c('v-flex', {
      key: product.id,
      staticClass: "product-list",
      attrs: {
        "xs6": "",
        "sm4": "",
        "lg3": ""
      }
    }, [_c('product-card', {
      attrs: {
        "hideOverlay": "",
        "noMeta": _vm.onMobile,
        "altMeta": _vm.onMobile,
        "altMetaPrice": _vm.onMobile,
        "dataObject": product
      },
      nativeOn: {
        "click": function($event) {
          _vm.verifyUser(product)
        }
      }
    })], 1)
  }))], 1)], 1)], 1)]) : _c('div', {
    staticClass: "page-loader"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(166),
      "alt": ""
    }
  })])], 1)
},staticRenderFns: []}

/***/ }),
/* 1876 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "onboarding_comp auth-input-page"
  }, [_c('div', {
    staticClass: "auth-input-page__group"
  }, [_c('label', {
    staticClass: "auth-label-input"
  }, [_vm._v("Age group")]), _vm._v(" "), _c('div', {
    staticClass: "selections"
  }, _vm._l((_vm.ageGroups), function(age, index) {
    return _c('div', {
      key: index,
      staticClass: "selection",
      class: {
        _selected: _vm.ageRange == age.title
      },
      on: {
        "click": function($event) {
          _vm.selectAgeRange(age)
        }
      }
    }, [_vm._v("\n        " + _vm._s(age.title) + "\n      ")])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "auth-input-page__group mb-2"
  }, [_c('label', {
    staticClass: "auth-label-input"
  }, [_vm._v("Country")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.country),
      expression: "country"
    }],
    class: {
      _filled: _vm.country
    },
    attrs: {
      "type": "text",
      "placeholder": "Type your country"
    },
    domProps: {
      "value": (_vm.country)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.country = $event.target.value
      }
    }
  }), _vm._v(" "), _c('autocomplete', {
    staticClass: "location",
    attrs: {
      "keyword": _vm.country,
      "options": _vm.getCountryList,
      "identifier": "country"
    },
    on: {
      "selected": _vm.selected
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "auth-input-page__group"
  }, [_c('label', {
    staticClass: "auth-label-input"
  }, [_vm._v("City")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.city),
      expression: "city"
    }],
    class: {
      _filled: _vm.city
    },
    attrs: {
      "type": "text",
      "placeholder": "Type your city"
    },
    domProps: {
      "value": (_vm.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.city = $event.target.value
      }
    }
  }), _vm._v(" "), _c('autocomplete', {
    staticClass: "location",
    staticStyle: {
      "z-index": "1"
    },
    attrs: {
      "keyword": _vm.city,
      "options": _vm.getCityList,
      "identifier": "city"
    },
    on: {
      "selected": _vm.selected
    }
  })], 1), _vm._v(" "), _c('VueLoadingButton', {
    staticClass: "w-100",
    attrs: {
      "loading": _vm.isLoading
    },
    nativeOn: {
      "click": function($event) {
        _vm.handleClick($event)
      }
    }
  }, [_c('div', {
    class: {
      'display-flex align-center gap-8 justify-space-between': _vm.$vuetify.breakpoint.width <= 1280,
    }
  }, [(_vm.$vuetify.breakpoint.width <= 1280) ? _c('v-btn', {
    staticClass: "back-button",
    on: {
      "click": function($event) {
        _vm.$emit('actionPrevStage')
      }
    }
  }, [_vm._v("\n        Back\n      ")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "auth-button",
    class: {
      _disabled: !_vm.validated('skipToast'),
      'auth-bg-disabled': _vm.checkDataEmpty,
      'auth-bg-active': !_vm.checkDataEmpty,
    },
    on: {
      "click": function($event) {
        _vm.handleNextStage()
      }
    }
  }, [_vm._v("\n        Next\n      ")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1877 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "onboarding_comp auth-input-page"
  }, [_c('div', {
    staticClass: "auth-input-page__group"
  }, [_c('label', {
    staticClass: "auth-label-input"
  }, [_vm._v("Choose platform")]), _vm._v(" "), _c('v-menu', {
    staticClass: "social-type-menu",
    attrs: {
      "bottom": "",
      "left": "",
      "offset-y": "",
      "nudge-top": -5,
      "nudge-left": 0,
      "content-class": "social-menu__content"
    }
  }, [_c('v-select', {
    staticClass: "social-types-selector py-0",
    class: {
      _filled: _vm.socialChannel
    },
    attrs: {
      "slot": "activator",
      "placeholder": _vm.socialChannel ? _vm.socialChannel.title : 'Select',
      "single-line": "",
      "hide-details": ""
    },
    slot: "activator"
  }), _vm._v(" "), _vm._l((_vm.socialChannels), function(channel, i) {
    return _c('div', {
      key: i,
      staticClass: "channel-info",
      class: [((channel.id) + "-menu")],
      on: {
        "click": function($event) {
          _vm.selectedChannel(channel)
        }
      }
    }, [_c('div', {
      staticClass: "_title"
    }, [_vm._v(_vm._s(channel.title))]), _vm._v(" "), _c('div', {
      staticClass: "_tags"
    }, [_vm._v("\n          " + _vm._s(channel.tags) + "\n        ")])])
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "auth-input-page__group mt-1"
  }, [_c('label', {
    staticClass: "auth-label-input"
  }, [_vm._v("Username")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.socialUsername),
      expression: "socialUsername"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.socialUsername)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.socialUsername = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    class: {
      'display-flex align-center gap-8 justify-space-between': _vm.$vuetify.breakpoint.width <= 1280,
    }
  }, [(_vm.$vuetify.breakpoint.width <= 1280) ? _c('v-btn', {
    staticClass: "back-button",
    on: {
      "click": function($event) {
        _vm.$emit('actionPrevStage')
      }
    }
  }, [_vm._v("\n      Back\n    ")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "auth-button",
    class: {
      _disabled: !_vm.validated('skipToast'),
      'auth-bg-disabled': _vm.checkDataEmpty,
      'auth-bg-active': !_vm.checkDataEmpty,
    },
    on: {
      "click": function($event) {
        _vm.handleNextStage()
      }
    }
  }, [_vm._v("\n      Next\n    ")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1878 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "item__header"
  }, [(_vm.item.status !== 'item_refunded') ? _c('v-checkbox', {
    attrs: {
      "hide-details": "",
      "color": "red"
    },
    on: {
      "change": function($event) {
        _vm.$emit('input', _vm.item)
      }
    },
    model: {
      value: (_vm.item.refund),
      callback: function($$v) {
        _vm.$set(_vm.item, "refund", $$v)
      },
      expression: "item.refund"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "item__content"
  }, [_c('app-card', {
    attrs: {
      "image": _vm.productImage,
      "title": _vm.productName,
      "subtitle": _vm.itemPrice,
      "description": _vm.itemShippingCost
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "item__footer"
  }, [(_vm.item.refund) ? _c('vue-numeric', {
    attrs: {
      "currency": "$",
      "separator": ",",
      "precision": 2,
      "min": 0.01,
      "max": _vm.itemMaxRefundAmount
    },
    on: {
      "blur": function($event) {
        _vm.$emit('input', _vm.item)
      }
    },
    model: {
      value: (_vm.item.refund_amount_in_dollar),
      callback: function($$v) {
        _vm.$set(_vm.item, "refund_amount_in_dollar", $$v)
      },
      expression: "item.refund_amount_in_dollar"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "item__footer"
  }, [_c('div', [_vm._v("Quantity: " + _vm._s(_vm.itemQuantity))]), _vm._v(" "), _c('label', {
    class: _vm.itemStatus.toLowerCase()
  }, [_vm._v(_vm._s(_vm.itemStatus))])])])
},staticRenderFns: []}

/***/ }),
/* 1879 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('upload-nav', {
    attrs: {
      "name": "upload"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "px-5 pt-5 mt-5 text-poppins-36"
  }, [_vm._v("Upload audio")]), _vm._v(" "), _vm._v("\n    >\n      "), (_vm.isPageReady) ? _c('div', [_c('div', [_c('track-uploader', {
    attrs: {
      "accept": ".mp3",
      "autoUpload": true,
      "album": _vm.album
    }
  })], 1), _vm._v(" "), (_vm.album.tracks.length) ? _c('div', {
    attrs: {
      "id": "album_info_section"
    }
  }, [_c('div', {
    staticClass: "album-info-section mx-5"
  }, [_vm._m(0), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-lg": "",
      "px-0": "",
      "album-section": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "album-content-section": "",
      "album-content-info": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm12": "",
      "md8": ""
    }
  }, [_c('div', {
    staticClass: "dflex d-row"
  }, [_c('div', {
    staticClass: "w-100"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("\n                        Album Title\n                      ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.album.name),
      expression: "album.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.album.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.album, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "dflex gap-15 upload-album-item"
  }, [_c('div', {
    staticClass: "w-25"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("\n                        Genre\n                      ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.$store.getters['genreSelector/genre'].name
    },
    on: {
      "click": function($event) {
        _vm.openGenreSelectorDialog()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "w-15"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(" BPM ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.album.bpm),
      expression: "album.bpm"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "'1-999'"
    },
    domProps: {
      "value": (_vm.album.bpm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.album, "bpm", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "upload-album-key w-25 dflex gap-15"
  }, [_c('div', {
    staticClass: "w-100"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(" KEY ")]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-nail"
  }, [_c('div', {
    staticClass: "dropdown-head",
    on: {
      "click": function($event) {
        _vm.majorDropdown = true
      }
    }
  }, [(_vm.majorValue == 'major') ? _c('div', [_vm._v("Major")]) : (_vm.majorValue == 'minor') ? _c('div', [_vm._v("Minor")]) : _c('div', {
    staticClass: "text-dull"
  }, [_vm._v("Select")])]), _vm._v(" "), (_vm.majorDropdown) ? _c('div', [_c('div', {
    staticClass: "dropdown-overlay",
    on: {
      "click": function($event) {
        _vm.majorDropdown = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dropdown-body"
  }, [_c('div', {
    staticClass: "inline-block",
    on: {
      "click": function($event) {
        _vm.majorValue = 'major';
        _vm.majorDropdown = false;
        _vm.keyDropdown = true;
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "id": "major",
      "name": "key",
      "value": "major"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "major"
    }
  }, [_vm._v("Major")])]), _vm._v(" "), _c('div', {
    staticClass: "inline-block",
    on: {
      "click": function($event) {
        _vm.majorValue = 'minor';
        _vm.majorDropdown = false;
        _vm.keyDropdown = true;
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "id": "minor",
      "name": "key",
      "value": "minor"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "minor"
    }
  }, [_vm._v("Minor")])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "w-100"
  }, [_c('label', {
    staticClass: "control-label show-none"
  }, [_vm._v(" KEY ")]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-nail"
  }, [_c('div', {
    staticClass: "dropdown-head"
  }, [(_vm.keyValue == 'none') ? _c('div', {
    staticClass: "text-dull"
  }, [_vm._v("\n                              -\n                            ")]) : _c('div', [_vm._v("\n                              " + _vm._s(_vm.keyValue) + "\n                            ")])]), _vm._v(" "), (_vm.keyDropdown) ? _c('div', [_c('div', {
    staticClass: "dropdown-body"
  }, _vm._l((_vm.keyOptions), function(index) {
    return _c('div', {
      staticClass: "cursor-pointer key-value",
      on: {
        "click": function($event) {
          _vm.setKeyValue(index);
          _vm.keyDropdown = false;
        }
      }
    }, [_vm._v("\n                                " + _vm._s(index) + "\n                              ")])
  }))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "w-30"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Location this album represents")]), _vm._v(" "), _c('v-select', {
    staticClass: "pt-0",
    attrs: {
      "items": _vm.locations,
      "item-text": "name",
      "item-value": "name",
      "placeholder": "Type name to search",
      "single-line": "",
      "autocomplete": ""
    },
    model: {
      value: (_vm.album.location),
      callback: function($$v) {
        _vm.$set(_vm.album, "location", $$v)
      },
      expression: "album.location"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "dflex gap-15 upload-album-item"
  }, [_c('div', {
    staticClass: "w-25"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("\n                        Released Date\n                      ")]), _vm._v(" "), _c('v-menu', {
    staticClass: "released-at-picker",
    attrs: {
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-right": 40,
      "max-width": "290px",
      "min-width": "290px",
      "lazy": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.album.released_at),
      callback: function($$v) {
        _vm.$set(_vm.album, "released_at", $$v)
      },
      expression: "album.released_at"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": "",
      "actions": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var save = ref.save;
        var cancel = ref.cancel;

        return [_c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
          attrs: {
            "flat": "",
            "color": "primary"
          },
          on: {
            "click": cancel
          }
        }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
          attrs: {
            "flat": "",
            "color": "primary"
          },
          on: {
            "click": save
          }
        }, [_vm._v("OK")])], 1)]
      }
    }]),
    model: {
      value: (_vm.album.released_at),
      callback: function($$v) {
        _vm.$set(_vm.album, "released_at", $$v)
      },
      expression: "album.released_at"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "w-75"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("\n                        Album includes\n                      ")]), _vm._v(" "), _c('div', {
    staticClass: "album-content-wrapper font-lable-check"
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Acapella",
      "hide-details": ""
    },
    model: {
      value: (_vm.album.is_content_acapella),
      callback: function($$v) {
        _vm.$set(_vm.album, "is_content_acapella", $$v)
      },
      expression: "album.is_content_acapella"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Inst",
      "hide-details": ""
    },
    model: {
      value: (_vm.album.is_content_instrumental),
      callback: function($$v) {
        _vm.$set(_vm.album, "is_content_instrumental", $$v)
      },
      expression: "album.is_content_instrumental"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Stems",
      "hide-details": ""
    },
    model: {
      value: (_vm.album.is_content_stems),
      callback: function($$v) {
        _vm.$set(_vm.album, "is_content_stems", $$v)
      },
      expression: "album.is_content_stems"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Remix",
      "hide-details": ""
    },
    model: {
      value: (_vm.album.is_content_remix),
      callback: function($$v) {
        _vm.$set(_vm.album, "is_content_remix", $$v)
      },
      expression: "album.is_content_remix"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "DJ Mix",
      "hide-details": ""
    },
    model: {
      value: (_vm.album.is_content_dj_mix),
      callback: function($$v) {
        _vm.$set(_vm.album, "is_content_dj_mix", $$v)
      },
      expression: "album.is_content_dj_mix"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "dflex"
  }, [_c('div', {
    staticClass: "w-100"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.album.description),
      expression: "album.description"
    }],
    staticClass: "album-description form-control non-resizable",
    domProps: {
      "value": (_vm.album.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.album, "description", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm12": "",
      "md4": ""
    }
  }, [_c('div', {
    staticClass: "album-image-section pb-2"
  }, [_c('div', {
    staticClass: "image-section"
  }, [(_vm.album_image_url) ? _c('div', {
    staticClass: "album-image",
    style: (("background-image: url(" + _vm.album_image_url + ")")),
    attrs: {
      "id": "album_image"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.album_image_url) ? _c('div', {
    staticClass: "album-image-upload-section"
  }, [_c('input', {
    staticClass: "add-album-image-file",
    attrs: {
      "type": "file",
      "name": "album_image_file",
      "id": "album_image_file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.imageChanged($event)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "album_image_file"
    }
  }, [_c('v-icon', {
    staticClass: "camera mt-0"
  }, [_vm._v("photo_camera")]), _vm._v("upload\n                        ")], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "image-change-section"
  }, [_c('input', {
    staticClass: "change-album-image-file",
    attrs: {
      "type": "file",
      "name": "album_image_file",
      "id": "album_image_file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.imageChanged($event)
      }
    }
  }), _vm._v(" "), (_vm.album_image_url) ? _c('label', {
    attrs: {
      "for": "album_image_file"
    }
  }, [_vm._v("Change")]) : _vm._e()])])])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "album-info-section mx-5 pb-0"
  }, [_vm._m(1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-lg": "",
      "px-0": "",
      "album-section": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "album-content-section": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "form-group": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label max-char-label"
  }, [_c('span', {
    staticClass: "__title"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("\n                        Available to..\n                      ")])]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "py-0 my-0",
    attrs: {
      "items": _vm.access_levels,
      "name": "access_level",
      "item-text": "title",
      "item-value": "id",
      "chips": "",
      "multiple": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(data) {
        return [_c('div', {
          staticClass: "custom-multi-select"
        }, [_c('span', [_vm._v(_vm._s(data.item.title))]), _vm._v(" "), _c('v-icon', {
          staticClass: "icon-close text-white"
        }, [_vm._v("\n                            close\n                          ")])], 1)]
      }
    }]),
    model: {
      value: (_vm.album.access_level),
      callback: function($$v) {
        _vm.$set(_vm.album, "access_level", $$v)
      },
      expression: "album.access_level"
    }
  })], 1)])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "album-info-section mx-5"
  }, [_vm._m(2), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-lg": "",
      "px-0": "",
      "album-section": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "album-content-section": ""
    }
  }, [_c('v-flex', {
    staticClass: "additional-info-section",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "pa-0": ""
    }
  }, [_c('v-flex', {
    staticClass: "my-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "dflex": "",
      "align-center": "",
      "pa-0": "",
      "my-0": ""
    }
  }, [_c('h4', {
    staticClass: "album-info-title-x mb-0 mr-2"
  }, [_vm._v("\n                            Collaborators (" + _vm._s(_vm.collaborators.length) + ")\n                          ")]), _vm._v(" "), (_vm.collaborators.length < 3) ? _c('v-btn', {
    staticClass: "add-option-btn ma-0",
    nativeOn: {
      "click": function($event) {
        _vm.addCollaborator()
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "pa-0": ""
    }
  }, _vm._l((_vm.collaborators), function(collaborator, index) {
    return _c('div', {
      key: index,
      staticClass: "upload-album-collaborator mb-3"
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "option-content": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "display-flex": "",
        "justify-start": "",
        "align-center": "",
        "gap-15": "",
        "mb-2": ""
      }
    }, [_c('div', [_c('img', {
      attrs: {
        "src": "/static/images/track-example.png",
        "width": "62",
        "height": "62"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "w-100"
    }, [_c('label', {
      staticClass: "control-label mb-0"
    }, [_vm._v("Track")]), _vm._v(" "), _c('span', {
      staticClass: "dflex align-center"
    }, [_c('input', {
      staticClass: "form-control",
      attrs: {
        "type": "text"
      }
    })])])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm6": "",
        "md3": ""
      }
    }, [_c('label', {
      staticClass: "control-label"
    }, [_vm._v("Owner")]), _vm._v(" "), _c('v-select', {
      staticClass: "pt-0",
      attrs: {
        "item-text": "owner",
        "item-value": "id",
        "placeholder": "Type name to search",
        "chips": "",
        "no-data-text": "No artist found",
        "autocomplete": ""
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm6": "",
        "md3": ""
      }
    }, [_c('label', {
      staticClass: "control-label"
    }, [_vm._v("Role")]), _vm._v(" "), _c('span', {
      staticClass: "dflex align-center"
    }, [_c('v-select', {
      staticClass: "pt-0",
      attrs: {
        "item-text": "name",
        "item-value": "name",
        "placeholder": "Type name to search",
        "autocomplete": ""
      }
    })], 1)]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm6": "",
        "md3": ""
      }
    }, [_c('label', {
      staticClass: "control-label"
    }, [_vm._v("Profit split")]), _vm._v(" "), _c('span', {
      staticClass: "dflex align-center"
    }, [_c('input', {
      staticClass: "form-control",
      attrs: {
        "type": "text"
      }
    })])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm6": "",
        "md3": ""
      }
    }, [_c('label', {
      staticClass: "control-label"
    }, [_vm._v("Recoup amount")]), _vm._v(" "), _c('span', {
      staticClass: "dflex align-center"
    }, [_c('input', {
      staticClass: "form-control",
      attrs: {
        "type": "text"
      }
    })])])], 1), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "option-content": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "sm6": "",
        "md3": ""
      }
    }, [_c('label', {
      staticClass: "control-label"
    }, [_vm._v("Collaborator")]), _vm._v(" "), _c('v-select', {
      staticClass: "pt-0",
      attrs: {
        "items": _vm.potential_collaborators,
        "item-text": "username",
        "item-value": "id",
        "placeholder": "Type name to search",
        "chips": "",
        "no-data-text": "No artist found",
        "autocomplete": ""
      },
      scopedSlots: _vm._u([{
        key: "selection",
        fn: function(data) {
          return [_c('v-chip', {
            key: JSON.stringify(data.item),
            staticClass: "chip--select-multi",
            attrs: {
              "selected": data.selected
            },
            on: {
              "input": function($event) {
                data.parent.selectItem(data.item)
              }
            }
          }, [_c('v-avatar', [_c('img', {
            attrs: {
              "src": data.item.avatar.thumb.url
            }
          })]), _vm._v("\n                                  " + _vm._s(data.item.username) + "\n                                ")], 1)]
        }
      }, {
        key: "item",
        fn: function(data) {
          return [(typeof data.item !== 'object') ? [_c('v-list-tile-content', {
            domProps: {
              "textContent": _vm._s(data.item)
            }
          })] : [_c('v-list-tile-avatar', [_c('img', {
            attrs: {
              "src": data.item.avatar.thumb.url
            }
          })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
            domProps: {
              "innerHTML": _vm._s(data.item.username)
            }
          })], 1)]]
        }
      }]),
      model: {
        value: (collaborator.user_id),
        callback: function($$v) {
          _vm.$set(collaborator, "user_id", $$v)
        },
        expression: "collaborator.user_id"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm6": "",
        "md3": ""
      }
    }, [_c('label', {
      staticClass: "control-label"
    }, [_vm._v("Role")]), _vm._v(" "), _c('span', {
      staticClass: "dflex align-center"
    }, [_c('v-select', {
      staticClass: "pt-0",
      attrs: {
        "items": _vm.role_types,
        "item-text": "name",
        "item-value": "name",
        "placeholder": "Type name to search",
        "autocomplete": ""
      },
      model: {
        value: (collaborator.user_role),
        callback: function($$v) {
          _vm.$set(collaborator, "user_role", $$v)
        },
        expression: "collaborator.user_role"
      }
    })], 1)]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm6": "",
        "md3": ""
      }
    }, [_c('label', {
      staticClass: "control-label"
    }, [_vm._v("Profit split")]), _vm._v(" "), _c('span', {
      staticClass: "dflex align-center"
    }, [_c('input', {
      staticClass: "form-control",
      attrs: {
        "type": "text"
      }
    })])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm6": "",
        "md3": ""
      }
    }, [_c('label', {
      staticClass: "control-label"
    }, [_vm._v("Recoup amount")]), _vm._v(" "), _c('span', {
      staticClass: "dflex align-center"
    }, [_c('input', {
      staticClass: "form-control",
      attrs: {
        "type": "text"
      }
    }), _vm._v(" "), _c('v-icon', {
      staticClass: "clear-btn mb-15",
      on: {
        "click": function($event) {
          _vm.deleteCollaborator(index)
        }
      }
    }, [_vm._v("\n                                clear\n                              ")])], 1)])], 1)], 1)
  }))], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "additional-info-section",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "pa-0": ""
    }
  }, [_c('v-flex', {
    staticClass: "my-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "dflex": "",
      "align-center": "",
      "pa-0": "",
      "my-0": ""
    }
  }, [_c('h4', {
    staticClass: "album-info-title-x mb-0 mr-2"
  }, [_vm._v("\n                            Album Credits (" + _vm._s(_vm.contributors.length) + ")\n                          ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "add-option-btn ma-0",
    nativeOn: {
      "click": function($event) {
        _vm.addContributor()
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "pa-0": ""
    }
  }, _vm._l((_vm.contributors), function(contirbutor, index) {
    return _c('v-layout', {
      key: index,
      attrs: {
        "row": "",
        "option-content": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md6": "",
        "lg3": ""
      }
    }, [_c('label', {
      staticClass: "control-label"
    }, [_vm._v(" Contributor ")]), _vm._v(" "), _c('v-select', {
      staticClass: "pt-0",
      attrs: {
        "items": _vm.potential_contributors,
        "item-text": "username",
        "item-value": "id",
        "placeholder": "Type name to search",
        "chips": "",
        "no-data-text": "No user found",
        "autocomplete": "",
        "clearable": ""
      },
      scopedSlots: _vm._u([{
        key: "selection",
        fn: function(data) {
          return [_c('v-chip', {
            key: JSON.stringify(data.item),
            staticClass: "chip--select-multi",
            attrs: {
              "selected": data.selected
            },
            on: {
              "input": function($event) {
                data.parent.selectItem(data.item)
              }
            }
          }, [_c('v-avatar', [_c('img', {
            attrs: {
              "src": data.item.avatar.thumb.url
            }
          })]), _vm._v("\n                                " + _vm._s(data.item.username) + "\n                              ")], 1)]
        }
      }, {
        key: "item",
        fn: function(data) {
          return [(typeof data.item !== 'object') ? [_c('v-list-tile-content', {
            domProps: {
              "textContent": _vm._s(data.item)
            }
          })] : [_c('v-list-tile-avatar', [_c('img', {
            attrs: {
              "src": data.item.avatar.thumb.url
            }
          })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
            domProps: {
              "innerHTML": _vm._s(data.item.username)
            }
          })], 1)]]
        }
      }]),
      model: {
        value: (contirbutor.user_id),
        callback: function($$v) {
          _vm.$set(contirbutor, "user_id", $$v)
        },
        expression: "contirbutor.user_id"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "md6": "",
        "lg3": ""
      }
    }, [_c('label', {
      staticClass: "control-label"
    }, [_vm._v(" Role ")]), _vm._v(" "), _c('span', {
      staticClass: "dflex align-center"
    }, [_c('v-select', {
      staticClass: "pt-0",
      attrs: {
        "items": _vm.role_types,
        "item-text": "name",
        "item-value": "name",
        "placeholder": "Type name to search",
        "autocomplete": ""
      },
      model: {
        value: (contirbutor.user_role),
        callback: function($$v) {
          _vm.$set(contirbutor, "user_role", $$v)
        },
        expression: "contirbutor.user_role"
      }
    }), _vm._v(" "), _c('v-icon', {
      staticClass: "clear-btn mb-4",
      on: {
        "click": function($event) {
          _vm.deleteContributor(index)
        }
      }
    }, [_vm._v("\n                              clear\n                            ")])], 1)])], 1)
  }))], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mx-5",
    attrs: {
      "xs12": "",
      "album-action-section": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm-6": "",
      "text-xs-left": "",
      "mb-5": ""
    }
  }, [_c('v-btn', {
    staticClass: "release-now-btn white--text",
    attrs: {
      "flat": "",
      "loading": _vm.loading,
      "disabled": _vm.slug ? !_vm.isAvailableToEditAlbum : !_vm.isAvailableToUploadAlbum
    },
    nativeOn: {
      "click": function($event) {
        _vm.releaseNow()
      }
    }
  }, [_vm._v("\n                  Release\n                ")]), _vm._v(" "), (false) ? _c('v-btn', {
    staticClass: "save-for-later-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.saveForLater()
      }
    }
  }, [_vm._v("\n                  Save for later\n                ")]) : _vm._e()], 1)], 1)], 1)], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "my-dialog-1 large"
    },
    model: {
      value: (_vm.show_sample_clearance_license_modal),
      callback: function($$v) {
        _vm.show_sample_clearance_license_modal = $$v
      },
      expression: "show_sample_clearance_license_modal"
    }
  }, [_c('sample-license-dialog', {
    attrs: {
      "dismiss": _vm.closeSampleClearanceLicenseModal
    }
  })], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "my-genre-dialog ma-0 pa-2"
    },
    model: {
      value: (_vm.show_genre_selector_dialog),
      callback: function($$v) {
        _vm.show_genre_selector_dialog = $$v
      },
      expression: "show_genre_selector_dialog"
    }
  }, [_c('genre-single-selector', {
    attrs: {
      "dismiss": _vm.closeGenreSelectorDialog
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', {
    staticClass: "album-info-title mt-2"
  }, [_vm._v("Info")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', {
    staticClass: "album-info-title"
  }, [_vm._v("Options")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', {
    staticClass: "album-info-title"
  }, [_vm._v("Collaborators")])])
}]}

/***/ }),
/* 1880 */,
/* 1881 */,
/* 1882 */,
/* 1883 */,
/* 1884 */,
/* 1885 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./404": [
		327
	],
	"./404.vue": [
		327
	],
	"./BannerUpload/index": [
		54
	],
	"./BannerUpload/index.vue": [
		54
	],
	"./LoginPage/index": [
		328
	],
	"./LoginPage/index.vue": [
		328
	],
	"./LogoutModal/index": [
		98
	],
	"./LogoutModal/index.vue": [
		98
	],
	"./LogoutModal/logout.scss": [
		1893,
		179
	],
	"./Playlists/addToPlaylist": [
		120
	],
	"./Playlists/addToPlaylist.vue": [
		120
	],
	"./Playlists/playlist": [
		329
	],
	"./Playlists/playlist.vue": [
		329
	],
	"./SignUpPage/index": [
		330
	],
	"./SignUpPage/index.vue": [
		330
	],
	"./UpgradeModal/index": [
		227
	],
	"./UpgradeModal/index.vue": [
		227
	],
	"./activity/index": [
		150
	],
	"./activity/index.ctrl": [
		656,
		169
	],
	"./activity/index.ctrl.js": [
		656,
		169
	],
	"./activity/index.vue": [
		150
	],
	"./admin/admin": [
		331
	],
	"./admin/admin.ctrl": [
		657,
		168
	],
	"./admin/admin.ctrl.js": [
		657,
		168
	],
	"./admin/admin.scss": [
		1894,
		178
	],
	"./admin/admin.vue": [
		331
	],
	"./admin/components/album_detail_dialog": [
		228
	],
	"./admin/components/album_detail_dialog.ctrl": [
		658,
		167
	],
	"./admin/components/album_detail_dialog.ctrl.js": [
		658,
		167
	],
	"./admin/components/album_detail_dialog.vue": [
		228
	],
	"./admin/components/albums": [
		229
	],
	"./admin/components/albums.ctrl": [
		659,
		166
	],
	"./admin/components/albums.ctrl.js": [
		659,
		166
	],
	"./admin/components/albums.vue": [
		229
	],
	"./admin/components/attendees": [
		230
	],
	"./admin/components/attendees.ctrl": [
		660,
		165
	],
	"./admin/components/attendees.ctrl.js": [
		660,
		165
	],
	"./admin/components/attendees.vue": [
		230
	],
	"./admin/components/general.scss": [
		1895,
		177
	],
	"./admin/components/genres": [
		231
	],
	"./admin/components/genres.ctrl": [
		661,
		164
	],
	"./admin/components/genres.ctrl.js": [
		661,
		164
	],
	"./admin/components/genres.vue": [
		231
	],
	"./admin/components/global_stats": [
		232
	],
	"./admin/components/global_stats.ctrl": [
		662,
		163
	],
	"./admin/components/global_stats.ctrl.js": [
		662,
		163
	],
	"./admin/components/global_stats.vue": [
		232
	],
	"./admin/components/payments": [
		233
	],
	"./admin/components/payments.ctrl": [
		663,
		162
	],
	"./admin/components/payments.ctrl.js": [
		663,
		162
	],
	"./admin/components/payments.vue": [
		233
	],
	"./admin/components/product_detail_dialog": [
		234
	],
	"./admin/components/product_detail_dialog.ctrl": [
		664,
		161
	],
	"./admin/components/product_detail_dialog.ctrl.js": [
		664,
		161
	],
	"./admin/components/product_detail_dialog.vue": [
		234
	],
	"./admin/components/settings": [
		235
	],
	"./admin/components/settings.ctrl": [
		665,
		160
	],
	"./admin/components/settings.ctrl.js": [
		665,
		160
	],
	"./admin/components/settings.vue": [
		235
	],
	"./admin/components/signup_approve_modal": [
		137
	],
	"./admin/components/signup_approve_modal.ctrl": [
		666,
		159
	],
	"./admin/components/signup_approve_modal.ctrl.js": [
		666,
		159
	],
	"./admin/components/signup_approve_modal.vue": [
		137
	],
	"./admin/components/signup_deny_modal": [
		138
	],
	"./admin/components/signup_deny_modal.vue": [
		138
	],
	"./admin/components/signups": [
		236
	],
	"./admin/components/signups.ctrl": [
		667,
		158
	],
	"./admin/components/signups.ctrl.js": [
		667,
		158
	],
	"./admin/components/signups.vue": [
		236
	],
	"./admin/components/streams": [
		237
	],
	"./admin/components/streams.ctrl": [
		668,
		157
	],
	"./admin/components/streams.ctrl.js": [
		668,
		157
	],
	"./admin/components/streams.vue": [
		237
	],
	"./admin/components/subscriptions": [
		238
	],
	"./admin/components/subscriptions.ctrl": [
		669,
		156
	],
	"./admin/components/subscriptions.ctrl.js": [
		669,
		156
	],
	"./admin/components/subscriptions.vue": [
		238
	],
	"./admin/components/users": [
		239
	],
	"./admin/components/users.ctrl": [
		670,
		155
	],
	"./admin/components/users.ctrl.js": [
		670,
		155
	],
	"./admin/components/users.vue": [
		239
	],
	"./album/album": [
		790,
		44
	],
	"./album/album.ctrl": [
		671,
		53
	],
	"./album/album.ctrl.js": [
		671,
		53
	],
	"./album/album.vue": [
		790,
		44
	],
	"./album/album_edit": [
		332
	],
	"./album/album_edit.ctrl": [
		672,
		154
	],
	"./album/album_edit.ctrl.js": [
		672,
		154
	],
	"./album/album_edit.vue": [
		332
	],
	"./album/album_stats": [
		333
	],
	"./album/album_stats.ctrl": [
		673,
		153
	],
	"./album/album_stats.ctrl.js": [
		673,
		153
	],
	"./album/album_stats.vue": [
		333
	],
	"./album/components/album": [
		240
	],
	"./album/components/album.vue": [
		240
	],
	"./album/components/albumList": [
		241
	],
	"./album/components/albumList.vue": [
		241
	],
	"./album/components/manageAlbum": [
		242
	],
	"./album/components/manageAlbum.ctrl": [
		674,
		152
	],
	"./album/components/manageAlbum.ctrl.js": [
		674,
		152
	],
	"./album/components/manageAlbum.vue": [
		242
	],
	"./album/components/nav": [
		139
	],
	"./album/components/nav.ctrl": [
		675,
		151
	],
	"./album/components/nav.ctrl.js": [
		675,
		151
	],
	"./album/components/nav.vue": [
		139
	],
	"./album/components/sample_license_dialog": [
		133
	],
	"./album/components/sample_license_dialog.vue": [
		133
	],
	"./album/index": [
		189
	],
	"./album/index.ctrl": [
		676,
		150
	],
	"./album/index.ctrl.js": [
		676,
		150
	],
	"./album/index.vue": [
		189
	],
	"./album/manage": [
		334
	],
	"./album/manage.ctrl": [
		677,
		149
	],
	"./album/manage.ctrl.js": [
		677,
		149
	],
	"./album/manage.vue": [
		334
	],
	"./album/playlist": [
		335
	],
	"./album/playlist.ctrl": [
		678,
		148
	],
	"./album/playlist.ctrl.js": [
		678,
		148
	],
	"./album/playlist.vue": [
		335
	],
	"./album/upload_album": [
		336
	],
	"./album/upload_album.ctrl": [
		679,
		147
	],
	"./album/upload_album.ctrl.js": [
		679,
		147
	],
	"./album/upload_album.vue": [
		336
	],
	"./analyticsModal/index": [
		243
	],
	"./analyticsModal/index.vue": [
		243
	],
	"./auth/authTab/authTab.ctrl": [
		680,
		146
	],
	"./auth/authTab/authTab.ctrl.js": [
		680,
		146
	],
	"./auth/authTab/index": [
		337
	],
	"./auth/authTab/index.vue": [
		337
	],
	"./auth/confirmation": [
		338
	],
	"./auth/confirmation.ctrl": [
		681,
		145
	],
	"./auth/confirmation.ctrl.js": [
		681,
		145
	],
	"./auth/confirmation.vue": [
		338
	],
	"./auth/forgotPasswordInput": [
		99
	],
	"./auth/forgotPasswordInput.vue": [
		99
	],
	"./auth/forgot_password": [
		339
	],
	"./auth/forgot_password.ctrl": [
		682,
		144
	],
	"./auth/forgot_password.ctrl.js": [
		682,
		144
	],
	"./auth/forgot_password.vue": [
		339
	],
	"./auth/login": [
		340
	],
	"./auth/login.ctrl": [
		683,
		143
	],
	"./auth/login.ctrl.js": [
		683,
		143
	],
	"./auth/login.vue": [
		340
	],
	"./auth/loginInput": [
		100
	],
	"./auth/loginInput.vue": [
		100
	],
	"./auth/protect_page": [
		341
	],
	"./auth/protect_page.vue": [
		341
	],
	"./auth/register_as": [
		791,
		69
	],
	"./auth/register_as.ctrl": [
		684,
		142
	],
	"./auth/register_as.ctrl.js": [
		684,
		142
	],
	"./auth/register_as.vue": [
		791,
		69
	],
	"./auth/register_by_artist": [
		792,
		68
	],
	"./auth/register_by_artist.ctrl": [
		685,
		141
	],
	"./auth/register_by_artist.ctrl.js": [
		685,
		141
	],
	"./auth/register_by_artist.vue": [
		792,
		68
	],
	"./auth/register_by_attendee": [
		793,
		67
	],
	"./auth/register_by_attendee.ctrl": [
		686,
		140
	],
	"./auth/register_by_attendee.ctrl.js": [
		686,
		140
	],
	"./auth/register_by_attendee.vue": [
		793,
		67
	],
	"./auth/register_by_brand": [
		794,
		66
	],
	"./auth/register_by_brand.ctrl": [
		687,
		139
	],
	"./auth/register_by_brand.ctrl.js": [
		687,
		139
	],
	"./auth/register_by_brand.vue": [
		794,
		66
	],
	"./auth/register_by_invited": [
		244
	],
	"./auth/register_by_invited.ctrl": [
		688,
		138
	],
	"./auth/register_by_invited.ctrl.js": [
		688,
		138
	],
	"./auth/register_by_invited.vue": [
		244
	],
	"./auth/register_by_label": [
		795,
		65
	],
	"./auth/register_by_label.ctrl": [
		689,
		137
	],
	"./auth/register_by_label.ctrl.js": [
		689,
		137
	],
	"./auth/register_by_label.vue": [
		795,
		65
	],
	"./auth/register_by_listener": [
		245
	],
	"./auth/register_by_listener.ctrl": [
		690,
		136
	],
	"./auth/register_by_listener.ctrl.js": [
		690,
		136
	],
	"./auth/register_by_listener.vue": [
		245
	],
	"./auth/reset_password": [
		342
	],
	"./auth/reset_password.ctrl": [
		691,
		135
	],
	"./auth/reset_password.ctrl.js": [
		691,
		135
	],
	"./auth/reset_password.vue": [
		342
	],
	"./auth/social_verify": [
		343
	],
	"./auth/social_verify.ctrl": [
		692,
		134
	],
	"./auth/social_verify.ctrl.js": [
		692,
		134
	],
	"./auth/social_verify.vue": [
		343
	],
	"./auth/twitter_callback": [
		344
	],
	"./auth/twitter_callback.ctrl": [
		693,
		133
	],
	"./auth/twitter_callback.ctrl.js": [
		693,
		133
	],
	"./auth/twitter_callback.vue": [
		344
	],
	"./auth/twitter_confirm": [
		345
	],
	"./auth/twitter_confirm.ctrl": [
		694,
		132
	],
	"./auth/twitter_confirm.ctrl.js": [
		694,
		132
	],
	"./auth/twitter_confirm.vue": [
		345
	],
	"./cart/cart": [
		346
	],
	"./cart/cart.ctrl": [
		695,
		131
	],
	"./cart/cart.ctrl.js": [
		695,
		131
	],
	"./cart/cart.vue": [
		346
	],
	"./cart/checkout": [
		347
	],
	"./cart/checkout.ctrl": [
		696,
		130
	],
	"./cart/checkout.ctrl.js": [
		696,
		130
	],
	"./cart/checkout.vue": [
		347
	],
	"./cart/components/ticket_new_dialog": [
		246
	],
	"./cart/components/ticket_new_dialog.vue": [
		246
	],
	"./chartPage/chartPage.scss": [
		1896,
		176
	],
	"./chartPage/index": [
		348
	],
	"./chartPage/index.ctrl": [
		697,
		129
	],
	"./chartPage/index.ctrl.js": [
		697,
		129
	],
	"./chartPage/index.vue": [
		348
	],
	"./chat/chat": [
		349
	],
	"./chat/chat.ctrl": [
		698,
		128
	],
	"./chat/chat.ctrl.js": [
		698,
		128
	],
	"./chat/chat.vue": [
		349
	],
	"./collection/index": [
		350
	],
	"./collection/index.ctrl": [
		699,
		127
	],
	"./collection/index.ctrl.js": [
		699,
		127
	],
	"./collection/index.vue": [
		350
	],
	"./collection/repostMusic": [
		247
	],
	"./collection/repostMusic.vue": [
		247
	],
	"./collection/repostProducts": [
		248
	],
	"./collection/repostProducts.vue": [
		248
	],
	"./collection/repostVideos": [
		249
	],
	"./collection/repostVideos.vue": [
		249
	],
	"./dashboard/dashboard.ctrl": [
		700,
		126
	],
	"./dashboard/dashboard.ctrl.js": [
		700,
		126
	],
	"./dashboard/index": [
		351
	],
	"./dashboard/index.vue": [
		351
	],
	"./discover/_index": [
		796,
		54
	],
	"./discover/_index.ctrl": [
		701,
		125
	],
	"./discover/_index.ctrl.js": [
		701,
		125
	],
	"./discover/_index.vue": [
		796,
		54
	],
	"./discover/index": [
		797,
		64
	],
	"./discover/index.ctrl": [
		702,
		124
	],
	"./discover/index.ctrl.js": [
		702,
		124
	],
	"./discover/index.vue": [
		797,
		64
	],
	"./featureModal/feature.scss": [
		1897,
		175
	],
	"./featureModal/index": [
		352
	],
	"./featureModal/index.vue": [
		352
	],
	"./feed/index": [
		798,
		39
	],
	"./feed/index.ctrl": [
		703,
		41
	],
	"./feed/index.ctrl.js": [
		703,
		41
	],
	"./feed/index.vue": [
		798,
		39
	],
	"./getPaidToShare/getPaidToShare.ctrl": [
		704,
		123
	],
	"./getPaidToShare/getPaidToShare.ctrl.js": [
		704,
		123
	],
	"./getPaidToShare/index": [
		140
	],
	"./getPaidToShare/index.vue": [
		140
	],
	"./home/add_attendee": [
		353
	],
	"./home/add_attendee.ctrl": [
		705,
		122
	],
	"./home/add_attendee.ctrl.js": [
		705,
		122
	],
	"./home/add_attendee.vue": [
		353
	],
	"./home/artist_landing": [
		799,
		63
	],
	"./home/artist_landing.ctrl": [
		706,
		121
	],
	"./home/artist_landing.ctrl.js": [
		706,
		121
	],
	"./home/artist_landing.vue": [
		799,
		63
	],
	"./home/browser": [
		170
	],
	"./home/browser.vue": [
		170
	],
	"./home/components/album_card": [
		800,
		74
	],
	"./home/components/album_card.vue": [
		800,
		74
	],
	"./home/components/landing_card": [
		639,
		73
	],
	"./home/components/landing_card.vue": [
		639,
		73
	],
	"./home/components/playlist_card": [
		801,
		72
	],
	"./home/components/playlist_card.vue": [
		801,
		72
	],
	"./home/components/product_card": [
		802,
		71
	],
	"./home/components/product_card.vue": [
		802,
		71
	],
	"./home/components/video_card": [
		803,
		70
	],
	"./home/components/video_card.vue": [
		803,
		70
	],
	"./home/create_attendee": [
		804,
		62
	],
	"./home/create_attendee.ctrl": [
		707,
		120
	],
	"./home/create_attendee.ctrl.js": [
		707,
		120
	],
	"./home/create_attendee.vue": [
		804,
		62
	],
	"./home/landing": [
		805,
		50
	],
	"./home/landing.ctrl": [
		708,
		59
	],
	"./home/landing.ctrl.js": [
		708,
		59
	],
	"./home/landing.vue": [
		805,
		50
	],
	"./home/main_landing": [
		806,
		61
	],
	"./home/main_landing.ctrl": [
		709,
		119
	],
	"./home/main_landing.ctrl.js": [
		709,
		119
	],
	"./home/main_landing.vue": [
		806,
		61
	],
	"./label/components/album": [
		250
	],
	"./label/components/album.vue": [
		250
	],
	"./label/components/user": [
		251
	],
	"./label/components/user.vue": [
		251
	],
	"./label/manage": [
		354
	],
	"./label/manage.ctrl": [
		710,
		118
	],
	"./label/manage.ctrl.js": [
		710,
		118
	],
	"./label/manage.vue": [
		354
	],
	"./landing-new/components/FooterLandingPage": [
		167
	],
	"./landing-new/components/FooterLandingPage.vue": [
		167
	],
	"./landing-new/components/ForCreators": [
		355
	],
	"./landing-new/components/ForCreators.vue": [
		355
	],
	"./landing-new/components/FqaPage": [
		807,
		48
	],
	"./landing-new/components/FqaPage.vue": [
		807,
		48
	],
	"./landing-new/components/RevenueCalculator": [
		356
	],
	"./landing-new/components/RevenueCalculator.vue": [
		356
	],
	"./landing-new/components/UpgradePlan": [
		168
	],
	"./landing-new/components/UpgradePlan.vue": [
		168
	],
	"./landing-new/index": [
		357
	],
	"./landing-new/index.vue": [
		357
	],
	"./landing-x/index": [
		808,
		47
	],
	"./landing-x/index.vue": [
		808,
		47
	],
	"./landing/components/footer": [
		640,
		57
	],
	"./landing/components/footer.vue": [
		640,
		57
	],
	"./landing/components/header": [
		641,
		58
	],
	"./landing/components/header.vue": [
		641,
		58
	],
	"./landing/landing": [
		809,
		38
	],
	"./landing/landing.vue": [
		809,
		38
	],
	"./landing/landing1": [
		810,
		40
	],
	"./landing/landing1.vue": [
		810,
		40
	],
	"./landingPages/landing1": [
		358
	],
	"./landingPages/landing1.vue": [
		358
	],
	"./landingPages/landing2": [
		359
	],
	"./landingPages/landing2.vue": [
		359
	],
	"./landingPages/landing3": [
		360
	],
	"./landingPages/landing3.vue": [
		360
	],
	"./manage/index": [
		361
	],
	"./manage/index.ctrl": [
		711,
		42
	],
	"./manage/index.ctrl.js": [
		711,
		42
	],
	"./manage/index.vue": [
		361
	],
	"./membership/index": [
		811,
		46
	],
	"./membership/index.ctrl": [
		712,
		75
	],
	"./membership/index.ctrl.js": [
		712,
		75
	],
	"./membership/index.vue": [
		811,
		46
	],
	"./messages/components/message": [
		141
	],
	"./messages/components/message.vue": [
		141
	],
	"./messages/index": [
		252
	],
	"./messages/index.ctrl": [
		713,
		117
	],
	"./messages/index.ctrl.js": [
		713,
		117
	],
	"./messages/index.vue": [
		252
	],
	"./mobile/QR/index": [
		121
	],
	"./mobile/QR/index.vue": [
		121
	],
	"./mobile/album/album": [
		253,
		11
	],
	"./mobile/album/album.vue": [
		253,
		11
	],
	"./mobile/album/show": [
		254,
		10
	],
	"./mobile/album/show.ctrl": [
		213,
		13
	],
	"./mobile/album/show.ctrl.js": [
		213,
		13
	],
	"./mobile/album/show.vue": [
		254,
		10
	],
	"./mobile/auth/activation/index": [
		122
	],
	"./mobile/auth/activation/index.ctrl": [
		214,
		37
	],
	"./mobile/auth/activation/index.ctrl.js": [
		214,
		37
	],
	"./mobile/auth/activation/index.vue": [
		122
	],
	"./mobile/auth/confirmation": [
		123
	],
	"./mobile/auth/confirmation.vue": [
		123
	],
	"./mobile/auth/learnMore": [
		74
	],
	"./mobile/auth/learnMore.vue": [
		74
	],
	"./mobile/auth/onboarding/accountInfo": [
		101
	],
	"./mobile/auth/onboarding/accountInfo.vue": [
		101
	],
	"./mobile/auth/onboarding/accountType": [
		102
	],
	"./mobile/auth/onboarding/accountType.vue": [
		102
	],
	"./mobile/auth/onboarding/ageLocation": [
		103
	],
	"./mobile/auth/onboarding/ageLocation.vue": [
		103
	],
	"./mobile/auth/onboarding/authPlan": [
		48
	],
	"./mobile/auth/onboarding/authPlan.vue": [
		48
	],
	"./mobile/auth/onboarding/checkEmail": [
		75
	],
	"./mobile/auth/onboarding/checkEmail.vue": [
		75
	],
	"./mobile/auth/onboarding/chooseAccount": [
		104
	],
	"./mobile/auth/onboarding/chooseAccount.vue": [
		104
	],
	"./mobile/auth/onboarding/confirmEmail": [
		105
	],
	"./mobile/auth/onboarding/confirmEmail.vue": [
		105
	],
	"./mobile/auth/onboarding/getVerified": [
		106
	],
	"./mobile/auth/onboarding/getVerified.vue": [
		106
	],
	"./mobile/auth/onboarding/index": [
		62
	],
	"./mobile/auth/onboarding/index.ctrl": [
		215,
		36
	],
	"./mobile/auth/onboarding/index.ctrl.js": [
		215,
		36
	],
	"./mobile/auth/onboarding/index.vue": [
		62
	],
	"./mobile/auth/onboarding/navFooter": [
		255,
		20
	],
	"./mobile/auth/onboarding/navFooter.vue": [
		255,
		20
	],
	"./mobile/auth/onboarding/profileImage": [
		107
	],
	"./mobile/auth/onboarding/profileImage.vue": [
		107
	],
	"./mobile/auth/reset_password": [
		256,
		33
	],
	"./mobile/auth/reset_password.vue": [
		256,
		33
	],
	"./mobile/auth/stager": [
		73
	],
	"./mobile/auth/stager.vue": [
		73
	],
	"./mobile/components/audio_player": [
		181,
		32
	],
	"./mobile/components/audio_player.vue": [
		181,
		32
	],
	"./mobile/components/contacts/directory": [
		90
	],
	"./mobile/components/contacts/directory.vue": [
		90
	],
	"./mobile/components/contacts/index": [
		178,
		31
	],
	"./mobile/components/contacts/index.vue": [
		178,
		31
	],
	"./mobile/components/footer": [
		86
	],
	"./mobile/components/footer.vue": [
		86
	],
	"./mobile/components/header": [
		64
	],
	"./mobile/components/header.vue": [
		64
	],
	"./mobile/components/header_dep": [
		257,
		30
	],
	"./mobile/components/header_dep.vue": [
		257,
		30
	],
	"./mobile/components/menu": [
		172,
		29
	],
	"./mobile/components/menu.vue": [
		172,
		29
	],
	"./mobile/components/mobileComments": [
		69
	],
	"./mobile/components/mobileComments.vue": [
		69
	],
	"./mobile/components/paneTabs": [
		179,
		28
	],
	"./mobile/components/paneTabs.vue": [
		179,
		28
	],
	"./mobile/components/search": [
		124
	],
	"./mobile/components/search.vue": [
		124
	],
	"./mobile/components/tab_nav": [
		173,
		27
	],
	"./mobile/components/tab_nav.vue": [
		173,
		27
	],
	"./mobile/components/timeline/timeline": [
		182,
		17
	],
	"./mobile/components/timeline/timeline.ctrl": [
		216,
		35
	],
	"./mobile/components/timeline/timeline.ctrl.js": [
		216,
		35
	],
	"./mobile/components/timeline/timeline.vue": [
		182,
		17
	],
	"./mobile/components/trending/music": [
		108
	],
	"./mobile/components/trending/music.vue": [
		108
	],
	"./mobile/components/trending/products": [
		109
	],
	"./mobile/components/trending/products.vue": [
		109
	],
	"./mobile/components/trending/videos": [
		110
	],
	"./mobile/components/trending/videos.vue": [
		110
	],
	"./mobile/discover/index": [
		258,
		2
	],
	"./mobile/discover/index.vue": [
		258,
		2
	],
	"./mobile/discover/music": [
		190,
		18
	],
	"./mobile/discover/music.vue": [
		190,
		18
	],
	"./mobile/discover/product": [
		191,
		26
	],
	"./mobile/discover/product.vue": [
		191,
		26
	],
	"./mobile/discover/video": [
		192,
		25
	],
	"./mobile/discover/video.vue": [
		192,
		25
	],
	"./mobile/feed/index": [
		259,
		3
	],
	"./mobile/feed/index.ctrl": [
		217,
		5
	],
	"./mobile/feed/index.ctrl.js": [
		217,
		5
	],
	"./mobile/feed/index.vue": [
		259,
		3
	],
	"./mobile/landing/components/stepper": [
		193,
		24
	],
	"./mobile/landing/components/stepper.vue": [
		193,
		24
	],
	"./mobile/landing/landing": [
		260,
		6
	],
	"./mobile/landing/landing.vue": [
		260,
		6
	],
	"./mobile/landing/landing1": [
		261,
		9
	],
	"./mobile/landing/landing1.vue": [
		261,
		9
	],
	"./mobile/landingPages/landing1": [
		262,
		23
	],
	"./mobile/landingPages/landing1.vue": [
		262,
		23
	],
	"./mobile/messages/SMS/index": [
		183,
		12
	],
	"./mobile/messages/SMS/index.vue": [
		183,
		12
	],
	"./mobile/messages/SMS/smsEngagement": [
		125
	],
	"./mobile/messages/SMS/smsEngagement.vue": [
		125
	],
	"./mobile/messages/conversations/components/DM": [
		175,
		8
	],
	"./mobile/messages/conversations/components/DM.vue": [
		175,
		8
	],
	"./mobile/messages/conversations/components/message": [
		171,
		21
	],
	"./mobile/messages/conversations/components/message.vue": [
		171,
		21
	],
	"./mobile/messages/conversations/index": [
		184,
		4
	],
	"./mobile/messages/conversations/index.ctrl": [
		218,
		7
	],
	"./mobile/messages/conversations/index.ctrl.js": [
		218,
		7
	],
	"./mobile/messages/conversations/index.vue": [
		184,
		4
	],
	"./mobile/messages/index": [
		263,
		0
	],
	"./mobile/messages/index.ctrl": [
		219,
		1
	],
	"./mobile/messages/index.ctrl.js": [
		219,
		1
	],
	"./mobile/messages/index.vue": [
		263,
		0
	],
	"./mobile/product/show": [
		264,
		16
	],
	"./mobile/product/show.vue": [
		264,
		16
	],
	"./mobile/search/search": [
		265,
		19
	],
	"./mobile/search/search.vue": [
		265,
		19
	],
	"./mobile/sell/single_product": [
		266,
		22
	],
	"./mobile/sell/single_product.ctrl": [
		220,
		34
	],
	"./mobile/sell/single_product.ctrl.js": [
		220,
		34
	],
	"./mobile/sell/single_product.vue": [
		266,
		22
	],
	"./mobile/terms/index": [
		267,
		15
	],
	"./mobile/terms/index.vue": [
		267,
		15
	],
	"./mobile/user/show": [
		268,
		14
	],
	"./mobile/user/show.vue": [
		268,
		14
	],
	"./new-mobile/cart": [
		362
	],
	"./new-mobile/cart.vue": [
		362
	],
	"./new-mobile/chat_room": [
		363
	],
	"./new-mobile/chat_room.vue": [
		363
	],
	"./new-mobile/checkout": [
		364
	],
	"./new-mobile/checkout.vue": [
		364
	],
	"./new-mobile/community": [
		365
	],
	"./new-mobile/community.vue": [
		365
	],
	"./new-mobile/components/card": [
		169
	],
	"./new-mobile/components/card.vue": [
		169
	],
	"./new-mobile/components/footer": [
		63
	],
	"./new-mobile/components/footer.vue": [
		63
	],
	"./new-mobile/components/plan-detail/payment": [
		366
	],
	"./new-mobile/components/plan-detail/payment.vue": [
		366
	],
	"./new-mobile/components/plan-detail/plan_detail": [
		367
	],
	"./new-mobile/components/plan-detail/plan_detail.vue": [
		367
	],
	"./new-mobile/components/plan-detail/success": [
		368
	],
	"./new-mobile/components/plan-detail/success.vue": [
		368
	],
	"./new-mobile/confirmation": [
		369
	],
	"./new-mobile/confirmation.vue": [
		369
	],
	"./new-mobile/discover": [
		370
	],
	"./new-mobile/discover.vue": [
		370
	],
	"./new-mobile/library": [
		371
	],
	"./new-mobile/library.vue": [
		371
	],
	"./new-mobile/messages": [
		372
	],
	"./new-mobile/messages.vue": [
		372
	],
	"./new-mobile/notification": [
		373
	],
	"./new-mobile/notification.vue": [
		373
	],
	"./new-mobile/plan": [
		374
	],
	"./new-mobile/plan.vue": [
		374
	],
	"./new-mobile/plan_detail": [
		375
	],
	"./new-mobile/plan_detail.vue": [
		375
	],
	"./new-mobile/player": [
		376
	],
	"./new-mobile/player.vue": [
		376
	],
	"./new-mobile/profile": [
		377
	],
	"./new-mobile/profile.vue": [
		377
	],
	"./new-mobile/spotlight": [
		378
	],
	"./new-mobile/spotlight.vue": [
		378
	],
	"./new-mobile/you": [
		379
	],
	"./new-mobile/you.vue": [
		379
	],
	"./notification/index": [
		380
	],
	"./notification/index.ctrl": [
		714,
		116
	],
	"./notification/index.ctrl.js": [
		714,
		116
	],
	"./notification/index.vue": [
		380
	],
	"./notifications/notifications.ctrl": [
		715,
		115
	],
	"./notifications/notifications.ctrl.js": [
		715,
		115
	],
	"./overview/components/features_tab": [
		269
	],
	"./overview/components/features_tab.vue": [
		269
	],
	"./overview/components/opportunity_tab": [
		270
	],
	"./overview/components/opportunity_tab.vue": [
		270
	],
	"./overview/components/product_tab": [
		271
	],
	"./overview/components/product_tab.vue": [
		271
	],
	"./overview/components/success_tab": [
		272
	],
	"./overview/components/success_tab.vue": [
		272
	],
	"./overview/components/team_tab": [
		273
	],
	"./overview/components/team_tab.vue": [
		273
	],
	"./overview/components/timeline_tab": [
		274
	],
	"./overview/components/timeline_tab.vue": [
		274
	],
	"./overview/index": [
		381
	],
	"./overview/index.ctrl": [
		716,
		114
	],
	"./overview/index.ctrl.js": [
		716,
		114
	],
	"./overview/index.vue": [
		381
	],
	"./partners/index": [
		382
	],
	"./partners/index.vue": [
		382
	],
	"./partners/partners.ctrl": [
		717,
		113
	],
	"./partners/partners.ctrl.js": [
		717,
		113
	],
	"./payments/components/order_refund_dialog": [
		275
	],
	"./payments/components/order_refund_dialog.vue": [
		275
	],
	"./payments/components/product": [
		276
	],
	"./payments/components/product.vue": [
		276
	],
	"./payments/components/shop_item": [
		383
	],
	"./payments/components/shop_item.vue": [
		383
	],
	"./payments/index": [
		151
	],
	"./payments/index.ctrl": [
		718,
		112
	],
	"./payments/index.ctrl.js": [
		718,
		112
	],
	"./payments/index.vue": [
		151
	],
	"./product/components/manageProduct": [
		649,
		60
	],
	"./product/components/manageProduct.ctrl": [
		719,
		111
	],
	"./product/components/manageProduct.ctrl.js": [
		719,
		111
	],
	"./product/components/manageProduct.vue": [
		649,
		60
	],
	"./product/index": [
		194
	],
	"./product/index.ctrl": [
		720,
		110
	],
	"./product/index.ctrl.js": [
		720,
		110
	],
	"./product/index.vue": [
		194
	],
	"./search/search": [
		812,
		43
	],
	"./search/search.ctrl": [
		721,
		52
	],
	"./search/search.ctrl.js": [
		721,
		52
	],
	"./search/search.vue": [
		812,
		43
	],
	"./sell/add_product": [
		384
	],
	"./sell/add_product.ctrl": [
		722,
		109
	],
	"./sell/add_product.ctrl.js": [
		722,
		109
	],
	"./sell/add_product.vue": [
		384
	],
	"./sell/components/collaborate_product": [
		185
	],
	"./sell/components/collaborate_product.vue": [
		185
	],
	"./sell/components/digital_uploader": [
		132
	],
	"./sell/components/digital_uploader.vue": [
		132
	],
	"./sell/components/nav": [
		277
	],
	"./sell/components/nav.ctrl": [
		723,
		108
	],
	"./sell/components/nav.ctrl.js": [
		723,
		108
	],
	"./sell/components/nav.vue": [
		277
	],
	"./sell/edit_product": [
		385
	],
	"./sell/edit_product.ctrl": [
		724,
		107
	],
	"./sell/edit_product.ctrl.js": [
		724,
		107
	],
	"./sell/edit_product.vue": [
		385
	],
	"./sell/orderdetail": [
		386
	],
	"./sell/orderdetail.ctrl": [
		725,
		106
	],
	"./sell/orderdetail.ctrl.js": [
		725,
		106
	],
	"./sell/orderdetail.vue": [
		386
	],
	"./sell/orderdetails.scss": [
		1898,
		174
	],
	"./sell/sell": [
		387
	],
	"./sell/sell.ctrl": [
		726,
		105
	],
	"./sell/sell.ctrl.js": [
		726,
		105
	],
	"./sell/sell.vue": [
		387
	],
	"./sell/single_product": [
		813,
		49
	],
	"./sell/single_product.ctrl": [
		727,
		104
	],
	"./sell/single_product.ctrl.js": [
		727,
		104
	],
	"./sell/single_product.vue": [
		813,
		49
	],
	"./settings/components/account_download": [
		278
	],
	"./settings/components/account_download.vue": [
		278
	],
	"./settings/components/account_subscription": [
		279
	],
	"./settings/components/account_subscription.ctrl": [
		728,
		103
	],
	"./settings/components/account_subscription.ctrl.js": [
		728,
		103
	],
	"./settings/components/account_subscription.vue": [
		279
	],
	"./settings/components/address_tab": [
		92
	],
	"./settings/components/address_tab.ctrl": [
		729,
		102
	],
	"./settings/components/address_tab.ctrl.js": [
		729,
		102
	],
	"./settings/components/address_tab.vue": [
		92
	],
	"./settings/components/genre_tab": [
		280
	],
	"./settings/components/genre_tab.ctrl": [
		730,
		101
	],
	"./settings/components/genre_tab.ctrl.js": [
		730,
		101
	],
	"./settings/components/genre_tab.vue": [
		280
	],
	"./settings/components/package_card": [
		281
	],
	"./settings/components/package_card.ctrl": [
		731,
		100
	],
	"./settings/components/package_card.ctrl.js": [
		731,
		100
	],
	"./settings/components/package_card.vue": [
		281
	],
	"./settings/components/policy_tab": [
		142
	],
	"./settings/components/policy_tab.ctrl": [
		732,
		99
	],
	"./settings/components/policy_tab.ctrl.js": [
		732,
		99
	],
	"./settings/components/policy_tab.vue": [
		142
	],
	"./settings/components/price_tab": [
		282
	],
	"./settings/components/price_tab.ctrl": [
		733,
		98
	],
	"./settings/components/price_tab.ctrl.js": [
		733,
		98
	],
	"./settings/components/price_tab.vue": [
		282
	],
	"./settings/components/subscription_plan": [
		283
	],
	"./settings/components/subscription_plan.ctrl": [
		734,
		97
	],
	"./settings/components/subscription_plan.ctrl.js": [
		734,
		97
	],
	"./settings/components/subscription_plan.vue": [
		283
	],
	"./settings/components/verify_tab": [
		284
	],
	"./settings/components/verify_tab.ctrl": [
		735,
		96
	],
	"./settings/components/verify_tab.ctrl.js": [
		735,
		96
	],
	"./settings/components/verify_tab.vue": [
		284
	],
	"./settings/index": [
		152
	],
	"./settings/index.ctrl": [
		736,
		95
	],
	"./settings/index.ctrl.js": [
		736,
		95
	],
	"./settings/index.vue": [
		152
	],
	"./spotlight/index": [
		388
	],
	"./spotlight/index.vue": [
		388
	],
	"./spotlight/spotlight.scss": [
		1899,
		173
	],
	"./subscribe/index": [
		389
	],
	"./subscribe/index.vue": [
		389
	],
	"./supportPage/index": [
		390
	],
	"./supportPage/index.vue": [
		390
	],
	"./terms/components/community_guidelines_tab": [
		201
	],
	"./terms/components/community_guidelines_tab.vue": [
		201
	],
	"./terms/components/cookie_policy_tab": [
		202
	],
	"./terms/components/cookie_policy_tab.vue": [
		202
	],
	"./terms/components/copyright_policy_tab": [
		203
	],
	"./terms/components/copyright_policy_tab.vue": [
		203
	],
	"./terms/components/gdpr_tab": [
		204
	],
	"./terms/components/gdpr_tab.vue": [
		204
	],
	"./terms/components/privacy_choice_tab": [
		205
	],
	"./terms/components/privacy_choice_tab.vue": [
		205
	],
	"./terms/components/privacy_policy_tab": [
		206
	],
	"./terms/components/privacy_policy_tab.vue": [
		206
	],
	"./terms/components/sample_clearance_tab": [
		207
	],
	"./terms/components/sample_clearance_tab.vue": [
		207
	],
	"./terms/components/terms_of_use_tab": [
		208
	],
	"./terms/components/terms_of_use_tab.vue": [
		208
	],
	"./terms/components/trademark_policy_tab": [
		209
	],
	"./terms/components/trademark_policy_tab.vue": [
		209
	],
	"./terms/index": [
		391
	],
	"./terms/index.ctrl": [
		737,
		94
	],
	"./terms/index.ctrl.js": [
		737,
		94
	],
	"./terms/index.vue": [
		391
	],
	"./topCreators/creator.ctrl": [
		738,
		93
	],
	"./topCreators/creator.ctrl.js": [
		738,
		93
	],
	"./topCreators/creator.scss": [
		1900,
		172
	],
	"./topCreators/index": [
		392
	],
	"./topCreators/index.vue": [
		392
	],
	"./upload/components/nav": [
		143
	],
	"./upload/components/nav.ctrl": [
		739,
		92
	],
	"./upload/components/nav.ctrl.js": [
		739,
		92
	],
	"./upload/components/nav.vue": [
		143
	],
	"./upload/index": [
		393
	],
	"./upload/index.ctrl": [
		740,
		91
	],
	"./upload/index.ctrl.js": [
		740,
		91
	],
	"./upload/index.vue": [
		393
	],
	"./user/direct_messages": [
		394
	],
	"./user/direct_messages.ctrl": [
		741,
		90
	],
	"./user/direct_messages.ctrl.js": [
		741,
		90
	],
	"./user/direct_messages.vue": [
		394
	],
	"./user/get_verified": [
		395
	],
	"./user/get_verified.ctrl": [
		742,
		89
	],
	"./user/get_verified.ctrl.js": [
		742,
		89
	],
	"./user/get_verified.vue": [
		395
	],
	"./user/members": [
		396
	],
	"./user/members.ctrl": [
		743,
		88
	],
	"./user/members.ctrl.js": [
		743,
		88
	],
	"./user/members.vue": [
		396
	],
	"./user/profile": [
		397
	],
	"./user/profile.ctrl": [
		744,
		87
	],
	"./user/profile.ctrl.js": [
		744,
		87
	],
	"./user/profile.vue": [
		397
	],
	"./user/stripe_connect": [
		398
	],
	"./user/stripe_connect.ctrl": [
		745,
		86
	],
	"./user/stripe_connect.ctrl.js": [
		745,
		86
	],
	"./user/stripe_connect.vue": [
		398
	],
	"./video/components/attach": [
		65
	],
	"./video/components/attach.vue": [
		65
	],
	"./video/components/attach_card": [
		399
	],
	"./video/components/attach_card.vue": [
		399
	],
	"./video/components/attach_picker": [
		131
	],
	"./video/components/attach_picker.vue": [
		131
	],
	"./video/components/digital_uploader": [
		144
	],
	"./video/components/digital_uploader.vue": [
		144
	],
	"./video/components/listVideo": [
		637,
		56
	],
	"./video/components/listVideo.vue": [
		637,
		56
	],
	"./video/components/manageVideo": [
		650,
		45
	],
	"./video/components/manageVideo.ctrl": [
		746,
		51
	],
	"./video/components/manageVideo.ctrl.js": [
		746,
		51
	],
	"./video/components/manageVideo.vue": [
		650,
		45
	],
	"./video/components/nav": [
		145
	],
	"./video/components/nav.ctrl": [
		747,
		85
	],
	"./video/components/nav.ctrl.js": [
		747,
		85
	],
	"./video/components/nav.vue": [
		145
	],
	"./video/components/user_box": [
		285
	],
	"./video/components/user_box.vue": [
		285
	],
	"./video/components/video-player.scss": [
		1901,
		171
	],
	"./video/components/video_box": [
		814,
		55
	],
	"./video/components/video_box.vue": [
		814,
		55
	],
	"./video/components/video_player": [
		286
	],
	"./video/components/video_player.vue": [
		286
	],
	"./video/create": [
		400
	],
	"./video/create.ctrl": [
		748,
		84
	],
	"./video/create.ctrl.js": [
		748,
		84
	],
	"./video/create.vue": [
		400
	],
	"./video/delete": [
		401
	],
	"./video/delete.ctrl": [
		749,
		83
	],
	"./video/delete.ctrl.js": [
		749,
		83
	],
	"./video/delete.vue": [
		401
	],
	"./video/edit": [
		402
	],
	"./video/edit.ctrl": [
		750,
		82
	],
	"./video/edit.ctrl.js": [
		750,
		82
	],
	"./video/edit.vue": [
		402
	],
	"./video/estimate": [
		153
	],
	"./video/estimate.ctrl": [
		751,
		81
	],
	"./video/estimate.ctrl.js": [
		751,
		81
	],
	"./video/estimate.vue": [
		153
	],
	"./video/index": [
		195
	],
	"./video/index.ctrl": [
		752,
		80
	],
	"./video/index.ctrl.js": [
		752,
		80
	],
	"./video/index.vue": [
		195
	],
	"./video/live": [
		403
	],
	"./video/live.ctrl": [
		753,
		79
	],
	"./video/live.ctrl.js": [
		753,
		79
	],
	"./video/live.vue": [
		403
	],
	"./video/manage": [
		404
	],
	"./video/manage.ctrl": [
		754,
		78
	],
	"./video/manage.ctrl.js": [
		754,
		78
	],
	"./video/manage.vue": [
		404
	],
	"./video/show": [
		405
	],
	"./video/show.ctrl": [
		755,
		77
	],
	"./video/show.ctrl.js": [
		755,
		77
	],
	"./video/show.vue": [
		405
	],
	"./video/upload": [
		406
	],
	"./video/upload.ctrl": [
		756,
		76
	],
	"./video/upload.ctrl.js": [
		756,
		76
	],
	"./video/upload.vue": [
		406
	],
	"./welcomePage/index": [
		407
	],
	"./welcomePage/index.scss": [
		1902,
		170
	],
	"./welcomePage/index.vue": [
		407
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 1885;

/***/ }),
/* 1886 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./QR/index": [
		121
	],
	"./QR/index.vue": [
		121
	],
	"./album/album": [
		253,
		11
	],
	"./album/album.vue": [
		253,
		11
	],
	"./album/show": [
		254,
		10
	],
	"./album/show.ctrl": [
		213,
		13
	],
	"./album/show.ctrl.js": [
		213,
		13
	],
	"./album/show.vue": [
		254,
		10
	],
	"./auth/activation/index": [
		122
	],
	"./auth/activation/index.ctrl": [
		214,
		37
	],
	"./auth/activation/index.ctrl.js": [
		214,
		37
	],
	"./auth/activation/index.vue": [
		122
	],
	"./auth/confirmation": [
		123
	],
	"./auth/confirmation.vue": [
		123
	],
	"./auth/learnMore": [
		74
	],
	"./auth/learnMore.vue": [
		74
	],
	"./auth/onboarding/accountInfo": [
		101
	],
	"./auth/onboarding/accountInfo.vue": [
		101
	],
	"./auth/onboarding/accountType": [
		102
	],
	"./auth/onboarding/accountType.vue": [
		102
	],
	"./auth/onboarding/ageLocation": [
		103
	],
	"./auth/onboarding/ageLocation.vue": [
		103
	],
	"./auth/onboarding/authPlan": [
		48
	],
	"./auth/onboarding/authPlan.vue": [
		48
	],
	"./auth/onboarding/checkEmail": [
		75
	],
	"./auth/onboarding/checkEmail.vue": [
		75
	],
	"./auth/onboarding/chooseAccount": [
		104
	],
	"./auth/onboarding/chooseAccount.vue": [
		104
	],
	"./auth/onboarding/confirmEmail": [
		105
	],
	"./auth/onboarding/confirmEmail.vue": [
		105
	],
	"./auth/onboarding/getVerified": [
		106
	],
	"./auth/onboarding/getVerified.vue": [
		106
	],
	"./auth/onboarding/index": [
		62
	],
	"./auth/onboarding/index.ctrl": [
		215,
		36
	],
	"./auth/onboarding/index.ctrl.js": [
		215,
		36
	],
	"./auth/onboarding/index.vue": [
		62
	],
	"./auth/onboarding/navFooter": [
		255,
		20
	],
	"./auth/onboarding/navFooter.vue": [
		255,
		20
	],
	"./auth/onboarding/profileImage": [
		107
	],
	"./auth/onboarding/profileImage.vue": [
		107
	],
	"./auth/reset_password": [
		256,
		33
	],
	"./auth/reset_password.vue": [
		256,
		33
	],
	"./auth/stager": [
		73
	],
	"./auth/stager.vue": [
		73
	],
	"./components/audio_player": [
		181,
		32
	],
	"./components/audio_player.vue": [
		181,
		32
	],
	"./components/contacts/directory": [
		90
	],
	"./components/contacts/directory.vue": [
		90
	],
	"./components/contacts/index": [
		178,
		31
	],
	"./components/contacts/index.vue": [
		178,
		31
	],
	"./components/footer": [
		86
	],
	"./components/footer.vue": [
		86
	],
	"./components/header": [
		64
	],
	"./components/header.vue": [
		64
	],
	"./components/header_dep": [
		257,
		30
	],
	"./components/header_dep.vue": [
		257,
		30
	],
	"./components/menu": [
		172,
		29
	],
	"./components/menu.vue": [
		172,
		29
	],
	"./components/mobileComments": [
		69
	],
	"./components/mobileComments.vue": [
		69
	],
	"./components/paneTabs": [
		179,
		28
	],
	"./components/paneTabs.vue": [
		179,
		28
	],
	"./components/search": [
		124
	],
	"./components/search.vue": [
		124
	],
	"./components/tab_nav": [
		173,
		27
	],
	"./components/tab_nav.vue": [
		173,
		27
	],
	"./components/timeline/timeline": [
		182,
		17
	],
	"./components/timeline/timeline.ctrl": [
		216,
		35
	],
	"./components/timeline/timeline.ctrl.js": [
		216,
		35
	],
	"./components/timeline/timeline.vue": [
		182,
		17
	],
	"./components/trending/music": [
		108
	],
	"./components/trending/music.vue": [
		108
	],
	"./components/trending/products": [
		109
	],
	"./components/trending/products.vue": [
		109
	],
	"./components/trending/videos": [
		110
	],
	"./components/trending/videos.vue": [
		110
	],
	"./discover/index": [
		258,
		2
	],
	"./discover/index.vue": [
		258,
		2
	],
	"./discover/music": [
		190,
		18
	],
	"./discover/music.vue": [
		190,
		18
	],
	"./discover/product": [
		191,
		26
	],
	"./discover/product.vue": [
		191,
		26
	],
	"./discover/video": [
		192,
		25
	],
	"./discover/video.vue": [
		192,
		25
	],
	"./feed/index": [
		259,
		3
	],
	"./feed/index.ctrl": [
		217,
		5
	],
	"./feed/index.ctrl.js": [
		217,
		5
	],
	"./feed/index.vue": [
		259,
		3
	],
	"./landing/components/stepper": [
		193,
		24
	],
	"./landing/components/stepper.vue": [
		193,
		24
	],
	"./landing/landing": [
		260,
		6
	],
	"./landing/landing.vue": [
		260,
		6
	],
	"./landing/landing1": [
		261,
		9
	],
	"./landing/landing1.vue": [
		261,
		9
	],
	"./landingPages/landing1": [
		262,
		23
	],
	"./landingPages/landing1.vue": [
		262,
		23
	],
	"./messages/SMS/index": [
		183,
		12
	],
	"./messages/SMS/index.vue": [
		183,
		12
	],
	"./messages/SMS/smsEngagement": [
		125
	],
	"./messages/SMS/smsEngagement.vue": [
		125
	],
	"./messages/conversations/components/DM": [
		175,
		8
	],
	"./messages/conversations/components/DM.vue": [
		175,
		8
	],
	"./messages/conversations/components/message": [
		171,
		21
	],
	"./messages/conversations/components/message.vue": [
		171,
		21
	],
	"./messages/conversations/index": [
		184,
		4
	],
	"./messages/conversations/index.ctrl": [
		218,
		7
	],
	"./messages/conversations/index.ctrl.js": [
		218,
		7
	],
	"./messages/conversations/index.vue": [
		184,
		4
	],
	"./messages/index": [
		263,
		0
	],
	"./messages/index.ctrl": [
		219,
		1
	],
	"./messages/index.ctrl.js": [
		219,
		1
	],
	"./messages/index.vue": [
		263,
		0
	],
	"./product/show": [
		264,
		16
	],
	"./product/show.vue": [
		264,
		16
	],
	"./search/search": [
		265,
		19
	],
	"./search/search.vue": [
		265,
		19
	],
	"./sell/single_product": [
		266,
		22
	],
	"./sell/single_product.ctrl": [
		220,
		34
	],
	"./sell/single_product.ctrl.js": [
		220,
		34
	],
	"./sell/single_product.vue": [
		266,
		22
	],
	"./terms/index": [
		267,
		15
	],
	"./terms/index.vue": [
		267,
		15
	],
	"./user/show": [
		268,
		14
	],
	"./user/show.vue": [
		268,
		14
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 1886;

/***/ }),
/* 1887 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1888 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1889 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1890 */,
/* 1891 */,
/* 1892 */,
/* 1893 */,
/* 1894 */,
/* 1895 */,
/* 1896 */,
/* 1897 */,
/* 1898 */,
/* 1899 */,
/* 1900 */,
/* 1901 */,
/* 1902 */,
/* 1903 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1904 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iOSIgdmlld0JveD0iMCAwIDE2IDkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xIDFMOCA4TDE1IDEiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K"

/***/ })
],[842]);


// WEBPACK FOOTER //
// static/js/app.f73d4abb5582c73457ce.js